import React, { useState, useCallback, useRef, useMemo, useEffect } from "react";
import * as XLSX from "xlsx";

/* ================================================================
   QUARRED SaaS LAYER — Auth + Plans + UserMenu + PricingModal
================================================================ */

const LOGO_SRC = "data:image/png;base64,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";
// API_BASE: the PHP backend lives on the SAME domain as this app, so we always
// use same-origin relative paths in production. We intentionally IGNORE any
// REACT_APP_API_URL / .env override here to prevent a stale env var from
// pointing the app at an old/dead backend (e.g. api.quarred.com).
// Local dev (npm start on localhost) talks to a local PHP server on :4000.
const API_BASE = (typeof window !== "undefined" && window.location.hostname === "localhost")
  ? "http://localhost:4000"
  : "";
// Google OAuth Client ID is fetched from the backend (config.php) at runtime
// by GoogleSignInBtn — never hardcode it here, or it silently overrides
// whatever is actually configured on the server.
//
// Google login is OFF for now (Google's app-verification for the new domain
// is still pending). Email/password login works fully. Set this to true to
// show the "Continue with Google" button again once verification clears.
const GOOGLE_LOGIN_ENABLED = false;
const SAAS_KEY  = "quarred_auth_v1";
const PLAN_KEY  = "quarred_plan_v1";

const PLANS = [
  { id:"free",    name:"Free",    price:0,  color:"#1a9e4a", badge:"",
    features:["1 Brand","Core PPC modules","Data Hub uploads","Search Term Intel","Community support"] },
  { id:"starter", name:"Starter", price:10, color:"#555",    badge:"",
    features:["3 Brands","15+ core modules","STR Harvest Engine","Bulk Builder","Email support"] },
  { id:"pro",     name:"Pro",     price:20, color:"#4f46e5", badge:"Most Popular",
    features:["10 Brands","All 30+ modules","Account Audit","AI Strategist","Client Reporting","Priority support"] },
  { id:"agency",  name:"Agency",  price:40, color:"#1a5fa0", badge:"Best Value",
    features:["Unlimited Brands","Everything in Pro","White-label reports","Team seats","Dedicated onboarding"] },
];

function loadAuth(){ try{ return JSON.parse(localStorage.getItem(SAAS_KEY)||"null"); }catch{ return null; } }
function saveAuth(u){ try{ localStorage.setItem(SAAS_KEY, JSON.stringify(u)); }catch{} }
function clearAuth(){ try{ localStorage.removeItem(SAAS_KEY); }catch{} }
function loadPlan(){ try{ return localStorage.getItem(PLAN_KEY)||"pro"; }catch{ return "pro"; } }
function savePlan(p){ try{ localStorage.setItem(PLAN_KEY, p); }catch{} }

const _inpSt = {
  width:"100%",padding:"11px 14px",borderRadius:10,
  border:"1px solid #e2e2e8",
  background:"#fff",
  color:"#1a1a2e",fontSize:13,outline:"none",boxSizing:"border-box",
};

/* ── Auth Screen ─────────────────────────────────────────── */
/* ── Google Sign-In Button ─────────────────────────────────── */
function GoogleSignInBtn({onAuth,setErr}){
  // Server-side OAuth 2.0 Authorization Code flow.
  // Click → redirect to Google → Google redirects back with ?code= →
  // we POST the code to the backend, which exchanges it using the Client Secret.
  const[loading,setLoading]=useState(false);
  const[hover,setHover]=useState(false);
  const[clientId,setClientId]=useState(window.GOOGLE_CLIENT_ID||"");

  // Google Client ID comes from the backend (config.php) — one place to configure.
  useEffect(()=>{
    if(clientId)return;
    fetch(API_BASE+"/api/config").then(r=>r.json()).then(d=>{
      if(d.googleClientId){ window.GOOGLE_CLIENT_ID=d.googleClientId; setClientId(d.googleClientId); }
    }).catch(()=>{});
  },[]);

  useEffect(()=>{
    const params=new URLSearchParams(window.location.search);
    const code=params.get("code");
    if(!code)return;
    setLoading(true);
    // "state" carries the referral code through the round-trip
    fetch(API_BASE+"/api/auth/google",{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({code,ref:params.get("state")||""})
    })
      .then(r=>r.json())
      .then(data=>{
        setLoading(false);
        window.history.replaceState({},"",window.location.pathname);
        if(data.error){setErr(data.error);return;}
        localStorage.setItem("rq_token",data.token);
        saveAuth(data.user);savePlan(data.user.plan);onAuth(data.user);
      })
      .catch(()=>{setLoading(false);setErr("Google sign-in failed. Please try again.");});
  },[]);

  function handleGoogleClick(){
    const refCode=new URLSearchParams(window.location.search).get("ref")||"";
    // The app itself now lives at /app (root is the marketing landing page),
    // so Google must send the user back to /app/ — this MUST exactly match
    // the redirect URI configured in Google Cloud Console and in config.php.
    const redirectUri=window.location.origin+"/app/";
    const url="https://accounts.google.com/o/oauth2/v2/auth"+
      "?client_id="+encodeURIComponent(clientId)+
      "&redirect_uri="+encodeURIComponent(redirectUri)+
      "&response_type=code"+
      "&scope="+encodeURIComponent("openid email profile")+
      "&state="+encodeURIComponent(refCode)+
      "&access_type=online&prompt=select_account";
    window.location.href=url;
  }

  if(!clientId)return null; // hidden until backend config loads (or if Google OAuth is off)
  return(
    <button type="button" onClick={handleGoogleClick} disabled={loading}
      onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}
      style={{width:"100%",padding:"11px",display:"flex",alignItems:"center",justifyContent:"center",gap:9,
        background:hover?"#f8f8fb":"#fff",border:"1px solid "+(hover?"#4f46e5":"#e2e2e8"),borderRadius:10,
        fontSize:14,fontWeight:600,cursor:loading?"wait":"pointer",opacity:loading?0.6:1,color:"#1a1a2e",transition:"all 0.18s"}}>
      <svg width="17" height="17" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
      {loading?"Signing you in…":"Continue with Google"}
    </button>
  );
}

function AuthScreen({onAuth}){
  const[mode,setMode]=useState("login");   // login | signup | forgot | reset | twofa
  const[email,setEmail]=useState("");
  const[pw,setPw]=useState("");
  const[pw2,setPw2]=useState("");
  const[uname,setUname]=useState("");
  const[plan,setPlan]=useState("pro");
  const[loading,setLoading]=useState(false);
  const[err,setErr]=useState("");
  const[ok,setOk]=useState("");
  const[twofaCode,setTwofaCode]=useState("");
  const[resetToken,setResetToken]=useState("");

  // If the user arrived from a password-reset email (?reset=TOKEN), open reset mode.
  useEffect(()=>{
    const t=new URLSearchParams(window.location.search).get("reset");
    if(t){ setResetToken(t); setMode("reset"); window.history.replaceState({},"",window.location.pathname); }
  },[]);

  function finishLogin(data){
    localStorage.setItem("rq_token",data.token);
    saveAuth(data.user); savePlan(data.user.plan); onAuth(data.user);
  }
  function post(endpoint,body,onOk){
    fetch(API_BASE+endpoint,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
      .then(r=>r.json())
      .then(data=>{ setLoading(false); if(data.error){setErr(data.error);return;} onOk(data); })
      .catch(()=>{setLoading(false);setErr("Network error. Please try again.");});
  }

  function go(e){
    e.preventDefault(); setErr(""); setOk("");

    if(mode==="twofa"){
      if(twofaCode.trim().length!==6){ setErr("Enter the 6-digit code from your email."); return; }
      setLoading(true);
      post("/api/auth/verify_2fa",{email,code:twofaCode.trim()},data=>finishLogin(data));
      return;
    }
    if(mode==="reset"){
      if(pw.length<10){ setErr("Password must be at least 10 characters."); return; }
      if(pw!==pw2){ setErr("Passwords do not match."); return; }
      setLoading(true);
      post("/api/auth/reset",{token:resetToken,password:pw},()=>{
        setOk("Password updated! You can sign in now."); setMode("login"); setPw(""); setPw2("");
      });
      return;
    }
    if(!email||!email.includes("@")){ setErr("Enter a valid email address."); return; }
    if(mode==="forgot"){
      setLoading(true);
      post("/api/auth/forgot",{email},data=>{
        setOk(data.message||"If that email exists, a reset link is on its way. Check your inbox.");
      });
      return;
    }
    if(pw.length<(mode==="signup"?10:6)){ setErr(mode==="signup"?"Password must be at least 10 characters.":"Enter your password."); return; }
    setLoading(true);
    const ref = new URLSearchParams(window.location.search).get("ref") || "";
    const endpoint = mode==="login"?"/api/auth/login":"/api/auth/signup";
    const body = mode==="login"?{email,password:pw}:{email,password:pw,name:uname,plan,ref};
    post(endpoint,body,data=>{
      if(data.twofa_required){ setMode("twofa"); setOk("We emailed you a 6-digit security code."); return; }
      finishLogin(data);
    });
  }

  const selPlan = PLANS.find(p=>p.id===plan)||PLANS[1];

  return(
    <div style={{minHeight:"100vh",background:"#f4f5f7",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",padding:"20px"}}>
      <div style={{width:"100%",maxWidth:430}}>
        <div style={{textAlign:"center",marginBottom:26}}>
          <div style={{display:"inline-flex",alignItems:"center",gap:12,marginBottom:8}}>
            <img src={LOGO_SRC} style={{width:46,height:46,borderRadius:13,objectFit:"contain",background:"#fff",boxShadow:"0 4px 16px rgba(79,70,229,0.18)"}}/>
            <div style={{textAlign:"left"}}>
              <div style={{fontSize:26,fontWeight:900,color:"#1a1a2e",letterSpacing:"-0.5px",lineHeight:1}}>OperaIQ</div>
              <div style={{fontSize:10,color:"#9a9aa8",letterSpacing:"2px",textTransform:"uppercase",marginTop:3}}>PPC Operating System · by Quarred</div>
            </div>
          </div>
        </div>

        <div style={{background:"#fff",border:"1px solid #ececf0",borderRadius:18,padding:"30px 32px",boxShadow:"0 8px 40px rgba(0,0,0,0.06)"}}>
          <h1 style={{color:"#1a1a2e",fontSize:21,fontWeight:800,marginBottom:5,textAlign:"center",letterSpacing:"-0.3px"}}>
            {mode==="login"?"Welcome back":mode==="signup"?"Create your account":mode==="twofa"?"Security check":mode==="reset"?"Set a new password":"Reset password"}
          </h1>
          <p style={{color:"#999",fontSize:12,textAlign:"center",marginBottom:24}}>
            {mode==="login"?"Sign in to your OperaIQ account":mode==="signup"?"Free during beta · No credit card required":mode==="twofa"?"Enter the 6-digit code we emailed you":mode==="reset"?"Choose a strong new password (10+ characters)":"We will email you a secure reset link"}
          </p>

          {err&&<div style={{background:"#fdecec",border:"1px solid #f5c6c6",borderRadius:9,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#c0392b"}}>{err}</div>}
          {ok&&<div style={{background:"#e9f8ef",border:"1px solid #bfe6cd",borderRadius:9,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#1d8a4e"}}>{ok}</div>}

          <form onSubmit={go}>
            {mode==="signup"&&(
              <div style={{marginBottom:14}}>
                <label style={{display:"block",fontSize:10,fontWeight:700,color:"#888",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.6px"}}>Full Name</label>
                <input value={uname} onChange={e=>setUname(e.target.value)} placeholder="Your name" style={_inpSt}/>
              </div>
            )}
            {mode!=="reset"&&mode!=="twofa"&&(
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:10,fontWeight:700,color:"#888",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.6px"}}>Email</label>
              <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@agency.com" style={_inpSt}/>
            </div>
            )}
            {mode==="twofa"&&(
            <div style={{marginBottom:22}}>
              <label style={{display:"block",fontSize:10,fontWeight:700,color:"#888",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.6px"}}>6-Digit Code</label>
              <input value={twofaCode} onChange={e=>setTwofaCode(e.target.value.replace(/[^0-9]/g,"").slice(0,6))} placeholder="000000" autoFocus
                style={{..._inpSt,textAlign:"center",fontSize:22,letterSpacing:"8px",fontWeight:700}}/>
              <div style={{fontSize:11,color:"#999",marginTop:8,textAlign:"center"}}>Sent to {email} · valid for 10 minutes</div>
            </div>
            )}
            {mode==="reset"&&(
            <>
              <div style={{marginBottom:14}}>
                <label style={{display:"block",fontSize:10,fontWeight:700,color:"#888",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.6px"}}>New Password</label>
                <input type="password" value={pw} onChange={e=>setPw(e.target.value)} placeholder="At least 10 characters" style={_inpSt}/>
              </div>
              <div style={{marginBottom:22}}>
                <label style={{display:"block",fontSize:10,fontWeight:700,color:"#888",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.6px"}}>Confirm Password</label>
                <input type="password" value={pw2} onChange={e=>setPw2(e.target.value)} placeholder="Repeat new password" style={_inpSt}/>
              </div>
            </>
            )}
            {(mode==="login"||mode==="signup")&&(
              <div style={{marginBottom:mode==="signup"?20:26}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                  <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.6px"}}>Password</label>
                  {mode==="login"&&<button type="button" onClick={()=>{setMode("forgot");setErr("");setOk("");}} style={{background:"none",border:"none",color:"#4f46e5",fontSize:11,cursor:"pointer",fontWeight:600}}>Forgot?</button>}
                </div>
                <input type="password" value={pw} onChange={e=>setPw(e.target.value)} placeholder="••••••••" style={_inpSt}/>
              </div>
            )}
            {mode==="signup"&&(
              <div style={{marginBottom:24}}>
                <label style={{display:"block",fontSize:10,fontWeight:700,color:"#888",marginBottom:10,textTransform:"uppercase",letterSpacing:"0.6px"}}>Choose Plan</label>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:7}}>
                  {PLANS.map(p=>(
                    <div key={p.id} onClick={()=>setPlan(p.id)} style={{padding:"10px 5px",borderRadius:10,border:`2px solid ${plan===p.id?p.color:"#e8e8ee"}`,background:plan===p.id?p.color+"12":"#fff",cursor:"pointer",textAlign:"center"}}>
                      {p.badge&&<div style={{fontSize:7,fontWeight:700,color:p.color,textTransform:"uppercase",marginBottom:3,lineHeight:1.1}}>{p.badge}</div>}
                      <div style={{fontSize:12,fontWeight:800,color:"#1a1a2e"}}>{p.name}</div>
                      <div style={{fontSize:11,fontWeight:700,color:plan===p.id?p.color:"#aaa"}}>{p.price===0?"Free":"$"+p.price}</div>
                    </div>
                  ))}
                </div>
                <div style={{textAlign:"center",fontSize:10,color:"#bbb",marginTop:8}}>Everything free during beta · No card required</div>
              </div>
            )}
            <button type="submit" disabled={loading} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:loading?"rgba(79,70,229,0.5)":"#4f46e5",color:"#fff",fontSize:14,fontWeight:700,cursor:loading?"not-allowed":"pointer",boxShadow:"0 4px 16px rgba(79,70,229,0.22)"}}>
              {loading?"Please wait..."
               :mode==="login"?"Sign In →"
               :mode==="signup"?`Create Account — ${selPlan.name}`
               :mode==="twofa"?"Verify Code →"
               :mode==="reset"?"Update Password"
               :"Send Reset Email"}
            </button>
          </form>

          {/* Google Sign-In — hidden until Google OAuth verification clears.
              Flip GOOGLE_LOGIN_ENABLED to true (top of file) to bring it back. */}
          {GOOGLE_LOGIN_ENABLED&&(mode==="login"||mode==="signup")&&(<>
          <div style={{margin:"16px 0",display:"flex",alignItems:"center",gap:10}}>
            <div style={{flex:1,height:1,background:"#ececf0"}}/>
            <span style={{fontSize:11,color:"#bbb"}}>or</span>
            <div style={{flex:1,height:1,background:"#ececf0"}}/>
          </div>
          <GoogleSignInBtn onAuth={onAuth} setErr={setErr}/>
          </>)}

          <div style={{marginTop:16,textAlign:"center",fontSize:12,color:"#999"}}>
            {mode==="login"&&<>No account? <button type="button" onClick={()=>{setMode("signup");setErr("");}} style={{background:"none",border:"none",color:"#4f46e5",fontWeight:700,cursor:"pointer",fontSize:12}}>Sign up free</button></>}
            {mode==="signup"&&<>Have an account? <button type="button" onClick={()=>{setMode("login");setErr("");}} style={{background:"none",border:"none",color:"#4f46e5",fontWeight:700,cursor:"pointer",fontSize:12}}>Sign in</button></>}
            {(mode==="forgot"||mode==="twofa"||mode==="reset")&&<><button type="button" onClick={()=>{setMode("login");setErr("");setOk("");setTwofaCode("");}} style={{background:"none",border:"none",color:"#4f46e5",fontWeight:700,cursor:"pointer",fontSize:12}}>← Back to login</button></>}
          </div>
        </div>

        <p style={{textAlign:"center",marginTop:18,fontSize:11,color:"#bbb"}}>
          © {new Date().getFullYear()} OperaIQ by Quarred · Amazon PPC Operating System
        </p>
      </div>
    </div>
  );
}

/* ── User Avatar Dropdown ─────────────────────────────────── */
function UserMenu({user,onLogout,onUpgrade}){
  const[open,setOpen]=useState(false);
  const plan=PLANS.find(p=>p.id===(user?.plan||"pro"))||PLANS[1];
  const ref=useRef();
  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);
  return(
    <div ref={ref} style={{position:"relative",zIndex:100}}>
      <button onClick={()=>setOpen(o=>!o)} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 10px 5px 5px",borderRadius:22,border:"1px solid #e8e8e8",background:"#fff",cursor:"pointer"}}>
        <div style={{width:28,height:28,borderRadius:"50%",background:"#4f46e5",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:13,fontWeight:900,flexShrink:0}}>
          {user?.avatar||user?.name?.[0]?.toUpperCase()||"U"}
        </div>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:"#111",maxWidth:100,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user?.name}</div>
          <div style={{fontSize:9,fontWeight:700,color:plan.color,textTransform:"uppercase",letterSpacing:"0.4px"}}>{plan.name}</div>
        </div>
        <i className="ti ti-chevron-down" style={{fontSize:10,color:"#aaa"}}/>
      </button>
      {open&&(
        <div style={{position:"absolute",right:0,top:"calc(100% + 7px)",width:224,background:"#fff",borderRadius:14,border:"1px solid #e8e8e8",boxShadow:"0 10px 40px rgba(0,0,0,0.14)",overflow:"hidden"}}>
          <div style={{padding:"14px 16px",borderBottom:"1px solid #f0f0f0"}}>
            <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{user?.name}</div>
            <div style={{fontSize:11,color:"#888",marginTop:2}}>{user?.email}</div>
            <span style={{display:"inline-flex",alignItems:"center",gap:5,marginTop:7,padding:"2px 9px",borderRadius:9,background:plan.color+"18",color:plan.color,fontSize:10,fontWeight:700}}>
              <i className="ti ti-crown" style={{fontSize:9}}/>{plan.name} Plan
            </span>
          </div>
          {[
            {icon:"ti-user-circle",label:"Account Settings"},
            {icon:"ti-credit-card",label:"Billing & Subscription"},
            {icon:"ti-users",label:"Team Members"},
            {icon:"ti-help-circle",label:"Help & Support"},
          ].map((item,i)=>(
            <button key={i} onClick={()=>setOpen(false)} style={{width:"100%",padding:"9px 16px",border:"none",background:"transparent",display:"flex",alignItems:"center",gap:10,cursor:"pointer",fontSize:12,color:"#333",textAlign:"left"}}>
              <i className={"ti "+item.icon} style={{fontSize:13,color:"#999"}}/>{item.label}
            </button>
          ))}
          {user?.plan==="starter"&&(
            <div style={{padding:"10px 12px",borderTop:"1px solid #f5f5f5"}}>
              <button onClick={()=>{onUpgrade&&onUpgrade();setOpen(false);}} style={{width:"100%",padding:"8px",borderRadius:8,border:"none",background:"#4f46e5",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                ⬆ Upgrade to Pro
              </button>
            </div>
          )}
          <div style={{borderTop:"1px solid #f5f5f5"}}>
            <button onClick={()=>{onLogout();setOpen(false);}} style={{width:"100%",padding:"10px 16px",border:"none",background:"transparent",display:"flex",alignItems:"center",gap:10,cursor:"pointer",fontSize:12,color:"#d42b2b",fontWeight:600,textAlign:"left"}}>
              <i className="ti ti-logout" style={{fontSize:12}}/>Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Pricing / Upgrade Modal ─────────────────────────────── */
function PricingModal({onClose,currentPlan,onSelect}){
  const[sel,setSel]=useState(currentPlan||"pro");
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:9900,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:22,padding:"32px 28px",maxWidth:720,width:"100%",maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{fontSize:22,fontWeight:900,color:"#111",marginBottom:5}}>Choose Your Plan</div>
          <div style={{fontSize:13,color:"#888"}}>Switch plans anytime · Everything free during beta</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:14,marginBottom:24}}>
          {PLANS.map(plan=>(
            <div key={plan.id} onClick={()=>setSel(plan.id)} style={{padding:"22px 18px",borderRadius:14,border:`2px solid ${sel===plan.id?plan.color:"#e8e8e8"}`,background:sel===plan.id?plan.color+"08":"#fff",cursor:"pointer",position:"relative"}}>
              {plan.badge&&<div style={{position:"absolute",top:-12,left:"50%",transform:"translateX(-50%)",background:plan.color,color:"#fff",fontSize:10,fontWeight:700,padding:"3px 10px",borderRadius:10,whiteSpace:"nowrap"}}>{plan.badge}</div>}
              <div style={{fontSize:17,fontWeight:800,color:"#111",marginBottom:3}}>{plan.name}</div>
              <div style={{fontSize:28,fontWeight:900,color:plan.color,marginBottom:14}}>${plan.price}<span style={{fontSize:13,fontWeight:400,color:"#aaa"}}>/mo</span></div>
              {plan.features.map((f,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:7,marginBottom:7,fontSize:12,color:"#444"}}>
                  <i className="ti ti-check" style={{fontSize:11,color:"#1a9e5f",flexShrink:0}}/>{f}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div style={{display:"flex",gap:10}}>
          <button onClick={onClose} style={{flex:1,padding:"12px",borderRadius:10,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:13,fontWeight:600,cursor:"pointer"}}>Cancel</button>
          <button onClick={()=>{onSelect(sel);onClose();}} style={{flex:2,padding:"12px",borderRadius:10,border:"none",background:"#4f46e5",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer",boxShadow:"0 4px 16px rgba(79,70,229,0.3)"}}>
            Confirm — {PLANS.find(p=>p.id===sel)?.name} Plan
          </button>
        </div>
      </div>
    </div>
  );
}


const R = "#4f46e5";

/* ================================================================
   AMAZON BULK UPLOAD FORMAT HELPERS
   Based on official Amazon Bulk Operations format (updated 2024).
   Rules:
   - Operation column: "create" or "update" (lowercase)
   - Entity values: exact strings, case-sensitive
   - Match types: exact / phrase / broad / negativeExact / negativePhrase (camelCase)
   - Placement entity: "Bidding Adjustment"
   - Placement values: "Top of Search (Organic)" / "Detail Page (ASIN)" / "Other on-Amazon"
   - Percentage: whole number 0–900 (no % sign)
   - Bids: decimal 2 places, max $100 (most categories)
   - State: "enabled" / "paused" (lowercase)
   - Dates: YYYYMMDD format
================================================================ */

/* SP Bulk columns — exact Amazon order */
const AMZN_SP_COLS=[
  "Product","Entity","Operation","Campaign ID","Ad Group ID","Portfolio ID",
  "Ad ID","Keyword ID","Product Targeting ID","Campaign Name","Ad Group Name",
  "Campaign Name (Informational only)","Ad Group Name (Informational only)",
  "Portfolio Name (Informational only)","Start Date","End Date","Targeting Type",
  "State","Campaign State (Informational only)","Ad Group State (Informational only)",
  "Daily Budget","SKU","ASIN (Informational only)","Eligibility Status (Informational only)",
  "Reason for Ineligibility (Informational only)","Ad Group Default Bid",
  "Ad Group Default Bid (Informational only)","Bid","Keyword Text","Native Language Keyword",
  "Native Language Locale","Match Type","Bidding Strategy","Placement","Percentage",
  "Product Targeting Expression","Resolved Product Targeting Expression (Informational only)",
  "Impressions","Clicks","Click-through Rate","Spend","Sales","Orders","Units",
  "Conversion Rate","ACOS","CPC","ROAS"
];

/* Build a blank SP row — all columns present, all empty by default */
function amznBlankRow(overrides={}){
  const row={};
  AMZN_SP_COLS.forEach(col=>{row[col]="";});
  Object.assign(row,overrides);
  return row;
}

/* Build bid update row — updates keyword bid */
function amznBidUpdateRow(r){
  return amznBlankRow({
    "Product":"Sponsored Products",
    "Entity":"Keyword",
    "Operation":"update",
    "Campaign ID":r.campaignId||"",
    "Campaign Name":r.campaign||"",
    "Ad Group ID":r.adGroupId||"",
    "Ad Group Name":r.adGroup||"",
    "Keyword ID":r.keywordId||"",
    "Keyword Text":r.keyword||"",
    "Match Type":r.matchType||"",
    "State":r.state||"enabled",
    "Bid":typeof r.newBid==="number"?r.newBid.toFixed(2):r.newBid||"",
  });
}

/* Build placement adjustment row */
function amznPlacementRow(r){
  // Placement values Amazon accepts:
  // "Top of Search (Organic)" — TOS modifier
  // "Detail Page (ASIN)"       — Product pages modifier  
  // "Other on-Amazon"          — Rest of search
  const placementMap={
    "TOS":"Top of Search (Organic)",
    "PP":"Detail Page (ASIN)",
    "ROS":"Other on-Amazon",
    "Top of Search (Organic)":"Top of Search (Organic)",
    "Detail Page (ASIN)":"Detail Page (ASIN)",
    "Other on-Amazon":"Other on-Amazon",
    "Rest of Search":"Other on-Amazon",
    "Product Pages":"Detail Page (ASIN)",
  };
  return amznBlankRow({
    "Product":"Sponsored Products",
    "Entity":"Bidding Adjustment",
    "Operation":"update",
    "Campaign ID":r.campaignId||"",
    "Campaign Name":r.campaign||"",
    "Placement":placementMap[r.placement]||r.placement||"",
    "Percentage":String(Math.round(Math.max(0,Math.min(900,r.percentage||0)))),
    "State":r.state||"enabled",
  });
}

/* Build campaign-level negative keyword row */
function amznCampNegRow(r){
  // Entity = "Campaign Negative Keyword" for campaign level
  // Entity = "Negative Keyword" for ad-group level
  // Match type: "negativeExact" or "negativePhrase" (camelCase, no spaces)
  const matchMap={
    "Negative Exact":"negativeExact",
    "Negative Phrase":"negativePhrase",
    "negativeExact":"negativeExact",
    "negativePhrase":"negativePhrase",
    "exact":"negativeExact",
    "phrase":"negativePhrase",
  };
  const isCampLevel=!r.adGroup&&!r.adGroupId;
  return amznBlankRow({
    "Product":"Sponsored Products",
    "Entity":isCampLevel?"Campaign Negative Keyword":"Negative Keyword",
    "Operation":"create",
    "Campaign ID":r.campaignId||"",
    "Campaign Name":r.campaign||"",
    "Ad Group ID":r.adGroupId||"",
    "Ad Group Name":r.adGroup||"",
    "State":"enabled",
    "Keyword Text":r.keyword||r.searchTerm||"",
    "Match Type":matchMap[r.matchType]||"negativeExact",
  });
}

/* Build keyword pause row */
function amznPauseRow(r){
  return amznBlankRow({
    "Product":"Sponsored Products",
    "Entity":"Keyword",
    "Operation":"update",
    "Campaign ID":r.campaignId||"",
    "Campaign Name":r.campaign||"",
    "Ad Group ID":r.adGroupId||"",
    "Ad Group Name":r.adGroup||"",
    "Keyword ID":r.keywordId||"",
    "Keyword Text":r.keyword||"",
    "Match Type":r.matchType||"",
    "State":"paused",
  });
}

/* Export to proper Amazon xlsx with one sheet tab named "Sponsored Products Campaigns" */
function amznExportBulk(rows, filename="amazon_bulk_upload"){
  const ws=XLSX.utils.json_to_sheet(rows,{header:AMZN_SP_COLS});
  /* Style header row */
  ws["!cols"]=AMZN_SP_COLS.map(col=>{
    const widths={"Campaign Name":30,"Ad Group Name":25,"Keyword Text":30,"Product Targeting Expression":30,"Campaign ID":20,"Keyword ID":20};
    return{wch:widths[col]||14};
  });
  const wb=XLSX.utils.book_new();
  /* Amazon requires the sheet to be named "Sponsored Products Campaigns" */
  XLSX.utils.book_append_sheet(wb,ws,"Sponsored Products Campaigns");
  XLSX.writeFile(wb,`${filename}_${new Date().toISOString().split("T")[0]}.xlsx`);
}


/* ─── Templates ─────────────────────────────────────────────── */
const SP_COLS=["Product","Entity","Operation","Campaign ID","Ad Group ID","Portfolio ID","Ad ID","Keyword ID","Product Targeting ID","Campaign Name","Ad Group Name","Campaign Name (Informational only)","Ad Group Name (Informational only)","Portfolio Name (Informational only)","Start Date","End Date","Targeting Type","State","Campaign State (Informational only)","Ad Group State (Informational only)","Daily Budget","SKU","ASIN (Informational only)","Eligibility Status (Informational only)","Reason for Ineligibility (Informational only)","Ad Group Default Bid","Ad Group Default Bid (Informational only)","Bid","Keyword Text","Native Language Keyword","Native Language Locale","Match Type","Bidding Strategy","Placement","Percentage","Product Targeting Expression","Resolved Product Targeting Expression (Informational only)","Audience ID","Shopper Cohort Percentage","Shopper Cohort Type","Segment Name (Informational only)","Sites","Impressions","Clicks","Click-through Rate","Spend","Sales","Orders","Units","Conversion Rate","ACOS","CPC","ROAS"];
const SB_COLS=["Product","Entity","Operation","Campaign ID","Draft Campaign ID","Portfolio ID","Ad Group ID","Keyword ID","Product Targeting ID","Campaign Name","Campaign Name (Informational only)","Portfolio Name (Informational only)","Start Date","End Date","State","Campaign State (Informational only)","Campaign Serving Status (Informational only)","Budget Type","Budget","Bid Optimization","Bid Multiplier","Bid","Keyword Text","Match Type","Product Targeting Expression","Resolved Product Targeting Expression (Informational only)","Ad Format","Ad Format (Informational only)","Landing Page URL","Landing Page ASINs","Landing Page Type (Informational only)","Brand Entity ID","Brand Name","Brand Logo Asset ID","Brand Logo URL (Informational only)","Custom Image Asset ID","Creative Headline","Creative ASINs","Video Media IDs","Creative Type","Impressions","Clicks","Click-through Rate","Spend","Sales","Orders","Units","Conversion Rate","ACOS","CPC","ROAS"];
const SD_COLS=["Product","Entity","Operation","Campaign ID","Portfolio ID","Ad Group ID","Ad ID","Targeting ID","Campaign Name","Ad Group Name","Campaign Name (Informational only)","Ad Group Name (Informational only)","Portfolio Name (Informational only)","Start Date","End Date","State","Campaign State (Informational only)","Ad Group State (Informational only)","Tactic","Budget Type","Budget","SKU","ASIN (Informational only)","Ad Group Default Bid","Ad Group Default Bid (Informational only)","Bid","Bid Optimization","Cost Type","Targeting Expression","Resolved Targeting Expression (Informational only)","Impressions","Clicks","Click-through Rate","Spend","Sales","Orders","Units","Conversion Rate","ACOS","CPC","ROAS","Viewable Impressions","Sales (Views & Clicks)","Orders (Views & Clicks)","Units (Views & Clicks)","ACOS (Views & Clicks)","ROAS (Views & Clicks)"];
function dlTemplate(cols,name,file){const ws=XLSX.utils.aoa_to_sheet([cols]);ws["!cols"]=cols.map(()=>({wch:24}));const wb=XLSX.utils.book_new();XLSX.utils.book_append_sheet(wb,ws,name);XLSX.writeFile(wb,file);}

/* ─── KPI / Filter / Action defs ────────────────────────────── */
const KPI_DEFS=[{key:"impressions",label:"Impressions",lowerBetter:false,fmt:v=>v>=1e6?`${(v/1e6).toFixed(2)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))},{key:"clicks",label:"Clicks",lowerBetter:false,fmt:v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))},{key:"orders",label:"Orders",lowerBetter:false,fmt:v=>String(Math.round(v))},{key:"spend",label:"Spend",lowerBetter:true,fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(2)}`},{key:"sales",label:"Sales",lowerBetter:false,fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(2)}`},{key:"acos",label:"ACoS",lowerBetter:true,fmt:v=>`${v.toFixed(1)}%`},{key:"ctr",label:"CTR",lowerBetter:false,fmt:v=>`${v.toFixed(2)}%`},{key:"cvr",label:"CVR",lowerBetter:false,fmt:v=>`${v.toFixed(1)}%`},{key:"cpc",label:"CPC",lowerBetter:true,fmt:v=>`$${v.toFixed(2)}`},{key:"roas",label:"ROAS",lowerBetter:false,fmt:v=>v.toFixed(2)}];
const FILTER_FIELDS=[{key:"target",label:"Target",type:"text",ops:["contains","doesn't contain","matches"]},{key:"campaign",label:"Campaign Name",type:"text",ops:["contains","doesn't contain"]},{key:"matchType",label:"Match Type",type:"enum",ops:["is","is not"],values:["Exact","Broad","Phrase","Auto"]},{key:"state",label:"State",type:"enum",ops:["is","is not"],values:["enabled","paused","archived"]},{key:"acos",label:"ACoS (%)",type:"number",ops:[">",">=","<","<=","between"]},{key:"roas",label:"ROAS",type:"number",ops:[">",">=","<","<=","between"]},{key:"sales",label:"Sales ($)",type:"number",ops:[">",">=","<","<=","between"]},{key:"spend",label:"Spend ($)",type:"number",ops:[">",">=","<","<=","between"]},{key:"impressions",label:"Impressions",type:"number",ops:[">",">=","<","<=","between"]},{key:"clicks",label:"Clicks",type:"number",ops:[">",">=","<","<=","between"]},{key:"orders",label:"Orders",type:"number",ops:[">",">=","<","<=","between"]},{key:"ctr",label:"CTR (%)",type:"number",ops:[">",">=","<","<=","between"]},{key:"cvr",label:"CVR (%)",type:"number",ops:[">",">=","<","<=","between"]},{key:"cpc",label:"CPC ($)",type:"number",ops:[">",">=","<","<=","between"]},{key:"bid",label:"Bid ($)",type:"number",ops:[">",">=","<","<=","between"]}];
const BID_ACTIONS=[{key:"no_change",label:"No change"},{key:"inc_pct",label:"Increase bid by (%)"},{key:"inc_amount",label:"Increase bid by ($)"},{key:"dec_pct",label:"Decrease bid by (%)"},{key:"dec_amount",label:"Decrease bid by ($)"},{key:"set_bid",label:"Set bid to ($)"}];
const RULE_KPIS=[{key:"acos",label:"ACoS",unit:"%"},{key:"roas",label:"ROAS",unit:""},{key:"sales",label:"Sales",unit:"$"},{key:"spend",label:"Spend",unit:"$"},{key:"impressions",label:"Impressions",unit:""},{key:"clicks",label:"Clicks",unit:""},{key:"ctr",label:"CTR",unit:"%"},{key:"cvr",label:"CVR",unit:"%"},{key:"orders",label:"Orders",unit:""},{key:"cpc",label:"CPC",unit:"$"}];
const RULE_OPS=[{key:"gt",label:">"},{key:"gte",label:">="},{key:"lt",label:"<"},{key:"lte",label:"<="},{key:"between",label:"between"}];
const RULE_ACTS=[{key:"inc_amount",label:"Increase bid by $"},{key:"dec_amount",label:"Decrease bid by $"},{key:"inc_pct",label:"Increase bid by %"},{key:"dec_pct",label:"Decrease bid by %"},{key:"set_bid",label:"Set bid to $"}];

/* ─── Column aliases ────────────────────────────────────────── */
/* Comprehensive Amazon export column aliases — covers bulk files,
   campaign reports, search term reports, placement reports, advertised
   product reports across all Amazon marketplace formats */
const COL_ALIASES={
  bid:        ["Bid","Ad Group Default Bid","Ad Group Default Bid (Informational only)","Default Bid","Keyword Bid","keyword bid","Bid ($)"],
  impressions:["Impressions","impressions","Total Impressions"],
  clicks:     ["Clicks","clicks","Total Clicks"],
  spend:      ["Spend","Cost","Total Spend","Attributed Sales 7d","Spend ($)","Attributed Cost","Ad Spend","Cost ($)"],
  sales:      ["Sales","14 Day Total Sales","14 Day Total Sales ($)","14 Day Total Sales (₹)","Total Sales","7 Day Total Sales","Sales (£)","Attributed Sales","Revenue","Ordered Product Sales","Ordered Product Sales - B2B"],
  orders:     ["Orders","14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)","Total Orders","Units Ordered","Attributed Conversions","Attributed Orders 7d"],
  units:      ["Units","14 Day Total Units (#)","7 Day Total Units (#)","Total Units","Units Ordered","Attributed Units Ordered 7d"],
  ctr:        ["Click-through Rate","CTR","Click-Through Rate","ctr","CTR (%)"],
  cvr:        ["Conversion Rate","CVR","cvr","Order Rate","Unit Session Percentage"],
  acos:       ["ACOS","ACoS","acos","Advertising Cost of Sales","ACOS (%)","Ad Cost of Sales"],
  roas:       ["ROAS","Return on Ad Spend","roas"],
  cpc:        ["CPC","Cost Per Click","cpc","CPC ($)","Average CPC"],
  entity:     ["Entity","Record Type","Type","entity","Record Type (Informational only)"],
  keyword:    ["Keyword Text","Keyword","Keyword or Product Targeting","Targeting Expression","Product Targeting Expression","Search Term","Customer Search Term","Query","Search query"],
  campaign:   ["Campaign Name","Campaign","campaign name","Campaign Name (Informational only)"],
  adGroup:    ["Ad Group Name","Ad Group","Ad group","ad group name","Ad Group Name (Informational only)"],
  matchType:  ["Match Type","match type","Targeting Type","Match type"],
  state:      ["State","Status","state","Campaign State (Informational only)","Campaign State"],
  placement:  ["Placement","Placement Type","placement","Top of Search (Impression Share)"],
  portfolio:  ["Portfolio Name","Portfolio Name (Informational only)","Portfolio"],
  sku:        ["SKU","sku","Advertised SKU"],
  asin:       ["ASIN","asin","Advertised ASIN","ASIN (Informational only)","Parent ASIN","Child ASIN"],
  searchTerm: ["Customer Search Term","Search Term","Query","Search query","Keyword"],
  impressionShare:["Impression Share","Top of Search (Impression Share)","Product Pages (Impression Share)"],
};

/* ─── Date helpers ──────────────────────────────────────────── */
const MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];
const PRESETS=[{label:"Last 7 days",days:7},{label:"Last 14 days",days:14},{label:"Last 30 days",days:30},{label:"Last 60 days",days:60},{label:"Last 90 days",days:90},{label:"Last 365 days",days:365}];
function addDays(d,n){const r=new Date(d);r.setDate(r.getDate()+n);return r;}
function startOfDay(d){const r=new Date(d);r.setHours(0,0,0,0);return r;}
function isSameDay(a,b){return a&&b&&a.toDateString()===b.toDateString();}
function daysDiff(d1,d2){return Math.round(Math.abs(d2-d1)/86400000);}
function fmtDisp(d){if(!d)return"—";return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});}

/* ─── Data helpers ──────────────────────────────────────────── */
let _uid=700;const uid=()=>++_uid;
function findCol(headers,cands){for(const c of cands){const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());if(h)return h;}for(const c of cands){const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));if(h)return h;}return null;}
function detectMap(headers){const r={};for(const[k,v]of Object.entries(COL_ALIASES))r[k]=findCol(headers,v);return r;}
function getNum(row,col){if(!col||row[col]==null||row[col]==="")return 0;const v=parseFloat(String(row[col]).replace(/[%$,\s]/g,""));return isNaN(v)?0:v;}
function calcRowMetrics(row,cm){
  const imp=getNum(row,cm.impressions),clk=getNum(row,cm.clicks),spd=getNum(row,cm.spend),sal=getNum(row,cm.sales),ord=getNum(row,cm.orders),bid=getNum(row,cm.bid);
  // Use sheet values directly if column exists; only calculate as fallback
  const ctr = cm.ctr && row[cm.ctr]!==""&&row[cm.ctr]!=null ? getNum(row,cm.ctr) : imp>0?(clk/imp)*100:0;
  const acosRaw = cm.acos && row[cm.acos]!==""&&row[cm.acos]!=null ? getNum(row,cm.acos) : null;
  const acos = acosRaw!==null ? acosRaw : sal>0?(spd/sal)*100:spd>0?0:0;
  const roas = cm.roas && row[cm.roas]!==""&&row[cm.roas]!=null ? getNum(row,cm.roas) : spd>0?sal/spd:0;
  const cvr  = cm.cvr  && row[cm.cvr]!==""&&row[cm.cvr]!=null  ? getNum(row,cm.cvr)  : clk>0?(ord/clk)*100:0;
  const cpc  = cm.cpc  && row[cm.cpc]!==""&&row[cm.cpc]!=null  ? getNum(row,cm.cpc)  : clk>0?spd/clk:0;
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,bid,ctr,acos,roas,cvr,cpc};
}
function matchRuleCond(m,cond){
  const val=m[cond.kpi]??0,v1=parseFloat(cond.v1||0),v2=parseFloat(cond.v2||0);
  if(cond.op==="gt")return val>v1;if(cond.op==="gte")return val>=v1;
  if(cond.op==="lt")return val<v1;if(cond.op==="lte")return val<=v1;
  if(cond.op==="between")return val>=v1&&val<=v2;return false;
}
function applyRulesToRows(rows,cm,rules){
  const changes={};
  rows.forEach(row=>{
    const metrics=calcRowMetrics(row,cm);
    const k=rowKey(row,cm);
    for(const rule of rules){
      if(!rule.enabled)continue;
      if(rule.conditions.length>0&&rule.conditions.every(c=>matchRuleCond(metrics,c))){
        const v=parseFloat(rule.action.value||0);let nb=metrics.bid;
        if(rule.action.type==="inc_amount")nb=metrics.bid+v;
        else if(rule.action.type==="dec_amount")nb=metrics.bid-v;
        else if(rule.action.type==="inc_pct")nb=metrics.bid*(1+v/100);
        else if(rule.action.type==="dec_pct")nb=metrics.bid*(1-v/100);
        else if(rule.action.type==="set_bid")nb=v;
        nb=Math.max(0.02,Math.round(nb*100)/100);
        if(rule.minBid&&parseFloat(rule.minBid)>0)nb=Math.max(parseFloat(rule.minBid),nb);
        if(rule.maxBid&&parseFloat(rule.maxBid)>0)nb=Math.min(parseFloat(rule.maxBid),nb);
        if(nb!==metrics.bid)changes[k]=nb;
        break;
      }
    }
  });
  return changes;
}
/* ================================================================
   INTELLIGENCE ENGINE
   Generates strategic insights, priority scores and explanations
   from raw Amazon export data — no manual input needed.
================================================================ */

/* Priority levels for every keyword/target */
function getPriority(m){
  // CRITICAL — immediate action required
  if(m.spend>20&&m.orders===0)                         return{level:"critical",label:"Critical Bleeder",color:"#d42b2b",bg:"rgba(212,43,43,0.08)",icon:"ti-droplet-off",why:"Significant spend with zero conversions. Every click is pure waste."};
  if(m.acos>80&&m.orders>0)                            return{level:"critical",label:"Critical ACoS",color:"#d42b2b",bg:"rgba(212,43,43,0.08)",icon:"ti-trending-down",why:"ACoS is dangerously high. Immediate bid reduction required."};
  // WARNING — action needed soon
  if(m.acos>40&&m.acos<=80&&m.orders>0)               return{level:"warning",label:"High ACoS",color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-alert-triangle",why:"ACoS above 40%. Profitability is at risk without optimization."};
  if(m.spend>10&&m.orders===0)                         return{level:"warning",label:"Low Converter",color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-coin-off",why:"Spending without converting. Monitor or reduce bid."};
  if(m.impressions<100&&m.orders>0)                    return{level:"warning",label:"Under-Exposed Winner",color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-eye-off",why:"Converts well but barely visible. Bid is likely too low."};
  // OPPORTUNITY — scale this
  if(m.acos<20&&m.acos>0&&m.orders>=3)               return{level:"opportunity",label:"Scale Opportunity",color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-rocket",why:"Low ACoS with proven sales. Increase bid to capture more volume."};
  if(m.roas>5&&m.orders>=2)                            return{level:"opportunity",label:"High Performer",color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-star",why:"Excellent ROAS. Expand budget allocation here."};
  if(m.impressions<500&&m.orders>=1&&m.acos<35)       return{level:"opportunity",label:"Rank Opportunity",color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-trending-up",why:"Low impressions but converting. Push bid to gain rank."};
  // GOOD — maintain
  if(m.acos>=20&&m.acos<=40&&m.orders>0)              return{level:"good",label:"On Target",color:"#555",bg:"transparent",icon:"ti-check",why:"Performing within acceptable ACoS range. Monitor weekly."};
  if(m.impressions>0&&m.orders===0&&m.spend<5)        return{level:"low",label:"Low Activity",color:"#aaa",bg:"transparent",icon:"ti-minus",why:"Low spend and activity. Not a priority right now."};
  return{level:"neutral",label:"—",color:"#aaa",bg:"transparent",icon:"ti-minus",why:""};
}

/* Auto-generate strategic intelligence from aggregated data */
function generateInsights(curAgg, compAgg, rows, cm){
  const insights=[];
  if(!curAgg||!Object.keys(curAgg).length)return insights;

  const has=(k)=>curAgg[k]!=null&&curAgg[k]>0;
  const delta=(k)=>compAgg&&compAgg[k]!=null?(curAgg[k]-compAgg[k]):null;
  const pct=(k)=>{const d=delta(k);if(d===null||!compAgg[k])return null;return(d/Math.abs(compAgg[k]))*100;};

  /* ── ACoS movement ── */
  const acosDelta=delta("acos");
  if(acosDelta!==null&&Math.abs(acosDelta)>2){
    insights.push({
      priority:acosDelta>5?"critical":acosDelta>2?"warning":"good",
      metric:"ACoS",
      current:`${curAgg.acos.toFixed(1)}%`,
      previous:compAgg?`${compAgg.acos.toFixed(1)}%`:null,
      delta:`${acosDelta>0?"+":""}${acosDelta.toFixed(1)}pp`,
      trend:acosDelta>0?"up":"down",
      trendGood:acosDelta<0,
      title:acosDelta>0?"ACoS Increased":"ACoS Improved",
      explanation:acosDelta>0
        ?`Your ACoS increased by ${acosDelta.toFixed(1)} percentage points vs previous period. This indicates rising CPCs, declining CVR, or increased competition. Identify top spending keywords with rising ACoS and reduce bids by 10–15%.`
        :`Your ACoS improved by ${Math.abs(acosDelta).toFixed(1)} percentage points. This reflects better bid discipline, improved conversion rate, or stronger search intent alignment. Consider scaling top performers.`,
      action:acosDelta>0?"Review top spenders — reduce bids on ACoS > 40%":"Identify scale opportunities — increase bids on ACoS < 25% with orders",
    });
  }

  /* ── Sales movement ── */
  const salesPct=pct("sales");
  if(salesPct!==null&&Math.abs(salesPct)>10){
    insights.push({
      priority:salesPct<-20?"critical":salesPct<-10?"warning":salesPct>20?"opportunity":"good",
      metric:"Sales",
      current:`$${curAgg.sales?.toFixed(0)}`,
      previous:compAgg?`$${compAgg.sales?.toFixed(0)}`:null,
      delta:`${salesPct>0?"+":""}${salesPct.toFixed(1)}%`,
      trend:salesPct>0?"up":"down",
      trendGood:salesPct>0,
      title:salesPct>0?"Sales Growing":"Sales Declining",
      explanation:salesPct>0
        ?`Sales grew ${salesPct.toFixed(1)}% vs previous period. This may reflect improved keyword coverage, stronger bids on converters, or seasonal lift. Identify which campaigns drove the increase.`
        :`Sales dropped ${Math.abs(salesPct).toFixed(1)}% vs previous period. Possible causes: budget limitations, bid reductions on converters, increased competition, or CVR decline from listing changes.`,
      action:salesPct<0?"Check budget caps — are campaigns running out of budget daily? Audit bids on previously converting keywords.":"Identify top-performing campaigns and scale budget allocation.",
    });
  }

  /* ── Spend without sales (waste) ── */
  const bleeders=rows.filter(r=>{const m=calcRowMetrics(r,cm);return m.spend>15&&m.orders===0;});
  if(bleeders.length>0){
    const totalWaste=bleeders.reduce((s,r)=>s+calcRowMetrics(r,cm).spend,0);
    insights.push({
      priority:"critical",
      metric:"Wasted Spend",
      current:`$${totalWaste.toFixed(0)}`,
      previous:null,delta:null,trend:"down",trendGood:false,
      title:`${bleeders.length} Bleeding Target${bleeders.length>1?"s":""}`,
      explanation:`${bleeders.length} keyword${bleeders.length>1?"s":""} spent $${totalWaste.toFixed(0)} total with zero conversions this period. These are pure waste drains on your budget. Immediate action is needed.`,
      action:`Reduce bids by 30–50% or pause the top bleeders. Review search terms behind these keywords to identify irrelevant traffic.`,
    });
  }

  /* ── Impression decline ── */
  const impPct=pct("impressions");
  if(impPct!==null&&impPct<-15){
    insights.push({
      priority:"warning",
      metric:"Impressions",
      current:curAgg.impressions>=1e3?`${(curAgg.impressions/1e3).toFixed(1)}K`:String(Math.round(curAgg.impressions)),
      previous:compAgg?(compAgg.impressions>=1e3?`${(compAgg.impressions/1e3).toFixed(1)}K`:String(Math.round(compAgg.impressions))):null,
      delta:`${impPct.toFixed(1)}%`,trend:"down",trendGood:false,
      title:"Visibility Declining",
      explanation:`Impressions dropped ${Math.abs(impPct).toFixed(1)}% vs previous period. Your ads are showing less frequently. Possible causes: bids too low for auction, budget constraints, or increased competitor activity.`,
      action:"Check daily budget utilization. Identify keywords with impression share loss and increase bids by 10–20%.",
    });
  }

  /* ── CPC inflation ── */
  const cpcPct=pct("cpc");
  if(cpcPct!==null&&cpcPct>15){
    insights.push({
      priority:"warning",
      metric:"CPC",
      current:`$${curAgg.cpc?.toFixed(2)}`,
      previous:compAgg?`$${compAgg.cpc?.toFixed(2)}`:null,
      delta:`+${cpcPct.toFixed(1)}%`,trend:"up",trendGood:false,
      title:"CPC Inflation Detected",
      explanation:`Average CPC increased ${cpcPct.toFixed(1)}% vs previous period. Rising CPCs squeeze margin without guaranteed proportional sales lift. This usually signals increased competition or bid inflation across the account.`,
      action:"Audit keywords with highest CPC increase. Consider tightening match types on broad/phrase terms to reduce irrelevant auction competition.",
    });
  }

  /* ── Scale opportunity ── */
  const scalers=rows.filter(r=>{const m=calcRowMetrics(r,cm);return m.acos>0&&m.acos<20&&m.orders>=3&&m.impressions<2000;});
  if(scalers.length>0){
    insights.push({
      priority:"opportunity",
      metric:"Scale Targets",
      current:`${scalers.length} keywords`,
      previous:null,delta:null,trend:"up",trendGood:true,
      title:`${scalers.length} Scale Opportunit${scalers.length>1?"ies":"y"}`,
      explanation:`${scalers.length} keyword${scalers.length>1?"s":""} have low ACoS (< 20%) with proven conversions but limited impressions. These are your hidden winners — underbid and underexposed.`,
      action:"Increase bids by 15–25% on these targets. They convert well and need more visibility to scale revenue.",
    });
  }

  /* ── CVR decline ── */
  const cvrPct=pct("cvr");
  if(cvrPct!==null&&cvrPct<-20){
    insights.push({
      priority:"warning",
      metric:"CVR",
      current:`${curAgg.cvr?.toFixed(1)}%`,
      previous:compAgg?`${compAgg.cvr?.toFixed(1)}%`:null,
      delta:`${cvrPct.toFixed(1)}%`,trend:"down",trendGood:false,
      title:"Conversion Rate Declining",
      explanation:`CVR dropped ${Math.abs(cvrPct).toFixed(1)}% vs previous period. Lower CVR means more clicks needed per sale, inflating effective CPC and ACoS. Possible causes: listing changes, price increase, new competitor, or seasonal demand shift.`,
      action:"Audit listing quality — check images, bullets, price competitiveness. Review search term relevance — irrelevant traffic reduces CVR. Consider reducing bids temporarily until CVR stabilizes.",
    });
  }

  return insights.sort((a,b)=>{const order={critical:0,warning:1,opportunity:2,good:3,neutral:4};return(order[a.priority]||4)-(order[b.priority]||4);});
}

function sumAgg(rows,cm){let imp=0,clk=0,spd=0,sal=0,ord=0;rows.forEach(r=>{imp+=getNum(r,cm.impressions);clk+=getNum(r,cm.clicks);spd+=getNum(r,cm.spend);sal+=getNum(r,cm.sales);ord+=getNum(r,cm.orders);});return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,acos:sal>0?(spd/sal)*100:0,ctr:imp>0?(clk/imp)*100:0,cvr:clk>0?(ord/clk)*100:0,cpc:clk>0?spd/clk:0,roas:spd>0?sal/spd:0};}
function isBidRow(row,cm){if(!cm.bid)return false;const bv=row[cm.bid];if(bv===""||bv==null||bv===undefined)return false;const n=parseFloat(String(bv).replace(/[%$,\\s]/g,""));if(isNaN(n)||n<=0)return false;if(cm.entity){const e=String(row[cm.entity]||"").toLowerCase().trim();const skip=["campaign","ad group","ad groups","portfolio","bid rule","product ad","placement","bidding adjustment"];if(skip.some(s=>e===s))return false;}return true;}
function rowKey(row,cm){const kw=String(row[cm.keyword]||row["Keyword Text"]||row["Keyword"]||row["Targeting Expression"]||row["Product Targeting Expression"]||"").trim().toLowerCase();const camp=String(row[cm.campaign]||row["Campaign Name"]||"").trim().toLowerCase();const mt=String(row[cm.matchType]||row["Match Type"]||"").trim().toLowerCase();return`${camp}||${kw}||${mt}`;}
function parseSheet(file){return new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=e=>{try{const wb=XLSX.read(new Uint8Array(e.target.result),{type:"array"});const ws=wb.Sheets[wb.SheetNames[0]];const data=XLSX.utils.sheet_to_json(ws,{header:1,defval:""});let hi=0;for(let i=0;i<Math.min(data.length,20);i++){const row=data[i];if(!Array.isArray(row))continue;const j=row.join(" ").toLowerCase();if(j.includes("entity")||j.includes("campaign name")||j.includes("keyword text")||j.includes("impressions")){hi=i;break;}}const hdrs=data[hi].map(h=>String(h).trim()).filter(h=>h!=="");const rows=data.slice(hi+1).map(row=>{const obj={};hdrs.forEach((h,idx)=>{obj[h]=row[idx]!=null?row[idx]:"";});return obj;}).filter(r=>Object.values(r).some(v=>v!==""&&v!=null));resolve({headers:hdrs,rows});}catch(err){reject(err);}};reader.onerror=reject;reader.readAsArrayBuffer(file);});}

/* ─── Parse all sub-sheets from one Amazon bulk file ─────── */
function parseWorksheet(ws){
  const data=XLSX.utils.sheet_to_json(ws,{header:1,defval:""});
  let hi=0;
  for(let i=0;i<Math.min(data.length,20);i++){
    const row=data[i];if(!Array.isArray(row))continue;
    const j=row.join(" ").toLowerCase();
    if(j.includes("entity")||j.includes("campaign name")||j.includes("keyword text")||j.includes("impressions")){hi=i;break;}
  }
  const hdrs=data[hi].map(h=>String(h).trim()).filter(h=>h!=="");
  const rows=data.slice(hi+1).map(row=>{const obj={};hdrs.forEach((h,idx)=>{obj[h]=row[idx]!=null?row[idx]:"";});return obj;}).filter(r=>Object.values(r).some(v=>v!==""&&v!=null));
  return{headers:hdrs,rows};
}

function parseAllSheets(file){
  return new Promise((resolve,reject)=>{
    const reader=new FileReader();
    reader.onload=e=>{
      try{
        const wb=XLSX.read(new Uint8Array(e.target.result),{type:"array"});
        const result={sp:null,sb:null,sd:null,detected:[]};
        wb.SheetNames.forEach(name=>{
          const nl=name.toLowerCase();
          const ws=wb.Sheets[name];
          try{
            const parsed=parseWorksheet(ws);
            if(parsed.rows.length===0)return;
            if(nl.includes("sponsored products")||nl.includes("sp campaign")){
              result.sp=parsed;result.detected.push({key:"sp",name});
            } else if(nl.includes("sponsored display")||nl.includes("sd campaign")){
              result.sd=parsed;result.detected.push({key:"sd",name});
            } else if(nl.includes("sponsored brand")||nl.includes("sb campaign")||nl.includes("sb multi")){
              // merge SB sheets if multiple
              if(result.sb){
                result.sb={headers:result.sb.headers,rows:[...result.sb.rows,...parsed.rows]};
                result.detected.push({key:"sb",name:"(merged)"});
              } else {
                result.sb=parsed;result.detected.push({key:"sb",name});
              }
            }
          }catch(e2){/* skip bad sheets */}
        });
        resolve(result);
      }catch(err){reject(err);}
    };
    reader.onerror=reject;
    reader.readAsArrayBuffer(file);
  });
}

/* ─── localStorage ──────────────────────────────────────────── */
const LS_BRANDS="rmq_brands_v2";const LS_RULES=(bid,at)=>`rmq_rules_v3_${bid}_${at}`;
function loadBrands(){try{const r=localStorage.getItem(LS_BRANDS);if(r)return JSON.parse(r);}catch{}return[{id:"b1",name:"My First Brand"}];}
function saveBrands(b){try{localStorage.setItem(LS_BRANDS,JSON.stringify(b));}catch{}}
function makeRule(name){return{id:uid(),name:name||"New Rule",enabled:true,conditions:[{id:uid(),kpi:"acos",op:"gt",v1:"30",v2:""}],action:{type:"dec_amount",value:"0.10"},minBid:"0.02",maxBid:""};}
function defaultRules(){return[{id:uid(),name:"High performer — raise bid",enabled:true,conditions:[{id:uid(),kpi:"sales",op:"gt",v1:"5",v2:""},{id:uid(),kpi:"acos",op:"between",v1:"0",v2:"25"}],action:{type:"inc_amount",value:"0.10"},minBid:"0.02",maxBid:"3.00"},{id:uid(),name:"High ACoS — lower bid",enabled:true,conditions:[{id:uid(),kpi:"acos",op:"gt",v1:"40",v2:""}],action:{type:"dec_amount",value:"0.10"},minBid:"0.02",maxBid:""},{id:uid(),name:"Low impressions — push bid",enabled:true,conditions:[{id:uid(),kpi:"impressions",op:"lt",v1:"500",v2:""},{id:uid(),kpi:"orders",op:"gte",v1:"1",v2:""}],action:{type:"inc_pct",value:"15"},minBid:"0.02",maxBid:""}];}
function loadRules(bid,at){try{const r=localStorage.getItem(LS_RULES(bid,at));if(r)return JSON.parse(r);}catch{}return defaultRules();}
function saveRules(bid,at,rules){try{localStorage.setItem(LS_RULES(bid,at),JSON.stringify(rules));}catch{}}

/* ─── Style tokens ──────────────────────────────────────────── */
const T={inp:{fontSize:13,padding:"8px 11px",borderRadius:7,border:"1px solid var(--color-border-secondary)",background:"var(--color-background-primary)",color:"var(--color-text-primary)",outline:"none",width:"100%"},sel:{fontSize:13,padding:"8px 11px",borderRadius:7,border:"1px solid var(--color-border-secondary)",background:"var(--color-background-primary)",color:"var(--color-text-primary)",outline:"none",cursor:"pointer"},btnR:(sm)=>({display:"inline-flex",alignItems:"center",gap:6,padding:sm?"6px 14px":"9px 20px",borderRadius:8,background:R,color:"#fff",border:"none",fontSize:sm?12:13,fontWeight:500,cursor:"pointer",whiteSpace:"nowrap"}),btnG:(sm)=>({display:"inline-flex",alignItems:"center",gap:6,padding:sm?"6px 14px":"9px 20px",borderRadius:8,background:"var(--color-background-secondary)",color:"var(--color-text-secondary)",border:"1px solid var(--color-border-secondary)",fontSize:sm?12:13,fontWeight:500,cursor:"pointer",whiteSpace:"nowrap"}),btnW:(sm)=>({display:"inline-flex",alignItems:"center",gap:6,padding:sm?"6px 14px":"9px 20px",borderRadius:8,background:"var(--color-background-primary)",color:"var(--color-text-primary)",border:"1px solid var(--color-border-secondary)",fontSize:sm?12:13,fontWeight:500,cursor:"pointer",whiteSpace:"nowrap"}),label:{display:"block",fontSize:11,fontWeight:600,color:"var(--color-text-secondary)",marginBottom:5,letterSpacing:"0.5px",textTransform:"uppercase"}};

/* === STRATEGIST INSTRUCTION SYSTEM ============================
   Senior PPC strategist guides for every portal feature
=============================================================== */

const HELP_CONTENT = {
  bids: {
    name: "Bids Optimizer",
    badge: "Core",
    purpose: "Optimize keyword and product targeting bids using data-driven rules across Sponsored Products, Sponsored Brands, and Sponsored Display — without touching Seller Central one by one.",
    painPoint: "Manual bid management across hundreds or thousands of keywords is slow, inconsistent, and error-prone. Strategists waste hours downloading bulk sheets, copying data into Excel, and manually adjusting bids. This tool automates the logic while keeping the strategist in full control.",
    whenToUse: [
      "Weekly optimization cadence — every Monday morning before campaigns run",
      "After any major budget change or campaign restructure",
      "When ACoS spikes across multiple keywords simultaneously",
      "When scaling winners identified from search term reports",
      "After any Amazon algorithm or auction behavior change",
    ],
    inputs: [
      {name:"Amazon Bulk Export (.xlsx)", required:true, note:"From Seller Central → Campaign Manager → Bulk Operations. Contains SP, SB, SD tabs in one file."},
      {name:"Comparison Period Sheet", required:false, note:"Same bulk file from previous period. Enables delta analysis on every KPI."},
    ],
    howItWorks: [
      {title:"Sheet Auto-Detection", body:"Uploads one file and automatically reads SP, SB, SD campaign tabs. No manual extraction needed."},
      {title:"Rule Engine", body:"You define conditions (ACoS > 40%, Impressions < 500, etc.) with AND logic. First matching rule wins — order matters. Rules run in priority sequence."},
      {title:"Bid Calculation", body:"New bid = old bid ± your defined action ($, % or fixed). Safety limits (min/max bid) are enforced to prevent runaway bids."},
      {title:"Comparison Analysis", body:"When two periods are uploaded, every KPI shows delta vs previous — absolute change + percentage change. ACoS shows pp (percentage points) change."},
      {title:"Download", body:"Modified bulk file downloads with Operation = update set on changed rows — ready for direct re-upload to Amazon Seller Central."},
    ],
    readResults: [
      {label:"Green delta", meaning:"Metric improved vs previous period"},
      {label:"Red delta", meaning:"Metric declined vs previous period"},
      {label:"ACoS 0.0%", meaning:"Keyword had spend but no sales — potential waste"},
      {label:"ROAS —", meaning:"No data available for calculation"},
      {label:"Yellow row", meaning:"Bid has been manually edited in this session"},
      {label:"KW badge", meaning:"Keyword targeting row"},
      {label:"PT badge", meaning:"Product targeting row"},
    ],
    actions: [
      {finding:"High ACoS keyword (>40%)", action:"Decrease bid by $0.10–$0.20 or 10–15%", why:"Reduce auction cost per click to bring ACoS in line with target", outcome:"ACoS normalizes over 7–14 days"},
      {finding:"Low ACoS + good sales", action:"Increase bid by $0.10–$0.20", why:"You are winning at a profitable rate — push for more volume and rank", outcome:"More impressions, more clicks, potential rank improvement"},
      {finding:"High spend, zero sales", action:"Decrease bid aggressively or pause", why:"Pure waste — every click costs money with zero return", outcome:"Reduced wasted spend immediately"},
      {finding:"Low impressions + orders exist", action:"Increase bid by 15–20%", why:"Keyword converts but isn't getting visibility — you're under-bidding the auction", outcome:"More impressions, same CVR, more orders"},
      {finding:"High CVR, low CTR", action:"Increase bid + check placement modifiers", why:"Your listing converts when clicked — the problem is visibility not quality", outcome:"More traffic with strong conversion"},
    ],
    mistakes: [
      "Raising bids on keywords with no sales history — wait for statistical significance first",
      "Applying rules without safety limits — a rule without max bid can accidentally set $50 bids",
      "Running rules every day — bid changes need 5–7 days to show impact before next adjustment",
      "Ignoring match type context — Broad match at low ACoS might just have low volume, not efficiency",
      "Downloading without reviewing the preview — always check what will change before downloading",
    ],
    proTips: [
      "Sort by ACoS descending in the preview — your biggest problems are at the top",
      "Use the filter to isolate keywords with Spend > $10 and Orders = 0 — these are your bleeders",
      "Create separate rules for KW vs PT rows — product targeting behaves differently",
      "Set max bid limits = your target CPC × 1.5 to prevent overbidding",
      "Run Apply Rules first, review preview, then manually override specific bids before downloading",
      "Upload both periods every week — the comparison delta is your most powerful diagnostic tool",
    ],
    aiNote: "The Rules Engine is logic-based automation, not AI. It runs exactly the conditions you define. There is no guess work — every bid change is explainable and reversible. AI-powered suggestions are coming in a future update.",
    cadence: "Run weekly. Best practice: optimize on Monday using prior week's data (Mon–Sun). Allow 5–7 days before re-optimizing the same keywords.",
    takeaway: "The Bids Optimizer compresses 3–4 hours of manual bid work into under 20 minutes. More importantly, it enforces consistent logic — no more gut-feel adjustments. Every decision is rule-based, auditable, and strategic.",
  },
  action: {
    name: "Action Center",
    badge: "Core",
    purpose: "Your daily PPC command center. Surfaces the most critical actions across all campaigns ranked by urgency and estimated impact.",
    painPoint: "Strategists waste time deciding where to look first. The Action Center eliminates that by auto-ranking problems and opportunities by estimated dollar impact.",
    whenToUse: ["Every morning before touching any campaign", "After syncing fresh account data", "During weekly client reviews"],
    comingSoon: true,
  },
  priority: {
    name: "Priority Engine",
    badge: "Core",
    purpose: "Classifies every optimization opportunity into High, Medium, and Low priority buckets based on spend velocity, CVR collapse, ranking losses, and budget constraints.",
    painPoint: "Without priority scoring, strategists optimize the wrong things first — spending time on small wins while critical bleeders go untouched.",
    whenToUse: ["Start of every optimization session", "When account has 50+ campaigns", "When multiple issues need addressing simultaneously"],
    comingSoon: true,
  },
  negations: {
    name: "Negations",
    badge: "Core",
    purpose: "Identifies search terms that are consuming budget without converting and recommends negative keywords at the right campaign and match type level.",
    painPoint: "Irrelevant traffic is the silent killer of ACoS. Most accounts waste 15–30% of spend on terms that will never convert.",
    whenToUse: ["Weekly after downloading search term report", "After launching any broad or auto campaign", "When ACoS spikes unexpectedly"],
    comingSoon: true,
  },
  bleeder: {
    name: "Bleeder Check",
    badge: "Core",
    purpose: "Detects keywords, search terms, and campaigns that are spending significantly above their expected efficiency threshold with no return.",
    painPoint: "Bleeders are often hidden in large accounts. A $5/day bleeder across 40 keywords is $200/day in pure waste.",
    whenToUse: ["First thing Monday morning", "When spend increases but ACoS spikes", "Before any budget increases"],
    comingSoon: true,
  },
  sqpr: {
    name: "SQPR Analyzer",
    badge: "Core",
    purpose: "Analyzes the Search Query Performance Report to find click share gaps, conversion share gaps, and ranking opportunities your campaigns are missing.",
    painPoint: "The SQP report is Amazon's most powerful data source — but raw data is impossible to analyze manually across hundreds of queries.",
    whenToUse: ["Monthly for strategic planning", "When ranking is stagnant", "When launching keyword harvesting from search terms"],
    comingSoon: true,
  },
  reporting: {
    name: "Client Reporting",
    badge: "Core",
    purpose: "Generates professional AI-written executive summaries, performance narratives, TACOS analysis, and strategic recommendations ready to send to clients.",
    painPoint: "Client reports take 2–3 hours per account to write. Most are generic, not strategic. This generates structured, insight-rich reports in minutes.",
    whenToUse: ["Monthly client reviews", "After major performance changes", "Onboarding new clients"],
    comingSoon: true,
  },
};

/* === HELP MODAL =============================================== */
function HelpModal({open, onClose, featureKey}){
  const d = HELP_CONTENT[featureKey];
  if(!open || !d) return null;

  const bs = {Core:"#1a7a3c", AI:"#6338c8", Advanced:"#9a5800", Soon:"#888"};
  const bsBg = {Core:"rgba(26,122,60,0.08)", AI:"rgba(99,60,180,0.08)", Advanced:"rgba(154,88,0,0.08)", Soon:"rgba(0,0,0,0.04)"};

  const Section = ({icon, title, children}) => (
    <div style={{marginBottom:24}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
        <div style={{width:28,height:28,borderRadius:7,background:"rgba(79,70,229,0.08)",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <i className={`ti ${icon}`} style={{fontSize:13,color:R}}/>
        </div>
        <div style={{fontSize:13,fontWeight:700,color:"#111",letterSpacing:"-0.1px"}}>{title}</div>
      </div>
      {children}
    </div>
  );

  const Pill = ({text, color="#555", bg="#f0f0f0"}) => (
    <span style={{display:"inline-flex",alignItems:"center",padding:"3px 10px",borderRadius:20,background:bg,color,fontSize:11,fontWeight:600,margin:"3px 4px 3px 0"}}>{text}</span>
  );

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:4000,display:"flex",alignItems:"flex-start",justifyContent:"flex-end",backdropFilter:"blur(2px)"}}>
      <div style={{width:580,maxWidth:"95vw",height:"100vh",background:"#fff",boxShadow:"-20px 0 60px rgba(0,0,0,0.2)",display:"flex",flexDirection:"column",overflowY:"auto"}}>

        {/* Header */}
        <div style={{padding:"20px 24px 16px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"flex-start",justifyContent:"space-between",position:"sticky",top:0,background:"#fff",zIndex:1}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
              <div style={{fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>{d.name}</div>
              {d.badge&&<span style={{fontSize:9,padding:"2px 8px",borderRadius:4,background:bsBg[d.badge],color:bs[d.badge],fontWeight:800,letterSpacing:"0.5px",textTransform:"uppercase"}}>{d.badge}</span>}
            </div>
            <div style={{fontSize:12,color:"#888",fontStyle:"italic"}}>Strategist Guide — written by a senior Amazon PPC specialist</div>
          </div>
          <button onClick={onClose} style={{padding:"6px 10px",border:"none",background:"#f5f5f5",cursor:"pointer",borderRadius:7,fontSize:15,color:"#555",lineHeight:1}}>✕</button>
        </div>

        {/* Coming Soon overlay content */}
        {d.comingSoon ? (
          <div style={{flex:1,padding:"24px"}}>
            <div style={{background:"linear-gradient(135deg,rgba(79,70,229,0.04),rgba(79,70,229,0.02))",border:"1px solid rgba(79,70,229,0.12)",borderRadius:12,padding:"24px",marginBottom:20,textAlign:"center"}}>
              <i className="ti ti-clock" style={{fontSize:32,color:R,display:"block",marginBottom:12}}/>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Coming Soon</div>
              <div style={{fontSize:13,color:"#666",lineHeight:1.6}}>This feature is in development. Here's what it will solve:</div>
            </div>
            <Section icon="ti-target" title="Purpose">
              <p style={{fontSize:13,color:"#444",lineHeight:1.7,margin:0}}>{d.purpose}</p>
            </Section>
            <Section icon="ti-alert-circle" title="Strategist Pain Point Solved">
              <p style={{fontSize:13,color:"#444",lineHeight:1.7,margin:0}}>{d.painPoint}</p>
            </Section>
            <Section icon="ti-calendar-check" title="When You'll Use This">
              <div>{d.whenToUse?.map((u,i)=>(
                <div key={i} style={{display:"flex",gap:10,marginBottom:8}}>
                  <span style={{width:5,height:5,borderRadius:"50%",background:R,flexShrink:0,marginTop:6}}/>
                  <span style={{fontSize:13,color:"#444",lineHeight:1.6}}>{u}</span>
                </div>
              ))}</div>
            </Section>
            <div style={{padding:"14px 16px",background:"#f9f9f9",borderRadius:10,border:"1px solid #eee",fontSize:12,color:"#888",textAlign:"center"}}>
              Want this sooner? Email us at <a href="mailto:support@operaiq.quarred.com" style={{color:R,fontWeight:600,textDecoration:"none"}}>support@operaiq.quarred.com</a>
            </div>
          </div>
        ) : (
          <div style={{flex:1,padding:"24px"}}>

            {/* Purpose */}
            <Section icon="ti-target" title="Purpose & Strategic Value">
              <p style={{fontSize:13,color:"#444",lineHeight:1.7,margin:"0 0 10px"}}>{d.purpose}</p>
              <div style={{padding:"12px 14px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.1)",fontSize:12,color:"#555",lineHeight:1.6}}>
                <strong style={{color:R}}>Pain point solved:</strong> {d.painPoint}
              </div>
            </Section>

            {/* When to use */}
            <Section icon="ti-calendar-check" title="When to Use This">
              <div>{d.whenToUse?.map((u,i)=>(
                <div key={i} style={{display:"flex",gap:10,marginBottom:8,alignItems:"flex-start"}}>
                  <span style={{width:18,height:18,borderRadius:"50%",background:"rgba(79,70,229,0.08)",color:R,fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span>
                  <span style={{fontSize:13,color:"#444",lineHeight:1.6}}>{u}</span>
                </div>
              ))}</div>
            </Section>

            {/* Inputs */}
            {d.inputs&&<Section icon="ti-file-spreadsheet" title="Required Inputs">
              {d.inputs.map((inp,i)=>(
                <div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"10px 12px",background:"#fafafa",borderRadius:8,border:"1px solid #eee",marginBottom:8}}>
                  <span style={{fontSize:9,padding:"2px 7px",borderRadius:3,background:inp.required?"rgba(79,70,229,0.1)":"rgba(0,0,0,0.05)",color:inp.required?R:"#888",fontWeight:700,flexShrink:0,marginTop:1}}>{inp.required?"REQUIRED":"OPTIONAL"}</span>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:"#111",marginBottom:2}}>{inp.name}</div>
                    <div style={{fontSize:11,color:"#888",lineHeight:1.5}}>{inp.note}</div>
                  </div>
                </div>
              ))}
            </Section>}

            {/* How it works */}
            {d.howItWorks&&<Section icon="ti-settings" title="How It Works">
              {d.howItWorks.map((h,i)=>(
                <div key={i} style={{marginBottom:10,paddingLeft:12,borderLeft:`2px solid ${i===0?R:"#eee"}`}}>
                  <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:2}}>{h.title}</div>
                  <div style={{fontSize:12,color:"#555",lineHeight:1.6}}>{h.body}</div>
                </div>
              ))}
            </Section>}

            {/* Reading results */}
            {d.readResults&&<Section icon="ti-eye" title="How to Read the Results">
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                {d.readResults.map((r,i)=>(
                  <div key={i} style={{padding:"8px 10px",background:"#fafafa",borderRadius:7,border:"1px solid #eee"}}>
                    <div style={{fontSize:10,fontWeight:700,color:R,marginBottom:2}}>{r.label}</div>
                    <div style={{fontSize:11,color:"#555",lineHeight:1.4}}>{r.meaning}</div>
                  </div>
                ))}
              </div>
            </Section>}

            {/* Recommended actions */}
            {d.actions&&<Section icon="ti-bolt" title="Recommended Actions by Finding">
              {d.actions.map((a,i)=>(
                <div key={i} style={{marginBottom:10,padding:"12px 14px",background:"#fafafa",borderRadius:9,border:"1px solid #e8e8e8"}}>
                  <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:4}}>Finding</div>
                  <div style={{fontSize:12,fontWeight:600,color:"#111",marginBottom:8}}>{a.finding}</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                    <div><div style={{fontSize:10,fontWeight:700,color:R,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:2}}>Action</div><div style={{fontSize:11,color:"#444",lineHeight:1.5}}>{a.action}</div></div>
                    <div><div style={{fontSize:10,fontWeight:700,color:"#1a7a3c",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:2}}>Expected Outcome</div><div style={{fontSize:11,color:"#444",lineHeight:1.5}}>{a.outcome}</div></div>
                  </div>
                  <div style={{marginTop:8,fontSize:11,color:"#666",fontStyle:"italic",borderTop:"1px solid #eee",paddingTop:6}}>Why: {a.why}</div>
                </div>
              ))}
            </Section>}

            {/* Mistakes */}
            {d.mistakes&&<Section icon="ti-alert-triangle" title="Common Strategist Mistakes">
              <div style={{padding:"12px 14px",background:"rgba(212,43,43,0.04)",borderRadius:9,border:"1px solid rgba(212,43,43,0.12)"}}>
                {d.mistakes.map((m,i)=>(
                  <div key={i} style={{display:"flex",gap:8,marginBottom:i<d.mistakes.length-1?10:0,alignItems:"flex-start"}}>
                    <i className="ti ti-x" style={{fontSize:11,color:"#d42b2b",flexShrink:0,marginTop:2}}/>
                    <span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{m}</span>
                  </div>
                ))}
              </div>
            </Section>}

            {/* Pro tips */}
            {d.proTips&&<Section icon="ti-star" title="Pro Strategist Tips">
              <div style={{padding:"12px 14px",background:"rgba(26,158,74,0.04)",borderRadius:9,border:"1px solid rgba(26,158,74,0.12)"}}>
                {d.proTips.map((t,i)=>(
                  <div key={i} style={{display:"flex",gap:8,marginBottom:i<d.proTips.length-1?10:0,alignItems:"flex-start"}}>
                    <i className="ti ti-star-filled" style={{fontSize:10,color:"#1a9e4a",flexShrink:0,marginTop:2}}/>
                    <span style={{fontSize:12,color:"#444",lineHeight:1.5}}>{t}</span>
                  </div>
                ))}
              </div>
            </Section>}

            {/* AI Note */}
            {d.aiNote&&<Section icon="ti-brain" title="About AI & Automation">
              <div style={{padding:"12px 14px",background:"rgba(99,60,180,0.04)",borderRadius:9,border:"1px solid rgba(99,60,180,0.12)",fontSize:12,color:"#444",lineHeight:1.7}}>{d.aiNote}</div>
            </Section>}

            {/* Cadence */}
            {d.cadence&&<Section icon="ti-clock" title="Optimization Cadence">
              <div style={{padding:"12px 14px",background:"#fafafa",borderRadius:9,border:"1px solid #eee",fontSize:12,color:"#444",lineHeight:1.7}}>{d.cadence}</div>
            </Section>}

            {/* Takeaway */}
            {d.takeaway&&<div style={{padding:"16px 18px",background:"linear-gradient(135deg,rgba(79,70,229,0.06),rgba(79,70,229,0.03))",borderRadius:12,border:"1px solid rgba(79,70,229,0.12)",marginTop:4}}>
              <div style={{fontSize:11,fontWeight:800,color:R,textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:6}}>Final Takeaway</div>
              <div style={{fontSize:13,color:"#333",lineHeight:1.7,fontWeight:500}}>{d.takeaway}</div>
            </div>}

          </div>
        )}
      </div>
    </div>
  );
}

/* ─── Logo ──────────────────────────────────────────────────── */
function Logo({size=32}){return(
  <img src="data:image/png;base64,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" style={{width:size,height:size,borderRadius:size*0.18,objectFit:"contain",flexShrink:0,display:"block"}} alt="Quarred"/>
);}

function BrandDropdown({brands,activeId,onSwitch,onAdd,onRename,onDelete}){const[open,setOpen]=useState(false);const[adding,setAdding]=useState(false);const[newName,setNewName]=useState("");const[renId,setRenId]=useState(null);const[renVal,setRenVal]=useState("");const ref=useRef();const active=brands.find(b=>b.id===activeId);useEffect(()=>{const h=e=>{if(ref.current&&!ref.current.contains(e.target)){setOpen(false);setAdding(false);setRenId(null);}};document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);},[]);return(<div ref={ref} style={{position:"relative"}}><button onClick={()=>setOpen(o=>!o)} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 14px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",cursor:"pointer",fontSize:13,fontWeight:600,color:"#111",minWidth:210}}><i className="ti ti-building-store" style={{fontSize:14,color:R}}/><span style={{flex:1,textAlign:"left",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{active?.name||"Select Brand"}</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"var(--color-text-secondary)"}}/></button>{open&&(<div style={{position:"absolute",top:"calc(100% + 6px)",right:0,minWidth:260,background:"#fff",border:"1px solid #e8e8e8",borderRadius:12,boxShadow:"0 8px 40px rgba(0,0,0,0.14)",zIndex:999,overflow:"hidden"}}><div style={{padding:"10px 14px 8px",fontSize:10,color:"var(--color-text-tertiary)",letterSpacing:"0.8px",textTransform:"uppercase",borderBottom:"1px solid var(--color-border-tertiary)"}}>Switch Brand</div>{brands.map(b=>(<div key={b.id}>{renId===b.id?(<div style={{padding:"8px 12px",display:"flex",gap:6}}><input autoFocus style={{...T.inp,flex:1,padding:"5px 8px",fontSize:12}} value={renVal} onChange={e=>setRenVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){onRename(b.id,renVal.trim());setRenId(null);}if(e.key==="Escape")setRenId(null);}}/><button onClick={()=>{onRename(b.id,renVal.trim());setRenId(null);}} style={T.btnR(true)}>Save</button></div>):(<div onClick={()=>{onSwitch(b.id);setOpen(false);}} style={{display:"flex",alignItems:"center",gap:9,padding:"10px 14px",cursor:"pointer",background:b.id===activeId?"rgba(79,70,229,0.06)":"transparent",borderLeft:`2.5px solid ${b.id===activeId?R:"transparent"}`}}><span style={{flex:1,fontSize:13,fontWeight:b.id===activeId?500:400,color:b.id===activeId?R:"var(--color-text-primary)"}}>{b.name}</span>{b.id===activeId&&(<div style={{display:"flex",gap:3}} onClick={e=>e.stopPropagation()}><button onClick={()=>{setRenId(b.id);setRenVal(b.name);}} style={{padding:"3px 6px",border:"none",background:"transparent",cursor:"pointer",color:"var(--color-text-tertiary)",fontSize:12}}><i className="ti ti-pencil"/></button>{brands.length>1&&<button onClick={()=>{if(window.confirm(`Delete "${b.name}"?`)){onDelete(b.id);setOpen(false);}}} style={{padding:"3px 6px",border:"none",background:"transparent",cursor:"pointer",color:"#A32D2D",fontSize:12}}><i className="ti ti-trash"/></button>}</div>)}</div>)}</div>))}<div style={{borderTop:"1px solid var(--color-border-tertiary)",padding:"8px 12px"}}>{adding?(<div style={{display:"flex",gap:6}}><input autoFocus placeholder="Brand name" style={{...T.inp,flex:1,padding:"5px 8px",fontSize:12}} value={newName} onChange={e=>setNewName(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&newName.trim()){onAdd(newName.trim());setNewName("");setAdding(false);setOpen(false);}if(e.key==="Escape")setAdding(false);}}/><button onClick={()=>{if(newName.trim()){onAdd(newName.trim());setNewName("");setAdding(false);setOpen(false);}}} style={T.btnR(true)}>Add</button></div>):(<button onClick={()=>setAdding(true)} style={{display:"flex",alignItems:"center",gap:6,width:"100%",padding:"7px 10px",borderRadius:7,border:"1px dashed var(--color-border-secondary)",background:"transparent",cursor:"pointer",fontSize:12,color:"var(--color-text-secondary)"}}><i className="ti ti-plus" style={{fontSize:13}}/> Add New Brand</button>)}</div></div>)}</div>);}

/* ─── Topbar ────────────────────────────────────────────────── */
function Topbar({brands,activeId,onSwitch,onAdd,onRename,onDelete,adTypeLabel}){
  return(
    <div style={{height:52,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 24px",background:"#fff",borderBottom:"1px solid #f0f0f0",flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"#aaa",fontWeight:500,letterSpacing:"0.2px"}}>
        <span style={{textTransform:"uppercase",letterSpacing:"0.8px",fontSize:10,fontWeight:700}}>Bids Optimizer</span>
        {adTypeLabel&&<><span style={{color:"#ddd",fontSize:16,lineHeight:1}}>›</span><span style={{color:R,fontWeight:700,fontSize:11}}>{adTypeLabel}</span></>}
      </div>
      <BrandDropdown brands={brands} activeId={activeId} onSwitch={onSwitch} onAdd={onAdd} onRename={onRename} onDelete={onDelete}/>
    </div>
  );
}

/* ─── Sidebar ───────────────────────────────────────────────── */
const BIDS_SUB=[
  {key:"sp",label:"Sponsored Products"},
  {key:"sd",label:"Sponsored Display"},
  {key:"sb",label:"Sponsored Brands"}
];

const NAV=[
  /* ── 1. STRATEGIST COMMAND CENTER ── */
  {section:"Command Center"},
  {key:"hub",        icon:"ti-database-import",   label:"Data Hub",            badge:"Core",    desc:"Upload once — all modules sync automatically"},
  {key:"action",     icon:"ti-layout-dashboard",  label:"Action Center",       badge:"Core",    desc:"Daily priorities, alerts, scaling opps"},
  {key:"priority",   icon:"ti-list-check",         label:"Priority Engine",     badge:"Core",    desc:"Auto-ranked action queue"},
  {key:"ai",         icon:"ti-brain",              label:"AI Strategist",       badge:"AI",      desc:"AI-powered account analysis & strategic recommendations"},

  /* ── 2. CORE STRATEGIST WORKFLOW ── */
  {section:"Bid Management"},
  {key:"bids",       icon:"ti-adjustments-horizontal", label:"Bids Optimizer",  badge:"Core",    hasSub:true},
  {key:"brandtable", icon:"ti-table-heart",         label:"Brand Table",         badge:"Core",    desc:"Product catalog with ASIN data, COGs, breakeven calculations"},
  {key:"bulk",       icon:"ti-file-plus",          label:"Bulk Builder",        badge:"Core",    desc:"Campaign structure generation & bulk upload builder"},
  {key:"automation", icon:"ti-robot",              label:"Rules Engine",        badge:"Advanced", desc:"PPC automation rules & bid simulator"},

  /* ── 3. SEARCH TERM INTELLIGENCE ── */
  {section:"Search Term Intel"},
  {key:"sqpr",       icon:"ti-search",             label:"SQPR Analyzer",       badge:"Core",    desc:"Click share, conversion share & market intelligence"},
  {key:"negations",  icon:"ti-ban",                label:"Negation Engine",     badge:"Core",    desc:"Waste detection & Amazon-ready negative sheets"},
  {key:"searchterms",icon:"ti-eye-search",         label:"Search Term Intel",   badge:"Core",    desc:"Bleeding, scaling & discovery terms"},
  {key:"intent",     icon:"ti-target",             label:"Search Intent AI",    badge:"AI",      desc:"Classify intent behind search queries"},

  /* ── 4. CAMPAIGN HEALTH ── */
  {section:"Campaign Health"},
  {key:"bleeder",    icon:"ti-droplet-off",        label:"Bleeder Check",       badge:"Core",    desc:"Bleeding spend & CVR decay"},
  {key:"health",     icon:"ti-heart-rate-monitor", label:"Campaign Health",     badge:"Core",    desc:"Budget, CPC, placement inefficiencies"},
  {key:"campaigns",  icon:"ti-speakerphone",       label:"Campaign Suggestions",badge:"Core",    desc:"Structure & cannibalization fixes"},
  {key:"conflict",   icon:"ti-alert-triangle",     label:"Conflict Detector",   badge:"Advanced", desc:"Cross-campaign keyword conflicts"},

  /* ── 5. INTELLIGENCE & INSIGHTS ── */
  {section:"Intelligence"},
  {key:"impression", icon:"ti-eye",                label:"Impression Share",    badge:"Core",    desc:"Lost share, TOS & visibility trends"},
  {key:"rank",       icon:"ti-trending-up",        label:"Rank Radar",          badge:"Core",    desc:"Keyword rank movement & ranking intelligence"},
  {key:"niche",      icon:"ti-telescope",          label:"Niche Dives",         badge:"Advanced", desc:"Market & competitor intelligence"},
  {key:"placement",  icon:"ti-layout-2",           label:"Placement Optimizer", badge:"Core",    desc:"TOS, Product Pages & Rest of Search optimization"},
  {key:"dayparting", icon:"ti-clock",              label:"Dayparting Intel",    badge:"Core",    desc:"Hourly performance analysis & bid scheduling"},

  /* ── 6. RESEARCH & COMPETITIVE ── */
  {section:"Research & Competitive"},
  {key:"branddef",   icon:"ti-shield",  label:"Brand Defense",    badge:"Advanced", desc:"Monitor & defend branded terms"},
  {key:"competitor", icon:"ti-radar",   label:"Competitor Radar", badge:"Advanced", desc:"Competitor attack & movement alerts"},
  {key:"portfolio",  icon:"ti-command",           label:"Portfolio Command", badge:"Advanced", desc:"Portfolio-level performance & budget intelligence"},
  {key:"seasonal",   icon:"ti-calendar-event",     label:"Seasonal Engine",     badge:"Advanced", desc:"Trend-aware campaign planning"},
  {key:"inventory",  icon:"ti-package",            label:"Inventory & PPC Intel",badge:"Core",    desc:"Stock risk, stockout prevention & inventory-aware scaling"},

  /* ── 7. REPORTING & CLIENT COMMS ── */
  {section:"Reporting"},
  {key:"reporting",  icon:"ti-file-analytics",     label:"Client Reporting",    badge:"Core",    desc:"AI-generated exec summaries & TACOS"},
  {key:"audit",      icon:"ti-clipboard-check",    label:"Account Audit",       badge:"Core",    desc:"Full account health diagnostic"},
  {key:"listing",    icon:"ti-list-details",       label:"Listing Conversion",  badge:"Core",    desc:"Conversion intelligence & listing optimization"},

  /* ── 8. SYSTEM ── */
  {section:"System"},
  {key:"strharvest", icon:"ti-plant-2",            label:"STR Harvest Engine",  badge:"Core",    desc:"Harvest converting search terms into campaigns with bulk-ready output"},
  {key:"dedup",      icon:"ti-copy-off",           label:"Portfolio Deduplication", badge:"Core", desc:"Find and fix duplicate keywords across campaigns and portfolios"},
  {key:"stin",       icon:"ti-chart-radar",        label:"STIN — Search Term Intel", badge:"Core", desc:"Full account picture: match type, portfolio, impression share with comparison"},
  {key:"learning",   icon:"ti-school",             label:"PPC Learning Hub",    badge:"Core"},
  {key:"settings",   icon:"ti-settings",           label:"Settings",            badge:"Core"},
];

/* Badge colors */
const BADGE_STYLE={
  Core:     {bg:"rgba(26,158,74,0.12)",  color:"#1a7a3c"},
  AI:       {bg:"rgba(99,60,180,0.12)",  color:"#6338c8"},
  Soon:     {bg:"rgba(0,0,0,0.06)",      color:"#999"},
  Advanced: {bg:"rgba(200,120,0,0.12)",  color:"#9a5800"},
};

/* ── 2FA toggle card (email-based two-factor auth) ── */
function TwoFACard({user}){
  const[on,setOn]=useState(!!user?.twofaEnabled);
  const[busy,setBusy]=useState(false);
  const[msg,setMsg]=useState("");
  function toggle(){
    if(busy)return;
    const next=!on; setBusy(true); setMsg("");
    fetch(API_BASE+"/api/auth/set_2fa",{method:"POST",headers:{"Content-Type":"application/json","Authorization":"Bearer "+(localStorage.getItem("rq_token")||"")},body:JSON.stringify({enabled:next})})
      .then(r=>r.json())
      .then(d=>{setBusy(false);if(d.error){setMsg(d.error);return;}setOn(d.twofaEnabled);
        const a=loadAuth&&loadAuth();if(a){a.twofaEnabled=d.twofaEnabled;saveAuth(a);}
        setMsg(d.twofaEnabled?"2FA is on — we'll email you a 6-digit code at every sign-in.":"2FA turned off.");})
      .catch(()=>{setBusy(false);setMsg("Network error, try again.");});
  }
  return(
    <div style={{background:"#faf9fd",border:"1px solid #e2ddf0",borderRadius:12,padding:18,marginTop:14}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"#4f46e5",marginBottom:4}}>Two-Factor Authentication (2FA)</div>
          <div style={{fontSize:12,color:"#777",lineHeight:1.6}}>Extra security: at every sign-in we email a 6-digit code to {user?.email||"your inbox"}.</div>
        </div>
        <button onClick={toggle} disabled={busy}
          style={{position:"relative",width:46,height:26,borderRadius:20,border:"none",cursor:busy?"wait":"pointer",flexShrink:0,
            background:on?"#4f46e5":"#d5d5de",transition:"background 0.2s"}}>
          <span style={{position:"absolute",top:3,left:on?23:3,width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.25)"}}/>
        </button>
      </div>
      {msg&&<div style={{fontSize:11.5,color:on?"#1d8a4e":"#777",marginTop:10}}>{msg}</div>}
    </div>
  );
}

/* ── Account Modal: Account Settings / Billing / Team / Help ── */
function AccountModal({user,initialTab,onClose,onLogout,onUpgrade}){
  const[tab,setTab]=useState(initialTab||"account");
  const plan=PLANS.find(p=>p.id===(user?.plan||"pro"))||PLANS[1];
  const R="#4f46e5";
  const tabs=[
    {id:"account",label:"Account Settings",icon:"ti-user-circle"},
    {id:"billing",label:"Billing & Subscription",icon:"ti-credit-card"},
    {id:"team",label:"Team Members",icon:"ti-users"},
    {id:"help",label:"Help & Support",icon:"ti-help-circle"},
  ];
  const card={background:"#fff",border:"1px solid #ececf0",borderRadius:12,padding:18,marginBottom:14};
  const lbl={fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:6};
  const val={fontSize:14,color:"#222",fontWeight:600};
  return(
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(15,15,20,0.55)",backdropFilter:"blur(3px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div onClick={e=>e.stopPropagation()} style={{width:"min(820px,96vw)",height:"min(620px,92vh)",background:"#f7f7f9",borderRadius:18,overflow:"hidden",display:"flex",boxShadow:"0 24px 80px rgba(0,0,0,0.4)"}}>
        {/* left tabs */}
        <div style={{width:230,background:"#fff",borderRight:"1px solid #ececf0",padding:"20px 12px",display:"flex",flexDirection:"column"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"0 8px 18px"}}>
            <div style={{width:38,height:38,borderRadius:10,background:R,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:900,fontSize:17}}>{user?.avatar||user?.name?.[0]?.toUpperCase()||"U"}</div>
            <div style={{overflow:"hidden"}}>
              <div style={{fontSize:13,fontWeight:800,color:"#111",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{user?.name}</div>
              <div style={{fontSize:10,color:plan.color,fontWeight:700,textTransform:"uppercase"}}>{plan.name}</div>
            </div>
          </div>
          {tabs.map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:9,border:"none",background:tab===t.id?R+"12":"transparent",color:tab===t.id?R:"#555",fontSize:13,fontWeight:tab===t.id?700:500,cursor:"pointer",textAlign:"left",marginBottom:3}}>
              <i className={"ti "+t.icon} style={{fontSize:16}}/>{t.label}
            </button>
          ))}
          <div style={{flex:1}}/>
          <button onClick={()=>{onLogout&&onLogout();}} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:9,border:"none",background:"transparent",color:"#d42b2b",fontSize:13,fontWeight:600,cursor:"pointer",textAlign:"left"}}>
            <i className="ti ti-logout" style={{fontSize:16}}/>Sign Out
          </button>
        </div>
        {/* right content */}
        <div style={{flex:1,overflow:"auto",padding:"22px 26px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
            <div style={{fontSize:18,fontWeight:800,color:"#111"}}>{tabs.find(t=>t.id===tab)?.label}</div>
            <button onClick={onClose} style={{width:30,height:30,borderRadius:8,border:"1px solid #e2e2e8",background:"#fff",cursor:"pointer",color:"#888",fontSize:15}}>✕</button>
          </div>

          {tab==="account"&&(
            <div>
              <div style={card}>
                <div style={lbl}>Full Name</div><div style={val}>{user?.name||"—"}</div>
                <div style={{...lbl,marginTop:16}}>Email Address</div><div style={val}>{user?.email||"—"}</div>
                <div style={{...lbl,marginTop:16}}>Account ID</div><div style={{...val,fontFamily:"monospace",fontSize:12}}>{user?.id||"—"}</div>
                <div style={{...lbl,marginTop:16}}>Member Since</div><div style={val}>{user?.createdAt?new Date(user.createdAt).toLocaleDateString():"—"}</div>
              </div>
              <div style={card}>
                <div style={{fontSize:13,fontWeight:700,color:R,marginBottom:6}}>Password</div>
                <div style={{fontSize:12,color:"#777",lineHeight:1.6}}>To change your password, sign out and click <b>Forgot?</b> on the login screen — we'll email you a secure reset link.</div>
              </div>
              <TwoFACard user={user}/>
            </div>
          )}

          {tab==="billing"&&(
            <div>
              <div style={{...card,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={lbl}>Current Plan</div>
                  <div style={{fontSize:20,fontWeight:800,color:plan.color}}>{plan.name}</div>
                  <div style={{fontSize:12,color:"#888",marginTop:3}}>All modules unlocked · Beta access</div>
                </div>
                <span style={{padding:"6px 14px",borderRadius:20,background:"#e6f7ec",color:"#1d9b54",fontSize:12,fontWeight:700}}>● Active</span>
              </div>
              <div style={card}>
                <div style={{fontSize:13,fontWeight:700,color:"#222",marginBottom:10}}>Billing</div>
                <div style={{fontSize:12,color:"#777",lineHeight:1.7}}>
                  OperaIQ is currently <b>free during beta</b> — no payment required and no card on file. Paid plans (Pro & Agency) will launch later with full billing, invoices, and subscription management here.
                </div>
              </div>
              <div style={{padding:"12px 14px",background:"#f0f4ff",border:"1px solid #d4def5",borderRadius:10,fontSize:12,color:"#3a4fb8"}}>
                <i className="ti ti-info-circle" style={{marginRight:6}}/>You're on full Agency access at no cost during the beta period.
              </div>
            </div>
          )}

          {tab==="team"&&(
            <div>
              <div style={card}>
                <div style={{fontSize:13,fontWeight:700,color:"#222",marginBottom:4}}>Your Team</div>
                <div style={{fontSize:12,color:"#888",marginBottom:14}}>Strategists with access to this OperaIQ workspace.</div>
                <div style={{display:"flex",alignItems:"center",gap:12,padding:"12px",background:"#fafafb",borderRadius:10,border:"1px solid #eee"}}>
                  <div style={{width:36,height:36,borderRadius:"50%",background:R,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>{user?.avatar||user?.name?.[0]?.toUpperCase()||"U"}</div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{user?.name} <span style={{fontSize:10,color:"#888",fontWeight:500}}>(You)</span></div>
                    <div style={{fontSize:11,color:"#888"}}>{user?.email}</div>
                  </div>
                  <span style={{padding:"4px 10px",borderRadius:8,background:R+"12",color:R,fontSize:10,fontWeight:700}}>{user?.isAdmin?"OWNER":"MEMBER"}</span>
                </div>
              </div>
              <div style={{...card,background:"#fff8f8",border:"1px solid #f3d9d9"}}>
                <div style={{fontSize:13,fontWeight:700,color:R,marginBottom:6}}>Invite Team Members</div>
                <div style={{fontSize:12,color:"#777",lineHeight:1.6}}>Multi-seat team invites are coming soon. For now, additional strategists can be added by the admin from the admin panel.</div>
              </div>
            </div>
          )}

          {tab==="help"&&(
            <div>
              <div style={card}>
                <div style={{fontSize:13,fontWeight:700,color:"#222",marginBottom:10}}>Get Help</div>
                <a href="mailto:support@operaiq.quarred.com" style={{display:"flex",alignItems:"center",gap:12,padding:"12px",background:"#fafafb",borderRadius:10,border:"1px solid #eee",textDecoration:"none",marginBottom:10}}>
                  <i className="ti ti-mail" style={{fontSize:20,color:R}}/>
                  <div><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Email Support</div><div style={{fontSize:11,color:"#888"}}>support@operaiq.quarred.com</div></div>
                </a>
                <a href="https://wa.me/923295367480" target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",gap:12,padding:"12px",background:"#fafafb",borderRadius:10,border:"1px solid #eee",textDecoration:"none",marginBottom:10}}>
                  <i className="ti ti-brand-whatsapp" style={{fontSize:20,color:R}}/>
                  <div><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Phone / WhatsApp</div><div style={{fontSize:11,color:"#888"}}>+92 329 5367480</div></div>
                </a>
                <div style={{display:"flex",alignItems:"center",gap:12,padding:"12px",background:"#fafafb",borderRadius:10,border:"1px solid #eee"}}>
                  <i className="ti ti-book" style={{fontSize:20,color:R}}/>
                  <div><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Documentation</div><div style={{fontSize:11,color:"#888"}}>In-app help is available via the ? icons next to each module.</div></div>
                </div>
              </div>
              <div style={card}>
                <div style={{fontSize:13,fontWeight:700,color:"#222",marginBottom:6}}>About OperaIQ</div>
                <div style={{fontSize:12,color:"#777",lineHeight:1.7}}>OperaIQ is an Amazon PPC Operating System by Quarred. Version 1.0 (Beta).</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── Sidebar Profile (bottom-left), opens account modal ── */
function SidebarProfile({user,onLogout,onUpgrade,onOpenAccount,onAdmin}){
  const[open,setOpen]=useState(false);
  const plan=PLANS.find(p=>p.id===(user?.plan||"pro"))||PLANS[1];
  const ref=useRef();
  const R="#4f46e5";
  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);
  function go(tab){ setOpen(false); onOpenAccount(tab); }
  return(
    <div ref={ref} style={{position:"relative",padding:"10px 12px",borderTop:"1px solid rgba(255,255,255,0.08)"}}>
      {open&&(
        <div style={{position:"absolute",bottom:"calc(100% + 6px)",left:12,right:12,background:"#fff",borderRadius:12,border:"1px solid #e8e8e8",boxShadow:"0 -8px 40px rgba(0,0,0,0.25)",overflow:"hidden",zIndex:200}}>
          <div style={{padding:"13px 15px",borderBottom:"1px solid #f0f0f0"}}>
            <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{user?.name}</div>
            <div style={{fontSize:11,color:"#888",marginTop:2}}>{user?.email}</div>
            <span style={{display:"inline-flex",alignItems:"center",gap:5,marginTop:7,padding:"2px 9px",borderRadius:9,background:plan.color+"18",color:plan.color,fontSize:10,fontWeight:700}}>
              <i className="ti ti-crown" style={{fontSize:9}}/>{plan.name} Plan
            </span>
          </div>
          {[
            {icon:"ti-user-circle",label:"Account Settings",tab:"account"},
            {icon:"ti-credit-card",label:"Billing & Subscription",tab:"billing"},
            {icon:"ti-users",label:"Team Members",tab:"team"},
            {icon:"ti-help-circle",label:"Help & Support",tab:"help"},
          ].map((item,i)=>(
            <button key={i} onClick={()=>go(item.tab)} style={{width:"100%",padding:"9px 15px",border:"none",background:"transparent",display:"flex",alignItems:"center",gap:10,cursor:"pointer",fontSize:12,color:"#333",textAlign:"left"}}
              onMouseEnter={e=>e.currentTarget.style.background="#f6f6f8"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <i className={"ti "+item.icon} style={{fontSize:13,color:"#999"}}/>{item.label}
            </button>
          ))}
          {onAdmin&&(
            <button onClick={()=>{setOpen(false);onAdmin();}} style={{width:"100%",padding:"9px 15px",border:"none",borderTop:"1px solid #f5f5f5",background:"transparent",display:"flex",alignItems:"center",gap:10,cursor:"pointer",fontSize:12,color:R,fontWeight:700,textAlign:"left"}}
              onMouseEnter={e=>e.currentTarget.style.background="#fbeaea"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <i className="ti ti-shield" style={{fontSize:13}}/>Admin Panel
            </button>
          )}
          <div style={{borderTop:"1px solid #f5f5f5"}}>
            <button onClick={()=>{setOpen(false);onLogout();}} style={{width:"100%",padding:"10px 15px",border:"none",background:"transparent",display:"flex",alignItems:"center",gap:10,cursor:"pointer",fontSize:12,color:"#d42b2b",fontWeight:600,textAlign:"left"}}>
              <i className="ti ti-logout" style={{fontSize:12}}/>Sign Out
            </button>
          </div>
        </div>
      )}
      <button onClick={()=>setOpen(o=>!o)} style={{width:"100%",display:"flex",alignItems:"center",gap:9,padding:"7px 8px",borderRadius:9,border:"none",background:open?"rgba(255,255,255,0.08)":"transparent",cursor:"pointer"}}
        onMouseEnter={e=>{if(!open)e.currentTarget.style.background="rgba(255,255,255,0.05)";}} onMouseLeave={e=>{if(!open)e.currentTarget.style.background="transparent";}}>
        <div style={{width:30,height:30,borderRadius:"50%",background:R,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:13,fontWeight:900,flexShrink:0}}>
          {user?.avatar||user?.name?.[0]?.toUpperCase()||"U"}
        </div>
        <div style={{flex:1,textAlign:"left",overflow:"hidden"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#fff",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{user?.name}</div>
          <div style={{fontSize:9,fontWeight:700,color:plan.color,textTransform:"uppercase",letterSpacing:"0.4px"}}>{plan.name}</div>
        </div>
        <i className="ti ti-chevron-up" style={{fontSize:11,color:"rgba(255,255,255,0.5)",transform:open?"rotate(0deg)":"rotate(180deg)",transition:"transform 0.15s"}}/>
      </button>
      <div style={{fontSize:9,color:"rgba(255,255,255,0.35)",letterSpacing:"0.5px",marginTop:8,paddingLeft:2}}>v1.0 · Beta · OperaIQ</div>
    </div>
  );
}

/* ── Sidebar ─────────────────────────────────────────────── */
function Sidebar({active,adType,setAdType,setTab,onHelp,user,onLogout,onUpgrade,onOpenAccount,onAdmin}){
  const[collapsed,setCollapsed]=useState({});
  const toggle=sec=>setCollapsed(p=>({...p,[sec]:!p[sec]}));

  return(
    <div style={{width:234,flexShrink:0,background:"#1c1c1c",display:"flex",flexDirection:"column",height:"100vh",position:"sticky",top:0,overflowY:"auto"}}>

      {/* Logo */}
      <div style={{padding:"0 16px",height:52,display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid rgba(255,255,255,0.08)",flexShrink:0}}>
        <Logo size={28}/>
        <div>
          <div style={{fontSize:13,fontWeight:800,color:"#ffffff",letterSpacing:"-0.3px"}}>OperaIQ</div>
          <div style={{fontSize:8,color:R,fontWeight:800,letterSpacing:"1.5px",textTransform:"uppercase"}}>by Quarred</div>
        </div>
      </div>

      {/* Nav */}
      <div style={{flex:1,padding:"10px 8px 20px"}}>
        {NAV.map((item,i)=>{

          /* ── Section header ── */
          if(item.section){
            const isCollapsed=collapsed[item.section];
            return(
              <div key={item.section+i} onClick={()=>toggle(item.section)}
                style={{display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:9,color:"#ffffff",padding:i===0?"10px 10px 5px":"18px 10px 5px",letterSpacing:"1.4px",textTransform:"uppercase",fontWeight:800,cursor:"pointer",userSelect:"none",opacity:0.7}}>
                {item.section}
                <i className={`ti ${isCollapsed?"ti-chevron-right":"ti-chevron-down"}`} style={{fontSize:9,opacity:0.6}}/>
              </div>
            );
          }

          /* Skip if parent section collapsed */
          let parentSection=null;
          for(let j=i-1;j>=0;j--){if(NAV[j].section){parentSection=NAV[j].section;break;}}
          if(parentSection&&collapsed[parentSection])return null;

          const on=active===item.key;
          const BADGE={Core:{bg:"rgba(26,158,74,0.2)",c:"#4dda7a"},AI:{bg:"rgba(140,80,255,0.2)",c:"#b48fff"},Soon:{bg:"rgba(255,255,255,0.1)",c:"#aaa"},Advanced:{bg:"rgba(255,160,0,0.18)",c:"#ffb84d"}};
          const bs=item.badge?BADGE[item.badge]||BADGE.Soon:null;

          /* ── Bids Optimizer with sub-menu ── */
          if(item.hasSub){
            return(
              <div key={item.key}>
                <div onClick={()=>setTab&&setTab("bids")} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",fontSize:13,fontWeight:700,color:"#ffffff",background:on?"rgba(255,255,255,0.08)":"transparent",borderRadius:7,marginBottom:2,cursor:"pointer"}}>
                  <i className={`ti ${item.icon}`} style={{fontSize:14,color:on?R:"rgba(255,255,255,0.6)",flexShrink:0}}/>
                  <span style={{flex:1}}>{item.label}</span>
                  {bs&&<span style={{fontSize:8,padding:"2px 6px",borderRadius:3,background:bs.bg,color:bs.c,fontWeight:700}}>{item.badge}</span>}
                </div>
                {on&&(
                  <div style={{marginLeft:10,marginBottom:6,paddingLeft:4,borderLeft:"1px solid rgba(255,255,255,0.12)"}}>
                    {BIDS_SUB.map(sub=>{
                      const sOn=adType===sub.key;
                      return(
                        <div key={sub.key} onClick={()=>setAdType(sub.key)}
                          style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px 7px 12px",fontSize:12.5,fontWeight:sOn?600:400,color:sOn?"#ffffff":"rgba(255,255,255,0.75)",background:sOn?"rgba(79,70,229,0.55)":"transparent",borderRadius:7,cursor:"pointer",marginBottom:2,transition:"all 0.1s",border:sOn?"1px solid rgba(79,70,229,0.8)":"1px solid transparent"}}>
                          <span style={{width:5,height:5,borderRadius:"50%",background:sOn?R:"rgba(255,255,255,0.4)",flexShrink:0}}/>
                          {sub.label}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          }

          /* ── Regular nav item ── */
          return(
            <div key={item.key}
              onClick={()=>!item.soon&&setTab&&setTab(item.key)}
              style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",fontSize:12.5,
                fontWeight:on?600:400,
                color:on?"#ffffff":item.soon?"rgba(255,255,255,0.65)":"rgba(255,255,255,0.88)",
                background:on?"rgba(255,255,255,0.09)":"transparent",
                borderRadius:7,cursor:item.soon?"not-allowed":"pointer",marginBottom:2,
                transition:"background 0.1s"}}>
              <i className={`ti ${item.icon}`} style={{fontSize:13,color:on?R:"rgba(255,255,255,0.55)",flexShrink:0}}/>
              <span style={{flex:1,lineHeight:1.2}}>{item.label}</span>
              {HELP_CONTENT[item.key]&&!item.soon&&(
                <button className="help-btn" onClick={e=>{e.stopPropagation();onHelp&&onHelp(item.key);}}
                  style={{padding:"1px 5px",borderRadius:3,border:"none",background:"rgba(255,255,255,0.12)",color:"rgba(255,255,255,0.6)",fontSize:9,fontWeight:700,cursor:"pointer",lineHeight:1.4}}>?</button>
              )}
              {bs&&<span style={{fontSize:8,padding:"2px 6px",borderRadius:3,background:bs.bg,color:bs.c,fontWeight:700,letterSpacing:"0.3px",whiteSpace:"nowrap"}}>{item.badge}</span>}
              {item.soon&&!bs&&<span style={{fontSize:8,padding:"2px 5px",borderRadius:3,background:"rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.5)",fontWeight:600}}>Soon</span>}
            </div>
          );
        })}
      </div>

      <SidebarProfile user={user} onLogout={onLogout} onUpgrade={onUpgrade} onOpenAccount={onOpenAccount} onAdmin={onAdmin}/>
    </div>
  );
}

/* === DATE RANGE PICKER ======================================= */
function CalMonth({year,month,selStart,selEnd,hovDate,onDayClick,onDayHover}){
  const firstDow=new Date(year,month,1).getDay();const total=new Date(year,month+1,0).getDate();const days=[];
  for(let i=0;i<firstDow;i++)days.push(null);for(let d=1;d<=total;d++)days.push(new Date(year,month,d));
  const today0=startOfDay(new Date());
  function inRange(d){if(!d||!selStart)return false;const e=selEnd||hovDate;if(!e)return false;const lo=selStart<e?selStart:e,hi=selStart<e?e:selStart;return d>=startOfDay(lo)&&d<=startOfDay(hi);}
  return(<div><div style={{textAlign:"center",fontSize:13,fontWeight:600,color:"#111",marginBottom:10}}>{MONTHS[month]} {year}</div><div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:1,marginBottom:4}}>{["Su","Mo","Tu","We","Th","Fr","Sa"].map(d=><div key={d} style={{textAlign:"center",fontSize:10,color:"#bbb",fontWeight:600,padding:"3px 0"}}>{d}</div>)}</div><div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:1}}>{days.map((d,i)=>{if(!d)return<div key={`e${i}`}/>;const isStart=selStart&&isSameDay(d,selStart),isEnd=selEnd&&isSameDay(d,selEnd),inR=inRange(d),isFut=d>today0;return(<div key={d.getDate()} onClick={()=>!isFut&&onDayClick(d)} onMouseEnter={()=>!isFut&&onDayHover(d)} style={{textAlign:"center",padding:"5px 2px",borderRadius:6,fontSize:12,cursor:isFut?"not-allowed":"pointer",background:isStart||isEnd?R:inR?"rgba(79,70,229,0.1)":"transparent",color:isStart||isEnd?"#fff":isFut?"#ccc":"#111",fontWeight:isStart||isEnd?600:400,border:`1px solid ${isSameDay(d,new Date())?"rgba(79,70,229,0.4)":"transparent"}`}}>{d.getDate()}</div>);})}</div></div>);
}
function DateRangePicker({onConfirm}){
  const now=new Date();const[viewYear,setViewYear]=useState(now.getFullYear());const[viewMonth,setViewMonth]=useState(now.getMonth()===0?0:now.getMonth()-1);const[selStart,setSelStart]=useState(null);const[selEnd,setSelEnd]=useState(null);const[phase,setPhase]=useState("start");const[hovDate,setHovDate]=useState(null);
  const compPeriod=useMemo(()=>{if(!selStart||!selEnd)return null;const diff=daysDiff(selStart,selEnd)+1;return{start:addDays(selStart,-diff),end:addDays(selEnd,-diff)};},[selStart,selEnd]);
  function handleDay(d){if(phase==="start"){setSelStart(d);setSelEnd(null);setPhase("end");}else{if(d<selStart){setSelEnd(selStart);setSelStart(d);}else setSelEnd(d);setPhase("start");setHovDate(null);}}
  function handlePreset(days){const e=startOfDay(new Date());const s=addDays(e,-(days-1));setSelStart(s);setSelEnd(e);setPhase("start");setHovDate(null);}
  const m2=viewMonth===11?0:viewMonth+1,y2=viewMonth===11?viewYear+1:viewYear;
  const ready=selStart&&selEnd;
  return(<div style={{maxWidth:720,margin:"0 auto",padding:"32px 24px",color:"#111"}}><h2 style={{fontSize:21,fontWeight:600,color:"#111",margin:"0 0 4px"}}>Select Date Range</h2><p style={{fontSize:13,color:"#666",margin:"0 0 22px"}}>{phase==="start"?"Click a start date to begin your reporting period.":"Now click an end date."}</p><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",overflow:"hidden"}}><div style={{display:"flex"}}><div style={{width:150,flexShrink:0,borderRight:"1px solid #f0f0f0",padding:"16px 10px"}}><div style={{fontSize:10,fontWeight:600,color:"#aaa",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:10,paddingLeft:6}}>Quick Select</div>{PRESETS.map(p=><button key={p.days} onClick={()=>handlePreset(p.days)} style={{display:"block",width:"100%",textAlign:"left",padding:"7px 10px",borderRadius:7,border:"none",background:"transparent",cursor:"pointer",fontSize:12,color:"#555",marginBottom:1}}>{p.label}</button>)}</div><div style={{flex:1,padding:"18px 20px"}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:14}}><button onClick={()=>{if(viewMonth===0){setViewMonth(11);setViewYear(y=>y-1);}else setViewMonth(m=>m-1);}} style={{padding:"5px 10px",borderRadius:6,border:"1px solid var(--color-border-secondary)",background:"transparent",cursor:"pointer"}}><i className="ti ti-chevron-left" style={{fontSize:13}}/></button><button onClick={()=>{if(viewMonth===11){setViewMonth(0);setViewYear(y=>y+1);}else setViewMonth(m=>m+1);}} style={{padding:"5px 10px",borderRadius:6,border:"1px solid var(--color-border-secondary)",background:"transparent",cursor:"pointer"}}><i className="ti ti-chevron-right" style={{fontSize:13}}/></button></div><div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:28}} onMouseLeave={()=>setHovDate(null)}><CalMonth year={viewYear} month={viewMonth} selStart={selStart} selEnd={selEnd} hovDate={hovDate} onDayClick={handleDay} onDayHover={setHovDate}/><CalMonth year={y2} month={m2} selStart={selStart} selEnd={selEnd} hovDate={hovDate} onDayClick={handleDay} onDayHover={setHovDate}/></div></div></div><div style={{borderTop:"1px solid var(--color-border-tertiary)",padding:"14px 20px",display:"flex",alignItems:"center",gap:24,background:"#fafafa",flexWrap:"wrap"}}><div><div style={{fontSize:10,color:"#aaa",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Current Period</div><div style={{fontSize:13,fontWeight:500,color:"#111"}}>{ready?`${fmtDisp(selStart)} — ${fmtDisp(selEnd)}`:"Not selected"}</div></div><div style={{width:1,height:32,background:"var(--color-border-secondary)"}}/><div><div style={{fontSize:10,color:"#aaa",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Comparison Period (auto)</div><div style={{fontSize:13,color:"#555"}}>{compPeriod?`${fmtDisp(compPeriod.start)} — ${fmtDisp(compPeriod.end)}`:"—"}</div></div><div style={{flex:1}}/><button onClick={()=>ready&&onConfirm({current:{start:selStart,end:selEnd},comp:compPeriod})} disabled={!ready} style={{...T.btnR(false),opacity:ready?1:0.4,boxShadow:ready?"0 2px 8px rgba(79,70,229,0.3)":"none",fontWeight:600}}><i className="ti ti-arrow-right" style={{fontSize:14}}/> Continue to Upload</button></div></div></div>);
}

/* === UPLOAD PHASE ============================================ */
function UploadZone({label,period,onFile,fileName,detected}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(<div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)} onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(f);}} onClick={()=>ref.current?.click()} style={{border:`2px dashed ${drag||fileName?R:"var(--color-border-secondary)"}`,borderRadius:10,padding:"28px 16px",textAlign:"center",cursor:"pointer",background:fileName?"rgba(79,70,229,0.03)":drag?"rgba(79,70,229,0.04)":"var(--color-background-secondary)",transition:"all 0.15s"}}><input ref={ref} type="file" accept=".xlsx,.xls" style={{display:"none"}} onChange={e=>onFile(e.target.files[0])}/><div style={{width:44,height:44,borderRadius:9,background:"var(--color-background-primary)",border:"1px solid var(--color-border-tertiary)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 10px"}}><i className={`ti ${fileName?"ti-file-check":"ti-file-spreadsheet"}`} style={{fontSize:22,color:fileName?R:"var(--color-text-secondary)"}}/></div><div style={{fontSize:13,fontWeight:600,color:"var(--color-text-primary)",marginBottom:3}}>{label}</div><div style={{fontSize:11,color:"var(--color-text-secondary)",marginBottom:10}}>{period?`${fmtDisp(period.start)} — ${fmtDisp(period.end)}`:"—"}</div>{fileName?(<div><div style={{fontSize:12,color:R,fontWeight:500,marginBottom:detected?.length?8:0}}><i className="ti ti-check"/> {fileName}</div>{detected?.length>0&&<div style={{display:"flex",gap:6,justifyContent:"center",flexWrap:"wrap"}}>{detected.map(d=><span key={d.key} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`rgba(79,70,229,0.1)`,color:R,fontWeight:600}}>{d.key.toUpperCase()} ✓</span>)}</div>}</div>):<div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"6px 14px",borderRadius:7,background:R,color:"#fff",fontSize:12,fontWeight:500}}><i className="ti ti-upload" style={{fontSize:12}}/> Browse</div>}</div>);
}

function UploadPhase({periods,onComplete}){
  const[curFile,setCurFile]=useState(null);const[compFile,setCompFile]=useState(null);
  const[curName,setCurName]=useState(null);const[compName,setCompName]=useState(null);
  const[curDetected,setCurDetected]=useState([]);const[compDetected,setCompDetected]=useState([]);
  const[loading,setLoading]=useState(false);const[err,setErr]=useState(null);

  async function handleCurFile(f){
    setCurFile(f);setCurName(f.name);setCurDetected([]);setErr(null);
    // Quick preview of detected sheets
    try{const result=await parseAllSheets(f);setCurDetected(result.detected);}catch(e){setErr("Could not read file: "+e.message);}
  }
  async function handleCompFile(f){
    setCompFile(f);setCompName(f.name);setCompDetected([]);
    try{const result=await parseAllSheets(f);setCompDetected(result.detected);}catch(e){}
  }

  async function go(){
    if(!curFile)return;setLoading(true);setErr(null);
    try{
      const cur=await parseAllSheets(curFile);
      let comp=null;if(compFile)comp=await parseAllSheets(compFile);
      const detected=cur.detected;
      if(!cur.sp&&!cur.sb&&!cur.sd){setErr("No SP, SB, or SD campaign sheets found in this file. Make sure you are uploading the full Amazon bulk export.");setLoading(false);return;}
      onComplete({cur,comp,detected});
    }catch(e){setErr("Error reading file: "+e.message);}
    setLoading(false);
  }

  return(<div style={{maxWidth:740,margin:"0 auto",padding:"32px 24px"}}>
    <h2 style={{fontSize:21,fontWeight:600,color:"var(--color-text-primary)",margin:"0 0 4px"}}>Upload Bulk File</h2>
    <p style={{fontSize:13,color:"var(--color-text-secondary)",margin:"0 0 22px"}}>Upload your Amazon bulk export file. The tool will automatically detect SP, SB, and SD sheets inside it.</p>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
      <div><div style={{fontSize:11,fontWeight:600,color:"var(--color-text-secondary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:7}}>Current Period <span style={{color:R}}>*</span></div><UploadZone label="Current Period" period={periods?.current} onFile={handleCurFile} fileName={curName} detected={curDetected}/></div>
      <div><div style={{fontSize:11,fontWeight:600,color:"var(--color-text-secondary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:7}}>Comparison Period <span style={{color:"var(--color-text-tertiary)"}}>(optional)</span></div><UploadZone label="Comparison Period" period={periods?.comp} onFile={handleCompFile} fileName={compName} detected={compDetected}/></div>
    </div>
    <div style={{padding:"14px 16px",background:"var(--color-background-secondary)",borderRadius:8,border:"1px solid var(--color-border-tertiary)",marginBottom:14}}>
      <div style={{fontSize:12,fontWeight:600,color:"var(--color-text-primary)",marginBottom:10}}>How to get your Amazon bulk file</div>
      {["Go to Seller Central → Campaign Manager → Bulk Operations","Set your date range and click Create spreadsheet for download","Upload the downloaded file directly above — no need to extract any sheets","The tool automatically reads SP, SB, and SD tabs from the same file"].map((s,i)=>(<div key={i} style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:7}}><span style={{width:18,height:18,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"var(--color-text-secondary)",lineHeight:1.6}}>{s}</span></div>))}
    </div>
    <div style={{padding:"10px 14px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.15)",marginBottom:14,display:"flex",gap:9}}><i className="ti ti-info-circle" style={{fontSize:15,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"var(--color-text-secondary)",lineHeight:1.7}}>If sheets are not detected, email us at <a href="mailto:support@operaiq.quarred.com" style={{color:R,fontWeight:500,textDecoration:"none"}}>support@operaiq.quarred.com</a></div></div>
    {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:7,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}><i className="ti ti-alert-triangle" style={{marginRight:5}}/>{err}</div>}
    <div style={{display:"flex",justifyContent:"flex-end"}}>
      <button onClick={go} disabled={!curFile||loading} style={{...T.btnR(false),opacity:curFile&&!loading?1:0.4}}>{loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Detecting sheets...</>:<><i className="ti ti-arrow-right" style={{fontSize:14}}/> Analyze Data</>}</button>
    </div>
  </div>);
}

/* === KPI CARDS =============================================== */
function KPICards({curAgg,compAgg}){
  return(
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",flexShrink:0,overflowX:"auto"}}>
      <div style={{display:"flex",minWidth:"max-content"}}>
        {KPI_DEFS.map((kpi,idx)=>{
          const cur=curAgg[kpi.key]||0;
          const comp=compAgg?compAgg[kpi.key]||0:null;
          // Show comparison even if comp=0 — means previous period had 0
          const hasMComp=comp!=null;
          let pctD=null,absD=null;
          if(hasMComp&&comp!==0){pctD=((cur-comp)/Math.abs(comp))*100;absD=cur-comp;}
          const good=pctD!=null?(kpi.lowerBetter?pctD<=0:pctD>=0):null;
          const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";
          const sign=v=>v>0?"+":v<0?"-":"";
          return(
            <div key={kpi.key} style={{flex:"0 0 auto",minWidth:130,padding:"16px 20px",borderRight:idx<KPI_DEFS.length-1?"1px solid #f0f0f0":"none",cursor:"default",transition:"background 0.1s"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:8}}>{kpi.label}</div>
              <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:compAgg?6:0,letterSpacing:"-0.5px",lineHeight:1}}>{kpi.fmt(cur)}</div>
              {compAgg&&(
                <div>
                  {pctD!==null?(
                    <>
                      <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:2}}>
                        <span style={{fontSize:12,fontWeight:700,color:dc,display:"flex",alignItems:"center",gap:3}}>
                          <i className={`ti ${good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:11}}/>
                          {sign(pctD)}{Math.abs(pctD).toFixed(1)}%
                        </span>
                        <span style={{fontSize:10,color:"#bbb"}}>vs prev</span>
                      </div>
                      {absD!==null&&<div style={{fontSize:10,color:dc,fontWeight:600}}>{sign(absD)}{kpi.fmt(Math.abs(absD))}</div>}
                    </>
                  ):<div style={{fontSize:11,color:"#ccc"}}>No prev data</div>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* === FILTER MODAL ============================================ */
function FilterModal({open,onClose,activeFilters,onApply}){
  const[filters,setFilters]=useState([]);
  useEffect(()=>{if(open)setFilters(activeFilters?.length?activeFilters.map(f=>({...f})):[]);},[open]);
  const addF=()=>setFilters(fs=>[...fs,{id:uid(),field:"acos",op:">",v1:"",v2:""}]);
  const delF=id=>setFilters(fs=>fs.filter(f=>f.id!==id));
  const updF=(id,up)=>setFilters(fs=>fs.map(f=>f.id===id?{...f,...up}:f));
  if(!open)return null;
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{background:"#fff",color:"#111",borderRadius:12,width:700,maxWidth:"95vw",maxHeight:"80vh",display:"flex",flexDirection:"column",boxShadow:"0 24px 80px rgba(0,0,0,0.35)"}}>

        {/* Header */}
        <div style={{padding:"18px 22px",borderBottom:"2px solid #eee",display:"flex",alignItems:"center",justifyContent:"space-between",background:"#fff",borderRadius:"12px 12px 0 0"}}>
          <div style={{fontSize:17,fontWeight:700,color:"#111"}}>Filters</div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>setFilters([])} style={{display:"inline-flex",alignItems:"center",gap:5,padding:"6px 14px",borderRadius:7,background:"#f5f5f5",color:"#555",border:"1px solid #ddd",fontSize:12,fontWeight:500,cursor:"pointer"}}><i className="ti ti-eraser" style={{fontSize:12}}/> Clear All</button>
            <button onClick={onClose} style={{padding:"6px 10px",border:"none",background:"transparent",cursor:"pointer",fontSize:20,color:"#555",lineHeight:1}}><i className="ti ti-x"/></button>
          </div>
        </div>

        {/* Filter rows */}
        <div style={{flex:1,overflowY:"auto",padding:"18px 22px",background:"#fafafa"}}>
          {filters.length===0&&(
            <div style={{textAlign:"center",padding:"32px",color:"#888",fontSize:14,border:"2px dashed #ddd",borderRadius:10,background:"#fff"}}>
              <i className="ti ti-filter" style={{fontSize:32,display:"block",marginBottom:8,color:"#ccc"}}/> No filters yet.<br/>Click <strong style={{color:"#111"}}>Add New Filter</strong> below.
            </div>
          )}
          {filters.map((f,fi)=>{
            const fd=FILTER_FIELDS.find(x=>x.key===f.field)||FILTER_FIELDS[0];
            return(
              <div key={f.id} style={{background:"#fff",border:"1.5px solid #e0e0e0",borderRadius:9,padding:"14px 16px",marginBottom:10,display:"grid",gridTemplateColumns:"1fr 150px 1fr 36px",gap:10,alignItems:"end"}}>
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.6px",marginBottom:5}}>Filter</div>
                  <select style={{width:"100%",fontSize:13,padding:"8px 10px",borderRadius:7,border:"1.5px solid #ddd",background:"#fff",color:"#111",outline:"none",cursor:"pointer"}} value={f.field} onChange={e=>{const nd=FILTER_FIELDS.find(x=>x.key===e.target.value)||FILTER_FIELDS[0];updF(f.id,{field:e.target.value,op:nd.ops[0],v1:"",v2:""});}}>
                    {FILTER_FIELDS.map(fd2=><option key={fd2.key} value={fd2.key}>{fd2.label}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.6px",marginBottom:5}}>Operator</div>
                  <select style={{width:"100%",fontSize:13,padding:"8px 10px",borderRadius:7,border:"1.5px solid #ddd",background:"#fff",color:"#111",outline:"none",cursor:"pointer"}} value={f.op} onChange={e=>updF(f.id,{op:e.target.value})}>
                    {fd.ops.map(op=><option key={op} value={op}>{op}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.6px",marginBottom:5}}>Value</div>
                  {fd.type==="enum"?(
                    <select style={{width:"100%",fontSize:13,padding:"8px 10px",borderRadius:7,border:"1.5px solid #ddd",background:"#fff",color:"#111",outline:"none",cursor:"pointer"}} value={f.v1} onChange={e=>updF(f.id,{v1:e.target.value})}>
                      <option value="">Select…</option>{fd.values?.map(v=><option key={v} value={v}>{v}</option>)}
                    </select>
                  ):f.op==="between"?(
                    <div style={{display:"flex",gap:6}}>
                      <input style={{flex:1,fontSize:13,padding:"8px 10px",borderRadius:7,border:"1.5px solid #ddd",background:"#fff",color:"#111",outline:"none"}} type="number" placeholder="Min" value={f.v1} onChange={e=>updF(f.id,{v1:e.target.value})}/>
                      <input style={{flex:1,fontSize:13,padding:"8px 10px",borderRadius:7,border:"1.5px solid #ddd",background:"#fff",color:"#111",outline:"none"}} type="number" placeholder="Max" value={f.v2} onChange={e=>updF(f.id,{v2:e.target.value})}/>
                    </div>
                  ):(
                    <input style={{width:"100%",fontSize:13,padding:"8px 10px",borderRadius:7,border:"1.5px solid #ddd",background:"#fff",color:"#111",outline:"none",boxSizing:"border-box"}} type={fd.type==="number"?"number":"text"} placeholder="Enter value…" value={f.v1} onChange={e=>updF(f.id,{v1:e.target.value})}/>
                  )}
                </div>
                <div style={{display:"flex",alignItems:"flex-end"}}>
                  <button onClick={()=>delF(f.id)} style={{width:36,height:40,borderRadius:7,border:"1.5px solid #fcc",background:"#fff8f8",cursor:"pointer",color:"#cc2222",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}><i className="ti ti-x"/></button>
                </div>
              </div>
            );
          })}
          <button onClick={addF} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"8px 16px",borderRadius:8,border:"1.5px dashed #bbb",background:"#fff",cursor:"pointer",fontSize:13,color:"#555",fontWeight:500,marginTop:4}}>
            <i className="ti ti-plus" style={{fontSize:13}}/> Add New Filter
          </button>
        </div>

        {/* Footer */}
        <div style={{padding:"14px 22px",borderTop:"2px solid #eee",display:"flex",justifyContent:"flex-end",gap:10,background:"#fff",borderRadius:"0 0 12px 12px"}}>
          <button onClick={onClose} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"9px 20px",borderRadius:8,background:"#f0f0f0",color:"#555",border:"1px solid #ddd",fontSize:13,fontWeight:500,cursor:"pointer"}}>Cancel</button>
          <button onClick={()=>onApply(filters)} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"9px 20px",borderRadius:8,background:R,color:"#fff",border:"none",fontSize:13,fontWeight:600,cursor:"pointer"}}>
            Apply {filters.length>0?`${filters.length} Filter${filters.length>1?"s":""}`:""} <i className="ti ti-check" style={{fontSize:13}}/>
          </button>
        </div>
      </div>
    </div>
  );
}

/* === CHANGE BID MODAL ======================================== */
function ChangeBidModal({open,onClose,selectedRows,colMap,onApply}){
  const[action,setAction]=useState("no_change");
  const[value,setValue]=useState("");
  const[confirmed,setConfirmed]=useState(false);
  const cm=colMap;const count=selectedRows?.length||0;

  const preview=useMemo(()=>{
    if(!selectedRows||action==="no_change"||!value)return[];
    const v=parseFloat(value||0);
    return selectedRows.slice(0,4).map(row=>{
      const orig=parseFloat(String(row[cm?.bid]||0).replace(/[$,]/g,""))||0;
      let nb=orig;
      if(action==="inc_pct")nb=orig*(1+v/100);
      else if(action==="inc_amount")nb=orig+v;
      else if(action==="dec_pct")nb=Math.max(0.02,orig*(1-v/100));
      else if(action==="dec_amount")nb=Math.max(0.02,orig-v);
      else if(action==="set_bid")nb=v;
      nb=Math.max(0.02,Math.round(nb*100)/100);
      const kw=String(row[cm?.keyword]||row["Keyword Text"]||row["Targeting Expression"]||"").slice(0,28);
      return{orig,nb,pct:orig>0?((nb-orig)/orig)*100:0,kw};
    });
  },[selectedRows,action,value,cm]);

  const overFifty=useMemo(()=>{
    if(!selectedRows||action==="no_change"||!value)return false;
    const v=parseFloat(value||0);
    return selectedRows.some(row=>{
      const orig=parseFloat(String(row[cm?.bid]||0).replace(/[$,]/g,""))||0;
      let nb=orig;
      if(action==="inc_pct")nb=orig*(1+v/100);
      else if(action==="inc_amount")nb=orig+v;
      return orig>0&&((nb-orig)/orig)*100>50;
    });
  },[selectedRows,action,value,cm]);

  const canApply=action!=="no_change"&&value!==""&&(!overFifty||confirmed);

  useEffect(()=>{if(!open){setAction("no_change");setValue("");setConfirmed(false);}},[open]);
  if(!open)return null;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:3000,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(3px)"}}>
      <div style={{background:"#fff",borderRadius:16,width:480,maxWidth:"95vw",boxShadow:"0 32px 100px rgba(0,0,0,0.4)",overflow:"hidden",fontFamily:"inherit"}}>

        {/* Header */}
        <div style={{padding:"20px 24px 16px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"flex-start",justifyContent:"space-between"}}>
          <div>
            <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:3}}>Bulk Edit Bids</div>
            <div style={{fontSize:13,color:"#666"}}><strong style={{color:"#111"}}>{count}</strong> target{count!==1?"s":""} selected</div>
          </div>
          <button onClick={onClose} style={{padding:"4px 8px",border:"none",background:"#f5f5f5",cursor:"pointer",fontSize:16,color:"#555",borderRadius:6,lineHeight:1,marginTop:2}}>✕</button>
        </div>

        {/* Body */}
        <div style={{padding:"20px 24px"}}>

          {/* Action picker */}
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.6px",marginBottom:8}}>Action</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
              {BID_ACTIONS.filter(a=>a.key!=="no_change").map(a=>(
                <button key={a.key} onClick={()=>{setAction(a.key);setValue("");setConfirmed(false);}}
                  style={{padding:"9px 12px",borderRadius:8,border:`1.5px solid ${action===a.key?R:"#e0e0e0"}`,background:action===a.key?"rgba(79,70,229,0.06)":"#fff",color:action===a.key?R:"#444",fontSize:12,fontWeight:action===a.key?600:400,cursor:"pointer",textAlign:"left",transition:"all 0.12s"}}>
                  {a.label}
                </button>
              ))}
            </div>
          </div>

          {/* Value input */}
          {action!=="no_change"&&(
            <div style={{marginBottom:16}}>
              <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.6px",marginBottom:8}}>{action.includes("pct")?"Percentage (%)":"Amount ($)"}</div>
              <input style={{width:"100%",fontSize:16,fontWeight:600,padding:"10px 14px",borderRadius:8,border:`1.5px solid ${value?R:"#ddd"}`,outline:"none",color:"#111",boxSizing:"border-box",transition:"border 0.15s"}}
                type="number" min="0" step={action.includes("pct")?"1":"0.01"} placeholder="0" autoFocus
                value={value} onChange={e=>{setValue(e.target.value);setConfirmed(false);}}/>
            </div>
          )}

          {/* Preview */}
          {preview.length>0&&(
            <div style={{background:"#f9f9f9",borderRadius:10,border:"1px solid #e8e8e8",padding:"12px 14px",marginBottom:14}}>
              <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.6px",marginBottom:10}}>Preview</div>
              {preview.map((p,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,fontSize:12}}>
                  <span style={{flex:1,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.kw||`Target ${i+1}`}</span>
                  <span style={{color:"#999",textDecoration:"line-through"}}>${p.orig.toFixed(2)}</span>
                  <span style={{color:"#333"}}>→</span>
                  <span style={{fontWeight:700,color:p.pct>0?"#1a9e4a":"#d42b2b"}}>${p.nb.toFixed(2)}</span>
                  <span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:p.pct>0?"rgba(26,158,74,0.1)":"rgba(212,43,43,0.1)",color:p.pct>0?"#1a9e4a":"#d42b2b",fontWeight:600}}>
                    {p.pct>0?"+":""}{p.pct.toFixed(1)}%
                  </span>
                </div>
              ))}
              {count>4&&<div style={{fontSize:11,color:"#aaa",marginTop:4}}>+ {count-4} more targets</div>}
            </div>
          )}

          {/* 50% warning */}
          {overFifty&&(
            <div style={{padding:"12px 14px",background:"#fff8ed",borderRadius:10,border:"1.5px solid #f5c842",marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:700,color:"#b35a00",marginBottom:6,display:"flex",alignItems:"center",gap:6}}>
                <i className="ti ti-alert-triangle" style={{fontSize:15}}/> Bid increase exceeds 50%
              </div>
              <div style={{fontSize:12,color:"#7a4000",marginBottom:10,lineHeight:1.5}}>
                Some bids will increase by more than 50%. This may significantly impact your ad spend.
              </div>
              <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:12,color:"#7a4000",fontWeight:500}}>
                <input type="checkbox" checked={confirmed} onChange={e=>setConfirmed(e.target.checked)} style={{accentColor:R,width:15,height:15}}/>
                I understand and want to proceed anyway
              </label>
            </div>
          )}

          <div style={{fontSize:11,color:"#aaa",display:"flex",alignItems:"center",gap:5}}>
            <i className="ti ti-info-circle" style={{fontSize:12}}/> Suggested bids require Amazon Ads API — not available in bulk sheet mode.
          </div>
        </div>

        {/* Footer */}
        <div style={{padding:"14px 24px",borderTop:"1px solid #f0f0f0",display:"flex",justifyContent:"flex-end",gap:10}}>
          <button onClick={onClose} style={{padding:"9px 20px",borderRadius:8,border:"1px solid #e0e0e0",background:"#f5f5f5",color:"#555",fontSize:13,fontWeight:500,cursor:"pointer"}}>Cancel</button>
          <button onClick={()=>{if(canApply){onApply(action,parseFloat(value||0));onClose();}}} disabled={!canApply}
            style={{padding:"9px 22px",borderRadius:8,background:canApply?R:"#ccc",color:"#fff",border:"none",fontSize:13,fontWeight:700,cursor:canApply?"pointer":"not-allowed",boxShadow:canApply?"0 2px 8px rgba(79,70,229,0.35)":"none",transition:"all 0.15s"}}>
            Apply Changes
          </button>
        </div>
      </div>
    </div>
  );
}

/* === RULES PAGE ============================================== */
function RulesPage({rules,setRules,onBack}){
  const[editId,setEditId]=useState(null);const[saved,setSaved]=useState(false);
  const addRule=()=>{const r=makeRule("New Rule "+( rules.length+1));setRules(rs=>[...rs,r]);setEditId(r.id);};
  const delRule=id=>{setRules(rs=>rs.filter(r=>r.id!==id));setEditId(prev=>prev===id?null:prev);};
  const togRule=id=>setRules(rs=>rs.map(r=>r.id===id?{...r,enabled:!r.enabled}:r));
  const updRule=(id,up)=>setRules(rs=>rs.map(r=>r.id===id?{...r,...up}:r));
  const addCond=id=>setRules(rs=>rs.map(r=>r.id===id?{...r,conditions:[...r.conditions,{id:uid(),kpi:"acos",op:"gt",v1:"",v2:""}]}:r));
  const delCond=(rid,cid)=>setRules(rs=>rs.map(r=>r.id===rid?{...r,conditions:r.conditions.filter(c=>c.id!==cid)}:r));
  const updCond=(rid,cid,up)=>setRules(rs=>rs.map(r=>r.id===rid?{...r,conditions:r.conditions.map(c=>c.id===cid?{...c,...up}:c)}:r));
  const editRule=rules.find(r=>r.id===editId);

  return(
    <div style={{display:"flex",height:"100%",overflow:"hidden"}}>

      {/* ── Left: Rule List ── */}
      <div style={{width:300,flexShrink:0,borderRight:"1px solid var(--color-border-tertiary)",display:"flex",flexDirection:"column",background:"var(--color-background-primary)"}}>
        <div style={{padding:"14px 16px",borderBottom:"1px solid var(--color-border-tertiary)",display:"flex",alignItems:"center",gap:8}}>
          <button onClick={onBack} style={{padding:"5px 9px",borderRadius:6,border:"1px solid var(--color-border-secondary)",background:"transparent",cursor:"pointer",color:"var(--color-text-secondary)",fontSize:12,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:12}}/> Back</button>
          <div style={{flex:1,fontSize:13,fontWeight:600,color:"var(--color-text-primary)"}}>Bid Rules</div>
          <button onClick={addRule} style={{...T.btnR(true)}}><i className="ti ti-plus" style={{fontSize:12}}/> New Rule</button>
        </div>
        <div style={{padding:"8px 12px 4px",fontSize:11,color:"var(--color-text-tertiary)"}}>Rules run top to bottom · first match wins</div>
        <div style={{flex:1,overflowY:"auto",padding:"8px 10px"}}>
          {rules.length===0&&<div style={{textAlign:"center",padding:"30px 10px",color:"var(--color-text-secondary)",fontSize:13}}>No rules yet.<br/>Click <strong>New Rule</strong> to start.</div>}
          {rules.map((rule,idx)=>(
            <div key={rule.id} onClick={()=>setEditId(rule.id)}
              style={{padding:"12px 14px",borderRadius:9,marginBottom:8,cursor:"pointer",border:`1.5px solid ${editId===rule.id?R:"var(--color-border-secondary)"}`,background:editId===rule.id?"rgba(79,70,229,0.05)":"var(--color-background-secondary)",opacity:rule.enabled?1:0.55,transition:"all 0.12s"}}>
              <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:6}}>
                <span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:editId===rule.id?"rgba(79,70,229,0.12)":"var(--color-background-primary)",color:editId===rule.id?R:"var(--color-text-tertiary)",fontWeight:700}}>#{idx+1}</span>
                <span style={{fontSize:13,fontWeight:500,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"var(--color-text-primary)"}}>{rule.name}</span>
              </div>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div style={{fontSize:11,color:"var(--color-text-secondary)"}}>{rule.conditions.length} condition{rule.conditions.length!==1?"s":""} · <span style={{color:rule.action.type.includes("inc")?"#3B6D11":"#A32D2D",fontWeight:500}}>{RULE_ACTS.find(a=>a.key===rule.action.type)?.label} {rule.action.value}</span></div>
                <div style={{display:"flex",gap:2}} onClick={e=>e.stopPropagation()}>
                  <button title={rule.enabled?"Disable":"Enable"} onClick={()=>togRule(rule.id)} style={{padding:"3px 5px",border:"none",background:"transparent",cursor:"pointer",fontSize:18,color:rule.enabled?R:"var(--color-text-tertiary)",lineHeight:1}}>
                    <i className={`ti ${rule.enabled?"ti-toggle-right":"ti-toggle-left"}`}/>
                  </button>
                  <button title="Delete rule" onClick={()=>{if(window.confirm("Delete this rule?"))delRule(rule.id);}} style={{padding:"3px 5px",border:"none",background:"transparent",cursor:"pointer",color:"#A32D2D",fontSize:13,lineHeight:1}}>
                    <i className="ti ti-trash"/>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{padding:"12px",borderTop:"1px solid var(--color-border-tertiary)"}}>
          <button onClick={()=>{setSaved(true);setTimeout(()=>setSaved(false),2000);}} style={{...T.btnG(true),width:"100%",justifyContent:"center",background:saved?"#EAF3DE":undefined,color:saved?"#3B6D11":undefined,border:saved?"1px solid #C0DD97":undefined}}>
            <i className={`ti ${saved?"ti-check":"ti-device-floppy"}`} style={{fontSize:13}}/>{saved?"  Saved!":"  Save All Rules"}
          </button>
        </div>
      </div>

      {/* ── Right: Rule Editor ── */}
      <div style={{flex:1,overflowY:"auto",background:"var(--color-background-secondary)"}}>
        {!editRule?(
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",gap:12,color:"var(--color-text-secondary)"}}>
            <i className="ti ti-adjustments-horizontal" style={{fontSize:48,color:"var(--color-border-secondary)"}}/>
            <div style={{fontSize:15,fontWeight:500}}>Select a rule to edit</div>
            <div style={{fontSize:13,color:"var(--color-text-tertiary)"}}>Or click <strong>New Rule</strong> to create one</div>
          </div>
        ):(
          <div style={{padding:"24px 28px",maxWidth:700}}>

            {/* Rule name */}
            <div style={{background:"var(--color-background-primary)",border:"1px solid var(--color-border-tertiary)",borderRadius:10,padding:"18px 20px",marginBottom:16}}>
              <div style={{fontSize:12,fontWeight:600,color:"var(--color-text-secondary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:8}}>Rule Name</div>
              <input style={{...T.inp,fontSize:15,fontWeight:500,padding:"10px 14px"}} value={editRule.name} onChange={e=>updRule(editRule.id,{name:e.target.value})} placeholder="e.g. High ACoS — lower bid"/>
            </div>

            {/* Conditions */}
            <div style={{background:"var(--color-background-primary)",border:"1px solid var(--color-border-tertiary)",borderRadius:10,padding:"18px 20px",marginBottom:16}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
                <div>
                  <div style={{fontSize:15,fontWeight:700,color:"var(--color-text-primary)"}}>Conditions</div>
                  <div style={{fontSize:12,color:"var(--color-text-secondary)",marginTop:3}}>All conditions must match for this rule to apply</div>
                </div>
                <button onClick={()=>addCond(editRule.id)} style={T.btnG(true)}><i className="ti ti-plus" style={{fontSize:13}}/> Add Condition</button>
              </div>

              {editRule.conditions.length===0&&(
                <div style={{textAlign:"center",padding:"20px",border:"1px dashed var(--color-border-secondary)",borderRadius:8,color:"var(--color-text-tertiary)",fontSize:13}}>No conditions. Click Add Condition.</div>
              )}

              {editRule.conditions.map((cond,ci)=>{
                const kd=RULE_KPIS.find(k=>k.key===cond.kpi)||RULE_KPIS[0];
                return(
                  <div key={cond.id} style={{background:"var(--color-background-primary)",border:"1.5px solid var(--color-border-secondary)",borderRadius:10,padding:"16px 18px",marginBottom:10,position:"relative",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
                    <div style={{position:"absolute",top:10,right:10}}>
                      <button onClick={()=>delCond(editRule.id,cond.id)} disabled={editRule.conditions.length===1}
                        style={{padding:"3px 6px",borderRadius:5,border:"none",background:"transparent",cursor:editRule.conditions.length===1?"not-allowed":"pointer",color:editRule.conditions.length===1?"var(--color-text-tertiary)":"#A32D2D",fontSize:13}}>
                        <i className="ti ti-x"/>
                      </button>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 140px 1fr",gap:12,paddingRight:28}}>
                      <div>
                        <div style={{fontSize:10,fontWeight:600,color:"var(--color-text-tertiary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>KPI / Metric</div>
                        <select style={{...T.sel,width:"100%"}} value={cond.kpi} onChange={e=>updCond(editRule.id,cond.id,{kpi:e.target.value})}>
                          {RULE_KPIS.map(k=><option key={k.key} value={k.key}>{k.label}{k.unit?` (${k.unit})`:""}</option>)}
                        </select>
                      </div>
                      <div>
                        <div style={{fontSize:10,fontWeight:600,color:"var(--color-text-tertiary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>Operator</div>
                        <select style={{...T.sel,width:"100%"}} value={cond.op} onChange={e=>updCond(editRule.id,cond.id,{op:e.target.value})}>
                          {RULE_OPS.map(o=><option key={o.key} value={o.key}>{o.label}</option>)}
                        </select>
                      </div>
                      <div>
                        <div style={{fontSize:10,fontWeight:600,color:"var(--color-text-tertiary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>{cond.op==="between"?"Min & Max Value":"Value"}</div>
                        {cond.op==="between"?(
                          <div style={{display:"flex",gap:8,alignItems:"center"}}>
                            <div style={{position:"relative",flex:1}}>
                              <input style={{...T.inp,paddingRight:kd.unit?26:10}} type="number" step="any" placeholder="Min" value={cond.v1} onChange={e=>updCond(editRule.id,cond.id,{v1:e.target.value})}/>
                              {kd.unit&&<span style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",fontSize:10,color:"var(--color-text-tertiary)",pointerEvents:"none"}}>{kd.unit}</span>}
                            </div>
                            <span style={{fontSize:11,color:"var(--color-text-tertiary)",flexShrink:0}}>to</span>
                            <div style={{position:"relative",flex:1}}>
                              <input style={{...T.inp,paddingRight:kd.unit?26:10}} type="number" step="any" placeholder="Max" value={cond.v2} onChange={e=>updCond(editRule.id,cond.id,{v2:e.target.value})}/>
                              {kd.unit&&<span style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",fontSize:10,color:"var(--color-text-tertiary)",pointerEvents:"none"}}>{kd.unit}</span>}
                            </div>
                          </div>
                        ):(
                          <div style={{position:"relative"}}>
                            <input style={{...T.inp,paddingRight:kd.unit?26:10}} type="number" step="any" placeholder="Enter value" value={cond.v1} onChange={e=>updCond(editRule.id,cond.id,{v1:e.target.value})}/>
                            {kd.unit&&<span style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",fontSize:10,color:"var(--color-text-tertiary)",pointerEvents:"none"}}>{kd.unit}</span>}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Action */}
            <div style={{background:"var(--color-background-primary)",border:"1px solid var(--color-border-tertiary)",borderRadius:10,padding:"18px 20px",marginBottom:16}}>
              <div style={{fontSize:14,fontWeight:600,color:"var(--color-text-primary)",marginBottom:4}}>Action</div>
              <div style={{fontSize:12,color:"var(--color-text-secondary)",marginBottom:14}}>What to do with the bid when all conditions match</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 130px",gap:12}}>
                <div>
                  <div style={{fontSize:10,fontWeight:600,color:"var(--color-text-tertiary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>Bid Action</div>
                  <select style={{...T.sel,width:"100%"}} value={editRule.action.type} onChange={e=>updRule(editRule.id,{action:{...editRule.action,type:e.target.value}})}>
                    {RULE_ACTS.map(a=><option key={a.key} value={a.key}>{a.label}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:600,color:"var(--color-text-tertiary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>Amount</div>
                  <input style={{...T.inp}} type="number" step="0.01" min="0" placeholder="0.10" value={editRule.action.value} onChange={e=>updRule(editRule.id,{action:{...editRule.action,value:e.target.value}})}/>
                </div>
              </div>
            </div>

            {/* Safety limits */}
            <div style={{background:"var(--color-background-primary)",border:"1px solid var(--color-border-tertiary)",borderRadius:10,padding:"18px 20px"}}>
              <div style={{fontSize:14,fontWeight:600,color:"var(--color-text-primary)",marginBottom:4}}>Safety Limits <span style={{fontSize:12,fontWeight:400,color:"var(--color-text-tertiary)"}}>(optional)</span></div>
              <div style={{fontSize:12,color:"var(--color-text-secondary)",marginBottom:14}}>Bids will never go outside these bounds</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                <div>
                  <div style={{fontSize:10,fontWeight:600,color:"var(--color-text-tertiary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>Min Bid ($)</div>
                  <input style={T.inp} type="number" step="0.01" min="0.02" placeholder="0.02" value={editRule.minBid} onChange={e=>updRule(editRule.id,{minBid:e.target.value})}/>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:600,color:"var(--color-text-tertiary)",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>Max Bid ($)</div>
                  <input style={T.inp} type="number" step="0.01" min="0" placeholder="No limit" value={editRule.maxBid} onChange={e=>updRule(editRule.id,{maxBid:e.target.value})}/>
                </div>
              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
}

/* === INTELLIGENCE BRIEF ====================================== */
function IntelligenceBrief({insights}){
  const[expanded,setExpanded]=useState(null);
  if(!insights||insights.length===0)return null;

  const pColor={critical:"#d42b2b",warning:"#c47a00",opportunity:"#1a7a3c",good:"#555",neutral:"#aaa"};
  const pBg   ={critical:"rgba(212,43,43,0.06)",warning:"rgba(196,122,0,0.06)",opportunity:"rgba(26,122,60,0.06)",good:"rgba(0,0,0,0.02)",neutral:"transparent"};
  const pBorder={critical:"rgba(212,43,43,0.2)",warning:"rgba(196,122,0,0.2)",opportunity:"rgba(26,122,60,0.2)",good:"#eee",neutral:"#eee"};

  return(
    <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
        <i className="ti ti-brain" style={{fontSize:14,color:R}}/>
        <div style={{fontSize:12,fontWeight:700,color:"#111",letterSpacing:"-0.1px"}}>Performance Intelligence</div>
        <div style={{fontSize:11,color:"#888",marginLeft:2}}>{insights.length} insight{insights.length!==1?"s":""} detected</div>
        <div style={{flex:1}}/>
        <div style={{fontSize:10,color:"#bbb",fontStyle:"italic"}}>Powered by Quarred AI · Based on your uploaded data only</div>
      </div>

      <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:4}}>
        {insights.map((ins,i)=>{
          const isExp=expanded===i;
          return(
            <div key={i} onClick={()=>setExpanded(isExp?null:i)}
              style={{flexShrink:0,minWidth:200,maxWidth:280,padding:"10px 12px",borderRadius:9,border:`1px solid ${pBorder[ins.priority]||"#eee"}`,background:pBg[ins.priority]||"#fafafa",cursor:"pointer",transition:"all 0.15s",position:"relative"}}>

              {/* Top row */}
              <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                <div style={{width:22,height:22,borderRadius:5,background:pBg[ins.priority],border:`1px solid ${pBorder[ins.priority]||"#eee"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${ins.icon||"ti-info-circle"}`} style={{fontSize:11,color:pColor[ins.priority]||"#aaa"}}/>
                </div>
                <span style={{fontSize:10,fontWeight:800,color:pColor[ins.priority]||"#aaa",textTransform:"uppercase",letterSpacing:"0.4px"}}>{ins.priority}</span>
                {ins.delta&&<span style={{marginLeft:"auto",fontSize:11,fontWeight:700,color:ins.trendGood?"#1a7a3c":"#d42b2b"}}>{ins.delta}</span>}
              </div>

              {/* Title */}
              <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:3,lineHeight:1.3}}>{ins.title}</div>

              {/* Metrics row */}
              {(ins.current||ins.previous)&&(
                <div style={{display:"flex",gap:10,marginBottom:isExp?8:0}}>
                  {ins.current&&<div><div style={{fontSize:9,color:"#aaa",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px"}}>Now</div><div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ins.current}</div></div>}
                  {ins.previous&&<div style={{borderLeft:"1px solid #eee",paddingLeft:10}}><div style={{fontSize:9,color:"#aaa",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px"}}>Prev</div><div style={{fontSize:13,fontWeight:600,color:"#888"}}>{ins.previous}</div></div>}
                </div>
              )}

              {/* Expanded explanation */}
              {isExp&&(
                <div style={{marginTop:8,borderTop:"1px solid rgba(0,0,0,0.06)",paddingTop:8}}>
                  <div style={{fontSize:11,color:"#444",lineHeight:1.65,marginBottom:8}}>{ins.explanation}</div>
                  <div style={{padding:"7px 9px",background:"rgba(79,70,229,0.05)",borderRadius:6,border:"1px solid rgba(79,70,229,0.12)"}}>
                    <div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Recommended Action</div>
                    <div style={{fontSize:11,color:"#333",lineHeight:1.5,fontWeight:500}}>{ins.action}</div>
                  </div>
                </div>
              )}

              {/* Expand hint */}
              {!isExp&&<div style={{fontSize:9,color:"#bbb",marginTop:4}}>{isExp?"▲ collapse":"▼ tap for details & action"}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* === TARGETING TABLE ======================================== */
function applyFilter(f,row,cm,metrics){
  const fld=f.field;
  if(fld==="target"||fld==="campaign"){const val=String(fld==="target"?(row[cm.keyword]||row["Keyword Text"]||row["Targeting Expression"]||""):(row[cm.campaign]||row["Campaign Name"]||"")).toLowerCase();const q=(f.v1||"").toLowerCase();if(f.op==="contains")return val.includes(q);if(f.op==="doesn't contain")return!val.includes(q);if(f.op==="matches")return val===q;return true;}
  if(fld==="matchType"||fld==="state"){const val=String(fld==="matchType"?(row[cm.matchType]||row["Match Type"]||""):(row[cm.state]||row["State"]||"")).toLowerCase();if(f.op==="is")return val===(f.v1||"").toLowerCase();if(f.op==="is not")return val!==(f.v1||"").toLowerCase();return true;}
  const n=metrics[fld]||0,v1=parseFloat(f.v1||0),v2=parseFloat(f.v2||0);
  if(f.op===">")return n>v1;if(f.op===">=")return n>=v1;if(f.op==="<")return n<v1;if(f.op==="<=")return n<=v1;if(f.op==="between")return n>=v1&&n<=v2;return true;
}

// Delta cell — only shows delta when prev period data genuinely exists (comp > 0 or both are 0)
function DeltaCell({cur,comp,fmt,lowerBetter,isPp,style:st}){
  // Only show delta if comparison data exists AND comparison period had actual data
  // Show delta even when comp=0 — means keyword existed in prev period with zero value
  const hasMeaningfulComp = comp!=null && comp!==undefined;
  const delta = hasMeaningfulComp ? cur-comp : null;
  const good  = delta===null?null:(lowerBetter?delta<=0:delta>=0);
  const dc    = good===true?"#1a9e4a":good===false?"#d42b2b":"var(--color-text-tertiary)";
  const sign  = v=>v>0?"+":v<0?"-":"";
  const fmtD  = v=>{
    if(isPp) return `${sign(v)}${Math.abs(v).toFixed(1)}pp`;
    if(fmt)  return `${sign(v)}${fmt(Math.abs(v))}`;
    return `${sign(v)}${Math.abs(v).toFixed(1)}`;
  };
  return(
    <td style={{padding:"8px 10px",verticalAlign:"top",...st}}>
      <div style={{fontWeight:500,color:"var(--color-text-primary)",fontSize:12,lineHeight:1.4}}>{fmt?fmt(cur):cur}</div>
      {delta!==null&&Math.abs(delta)>0.001&&(
        <div style={{fontSize:10,fontWeight:600,color:dc,lineHeight:1.3,marginTop:1}}>{fmtD(delta)}</div>
      )}
    </td>
  );
}

function TargetingTable({curRows,compRows,colMap,bidChanges,setBidChanges,onDownload,pendingCount}){
  const[search,setSearch]=useState("");
  const[activeFilters,setActiveFilters]=useState([]);
  const[filterOpen,setFilterOpen]=useState(false);
  const[selRows,setSelRows]=useState(new Set());
  const[changeBidOpen,setChangeBidOpen]=useState(false);
  const[editBidKey,setEditBidKey]=useState(null);
  const[editBidVal,setEditBidVal]=useState("");
  const[sortKey,setSortKey]=useState("priority");
  const[sortDir,setSortDir]=useState("asc");
  const cm=colMap;

  const compMap=useMemo(()=>{
    if(!compRows||!compRows.length)return{};
    const m={};
    compRows.filter(r=>isBidRow(r,cm)).forEach(r=>{const k=rowKey(r,cm);m[k]=calcRowMetrics(r,cm);});
    return m;
  },[compRows,cm]);

  const processed=useMemo(()=>curRows.map(r=>{
    const k=rowKey(r,cm);const metrics=calcRowMetrics(r,cm);
    return{r,k,metrics,comp:compMap[k]||null,
      kw:String(r[cm.keyword]||r["Keyword Text"]||r["Keyword"]||r["Targeting Expression"]||r["Product Targeting Expression"]||""),
      camp:String(r[cm.campaign]||r["Campaign Name"]||""),
      mt:String(r[cm.matchType]||r["Match Type"]||""),
      st:String(r[cm.state]||r["State"]||"").toLowerCase(),
      ent:String(r[cm.entity]||"").toLowerCase(),
      pendingBid:bidChanges[k]??null};
  }),[curRows,cm,compMap,bidChanges]);

  const filtered=useMemo(()=>{
    let rows=processed;
    if(search){const q=search.toLowerCase();rows=rows.filter(({kw,camp})=>kw.toLowerCase().includes(q)||camp.toLowerCase().includes(q));}
    if(activeFilters.length>0)rows=rows.filter(({r,metrics})=>activeFilters.every(f=>applyFilter(f,r,cm,metrics)));
    return rows;
  },[processed,search,activeFilters,cm]);

  const PRIORITY_ORDER={critical:0,warning:1,opportunity:2,good:3,low:4,neutral:5};
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{
    let va,vb;
    if(sortKey==="priority"){
      const pa=getPriority(a.metrics).level,pb=getPriority(b.metrics).level;
      return sortDir==="asc"?(PRIORITY_ORDER[pa]??5)-(PRIORITY_ORDER[pb]??5):(PRIORITY_ORDER[pb]??5)-(PRIORITY_ORDER[pa]??5);
    }
    if(sortKey==="kw"){va=a.kw;vb=b.kw;}else if(sortKey==="camp"){va=a.camp;vb=b.camp;}
    else{va=a.metrics[sortKey]??0;vb=b.metrics[sortKey]??0;}
    if(typeof va==="string")return sortDir==="asc"?va.localeCompare(vb):vb.localeCompare(va);
    return sortDir==="asc"?va-vb:vb-va;
  }),[filtered,sortKey,sortDir]);

  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir("desc");}}
  function toggleRow(k){setSelRows(s=>{const n=new Set(s);n.has(k)?n.delete(k):n.add(k);return n;});}
  function toggleAll(){
    // If all visible filtered rows are selected → deselect all
    // Otherwise → select all visible filtered rows
    const allKeys=new Set(sorted.map(x=>x.k));
    const allSelected=sorted.length>0&&sorted.every(x=>selRows.has(x.k));
    if(allSelected)setSelRows(new Set());
    else setSelRows(allKeys);
  }

  function handleBulkApply(action,val){
    const changes={...bidChanges};
    sorted.filter(({k})=>selRows.has(k)).forEach(({k,metrics})=>{
      let nb=metrics.bid;
      if(action==="inc_pct")nb=metrics.bid*(1+val/100);else if(action==="inc_amount")nb=metrics.bid+val;
      else if(action==="dec_pct")nb=Math.max(0.02,metrics.bid*(1-val/100));else if(action==="dec_amount")nb=Math.max(0.02,metrics.bid-val);
      else if(action==="set_bid")nb=val;
      changes[k]=Math.max(0.02,Math.round(nb*100)/100);
    });
    setBidChanges(changes);setSelRows(new Set());
  }

  function startInline(k,cur){setEditBidKey(k);setEditBidVal(String(cur.toFixed(2)));}
  function saveInline(k){const nb=parseFloat(editBidVal);if(!isNaN(nb)&&nb>=0.02)setBidChanges(b=>({...b,[k]:Math.round(nb*100)/100}));setEditBidKey(null);}

  const fmtUSD  = v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(2)}`;
  const fmtNum  = v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v));
  const fmtPct  = v=>`${v.toFixed(2)}%`;
  const fmtAcos = v=>`${v.toFixed(1)}%`;

  const SI=({col})=>{if(sortKey!==col)return<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;return<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>;};
  const thS={padding:"10px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const selList=sorted.filter(({k})=>selRows.has(k)).map(({r})=>r);

  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>

      {/* ── Toolbar ── */}
      <div style={{padding:"10px 20px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"7px 12px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:200}}>
          <i className="ti ti-search" style={{fontSize:14,color:"var(--color-text-tertiary)"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search keyword or campaign…" style={{border:"none",background:"transparent",outline:"none",fontSize:13,color:"var(--color-text-primary)",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:12,cursor:"pointer",color:"var(--color-text-tertiary)"}} onClick={()=>setSearch("")}/>}
        </div>
        <button onClick={()=>setFilterOpen(true)} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 14px",borderRadius:8,background:"#fff",color:"#333",border:"1.5px solid #e0e0e0",fontSize:12,fontWeight:600,cursor:"pointer",position:"relative",whiteSpace:"nowrap"}}>
          <i className="ti ti-filter" style={{fontSize:14}}/> Filters
          {activeFilters.length>0&&<span style={{position:"absolute",top:-6,right:-6,width:18,height:18,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>{activeFilters.length}</span>}
        </button>
        <div style={{flex:1}}/>
        <span style={{fontSize:12,color:"var(--color-text-secondary)"}}><strong style={{color:"var(--color-text-primary)"}}>{sorted.length}</strong> targets · <strong style={{color:pendingCount>0?R:"var(--color-text-primary)"}}>{pendingCount}</strong> edited</span>
        {pendingCount>0&&<button onClick={onDownload} style={T.btnR(true)}><i className="ti ti-download" style={{fontSize:13}}/> Download ({pendingCount} changes)</button>}
      </div>

      {/* ── Table ── */}
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr>
              <th style={{...thS,width:36,cursor:"default"}}>
  <input type="checkbox"
    checked={sorted.length>0&&sorted.every(x=>selRows.has(x.k))}
    ref={el=>{if(el)el.indeterminate=selRows.size>0&&!sorted.every(x=>selRows.has(x.k));}}
    onChange={toggleAll}
    style={{accentColor:R,cursor:"pointer"}}/>
</th>
              <th style={{...thS,width:90}} onClick={()=>toggleSort("priority")}>Priority <SI col="priority"/></th>
              <th style={thS} onClick={()=>toggleSort("kw")}>Target <SI col="kw"/></th>
              <th style={thS} onClick={()=>toggleSort("camp")}>Campaign <SI col="camp"/></th>
              <th style={{...thS,cursor:"default"}}>Type</th>
              <th style={{...thS,cursor:"default"}}>Match</th>
              <th style={{...thS,cursor:"default"}}>State</th>
              <th style={thS} onClick={()=>toggleSort("bid")}>Bid <SI col="bid"/></th>
              <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
              <th style={thS} onClick={()=>toggleSort("sales")}>Sales <SI col="sales"/></th>
              <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
              <th style={thS} onClick={()=>toggleSort("roas")}>ROAS <SI col="roas"/></th>
              <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
              <th style={thS} onClick={()=>toggleSort("impressions")}>Impr. <SI col="impressions"/></th>
              <th style={thS} onClick={()=>toggleSort("clicks")}>Clicks <SI col="clicks"/></th>
              <th style={thS} onClick={()=>toggleSort("ctr")}>CTR <SI col="ctr"/></th>
              <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
              <th style={thS} onClick={()=>toggleSort("cpc")}>CPC <SI col="cpc"/></th>
            </tr>
          </thead>
          <tbody>
            {sorted.map(({r,k,metrics,comp,kw,camp,mt,st,ent,pendingBid},i)=>{
              const isSel=selRows.has(k);
              const hasPending=pendingBid!=null;
              const mtle=mt.toLowerCase();
              const mtColor=mtle==="exact"?"#1a7a3c":mtle==="broad"?"#7a5200":mtle==="phrase"?"#1a50a0":"var(--color-text-secondary)";
              const mtBg  =mtle==="exact"?"rgba(26,122,60,0.09)":mtle==="broad"?"rgba(122,82,0,0.09)":mtle==="phrase"?"rgba(26,80,160,0.09)":"var(--color-background-secondary)";
              const curBid=hasPending?pendingBid:metrics.bid;
              const isKW=ent.includes("keyword")||(!ent.includes("targeting")&&mt!=="");
              const rowBg=isSel?"rgba(79,70,229,0.04)":hasPending?"rgba(255,248,195,0.7)":i%2===0?"#fff":"#fafafa";
              return(
                <tr key={k} style={{borderBottom:"1px solid var(--color-border-tertiary)",background:rowBg}}>
                  <td style={{padding:"8px 10px"}}><input type="checkbox" checked={isSel} onChange={()=>toggleRow(k)} style={{accentColor:R}}/></td>

                  {/* Priority */}
                  {(()=>{
                    const p=getPriority(metrics);
                    return(
                      <td style={{padding:"6px 10px",verticalAlign:"middle"}}>
                        {p.level!=="neutral"&&p.level!=="low"&&(
                          <div style={{display:"inline-flex",alignItems:"center",gap:4,padding:"3px 7px",borderRadius:5,background:p.bg,border:`1px solid ${p.color}22`}}>
                            <i className={`ti ${p.icon}`} style={{fontSize:9,color:p.color}}/>
                            <span style={{fontSize:9,fontWeight:700,color:p.color,whiteSpace:"nowrap"}}>{p.label}</span>
                          </div>
                        )}
                        {(p.level==="neutral"||p.level==="low")&&<span style={{fontSize:10,color:"#ddd"}}>—</span>}
                      </td>
                    );
                  })()}
                  {/* Target */}
                  <td style={{padding:"8px 10px",maxWidth:200,fontWeight:600,color:"var(--color-text-primary)",fontSize:12}} title={kw}>
                    <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{kw||"—"}</div>
                  </td>

                  {/* Campaign */}
                  <td style={{padding:"8px 10px",maxWidth:160,color:"var(--color-text-secondary)",fontSize:11}} title={camp}>
                    <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{camp||"—"}</div>
                  </td>

                  {/* Type */}
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:isKW?"rgba(26,80,160,0.08)":"rgba(79,70,229,0.08)",color:isKW?"#1a50a0":R,fontWeight:700}}>{isKW?"KW":"PT"}</span>
                  </td>

                  {/* Match */}
                  <td style={{padding:"8px 10px"}}>{mt?<span style={{padding:"2px 7px",borderRadius:5,fontSize:11,fontWeight:700,background:mtBg,color:mtColor}}>{mt}</span>:"-"}</td>

                  {/* State */}
                  <td style={{padding:"8px 10px",fontSize:11,whiteSpace:"nowrap"}}>
                    {st==="enabled"?<span style={{color:"#1a9e4a",fontWeight:600,display:"flex",alignItems:"center",gap:4}}><span style={{width:6,height:6,borderRadius:"50%",background:"#1a9e4a",display:"inline-block"}}/>Active</span>:<span style={{color:"var(--color-text-tertiary)"}}>{st}</span>}
                  </td>

                  {/* Bid */}
                  <td style={{padding:"8px 10px"}}>
                    {editBidKey===k?(
                      <input autoFocus style={{...T.inp,width:72,padding:"4px 7px",fontSize:12}} type="number" step="0.01" min="0.02" value={editBidVal} onChange={e=>setEditBidVal(e.target.value)} onBlur={()=>saveInline(k)} onKeyDown={e=>{if(e.key==="Enter")saveInline(k);if(e.key==="Escape")setEditBidKey(null);}}/>
                    ):(
                      <div style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer"}} onClick={()=>startInline(k,curBid)}>
                        <span style={{fontWeight:600,color:hasPending?R:"var(--color-text-primary)",fontSize:12}}>${curBid.toFixed(2)}</span>
                        {hasPending&&<span style={{fontSize:9,color:R,fontWeight:700,padding:"1px 4px",borderRadius:3,background:"rgba(79,70,229,0.1)"}}>✓</span>}
                        <i className="ti ti-pencil" style={{fontSize:10,color:"var(--color-text-tertiary)",opacity:0.5}}/>
                      </div>
                    )}
                  </td>

                  {/* Spend */}
                  <DeltaCell cur={metrics.spend} comp={comp?.spend} fmt={fmtUSD} lowerBetter={true}/>

                  {/* Sales */}
                  <DeltaCell cur={metrics.sales} comp={comp?.sales} fmt={fmtUSD} lowerBetter={false}/>

                  {/* ACoS */}
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}>
                    <div style={{fontWeight:600,color:metrics.acos>50?"#d42b2b":metrics.acos>30?"#c47a00":"#111",fontSize:12,lineHeight:1.4}}>
                      {metrics.spend>0?(metrics.acos>0?`${metrics.acos.toFixed(1)}%`:(metrics.sales>0?"0.0%":"—")):"-"}
                    </div>
                    {comp!=null&&(()=>{
                      const d=metrics.acos-(comp.acos||0);
                      if(Math.abs(d)<0.001)return null;
                      return<div style={{fontSize:10,fontWeight:600,color:d<0?"#1a9e4a":"#d42b2b",marginTop:1,lineHeight:1.3}}>{d>0?"+":""}{d.toFixed(1)}pp</div>;
                    })()}
                  </td>

                  {/* ROAS */}
                  <DeltaCell cur={metrics.roas} comp={comp?.roas} fmt={v=>v.toFixed(2)} lowerBetter={false}/>

                  {/* Orders */}
                  <DeltaCell cur={metrics.orders} comp={comp?.orders} fmt={v=>String(Math.round(v))} lowerBetter={false}/>

                  {/* Impressions */}
                  <DeltaCell cur={metrics.impressions} comp={comp?.impressions} fmt={fmtNum} lowerBetter={false}/>

                  {/* Clicks */}
                  <DeltaCell cur={metrics.clicks} comp={comp?.clicks} fmt={v=>String(Math.round(v))} lowerBetter={false}/>

                  {/* CTR */}
                  <DeltaCell cur={metrics.ctr} comp={comp?.ctr} fmt={v=>`${v.toFixed(2)}%`} lowerBetter={false} isPp={true}/>

                  {/* CVR */}
                  <DeltaCell cur={metrics.cvr} comp={comp?.cvr} fmt={v=>`${v.toFixed(1)}%`} lowerBetter={false} isPp={true}/>

                  {/* CPC */}
                  <DeltaCell cur={metrics.cpc} comp={comp?.cpc} fmt={v=>`$${v.toFixed(2)}`} lowerBetter={true}/>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length===0&&(
          <div style={{textAlign:"center",padding:"60px 0",color:"var(--color-text-secondary)"}}>
            <i className="ti ti-search-off" style={{fontSize:36,display:"block",marginBottom:8,color:"var(--color-border-secondary)"}}/>
            <div style={{fontSize:14,fontWeight:500,marginBottom:4}}>No targets found</div>
            <div style={{fontSize:12}}>Try adjusting your search or filters</div>
          </div>
        )}
      </div>

      {/* ── Selection bar ── */}
      {selRows.size>0&&(
        <div style={{padding:"12px 24px",background:"#111",display:"flex",alignItems:"center",gap:12,flexShrink:0,boxShadow:"0 -4px 20px rgba(0,0,0,0.15)"}}>
          <span style={{fontSize:13,fontWeight:600,color:"#fff"}}><span style={{color:R,fontWeight:800}}>{selRows.size}</span> of {sorted.length} targets selected</span>
          <div style={{flex:1}}/>
          <button onClick={()=>setSelRows(new Set())} style={{padding:"6px 14px",borderRadius:7,border:"1px solid rgba(255,255,255,0.15)",background:"rgba(255,255,255,0.08)",cursor:"pointer",color:"rgba(255,255,255,0.7)",fontSize:12,fontWeight:500}}>Clear selection</button>
          <button onClick={()=>setChangeBidOpen(true)} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"8px 18px",borderRadius:8,background:R,color:"#fff",border:"none",fontSize:12,fontWeight:700,cursor:"pointer",boxShadow:"0 2px 8px rgba(79,70,229,0.4)"}}>
            <i className="ti ti-pencil" style={{fontSize:13}}/> Bulk Actions
          </button>
        </div>
      )}

      <FilterModal open={filterOpen} onClose={()=>setFilterOpen(false)} activeFilters={activeFilters} onApply={f=>{setActiveFilters(f);setFilterOpen(false);}}/>
      <ChangeBidModal open={changeBidOpen} onClose={()=>setChangeBidOpen(false)} selectedRows={selList} colMap={cm} onApply={handleBulkApply}/>
    </div>
  );
}

/* === BRAND WORKSPACE ======================================== */
function BrandWorkspace({brandId,brandName,adType,setAdType}){
  // All data stored here — persists across adType switches
  const[page,setPage]=useState("dates");
  const[periods,setPeriods]=useState(null);
  const[allData,setAllData]=useState(null);     // {sp,sb,sd,detected}
  const[compAllData,setCompAllData]=useState(null);
  const[bidChanges,setBidChanges]=useState({sp:{},sb:{},sd:{}});
  const[detected,setDetected]=useState([]);

  const[rules,setRulesRaw]=useState(()=>loadRules(brandId,adType));
  const setRules=useCallback(up=>{setRulesRaw(prev=>{const next=typeof up==="function"?up(prev):up;saveRules(brandId,adType,next);return next;});},[brandId,adType]);

  // When adType changes, load its rules but DO NOT reset data
  const prevAt=useRef(adType);
  useEffect(()=>{
    if(prevAt.current!==adType){setRulesRaw(loadRules(brandId,adType));}
    prevAt.current=adType;
  },[adType,brandId]);

  // Current ad type data
  const curData=allData?.[adType]||null;
  const compData=compAllData?.[adType]||null;
  const colMap=useMemo(()=>curData?detectMap(curData.headers):{},[curData]);
  const compColMap=useMemo(()=>compData?detectMap(compData.headers):{},[compData]);
  const curBidRows=useMemo(()=>curData?curData.rows.filter(r=>isBidRow(r,colMap)):[],[curData,colMap]);
  const compBidRows=useMemo(()=>compData?compData.rows.filter(r=>isBidRow(r,compColMap)):[],[compData,compColMap]);
  const curAgg=useMemo(()=>curBidRows.length?sumAgg(curBidRows,colMap):{},[curBidRows,colMap]);
  const compAgg=useMemo(()=>compBidRows.length?sumAgg(compBidRows,compColMap):{},[compBidRows,compColMap]);
  const curBidChanges=bidChanges[adType]||{};
  // Insights available in Priority Action Center module
  const setCurBidChanges=useCallback(up=>{setBidChanges(prev=>{const cur=prev[adType]||{};const next=typeof up==="function"?up(cur):up;return{...prev,[adType]:next};});},[adType]);
  const pendingCount=Object.keys(curBidChanges).length;

  function handleComplete({cur,comp,detected:det}){
    setAllData(cur);setCompAllData(comp||null);setDetected(det||[]);setBidChanges({sp:{},sb:{},sd:{}});
    // Auto-switch to first detected ad type
    if(det&&det.length>0){const first=det[0].key;if(first!==adType)setAdType(first);}
    setPage("dashboard");
  }

  function handleDownload(){
    if(!curData)return;const cm=colMap;
    const changed=curData.rows.filter(row=>{const k=rowKey(row,cm);return curBidChanges[k]!=null;});
    if(!changed.length){alert("No bid changes to download.");return;}
    /* Use proper Amazon bulk format with all required columns */
    const outputRows=curData.rows.map(row=>{
      const k=rowKey(row,cm);
      const newBid=curBidChanges[k];
      const bidChanged=newBid!=null&&cm.bid;
      /* Start with original row to preserve Campaign ID, Ad Group ID, Keyword ID etc */
      const updatedRow={...row};
      if(bidChanged){
        /* Set bid to 2 decimal places */
        updatedRow[cm.bid]=parseFloat(newBid).toFixed(2);
        updatedRow["Operation"]="update";
      }
      /* Ensure Product column is set correctly for Amazon */
      const adTypeLabel={"sp":"Sponsored Products","sb":"Sponsored Brands","sd":"Sponsored Display"};
      if(!updatedRow["Product"])updatedRow["Product"]=adTypeLabel[adType]||"Sponsored Products";
      return updatedRow;
    });
    /* Use original headers but ensure Operation is included */
    const hdrs=[...curData.headers];
    if(!hdrs.includes("Operation"))hdrs.splice(2,0,"Operation");
    if(!hdrs.includes("Product"))hdrs.unshift("Product");
    const ws=XLSX.utils.json_to_sheet(outputRows,{header:hdrs});
    ws["!cols"]=hdrs.map(h=>{
      const wide=["Campaign Name","Ad Group Name","Keyword Text","Product Targeting Expression"];
      return{wch:wide.includes(h)?28:14};
    });
    const wb=XLSX.utils.book_new();
    /* Amazon requires specific sheet names per ad type */
    const sheetNames={"sp":"Sponsored Products Campaigns","sb":"Sponsored Brands Campaigns","sd":"Sponsored Display Campaigns"};
    XLSX.utils.book_append_sheet(wb,ws,sheetNames[adType]||"Sponsored Products Campaigns");
    XLSX.writeFile(wb,`${brandName.replace(/\s+/g,"_")}_${adType.toUpperCase()}_bid_changes_${new Date().toISOString().split("T")[0]}.xlsx`);
  }

  if(page==="rules")return(
    <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid var(--color-border-tertiary)",background:"var(--color-background-primary)",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
        <h2 style={{margin:0,fontSize:16,fontWeight:600,color:"var(--color-text-primary)"}}>Bid Rules</h2>
        <span style={{fontSize:12,color:"var(--color-text-secondary)"}}>· {brandName} · {adType.toUpperCase()}</span>
      </div>
      <div style={{flex:1,overflow:"hidden"}}><RulesPage rules={rules} setRules={setRules} onBack={()=>setPage("dashboard")}/></div>
    </div>
  );

  if(page==="dates")return<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setPeriods(p);setPage("upload");}}/></div>;

  if(page==="upload")return(
    <div style={{flex:1,overflowY:"auto"}}>
      <div style={{padding:"12px 20px 0",maxWidth:740,margin:"0 auto"}}>
        <button onClick={()=>setPage("dates")} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 10px",borderRadius:6,border:"1px solid var(--color-border-secondary)",background:"transparent",cursor:"pointer",color:"var(--color-text-secondary)",fontSize:12}}><i className="ti ti-arrow-left" style={{fontSize:12}}/> Back to Date Selection</button>
      </div>
      <UploadPhase periods={periods} onComplete={handleComplete}/>
    </div>
  );

  // Dashboard
  const hasData=!!curData;
  const adLabel=BIDS_SUB.find(s=>s.key===adType)?.label||adType.toUpperCase();

  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
    {/* ── Modern Dashboard Header ── */}
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",flexShrink:0}}>
      {/* Top row */}
      <div style={{padding:"14px 22px 12px",display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:700,color:"var(--color-text-primary)",letterSpacing:"-0.3px"}}>{brandName}</h2>
            <span style={{fontSize:12,padding:"2px 10px",borderRadius:20,background:"rgba(79,70,229,0.1)",color:R,fontWeight:600,letterSpacing:"0.3px"}}>{adLabel}</span>
          </div>
          <div style={{fontSize:12,color:"var(--color-text-secondary)",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:12}}/>
            <span style={{fontWeight:500,color:"var(--color-text-primary)"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compAllData&&<><span style={{color:"var(--color-text-tertiary)"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
          </div>
        </div>

        {/* Ad type switcher */}
        {detected.length>0&&(
          <div style={{display:"flex",gap:4,background:"var(--color-background-secondary)",padding:"3px",borderRadius:9,border:"1px solid var(--color-border-tertiary)"}}>
            {BIDS_SUB.map(sub=>{
              const found=detected.find(d=>d.key===sub.key);
              const isActive=adType===sub.key;
              return(
                <button key={sub.key} onClick={()=>found&&setAdType(sub.key)}
                  style={{padding:"5px 14px",borderRadius:7,border:"none",fontSize:12,fontWeight:isActive?700:500,cursor:found?"pointer":"not-allowed",transition:"all 0.15s",
                    background:isActive?R:"transparent",color:isActive?"#fff":found?"var(--color-text-secondary)":"var(--color-text-tertiary)",
                    opacity:found?1:0.4}}>
                  {sub.key.toUpperCase()}
                  {found&&!isActive&&<span style={{display:"inline-block",width:5,height:5,borderRadius:"50%",background:"#1a9e4a",marginLeft:5,verticalAlign:"middle"}}/>}
                </button>
              );
            })}
          </div>
        )}

        {/* Action buttons */}
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <button onClick={()=>setPage("upload")} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:12,fontWeight:500,cursor:"pointer"}}>
            <i className="ti ti-upload" style={{fontSize:13}}/> Re-upload
          </button>
          <button onClick={()=>{/* open help - passed via prop would need lifting, use window event */document.dispatchEvent(new CustomEvent("quarred-help",{detail:"bids"}));}} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px dashed rgba(79,70,229,0.3)",background:"rgba(79,70,229,0.04)",color:R,fontSize:12,fontWeight:600,cursor:"pointer"}}>
            <i className="ti ti-help" style={{fontSize:13}}/> How to Use
          </button>
          <button onClick={()=>setPage("rules")} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",color:"#111",fontSize:12,fontWeight:600,cursor:"pointer",position:"relative"}}>
            <i className="ti ti-adjustments-horizontal" style={{fontSize:13}}/> Rules
            {rules.filter(r=>r.enabled).length>0&&<span style={{position:"absolute",top:-5,right:-5,width:16,height:16,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>{rules.filter(r=>r.enabled).length}</span>}
          </button>
          {rules.filter(r=>r.enabled).length>0&&curBidRows.length>0&&(
            <button onClick={()=>{const ch=applyRulesToRows(curBidRows,colMap,rules);setCurBidChanges(prev=>({...prev,...ch}));}}
              style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 14px",borderRadius:8,border:`2px solid ${R}`,background:"rgba(79,70,229,0.05)",color:R,fontSize:12,fontWeight:700,cursor:"pointer"}}>
              <i className="ti ti-player-play" style={{fontSize:13}}/> Apply Rules
            </button>
          )}
          {pendingCount>0&&(
            <button onClick={handleDownload}
              style={{display:"inline-flex",alignItems:"center",gap:6,padding:"8px 16px",borderRadius:8,background:R,color:"#fff",border:"none",fontSize:13,fontWeight:600,cursor:"pointer",boxShadow:`0 2px 8px rgba(79,70,229,0.3)`}}>
              <i className="ti ti-download" style={{fontSize:14}}/> Download · {pendingCount} {pendingCount===1?"change":"changes"}
            </button>
          )}
        </div>
      </div>
    </div>

    {/* No data for this ad type */}
    {!hasData&&(
      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:14,padding:40}}>
        <div style={{width:72,height:72,borderRadius:18,background:"rgba(79,70,229,0.06)",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <i className="ti ti-file-off" style={{fontSize:34,color:R}}/>
        </div>
        <div>
          <div style={{fontSize:17,fontWeight:700,color:"var(--color-text-primary)",textAlign:"center",marginBottom:6}}>No {adLabel} data found</div>
          <div style={{fontSize:13,color:"var(--color-text-secondary)",textAlign:"center"}}>This ad type was not detected in your uploaded file.</div>
        </div>
        <button onClick={()=>setPage("upload")} style={{...T.btnR(false),boxShadow:"0 2px 8px rgba(79,70,229,0.3)"}}><i className="ti ti-upload" style={{fontSize:14}}/> Re-upload File</button>
      </div>
    )}

    {hasData&&<>
      {Object.keys(curAgg).length>0&&<KPICards curAgg={curAgg} compAgg={Object.keys(compAgg).length?compAgg:null}/>}
      {/* Intelligence moved to Priority Action Center */}
      <TargetingTable key={adType} curRows={curBidRows} compRows={compBidRows} colMap={colMap} bidChanges={curBidChanges} setBidChanges={setCurBidChanges} onDownload={handleDownload} pendingCount={pendingCount}/>
    </>}
  </div>);
}

/* === ROOT APP ================================================ */


/* ================================================================
   ADMIN PORTAL — Full SaaS admin dashboard
   Accessible only when user.isAdmin === true
================================================================ */
function AdminPortal({user, onClose}){
  const[section,setSection]=useState('dashboard');
  const[stats,setStats]=useState(null);
  const[users,setUsers]=useState([]);
  const[revenue,setRevenue]=useState([]);
  const[logs,setLogs]=useState([]);
  const[loading,setLoading]=useState(true);
  const[userSearch,setUserSearch]=useState('');
  const[userPlanFilter,setUserPlanFilter]=useState('');
  const[selectedUser,setSelectedUser]=useState(null);
  const[emailModal,setEmailModal]=useState(null);
  const[emailSubj,setEmailSubj]=useState('');
  const[emailBody,setEmailBody]=useState('');
  const[page,setPage]=useState(1);
  const[totalUsers,setTotalUsers]=useState(0);
  const TOKEN=localStorage.getItem('rq_token');

  const api=async(path,opts={})=>{
    const r=await fetch(`${API_BASE}/api/admin${path}`,{
      headers:{'Authorization':`Bearer ${TOKEN}`,'Content-Type':'application/json'},
      ...opts
    });
    if(!r.ok)throw new Error(await r.text());
    return r.json();
  };

  async function loadDashboard(){
    setLoading(true);
    try{
      const[s,rev,lg]=await Promise.all([
        api('/stats'),api('/revenue'),api('/logs')
      ]);
      setStats(s);setRevenue(rev.months||[]);setLogs(lg.logs||[]);
    }catch(e){console.error(e);}
    setLoading(false);
  }

  async function loadUsers(){
    setLoading(true);
    try{
      const params=new URLSearchParams({page,limit:50});
      if(userSearch)params.set('search',userSearch);
      if(userPlanFilter)params.set('plan',userPlanFilter);
      const d=await api(`/users?${params}`);
      setUsers(d.users||[]);setTotalUsers(d.total||0);
    }catch(e){console.error(e);}
    setLoading(false);
  }

  async function updateUser(id,updates){
    try{
      await api(`/users/${id}`,{method:'PATCH',body:JSON.stringify(updates)});
      loadUsers();
      setSelectedUser(null);
      alert('User updated');
    }catch(e){alert('Failed: '+e.message);}
  }

  async function deleteUser(id){
    if(!window.confirm('Delete this user permanently?'))return;
    try{await api(`/users/${id}`,{method:'DELETE'});loadUsers();}
    catch(e){alert('Failed: '+e.message);}
  }

  async function sendUserEmail(){
    if(!emailModal||!emailSubj||!emailBody)return;
    try{
      await api('/email',{method:'POST',body:JSON.stringify({userId:emailModal,subject:emailSubj,html:`<p>${emailBody}</p>`})});
      setEmailModal(null);setEmailSubj('');setEmailBody('');
      alert('Email sent');
    }catch(e){alert('Failed: '+e.message);}
  }

  useEffect(()=>{loadDashboard();},[]);
  useEffect(()=>{if(section==='users')loadUsers();},[section,page,userPlanFilter]);

  const PLAN_COLOR={starter:'#555',pro:'#4f46e5',agency:'#1a5fa0'};
  const fmtD=v=>v==null?'—':`$${v>=1000?(v/1000).toFixed(1)+'K':v.toFixed(0)}`;
  const fmtN=v=>v>=1000?(v/1000).toFixed(1)+'K':v.toString();

  const SECTIONS=[
    {k:'dashboard',label:'Dashboard',  icon:'ti-layout-dashboard'},
    {k:'users',    label:'Users',      icon:'ti-users'},
    {k:'revenue',  label:'Revenue',    icon:'ti-chart-bar'},
    {k:'logs',     label:'Audit Logs', icon:'ti-clipboard-list'},
    {k:'settings', label:'Settings',   icon:'ti-settings'},
  ];

  return(
    <div style={{position:'fixed',inset:0,background:'#f0f2f7',zIndex:8000,display:'flex',fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>

      {/* Admin Sidebar */}
      <div style={{width:220,background:'#111827',display:'flex',flexDirection:'column',flexShrink:0}}>
        <div style={{padding:'20px 16px',borderBottom:'1px solid rgba(255,255,255,0.08)'}}>
          <div style={{display:'flex',alignItems:'center',gap:9}}>
            <div style={{width:32,height:32,borderRadius:8,background:'#4f46e5',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:900,color:'#fff'}}>A</div>
            <div>
              <div style={{fontSize:13,fontWeight:800,color:'#fff'}}>Admin Portal</div>
              <div style={{fontSize:10,color:'rgba(255,255,255,0.4)'}}>OperaIQ</div>
            </div>
          </div>
        </div>
        <div style={{flex:1,padding:'12px 0'}}>
          {SECTIONS.map(s=>(
            <button key={s.k} onClick={()=>{setSection(s.k);if(s.k==='users')loadUsers();}} style={{width:'100%',padding:'10px 16px',border:'none',background:section===s.k?'rgba(79,70,229,0.3)':'transparent',cursor:'pointer',display:'flex',alignItems:'center',gap:9,color:section===s.k?'#fff':'rgba(255,255,255,0.5)',fontSize:13,fontWeight:section===s.k?700:400,textAlign:'left',borderLeft:`3px solid ${section===s.k?'#4f46e5':'transparent'}`}}>
              <i className={`ti ${s.icon}`} style={{fontSize:14}}/>{s.label}
            </button>
          ))}
        </div>
        <div style={{padding:'12px 16px',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
          <button onClick={onClose} style={{width:'100%',padding:'9px',borderRadius:8,border:'none',background:'rgba(255,255,255,0.07)',color:'rgba(255,255,255,0.6)',cursor:'pointer',fontSize:12,fontWeight:600,display:'flex',alignItems:'center',gap:7,justifyContent:'center'}}>
            <i className="ti ti-arrow-left" style={{fontSize:12}}/> Back to App
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{flex:1,overflow:'auto'}}>

        {/* Topbar */}
        <div style={{padding:'14px 24px',background:'#fff',borderBottom:'1px solid #e8ebf2',display:'flex',alignItems:'center',gap:10}}>
          <span style={{fontSize:16,fontWeight:800,color:'#111'}}>
            {SECTIONS.find(s=>s.k===section)?.label}
          </span>
          <div style={{marginLeft:'auto',fontSize:12,color:'#888'}}>Logged in as <strong>{user?.email}</strong></div>
        </div>

        <div style={{padding:'24px'}}>

          {/* ── DASHBOARD ── */}
          {section==='dashboard'&&(
            loading?<div style={{textAlign:'center',padding:60,color:'#aaa'}}>Loading stats...</div>:
            stats&&(
              <>
                {/* KPI Cards */}
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:14,marginBottom:24}}>
                  {[
                    {label:'Total Users',      val:fmtN(stats.totalUsers),      icon:'ti-users',         color:'#1a5fa0'},
                    {label:'Active Users',     val:fmtN(stats.activeUsers),     icon:'ti-user-check',    color:'#1a9e5f'},
                    {label:'On Trial',         val:fmtN(stats.trialUsers),      icon:'ti-clock',         color:'#c47a00'},
                    {label:'Monthly Revenue',  val:fmtD(stats.MRR),             icon:'ti-currency-dollar',color:'#4f46e5'},
                  ].map((k,i)=>(
                    <div key={i} style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px',boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
                      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
                        <div style={{width:34,height:34,borderRadius:9,background:k.color+'15',display:'flex',alignItems:'center',justifyContent:'center'}}>
                          <i className={`ti ${k.icon}`} style={{fontSize:15,color:k.color}}/>
                        </div>
                        <span style={{fontSize:11,color:'#888',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.4px'}}>{k.label}</span>
                      </div>
                      <div style={{fontSize:26,fontWeight:900,color:'#111',letterSpacing:'-0.5px'}}>{k.val}</div>
                    </div>
                  ))}
                </div>

                {/* Plans breakdown */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:20}}>
                  <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px'}}>
                    <div style={{fontSize:13,fontWeight:700,color:'#111',marginBottom:16}}>Plan Distribution</div>
                    {Object.entries(stats.plans||{}).map(([plan,count])=>(
                      <div key={plan} style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
                        <div style={{width:9,height:9,borderRadius:'50%',background:PLAN_COLOR[plan]||'#aaa',flexShrink:0}}/>
                        <span style={{fontSize:13,color:'#333',flex:1,textTransform:'capitalize',fontWeight:600}}>{plan}</span>
                        <span style={{fontSize:13,fontWeight:800,color:PLAN_COLOR[plan]}}>{count}</span>
                        <span style={{fontSize:11,color:'#aaa'}}>users</span>
                      </div>
                    ))}
                    <div style={{marginTop:14,paddingTop:14,borderTop:'1px solid #f0f0f0',display:'flex',justifyContent:'space-between'}}>
                      <span style={{fontSize:12,color:'#888',fontWeight:600}}>Estimated MRR</span>
                      <span style={{fontSize:14,fontWeight:900,color:'#4f46e5'}}>{fmtD(stats.MRR)}</span>
                    </div>
                  </div>

                  {/* Recent signups */}
                  <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px'}}>
                    <div style={{fontSize:13,fontWeight:700,color:'#111',marginBottom:14}}>Recent Signups</div>
                    {(stats.recentSignups||[]).map((u,i)=>(
                      <div key={i} style={{display:'flex',alignItems:'center',gap:9,marginBottom:9,paddingBottom:9,borderBottom:i<stats.recentSignups.length-1?'1px solid #f5f5f5':'none'}}>
                        <div style={{width:28,height:28,borderRadius:'50%',background:'#f0f0f0',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,color:'#555',flexShrink:0}}>
                          {u.name?.[0]?.toUpperCase()||'?'}
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:12,fontWeight:600,color:'#111',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{u.name}</div>
                          <div style={{fontSize:10,color:'#aaa',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{u.email}</div>
                        </div>
                        <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,background:PLAN_COLOR[u.plan]+'18',color:PLAN_COLOR[u.plan],fontWeight:700,flexShrink:0}}>{u.plan}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )
          )}

          {/* ── USERS TABLE ── */}
          {section==='users'&&(
            <>
              <div style={{display:'flex',gap:10,marginBottom:16,alignItems:'center',flexWrap:'wrap'}}>
                <input value={userSearch} onChange={e=>setUserSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&loadUsers()} placeholder="Search email or name..." style={{padding:'8px 12px',borderRadius:9,border:'1px solid #e0e0e0',fontSize:13,outline:'none',width:260}}/>
                {['','starter','pro','agency'].map(p=>(
                  <button key={p} onClick={()=>{setUserPlanFilter(p);setPage(1);}} style={{padding:'6px 14px',borderRadius:20,border:`1px solid ${userPlanFilter===p?'#4f46e5':'#e0e0e0'}`,background:userPlanFilter===p?'#4f46e5':'#fff',color:userPlanFilter===p?'#fff':'#555',fontSize:12,fontWeight:600,cursor:'pointer',textTransform:'capitalize'}}>
                    {p||'All Plans'}
                  </button>
                ))}
                <span style={{marginLeft:'auto',fontSize:12,color:'#888'}}>{totalUsers} total users</span>
              </div>

              <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',overflow:'hidden'}}>
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
                  <thead>
                    <tr style={{background:'#f8f9fc'}}>
                      {['Name','Email','Plan','Status','Joined','Last Login','Actions'].map(h=>(
                        <th key={h} style={{padding:'11px 14px',textAlign:'left',fontWeight:700,color:'#555',borderBottom:'1px solid #e8ebf2',whiteSpace:'nowrap'}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {loading?(<tr><td colSpan={7} style={{textAlign:'center',padding:40,color:'#aaa'}}>Loading...</td></tr>):
                    users.map((u,i)=>(
                      <tr key={u.id} style={{borderBottom:'1px solid #f5f5f5',background:i%2===0?'#fff':'#fafbfd'}}>
                        <td style={{padding:'10px 14px',fontWeight:600,color:'#111'}}>
                          <div style={{display:'flex',alignItems:'center',gap:8}}>
                            <div style={{width:26,height:26,borderRadius:'50%',background:'#f0f0f0',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,color:'#555',flexShrink:0}}>{u.name?.[0]?.toUpperCase()||'?'}</div>
                            {u.name}
                            {u.is_admin&&<span style={{fontSize:9,padding:'1px 5px',borderRadius:6,background:'rgba(79,70,229,0.1)',color:'#4f46e5',fontWeight:700}}>ADMIN</span>}
                          </div>
                        </td>
                        <td style={{padding:'10px 14px',color:'#555'}}>{u.email}</td>
                        <td style={{padding:'10px 14px'}}>
                          <span style={{padding:'2px 8px',borderRadius:8,background:PLAN_COLOR[u.plan]+'18',color:PLAN_COLOR[u.plan],fontWeight:700,fontSize:11,textTransform:'capitalize'}}>{u.plan}</span>
                        </td>
                        <td style={{padding:'10px 14px'}}>
                          <span style={{padding:'2px 8px',borderRadius:8,background:u.is_active?'rgba(26,158,95,0.1)':'rgba(212,43,43,0.1)',color:u.is_active?'#1a9e5f':'#d42b2b',fontWeight:700,fontSize:11}}>
                            {u.is_active?'Active':'Suspended'}
                          </span>
                        </td>
                        <td style={{padding:'10px 14px',color:'#888',fontSize:11}}>{u.created_at?.slice(0,10)||'—'}</td>
                        <td style={{padding:'10px 14px',color:'#888',fontSize:11}}>{u.last_login_at?.slice(0,10)||'Never'}</td>
                        <td style={{padding:'10px 14px'}}>
                          <div style={{display:'flex',gap:5}}>
                            <button onClick={()=>setSelectedUser(u)} style={{padding:'4px 8px',borderRadius:6,border:'1px solid #e0e0e0',background:'#fff',fontSize:11,cursor:'pointer',color:'#555'}}>Edit</button>
                            <button onClick={()=>setEmailModal(u.id)} style={{padding:'4px 8px',borderRadius:6,border:'1px solid #e0e0e0',background:'#fff',fontSize:11,cursor:'pointer',color:'#1a5fa0'}}>Email</button>
                            <button onClick={()=>deleteUser(u.id)} style={{padding:'4px 8px',borderRadius:6,border:'1px solid rgba(212,43,43,0.2)',background:'rgba(212,43,43,0.05)',fontSize:11,cursor:'pointer',color:'#d42b2b'}}>Del</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination */}
                <div style={{padding:'12px 16px',borderTop:'1px solid #f0f0f0',display:'flex',gap:8,alignItems:'center'}}>
                  <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1} style={{padding:'5px 12px',borderRadius:7,border:'1px solid #e0e0e0',background:'#fff',cursor:'pointer',fontSize:12,opacity:page===1?0.4:1}}>← Prev</button>
                  <span style={{fontSize:12,color:'#888'}}>Page {page} · {totalUsers} users</span>
                  <button onClick={()=>setPage(p=>p+1)} disabled={users.length<50} style={{padding:'5px 12px',borderRadius:7,border:'1px solid #e0e0e0',background:'#fff',cursor:'pointer',fontSize:12,opacity:users.length<50?0.4:1}}>Next →</button>
                </div>
              </div>
            </>
          )}

          {/* ── REVENUE ── */}
          {section==='revenue'&&(
            <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px'}}>
              <div style={{fontSize:15,fontWeight:700,color:'#111',marginBottom:20}}>Monthly Revenue (Estimated)</div>
              {revenue.length===0?<div style={{textAlign:'center',padding:40,color:'#aaa'}}>No revenue data yet</div>:(
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
                  <thead><tr style={{background:'#f8f9fc'}}>
                    {['Month','MRR','Starter Users','Pro Users','Agency Users'].map(h=>(
                      <th key={h} style={{padding:'10px 14px',textAlign:h==='Month'?'left':'right',fontWeight:700,color:'#555',borderBottom:'1px solid #e8ebf2'}}>{h}</th>
                    ))}
                  </tr></thead>
                  <tbody>
                    {revenue.slice().reverse().map((m,i)=>(
                      <tr key={i} style={{borderBottom:'1px solid #f5f5f5'}}>
                        <td style={{padding:'10px 14px',fontWeight:600,color:'#111'}}>{m.month}</td>
                        <td style={{padding:'10px 14px',textAlign:'right',fontWeight:800,color:'#4f46e5'}}>{fmtD(m.mrr)}</td>
                        <td style={{padding:'10px 14px',textAlign:'right',color:'#555'}}>{m.starter}</td>
                        <td style={{padding:'10px 14px',textAlign:'right',color:'#4f46e5',fontWeight:600}}>{m.pro}</td>
                        <td style={{padding:'10px 14px',textAlign:'right',color:'#1a5fa0',fontWeight:600}}>{m.agency}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}

          {/* ── AUDIT LOGS ── */}
          {section==='logs'&&(
            <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',overflow:'hidden'}}>
              <div style={{padding:'16px 20px',borderBottom:'1px solid #f0f0f0',fontSize:14,fontWeight:700,color:'#111'}}>Admin Action Logs</div>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                <thead><tr style={{background:'#f8f9fc'}}>
                  {['Time','Admin','Action','Target'].map(h=>(
                    <th key={h} style={{padding:'9px 14px',textAlign:'left',fontWeight:700,color:'#555',borderBottom:'1px solid #e8ebf2'}}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {logs.map((l,i)=>(
                    <tr key={i} style={{borderBottom:'1px solid #f5f5f5'}}>
                      <td style={{padding:'9px 14px',color:'#888'}}>{l.created_at?.slice(0,16).replace('T',' ')}</td>
                      <td style={{padding:'9px 14px',fontWeight:600,color:'#111'}}>{l.admin?.name||'System'}</td>
                      <td style={{padding:'9px 14px',color:'#555',maxWidth:300}}><code style={{fontSize:11}}>{l.action?.slice(0,80)}</code></td>
                      <td style={{padding:'9px 14px',color:'#888'}}>{l.target_user_id?.slice(0,8)}...</td>
                    </tr>
                  ))}
                  {logs.length===0&&<tr><td colSpan={4} style={{textAlign:'center',padding:40,color:'#aaa'}}>No logs yet</td></tr>}
                </tbody>
              </table>
            </div>
          )}

          {/* ── SETTINGS ── */}
          {section==='settings'&&(
            <div style={{maxWidth:600}}>
              {[
                {title:'Stripe Integration',desc:'Stripe is connected. Payments and subscriptions are managed automatically.',icon:'ti-credit-card',ok:true},
                {title:'Supabase Database',desc:'PostgreSQL database connected. All user data is stored securely.',icon:'ti-database',ok:true},
                {title:'Google OAuth',desc:'Enable Google Sign-In by adding GOOGLE_CLIENT_ID to your .env file.',icon:'ti-brand-google',ok:!!window.GOOGLE_CLIENT_ID},
                {title:'Email Service',desc:'Transactional emails via SMTP. Configure in .env (EMAIL_HOST, EMAIL_USER, EMAIL_PASS).',icon:'ti-mail',ok:true},
              ].map((s,i)=>(
                <div key={i} style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px',marginBottom:12,display:'flex',alignItems:'center',gap:14}}>
                  <div style={{width:40,height:40,borderRadius:10,background:s.ok?'rgba(26,158,95,0.1)':'rgba(196,122,0,0.1)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    <i className={`ti ${s.icon}`} style={{fontSize:17,color:s.ok?'#1a9e5f':'#c47a00'}}/>
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:'#111',marginBottom:3}}>{s.title}</div>
                    <div style={{fontSize:12,color:'#888'}}>{s.desc}</div>
                  </div>
                  <span style={{fontSize:11,padding:'3px 9px',borderRadius:8,background:s.ok?'rgba(26,158,95,0.1)':'rgba(196,122,0,0.1)',color:s.ok?'#1a9e5f':'#c47a00',fontWeight:700}}>{s.ok?'Connected':'Setup needed'}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Edit User Modal */}
      {selectedUser&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:9000,display:'flex',alignItems:'center',justifyContent:'center',padding:20}} onClick={()=>setSelectedUser(null)}>
          <div style={{background:'#fff',borderRadius:16,padding:'28px',width:400}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:16,fontWeight:800,color:'#111',marginBottom:20}}>Edit User: {selectedUser.name}</div>
            <div style={{marginBottom:14}}>
              <label style={{display:'block',fontSize:11,fontWeight:700,color:'#888',marginBottom:5,textTransform:'uppercase'}}>Plan</label>
              <select defaultValue={selectedUser.plan} id="edit-plan" style={{width:'100%',padding:'8px 10px',borderRadius:8,border:'1px solid #e0e0e0',fontSize:13,outline:'none'}}>
                <option value="free">Free ($0/mo)</option>
                <option value="starter">Starter ($10/mo)</option>
                <option value="pro">Pro ($20/mo)</option>
                <option value="agency">Agency ($40/mo)</option>
              </select>
            </div>
            <div style={{marginBottom:20}}>
              <label style={{display:'block',fontSize:11,fontWeight:700,color:'#888',marginBottom:5,textTransform:'uppercase'}}>Status</label>
              <select defaultValue={selectedUser.is_active?'active':'suspended'} id="edit-status" style={{width:'100%',padding:'8px 10px',borderRadius:8,border:'1px solid #e0e0e0',fontSize:13,outline:'none'}}>
                <option value="active">Active</option>
                <option value="suspended">Suspended</option>
              </select>
            </div>
            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setSelectedUser(null)} style={{flex:1,padding:'10px',borderRadius:9,border:'1px solid #e0e0e0',background:'#fff',color:'#555',fontSize:13,fontWeight:600,cursor:'pointer'}}>Cancel</button>
              <button onClick={()=>{const plan=document.getElementById('edit-plan').value;const is_active=document.getElementById('edit-status').value==='active';updateUser(selectedUser.id,{plan,is_active});}} style={{flex:2,padding:'10px',borderRadius:9,border:'none',background:'#4f46e5',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>Save Changes</button>
            </div>
          </div>
        </div>
      )}

      {/* Email User Modal */}
      {emailModal&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:9000,display:'flex',alignItems:'center',justifyContent:'center',padding:20}} onClick={()=>setEmailModal(null)}>
          <div style={{background:'#fff',borderRadius:16,padding:'28px',width:460}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:16,fontWeight:800,color:'#111',marginBottom:20}}>Send Email to User</div>
            <input value={emailSubj} onChange={e=>setEmailSubj(e.target.value)} placeholder="Subject..." style={{width:'100%',padding:'9px 12px',borderRadius:8,border:'1px solid #e0e0e0',fontSize:13,outline:'none',marginBottom:10,boxSizing:'border-box'}}/>
            <textarea value={emailBody} onChange={e=>setEmailBody(e.target.value)} placeholder="Message body..." rows={6} style={{width:'100%',padding:'9px 12px',borderRadius:8,border:'1px solid #e0e0e0',fontSize:13,outline:'none',resize:'vertical',boxSizing:'border-box',marginBottom:16}}/>
            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setEmailModal(null)} style={{flex:1,padding:'10px',borderRadius:9,border:'1px solid #e0e0e0',background:'#fff',color:'#555',fontSize:13,fontWeight:600,cursor:'pointer'}}>Cancel</button>
              <button onClick={sendUserEmail} style={{flex:2,padding:'10px',borderRadius:9,border:'none',background:'#1a5fa0',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>Send Email</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


export default function App(){
  const[user,setUser]=useState(()=>loadAuth());
  const[showPricing,setShowPricing]=useState(false);
  const[booting,setBooting]=useState(true);

  // On load, verify the saved session token with the backend.
  useEffect(()=>{
    const token=localStorage.getItem("rq_token");
    if(!token){ setBooting(false); return; }
    fetch(API_BASE+"/api/auth/me",{headers:{Authorization:"Bearer "+token}})
      .then(r=>r.json())
      .then(d=>{ if(d&&d.user){ saveAuth(d.user); savePlan(d.user.plan); setUser(d.user); } else { clearAuth(); setUser(null); } })
      .catch(()=>{ /* offline: keep local copy */ })
      .finally(()=>setBooting(false));
  },[]);

  function handleAuth(u){ setUser(u); }
  function handleLogout(){
    const token=localStorage.getItem("rq_token");
    if(token){ fetch(API_BASE+"/api/auth/logout",{method:"POST",headers:{Authorization:"Bearer "+token}}).catch(()=>{}); }
    localStorage.removeItem("rq_token");
    clearAuth(); setUser(null);
  }
  function handlePlanSelect(planId){
    if(user){ const u={...user,plan:planId}; saveAuth(u); savePlan(planId); setUser(u); }
  }

  const[showAdmin,setShowAdmin]=useState(false);

  if(booting) return <div style={{height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"Inter,sans-serif",color:"#4f46e5",fontWeight:700}}>Loading…</div>;
  if(!user) return <AuthScreen onAuth={handleAuth}/>;

  return(
    <>
      {showPricing&&<PricingModal onClose={()=>setShowPricing(false)} currentPlan={user.plan} onSelect={handlePlanSelect}/>}
      {/* In-app AdminPortal is kept for reference but no longer the primary admin.
         The real admin is the standalone PHP panel at /api/admin/ which fully
         matches the backend. The Admin button opens it in a new tab. */}
      {showAdmin&&user.isAdmin&&<AdminPortal user={user} onClose={()=>setShowAdmin(false)}/>}
      <AppInner user={user} onLogout={handleLogout} onUpgrade={()=>setShowPricing(true)} onAdmin={user.isAdmin?()=>{ window.open(API_BASE+"/api/admin/","_blank"); }:null}/>
    </>
  );
}

function AppInner({user,onLogout,onUpgrade,onAdmin}){
  const[tab,setTab]=useState("hub");
  const[globalData,setGlobalData]=useState(null);
  const[brands,setBrands]=useState(loadBrands);
  const[activeId,setActiveId]=useState(()=>loadBrands()[0].id);
  const[adType,setAdType]=useState("sp");
  const[helpKey,setHelpKey]=useState(null);
  const[accountTab,setAccountTab]=useState(null); // null=closed, else tab id
  useEffect(()=>{const h=e=>setHelpKey(e.detail);document.addEventListener("quarred-help",h);return()=>document.removeEventListener("quarred-help",h);},[]);
  const addBrand=name=>{const id=`b_${Date.now()}`,u=[...brands,{id,name}];setBrands(u);saveBrands(u);setActiveId(id);};
  const renameBrand=(id,name)=>{const u=brands.map(b=>b.id===id?{...b,name}:b);setBrands(u);saveBrands(u);};
  const deleteBrand=id=>{const u=brands.filter(b=>b.id!==id);setBrands(u);saveBrands(u);try{["sp","sb","sd"].forEach(at=>localStorage.removeItem(LS_RULES(id,at)));}catch{}setActiveId(u[0].id);};
  const activeBrand=brands.find(b=>b.id===activeId);const adLabel=BIDS_SUB.find(s=>s.key===adType)?.label||"";
  return(<div style={{display:"flex",height:"100vh",fontFamily:"var(--font-sans,system-ui,sans-serif)",background:"var(--color-background-tertiary,#f4f4f5)",overflow:"hidden"}}>
    <HelpModal open={!!helpKey} onClose={()=>setHelpKey(null)} featureKey={helpKey}/>
    {accountTab&&<AccountModal user={user} initialTab={accountTab} onClose={()=>setAccountTab(null)} onLogout={onLogout} onUpgrade={onUpgrade}/>}
    <Sidebar active={tab} adType={adType} setAdType={t=>{setAdType(t);setTab("bids");}} setTab={setTab} onHelp={k=>setHelpKey(k)} user={user} onLogout={onLogout} onUpgrade={onUpgrade} onOpenAccount={t=>setAccountTab(t)} onAdmin={onAdmin}/>
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
      <Topbar brands={brands} activeId={activeId} onSwitch={setActiveId} onAdd={addBrand} onRename={renameBrand} onDelete={deleteBrand} adTypeLabel={adLabel}/>
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {tab==="hub"
          ?<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
            <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
              <i className="ti ti-database-import" style={{fontSize:15,color:"#4f46e5"}}/>
              <h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Data Hub</h2>
              <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,122,60,0.1)",color:"#1a7a3c",fontWeight:700}}>Upload Once · All Modules Sync</span>
            </div>
            <DataHub globalData={globalData} onDataLoaded={d=>setGlobalData(d)} onClearData={()=>setGlobalData(null)} setTab={setTab}/>
          </div>
          :tab==="searchterms"
          ?<SearchTermModule globalData={globalData} setTab={setTab}/>
          :tab==="action"
          ?<ActionCenterModule globalData={globalData} setTab={setTab}/>
          :tab==="health"
          ?<CampaignHealthModule globalData={globalData} setTab={setTab}/>
          :tab==="impression"
          ?<ImpressionShareModule globalData={globalData} setTab={setTab}/>
          :tab==="sqpr"
          ?<SQPModule globalData={globalData} setTab={setTab}/>
          :tab==="rank"
          ?<RankRadarModule globalData={globalData} setTab={setTab}/>
          :tab==="brandtable"
          ?<BrandTableModule globalData={globalData} setTab={setTab}/>
          :tab==="bulk"
          ?<BulkBuilderModule globalData={globalData} setTab={setTab}/>
          :tab==="ai"
          ?<AIStrategistModule globalData={globalData} setTab={setTab}/>
          :tab==="negations"
          ?<NegationModule globalData={globalData} setTab={setTab}/>
          :tab==="dayparting"
          ?<DaypartingModule globalData={globalData} setTab={setTab}/>
          :tab==="placement"
          ?<PlacementOptimizerModule globalData={globalData} setTab={setTab}/>
          :tab==="inventory"
          ?<InventoryPPCModule globalData={globalData} setTab={setTab}/>
          :tab==="listing"
          ?<ListingConversionModule globalData={globalData} setTab={setTab}/>
          :tab==="branddef"
          ?<BrandDefenseModule globalData={globalData} setTab={setTab}/>
          :tab==="competitor"
          ?<CompetitorRadarModule globalData={globalData} setTab={setTab}/>
          :tab==="portfolio"
          ?<PortfolioCommandModule globalData={globalData} setTab={setTab}/>
          :tab==="reporting"
          ?<ClientReportingModule globalData={globalData} setTab={setTab}/>
          :tab==="settings"
          ?<SettingsModule globalData={globalData} setTab={setTab}/>
          :tab==="strharvest"
          ?<STRHarvestModule globalData={globalData} setTab={setTab}/>
          :tab==="dedup"
          ?<PortfolioDeduplicationModule globalData={globalData} setTab={setTab}/>
          :tab==="stin"
          ?<STINModule globalData={globalData} setTab={setTab}/>
          :tab==="profit"
          ?<ProfitIntelModule globalData={globalData} setTab={setTab}/>
          :tab==="budget"
          ?<BudgetPacingModule globalData={globalData} setTab={setTab}/>
          :tab==="strategy"
          ?<ACOSStrategyModule globalData={globalData} setTab={setTab}/>
          :tab==="learning"
          ?<PPCLearningHubModule globalData={globalData} setTab={setTab}/>
          :tab==="priority"
          ?<PriorityEngineModule globalData={globalData} setTab={setTab}/>
          :tab==="audit"
          ?<AccountAuditModule globalData={globalData} setTab={setTab}/>
          :tab==="seasonal"
          ?<SeasonalEngineModule globalData={globalData} setTab={setTab}/>
          :tab==="niche"
          ?<NicheDivesModule globalData={globalData} setTab={setTab}/>
          :tab==="conflict"
          ?<ConflictDetectorModule globalData={globalData} setTab={setTab}/>
          :tab==="campaigns"
          ?<CampaignSuggestionsModule globalData={globalData} setTab={setTab}/>
          :tab==="bleeder"
          ?<BleederCheckModule globalData={globalData} setTab={setTab}/>
          :tab==="intent"
          ?<SearchIntentModule globalData={globalData} setTab={setTab}/>
          :tab==="automation"
          ?<RulesEngineModule globalData={globalData} setTab={setTab}/>
          :<BrandWorkspace brandId={activeId} brandName={activeBrand?.name||""} adType={adType} setAdType={setAdType}/>
        }
      </div>
    </div>
  </div>);
}

/* ================================================================
   SEARCH TERM INTELLIGENCE MODULE
   Full strategist workspace for Amazon Search Term Report analysis
================================================================ */

/* ── STR Column aliases ──────────────────────────────────────── */
const STR_ALIASES={
  campaign:    ["Campaign Name","Campaign","campaign name"],
  adGroup:     ["Ad Group Name","Ad Group","ad group"],
  matchType:   ["Match Type","match type","Targeting Type"],
  searchTerm:  ["Customer Search Term","Search Term","Query","Search query","Keyword"],
  impressions: ["Impressions","impressions"],
  clicks:      ["Clicks","clicks"],
  ctr:         ["Click-through Rate","CTR","Click-Through Rate"],
  spend:       ["Spend","Cost","Ad Spend"],
  sales:       ["14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales","Sales","Total Sales","Attributed Sales 7d"],
  orders:      ["14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)","Orders","Total Orders"],
  acos:        ["ACOS","ACoS","Advertising Cost of Sales"],
  roas:        ["ROAS","Return on Ad Spend"],
  cpc:         ["CPC","Cost Per Click","Average CPC"],
  cvr:         ["Conversion Rate","CVR","Order Rate"],
  units:       ["14 Day Total Units (#)","7 Day Total Units (#)","Units"],
};

function strDetectMap(headers){
  const r={};
  for(const[k,cands]of Object.entries(STR_ALIASES)){
    for(const cand of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===cand.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const cand of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(cand.toLowerCase().split(" ")[0].toLowerCase()));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function strGetNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function strCalcMetrics(row,sm){
  const imp=strGetNum(row,sm.impressions),clk=strGetNum(row,sm.clicks),
    spd=strGetNum(row,sm.spend),sal=strGetNum(row,sm.sales),
    ord=strGetNum(row,sm.orders);
  const ctr=sm.ctr&&strGetNum(row,sm.ctr)>0?strGetNum(row,sm.ctr):imp>0?(clk/imp)*100:0;
  const acos=sm.acos&&strGetNum(row,sm.acos)>0?strGetNum(row,sm.acos):sal>0?(spd/sal)*100:spd>0?0:0;
  const roas=sm.roas&&strGetNum(row,sm.roas)>0?strGetNum(row,sm.roas):spd>0?sal/spd:0;
  const cvr=sm.cvr&&strGetNum(row,sm.cvr)>0?strGetNum(row,sm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=sm.cpc&&strGetNum(row,sm.cpc)>0?strGetNum(row,sm.cpc):clk>0?spd/clk:0;
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,ctr,acos,roas,cvr,cpc};
}

function strAgg(rows,sm){
  let imp=0,clk=0,spd=0,sal=0,ord=0;
  rows.forEach(r=>{imp+=strGetNum(r,sm.impressions);clk+=strGetNum(r,sm.clicks);spd+=strGetNum(r,sm.spend);sal+=strGetNum(r,sm.sales);ord+=strGetNum(r,sm.orders);});
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    acos:sal>0?(spd/sal)*100:0,ctr:imp>0?(clk/imp)*100:0,
    cvr:clk>0?(ord/clk)*100:0,cpc:clk>0?spd/clk:0,roas:spd>0?sal/spd:0};
}

/* ── Classification Engine ───────────────────────────────────── */
function classifyTerm(m, term=""){
  const t=term.toLowerCase();
  const isBrand=(t.includes("your brand")); // override with real brand names if needed
  if(isBrand)                                           return{cls:"Defensive",    color:"#1a50a0",bg:"rgba(26,80,160,0.08)",icon:"ti-shield",priority:4};
  if(m.spend>25&&m.orders===0&&m.clicks>=8)             return{cls:"Bleeder",      color:"#d42b2b",bg:"rgba(212,43,43,0.08)",icon:"ti-droplet-off",priority:0};
  if(m.spend>10&&m.orders===0&&m.clicks>=5)             return{cls:"Waste",        color:"#d42b2b",bg:"rgba(212,43,43,0.06)",icon:"ti-coin-off",priority:1};
  if(m.cvr>5&&m.impressions<1000&&m.orders>=2)          return{cls:"Scale Opp.",   color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-rocket",priority:2};
  if(m.cvr>3&&m.orders>=3&&m.acos<25&&m.acos>0)        return{cls:"Harvest",      color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-cut",priority:2};
  if(m.orders>=2&&m.acos>0&&m.acos<20&&m.clicks>10)    return{cls:"Ranking Term", color:"#6338c8",bg:"rgba(99,56,200,0.08)",icon:"ti-trending-up",priority:3};
  if(m.ctr>0.5&&m.cvr>2&&m.orders>=1)                  return{cls:"Efficient",    color:"#1a7a3c",bg:"rgba(26,122,60,0.06)",icon:"ti-check",priority:4};
  if(m.clicks<5&&m.impressions>0&&m.spend<3)            return{cls:"Discovery",    color:"#888",bg:"rgba(0,0,0,0.04)",icon:"ti-search",priority:5};
  if(m.ctr<0.1&&m.clicks>5&&m.orders===0)              return{cls:"Irrelevant",   color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-ban",priority:1};
  if(m.orders>=1&&m.acos>0)                             return{cls:"Monitor",      color:"#888",bg:"rgba(0,0,0,0.04)",icon:"ti-eye",priority:4};
  return{cls:"Discovery",color:"#888",bg:"rgba(0,0,0,0.04)",icon:"ti-search",priority:5};
}

/* ── STR Insights Generator ──────────────────────────────────── */
function generateSTRInsights(rows,sm,compMap){
  const insights=[];
  const metrics=rows.map(r=>({r,m:strCalcMetrics(r,sm),term:String(r[sm.searchTerm]||"")}));

  const bleeders=metrics.filter(({m})=>m.spend>15&&m.orders===0);
  if(bleeders.length){
    const waste=bleeders.reduce((s,{m})=>s+m.spend,0);
    insights.push({priority:"critical",icon:"ti-droplet-off",title:`${bleeders.length} Bleeding Search Terms`,
      explanation:`${bleeders.length} terms spent $${waste.toFixed(0)} with zero conversions. This is recoverable budget being wasted on non-converting traffic. Immediate negation or bid reduction required.`,
      action:"Negate exact on confirmed bleeders. For terms with 5–7 clicks no sales — reduce bid 30% first and monitor.",metric:"Wasted Spend",current:`$${waste.toFixed(0)}`});
  }

  const harvestable=metrics.filter(({m})=>m.cvr>3&&m.orders>=2&&m.acos>0&&m.acos<30);
  if(harvestable.length){
    insights.push({priority:"opportunity",icon:"ti-cut",title:`${harvestable.length} Harvest Opportunit${harvestable.length>1?"ies":"y"}`,
      explanation:`${harvestable.length} converting search terms with strong CVR haven't been isolated into exact match campaigns. Isolating them improves bid control, ranking, and conversion efficiency.`,
      action:"Create exact match targeting for these terms in a dedicated campaign. Add as negative exact in the source broad/auto campaign.",metric:"Harvestable Terms",current:String(harvestable.length)});
  }

  const scalers=metrics.filter(({m})=>m.cvr>4&&m.impressions<800&&m.orders>=2);
  if(scalers.length){
    insights.push({priority:"opportunity",icon:"ti-rocket",title:`${scalers.length} Scale Opportunit${scalers.length>1?"ies":"y"}`,
      explanation:`${scalers.length} terms have strong conversion rates but low impressions. These are under-bid winners — you're leaving profitable traffic on the table.`,
      action:"Increase bids by 20–30% on these terms. If in broad/auto, create an exact campaign and push budget there.",metric:"Scale Targets",current:String(scalers.length)});
  }

  const highCpc=metrics.filter(({m})=>m.cpc>3&&m.orders===0&&m.clicks>3);
  if(highCpc.length){
    const waste=highCpc.reduce((s,{m})=>s+m.spend,0);
    insights.push({priority:"warning",icon:"ti-coin",title:"CPC Inflation on Non-Converters",
      explanation:`${highCpc.length} terms have CPC above $3 with no conversions. High CPC non-converters are the fastest way to inflate ACoS. These may be broad-match leakage into competitive auctions.`,
      action:"Reduce bids by 40–50% on these terms. Consider match type restriction — move from broad to phrase or exact.",metric:"Wasted on High CPC",current:`$${waste.toFixed(0)}`});
  }

  const nonConverters=metrics.filter(({m})=>m.clicks>10&&m.orders===0&&m.spend>5);
  if(nonConverters.length>bleeders.length){
    insights.push({priority:"warning",icon:"ti-click",title:`${nonConverters.length} Click Traps Detected`,
      explanation:`${nonConverters.length} terms get consistent clicks but never convert. This typically signals irrelevant traffic, poor listing-keyword alignment, or pricing issues.`,
      action:"Review these terms against your listing. If not relevant — negate. If relevant but not converting — check listing quality and pricing.",metric:"Non-Converting",current:String(nonConverters.length)});
  }

  // CVR decline insight from comparison
  if(compMap&&Object.keys(compMap).length){
    const cvrDeclines=metrics.filter(({m,term})=>{
      const comp=compMap[term.toLowerCase()];
      return comp&&comp.cvr>0&&m.cvr<comp.cvr*(0.75)&&m.clicks>5;
    });
    if(cvrDeclines.length){
      insights.push({priority:"warning",icon:"ti-trending-down",title:`CVR Declined on ${cvrDeclines.length} Terms`,
        explanation:`${cvrDeclines.length} search terms show significant CVR decline vs previous period. Declining CVR means your listing relevance or competitive position has weakened for these queries.`,
        action:"Audit listing quality for top CVR decliners. Check if competitors have improved. Consider bid reduction until CVR recovers.",metric:"CVR Declines",current:String(cvrDeclines.length)});
    }
  }

  return insights.sort((a,b)=>{const o={critical:0,warning:1,opportunity:2};return(o[a.priority]??3)-(o[b.priority]??3);});
}

/* ── STR Upload Zone (must be outside STRUploadPhase to avoid hooks violation) ── */
function STRUploadZone({label,period,onFile,fileName}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(f);}}
      onClick={()=>ref.current?.click()}
      style={{border:`2px dashed ${drag||fileName?R:"#e0e0e0"}`,borderRadius:10,padding:"24px 16px",textAlign:"center",cursor:"pointer",background:fileName?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(e.target.files[0])}/>
      <div style={{width:40,height:40,borderRadius:9,background:"#fff",border:"1px solid #eee",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 10px"}}>
        <i className={`ti ${fileName?"ti-file-check":"ti-file-spreadsheet"}`} style={{fontSize:20,color:fileName?R:"#aaa"}}/>
      </div>
      <div style={{fontSize:13,fontWeight:600,color:"#111",marginBottom:3}}>{label}</div>
      <div style={{fontSize:11,color:"#888",marginBottom:10}}>{period?`${fmtDisp(period.start)} — ${fmtDisp(period.end)}`:"—"}</div>
      {fileName
        ?<div style={{fontSize:12,color:R,fontWeight:600}}><i className="ti ti-check"/> {fileName}</div>
        :<div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"6px 14px",borderRadius:7,background:R,color:"#fff",fontSize:12,fontWeight:500}}><i className="ti ti-upload" style={{fontSize:12}}/> Browse</div>}
    </div>
  );
}

/* ── STR Upload Phase ────────────────────────────────────────── */
function STRUploadPhase({periods,onComplete}){
  const[curFile,setCurFile]=useState(null);const[compFile,setCompFile]=useState(null);
  const[curName,setCurName]=useState(null);const[compName,setCompName]=useState(null);
  const[loading,setLoading]=useState(false);const[err,setErr]=useState(null);

  async function go(){
    if(!curFile)return;setLoading(true);setErr(null);
    try{
      const cur=await parseSheet(curFile);
      let comp=null;if(compFile)comp=await parseSheet(compFile);
      onComplete({cur,comp});
    }catch(e){setErr("Error: "+e.message);}
    setLoading(false);
  }

  return(
    <div style={{maxWidth:700,margin:"0 auto",padding:"32px 24px"}}>
      <div style={{marginBottom:24}}>
        <h2 style={{fontSize:21,fontWeight:700,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Search Term Intelligence</h2>
        <p style={{fontSize:13,color:"#666",margin:0}}>Upload your raw Amazon Search Term Report. No formatting needed — the system detects everything automatically.</p>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:16}}>
        <div><div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:8}}>Current Period <span style={{color:R}}>*</span></div>
          <STRUploadZone label="Current Period" period={periods?.current} onFile={f=>{setCurFile(f);setCurName(f.name);}} fileName={curName}/></div>
        <div><div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:8}}>Comparison Period <span style={{color:"#ccc"}}>(optional)</span></div>
          <STRUploadZone label="Comparison Period" period={periods?.comp} onFile={f=>{setCompFile(f);setCompName(f.name);}} fileName={compName}/></div>
      </div>
      <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"14px 16px",marginBottom:14}}>
        <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10}}>How to get your Search Term Report</div>
        {["Go to Amazon Advertising Console → Reports → Create Report","Select Report Type: Search Term Report","Set your date range and download the .xlsx file","Upload directly above — no formatting needed","Repeat for comparison period if you want trend analysis"].map((s,i)=>(
          <div key={i} style={{display:"flex",gap:10,marginBottom:7,alignItems:"flex-start"}}>
            <span style={{width:18,height:18,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span>
            <span style={{fontSize:12,color:"#555",lineHeight:1.6}}>{s}</span>
          </div>
        ))}
      </div>
      <div style={{padding:"10px 14px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:9}}>
        <i className="ti ti-info-circle" style={{fontSize:14,color:R,flexShrink:0,marginTop:1}}/>
        <div style={{fontSize:12,color:"#555",lineHeight:1.7}}>The system supports Sponsored Products, Sponsored Brands, and Sponsored Display search term reports. Upload once per ad type or a combined export.</div>
      </div>
      {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:7,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
      <div style={{display:"flex",justifyContent:"flex-end"}}>
        <button onClick={go} disabled={!curFile||loading} style={{...T.btnR(false),opacity:curFile&&!loading?1:0.4,boxShadow:curFile?"0 2px 8px rgba(79,70,229,0.3)":"none",fontWeight:700}}>
          {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-arrow-right" style={{fontSize:14}}/> Analyze Search Terms</>}
        </button>
      </div>
    </div>
  );
}

/* ── STR KPI Bar ─────────────────────────────────────────────── */
function STRKPIBar({cur,comp}){
  const defs=[
    {k:"spend",   label:"Total Spend",   fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(2)}`,   lb:true},
    {k:"sales",   label:"Total Sales",   fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(2)}`,   lb:false},
    {k:"orders",  label:"Orders",        fmt:v=>String(Math.round(v)),                                  lb:false},
    {k:"acos",    label:"ACoS",          fmt:v=>`${v.toFixed(1)}%`,                                    lb:true},
    {k:"cpc",     label:"Avg CPC",       fmt:v=>`$${v.toFixed(2)}`,                                    lb:true},
    {k:"cvr",     label:"CVR",           fmt:v=>`${v.toFixed(1)}%`,                                    lb:false},
    {k:"ctr",     label:"CTR",           fmt:v=>`${v.toFixed(2)}%`,                                    lb:false},
    {k:"roas",    label:"ROAS",          fmt:v=>v.toFixed(2),                                          lb:false},
    {k:"clicks",  label:"Clicks",        fmt:v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v)),lb:false},
    {k:"impressions",label:"Impressions",fmt:v=>v>=1e6?`${(v/1e6).toFixed(1)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v)),lb:false},
  ];
  return(
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",flexShrink:0,overflowX:"auto"}}>
      <div style={{display:"flex",minWidth:"max-content"}}>
        {defs.map((d,idx)=>{
          const cv=cur[d.k]||0;const pv=comp?comp[d.k]||0:null;
          const hasMComp=pv!=null;
          let pct=null,abs=null;
          if(hasMComp&&pv!==0){pct=((cv-pv)/Math.abs(pv))*100;abs=cv-pv;}
          const good=pct!=null?(d.lb?pct<=0:pct>=0):null;
          const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";
          const sign=v=>v>0?"+":"";
          return(
            <div key={d.k} style={{flex:"0 0 auto",minWidth:120,padding:"14px 18px",borderRight:idx<defs.length-1?"1px solid #f0f0f0":"none",borderBottom:`3px solid ${good===true?"#1a9e4a":good===false?"#d42b2b":"transparent"}`}}>
              <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:7}}>{d.label}</div>
              <div style={{fontSize:21,fontWeight:800,color:"#111",marginBottom:5,letterSpacing:"-0.5px",lineHeight:1}}>{d.fmt(cv)}</div>
              {comp&&pct!=null&&(
                <div>
                  <div style={{fontSize:12,fontWeight:700,color:dc,display:"flex",alignItems:"center",gap:3,marginBottom:1}}>
                    <i className={`ti ${good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:11}}/>
                    {sign(pct)}{Math.abs(pct).toFixed(1)}% <span style={{fontSize:10,color:"#ccc",fontWeight:400,marginLeft:2}}>vs prev</span>
                  </div>
                  {abs!=null&&<div style={{fontSize:10,color:dc,fontWeight:600}}>{sign(abs)}{d.fmt(Math.abs(abs))}</div>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ── STR Intelligence Brief ──────────────────────────────────── */
function STRBrief({insights}){
  const[expanded,setExpanded]=useState(null);
  if(!insights||!insights.length)return null;
  const pc={critical:"#d42b2b",warning:"#c47a00",opportunity:"#1a7a3c"};
  const pb={critical:"rgba(212,43,43,0.06)",warning:"rgba(196,122,0,0.06)",opportunity:"rgba(26,122,60,0.06)"};
  const pbr={critical:"rgba(212,43,43,0.2)",warning:"rgba(196,122,0,0.2)",opportunity:"rgba(26,122,60,0.2)"};
  return(
    <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
        <i className="ti ti-brain" style={{fontSize:14,color:R}}/>
        <div style={{fontSize:12,fontWeight:700,color:"#111"}}>Search Term Intelligence</div>
        <div style={{fontSize:11,color:"#888"}}>{insights.length} finding{insights.length!==1?"s":""}</div>
        <div style={{flex:1}}/>
        <div style={{fontSize:10,color:"#bbb",fontStyle:"italic"}}>Based on your uploaded data only</div>
      </div>
      <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:4}}>
        {insights.map((ins,i)=>{
          const isExp=expanded===i;
          return(
            <div key={i} onClick={()=>setExpanded(isExp?null:i)}
              style={{flexShrink:0,minWidth:190,maxWidth:270,padding:"10px 12px",borderRadius:9,border:`1px solid ${pbr[ins.priority]||"#eee"}`,background:pb[ins.priority]||"#fafafa",cursor:"pointer"}}>
              <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:5}}>
                <div style={{width:20,height:20,borderRadius:5,background:pb[ins.priority],display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${ins.icon}`} style={{fontSize:10,color:pc[ins.priority]||"#aaa"}}/>
                </div>
                <span style={{fontSize:9,fontWeight:800,color:pc[ins.priority]||"#aaa",textTransform:"uppercase",letterSpacing:"0.4px"}}>{ins.priority}</span>
                {ins.current&&<span style={{marginLeft:"auto",fontSize:12,fontWeight:700,color:pc[ins.priority]||"#aaa"}}>{ins.current}</span>}
              </div>
              <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:4,lineHeight:1.3}}>{ins.title}</div>
              {isExp&&(
                <div style={{marginTop:8,borderTop:"1px solid rgba(0,0,0,0.06)",paddingTop:8}}>
                  <div style={{fontSize:11,color:"#444",lineHeight:1.65,marginBottom:8}}>{ins.explanation}</div>
                  <div style={{padding:"7px 9px",background:"rgba(79,70,229,0.05)",borderRadius:6,border:"1px solid rgba(79,70,229,0.12)"}}>
                    <div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Action</div>
                    <div style={{fontSize:11,color:"#333",lineHeight:1.5,fontWeight:500}}>{ins.action}</div>
                  </div>
                </div>
              )}
              {!isExp&&<div style={{fontSize:9,color:"#bbb",marginTop:4}}>▼ tap for details</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ── STR Delta Cell (module-level to satisfy React rules) ───── */
function STRDeltaCell({cur,prev,fmt,lb,isPp}){
  const hasMC=prev!=null;
  const d=hasMC?cur-prev:null;
  const good=d===null?null:(lb?d<=0:d>=0);
  const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";
  const sign=v=>v>0?"+":"";
  return(
    <td style={{padding:"8px 10px",verticalAlign:"top"}}>
      <div style={{fontWeight:500,color:"#111",fontSize:12,lineHeight:1.4}}>{fmt(cur)}</div>
      {d!==null&&Math.abs(d)>0.001&&<div style={{fontSize:10,fontWeight:600,color:dc,marginTop:1}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}
    </td>
  );
}

/* ── STR Table ───────────────────────────────────────────────── */
function STRTable({rows,sm,compMap,periods}){
  const[search,setSearch]=useState("");
  const[clsFilter,setClsFilter]=useState("All");
  const[sortKey,setSortKey]=useState("priority");
  const[sortDir,setSortDir]=useState("asc");
  const[selRows,setSelRows]=useState(new Set());

  const CLS_ALL=["All","Bleeder","Waste","Irrelevant","Scale Opp.","Harvest","Ranking Term","Efficient","Monitor","Discovery","Defensive"];
  const PRIORITY_ORDER={Bleeder:0,Waste:1,Irrelevant:1,"Scale Opp.":2,Harvest:2,"Ranking Term":3,Efficient:4,Monitor:4,Discovery:5,Defensive:5};

  const processed=useMemo(()=>rows.map((r,i)=>{
    const m=strCalcMetrics(r,sm);
    const term=String(r[sm.searchTerm]||"");
    const cls=classifyTerm(m,term);
    const comp=compMap?compMap[term.toLowerCase()]||null:null;
    return{r,m,term,cls,comp,camp:String(r[sm.campaign]||""),mt:String(r[sm.matchType]||""),id:i};
  }),[rows,sm,compMap]);

  const filtered=useMemo(()=>{
    let d=processed;
    if(clsFilter!=="All")d=d.filter(x=>x.cls.cls===clsFilter);
    if(search){const q=search.toLowerCase();d=d.filter(x=>x.term.toLowerCase().includes(q)||x.camp.toLowerCase().includes(q));}
    return d;
  },[processed,clsFilter,search]);

  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{
    if(sortKey==="priority")return sortDir==="asc"?(PRIORITY_ORDER[a.cls.cls]??5)-(PRIORITY_ORDER[b.cls.cls]??5):(PRIORITY_ORDER[b.cls.cls]??5)-(PRIORITY_ORDER[a.cls.cls]??5);
    if(sortKey==="term")return sortDir==="asc"?a.term.localeCompare(b.term):b.term.localeCompare(a.term);
    const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;
    return sortDir==="asc"?va-vb:vb-va;
  }),[filtered,sortKey,sortDir]);

  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir("desc");}}
  function toggleAll(){if(selRows.size===sorted.length&&sorted.length>0)setSelRows(new Set());else setSelRows(new Set(sorted.map(x=>x.id)));}

  function exportNegations(){
    const neg=sorted.filter(x=>["Bleeder","Waste","Irrelevant"].includes(x.cls.cls));
    if(!neg.length){alert("No bleeders or irrelevant terms to negate.");return;}
    /* ── Amazon-ready bulk upload format ──────────────────────
       Entity: "Campaign Negative Keyword" (campaign level, applies to all ad groups)
       Match Type: "negativeExact" or "negativePhrase" (camelCase — Amazon is strict)
       Operation: "create"
       All other columns must exist but can be empty.
    ─────────────────────────────────────────────────────────── */
    const bulkRows=neg.map(x=>{
      const isExact=x.cls.cls==="Bleeder"||(x.m.spend>15&&x.m.orders===0);
      return amznBlankRow({
        "Product":"Sponsored Products",
        "Entity":"Campaign Negative Keyword",
        "Operation":"create",
        "Campaign Name":x.camp||"",
        "State":"enabled",
        "Keyword Text":x.term,
        "Match Type":isExact?"negativeExact":"negativePhrase",
      });
    });
    /* Sheet 1: Amazon bulk upload (ready to upload) */
    const ws1=XLSX.utils.json_to_sheet(bulkRows,{header:AMZN_SP_COLS});
    ws1["!cols"]=AMZN_SP_COLS.map(h=>({wch:["Campaign Name","Keyword Text"].includes(h)?30:14}));
    /* Sheet 2: Review sheet with full metrics */
    const reviewRows=neg.map(x=>({
      "Search Term":x.term,"Classification":x.cls.cls,
      "Spend ($)":x.m.spend.toFixed(2),"Clicks":x.m.clicks,"Orders":x.m.orders,
      "ACoS (%)":x.m.acos>0?x.m.acos.toFixed(1):"—",
      "Negation Type":x.cls.cls==="Bleeder"?"negativeExact":"negativePhrase",
      "Campaign":x.camp,"Match Type (Original)":x.mt,
      "Reasoning":x.cls.cls==="Bleeder"?"High spend zero orders — confirmed waste":"Irrelevant/low intent traffic"
    }));
    const ws2=XLSX.utils.json_to_sheet(reviewRows);
    ws2["!cols"]=[{wch:35},{wch:16},{wch:10},{wch:8},{wch:8},{wch:10},{wch:16},{wch:40},{wch:16},{wch:50}];
    const wb=XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb,ws1,"Sponsored Products Campaigns");
    XLSX.utils.book_append_sheet(wb,ws2,"Review — Do Not Upload");
    XLSX.writeFile(wb,"Amazon_Negations_Upload_"+new Date().toISOString().slice(0,10)+".xlsx");
  }

  function exportHarvest(){
    const harv=sorted.filter(x=>["Harvest","Scale Opp.","Ranking Term"].includes(x.cls.cls));
    if(!harv.length){alert("No harvest opportunities found.");return;}
    const wb=XLSX.utils.book_new();
    const ws=XLSX.utils.aoa_to_sheet([
      ["Search Term","Classification","Orders","CVR (%)","ACoS (%)","CPC ($)","Spend","Sales","Recommended Action","Source Campaign"],
      ...harv.map(x=>[x.term,x.cls.cls,x.m.orders,x.m.cvr.toFixed(1),x.m.acos.toFixed(1),x.m.cpc.toFixed(2),x.m.spend.toFixed(2),x.m.sales.toFixed(2),x.cls.cls==="Harvest"?"Isolate as Exact Match":x.cls.cls==="Scale Opp."?"Increase Bid 20-30%":"Create Ranking Campaign",x.camp])
    ]);
    ws["!cols"]=[{wch:35},{wch:16},{wch:8},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10},{wch:30},{wch:40}];
    XLSX.utils.book_append_sheet(wb,ws,"Harvest Opportunities");
    XLSX.writeFile(wb,"STR_Harvest_"+new Date().toISOString().slice(0,10)+".xlsx");
  }

  const fmtU=v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(2)}`;
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;

  const clsCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.cls.cls]=(m[x.cls.cls]||0)+1;});return m;},[processed]);

  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      {/* Toolbar */}
      <div style={{padding:"10px 20px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"7px 12px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:200}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search term or campaign…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        {/* Classification filter pills */}
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {CLS_ALL.map(cls=>{
            const count=cls==="All"?processed.length:clsCounts[cls]||0;
            if(cls!=="All"&&!count)return null;
            const active=clsFilter===cls;
            return(
              <button key={cls} onClick={()=>setClsFilter(cls)}
                style={{padding:"4px 10px",borderRadius:20,border:`1.5px solid ${active?R:"#e0e0e0"}`,background:active?R:"#fff",color:active?"#fff":"#555",fontSize:11,fontWeight:active?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>
                {cls} {count>0&&<span style={{opacity:0.7}}>({count})</span>}
              </button>
            );
          })}
        </div>
        <div style={{flex:1}}/>
        <span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> terms</span>
        <button onClick={exportNegations} style={{...T.btnG(true)}}><i className="ti ti-ban" style={{fontSize:12}}/> Negation Sheet</button>
        <button onClick={exportHarvest} style={{...T.btnG(true)}}><i className="ti ti-cut" style={{fontSize:12}}/> Harvest Sheet</button>
      </div>

      {/* Table */}
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr>
              <th style={{...thS,width:36,cursor:"default"}}><input type="checkbox" checked={selRows.size===sorted.length&&sorted.length>0} onChange={toggleAll} style={{accentColor:R,cursor:"pointer"}}/></th>
              <th style={thS} onClick={()=>toggleSort("priority")}>Class <SI col="priority"/></th>
              <th style={thS} onClick={()=>toggleSort("term")}>Search Term <SI col="term"/></th>
              <th style={{...thS,cursor:"default"}}>Campaign</th>
              <th style={{...thS,cursor:"default"}}>Match</th>
              <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
              <th style={thS} onClick={()=>toggleSort("sales")}>Sales <SI col="sales"/></th>
              <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
              <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
              <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
              <th style={thS} onClick={()=>toggleSort("cpc")}>CPC <SI col="cpc"/></th>
              <th style={thS} onClick={()=>toggleSort("clicks")}>Clicks <SI col="clicks"/></th>
              <th style={thS} onClick={()=>toggleSort("impressions")}>Impr. <SI col="impressions"/></th>
              <th style={thS} onClick={()=>toggleSort("ctr")}>CTR <SI col="ctr"/></th>
            </tr>
          </thead>
          <tbody>
            {sorted.map(({r,m,term,cls,comp,camp,mt,id},i)=>{
              const isSel=selRows.has(id);
              const mtle=mt.toLowerCase();
              const mtColor=mtle==="exact"?"#1a7a3c":mtle==="broad"?"#7a5200":mtle==="phrase"?"#1a50a0":"#888";
              const mtBg=mtle==="exact"?"rgba(26,122,60,0.09)":mtle==="broad"?"rgba(122,82,0,0.09)":mtle==="phrase"?"rgba(26,80,160,0.09)":"#f0f0f0";
              const rowBg=isSel?"rgba(79,70,229,0.04)":i%2===0?"#fff":"#fafafa";
              // StrDelta is defined at module level as STRDeltaCell
              return(
                <tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:rowBg}}>
                  <td style={{padding:"8px 10px"}}><input type="checkbox" checked={isSel} onChange={()=>setSelRows(s=>{const n=new Set(s);n.has(id)?n.delete(id):n.add(id);return n;})} style={{accentColor:R}}/></td>
                  <td style={{padding:"6px 10px"}}>
                    <div style={{display:"inline-flex",alignItems:"center",gap:4,padding:"3px 7px",borderRadius:5,background:cls.bg,border:`1px solid ${cls.color}22`}}>
                      <i className={`ti ${cls.icon}`} style={{fontSize:9,color:cls.color}}/>
                      <span style={{fontSize:9,fontWeight:700,color:cls.color,whiteSpace:"nowrap"}}>{cls.cls}</span>
                    </div>
                  </td>
                  <td style={{padding:"8px 10px",maxWidth:220,fontWeight:600,color:"#111",fontSize:12}} title={term}>
                    <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{term||"—"}</div>
                  </td>
                  <td style={{padding:"8px 10px",maxWidth:150,color:"#888",fontSize:11}} title={camp}>
                    <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{camp||"—"}</div>
                  </td>
                  <td style={{padding:"8px 10px"}}>{mt?<span style={{padding:"2px 7px",borderRadius:5,fontSize:10,fontWeight:700,background:mtBg,color:mtColor}}>{mt}</span>:"-"}</td>
                  <STRDeltaCell cur={m.spend} prev={comp?.spend} fmt={fmtU} lb={true}/>
                  <STRDeltaCell cur={m.sales} prev={comp?.sales} fmt={fmtU} lb={false}/>
                  <td style={{padding:"8px 10px",fontWeight:600,color:m.acos>50?"#d42b2b":m.acos>30?"#c47a00":"#111",fontSize:12,verticalAlign:"top"}}>
                    <div>{m.spend>0?(m.acos>0?`${m.acos.toFixed(1)}%`:(m.sales>0?"0.0%":"—")):"-"}</div>
                    {comp!=null&&(()=>{const d=m.acos-(comp.acos||0);if(Math.abs(d)<0.01)return null;return<div style={{fontSize:10,fontWeight:600,color:d<0?"#1a9e4a":"#d42b2b",marginTop:1}}>{d>0?"+":""}{d.toFixed(1)}pp</div>;})()}
                  </td>
                  <STRDeltaCell cur={m.orders} prev={comp?.orders} fmt={v=>String(Math.round(v))} lb={false}/>
                  <STRDeltaCell cur={m.cvr} prev={comp?.cvr} fmt={v=>`${v.toFixed(1)}%`} lb={false} isPp={true}/>
                  <STRDeltaCell cur={m.cpc} prev={comp?.cpc} fmt={v=>`$${v.toFixed(2)}`} lb={true}/>
                  <STRDeltaCell cur={m.clicks} prev={comp?.clicks} fmt={v=>String(Math.round(v))} lb={false}/>
                  <STRDeltaCell cur={m.impressions} prev={comp?.impressions} fmt={v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))} lb={false}/>
                  <STRDeltaCell cur={m.ctr} prev={comp?.ctr} fmt={v=>`${v.toFixed(2)}%`} lb={false} isPp={true}/>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"60px 0",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:36,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500,marginBottom:4}}>No search terms match</div><div style={{fontSize:12}}>Try a different filter or search</div></div>}
      </div>
    </div>
  );
}

/* ── Search Term Intelligence Root ───────────────────────────── */
/* ================================================================
   MODULE OVERVIEW — Universal first-tab overview component
   Used by all data-driven modules as the first tab.
   Shows: KPIs, comparison, wins, losses, alerts, top opportunities.
================================================================ */

/* ── Delta badge: shows +/- vs previous period ── */
function Delta({cur, prev, fmt='pct', invert=false, small=false}){
  if(prev==null||prev===0) return null;
  const pct=((cur-prev)/Math.abs(prev))*100;
  const good = invert ? pct<0 : pct>0;
  const color = good ? '#1a7a3c' : '#d42b2b';
  const bg    = good ? 'rgba(26,122,60,0.1)' : 'rgba(212,43,43,0.08)';
  const label = fmt==='abs'
    ? `${pct>=0?'+':''}${(cur-prev).toFixed(2)}`
    : `${pct>=0?'+':''}${pct.toFixed(1)}%`;
  return(
    <span style={{fontSize:small?9:10,fontWeight:700,color,background:bg,padding:'1px 6px',borderRadius:8,marginLeft:5}}>
      {label}
    </span>
  );
}

/* ── Single KPI card ── */
function OvKPI({label, value, prev, fmt='dollar', invert=false, icon, color='#111'}){
  const fmtVal = (v) => {
    if(v==null) return '—';
    if(fmt==='dollar')  return `$${v>=1000?(v/1000).toFixed(1)+'K':v.toFixed(2)}`;
    if(fmt==='pct')     return `${v.toFixed(1)}%`;
    if(fmt==='int')     return v>=1000?(v/1000).toFixed(1)+'K':Math.round(v).toString();
    if(fmt==='x')       return `${v.toFixed(2)}x`;
    return v;
  };
  return(
    <div style={{background:'#fff',borderRadius:11,border:'1px solid #f0f0f0',padding:'13px 15px',boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
      <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:6}}>
        <i className={`ti ${icon}`} style={{fontSize:12,color,flexShrink:0}}/>
        <span style={{fontSize:10,color:'#888',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.4px'}}>{label}</span>
      </div>
      <div style={{display:'flex',alignItems:'baseline',gap:4,flexWrap:'wrap'}}>
        <span style={{fontSize:20,fontWeight:800,color:'#111',letterSpacing:'-0.5px'}}>{fmtVal(value)}</span>
        {prev!=null&&<Delta cur={value} prev={prev} fmt='pct' invert={invert}/>}
      </div>
      {prev!=null&&<div style={{fontSize:10,color:'#bbb',marginTop:3}}>prev: {fmtVal(prev)}</div>}
    </div>
  );
}

/* ── Win / Loss card ── */
function OvAlert({type, icon, title, value, detail, action}){
  const isWin = type==='win';
  const color  = isWin ? '#1a7a3c' : type==='critical' ? '#d42b2b' : '#c47a00';
  const bg     = isWin ? 'rgba(26,122,60,0.05)' : type==='critical' ? 'rgba(212,43,43,0.04)' : 'rgba(196,122,0,0.05)';
  const border = isWin ? 'rgba(26,122,60,0.2)' : type==='critical' ? 'rgba(212,43,43,0.2)' : 'rgba(196,122,0,0.2)';
  return(
    <div style={{padding:'11px 14px',borderRadius:9,background:bg,border:`1px solid ${border}`,display:'flex',alignItems:'flex-start',gap:10}}>
      <div style={{width:28,height:28,borderRadius:8,background:color,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:1}}>
        <i className={`ti ${icon}`} style={{fontSize:12,color:'#fff'}}/>
      </div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:12,fontWeight:700,color:'#111',marginBottom:2}}>{title}</div>
        {value&&<div style={{fontSize:13,fontWeight:800,color,marginBottom:2}}>{value}</div>}
        <div style={{fontSize:11,color:'#555',lineHeight:1.6}}>{detail}</div>
        {action&&<div style={{fontSize:10,color,fontWeight:700,marginTop:4}}>→ {action}</div>}
      </div>
    </div>
  );
}

/* ── ModuleOverview: main component ── */
function ModuleOverview({
  moduleName,
  moduleIcon,
  periods,
  cur,           // {spend,sales,acos,orders,clicks,impressions,cvr,cpc,roas,ctr}
  comp,          // same shape, previous period (null if no comparison)
  rows=[],       // raw rows for drill-down stats
  alerts=[],     // [{type:'win'|'loss'|'critical', icon, title, value, detail, action}]
  extraKpis=[],  // [{label, value, prev, fmt, invert, icon, color}]
  onGoToTab,     // fn(tabName) to navigate
  customSection  // optional JSX for module-specific content
}){
  const hasComp = comp!=null && (comp.spend>0||comp.sales>0);

  /* Build default KPI set */
  const kpis = [
    {label:'Total Spend',    value:cur?.spend,    prev:comp?.spend,    fmt:'dollar',  invert:false, icon:'ti-credit-card',   color:'#4f46e5'},
    {label:'Total Sales',    value:cur?.sales,    prev:comp?.sales,    fmt:'dollar',  invert:false, icon:'ti-chart-bar',     color:'#1a7a3c'},
    {label:'ACoS',           value:cur?.acos,     prev:comp?.acos,     fmt:'pct',     invert:true,  icon:'ti-percentage',    color:'#c47a00'},
    {label:'ROAS',           value:cur?.roas,     prev:comp?.roas,     fmt:'x',       invert:false, icon:'ti-multiplier-2x', color:'#6338c8'},
    {label:'Orders',         value:cur?.orders,   prev:comp?.orders,   fmt:'int',     invert:false, icon:'ti-shopping-cart', color:'#1a5fa0'},
    {label:'CVR',            value:cur?.cvr,      prev:comp?.cvr,      fmt:'pct',     invert:false, icon:'ti-target',        color:'#1a7a3c'},
    {label:'CPC',            value:cur?.cpc,      prev:comp?.cpc,      fmt:'dollar',  invert:true,  icon:'ti-coin',          color:'#555'},
    {label:'Clicks',         value:cur?.clicks,   prev:comp?.clicks,   fmt:'int',     invert:false, icon:'ti-cursor-text',   color:'#888'},
    ...extraKpis,
  ].filter(k=>k.value!=null&&k.value!==0);

  /* Auto-generate win/loss alerts from comparison */
  const autoAlerts = [];
  if(hasComp && cur && comp){
    if(comp.acos>0 && cur.acos>0){
      const acosChg = ((cur.acos - comp.acos)/comp.acos)*100;
      if(acosChg < -5) autoAlerts.push({type:'win',   icon:'ti-trending-down', title:'ACoS Improved',      value:`${cur.acos.toFixed(1)}%`, detail:`Down ${Math.abs(acosChg).toFixed(1)}% vs previous period`,       action:'Keep scaling — bids are working'});
      if(acosChg >  8) autoAlerts.push({type:'critical',icon:'ti-trending-up', title:'ACoS Increased',     value:`${cur.acos.toFixed(1)}%`, detail:`Up ${acosChg.toFixed(1)}% vs previous — urgently review bids`,    action:'Check Bids Optimizer'});
    }
    if(comp.sales>0){
      const salChg = ((cur.sales-comp.sales)/comp.sales)*100;
      if(salChg>10)  autoAlerts.push({type:'win',      icon:'ti-arrow-up-right', title:'Sales Growing',    value:`$${cur.sales.toFixed(0)}`, detail:`+${salChg.toFixed(1)}% vs previous period`,                      action:'Identify top campaigns and scale'});
      if(salChg<-10) autoAlerts.push({type:'critical',  icon:'ti-arrow-down-right','title':'Sales Dropped', value:`$${cur.sales.toFixed(0)}`, detail:`${salChg.toFixed(1)}% vs previous — investigate immediately`,    action:'Check Campaign Health'});
    }
    if(comp.spend>0){
      const cpcChg = comp.cpc>0 ? ((cur.cpc-comp.cpc)/comp.cpc)*100 : 0;
      if(cpcChg > 15) autoAlerts.push({type:'loss',    icon:'ti-coin', title:'CPC Rising',               value:`$${cur.cpc?.toFixed(2)||'—'}`, detail:`Up ${cpcChg.toFixed(1)}% — competition increasing or bids too aggressive`, action:'Review Bids Optimizer'});
    }
    if(comp.orders>0){
      const cvrChg = ((cur.cvr-comp.cvr)/comp.cvr)*100;
      if(cvrChg > 10) autoAlerts.push({type:'win',    icon:'ti-target', title:'CVR Improving',            value:`${cur.cvr?.toFixed(1)}%`, detail:`+${cvrChg.toFixed(1)}% conversion rate — listing or targeting improving`, action:'Harvest converting terms'});
      if(cvrChg < -10)autoAlerts.push({type:'loss',   icon:'ti-target', title:'CVR Dropped',              value:`${cur.cvr?.toFixed(1)}%`, detail:`${cvrChg.toFixed(1)}% — check listing quality or keyword relevance`, action:'Review Listing Conversion'});
    }
  }

  const allAlerts = [...alerts, ...autoAlerts];
  const wins      = allAlerts.filter(a=>a.type==='win');
  const issues    = allAlerts.filter(a=>a.type!=='win');

  return(
    <div style={{flex:1,overflowY:'auto',background:'#f7f7f7'}}>
      <div style={{maxWidth:1100,margin:'0 auto',padding:'16px 20px'}}>

        {/* ── Period summary bar ── */}
        {periods&&(
          <div style={{background:'#fff',borderRadius:10,border:'1px solid #f0f0f0',padding:'10px 16px',marginBottom:14,display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
            <i className={`ti ${moduleIcon||'ti-chart-bar'}`} style={{fontSize:14,color:R}}/>
            <div style={{fontSize:13,fontWeight:700,color:'#111'}}>{moduleName} — Overview</div>
            <div style={{fontSize:11,color:'#555',padding:'2px 10px',borderRadius:6,background:'rgba(79,70,229,0.06)',fontWeight:600}}>
              {periods?.current?.start} → {periods?.current?.end}
            </div>
            {hasComp&&<div style={{fontSize:11,color:'#888'}}>vs {periods?.comp?.start} → {periods?.comp?.end}</div>}
            {!hasComp&&<div style={{fontSize:10,color:'#aaa',fontStyle:'italic'}}>Upload comparison period for delta metrics</div>}
            <div style={{flex:1}}/>
            <div style={{fontSize:11,color:'#aaa'}}>{rows.length.toLocaleString()} rows analysed</div>
          </div>
        )}

        {/* ── KPI grid ── */}
        {kpis.length>0&&(
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:14}}>
            {kpis.map((k,i)=><OvKPI key={i} {...k}/>)}
          </div>
        )}

        {/* ── Wins + Issues columns ── */}
        {allAlerts.length>0&&(
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
            {/* Wins */}
            <div style={{background:'#fff',borderRadius:11,border:'1px solid #f0f0f0',padding:'14px 16px',boxShadow:'0 1px 4px rgba(0,0,0,0.03)'}}>
              <div style={{fontSize:12,fontWeight:800,color:'#1a7a3c',marginBottom:10,display:'flex',alignItems:'center',gap:7}}>
                <i className="ti ti-trending-up" style={{fontSize:13}}/> Wins ({wins.length})
              </div>
              {wins.length>0
                ? wins.map((a,i)=><div key={i} style={{marginBottom:i<wins.length-1?8:0}}><OvAlert {...a}/></div>)
                : <div style={{fontSize:11,color:'#bbb',fontStyle:'italic'}}>No wins detected vs previous period</div>}
            </div>
            {/* Issues */}
            <div style={{background:'#fff',borderRadius:11,border:'1px solid #f0f0f0',padding:'14px 16px',boxShadow:'0 1px 4px rgba(0,0,0,0.03)'}}>
              <div style={{fontSize:12,fontWeight:800,color:'#d42b2b',marginBottom:10,display:'flex',alignItems:'center',gap:7}}>
                <i className="ti ti-alert-triangle" style={{fontSize:13}}/> Issues ({issues.length})
              </div>
              {issues.length>0
                ? issues.map((a,i)=><div key={i} style={{marginBottom:i<issues.length-1?8:0}}><OvAlert {...a}/></div>)
                : <div style={{fontSize:11,color:'#bbb',fontStyle:'italic'}}>No critical issues detected</div>}
            </div>
          </div>
        )}

        {/* ── Custom module section ── */}
        {customSection}

        {/* ── No data placeholder ── */}
        {kpis.length===0&&allAlerts.length===0&&(
          <div style={{textAlign:'center',padding:'60px 20px',color:'#aaa'}}>
            <i className="ti ti-chart-bar" style={{fontSize:40,display:'block',marginBottom:12}}/>
            <div style={{fontSize:15,fontWeight:700,color:'#555',marginBottom:6}}>No data to overview</div>
            <div style={{fontSize:12}}>Upload your reports to see the full overview</div>
          </div>
        )}
      </div>
    </div>
  );
}

function SearchTermModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.primary?"workspace":"dates");
  const[periods,setPeriods]=useState(globalData?.periods||null);
  const[curData,setCurData]=useState(globalData?.cur?.primary||null);
  const[compData,setCompData]=useState(globalData?.comp?.primary||null);
  useEffect(()=>{if(globalData?.cur?.primary&&page==="dates"){setCurData(globalData.cur.primary);setCompData(globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);

  const sm=useMemo(()=>curData?strDetectMap(curData.headers):{},[curData]);
  const compMap=useMemo(()=>{
    if(!compData)return null;
    const csm=strDetectMap(compData.headers);
    const m={};
    compData.rows.forEach(r=>{
      const term=String(r[csm.searchTerm]||"").trim().toLowerCase();
      if(term)m[term]=strCalcMetrics(r,csm);
    });
    return m;
  },[compData]);

  const curAgg=useMemo(()=>curData?strAgg(curData.rows,sm):{},[curData,sm]);
  const compAgg=useMemo(()=>{
    if(!compData)return null;
    const csm=strDetectMap(compData.headers);
    return strAgg(compData.rows,csm);
  },[compData]);

  const insights=useMemo(()=>curData?generateSTRInsights(curData.rows,sm,compMap):[],[curData,sm,compMap]);

  // ALL hooks must be before ANY early return
  const strAlerts=useMemo(()=>{
    if(!curData)return[];
    const al=[];
    const rows=curData.rows||[];
    const bleeders=rows.filter(r=>{const m=strCalcMetrics(r,sm);return m.spend>15&&m.orders===0;});
    const waste=bleeders.reduce((s,r)=>s+strCalcMetrics(r,sm).spend,0);
    const topConv=rows.filter(r=>{const m=strCalcMetrics(r,sm);return m.orders>=3&&m.acos>0&&m.acos<25;});
    const scaleOpps=rows.filter(r=>{const m=strCalcMetrics(r,sm);return m.cvr>4&&m.impressions<2000&&m.orders>=2;});
    if(bleeders.length)al.push({type:"critical",icon:"ti-droplet-off",title:`${bleeders.length} Bleeding Terms`,value:`$${waste.toFixed(0)} wasted`,detail:"Spending with zero conversions — immediate negation needed.",action:"Go to full analysis to export negations"});
    if(topConv.length)al.push({type:"win",icon:"ti-star",title:`${topConv.length} Converting Terms`,value:`${topConv.length} terms`,detail:"Hitting <25% ACoS with 3+ orders — your best keywords.",action:"Harvest to Exact match campaigns"});
    if(scaleOpps.length)al.push({type:"win",icon:"ti-rocket",title:`${scaleOpps.length} Scale Opportunities`,value:`CVR >4%`,detail:"High CVR but low impressions — increase bids to unlock volume.",action:"Raise bids in Bids Optimizer"});
    return al;
  },[curData,sm]);

  const[strView,setStrView]=useState("overview");

  if(page==="dates")return(
    <div style={{flex:1,overflowY:"auto"}}>
      <DateRangePicker onConfirm={p=>{setPeriods(p);setPage("upload");}}/>
    </div>
  );

  if(page==="upload")return(
    <div style={{flex:1,overflowY:"auto"}}>
      <div style={{padding:"12px 20px 0",maxWidth:700,margin:"0 auto"}}>
        <button onClick={()=>setPage("dates")} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",background:"transparent",cursor:"pointer",color:"#555",fontSize:12}}><i className="ti ti-arrow-left" style={{fontSize:12}}/> Back to Date Selection</button>
      </div>
      <STRUploadPhase periods={periods} onComplete={({cur,comp})=>{setCurData(cur);setCompData(comp||null);setPage("dashboard");}}/>
    </div>
  );

  // Dashboard
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {/* Header */}
      <div style={{padding:"12px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:2}}>
            <h2 style={{margin:0,fontSize:16,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Search Term Intelligence</h2>
            <span style={{fontSize:10,padding:"2px 8px",borderRadius:20,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>STR</span>
          </div>
          <div style={{fontSize:11,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span>
            <span>{curData?.rows?.length||0} terms</span>
          </div>
        </div>
        <button onClick={()=>setPage("upload")} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:12,cursor:"pointer"}}>
          <i className="ti ti-upload" style={{fontSize:12}}/> Re-upload
        </button>
      </div>

      {/* Tab bar */}
      <div style={{display:"flex",gap:0,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0}}>
        {[{k:"overview",label:"Overview",icon:"ti-layout-dashboard"},{k:"analysis",label:"Full Analysis",icon:"ti-table"},{k:"alerts",label:"Alerts",icon:"ti-bell",badge:strAlerts.filter(a=>a.type==="critical").length||null}].map(t=>(
          <button key={t.k} onClick={()=>setStrView(t.k)} style={{display:"flex",alignItems:"center",gap:6,padding:"9px 14px",border:"none",borderBottom:`2px solid ${strView===t.k?R:"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:strView===t.k?700:500,color:strView===t.k?R:"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:12}}/>{t.label}
            {t.badge>0&&<span style={{fontSize:9,padding:"1px 5px",borderRadius:8,background:"#d42b2b",color:"#fff",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      {/* Content */}
      {strView==="overview"&&(
        <ModuleOverview
          moduleName="Search Term Intel"
          moduleIcon="ti-search"
          periods={periods}
          cur={curAgg}
          comp={compAgg}
          rows={curData?.rows||[]}
          alerts={strAlerts}
          onGoToTab={setStrView}
          customSection={Object.keys(curAgg).length>0&&<STRKPIBar cur={curAgg} comp={compAgg}/>}
        />
      )}
      {strView==="analysis"&&<STRTable rows={curData?.rows||[]} sm={sm} compMap={compMap} periods={periods}/>}
      {strView==="alerts"&&(
        <div style={{flex:1,overflowY:"auto",padding:"16px 20px",background:"#f7f7f7"}}>
          <STRBrief insights={insights}/>
        </div>
      )}
    </div>
  );
}

/* ================================================================
   PRIORITY ACTION CENTER MODULE
   Strategist command center — critical alerts, ranked actions,
   scaling opportunities, AI summary, performance movement.
   Strict scope: upload + daily action center only.
================================================================ */

/* ── Supported report types ─────────────────────────────────── */
const AC_REPORT_TYPES=[
  {id:"campaign",   label:"Campaign Report",        icon:"ti-speakerphone",   required:true,  desc:"Spend, sales, ACoS, impressions by campaign"},
  {id:"searchterm", label:"Search Term Report",      icon:"ti-search",         required:false, desc:"Query-level performance data"},
  {id:"placement",  label:"Placement Report",        icon:"ti-layout-2",       required:false, desc:"TOS, PP and rest of search breakdown"},
  {id:"advertised", label:"Advertised Product Report",icon:"ti-box",           required:false, desc:"ASIN-level performance data"},
  {id:"business",   label:"Business Report",         icon:"ti-chart-bar",      required:false, desc:"Organic + total sales for TACOS calculation"},
];

/* ── Column aliases for Campaign Report ─────────────────────── */
const AC_CAMP_ALIASES={
  campaign:   ["Campaign Name","Campaign","campaign name"],
  adType:     ["Campaign Type","Ad Type","Portfolio Type"],
  state:      ["Campaign State","State","Status"],
  budget:     ["Daily Budget","Budget","budget"],
  impressions:["Impressions","impressions"],
  clicks:     ["Clicks","clicks"],
  spend:      ["Spend","Cost","Ad Spend"],
  sales:      ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales","Attributed Sales 7d"],
  orders:     ["Orders","14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)"],
  acos:       ["ACOS","ACoS","Advertising Cost of Sales"],
  roas:       ["ROAS","Return on Ad Spend"],
  cpc:        ["CPC","Cost Per Click","Average CPC"],
  ctr:        ["Click-through Rate","CTR"],
  cvr:        ["Conversion Rate","CVR"],
};

function acDetectMap(headers){
  const r={};
  for(const[k,cands] of Object.entries(AC_CAMP_ALIASES)){
    for(const cand of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===cand.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const cand of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(cand.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function acGetNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function acCalcRow(row,cm){
  const imp=acGetNum(row,cm.impressions),clk=acGetNum(row,cm.clicks),
    spd=acGetNum(row,cm.spend),sal=acGetNum(row,cm.sales),ord=acGetNum(row,cm.orders);
  const ctr=cm.ctr&&acGetNum(row,cm.ctr)>0?acGetNum(row,cm.ctr):imp>0?(clk/imp)*100:0;
  const acos=cm.acos&&acGetNum(row,cm.acos)>0?acGetNum(row,cm.acos):sal>0?(spd/sal)*100:0;
  const roas=sal>0&&spd>0?sal/spd:0;
  const cvr=cm.cvr&&acGetNum(row,cm.cvr)>0?acGetNum(row,cm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=clk>0?spd/clk:0;
  const budget=acGetNum(row,cm.budget);
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,ctr,acos,roas,cvr,cpc,budget,
    campaign:String(row[cm.campaign]||""),state:String(row[cm.state]||"").toLowerCase()};
}

function acSumAgg(rows,cm){
  let imp=0,clk=0,spd=0,sal=0,ord=0;
  rows.forEach(r=>{const m=acCalcRow(r,cm);imp+=m.impressions;clk+=m.clicks;spd+=m.spend;sal+=m.sales;ord+=m.orders;});
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    acos:sal>0?(spd/sal)*100:0,ctr:imp>0?(clk/imp)*100:0,
    cvr:clk>0?(ord/clk)*100:0,cpc:clk>0?spd/clk:0,roas:spd>0?sal/spd:0};
}

/* ── Priority engine for campaigns ─────────────────────────── */
function acPrioritize(rows,cm,compMap){
  const alerts=[];
  const actions=[];
  const opportunities=[];

  rows.forEach(row=>{
    const m=acCalcRow(row,cm);
    const name=m.campaign;
    const comp=compMap?compMap[name.toLowerCase()]||null:null;
    if(!name||m.spend===0)return;

    /* ── CRITICAL ALERTS ── */
    // Budget exhausted (spend = budget)
    if(m.budget>0&&m.spend>=m.budget*0.98){
      alerts.push({severity:"critical",icon:"ti-coin",color:"#d42b2b",
        title:"Budget Cap Hit",entity:name,
        issue:`Campaign reached daily budget limit — impressions are being throttled`,
        compNote:comp?`Spend +${(((m.spend-comp.spend)/Math.max(comp.spend,0.01))*100).toFixed(0)}% vs prev period`:null,
        impact:`Estimated lost impressions: ${Math.round(m.impressions*0.15).toLocaleString()}+`,
        action:"Increase daily budget by 20–30% or redistribute from low-performing campaigns",
        confidence:95});
    }

    // CPC spike >30%
    if(comp&&comp.cpc>0&&m.cpc>comp.cpc*1.30&&m.clicks>20){
      const cpcp=((m.cpc-comp.cpc)/comp.cpc)*100;
      alerts.push({severity:"critical",icon:"ti-trending-up",color:"#d42b2b",
        title:"CPC Spike Detected",entity:name,
        issue:`CPC increased ${cpcp.toFixed(0)}% vs previous period — auction becoming more expensive`,
        compNote:`$${comp.cpc.toFixed(2)} → $${m.cpc.toFixed(2)}`,
        impact:`Extra spend: $${((m.cpc-comp.cpc)*m.clicks).toFixed(0)} this period`,
        action:"Tighten match types, review negative keywords, audit broad-match terms",
        confidence:88});
    }

    // CVR collapse >25%
    if(comp&&comp.cvr>0&&m.cvr<comp.cvr*0.75&&m.clicks>30){
      const cvrp=((m.cvr-comp.cvr)/comp.cvr)*100;
      alerts.push({severity:"critical",icon:"ti-chart-line-down",color:"#d42b2b",
        title:"CVR Collapse",entity:name,
        issue:`Conversion rate dropped ${Math.abs(cvrp).toFixed(0)}% — same traffic, fewer conversions`,
        compNote:`${comp.cvr.toFixed(1)}% → ${m.cvr.toFixed(1)}%`,
        impact:`Estimated missed orders: ${Math.round(m.clicks*(comp.cvr-m.cvr)/100)}`,
        action:"Audit listing quality, pricing vs competitors, check if ASIN got suppressed",
        confidence:91});
    }

    // Spend spike with high ACoS
    if(comp&&comp.spend>0&&m.spend>comp.spend*1.4&&m.acos>45){
      const spp=((m.spend-comp.spend)/comp.spend)*100;
      alerts.push({severity:"high",icon:"ti-alert-triangle",color:"#c47a00",
        title:"Spend Spike + High ACoS",entity:name,
        issue:`Spend up ${spp.toFixed(0)}% while ACoS is ${m.acos.toFixed(1)}% — unprofitable scaling`,
        compNote:`$${comp.spend.toFixed(0)} → $${m.spend.toFixed(0)} spend`,
        impact:`Estimated over-spend: $${((m.spend-comp.spend)*(m.acos/100)).toFixed(0)}`,
        action:"Reduce bids on top spending keywords. Set ACoS targets before increasing budgets",
        confidence:85});
    }

    /* ── PRIORITY ACTIONS ── */
    // High ACoS campaign
    if(m.acos>40&&m.acos<80&&m.spend>20&&m.orders>0){
      actions.push({priority:"high",icon:"ti-adjustments",color:"#c47a00",
        title:"Reduce ACoS",entity:name,
        reason:`ACoS at ${m.acos.toFixed(1)}% — above profitable threshold`,
        comparison:comp?`${comp.acos.toFixed(1)}% → ${m.acos.toFixed(1)}% (${((m.acos-comp.acos)>0?"+":"")}${(m.acos-comp.acos).toFixed(1)}pp)`:null,
        action:"Lower bids on keywords with ACoS > 40% by 10–15%. Pause zero-converting terms",
        confidence:90,impact:`Potential ACoS reduction: ${(m.acos-35).toFixed(0)}pp if top bleeders addressed`});
    }

    // Critical ACoS
    if(m.acos>=80&&m.spend>10){
      actions.push({priority:"critical",icon:"ti-flame",color:"#d42b2b",
        title:"Critical ACoS — Immediate Action",entity:name,
        reason:`ACoS at ${m.acos.toFixed(1)}% — severely unprofitable`,
        comparison:comp?`Prev: ${comp.acos.toFixed(1)}% → Now: ${m.acos.toFixed(1)}%`:null,
        action:"Pause this campaign or cut bids by 30–40% immediately. Review match types",
        confidence:95,impact:`$${(m.spend*(1-35/m.acos)).toFixed(0)} recoverable if ACoS normalized to 35%`});
    }

    // Zero sales spend
    if(m.spend>30&&m.orders===0){
      actions.push({priority:"critical",icon:"ti-droplet-off",color:"#d42b2b",
        title:"Spend With Zero Sales",entity:name,
        reason:`$${m.spend.toFixed(0)} spent with zero conversions this period`,
        comparison:comp?`Prev period had ${comp.orders} orders`:null,
        action:"Pause or reduce budget immediately. Audit search terms for irrelevant traffic",
        confidence:98,impact:`$${m.spend.toFixed(0)} fully recoverable`});
    }

    // Impression decline + has history
    if(comp&&comp.impressions>500&&m.impressions<comp.impressions*0.6&&m.orders>0){
      const imp_p=((m.impressions-comp.impressions)/comp.impressions)*100;
      actions.push({priority:"high",icon:"ti-eye-off",color:"#c47a00",
        title:"Visibility Declined",entity:name,
        reason:`Impressions dropped ${Math.abs(imp_p).toFixed(0)}% — losing auction coverage`,
        comparison:`${(comp.impressions/1000).toFixed(1)}K → ${(m.impressions/1000).toFixed(1)}K impressions`,
        action:"Increase bids on converting keywords by 15–20%. Check budget caps",
        confidence:82,impact:`${Math.round((comp.impressions-m.impressions)*m.cvr/100)} estimated missed orders`});
    }

    /* ── SCALING OPPORTUNITIES ── */
    // Low ACoS, low impression share — scale candidate
    if(m.acos>0&&m.acos<22&&m.orders>=3&&m.impressions<5000){
      opportunities.push({icon:"ti-rocket",color:"#1a7a3c",
        title:"Scale This Campaign",entity:name,
        why:`ACoS ${m.acos.toFixed(1)}% with ${m.orders} orders — profitable and under-exposed`,
        outcome:"Increasing budget/bids here should generate profitable additional orders",
        action:`Increase daily budget by 30–50%. Raise bids on top converting keywords by 15%`,
        type:"scale"});
    }

    // Great CVR, bad impressions
    if(m.cvr>5&&m.impressions<2000&&m.orders>=2){
      opportunities.push({icon:"ti-eye",color:"#6338c8",
        title:"High CVR, Low Visibility",entity:name,
        why:`CVR ${m.cvr.toFixed(1)}% — excellent conversion, only ${(m.impressions/1000).toFixed(1)}K impressions`,
        outcome:"More impressions at this CVR = proportionally more orders",
        action:"Push bids up 20–25%. Add TOS bid modifier. Check if budget-capped",
        type:"visibility"});
    }

    // Sales growing, spend stable
    if(comp&&comp.sales>0&&m.sales>comp.sales*1.25&&m.spend<comp.spend*1.1&&m.acos<30){
      opportunities.push({icon:"ti-trending-up",color:"#1a7a3c",
        title:"Ranking Momentum — Push Now",entity:name,
        why:`Sales grew ${(((m.sales-comp.sales)/comp.sales)*100).toFixed(0)}% without spend increase — organic momentum building`,
        outcome:"Double down while momentum is strong",
        action:"Increase budget 20%. Add TOS modifier to capture rank-driving impressions",
        type:"momentum"});
    }
  });

  // Sort by severity/priority
  const sevOrder={critical:0,high:1,medium:2,low:3};
  alerts.sort((a,b)=>(sevOrder[a.severity]??3)-(sevOrder[b.severity]??3));
  actions.sort((a,b)=>(sevOrder[a.priority]??3)-(sevOrder[b.priority]??3));

  return{alerts,actions,opportunities};
}

/* ── AI Strategic Summary generator ─────────────────────────── */
function generateACSummary(curAgg,compAgg,alerts,actions,opportunities){
  const lines=[];
  if(!curAgg||!Object.keys(curAgg).length)return[];

  const pct=(k)=>compAgg&&compAgg[k]>0?((curAgg[k]-compAgg[k])/compAgg[k])*100:null;
  const acosDelta=compAgg?curAgg.acos-compAgg.acos:null;
  const salesPct=pct("sales");
  const spendPct=pct("spend");
  const cvrPct=pct("cvr");

  // Account direction
  if(salesPct!=null){
    lines.push(salesPct>10
      ?{type:"positive",text:`Account revenue grew ${salesPct.toFixed(0)}% vs previous period. ${alerts.filter(a=>a.severity==="critical").length>0?"However, critical issues require attention before scaling further.":"Overall trajectory is positive."}`}
      :salesPct<-10
      ?{type:"negative",text:`Account revenue declined ${Math.abs(salesPct).toFixed(0)}% vs previous period. ${acosDelta>0?"Worsening ACoS compounds the problem — spend efficiency has dropped.":"Spend efficiency held, suggesting the issue may be impression/visibility loss."}`}
      :{type:"neutral",text:`Account revenue is relatively flat vs previous period (${salesPct>0?"+":""}${salesPct?.toFixed(1)}%). Look for rebalancing opportunities across campaigns.`}
    );
  }

  // CVR observation
  if(cvrPct!=null&&Math.abs(cvrPct)>15){
    lines.push(cvrPct<0
      ?{type:"negative",text:`Conversion rate declined ${Math.abs(cvrPct).toFixed(0)}% — this typically points to listing quality issues, price changes, or irrelevant traffic from broad-match campaigns.`}
      :{type:"positive",text:`Conversion rate improved ${cvrPct.toFixed(0)}% — stronger listing relevance or better search term alignment is likely driving this.`}
    );
  }

  // ACoS context
  if(acosDelta!=null&&Math.abs(acosDelta)>3){
    lines.push(acosDelta>0
      ?{type:"negative",text:`ACoS deteriorated by ${acosDelta.toFixed(1)} percentage points. Primary causes are typically CPC inflation, CVR decline, or budget misallocation to under-performing campaigns.`}
      :{type:"positive",text:`ACoS improved by ${Math.abs(acosDelta).toFixed(1)} percentage points — either bids were tightened effectively or conversion efficiency improved.`}
    );
  }

  // Opportunities
  if(opportunities.length>0){
    lines.push({type:"opportunity",text:`${opportunities.length} scaling opportunit${opportunities.length>1?"ies":"y"} detected — campaigns with strong efficiency metrics but under-utilized impression share. These represent the safest areas to increase investment.`});
  }

  // Critical count
  if(alerts.filter(a=>a.severity==="critical").length>0){
    lines.push({type:"critical",text:`${alerts.filter(a=>a.severity==="critical").length} critical issue${alerts.filter(a=>a.severity==="critical").length>1?"s require":"requires"} immediate attention. Address these before making any scaling decisions to avoid amplifying inefficiency.`});
  }

  return lines;
}

/* ── Upload Report Zone ──────────────────────────────────────── */
function ACUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"16px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s",position:"relative"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <div style={{width:36,height:36,borderRadius:8,background:file?"rgba(79,70,229,0.08)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:16,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
            <div style={{fontSize:13,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required&&<span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>}
            {!type.required&&<span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:11,color:"#888",lineHeight:1.4}}>{type.desc}</div>
          {file&&<div style={{fontSize:11,color:R,fontWeight:600,marginTop:4}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file
          ?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:11}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"6px 12px",borderRadius:7,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:11,fontWeight:600,flexShrink:0}}>Upload</button>
        }
      </div>
    </div>
  );
}

/* ── AC Upload Page ──────────────────────────────────────────── */
function ACUploadPage({periods,onPeriodSet,onComplete}){
  const[files,setFiles]=useState({});
  const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);
  const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[localPeriods,setLocalPeriods]=useState(periods);

  function setFile(id,f){setFiles(p=>({...p,[id]:f}));}
  function clearFile(id){setFiles(p=>{const n={...p};delete n[id];return n;});}
  function setCompFile(id,f){setCompFiles(p=>({...p,[id]:f}));}
  function clearCompFile(id){setCompFiles(p=>{const n={...p};delete n[id];return n;});}

  async function go(){
    if(!files.campaign)return;
    setLoading(true);setErr(null);
    try{
      const cur=await parseSheet(files.campaign);
      let comp=null;
      if(compFiles.campaign)comp=await parseSheet(compFiles.campaign);
      onComplete({cur,comp,periods:localPeriods});
    }catch(e){setErr("Error reading file: "+e.message);}
    setLoading(false);
  }

  if(subPage==="dates")return(
    <div style={{flex:1,overflowY:"auto"}}>
      <DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/>
    </div>
  );

  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:720,margin:"0 auto",padding:"32px 24px"}}>

        {/* Header */}
        <div style={{marginBottom:24}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)}</span> → <span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.end)}</span>{localPeriods.comp&&<> vs <span style={{color:"#888"}}>{fmtDisp(localPeriods.comp?.start)} → {fmtDisp(localPeriods.comp?.end)}</span></>}</div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Performance Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload raw Amazon exports directly. No formatting required — the system detects everything automatically.</p>
        </div>

        {/* Current period uploads */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:R}}/>
            <div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period Reports</div>
            <span style={{fontSize:11,color:"#888",marginLeft:2}}>{fmtDisp(localPeriods?.current?.start)} — {fmtDisp(localPeriods?.current?.end)}</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {AC_REPORT_TYPES.map(type=>(
              <ACUploadZone key={type.id} type={type} file={files[type.id]} onFile={setFile} onClear={clearFile}/>
            ))}
          </div>
        </div>

        {/* Comparison period toggle */}
        <div style={{marginBottom:16}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"9px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:13}}/> {showComp?"Remove":"Add"} Comparison Period Reports
            {localPeriods?.comp&&<span style={{fontSize:11,color:"#888",fontWeight:400,marginLeft:4}}>{fmtDisp(localPeriods.comp?.start)} — {fmtDisp(localPeriods.comp?.end)}</span>}
          </button>
          {showComp&&(
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginTop:8}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:"#aaa"}}/>
                <div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period Reports</div>
                <span style={{fontSize:11,color:"#888"}}>{fmtDisp(localPeriods?.comp?.start)} — {fmtDisp(localPeriods?.comp?.end)}</span>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {AC_REPORT_TYPES.map(type=>(
                  <ACUploadZone key={type.id} type={type} file={compFiles[type.id]} onFile={setCompFile} onClear={clearCompFile}/>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Instructions */}
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"14px 16px",marginBottom:16}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10}}>How to export from Amazon Advertising Console</div>
          {[
            "Go to Amazon Advertising Console → Reports → Create Report",
            "For Campaign Report: Report Type = Campaign, Metrics = all available",
            "For Search Term Report: Report Type = Search Term",
            "Set date range matching your selected period above",
            "Download .xlsx and upload directly — no editing needed"
          ].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:10,marginBottom:7,alignItems:"flex-start"}}>
              <span style={{width:18,height:18,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span>
              <span style={{fontSize:12,color:"#555",lineHeight:1.6}}>{s}</span>
            </div>
          ))}
        </div>

        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}><i className="ti ti-alert-triangle" style={{marginRight:5}}/>{err}</div>}

        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.campaign||loading}
            style={{...T.btnR(false),opacity:files.campaign&&!loading?1:0.4,fontWeight:700,boxShadow:files.campaign?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-brain" style={{fontSize:14}}/> Run Priority Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Performance Movement Row ────────────────────────────────── */
function ACPerfMovement({cur,comp}){
  const defs=[
    {k:"spend",  label:"Spend",   fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`, lb:true},
    {k:"sales",  label:"Sales",   fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`, lb:false},
    {k:"acos",   label:"ACoS",    fmt:v=>`${v.toFixed(1)}%`,                                  lb:true,  isPp:true},
    {k:"roas",   label:"ROAS",    fmt:v=>v.toFixed(2),                                        lb:false},
    {k:"orders", label:"Orders",  fmt:v=>String(Math.round(v)),                               lb:false},
    {k:"cvr",    label:"CVR",     fmt:v=>`${v.toFixed(1)}%`,                                  lb:false, isPp:true},
    {k:"cpc",    label:"CPC",     fmt:v=>`$${v.toFixed(2)}`,                                  lb:true},
    {k:"ctr",    label:"CTR",     fmt:v=>`${v.toFixed(2)}%`,                                  lb:false, isPp:true},
    {k:"clicks", label:"Clicks",  fmt:v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v)), lb:false},
    {k:"impressions",label:"Impr.",fmt:v=>v>=1e6?`${(v/1e6).toFixed(1)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v)), lb:false},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:1,background:"#f0f0f0",borderRadius:10,overflow:"hidden",border:"1px solid #f0f0f0"}}>
      {defs.map((d,i)=>{
        const cv=cur[d.k]||0;const pv=comp?comp[d.k]||0:null;
        const delta=pv!=null?cv-pv:null;
        const pct=delta!=null&&pv!==0?(delta/Math.abs(pv))*100:null;
        const good=delta===null?null:(d.lb?delta<=0:delta>=0);
        const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";
        const sign=v=>v>0?"+":"";
        return(
          <div key={d.k} style={{background:"#fff",padding:"14px 16px"}}>
            <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:7}}>{d.label}</div>
            <div style={{fontSize:19,fontWeight:800,color:"#111",letterSpacing:"-0.4px",lineHeight:1,marginBottom:5}}>{d.fmt(cv)}</div>
            {comp&&pct!=null&&(
              <div>
                <div style={{fontSize:12,fontWeight:700,color:dc,display:"flex",alignItems:"center",gap:3,marginBottom:1}}>
                  <i className={`ti ${good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:11}}/>
                  {sign(pct)}{Math.abs(pct).toFixed(1)}%
                  <span style={{fontSize:10,color:"#ccc",fontWeight:400,marginLeft:2}}>vs prev</span>
                </div>
                {delta!=null&&<div style={{fontSize:10,color:dc,fontWeight:600}}>{d.isPp?`${sign(delta)}${Math.abs(delta).toFixed(1)}pp`:`${sign(delta)}${d.fmt(Math.abs(delta))}`}</div>}
              </div>
            )}
            {comp&&delta===null&&<div style={{fontSize:10,color:"#ddd"}}>No prev data</div>}
          </div>
        );
      })}
    </div>
  );
}

/* ── Alert Card ─────────────────────────────────────────────── */
function ACAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555",low:"#888"};
  const sb={critical:"rgba(212,43,43,0.06)",high:"rgba(196,122,0,0.06)",medium:"rgba(0,0,0,0.02)",low:"transparent"};
  const sbr={critical:"rgba(212,43,43,0.2)",high:"rgba(196,122,0,0.2)",medium:"#eee",low:"#eee"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:10}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"12px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:12}}>
        <div style={{width:32,height:32,borderRadius:8,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          <i className={`ti ${a.icon}`} style={{fontSize:14,color:sc[a.severity]}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 7px",borderRadius:4,background:sb[a.severity],color:sc[a.severity],fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{a.title}</span>
          </div>
          <div style={{fontSize:11,color:"#666",marginBottom:2,lineHeight:1.4,fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.entity}</div>
          <div style={{fontSize:11,color:"#444",lineHeight:1.4}}>{a.issue}</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
          {a.confidence&&<span style={{fontSize:10,color:"#aaa"}}>{a.confidence}% conf.</span>}
          <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#bbb"}}/>
        </div>
      </div>
      {open&&(
        <div style={{padding:"0 14px 14px 58px",borderTop:"1px solid rgba(0,0,0,0.06)"}}>
          {a.compNote&&<div style={{fontSize:11,color:"#888",marginTop:10,marginBottom:8,fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4}}/>{a.compNote}</div>}
          {a.impact&&<div style={{fontSize:12,color:"#555",marginBottom:10,padding:"8px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6}}><strong>Estimated impact:</strong> {a.impact}</div>}
          <div style={{padding:"10px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}>
            <div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:4}}>Recommended Action</div>
            <div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Action Card ─────────────────────────────────────────────── */
function ACActionCard({action:a}){
  const[open,setOpen]=useState(false);
  const pc={critical:"#d42b2b",high:"#c47a00",medium:"#1a50a0",low:"#888"};
  const pb={critical:"rgba(212,43,43,0.06)",high:"rgba(196,122,0,0.06)",medium:"rgba(26,80,160,0.06)",low:"transparent"};
  const pbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"rgba(26,80,160,0.18)",low:"#eee"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${pbr[a.priority]||"#eee"}`,background:pb[a.priority]||"#fff",overflow:"hidden",marginBottom:10}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"12px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:12}}>
        <div style={{width:32,height:32,borderRadius:8,background:"#fff",border:`1.5px solid ${pbr[a.priority]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          <i className={`ti ${a.icon}`} style={{fontSize:14,color:pc[a.priority]}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 7px",borderRadius:4,background:pb[a.priority],color:pc[a.priority],fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${pbr[a.priority]}`}}>{a.priority}</span>
            <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{a.title}</span>
          </div>
          <div style={{fontSize:11,color:"#555",lineHeight:1.4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.entity}</div>
          <div style={{fontSize:11,color:"#666",marginTop:2}}>{a.reason}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#bbb",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&(
        <div style={{padding:"0 14px 14px 58px",borderTop:"1px solid rgba(0,0,0,0.06)"}}>
          {a.comparison&&<div style={{fontSize:11,color:"#888",margin:"10px 0 8px",fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4}}/>{a.comparison}</div>}
          {a.impact&&<div style={{fontSize:12,color:"#555",marginBottom:10,padding:"8px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6}}><strong>Expected impact:</strong> {a.impact}</div>}
          <div style={{padding:"10px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}>
            <div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:4}}>Recommended Action</div>
            <div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div>
          </div>
          {a.confidence&&<div style={{fontSize:10,color:"#aaa",marginTop:8,textAlign:"right"}}>Confidence: {a.confidence}%</div>}
        </div>
      )}
    </div>
  );
}

/* ── Opportunity Card ────────────────────────────────────────── */
function ACOpportunityCard({opp:o}){
  const[open,setOpen]=useState(false);
  return(
    <div style={{borderRadius:10,border:"1.5px solid rgba(26,122,60,0.2)",background:"rgba(26,122,60,0.04)",overflow:"hidden",marginBottom:10}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"12px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:12}}>
        <div style={{width:32,height:32,borderRadius:8,background:"#fff",border:"1.5px solid rgba(26,122,60,0.2)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          <i className={`ti ${o.icon}`} style={{fontSize:14,color:o.color||"#1a7a3c"}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
            <span style={{fontSize:9,padding:"2px 7px",borderRadius:4,background:"rgba(26,122,60,0.08)",color:"#1a7a3c",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:"1px solid rgba(26,122,60,0.18)"}}>Opportunity</span>
            <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{o.title}</span>
          </div>
          <div style={{fontSize:11,color:"#555",lineHeight:1.4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{o.entity}</div>
          <div style={{fontSize:11,color:"#666",marginTop:2}}>{o.why}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#bbb",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&(
        <div style={{padding:"0 14px 14px 58px",borderTop:"1px solid rgba(26,122,60,0.08)"}}>
          {o.outcome&&<div style={{fontSize:12,color:"#555",margin:"10px 0 8px",padding:"8px 10px",background:"rgba(26,122,60,0.04)",borderRadius:6,border:"1px solid rgba(26,122,60,0.1)"}}><strong>Expected outcome:</strong> {o.outcome}</div>}
          <div style={{padding:"10px 12px",background:"rgba(26,122,60,0.06)",borderRadius:8,border:"1px solid rgba(26,122,60,0.15)"}}>
            <div style={{fontSize:9,color:"#1a7a3c",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:4}}>Scaling Action</div>
            <div style={{fontSize:12,color:"#1a4a28",lineHeight:1.6,fontWeight:500}}>{o.action}</div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Daily Action Center Dashboard ──────────────────────────── */
function ACDashboard({curData,compData,periods,onReupload}){
  const cm=useMemo(()=>curData?acDetectMap(curData.headers):{},[curData]);
  const compCm=useMemo(()=>compData?acDetectMap(compData.headers):{},[compData]);

  const curAgg=useMemo(()=>curData?acSumAgg(curData.rows,cm):{},[curData,cm]);
  const compAgg=useMemo(()=>compData?acSumAgg(compData.rows,compCm):{},[compData,compCm]);

  // Build compMap by campaign name
  const compMap=useMemo(()=>{
    if(!compData)return null;
    const m={};
    compData.rows.forEach(r=>{
      const m2=acCalcRow(r,compCm);
      if(m2.campaign)m[m2.campaign.toLowerCase()]=m2;
    });
    return m;
  },[compData,compCm]);

  const{alerts,actions,opportunities}=useMemo(()=>
    curData?acPrioritize(curData.rows,cm,compMap):{alerts:[],actions:[],opportunities:[]}
  ,[curData,cm,compMap]);

  const summary=useMemo(()=>
    generateACSummary(curAgg,compAgg?.orders>0?compAgg:null,alerts,actions,opportunities)
  ,[curAgg,compAgg,alerts,actions,opportunities]);

  const[filter,setFilter]=useState("All");
  const FILTERS=["All","Critical","High","Medium","Opportunity"];

  const filteredAlerts=filter==="All"||filter==="Critical"?alerts.filter(a=>filter==="All"||a.severity===filter.toLowerCase()):[];
  const filteredActions=filter==="All"||["Critical","High","Medium"].includes(filter)?actions.filter(a=>filter==="All"||a.priority===filter.toLowerCase()):[];
  const filteredOpps=filter==="All"||filter==="Opportunity"?opportunities:[];

  const totalIssues=alerts.length+actions.length;
  const critCount=alerts.filter(a=>a.severity==="critical").length+actions.filter(a=>a.priority==="critical").length;

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>

      {/* Header */}
      <div style={{padding:"14px 24px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Daily Action Center</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {opportunities.length>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(26,122,60,0.08)",color:"#1a7a3c",fontWeight:700}}>{opportunities.length} Opportunit{opportunities.length>1?"ies":"y"}</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:12}}/>
            <span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{curData?.rows?.length||0} campaigns analyzed</span>
          </div>
        </div>
        <button onClick={onReupload} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:12,fontWeight:500,cursor:"pointer"}}>
          <i className="ti ti-upload" style={{fontSize:13}}/> Re-upload
        </button>
      </div>

      <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
        <div style={{maxWidth:900,margin:"0 auto",padding:"20px 24px"}}>

          {/* ── Section 5: Performance Movement ── */}
          <div style={{marginBottom:24}}>
            <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Performance Movement</div>
            <ACPerfMovement cur={curAgg} comp={compAgg?.orders>0||compAgg?.spend>0?compAgg:null}/>
          </div>

          {/* ── Section 4: AI Strategic Summary ── */}
          {summary.length>0&&(
            <div style={{marginBottom:24}}>
              <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>AI Strategic Summary</div>
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px"}}>
                <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}>
                  <i className="ti ti-brain" style={{fontSize:14,color:R}}/>
                  <div style={{fontSize:12,fontWeight:700,color:"#111"}}>Account Analysis</div>
                  <div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on your uploaded data only</div>
                </div>
                {summary.map((s,i)=>{
                  const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",critical:"#d42b2b",neutral:"#555"};
                  const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-rocket",critical:"ti-alert-triangle",neutral:"ti-minus"};
                  return(
                    <div key={i} style={{display:"flex",gap:10,marginBottom:i<summary.length-1?10:0,paddingBottom:i<summary.length-1?10:0,borderBottom:i<summary.length-1?"1px solid #f5f5f5":"none"}}>
                      <div style={{width:20,height:20,borderRadius:5,background:`rgba(0,0,0,0.04)`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                        <i className={`ti ${ic[s.type]}`} style={{fontSize:10,color:tc[s.type]}}/>
                      </div>
                      <div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{s.text}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Filter pills */}
          <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
            {FILTERS.map(f=>{
              const count=f==="All"?totalIssues+opportunities.length:f==="Opportunity"?opportunities.length:f==="Critical"?alerts.filter(a=>a.severity==="critical").length+actions.filter(a=>a.priority==="critical").length:f==="High"?alerts.filter(a=>a.severity==="high").length+actions.filter(a=>a.priority==="high").length:alerts.filter(a=>a.severity==="medium").length+actions.filter(a=>a.priority==="medium").length;
              const active=filter===f;
              const fc={Critical:"#d42b2b",High:"#c47a00",Opportunity:"#1a7a3c",Medium:"#1a50a0",All:"#111"};
              return(
                <button key={f} onClick={()=>setFilter(f)}
                  style={{padding:"5px 12px",borderRadius:20,border:`1.5px solid ${active?(fc[f]||"#111"):"#e0e0e0"}`,background:active?"#111":"#fff",color:active?"#fff":"#555",fontSize:11,fontWeight:active?700:500,cursor:"pointer"}}>
                  {f} {count>0&&`(${count})`}
                </button>
              );
            })}
          </div>

          {/* ── Section 1: Critical Alerts ── */}
          {(filter==="All"||filter==="Critical")&&alerts.length>0&&(
            <div style={{marginBottom:24}}>
              <div style={{fontSize:12,fontWeight:700,color:"#d42b2b",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
                <i className="ti ti-alert-triangle" style={{fontSize:12}}/> Critical Alerts <span style={{fontSize:10,color:"#d42b2b",fontWeight:500}}>({alerts.length})</span>
              </div>
              {alerts.map((a,i)=><ACAlertCard key={i} alert={a}/>)}
            </div>
          )}

          {/* ── Section 2: Priority Actions ── */}
          {(filter==="All"||["Critical","High","Medium"].includes(filter))&&actions.length>0&&(
            <div style={{marginBottom:24}}>
              <div style={{fontSize:12,fontWeight:700,color:"#111",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
                <i className="ti ti-bolt" style={{fontSize:12}}/> Priority Actions <span style={{fontSize:10,color:"#888",fontWeight:500}}>({actions.length})</span>
              </div>
              {(filter==="All"?actions:actions.filter(a=>a.priority===filter.toLowerCase())).map((a,i)=><ACActionCard key={i} action={a}/>)}
            </div>
          )}

          {/* ── Section 3: Scaling Opportunities ── */}
          {(filter==="All"||filter==="Opportunity")&&opportunities.length>0&&(
            <div style={{marginBottom:24}}>
              <div style={{fontSize:12,fontWeight:700,color:"#1a7a3c",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
                <i className="ti ti-rocket" style={{fontSize:12}}/> Scaling Opportunities <span style={{fontSize:10,color:"#1a7a3c",fontWeight:500}}>({opportunities.length})</span>
              </div>
              {opportunities.map((o,i)=><ACOpportunityCard key={i} opp={o}/>)}
            </div>
          )}

          {/* Empty state */}
          {totalIssues===0&&opportunities.length===0&&(
            <div style={{textAlign:"center",padding:"60px 20px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}>
              <i className="ti ti-circle-check" style={{fontSize:48,color:"#1a9e4a",display:"block",marginBottom:12}}/>
              <div style={{fontSize:16,fontWeight:700,color:"#111",marginBottom:6}}>Account Looks Healthy</div>
              <div style={{fontSize:13,color:"#888"}}>No critical issues or major opportunities detected in this data set.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── Action Center Module Root ───────────────────────────────── */
function ActionCenterModule({globalData,setTab}){
  const[subPage,setSubPage]=useState(globalData?.cur?.primary?"dashboard":"upload");
  const[periods,setPeriods]=useState(globalData?.periods||null);
  const[curData,setCurData]=useState(globalData?.cur?.primary||null);
  const[compData,setCompData]=useState(globalData?.comp?.primary||null);
  useEffect(()=>{if(globalData?.cur?.primary&&subPage==="upload"){setCurData(globalData.cur.primary);setCompData(globalData.comp?.primary||null);setPeriods(globalData.periods||null);setSubPage("dashboard");}},[globalData]);

  if(subPage==="dashboard"&&curData){
    return(
      <ACDashboard
        curData={curData}
        compData={compData}
        periods={periods}
        onReupload={()=>setSubPage("upload")}
      />
    );
  }

  return(
    <ACUploadPage
      periods={periods}
      onPeriodSet={p=>setPeriods(p)}
      onComplete={({cur,comp,periods:p})=>{
        setCurData(cur);
        setCompData(comp||null);
        if(p)setPeriods(p);
        setSubPage("dashboard");
      }}
    />
  );
}

/* ================================================================
   CAMPAIGN HEALTH CENTER MODULE
   Diagnostic system for Amazon PPC campaign health analysis.
   Strict scope: upload page + health workspace only.
================================================================ */

/* ── Column aliases for campaign reports ─────────────────────── */
const CH_ALIASES={
  campaign:    ["Campaign Name","Campaign","campaign name"],
  type:        ["Campaign Type","Type","Ad Type","Campaign Type (Informational only)"],
  state:       ["Campaign State","State","Status","Campaign State (Informational only)"],
  budget:      ["Daily Budget","Budget","Daily Budget ($)"],
  impressions: ["Impressions","impressions"],
  clicks:      ["Clicks","clicks"],
  spend:       ["Spend","Cost","Ad Spend","Spend ($)"],
  sales:       ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales","Attributed Sales 7d"],
  orders:      ["Orders","14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)"],
  acos:        ["ACOS","ACoS","Advertising Cost of Sales","ACOS (%)"],
  roas:        ["ROAS","Return on Ad Spend"],
  cpc:         ["CPC","Cost Per Click","Average CPC","CPC ($)"],
  ctr:         ["Click-through Rate","CTR","Click-Through Rate","CTR (%)"],
  cvr:         ["Conversion Rate","CVR","Order Rate","CVR (%)"],
  portfolio:   ["Portfolio Name","Portfolio","Portfolio Name (Informational only)"],
};

function chDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(CH_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function chNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function chRow(row,cm){
  const imp=chNum(row,cm.impressions),clk=chNum(row,cm.clicks),
    spd=chNum(row,cm.spend),sal=chNum(row,cm.sales),ord=chNum(row,cm.orders),
    bgt=chNum(row,cm.budget);
  const ctr=cm.ctr&&chNum(row,cm.ctr)>0?chNum(row,cm.ctr):imp>0?(clk/imp)*100:0;
  const acos=cm.acos&&chNum(row,cm.acos)>0?chNum(row,cm.acos):sal>0?(spd/sal)*100:0;
  const cvr=cm.cvr&&chNum(row,cm.cvr)>0?chNum(row,cm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=clk>0?spd/clk:0;
  const roas=spd>0?sal/spd:0;
  const budgetPct=bgt>0?(spd/bgt)*100:0;
  return{
    campaign:String(row[cm.campaign]||""),
    type:String(row[cm.type]||""),
    state:String(row[cm.state]||"").toLowerCase(),
    portfolio:String(row[cm.portfolio]||""),
    impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    budget:bgt,budgetPct,ctr,acos,roas,cvr,cpc,
  };
}

function chAgg(rows,cm){
  let imp=0,clk=0,spd=0,sal=0,ord=0,bgt=0;
  rows.forEach(r=>{const m=chRow(r,cm);imp+=m.impressions;clk+=m.clicks;spd+=m.spend;sal+=m.sales;ord+=m.orders;bgt+=m.budget;});
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,budget:bgt,
    acos:sal>0?(spd/sal)*100:0,ctr:imp>0?(clk/imp)*100:0,
    cvr:clk>0?(ord/clk)*100:0,cpc:clk>0?spd/clk:0,roas:spd>0?sal/spd:0,
    budgetPct:bgt>0?(spd/bgt)*100:0};
}

/* ── Health Scoring Engine ────────────────────────────────────
   Scores are calculated from real data, not random values.
   Each sub-score is 0–100, overall is weighted average.
─────────────────────────────────────────────────────────────── */
function calcHealthScore(m, comp){
  // Efficiency Score — ACoS-based (target 30%)
  let efficiency=100;
  if(m.acos>0){
    if(m.acos<=25)efficiency=95;
    else if(m.acos<=35)efficiency=80;
    else if(m.acos<=50)efficiency=60;
    else if(m.acos<=70)efficiency=40;
    else efficiency=20;
    // Penalize if worsening vs comparison
    if(comp&&comp.acos>0&&m.acos>comp.acos*1.15)efficiency=Math.max(10,efficiency-15);
  }else if(m.spend>10) efficiency=15; // spend with no sales

  // Conversion Score — CVR consistency
  let conversion=75;
  if(m.clicks<10){conversion=50;} // not enough data
  else if(m.cvr>5)conversion=95;
  else if(m.cvr>3)conversion=82;
  else if(m.cvr>1.5)conversion=65;
  else if(m.cvr>0.5)conversion=45;
  else conversion=25;
  if(comp&&comp.cvr>0&&m.cvr<comp.cvr*0.75)conversion=Math.max(15,conversion-20);

  // Scaling Score — impressions & CVR growth opportunity
  let scaling=50;
  if(m.acos>0&&m.acos<25&&m.orders>=3){
    if(m.impressions<3000)scaling=90; // under-exposed winner
    else if(m.impressions<10000)scaling=75;
    else scaling=60;
  } else if(m.acos>50||m.orders===0){scaling=20;}
  else {scaling=45;}

  // Structural Score — budget utilization & CPC health
  let structural=80;
  if(m.budgetPct>=98)structural=Math.max(20,structural-40); // budget capped
  else if(m.budgetPct>=90)structural=Math.max(40,structural-20);
  if(comp&&comp.cpc>0&&m.cpc>comp.cpc*1.3)structural=Math.max(20,structural-25); // CPC spike
  if(m.spend>50&&m.orders===0)structural=Math.max(10,structural-50); // pure waste

  const overall=Math.round(efficiency*0.35+conversion*0.30+scaling*0.20+structural*0.15);
  return{overall,efficiency:Math.round(efficiency),conversion:Math.round(conversion),
    scaling:Math.round(scaling),structural:Math.round(structural)};
}

function healthLabel(score){
  if(score>=82)return{label:"Healthy",color:"#1a7a3c",bg:"rgba(26,122,60,0.08)"};
  if(score>=65)return{label:"Scaling Opp.",color:"#1a50a0",bg:"rgba(26,80,160,0.08)"};
  if(score>=50)return{label:"Warning",color:"#c47a00",bg:"rgba(196,122,0,0.08)"};
  if(score>=30)return{label:"Declining",color:"#d42b2b",bg:"rgba(212,43,43,0.08)"};
  return{label:"Critical",color:"#d42b2b",bg:"rgba(212,43,43,0.12)"};
}

/* ── Alert generation engine ─────────────────────────────────── */
function generateCHAlerts(rows,cm,compMap){
  const alerts=[];
  rows.forEach(row=>{
    const m=chRow(row,cm);
    const comp=compMap?compMap[m.campaign.toLowerCase()]||null:null;
    if(!m.campaign||m.spend===0)return;

    // Budget suffocation
    if(m.budget>0&&m.budgetPct>=98){
      alerts.push({severity:"critical",type:"Budget Suffocation",icon:"ti-coin",color:"#d42b2b",
        campaign:m.campaign,
        comparison:`Budget: $${m.budget.toFixed(0)}/day · Spent: $${m.spend.toFixed(0)} (${m.budgetPct.toFixed(0)}%)`,
        cause:"Campaign is hitting its daily budget cap — impressions are being throttled. You are losing valuable traffic every day.",
        action:"Increase daily budget by 25–40%, or redistribute budget from low-performing campaigns",
        impact:"Estimated traffic loss: 15–25% of available impressions",confidence:94});
    }

    // CPC inflation
    if(comp&&comp.cpc>0&&m.cpc>comp.cpc*1.30&&m.clicks>15){
      const cpcp=((m.cpc-comp.cpc)/comp.cpc)*100;
      alerts.push({severity:"high",type:"CPC Inflation",icon:"ti-trending-up",color:"#c47a00",
        campaign:m.campaign,
        comparison:`CPC: $${comp.cpc.toFixed(2)} → $${m.cpc.toFixed(2)} (+${cpcp.toFixed(0)}%)`,
        cause:`Average CPC increased ${cpcp.toFixed(0)}% vs previous period. Auction competition intensified or match types are too broad, pulling in expensive irrelevant traffic.`,
        action:"Tighten match types, review negative keywords, audit high-CPC search terms",
        impact:`Extra spend this period: $${((m.cpc-comp.cpc)*m.clicks).toFixed(0)}`,confidence:87});
    }

    // CVR deterioration
    if(comp&&comp.cvr>0&&m.cvr<comp.cvr*0.72&&m.clicks>25){
      const cvrp=((m.cvr-comp.cvr)/comp.cvr)*100;
      alerts.push({severity:"critical",type:"Conversion Deterioration",icon:"ti-chart-line-down",color:"#d42b2b",
        campaign:m.campaign,
        comparison:`CVR: ${comp.cvr.toFixed(1)}% → ${m.cvr.toFixed(1)}% (${cvrp.toFixed(0)}%)`,
        cause:`Conversion rate dropped ${Math.abs(cvrp).toFixed(0)}% — same traffic generating significantly fewer orders. Typical causes: listing quality change, price increase, competitor improvement, or irrelevant traffic growth.`,
        action:"Audit listing quality, pricing, and primary image. Review search terms for irrelevant traffic",
        impact:`Missed orders: ~${Math.round(m.clicks*(comp.cvr-m.cvr)/100)} this period`,confidence:91});
    }

    // Spend leakage
    if(m.spend>40&&m.orders===0){
      alerts.push({severity:"critical",type:"Spend Leakage",icon:"ti-droplet-off",color:"#d42b2b",
        campaign:m.campaign,
        comparison:comp?`Prev period: ${comp.orders} orders, $${comp.spend.toFixed(0)} spend`:`$${m.spend.toFixed(0)} spent, zero conversions`,
        cause:"Significant spend with zero conversions. This campaign is generating pure cost with no return. Every dollar spent here is a loss.",
        action:"Pause or cut budget immediately. Audit all search terms. Review targeting structure",
        impact:`$${m.spend.toFixed(0)} fully recoverable budget`,confidence:98});
    }

    // Impression loss
    if(comp&&comp.impressions>500&&m.impressions<comp.impressions*0.55&&m.orders>0){
      const impp=((m.impressions-comp.impressions)/comp.impressions)*100;
      alerts.push({severity:"high",type:"Impression Loss",icon:"ti-eye-off",color:"#c47a00",
        campaign:m.campaign,
        comparison:`Impressions: ${(comp.impressions/1000).toFixed(1)}K → ${(m.impressions/1000).toFixed(1)}K (${impp.toFixed(0)}%)`,
        cause:`Visibility dropped ${Math.abs(impp).toFixed(0)}% — campaign is losing auction presence. Possible causes: budget cap, bid reduction, or competitive pressure from other advertisers.`,
        action:"Check budget utilization. Increase bids on converting keywords by 15–20%",
        impact:`~${Math.round((comp.impressions-m.impressions)*m.cvr/100)} missed orders this period`,confidence:82});
    }

    // High ACoS + increasing spend
    if(m.acos>60&&m.spend>20&&m.orders>0){
      alerts.push({severity:"high",type:"Efficiency Decline",icon:"ti-alert-triangle",color:"#c47a00",
        campaign:m.campaign,
        comparison:comp?`ACoS: ${comp.acos.toFixed(1)}% → ${m.acos.toFixed(1)}%`:`ACoS: ${m.acos.toFixed(1)}%`,
        cause:`ACoS at ${m.acos.toFixed(1)}% — well above profitable threshold. Campaign is generating orders but at a significant loss per unit.`,
        action:"Reduce bids on highest-spend keywords by 15–25%. Eliminate zero-converting targets",
        impact:`At 35% target ACoS: $${((m.spend-m.sales*0.35)).toFixed(0)} recoverable`,confidence:88});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3));
}

/* ── AI Insights generator ───────────────────────────────────── */
function generateCHInsights(curAgg,compAgg,rows,cm){
  const lines=[];
  if(!curAgg||!Object.keys(curAgg).length)return lines;
  const pct=(k)=>compAgg&&compAgg[k]>0?((curAgg[k]-compAgg[k])/compAgg[k])*100:null;
  const acosDelta=compAgg?curAgg.acos-compAgg.acos:null;
  const cvrPct=pct("cvr");const cpcPct=pct("cpc");const salesPct=pct("sales");

  // Account direction
  if(salesPct!=null){
    lines.push({type:salesPct>10?"positive":salesPct<-10?"negative":"neutral",
      icon:salesPct>0?"ti-trending-up":"ti-trending-down",
      text:salesPct>10?`Campaign sales grew ${salesPct.toFixed(0)}% vs previous period. Review which campaigns drove the increase and consider scaling their budgets.`
        :salesPct<-10?`Campaign sales declined ${Math.abs(salesPct).toFixed(0)}% vs previous period. Investigate budget caps, bid changes, and CVR deterioration across your campaign portfolio.`
        :`Campaign sales are relatively stable (${salesPct>0?"+":""}${salesPct.toFixed(1)}%). Focus on rebalancing spend from low-efficiency to high-efficiency campaigns.`});
  }

  // ACoS
  if(acosDelta!=null&&Math.abs(acosDelta)>2){
    lines.push({type:acosDelta>0?"negative":"positive",icon:acosDelta>0?"ti-chart-line-down":"ti-chart-line",
      text:acosDelta>0?`Account ACoS deteriorated by ${acosDelta.toFixed(1)} percentage points. The primary causes are typically CPC inflation, CVR decline, or budget misallocated to low-efficiency campaigns. Address high-ACoS campaigns before scaling.`
        :`Account ACoS improved by ${Math.abs(acosDelta).toFixed(1)} percentage points — bid discipline or conversion improvements are working. Safe to consider selective budget increases on proven campaigns.`});
  }

  // CVR
  if(cvrPct!=null&&Math.abs(cvrPct)>15){
    lines.push({type:cvrPct<0?"negative":"positive",icon:cvrPct<0?"ti-trending-down":"ti-trending-up",
      text:cvrPct<0?`Conversion rate declined ${Math.abs(cvrPct).toFixed(0)}% across campaigns. This is rarely a campaign problem — check listing quality, pricing, stock levels, and image quality. Broad-match traffic may also be diluting CVR.`
        :`Conversion rate improved ${cvrPct.toFixed(0)}% — either listing quality improved or search term targeting became more precise. This is a good signal to increase bids on top converting keywords.`});
  }

  // CPC
  if(cpcPct!=null&&cpcPct>20){
    lines.push({type:"negative",icon:"ti-coin",
      text:`CPC increased ${cpcPct.toFixed(0)}% across campaigns. Rising CPCs compress margins even when CVR holds steady. Audit broad-match campaigns first — they are the most common source of CPC inflation in Amazon advertising.`});
  }

  // Structural issues
  const bleeders=rows.filter(r=>{const m=chRow(r,cm);return m.spend>30&&m.orders===0;});
  if(bleeders.length){
    lines.push({type:"critical",icon:"ti-droplet-off",
      text:`${bleeders.length} campaign${bleeders.length>1?"s are":"is"} spending without generating any conversions. These represent fully recoverable budget — address these before any scaling decisions to ensure budget is reallocated efficiently.`});
  }

  const capped=rows.filter(r=>{const m=chRow(r,cm);return m.budget>0&&m.budgetPct>=95&&m.acos<35&&m.orders>0;});
  if(capped.length){
    lines.push({type:"opportunity",icon:"ti-rocket",
      text:`${capped.length} profitable campaign${capped.length>1?"s are":"is"} hitting budget caps. These are your best scaling opportunities — they're efficient and demand is there, but budget is constraining growth.`});
  }

  return lines;
}

/* ── Health Score Badge ───────────────────────────────────────── */
function CHScoreBadge({score,size="sm"}){
  const{label,color,bg}=healthLabel(score);
  const sz=size==="lg"?{w:44,h:44,fs:16,lfs:11}:{w:32,h:32,fs:12,lfs:9};
  return(
    <div style={{display:"flex",alignItems:"center",gap:6}}>
      <div style={{width:sz.w,height:sz.h,borderRadius:8,background:bg,border:`1.5px solid ${color}33`,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <span style={{fontSize:sz.fs,fontWeight:800,color}}>{score}</span>
      </div>
      {size==="lg"&&<div><div style={{fontSize:12,fontWeight:700,color}}>{label}</div><div style={{fontSize:10,color:"#aaa"}}>Health Score</div></div>}
      {size==="sm"&&<span style={{fontSize:sz.lfs,padding:"1px 5px",borderRadius:3,background:bg,color,fontWeight:700}}>{label}</span>}
    </div>
  );
}

/* ── CH Upload Zone (module-level) ───────────────────────────── */
function CHUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"14px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <div style={{width:34,height:34,borderRadius:8,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:15,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required&&<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>}
            {!type.required&&<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:11,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:11,color:R,fontWeight:600,marginTop:3}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:11}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 12px",borderRadius:7,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:11,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const CH_REPORT_TYPES=[
  {id:"campaign",  label:"Campaign Report",          icon:"ti-speakerphone",required:true, desc:"Core campaign-level performance metrics — required for health scoring"},
  {id:"placement", label:"Placement Report",          icon:"ti-layout-2",   required:false,desc:"TOS, Product Pages, and Rest of Search breakdown"},
  {id:"advertised",label:"Advertised Product Report", icon:"ti-box",        required:false,desc:"ASIN-level performance data"},
  {id:"budget",    label:"Budget Report",             icon:"ti-coin",       required:false,desc:"Budget utilization and daily cap analysis"},
];

/* ── CH Upload Page ──────────────────────────────────────────── */
function CHUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});
  const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);
  const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);
  const[localPeriods,setLocalPeriods]=useState(periods);

  function setFile(id,f){setFiles(p=>({...p,[id]:f}));}
  function clearFile(id){setFiles(p=>{const n={...p};delete n[id];return n;});}
  function setCompFile(id,f){setCompFiles(p=>({...p,[id]:f}));}
  function clearCompFile(id){setCompFiles(p=>{const n={...p};delete n[id];return n;});}

  async function go(){
    if(!files.campaign)return;
    setLoading(true);setErr(null);
    try{
      const cur=await parseSheet(files.campaign);
      let comp=null;if(compFiles.campaign)comp=await parseSheet(compFiles.campaign);
      onComplete({cur,comp,periods:localPeriods});
    }catch(e){setErr("Error reading file: "+e.message);}
    setLoading(false);
  }

  if(subPage==="dates")return(
    <div style={{flex:1,overflowY:"auto"}}>
      <DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/>
    </div>
  );

  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:720,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Campaign Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload raw Amazon exports directly — no formatting or preprocessing needed. The system maps columns automatically.</p>
        </div>

        {/* Current period */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:R}}/>
            <div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div>
            <span style={{fontSize:11,color:"#888"}}>{fmtDisp(localPeriods?.current?.start)} — {fmtDisp(localPeriods?.current?.end)}</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {CH_REPORT_TYPES.map(t=><CHUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}
          </div>
        </div>

        {/* Comparison period */}
        <div style={{marginBottom:14}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"9px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/> {showComp?"Remove":"Add"} Comparison Period
            {localPeriods?.comp&&<span style={{fontSize:11,color:"#888",fontWeight:400,marginLeft:4}}>{fmtDisp(localPeriods.comp.start)} — {fmtDisp(localPeriods.comp.end)}</span>}
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
              <div style={{width:8,height:8,borderRadius:"50%",background:"#aaa"}}/>
              <div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div>
              {localPeriods?.comp&&<span style={{fontSize:11,color:"#888"}}>{fmtDisp(localPeriods.comp.start)} — {fmtDisp(localPeriods.comp.end)}</span>}
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {CH_REPORT_TYPES.map(t=><CHUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}
            </div>
          </div>}
        </div>

        {/* Instructions */}
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"14px 16px",marginBottom:14}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10}}>How to export Campaign Reports from Amazon</div>
          {["Go to Amazon Advertising Console → Reports → Create Report","Select Report Type: Campaign (for the Campaign Report)","Include all available metrics — do not customize columns","Set date range matching your selected period above","Download .xlsx and upload directly — no editing required"].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:10,marginBottom:6,alignItems:"flex-start"}}>
              <span style={{width:17,height:17,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span>
              <span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span>
            </div>
          ))}
        </div>

        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}><i className="ti ti-alert-triangle" style={{marginRight:5}}/>{err}</div>}

        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.campaign||loading} style={{...T.btnR(false),opacity:files.campaign&&!loading?1:0.4,fontWeight:700,boxShadow:files.campaign?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Running Diagnostics...</>:<><i className="ti ti-heart-rate-monitor" style={{fontSize:14}}/> Run Campaign Health Check</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── CH Overview KPI Bar ─────────────────────────────────────── */
function CHOverviewBar({cur,comp}){
  const defs=[
    {k:"spend",  lb:true, label:"Total Spend",fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`},
    {k:"sales",  lb:false,label:"Total Sales",fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`},
    {k:"acos",   lb:true, label:"ACoS",       fmt:v=>`${v.toFixed(1)}%`,isPp:true},
    {k:"roas",   lb:false,label:"ROAS",        fmt:v=>v.toFixed(2)},
    {k:"orders", lb:false,label:"Orders",      fmt:v=>String(Math.round(v))},
    {k:"cvr",    lb:false,label:"CVR",         fmt:v=>`${v.toFixed(1)}%`,isPp:true},
    {k:"cpc",    lb:true, label:"CPC",         fmt:v=>`$${v.toFixed(2)}`},
    {k:"ctr",    lb:false,label:"CTR",         fmt:v=>`${v.toFixed(2)}%`,isPp:true},
    {k:"impressions",lb:false,label:"Impr.",   fmt:v=>v>=1e6?`${(v/1e6).toFixed(1)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))},
    {k:"budgetPct",lb:true,label:"Budget Use", fmt:v=>`${v.toFixed(0)}%`,isPp:true},
  ];
  return(
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",overflowX:"auto",flexShrink:0}}>
      <div style={{display:"flex",minWidth:"max-content"}}>
        {defs.map((d,idx)=>{
          const cv=cur[d.k]||0;const pv=comp?comp[d.k]||0:null;
          const delta=pv!=null?cv-pv:null;
          const pct=delta!=null&&pv!==0?(delta/Math.abs(pv))*100:null;
          const good=delta===null?null:(d.lb?delta<=0:delta>=0);
          const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";
          const sign=v=>v>0?"+":"";
          return(
            <div key={d.k} style={{flex:"0 0 auto",minWidth:115,padding:"13px 16px",borderRight:idx<defs.length-1?"1px solid #f0f0f0":"none",borderBottom:`3px solid ${good===true?"#1a9e4a":good===false?"#d42b2b":"transparent"}`}}>
              <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:6}}>{d.label}</div>
              <div style={{fontSize:19,fontWeight:800,color:"#111",letterSpacing:"-0.4px",lineHeight:1,marginBottom:4}}>{d.fmt(cv)}</div>
              {comp&&pct!=null&&<div>
                <div style={{fontSize:11,fontWeight:700,color:dc,display:"flex",alignItems:"center",gap:3,marginBottom:1}}>
                  <i className={`ti ${good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:10}}/>{sign(pct)}{Math.abs(pct).toFixed(1)}%<span style={{fontSize:9,color:"#ccc",fontWeight:400,marginLeft:2}}>vs prev</span>
                </div>
                {delta!=null&&<div style={{fontSize:10,color:dc,fontWeight:600}}>{d.isPp?`${sign(delta)}${Math.abs(delta).toFixed(1)}pp`:`${sign(delta)}${d.fmt(Math.abs(delta))}`}</div>}
              </div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ── CH Alert Card ───────────────────────────────────────────── */
function CHAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555",low:"#888"};
  const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)",medium:"rgba(0,0,0,0.02)"};
  const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"#eee"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          <i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity],color:sc[a.severity],fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
          </div>
          <div style={{fontSize:11,color:"#555",fontWeight:500,marginBottom:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.campaign}</div>
          {!open&&<div style={{fontSize:10,color:"#888"}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
          <span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span>
          <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/>
        </div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4,fontSize:10}}/>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Estimated impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}>
          <div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Recommended Action</div>
          <div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div>
        </div>
      </div>}
    </div>
  );
}

/* ── CH Campaign Table ───────────────────────────────────────── */
function CHCampaignTable({rows,cm,compMap}){
  const[search,setSearch]=useState("");
  const[sortKey,setSortKey]=useState("health");
  const[sortDir,setSortDir]=useState("asc");
  const[expanded,setExpanded]=useState(null);
  const[filterCls,setFilterCls]=useState("All");

  const CLS_FILTERS=["All","Critical","Declining","Warning","Scaling Opp.","Healthy"];

  const processed=useMemo(()=>rows.map((r,i)=>{
    const m=chRow(r,cm);
    const comp=compMap?compMap[m.campaign.toLowerCase()]||null:null;
    const scores=calcHealthScore(m,comp);
    const hl=healthLabel(scores.overall);
    return{r,m,comp,scores,hl,id:i};
  }).filter(x=>x.m.campaign&&x.m.spend>0),[rows,cm,compMap]);

  const filtered=useMemo(()=>{
    let d=processed;
    if(search){const q=search.toLowerCase();d=d.filter(x=>x.m.campaign.toLowerCase().includes(q));}
    if(filterCls!=="All")d=d.filter(x=>x.hl.label===filterCls);
    return d;
  },[processed,search,filterCls]);

  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{
    if(sortKey==="health")return sortDir==="asc"?a.scores.overall-b.scores.overall:b.scores.overall-a.scores.overall;
    if(sortKey==="camp")return sortDir==="asc"?a.m.campaign.localeCompare(b.m.campaign):b.m.campaign.localeCompare(a.m.campaign);
    const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;
    return sortDir==="asc"?va-vb:vb-va;
  }),[filtered,sortKey,sortDir]);

  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir(k==="health"?"asc":"desc");}}

  const clsCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.hl.label]=(m[x.hl.label]||0)+1;});return m;},[processed]);

  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const fmtU=v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`;
  const DC=({cur,prev,fmt,lb,isPp})=>{const d=prev!=null?cur-prev:null;const good=d===null?null:(lb?d<=0:d>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";return<><div style={{fontSize:12,fontWeight:500,color:"#111",lineHeight:1.4}}>{fmt(cur)}</div>{d!=null&&Math.abs(d)>0.001&&<div style={{fontSize:10,fontWeight:600,color:dc}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}</>;};

  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      {/* Toolbar */}
      <div style={{padding:"10px 18px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:180}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search campaign…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {CLS_FILTERS.map(f=>{const cnt=f==="All"?processed.length:clsCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterCls===f;return<button key={f} onClick={()=>setFilterCls(f)} style={{padding:"4px 10px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/>
        <span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> campaigns</span>
      </div>

      {/* Table */}
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("health")}>Health <SI col="health"/></th>
            <th style={thS} onClick={()=>toggleSort("camp")}>Campaign <SI col="camp"/></th>
            <th style={{...thS,cursor:"default"}}>Type</th>
            <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
            <th style={thS} onClick={()=>toggleSort("sales")}>Sales <SI col="sales"/></th>
            <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
            <th style={thS} onClick={()=>toggleSort("roas")}>ROAS <SI col="roas"/></th>
            <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
            <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
            <th style={thS} onClick={()=>toggleSort("cpc")}>CPC <SI col="cpc"/></th>
            <th style={thS} onClick={()=>toggleSort("impressions")}>Impr. <SI col="impressions"/></th>
            <th style={thS} onClick={()=>toggleSort("budgetPct")}>Budget <SI col="budgetPct"/></th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,scores,hl,id},i)=>{
              const isExp=expanded===id;
              const rowBg=isExp?"rgba(79,70,229,0.02)":i%2===0?"#fff":"#fafafa";
              return(<>
                <tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:rowBg,cursor:"pointer"}} onClick={()=>setExpanded(isExp?null:id)}>
                  <td style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:7}}>
                      <div style={{width:34,height:34,borderRadius:8,background:hl.bg,border:`1.5px solid ${hl.color}33`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <span style={{fontSize:12,fontWeight:800,color:hl.color}}>{scores.overall}</span>
                      </div>
                      <span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:hl.bg,color:hl.color,fontWeight:700}}>{hl.label}</span>
                    </div>
                  </td>
                  <td style={{padding:"8px 10px",maxWidth:220}} title={m.campaign}><div style={{fontWeight:600,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.campaign}</div></td>
                  <td style={{padding:"8px 10px"}}><span style={{fontSize:10,padding:"2px 6px",borderRadius:3,background:"#f0f0f0",color:"#555",fontWeight:600}}>{m.type||"SP"}</span></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.spend} prev={comp?.spend} fmt={fmtU} lb={true}/></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.sales} prev={comp?.sales} fmt={fmtU} lb={false}/></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.acos} prev={comp?.acos} fmt={v=>`${v.toFixed(1)}%`} lb={true} isPp={true}/></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.roas} prev={comp?.roas} fmt={v=>v.toFixed(2)} lb={false}/></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.orders} prev={comp?.orders} fmt={v=>String(Math.round(v))} lb={false}/></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cvr} prev={comp?.cvr} fmt={v=>`${v.toFixed(1)}%`} lb={false} isPp={true}/></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cpc} prev={comp?.cpc} fmt={v=>`$${v.toFixed(2)}`} lb={true}/></td>
                  <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.impressions} prev={comp?.impressions} fmt={v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))} lb={false}/></td>
                  <td style={{padding:"8px 10px"}}>{m.budget>0?<div style={{fontSize:11,fontWeight:600,color:m.budgetPct>=95?"#d42b2b":m.budgetPct>=80?"#c47a00":"#1a7a3c"}}>{m.budgetPct.toFixed(0)}%</div>:"-"}</td>
                </tr>
                {isExp&&<tr key={`exp-${id}`} style={{background:"rgba(79,70,229,0.015)",borderBottom:"1px solid #f0f0f0"}}>
                  <td colSpan={12} style={{padding:"12px 16px"}}>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:12}}>
                      {[{label:"Efficiency",val:scores.efficiency},{label:"Conversion",val:scores.conversion},{label:"Scaling",val:scores.scaling},{label:"Structural",val:scores.structural}].map(s=>{
                        const c=s.val>=75?"#1a7a3c":s.val>=55?"#c47a00":"#d42b2b";
                        return<div key={s.label} style={{padding:"10px 12px",background:"#fff",borderRadius:8,border:"1px solid #f0f0f0"}}>
                          <div style={{fontSize:10,color:"#aaa",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:4}}>{s.label} Score</div>
                          <div style={{fontSize:20,fontWeight:800,color:c}}>{s.val}</div>
                          <div style={{marginTop:5,height:3,borderRadius:2,background:"#f0f0f0"}}><div style={{height:3,borderRadius:2,background:c,width:`${s.val}%`}}/></div>
                        </div>;
                      })}
                    </div>
                    <div style={{fontSize:11,color:"#666",padding:"8px 10px",background:"#fff",borderRadius:7,border:"1px solid #f0f0f0"}}>
                      {scores.overall<50?"⚠️ This campaign needs immediate attention. Address spend efficiency before considering any budget changes."
                        :scores.overall<65?"📊 Performance is below target. Focus on bid optimization and search term cleanup."
                        :scores.overall<80?"✅ Decent performance. Look for incremental improvements in match type efficiency."
                        :"🚀 Strong campaign. Safe to scale budget if impression share allows."}
                    </div>
                  </td>
                </tr>}
              </>);
            })}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px 0",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No campaigns match</div></div>}
      </div>
    </div>
  );
}

/* ── CH Workspace ────────────────────────────────────────────── */
function CHWorkspace({curData,compData,periods,onReupload}){
  const cm=useMemo(()=>curData?chDetect(curData.headers):{},[curData]);
  const compCm=useMemo(()=>compData?chDetect(compData.headers):{},[compData]);
  const curAgg=useMemo(()=>curData?chAgg(curData.rows,cm):{},[curData,cm]);
  const compAgg=useMemo(()=>compData?chAgg(compData.rows,compCm):null,[compData,compCm]);
  const compMap=useMemo(()=>{
    if(!compData)return null;
    const m={};
    compData.rows.forEach(r=>{const row=chRow(r,compCm);if(row.campaign)m[row.campaign.toLowerCase()]=row;});
    return m;
  },[compData,compCm]);
  const alerts=useMemo(()=>curData?generateCHAlerts(curData.rows,cm,compMap):[],[curData,cm,compMap]);
  const insights=useMemo(()=>curData?generateCHInsights(curAgg,compAgg,curData.rows,cm):[],[curAgg,compAgg,curData,cm]);
  const[activeTab,setActiveTab]=useState("overview");
  const critCount=alerts.filter(a=>a.severity==="critical").length;

  const TAB_DATA=[
    {key:"overview",label:"Health Overview",icon:"ti-heart-rate-monitor"},
    {key:"alerts",  label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},
    {key:"campaigns",label:"Campaign Table",icon:"ti-table"},
    {key:"insights",label:"AI Insights",icon:"ti-brain"},
  ];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {/* Header */}
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Campaign Health Center</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/>
            <span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{curData?.rows?.filter(r=>chRow(r,cm).spend>0).length||0} active campaigns</span>
          </div>
        </div>
        <button onClick={onReupload} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:12,fontWeight:500,cursor:"pointer"}}>
          <i className="ti ti-upload" style={{fontSize:13}}/> Re-upload
        </button>
      </div>

      {/* KPI Overview */}
      <CHOverviewBar cur={curAgg} comp={compAgg?.spend>0?compAgg:null}/>

      {/* Tabs */}
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TAB_DATA.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)}
          style={{padding:"10px 16px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:6,whiteSpace:"nowrap"}}>
          <i className={`ti ${t.icon}`} style={{fontSize:12}}/>{t.label}
        </button>)}
      </div>

      {/* Tab content */}
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>

        {/* OVERVIEW TAB */}
        {activeTab==="overview"&&(
          <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
            <div style={{maxWidth:900,margin:"0 auto",padding:"20px 22px"}}>
              {/* Score distribution */}
              <div style={{marginBottom:20}}>
                <ModuleOverview
            moduleName="Campaign Health" moduleIcon="ti-heart-rate-monitor" periods={periods}
            cur={curAgg} comp={compAgg?.spend>0?compAgg:null}
            rows={curData?.rows||[]}
            alerts={alerts.slice(0,3).map(a=>({type:a.severity==="critical"?"critical":a.severity==="warning"?"loss":"win",icon:"ti-speakerphone",title:a.title,detail:a.explanation||""}))}
          />
          <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10,marginTop:12}}>Campaign Health Distribution</div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:8}}>
                  {[{label:"Critical",color:"#d42b2b",bg:"rgba(212,43,43,0.08)",max:30},{label:"Declining",color:"#d42b2b",bg:"rgba(212,43,43,0.05)",min:30,max:50},{label:"Warning",color:"#c47a00",bg:"rgba(196,122,0,0.07)",min:50,max:65},{label:"Scaling Opp.",color:"#1a50a0",bg:"rgba(26,80,160,0.07)",min:65,max:82},{label:"Healthy",color:"#1a7a3c",bg:"rgba(26,122,60,0.07)",min:82}].map(cat=>{
                    const count=curData?.rows?.filter(r=>{const m=chRow(r,cm);if(!m.campaign||m.spend===0)return false;const s=calcHealthScore(m,compMap?compMap[m.campaign.toLowerCase()]||null:null).overall;return(!cat.min||s>=cat.min)&&(!cat.max||s<cat.max);}).length||0;
                    return(
                      <div key={cat.label} style={{padding:"14px 14px",background:cat.bg,borderRadius:10,border:`1px solid ${cat.color}22`,textAlign:"center"}}>
                        <div style={{fontSize:24,fontWeight:800,color:cat.color,marginBottom:4}}>{count}</div>
                        <div style={{fontSize:11,fontWeight:600,color:cat.color}}>{cat.label}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* AI Summary quick view */}
              {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:20}}>
                <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}>
                  <i className="ti ti-brain" style={{fontSize:13,color:R}}/>
                  <div style={{fontSize:12,fontWeight:700,color:"#111"}}>Quick Strategic Summary</div>
                  <div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div>
                </div>
                {insights.slice(0,3).map((ins,i)=>{
                  const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",critical:"#d42b2b",neutral:"#555"};
                  const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-rocket",critical:"ti-droplet-off",neutral:"ti-minus"};
                  return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}>
                    <div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                      <i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/>
                    </div>
                    <div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div>
                  </div>;
                })}
              </div>}
              {/* Top critical alerts preview */}
              {alerts.length>0&&<div>
                <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Top Priority Alerts</div>
                {alerts.slice(0,4).map((a,i)=><CHAlertCard key={i} alert={a}/>)}
                {alerts.length>4&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),marginTop:4,width:"100%",justifyContent:"center"}}>View All {alerts.length} Alerts →</button>}
              </div>}
            </div>
          </div>
        )}

        {/* ALERTS TAB */}
        {activeTab==="alerts"&&(
          <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
            <div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>
              {alerts.length===0
                ?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-circle-check" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No health alerts detected</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All campaigns are within acceptable performance thresholds.</div></div>
                :alerts.map((a,i)=><CHAlertCard key={i} alert={a}/>)}
            </div>
          </div>
        )}

        {/* CAMPAIGNS TAB */}
        {activeTab==="campaigns"&&<CHCampaignTable rows={curData?.rows||[]} cm={cm} compMap={compMap}/>}

        {/* INSIGHTS TAB */}
        {activeTab==="insights"&&(
          <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
            <div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}>
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
                  <i className="ti ti-brain" style={{fontSize:14,color:R}}/>
                  <div style={{fontSize:14,fontWeight:700,color:"#111"}}>AI Strategic Analysis</div>
                  <div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on your uploaded campaign data only</div>
                </div>
                {insights.length===0
                  ?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><i className="ti ti-file-search" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div>Upload comparison period data to enable trend analysis</div></div>
                  :insights.map((ins,i)=>{
                    const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",critical:"#d42b2b",neutral:"#555"};
                    const tb={positive:"rgba(26,122,60,0.05)",negative:"rgba(212,43,43,0.04)",opportunity:"rgba(26,80,160,0.05)",critical:"rgba(212,43,43,0.05)",neutral:"rgba(0,0,0,0.02)"};
                    const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-rocket",critical:"ti-droplet-off",neutral:"ti-minus"};
                    return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}>
                      <div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                        <i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/>
                      </div>
                      <div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div>
                    </div>;
                  })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Campaign Health Module Root ─────────────────────────────── */
function CampaignHealthModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.primary?"workspace":"upload");
  const[periods,setPeriods]=useState(globalData?.periods||null);
  const[curData,setCurData]=useState(globalData?.cur?.primary||null);
  const[compData,setCompData]=useState(globalData?.comp?.primary||null);
  useEffect(()=>{if(globalData?.cur?.primary&&page==="upload"){setCurData(globalData.cur.primary);setCompData(globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);

  if(page==="workspace"&&curData){
    return<CHWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>setPage("upload")}/>;
  }
  return(
    <CHUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)}
      onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/>
  );
}

/* ================================================================
   IMPRESSION SHARE INTELLIGENCE MODULE
   Visibility intelligence system for Amazon PPC strategists.
   Strict scope: upload page + visibility workspace only.
================================================================ */

/* ── IS Column aliases — covers campaign + placement reports ─── */
const IS_ALIASES={
  campaign:    ["Campaign Name","Campaign","campaign name"],
  type:        ["Campaign Type","Type","Ad Type"],
  state:       ["Campaign State","State","Status"],
  portfolio:   ["Portfolio Name","Portfolio"],
  impressions: ["Impressions","impressions","Total Impressions"],
  clicks:      ["Clicks","clicks"],
  spend:       ["Spend","Cost","Ad Spend"],
  sales:       ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales"],
  orders:      ["Orders","14 Day Total Orders (#)","14 Day Total Orders"],
  cpc:         ["CPC","Cost Per Click","Average CPC"],
  ctr:         ["Click-through Rate","CTR"],
  cvr:         ["Conversion Rate","CVR"],
  acos:        ["ACOS","ACoS"],
  tosShare:    ["Top of Search (Impression Share)","TOS Impression Share","Top of Search %","Impression Share - Top"],
  losShare:    ["Lost Impression Share (Budget)","Lost IS Budget","Lost Impression Share (Rank)","Lost IS Rank","Lost Impression Share"],
  clickShare:  ["Click Share","Click share"],
  placement:   ["Placement","Placement Type"],
  budget:      ["Daily Budget","Budget"],
};

function isDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(IS_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function isNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function isRowMetrics(row,cm){
  const imp=isNum(row,cm.impressions),clk=isNum(row,cm.clicks),
    spd=isNum(row,cm.spend),sal=isNum(row,cm.sales),ord=isNum(row,cm.orders);
  const ctr=cm.ctr&&isNum(row,cm.ctr)>0?isNum(row,cm.ctr):imp>0?(clk/imp)*100:0;
  const cvr=cm.cvr&&isNum(row,cm.cvr)>0?isNum(row,cm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=clk>0?spd/clk:0;
  const acos=cm.acos&&isNum(row,cm.acos)>0?isNum(row,cm.acos):sal>0?(spd/sal)*100:0;
  const tosShare=isNum(row,cm.tosShare);
  const losShare=isNum(row,cm.losShare);
  const clickShare=isNum(row,cm.clickShare);
  const budget=isNum(row,cm.budget);
  const budgetPct=budget>0?(spd/budget)*100:0;
  return{
    campaign:String(row[cm.campaign]||""),type:String(row[cm.type]||""),
    state:String(row[cm.state]||"").toLowerCase(),portfolio:String(row[cm.portfolio]||""),
    impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    ctr,cvr,cpc,acos,tosShare,losShare,clickShare,budget,budgetPct,
    // Visibility score 0–100 from available data
    visScore:imp>0?Math.min(100,Math.round((imp/Math.max(imp,1))*100)):0,
  };
}

function isAgg(rows,cm){
  let imp=0,clk=0,spd=0,sal=0,ord=0,tos=0,los=0,cs=0,n=0;
  rows.forEach(r=>{
    const m=isRowMetrics(r,cm);
    imp+=m.impressions;clk+=m.clicks;spd+=m.spend;sal+=m.sales;ord+=m.orders;
    if(m.tosShare>0){tos+=m.tosShare;n++;}
    if(m.losShare>0)los+=m.losShare;
    if(m.clickShare>0)cs+=m.clickShare;
  });
  const cnt=Math.max(rows.filter(r=>isNum(r,cm.impressions)>0).length,1);
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    acos:sal>0?(spd/sal)*100:0,ctr:imp>0?(clk/imp)*100:0,
    cvr:clk>0?(ord/clk)*100:0,cpc:clk>0?spd/clk:0,
    tosShare:n>0?tos/n:0,losShare:cnt>0?los/cnt:0,clickShare:cnt>0?cs/cnt:0};
}

/* ── Visibility classification ───────────────────────────────── */
function classifyVisibility(m, comp){
  // Immediate attention: significant impression loss
  if(comp&&comp.impressions>200&&m.impressions<comp.impressions*0.55&&m.orders>0)
    return{cls:"Declining",priority:0,color:"#d42b2b",bg:"rgba(212,43,43,0.07)",icon:"ti-eye-off"};
  // Budget/bid suppression
  if(m.budgetPct>=95&&m.impressions>0)
    return{cls:"Suppressed",priority:1,color:"#d42b2b",bg:"rgba(212,43,43,0.06)",icon:"ti-coin-off"};
  // Scale opportunity: good CVR but low impressions
  if(m.cvr>3&&m.impressions<3000&&m.orders>=2&&m.acos>0&&m.acos<30)
    return{cls:"Scale Opp.",priority:2,color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-rocket"};
  // TOS opportunity: converting well but TOS share is low
  if(m.cvr>2&&m.tosShare>0&&m.tosShare<30&&m.orders>=2)
    return{cls:"TOS Opp.",priority:2,color:"#6338c8",bg:"rgba(99,56,200,0.08)",icon:"ti-trending-up"};
  // Gaining momentum
  if(comp&&m.impressions>comp.impressions*1.2&&m.acos>0&&m.acos<35)
    return{cls:"Growing",priority:3,color:"#1a7a3c",bg:"rgba(26,122,60,0.06)",icon:"ti-chart-line"};
  // Placement weakness: spending but low TOS exposure
  if(m.spend>20&&m.tosShare>0&&m.tosShare<15&&m.acos<40)
    return{cls:"Placement Weak",priority:3,color:"#c47a00",bg:"rgba(196,122,0,0.07)",icon:"ti-layout-2"};
  // Stable/healthy visibility
  if(m.impressions>500&&m.acos>0&&m.acos<40)
    return{cls:"Stable",priority:4,color:"#555",bg:"rgba(0,0,0,0.03)",icon:"ti-check"};
  return{cls:"Monitor",priority:5,color:"#aaa",bg:"transparent",icon:"ti-minus"};
}

/* ── Visibility alert generator ──────────────────────────────── */
function generateISAlerts(rows,cm,compMap){
  const alerts=[];
  rows.forEach(row=>{
    const m=isRowMetrics(row,cm);
    const comp=compMap?compMap[m.campaign.toLowerCase()]||null:null;
    if(!m.campaign||m.impressions===0)return;

    // Impression share loss
    if(comp&&comp.impressions>300&&m.impressions<comp.impressions*0.60&&m.orders>0){
      const pct=((m.impressions-comp.impressions)/comp.impressions)*100;
      alerts.push({severity:"critical",type:"Impression Share Loss",icon:"ti-eye-off",color:"#d42b2b",
        campaign:m.campaign,
        comparison:`${(comp.impressions/1000).toFixed(1)}K → ${(m.impressions/1000).toFixed(1)}K impressions (${pct.toFixed(0)}%)`,
        cause:`Visibility dropped ${Math.abs(pct).toFixed(0)}% vs previous period. This campaign is losing auction presence despite having proven conversions. Likely causes: bid reductions, budget limitations, or increased competitor activity.`,
        action:"Increase bids on converting keywords by 15–20%. Check daily budget utilization. Review auction competitiveness.",
        impact:`Estimated missed orders: ~${Math.round((comp.impressions-m.impressions)*m.cvr/100)}`,confidence:88});
    }

    // TOS decline
    if(comp&&comp.tosShare>20&&m.tosShare>0&&m.tosShare<comp.tosShare*0.65){
      const pct=((m.tosShare-comp.tosShare)/comp.tosShare)*100;
      alerts.push({severity:"high",type:"Top of Search Decline",icon:"ti-arrow-down",color:"#c47a00",
        campaign:m.campaign,
        comparison:`TOS Share: ${comp.tosShare.toFixed(1)}% → ${m.tosShare.toFixed(1)}% (${pct.toFixed(0)}%)`,
        cause:`Top of Search impression share dropped ${Math.abs(pct).toFixed(0)}%. TOS placements drive the strongest conversion rates — losing TOS share directly reduces campaign efficiency and organic rank momentum.`,
        action:"Increase TOS bid modifier by 20–30%. Review keyword bids. Consider dedicated TOS-focused campaigns.",
        impact:`Reduced TOS visibility affects both paid CVR and organic rank signals`,confidence:83});
    }

    // Budget suppression
    if(m.budget>0&&m.budgetPct>=96&&m.acos>0&&m.acos<35){
      alerts.push({severity:"high",type:"Visibility Suppression",icon:"ti-coin-off",color:"#c47a00",
        campaign:m.campaign,
        comparison:`Budget: $${m.budget.toFixed(0)}/day · Used: ${m.budgetPct.toFixed(0)}% · ACoS: ${m.acos.toFixed(1)}%`,
        cause:"Campaign is hitting its daily budget cap while maintaining profitable ACoS. Impressions are being artificially throttled — you're leaving profitable traffic uncaptured due to a budget constraint, not a performance problem.",
        action:"Increase daily budget by 30–50%. This campaign is profitable — budget is the only limiting factor.",
        impact:`Estimated additional profitable orders available if budget increased`,confidence:94});
    }

    // CPC-driven visibility loss
    if(comp&&comp.cpc>0&&m.cpc>comp.cpc*1.35&&m.impressions<comp.impressions*0.80){
      const cpcp=((m.cpc-comp.cpc)/comp.cpc)*100;
      alerts.push({severity:"high",type:"CPC Pressure Reducing Visibility",icon:"ti-trending-up",color:"#c47a00",
        campaign:m.campaign,
        comparison:`CPC +${cpcp.toFixed(0)}% · Impressions -${(((comp.impressions-m.impressions)/comp.impressions)*100).toFixed(0)}%`,
        cause:"Rising CPCs are forcing Amazon's system to show ads less frequently to stay within budget. Higher auction costs are restricting impression delivery.",
        action:"Tighten match types to reduce irrelevant expensive clicks. Review search term reports for CPC inflation sources.",
        impact:`CPC reduction of 15–20% could recover visibility without budget increase`,confidence:79});
    }

    // Sudden visibility spike (anomaly)
    if(comp&&comp.impressions>0&&m.impressions>comp.impressions*2.5&&m.acos>50){
      alerts.push({severity:"medium",type:"Impression Spike — Low Efficiency",icon:"ti-alert-triangle",color:"#c47a00",
        campaign:m.campaign,
        comparison:`Impressions: ${(comp.impressions/1000).toFixed(1)}K → ${(m.impressions/1000).toFixed(1)}K (+${(((m.impressions-comp.impressions)/comp.impressions)*100).toFixed(0)}%)`,
        cause:"Significant impression increase without proportional conversion growth — likely triggered by match type broadening, bid increase, or campaign structure change. High ACoS suggests traffic quality is low.",
        action:"Review what changed in this campaign. Audit search terms for newly triggered broad-match traffic. Tighten targeting.",
        impact:`ACoS ${m.acos.toFixed(1)}% — visibility increase is unprofitable at current efficiency`,confidence:74});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3));
}

/* ── Scale opportunity detector ──────────────────────────────── */
function generateISOpportunities(rows,cm,compMap){
  const opps=[];
  rows.forEach(row=>{
    const m=isRowMetrics(row,cm);
    const comp=compMap?compMap[m.campaign.toLowerCase()]||null:null;
    if(!m.campaign||m.spend===0)return;

    // High CVR, low impressions — classic scale signal
    if(m.cvr>4&&m.impressions<3000&&m.orders>=2&&m.acos>0&&m.acos<28){
      opps.push({icon:"ti-rocket",color:"#1a7a3c",type:"scale",
        title:"Under-Exposed Winner",campaign:m.campaign,
        why:`CVR ${m.cvr.toFixed(1)}% with only ${(m.impressions/1000).toFixed(1)}K impressions — strong converter, severely under-exposed`,
        movement:comp?`Impressions: ${(comp.impressions/1000).toFixed(1)}K → ${(m.impressions/1000).toFixed(1)}K`:"First period data",
        action:"Increase daily budget 40–60%. Push bids up 20% on top converting keywords. Add TOS bid modifier.",
        impact:"Every 1K additional impressions at this CVR generates ~"+Math.round(1000*m.cvr/100)+" additional orders"});
    }

    // Strong TOS performance — dominate it
    if(m.tosShare>40&&m.cvr>3&&m.acos>0&&m.acos<30&&m.orders>=3){
      opps.push({icon:"ti-crown",color:"#6338c8",type:"tos",
        title:"TOS Dominance Opportunity",campaign:m.campaign,
        why:`TOS share ${m.tosShare.toFixed(0)}% with ${m.cvr.toFixed(1)}% CVR — strong TOS performer that can scale`,
        movement:comp?`TOS: ${comp.tosShare.toFixed(0)}% → ${m.tosShare.toFixed(0)}%`:"TOS share: "+m.tosShare.toFixed(0)+"%",
        action:"Increase TOS modifier by 20–30% further. This campaign converts well at TOS — push for dominance.",
        impact:"Higher TOS share improves both paid conversion and organic rank signals simultaneously"});
    }

    // Gaining momentum — push now
    if(comp&&m.impressions>comp.impressions*1.25&&m.acos>0&&m.acos<32&&m.orders>=2){
      const impp=((m.impressions-comp.impressions)/comp.impressions)*100;
      opps.push({icon:"ti-trending-up",color:"#1a7a3c",type:"momentum",
        title:"Visibility Momentum — Scale Now",campaign:m.campaign,
        why:`Impressions grew +${impp.toFixed(0)}% while maintaining ${m.acos.toFixed(1)}% ACoS — momentum is building`,
        movement:`${(comp.impressions/1000).toFixed(1)}K → ${(m.impressions/1000).toFixed(1)}K impressions`,
        action:"Increase budget 20–30% immediately to sustain momentum. Don't let budget cap kill the growth phase.",
        impact:"Sustaining visibility momentum during growth phase compounds ranking improvements"});
    }

    // Lost impression share + converts = under-bid
    if(m.losShare>30&&m.cvr>2&&m.orders>=2){
      opps.push({icon:"ti-eye",color:"#c47a00",type:"underbid",
        title:"Lost Share Recovery",campaign:m.campaign,
        why:`${m.losShare.toFixed(0)}% impression share is being lost — campaign converts at ${m.cvr.toFixed(1)}% but isn't winning enough auctions`,
        movement:comp?`Lost share: ${comp.losShare.toFixed(0)}% → ${m.losShare.toFixed(0)}%`:`Lost share: ${m.losShare.toFixed(0)}%`,
        action:"Increase bids by 15–25% on converting keywords. Review which placement is losing share most.",
        impact:`Recovering 50% of lost share at current CVR = ~${Math.round(m.impressions*0.5*m.losShare/100*m.cvr/100)} additional orders`});
    }
  });

  return opps.slice(0,12); // cap at 12 to keep UI clean
}

/* ── AI Visibility Insights ─────────────────────────────────── */
function generateISInsights(curAgg,compAgg,rows,cm){
  const lines=[];
  if(!curAgg||!Object.keys(curAgg).length)return lines;
  const pct=(k)=>compAgg&&compAgg[k]>0?((curAgg[k]-compAgg[k])/compAgg[k])*100:null;
  const impPct=pct("impressions");const cpcPct=pct("cpc");const salesPct=pct("sales");

  if(impPct!=null){
    lines.push({type:impPct>10?"positive":impPct<-10?"negative":"neutral",
      icon:impPct>0?"ti-trending-up":"ti-trending-down",
      text:impPct>10
        ?`Total impressions grew ${impPct.toFixed(0)}% vs previous period. ${curAgg.acos>0&&curAgg.acos<35?"Visibility growth is aligned with profitable performance — this is a healthy expansion signal.":"Monitor efficiency — ensure impression growth is driven by relevant traffic, not broad-match inflation."}`
        :impPct<-10
        ?`Total impressions dropped ${Math.abs(impPct).toFixed(0)}% vs previous period. Primary causes of impression loss are typically: bid reductions below competitive threshold, budget caps throttling delivery, or increased competitor investment in shared auctions.`
        :`Overall visibility is relatively stable (${impPct>0?"+":""}${impPct.toFixed(1)}%). Focus on redistributing impression share from low-efficiency to high-efficiency campaigns.`});
  }

  if(curAgg.tosShare>0&&compAgg?.tosShare>0){
    const tosDelta=curAgg.tosShare-compAgg.tosShare;
    if(Math.abs(tosDelta)>3){
      lines.push({type:tosDelta>0?"positive":"negative",icon:tosDelta>0?"ti-arrow-up":"ti-arrow-down",
        text:tosDelta>0
          ?`Top of Search impression share improved by ${tosDelta.toFixed(1)} percentage points. TOS placements deliver the strongest CVR and have the highest impact on organic rank — this is a positive visibility signal.`
          :`Top of Search impression share declined by ${Math.abs(tosDelta).toFixed(1)} percentage points. Losing TOS share reduces both paid CVR and organic ranking momentum. Increase TOS bid modifiers by 15–25% to recover this share.`});
    }
  }

  if(cpcPct!=null&&cpcPct>20){
    lines.push({type:"negative",icon:"ti-coin",
      text:`Average CPC increased ${cpcPct.toFixed(0)}% — rising auction costs are restricting impression delivery within fixed budgets. Tighten match types and audit broad-match search terms to reduce CPC without sacrificing relevant visibility.`});
  }

  const suppressed=rows.filter(r=>{const m=isRowMetrics(r,cm);return m.budget>0&&m.budgetPct>=95&&m.acos>0&&m.acos<35&&m.orders>0;});
  if(suppressed.length>0){
    lines.push({type:"opportunity",icon:"ti-rocket",
      text:`${suppressed.length} campaign${suppressed.length>1?"s are":"is"} being suppressed by budget caps while maintaining profitable efficiency. These campaigns have proven they can convert — the only constraint is budget. Increasing their budgets represents the lowest-risk scaling opportunity in the account.`});
  }

  const losers=rows.filter(r=>{const m=isRowMetrics(r,cm);const comp=null;return m.losShare>35&&m.cvr>2&&m.orders>=2;});
  if(losers.length>0){
    lines.push({type:"negative",icon:"ti-eye-off",
      text:`${losers.length} campaign${losers.length>1?"s are":"is"} losing more than 35% of available impression share despite having proven conversion rates. These are under-bid relative to their conversion value — increasing bids would recover visibility with profitable returns.`});
  }

  return lines;
}

/* ── IS Upload Zone (module-level) ───────────────────────────── */
function ISUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"13px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:11}}>
        <div style={{width:34,height:34,borderRadius:8,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:15,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:11,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:11,color:R,fontWeight:600,marginTop:3}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:11}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 12px",borderRadius:7,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:11,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const IS_REPORT_TYPES=[
  {id:"campaign",  label:"Campaign Report",         icon:"ti-speakerphone",required:true, desc:"Core visibility data — impressions, clicks, spend, TOS share if available"},
  {id:"placement", label:"Placement Report",         icon:"ti-layout-2",   required:false,desc:"TOS, Product Pages, and Rest of Search breakdown"},
  {id:"searchterm",label:"Search Term Report",       icon:"ti-search",     required:false,desc:"Query-level visibility and impression data"},
  {id:"bulk",      label:"Bulk File",                icon:"ti-file-spreadsheet",required:false,desc:"Impression share columns from bulk export"},
];

/* ── IS Upload Page ──────────────────────────────────────────── */
function ISUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  function setFile(id,f){setFiles(p=>({...p,[id]:f}));}function clearFile(id){setFiles(p=>{const n={...p};delete n[id];return n;});}
  function setCompFile(id,f){setCompFiles(p=>({...p,[id]:f}));}function clearCompFile(id){setCompFiles(p=>{const n={...p};delete n[id];return n;});}
  async function go(){
    if(!files.campaign)return;setLoading(true);setErr(null);
    try{const cur=await parseSheet(files.campaign);let comp=null;if(compFiles.campaign)comp=await parseSheet(compFiles.campaign);onComplete({cur,comp,periods:localPeriods});}
    catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:720,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Impression Share Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload raw Amazon reports. The system automatically detects impression share, TOS share, click share, and visibility columns.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div>
            <span style={{fontSize:11,color:"#888"}}>{fmtDisp(localPeriods?.current?.start)} — {fmtDisp(localPeriods?.current?.end)}</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{IS_REPORT_TYPES.map(t=><ISUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:14}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"9px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period {localPeriods?.comp&&<span style={{fontSize:11,color:"#888",fontWeight:400,marginLeft:4}}>{fmtDisp(localPeriods.comp.start)} — {fmtDisp(localPeriods.comp.end)}</span>}
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><div style={{width:8,height:8,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{IS_REPORT_TYPES.map(t=><ISUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px",marginBottom:14}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:9}}>How to get Impression Share data from Amazon</div>
          {["Go to Amazon Advertising Console → Reports → Create Report","Select Campaign Report — it includes impression and click data","For TOS share: download Placement Report (Placement tab)","Set date range matching your selected period above","Upload directly — no formatting needed"].map((s,i)=>(<div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>))}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>Note: Amazon's standard Campaign Report does not include TOS impression share as a column. For full TOS analysis, also upload the Placement Report.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}><i className="ti ti-alert-triangle" style={{marginRight:5}}/>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.campaign||loading} style={{...T.btnR(false),opacity:files.campaign&&!loading?1:0.4,fontWeight:700,boxShadow:files.campaign?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-eye" style={{fontSize:14}}/> Run Visibility Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── IS Overview KPI Bar ─────────────────────────────────────── */
function ISOverviewBar({cur,comp}){
  const defs=[
    {k:"impressions",lb:false,label:"Impressions", fmt:v=>v>=1e6?`${(v/1e6).toFixed(1)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))},
    {k:"tosShare",   lb:false,label:"TOS Share",   fmt:v=>v>0?`${v.toFixed(1)}%`:"—",         isPp:true},
    {k:"losShare",   lb:true, label:"Lost IS",     fmt:v=>v>0?`${v.toFixed(1)}%`:"—",         isPp:true},
    {k:"clickShare", lb:false,label:"Click Share", fmt:v=>v>0?`${v.toFixed(1)}%`:"—",         isPp:true},
    {k:"clicks",     lb:false,label:"Clicks",      fmt:v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))},
    {k:"ctr",        lb:false,label:"CTR",         fmt:v=>`${v.toFixed(2)}%`,                  isPp:true},
    {k:"cvr",        lb:false,label:"CVR",         fmt:v=>`${v.toFixed(1)}%`,                  isPp:true},
    {k:"cpc",        lb:true, label:"CPC",         fmt:v=>`$${v.toFixed(2)}`},
    {k:"spend",      lb:true, label:"Spend",       fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`},
    {k:"sales",      lb:false,label:"Sales",       fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`},
  ];
  return(
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",overflowX:"auto",flexShrink:0}}>
      <div style={{display:"flex",minWidth:"max-content"}}>
        {defs.map((d,idx)=>{
          const cv=cur[d.k]||0;const pv=comp?comp[d.k]||0:null;
          const delta=pv!=null?cv-pv:null;const pct=delta!=null&&pv!==0?(delta/Math.abs(pv))*100:null;
          const good=delta===null?null:(d.lb?delta<=0:delta>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";
          return(<div key={d.k} style={{flex:"0 0 auto",minWidth:110,padding:"13px 16px",borderRight:idx<defs.length-1?"1px solid #f0f0f0":"none",borderBottom:`3px solid ${good===true?"#1a9e4a":good===false?"#d42b2b":"transparent"}`}}>
            <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:6}}>{d.label}</div>
            <div style={{fontSize:19,fontWeight:800,color:"#111",letterSpacing:"-0.4px",lineHeight:1,marginBottom:4}}>{d.fmt(cv)}</div>
            {comp&&pct!=null&&<div><div style={{fontSize:11,fontWeight:700,color:dc,display:"flex",alignItems:"center",gap:3,marginBottom:1}}><i className={`ti ${good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:10}}/>{sign(pct)}{Math.abs(pct).toFixed(1)}%<span style={{fontSize:9,color:"#ccc",fontWeight:400,marginLeft:2}}>vs prev</span></div>{delta!=null&&<div style={{fontSize:10,color:dc,fontWeight:600}}>{d.isPp?`${sign(delta)}${Math.abs(delta).toFixed(1)}pp`:`${sign(delta)}${d.fmt(Math.abs(delta))}`}</div>}</div>}
          </div>);
        })}
      </div>
    </div>
  );
}

/* ── IS Alert Card ───────────────────────────────────────────── */
function ISAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555"};const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)"};const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"#eee"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity]||"#f0f0f0",color:sc[a.severity]||"#555",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
          </div>
          <div style={{fontSize:11,color:"#555",fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.campaign}</div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}><span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/></div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4,fontSize:10}}/>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Visibility impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Recommended Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div></div>
      </div>}
    </div>
  );
}

/* ── IS Opportunity Card ─────────────────────────────────────── */
function ISOpportunityCard({opp:o}){
  const[open,setOpen]=useState(false);
  const tc={scale:"#1a7a3c",tos:"#6338c8",momentum:"#1a7a3c",underbid:"#c47a00"};const tb={scale:"rgba(26,122,60,0.05)",tos:"rgba(99,56,200,0.05)",momentum:"rgba(26,122,60,0.04)",underbid:"rgba(196,122,0,0.05)"};const tbr={scale:"rgba(26,122,60,0.18)",tos:"rgba(99,56,200,0.18)",momentum:"rgba(26,122,60,0.15)",underbid:"rgba(196,122,0,0.18)"};
  const c=tc[o.type]||"#1a7a3c";const bg=tb[o.type]||"rgba(26,122,60,0.04)";const br=tbr[o.type]||"rgba(26,122,60,0.15)";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${o.icon}`} style={{fontSize:13,color:c}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>Opportunity</span><span style={{fontSize:12,fontWeight:700,color:"#111"}}>{o.title}</span></div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{o.campaign}</div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{o.why}</div>}
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:`1px solid ${br}`}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}>{o.movement}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{o.why}</div>
        {o.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}>{o.impact}</div>}
        <div style={{padding:"9px 12px",background:bg,borderRadius:8,border:`1px solid ${br}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Scaling Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{o.action}</div></div>
      </div>}
    </div>
  );
}

/* ── IS Visibility Table ─────────────────────────────────────── */
function ISVisibilityTable({rows,cm,compMap}){
  const[search,setSearch]=useState("");const[sortKey,setSortKey]=useState("visCls");const[sortDir,setSortDir]=useState("asc");const[filterCls,setFilterCls]=useState("All");
  const VIS_FILTERS=["All","Declining","Suppressed","Scale Opp.","TOS Opp.","Growing","Stable"];
  const VCLS_ORDER={Declining:0,Suppressed:1,"Scale Opp.":2,"TOS Opp.":2,Growing:3,"Placement Weak":3,Stable:4,Monitor:5};
  const processed=useMemo(()=>rows.map((r,i)=>{const m=isRowMetrics(r,cm);const comp=compMap?compMap[m.campaign.toLowerCase()]||null:null;const cls=classifyVisibility(m,comp);return{r,m,comp,cls,id:i};}).filter(x=>x.m.campaign&&x.m.impressions>0),[rows,cm,compMap]);
  const filtered=useMemo(()=>{let d=processed;if(search){const q=search.toLowerCase();d=d.filter(x=>x.m.campaign.toLowerCase().includes(q));}if(filterCls!=="All")d=d.filter(x=>x.cls.cls===filterCls);return d;},[processed,search,filterCls]);
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{if(sortKey==="visCls")return sortDir==="asc"?(VCLS_ORDER[a.cls.cls]??5)-(VCLS_ORDER[b.cls.cls]??5):(VCLS_ORDER[b.cls.cls]??5)-(VCLS_ORDER[a.cls.cls]??5);if(sortKey==="camp")return sortDir==="asc"?a.m.campaign.localeCompare(b.m.campaign):b.m.campaign.localeCompare(a.m.campaign);const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;}),[filtered,sortKey,sortDir]);
  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir("desc");}}
  const clsCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.cls.cls]=(m[x.cls.cls]||0)+1;});return m;},[processed]);
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const DC=({cur,prev,fmt,lb,isPp})=>{const d=prev!=null?cur-prev:null;const good=d===null?null:(lb?d<=0:d>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";return<><div style={{fontSize:12,fontWeight:500,color:"#111",lineHeight:1.4}}>{fmt(cur)}</div>{d!=null&&Math.abs(d)>0.001&&<div style={{fontSize:10,fontWeight:600,color:dc}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}</>;};
  const fmtI=v=>v>=1e6?`${(v/1e6).toFixed(1)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v));
  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 18px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:180}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search campaign…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {VIS_FILTERS.map(f=>{const cnt=f==="All"?processed.length:clsCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterCls===f;return<button key={f} onClick={()=>setFilterCls(f)} style={{padding:"4px 10px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/><span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> campaigns</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("visCls")}>Visibility <SI col="visCls"/></th>
            <th style={thS} onClick={()=>toggleSort("camp")}>Campaign <SI col="camp"/></th>
            <th style={thS} onClick={()=>toggleSort("impressions")}>Impressions <SI col="impressions"/></th>
            <th style={thS} onClick={()=>toggleSort("tosShare")}>TOS Share <SI col="tosShare"/></th>
            <th style={thS} onClick={()=>toggleSort("losShare")}>Lost IS <SI col="losShare"/></th>
            <th style={thS} onClick={()=>toggleSort("clickShare")}>Click Share <SI col="clickShare"/></th>
            <th style={thS} onClick={()=>toggleSort("ctr")}>CTR <SI col="ctr"/></th>
            <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
            <th style={thS} onClick={()=>toggleSort("cpc")}>CPC <SI col="cpc"/></th>
            <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,cls,id},i)=>(<tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
              <td style={{padding:"7px 10px"}}><div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 8px",borderRadius:6,background:cls.bg,border:`1px solid ${cls.color}22`}}><i className={`ti ${cls.icon}`} style={{fontSize:10,color:cls.color}}/><span style={{fontSize:10,fontWeight:700,color:cls.color,whiteSpace:"nowrap"}}>{cls.cls}</span></div></td>
              <td style={{padding:"8px 10px",maxWidth:210}} title={m.campaign}><div style={{fontWeight:600,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.campaign}</div></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.impressions} prev={comp?.impressions} fmt={fmtI} lb={false}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.tosShare} prev={comp?.tosShare} fmt={v=>v>0?`${v.toFixed(1)}%`:"—"} lb={false} isPp={true}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.losShare} prev={comp?.losShare} fmt={v=>v>0?`${v.toFixed(1)}%`:"—"} lb={true} isPp={true}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.clickShare} prev={comp?.clickShare} fmt={v=>v>0?`${v.toFixed(1)}%`:"—"} lb={false} isPp={true}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.ctr} prev={comp?.ctr} fmt={v=>`${v.toFixed(2)}%`} lb={false} isPp={true}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cvr} prev={comp?.cvr} fmt={v=>`${v.toFixed(1)}%`} lb={false} isPp={true}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cpc} prev={comp?.cpc} fmt={v=>`$${v.toFixed(2)}`} lb={true}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.spend} prev={comp?.spend} fmt={v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`} lb={true}/></td>
            </tr>))}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No campaigns match</div></div>}
      </div>
    </div>
  );
}

/* ── IS Workspace ────────────────────────────────────────────── */
function ISWorkspace({curData,compData,periods,onReupload}){
  const cm=useMemo(()=>curData?isDetect(curData.headers):{},[curData]);
  const compCm=useMemo(()=>compData?isDetect(compData.headers):{},[compData]);
  const curAgg=useMemo(()=>curData?isAgg(curData.rows,cm):{},[curData,cm]);
  const compAgg=useMemo(()=>compData?isAgg(compData.rows,compCm):null,[compData,compCm]);
  const compMap=useMemo(()=>{if(!compData)return null;const m={};compData.rows.forEach(r=>{const row=isRowMetrics(r,compCm);if(row.campaign)m[row.campaign.toLowerCase()]=row;});return m;},[compData,compCm]);
  const alerts=useMemo(()=>curData?generateISAlerts(curData.rows,cm,compMap):[],[curData,cm,compMap]);
  const opportunities=useMemo(()=>curData?generateISOpportunities(curData.rows,cm,compMap):[],[curData,cm,compMap]);
  const insights=useMemo(()=>curData?generateISInsights(curAgg,compAgg,curData.rows,cm):[],[curAgg,compAgg,curData,cm]);
  const[activeTab,setActiveTab]=useState("overview");
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const TABS=[{key:"overview",label:"Visibility Overview",icon:"ti-eye"},{key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},{key:"opportunities",label:`Scale Opps${opportunities.length?` (${opportunities.length})`:""}`,icon:"ti-rocket"},{key:"table",label:"Campaign Table",icon:"ti-table"},{key:"insights",label:"AI Insights",icon:"ti-brain"}];
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Impression Share Intelligence</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {opportunities.length>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(26,122,60,0.08)",color:"#1a7a3c",fontWeight:700}}>{opportunities.length} Scale Opps</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/>
            <span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{curData?.rows?.filter(r=>isNum(r,cm.impressions)>0).length||0} campaigns</span>
          </div>
        </div>
        <button onClick={onReupload} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:12,fontWeight:500,cursor:"pointer"}}><i className="ti ti-upload" style={{fontSize:13}}/> Re-upload</button>
      </div>

      <ISOverviewBar cur={curAgg} comp={compAgg?.impressions>0?compAgg:null}/>

      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>

      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {/* OVERVIEW */}
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
          <div style={{maxWidth:900,margin:"0 auto",padding:"20px 22px"}}>
            {/* Classification summary */}
            <div style={{marginBottom:20}}>
              <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Visibility Distribution</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
                {[{cls:"Declining",color:"#d42b2b",bg:"rgba(212,43,43,0.07)"},{cls:"Suppressed",color:"#d42b2b",bg:"rgba(212,43,43,0.05)"},{cls:"Scale Opp.",color:"#1a7a3c",bg:"rgba(26,122,60,0.07)"},{cls:"Growing",color:"#1a7a3c",bg:"rgba(26,122,60,0.05)"}].map(cat=>{
                  const count=curData?.rows?.filter(r=>{const m=isRowMetrics(r,cm);const comp=compMap?compMap[m.campaign.toLowerCase()]||null:null;return m.impressions>0&&classifyVisibility(m,comp).cls===cat.cls;}).length||0;
                  return<div key={cat.cls} style={{padding:"14px",background:cat.bg,borderRadius:10,border:`1px solid ${cat.color}22`,textAlign:"center"}}><div style={{fontSize:24,fontWeight:800,color:cat.color,marginBottom:4}}>{count}</div><div style={{fontSize:11,fontWeight:600,color:cat.color}}>{cat.cls}</div></div>;
                })}
              </div>
            </div>
            {/* AI quick summary */}
            {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:20}}>
              <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Visibility Summary</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
              {insights.slice(0,3).map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",neutral:"#555"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-rocket",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
            </div>}
            {/* Top alerts */}
            {alerts.length>0&&<div><div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Top Visibility Alerts</div>{alerts.slice(0,3).map((a,i)=><ISAlertCard key={i} alert={a}/>)}{alerts.length>3&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),marginTop:4,width:"100%",justifyContent:"center"}}>View All {alerts.length} Alerts →</button>}</div>}
          </div>
        </div>}

        {/* ALERTS */}
        {activeTab==="alerts"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alerts.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-eye" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No visibility alerts</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All campaigns have stable visibility metrics.</div></div>:alerts.map((a,i)=><ISAlertCard key={i} alert={a}/>)}</div></div>}

        {/* OPPORTUNITIES */}
        {activeTab==="opportunities"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{opportunities.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-rocket" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No scaling opportunities detected</div><div style={{fontSize:13,color:"#888",marginTop:4}}>Upload a comparison period to enable opportunity detection.</div></div>:opportunities.map((o,i)=><ISOpportunityCard key={i} opp={o}/>)}</div></div>}

        {/* TABLE */}
        {activeTab==="table"&&<ISVisibilityTable rows={curData?.rows||[]} cm={cm} compMap={compMap}/>}

        {/* INSIGHTS */}
        {activeTab==="insights"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><i className="ti ti-brain" style={{fontSize:14,color:R}}/><div style={{fontSize:14,fontWeight:700,color:"#111"}}>Visibility Intelligence Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>{insights.length===0?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><i className="ti ti-file-search" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div>Upload a comparison period to enable AI trend analysis</div></div>:insights.map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",neutral:"#555"};const tb={positive:"rgba(26,122,60,0.05)",negative:"rgba(212,43,43,0.04)",opportunity:"rgba(26,80,160,0.05)",neutral:"rgba(0,0,0,0.02)"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-rocket",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}><div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/></div><div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div></div>;})}</div></div></div>}
      </div>
    </div>
  );
}

/* ── Impression Share Module Root ────────────────────────────── */
function ImpressionShareModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.primary?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(globalData?.cur?.primary||null);const[compData,setCompData]=useState(globalData?.comp?.primary||null);
  useEffect(()=>{if(globalData?.cur?.primary&&page==="upload"){setCurData(globalData.cur.primary);setCompData(globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);
  if(page==="workspace"&&curData)return<ISWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>setPage("upload")}/>;
  return<ISUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/>;
}

/* ================================================================
   SQP & MARKET INTELLIGENCE MODULE
   Market share, click share, and conversion intelligence.
   Strict scope: upload page + market intelligence workspace only.
================================================================ */

/* ── SQP Column aliases ──────────────────────────────────────── */
const SQP_ALIASES={
  query:         ["Search Query","Search Term","Query","Customer Search Term","Search query","search query"],
  asin:          ["ASIN","Advertised ASIN","asin"],
  brand:         ["Brand","brand","Brand Name"],
  category:      ["Category","category","Department"],
  searchVolume:  ["Search Query Volume","Search Volume","Impressions","Total Search Volume","query volume"],
  clickShare:    ["Click Share","click share","Click share (%)","Your Click Share","Branded Click Share"],
  convShare:     ["Conversion Share","conversion share","Conversion share (%)","Your Conversion Share","Purchase Share"],
  clicks:        ["Clicks","clicks","Your Clicks"],
  conversions:   ["Conversions","Purchases","Orders","Your Conversions","Your Purchases"],
  impressions:   ["Impressions","Search Query Volume","impressions"],
  brandClickShare:["Branded Click Share","Brand Click Share"],
  nonBrandClickShare:["Non-Branded Click Share","Non-Brand Click Share"],
  spend:         ["Spend","Cost","Ad Spend"],
  sales:         ["Sales","14 Day Total Sales","Attributed Sales"],
};

function sqpDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(SQP_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function sqpNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function sqpRow(row,sm){
  return{
    query:       String(row[sm.query]||"").trim(),
    brand:       String(row[sm.brand]||""),
    category:    String(row[sm.category]||""),
    searchVolume:sqpNum(row,sm.searchVolume),
    clickShare:  sqpNum(row,sm.clickShare),
    convShare:   sqpNum(row,sm.convShare),
    clicks:      sqpNum(row,sm.clicks),
    conversions: sqpNum(row,sm.conversions),
    impressions: sqpNum(row,sm.impressions),
    brandClickShare:   sqpNum(row,sm.brandClickShare),
    nonBrandClickShare:sqpNum(row,sm.nonBrandClickShare),
    spend:       sqpNum(row,sm.spend),
    sales:       sqpNum(row,sm.sales),
  };
}

function sqpAgg(rows,sm){
  let sv=0,cs=0,cvs=0,clk=0,conv=0,n=0,csN=0,cvsN=0;
  rows.forEach(r=>{
    const m=sqpRow(r,sm);
    sv+=m.searchVolume;clk+=m.clicks;conv+=m.conversions;n++;
    if(m.clickShare>0){cs+=m.clickShare;csN++;}
    if(m.convShare>0){cvs+=m.convShare;cvsN++;}
  });
  return{searchVolume:sv,clicks:clk,conversions:conv,
    clickShare:csN>0?cs/csN:0,convShare:cvsN>0?cvs/cvsN:0,termCount:n};
}

/* ── Opportunity scoring ─────────────────────────────────────── */
function sqpOpportunityScore(m,comp){
  let score=0;
  // High volume + low share = big opportunity
  if(m.searchVolume>1000&&m.clickShare<10)score+=35;
  else if(m.searchVolume>500&&m.clickShare<15)score+=25;
  else if(m.searchVolume>100&&m.clickShare<20)score+=15;
  // Conversion share gap
  if(m.convShare>0&&m.clickShare>m.convShare*1.5)score+=20; // clicking but not converting enough
  if(m.convShare<5&&m.searchVolume>200)score+=15;
  // Growth vs comp
  if(comp){
    if(m.clickShare<comp.clickShare)score+=25; // losing share — urgent
    if(m.convShare<comp.convShare)score+=15;
    if(m.searchVolume>comp.searchVolume*1.2)score+=10; // growing market
  }
  return Math.min(100,score);
}

/* ── Classify SQP term ───────────────────────────────────────── */
function classifySQPTerm(m,comp){
  const opp=sqpOpportunityScore(m,comp);
  // Critical share loss
  if(comp&&comp.clickShare>10&&m.clickShare<comp.clickShare*0.65&&m.searchVolume>100)
    return{cls:"Critical Loss",priority:0,color:"#d42b2b",bg:"rgba(212,43,43,0.08)",icon:"ti-trending-down"};
  // High volume, low share = gap
  if(m.searchVolume>500&&m.clickShare<8)
    return{cls:"Volume Gap",priority:1,color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-target"};
  // Good conv share but click share falling
  if(comp&&m.clickShare<comp.clickShare*0.80&&m.convShare>5)
    return{cls:"Share Eroding",priority:1,color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-chart-line-down"};
  // Growing search volume + good share = momentum
  if(comp&&m.searchVolume>comp.searchVolume*1.15&&m.clickShare>15)
    return{cls:"Momentum",priority:2,color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-rocket"};
  // High conv share, low click share = scale
  if(m.convShare>m.clickShare&&m.searchVolume>100)
    return{cls:"Scale Signal",priority:2,color:"#6338c8",bg:"rgba(99,56,200,0.08)",icon:"ti-trending-up"};
  // Good coverage
  if(m.clickShare>20&&m.convShare>10)
    return{cls:"Dominant",priority:4,color:"#1a7a3c",bg:"rgba(26,122,60,0.06)",icon:"ti-crown"};
  if(m.clickShare>8)
    return{cls:"Stable",priority:4,color:"#555",bg:"rgba(0,0,0,0.03)",icon:"ti-check"};
  return{cls:"Monitor",priority:5,color:"#aaa",bg:"transparent",icon:"ti-minus"};
}

/* ── Market alerts ───────────────────────────────────────────── */
function generateSQPAlerts(rows,sm,compMap){
  const alerts=[];
  rows.forEach(row=>{
    const m=sqpRow(row,sm);
    const comp=compMap?compMap[m.query.toLowerCase()]||null:null;
    if(!m.query)return;

    // Click share loss on high-volume term
    if(comp&&comp.clickShare>8&&m.clickShare<comp.clickShare*0.65&&m.searchVolume>200){
      const d=m.clickShare-comp.clickShare;
      alerts.push({severity:"critical",type:"Click Share Loss",icon:"ti-chart-line-down",color:"#d42b2b",
        query:m.query,volume:m.searchVolume,
        comparison:`Click Share: ${comp.clickShare.toFixed(1)}% → ${m.clickShare.toFixed(1)}% (${d.toFixed(1)}pp)`,
        cause:`Click share on "${m.query}" dropped ${Math.abs(d).toFixed(1)} percentage points. With ${m.searchVolume.toLocaleString()} monthly searches, this represents significant captured traffic loss. Competitors likely increased bids or improved listing relevance.`,
        action:"Increase bids on this query's exact match targeting. Review listing optimization for this specific search intent. Add to a dedicated ranking campaign.",
        impact:`At ${m.searchVolume.toLocaleString()} searches/period: recovering 5pp share = ~${Math.round(m.searchVolume*0.05)} additional clicks`,confidence:87});
    }

    // Conversion share decline
    if(comp&&comp.convShare>5&&m.convShare<comp.convShare*0.70&&m.searchVolume>100){
      const d=m.convShare-comp.convShare;
      alerts.push({severity:"high",type:"Conversion Share Decline",icon:"ti-shopping-cart-off",color:"#c47a00",
        query:m.query,volume:m.searchVolume,
        comparison:`Conv. Share: ${comp.convShare.toFixed(1)}% → ${m.convShare.toFixed(1)}% (${d.toFixed(1)}pp)`,
        cause:`Conversion share declined ${Math.abs(d).toFixed(1)}pp — you're getting clicks but losing purchase decisions to competitors. Possible causes: competitor pricing, stronger listing, or review advantage.`,
        action:"Audit your listing vs top 3 competitors for this query. Check price competitiveness. Consider increasing budget to maintain TOS placement for conversion priority.",
        impact:`Recovering conversion share directly improves TACOS on this high-value query`,confidence:82});
    }

    // High volume, very low click share
    if(m.searchVolume>1000&&m.clickShare<5&&(!comp||comp.clickShare<8)){
      alerts.push({severity:"high",type:"High Volume Gap",icon:"ti-target",color:"#c47a00",
        query:m.query,volume:m.searchVolume,
        comparison:`Search Volume: ${m.searchVolume.toLocaleString()} · Click Share: ${m.clickShare.toFixed(1)}%`,
        cause:`High search volume (${m.searchVolume.toLocaleString()} searches) with only ${m.clickShare.toFixed(1)}% click share captured. This keyword represents a major untapped market opportunity.`,
        action:"Add this query as exact match in a dedicated campaign. Build a ranking campaign specifically for this term. Optimize listing for this search intent.",
        impact:`Capturing 10% share = ~${Math.round(m.searchVolume*0.10).toLocaleString()} additional clicks/period`,confidence:90});
    }

    // Growing search volume — act now
    if(comp&&m.searchVolume>comp.searchVolume*1.30&&m.searchVolume>200&&m.clickShare<15){
      const vp=((m.searchVolume-comp.searchVolume)/comp.searchVolume)*100;
      alerts.push({severity:"medium",type:"Growing Market — Capture Now",icon:"ti-trending-up",color:"#1a7a3c",
        query:m.query,volume:m.searchVolume,
        comparison:`Search Volume: +${vp.toFixed(0)}% growth · Click Share: ${m.clickShare.toFixed(1)}%`,
        cause:`Search volume for "${m.query}" grew ${vp.toFixed(0)}% vs previous period — market demand is accelerating. Act now before competitors entrench their positions.`,
        action:"Increase bids on this query immediately. Create a dedicated campaign if not already isolated. Optimize listing for this intent while volume is surging.",
        impact:`Market expanding — early capture compounds over time`,confidence:78});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3)).slice(0,20);
}

/* ── Keyword gap opportunities ───────────────────────────────── */
function generateSQPGaps(rows,sm,compMap){
  const gaps=[];
  rows.forEach(row=>{
    const m=sqpRow(row,sm);
    const comp=compMap?compMap[m.query.toLowerCase()]||null:null;
    if(!m.query||m.searchVolume===0)return;

    // High volume, low capture
    if(m.searchVolume>500&&m.clickShare<8){
      gaps.push({type:"volume_gap",icon:"ti-target",color:"#c47a00",
        title:"High Volume, Low Capture",query:m.query,score:sqpOpportunityScore(m,comp),
        why:`${m.searchVolume.toLocaleString()} searches with only ${m.clickShare.toFixed(1)}% click share — major untapped market`,
        movement:comp?`Click share was ${comp.clickShare.toFixed(1)}% → now ${m.clickShare.toFixed(1)}%`:`Click share: ${m.clickShare.toFixed(1)}%`,
        action:"Create exact match campaign for this query. Build dedicated ranking campaign. Optimize listing title and bullets for this specific search intent.",
        impact:`Every 5pp share gain = ~${Math.round(m.searchVolume*0.05).toLocaleString()} additional clicks`});
    }

    // Conversion share > click share = strong converter worth scaling
    if(m.convShare>0&&m.convShare>m.clickShare&&m.searchVolume>100){
      gaps.push({type:"conv_scale",icon:"ti-rocket",color:"#1a7a3c",
        title:"Conversion Efficiency — Scale Visibility",query:m.query,score:sqpOpportunityScore(m,comp)+10,
        why:`Conversion share (${m.convShare.toFixed(1)}%) exceeds click share (${m.clickShare.toFixed(1)}%) — you convert better than you capture. Scaling visibility here has proportional conversion upside.`,
        movement:comp?`Conv share: ${comp.convShare.toFixed(1)}% → ${m.convShare.toFixed(1)}%`:`Conv share: ${m.convShare.toFixed(1)}%`,
        action:"Increase bids to capture more clicks on this query. Your conversion rate is strong — more traffic = proportionally more purchases.",
        impact:`With stronger conversion efficiency than market average, each % of additional click share yields above-average conversions`});
    }

    // Share losing to competitors
    if(comp&&m.clickShare<comp.clickShare*0.80&&m.searchVolume>200){
      gaps.push({type:"competitor",icon:"ti-shield",color:"#d42b2b",
        title:"Competitor Gaining Ground",query:m.query,score:sqpOpportunityScore(m,comp)+15,
        why:`Click share dropped from ${comp.clickShare.toFixed(1)}% to ${m.clickShare.toFixed(1)}% — a competitor increased their capture on this query`,
        movement:`-${(comp.clickShare-m.clickShare).toFixed(1)}pp click share lost vs prev period`,
        action:"Identify which competitor is gaining. Increase bids. Improve listing for this search intent. Consider launching a defensive exact campaign.",
        impact:`Recovering lost share before competitors entrench is critical — the longer you wait, the harder the recapture`});
    }
  });

  return gaps.sort((a,b)=>b.score-a.score).slice(0,15);
}

/* ── AI SQP Insights ─────────────────────────────────────────── */
function generateSQPInsights(curAgg,compAgg,rows,sm){
  const lines=[];
  if(!curAgg||!Object.keys(curAgg).length)return lines;
  const pct=(k)=>compAgg&&compAgg[k]>0?((curAgg[k]-compAgg[k])/compAgg[k])*100:null;
  const csPct=pct("clickShare");const cvsPct=pct("convShare");const svPct=pct("searchVolume");

  if(csPct!=null){
    lines.push({type:csPct>3?"positive":csPct<-3?"negative":"neutral",icon:csPct>0?"ti-trending-up":"ti-trending-down",
      text:csPct>3?`Average click share improved ${csPct.toFixed(1)}% vs previous period — you are capturing more traffic in your target markets. Prioritize scaling campaigns on the highest-volume terms where share is growing.`
        :csPct<-3?`Average click share declined ${Math.abs(csPct).toFixed(1)}% — competitors are capturing traffic that was previously yours. Identify which high-volume queries lost the most share and act on those first.`
        :`Click share is relatively stable. Focus on identifying high-volume terms with click share below 10% — these represent the largest untapped opportunities.`});
  }

  if(cvsPct!=null&&Math.abs(cvsPct)>5){
    lines.push({type:cvsPct>0?"positive":"negative",icon:cvsPct>0?"ti-shopping-cart":"ti-shopping-cart-off",
      text:cvsPct>0?`Conversion share improved ${cvsPct.toFixed(1)}% — your listings are winning more purchase decisions. This is the most valuable market share metric because it reflects actual revenue capture, not just visibility.`
        :`Conversion share declined ${Math.abs(cvsPct).toFixed(1)}% — competitors are winning more purchase decisions even when your click share may be stable. Audit listing quality, pricing, and review velocity vs competitors.`});
  }

  if(svPct!=null&&svPct>15){
    lines.push({type:"opportunity",icon:"ti-chart-bar",
      text:`Overall search volume in your category grew ${svPct.toFixed(0)}% vs previous period — market demand is expanding. This is a critical window to capture share before competitors establish dominance in the growing query set.`});
  }

  const gaps=rows.filter(r=>{const m=sqpRow(r,sm);return m.searchVolume>500&&m.clickShare<8;});
  if(gaps.length>0){
    const totalVol=gaps.reduce((s,r)=>s+sqpRow(r,sm).searchVolume,0);
    lines.push({type:"opportunity",icon:"ti-target",
      text:`${gaps.length} high-volume queries (${totalVol.toLocaleString()} combined searches) have less than 8% click share. These represent your largest keyword gaps — queries where market demand exists but your brand is largely absent.`});
  }

  const losers=rows.filter(r=>{const m=sqpRow(r,sm);const comp=compAgg?null:null;return m.clickShare<5&&m.convShare>8;});
  if(losers.length>0){
    lines.push({type:"opportunity",icon:"ti-rocket",
      text:`${losers.length} queries show conversion share significantly exceeding click share — these are high-efficiency terms where you convert well but don't capture enough initial clicks. Increasing bid on these queries has the highest-confidence revenue impact.`});
  }

  return lines;
}

/* ── SQP Upload Zone (module-level) ──────────────────────────── */
function SQPUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"13px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:11}}>
        <div style={{width:34,height:34,borderRadius:8,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:15,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:11,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:11,color:R,fontWeight:600,marginTop:3}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:11}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 12px",borderRadius:7,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:11,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const SQP_REPORT_TYPES=[
  {id:"sqp",     label:"Search Query Performance Report", icon:"ti-search",          required:true, desc:"Core SQP data — click share, conversion share, search volume"},
  {id:"catalog", label:"Search Catalog Report",           icon:"ti-list",            required:false,desc:"Category-level search performance data"},
  {id:"basket",  label:"Market Basket Report",            icon:"ti-shopping-cart",   required:false,desc:"Purchase co-occurrence and market basket data"},
];

/* ── SQP Upload Page ─────────────────────────────────────────── */
function SQPUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.sqp)return;setLoading(true);setErr(null);
    try{const cur=await parseSheet(files.sqp);let comp=null;if(compFiles.sqp)comp=await parseSheet(compFiles.sqp);onComplete({cur,comp,periods:localPeriods});}
    catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:720,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload SQP Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your raw Search Query Performance reports directly from Amazon. No formatting needed — the system detects click share, conversion share, and search volume automatically.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><div style={{width:8,height:8,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div><span style={{fontSize:11,color:"#888"}}>{fmtDisp(localPeriods?.current?.start)} — {fmtDisp(localPeriods?.current?.end)}</span></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{SQP_REPORT_TYPES.map(t=><SQPUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:14}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"9px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period{localPeriods?.comp&&<span style={{fontSize:11,color:"#888",fontWeight:400,marginLeft:4}}>{fmtDisp(localPeriods.comp.start)} — {fmtDisp(localPeriods.comp.end)}</span>}
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><div style={{width:8,height:8,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{SQP_REPORT_TYPES.map(t=><SQPUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px",marginBottom:14}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:9}}>How to export SQP data from Amazon</div>
          {["Go to Amazon Advertising Console → Reports → Create Report","Select Report Type: Search Query Performance","Set your date range and include all available metrics","Download the .xlsx file — upload directly without any modifications","For comparison: download SQP for the previous period and upload below"].map((s,i)=>(<div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>))}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>SQP reports are available for Sponsored Products only. The report shows your brand's click and conversion share vs total market for each search query. Available in Seller Central → Advertising → Reports.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.sqp||loading} style={{...T.btnR(false),opacity:files.sqp&&!loading?1:0.4,fontWeight:700,boxShadow:files.sqp?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-chart-bar" style={{fontSize:14}}/> Run Market Intelligence</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── SQP Overview KPI Bar ────────────────────────────────────── */
function SQPOverviewBar({cur,comp}){
  const defs=[
    {k:"clickShare",  lb:false,label:"Avg Click Share",   fmt:v=>v>0?`${v.toFixed(1)}%`:"—",isPp:true},
    {k:"convShare",   lb:false,label:"Conv. Share",        fmt:v=>v>0?`${v.toFixed(1)}%`:"—",isPp:true},
    {k:"searchVolume",lb:false,label:"Search Volume",      fmt:v=>v>=1e6?`${(v/1e6).toFixed(1)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))},
    {k:"termCount",   lb:false,label:"Queries Tracked",    fmt:v=>String(Math.round(v))},
    {k:"clicks",      lb:false,label:"Total Clicks",       fmt:v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))},
    {k:"conversions", lb:false,label:"Conversions",        fmt:v=>String(Math.round(v))},
  ];
  return(
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",overflowX:"auto",flexShrink:0}}>
      <div style={{display:"flex",minWidth:"max-content"}}>
        {defs.map((d,idx)=>{
          const cv=cur[d.k]||0;const pv=comp?comp[d.k]||0:null;
          const delta=pv!=null?cv-pv:null;const pct=delta!=null&&pv!==0?(delta/Math.abs(pv))*100:null;
          const good=delta===null?null:(d.lb?delta<=0:delta>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";
          return(<div key={d.k} style={{flex:"0 0 auto",minWidth:130,padding:"13px 18px",borderRight:idx<defs.length-1?"1px solid #f0f0f0":"none",borderBottom:`3px solid ${good===true?"#1a9e4a":good===false?"#d42b2b":"transparent"}`}}>
            <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:6}}>{d.label}</div>
            <div style={{fontSize:19,fontWeight:800,color:"#111",letterSpacing:"-0.4px",lineHeight:1,marginBottom:4}}>{d.fmt(cv)}</div>
            {comp&&pct!=null&&<div><div style={{fontSize:11,fontWeight:700,color:dc,display:"flex",alignItems:"center",gap:3,marginBottom:1}}><i className={`ti ${good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:10}}/>{sign(pct)}{Math.abs(pct).toFixed(1)}%<span style={{fontSize:9,color:"#ccc",fontWeight:400,marginLeft:2}}>vs prev</span></div>{delta!=null&&<div style={{fontSize:10,color:dc,fontWeight:600}}>{d.isPp?`${sign(delta)}${Math.abs(delta).toFixed(1)}pp`:`${sign(delta)}${d.fmt(Math.abs(delta))}`}</div>}</div>}
          </div>);
        })}
      </div>
    </div>
  );
}

/* ── SQP Alert Card ──────────────────────────────────────────── */
function SQPAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555"};const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)"};const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"#eee"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity]||"#f0f0f0",color:sc[a.severity]||"#555",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
            {a.volume>0&&<span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:"#f5f5f5",color:"#888"}}>{a.volume.toLocaleString()} searches</span>}
          </div>
          <div style={{fontSize:12,fontWeight:600,color:"#333",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.query}</div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}><span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/></div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4,fontSize:10}}/>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Market impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Strategic Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div></div>
      </div>}
    </div>
  );
}

/* ── SQP Gap Card ────────────────────────────────────────────── */
function SQPGapCard({gap:g}){
  const[open,setOpen]=useState(false);
  const tc={volume_gap:"#c47a00",conv_scale:"#1a7a3c",competitor:"#d42b2b"};const tb={volume_gap:"rgba(196,122,0,0.05)",conv_scale:"rgba(26,122,60,0.05)",competitor:"rgba(212,43,43,0.05)"};const tbr={volume_gap:"rgba(196,122,0,0.18)",conv_scale:"rgba(26,122,60,0.18)",competitor:"rgba(212,43,43,0.18)"};
  const c=tc[g.type]||"#555";const bg=tb[g.type]||"#fafafa";const br=tbr[g.type]||"#eee";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${g.icon}`} style={{fontSize:13,color:c}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>{g.title}</span><span style={{fontSize:10,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#666"}}>Score: {g.score}</span></div>
          <div style={{fontSize:12,fontWeight:600,color:"#111",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{g.query}</div>
          {!open&&<div style={{fontSize:11,color:"#666",marginTop:2}}>{g.why}</div>}
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:`1px solid ${br}`}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}>{g.movement}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{g.why}</div>
        {g.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}>{g.impact}</div>}
        <div style={{padding:"9px 12px",background:bg,borderRadius:8,border:`1px solid ${br}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Strategic Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{g.action}</div></div>
      </div>}
    </div>
  );
}

/* ── SQP Share Movement Table ────────────────────────────────── */
function SQPShareTable({rows,sm,compMap}){
  const[search,setSearch]=useState("");const[sortKey,setSortKey]=useState("priority");const[sortDir,setSortDir]=useState("asc");const[filterCls,setFilterCls]=useState("All");
  const CLS_F=["All","Critical Loss","Volume Gap","Share Eroding","Scale Signal","Momentum","Dominant","Stable"];
  const PCLS_O={"Critical Loss":0,"Volume Gap":1,"Share Eroding":1,"Scale Signal":2,"Momentum":2,"Dominant":4,"Stable":4,"Monitor":5};
  const processed=useMemo(()=>rows.map((r,i)=>{const m=sqpRow(r,sm);const comp=compMap?compMap[m.query.toLowerCase()]||null:null;const cls=classifySQPTerm(m,comp);const score=sqpOpportunityScore(m,comp);return{r,m,comp,cls,score,id:i};}).filter(x=>x.m.query&&(x.m.searchVolume>0||x.m.clickShare>0)),[rows,sm,compMap]);
  const filtered=useMemo(()=>{let d=processed;if(search){const q=search.toLowerCase();d=d.filter(x=>x.m.query.toLowerCase().includes(q));}if(filterCls!=="All")d=d.filter(x=>x.cls.cls===filterCls);return d;},[processed,search,filterCls]);
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{if(sortKey==="priority")return sortDir==="asc"?(PCLS_O[a.cls.cls]??5)-(PCLS_O[b.cls.cls]??5):(PCLS_O[b.cls.cls]??5)-(PCLS_O[a.cls.cls]??5);if(sortKey==="query")return sortDir==="asc"?a.m.query.localeCompare(b.m.query):b.m.query.localeCompare(a.m.query);const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;}),[filtered,sortKey,sortDir]);
  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir("desc");}}
  const clsCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.cls.cls]=(m[x.cls.cls]||0)+1;});return m;},[processed]);
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const DC=({cur,prev,fmt,lb,isPp})=>{const d=prev!=null?cur-prev:null;const good=d===null?null:(lb?d<=0:d>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";return<><div style={{fontSize:12,fontWeight:500,color:"#111",lineHeight:1.4}}>{fmt(cur)}</div>{d!=null&&Math.abs(d)>0.01&&<div style={{fontSize:10,fontWeight:600,color:dc}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}</>;};
  const fmtV=v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v));
  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 18px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:180}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search query…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {CLS_F.map(f=>{const cnt=f==="All"?processed.length:clsCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterCls===f;return<button key={f} onClick={()=>setFilterCls(f)} style={{padding:"4px 9px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/><span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> queries</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("priority")}>Classification <SI col="priority"/></th>
            <th style={thS} onClick={()=>toggleSort("query")}>Search Query <SI col="query"/></th>
            <th style={thS} onClick={()=>toggleSort("searchVolume")}>Search Vol. <SI col="searchVolume"/></th>
            <th style={thS} onClick={()=>toggleSort("clickShare")}>Click Share <SI col="clickShare"/></th>
            <th style={thS} onClick={()=>toggleSort("convShare")}>Conv. Share <SI col="convShare"/></th>
            <th style={thS} onClick={()=>toggleSort("score")}>Opp. Score <SI col="score"/></th>
            <th style={thS} onClick={()=>toggleSort("clicks")}>Clicks <SI col="clicks"/></th>
            <th style={thS} onClick={()=>toggleSort("conversions")}>Conversions <SI col="conversions"/></th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,cls,score,id},i)=>(<tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
              <td style={{padding:"7px 10px"}}><div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:6,background:cls.bg,border:`1px solid ${cls.color}22`}}><i className={`ti ${cls.icon}`} style={{fontSize:9,color:cls.color}}/><span style={{fontSize:9,fontWeight:700,color:cls.color,whiteSpace:"nowrap"}}>{cls.cls}</span></div></td>
              <td style={{padding:"8px 10px",maxWidth:240}} title={m.query}><div style={{fontWeight:600,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.query}</div></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.searchVolume} prev={comp?.searchVolume} fmt={fmtV} lb={false}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.clickShare} prev={comp?.clickShare} fmt={v=>v>0?`${v.toFixed(1)}%`:"—"} lb={false} isPp={true}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.convShare} prev={comp?.convShare} fmt={v=>v>0?`${v.toFixed(1)}%`:"—"} lb={false} isPp={true}/></td>
              <td style={{padding:"8px 10px"}}>
                <div style={{display:"flex",alignItems:"center",gap:6}}><div style={{height:4,borderRadius:2,background:`${score>=70?"#1a9e4a":score>=40?"#c47a00":"#d42b2b"}`,width:`${score}%`,maxWidth:50}}/><span style={{fontSize:11,fontWeight:700,color:score>=70?"#1a7a3c":score>=40?"#c47a00":"#d42b2b"}}>{score}</span></div>
              </td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.clicks} prev={comp?.clicks} fmt={fmtV} lb={false}/></td>
              <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.conversions} prev={comp?.conversions} fmt={v=>String(Math.round(v))} lb={false}/></td>
            </tr>))}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No queries match</div></div>}
      </div>
    </div>
  );
}

/* ── SQP Workspace ───────────────────────────────────────────── */
function SQPWorkspace({curData,compData,periods,onReupload}){
  const sm=useMemo(()=>curData?sqpDetect(curData.headers):{},[curData]);
  const compSm=useMemo(()=>compData?sqpDetect(compData.headers):{},[compData]);
  const curAgg=useMemo(()=>curData?sqpAgg(curData.rows,sm):{},[curData,sm]);
  const compAgg=useMemo(()=>compData?sqpAgg(compData.rows,compSm):null,[compData,compSm]);
  const compMap=useMemo(()=>{if(!compData)return null;const m={};compData.rows.forEach(r=>{const row=sqpRow(r,compSm);if(row.query)m[row.query.toLowerCase()]=row;});return m;},[compData,compSm]);
  const alerts=useMemo(()=>curData?generateSQPAlerts(curData.rows,sm,compMap):[],[curData,sm,compMap]);
  const gaps=useMemo(()=>curData?generateSQPGaps(curData.rows,sm,compMap):[],[curData,sm,compMap]);
  const insights=useMemo(()=>curData?generateSQPInsights(curAgg,compAgg,curData.rows,sm):[],[curAgg,compAgg,curData,sm]);
  const[activeTab,setActiveTab]=useState("overview");
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const TABS=[{key:"overview",label:"Market Overview",icon:"ti-chart-bar"},{key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},{key:"gaps",label:`Keyword Gaps${gaps.length?` (${gaps.length})`:""}`,icon:"ti-target"},{key:"table",label:"Share Movement",icon:"ti-table"},{key:"insights",label:"AI Insights",icon:"ti-brain"}];
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>SQP & Market Intelligence</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {gaps.length>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(196,122,0,0.08)",color:"#c47a00",fontWeight:700}}>{gaps.length} Gaps</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{curAgg.termCount||0} queries tracked</span>
          </div>
        </div>
        <button onClick={onReupload} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:12,fontWeight:500,cursor:"pointer"}}><i className="ti ti-upload" style={{fontSize:13}}/> Re-upload</button>
      </div>
      <SQPOverviewBar cur={curAgg} comp={compAgg?.termCount>0?compAgg:null}/>
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {/* OVERVIEW */}
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:900,margin:"0 auto",padding:"20px 22px"}}>
          <div style={{marginBottom:20}}>
            <ModuleOverview
            moduleName="Search Query Performance" moduleIcon="ti-chart-pie" periods={periods}
            cur={{spend:curAgg.totalSpend,sales:curAgg.totalSales,orders:curAgg.totalOrders,clicks:curAgg.totalClicks,impressions:curAgg.totalImpressions,cvr:curAgg.avgCvr,cpc:curAgg.avgCpc,roas:curAgg.avgRoas,acos:curAgg.avgAcos}}
            comp={compAgg?.termCount>0?{spend:compAgg.totalSpend,sales:compAgg.totalSales,orders:compAgg.totalOrders,clicks:compAgg.totalClicks,impressions:compAgg.totalImpressions,cvr:compAgg.avgCvr,cpc:compAgg.avgCpc}:null}
            rows={curData?.rows||[]} extraKpis={[{label:"Queries Tracked",value:curAgg.termCount,prev:compAgg?.termCount,fmt:"int",icon:"ti-hash",color:"#6338c8"}]}
            alerts={alerts.slice(0,3).map(a=>({type:a.severity==="critical"?"critical":"loss",icon:"ti-chart-pie",title:a.title,detail:a.explanation||""}))}
          />
          <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10,marginTop:12}}>Market Share Distribution</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
              {[{cls:"Critical Loss",color:"#d42b2b",bg:"rgba(212,43,43,0.07)"},{cls:"Volume Gap",color:"#c47a00",bg:"rgba(196,122,0,0.07)"},{cls:"Scale Signal",color:"#6338c8",bg:"rgba(99,56,200,0.07)"},{cls:"Dominant",color:"#1a7a3c",bg:"rgba(26,122,60,0.07)"}].map(cat=>{
                const count=curData?.rows?.filter(r=>{const m=sqpRow(r,sm);const comp=compMap?compMap[m.query.toLowerCase()]||null:null;return m.query&&classifySQPTerm(m,comp).cls===cat.cls;}).length||0;
                return<div key={cat.cls} style={{padding:"14px",background:cat.bg,borderRadius:10,border:`1px solid ${cat.color}22`,textAlign:"center"}}><div style={{fontSize:24,fontWeight:800,color:cat.color,marginBottom:4}}>{count}</div><div style={{fontSize:11,fontWeight:600,color:cat.color}}>{cat.cls}</div></div>;
              })}
            </div>
          </div>
          {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:20}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Market Intelligence Summary</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
            {insights.slice(0,3).map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#c47a00",neutral:"#555"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-target",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
          </div>}
          {alerts.length>0&&<div><div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Top Market Alerts</div>{alerts.slice(0,3).map((a,i)=><SQPAlertCard key={i} alert={a}/>)}{alerts.length>3&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),marginTop:4,width:"100%",justifyContent:"center"}}>View All {alerts.length} Alerts →</button>}</div>}
        </div></div>}
        {/* ALERTS */}
        {activeTab==="alerts"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alerts.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-chart-bar" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No market alerts detected</div><div style={{fontSize:13,color:"#888",marginTop:4}}>Upload a comparison period to enable share movement detection.</div></div>:alerts.map((a,i)=><SQPAlertCard key={i} alert={a}/>)}</div></div>}
        {/* GAPS */}
        {activeTab==="gaps"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{gaps.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-target" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No keyword gaps detected</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All tracked queries have reasonable click share coverage.</div></div>:gaps.map((g,i)=><SQPGapCard key={i} gap={g}/>)}</div></div>}
        {/* TABLE */}
        {activeTab==="table"&&<SQPShareTable rows={curData?.rows||[]} sm={sm} compMap={compMap}/>}
        {/* INSIGHTS */}
        {activeTab==="insights"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><i className="ti ti-brain" style={{fontSize:14,color:R}}/><div style={{fontSize:14,fontWeight:700,color:"#111"}}>Market Intelligence Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded SQP data only</div></div>{insights.length===0?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><div>Upload comparison period to enable AI trend analysis</div></div>:insights.map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#c47a00",neutral:"#555"};const tb={positive:"rgba(26,122,60,0.05)",negative:"rgba(212,43,43,0.04)",opportunity:"rgba(196,122,0,0.05)",neutral:"rgba(0,0,0,0.02)"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-target",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}><div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/></div><div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div></div>;})}</div></div></div>}
      </div>
    </div>
  );
}

/* ── SQP Module Root ─────────────────────────────────────────── */
function SQPModule({globalData,setTab}){
  const _sqpd=globalData?.cur?.sqp||globalData?.cur?.primary;
  const _sqpdc=globalData?.comp?.sqp||globalData?.comp?.primary;
  const[page,setPage]=useState(_sqpd?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(_sqpd||null);const[compData,setCompData]=useState(_sqpdc||null);
  useEffect(()=>{const d=globalData?.cur?.sqp||globalData?.cur?.primary;if(d&&page==="upload"){setCurData(d);setCompData(globalData?.comp?.sqp||globalData?.comp?.primary||null);setPeriods(globalData?.periods||null);setPage("workspace");}},[globalData]);
  if(page==="workspace"&&curData)return<SQPWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>setPage("upload")}/>;
  return<SQPUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/>;
}

/* ================================================================
   RANK RADAR MODULE
   Keyword ranking intelligence system for Amazon PPC strategists.
   Strict scope: upload page + rank intelligence workspace only.
================================================================ */

/* ── Rank column aliases — covers Amazon + 3rd party trackers ── */
const RR_ALIASES={
  keyword:     ["Keyword","Search Term","keyword","Query","Keyword Text","search term"],
  orgRank:     ["Organic Rank","Organic Position","Rank","organic rank","Position","organic position","Organic","Current Rank","rank"],
  sponRank:    ["Sponsored Rank","Sponsored Position","Ad Rank","sponsored rank","Paid Rank","PPC Rank"],
  asin:        ["ASIN","asin","Product ASIN","Advertised ASIN"],
  searchVolume:["Search Volume","Monthly Searches","Volume","search volume","Impressions"],
  clicks:      ["Clicks","clicks"],
  impressions: ["Impressions","impressions"],
  spend:       ["Spend","Cost","Ad Spend"],
  sales:       ["Sales","14 Day Total Sales","Revenue"],
  orders:      ["Orders","Conversions","14 Day Total Orders (#)"],
  cvr:         ["CVR","Conversion Rate","conversion rate"],
  cpc:         ["CPC","Cost Per Click"],
  matchType:   ["Match Type","match type"],
  campaign:    ["Campaign Name","Campaign","campaign"],
  stability:   ["Stability","Rank Stability","stability score"],
  page:        ["Page","Page Number","Rank Page"],
};

function rrDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(RR_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function rrNum(row,col){
  if(!col||row[col]==null||row[col]==="")return null;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?null:v;
}

function rrRow(row,rm){
  const orgRank=rrNum(row,rm.orgRank);
  const sponRank=rrNum(row,rm.sponRank);
  const sv=rrNum(row,rm.searchVolume)||0;
  const clicks=rrNum(row,rm.clicks)||0;
  const spend=rrNum(row,rm.spend)||0;
  const orders=rrNum(row,rm.orders)||0;
  const cvr=rm.cvr&&rrNum(row,rm.cvr)!=null?rrNum(row,rm.cvr):clicks>0?(orders/clicks)*100:0;
  return{
    keyword:String(row[rm.keyword]||"").trim(),
    asin:String(row[rm.asin]||""),
    campaign:String(row[rm.campaign]||""),
    matchType:String(row[rm.matchType]||""),
    orgRank,sponRank,searchVolume:sv,clicks,spend,orders,cvr,
    cpc:clicks>0?spend/clicks:0,
    // Lower rank number = better position. Rank 1 = page 1 top.
    orgPage:orgRank!=null?Math.ceil(orgRank/16):null,
  };
}

function rrAgg(rows,rm){
  let totalOrg=0,nOrg=0,totalSpon=0,nSpon=0,sv=0,improving=0,declining=0,stable=0;
  rows.forEach(r=>{
    const m=rrRow(r,rm);
    if(m.orgRank!=null&&m.orgRank>0){totalOrg+=m.orgRank;nOrg++;}
    if(m.sponRank!=null&&m.sponRank>0){totalSpon+=m.sponRank;nSpon++;}
    sv+=m.searchVolume;
  });
  return{avgOrgRank:nOrg>0?totalOrg/nOrg:0,avgSponRank:nSpon>0?totalSpon/nSpon:0,
    totalSearchVolume:sv,termCount:rows.length,nOrg,nSpon};
}

/* ── Rank movement classification ───────────────────────────── */
function classifyRank(m,comp){
  const orgNow=m.orgRank;const orgPrev=comp?.orgRank;
  // Lower number = better rank
  if(orgNow==null&&comp==null)return{cls:"No Data",priority:6,color:"#ccc",bg:"transparent",icon:"ti-minus"};

  const delta=orgNow!=null&&orgPrev!=null?orgPrev-orgNow:null; // positive = improved (moved up)

  // Rapid decline
  if(delta!=null&&delta<-10&&orgNow>30)return{cls:"Rapid Decline",priority:0,color:"#d42b2b",bg:"rgba(212,43,43,0.08)",icon:"ti-trending-down",delta};
  if(delta!=null&&delta<-5&&orgNow>20) return{cls:"Declining",priority:1,color:"#d42b2b",bg:"rgba(212,43,43,0.06)",icon:"ti-arrow-down",delta};
  // PPC dependency — has sponsored rank but weak organic
  if(orgNow!=null&&orgNow>50&&m.sponRank!=null&&m.sponRank<10&&m.spend>5)
    return{cls:"PPC Dependent",priority:2,color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-ad-circle",delta};
  // Rapid gain — momentum
  if(delta!=null&&delta>10)return{cls:"Momentum",priority:2,color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-rocket",delta};
  if(delta!=null&&delta>4) return{cls:"Improving",priority:3,color:"#1a7a3c",bg:"rgba(26,122,60,0.06)",icon:"ti-trending-up",delta};
  // Weak rank but converts — opportunity
  if(m.cvr>2&&orgNow!=null&&orgNow>20&&m.orders>0)
    return{cls:"Rank Opportunity",priority:2,color:"#6338c8",bg:"rgba(99,56,200,0.08)",icon:"ti-target",delta};
  // On page 1 (rank ≤ 16)
  if(orgNow!=null&&orgNow<=16)return{cls:"Page 1",priority:4,color:"#1a7a3c",bg:"rgba(26,122,60,0.05)",icon:"ti-award",delta};
  // Stable
  if(delta!=null&&Math.abs(delta)<=2)return{cls:"Stable",priority:5,color:"#555",bg:"rgba(0,0,0,0.03)",icon:"ti-equal",delta};
  return{cls:"Monitor",priority:5,color:"#aaa",bg:"transparent",icon:"ti-minus",delta};
}

/* ── Opportunity score ───────────────────────────────────────── */
function rrOppScore(m,comp){
  let score=0;
  // High search volume + bad rank = big opportunity
  if(m.searchVolume>1000&&m.orgRank!=null&&m.orgRank>30)score+=30;
  else if(m.searchVolume>500&&m.orgRank!=null&&m.orgRank>20)score+=20;
  // Strong CVR = worth ranking investment
  if(m.cvr>4&&m.orders>=2)score+=25;
  else if(m.cvr>2&&m.orders>=1)score+=15;
  // Gaining momentum
  if(comp&&comp.orgRank!=null&&m.orgRank!=null&&m.orgRank<comp.orgRank)score+=20;
  // PPC supporting — rank can improve with more spend
  if(m.sponRank!=null&&m.sponRank<10&&m.orgRank!=null&&m.orgRank>15)score+=15;
  // Close to page 1
  if(m.orgRank!=null&&m.orgRank>=17&&m.orgRank<=32)score+=10;
  return Math.min(100,score);
}

/* ── Rank alerts ─────────────────────────────────────────────── */
function generateRRAlerts(rows,rm,compMap){
  const alerts=[];
  rows.forEach(row=>{
    const m=rrRow(row,rm);
    const comp=compMap?compMap[m.keyword.toLowerCase()]||null:null;
    if(!m.keyword)return;
    const orgNow=m.orgRank;const orgPrev=comp?.orgRank;
    const delta=orgNow!=null&&orgPrev!=null?orgPrev-orgNow:null; // positive = rank improved

    // Rapid rank decline
    if(delta!=null&&delta<-8&&orgNow!=null){
      alerts.push({severity:"critical",type:"Rapid Rank Decline",icon:"ti-trending-down",color:"#d42b2b",
        keyword:m.keyword,searchVolume:m.searchVolume,
        comparison:`Rank: ${Math.round(orgPrev)} → ${Math.round(orgNow)} (${Math.abs(delta).toFixed(0)} positions lost)`,
        cause:`Organic rank dropped ${Math.abs(delta).toFixed(0)} positions to rank ${Math.round(orgNow)}. Rapid declines typically indicate: reduced PPC support, competitor improved listing quality, or algorithm re-evaluation of keyword relevance.`,
        action:`Increase PPC spend on this keyword immediately to maintain visibility while organic rank recovers. Add this keyword to a dedicated ranking campaign with TOS focus.`,
        impact:`Rank ${Math.round(orgNow)} vs ${Math.round(orgPrev)} — estimated ${Math.round((orgNow-orgPrev)*0.03*100)}% visibility reduction`,confidence:85});
    }

    // PPC dependency risk
    if(m.sponRank!=null&&m.sponRank<8&&orgNow!=null&&orgNow>40&&m.spend>10){
      alerts.push({severity:"high",type:"PPC Dependency Risk",icon:"ti-ad-circle",color:"#c47a00",
        keyword:m.keyword,searchVolume:m.searchVolume,
        comparison:`Organic: ${Math.round(orgNow)} · Sponsored: ${Math.round(m.sponRank)} · Spend: $${m.spend.toFixed(0)}`,
        cause:`Keyword ranks well in sponsored placements but organic rank is ${Math.round(orgNow)}. High PPC dependency means any budget reduction will cause significant visibility loss. Organic rank needs strengthening.`,
        action:`Allocate dedicated ranking budget for this keyword. Use a low-bid TOS ranking campaign to build organic velocity. Do NOT reduce PPC until organic rank improves to top 30.`,
        impact:`Reducing spend now would cost rank ${Math.round(orgNow)} → estimated page 4+`,confidence:82});
    }

    // Rank volatility
    if(delta!=null&&Math.abs(delta)>15&&orgNow!=null){
      alerts.push({severity:"high",type:"Rank Volatility",icon:"ti-arrows-exchange-2",color:"#c47a00",
        keyword:m.keyword,searchVolume:m.searchVolume,
        comparison:`Rank moved ${Math.abs(delta).toFixed(0)} positions ${delta>0?"upward":"downward"} in this period`,
        cause:`Significant rank swing of ${Math.abs(delta).toFixed(0)} positions indicates algorithm instability or inconsistent PPC support. Volatile rankings reduce the compounding benefit of ranking investment.`,
        action:`Maintain consistent daily PPC budget for this keyword — budget fluctuations directly cause rank volatility. Consider a dedicated Always-On ranking campaign.`,
        impact:`Rank stability is required before any meaningful organic rank compound growth`,confidence:76});
    }

    // Close to page 1 — push now
    if(orgNow!=null&&orgNow>=17&&orgNow<=28&&m.searchVolume>200){
      alerts.push({severity:"medium",type:"Near Page 1 — Push Now",icon:"ti-target",color:"#6338c8",
        keyword:m.keyword,searchVolume:m.searchVolume,
        comparison:`Current rank: ${Math.round(orgNow)}${orgPrev!=null?` (prev: ${Math.round(orgPrev)})`:""} · ${m.searchVolume.toLocaleString()} searches`,
        cause:`Rank ${Math.round(orgNow)} is just ${Math.round(orgNow-16)} positions from page 1. Page 1 keywords get exponentially more organic clicks — a focused ranking push here has an outsized return.`,
        action:`Increase TOS bid modifier 25–40%. Add this keyword to a dedicated ranking campaign. Optimize listing for this specific keyword to improve relevance signals.`,
        impact:`Page 1 keywords typically get 3–5x more clicks than page 2 — worth the ranking investment`,confidence:80});
    }

    // Rank recovery opportunity
    if(orgPrev!=null&&orgNow!=null&&orgPrev<20&&orgNow>35){
      alerts.push({severity:"high",type:"Rank Recovery Opportunity",icon:"ti-refresh",color:"#c47a00",
        keyword:m.keyword,searchVolume:m.searchVolume,
        comparison:`Prev rank: ${Math.round(orgPrev)} → Current: ${Math.round(orgNow)} (${Math.round(orgNow-orgPrev)} positions lost)`,
        cause:`This keyword previously held a strong rank ${Math.round(orgPrev)} but has fallen to ${Math.round(orgNow)}. Recovery is possible because the keyword has demonstrated its ranking potential — previous rank proves the ASIN can compete.`,
        action:`Launch a recovery ranking campaign at 2x normal TOS spend for 2–3 weeks. Ensure listing is fully optimized. Monitor weekly rank changes.`,
        impact:`Recovering to previous rank ${Math.round(orgPrev)} from ${Math.round(orgNow)} would restore ${Math.round((orgNow-orgPrev)*2)}% estimated organic traffic`,confidence:79});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3)).slice(0,20);
}

/* ── Ranking opportunities ───────────────────────────────────── */
function generateRROpportunities(rows,rm,compMap){
  const opps=[];
  rows.forEach(row=>{
    const m=rrRow(row,rm);
    const comp=compMap?compMap[m.keyword.toLowerCase()]||null:null;
    if(!m.keyword)return;
    const orgNow=m.orgRank;const orgPrev=comp?.orgRank;
    const delta=orgNow!=null&&orgPrev!=null?orgPrev-orgNow:null;

    // Strong CVR + weak rank
    if(m.cvr>4&&m.orders>=2&&orgNow!=null&&orgNow>25){
      opps.push({icon:"ti-rocket",color:"#1a7a3c",type:"cvr_rank",
        title:"Strong Converter Needs Rank Support",keyword:m.keyword,score:rrOppScore(m,comp),
        why:`CVR ${m.cvr.toFixed(1)}% with ${m.orders} orders — proven converter sitting at rank ${Math.round(orgNow)}. Page 1 would multiply volume at the same CVR.`,
        movement:orgPrev!=null?`Rank: ${Math.round(orgPrev)} → ${Math.round(orgNow)}`:`Current rank: ${Math.round(orgNow)}`,
        action:`Launch dedicated ranking campaign with TOS focus. Bid 30–40% above normal for 3–4 weeks. The CVR justifies the ranking investment.`,
        impact:`Page 1 visibility at ${m.cvr.toFixed(1)}% CVR = significant order volume unlock`});
    }

    // Momentum — reinforce it
    if(delta!=null&&delta>6&&orgNow!=null&&orgNow>5){
      opps.push({icon:"ti-trending-up",color:"#1a7a3c",type:"momentum",
        title:"Rank Momentum — Reinforce Now",keyword:m.keyword,score:rrOppScore(m,comp)+10,
        why:`Rank improved ${delta.toFixed(0)} positions to rank ${Math.round(orgNow)} — momentum is building. Don't let budget cuts interrupt this progress.`,
        movement:`Rank: ${Math.round(orgPrev)} → ${Math.round(orgNow)} (+${delta.toFixed(0)} positions)`,
        action:`Increase ranking campaign budget 20–30% to accelerate momentum. Maintain consistent daily TOS spend. Do not reduce spend during momentum phase.`,
        impact:`Compounding rank improvement — each page move multiplies organic click volume`});
    }

    // Near page 1 — push
    if(orgNow!=null&&orgNow>=17&&orgNow<=30&&m.searchVolume>300){
      opps.push({icon:"ti-award",color:"#6338c8",type:"page1",
        title:"Page 1 Breakthrough Opportunity",keyword:m.keyword,score:rrOppScore(m,comp)+15,
        why:`Rank ${Math.round(orgNow)} — only ${Math.round(orgNow-16)} positions from page 1 on a ${m.searchVolume.toLocaleString()}-search keyword. This is the highest-ROI ranking push available.`,
        movement:orgPrev!=null?`Rank: ${Math.round(orgPrev)} → ${Math.round(orgNow)}`:`Current rank: ${Math.round(orgNow)}`,
        action:`Increase TOS bid modifier to 50–70%. Run a 3-week focused ranking push. Page 1 on ${m.searchVolume.toLocaleString()} searches changes account economics.`,
        impact:`Page 1 vs page 2: estimated 4x more clicks at same CVR = 4x more orders`});
    }

    // PPC-assisted — organic improving with paid support
    if(m.sponRank!=null&&m.sponRank<15&&orgNow!=null&&orgNow<30&&delta!=null&&delta>3){
      opps.push({icon:"ti-ad-circle",color:"#1a50a0",type:"ppc_assisted",
        title:"PPC Driving Rank Growth",keyword:m.keyword,score:rrOppScore(m,comp),
        why:`Sponsored rank ${Math.round(m.sponRank)} is supporting organic rank improvement from ${Math.round(orgPrev)} to ${Math.round(orgNow)}. PPC investment is working — maintain and scale.`,
        movement:`Organic: +${delta.toFixed(0)} positions · Sponsored rank: ${Math.round(m.sponRank)}`,
        action:`Maintain current PPC spend. Consider increasing budget 15–20% to accelerate velocity while organic rank builds.`,
        impact:`PPC-to-organic rank correlation confirmed — continued investment will compound`});
    }
  });

  return opps.sort((a,b)=>b.score-a.score).slice(0,12);
}

/* ── AI Rank Insights ────────────────────────────────────────── */
function generateRRInsights(curAgg,compAgg,rows,rm){
  const lines=[];
  if(!curAgg||!Object.keys(curAgg).length)return lines;

  if(compAgg&&curAgg.avgOrgRank>0&&compAgg.avgOrgRank>0){
    const delta=compAgg.avgOrgRank-curAgg.avgOrgRank; // positive = improved
    lines.push({type:delta>2?"positive":delta<-2?"negative":"neutral",icon:delta>0?"ti-trending-up":"ti-trending-down",
      text:delta>2?`Average organic rank improved by ${delta.toFixed(1)} positions vs previous period. Consistent PPC support and listing relevance improvements are driving ranking gains. Identify which keywords gained the most and reinforce their campaigns.`
        :delta<-2?`Average organic rank declined by ${Math.abs(delta).toFixed(1)} positions. This typically indicates reduced PPC support, increased competition, or listing relevance issues. Review the top-volume keywords that declined most and rebuild ranking campaigns.`
        :`Organic ranking is relatively stable vs previous period. Focus on identifying keywords near page 1 — these have the highest ROI for focused ranking investment.`});
  }

  const ppcDependent=rows.filter(r=>{const m=rrRow(r,rm);return m.sponRank!=null&&m.sponRank<10&&m.orgRank!=null&&m.orgRank>40;});
  if(ppcDependent.length>0){
    lines.push({type:"negative",icon:"ti-ad-circle",
      text:`${ppcDependent.length} keyword${ppcDependent.length>1?"s are":"is"} heavily PPC-dependent — ranking well in sponsored placements but weak organically. These keywords are expensive to maintain and vulnerable to any budget changes. Prioritize building organic strength here.`});
  }

  const nearPage1=rows.filter(r=>{const m=rrRow(r,rm);return m.orgRank!=null&&m.orgRank>=17&&m.orgRank<=30&&m.searchVolume>200;});
  if(nearPage1.length>0){
    const totalVol=nearPage1.reduce((s,r)=>s+rrRow(r,rm).searchVolume,0);
    lines.push({type:"opportunity",icon:"ti-award",
      text:`${nearPage1.length} keyword${nearPage1.length>1?"s are":"is"} within striking distance of page 1 (${totalVol.toLocaleString()} combined searches). These represent your highest-ROI ranking opportunities — a focused 3–4 week push could permanently shift account economics.`});
  }

  const momentum=rows.filter(r=>{const m=rrRow(r,rm);const comp=null;return m.orgRank!=null&&m.orgRank<30&&m.cvr>3&&m.orders>=2;});
  if(momentum.length>0){
    lines.push({type:"positive",icon:"ti-rocket",
      text:`${momentum.length} keyword${momentum.length>1?"s have":"has"} strong conversion rates while maintaining reasonable ranks. These are your compound growth opportunities — more PPC visibility accelerates both organic rank and revenue simultaneously.`});
  }

  return lines;
}

/* ── RR Upload Zone (module-level) ───────────────────────────── */
function RRUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"13px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:11}}>
        <div style={{width:34,height:34,borderRadius:8,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:15,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:11,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:11,color:R,fontWeight:600,marginTop:3}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:11}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 12px",borderRadius:7,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:11,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const RR_REPORT_TYPES=[
  {id:"rank",    label:"Keyword Rank Report",       icon:"ti-trending-up", required:true, desc:"Organic and/or sponsored rank data per keyword — from any rank tracker or Amazon export"},
  {id:"campaign",label:"Campaign Report",            icon:"ti-speakerphone",required:false,desc:"PPC spend and performance data to analyze ranking correlation"},
  {id:"searchterm",label:"Search Term Report",       icon:"ti-search",     required:false,desc:"Search term performance to validate ranking vs conversion relationship"},
];

/* ── RR Upload Page ──────────────────────────────────────────── */
function RRUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.rank)return;setLoading(true);setErr(null);
    try{const cur=await parseSheet(files.rank);let comp=null;if(compFiles.rank)comp=await parseSheet(compFiles.rank);onComplete({cur,comp,periods:localPeriods});}
    catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:720,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Rank Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your keyword ranking data directly. The system auto-detects organic rank, sponsored rank, and search volume columns from any rank tracker or Amazon export.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><div style={{width:8,height:8,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div><span style={{fontSize:11,color:"#888"}}>{fmtDisp(localPeriods?.current?.start)} — {fmtDisp(localPeriods?.current?.end)}</span></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{RR_REPORT_TYPES.map(t=><RRUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:14}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"9px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period{localPeriods?.comp&&<span style={{fontSize:11,color:"#888",fontWeight:400,marginLeft:4}}>{fmtDisp(localPeriods.comp.start)} — {fmtDisp(localPeriods.comp.end)}</span>}
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><div style={{width:8,height:8,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{RR_REPORT_TYPES.map(t=><RRUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px",marginBottom:14}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:9}}>Supported ranking data sources</div>
          {["Amazon Brand Analytics — Keyword Rankings export","Helium 10 Keyword Tracker export (.xlsx or .csv)","Jungle Scout Rank Tracker export","DataDive, ZonGuru, or any rank tracker with Keyword + Rank columns","Custom rank tracking spreadsheet — needs Keyword and Rank columns minimum"].map((s,i)=>(<div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:"#555",color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className="ti ti-check" style={{fontSize:8}}/></span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>))}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>Minimum required columns: Keyword + at least one of Organic Rank or Sponsored Rank. The system will detect column names automatically from any standard export format.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.rank||loading} style={{...T.btnR(false),opacity:files.rank&&!loading?1:0.4,fontWeight:700,boxShadow:files.rank?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-trending-up" style={{fontSize:14}}/> Run Rank Intelligence</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── RR Overview KPI Bar ─────────────────────────────────────── */
function RROverviewBar({cur,comp,rankStats}){
  const items=[
    {label:"Avg Organic Rank",val:cur.avgOrgRank>0?`#${cur.avgOrgRank.toFixed(0)}`:"—",prev:comp?.avgOrgRank>0?`#${comp.avgOrgRank.toFixed(0)}`:"—",good:comp&&cur.avgOrgRank>0&&cur.avgOrgRank<comp.avgOrgRank,delta:comp&&cur.avgOrgRank>0&&comp.avgOrgRank>0?`${(comp.avgOrgRank-cur.avgOrgRank)>0?"+":""}${(comp.avgOrgRank-cur.avgOrgRank).toFixed(0)} pos`:null},
    {label:"Avg Sponsored Rank",val:cur.avgSponRank>0?`#${cur.avgSponRank.toFixed(0)}`:"—",prev:comp?.avgSponRank>0?`#${comp.avgSponRank.toFixed(0)}`:"—",good:comp&&cur.avgSponRank>0&&cur.avgSponRank<comp.avgSponRank,delta:comp&&cur.avgSponRank>0&&comp.avgSponRank>0?`${(comp.avgSponRank-cur.avgSponRank)>0?"+":""}${(comp.avgSponRank-cur.avgSponRank).toFixed(0)} pos`:null},
    {label:"Keywords Tracked",val:String(cur.termCount||0),prev:null,good:null,delta:null},
    {label:"Organic Ranked",val:String(cur.nOrg||0),prev:null,good:null,delta:null},
    {label:"Page 1 Keywords",val:String(rankStats?.page1||0),prev:String(rankStats?.prevPage1||0),good:rankStats&&rankStats.page1>=(rankStats.prevPage1||0),delta:rankStats&&rankStats.prevPage1!=null?`${(rankStats.page1-rankStats.prevPage1)>0?"+":""}${rankStats.page1-rankStats.prevPage1}`:null},
    {label:"Improving",val:String(rankStats?.improving||0),prev:null,good:true,delta:null},
    {label:"Declining",val:String(rankStats?.declining||0),prev:null,good:false,delta:null},
    {label:"Search Volume",val:cur.totalSearchVolume>=1e3?`${(cur.totalSearchVolume/1e3).toFixed(1)}K`:String(Math.round(cur.totalSearchVolume)),prev:null,good:null,delta:null},
  ];
  return(
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",overflowX:"auto",flexShrink:0}}>
      <div style={{display:"flex",minWidth:"max-content"}}>
        {items.map((d,idx)=><div key={d.label} style={{flex:"0 0 auto",minWidth:120,padding:"13px 16px",borderRight:idx<items.length-1?"1px solid #f0f0f0":"none",borderBottom:`3px solid ${d.good===true?"#1a9e4a":d.good===false?"#d42b2b":"transparent"}`}}>
          <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:6}}>{d.label}</div>
          <div style={{fontSize:19,fontWeight:800,color:d.good===true?"#1a7a3c":d.good===false?"#d42b2b":"#111",letterSpacing:"-0.4px",lineHeight:1,marginBottom:4}}>{d.val}</div>
          {d.delta&&<div style={{fontSize:11,fontWeight:700,color:d.good===true?"#1a9e4a":"#d42b2b",display:"flex",alignItems:"center",gap:3}}><i className={`ti ${d.good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:10}}/>{d.delta}</div>}
          {!d.delta&&d.prev&&d.prev!=="—"&&<div style={{fontSize:10,color:"#ccc"}}>prev: {d.prev}</div>}
        </div>)}
      </div>
    </div>
  );
}

/* ── RR Alert Card ───────────────────────────────────────────── */
function RRAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#6338c8"};const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)",medium:"rgba(99,56,200,0.05)"};const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"rgba(99,56,200,0.18)"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity]||"#f0f0f0",color:sc[a.severity]||"#555",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
            {a.searchVolume>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#888"}}>{a.searchVolume.toLocaleString()} searches</span>}
          </div>
          <div style={{fontSize:12,fontWeight:600,color:"#333",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.keyword}</div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}><span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/></div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4,fontSize:10}}/>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Ranking impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Recommended Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div></div>
      </div>}
    </div>
  );
}

/* ── RR Opportunity Card ─────────────────────────────────────── */
function RROpportunityCard({opp:o}){
  const[open,setOpen]=useState(false);
  const tc={cvr_rank:"#1a7a3c",momentum:"#1a7a3c",page1:"#6338c8",ppc_assisted:"#1a50a0"};const tb={cvr_rank:"rgba(26,122,60,0.05)",momentum:"rgba(26,122,60,0.04)",page1:"rgba(99,56,200,0.06)",ppc_assisted:"rgba(26,80,160,0.05)"};const tbr={cvr_rank:"rgba(26,122,60,0.18)",momentum:"rgba(26,122,60,0.15)",page1:"rgba(99,56,200,0.18)",ppc_assisted:"rgba(26,80,160,0.15)"};
  const c=tc[o.type]||"#1a7a3c";const bg=tb[o.type]||"rgba(26,122,60,0.04)";const br=tbr[o.type]||"rgba(26,122,60,0.15)";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${o.icon}`} style={{fontSize:13,color:c}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>Opportunity</span><span style={{fontSize:10,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#666"}}>Score: {o.score}</span></div>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:2}}>{o.title}</div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{o.keyword}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:`1px solid ${br}`}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}>{o.movement}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{o.why}</div>
        {o.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}>{o.impact}</div>}
        <div style={{padding:"9px 12px",background:bg,borderRadius:8,border:`1px solid ${br}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Ranking Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{o.action}</div></div>
      </div>}
    </div>
  );
}

/* ── RR Movement Table ───────────────────────────────────────── */
function RRMovementTable({rows,rm,compMap}){
  const[search,setSearch]=useState("");const[sortKey,setSortKey]=useState("cls");const[sortDir,setSortDir]=useState("asc");const[filterCls,setFilterCls]=useState("All");
  const CLS_F=["All","Rapid Decline","Declining","PPC Dependent","Rank Opportunity","Momentum","Improving","Page 1","Stable"];
  const PCLS_O={"Rapid Decline":0,"Declining":1,"PPC Dependent":2,"Rank Opportunity":2,"Momentum":3,"Improving":3,"Page 1":4,"Stable":5,"Monitor":6,"No Data":7};
  const processed=useMemo(()=>rows.map((r,i)=>{const m=rrRow(r,rm);const comp=compMap?compMap[m.keyword.toLowerCase()]||null:null;const cls=classifyRank(m,comp);const score=rrOppScore(m,comp);return{r,m,comp,cls,score,id:i};}).filter(x=>x.m.keyword),[rows,rm,compMap]);
  const filtered=useMemo(()=>{let d=processed;if(search){const q=search.toLowerCase();d=d.filter(x=>x.m.keyword.toLowerCase().includes(q));}if(filterCls!=="All")d=d.filter(x=>x.cls.cls===filterCls);return d;},[processed,search,filterCls]);
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{if(sortKey==="cls")return sortDir==="asc"?(PCLS_O[a.cls.cls]??7)-(PCLS_O[b.cls.cls]??7):(PCLS_O[b.cls.cls]??7)-(PCLS_O[a.cls.cls]??7);if(sortKey==="keyword")return sortDir==="asc"?a.m.keyword.localeCompare(b.m.keyword):b.m.keyword.localeCompare(a.m.keyword);if(sortKey==="orgRank"){const va=a.m.orgRank??999,vb=b.m.orgRank??999;return sortDir==="asc"?va-vb:vb-va;}if(sortKey==="score"){return sortDir==="asc"?a.score-b.score:b.score-a.score;}const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;}),[filtered,sortKey,sortDir]);
  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir(k==="orgRank"?"asc":"desc");}}
  const clsCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.cls.cls]=(m[x.cls.cls]||0)+1;});return m;},[processed]);
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const fmtV=v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v));
  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 18px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:180}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search keyword…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {CLS_F.map(f=>{const cnt=f==="All"?processed.length:clsCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterCls===f;return<button key={f} onClick={()=>setFilterCls(f)} style={{padding:"4px 9px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/><span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> keywords</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("cls")}>Status <SI col="cls"/></th>
            <th style={thS} onClick={()=>toggleSort("keyword")}>Keyword <SI col="keyword"/></th>
            <th style={thS} onClick={()=>toggleSort("orgRank")}>Organic Rank <SI col="orgRank"/></th>
            <th style={thS} onClick={()=>toggleSort("sponRank")}>Sponsored <SI col="sponRank"/></th>
            <th style={{...thS,cursor:"default"}}>Delta</th>
            <th style={thS} onClick={()=>toggleSort("searchVolume")}>Search Vol. <SI col="searchVolume"/></th>
            <th style={thS} onClick={()=>toggleSort("score")}>Opp. Score <SI col="score"/></th>
            <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
            <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
            <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,cls,score,id},i)=>{
              const delta=cls.delta;
              const rankColor=m.orgRank!=null?m.orgRank<=16?"#1a7a3c":m.orgRank<=32?"#c47a00":"#d42b2b":"#aaa";
              return(<tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"7px 10px"}}><div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:6,background:cls.bg,border:`1px solid ${cls.color}22`}}><i className={`ti ${cls.icon}`} style={{fontSize:9,color:cls.color}}/><span style={{fontSize:9,fontWeight:700,color:cls.color,whiteSpace:"nowrap"}}>{cls.cls}</span></div></td>
                <td style={{padding:"8px 10px",maxWidth:200}} title={m.keyword}><div style={{fontWeight:600,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.keyword}</div></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}>
                  <div style={{fontSize:13,fontWeight:800,color:rankColor}}>{m.orgRank!=null?`#${Math.round(m.orgRank)}`:"—"}</div>
                  {m.orgRank!=null&&<div style={{fontSize:9,color:"#aaa"}}>p.{Math.ceil(m.orgRank/16)}</div>}
                  {comp?.orgRank!=null&&<div style={{fontSize:10,color:"#ccc"}}>prev: #{Math.round(comp.orgRank)}</div>}
                </td>
                <td style={{padding:"8px 10px"}}>{m.sponRank!=null?<span style={{fontSize:12,fontWeight:600,color:"#1a50a0"}}>#{Math.round(m.sponRank)}</span>:"—"}</td>
                <td style={{padding:"8px 10px"}}>
                  {delta!=null&&Math.abs(delta)>0?
                    <span style={{fontSize:12,fontWeight:700,color:delta>0?"#1a9e4a":"#d42b2b",display:"flex",alignItems:"center",gap:3}}>
                      <i className={`ti ${delta>0?"ti-arrow-up":"ti-arrow-down"}`} style={{fontSize:10}}/>{delta>0?"+":""}{Math.round(delta)}
                    </span>:"—"}
                </td>
                <td style={{padding:"8px 10px"}}>{m.searchVolume>0?fmtV(m.searchVolume):"—"}</td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:5}}><div style={{height:4,borderRadius:2,background:`${score>=70?"#1a9e4a":score>=40?"#c47a00":"#eee"}`,width:`${score}%`,maxWidth:40}}/><span style={{fontSize:11,fontWeight:700,color:score>=70?"#1a7a3c":score>=40?"#c47a00":"#aaa"}}>{score}</span></div>
                </td>
                <td style={{padding:"8px 10px"}}>{m.cvr>0?<span style={{fontSize:12,color:"#111"}}>{m.cvr.toFixed(1)}%</span>:"—"}</td>
                <td style={{padding:"8px 10px"}}>{m.orders>0?<span style={{fontSize:12,color:"#111"}}>{Math.round(m.orders)}</span>:"—"}</td>
                <td style={{padding:"8px 10px"}}>{m.spend>0?<span style={{fontSize:12,color:"#111"}}>${m.spend.toFixed(0)}</span>:"—"}</td>
              </tr>);
            })}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No keywords match</div></div>}
      </div>
    </div>
  );
}

/* ── RR Workspace ────────────────────────────────────────────── */
function RRWorkspace({curData,compData,periods,onReupload}){
  const rm=useMemo(()=>curData?rrDetect(curData.headers):{},[curData]);
  const compRm=useMemo(()=>compData?rrDetect(compData.headers):{},[compData]);
  const curAgg=useMemo(()=>curData?rrAgg(curData.rows,rm):{},[curData,rm]);
  const compAgg=useMemo(()=>compData?rrAgg(compData.rows,compRm):null,[compData,compRm]);
  const compMap=useMemo(()=>{if(!compData)return null;const m={};compData.rows.forEach(r=>{const row=rrRow(r,compRm);if(row.keyword)m[row.keyword.toLowerCase()]=row;});return m;},[compData,compRm]);
  const alerts=useMemo(()=>curData?generateRRAlerts(curData.rows,rm,compMap):[],[curData,rm,compMap]);
  const opportunities=useMemo(()=>curData?generateRROpportunities(curData.rows,rm,compMap):[],[curData,rm,compMap]);
  const insights=useMemo(()=>curData?generateRRInsights(curAgg,compAgg,curData.rows,rm):[],[curAgg,compAgg,curData,rm]);
  const rankStats=useMemo(()=>{
    if(!curData)return null;
    let page1=0,improving=0,declining=0,prevPage1=0;
    curData.rows.forEach(r=>{
      const m=rrRow(r,rm);const comp=compMap?compMap[m.keyword.toLowerCase()]||null:null;
      const cls=classifyRank(m,comp);
      if(m.orgRank!=null&&m.orgRank<=16)page1++;
      if(cls.cls==="Momentum"||cls.cls==="Improving")improving++;
      if(cls.cls==="Declining"||cls.cls==="Rapid Decline")declining++;
    });
    if(compData){compData.rows.forEach(r=>{const m=rrRow(r,compRm);if(m.orgRank!=null&&m.orgRank<=16)prevPage1++;});}
    return{page1,improving,declining,prevPage1:compData?prevPage1:null};
  },[curData,compData,rm,compRm,compMap]);

  const[activeTab,setActiveTab]=useState("overview");
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const TABS=[{key:"overview",label:"Rank Overview",icon:"ti-trending-up"},{key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},{key:"opportunities",label:`Opportunities${opportunities.length?` (${opportunities.length})`:""}`,icon:"ti-rocket"},{key:"table",label:"Rank Movement",icon:"ti-table"},{key:"insights",label:"AI Insights",icon:"ti-brain"}];
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Rank Radar</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {opportunities.length>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(99,56,200,0.08)",color:"#6338c8",fontWeight:700}}>{opportunities.length} Opportunities</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{curAgg.termCount||0} keywords tracked</span>
          </div>
        </div>
        <button onClick={onReupload} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 13px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",color:"#555",fontSize:12,fontWeight:500,cursor:"pointer"}}><i className="ti ti-upload" style={{fontSize:13}}/> Re-upload</button>
      </div>
      <RROverviewBar cur={curAgg} comp={compAgg?.termCount>0?compAgg:null} rankStats={rankStats}/>
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {/* OVERVIEW */}
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:900,margin:"0 auto",padding:"20px 22px"}}>
          <div style={{marginBottom:20}}>
            <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Rank Distribution</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
              {[{label:"Page 1",val:rankStats?.page1||0,color:"#1a7a3c",bg:"rgba(26,122,60,0.07)"},{label:"Improving",val:rankStats?.improving||0,color:"#1a9e4a",bg:"rgba(26,158,74,0.06)"},{label:"Declining",val:rankStats?.declining||0,color:"#d42b2b",bg:"rgba(212,43,43,0.07)"},{label:"Near Page 1",val:curData?.rows?.filter(r=>{const m=rrRow(r,rm);return m.orgRank!=null&&m.orgRank>=17&&m.orgRank<=32;}).length||0,color:"#6338c8",bg:"rgba(99,56,200,0.07)"}].map(cat=>(
                <div key={cat.label} style={{padding:"14px",background:cat.bg,borderRadius:10,border:`1px solid ${cat.color}22`,textAlign:"center"}}><div style={{fontSize:24,fontWeight:800,color:cat.color,marginBottom:4}}>{cat.val}</div><div style={{fontSize:11,fontWeight:600,color:cat.color}}>{cat.label}</div></div>
              ))}
            </div>
          </div>
          {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:20}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Rank Intelligence Summary</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
            {insights.slice(0,3).map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#6338c8",neutral:"#555"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-award",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
          </div>}
          {alerts.length>0&&<div><div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Top Rank Alerts</div>{alerts.slice(0,3).map((a,i)=><RRAlertCard key={i} alert={a}/>)}{alerts.length>3&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),marginTop:4,width:"100%",justifyContent:"center"}}>View All {alerts.length} Alerts →</button>}</div>}
        </div></div>}
        {activeTab==="alerts"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alerts.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-trending-up" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No rank alerts</div><div style={{fontSize:13,color:"#888",marginTop:4}}>Upload a comparison period to enable rank movement detection.</div></div>:alerts.map((a,i)=><RRAlertCard key={i} alert={a}/>)}</div></div>}
        {activeTab==="opportunities"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{opportunities.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-rocket" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No ranking opportunities detected</div><div style={{fontSize:13,color:"#888",marginTop:4}}>Upload data with CVR and order columns to enable opportunity detection.</div></div>:opportunities.map((o,i)=><RROpportunityCard key={i} opp={o}/>)}</div></div>}
        {activeTab==="table"&&<RRMovementTable rows={curData?.rows||[]} rm={rm} compMap={compMap}/>}
        {activeTab==="insights"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><i className="ti ti-brain" style={{fontSize:14,color:R}}/><div style={{fontSize:14,fontWeight:700,color:"#111"}}>Rank Intelligence Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>{insights.length===0?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><div>Upload a comparison period to enable AI rank analysis</div></div>:insights.map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#6338c8",neutral:"#555"};const tb={positive:"rgba(26,122,60,0.05)",negative:"rgba(212,43,43,0.04)",opportunity:"rgba(99,56,200,0.05)",neutral:"rgba(0,0,0,0.02)"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-award",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}><div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/></div><div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div></div>;})}</div></div></div>}
      </div>
    </div>
  );
}

/* ── Rank Radar Module Root ──────────────────────────────────── */
function RankRadarModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.rank?"workspace":globalData?.cur?.primary?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(globalData?.cur?.rank||globalData?.cur?.primary||null);const[compData,setCompData]=useState(globalData?.comp?.rank||globalData?.comp?.primary||null);
  useEffect(()=>{if((globalData?.cur?.rank||globalData?.cur?.primary)&&page==="upload"){setCurData(globalData.cur.rank||globalData.cur.primary);setCompData(globalData.comp?.rank||globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);
  if(page==="workspace"&&curData)return<RRWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>setPage("upload")}/>;
  return<RRUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/>;
}

/* ================================================================
   BULK CAMPAIGN BUILDER MODULE
   Campaign structure generation system for Amazon PPC strategists.
   Pages: Upload Input → Builder Workspace → Export Bulk Sheets
================================================================ */

/* ================================================================
   BULK BUILDER MODULE — 5-TAB CAMPAIGN CREATION SYSTEM
   Tabs: Rules | Brand Table | Keywords & ASINs |
         Keyword Campaigns Created | Product Campaigns Created
   Mirrors the Google Sheet JCM workflow exactly.
================================================================ */

const BB_LS = "quarred_bulkbuilder_v1";
function bbLoad(){try{const s=localStorage.getItem(BB_LS);return s?JSON.parse(s):bbDefault();}catch{return bbDefault();}}
function bbDefault(){
  return{
    /* Rules */
    brandName:"",productName:"",portfolioId:"",portfolioName:"",sku:"",
    productCode:"",adType:"SP",sourceKW:"KW",specialId:"",
    lastCampExact:0,lastCampPhrase:0,lastCampBroad:0,lastCampAsin:0,lastCampAsinExp:0,
    maxKwPerCamp:500,
    dailyBudget:15,startDate:"",defaultGroupBid:1,
    bidExact:1.20,bidPhrase:0.90,bidBroad:0.65,bidAsin:0.85,bidAsinExp:0.75,
    /* Match type enables */
    useExact:true,usePhrase:true,useBroad:false,useAsin:false,useAsinExp:false,
    /* Brand Table rows */
    brandTableRows:[],
    /* Keywords & ASINs */
    kwExact:"",kwPhrase:"",kwBroad:"",kwAsin:"",kwAsinExp:"",
    /* Generated campaigns */
    campKeyword:[],campProduct:[],
  };
}
function bbSave(d){try{localStorage.setItem(BB_LS,JSON.stringify(d));}catch{}}

/* ── Build Quarred campaign name ── */
function bbName(d, matchLabel, num){
  const parts=[d.productCode,d.adType||"SP",d.sourceKW||"KW",d.specialId,matchLabel,String(num)].filter(Boolean);
  return parts.join(" - ");
}

/* ── Split text into clean keyword list ── */
function bbKwList(text){return(text||"").split(/[\n,]+/).map(k=>k.trim()).filter(Boolean);}

/* ── Generate all campaign rows ── */
function bbGenerate(d){
  const today=new Date();
  const dateStr=d.startDate||(today.getFullYear()+String(today.getMonth()+1).padStart(2,"0")+String(today.getDate()).padStart(2,"0"));
  const campKeyword=[];
  const campProduct=[];

  function addKwCampaigns(matchType, matchLabel, kwText, lastNum, bid){
    const kws=bbKwList(kwText);
    if(!kws.length)return lastNum;
    const max=parseInt(d.maxKwPerCamp)||500;
    let num=parseInt(lastNum||0);
    for(let i=0;i<kws.length;i+=max){
      num++;
      const chunk=kws.slice(i,i+max);
      const campName=bbName(d,matchLabel,num);
      /* Campaign */
      campKeyword.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Campaign","Operation":"create","Campaign Name":campName,"Portfolio ID":d.portfolioId||"","Portfolio Id":d.portfolioId||"","Targeting Type":"Manual","State":"enabled","Daily Budget":parseFloat(d.dailyBudget||15).toFixed(2),"Bidding Strategy":"legacyForSales","Start Date":dateStr}));
      /* Ad Group */
      campKeyword.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Ad Group","Operation":"create","Campaign Name":campName,"Ad Group Name":campName,"State":"enabled","Ad Group Default Bid":parseFloat(d.defaultGroupBid||1).toFixed(2)}));
      /* Product Ad per SKU */
      const skus=bbGetSkus(d);
      skus.forEach(sku=>campKeyword.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Product Ad","Operation":"create","Campaign Name":campName,"Ad Group Name":campName,"SKU":sku,"State":"enabled"})));
      /* Keywords */
      chunk.forEach(kw=>campKeyword.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Keyword","Operation":"create","Campaign Name":campName,"Ad Group Name":campName,"Keyword Text":kw,"Match Type":matchType,"Bid":parseFloat(bid||1).toFixed(2),"State":"enabled"})));
    }
    return num;
  }

  function addAsinCampaigns(matchLabel, asinText, lastNum, bid, expanded){
    const asins=bbKwList(asinText);
    if(!asins.length)return lastNum;
    const max=parseInt(d.maxKwPerCamp)||500;
    let num=parseInt(lastNum||0);
    for(let i=0;i<asins.length;i+=max){
      num++;
      const chunk=asins.slice(i,i+max);
      const campName=bbName(d,matchLabel,num);
      campProduct.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Campaign","Operation":"create","Campaign Name":campName,"Portfolio ID":d.portfolioId||"","Portfolio Id":d.portfolioId||"","Targeting Type":"Manual","State":"enabled","Daily Budget":parseFloat(d.dailyBudget||15).toFixed(2),"Bidding Strategy":"legacyForSales","Start Date":dateStr}));
      campProduct.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Ad Group","Operation":"create","Campaign Name":campName,"Ad Group Name":campName,"State":"enabled","Ad Group Default Bid":parseFloat(d.defaultGroupBid||1).toFixed(2)}));
      const skus=bbGetSkus(d);
      skus.forEach(sku=>campProduct.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Product Ad","Operation":"create","Campaign Name":campName,"Ad Group Name":campName,"SKU":sku,"State":"enabled"})));
      chunk.forEach(asin=>{
        const expr=expanded?`asin="${asin.trim().toUpperCase()}"`:(`asin="${asin.trim().toUpperCase()}"`);
        campProduct.push(amznBlankRow({"Product":"Sponsored Products","Entity":"Product Targeting","Operation":"create","Campaign Name":campName,"Ad Group Name":campName,"Product Targeting Expression":expr,"Bid":parseFloat(bid||0.85).toFixed(2),"State":"enabled"}));
      });
    }
    return num;
  }

  let newLastExact=d.lastCampExact,newLastPhrase=d.lastCampPhrase,newLastBroad=d.lastCampBroad,newLastAsin=d.lastCampAsin,newLastAsinExp=d.lastCampAsinExp;
  if(d.useExact)  newLastExact  =addKwCampaigns("exact",  "Exact",         d.kwExact,   d.lastCampExact,   d.bidExact);
  if(d.usePhrase) newLastPhrase =addKwCampaigns("phrase", "Phrase",        d.kwPhrase,  d.lastCampPhrase,  d.bidPhrase);
  if(d.useBroad)  newLastBroad  =addKwCampaigns("broad",  "Broad",         d.kwBroad,   d.lastCampBroad,   d.bidBroad);
  if(d.useAsin)   newLastAsin   =addAsinCampaigns("Asin",         d.kwAsin,    d.lastCampAsin,    d.bidAsin,    false);
  if(d.useAsinExp)newLastAsinExp=addAsinCampaigns("Asin Expanded",d.kwAsinExp, d.lastCampAsinExp, d.bidAsinExp, true);

  return{campKeyword,campProduct,newLastExact,newLastPhrase,newLastBroad,newLastAsin,newLastAsinExp};
}

function bbGetSkus(d){
  /* Collect all SKUs from the selected brand table row */
  const row=d._selectedBtRow;
  if(!row)return[d.sku||""].filter(Boolean);
  const skus=[];
  for(let i=1;i<=20;i++){const k=`sku${i===1?"":i}`;if(row[k])skus.push(row[k]);}
  if(!skus.length&&d.sku)skus.push(d.sku);
  return skus.filter(Boolean);
}

/* ── Export helpers ── */
function bbDownloadKw(campKeyword,d){
  if(!campKeyword.length){alert("No keyword campaigns generated. Check your keywords and match type settings.");return;}
  const ws=XLSX.utils.json_to_sheet(campKeyword,{header:AMZN_SP_COLS});
  ws["!cols"]=AMZN_SP_COLS.map(h=>({wch:["Campaign Name","Ad Group Name","Keyword Text"].includes(h)?32:14}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Sponsored Products Campaigns");
  XLSX.writeFile(wb,`Amazon_KW_Campaigns_${d.productCode||"bulk"}_${new Date().toISOString().slice(0,10)}.xlsx`);
}
function bbDownloadPt(campProduct,d){
  if(!campProduct.length){alert("No product targeting campaigns generated. Check your ASINs and match type settings.");return;}
  const ws=XLSX.utils.json_to_sheet(campProduct,{header:AMZN_SP_COLS});
  ws["!cols"]=AMZN_SP_COLS.map(h=>({wch:["Campaign Name","Ad Group Name","Product Targeting Expression"].includes(h)?32:14}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Sponsored Products Campaigns");
  XLSX.writeFile(wb,`Amazon_PT_Campaigns_${d.productCode||"bulk"}_${new Date().toISOString().slice(0,10)}.xlsx`);
}

/* ── RULES TAB ── */
function BBRulesTab({d,setD,btRows}){
  const upd=(k,v)=>setD(p=>({...p,[k]:v}));

  /* When product selected from brand table, auto-fill */
  function selectBtRow(rowIdx){
    const row=btRows[parseInt(rowIdx)];
    if(!row)return;
    setD(p=>({...p,
      brandName:row.brandName||p.brandName,
      productName:row.productName||p.productName,
      portfolioId:row.portfolioId||p.portfolioId,
      portfolioName:row.portfolioName||p.portfolioName,
      sku:row.sku1||row.sku||p.sku,
      productCode:row.productCode||p.productCode,
      _selectedBtRow:row,
      _selectedBtIdx:rowIdx,
    }));
  }

  const MATCH_TYPES=[
    {key:"useExact",   label:"Exact",         bid:"bidExact",   last:"lastCampExact",   color:"#4f46e5"},
    {key:"usePhrase",  label:"Phrase",        bid:"bidPhrase",  last:"lastCampPhrase",  color:"#1a5fa0"},
    {key:"useBroad",   label:"Broad",         bid:"bidBroad",   last:"lastCampBroad",   color:"#1a7a3c"},
    {key:"useAsin",    label:"Asin",          bid:"bidAsin",    last:"lastCampAsin",    color:"#6338c8"},
    {key:"useAsinExp", label:"Asin Expanded", bid:"bidAsinExp", last:"lastCampAsinExp", color:"#c47a00"},
  ];

  const Inp=({label,k,type="text",ph,small})=>(
    <div>
      <div style={{fontSize:10,fontWeight:700,color:"#666",textTransform:"uppercase",letterSpacing:"0.4px",marginBottom:3}}>{label}</div>
      <input type={type}
        defaultValue={d[k]||""}
        key={k+"_"+String(d[k]||"")}
        onBlur={e=>upd(k,type==="number"?parseFloat(e.target.value)||0:e.target.value)}
        onChange={()=>{}}
        placeholder={ph||""} step={type==="number"?"0.01":undefined} min={type==="number"?"0.02":undefined}
        style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
      {small&&<div style={{fontSize:9,color:"#aaa",marginTop:2}}>{small}</div>}
    </div>
  );

  /* Campaign name preview */
  const previewMt=MATCH_TYPES.find(m=>d[m.key])||MATCH_TYPES[0];
  const previewNum=(parseInt(d[previewMt.last]||0)+1);
  const preview=bbName(d,previewMt.label,previewNum);

  return(
    <div style={{padding:"16px 20px",overflowY:"auto",height:"100%",boxSizing:"border-box"}}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18,maxWidth:1000}}>
        {/* Left column */}
        <div style={{display:"flex",flexDirection:"column",gap:10}}>

          {/* Product from Brand Table */}
          {btRows.length>0&&(
            <div style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"12px 14px"}}>
              <div style={{fontSize:11,fontWeight:700,color:"#1a7a3c",marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
                <i className="ti ti-table-heart" style={{fontSize:11}}/>Select from Brand Table
              </div>
              <select value={d._selectedBtIdx??""} onChange={e=>selectBtRow(e.target.value)} style={{padding:"7px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",cursor:"pointer"}}>
                <option value="">— Select product —</option>
                {btRows.map((r,i)=><option key={i} value={i}>{r.productCode||"?"} — {(r.productName||r.brandName||"").slice(0,45)}</option>)}
              </select>
            </div>
          )}

          <div style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"12px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:10,textTransform:"uppercase",letterSpacing:"0.5px"}}>Product Info</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              <Inp label="Brand Name" k="brandName" ph="El Yucateco"/>
              <Inp label="Product Name" k="productName" ph="Red Habanero Hot Sauce"/>
              <Inp label="Portfolio ID" k="portfolioId" ph="157001817011792"/>
              <Inp label="SKU" k="sku" ph="75"/>
              <Inp label="Product Code" k="productCode" ph="RHHS-HG"/>
            </div>
          </div>

          <div style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"12px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:10,textTransform:"uppercase",letterSpacing:"0.5px"}}>Campaign Naming</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              <div>
                <div style={{fontSize:10,fontWeight:700,color:"#666",textTransform:"uppercase",letterSpacing:"0.4px",marginBottom:3}}>Source of KW</div>
                <select value={d.sourceKW||"KW"} onChange={e=>upd("sourceKW",e.target.value)} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",cursor:"pointer"}}>
                  {["KW","SQPR","STR","COMP","BRAND","AUTO","ASIN"].map(v=><option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <Inp label="Special Identifier" k="specialId" ph="Green Sauce Related"/>
            </div>
            <div style={{marginTop:8,padding:"8px 10px",background:"rgba(79,70,229,0.04)",borderRadius:7,border:"1px solid rgba(79,70,229,0.1)",fontSize:11,color:"#333",fontFamily:"monospace"}}>
              <span style={{fontSize:9,color:"#aaa",display:"block",marginBottom:2}}>PREVIEW</span>
              {preview||"Fill product code + special identifier to see preview"}
            </div>
          </div>

          <div style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"12px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:10,textTransform:"uppercase",letterSpacing:"0.5px"}}>Campaign Settings</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              <div>
                <div style={{fontSize:10,fontWeight:700,color:"#666",textTransform:"uppercase",letterSpacing:"0.4px",marginBottom:3}}>Start Date</div>
                <input type="date" value={d.startDate?.length===8?`${d.startDate.slice(0,4)}-${d.startDate.slice(4,6)}-${d.startDate.slice(6,8)}`:d.startDate||""} min={new Date().toISOString().slice(0,10)} onChange={e=>upd("startDate",e.target.value.replace(/-/g,""))} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none",cursor:"pointer"}}/>
                <div style={{fontSize:9,color:"#c47a00",marginTop:2}}>⚠ Cannot be past. Upload on this date.</div>
              </div>
              <Inp label="Daily Budget ($)" k="dailyBudget" type="number" ph="15"/>
              <div>
                <Inp label="Default Group Bid ($)" k="defaultGroupBid" type="number" ph="1"/>
                <div style={{fontSize:9,color:"#888",marginTop:2}}>Fallback only — keyword bids override this</div>
              </div>
              <Inp label="Max KWs per Campaign" k="maxKwPerCamp" type="number" ph="500" small="Splits into new campaign when exceeded"/>
            </div>
          </div>
        </div>

        {/* Right column — Match types */}
        <div>
          <div style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"12px 14px",marginBottom:10}}>
            <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>Match Type Activation</div>
            <div style={{fontSize:10,color:"#888",marginBottom:12}}>Enable match types. Campaigns only created for enabled types that have keywords in the Keywords & ASINs tab.</div>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"#f7f7f7"}}>
                  {["On","Match Type","Bid ($)","Last Camp #","How many/day","Max KW/Camp","Total KW-ASINs"].map(h=>(
                    <th key={h} style={{padding:"7px 8px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {MATCH_TYPES.map((mt,i)=>{
                  const kwCount=bbKwList(d[mt.key==="useAsin"?"kwAsin":mt.key==="useAsinExp"?"kwAsinExp":mt.key==="useExact"?"kwExact":mt.key==="usePhrase"?"kwPhrase":"kwBroad"]).length;
                  const maxKw=parseInt(d.maxKwPerCamp)||500;
                  const camps=kwCount>0?Math.ceil(kwCount/maxKw):0;
                  return(
                    <tr key={mt.key} style={{borderBottom:"1px solid #f5f5f5",background:d[mt.key]?"rgba(0,0,0,0.01)":"#fafafa",opacity:d[mt.key]?1:0.5}}>
                      <td style={{padding:"6px 8px"}}>
                        <button onClick={()=>upd(mt.key,!d[mt.key])} style={{width:20,height:20,borderRadius:4,border:`2px solid ${d[mt.key]?mt.color:"#ccc"}`,background:d[mt.key]?mt.color:"#fff",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                          {d[mt.key]&&<i className="ti ti-check" style={{fontSize:10,color:"#fff"}}/>}
                        </button>
                      </td>
                      <td style={{padding:"6px 8px",fontWeight:600,color:mt.color}}>{mt.label}</td>
                      <td style={{padding:"6px 8px"}}>
                        <input type="number" step="0.01" min="0.02" defaultValue={d[mt.bid]||""} key={mt.bid+"_"+String(d[mt.bid]||"")} onBlur={e=>upd(mt.bid,parseFloat(e.target.value)||0)} onChange={()=>{}} style={{padding:"4px 7px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:11,width:65,outline:"none"}}/>
                      </td>
                      <td style={{padding:"6px 8px"}}>
                        <input type="number" min="0" defaultValue={d[mt.last]||0} key={mt.last+"_"+String(d[mt.last]||0)} onBlur={e=>upd(mt.last,parseInt(e.target.value)||0)} onChange={()=>{}} style={{padding:"4px 7px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:11,width:55,outline:"none"}}/>
                      </td>
                      <td style={{padding:"6px 8px",color:"#555",textAlign:"center"}}>{d[mt.key]?camps:0}</td>
                      <td style={{padding:"6px 8px",color:"#555",textAlign:"center"}}>{d.maxKwPerCamp||500}</td>
                      <td style={{padding:"6px 8px",fontWeight:600,color:kwCount>0?"#1a7a3c":"#888",textAlign:"center"}}>{kwCount}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* How to use — collapsible */}
          <BBHowToUse/>
        </div>
      </div>
    </div>
  );
}

/* ── How to use — collapsible ── */
function BBHowToUse(){
  const[open,setOpen]=useState(false);
  const steps=[
    {n:1,icon:"ti-table-heart",t:"Build Brand Table",b:"Add your products with Product Code, Portfolio ID and SKUs. Select the product here in Rules — everything auto-fills."},
    {n:2,icon:"ti-tag",t:"Set naming fields",b:"Product Code + Source of KW + Special Identifier builds your campaign name automatically. Example: RHHS-HG - SP - SQPR - Green Sauce Related - Exact - 1"},
    {n:3,icon:"ti-keyboard",t:"Paste keywords by match type",b:"Go to Keywords & ASINs tab. Paste into the column for each match type. Only columns with data AND enabled here will generate campaigns."},
    {n:4,icon:"ti-list-check",t:"Enable match types + set bids",b:"Tick the match types you want. Set bids per match type. Set Last Camp # if campaigns already exist (new ones continue the sequence)."},
    {n:5,icon:"ti-rocket",t:"Click Create Campaigns",b:"Click the button. Campaigns appear in Keyword Campaigns or Product Campaigns tabs. Download the Excel and upload to Amazon Bulk Operations."},
    {n:6,icon:"ti-upload",t:"Upload to Amazon",b:"Go to Seller Central → Campaign Manager → Bulk Operations → Upload. Amazon creates all campaigns in minutes."},
  ];
  return(
    <div style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",overflow:"hidden"}}>
      <button onClick={()=>setOpen(o=>!o)} style={{width:"100%",padding:"11px 14px",background:open?R:"#fff",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:8,textAlign:"left"}}>
        <i className="ti ti-help-circle" style={{fontSize:14,color:open?"#fff":R}}/>
        <span style={{fontSize:12,fontWeight:700,color:open?"#fff":R}}>How to use this module</span>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:open?"#fff":"#aaa",marginLeft:"auto"}}/>
      </button>
      {open&&(
        <div style={{padding:"14px 16px"}}>
          {steps.map((s,i)=>(
            <div key={i} style={{display:"flex",gap:11,marginBottom:i<5?12:0,paddingBottom:i<5?12:0,borderBottom:i<5?"1px solid #f5f5f5":"none"}}>
              <div style={{width:24,height:24,borderRadius:"50%",background:R,color:"#fff",fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{s.n}</div>
              <div>
                <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:2}}><i className={`ti ${s.icon}`} style={{fontSize:11,color:R,marginRight:5}}/>{s.t}</div>
                <div style={{fontSize:11,color:"#555",lineHeight:1.6}}>{s.b}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── BRAND TABLE TAB ── */
function BBBrandTableTab({d,setD}){
  const rows=d.brandTableRows||[];
  const[editing,setEditing]=useState(null); // index or "new"
  const[form,setForm]=useState({});

  const SKU_COLS=Array.from({length:20},(_,i)=>i===0?"sku":`sku${i+1}`);
  const SKU_LABELS=Array.from({length:20},(_,i)=>i===0?"SKU":`SKU${i+1}`);

  function saveRow(){
    const updated=editing==="new"?[...rows,{...form}]:rows.map((r,i)=>i===editing?{...form}:r);
    setD(p=>({...p,brandTableRows:updated}));
    setEditing(null);setForm({});
  }
  function delRow(i){if(!window.confirm("Delete this product?"))return;setD(p=>({...p,brandTableRows:rows.filter((_,j)=>j!==i)}));}
  function editRow(i){setForm({...rows[i]});setEditing(i);}
  function newRow(){setForm({});setEditing("new");}

  function exportBrandTable(){
    if(!rows.length){alert("No products in Brand Table.");return;}
    const headers=["SKU Counts","Brand Name","Product Name","Product Code","Portfolio ID","Portfolio Name",...SKU_LABELS];
    const wsRows=rows.map(r=>({
      "SKU Counts":SKU_COLS.filter(k=>r[k]).length||0,
      "Brand Name":r.brandName||"","Product Name":r.productName||"",
      "Product Code":r.productCode||"","Portfolio ID":r.portfolioId||"","Portfolio Name":r.portfolioName||"",
      ...Object.fromEntries(SKU_LABELS.map((l,i)=>[l,r[SKU_COLS[i]]||""]))
    }));
    const ws=XLSX.utils.json_to_sheet(wsRows,{header:headers});
    ws["!cols"]=headers.map(()=>({wch:18}));
    const wb=XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb,ws,"Brand Table");
    XLSX.writeFile(wb,`Brand_Table_${new Date().toISOString().slice(0,10)}.xlsx`);
  }

  return(
    <div style={{padding:"14px 20px",overflowY:"auto",height:"100%",boxSizing:"border-box"}}>
      {editing!==null&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:14,width:"100%",maxWidth:700,maxHeight:"85vh",overflow:"hidden",display:"flex",flexDirection:"column"}}>
            <div style={{padding:"14px 18px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:8}}>
              <i className="ti ti-table-heart" style={{fontSize:14,color:"#1a7a3c"}}/>
              <span style={{fontSize:14,fontWeight:700,color:"#111"}}>{editing==="new"?"Add Product":"Edit Product"}</span>
              <button onClick={()=>{setEditing(null);setForm({});}} style={{marginLeft:"auto",border:"none",background:"transparent",cursor:"pointer",fontSize:18,color:"#aaa"}}><i className="ti ti-x"/></button>
            </div>
            <div style={{overflowY:"auto",padding:"16px 18px"}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
                {[["Brand Name","brandName"],["Product Name","productName"],["Product Code","productCode"],["Portfolio ID","portfolioId"],["Portfolio Name","portfolioName"]].map(([lbl,k])=>(
                  <div key={k}>
                    <div style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",marginBottom:3}}>{lbl}</div>
                    <input value={form[k]||""} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
                  </div>
                ))}
              </div>
              <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:8}}>SKUs (unlimited — add as many child ASINs/SKUs as needed)</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
                {SKU_COLS.map((k,i)=>(
                  <div key={k}>
                    <div style={{fontSize:9,fontWeight:700,color:"#888",textTransform:"uppercase",marginBottom:3}}>{SKU_LABELS[i]}</div>
                    <input value={form[k]||""} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} style={{padding:"5px 8px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:11,width:"100%",boxSizing:"border-box",outline:"none"}}/>
                  </div>
                ))}
              </div>
            </div>
            <div style={{padding:"12px 18px",borderTop:"1px solid #f0f0f0",display:"flex",justifyContent:"flex-end",gap:8}}>
              <button onClick={()=>{setEditing(null);setForm({});}} style={{padding:"7px 16px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555",fontWeight:600}}>Cancel</button>
              <button onClick={saveRow} style={{...T.btnR(true),padding:"7px 20px",fontSize:12}}><i className="ti ti-check" style={{fontSize:12}}/>Save</button>
            </div>
          </div>
        </div>
      )}

      <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center"}}>
        <div style={{fontSize:14,fontWeight:700,color:"#111"}}>Brand Table</div>
        <span style={{fontSize:11,color:"#aaa"}}>{rows.length} products</span>
        <div style={{flex:1}}/>
        <button onClick={exportBrandTable} style={{padding:"7px 14px",borderRadius:8,border:"1px solid rgba(26,122,60,0.3)",background:"rgba(26,122,60,0.06)",cursor:"pointer",fontSize:11,color:"#1a7a3c",fontWeight:600,display:"flex",alignItems:"center",gap:5}}><i className="ti ti-download" style={{fontSize:11}}/>Export</button>
        <button onClick={newRow} style={{...T.btnR(true),fontSize:12,padding:"7px 16px"}}><i className="ti ti-plus" style={{fontSize:12}}/>Add Product</button>
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["SKU Counts","Brand","Product Name","Product Code","Portfolio ID","SKU1","SKU2","SKU3","...","Actions"].map(h=>(
                <th key={h} style={{padding:"8px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r,i)=>{
              const skuCount=SKU_COLS.filter(k=>r[k]).length;
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:700,color:"#1a7a3c",textAlign:"center"}}>{skuCount}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>{r.brandName||"—"}</td>
                  <td style={{padding:"8px 10px",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontWeight:500}} title={r.productName}>{r.productName||"—"}</td>
                  <td style={{padding:"8px 10px",fontWeight:700,color:R}}>{r.productCode||"—"}</td>
                  <td style={{padding:"8px 10px",fontSize:11,color:"#888",fontFamily:"monospace"}}>{r.portfolioId||"—"}</td>
                  <td style={{padding:"8px 10px",fontSize:11,color:"#555"}}>{r.sku||"—"}</td>
                  <td style={{padding:"8px 10px",fontSize:11,color:"#555"}}>{r.sku2||"—"}</td>
                  <td style={{padding:"8px 10px",fontSize:11,color:"#555"}}>{r.sku3||"—"}</td>
                  <td style={{padding:"8px 10px",fontSize:11,color:skuCount>3?"#1a5fa0":"#aaa"}}>{skuCount>3?`+${skuCount-3} more`:"—"}</td>
                  <td style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",gap:4}}>
                      <button onClick={()=>editRow(i)} style={{padding:"3px 8px",borderRadius:5,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555"}}><i className="ti ti-edit" style={{fontSize:10}}/></button>
                      <button onClick={()=>delRow(i)} style={{padding:"3px 8px",borderRadius:5,border:"1px solid rgba(212,43,43,0.2)",background:"rgba(212,43,43,0.04)",cursor:"pointer",fontSize:11,color:"#d42b2b"}}><i className="ti ti-trash" style={{fontSize:10}}/></button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {!rows.length&&<tr><td colSpan={10} style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No products yet. Click Add Product to start building your brand table.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── KEYWORDS & ASINS TAB ── */
function BBKeywordsTab({d,setD,globalData}){
  const upd=(k,v)=>setD(p=>({...p,[k]:v}));
  const COLS=[
    {key:"kwExact",   use:"useExact",   label:"Unique Exact",         color:"#4f46e5",  ph:"exact keyword\nanother exact keyword"},
    {key:"kwPhrase",  use:"usePhrase",  label:"Unique Phrase",        color:"#1a5fa0",  ph:"phrase keyword\nanother phrase"},
    {key:"kwBroad",   use:"useBroad",   label:"Unique Broad",         color:"#1a7a3c",  ph:"broad keyword\nanother broad"},
    {key:"kwAsin",    use:"useAsin",    label:"Unique ASIN",          color:"#6338c8",  ph:"B0COMPETITOR1\nB0COMPETITOR2"},
    {key:"kwAsinExp", use:"useAsinExp", label:"Unique ASIN Expanded", color:"#c47a00",  ph:"B0CATEGORY1\nB0CATEGORY2"},
  ];

  /* Import from Data Hub STR */
  function importFromSTR(){
    const rows=globalData?.cur?.searchterm?.rows||globalData?.cur?.primary?.rows||[];
    const cm=globalData?.cur?.searchterm?.cm||globalData?.cur?.primary?.cm||{};
    if(!rows.length){alert("No Search Term Report in Data Hub. Upload one first.");return;}
    const converting=rows.filter(r=>{const m=calcRowMetrics(r,cm);return m.orders>=2&&m.acos>0&&m.acos<35;}).map(r=>r[cm.searchTerm]||"").filter(Boolean);
    if(!converting.length){alert("No converting search terms found (need ≥2 orders, ACoS <35%).");return;}
    upd("kwExact",[...new Set([...bbKwList(d.kwExact),...converting])].join("\n"));
    alert(`Imported ${converting.length} converting search terms into Exact match column.`);
  }

  return(
    <div style={{padding:"14px 20px",overflowY:"auto",height:"100%",boxSizing:"border-box"}}>
      <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center"}}>
        <div style={{fontSize:14,fontWeight:700,color:"#111"}}>Keywords & ASINs</div>
        <span style={{fontSize:11,color:"#888"}}>Paste keywords per match type. Only enabled match types with data will generate campaigns.</span>
        <div style={{flex:1}}/>
        {(globalData?.cur?.searchterm||globalData?.cur?.primary)&&(
          <button onClick={importFromSTR} style={{padding:"6px 12px",borderRadius:7,border:"1px solid rgba(26,95,160,0.3)",background:"rgba(26,95,160,0.06)",cursor:"pointer",fontSize:11,color:"#1a5fa0",fontWeight:600,display:"flex",alignItems:"center",gap:5}}>
            <i className="ti ti-database-import" style={{fontSize:11}}/>Import from STR
          </button>
        )}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:8}}>
        {COLS.map(col=>{
          const count=bbKwList(d[col.key]).length;
          const enabled=d[col.use];
          return(
            <div key={col.key} style={{display:"flex",flexDirection:"column",gap:6}}>
              <div style={{display:"flex",alignItems:"center",gap:6,padding:"7px 10px",borderRadius:8,background:enabled?`${col.color}08`:"#fafafa",border:`1.5px solid ${enabled?col.color:"#e0e0e0"}`}}>
                <i className={`ti ${enabled?"ti-check-circle":"ti-circle"}`} style={{fontSize:11,color:enabled?col.color:"#ccc"}}/>
                <span style={{fontSize:11,fontWeight:700,color:enabled?col.color:"#888",flex:1}}>{col.label}</span>
                <span style={{fontSize:10,fontWeight:700,color:enabled&&count>0?col.color:"#aaa"}}>{count}</span>
              </div>
              {!enabled&&(
                <div style={{padding:"8px 10px",borderRadius:7,background:"#fafafa",border:"1px dashed #e0e0e0",fontSize:10,color:"#bbb",textAlign:"center"}}>
                  Disabled in Rules
                </div>
              )}
              {enabled&&(
                <textarea
                  defaultValue={d[col.key]||""}
                  onBlur={e=>upd(col.key,e.target.value)}
                  onChange={e=>{/* local only — saves on blur */}}
                  placeholder={col.ph}
                  style={{width:"100%",height:420,resize:"vertical",padding:"8px 10px",borderRadius:8,border:`1.5px solid ${enabled?col.color:"#e0e0e0"}`,fontSize:12,fontFamily:"monospace",outline:"none",boxSizing:"border-box",lineHeight:1.6}}
                />
              )}
              {enabled&&count>0&&(
                <div style={{fontSize:10,color:col.color,fontWeight:600,textAlign:"center"}}>{count} {col.key.includes("Asin")?"ASINs":"keywords"}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ── CAMPAIGN OUTPUT TAB ── */
function BBOutputTab({rows,label,onDownload,onCopy}){
  const kw=rows.filter(r=>r.Entity==="Keyword");
  const pt=rows.filter(r=>r.Entity==="Product Targeting");
  const camps=[...new Set(rows.filter(r=>r.Entity==="Campaign").map(r=>r["Campaign Name"]))];

  if(!rows.length)return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",color:"#aaa",gap:10}}>
      <i className="ti ti-rocket" style={{fontSize:40,color:"#eee"}}/>
      <div style={{fontSize:14,fontWeight:600}}>No campaigns yet</div>
      <div style={{fontSize:12}}>Go to Rules tab → click Create Campaigns</div>
    </div>
  );

  return(
    <div style={{padding:"14px 20px",overflowY:"auto",height:"100%",boxSizing:"border-box"}}>
      <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center"}}>
        <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{label}</div>
        <span style={{fontSize:11,padding:"2px 8px",borderRadius:5,background:"rgba(26,122,60,0.1)",color:"#1a7a3c",fontWeight:700}}>{camps.length} campaigns</span>
        <span style={{fontSize:11,color:"#aaa"}}>{rows.length} total rows</span>
        <div style={{flex:1}}/>
        <button onClick={onCopy} style={{padding:"7px 14px",borderRadius:8,border:"1px solid rgba(26,95,160,0.3)",background:"rgba(26,95,160,0.06)",cursor:"pointer",fontSize:11,color:"#1a5fa0",fontWeight:600,display:"flex",alignItems:"center",gap:5}}>
          <i className="ti ti-copy" style={{fontSize:11}}/>Copy All
        </button>
        <button onClick={onDownload} style={{...T.btnR(true),fontSize:12,padding:"7px 16px"}}>
          <i className="ti ti-download" style={{fontSize:12}}/>Download Excel
        </button>
      </div>

      {/* Campaign summary */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
        {camps.map((cn,i)=>(
          <div key={i} style={{padding:"4px 10px",borderRadius:6,background:"rgba(26,122,60,0.06)",border:"1px solid rgba(26,122,60,0.2)",fontSize:11,color:"#1a7a3c",fontWeight:600}}>{cn}</div>
        ))}
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Product","Entity","Operation","Campaign Name","Ad Group Name","State","Keyword/Target","Match Type","Bid","Budget","Portfolio Id","SKU","Start Date"].map(h=>(
                <th key={h} style={{padding:"7px 9px",textAlign:"left",fontSize:9,fontWeight:700,color:"#888",textTransform:"uppercase",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.slice(0,300).map((row,i)=>{
              const entityColors={"Campaign":"#4f46e5","Ad Group":"#1a5fa0","Keyword":"#1a7a3c","Product Targeting":"#6338c8","Product Ad":"#c47a00"};
              const ec=entityColors[row.Entity]||"#555";
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"5px 9px",color:"#888",fontSize:10}}>{row["Product"]||"SP"}</td>
                  <td style={{padding:"5px 9px"}}><span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:`${ec}12`,color:ec,fontWeight:700,whiteSpace:"nowrap"}}>{row.Entity}</span></td>
                  <td style={{padding:"5px 9px",color:"#555"}}>{row.Operation}</td>
                  <td style={{padding:"5px 9px",fontWeight:500,color:"#111",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={row["Campaign Name"]}>{row["Campaign Name"]}</td>
                  <td style={{padding:"5px 9px",color:"#555",maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row["Ad Group Name"]}</td>
                  <td style={{padding:"5px 9px",color:"#1a7a3c"}}>{row.State}</td>
                  <td style={{padding:"5px 9px",color:"#555",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row["Keyword Text"]||row["Product Targeting Expression"]||""}</td>
                  <td style={{padding:"5px 9px",color:ec,fontWeight:600}}>{row["Match Type"]||""}</td>
                  <td style={{padding:"5px 9px",color:"#555"}}>{row.Bid||""}</td>
                  <td style={{padding:"5px 9px",color:"#555"}}>{row["Daily Budget"]||""}</td>
                  <td style={{padding:"5px 9px",color:"#888",fontSize:10,fontFamily:"monospace"}}>{row["Portfolio Id"]||""}</td>
                  <td style={{padding:"5px 9px",color:"#555"}}>{row.SKU||""}</td>
                  <td style={{padding:"5px 9px",color:"#555"}}>{row["Start Date"]||""}</td>
                </tr>
              );
            })}
            {rows.length>300&&<tr><td colSpan={13} style={{textAlign:"center",padding:"10px",color:"#aaa",fontSize:11}}>Showing 300 of {rows.length} rows — download for full data</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── BULK BUILDER MODULE ROOT ── */
function BulkBuilderModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("rules");
  const[d,setDRaw]=useState(bbLoad);

  // Debounce localStorage save — only save 600ms after last change
  // This prevents input focus loss on every keystroke
  const bbSaveTimer = React.useRef(null);
  function setD(updater){
    setDRaw(prev=>{
      const next=typeof updater==="function"?updater(prev):updater;
      if(bbSaveTimer.current) clearTimeout(bbSaveTimer.current);
      bbSaveTimer.current = setTimeout(()=>bbSave(next), 600);
      return next;
    });
  }

  /* Generate campaigns */
  function createCampaigns(){
    if(!d.productCode){alert("Please set a Product Code in Rules before creating campaigns.");return;}
    const{campKeyword,campProduct,newLastExact,newLastPhrase,newLastBroad,newLastAsin,newLastAsinExp}=bbGenerate(d);
    if(!campKeyword.length&&!campProduct.length){alert("No campaigns generated. Make sure you have:\n• Keywords pasted in the Keywords & ASINs tab\n• Matching match types enabled in Rules");return;}
    setD(p=>({...p,
      campKeyword,campProduct,
      lastCampExact:newLastExact,lastCampPhrase:newLastPhrase,
      lastCampBroad:newLastBroad,lastCampAsin:newLastAsin,lastCampAsinExp:newLastAsinExp,
    }));
    /* Jump to relevant output tab */
    if(campKeyword.length)setActiveTab("kwcamps");
    else if(campProduct.length)setActiveTab("ptcamps");
    alert(`Created ${[...new Set((d.campKeyword||[]).concat(campKeyword).filter(r=>r.Entity==="Campaign").map(r=>r["Campaign Name"]))].length} campaigns.\n\n• Keyword Campaigns: ${[...new Set(campKeyword.filter(r=>r.Entity==="Campaign").map(r=>r["Campaign Name"]))].length}\n• Product Targeting Campaigns: ${[...new Set(campProduct.filter(r=>r.Entity==="Campaign").map(r=>r["Campaign Name"]))].length}`);
  }

  function copyToClipboard(rows){
    const headers=AMZN_SP_COLS.join("\t");
    const body=rows.map(r=>AMZN_SP_COLS.map(h=>r[h]||"").join("\t")).join("\n");
    navigator.clipboard.writeText(headers+"\n"+body).then(()=>alert("Copied to clipboard! Paste into Google Sheets or Excel.")).catch(()=>alert("Copy failed — use Download instead."));
  }

  const tabs=[
    {key:"rules",    label:"Rules",                      icon:"ti-adjustments"},
    {key:"brandtbl", label:"Brand Table",                icon:"ti-table-heart"},
    {key:"keywords", label:"Keywords & ASINs",           icon:"ti-keyboard"},
    {key:"kwcamps",  label:"Keyword Campaigns Created",  icon:"ti-speakerphone",  badge:(d.campKeyword||[]).filter(r=>r.Entity==="Campaign").length||null},
    {key:"ptcamps",  label:"Product Campaigns Created",  icon:"ti-package",       badge:(d.campProduct||[]).filter(r=>r.Entity==="Campaign").length||null},
  ];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {/* Header */}
      <div style={{padding:"10px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-file-plus" style={{fontSize:15,color:R}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Bulk Builder</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.1)",color:R,fontWeight:700}}>Core</span>
        {d.productCode&&<span style={{fontSize:11,color:"#888"}}>— {d.productCode}</span>}
        <div style={{flex:1}}/>
        <button onClick={createCampaigns} style={{...T.btnR(false),padding:"8px 20px",fontSize:13,fontWeight:700,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
          <i className="ti ti-rocket" style={{fontSize:13}}/>Create Campaigns
        </button>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:0,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 16px",border:"none",borderBottom:`2px solid ${activeTab===t.key?R:"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>{t.label}
            {t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?R:"rgba(26,122,60,0.1)",color:activeTab===t.key?"#fff":"#1a7a3c",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {activeTab==="rules"    &&<BBRulesTab d={d} setD={setD} btRows={d.brandTableRows||[]}/>}
        {activeTab==="brandtbl" &&<BBBrandTableTab d={d} setD={setD}/>}
        {activeTab==="keywords" &&<BBKeywordsTab d={d} setD={setD} globalData={globalData}/>}
        {activeTab==="kwcamps"  &&<BBOutputTab rows={d.campKeyword||[]} label="Keyword Campaigns Created" onDownload={()=>bbDownloadKw(d.campKeyword||[],d)} onCopy={()=>copyToClipboard(d.campKeyword||[])}/>}
        {activeTab==="ptcamps"  &&<BBOutputTab rows={d.campProduct||[]} label="Product Campaigns Created" onDownload={()=>bbDownloadPt(d.campProduct||[],d)} onCopy={()=>copyToClipboard(d.campProduct||[])}/>}
      </div>
    </div>
  );
}

/* ================================================================
   AI STRATEGIST MODULE
   Claude-powered strategic intelligence for Amazon PPC accounts.
   Pages: Upload Reports → AI Strategy Workspace → Action History
   AI uses ONLY uploaded data — no hallucination, no invented metrics.
================================================================ */

/* ── Build the AI prompt from processed data ─────────────────── */
function buildAIPrompt(datasets,periods){
  const{curCamp,compCamp,curSTR,compSTR}=datasets;

  // Aggregate campaign data
  let curAgg={},compAgg={};
  if(curCamp&&curCamp.rows.length){
    const cm=acDetectMap(curCamp.headers);
    curAgg=acSumAgg(curCamp.rows,cm);
    curAgg.campaignCount=curCamp.rows.filter(r=>acCalcRow(r,cm).spend>0).length;
  }
  if(compCamp&&compCamp.rows.length){
    const cm=acDetectMap(compCamp.headers);
    compAgg=acSumAgg(compCamp.rows,cm);
  }

  // STR summary
  let strSummary="";
  if(curSTR&&curSTR.rows.length){
    const sm=strDetectMap(curSTR.headers);
    const metrics=curSTR.rows.map(r=>({m:strCalcMetrics(r,sm),term:String(r[sm.searchTerm]||"")}));
    const bleeders=metrics.filter(({m})=>m.spend>15&&m.orders===0).length;
    const harvestable=metrics.filter(({m})=>m.cvr>3&&m.orders>=2&&m.acos>0&&m.acos<30).length;
    const totalWaste=metrics.filter(({m})=>m.spend>15&&m.orders===0).reduce((s,{m})=>s+m.spend,0);
    strSummary=`Search Terms: ${metrics.length} terms analyzed. ${bleeders} bleeders ($${totalWaste.toFixed(0)} wasted). ${harvestable} harvest opportunities.`;
  }

  // Delta calculations
  const delta=(k)=>compAgg[k]>0?((curAgg[k]-compAgg[k])/compAgg[k])*100:null;
  const acosDelta=compAgg.acos?curAgg.acos-compAgg.acos:null;
  const salesPct=delta("sales");const spendPct=delta("spend");const cvrPct=delta("cvr");const cpcPct=delta("cpc");const impPct=delta("impressions");

  const fmtPct=v=>v!=null?`${v>0?"+":""}${v.toFixed(1)}%`:"N/A";
  const fmtUSD=v=>v>=1e3?`$${(v/1e3).toFixed(1)}K`:`$${v?.toFixed(0)||0}`;

  return `You are a senior Amazon PPC strategist reviewing an advertising account. Analyze the following performance data and provide strategic intelligence.

CURRENT PERIOD: ${periods?.current?.start?.toLocaleDateString?.()||"Current"} to ${periods?.current?.end?.toLocaleDateString?.()||"End"}
COMPARISON PERIOD: ${periods?.comp?.start?.toLocaleDateString?.()||"Previous"} to ${periods?.comp?.end?.toLocaleDateString?.()||"End"}

ACCOUNT PERFORMANCE DATA:
- Campaigns analyzed: ${curAgg.campaignCount||"N/A"}
- Total Spend: ${fmtUSD(curAgg.spend)} (${fmtPct(spendPct)} vs prev)
- Total Sales: ${fmtUSD(curAgg.sales)} (${fmtPct(salesPct)} vs prev)
- ACoS: ${curAgg.acos?.toFixed(1)||"N/A"}%${acosDelta!=null?` (${acosDelta>0?"+":""}${acosDelta.toFixed(1)}pp vs prev)`:""}
- ROAS: ${curAgg.roas?.toFixed(2)||"N/A"}
- CVR: ${curAgg.cvr?.toFixed(1)||"N/A"}% (${fmtPct(cvrPct)} vs prev)
- CPC: $${curAgg.cpc?.toFixed(2)||"N/A"} (${fmtPct(cpcPct)} vs prev)
- Impressions: ${curAgg.impressions>=1e3?`${(curAgg.impressions/1e3).toFixed(1)}K`:curAgg.impressions||"N/A"} (${fmtPct(impPct)} vs prev)
- Orders: ${Math.round(curAgg.orders)||"N/A"}
${strSummary?`\n${strSummary}`:""}

RULES YOU MUST FOLLOW:
1. Base ALL insights ONLY on the data provided above. Never invent metrics.
2. If comparison data is unavailable (N/A), say so — do not invent trends.
3. Write like a senior strategist, not a generic AI assistant.
4. Be specific and actionable — not generic.
5. Reference actual numbers from the data above.

Respond ONLY with valid JSON in this exact structure (no markdown, no extra text):
{
  "accountSummary": "2-3 sentence strategic overview of account health and direction",
  "topPriority": "Single most important action the strategist must take right now",
  "recommendations": [
    {"type":"critical|scaling|efficiency|structural|visibility","title":"Short title","explanation":"Strategic explanation referencing data","action":"Specific action to take","outcome":"Expected outcome","confidence":85}
  ],
  "trends": [
    {"metric":"Metric name","direction":"improving|declining|stable","explanation":"Why this moved based on data","action":"What to do"}
  ],
  "opportunities": [
    {"type":"scaling|rank|budget|conversion|placement|structural","title":"Opportunity title","why":"Data-backed reason","action":"Specific scaling action","impact":"Expected impact"}
  ],
  "risks": [
    {"type":"spend_leakage|cpc|cvr|visibility|rank|structural","title":"Risk title","severity":"critical|high|medium","explanation":"Data-backed explanation","fix":"Specific fix"}
  ]
}
Limit: 3 recommendations, 3 trends, 3 opportunities, 3 risks max.`;
}

/* ── Gemini API config ───────────────────────────────────────── */
// The key comes from Settings → AI Settings (getGlobalAIKey) — one key,
// entered by the user in-app, propagates to every AI module. Never hardcode
// a key here: it would ship in the public JS bundle where anyone can steal it.
//
// MODEL FALLBACK: Google retires Gemini models aggressively (2.0-flash died
// June 1 2026; 2.5-flash is scheduled for Oct 16 2026). Instead of hardcoding
// one model, we try candidates in order and remember the first that works.
const GEMINI_MODELS=["gemini-3.5-flash","gemini-2.5-flash","gemini-2.5-flash-lite"];
let GEMINI_ACTIVE_IDX=0;
async function geminiFetch(apiKey,options){
  let res=null;
  for(let i=GEMINI_ACTIVE_IDX;i<GEMINI_MODELS.length;i++){
    res=await fetch(`https://generativelanguage.googleapis.com/v1beta/models/${GEMINI_MODELS[i]}:generateContent?key=${apiKey}`,options);
    if(res.status===404){continue;}   // model retired/unknown → try the next one
    GEMINI_ACTIVE_IDX=i;              // remember the working model for this session
    return res;
  }
  return res; // all candidates failed — caller surfaces the error normally
}

/* ── Call Gemini API ─────────────────────────────────────────── */
async function callAIStrategist(prompt){
  const GEMINI_API_KEY=getGlobalAIKey();
  if(!GEMINI_API_KEY){
    throw new Error("AI key not set. Go to Settings → AI Settings and paste your free Gemini API key (aistudio.google.com/app/apikey). It powers every AI module automatically.");
  }
  const response=await geminiFetch(GEMINI_API_KEY,{
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body:JSON.stringify({
      contents:[{parts:[{text:prompt}]}],
      generationConfig:{temperature:0.3,maxOutputTokens:1200,responseMimeType:"application/json"}
    })
  });
  const data=await response.json();
  if(data.error)throw new Error(data.error.message||"Gemini API error");
  const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"{}";
  try{return JSON.parse(text);}catch{
    const match=text.match(/\{[\s\S]*\}/);
    if(match)return JSON.parse(match[0]);
    throw new Error("Gemini returned invalid JSON — try re-analyzing");
  }
}

/* ── Action history storage ──────────────────────────────────── */
const LS_AI_HISTORY="rmq_ai_history_v1";
function loadAIHistory(){try{const r=localStorage.getItem(LS_AI_HISTORY);if(r)return JSON.parse(r);}catch{}return[];}
function saveAIHistory(h){try{localStorage.setItem(LS_AI_HISTORY,JSON.stringify(h.slice(0,50)));}catch{}}

/* ── AIS Upload Zone ─────────────────────────────────────────── */
function AISUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"12px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:32,height:32,borderRadius:7,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:14,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:1}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Req.</span>
              :<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Opt.</span>}
          </div>
          <div style={{fontSize:10,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:10,color:R,fontWeight:600,marginTop:2}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"3px 7px",borderRadius:5,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:10}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 11px",borderRadius:6,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:10,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const AIS_REPORT_TYPES=[
  {id:"campaign",  label:"Campaign Report",      icon:"ti-speakerphone",required:true, desc:"Core account performance — spend, sales, ACoS, CVR"},
  {id:"searchterm",label:"Search Term Report",   icon:"ti-search",     required:false,desc:"Search term data for waste and harvest analysis"},
  {id:"placement", label:"Placement Report",     icon:"ti-layout-2",   required:false,desc:"Placement performance for TOS analysis"},
  {id:"sqp",       label:"SQP Report",           icon:"ti-chart-bar",  required:false,desc:"Market share and click share intelligence"},
];

/* ── AIS Upload Page ─────────────────────────────────────────── */
function AISUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.campaign)return;setLoading(true);setErr(null);
    try{
      const curCamp=await parseSheet(files.campaign);
      const compCamp=compFiles.campaign?await parseSheet(compFiles.campaign):null;
      const curSTR=files.searchterm?await parseSheet(files.searchterm):null;
      const compSTR=compFiles.searchterm?await parseSheet(compFiles.searchterm):null;
      onComplete({curCamp,compCamp,curSTR,compSTR,periods:localPeriods});
    }catch(e){setErr("Error: "+e.message);}
    setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:700,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Analysis Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your Amazon reports. The AI will analyze actual data only — no invented metrics or generic advice.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{AIS_REPORT_TYPES.map(t=><AISUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:12}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period{localPeriods?.comp&&<span style={{fontSize:11,color:"#888",fontWeight:400,marginLeft:4}}>{fmtDisp(localPeriods.comp.start)} → {fmtDisp(localPeriods.comp.end)}</span>}
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{AIS_REPORT_TYPES.map(t=><AISUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-brain" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>The AI Strategist analyzes <strong>only your uploaded data</strong>. It never invents metrics or generates generic advice. The more reports you upload, the richer the analysis.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.campaign||loading} style={{...T.btnR(false),opacity:files.campaign&&!loading?1:0.4,fontWeight:700,boxShadow:files.campaign?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Processing...</>:<><i className="ti ti-brain" style={{fontSize:14}}/> Run AI Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Recommendation Card ─────────────────────────────────────── */
function AISRecCard({rec}){
  const[open,setOpen]=useState(false);
  const tc={critical:"#d42b2b",scaling:"#1a7a3c",efficiency:"#1a50a0",structural:"#6338c8",visibility:"#c47a00"};
  const tb={critical:"rgba(212,43,43,0.05)",scaling:"rgba(26,122,60,0.05)",efficiency:"rgba(26,80,160,0.05)",structural:"rgba(99,56,200,0.05)",visibility:"rgba(196,122,0,0.05)"};
  const tbr={critical:"rgba(212,43,43,0.18)",scaling:"rgba(26,122,60,0.18)",efficiency:"rgba(26,80,160,0.15)",structural:"rgba(99,56,200,0.15)",visibility:"rgba(196,122,0,0.18)"};
  const c=tc[rec.type]||"#555";const bg=tb[rec.type]||"#fafafa";const br=tbr[rec.type]||"#eee";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"12px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          <i className={`ti ${rec.type==="critical"?"ti-alert-triangle":rec.type==="scaling"?"ti-rocket":rec.type==="efficiency"?"ti-adjustments":rec.type==="structural"?"ti-layout":rec.type==="visibility"?"ti-eye":"ti-star"}`} style={{fontSize:13,color:c}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>{rec.type?.replace("_"," ")}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{rec.title}</span>
          </div>
          <div style={{fontSize:11,color:"#555",lineHeight:1.4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{rec.explanation}</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
          {rec.confidence&&<span style={{fontSize:10,color:"#bbb"}}>{rec.confidence}%</span>}
          <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/>
        </div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:12,color:"#444",lineHeight:1.7,marginTop:10,marginBottom:10}}>{rec.explanation}</div>
        {rec.outcome&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Expected outcome:</strong> {rec.outcome}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Recommended Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{rec.action}</div></div>
      </div>}
    </div>
  );
}

/* ── Opportunity Card ────────────────────────────────────────── */
function AISOpportunityCard({opp}){
  const[open,setOpen]=useState(false);
  const tc={scaling:"#1a7a3c",rank:"#6338c8",budget:"#1a50a0",conversion:"#c47a00",placement:"#555",structural:"#888"};const bg={scaling:"rgba(26,122,60,0.05)",rank:"rgba(99,56,200,0.05)",budget:"rgba(26,80,160,0.05)",conversion:"rgba(196,122,0,0.05)",placement:"rgba(0,0,0,0.02)",structural:"rgba(0,0,0,0.02)"};const br={scaling:"rgba(26,122,60,0.18)",rank:"rgba(99,56,200,0.18)",budget:"rgba(26,80,160,0.15)",conversion:"rgba(196,122,0,0.18)",placement:"#e0e0e0",structural:"#e0e0e0"};
  const c=tc[opp.type]||"#1a7a3c";const bgc=bg[opp.type]||"#fafafa";const brc=br[opp.type]||"#eee";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${brc}`,background:bgc,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1.5px solid ${brc}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          <i className={`ti ${opp.type==="scaling"?"ti-rocket":opp.type==="rank"?"ti-trending-up":opp.type==="budget"?"ti-coin":opp.type==="conversion"?"ti-target":opp.type==="placement"?"ti-layout-2":"ti-grid"}`} style={{fontSize:12,color:c}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:2}}><span style={{fontSize:9,padding:"2px 5px",borderRadius:3,background:bgc,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${brc}`}}>Opportunity</span><span style={{fontSize:12,fontWeight:700,color:"#111"}}>{opp.title}</span></div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{opp.why}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 53px",borderTop:`1px solid ${brc}`}}>
        <div style={{fontSize:12,color:"#444",lineHeight:1.7,marginTop:10,marginBottom:10}}>{opp.why}</div>
        {opp.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Expected impact:</strong> {opp.impact}</div>}
        <div style={{padding:"9px 12px",background:bgc,borderRadius:8,border:`1px solid ${brc}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Strategic Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{opp.action}</div></div>
      </div>}
    </div>
  );
}

/* ── Risk Card ───────────────────────────────────────────────── */
function AISRiskCard({risk}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555"};const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)"};const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"#eee"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[risk.severity]||"#eee"}`,background:sb[risk.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[risk.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          <i className="ti ti-alert-triangle" style={{fontSize:12,color:sc[risk.severity]||"#555"}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:2}}>
            <span style={{fontSize:9,padding:"2px 5px",borderRadius:3,background:sb[risk.severity]||"#f0f0f0",color:sc[risk.severity]||"#555",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[risk.severity]}`}}>{risk.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{risk.title}</span>
          </div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{risk.explanation}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 53px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:12,color:"#444",lineHeight:1.7,marginTop:10,marginBottom:10}}>{risk.explanation}</div>
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Recommended Fix</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{risk.fix}</div></div>
      </div>}
    </div>
  );
}

/* ── AIS Workspace ───────────────────────────────────────────── */
function AISWorkspace({datasets,periods,onReupload,onSaveHistory}){
  const[aiData,setAIData]=useState(null);const[loading,setLoading]=useState(false);const[err,setErr]=useState(null);
  const[activeTab,setActiveTab]=useState("summary");

  useEffect(()=>{if(!aiData&&!loading)runAnalysis();},[]);

  async function runAnalysis(){
    setLoading(true);setErr(null);
    try{
      const prompt=buildAIPrompt(datasets,periods);
      const result=await callAIStrategist(prompt);
      setAIData(result);
      // Save to history
      onSaveHistory({date:new Date().toISOString(),periods,summary:result.accountSummary,topPriority:result.topPriority,recCount:(result.recommendations||[]).length,oppCount:(result.opportunities||[]).length,riskCount:(result.risks||[]).length,completed:false});
    }catch(e){setErr("AI analysis failed: "+e.message+". Check your internet connection.");}
    setLoading(false);
  }

  const TABS=[{key:"summary",label:"Account Summary",icon:"ti-brain"},{key:"recs",label:`Actions${aiData?.recommendations?.length?` (${aiData.recommendations.length})`:""}`,icon:"ti-bolt"},{key:"opps",label:`Opportunities${aiData?.opportunities?.length?` (${aiData.opportunities.length})`:""}`,icon:"ti-rocket"},{key:"risks",label:`Risks${aiData?.risks?.length?` (${aiData.risks.length})`:""}`,icon:"ti-alert-triangle"},{key:"trends",label:"Trend Analysis",icon:"ti-chart-line"}];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>AI Strategist</h2>
            {loading&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(79,70,229,0.08)",color:R,fontWeight:600,display:"flex",alignItems:"center",gap:5}}><i className="ti ti-loader" style={{fontSize:11}}/> Analyzing...</span>}
            {aiData&&!loading&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(26,122,60,0.08)",color:"#1a7a3c",fontWeight:600}}><i className="ti ti-check"/> Analysis complete</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {datasets.compCamp&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnG(true),opacity:loading?0.5:1}}><i className="ti ti-refresh" style={{fontSize:12}}/> Re-analyze</button>
          <button onClick={onReupload} style={T.btnG(true)}><i className="ti ti-upload" style={{fontSize:12}}/> Re-upload</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>

      <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
        {/* Loading state */}
        {loading&&(
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",gap:16}}>
            <div style={{width:60,height:60,borderRadius:16,background:"rgba(79,70,229,0.07)",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className="ti ti-brain" style={{fontSize:28,color:R}}/>
            </div>
            <div style={{fontSize:15,fontWeight:700,color:"#111"}}>Claude is analyzing your account</div>
            <div style={{fontSize:12,color:"#888",maxWidth:380,textAlign:"center",lineHeight:1.6}}>Reading your campaign data, calculating deltas, and generating strategic insights based only on your uploaded reports.</div>
            <div style={{display:"flex",gap:6,marginTop:4}}>
              {["Calculating metrics","Detecting patterns","Generating insights"].map((s,i)=><div key={s} style={{padding:"4px 10px",borderRadius:20,background:"#fff",border:"1px solid #eee",fontSize:11,color:"#888"}}>{s}</div>)}
            </div>
          </div>
        )}

        {/* Error state */}
        {err&&!loading&&(
          <div style={{maxWidth:600,margin:"40px auto",padding:"24px",background:"#fff",borderRadius:12,border:"1px solid #eee",textAlign:"center"}}>
            <i className="ti ti-alert-triangle" style={{fontSize:36,color:"#c47a00",display:"block",marginBottom:12}}/>
            <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:8}}>Analysis Failed</div>
            <div style={{fontSize:13,color:"#555",marginBottom:16,lineHeight:1.6}}>{err}</div>
            <button onClick={runAnalysis} style={T.btnR(false)}><i className="ti ti-refresh" style={{fontSize:14}}/> Try Again</button>
          </div>
        )}

        {/* Content */}
        {aiData&&!loading&&(
          <div style={{maxWidth:820,margin:"0 auto",padding:"20px 22px"}}>

            {/* SUMMARY TAB */}
            {activeTab==="summary"&&<>
              {/* Top priority banner */}
              {aiData.topPriority&&(
                <div style={{background:"#111",borderRadius:12,padding:"16px 18px",marginBottom:16,display:"flex",alignItems:"flex-start",gap:12}}>
                  <div style={{width:32,height:32,borderRadius:8,background:"rgba(79,70,229,0.3)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <i className="ti ti-bolt" style={{fontSize:15,color:R}}/>
                  </div>
                  <div>
                    <div style={{fontSize:10,color:"rgba(255,255,255,0.4)",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:4}}>Top Priority Right Now</div>
                    <div style={{fontSize:14,fontWeight:600,color:"#fff",lineHeight:1.5}}>{aiData.topPriority}</div>
                  </div>
                </div>
              )}

              {/* Account summary */}
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                  <i className="ti ti-brain" style={{fontSize:14,color:R}}/>
                  <div style={{fontSize:13,fontWeight:700,color:"#111"}}>Strategic Account Summary</div>
                  <div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Generated from your uploaded data only</div>
                </div>
                <div style={{fontSize:13,color:"#333",lineHeight:1.8}}>{aiData.accountSummary}</div>
              </div>

              {/* Quick stats */}
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:14}}>
                {[{icon:"ti-bolt",label:"Priority Actions",val:aiData.recommendations?.length||0,color:R},{icon:"ti-rocket",label:"Opportunities",val:aiData.opportunities?.length||0,color:"#1a7a3c"},{icon:"ti-alert-triangle",label:"Risks Detected",val:aiData.risks?.length||0,color:"#c47a00"}].map(s=>(
                  <div key={s.label} style={{padding:"14px",background:"#fff",borderRadius:10,border:"1px solid #eee",textAlign:"center"}}>
                    <i className={`ti ${s.icon}`} style={{fontSize:22,color:s.color,display:"block",marginBottom:6}}/>
                    <div style={{fontSize:22,fontWeight:800,color:s.color,marginBottom:2}}>{s.val}</div>
                    <div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
                  </div>
                ))}
              </div>

              {/* Top recs preview */}
              {aiData.recommendations?.length>0&&<>
                <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:8}}>Priority Actions</div>
                {aiData.recommendations.slice(0,2).map((r,i)=><AISRecCard key={i} rec={r}/>)}
                {aiData.recommendations.length>2&&<button onClick={()=>setActiveTab("recs")} style={{...T.btnG(true),width:"100%",justifyContent:"center",marginTop:4}}>View All {aiData.recommendations.length} Actions →</button>}
              </>}
            </>}

            {/* RECOMMENDATIONS TAB */}
            {activeTab==="recs"&&<>
              <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:12}}>AI Priority Actions ({aiData.recommendations?.length||0})</div>
              {(!aiData.recommendations||aiData.recommendations.length===0)
                ?<div style={{textAlign:"center",padding:"50px",background:"#fff",borderRadius:12,border:"1px solid #eee",color:"#aaa"}}><i className="ti ti-check-circle" style={{fontSize:36,display:"block",marginBottom:8,color:"#1a9e4a"}}/><div style={{fontSize:14,fontWeight:600,color:"#111"}}>No critical actions needed</div></div>
                :aiData.recommendations.map((r,i)=><AISRecCard key={i} rec={r}/>)}
            </>}

            {/* OPPORTUNITIES TAB */}
            {activeTab==="opps"&&<>
              <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:12}}>Scaling Opportunities ({aiData.opportunities?.length||0})</div>
              {(!aiData.opportunities||aiData.opportunities.length===0)
                ?<div style={{textAlign:"center",padding:"50px",background:"#fff",borderRadius:12,border:"1px solid #eee",color:"#aaa"}}><i className="ti ti-rocket" style={{fontSize:36,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:600}}>No opportunities detected</div></div>
                :aiData.opportunities.map((o,i)=><AISOpportunityCard key={i} opp={o}/>)}
            </>}

            {/* RISKS TAB */}
            {activeTab==="risks"&&<>
              <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:12}}>Risk Detection ({aiData.risks?.length||0})</div>
              {(!aiData.risks||aiData.risks.length===0)
                ?<div style={{textAlign:"center",padding:"50px",background:"#fff",borderRadius:12,border:"1px solid #eee",color:"#aaa"}}><i className="ti ti-circle-check" style={{fontSize:36,display:"block",marginBottom:8,color:"#1a9e4a"}}/><div style={{fontSize:14,fontWeight:600,color:"#111"}}>No significant risks detected</div></div>
                :aiData.risks.map((r,i)=><AISRiskCard key={i} risk={r}/>)}
            </>}

            {/* TRENDS TAB */}
            {activeTab==="trends"&&<>
              <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:12}}>Trend Analysis ({aiData.trends?.length||0})</div>
              {(!aiData.trends||aiData.trends.length===0)
                ?<div style={{textAlign:"center",padding:"50px",background:"#fff",borderRadius:12,border:"1px solid #eee",color:"#aaa"}}><div style={{fontSize:14}}>Upload a comparison period to enable trend analysis</div></div>
                :aiData.trends.map((t,i)=>{
                  const td=t.direction==="improving"?"#1a7a3c":t.direction==="declining"?"#d42b2b":"#555";
                  const tb2=t.direction==="improving"?"rgba(26,122,60,0.05)":t.direction==="declining"?"rgba(212,43,43,0.04)":"rgba(0,0,0,0.02)";
                  return<div key={i} style={{background:"#fff",borderRadius:10,border:"1px solid #eee",padding:"14px 16px",marginBottom:8}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                      <div style={{width:28,height:28,borderRadius:7,background:tb2,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${t.direction==="improving"?"ti-trending-up":t.direction==="declining"?"ti-trending-down":"ti-minus"}`} style={{fontSize:13,color:td}}/>
                      </div>
                      <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{t.metric}</div>
                      <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:tb2,color:td,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.4px",marginLeft:"auto"}}>{t.direction}</span>
                    </div>
                    <div style={{fontSize:12,color:"#444",lineHeight:1.7,marginBottom:8}}>{t.explanation}</div>
                    {t.action&&<div style={{fontSize:11,color:"#555",padding:"7px 9px",background:"#fafafa",borderRadius:6,border:"1px solid #eee"}}><i className="ti ti-bolt" style={{marginRight:4,color:R}}/>{t.action}</div>}
                  </div>;
                })}
            </>}
          </div>
        )}
      </div>
    </div>
  );
}

/* ── AIS Action History ──────────────────────────────────────── */
function AISActionHistory({history,onClear}){
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:780,margin:"0 auto",padding:"24px 22px"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:18}}>
          <div><div style={{fontSize:16,fontWeight:700,color:"#111"}}>AI Action History</div><div style={{fontSize:12,color:"#888",marginTop:2}}>Previous AI analyses and their recommendations</div></div>
          {history.length>0&&<button onClick={onClear} style={T.btnG(true)}><i className="ti ti-trash" style={{fontSize:12}}/> Clear All</button>}
        </div>
        {history.length===0
          ?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}>
            <i className="ti ti-history" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/>
            <div style={{fontSize:15,fontWeight:700,color:"#111"}}>No analysis history yet</div>
            <div style={{fontSize:13,color:"#888",marginTop:4}}>Run an AI analysis to start tracking recommendations.</div>
          </div>
          :history.map((h,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:10,border:"1px solid #eee",padding:"14px 16px",marginBottom:8}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                <div style={{width:30,height:30,borderRadius:7,background:"rgba(79,70,229,0.06)",display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <i className="ti ti-brain" style={{fontSize:13,color:R}}/>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{new Date(h.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"2-digit",minute:"2-digit"})}</div>
                  <div style={{fontSize:11,color:"#888"}}>{fmtDisp(h.periods?.current?.start)} → {fmtDisp(h.periods?.current?.end)}</div>
                </div>
                <div style={{display:"flex",gap:6}}>
                  {h.recCount>0&&<span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.08)",color:R,fontWeight:600}}>{h.recCount} actions</span>}
                  {h.oppCount>0&&<span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,122,60,0.08)",color:"#1a7a3c",fontWeight:600}}>{h.oppCount} opps</span>}
                  {h.riskCount>0&&<span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(196,122,0,0.08)",color:"#c47a00",fontWeight:600}}>{h.riskCount} risks</span>}
                </div>
              </div>
              {h.summary&&<div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:h.topPriority?8:0}}>{h.summary}</div>}
              {h.topPriority&&<div style={{fontSize:11,padding:"7px 9px",background:"#fafafa",borderRadius:6,border:"1px solid #eee",color:"#333"}}><i className="ti ti-bolt" style={{marginRight:4,color:R,fontSize:10}}/><strong>Top Priority:</strong> {h.topPriority}</div>}
            </div>
          ))}
      </div>
    </div>
  );
}

/* ── AI Strategist Module Root ───────────────────────────────── */
function AIStrategistModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.primary?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[datasets,setDatasets]=useState(globalData?.cur?.primary?{cur:globalData.cur.primary,comp:globalData.comp?.primary||null}:null);
  useEffect(()=>{if(globalData?.cur?.primary&&page==="upload"){setDatasets({cur:globalData.cur.primary,comp:globalData.comp?.primary||null});setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);
  const[history,setHistory]=useState(loadAIHistory);
  const[activeSection,setActiveSection]=useState("workspace"); // "workspace"|"history"

  function saveHistory(entry){const h=[entry,...history];setHistory(h);saveAIHistory(h);}

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {/* Module header with section switcher */}
      <div style={{padding:"10px 20px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:12,flexShrink:0,background:"#fff"}}>
        <h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>AI Strategist</h2>
        <div style={{display:"flex",gap:4,background:"#f5f5f5",padding:"3px",borderRadius:8,border:"1px solid #eee"}}>
          {[{k:"workspace",label:"Strategy Workspace",icon:"ti-brain"},{k:"history",label:"Action History",icon:"ti-history"}].map(s=>(
            <button key={s.k} onClick={()=>setActiveSection(s.k)}
              style={{padding:"5px 12px",borderRadius:6,border:"none",fontSize:11,fontWeight:activeSection===s.k?700:500,color:activeSection===s.k?"#fff":"#666",background:activeSection===s.k?R:"transparent",cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
              <i className={`ti ${s.icon}`} style={{fontSize:11}}/>{s.label}
            </button>
          ))}
        </div>
      </div>

      {/* History section */}
      {activeSection==="history"&&<AISActionHistory history={history} onClear={()=>{setHistory([]);saveAIHistory([]);}}/>}

      {/* Workspace section */}
      {activeSection==="workspace"&&<>
        {page==="upload"&&(
          <AISUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)}
            onComplete={({curCamp,compCamp,curSTR,compSTR,periods:p})=>{
              setDatasets({curCamp,compCamp,curSTR,compSTR});
              if(p)setPeriods(p);setPage("workspace");
            }}/>
        )}
        {page==="workspace"&&datasets&&(
          <AISWorkspace datasets={datasets} periods={periods}
            onReupload={()=>{setDatasets(null);setPage("upload");}}
            onSaveHistory={saveHistory}/>
        )}
      </>}
    </div>
  );
}

/* ================================================================
   NEGATION ENGINE MODULE
   Waste detection & Amazon-ready negative targeting system.
   Pages: Upload STR → Negation Workspace → Export Sheets
================================================================ */

/* ── Negation classification engine ─────────────────────────── */
function classifyNegation(m, comp, term=""){
  const t=term.toLowerCase();

  // Safety: never negate ranking intent campaigns
  if(t.includes("ranking")||t.includes("launch")||t.includes("rank"))
    return{rec:"Monitor Only",type:null,severity:"low",confidence:30,
      reason:"Term may be part of a ranking or launch strategy. Do not negate without reviewing campaign intent.",
      safe:false,wasteScore:0};

  // Safety: branded terms need protection not negation
  const isSingleWord=term.trim().split(" ").length===1&&term.length<6;

  // Critical bleeder — high spend, many clicks, zero orders
  if(m.spend>20&&m.clicks>=8&&m.orders===0){
    const ws=Math.min(100,Math.round((m.spend/Math.max(m.spend,1))*60+(m.clicks/20)*20));
    return{rec:"Negate Exact",type:"Negative Exact",severity:"critical",confidence:95,
      reason:`$${m.spend.toFixed(0)} spent, ${m.clicks} clicks, zero conversions. Pure waste — every click costs money with no return.`,
      safe:true,wasteScore:ws,saving:m.spend*0.90};
  }

  // High spend low conversion
  if(m.spend>10&&m.clicks>=5&&m.orders===0){
    return{rec:"Negate Exact",type:"Negative Exact",severity:"high",confidence:82,
      reason:`$${m.spend.toFixed(0)} spent with ${m.clicks} clicks and no conversions. Insufficient data to confirm intent — strong waste signal.`,
      safe:true,wasteScore:70,saving:m.spend*0.80};
  }

  // High ACoS — converting but losing money
  if(m.acos>80&&m.orders>0&&m.spend>8){
    return{rec:"Reduce Bid Only",type:null,severity:"high",confidence:75,
      reason:`ACoS ${m.acos.toFixed(0)}% — converting but severely unprofitable. Negating would lose the conversion; reduce bid instead.`,
      safe:false,wasteScore:50,saving:m.spend*0.30};
  }

  // Declining CVR from comp period — worsening term
  if(comp&&comp.cvr>0&&m.cvr<comp.cvr*0.50&&m.clicks>15&&m.orders===0){
    return{rec:"Negate Phrase",type:"Negative Phrase",severity:"high",confidence:78,
      reason:`CVR declined ${(((m.cvr-comp.cvr)/comp.cvr)*100).toFixed(0)}% vs previous period. Term that previously showed intent is now non-converting.`,
      safe:true,wasteScore:65,saving:m.spend*0.75};
  }

  // Low intent — very low CTR, no conversions
  if(m.ctr<0.1&&m.clicks>10&&m.orders===0&&m.spend>5){
    return{rec:"Negate Phrase",type:"Negative Phrase",severity:"medium",confidence:68,
      reason:`CTR ${m.ctr.toFixed(2)}% indicates weak search intent alignment. Traffic is clicking but not engaging meaningfully.`,
      safe:true,wasteScore:45,saving:m.spend*0.60};
  }

  // CPC inflation with no conversion
  if(comp&&comp.cpc>0&&m.cpc>comp.cpc*1.4&&m.orders===0&&m.spend>5){
    return{rec:"Negate Exact",type:"Negative Exact",severity:"medium",confidence:65,
      reason:`CPC inflated ${(((m.cpc-comp.cpc)/comp.cpc)*100).toFixed(0)}% vs previous period with zero conversions. Increasingly expensive non-converter.`,
      safe:true,wasteScore:55,saving:m.spend*0.70};
  }

  // Efficient — do not negate
  if(m.orders>0&&m.acos>0&&m.acos<40)
    return{rec:"Keep",type:null,severity:"low",confidence:90,reason:"Term is converting within acceptable ACoS. Do not negate.",safe:true,wasteScore:0,saving:0};

  return{rec:"Monitor",type:null,severity:"low",confidence:50,reason:"Insufficient data. Continue monitoring before negating.",safe:true,wasteScore:10,saving:0};
}

/* ── Overview aggregation ────────────────────────────────────── */
function negAgg(rows,sm){
  let waste=0,clicks=0,spend=0,sal=0,ord=0,n=0;
  rows.forEach(r=>{
    const m=strCalcMetrics(r,sm);
    if(m.spend>0)n++;
    spend+=m.spend;sal+=m.sales;ord+=m.orders;clicks+=m.clicks;
    if(m.orders===0&&m.spend>0)waste+=m.spend;
  });
  return{waste,clicks,spend,sales:sal,orders:ord,termCount:n,
    acos:sal>0?(spend/sal)*100:0,cvr:clicks>0?(ord/clicks)*100:0};
}

/* ── Safety checks ───────────────────────────────────────────── */
function safetyCheck(m, term, campaign=""){
  const warnings=[];
  const t=term.toLowerCase();const camp=campaign.toLowerCase();

  if(camp.includes("rank")||camp.includes("launch"))
    warnings.push({risk:"high",msg:"Campaign appears to be a ranking or launch campaign. Negations here may disrupt organic rank momentum."});
  if(m.orders>0&&m.acos<50)
    warnings.push({risk:"medium",msg:"This term has converted in the current period. Negating will lose future conversions — consider bid reduction first."});
  if(m.clicks<5)
    warnings.push({risk:"medium",msg:"Less than 5 clicks — insufficient data to confidently negate. Wait for more data."});
  if(t.split(" ").length===1&&t.length<5)
    warnings.push({risk:"high",msg:"Single short keyword — may be a branded or high-value root term. Verify intent before negating."});

  return warnings;
}

/* ── Negation Upload Zone ────────────────────────────────────── */
function NEGUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"12px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:32,height:32,borderRadius:7,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:14,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:1}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:10,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:10,color:R,fontWeight:600,marginTop:2}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"3px 7px",borderRadius:5,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:10}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 11px",borderRadius:6,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:10,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const NEG_REPORT_TYPES=[
  {id:"str",     label:"Search Term Report",   icon:"ti-search",      required:true, desc:"Primary source — customer search queries with spend & conversion data"},
  {id:"campaign",label:"Campaign Report",       icon:"ti-speakerphone",required:false,desc:"Campaign context — helps identify ranking vs discovery campaigns"},
];

/* ── Negation Upload Page ────────────────────────────────────── */
function NEGUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.str)return;setLoading(true);setErr(null);
    try{
      const cur=await parseSheet(files.str);
      const comp=compFiles.str?await parseSheet(compFiles.str):null;
      onComplete({cur,comp,periods:localPeriods});
    }catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:680,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Search Term Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your raw Amazon Search Term Report. The system auto-detects waste traffic and generates safe negation recommendations.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{NEG_REPORT_TYPES.map(t=><NEGUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:12}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{NEG_REPORT_TYPES.map(t=><NEGUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-shield" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>The safety system automatically protects ranking terms, branded traffic, and historically converting terms from accidental negation.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.str||loading} style={{...T.btnR(false),opacity:files.str&&!loading?1:0.4,fontWeight:700,boxShadow:files.str?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-ban" style={{fontSize:14}}/> Run Negation Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Negation KPI Bar ────────────────────────────────────────── */
function NEGOverviewBar({cur,comp}){
  const defs=[
    {k:"waste",     label:"Waste Spend",   fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`,lb:true},
    {k:"spend",     label:"Total Spend",   fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`,lb:true},
    {k:"sales",     label:"Total Sales",   fmt:v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`,lb:false},
    {k:"acos",      label:"ACoS",          fmt:v=>`${v.toFixed(1)}%`,lb:true,isPp:true},
    {k:"orders",    label:"Orders",        fmt:v=>String(Math.round(v)),lb:false},
    {k:"cvr",       label:"CVR",           fmt:v=>`${v.toFixed(1)}%`,lb:false,isPp:true},
    {k:"termCount", label:"Terms Analyzed",fmt:v=>String(Math.round(v)),lb:false},
  ];
  return(
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",overflowX:"auto",flexShrink:0}}>
      <div style={{display:"flex",minWidth:"max-content"}}>
        {defs.map((d,idx)=>{
          const cv=cur[d.k]||0;const pv=comp?comp[d.k]||0:null;
          const delta=pv!=null?cv-pv:null;const pct=delta!=null&&pv!==0?(delta/Math.abs(pv))*100:null;
          const good=delta===null?null:(d.lb?delta<=0:delta>=0);
          const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";
          return(
            <div key={d.k} style={{flex:"0 0 auto",minWidth:120,padding:"13px 16px",borderRight:idx<defs.length-1?"1px solid #f0f0f0":"none",borderBottom:`3px solid ${good===true?"#1a9e4a":good===false?"#d42b2b":"transparent"}`}}>
              <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.7px",marginBottom:6}}>{d.label}</div>
              <div style={{fontSize:19,fontWeight:800,color:d.k==="waste"&&cv>0?"#d42b2b":"#111",letterSpacing:"-0.4px",lineHeight:1,marginBottom:4}}>{d.fmt(cv)}</div>
              {comp&&pct!=null&&<div><div style={{fontSize:11,fontWeight:700,color:dc,display:"flex",alignItems:"center",gap:3,marginBottom:1}}><i className={`ti ${good?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:10}}/>{sign(pct)}{Math.abs(pct).toFixed(1)}%<span style={{fontSize:9,color:"#ccc",fontWeight:400,marginLeft:2}}>vs prev</span></div>{delta!=null&&<div style={{fontSize:10,color:dc,fontWeight:600}}>{d.isPp?`${sign(delta)}${Math.abs(delta).toFixed(1)}pp`:`${sign(delta)}${d.fmt(Math.abs(delta))}`}</div>}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ── Negation Recommendation Card ────────────────────────────── */
function NEGCard({item,onSelect,selected}){
  const[open,setOpen]=useState(false);
  const{m,comp,term,cls,campaign,mt,safety}=item;
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555",low:"#aaa"};
  const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)",medium:"rgba(0,0,0,0.02)"};
  const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"#eee",low:"#f0f0f0"};
  const sev=cls.severity;
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${selected?"#1a50a0":sbr[sev]||"#eee"}`,background:selected?"rgba(26,80,160,0.04)":sb[sev]||"#fff",overflow:"hidden",marginBottom:7}}>
      <div style={{padding:"11px 14px",display:"flex",alignItems:"flex-start",gap:11}}>
        <input type="checkbox" checked={selected} onChange={()=>onSelect(term)}
          style={{accentColor:R,cursor:"pointer",marginTop:3,flexShrink:0}}/>
        <div style={{flex:1,minWidth:0,cursor:"pointer"}} onClick={()=>setOpen(v=>!v)}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[sev]||"#f0f0f0",color:sc[sev]||"#555",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[sev]}`}}>{sev}</span>
            {cls.type&&<span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.07)",color:R,fontWeight:700,border:"1px solid rgba(79,70,229,0.15)"}}>{cls.type}</span>}
            <span style={{fontSize:12,fontWeight:700,color:"#111",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:240}}>{term}</span>
            {!cls.safe&&<span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:"rgba(196,122,0,0.1)",color:"#c47a00",fontWeight:700,border:"1px solid rgba(196,122,0,0.2)"}}>⚠ Safety Flag</span>}
          </div>
          <div style={{display:"flex",gap:12,fontSize:10,color:"#888",flexWrap:"wrap"}}>
            <span>Spend: <strong style={{color:m.spend>15?"#d42b2b":"#111"}}>${m.spend.toFixed(0)}</strong></span>
            <span>Clicks: <strong style={{color:"#111"}}>{m.clicks}</strong></span>
            <span>Orders: <strong style={{color:m.orders===0?"#d42b2b":"#1a7a3c"}}>{m.orders}</strong></span>
            {m.acos>0&&<span>ACoS: <strong style={{color:m.acos>50?"#d42b2b":"#111"}}>{m.acos.toFixed(0)}%</strong></span>}
            {cls.saving>0&&<span style={{color:"#1a7a3c",fontWeight:600}}>Est. saving: ${cls.saving.toFixed(0)}</span>}
            <span style={{marginLeft:"auto",color:"#bbb"}}>{cls.confidence}% conf.</span>
          </div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6,cursor:"pointer"}} onClick={()=>setOpen(v=>!v)}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 50px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        {comp&&<div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}>
          <i className="ti ti-arrows-exchange" style={{marginRight:4,fontSize:10}}/>
          Prev: ${(comp.spend||0).toFixed(0)} spend · {comp.orders||0} orders · {comp.cvr>0?`${comp.cvr.toFixed(1)}% CVR`:"no CVR"}
        </div>}
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{cls.reason}</div>
        {safety&&safety.length>0&&<div style={{marginBottom:10}}>
          {safety.map((w,i)=><div key={i} style={{display:"flex",gap:8,marginBottom:5,padding:"7px 10px",background:w.risk==="high"?"rgba(212,43,43,0.04)":"rgba(196,122,0,0.04)",borderRadius:7,border:`1px solid ${w.risk==="high"?"rgba(212,43,43,0.15)":"rgba(196,122,0,0.15)"}`}}>
            <i className="ti ti-alert-triangle" style={{fontSize:11,color:w.risk==="high"?"#d42b2b":"#c47a00",flexShrink:0,marginTop:1}}/>
            <div style={{fontSize:11,color:"#444",lineHeight:1.5}}>{w.msg}</div>
          </div>)}
        </div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}>
          <div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Recommendation</div>
          <div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{cls.rec}{cls.type?` — add as ${cls.type} in the source campaign.`:""}{!cls.safe?" Consider bid reduction first as a safer initial step.":""}</div>
        </div>
      </div>}
    </div>
  );
}

/* ── Negation Table ──────────────────────────────────────────── */
function NEGTable({rows,sm,compMap,onExport}){
  const[search,setSearch]=useState("");const[sortKey,setSortKey]=useState("wasteScore");const[sortDir,setSortDir]=useState("desc");const[filterSev,setFilterSev]=useState("All");const[selTerms,setSelTerms]=useState(new Set());
  const SEV_F=["All","critical","high","medium","low","Keep","Monitor"];
  const SPRIOR={critical:0,high:1,medium:2,low:3,Monitor:4,Keep:5};

  const processed=useMemo(()=>rows.map((r,i)=>{
    const m=strCalcMetrics(r,sm);const term=String(r[sm.searchTerm]||"").trim();const campaign=String(r[sm.campaign]||"");const mt=String(r[sm.matchType]||"");
    const comp=compMap?compMap[term.toLowerCase()]||null:null;
    const cls=classifyNegation(m,comp,term);const safety=safetyCheck(m,term,campaign);
    return{r,m,comp,term,campaign,mt,cls,safety,id:i};
  }).filter(x=>x.term),[rows,sm,compMap]);

  const filtered=useMemo(()=>{
    let d=processed;
    if(search){const q=search.toLowerCase();d=d.filter(x=>x.term.toLowerCase().includes(q)||x.campaign.toLowerCase().includes(q));}
    if(filterSev!=="All")d=d.filter(x=>filterSev==="Keep"||filterSev==="Monitor"?x.cls.rec===filterSev:x.cls.severity===filterSev);
    return d;
  },[processed,search,filterSev]);

  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{
    if(sortKey==="severity")return sortDir==="asc"?(SPRIOR[a.cls.severity]??5)-(SPRIOR[b.cls.severity]??5):(SPRIOR[b.cls.severity]??5)-(SPRIOR[a.cls.severity]??5);
    if(sortKey==="term")return sortDir==="asc"?a.term.localeCompare(b.term):b.term.localeCompare(a.term);
    if(sortKey==="wasteScore")return sortDir==="asc"?a.cls.wasteScore-b.cls.wasteScore:b.cls.wasteScore-a.cls.wasteScore;
    const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;
  }),[filtered,sortKey,sortDir]);

  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir("desc");}}
  const toggleSel=t=>setSelTerms(s=>{const n=new Set(s);n.has(t)?n.delete(t):n.add(t);return n;});
  const toggleAll=()=>selTerms.size===sorted.length&&sorted.length>0?setSelTerms(new Set()):setSelTerms(new Set(sorted.filter(x=>x.cls.type).map(x=>x.term)));
  const negItems=sorted.filter(x=>selTerms.has(x.term));
  const sevCounts=useMemo(()=>{const m={};processed.forEach(x=>{const k=x.cls.rec==="Keep"?"Keep":x.cls.rec==="Monitor"?"Monitor":x.cls.severity;m[k]=(m[k]||0)+1;});return m;},[processed]);

  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555",low:"#aaa"};
  const DC=({cur,prev,fmt,lb,isPp})=>{const d=prev!=null?cur-prev:null;const good=d===null?null:(lb?d<=0:d>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";return<><div style={{fontSize:12,fontWeight:500,color:"#111",lineHeight:1.4}}>{fmt(cur)}</div>{d!=null&&Math.abs(d)>0.001&&<div style={{fontSize:10,fontWeight:600,color:dc}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}</>;};

  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 16px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:180}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search term or campaign…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {SEV_F.map(f=>{const cnt=f==="All"?processed.length:sevCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterSev===f;return<button key={f} onClick={()=>setFilterSev(f)} style={{padding:"4px 9px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/>
        {selTerms.size>0&&<button onClick={()=>onExport(negItems)} style={{...T.btnR(true),fontWeight:700}}><i className="ti ti-download" style={{fontSize:12}}/> Export {selTerms.size} Selected</button>}
        <span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> terms</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={{...thS,cursor:"default",width:34}}><input type="checkbox" checked={selTerms.size===sorted.filter(x=>x.cls.type).length&&sorted.filter(x=>x.cls.type).length>0} onChange={toggleAll} style={{accentColor:R}}/></th>
            <th style={thS} onClick={()=>toggleSort("severity")}>Severity <SI col="severity"/></th>
            <th style={thS} onClick={()=>toggleSort("term")}>Search Term <SI col="term"/></th>
            <th style={{...thS,cursor:"default"}}>Recommendation</th>
            <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
            <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
            <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
            <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
            <th style={thS} onClick={()=>toggleSort("cpc")}>CPC <SI col="cpc"/></th>
            <th style={thS} onClick={()=>toggleSort("wasteScore")}>Waste Score <SI col="wasteScore"/></th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,term,cls,safety,id},i)=>{
              const isSel=selTerms.has(term);
              return(<tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:isSel?"rgba(79,70,229,0.03)":i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"8px 10px"}}>{cls.type&&<input type="checkbox" checked={isSel} onChange={()=>toggleSel(term)} style={{accentColor:R,cursor:"pointer"}}/>}</td>
                <td style={{padding:"7px 10px"}}><span style={{fontSize:10,padding:"2px 7px",borderRadius:5,background:`${sc[cls.severity]||"#aaa"}11`,color:sc[cls.severity]||"#aaa",fontWeight:700,border:`1px solid ${sc[cls.severity]||"#eee"}33`}}>{cls.severity}</span></td>
                <td style={{padding:"8px 10px",maxWidth:220}} title={term}><div style={{fontWeight:600,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{term}</div></td>
                <td style={{padding:"8px 10px"}}>
                  {cls.type?<span style={{fontSize:10,padding:"2px 7px",borderRadius:5,background:"rgba(79,70,229,0.07)",color:R,fontWeight:700}}>{cls.type}</span>
                    :<span style={{fontSize:10,padding:"2px 7px",borderRadius:5,background:"#f0f0f0",color:"#555",fontWeight:600}}>{cls.rec}</span>}
                  {safety&&safety.some(w=>w.risk==="high")&&<i className="ti ti-alert-triangle" style={{fontSize:10,color:"#c47a00",marginLeft:5}}/>}
                </td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.spend} prev={comp?.spend} fmt={v=>`$${v.toFixed(0)}`} lb={true}/></td>
                <td style={{padding:"8px 10px",fontWeight:600,color:m.orders===0?"#d42b2b":"#111",fontSize:12,verticalAlign:"top"}}>
                  <div>{m.orders}</div>{comp!=null&&<div style={{fontSize:10,color:m.orders<(comp.orders||0)?"#d42b2b":"#1a9e4a",fontWeight:600}}>{m.orders-(comp.orders||0)>0?"+":""}{m.orders-(comp.orders||0)}</div>}
                </td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.acos>0?m.acos:0} prev={comp?.acos>0?comp.acos:null} fmt={v=>v>0?`${v.toFixed(0)}%`:"—"} lb={true} isPp={true}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cvr} prev={comp?.cvr} fmt={v=>`${v.toFixed(1)}%`} lb={false} isPp={true}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cpc} prev={comp?.cpc} fmt={v=>`$${v.toFixed(2)}`} lb={true}/></td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:5}}><div style={{height:4,borderRadius:2,width:`${cls.wasteScore}%`,maxWidth:44,background:`${cls.wasteScore>=70?"#d42b2b":cls.wasteScore>=40?"#c47a00":"#1a9e4a"}`}}/><span style={{fontSize:11,fontWeight:700,color:cls.wasteScore>=70?"#d42b2b":cls.wasteScore>=40?"#c47a00":"#1a7a3c"}}>{cls.wasteScore}</span></div>
                </td>
              </tr>);
            })}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No terms match</div></div>}
      </div>
    </div>
  );
}

/* ── Negation Workspace ──────────────────────────────────────── */
function NEGWorkspace({curData,compData,periods,onReupload,onExport}){
  const sm=useMemo(()=>curData?strDetectMap(curData.headers):{},[curData]);
  const compSm=useMemo(()=>compData?strDetectMap(compData.headers):{},[compData]);
  const curAgg=useMemo(()=>curData?negAgg(curData.rows,sm):{},[curData,sm]);
  const compAgg=useMemo(()=>compData?negAgg(compData.rows,compSm):null,[compData,compSm]);
  const compMap=useMemo(()=>{if(!compData)return null;const m={};compData.rows.forEach(r=>{const row=strCalcMetrics(r,compSm);const term=String(r[compSm.searchTerm]||"").trim().toLowerCase();if(term)m[term]=row;});return m;},[compData,compSm]);

  // Pre-process for overview cards
  const allProcessed=useMemo(()=>curData?curData.rows.map(r=>{
    const m=strCalcMetrics(r,sm);const term=String(r[sm.searchTerm]||"").trim();
    const comp=compMap?compMap[term.toLowerCase()]||null:null;
    const cls=classifyNegation(m,comp,term);
    return{m,comp,term,cls};
  }).filter(x=>x.term):[],[curData,sm,compMap]);

  const toNegate=allProcessed.filter(x=>x.cls.type);
  const totalSaving=toNegate.reduce((s,x)=>s+x.cls.saving,0);
  const critCount=toNegate.filter(x=>x.cls.severity==="critical").length;
  const[activeTab,setActiveTab]=useState("overview");

  // Insights
  const insights=useMemo(()=>{
    const lines=[];const bleeders=allProcessed.filter(x=>x.m.spend>15&&x.m.orders===0);
    const ws=bleeders.reduce((s,x)=>s+x.m.spend,0);
    if(bleeders.length)lines.push({type:"critical",icon:"ti-droplet-off",text:`${bleeders.length} terms spending $${ws.toFixed(0)} with zero conversions. These are confirmed bleeders — pure waste that can be recovered immediately.`});
    const highCpc=allProcessed.filter(x=>x.m.cpc>3&&x.m.orders===0&&x.m.clicks>3);
    if(highCpc.length)lines.push({type:"negative",icon:"ti-coin",text:`${highCpc.length} terms have CPC above $3 with no conversions. High-CPC non-converters compound waste quickly — reduce bids or negate these first.`});
    const cvr=allProcessed.filter(x=>x.comp&&x.comp.cvr>0&&x.m.cvr<x.comp.cvr*0.5&&x.m.clicks>10&&x.m.orders===0);
    if(cvr.length)lines.push({type:"negative",icon:"ti-trending-down",text:`${cvr.length} terms show CVR decline >50% vs previous period with zero current conversions. Previously tolerable, now pure waste — escalate negation priority.`});
    if(totalSaving>0)lines.push({type:"opportunity",icon:"ti-piggy-bank",text:`Estimated spend recovery from recommended negations: $${totalSaving.toFixed(0)}. This budget can be reallocated to proven converting campaigns.`});
    return lines;
  },[allProcessed,totalSaving]);

  const TABS=[{key:"overview",label:"Overview",icon:"ti-ban"},{key:"cards",label:`Negations (${toNegate.length})`,icon:"ti-list-check"},{key:"table",label:"Full Table",icon:"ti-table"}];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Negation Engine</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {totalSaving>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(26,122,60,0.08)",color:"#1a7a3c",fontWeight:700}}>~${totalSaving.toFixed(0)} recoverable</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{curData?.rows?.length||0} search terms</span>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          {toNegate.length>0&&<button onClick={()=>onExport(toNegate)} style={{...T.btnR(true),fontWeight:700}}><i className="ti ti-download" style={{fontSize:12}}/> Export All ({toNegate.length})</button>}
          <button onClick={onReupload} style={T.btnG(true)}><i className="ti ti-upload" style={{fontSize:12}}/> Re-upload</button>
        </div>
      </div>

      <NEGOverviewBar cur={curAgg} comp={compAgg?.spend>0?compAgg:null}/>

      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>

      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {/* OVERVIEW */}
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:860,margin:"0 auto",padding:"20px 22px"}}>
          <ModuleOverview
            moduleName="Negation Engine" moduleIcon="ti-ban" periods={periods}
            cur={curAgg} comp={compAgg?.spend>0?compAgg:null}
            rows={curData?.rows||[]}
            extraKpis={[{label:"Terms to Negate",value:toNegate.length,fmt:"int",icon:"ti-ban",color:"#d42b2b"},{label:"Wasted Spend",value:allProcessed.filter(x=>x.cls.type).reduce((s,x)=>s+x.m.spend,0),fmt:"dollar",icon:"ti-coin-off",color:"#c47a00",invert:true}]}
            alerts={allProcessed.filter(x=>x.cls.wasteScore>=80).slice(0,3).map(x=>({type:"critical",icon:"ti-droplet-off",title:`Negate: "${x.term.slice(0,30)}"`,value:`$${x.m.spend.toFixed(0)} wasted`,detail:`${x.m.clicks} clicks, 0 orders — pure waste`}))}
          />
          {/* Stats grid */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:18}}>
            {[{label:"To Negate",val:toNegate.length,color:"#d42b2b",bg:"rgba(212,43,43,0.07)"},{label:"Critical",val:critCount,color:"#d42b2b",bg:"rgba(212,43,43,0.05)"},{label:"Recoverable",val:`$${totalSaving.toFixed(0)}`,color:"#1a7a3c",bg:"rgba(26,122,60,0.07)"},{label:"Waste Spend",val:`$${curAgg.waste?.toFixed(0)||0}`,color:"#c47a00",bg:"rgba(196,122,0,0.07)"}].map(s=>(
              <div key={s.label} style={{padding:"14px",background:s.bg,borderRadius:10,border:`1px solid ${s.color}22`,textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div>
                <div style={{fontSize:11,fontWeight:600,color:s.color}}>{s.label}</div>
              </div>
            ))}
          </div>
          {/* Insights */}
          {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:18}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Waste Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
            {insights.map((ins,i)=>{const tc={critical:"#d42b2b",negative:"#d42b2b",opportunity:"#1a7a3c",neutral:"#555"};const ic={critical:"ti-droplet-off",negative:"ti-trending-down",opportunity:"ti-piggy-bank",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
          </div>}
          {/* Top negations preview */}
          {toNegate.length>0&&<>
            <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Top Priority Negations</div>
            {toNegate.slice(0,5).map((x,i)=>{const{m,comp,term,cls,safety}=x;const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555",low:"#aaa"};const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)"};return(
              <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",background:"#fff",borderRadius:9,border:`1px solid ${sc[cls.severity]||"#eee"}22`,marginBottom:6}}>
                <div style={{width:4,height:36,borderRadius:2,background:sc[cls.severity]||"#eee",flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:700,color:"#111",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{term}</div>
                  <div style={{fontSize:10,color:"#888",marginTop:2}}>{cls.type||cls.rec} · ${m.spend.toFixed(0)} spent · {m.orders} orders{cls.saving>0?` · ~$${cls.saving.toFixed(0)} recoverable`:""}</div>
                </div>
                <span style={{fontSize:9,padding:"2px 7px",borderRadius:4,background:sb[cls.severity]||"#f0f0f0",color:sc[cls.severity]||"#555",fontWeight:700,border:`1px solid ${sc[cls.severity]||"#eee"}33`,flexShrink:0}}>{cls.severity}</span>
              </div>
            );})}
            {toNegate.length>5&&<button onClick={()=>setActiveTab("cards")} style={{...T.btnG(true),width:"100%",justifyContent:"center",marginTop:4}}>View All {toNegate.length} Negations →</button>}
          </>}
          {toNegate.length===0&&<div style={{textAlign:"center",padding:"50px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}>
            <i className="ti ti-circle-check" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/>
            <div style={{fontSize:16,fontWeight:700,color:"#111"}}>No negations needed</div>
            <div style={{fontSize:13,color:"#888",marginTop:4}}>All search terms are within acceptable performance thresholds.</div>
          </div>}
        </div></div>}

        {/* CARDS TAB */}
        {activeTab==="cards"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>
          {toNegate.length===0?<div style={{textAlign:"center",padding:"50px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-circle-check" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700}}>No negations recommended</div></div>
            :toNegate.map((x,i)=><NEGCard key={i} item={x} selected={false} onSelect={()=>{}}/>)}
        </div></div>}

        {/* TABLE TAB */}
        {activeTab==="table"&&<NEGTable rows={curData?.rows||[]} sm={sm} compMap={compMap} onExport={items=>onExport(items)}/>}
      </div>
    </div>
  );
}

/* ── Negation Export Page ────────────────────────────────────── */
function NEGExportPage({items,onBack}){
  const[exported,setExported]=useState({exact:false,phrase:false});

  function doExport(type){
    const filtered=items.filter(x=>x.cls.type===type);
    if(!filtered.length){alert(`No ${type} negations in selection.`);return;}
    /* Amazon requires camelCase match types — "negativeExact" not "Negative Exact" */
    const amznType=type==="Negative Exact"?"negativeExact":"negativePhrase";
    /* Amazon requires "Campaign Negative Keyword" for campaign-level negation */
    const bulkRows=filtered.map(x=>amznCampNegRow({
      campaign:x.campaign||x.camp||"",
      keyword:x.term,
      matchType:amznType,
    }));
    const wb=XLSX.utils.book_new();
    /* Sheet 1: Upload-ready Amazon bulk format */
    const ws1=XLSX.utils.json_to_sheet(bulkRows,{header:AMZN_SP_COLS});
    ws1["!cols"]=AMZN_SP_COLS.map(h=>({wch:["Campaign Name","Keyword Text"].includes(h)?30:14}));
    XLSX.utils.book_append_sheet(wb,ws1,"Sponsored Products Campaigns");
    /* Sheet 2: Review with metrics */
    const review=filtered.map(x=>({
      "Keyword Text":x.term,"Match Type (Amazon)":amznType,
      "Waste Score":x.cls.wasteScore,"Confidence (%)":x.cls.confidence,
      "Spend ($)":x.m?.spend?.toFixed(2)||"","Orders":x.m?.orders||0,
      "Reason":x.cls.reason||type,"Campaign":x.campaign||x.camp||"—"
    }));
    const ws2=XLSX.utils.json_to_sheet(review);
    ws2["!cols"]=[{wch:35},{wch:16},{wch:12},{wch:14},{wch:10},{wch:8},{wch:50},{wch:40}];
    XLSX.utils.book_append_sheet(wb,ws2,"Review — Do Not Upload");
    XLSX.writeFile(wb,`Amazon_${amznType}_Negations_${new Date().toISOString().slice(0,10)}.xlsx`);
    setExported(p=>({...p,[type==="Negative Exact"?"exact":"phrase"]:true}));
  }

  function doExportAll(){
    const wb=XLSX.utils.book_new();
    /* All negations in Amazon bulk format — one sheet Amazon can upload */
    const bulkRows=items.map(x=>{
      const amznType=x.cls.type==="Negative Exact"?"negativeExact":"negativePhrase";
      return amznCampNegRow({campaign:x.campaign||x.camp||"",keyword:x.term,matchType:amznType});
    });
    const ws1=XLSX.utils.json_to_sheet(bulkRows,{header:AMZN_SP_COLS});
    ws1["!cols"]=AMZN_SP_COLS.map(h=>({wch:["Campaign Name","Keyword Text"].includes(h)?30:14}));
    XLSX.utils.book_append_sheet(wb,ws1,"Sponsored Products Campaigns");
    /* Review sheet with full analytics */
    const reviewRows=items.map(x=>({
      "Keyword Text":x.term,
      "Amazon Match Type":x.cls.type==="Negative Exact"?"negativeExact":"negativePhrase",
      "Spend ($)":x.m?.spend?.toFixed(2)||"","Orders":x.m?.orders||0,
      "CVR (%)":x.m?.cvr?.toFixed(1)||"","Waste Score":x.cls.wasteScore,
      "Confidence (%)":x.cls.confidence,"Reason":x.cls.reason||"",
      "Campaign":x.campaign||x.camp||"—"
    }));
    const ws2=XLSX.utils.json_to_sheet(reviewRows);
    ws2["!cols"]=[{wch:35},{wch:18},{wch:10},{wch:8},{wch:10},{wch:12},{wch:14},{wch:50},{wch:40}];
    XLSX.utils.book_append_sheet(wb,ws2,"Review — Do Not Upload");
    XLSX.writeFile(wb,`Amazon_All_Negations_Upload_${new Date().toISOString().slice(0,10)}.xlsx`);
  }

  const exactCount=items.filter(x=>x.cls.type==="Negative Exact").length;
  const phraseCount=items.filter(x=>x.cls.type==="Negative Phrase").length;
  const totalSaving=items.reduce((s,x)=>s+x.cls.saving,0);

  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:700,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:12}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace</button>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Negation Sheets</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Amazon-ready negative targeting files. Upload directly to Seller Central → Campaign Manager → Bulk Operations.</p>
        </div>
        {/* Summary */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Export Summary</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
            {[{label:"Total Negations",val:items.length,color:"#d42b2b"},{label:"Negative Exact",val:exactCount,color:"#d42b2b"},{label:"Negative Phrase",val:phraseCount,color:"#c47a00"},{label:"Est. Recovery",val:`$${totalSaving.toFixed(0)}`,color:"#1a7a3c"}].map(s=>(
              <div key={s.label} style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div><div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>
          {/* Export buttons */}
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            <button onClick={doExportAll} style={{...T.btnR(false),justifyContent:"center",fontWeight:700,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
              <i className="ti ti-download" style={{fontSize:14}}/> Download All Negations ({items.length} terms) — Combined File
            </button>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              <button onClick={()=>doExport("Negative Exact")} disabled={!exactCount} style={{...T.btnG(false),justifyContent:"center",opacity:exactCount?1:0.4}}>
                <i className="ti ti-download" style={{fontSize:12}}/> Negative Exact ({exactCount})
              </button>
              <button onClick={()=>doExport("Negative Phrase")} disabled={!phraseCount} style={{...T.btnG(false),justifyContent:"center",opacity:phraseCount?1:0.4}}>
                <i className="ti ti-download" style={{fontSize:12}}/> Negative Phrase ({phraseCount})
              </button>
            </div>
          </div>
        </div>
        {/* Upload instructions */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>How to upload negations to Amazon</div>
          {["Go to Seller Central → Advertising → Campaign Manager","Click 'Bulk Operations' → 'Upload File'","Select your downloaded negation file","Amazon will validate and apply the negative keywords","Check the processing report for any errors"].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:10,marginBottom:7,alignItems:"flex-start"}}>
              <span style={{width:18,height:18,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span>
              <span style={{fontSize:12,color:"#555",lineHeight:1.6}}>{s}</span>
            </div>
          ))}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>Campaign Name and Ad Group Name columns are left blank — fill them in to apply negations to specific campaigns, or leave blank for campaign-level negation via the bulk upload interface.</div>
        </div>
      </div>
    </div>
  );
}

/* ── Negation Module Root ────────────────────────────────────── */
function NegationModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.primary?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(globalData?.cur?.primary||null);const[compData,setCompData]=useState(globalData?.comp?.primary||null);const[exportItems,setExportItems]=useState([]);
  useEffect(()=>{if(globalData?.cur?.primary&&page==="upload"){setCurData(globalData.cur.primary);setCompData(globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);
  if(page==="export")return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Negation Engine — Export</h2></div><NEGExportPage items={exportItems} onBack={()=>setPage("workspace")}/></div>);
  if(page==="workspace"&&curData)return(<NEGWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>{setCurData(null);setPage("upload");}} onExport={items=>{setExportItems(items);setPage("export");}}/>);
  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Negation Engine</h2></div><NEGUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/></div>);
}

/* ================================================================
   DAYPARTING INTELLIGENCE MODULE
   Time-based traffic analysis & bid scheduling system.
   Pages: Upload Hourly Reports → Workspace → Export Schedules
================================================================ */

/* ── Hourly column aliases ───────────────────────────────────── */
const DP_ALIASES={
  hour:        ["Hour","Hour of Day","Hour (24h)","Hour Block","hour","Time","Hour of day"],
  dayOfWeek:   ["Day of Week","Day","Weekday","day_of_week","Day of week"],
  date:        ["Date","date","Report Date","Day"],
  campaign:    ["Campaign Name","Campaign","campaign name"],
  impressions: ["Impressions","impressions"],
  clicks:      ["Clicks","clicks"],
  spend:       ["Spend","Cost","Ad Spend"],
  sales:       ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales"],
  orders:      ["Orders","14 Day Total Orders (#)","14 Day Total Orders"],
  acos:        ["ACOS","ACoS"],
  cpc:         ["CPC","Cost Per Click","Average CPC"],
  ctr:         ["Click-through Rate","CTR"],
  cvr:         ["Conversion Rate","CVR"],
};

function dpDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(DP_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function dpNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

/* ── Aggregate rows by hour ──────────────────────────────────── */
function dpGroupByHour(rows,dm){
  const byHour={};
  for(let h=0;h<24;h++)byHour[h]={hour:h,impressions:0,clicks:0,spend:0,sales:0,orders:0,count:0};
  rows.forEach(r=>{
    let h=dpNum(r,dm.hour);
    if(h<0||h>23)h=0;
    const imp=dpNum(r,dm.impressions),clk=dpNum(r,dm.clicks),spd=dpNum(r,dm.spend),sal=dpNum(r,dm.sales),ord=dpNum(r,dm.orders);
    byHour[h].impressions+=imp;byHour[h].clicks+=clk;byHour[h].spend+=spd;byHour[h].sales+=sal;byHour[h].orders+=ord;byHour[h].count++;
  });
  return Object.values(byHour).map(h=>{
    const ctr=h.impressions>0?(h.clicks/h.impressions)*100:0;
    const cvr=h.clicks>0?(h.orders/h.clicks)*100:0;
    const acos=h.sales>0?(h.spend/h.sales)*100:0;
    const cpc=h.clicks>0?h.spend/h.clicks:0;
    const roas=h.spend>0?h.sales/h.spend:0;
    // Efficiency score 0-100
    let eff=50;
    if(h.spend>0&&h.orders===0)eff=Math.max(5,eff-40);
    if(acos>0&&acos<25)eff=Math.min(100,eff+30);
    else if(acos>50)eff=Math.max(5,eff-25);
    if(cvr>3)eff=Math.min(100,eff+20);
    else if(cvr<0.5&&h.clicks>5)eff=Math.max(5,eff-20);
    return{...h,ctr,cvr,acos,cpc,roas,efficiency:Math.round(eff)};
  });
}

/* ── Hour label helper ───────────────────────────────────────── */
function hourLabel(h){
  if(h===0)return"12 AM";if(h<12)return`${h} AM`;if(h===12)return"12 PM";return`${h-12} PM`;
}
function hourBlock(h){
  if(h>=0&&h<6)return"Late Night";if(h>=6&&h<9)return"Early Morning";if(h>=9&&h<12)return"Morning";
  if(h>=12&&h<14)return"Midday";if(h>=14&&h<18)return"Afternoon";if(h>=18&&h<21)return"Evening";return"Night";
}

/* ── Efficiency classification ───────────────────────────────── */
function classifyHour(h,comp){
  const delta=comp?h.efficiency-comp.efficiency:null;
  if(h.spend>0&&h.orders===0&&h.clicks>=5) return{cls:"Waste Window",    color:"#d42b2b",bg:"rgba(212,43,43,0.08)",icon:"ti-clock-x",       action:"reduce_bid"};
  if(h.efficiency>=75&&h.spend>0)          return{cls:"Prime Window",    color:"#1a7a3c",bg:"rgba(26,122,60,0.08)", icon:"ti-clock-check",   action:"scale"};
  if(h.cvr>4&&h.spend>0)                  return{cls:"Scale Window",    color:"#1a7a3c",bg:"rgba(26,122,60,0.06)", icon:"ti-trending-up",   action:"scale"};
  if(h.cpc>2&&h.orders===0&&h.clicks>3)   return{cls:"CPC Inflation",   color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-trending-up",   action:"reduce_bid"};
  if(h.hour>=0&&h.hour<6&&h.spend>0)      return{cls:"Late Night Waste",color:"#c47a00",bg:"rgba(196,122,0,0.07)",icon:"ti-moon",           action:"pause"};
  if(h.acos>0&&h.acos<30&&h.orders>=1)    return{cls:"Efficient",       color:"#1a50a0",bg:"rgba(26,80,160,0.07)",icon:"ti-check",          action:"maintain"};
  if(h.spend===0)                          return{cls:"No Activity",     color:"#ccc",   bg:"transparent",          icon:"ti-minus",          action:"monitor"};
  return{cls:"Monitor",                  color:"#888",   bg:"rgba(0,0,0,0.03)",    icon:"ti-eye",            action:"monitor"};
}

/* ── Dayparting alerts ───────────────────────────────────────── */
function generateDPAlerts(hourData,compHour){
  const alerts=[];
  hourData.forEach(h=>{
    const comp=compHour?compHour.find(c=>c.hour===h.hour)||null:null;

    // Waste window — spending with no conversions
    if(h.spend>5&&h.orders===0&&h.clicks>=5){
      alerts.push({severity:"critical",type:"Waste Window",icon:"ti-clock-x",color:"#d42b2b",
        window:`${hourLabel(h.hour)} (${hourBlock(h.hour)})`,
        comparison:comp?`Prev: $${comp.spend.toFixed(0)} spend, ${comp.orders} orders`:`$${h.spend.toFixed(0)} spent, zero conversions`,
        cause:`${hourLabel(h.hour)} generated ${h.clicks} clicks and $${h.spend.toFixed(0)} spend with zero conversions. This time window consistently attracts low-intent traffic.`,
        action:"Reduce bids by 50–70% during this hour, or pause ads completely if pattern persists across multiple days.",
        impact:`Estimated saving: ~$${(h.spend*0.65).toFixed(0)} per day`,confidence:88});
    }

    // CVR collapse vs comp
    if(comp&&comp.cvr>2&&h.cvr<comp.cvr*0.5&&h.clicks>8){
      const pct=((h.cvr-comp.cvr)/comp.cvr)*100;
      alerts.push({severity:"high",type:"CVR Collapse",icon:"ti-chart-line-down",color:"#c47a00",
        window:`${hourLabel(h.hour)} (${hourBlock(h.hour)})`,
        comparison:`CVR: ${comp.cvr.toFixed(1)}% → ${h.cvr.toFixed(1)}% (${pct.toFixed(0)}%)`,
        cause:`Conversion rate at ${hourLabel(h.hour)} dropped ${Math.abs(pct).toFixed(0)}% vs previous period. Same traffic window, significantly fewer purchases — may indicate increased competition or lower intent shoppers at this hour.`,
        action:"Reduce bids at this hour by 25–30% until CVR recovers. Monitor for 7 days before restoring.",
        impact:"Reducing spend at low-CVR hours improves overall campaign efficiency",confidence:79});
    }

    // CPC inflation
    if(comp&&comp.cpc>0&&h.cpc>comp.cpc*1.4&&h.orders===0&&h.clicks>3){
      const pct=((h.cpc-comp.cpc)/comp.cpc)*100;
      alerts.push({severity:"high",type:"CPC Inflation Hour",icon:"ti-coin",color:"#c47a00",
        window:`${hourLabel(h.hour)} (${hourBlock(h.hour)})`,
        comparison:`CPC: $${comp.cpc.toFixed(2)} → $${h.cpc.toFixed(2)} (+${pct.toFixed(0)}%)`,
        cause:`Traffic cost at ${hourLabel(h.hour)} increased ${pct.toFixed(0)}% with no conversion improvement. Auction competition intensified at this hour without corresponding purchase intent.`,
        action:"Reduce bid modifier for this hour by 30–40%. Set a bid ceiling to prevent runaway CPC.",
        impact:`CPC reduction of 20% at this hour saves ~$${((h.cpc-comp.cpc)*h.clicks*0.7).toFixed(0)}`,confidence:75});
    }

    // Prime window — high efficiency
    if(h.efficiency>=78&&h.spend>0&&h.orders>=2){
      alerts.push({severity:"low",type:"Prime Conversion Window",icon:"ti-clock-check",color:"#1a7a3c",
        window:`${hourLabel(h.hour)} (${hourBlock(h.hour)})`,
        comparison:comp?`Efficiency: ${comp.efficiency} → ${h.efficiency} (+${h.efficiency-comp.efficiency}pts)`:`Efficiency score: ${h.efficiency}/100`,
        cause:`${hourLabel(h.hour)} shows strong conversion efficiency with ${h.orders} orders and ${h.efficiency}/100 efficiency score. This is a proven purchase-intent window.`,
        action:"Increase bids by 20–30% during this hour. Consider raising daily budget to ensure full coverage.",
        impact:`More impressions at this CVR (${h.cvr.toFixed(1)}%) = proportionally more orders`,confidence:85});
    }

    // Late night waste (0-5am)
    if(h.hour>=0&&h.hour<=4&&h.spend>3&&h.orders===0){
      alerts.push({severity:"medium",type:"Late Night Waste",icon:"ti-moon",color:"#c47a00",
        window:`${hourLabel(h.hour)} (Late Night)`,
        comparison:`$${h.spend.toFixed(0)} spent, zero conversions`,
        cause:"Late night hours (12–5 AM) typically show very low purchase intent on Amazon. Budget spent here is unlikely to convert and may inflate ACoS without ROI.",
        action:"Pause ads between 12 AM – 5 AM. Use the saved budget to increase bids during proven conversion windows.",
        impact:`Pausing 12–5 AM recovers ~$${(h.spend*0.9).toFixed(0)}/day for reallocation`,confidence:82});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3)).slice(0,15);
}

/* ── Scheduling recommendations ─────────────────────────────── */
function generateDPSchedule(hourData){
  const recs=[];
  const sorted=[...hourData].filter(h=>h.spend>0);

  // Scale hours — top performers
  const scaleHours=sorted.filter(h=>h.efficiency>=70&&h.orders>=1).sort((a,b)=>b.efficiency-a.efficiency).slice(0,5);
  if(scaleHours.length){
    recs.push({icon:"ti-trending-up",color:"#1a7a3c",type:"scale",
      title:"Scale These Hours",
      hours:scaleHours.map(h=>hourLabel(h.hour)).join(", "),
      why:`These ${scaleHours.length} hours show the strongest efficiency scores (avg ${Math.round(scaleHours.reduce((s,h)=>s+h.efficiency,0)/scaleHours.length)}/100) and highest conversion rates.`,
      action:"Increase bids by 20–35% during these windows. Allocate extra budget here first.",
      impact:"More impressions during high-CVR hours multiplies profitable conversions"});
  }

  // Reduce bid hours
  const reduceHours=sorted.filter(h=>h.efficiency<35&&h.spend>2).sort((a,b)=>a.efficiency-b.efficiency).slice(0,5);
  if(reduceHours.length){
    const wasteSave=reduceHours.reduce((s,h)=>s+h.spend*0.5,0);
    recs.push({icon:"ti-adjustments",color:"#c47a00",type:"reduce",
      title:"Reduce Bids These Hours",
      hours:reduceHours.map(h=>hourLabel(h.hour)).join(", "),
      why:`These ${reduceHours.length} hours have efficiency scores below 35. Traffic exists but conversions are weak — bids are too high for the intent level.`,
      action:"Reduce bid modifier by 40–60% during these hours. Don't pause — just lower exposure.",
      impact:`Estimated ~$${wasteSave.toFixed(0)}/day recoverable through bid reduction`});
  }

  // Pause candidates
  const pauseHours=sorted.filter(h=>h.spend>0&&h.orders===0&&h.clicks>=5).map(h=>h.hour);
  if(pauseHours.length){
    const pauseSave=sorted.filter(h=>pauseHours.includes(h.hour)).reduce((s,h)=>s+h.spend,0);
    recs.push({icon:"ti-player-pause",color:"#d42b2b",type:"pause",
      title:"Consider Pausing These Hours",
      hours:pauseHours.map(h=>hourLabel(h)).join(", "),
      why:`${pauseHours.length} hours spent $${pauseSave.toFixed(0)} total with zero conversions. No purchase intent detected during these windows.`,
      action:"Test pausing ads during these hours for 2 weeks. If total orders are maintained, make the pause permanent.",
      impact:`~$${pauseSave.toFixed(0)}/day recoverable. Reallocate to prime conversion windows.`});
  }

  // Prime window
  const primeHours=sorted.filter(h=>h.cvr>4&&h.orders>=2).sort((a,b)=>b.cvr-a.cvr);
  if(primeHours.length){
    recs.push({icon:"ti-star",color:"#6338c8",type:"prime",
      title:"Prime Conversion Windows",
      hours:primeHours.slice(0,6).map(h=>hourLabel(h.hour)).join(", "),
      why:`These hours show CVR above 4% — significantly above typical Amazon averages. These are your highest-value advertising windows.`,
      action:"Set bid modifiers to +30–50% for these hours. Ensure budget doesn't cap out before reaching these windows.",
      impact:"Every 1K extra impressions at this CVR generates more orders than at any other time of day"});
  }

  return recs;
}

/* ── AI dayparting insights ──────────────────────────────────── */
function generateDPInsights(hourData,compHour){
  const lines=[];const active=hourData.filter(h=>h.spend>0);
  if(!active.length)return lines;

  const bestHour=active.reduce((b,h)=>h.efficiency>b.efficiency?h:b,active[0]);
  const worstHour=active.filter(h=>h.clicks>=3).reduce((b,h)=>h.efficiency<b.efficiency?h:b,active[0]);
  const totalSpend=active.reduce((s,h)=>s+h.spend,0);
  const wasteSpend=active.filter(h=>h.orders===0&&h.clicks>=5).reduce((s,h)=>s+h.spend,0);
  const lateNightSpend=active.filter(h=>h.hour<=4||h.hour>=23).reduce((s,h)=>s+h.spend,0);

  if(bestHour){
    lines.push({type:"positive",icon:"ti-clock-check",text:`${hourLabel(bestHour.hour)} is your strongest conversion window with an efficiency score of ${bestHour.efficiency}/100${bestHour.cvr>0?` and ${bestHour.cvr.toFixed(1)}% CVR`:""}. Budget allocated here returns the highest value per dollar spent.`});
  }

  if(wasteSpend>0){
    const wastePct=(wasteSpend/totalSpend)*100;
    lines.push({type:"negative",icon:"ti-clock-x",text:`${wastePct.toFixed(0)}% of total hourly spend ($${wasteSpend.toFixed(0)}) occurred during hours with zero conversions. Reallocating this budget to proven conversion windows would improve overall account efficiency.`});
  }

  if(lateNightSpend>0){
    lines.push({type:"negative",icon:"ti-moon",text:`$${lateNightSpend.toFixed(0)} was spent between 11 PM – 5 AM. Late-night Amazon traffic typically shows significantly lower purchase intent. Pausing during these hours is a low-risk efficiency improvement.`});
  }

  if(compHour){
    const effDelta=active.reduce((s,h)=>{const c=compHour.find(ch=>ch.hour===h.hour);return c?s+(h.efficiency-c.efficiency):s;},0)/Math.max(active.length,1);
    if(Math.abs(effDelta)>3){
      lines.push({type:effDelta>0?"positive":"negative",icon:effDelta>0?"ti-trending-up":"ti-trending-down",
        text:effDelta>0?`Average hourly efficiency improved ${effDelta.toFixed(1)} points vs previous period — either traffic quality improved or bid optimization is working.`
          :`Average hourly efficiency declined ${Math.abs(effDelta).toFixed(1)} points vs previous period. Review which hours worsened most and apply bid reductions there first.`});
    }
  }

  const morningPerf=active.filter(h=>h.hour>=9&&h.hour<12);const eveningPerf=active.filter(h=>h.hour>=18&&h.hour<21);
  if(morningPerf.length&&eveningPerf.length){
    const mAvg=morningPerf.reduce((s,h)=>s+h.efficiency,0)/morningPerf.length;const eAvg=eveningPerf.reduce((s,h)=>s+h.efficiency,0)/eveningPerf.length;
    if(Math.abs(mAvg-eAvg)>10){
      lines.push({type:"opportunity",icon:"ti-clock",text:mAvg>eAvg?`Morning hours (9 AM–12 PM) outperform evening hours by ${(mAvg-eAvg).toFixed(0)} efficiency points. Shift budget weighting toward morning windows for better efficiency.`:`Evening hours (6 PM–9 PM) outperform morning by ${(eAvg-mAvg).toFixed(0)} efficiency points. Amazon shoppers in this account skew toward evening purchase intent.`});
    }
  }

  return lines;
}

/* ── DP Upload Zone ──────────────────────────────────────────── */
function DPUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"12px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:32,height:32,borderRadius:7,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:14,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:1}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:10,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:10,color:R,fontWeight:600,marginTop:2}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"3px 7px",borderRadius:5,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:10}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 11px",borderRadius:6,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:10,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const DP_REPORT_TYPES=[
  {id:"hourly",  label:"Hourly Performance Report",icon:"ti-clock",      required:true, desc:"Campaign data with Hour column — required for time-based analysis"},
  {id:"campaign",label:"Campaign Report",           icon:"ti-speakerphone",required:false,desc:"Overall campaign context to enrich hourly analysis"},
];

/* ── DP Upload Page ──────────────────────────────────────────── */
function DPUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.hourly)return;setLoading(true);setErr(null);
    try{
      const cur=await parseSheet(files.hourly);const comp=compFiles.hourly?await parseSheet(compFiles.hourly):null;
      onComplete({cur,comp,periods:localPeriods});
    }catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:680,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Hourly Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your Amazon hourly performance report. The system requires a report with an "Hour" column — available via Amazon Advertising Console's hourly breakdown.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{DP_REPORT_TYPES.map(t=><DPUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:12}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{DP_REPORT_TYPES.map(t=><DPUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>To get hourly data: In Amazon Advertising Console, create a Campaign report and select "Hour of day" as a dimension. The exported file will contain an "Hour" column (0–23).</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.hourly||loading} style={{...T.btnR(false),opacity:files.hourly&&!loading?1:0.4,fontWeight:700,boxShadow:files.hourly?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-clock" style={{fontSize:14}}/> Run Dayparting Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── DP Alert Card ───────────────────────────────────────────── */
function DPAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#1a50a0",low:"#1a7a3c"};
  const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)",medium:"rgba(26,80,160,0.04)",low:"rgba(26,122,60,0.04)"};
  const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"rgba(26,80,160,0.15)",low:"rgba(26,122,60,0.15)"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity],color:sc[a.severity],fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
            <span style={{fontSize:11,padding:"1px 7px",borderRadius:4,background:"#f0f0f0",color:"#555",fontWeight:600}}>{a.window}</span>
          </div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}><span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/></div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4,fontSize:10}}/>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Efficiency impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Scheduling Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div></div>
      </div>}
    </div>
  );
}

/* ── DP Schedule Recommendation Card ────────────────────────── */
function DPSchedCard({rec}){
  const[open,setOpen]=useState(false);
  const tc={scale:"#1a7a3c",reduce:"#c47a00",pause:"#d42b2b",prime:"#6338c8"};
  const tb={scale:"rgba(26,122,60,0.05)",reduce:"rgba(196,122,0,0.05)",pause:"rgba(212,43,43,0.05)",prime:"rgba(99,56,200,0.05)"};
  const tbr={scale:"rgba(26,122,60,0.18)",reduce:"rgba(196,122,0,0.18)",pause:"rgba(212,43,43,0.18)",prime:"rgba(99,56,200,0.18)"};
  const c=tc[rec.type]||"#555";const bg=tb[rec.type]||"#fafafa";const br=tbr[rec.type]||"#eee";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${rec.icon}`} style={{fontSize:13,color:c}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>{rec.type}</span><span style={{fontSize:12,fontWeight:700,color:"#111"}}>{rec.title}</span></div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{rec.hours}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:`1px solid ${br}`}}>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginTop:10,marginBottom:10}}>{rec.why}</div>
        {rec.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}>{rec.impact}</div>}
        <div style={{padding:"9px 12px",background:bg,borderRadius:8,border:`1px solid ${br}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Scheduling Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{rec.action}</div></div>
      </div>}
    </div>
  );
}

/* ── DP Hourly Table ─────────────────────────────────────────── */
function DPHourlyTable({hourData,compHour}){
  const[sortKey,setSortKey]=useState("hour");const[sortDir,setSortDir]=useState("asc");const[filterCls,setFilterCls]=useState("All");
  const CLS_F=["All","Waste Window","Prime Window","Scale Window","Late Night Waste","CPC Inflation","Efficient","No Activity"];
  const processed=useMemo(()=>hourData.map(h=>{const comp=compHour?compHour.find(c=>c.hour===h.hour)||null:null;const cls=classifyHour(h,comp);return{h,comp,cls};}),[hourData,compHour]);
  const filtered=useMemo(()=>filterCls==="All"?processed:processed.filter(x=>x.cls.cls===filterCls),[processed,filterCls]);
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{if(sortKey==="hour")return sortDir==="asc"?a.h.hour-b.h.hour:b.h.hour-a.h.hour;if(sortKey==="cls")return sortDir==="asc"?a.cls.cls.localeCompare(b.cls.cls):b.cls.cls.localeCompare(a.cls.cls);const va=a.h[sortKey]??0,vb=b.h[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;}),[filtered,sortKey,sortDir]);
  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir(k==="hour"?"asc":"desc");}}
  const clsCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.cls.cls]=(m[x.cls.cls]||0)+1;});return m;},[processed]);
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const DC=({cur,prev,fmt,lb,isPp})=>{const d=prev!=null?cur-prev:null;const good=d===null?null:(lb?d<=0:d>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";return<><div style={{fontSize:12,fontWeight:500,color:"#111",lineHeight:1.4}}>{fmt(cur)}</div>{d!=null&&Math.abs(d)>0.001&&<div style={{fontSize:10,fontWeight:600,color:dc}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}</>;};
  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 16px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {CLS_F.map(f=>{const cnt=f==="All"?processed.length:clsCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterCls===f;return<button key={f} onClick={()=>setFilterCls(f)} style={{padding:"4px 9px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/><span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> hours</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("hour")}>Hour <SI col="hour"/></th>
            <th style={thS} onClick={()=>toggleSort("cls")}>Status <SI col="cls"/></th>
            <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
            <th style={thS} onClick={()=>toggleSort("sales")}>Sales <SI col="sales"/></th>
            <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
            <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
            <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
            <th style={thS} onClick={()=>toggleSort("cpc")}>CPC <SI col="cpc"/></th>
            <th style={thS} onClick={()=>toggleSort("clicks")}>Clicks <SI col="clicks"/></th>
            <th style={thS} onClick={()=>toggleSort("efficiency")}>Efficiency <SI col="efficiency"/></th>
          </tr></thead>
          <tbody>
            {sorted.map(({h,comp,cls},i)=>(
              <tr key={h.hour} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"8px 10px"}}>
                  <div style={{fontWeight:700,color:"#111",fontSize:13}}>{hourLabel(h.hour)}</div>
                  <div style={{fontSize:9,color:"#aaa"}}>{hourBlock(h.hour)}</div>
                </td>
                <td style={{padding:"7px 10px"}}><div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:6,background:cls.bg,border:`1px solid ${cls.color}22`}}><i className={`ti ${cls.icon}`} style={{fontSize:9,color:cls.color}}/><span style={{fontSize:9,fontWeight:700,color:cls.color,whiteSpace:"nowrap"}}>{cls.cls}</span></div></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={h.spend} prev={comp?.spend} fmt={v=>`$${v.toFixed(0)}`} lb={true}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={h.sales} prev={comp?.sales} fmt={v=>`$${v.toFixed(0)}`} lb={false}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={h.acos>0?h.acos:0} prev={comp?.acos>0?comp.acos:null} fmt={v=>v>0?`${v.toFixed(0)}%`:"—"} lb={true} isPp={true}/></td>
                <td style={{padding:"8px 10px",fontWeight:600,color:h.orders===0&&h.spend>0?"#d42b2b":"#111",fontSize:12,verticalAlign:"top"}}><div>{h.orders}</div>{comp!=null&&<div style={{fontSize:10,color:(h.orders-comp.orders)>=0?"#1a9e4a":"#d42b2b",fontWeight:600}}>{h.orders-comp.orders>0?"+":""}{h.orders-comp.orders}</div>}</td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={h.cvr} prev={comp?.cvr} fmt={v=>`${v.toFixed(1)}%`} lb={false} isPp={true}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={h.cpc} prev={comp?.cpc} fmt={v=>`$${v.toFixed(2)}`} lb={true}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={h.clicks} prev={comp?.clicks} fmt={v=>String(Math.round(v))} lb={false}/></td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:5}}>
                    <div style={{height:4,borderRadius:2,width:`${h.efficiency}%`,maxWidth:44,background:h.efficiency>=70?"#1a9e4a":h.efficiency>=45?"#c47a00":"#d42b2b"}}/>
                    <span style={{fontSize:11,fontWeight:700,color:h.efficiency>=70?"#1a7a3c":h.efficiency>=45?"#c47a00":"#d42b2b"}}>{h.efficiency}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── DP Workspace ────────────────────────────────────────────── */
function DPWorkspace({curData,compData,periods,onReupload,onExport}){
  const dm=useMemo(()=>curData?dpDetect(curData.headers):{},[curData]);
  const compDm=useMemo(()=>compData?dpDetect(compData.headers):{},[compData]);
  const hourData=useMemo(()=>curData?dpGroupByHour(curData.rows,dm):[],[curData,dm]);
  const compHour=useMemo(()=>compData?dpGroupByHour(compData.rows,compDm):null,[compData,compDm]);
  const alerts=useMemo(()=>generateDPAlerts(hourData,compHour),[hourData,compHour]);
  const schedule=useMemo(()=>generateDPSchedule(hourData),[hourData]);
  const insights=useMemo(()=>generateDPInsights(hourData,compHour),[hourData,compHour]);
  const[activeTab,setActiveTab]=useState("overview");
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const activeHours=hourData.filter(h=>h.spend>0);
  const totalSpend=activeHours.reduce((s,h)=>s+h.spend,0);
  const totalOrders=activeHours.reduce((s,h)=>s+h.orders,0);
  const wasteHours=activeHours.filter(h=>h.orders===0&&h.clicks>=5).length;
  const bestH=activeHours.length?activeHours.reduce((b,h)=>h.efficiency>b.efficiency?h:b,activeHours[0]):null;
  const TABS=[{key:"overview",label:"Overview",icon:"ti-clock"},{key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},{key:"schedule",label:`Schedule${schedule.length?` (${schedule.length})`:""}`,icon:"ti-calendar-time"},{key:"table",label:"Hourly Table",icon:"ti-table"},{key:"insights",label:"AI Insights",icon:"ti-brain"}];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Dayparting Intelligence</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {bestH&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(26,122,60,0.08)",color:"#1a7a3c",fontWeight:700}}>Best: {hourLabel(bestH.hour)}</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{activeHours.length} active hours · {wasteHours} waste windows</span>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>onExport(hourData,schedule)} style={{...T.btnG(true)}}><i className="ti ti-download" style={{fontSize:12}}/> Export Schedule</button>
          <button onClick={onReupload} style={T.btnG(true)}><i className="ti ti-upload" style={{fontSize:12}}/> Re-upload</button>
        </div>
      </div>

      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>

      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {/* OVERVIEW */}
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:900,margin:"0 auto",padding:"20px 22px"}}>
          {/* Stats row */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
            {[{label:"Active Hours",val:activeHours.length,color:"#555",bg:"#fafafa"},{label:"Waste Windows",val:wasteHours,color:"#d42b2b",bg:"rgba(212,43,43,0.07)"},{label:"Best Hour",val:bestH?hourLabel(bestH.hour):"—",color:"#1a7a3c",bg:"rgba(26,122,60,0.07)"},{label:"Efficiency Avg",val:activeHours.length?`${Math.round(activeHours.reduce((s,h)=>s+h.efficiency,0)/activeHours.length)}/100`:"—",color:"#1a50a0",bg:"rgba(26,80,160,0.07)"}].map(s=>(
              <div key={s.label} style={{padding:"14px",background:s.bg,borderRadius:10,border:`1px solid ${s.color}22`,textAlign:"center"}}>
                <div style={{fontSize:s.val?.toString().length>4?16:22,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div>
                <div style={{fontSize:11,fontWeight:600,color:s.color}}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* 24h visual heatmap */}
          <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:16}}>
            <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:12}}>24-Hour Efficiency Heatmap</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(24,1fr)",gap:3,marginBottom:8}}>
              {hourData.map(h=>{
                const bg=h.spend===0?"#f5f5f5":h.efficiency>=70?"#1a9e4a":h.efficiency>=50?"#c47a00":"#d42b2b";
                const opacity=h.spend===0?0.3:0.2+h.efficiency/100*0.8;
                return<div key={h.hour} title={`${hourLabel(h.hour)}: ${h.efficiency}/100 efficiency`}
                  style={{height:28,borderRadius:4,background:bg,opacity,cursor:"pointer"}} onClick={()=>setActiveTab("table")}/>;
              })}
            </div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:"#bbb"}}>
              <span>12 AM</span><span>6 AM</span><span>12 PM</span><span>6 PM</span><span>11 PM</span>
            </div>
            <div style={{display:"flex",gap:12,marginTop:8,fontSize:10,color:"#888"}}>
              {[{color:"#1a9e4a",label:"Efficient (70+)"},{color:"#c47a00",label:"Moderate (45–70)"},{color:"#d42b2b",label:"Inefficient (<45)"},{color:"#f0f0f0",label:"No Activity"}].map(s=>(
                <div key={s.label} style={{display:"flex",alignItems:"center",gap:5}}><div style={{width:10,height:10,borderRadius:2,background:s.color}}/>{s.label}</div>
              ))}
            </div>
          </div>

          {/* AI insights */}
          {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Dayparting Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
            {insights.map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",neutral:"#555"};const ic={positive:"ti-trending-up",negative:"ti-clock-x",opportunity:"ti-clock",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
          </div>}

          {/* Top alerts preview */}
          {alerts.length>0&&<><div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Top Time-Based Alerts</div>{alerts.slice(0,3).map((a,i)=><DPAlertCard key={i} alert={a}/>)}{alerts.length>3&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),width:"100%",justifyContent:"center",marginTop:4}}>View All {alerts.length} Alerts →</button>}</>}
        </div></div>}

        {activeTab==="alerts"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alerts.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-clock-check" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No time-based alerts</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All hours show acceptable performance patterns.</div></div>:alerts.map((a,i)=><DPAlertCard key={i} alert={a}/>)}</div></div>}

        {activeTab==="schedule"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{schedule.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-calendar-time" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700}}>No scheduling recommendations</div></div>:schedule.map((r,i)=><DPSchedCard key={i} rec={r}/>)}</div></div>}

        {activeTab==="table"&&<DPHourlyTable hourData={hourData} compHour={compHour}/>}

        {activeTab==="insights"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><i className="ti ti-brain" style={{fontSize:14,color:R}}/><div style={{fontSize:14,fontWeight:700,color:"#111"}}>AI Dayparting Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>{insights.length===0?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><div>Upload a comparison period to enable AI trend analysis</div></div>:insights.map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",neutral:"#555"};const tb={positive:"rgba(26,122,60,0.05)",negative:"rgba(212,43,43,0.04)",opportunity:"rgba(26,80,160,0.05)",neutral:"rgba(0,0,0,0.02)"};const ic={positive:"ti-trending-up",negative:"ti-clock-x",opportunity:"ti-clock",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}><div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/></div><div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div></div>;})}</div></div></div>}
      </div>
    </div>
  );
}

/* ── DP Export Page ──────────────────────────────────────────── */
function DPExportPage({hourData,schedule,onBack}){
  function doExport(){
    const wb=XLSX.utils.book_new();
    // Hourly analysis sheet
    const h1Headers=["Hour","Hour Label","Time Block","Spend ($)","Sales ($)","Orders","ACoS (%)","CVR (%)","CPC ($)","Clicks","Impressions","Efficiency Score","Status","Recommended Action"];
    const h1Rows=hourData.filter(h=>h.spend>0).map(h=>{const cls=classifyHour(h,null);return{Hour:h.hour,"Hour Label":hourLabel(h.hour),"Time Block":hourBlock(h.hour),"Spend ($)":h.spend.toFixed(2),"Sales ($)":h.sales.toFixed(2),Orders:h.orders,"ACoS (%)":h.acos>0?h.acos.toFixed(1):"—","CVR (%)":h.cvr.toFixed(1),"CPC ($)":h.cpc.toFixed(2),Clicks:h.clicks,Impressions:h.impressions,"Efficiency Score":h.efficiency,Status:cls.cls,"Recommended Action":cls.action};});
    const ws1=XLSX.utils.json_to_sheet(h1Rows,{header:h1Headers});ws1["!cols"]=h1Headers.map(()=>({wch:16}));
    XLSX.utils.book_append_sheet(wb,ws1,"Hourly Analysis");
    // Schedule recommendations
    if(schedule.length){
      const s2Headers=["Recommendation","Type","Hours","Why","Action","Impact"];
      const s2Rows=schedule.map(s=>({Recommendation:s.title,Type:s.type,Hours:s.hours,Why:s.why,Action:s.action,Impact:s.impact||""}));
      const ws2=XLSX.utils.json_to_sheet(s2Rows,{header:s2Headers});ws2["!cols"]=s2Headers.map(()=>({wch:30}));
      XLSX.utils.book_append_sheet(wb,ws2,"Scheduling Recommendations");
    }
    // Bid modifier sheet (strategist-ready)
    const h3Headers=["Hour","Hour Label","Current Efficiency","Suggested Action","Bid Modifier (%)","Notes"];
    const h3Rows=hourData.map(h=>{const cls=classifyHour(h,null);const mod=cls.action==="scale"?"+25%":cls.action==="reduce_bid"?"-50%":cls.action==="pause"?"Pause":cls.action==="maintain"?"0%":"Monitor";return{Hour:h.hour,"Hour Label":hourLabel(h.hour),"Current Efficiency":h.spend>0?`${h.efficiency}/100`:"No Data","Suggested Action":cls.action,"Bid Modifier (%)":mod,Notes:h.spend>0?cls.cls:"No activity this hour"};});
    const ws3=XLSX.utils.json_to_sheet(h3Rows,{header:h3Headers});ws3["!cols"]=h3Headers.map(()=>({wch:20}));
    XLSX.utils.book_append_sheet(wb,ws3,"Bid Schedule");
    XLSX.writeFile(wb,`Quarred_Dayparting_${new Date().toISOString().slice(0,10)}.xlsx`);
  }

  const activeHours=hourData.filter(h=>h.spend>0);const wasteHours=activeHours.filter(h=>h.orders===0&&h.clicks>=5);
  const primeHours=activeHours.filter(h=>h.efficiency>=70&&h.orders>=1);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:700,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:12}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace</button>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Scheduling Sheets</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Export hourly performance data, bid schedule, and scheduling recommendations as a strategist-ready workbook.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Export Summary</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
            {[{label:"Active Hours",val:activeHours.length,color:"#555"},{label:"Prime Windows",val:primeHours.length,color:"#1a7a3c"},{label:"Waste Windows",val:wasteHours.length,color:"#d42b2b"}].map(s=>(
              <div key={s.label} style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div><div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{fontSize:12,color:"#555",marginBottom:14,lineHeight:1.6}}>Export includes 3 sheets: Hourly Analysis (all 24 hours with metrics), Scheduling Recommendations, and a Bid Schedule with suggested modifiers per hour.</div>
          <button onClick={doExport} style={{...T.btnR(false),width:"100%",justifyContent:"center",fontWeight:700,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
            <i className="ti ti-download" style={{fontSize:14}}/> Download Dayparting Workbook
          </button>
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>How to use the Bid Schedule sheet</div>
          {["Open the 'Bid Schedule' tab in the exported file","Review the Suggested Action and Bid Modifier (%) columns","Apply modifiers in Amazon Advertising via Campaign-level bid rules or dayparting tools","Test changes for 2 weeks before making permanent — monitor ACoS weekly","Repeat this analysis each month as traffic patterns shift seasonally"].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Dayparting Module Root ──────────────────────────────────── */
function DaypartingModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.primary?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(globalData?.cur?.primary||null);const[compData,setCompData]=useState(globalData?.comp?.primary||null);const[exportData,setExportData]=useState(null);
  useEffect(()=>{if(globalData?.cur?.primary&&page==="upload"){setCurData(globalData.cur.primary);setCompData(globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);
  if(page==="export"&&exportData)return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Dayparting — Export</h2></div><DPExportPage hourData={exportData.hourData} schedule={exportData.schedule} onBack={()=>setPage("workspace")}/></div>);
  if(page==="workspace"&&curData)return(<DPWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>{setCurData(null);setPage("upload");}} onExport={(hourData,schedule)=>{setExportData({hourData,schedule});setPage("export");}}/>);
  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Dayparting Intelligence</h2></div><DPUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/></div>);
}

/* ================================================================
   PLACEMENT OPTIMIZER MODULE
   Placement intelligence & modifier optimization system.
   Pages: Upload → Placement Workspace → Export Actions
   Placements: Top of Search (TOS) · Product Pages (PP) · Rest of Search (ROS)
================================================================ */

/* ── Placement column aliases ────────────────────────────────── */
const PO_ALIASES={
  campaign:    ["Campaign Name","Campaign","campaign name"],
  placement:   ["Placement","Placement Type","placement","Placement Name"],
  modifier:    ["Placement Bid Adjustment","Modifier","Bid Adjustment","Placement Adjustment (%)","Placement Modifier","Bid Modifier"],
  impressions: ["Impressions","impressions"],
  clicks:      ["Clicks","clicks"],
  spend:       ["Spend","Cost","Ad Spend"],
  sales:       ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales"],
  orders:      ["Orders","14 Day Total Orders (#)","14 Day Total Orders"],
  acos:        ["ACOS","ACoS"],
  cpc:         ["CPC","Cost Per Click","Average CPC"],
  ctr:         ["Click-through Rate","CTR"],
  cvr:         ["Conversion Rate","CVR"],
  type:        ["Campaign Type","Type","Ad Type"],
  portfolio:   ["Portfolio Name","Portfolio"],
};

const PO_PLACEMENT_TYPES={
  tos: ["Top of Search (Impression Share)","Top of Search","TOS","top of search","Top-of-Search"],
  pp:  ["Detail Page on-Amazon","Product Pages","Product Detail Page","Product Page","PP","product pages","Detail Page"],
  ros: ["Other on-Amazon","Rest of Search","ROS","rest of search","Other","Other on Amazon"],
};

function poDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(PO_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function poNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function detectPlacementType(val){
  const v=String(val||"").toLowerCase();
  for(const[type,cands] of Object.entries(PO_PLACEMENT_TYPES)){
    if(cands.some(c=>v.includes(c.toLowerCase())))return type;
  }
  return"ros"; // default
}

function poRow(row,pm){
  const imp=poNum(row,pm.impressions),clk=poNum(row,pm.clicks),
    spd=poNum(row,pm.spend),sal=poNum(row,pm.sales),ord=poNum(row,pm.orders),
    mod=poNum(row,pm.modifier);
  const ctr=pm.ctr&&poNum(row,pm.ctr)>0?poNum(row,pm.ctr):imp>0?(clk/imp)*100:0;
  const acos=pm.acos&&poNum(row,pm.acos)>0?poNum(row,pm.acos):sal>0?(spd/sal)*100:0;
  const cvr=pm.cvr&&poNum(row,pm.cvr)>0?poNum(row,pm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=clk>0?spd/clk:0;const roas=spd>0?sal/spd:0;
  const placementRaw=String(row[pm.placement]||"");
  const placementType=detectPlacementType(placementRaw);
  return{campaign:String(row[pm.campaign]||""),type:String(row[pm.type]||""),
    portfolio:String(row[pm.portfolio]||""),placementRaw,placementType,
    modifier:mod,impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    ctr,acos,cvr,cpc,roas};
}

/* ── Group by placement type ─────────────────────────────────── */
function poGroupByType(rows,pm){
  const groups={tos:{label:"Top of Search",icon:"ti-arrow-up-circle",color:"#1a50a0",spend:0,sales:0,orders:0,clicks:0,impressions:0,count:0},pp:{label:"Product Pages",icon:"ti-box",color:"#6338c8",spend:0,sales:0,orders:0,clicks:0,impressions:0,count:0},ros:{label:"Rest of Search",icon:"ti-layout-grid",color:"#555",spend:0,sales:0,orders:0,clicks:0,impressions:0,count:0}};
  rows.forEach(r=>{
    const m=poRow(r,pm);const g=groups[m.placementType];
    if(!g)return;
    g.spend+=m.spend;g.sales+=m.sales;g.orders+=m.orders;g.clicks+=m.clicks;g.impressions+=m.impressions;g.count++;
  });
  Object.values(groups).forEach(g=>{
    g.acos=g.sales>0?(g.spend/g.sales)*100:0;
    g.cvr=g.clicks>0?(g.orders/g.clicks)*100:0;
    g.cpc=g.clicks>0?g.spend/g.clicks:0;
    g.ctr=g.impressions>0?(g.clicks/g.impressions)*100:0;
  });
  return groups;
}

/* ── Placement efficiency score ──────────────────────────────── */
function poEfficiency(m){
  let eff=50;
  if(m.spend>0&&m.orders===0)eff=Math.max(5,eff-40);
  if(m.acos>0&&m.acos<20)eff=Math.min(100,eff+35);
  else if(m.acos>0&&m.acos<35)eff=Math.min(100,eff+20);
  else if(m.acos>60)eff=Math.max(5,eff-25);
  if(m.cvr>5)eff=Math.min(100,eff+20);
  else if(m.cvr>2)eff=Math.min(100,eff+10);
  else if(m.cvr<0.5&&m.clicks>5)eff=Math.max(5,eff-15);
  return Math.round(eff);
}

/* ── Modifier recommendation ─────────────────────────────────── */
function poModifierRec(m,comp){
  if(m.spend===0)return{action:"No Data",modifier:null,direction:null,color:"#ccc"};
  if(m.orders===0&&m.clicks>=5)return{action:"Reduce -60%",modifier:-60,direction:"reduce",color:"#d42b2b"};
  if(m.acos>0&&m.acos<20&&m.orders>=2)return{action:"Increase +30%",modifier:30,direction:"increase",color:"#1a7a3c"};
  if(m.acos>0&&m.acos<30&&m.orders>=1&&m.placementType==="tos")return{action:"Increase +20%",modifier:20,direction:"increase",color:"#1a7a3c"};
  if(comp&&comp.cvr>0&&m.cvr<comp.cvr*0.6&&m.spend>5)return{action:"Reduce -30%",modifier:-30,direction:"reduce",color:"#c47a00"};
  if(m.acos>60&&m.spend>10)return{action:"Reduce -40%",modifier:-40,direction:"reduce",color:"#d42b2b"};
  if(m.acos>35&&m.acos<60)return{action:"Reduce -20%",modifier:-20,direction:"reduce",color:"#c47a00"};
  if(m.cvr>4&&m.orders>=2)return{action:"Increase +25%",modifier:25,direction:"increase",color:"#1a7a3c"};
  return{action:"Maintain",modifier:0,direction:"maintain",color:"#555"};
}

/* ── Placement alerts ────────────────────────────────────────── */
function generatePOAlerts(rows,pm,compMap){
  const alerts=[];
  rows.forEach(row=>{
    const m=poRow(row,pm);const comp=compMap?compMap[`${m.campaign}|${m.placementType}`]||null:null;
    if(!m.campaign||m.spend===0)return;
    const pLabel={tos:"Top of Search",pp:"Product Pages",ros:"Rest of Search"}[m.placementType]||m.placementRaw;

    // High spend no conversion
    if(m.spend>15&&m.orders===0&&m.clicks>=5){
      alerts.push({severity:"critical",type:"Placement Spend Waste",icon:"ti-layout-off",color:"#d42b2b",
        campaign:m.campaign,placement:pLabel,
        comparison:comp?`Prev: $${comp.spend.toFixed(0)} spend, ${comp.orders} orders`:`$${m.spend.toFixed(0)} spent, zero conversions`,
        cause:`${pLabel} placement for "${m.campaign}" spent $${m.spend.toFixed(0)} with ${m.clicks} clicks and zero conversions. This placement is generating non-converting traffic.`,
        action:`Reduce ${pLabel} modifier by 50–70%. If zero conversion persists next period, set modifier to 0%.`,
        impact:`Estimated saving: ~$${(m.spend*0.65).toFixed(0)}`,confidence:91});
    }

    // TOS opportunity — good CVR, no TOS modifier
    if(m.placementType==="tos"&&m.cvr>3&&m.orders>=2&&m.acos>0&&m.acos<25&&(m.modifier||0)<20){
      alerts.push({severity:"low",type:"TOS Scaling Opportunity",icon:"ti-arrow-up-circle",color:"#1a7a3c",
        campaign:m.campaign,placement:pLabel,
        comparison:comp?`Prev ACoS: ${comp.acos.toFixed(1)}% → Current: ${m.acos.toFixed(1)}%`:`TOS ACoS: ${m.acos.toFixed(1)}% · CVR: ${m.cvr.toFixed(1)}%`,
        cause:`Top of Search is converting at ${m.cvr.toFixed(1)}% with ${m.acos.toFixed(1)}% ACoS — well within profitable range. Current modifier (${m.modifier||0}%) is leaving profitable TOS traffic uncaptured.`,
        action:"Increase TOS bid modifier to 25–40%. TOS placements also drive organic rank signals.",
        impact:"More TOS impressions at this CVR = more orders + organic rank momentum",confidence:85});
    }

    // CPC inflation
    if(comp&&comp.cpc>0&&m.cpc>comp.cpc*1.35&&m.orders===0&&m.clicks>3){
      const pct=((m.cpc-comp.cpc)/comp.cpc)*100;
      alerts.push({severity:"high",type:"CPC Inflation",icon:"ti-trending-up",color:"#c47a00",
        campaign:m.campaign,placement:pLabel,
        comparison:`CPC: $${comp.cpc.toFixed(2)} → $${m.cpc.toFixed(2)} (+${pct.toFixed(0)}%)`,
        cause:`${pLabel} CPC increased ${pct.toFixed(0)}% vs previous period with no conversion. Placement auction is becoming more competitive without proportional conversion improvement.`,
        action:`Reduce ${pLabel} modifier by 25–30%. Don't compete at inflated CPC without conversion evidence.`,
        impact:`Estimated CPC saving: ~$${((m.cpc-comp.cpc)*m.clicks*0.5).toFixed(0)}`,confidence:78});
    }

    // CVR decline
    if(comp&&comp.cvr>0&&m.cvr<comp.cvr*0.65&&m.clicks>10){
      const pct=((m.cvr-comp.cvr)/comp.cvr)*100;
      alerts.push({severity:"high",type:"CVR Deterioration",icon:"ti-chart-line-down",color:"#c47a00",
        campaign:m.campaign,placement:pLabel,
        comparison:`CVR: ${comp.cvr.toFixed(1)}% → ${m.cvr.toFixed(1)}% (${pct.toFixed(0)}%)`,
        cause:`${pLabel} conversion rate dropped ${Math.abs(pct).toFixed(0)}% vs previous period. Same traffic, significantly fewer purchases — placement quality or competitor listing improvement may be driving this.`,
        action:`Reduce ${pLabel} modifier by 20–30% until CVR recovers. Monitor weekly.`,
        impact:"Reducing exposure at low-CVR placements improves overall efficiency",confidence:80});
    }

    // PP waste — product pages overspend
    if(m.placementType==="pp"&&m.spend>20&&m.acos>80&&m.orders>0){
      alerts.push({severity:"high",type:"Product Page Waste",icon:"ti-box",color:"#c47a00",
        campaign:m.campaign,placement:pLabel,
        comparison:comp?`Prev ACoS: ${comp.acos.toFixed(1)}% → ${m.acos.toFixed(1)}%`:`PP ACoS: ${m.acos.toFixed(1)}%`,
        cause:`Product Pages placement has ${m.acos.toFixed(0)}% ACoS — severely unprofitable. Shoppers on competitor PDPs are often in browsing mode, not purchase mode.`,
        action:"Reduce Product Pages modifier by 40–50%. Consider removing PP targeting unless specifically targeting own ASINs.",
        impact:`At 35% target ACoS: $${((m.spend-m.sales*0.35)).toFixed(0)} recoverable`,confidence:82});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3)).slice(0,20);
}

/* ── Modifier recommendations ────────────────────────────────── */
function generatePOModifierRecs(rows,pm,compMap){
  const recs=[];
  // Group by placement type
  const byType={tos:[],pp:[],ros:[]};
  rows.forEach(r=>{const m=poRow(r,pm);if(m.spend>0&&m.campaign)byType[m.placementType]?.push(m);});

  Object.entries(byType).forEach(([type,items])=>{
    if(!items.length)return;
    const label={tos:"Top of Search",pp:"Product Pages",ros:"Rest of Search"}[type];
    const totalSpend=items.reduce((s,m)=>s+m.spend,0);
    const totalOrders=items.reduce((s,m)=>s+m.orders,0);
    const avgAcos=items.reduce((s,m)=>s+(m.acos||0),0)/items.length;
    const avgCvr=items.reduce((s,m)=>s+(m.cvr||0),0)/items.length;

    if(avgAcos>0&&avgAcos<25&&totalOrders>=3){
      recs.push({icon:"ti-trending-up",color:"#1a7a3c",type:"increase",
        title:`Scale ${label} Modifier`,placement:label,
        why:`${label} across ${items.length} campaign${items.length>1?"s":""} shows avg ACoS ${avgAcos.toFixed(1)}% — highly profitable placement. Increasing modifier will capture more impressions at this efficiency.`,
        movement:`$${totalSpend.toFixed(0)} spend · ${totalOrders} orders · ${avgCvr.toFixed(1)}% CVR`,
        action:`Increase ${label} modifier by 25–35%. Monitor ACoS for 2 weeks — if it holds below 30%, increase further.`,
        impact:"Compounding TOS/PP investment at profitable ACoS = more orders + improved organic signals"});
    }

    if((avgAcos>60||totalOrders===0)&&totalSpend>20){
      const wasteSave=totalSpend*(avgAcos>80?0.5:0.3);
      recs.push({icon:"ti-adjustments",color:"#d42b2b",type:"reduce",
        title:`Reduce ${label} Modifier`,placement:label,
        why:`${label} averaged ${avgAcos>0?`${avgAcos.toFixed(0)}% ACoS`:"zero conversions"} across ${items.length} campaign${items.length>1?"s":""}. This placement is consuming budget without adequate return.`,
        movement:`$${totalSpend.toFixed(0)} total spend · ${totalOrders} orders`,
        action:`Reduce ${label} modifier by ${avgAcos>80?"50–60":"30–40"}%. Reallocate budget to better-performing placements.`,
        impact:`~$${wasteSave.toFixed(0)} recoverable through modifier reduction`});
    }
  });

  // TOS isolation recommendation
  const tosPerformers=rows.map(r=>poRow(r,pm)).filter(m=>m.placementType==="tos"&&m.cvr>4&&m.orders>=3&&m.acos>0&&m.acos<25);
  if(tosPerformers.length>=2){
    recs.push({icon:"ti-crown",color:"#6338c8",type:"isolate",
      title:"Isolate Top TOS Performers",placement:"Top of Search",
      why:`${tosPerformers.length} campaigns show exceptional TOS performance (CVR > 4%, ACoS < 25%). Creating dedicated TOS campaigns for these would allow aggressive scaling without contaminating overall campaign metrics.`,
      movement:`${tosPerformers.length} campaigns eligible for TOS isolation`,
      action:"Extract top-converting keywords from these campaigns into dedicated TOS/ranking campaigns with 50–70% TOS modifier.",
      impact:"Isolated TOS campaigns allow full budget allocation to the highest-value placement"});
  }

  return recs;
}

/* ── AI placement insights ───────────────────────────────────── */
function generatePOInsights(groups,compGroups){
  const lines=[];
  const{tos,pp,ros}=groups;

  // TOS analysis
  if(tos.spend>0){
    if(tos.acos>0&&tos.acos<30&&tos.orders>=2){
      lines.push({type:"positive",icon:"ti-arrow-up-circle",text:`Top of Search is performing well at ${tos.acos.toFixed(1)}% ACoS with ${tos.cvr.toFixed(1)}% CVR. TOS placements also contribute to organic rank signals — scaling this placement compounds both paid and organic performance.`});
    } else if(tos.acos>60||tos.orders===0){
      lines.push({type:"negative",icon:"ti-arrow-up-circle",text:`Top of Search has ${tos.acos>0?`${tos.acos.toFixed(0)}% ACoS`:"zero conversions"} — underperforming. TOS bids may be attracting broad match traffic or competing in oversaturated auctions. Review search terms triggering TOS placements.`});
    }
  }

  // PP vs TOS comparison
  if(pp.spend>0&&tos.spend>0){
    const ppBetter=pp.acos>0&&tos.acos>0&&pp.acos<tos.acos*0.8;
    const tosBetter=tos.acos>0&&pp.acos>0&&tos.acos<pp.acos*0.8;
    if(tosBetter)lines.push({type:"opportunity",icon:"ti-crown",text:`Top of Search (${tos.acos.toFixed(0)}% ACoS) significantly outperforms Product Pages (${pp.acos.toFixed(0)}% ACoS). Reallocating budget from PP to TOS would improve overall account efficiency.`});
    else if(ppBetter)lines.push({type:"opportunity",icon:"ti-box",text:`Product Pages (${pp.acos.toFixed(0)}% ACoS) is outperforming Top of Search (${tos.acos.toFixed(0)}% ACoS) for this account. This is unusual — typically TOS converts better. Check if listings are optimized for browse-mode shoppers.`});
  }

  // Spend concentration
  const total=tos.spend+pp.spend+ros.spend;
  if(total>0){
    const tosShare=(tos.spend/total)*100;const ppShare=(pp.spend/total)*100;
    if(tosShare>60&&tos.acos<35)lines.push({type:"positive",icon:"ti-chart-pie",text:`${tosShare.toFixed(0)}% of placement spend is concentrated in Top of Search — appropriate given TOS efficiency. Maintain this allocation while TOS continues performing below 35% ACoS.`});
    else if(ppShare>50&&pp.acos>50)lines.push({type:"negative",icon:"ti-chart-pie",text:`${ppShare.toFixed(0)}% of placement spend is going to Product Pages at ${pp.acos.toFixed(0)}% ACoS — an inefficient allocation. Reducing PP modifier and shifting budget to TOS would improve overall efficiency.`});
    if(ros.spend>0&&ros.orders===0)lines.push({type:"negative",icon:"ti-layout-grid",text:`Rest of Search generated $${ros.spend.toFixed(0)} in spend with zero conversions. This placement is the weakest performer — consider setting modifier to 0% or removing entirely.`});
  }

  // Comparison trends
  if(compGroups){
    const tosEffDelta=tos.orders>0&&compGroups.tos.orders>0?tos.acos-compGroups.tos.acos:null;
    if(tosEffDelta!=null&&Math.abs(tosEffDelta)>5){
      lines.push({type:tosEffDelta<0?"positive":"negative",icon:tosEffDelta<0?"ti-trending-up":"ti-trending-down",
        text:tosEffDelta<0?`Top of Search ACoS improved ${Math.abs(tosEffDelta).toFixed(1)}pp vs previous period — TOS efficiency is strengthening. This is the right time to increase TOS modifiers.`:`Top of Search ACoS worsened ${tosEffDelta.toFixed(1)}pp vs previous period — review search term quality and match types driving TOS traffic.`});
    }
  }

  return lines;
}

/* ── PO Upload Zone ──────────────────────────────────────────── */
function POUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"12px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:32,height:32,borderRadius:7,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:14,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:1}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:10,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:10,color:R,fontWeight:600,marginTop:2}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"3px 7px",borderRadius:5,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:10}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 11px",borderRadius:6,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:10,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const PO_REPORT_TYPES=[
  {id:"placement",label:"Placement Report",       icon:"ti-layout-2",   required:true, desc:"Amazon Placement Report with TOS, Product Pages, and Rest of Search breakdown"},
  {id:"campaign", label:"Campaign Report",         icon:"ti-speakerphone",required:false,desc:"Overall campaign metrics for context and cross-reference"},
];

/* ── PO Upload Page ──────────────────────────────────────────── */
function POUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.placement)return;setLoading(true);setErr(null);
    try{const cur=await parseSheet(files.placement);const comp=compFiles.placement?await parseSheet(compFiles.placement):null;onComplete({cur,comp,periods:localPeriods});}
    catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:680,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Placement Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your Amazon Placement Report directly. The system auto-detects Top of Search, Product Pages, and Rest of Search columns.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{PO_REPORT_TYPES.map(t=><POUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:12}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{PO_REPORT_TYPES.map(t=><POUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>To get the Placement Report: Amazon Advertising Console → Reports → Create Report → Targeting → select "Placement" as a dimension. This gives TOS, Product Pages, and Rest of Search breakdown per campaign.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.placement||loading} style={{...T.btnR(false),opacity:files.placement&&!loading?1:0.4,fontWeight:700,boxShadow:files.placement?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-layout-2" style={{fontSize:14}}/> Run Placement Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── PO Placement Summary Cards ──────────────────────────────── */
function POPlacementSummary({groups,compGroups}){
  const placements=[
    {key:"tos",label:"Top of Search",icon:"ti-arrow-up-circle",color:"#1a50a0",bg:"rgba(26,80,160,0.07)"},
    {key:"pp", label:"Product Pages", icon:"ti-box",            color:"#6338c8",bg:"rgba(99,56,200,0.07)"},
    {key:"ros",label:"Rest of Search",icon:"ti-layout-grid",    color:"#555",   bg:"rgba(0,0,0,0.04)"},
  ];
  const fmtU=v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`;
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
      {placements.map(({key,label,icon,color,bg})=>{
        const g=groups[key];const cg=compGroups?compGroups[key]:null;
        const acosDelta=cg&&g.acos>0&&cg.acos>0?g.acos-cg.acos:null;
        const salesDelta=cg&&cg.sales>0?((g.sales-cg.sales)/cg.sales)*100:null;
        return(
          <div key={key} style={{padding:"14px 16px",background:"#fff",borderRadius:12,border:"1px solid #eee",borderTop:`3px solid ${color}`}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}>
              <i className={`ti ${icon}`} style={{fontSize:14,color}}/>
              <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{label}</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              {[{label:"Spend",val:fmtU(g.spend),delta:cg?((g.spend-cg.spend)/Math.max(cg.spend,0.01))*100:null,lb:true},
                {label:"Sales",val:fmtU(g.sales),delta:salesDelta,lb:false},
                {label:"ACoS",val:g.acos>0?`${g.acos.toFixed(1)}%`:"—",delta:acosDelta,lb:true,isPp:true},
                {label:"Orders",val:String(Math.round(g.orders)),delta:cg?g.orders-cg.orders:null,lb:false,isAbs:true},
                {label:"CVR",val:g.cvr>0?`${g.cvr.toFixed(1)}%`:"—",delta:cg&&cg.cvr>0?g.cvr-cg.cvr:null,lb:false,isPp:true},
                {label:"CPC",val:g.cpc>0?`$${g.cpc.toFixed(2)}`:"—",delta:cg&&cg.cpc>0?g.cpc-cg.cpc:null,lb:true},
              ].map(d=>{
                const good=d.delta===null?null:(d.lb?d.delta<=0:d.delta>=0);
                const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";
                const sign=v=>v>0?"+":"";
                return(
                  <div key={d.label}>
                    <div style={{fontSize:9,color:"#aaa",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:2}}>{d.label}</div>
                    <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{d.val}</div>
                    {d.delta!=null&&Math.abs(d.delta)>0.01&&<div style={{fontSize:10,fontWeight:600,color:dc}}>
                      {d.isAbs?`${sign(d.delta)}${Math.abs(Math.round(d.delta))}`:d.isPp?`${sign(d.delta)}${Math.abs(d.delta).toFixed(1)}pp`:`${sign(d.delta)}${Math.abs(d.delta).toFixed(0)}%`}
                    </div>}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

/* ── PO Alert Card ───────────────────────────────────────────── */
function POAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#555",low:"#1a7a3c"};
  const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)",low:"rgba(26,122,60,0.04)"};
  const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"#eee",low:"rgba(26,122,60,0.18)"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity]||"#f0f0f0",color:sc[a.severity]||"#555",fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:11,padding:"1px 7px",borderRadius:4,background:"#f0f0f0",color:"#555",fontWeight:600}}>{a.placement}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
          </div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.campaign}</div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}><span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/></div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}><i className="ti ti-arrows-exchange" style={{marginRight:4,fontSize:10}}/>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Efficiency impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Modifier Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div></div>
      </div>}
    </div>
  );
}

/* ── PO Modifier Rec Card ────────────────────────────────────── */
function POModCard({rec}){
  const[open,setOpen]=useState(false);
  const tc={increase:"#1a7a3c",reduce:"#d42b2b",isolate:"#6338c8"};const tb={increase:"rgba(26,122,60,0.05)",reduce:"rgba(212,43,43,0.05)",isolate:"rgba(99,56,200,0.05)"};const tbr={increase:"rgba(26,122,60,0.18)",reduce:"rgba(212,43,43,0.18)",isolate:"rgba(99,56,200,0.18)"};
  const c=tc[rec.type]||"#555";const bg=tb[rec.type]||"#fafafa";const br=tbr[rec.type]||"#eee";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${rec.icon}`} style={{fontSize:13,color:c}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>{rec.type}</span><span style={{fontSize:11,padding:"1px 6px",borderRadius:4,background:"#f0f0f0",color:"#555",fontWeight:600}}>{rec.placement}</span><span style={{fontSize:12,fontWeight:700,color:"#111"}}>{rec.title}</span></div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{rec.movement}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:`1px solid ${br}`}}>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginTop:10,marginBottom:10}}>{rec.why}</div>
        {rec.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}>{rec.impact}</div>}
        <div style={{padding:"9px 12px",background:bg,borderRadius:8,border:`1px solid ${br}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Modifier Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{rec.action}</div></div>
      </div>}
    </div>
  );
}

/* ── PO Campaign Table ───────────────────────────────────────── */
function POCampaignTable({rows,pm,compMap}){
  const[search,setSearch]=useState("");const[sortKey,setSortKey]=useState("eff");const[sortDir,setSortDir]=useState("desc");const[filterType,setFilterType]=useState("All");
  const TYPE_F=["All","tos","pp","ros"];const TYPE_LABELS={tos:"Top of Search",pp:"Product Pages",ros:"Rest of Search"};
  const processed=useMemo(()=>rows.map((r,i)=>{const m=poRow(r,pm);const comp=compMap?compMap[`${m.campaign}|${m.placementType}`]||null:null;const eff=poEfficiency(m);const modRec=poModifierRec(m,comp);return{r,m,comp,eff,modRec,id:i};}).filter(x=>x.m.campaign&&x.m.spend>0),[rows,pm,compMap]);
  const filtered=useMemo(()=>{let d=processed;if(search){const q=search.toLowerCase();d=d.filter(x=>x.m.campaign.toLowerCase().includes(q));}if(filterType!=="All")d=d.filter(x=>x.m.placementType===filterType);return d;},[processed,search,filterType]);
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{if(sortKey==="camp")return sortDir==="asc"?a.m.campaign.localeCompare(b.m.campaign):b.m.campaign.localeCompare(a.m.campaign);if(sortKey==="eff")return sortDir==="asc"?a.eff-b.eff:b.eff-a.eff;const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;}),[filtered,sortKey,sortDir]);
  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir("desc");}}
  const typeCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.m.placementType]=(m[x.m.placementType]||0)+1;});return m;},[processed]);
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const DC=({cur,prev,fmt,lb,isPp})=>{const d=prev!=null?cur-prev:null;const good=d===null?null:(lb?d<=0:d>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";return<><div style={{fontSize:12,fontWeight:500,color:"#111",lineHeight:1.4}}>{fmt(cur)}</div>{d!=null&&Math.abs(d)>0.01&&<div style={{fontSize:10,fontWeight:600,color:dc}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}</>;};
  const ptColors={tos:"#1a50a0",pp:"#6338c8",ros:"#555"};
  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 16px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:160}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search campaign…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5}}>
          {TYPE_F.map(f=>{const cnt=f==="All"?processed.length:typeCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterType===f;return<button key={f} onClick={()=>setFilterType(f)} style={{padding:"4px 10px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f==="All"?"All":TYPE_LABELS[f]}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/><span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> rows</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("camp")}>Campaign <SI col="camp"/></th>
            <th style={{...thS,cursor:"default"}}>Placement</th>
            <th style={thS} onClick={()=>toggleSort("spend")}>Spend <SI col="spend"/></th>
            <th style={thS} onClick={()=>toggleSort("sales")}>Sales <SI col="sales"/></th>
            <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
            <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
            <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
            <th style={thS} onClick={()=>toggleSort("cpc")}>CPC <SI col="cpc"/></th>
            <th style={thS} onClick={()=>toggleSort("modifier")}>Modifier <SI col="modifier"/></th>
            <th style={thS} onClick={()=>toggleSort("eff")}>Efficiency <SI col="eff"/></th>
            <th style={{...thS,cursor:"default"}}>Action</th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,eff,modRec,id},i)=>(
              <tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"8px 10px",maxWidth:200}} title={m.campaign}><div style={{fontWeight:600,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.campaign}</div></td>
                <td style={{padding:"7px 10px"}}><span style={{fontSize:10,padding:"2px 7px",borderRadius:5,background:`${ptColors[m.placementType]}11`,color:ptColors[m.placementType]||"#555",fontWeight:700}}>{TYPE_LABELS[m.placementType]||m.placementRaw}</span></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.spend} prev={comp?.spend} fmt={v=>`$${v.toFixed(0)}`} lb={true}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.sales} prev={comp?.sales} fmt={v=>`$${v.toFixed(0)}`} lb={false}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.acos>0?m.acos:0} prev={comp?.acos>0?comp.acos:null} fmt={v=>v>0?`${v.toFixed(1)}%`:"—"} lb={true} isPp={true}/></td>
                <td style={{padding:"8px 10px",fontWeight:600,color:m.orders===0&&m.spend>0?"#d42b2b":"#111",fontSize:12,verticalAlign:"top"}}><div>{m.orders}</div>{comp!=null&&<div style={{fontSize:10,color:(m.orders-comp.orders)>=0?"#1a9e4a":"#d42b2b",fontWeight:600}}>{m.orders-comp.orders>0?"+":""}{m.orders-comp.orders}</div>}</td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cvr} prev={comp?.cvr} fmt={v=>`${v.toFixed(1)}%`} lb={false} isPp={true}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.cpc} prev={comp?.cpc} fmt={v=>`$${v.toFixed(2)}`} lb={true}/></td>
                <td style={{padding:"8px 10px"}}>{m.modifier!==0?<span style={{fontSize:12,fontWeight:600,color:"#111"}}>{m.modifier>0?"+":""}{m.modifier}%</span>:<span style={{fontSize:11,color:"#aaa"}}>—</span>}</td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:5}}><div style={{height:4,borderRadius:2,width:`${eff}%`,maxWidth:40,background:eff>=70?"#1a9e4a":eff>=45?"#c47a00":"#d42b2b"}}/><span style={{fontSize:11,fontWeight:700,color:eff>=70?"#1a7a3c":eff>=45?"#c47a00":"#d42b2b"}}>{eff}</span></div>
                </td>
                <td style={{padding:"7px 10px"}}><span style={{fontSize:10,padding:"2px 7px",borderRadius:5,background:`${modRec.color}11`,color:modRec.color,fontWeight:700,whiteSpace:"nowrap"}}>{modRec.action}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No placement rows match</div></div>}
      </div>
    </div>
  );
}

/* ── PO Workspace ────────────────────────────────────────────── */
function POWorkspace({curData,compData,periods,onReupload,onExport}){
  const pm=useMemo(()=>curData?poDetect(curData.headers):{},[curData]);
  const compPm=useMemo(()=>compData?poDetect(compData.headers):{},[compData]);
  const groups=useMemo(()=>curData?poGroupByType(curData.rows,pm):{tos:{spend:0,sales:0,orders:0,clicks:0,impressions:0,acos:0,cvr:0,cpc:0,ctr:0},pp:{spend:0,sales:0,orders:0,clicks:0,impressions:0,acos:0,cvr:0,cpc:0,ctr:0},ros:{spend:0,sales:0,orders:0,clicks:0,impressions:0,acos:0,cvr:0,cpc:0,ctr:0}},[curData,pm]);
  const compGroups=useMemo(()=>compData?poGroupByType(compData.rows,compPm):null,[compData,compPm]);
  const compMap=useMemo(()=>{if(!compData)return null;const m={};compData.rows.forEach(r=>{const row=poRow(r,compPm);m[`${row.campaign}|${row.placementType}`]=row;});return m;},[compData,compPm]);
  const alerts=useMemo(()=>curData?generatePOAlerts(curData.rows,pm,compMap):[],[curData,pm,compMap]);
  const modRecs=useMemo(()=>curData?generatePOModifierRecs(curData.rows,pm,compMap):[],[curData,pm,compMap]);
  const insights=useMemo(()=>generatePOInsights(groups,compGroups),[groups,compGroups]);
  const[activeTab,setActiveTab]=useState("overview");
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const TABS=[{key:"overview",label:"Overview",icon:"ti-layout-2"},{key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},{key:"modifiers",label:`Modifiers${modRecs.length?` (${modRecs.length})`:""}`,icon:"ti-adjustments"},{key:"table",label:"Campaign Table",icon:"ti-table"},{key:"insights",label:"AI Insights",icon:"ti-brain"}];
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Placement Optimizer</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{curData?.rows?.length||0} placement rows</span>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>onExport(curData,pm,groups,alerts,modRecs)} style={T.btnG(true)}><i className="ti ti-download" style={{fontSize:12}}/> Export Actions</button>
          <button onClick={onReupload} style={T.btnG(true)}><i className="ti ti-upload" style={{fontSize:12}}/> Re-upload</button>
        </div>
      </div>
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:950,margin:"0 auto",padding:"20px 22px"}}>
          <ModuleOverview
            moduleName="Placement Optimizer" moduleIcon="ti-layout-2" periods={periods}
            cur={{spend:groups.tos.spend+groups.pp.spend+groups.ros.spend,sales:groups.tos.sales+groups.pp.sales+groups.ros.sales,orders:Math.round(groups.tos.orders+groups.pp.orders+groups.ros.orders),clicks:groups.tos.clicks+groups.pp.clicks+groups.ros.clicks,cvr:(groups.tos.clicks+groups.pp.clicks+groups.ros.clicks)>0?((groups.tos.orders+groups.pp.orders+groups.ros.orders)/(groups.tos.clicks+groups.pp.clicks+groups.ros.clicks))*100:0,acos:(groups.tos.sales+groups.pp.sales+groups.ros.sales)>0?((groups.tos.spend+groups.pp.spend+groups.ros.spend)/(groups.tos.sales+groups.pp.sales+groups.ros.sales))*100:0,cpc:(groups.tos.clicks+groups.pp.clicks+groups.ros.clicks)>0?(groups.tos.spend+groups.pp.spend+groups.ros.spend)/(groups.tos.clicks+groups.pp.clicks+groups.ros.clicks):0,roas:(groups.tos.spend+groups.pp.spend+groups.ros.spend)>0?(groups.tos.sales+groups.pp.sales+groups.ros.sales)/(groups.tos.spend+groups.pp.spend+groups.ros.spend):0}}
            comp={compGroups?{spend:compGroups.tos.spend+compGroups.pp.spend+compGroups.ros.spend,sales:compGroups.tos.sales+compGroups.pp.sales+compGroups.ros.sales,orders:Math.round(compGroups.tos.orders+compGroups.pp.orders+compGroups.ros.orders),clicks:compGroups.tos.clicks+compGroups.pp.clicks+compGroups.ros.clicks,cvr:(compGroups.tos.clicks+compGroups.pp.clicks+compGroups.ros.clicks)>0?((compGroups.tos.orders+compGroups.pp.orders+compGroups.ros.orders)/(compGroups.tos.clicks+compGroups.pp.clicks+compGroups.ros.clicks))*100:0,acos:(compGroups.tos.sales+compGroups.pp.sales+compGroups.ros.sales)>0?((compGroups.tos.spend+compGroups.pp.spend+compGroups.ros.spend)/(compGroups.tos.sales+compGroups.pp.sales+compGroups.ros.sales))*100:0}:null}
            rows={curData?.rows||[]} alerts={alerts.slice(0,3).map(a=>({type:a.severity==="critical"?"critical":"loss",icon:"ti-layout-2",title:a.title,detail:a.explanation||""}))}
          />
          <div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10,marginTop:12}}>Placement Breakdown</div>
          <POPlacementSummary groups={groups} compGroups={compGroups}/>
          {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Placement Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
            {insights.map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",neutral:"#555"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-arrow-up-circle",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
          </div>}
          {alerts.length>0&&<><div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Top Placement Alerts</div>{alerts.slice(0,3).map((a,i)=><POAlertCard key={i} alert={a}/>)}{alerts.length>3&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),width:"100%",justifyContent:"center",marginTop:4}}>View All {alerts.length} Alerts →</button>}</>}
        </div></div>}
        {activeTab==="alerts"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alerts.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-circle-check" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No placement alerts</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All placements are within acceptable performance thresholds.</div></div>:alerts.map((a,i)=><POAlertCard key={i} alert={a}/>)}</div></div>}
        {activeTab==="modifiers"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{modRecs.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-adjustments" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700}}>No modifier recommendations</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All placements have acceptable modifier settings.</div></div>:modRecs.map((r,i)=><POModCard key={i} rec={r}/>)}</div></div>}
        {activeTab==="table"&&<POCampaignTable rows={curData?.rows||[]} pm={pm} compMap={compMap}/>}
        {activeTab==="insights"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><i className="ti ti-brain" style={{fontSize:14,color:R}}/><div style={{fontSize:14,fontWeight:700,color:"#111"}}>Placement Intelligence Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>{insights.length===0?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><div>Upload a comparison period to enable trend analysis</div></div>:insights.map((ins,i)=>{const tc={positive:"#1a7a3c",negative:"#d42b2b",opportunity:"#1a50a0",neutral:"#555"};const tb={positive:"rgba(26,122,60,0.05)",negative:"rgba(212,43,43,0.04)",opportunity:"rgba(26,80,160,0.05)",neutral:"rgba(0,0,0,0.02)"};const ic={positive:"ti-trending-up",negative:"ti-trending-down",opportunity:"ti-arrow-up-circle",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}><div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/></div><div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div></div>;})}</div></div></div>}
      </div>
    </div>
  );
}

/* ── PO Export Page ──────────────────────────────────────────── */
function POExportPage({curData,pm,groups,alerts,modRecs,onBack}){
  function doExport(){
    const wb=XLSX.utils.book_new();

    /* ── Sheet 1: Amazon Bulk Upload — Bidding Adjustments ────────────
       Entity = "Bidding Adjustment" for placement modifiers
       Placement values Amazon accepts exactly:
         "Top of Search (Organic)"
         "Detail Page (ASIN)"
         "Other on-Amazon"
       Percentage = whole number 0-900 (no % sign)
    ──────────────────────────────────────────────────────────────── */
    const placementNameMap={tos:"Top of Search (Organic)",pp:"Detail Page (ASIN)",ros:"Other on-Amazon"};
    const bulkRows=[];
    if(curData&&pm){
      const seen=new Set();
      curData.rows.forEach(r=>{
        const m=poRow(r,pm);
        if(!m.campaign||seen.has(m.campaign+"_"+m.placementType))return;
        seen.add(m.campaign+"_"+m.placementType);
        const rec=poModifierRec(m,null);
        if(rec.modifier==null||rec.modifier===0)return; // no change needed
        const amznPlacement=placementNameMap[m.placementType];
        if(!amznPlacement)return;
        const newPct=Math.max(0,Math.min(900,Math.round((m.modifier||0)+rec.modifier)));
        bulkRows.push(amznPlacementRow({
          campaign:m.campaign,
          placement:amznPlacement,
          percentage:newPct,
          state:"enabled",
        }));
      });
    }
    if(bulkRows.length){
      const ws1=XLSX.utils.json_to_sheet(bulkRows,{header:AMZN_SP_COLS});
      ws1["!cols"]=AMZN_SP_COLS.map(h=>({wch:["Campaign Name","Placement"].includes(h)?30:14}));
      XLSX.utils.book_append_sheet(wb,ws1,"Sponsored Products Campaigns");
    }

    /* ── Sheet 2: Placement Performance Summary ──────────────────── */
    function fmtG(g){return{"Spend ($)":g.spend.toFixed(2),"Sales ($)":g.sales.toFixed(2),Orders:Math.round(g.orders),"ACoS (%)":g.acos>0?g.acos.toFixed(1):"—","CVR (%)":g.cvr.toFixed(1),"CPC ($)":g.cpc.toFixed(2),"CTR (%)":g.ctr.toFixed(2),Efficiency:poEfficiency(g)};}
    const sumRows=[{Placement:"Top of Search (Organic)",...fmtG(groups.tos)},{Placement:"Detail Page (ASIN)",...fmtG(groups.pp)},{Placement:"Other on-Amazon",...fmtG(groups.ros)}];
    const sumH=["Placement","Spend ($)","Sales ($)","Orders","ACoS (%)","CVR (%)","CPC ($)","CTR (%)","Efficiency"];
    const ws2=XLSX.utils.json_to_sheet(sumRows,{header:sumH});ws2["!cols"]=sumH.map(()=>({wch:20}));
    XLSX.utils.book_append_sheet(wb,ws2,"Placement Summary");

    /* ── Sheet 3: Modifier Recommendations (strategy review) ─────── */
    if(modRecs.length){
      const recRows=modRecs.map(r=>({
        "Campaign":r.campaign||"","Placement":r.placement,"Recommendation":r.title,
        "Current Modifier (%)":r.currentModifier!=null?r.currentModifier:"—",
        "Suggested Modifier (%)":r.modifier!=null?r.modifier:"Maintain",
        "Action":r.action,"Why":r.why,"Expected Impact":r.impact||""
      }));
      const recH=["Campaign","Placement","Recommendation","Current Modifier (%)","Suggested Modifier (%)","Action","Why","Expected Impact"];
      const ws3=XLSX.utils.json_to_sheet(recRows,{header:recH});ws3["!cols"]=recH.map(()=>({wch:22}));
      XLSX.utils.book_append_sheet(wb,ws3,"Modifier Actions — Review");
    }

    if(wb.SheetNames.length===0){alert("No placement changes to export.");return;}
    XLSX.writeFile(wb,`Amazon_Placement_Modifiers_${new Date().toISOString().slice(0,10)}.xlsx`);
  }
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:700,margin:"0 auto",padding:"32px 24px"}}>
        <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:16}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace</button>
        <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Placement Actions</h2>
        <p style={{fontSize:13,color:"#666",margin:"0 0 22px"}}>Export placement performance analysis and modifier recommendations as a strategist-ready workbook.</p>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Export Summary</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
            {[{label:"Alerts",val:alerts.length,color:"#c47a00"},{label:"Critical",val:critCount,color:"#d42b2b"},{label:"Modifier Recs",val:modRecs.length,color:"#1a50a0"}].map(s=>(
              <div key={s.label} style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div><div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{fontSize:12,color:"#555",marginBottom:14,lineHeight:1.6}}>Export includes 3 sheets: Placement Summary (TOS/PP/ROS aggregated), Placement Detail (per-campaign rows with modifier recommendations), and Modifier Recommendations (strategic adjustment guide).</div>
          <button onClick={doExport} style={{...T.btnR(false),width:"100%",justifyContent:"center",fontWeight:700,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
            <i className="ti ti-download" style={{fontSize:14}}/> Download Placement Workbook
          </button>
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>How to apply placement modifiers in Amazon</div>
          {["Open Campaign Manager → select a campaign → click 'Placement'","Scroll to 'Adjust bids by placement' section","Set modifier % for TOS, Product Pages, and Rest of Search","Changes take effect within 24 hours","Re-analyze placement data after 7–14 days to assess impact"].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Placement Optimizer Module Root ─────────────────────────── */
function PlacementOptimizerModule({globalData,setTab}){
  const _pod=globalData?.cur?.placement||globalData?.cur?.campaign||globalData?.cur?.primary;
  const _podc=globalData?.comp?.placement||globalData?.comp?.campaign||globalData?.comp?.primary;
  const[page,setPage]=useState(_pod?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(_pod||null);const[compData,setCompData]=useState(_podc||null);const[exportArgs,setExportArgs]=useState(null);
  useEffect(()=>{const d=globalData?.cur?.placement||globalData?.cur?.campaign||globalData?.cur?.primary;if(d&&page==="upload"){setCurData(d);setCompData(globalData?.comp?.placement||globalData?.comp?.campaign||globalData?.comp?.primary||null);setPeriods(globalData?.periods||null);setPage("workspace");}},[globalData]);
  if(page==="export"&&exportArgs)return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Placement Optimizer — Export</h2></div><POExportPage {...exportArgs} onBack={()=>setPage("workspace")}/></div>);
  if(page==="workspace"&&curData)return(<POWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>{setCurData(null);setPage("upload");}} onExport={(curData,pm,groups,alerts,modRecs)=>{setExportArgs({curData,pm,groups,alerts,modRecs});setPage("export");}}/>);
  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Placement Optimizer</h2></div><POUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/></div>);
}

/* ================================================================
   INVENTORY & PPC INTELLIGENCE MODULE
   Inventory-aware PPC decision system.
   Pages: Upload → Inventory Workspace → Export Actions
================================================================ */

/* ── Column aliases ──────────────────────────────────────────── */
const INV_ALIASES={
  sku:         ["SKU","sku","Seller SKU","MSKU","merchant sku","Seller-SKU"],
  asin:        ["ASIN","asin","Product ASIN"],
  title:       ["Product Name","Title","Product Title","Item Name","Description"],
  units:       ["Available","Available Inventory","Quantity Available","Units Available","Total Quantity","Inventory","Fulfillable Quantity","afn-fulfillable-quantity","Total Units"],
  daysSupply:  ["Days of Supply","Days Supply","Days Remaining","Estimated Days","day-of-supply"],
  velocity:    ["Units Sold","Daily Sales Rate","Sales Velocity","Units Ordered","14 Day Units","7 Day Units"],
  spend:       ["Spend","Ad Spend","Cost","PPC Spend"],
  sales:       ["Sales","PPC Sales","Ad Sales","14 Day Total Sales"],
  orders:      ["Orders","14 Day Total Orders","PPC Orders"],
  totalSales:  ["Total Sales","Total Revenue","Ordered Product Sales","Revenue"],
  acos:        ["ACOS","ACoS"],
  campaign:    ["Campaign Name","Campaign"],
  inboundUnits:["Inbound","Inbound Quantity","Reserved Inbound","Inbound Working"],
  reserved:    ["Reserved","Reserved Quantity","Total Reserved"],
};

function invDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(INV_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function invNum(row,col){
  if(!col||row[col]==null||row[col]==="")return null;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?null:v;
}

function invRow(row,im){
  const units=invNum(row,im.units)??0;
  const days=invNum(row,im.daysSupply);
  const vel=invNum(row,im.velocity)??0;
  const spend=invNum(row,im.spend)??0;
  const sales=invNum(row,im.sales)??0;
  const orders=invNum(row,im.orders)??0;
  const totalSales=invNum(row,im.totalSales)??sales;
  const acos=im.acos&&invNum(row,im.acos)!=null?invNum(row,im.acos):sales>0?(spend/sales)*100:0;
  // Calculate days remaining if not in report
  const calcDays=vel>0?units/vel:units>0?999:0;
  const daysRemaining=days!=null?days:calcDays;
  // Sell-through rate
  const sellThrough=vel>0&&units>0?(vel/(units+vel))*100:0;
  // Tacos
  const tacos=totalSales>0?(spend/totalSales)*100:0;
  return{
    sku:String(row[im.sku]||row[im.asin]||"").trim(),
    asin:String(row[im.asin]||"").trim(),
    title:String(row[im.title]||""),
    units,daysRemaining,velocity:vel,spend,sales,orders,totalSales,acos,tacos,
    sellThrough,inbound:invNum(row,im.inboundUnits)??0,
  };
}

/* ── Risk scoring ────────────────────────────────────────────── */
function invRiskScore(m){
  // 0 = safest, 100 = most critical
  if(m.units===0)return 100;
  if(m.daysRemaining<7)return 95;
  if(m.daysRemaining<14)return 80;
  if(m.daysRemaining<21)return 60;
  if(m.daysRemaining<30)return 40;
  if(m.units>500&&m.velocity<1)return 30; // overstock risk
  return 10;
}

function invRiskLabel(score){
  if(score>=90)return{label:"Stockout",color:"#d42b2b",bg:"rgba(212,43,43,0.09)",icon:"ti-alert-triangle"};
  if(score>=70)return{label:"Critical Risk",color:"#d42b2b",bg:"rgba(212,43,43,0.07)",icon:"ti-alert-circle"};
  if(score>=50)return{label:"High Risk",color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-hourglass"};
  if(score>=30)return{label:"Moderate",color:"#c47a00",bg:"rgba(196,122,0,0.06)",icon:"ti-clock"};
  if(score>=20)return{label:"Overstock",color:"#6338c8",bg:"rgba(99,56,200,0.07)",icon:"ti-package"};
  return{label:"Healthy",color:"#1a7a3c",bg:"rgba(26,122,60,0.07)",icon:"ti-circle-check"};
}

/* ── PPC alignment recommendation ───────────────────────────── */
function invPPCRec(m){
  if(m.units===0||m.daysRemaining<5)
    return{action:"Pause PPC",modifier:"Pause",color:"#d42b2b",reason:"No inventory available — PPC spend is pure waste."};
  if(m.daysRemaining<10&&m.spend>10)
    return{action:"Reduce 70%",modifier:"-70%",color:"#d42b2b",reason:"Stockout imminent — cut spend to preserve remaining stock for organic orders."};
  if(m.daysRemaining<21&&m.spend>5)
    return{action:"Reduce 40%",modifier:"-40%",color:"#c47a00",reason:"Low stock risk — reduce PPC pressure to extend runway while restocking."};
  if(m.daysRemaining>=30&&m.acos>0&&m.acos<30&&m.units>100)
    return{action:"Scale +30%",modifier:"+30%",color:"#1a7a3c",reason:"Healthy inventory + profitable ACoS — safe to increase PPC spend."};
  if(m.daysRemaining>=60&&m.velocity<1&&m.units>200)
    return{action:"Liquidate",modifier:"+50% + coupon",color:"#6338c8",reason:"Overstock detected — aggressive PPC + promotions to accelerate sell-through."};
  if(m.daysRemaining>=30&&m.acos>0&&m.acos<40)
    return{action:"Maintain",modifier:"0%",color:"#555",reason:"Inventory adequate. Maintain current PPC spend level."};
  return{action:"Monitor",modifier:"Watch",color:"#888",reason:"Insufficient data. Continue monitoring inventory and PPC trends."};
}

/* ── Inventory alerts ────────────────────────────────────────── */
function generateINVAlerts(rows,im,compMap){
  const alerts=[];
  rows.forEach(row=>{
    const m=invRow(row,im);
    const comp=compMap?compMap[m.sku.toLowerCase()]||null:null;
    if(!m.sku)return;

    // Stockout imminent
    if(m.units===0||(m.daysRemaining>0&&m.daysRemaining<7)){
      alerts.push({severity:"critical",type:"Stockout Imminent",icon:"ti-alert-triangle",color:"#d42b2b",
        sku:m.sku,title:m.title,
        comparison:comp?`Prev: ${Math.round(comp.units||0)} units → Now: ${Math.round(m.units)} units`:`${Math.round(m.units)} units · ~${m.daysRemaining.toFixed(0)} days remaining`,
        cause:m.units===0?`This product has zero available inventory. Any active PPC campaigns are generating spend with no purchasable stock.`:`Only ${Math.round(m.units)} units remain with ~${m.daysRemaining.toFixed(0)} days supply at current velocity. Stockout is imminent.`,
        action:"Pause or reduce PPC spend by 80–100% immediately. Prioritize restocking. Keep only branded campaigns active if needed.",
        impact:"Every dollar spent on PPC with zero/near-zero inventory is pure waste",confidence:98});
    }

    // PPC overspending on low stock
    if(m.daysRemaining>=7&&m.daysRemaining<21&&m.spend>15){
      alerts.push({severity:"high",type:"PPC Overspend on Low Stock",icon:"ti-coin-off",color:"#c47a00",
        sku:m.sku,title:m.title,
        comparison:`${m.daysRemaining.toFixed(0)} days supply · $${m.spend.toFixed(0)} PPC spend`,
        cause:`This product has only ${m.daysRemaining.toFixed(0)} days of inventory remaining but is spending $${m.spend.toFixed(0)} on PPC. Aggressive advertising on low stock risks selling out before a restock arrives.`,
        action:"Reduce PPC bids by 40–60%. Pause broad match and auto campaigns. Keep only exact match converting terms active.",
        impact:`Reducing spend extends inventory runway by ~${Math.round(m.spend/(Math.max(m.velocity,0.1)*m.acos/100||1))} days`,confidence:88});
    }

    // Inventory velocity decline
    if(comp&&comp.velocity>0&&m.velocity<comp.velocity*0.6&&m.units>50){
      const pct=((m.velocity-comp.velocity)/comp.velocity)*100;
      alerts.push({severity:"high",type:"Velocity Declining",icon:"ti-trending-down",color:"#c47a00",
        sku:m.sku,title:m.title,
        comparison:`Velocity: ${comp.velocity.toFixed(1)} → ${m.velocity.toFixed(1)} units/day (${pct.toFixed(0)}%)`,
        cause:`Sales velocity dropped ${Math.abs(pct).toFixed(0)}% vs previous period. Slower sell-through means inventory lasts longer but also indicates weakening demand or competition. PPC efficiency may be declining.`,
        action:"Review PPC campaigns for this product. Check if ACoS is rising. Consider promotional activity to re-accelerate velocity.",
        impact:"Declining velocity can indicate listing or pricing issues that PPC cannot solve alone",confidence:80});
    }

    // Overstock — aggressive liquidation opportunity
    if(m.daysRemaining>90&&m.velocity<0.5&&m.units>200){
      alerts.push({severity:"medium",type:"Overstock — Liquidate",icon:"ti-package",color:"#6338c8",
        sku:m.sku,title:m.title,
        comparison:`${Math.round(m.units)} units · ${m.daysRemaining>900?"900+ days":m.daysRemaining.toFixed(0)+" days"} supply · ${m.velocity.toFixed(1)} units/day velocity`,
        cause:`Product has excess inventory at current sell-through rate. Holding costs are accumulating and the product may age out. Aggressive PPC + promotional activity could accelerate liquidation.`,
        action:"Increase PPC spend 30–50% + apply 10–15% coupon. Consider running Lightning Deal or Prime Exclusive Discount to spike velocity.",
        impact:"Reducing excess stock improves cash flow and prevents long-term storage fees",confidence:75});
    }

    // Safe scaling opportunity
    if(m.daysRemaining>=45&&m.acos>0&&m.acos<25&&m.spend>0&&m.units>150){
      alerts.push({severity:"low",type:"Safe Scaling Window",icon:"ti-rocket",color:"#1a7a3c",
        sku:m.sku,title:m.title,
        comparison:`${Math.round(m.units)} units · ${m.daysRemaining.toFixed(0)} days supply · ACoS ${m.acos.toFixed(1)}%`,
        cause:`Healthy inventory (${m.daysRemaining.toFixed(0)} days supply) combined with profitable ACoS (${m.acos.toFixed(1)}%). This product is in the ideal position for PPC scaling.`,
        action:"Increase PPC budget by 25–40%. Expand to phrase match. Consider launching a dedicated ranking campaign.",
        impact:"Safe to scale — inventory runway supports increased traffic velocity",confidence:85});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3)).slice(0,20);
}

/* ── PPC alignment recommendations ──────────────────────────── */
function generateINVAlignments(rows,im){
  const processed=rows.map(r=>invRow(r,im)).filter(m=>m.sku&&(m.units>0||m.spend>0));
  const groups={pause:[],reduce:[],scale:[],liquidate:[],maintain:[]};
  processed.forEach(m=>{
    const rec=invPPCRec(m);
    if(rec.action.includes("Pause"))groups.pause.push(m);
    else if(rec.action.includes("Reduce"))groups.reduce.push(m);
    else if(rec.action.includes("Scale"))groups.scale.push(m);
    else if(rec.action.includes("Liquidate"))groups.liquidate.push(m);
    else groups.maintain.push(m);
  });
  const recs=[];
  if(groups.pause.length){const ws=groups.pause.reduce((s,m)=>s+m.spend,0);recs.push({icon:"ti-player-pause",color:"#d42b2b",type:"pause",title:"Pause PPC on Stockout SKUs",count:groups.pause.length,why:`${groups.pause.length} SKU${groups.pause.length>1?"s have":"has"} zero or near-zero inventory. Active PPC on these products generates spend with no purchasable stock.`,action:"Pause all broad match and auto campaigns immediately. Consider pausing exact match unless branded.",impact:`~$${ws.toFixed(0)}/period recoverable by pausing PPC on stocked-out products`});}
  if(groups.reduce.length){const ws=groups.reduce.reduce((s,m)=>s+m.spend*0.5,0);recs.push({icon:"ti-adjustments",color:"#c47a00",type:"reduce",title:"Reduce PPC on Low-Stock SKUs",count:groups.reduce.length,why:`${groups.reduce.length} SKU${groups.reduce.length>1?"s have":"has"} less than 21 days of inventory. Aggressive PPC accelerates stockout risk.`,action:"Reduce bids by 40–60%. Pause broad/auto match. Keep only exact match converting terms.",impact:`Extends inventory runway while maintaining core traffic coverage`});}
  if(groups.scale.length)recs.push({icon:"ti-rocket",color:"#1a7a3c",type:"scale",title:"Scale PPC on Well-Stocked SKUs",count:groups.scale.length,why:`${groups.scale.length} SKU${groups.scale.length>1?"s have":"has"} 30+ days supply with profitable PPC performance. These are safe to scale.`,action:"Increase daily budgets 25–35%. Expand match types. Add TOS bid modifiers.",impact:"Inventory supports growth — scale while conditions are favorable"});
  if(groups.liquidate.length)recs.push({icon:"ti-package",color:"#6338c8",type:"liquidate",title:"Liquidate Overstocked SKUs",count:groups.liquidate.length,why:`${groups.liquidate.length} SKU${groups.liquidate.length>1?"s have":"has"} 90+ days supply with weak velocity. Holding costs are accumulating.`,action:"Increase PPC 40–50% + apply coupons or Lightning Deals to spike sell-through rate.",impact:"Reduces holding costs and frees capital for better-performing SKUs"});
  return recs;
}

/* ── AI inventory insights ───────────────────────────────────── */
function generateINVInsights(rows,im,compMap){
  const lines=[];
  const processed=rows.map(r=>invRow(r,im)).filter(m=>m.sku);
  if(!processed.length)return lines;
  const stockouts=processed.filter(m=>m.units===0||(m.daysRemaining>0&&m.daysRemaining<7));
  const lowStock=processed.filter(m=>m.daysRemaining>=7&&m.daysRemaining<21);
  const healthy=processed.filter(m=>m.daysRemaining>=30&&m.acos>0&&m.acos<35&&m.spend>0);
  const overstock=processed.filter(m=>m.daysRemaining>90&&m.velocity<0.5);
  const totalSpend=processed.reduce((s,m)=>s+m.spend,0);
  const wasteSpend=stockouts.reduce((s,m)=>s+m.spend,0)+lowStock.reduce((s,m)=>s+m.spend*0.5,0);

  if(stockouts.length)lines.push({type:"critical",icon:"ti-alert-triangle",text:`${stockouts.length} SKU${stockouts.length>1?"s are":"is"} stocked out or have less than 7 days of supply remaining. PPC spend on these products is being wasted — ads may still show but purchases cannot be fulfilled or inventory will run out before replenishment arrives.`});
  if(wasteSpend>0&&totalSpend>0)lines.push({type:"negative",icon:"ti-coin-off",text:`An estimated $${wasteSpend.toFixed(0)} in PPC spend (${((wasteSpend/totalSpend)*100).toFixed(0)}% of total) is allocated to low-stock or stocked-out products. Pausing/reducing these campaigns protects remaining inventory and recovers budget for healthy SKUs.`});
  if(healthy.length)lines.push({type:"positive",icon:"ti-rocket",text:`${healthy.length} SKU${healthy.length>1?"s have":"has"} healthy inventory (30+ days supply) with profitable PPC performance (ACoS <35%). These are the safest products to scale — inventory supports increased traffic velocity.`});
  if(overstock.length)lines.push({type:"opportunity",icon:"ti-package",text:`${overstock.length} SKU${overstock.length>1?"s show":"shows"} excess inventory (90+ days supply) with weak sell-through velocity. Consider aggressive PPC + promotional tactics (coupons, Lightning Deals) to accelerate liquidation and recover capital.`});
  if(compMap){
    const velocityDeclines=processed.filter(m=>{const comp=compMap[m.sku.toLowerCase()];return comp&&comp.velocity>0&&m.velocity<comp.velocity*0.7;});
    if(velocityDeclines.length)lines.push({type:"negative",icon:"ti-trending-down",text:`${velocityDeclines.length} SKU${velocityDeclines.length>1?"s show":"shows"} declining sales velocity vs previous period. Slower sell-through can indicate listing issues, pricing pressure, or reduced PPC effectiveness. Review these products before any scaling decisions.`});
  }
  return lines;
}

/* ── INV Upload Zone ─────────────────────────────────────────── */
function INVUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"12px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:32,height:32,borderRadius:7,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:14,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:1}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:10,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:10,color:R,fontWeight:600,marginTop:2}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"3px 7px",borderRadius:5,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:10}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 11px",borderRadius:6,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:10,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const INV_REPORT_TYPES=[
  {id:"inventory",label:"Inventory Report",        icon:"ti-package",     required:true, desc:"FBA inventory report with units, days of supply, and SKU/ASIN data"},
  {id:"campaign", label:"Campaign / PPC Report",   icon:"ti-speakerphone",required:false,desc:"PPC spend and performance per SKU/ASIN for cross-referencing"},
  {id:"business", label:"Business Report",         icon:"ti-chart-bar",   required:false,desc:"Total sales data for TACOS calculation and velocity analysis"},
];

/* ── INV Upload Page ─────────────────────────────────────────── */
function INVUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.inventory)return;setLoading(true);setErr(null);
    try{
      const cur=await parseSheet(files.inventory);
      const comp=compFiles.inventory?await parseSheet(compFiles.inventory):null;
      onComplete({cur,comp,periods:localPeriods});
    }catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:680,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Inventory Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your Amazon inventory and PPC reports. The system auto-detects stock levels, days of supply, and aligns PPC recommendations with inventory reality.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{INV_REPORT_TYPES.map(t=><INVUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:12}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{INV_REPORT_TYPES.map(t=><INVUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>Get Inventory Report: Seller Central → Reports → Fulfillment → Amazon Fulfilled Inventory → Daily Inventory History. For days of supply, use the FBA Inventory report which includes "Days of Supply" column.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.inventory||loading} style={{...T.btnR(false),opacity:files.inventory&&!loading?1:0.4,fontWeight:700,boxShadow:files.inventory?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-package" style={{fontSize:14}}/> Run Inventory Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── INV Alert Card ──────────────────────────────────────────── */
function INVAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#6338c8",low:"#1a7a3c"};
  const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)",medium:"rgba(99,56,200,0.04)",low:"rgba(26,122,60,0.04)"};
  const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"rgba(99,56,200,0.18)",low:"rgba(26,122,60,0.18)"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity],color:sc[a.severity],fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
          </div>
          <div style={{display:"flex",gap:8,fontSize:11,color:"#555",flexWrap:"wrap"}}>
            <span style={{fontWeight:600}}>{a.sku}</span>
            {a.title&&<span style={{color:"#888",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:200}}>{a.title}</span>}
          </div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}><span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/></div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Inventory impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>PPC Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div></div>
      </div>}
    </div>
  );
}

/* ── INV Alignment Card ──────────────────────────────────────── */
function INVAlignCard({rec}){
  const[open,setOpen]=useState(false);
  const tc={pause:"#d42b2b",reduce:"#c47a00",scale:"#1a7a3c",liquidate:"#6338c8"};
  const tb={pause:"rgba(212,43,43,0.05)",reduce:"rgba(196,122,0,0.05)",scale:"rgba(26,122,60,0.05)",liquidate:"rgba(99,56,200,0.05)"};
  const tbr={pause:"rgba(212,43,43,0.18)",reduce:"rgba(196,122,0,0.18)",scale:"rgba(26,122,60,0.18)",liquidate:"rgba(99,56,200,0.18)"};
  const c=tc[rec.type]||"#555";const bg=tb[rec.type]||"#fafafa";const br=tbr[rec.type]||"#eee";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${rec.icon}`} style={{fontSize:13,color:c}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>{rec.type}</span><span style={{fontSize:12,fontWeight:700,color:"#111"}}>{rec.title}</span><span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:"#f0f0f0",color:"#888",marginLeft:4}}>{rec.count} SKU{rec.count!==1?"s":""}</span></div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{rec.why}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:`1px solid ${br}`}}>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginTop:10,marginBottom:10}}>{rec.why}</div>
        {rec.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}>{rec.impact}</div>}
        <div style={{padding:"9px 12px",background:bg,borderRadius:8,border:`1px solid ${br}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>PPC Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{rec.action}</div></div>
      </div>}
    </div>
  );
}

/* ── INV Inventory Table ─────────────────────────────────────── */
function INVTable({rows,im,compMap}){
  const[search,setSearch]=useState("");const[sortKey,setSortKey]=useState("risk");const[sortDir,setSortDir]=useState("desc");const[filterRisk,setFilterRisk]=useState("All");
  const RISK_F=["All","Stockout","Critical Risk","High Risk","Moderate","Overstock","Healthy"];
  const processed=useMemo(()=>rows.map((r,i)=>{const m=invRow(r,im);const comp=compMap?compMap[m.sku.toLowerCase()]||null:null;const risk=invRiskScore(m);const rl=invRiskLabel(risk);const rec=invPPCRec(m);return{r,m,comp,risk,rl,rec,id:i};}).filter(x=>x.m.sku),[rows,im,compMap]);
  const filtered=useMemo(()=>{let d=processed;if(search){const q=search.toLowerCase();d=d.filter(x=>x.m.sku.toLowerCase().includes(q)||x.m.title.toLowerCase().includes(q));}if(filterRisk!=="All")d=d.filter(x=>x.rl.label===filterRisk);return d;},[processed,search,filterRisk]);
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{if(sortKey==="risk")return sortDir==="asc"?a.risk-b.risk:b.risk-a.risk;if(sortKey==="sku")return sortDir==="asc"?a.m.sku.localeCompare(b.m.sku):b.m.sku.localeCompare(a.m.sku);const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;}),[filtered,sortKey,sortDir]);
  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir("desc");}}
  const riskCounts=useMemo(()=>{const m={};processed.forEach(x=>{m[x.rl.label]=(m[x.rl.label]||0)+1;});return m;},[processed]);
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 16px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:160}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search SKU or product…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {RISK_F.map(f=>{const cnt=f==="All"?processed.length:riskCounts[f]||0;if(f!=="All"&&!cnt)return null;const act=filterRisk===f;return<button key={f} onClick={()=>setFilterRisk(f)} style={{padding:"4px 9px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}{cnt>0&&` (${cnt})`}</button>;})}
        </div>
        <div style={{flex:1}}/><span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> SKUs</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("risk")}>Risk <SI col="risk"/></th>
            <th style={thS} onClick={()=>toggleSort("sku")}>SKU / ASIN <SI col="sku"/></th>
            <th style={thS} onClick={()=>toggleSort("units")}>Units <SI col="units"/></th>
            <th style={thS} onClick={()=>toggleSort("daysRemaining")}>Days Left <SI col="daysRemaining"/></th>
            <th style={thS} onClick={()=>toggleSort("velocity")}>Velocity <SI col="velocity"/></th>
            <th style={thS} onClick={()=>toggleSort("spend")}>PPC Spend <SI col="spend"/></th>
            <th style={thS} onClick={()=>toggleSort("sales")}>PPC Sales <SI col="sales"/></th>
            <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
            <th style={thS} onClick={()=>toggleSort("tacos")}>TACOS <SI col="tacos"/></th>
            <th style={{...thS,cursor:"default"}}>PPC Action</th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,risk,rl,rec,id},i)=>(
              <tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"7px 10px"}}>
                  <div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:6,background:rl.bg,border:`1px solid ${rl.color}22`}}>
                    <i className={`ti ${rl.icon}`} style={{fontSize:9,color:rl.color}}/>
                    <span style={{fontSize:9,fontWeight:700,color:rl.color,whiteSpace:"nowrap"}}>{rl.label}</span>
                  </div>
                </td>
                <td style={{padding:"8px 10px",maxWidth:160}}>
                  <div style={{fontWeight:700,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.sku}</div>
                  {m.asin&&m.asin!==m.sku&&<div style={{fontSize:9,color:"#aaa"}}>{m.asin}</div>}
                  {m.title&&<div style={{fontSize:10,color:"#888",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={m.title}>{m.title}</div>}
                </td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{fontSize:13,fontWeight:700,color:m.units<20?"#d42b2b":m.units<50?"#c47a00":"#111"}}>{Math.round(m.units)}</div>
                  {comp&&<div style={{fontSize:10,color:(m.units-comp.units)>=0?"#1a9e4a":"#d42b2b",fontWeight:600}}>{m.units-comp.units>0?"+":""}{Math.round(m.units-comp.units)}</div>}
                  {m.inbound>0&&<div style={{fontSize:9,color:"#aaa"}}>+{Math.round(m.inbound)} inbound</div>}
                </td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{fontSize:13,fontWeight:700,color:m.daysRemaining<7?"#d42b2b":m.daysRemaining<21?"#c47a00":"#1a7a3c"}}>{m.daysRemaining>900?"900+":Math.round(m.daysRemaining)}<span style={{fontSize:10,fontWeight:400,color:"#aaa"}}> days</span></div>
                </td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{fontSize:12,color:"#111"}}>{m.velocity.toFixed(1)}<span style={{fontSize:9,color:"#aaa"}}>/day</span></div>
                  {comp&&comp.velocity>0&&<div style={{fontSize:10,fontWeight:600,color:(m.velocity-comp.velocity)>=0?"#1a9e4a":"#d42b2b"}}>{m.velocity-comp.velocity>0?"+":""}{(m.velocity-comp.velocity).toFixed(1)}</div>}
                </td>
                <td style={{padding:"8px 10px"}}><div style={{fontSize:12,color:m.spend>0&&m.units<20?"#d42b2b":"#111",fontWeight:m.spend>0&&m.units<20?700:500}}>${m.spend.toFixed(0)}</div></td>
                <td style={{padding:"8px 10px"}}><div style={{fontSize:12,color:"#111"}}>${m.sales.toFixed(0)}</div></td>
                <td style={{padding:"8px 10px"}}><div style={{fontSize:12,color:m.acos>50?"#d42b2b":m.acos>30?"#c47a00":"#111",fontWeight:500}}>{m.acos>0?`${m.acos.toFixed(0)}%`:"—"}</div></td>
                <td style={{padding:"8px 10px"}}><div style={{fontSize:12,color:"#555"}}>{m.tacos>0?`${m.tacos.toFixed(0)}%`:"—"}</div></td>
                <td style={{padding:"7px 10px"}}><span style={{fontSize:10,padding:"2px 7px",borderRadius:5,background:`${rec.color}11`,color:rec.color,fontWeight:700,whiteSpace:"nowrap"}}>{rec.action}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No SKUs match</div></div>}
      </div>
    </div>
  );
}

/* ── INV Workspace ───────────────────────────────────────────── */
function INVWorkspace({curData,compData,periods,onReupload,onExport}){
  const im=useMemo(()=>curData?invDetect(curData.headers):{},[curData]);
  const compIm=useMemo(()=>compData?invDetect(compData.headers):{},[compData]);
  const compMap=useMemo(()=>{if(!compData)return null;const m={};compData.rows.forEach(r=>{const row=invRow(r,compIm);if(row.sku)m[row.sku.toLowerCase()]=row;});return m;},[compData,compIm]);
  const alerts=useMemo(()=>curData?generateINVAlerts(curData.rows,im,compMap):[],[curData,im,compMap]);
  const alignments=useMemo(()=>curData?generateINVAlignments(curData.rows,im):[],[curData,im]);
  const insights=useMemo(()=>curData?generateINVInsights(curData.rows,im,compMap):[],[curData,im,compMap]);
  const[activeTab,setActiveTab]=useState("overview");
  const processed=useMemo(()=>curData?curData.rows.map(r=>invRow(r,im)).filter(m=>m.sku):[],[curData,im]);
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const stockouts=processed.filter(m=>m.units===0||m.daysRemaining<7).length;
  const healthy=processed.filter(m=>m.daysRemaining>=30).length;
  const wasteSpend=processed.filter(m=>m.units===0||m.daysRemaining<7).reduce((s,m)=>s+m.spend,0);
  const TABS=[{key:"overview",label:"Overview",icon:"ti-package"},{key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},{key:"alignment",label:`PPC Alignment${alignments.length?` (${alignments.length})`:""}`,icon:"ti-adjustments"},{key:"table",label:"Inventory Table",icon:"ti-table"},{key:"insights",label:"AI Insights",icon:"ti-brain"}];
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Inventory & PPC Intelligence</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {wasteSpend>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(196,122,0,0.08)",color:"#c47a00",fontWeight:700}}>${wasteSpend.toFixed(0)} at risk</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{processed.length} SKUs analyzed</span>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>onExport(processed,alerts,alignments)} style={T.btnG(true)}><i className="ti ti-download" style={{fontSize:12}}/> Export Actions</button>
          <button onClick={onReupload} style={T.btnG(true)}><i className="ti ti-upload" style={{fontSize:12}}/> Re-upload</button>
        </div>
      </div>
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:900,margin:"0 auto",padding:"20px 22px"}}>
          <ModuleOverview
            moduleName="Inventory & PPC Intel" moduleIcon="ti-package" periods={periods}
            cur={{spend:processed.reduce((s,m)=>s+m.spend,0),sales:processed.reduce((s,m)=>s+m.sales,0),orders:processed.reduce((s,m)=>s+m.orders,0),acos:processed.reduce((s,m)=>s+m.sales,0)>0?(processed.reduce((s,m)=>s+m.spend,0)/processed.reduce((s,m)=>s+m.sales,0))*100:0}}
            comp={null} rows={curData?.rows||[]}
            extraKpis={[{label:"Stockout Risk",value:stockouts,fmt:"int",icon:"ti-alert-triangle",color:"#d42b2b"},{label:"Healthy Stock",value:healthy,fmt:"int",icon:"ti-package",color:"#1a7a3c"},{label:"Spend at Risk",value:wasteSpend,fmt:"dollar",icon:"ti-coin-off",color:"#c47a00",invert:true}]}
            alerts={alerts.slice(0,3).map(a=>({type:a.severity==="critical"?"critical":"loss",icon:"ti-package",title:a.title,detail:a.explanation||""}))}
          />
          {/* Status grid */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
            {[{label:"Total SKUs",val:processed.length,color:"#555",bg:"#fafafa"},{label:"Stockout Risk",val:stockouts,color:"#d42b2b",bg:"rgba(212,43,43,0.07)"},{label:"Healthy Stock",val:healthy,color:"#1a7a3c",bg:"rgba(26,122,60,0.07)"},{label:"Spend at Risk",val:`$${wasteSpend.toFixed(0)}`,color:"#c47a00",bg:"rgba(196,122,0,0.07)"}].map(s=>(
              <div key={s.label} style={{padding:"14px",background:s.bg,borderRadius:10,border:`1px solid ${s.color}22`,textAlign:"center"}}>
                <div style={{fontSize:s.val?.toString().length>5?16:22,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div>
                <div style={{fontSize:11,fontWeight:600,color:s.color}}>{s.label}</div>
              </div>
            ))}
          </div>
          {/* AI insights */}
          {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Inventory Intelligence Summary</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
            {insights.map((ins,i)=>{const tc={critical:"#d42b2b",negative:"#d42b2b",positive:"#1a7a3c",opportunity:"#1a50a0",neutral:"#555"};const ic={critical:"ti-alert-triangle",negative:"ti-coin-off",positive:"ti-rocket",opportunity:"ti-package",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
          </div>}
          {alerts.length>0&&<><div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Priority Inventory Alerts</div>{alerts.slice(0,4).map((a,i)=><INVAlertCard key={i} alert={a}/>)}{alerts.length>4&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),width:"100%",justifyContent:"center",marginTop:4}}>View All {alerts.length} Alerts →</button>}</>}
        </div></div>}
        {activeTab==="alerts"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alerts.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-circle-check" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No inventory alerts</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All SKUs have healthy inventory levels.</div></div>:alerts.map((a,i)=><INVAlertCard key={i} alert={a}/>)}</div></div>}
        {activeTab==="alignment"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alignments.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-adjustments" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700}}>No PPC adjustments needed</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All inventory levels are aligned with current PPC spend.</div></div>:alignments.map((r,i)=><INVAlignCard key={i} rec={r}/>)}</div></div>}
        {activeTab==="table"&&<INVTable rows={curData?.rows||[]} im={im} compMap={compMap}/>}
        {activeTab==="insights"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><i className="ti ti-brain" style={{fontSize:14,color:R}}/><div style={{fontSize:14,fontWeight:700,color:"#111"}}>Inventory Intelligence Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>{insights.length===0?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><div>Upload a comparison period to enable AI trend analysis</div></div>:insights.map((ins,i)=>{const tc={critical:"#d42b2b",negative:"#d42b2b",positive:"#1a7a3c",opportunity:"#1a50a0",neutral:"#555"};const tb={critical:"rgba(212,43,43,0.05)",negative:"rgba(212,43,43,0.04)",positive:"rgba(26,122,60,0.05)",opportunity:"rgba(26,80,160,0.05)",neutral:"rgba(0,0,0,0.02)"};const ic={critical:"ti-alert-triangle",negative:"ti-coin-off",positive:"ti-rocket",opportunity:"ti-package",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}><div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/></div><div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div></div>;})}</div></div></div>}
      </div>
    </div>
  );
}

/* ── INV Export Page ─────────────────────────────────────────── */
function INVExportPage({processed,alerts,alignments,onBack}){
  function doExport(){
    const wb=XLSX.utils.book_new();
    // SKU Action sheet
    const h1=["SKU","ASIN","Units Available","Days Remaining","Velocity (units/day)","PPC Spend","ACoS (%)","Risk Level","PPC Action","Modifier","Reason"];
    const r1=processed.map(m=>{const risk=invRiskScore(m);const rl=invRiskLabel(risk);const rec=invPPCRec(m);return{SKU:m.sku,ASIN:m.asin,"Units Available":Math.round(m.units),"Days Remaining":m.daysRemaining>900?"900+":Math.round(m.daysRemaining),"Velocity (units/day)":m.velocity.toFixed(1),"PPC Spend":`$${m.spend.toFixed(0)}`,"ACoS (%)":m.acos>0?`${m.acos.toFixed(1)}%`:"—","Risk Level":rl.label,"PPC Action":rec.action,"Modifier":rec.modifier,"Reason":rec.reason};});
    const ws1=XLSX.utils.json_to_sheet(r1,{header:h1});ws1["!cols"]=h1.map(()=>({wch:20}));
    XLSX.utils.book_append_sheet(wb,ws1,"SKU Actions");
    // Critical alerts
    if(alerts.length){
      const h2=["SKU","Alert Type","Severity","Comparison","Cause","Action","Impact","Confidence"];
      const r2=alerts.map(a=>({SKU:a.sku,"Alert Type":a.type,Severity:a.severity,Comparison:a.comparison,Cause:a.cause,Action:a.action,Impact:a.impact||""  ,Confidence:`${a.confidence}%`}));
      const ws2=XLSX.utils.json_to_sheet(r2,{header:h2});ws2["!cols"]=h2.map(()=>({wch:24}));
      XLSX.utils.book_append_sheet(wb,ws2,"Inventory Alerts");
    }
    // PPC alignment recs
    if(alignments.length){
      const h3=["Type","Title","SKU Count","Why","Action","Impact"];
      const r3=alignments.map(r=>({Type:r.type,Title:r.title,"SKU Count":r.count,Why:r.why,Action:r.action,Impact:r.impact||""}));
      const ws3=XLSX.utils.json_to_sheet(r3,{header:h3});ws3["!cols"]=h3.map(()=>({wch:28}));
      XLSX.utils.book_append_sheet(wb,ws3,"PPC Alignment");
    }
    XLSX.writeFile(wb,`Quarred_Inventory_PPC_${new Date().toISOString().slice(0,10)}.xlsx`);
  }
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const stockoutSkus=processed.filter(m=>m.units===0||m.daysRemaining<7);
  const scaleSkus=processed.filter(m=>m.daysRemaining>=30&&m.acos>0&&m.acos<30);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:700,margin:"0 auto",padding:"32px 24px"}}>
        <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:16}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace</button>
        <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Inventory Actions</h2>
        <p style={{fontSize:13,color:"#666",margin:"0 0 22px"}}>Export inventory-aligned PPC recommendations as a strategist-ready workbook.</p>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Export Summary</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
            {[{label:"Total SKUs",val:processed.length,color:"#555"},{label:"At Stockout Risk",val:stockoutSkus.length,color:"#d42b2b"},{label:"Safe to Scale",val:scaleSkus.length,color:"#1a7a3c"},{label:"Alerts",val:alerts.length,color:"#c47a00"}].map(s=>(
              <div key={s.label} style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div><div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{fontSize:12,color:"#555",marginBottom:14,lineHeight:1.6}}>Export includes 3 sheets: SKU Actions (per-SKU PPC recommendations), Inventory Alerts, and PPC Alignment (strategic adjustment guide).</div>
          <button onClick={doExport} style={{...T.btnR(false),width:"100%",justifyContent:"center",fontWeight:700,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
            <i className="ti ti-download" style={{fontSize:14}}/> Download Inventory Actions Workbook
          </button>
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>Key rules for inventory-aware PPC</div>
          {["Never run full-speed PPC on a product with less than 14 days of inventory","Pause broad match and auto campaigns first — they drive the most uncontrolled traffic","Keep exact match campaigns active even during low stock for brand/keyword protection","When inventory recovers to 45+ days, resume scaling incrementally","Check inventory levels weekly — conditions change faster than monthly reviews"].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Inventory PPC Module Root ───────────────────────────────── */
function InventoryPPCModule({globalData,setTab}){
  const[page,setPage]=useState(globalData?.cur?.primary?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(globalData?.cur?.primary||null);const[compData,setCompData]=useState(globalData?.comp?.primary||null);const[exportArgs,setExportArgs]=useState(null);
  useEffect(()=>{if(globalData?.cur?.primary&&page==="upload"){setCurData(globalData.cur.primary);setCompData(globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);
  if(page==="export"&&exportArgs)return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Inventory & PPC — Export</h2></div><INVExportPage {...exportArgs} onBack={()=>setPage("workspace")}/></div>);
  if(page==="workspace"&&curData)return(<INVWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>{setCurData(null);setPage("upload");}} onExport={(processed,alerts,alignments)=>{setExportArgs({processed,alerts,alignments});setPage("export");}}/>);
  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Inventory & PPC Intelligence</h2></div><INVUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/></div>);
}

/* ================================================================
   CREATIVE & LISTING CONVERSION INTELLIGENCE MODULE
   Conversion-focused listing intelligence for Amazon PPC.
   Pages: Upload → Conversion Workspace → Export Actions
================================================================ */

/* ── Column aliases ──────────────────────────────────────────── */
const LC_ALIASES={
  sku:         ["SKU","sku","Seller SKU","MSKU","(Child) ASIN","Child ASIN"],
  asin:        ["ASIN","asin","Parent ASIN","(Parent) ASIN"],
  title:       ["Title","Product Name","Product Title","Item Name","(Title)"],
  sessions:    ["Sessions","sessions","Total Sessions","Browser Sessions","Glance Views"],
  sessionsPct: ["Session Percentage","Sessions Percentage","Session %","Unit Session Percentage"],
  pageViews:   ["Page Views","pageviews","Browser Page Views","Total Page Views"],
  pageViewsPct:["Page Views Percentage","Page View %","Page Views %"],
  unitsSold:   ["Units Ordered","Units Sold","units ordered","Total Units Ordered","14 Day Total Units"],
  ordersPlaced:["Orders Placed","Total Orders","orders placed","Total Order Items"],
  cvr:         ["Order Item Session Percentage","Unit Session Percentage","Conversion Rate","CVR","Order Session %"],
  buyBoxPct:   ["Buy Box Percentage","Buy Box %","Featured Offer %","buybox","Featured Offer Percentage"],
  totalSales:  ["Ordered Product Sales","Total Sales","Total Revenue","Product Sales"],
  spend:       ["Spend","Ad Spend","Cost","PPC Spend"],
  ppcSales:    ["PPC Sales","Ad Sales","14 Day Total Sales","Attributed Sales"],
  ppcOrders:   ["PPC Orders","Ad Orders","14 Day Total Orders"],
  cpc:         ["CPC","Cost Per Click","Average CPC"],
  ctr:         ["CTR","Click-through Rate","Click-Through Rate"],
  acos:        ["ACOS","ACoS","Advertising Cost of Sales"],
};

function lcDetect(headers){
  const r={};
  for(const[k,cands] of Object.entries(LC_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function lcNum(row,col){
  if(!col||row[col]==null||row[col]==="")return null;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?null:v;
}

function lcRow(row,lm){
  const sessions=lcNum(row,lm.sessions)??0;
  const units=lcNum(row,lm.unitsSold)??0;
  const orders=lcNum(row,lm.ordersPlaced)??units;
  const totalSales=lcNum(row,lm.totalSales)??0;
  const spend=lcNum(row,lm.spend)??0;
  const ppcSales=lcNum(row,lm.ppcSales)??0;
  const ppcOrders=lcNum(row,lm.ppcOrders)??0;
  const pageViews=lcNum(row,lm.pageViews)??sessions;
  // CVR — use reported or calculate
  const cvrRaw=lcNum(row,lm.cvr);
  const cvr=cvrRaw!=null?cvrRaw:(sessions>0?(units/sessions)*100:0);
  const buyBox=lcNum(row,lm.buyBoxPct)??0;
  const cpc=lcNum(row,lm.cpc)??0;
  const ctr=lcNum(row,lm.ctr)??0;
  const acos=lcNum(row,lm.acos)??(ppcSales>0?(spend/ppcSales)*100:0);
  const organicSales=Math.max(0,totalSales-ppcSales);
  const organicOrders=Math.max(0,orders-ppcOrders);
  // Traffic efficiency: how well is traffic converting
  const trafficEff=cvr>=10?95:cvr>=7?85:cvr>=4?70:cvr>=2?50:cvr>=0.5?30:10;
  // Listing quality score
  let listingScore=50;
  if(cvr>=5)listingScore+=25;else if(cvr>=2)listingScore+=10;else if(cvr<0.5)listingScore-=20;
  if(buyBox>=90)listingScore+=15;else if(buyBox<50)listingScore-=15;
  if(ctr>0.5)listingScore+=10;
  const ppcCvrContr=spend>0&&ppcSales>0?ppcSales/totalSales:0;
  return{
    sku:String(row[lm.sku]||row[lm.asin]||"").trim(),
    asin:String(row[lm.asin]||"").trim(),
    title:String(row[lm.title]||""),
    sessions,pageViews,units,orders,cvr,buyBox,
    totalSales,spend,ppcSales,ppcOrders,organicSales,organicOrders,
    cpc,ctr,acos,ppcCvrContr,
    trafficEff:Math.min(100,Math.max(0,Math.round(trafficEff))),
    listingScore:Math.min(100,Math.max(0,Math.round(listingScore))),
  };
}

/* ── Conversion quality label ────────────────────────────────── */
function lcQualityLabel(score){
  if(score>=80)return{label:"High Converting",color:"#1a7a3c",bg:"rgba(26,122,60,0.08)",icon:"ti-star"};
  if(score>=60)return{label:"Good",           color:"#1a50a0",bg:"rgba(26,80,160,0.07)",icon:"ti-circle-check"};
  if(score>=40)return{label:"Needs Work",     color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-adjustments"};
  if(score>=20)return{label:"Weak CVR",       color:"#d42b2b",bg:"rgba(212,43,43,0.07)",icon:"ti-trending-down"};
  return{label:"Critical CVR",color:"#d42b2b",bg:"rgba(212,43,43,0.1)", icon:"ti-alert-triangle"};
}

/* ── Conversion optimization recommendation ──────────────────── */
function lcOptRec(m,comp){
  if(m.sessions===0)return{action:"No Traffic Data",color:"#ccc",priority:5};
  if(m.cvr<0.5&&m.sessions>100)return{action:"Fix Listing Urgently",color:"#d42b2b",priority:0};
  if(m.cvr<1.5&&m.sessions>50)return{action:"Improve Main Image",color:"#d42b2b",priority:1};
  if(m.buyBox>0&&m.buyBox<70)return{action:"Win Buy Box",color:"#c47a00",priority:1};
  if(comp&&comp.cvr>0&&m.cvr<comp.cvr*0.7&&m.sessions>30)return{action:"Refresh Creative",color:"#c47a00",priority:2};
  if(m.cvr>=2&&m.cvr<5&&m.sessions>50)return{action:"Optimize Bullets",color:"#c47a00",priority:2};
  if(m.cvr>=5&&m.sessions>0)return{action:"Scale Traffic",color:"#1a7a3c",priority:4};
  if(m.cvr>=3)return{action:"A/B Test Images",color:"#1a50a0",priority:3};
  return{action:"Monitor",color:"#888",priority:5};
}

/* ── Listing alerts ──────────────────────────────────────────── */
function generateLCAlerts(rows,lm,compMap){
  const alerts=[];
  rows.forEach(row=>{
    const m=lcRow(row,lm);
    const comp=compMap?compMap[m.sku.toLowerCase()]||null:null;
    if(!m.sku||m.sessions===0)return;

    // Critical CVR collapse
    if(m.cvr<0.5&&m.sessions>100){
      alerts.push({severity:"critical",type:"Conversion Collapse",icon:"ti-chart-line-down",color:"#d42b2b",
        sku:m.sku,title:m.title,
        comparison:comp?`Prev CVR: ${comp.cvr.toFixed(1)}% → Now: ${m.cvr.toFixed(1)}%`:`CVR: ${m.cvr.toFixed(1)}% on ${m.sessions.toLocaleString()} sessions`,
        cause:`Conversion rate is critically low at ${m.cvr.toFixed(1)}% despite ${m.sessions.toLocaleString()} sessions. PPC is driving traffic that isn't converting — every click is wasted spend until the listing is improved. Typical causes: poor main image, uncompetitive price, weak title, or negative review spike.`,
        action:"Immediately review: main image, price vs competitors, title relevance, and recent review ratings. Check if Buy Box was lost.",
        impact:`At target 3% CVR: ~${Math.round(m.sessions*0.03-m.orders)} additional orders possible from current traffic`,confidence:94});
    }

    // PPC traffic not converting
    if(m.spend>20&&m.ppcSales>0&&m.acos>70&&m.cvr<2){
      alerts.push({severity:"critical",type:"PPC Traffic Conversion Waste",icon:"ti-coin-off",color:"#d42b2b",
        sku:m.sku,title:m.title,
        comparison:comp?`Prev ACoS: ${comp.acos?.toFixed(1)||"—"}% → ${m.acos.toFixed(1)}%`:`ACoS ${m.acos.toFixed(1)}% · CVR ${m.cvr.toFixed(1)}%`,
        cause:`$${m.spend.toFixed(0)} PPC spend at ${m.acos.toFixed(0)}% ACoS with only ${m.cvr.toFixed(1)}% CVR. Paid traffic is landing on a listing that isn't converting. Increasing bids here amplifies the problem — fix the listing first.`,
        action:"Pause aggressive PPC scaling. Fix listing conversion first: improve images, review pricing, test different title. Re-enable scaling after CVR improves above 3%.",
        impact:"Every 1pp CVR improvement at current traffic = ~"+Math.round(m.sessions*0.01)+" additional orders",confidence:90});
    }

    // CVR decline vs comparison
    if(comp&&comp.cvr>2&&m.cvr<comp.cvr*0.65&&m.sessions>30){
      const pct=((m.cvr-comp.cvr)/comp.cvr)*100;
      alerts.push({severity:"high",type:"CVR Deterioration",icon:"ti-trending-down",color:"#c47a00",
        sku:m.sku,title:m.title,
        comparison:`CVR: ${comp.cvr.toFixed(1)}% → ${m.cvr.toFixed(1)}% (${pct.toFixed(0)}%)`,
        cause:`Conversion rate declined ${Math.abs(pct).toFixed(0)}% vs previous period. Listing is underperforming vs its own historical baseline — likely a competitor improvement, negative review, pricing shift, or algorithm change affecting visibility quality.`,
        action:"Compare listing vs top 3 competitors. Check if any reviews were posted recently. Test a price reduction of 5–10% to see if it recovers CVR.",
        impact:`Recovering to previous ${comp.cvr.toFixed(1)}% CVR = ~${Math.round(m.sessions*(comp.cvr-m.cvr)/100)} additional orders`,confidence:83});
    }

    // Buy Box loss
    if(m.buyBox>0&&m.buyBox<60&&m.sessions>50){
      alerts.push({severity:"high",type:"Buy Box Loss",icon:"ti-shopping-cart-off",color:"#c47a00",
        sku:m.sku,title:m.title,
        comparison:comp&&comp.buyBox>0?`Buy Box: ${comp.buyBox.toFixed(0)}% → ${m.buyBox.toFixed(0)}%`:`Buy Box: ${m.buyBox.toFixed(0)}% — below threshold`,
        cause:`Buy Box percentage is ${m.buyBox.toFixed(0)}%. When you don't own the Buy Box, your PPC ads may drive traffic that cannot easily purchase your product. This directly reduces CVR and wastes ad spend.`,
        action:"Check pricing vs competitors and account health metrics. Ensure FBA inventory is not running low. Match or beat lowest FBA price to recapture Buy Box.",
        impact:"Recovering Buy Box typically improves CVR by 30–50%",confidence:88});
    }

    // High traffic low CVR opportunity
    if(m.cvr>=2&&m.cvr<4&&m.sessions>200&&(!comp||m.cvr>=comp.cvr*0.9)){
      alerts.push({severity:"medium",type:"Traffic Monetization Gap",icon:"ti-target",color:"#1a50a0",
        sku:m.sku,title:m.title,
        comparison:`${m.sessions.toLocaleString()} sessions · ${m.cvr.toFixed(1)}% CVR · ${m.orders} orders`,
        cause:`Good traffic volume but CVR of ${m.cvr.toFixed(1)}% is below potential. With this many sessions, even a 1pp CVR improvement would generate significant additional orders without increasing ad spend.`,
        action:"Focus on: main image A/B test, bullet point optimization, A+ content, and pricing. A 1–2pp CVR gain here is worth more than any bid increase.",
        impact:`+1pp CVR = ~${Math.round(m.sessions*0.01)} additional orders from current traffic`,confidence:78});
    }
  });

  const sevO={critical:0,high:1,medium:2,low:3};
  return alerts.sort((a,b)=>(sevO[a.severity]??3)-(sevO[b.severity]??3)).slice(0,20);
}

/* ── Conversion opportunities ────────────────────────────────── */
function generateLCOpportunities(rows,lm,compMap){
  const opps=[];
  rows.forEach(row=>{
    const m=lcRow(row,lm);const comp=compMap?compMap[m.sku.toLowerCase()]||null:null;
    if(!m.sku||m.sessions<20)return;

    // Strong CVR — scale traffic
    if(m.cvr>=6&&m.sessions>0&&m.spend>0){
      opps.push({icon:"ti-rocket",color:"#1a7a3c",type:"scale",
        title:"Scale Traffic — Strong CVR",sku:m.sku,title_:m.title,
        why:`CVR ${m.cvr.toFixed(1)}% — significantly above Amazon average. This listing converts well; more traffic = proportionally more orders.`,
        movement:comp?`CVR: ${comp.cvr.toFixed(1)}% → ${m.cvr.toFixed(1)}%`:`CVR: ${m.cvr.toFixed(1)}% on ${m.sessions.toLocaleString()} sessions`,
        action:"Increase PPC bids 25–35%. Expand to phrase match. This listing earns more traffic investment.",
        impact:`Every 100 additional sessions = ~${Math.round(m.cvr)} additional orders at current CVR`});
    }

    // CVR improving trend — momentum
    if(comp&&comp.cvr>0&&m.cvr>comp.cvr*1.2&&m.sessions>30){
      const pct=((m.cvr-comp.cvr)/comp.cvr)*100;
      opps.push({icon:"ti-trending-up",color:"#1a7a3c",type:"momentum",
        title:"CVR Improving — Reinforce",sku:m.sku,title_:m.title,
        why:`CVR improved ${pct.toFixed(0)}% vs previous period. Listing quality is improving — capitalize on this momentum.`,
        movement:`CVR: ${comp.cvr.toFixed(1)}% → ${m.cvr.toFixed(1)}% (+${pct.toFixed(0)}%)`,
        action:"Increase PPC budget 20%. Continue whatever listing changes drove this improvement.",
        impact:"Sustained CVR improvement + more traffic = compound growth in orders"});
    }

    // Good CVR but low traffic
    if(m.cvr>=4&&m.sessions<100&&m.spend>0){
      opps.push({icon:"ti-eye",color:"#6338c8",type:"underexposed",
        title:"Strong Converter — Underexposed",sku:m.sku,title_:m.title,
        why:`${m.cvr.toFixed(1)}% CVR with only ${m.sessions} sessions — this listing converts well but lacks traffic.`,
        movement:`${m.sessions} sessions · ${m.cvr.toFixed(1)}% CVR · ${m.orders} orders`,
        action:"Significantly increase PPC spend. This listing is proven — more traffic will convert at the same rate.",
        impact:`Doubling sessions to ${m.sessions*2} = ~${Math.round(m.sessions*m.cvr/100)} additional orders`});
    }

    // Buy Box recovered
    if(comp&&comp.buyBox>0&&m.buyBox>comp.buyBox*1.15&&m.buyBox>80){
      opps.push({icon:"ti-shopping-cart",color:"#1a7a3c",type:"buybox",
        title:"Buy Box Recovered — Scale Now",sku:m.sku,title_:m.title,
        why:`Buy Box recovered to ${m.buyBox.toFixed(0)}% (was ${comp.buyBox.toFixed(0)}%). Strong Buy Box position maximizes CVR from both paid and organic traffic.`,
        movement:`Buy Box: ${comp.buyBox.toFixed(0)}% → ${m.buyBox.toFixed(0)}%`,
        action:"Increase PPC bids now. Buy Box recovery is the best time to scale — conversion efficiency is at its peak.",
        impact:"Buy Box >80% typically improves CVR 30–50% vs lower percentages"});
    }
  });
  return opps.sort((a,b)=>{const o={scale:0,momentum:1,underexposed:2,buybox:3};return(o[a.type]??4)-(o[b.type]??4);}).slice(0,12);
}

/* ── AI listing insights ─────────────────────────────────────── */
function generateLCInsights(rows,lm,compMap){
  const lines=[];
  const processed=rows.map(r=>lcRow(r,lm)).filter(m=>m.sku&&m.sessions>0);
  if(!processed.length)return lines;
  const totalSessions=processed.reduce((s,m)=>s+m.sessions,0);
  const avgCvr=processed.reduce((s,m)=>s+m.cvr,0)/processed.length;
  const criticals=processed.filter(m=>m.cvr<0.5&&m.sessions>100);
  const highCvr=processed.filter(m=>m.cvr>=5);
  const cvrDeclines=processed.filter(m=>{const comp=compMap?compMap[m.sku.toLowerCase()]:null;return comp&&comp.cvr>0&&m.cvr<comp.cvr*0.7;});
  const buyBoxIssues=processed.filter(m=>m.buyBox>0&&m.buyBox<60&&m.sessions>50);

  if(criticals.length)lines.push({type:"critical",icon:"ti-alert-triangle",text:`${criticals.length} listing${criticals.length>1?"s have":"has"} critically low CVR (<0.5%) despite significant traffic. PPC spend on these products is largely wasted until listing quality is improved. Fixing these should be the absolute first priority.`});
  if(avgCvr>0)lines.push({type:avgCvr>=4?"positive":avgCvr>=2?"neutral":"negative",icon:avgCvr>=4?"ti-trending-up":"ti-trending-down",text:avgCvr>=4?`Average conversion rate of ${avgCvr.toFixed(1)}% across analyzed listings is strong. Focus on scaling traffic to the best-converting products while maintaining listing quality.`:`Average conversion rate of ${avgCvr.toFixed(1)}% suggests listings have room for improvement. A 1–2pp improvement across all listings would significantly reduce effective CPC and improve overall account profitability.`});
  if(cvrDeclines.length)lines.push({type:"negative",icon:"ti-chart-line-down",text:`${cvrDeclines.length} listing${cvrDeclines.length>1?"s show":"shows"} CVR decline vs previous period. This typically indicates competitor listing improvements, pricing changes, review accumulation, or seasonal demand shifts affecting purchase intent.`});
  if(highCvr.length)lines.push({type:"positive",icon:"ti-rocket",text:`${highCvr.length} listing${highCvr.length>1?"s have":"has"} CVR above 5% — these are the account's most valuable traffic destinations. Prioritize traffic investment here before lower-converting listings.`});
  if(buyBoxIssues.length)lines.push({type:"negative",icon:"ti-shopping-cart-off",text:`${buyBoxIssues.length} listing${buyBoxIssues.length>1?"s have":"has"} Buy Box percentage below 60%. PPC traffic landing on listings without reliable Buy Box dramatically reduces conversion efficiency — every click risks bouncing to a competitor.`});
  return lines;
}

/* ── LC Upload Zone ──────────────────────────────────────────── */
function LCUploadZone({type,file,onFile,onClear}){
  const ref=useRef();const[drag,setDrag]=useState(false);
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(type.id,f);}}
      style={{border:`2px dashed ${drag||file?R:"#e0e0e0"}`,borderRadius:10,padding:"12px 14px",background:file?"rgba(79,70,229,0.02)":"#fafafa",transition:"all 0.15s"}}>
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={e=>onFile(type.id,e.target.files[0])}/>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:32,height:32,borderRadius:7,background:file?"rgba(79,70,229,0.07)":"#fff",border:`1px solid ${file?R:"#e0e0e0"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${type.icon}`} style={{fontSize:14,color:file?R:"#bbb"}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:1}}>
            <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{type.label}</div>
            {type.required?<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:R,fontWeight:700}}>Required</span>
              :<span style={{fontSize:9,padding:"1px 4px",borderRadius:3,background:"#f0f0f0",color:"#888",fontWeight:600}}>Optional</span>}
          </div>
          <div style={{fontSize:10,color:"#888"}}>{type.desc}</div>
          {file&&<div style={{fontSize:10,color:R,fontWeight:600,marginTop:2}}><i className="ti ti-check"/> {file.name}</div>}
        </div>
        {file?<button onClick={e=>{e.stopPropagation();onClear(type.id);}} style={{padding:"3px 7px",borderRadius:5,border:"1px solid #eee",background:"#fff",cursor:"pointer",color:"#888",fontSize:10}}>Remove</button>
          :<button onClick={()=>ref.current?.click()} style={{padding:"5px 11px",borderRadius:6,border:`1px solid ${R}`,background:R,color:"#fff",cursor:"pointer",fontSize:10,fontWeight:600,flexShrink:0}}>Upload</button>}
      </div>
    </div>
  );
}

const LC_REPORT_TYPES=[
  {id:"business",label:"Business Report",          icon:"ti-chart-bar",  required:true, desc:"Sessions, CVR, Buy Box %, and sales data per ASIN — from Seller Central Business Reports"},
  {id:"campaign",label:"Campaign / PPC Report",    icon:"ti-speakerphone",required:false,desc:"PPC spend, ACoS, CPC per campaign for listing-PPC alignment"},
];

/* ── LC Upload Page ──────────────────────────────────────────── */
function LCUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[files,setFiles]=useState({});const[compFiles,setCompFiles]=useState({});
  const[showComp,setShowComp]=useState(false);const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);const[localPeriods,setLocalPeriods]=useState(periods);
  const setFile=(id,f)=>setFiles(p=>({...p,[id]:f}));const clearFile=id=>setFiles(p=>{const n={...p};delete n[id];return n;});
  const setCompFile=(id,f)=>setCompFiles(p=>({...p,[id]:f}));const clearCompFile=id=>setCompFiles(p=>{const n={...p};delete n[id];return n;});
  async function go(){
    if(!files.business)return;setLoading(true);setErr(null);
    try{const cur=await parseSheet(files.business);const comp=compFiles.business?await parseSheet(compFiles.business):null;onComplete({cur,comp,periods:localPeriods});}
    catch(e){setErr("Error: "+e.message);}setLoading(false);
  }
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:680,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
            {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
          </div>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Listing Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your Amazon Business Report for conversion intelligence. The system detects sessions, CVR, Buy Box %, and sales per listing automatically.</p>
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period</div></div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>{LC_REPORT_TYPES.map(t=><LCUploadZone key={t.id} type={t} file={files[t.id]} onFile={setFile} onClear={clearFile}/>)}</div>
        </div>
        <div style={{marginBottom:12}}>
          <button onClick={()=>setShowComp(v=>!v)} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 14px",borderRadius:8,border:`1.5px dashed ${showComp?R:"#e0e0e0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
            <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:12}}/>{showComp?"Remove":"Add"} Comparison Period
          </button>
          {showComp&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginTop:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>{LC_REPORT_TYPES.map(t=><LCUploadZone key={t.id} type={t} file={compFiles[t.id]} onFile={setCompFile} onClear={clearCompFile}/>)}</div>
          </div>}
        </div>
        <div style={{padding:"10px 13px",background:"rgba(79,70,229,0.04)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)",marginBottom:14,display:"flex",gap:8}}>
          <i className="ti ti-info-circle" style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/><div style={{fontSize:12,color:"#555",lineHeight:1.6}}>Get Business Report: Seller Central → Reports → Business Reports → Detail Page Sales and Traffic by Child Item. This report contains sessions, CVR, Buy Box %, and all conversion metrics per ASIN.</div>
        </div>
        {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={go} disabled={!files.business||loading} style={{...T.btnR(false),opacity:files.business&&!loading?1:0.4,fontWeight:700,boxShadow:files.business?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
            {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Analyzing...</>:<><i className="ti ti-list-details" style={{fontSize:14}}/> Run Conversion Analysis</>}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── LC Alert Card ───────────────────────────────────────────── */
function LCAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const sc={critical:"#d42b2b",high:"#c47a00",medium:"#1a50a0",low:"#1a7a3c"};
  const sb={critical:"rgba(212,43,43,0.05)",high:"rgba(196,122,0,0.05)",medium:"rgba(26,80,160,0.04)",low:"rgba(26,122,60,0.04)"};
  const sbr={critical:"rgba(212,43,43,0.18)",high:"rgba(196,122,0,0.18)",medium:"rgba(26,80,160,0.15)",low:"rgba(26,122,60,0.18)"};
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${sbr[a.severity]||"#eee"}`,background:sb[a.severity]||"#fff",overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${sbr[a.severity]}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${a.icon}`} style={{fontSize:13,color:sc[a.severity]}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
            <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:sb[a.severity],color:sc[a.severity],fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${sbr[a.severity]}`}}>{a.severity}</span>
            <span style={{fontSize:12,fontWeight:700,color:"#111"}}>{a.type}</span>
          </div>
          <div style={{display:"flex",gap:8,fontSize:11,color:"#555"}}>
            <span style={{fontWeight:600}}>{a.sku}</span>
            {a.title&&<span style={{color:"#888",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:180}}>{a.title}</span>}
          </div>
          {!open&&<div style={{fontSize:10,color:"#888",marginTop:2}}>{a.comparison}</div>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}><span style={{fontSize:10,color:"#bbb"}}>{a.confidence}%</span><i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc"}}/></div>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:"1px solid rgba(0,0,0,0.05)"}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}>{a.comparison}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{a.cause}</div>
        {a.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}><strong>Conversion impact:</strong> {a.impact}</div>}
        <div style={{padding:"9px 12px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.12)"}}><div style={{fontSize:9,color:R,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Optimization Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{a.action}</div></div>
      </div>}
    </div>
  );
}

/* ── LC Opportunity Card ─────────────────────────────────────── */
function LCOppCard({opp:o}){
  const[open,setOpen]=useState(false);
  const tc={scale:"#1a7a3c",momentum:"#1a7a3c",underexposed:"#6338c8",buybox:"#1a50a0"};
  const tb={scale:"rgba(26,122,60,0.05)",momentum:"rgba(26,122,60,0.04)",underexposed:"rgba(99,56,200,0.05)",buybox:"rgba(26,80,160,0.05)"};
  const tbr={scale:"rgba(26,122,60,0.18)",momentum:"rgba(26,122,60,0.15)",underexposed:"rgba(99,56,200,0.18)",buybox:"rgba(26,80,160,0.15)"};
  const c=tc[o.type]||"#1a7a3c";const bg=tb[o.type]||"rgba(26,122,60,0.04)";const br=tbr[o.type]||"rgba(26,122,60,0.15)";
  return(
    <div style={{borderRadius:10,border:`1.5px solid ${br}`,background:bg,overflow:"hidden",marginBottom:8}}>
      <div onClick={()=>setOpen(v=>!v)} style={{padding:"11px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:11}}>
        <div style={{width:30,height:30,borderRadius:7,background:"#fff",border:`1.5px solid ${br}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${o.icon}`} style={{fontSize:13,color:c}}/></div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:bg,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",border:`1px solid ${br}`}}>Opportunity</span><span style={{fontSize:12,fontWeight:700,color:"#111"}}>{o.title}</span></div>
          <div style={{fontSize:11,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{o.sku}{o.title_?` — ${o.title_}`:""}</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#ccc",flexShrink:0,marginTop:6}}/>
      </div>
      {open&&<div style={{padding:"0 14px 14px 55px",borderTop:`1px solid ${br}`}}>
        <div style={{fontSize:11,color:"#888",margin:"10px 0 6px",fontStyle:"italic"}}>{o.movement}</div>
        <div style={{fontSize:12,color:"#444",lineHeight:1.65,marginBottom:10}}>{o.why}</div>
        {o.impact&&<div style={{fontSize:12,color:"#555",padding:"7px 10px",background:"rgba(0,0,0,0.03)",borderRadius:6,marginBottom:8}}>{o.impact}</div>}
        <div style={{padding:"9px 12px",background:bg,borderRadius:8,border:`1px solid ${br}`}}><div style={{fontSize:9,color:c,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>Optimization Action</div><div style={{fontSize:12,color:"#333",lineHeight:1.6,fontWeight:500}}>{o.action}</div></div>
      </div>}
    </div>
  );
}

/* ── LC Listing Table ────────────────────────────────────────── */
function LCListingTable({rows,lm,compMap}){
  const[search,setSearch]=useState("");const[sortKey,setSortKey]=useState("score");const[sortDir,setSortDir]=useState("asc");const[filterQ,setFilterQ]=useState("All");
  const Q_F=["All","Critical CVR","Weak CVR","Needs Work","Good","High Converting"];
  const processed=useMemo(()=>rows.map((r,i)=>{const m=lcRow(r,lm);const comp=compMap?compMap[m.sku.toLowerCase()]||null:null;const ql=lcQualityLabel(m.listingScore);const rec=lcOptRec(m,comp);return{r,m,comp,ql,rec,id:i};}).filter(x=>x.m.sku&&(x.m.sessions>0||x.m.totalSales>0)),[rows,lm,compMap]);
  const filtered=useMemo(()=>{let d=processed;if(search){const q=search.toLowerCase();d=d.filter(x=>x.m.sku.toLowerCase().includes(q)||x.m.title.toLowerCase().includes(q));}if(filterQ!=="All"){const qMap={"Critical CVR":score=>score<20,"Weak CVR":score=>score>=20&&score<40,"Needs Work":score=>score>=40&&score<60,"Good":score=>score>=60&&score<80,"High Converting":score=>score>=80};const fn=qMap[filterQ];d=fn?d.filter(x=>fn(x.m.listingScore)):d;}return d;},[processed,search,filterQ]);
  const sorted=useMemo(()=>[...filtered].sort((a,b)=>{if(sortKey==="score")return sortDir==="asc"?a.m.listingScore-b.m.listingScore:b.m.listingScore-a.m.listingScore;if(sortKey==="sku")return sortDir==="asc"?a.m.sku.localeCompare(b.m.sku):b.m.sku.localeCompare(a.m.sku);const va=a.m[sortKey]??0,vb=b.m[sortKey]??0;return sortDir==="asc"?va-vb:vb-va;}),[filtered,sortKey,sortDir]);
  function toggleSort(k){if(sortKey===k)setSortDir(d=>d==="asc"?"desc":"asc");else{setSortKey(k);setSortDir(k==="score"?"asc":"desc");}}
  const thS={padding:"9px 10px",fontWeight:700,fontSize:10,color:"#999",textAlign:"left",whiteSpace:"nowrap",cursor:"pointer",userSelect:"none",background:"#fafafa",position:"sticky",top:0,zIndex:1,borderBottom:"2px solid #f0f0f0",textTransform:"uppercase",letterSpacing:"0.7px"};
  const SI=({col})=>sortKey===col?<i className={`ti ${sortDir==="asc"?"ti-sort-ascending":"ti-sort-descending"}`} style={{fontSize:9,marginLeft:2,color:R}}/>:<i className="ti ti-selector" style={{fontSize:9,opacity:0.3,marginLeft:2}}/>;
  const DC=({cur,prev,fmt,lb,isPp})=>{const d=prev!=null?cur-prev:null;const good=d===null?null:(lb?d<=0:d>=0);const dc=good===true?"#1a9e4a":good===false?"#d42b2b":"#aaa";const sign=v=>v>0?"+":"";return<><div style={{fontSize:12,fontWeight:500,color:"#111",lineHeight:1.4}}>{fmt(cur)}</div>{d!=null&&Math.abs(d)>0.001&&<div style={{fontSize:10,fontWeight:600,color:dc}}>{isPp?`${sign(d)}${Math.abs(d).toFixed(1)}pp`:`${sign(d)}${fmt(Math.abs(d))}`}</div>}</>;};
  return(
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",minHeight:0}}>
      <div style={{padding:"10px 16px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 11px",borderRadius:8,border:"1.5px solid #e8e8e8",background:"#fafafa",flex:1,minWidth:160}}>
          <i className="ti ti-search" style={{fontSize:13,color:"#bbb"}}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search SKU or product title…" style={{border:"none",background:"transparent",outline:"none",fontSize:12,color:"#111",flex:1}}/>
          {search&&<i className="ti ti-x" style={{fontSize:11,cursor:"pointer",color:"#bbb"}} onClick={()=>setSearch("")}/>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {Q_F.map(f=>{const act=filterQ===f;return<button key={f} onClick={()=>setFilterQ(f)} style={{padding:"4px 9px",borderRadius:20,border:`1.5px solid ${act?R:"#e0e0e0"}`,background:act?R:"#fff",color:act?"#fff":"#555",fontSize:11,fontWeight:act?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>{f}</button>;})}
        </div>
        <div style={{flex:1}}/><span style={{fontSize:12,color:"#888"}}><strong style={{color:"#111"}}>{sorted.length}</strong> listings</span>
      </div>
      <div style={{flex:1,overflowY:"auto",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            <th style={thS} onClick={()=>toggleSort("score")}>Quality <SI col="score"/></th>
            <th style={thS} onClick={()=>toggleSort("sku")}>SKU / ASIN <SI col="sku"/></th>
            <th style={thS} onClick={()=>toggleSort("sessions")}>Sessions <SI col="sessions"/></th>
            <th style={thS} onClick={()=>toggleSort("cvr")}>CVR <SI col="cvr"/></th>
            <th style={thS} onClick={()=>toggleSort("orders")}>Orders <SI col="orders"/></th>
            <th style={thS} onClick={()=>toggleSort("totalSales")}>Total Sales <SI col="totalSales"/></th>
            <th style={thS} onClick={()=>toggleSort("ppcSales")}>PPC Sales <SI col="ppcSales"/></th>
            <th style={thS} onClick={()=>toggleSort("buyBox")}>Buy Box <SI col="buyBox"/></th>
            <th style={thS} onClick={()=>toggleSort("acos")}>ACoS <SI col="acos"/></th>
            <th style={{...thS,cursor:"default"}}>Action</th>
          </tr></thead>
          <tbody>
            {sorted.map(({m,comp,ql,rec,id},i)=>(
              <tr key={id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"7px 10px"}}>
                  <div style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:6,background:ql.bg,border:`1px solid ${ql.color}22`}}>
                    <i className={`ti ${ql.icon}`} style={{fontSize:9,color:ql.color}}/>
                    <span style={{fontSize:9,fontWeight:700,color:ql.color,whiteSpace:"nowrap"}}>{ql.label}</span>
                  </div>
                </td>
                <td style={{padding:"8px 10px",maxWidth:160}}>
                  <div style={{fontWeight:700,color:"#111",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.sku}</div>
                  {m.title&&<div style={{fontSize:10,color:"#888",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={m.title}>{m.title}</div>}
                </td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.sessions} prev={comp?.sessions} fmt={v=>v>=1e3?`${(v/1e3).toFixed(1)}K`:String(Math.round(v))} lb={false}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}>
                  <div style={{fontSize:13,fontWeight:800,color:m.cvr<1?"#d42b2b":m.cvr<3?"#c47a00":"#1a7a3c"}}>{m.cvr.toFixed(1)}%</div>
                  {comp&&<div style={{fontSize:10,fontWeight:600,color:(m.cvr-comp.cvr)>=0?"#1a9e4a":"#d42b2b"}}>{m.cvr-comp.cvr>0?"+":""}{(m.cvr-comp.cvr).toFixed(1)}pp</div>}
                </td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.orders} prev={comp?.orders} fmt={v=>String(Math.round(v))} lb={false}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.totalSales} prev={comp?.totalSales} fmt={v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`} lb={false}/></td>
                <td style={{padding:"8px 10px",verticalAlign:"top"}}><DC cur={m.ppcSales} prev={comp?.ppcSales} fmt={v=>`$${v>=1e3?`${(v/1e3).toFixed(1)}K`:v.toFixed(0)}`} lb={false}/></td>
                <td style={{padding:"8px 10px"}}>
                  {m.buyBox>0?<div style={{fontSize:12,fontWeight:700,color:m.buyBox<60?"#d42b2b":m.buyBox<80?"#c47a00":"#1a7a3c"}}>{m.buyBox.toFixed(0)}%</div>:<span style={{color:"#ccc"}}>—</span>}
                </td>
                <td style={{padding:"8px 10px"}}>{m.acos>0?<span style={{fontSize:12,color:m.acos>60?"#d42b2b":m.acos>35?"#c47a00":"#111"}}>{m.acos.toFixed(0)}%</span>:<span style={{color:"#ccc"}}>—</span>}</td>
                <td style={{padding:"7px 10px"}}><span style={{fontSize:10,padding:"2px 7px",borderRadius:5,background:`${rec.color}11`,color:rec.color,fontWeight:700,whiteSpace:"nowrap"}}>{rec.action}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        {sorted.length===0&&<div style={{textAlign:"center",padding:"50px",color:"#aaa"}}><i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8,color:"#ddd"}}/><div style={{fontSize:14,fontWeight:500}}>No listings match</div></div>}
      </div>
    </div>
  );
}

/* ── LC Workspace ────────────────────────────────────────────── */
function LCWorkspace({curData,compData,periods,onReupload,onExport}){
  const lm=useMemo(()=>curData?lcDetect(curData.headers):{},[curData]);
  const compLm=useMemo(()=>compData?lcDetect(compData.headers):{},[compData]);
  const compMap=useMemo(()=>{if(!compData)return null;const m={};compData.rows.forEach(r=>{const row=lcRow(r,compLm);if(row.sku)m[row.sku.toLowerCase()]=row;});return m;},[compData,compLm]);
  const alerts=useMemo(()=>curData?generateLCAlerts(curData.rows,lm,compMap):[],[curData,lm,compMap]);
  const opps=useMemo(()=>curData?generateLCOpportunities(curData.rows,lm,compMap):[],[curData,lm,compMap]);
  const insights=useMemo(()=>curData?generateLCInsights(curData.rows,lm,compMap):[],[curData,lm,compMap]);
  const processed=useMemo(()=>curData?curData.rows.map(r=>lcRow(r,lm)).filter(m=>m.sku&&(m.sessions>0||m.totalSales>0)):[],[curData,lm]);
  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const avgCvr=processed.length?processed.reduce((s,m)=>s+m.cvr,0)/processed.length:0;
  const highCvr=processed.filter(m=>m.cvr>=5).length;
  const critCvr=processed.filter(m=>m.cvr<0.5&&m.sessions>100).length;
  const[activeTab,setActiveTab]=useState("overview");
  const TABS=[{key:"overview",label:"Overview",icon:"ti-list-details"},{key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-triangle"},{key:"opps",label:`Opportunities${opps.length?` (${opps.length})`:""}`,icon:"ti-rocket"},{key:"table",label:"Listing Table",icon:"ti-table"},{key:"insights",label:"AI Insights",icon:"ti-brain"}];
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"14px 22px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:14,flexShrink:0,background:"#fff",flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:"#111",letterSpacing:"-0.3px"}}>Listing Conversion Intelligence</h2>
            {critCount>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>{critCount} Critical</span>}
            {avgCvr>0&&<span style={{fontSize:11,padding:"2px 10px",borderRadius:20,background:"rgba(0,0,0,0.05)",color:"#555",fontWeight:600}}>Avg CVR: {avgCvr.toFixed(1)}%</span>}
          </div>
          <div style={{fontSize:12,color:"#888",display:"flex",alignItems:"center",gap:6}}>
            <i className="ti ti-calendar" style={{fontSize:11}}/><span style={{fontWeight:600,color:"#555"}}>{fmtDisp(periods?.current?.start)} → {fmtDisp(periods?.current?.end)}</span>
            {compData&&<><span style={{color:"#ccc"}}>vs</span><span>{fmtDisp(periods?.comp?.start)} → {fmtDisp(periods?.comp?.end)}</span></>}
            <span style={{color:"#ccc"}}>·</span><span>{processed.length} listings analyzed</span>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>onExport(processed,alerts,opps)} style={T.btnG(true)}><i className="ti ti-download" style={{fontSize:12}}/> Export Actions</button>
          <button onClick={onReupload} style={T.btnG(true)}><i className="ti ti-upload" style={{fontSize:12}}/> Re-upload</button>
        </div>
      </div>
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",paddingLeft:22}}>
        {TABS.map(t=><button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#888",borderBottom:`2.5px solid ${activeTab===t.key?R:"transparent"}`,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}><i className={`ti ${t.icon}`} style={{fontSize:11}}/>{t.label}</button>)}
      </div>
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {activeTab==="overview"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:900,margin:"0 auto",padding:"20px 22px"}}>
          <ModuleOverview
            moduleName="Listing Conversion" moduleIcon="ti-list-details" periods={periods}
            cur={{cvr:avgCvr,orders:processed.reduce((s,m)=>s+m.ordersPlaced,0),sales:processed.reduce((s,m)=>s+m.totalSales,0),spend:processed.reduce((s,m)=>s+(m.spend||0),0)}}
            comp={null} rows={curData?.rows||[]}
            extraKpis={[{label:"High CVR (5%+)",value:highCvr,fmt:"int",icon:"ti-trending-up",color:"#1a7a3c"},{label:"Critical CVR",value:critCvr,fmt:"int",icon:"ti-trending-down",color:"#d42b2b",invert:true}]}
            alerts={alerts.slice(0,3).map(a=>({type:a.severity==="critical"?"critical":"loss",icon:"ti-list-details",title:a.title,detail:a.explanation||""}))}
          />
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16,marginTop:12}}>
            {[{label:"Listings",val:processed.length,color:"#555",bg:"#fafafa"},{label:"Critical CVR",val:critCvr,color:"#d42b2b",bg:"rgba(212,43,43,0.07)"},{label:"High CVR (5%+)",val:highCvr,color:"#1a7a3c",bg:"rgba(26,122,60,0.07)"},{label:"Avg CVR",val:`${avgCvr.toFixed(1)}%`,color:avgCvr>=4?"#1a7a3c":avgCvr>=2?"#c47a00":"#d42b2b",bg:avgCvr>=4?"rgba(26,122,60,0.07)":avgCvr>=2?"rgba(196,122,0,0.07)":"rgba(212,43,43,0.07)"}].map(s=>(
              <div key={s.label} style={{padding:"14px",background:s.bg,borderRadius:10,border:`1px solid ${s.color}22`,textAlign:"center"}}>
                <div style={{fontSize:s.val?.toString().length>5?16:22,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div>
                <div style={{fontSize:11,fontWeight:600,color:s.color}}>{s.label}</div>
              </div>
            ))}
          </div>
          {insights.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:12}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/><div style={{fontSize:12,fontWeight:700,color:"#111"}}>Conversion Intelligence Summary</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>
            {insights.map((ins,i)=>{const tc={critical:"#d42b2b",negative:"#d42b2b",positive:"#1a7a3c",neutral:"#555"};const ic={critical:"ti-alert-triangle",negative:"ti-trending-down",positive:"ti-rocket",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:9,marginBottom:i<insights.length-1?9:0,paddingBottom:i<insights.length-1?9:0,borderBottom:i<insights.length-1?"1px solid #f5f5f5":"none"}}><div style={{width:20,height:20,borderRadius:5,background:"rgba(0,0,0,0.03)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:10,color:tc[ins.type]}}/></div><div style={{fontSize:12,color:"#444",lineHeight:1.65}}>{ins.text}</div></div>;})}
          </div>}
          {alerts.length>0&&<><div style={{fontSize:12,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:10}}>Priority Conversion Alerts</div>{alerts.slice(0,4).map((a,i)=><LCAlertCard key={i} alert={a}/>)}{alerts.length>4&&<button onClick={()=>setActiveTab("alerts")} style={{...T.btnG(true),width:"100%",justifyContent:"center",marginTop:4}}>View All {alerts.length} Alerts →</button>}</>}
        </div></div>}
        {activeTab==="alerts"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{alerts.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-circle-check" style={{fontSize:44,color:"#1a9e4a",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700,color:"#111"}}>No conversion alerts</div><div style={{fontSize:13,color:"#888",marginTop:4}}>All listings have acceptable conversion metrics.</div></div>:alerts.map((a,i)=><LCAlertCard key={i} alert={a}/>)}</div></div>}
        {activeTab==="opps"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:800,margin:"0 auto",padding:"20px 22px"}}>{opps.length===0?<div style={{textAlign:"center",padding:"60px",background:"#fff",borderRadius:12,border:"1px solid #eee"}}><i className="ti ti-rocket" style={{fontSize:44,color:"#ddd",display:"block",marginBottom:12}}/><div style={{fontSize:16,fontWeight:700}}>No opportunities detected</div><div style={{fontSize:13,color:"#888",marginTop:4}}>Upload a comparison period to enable trend-based opportunity detection.</div></div>:opps.map((o,i)=><LCOppCard key={i} opp={o}/>)}</div></div>}
        {activeTab==="table"&&<LCListingTable rows={curData?.rows||[]} lm={lm} compMap={compMap}/>}
        {activeTab==="insights"&&<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}><div style={{maxWidth:780,margin:"0 auto",padding:"20px 22px"}}><div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px"}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}><i className="ti ti-brain" style={{fontSize:14,color:R}}/><div style={{fontSize:14,fontWeight:700,color:"#111"}}>Conversion Intelligence Analysis</div><div style={{fontSize:10,color:"#bbb",fontStyle:"italic",marginLeft:"auto"}}>Based on uploaded data only</div></div>{insights.length===0?<div style={{textAlign:"center",padding:"30px",color:"#aaa"}}><div>Upload a comparison period to enable AI trend analysis</div></div>:insights.map((ins,i)=>{const tc={critical:"#d42b2b",negative:"#d42b2b",positive:"#1a7a3c",neutral:"#555"};const tb={critical:"rgba(212,43,43,0.05)",negative:"rgba(212,43,43,0.04)",positive:"rgba(26,122,60,0.05)",neutral:"rgba(0,0,0,0.02)"};const ic={critical:"ti-alert-triangle",negative:"ti-trending-down",positive:"ti-rocket",neutral:"ti-minus"};return<div key={i} style={{display:"flex",gap:12,padding:"12px 14px",borderRadius:9,background:tb[ins.type],border:`1px solid ${tc[ins.type]}22`,marginBottom:10,alignItems:"flex-start"}}><div style={{width:28,height:28,borderRadius:7,background:"#fff",border:`1px solid ${tc[ins.type]}33`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><i className={`ti ${ic[ins.type]}`} style={{fontSize:13,color:tc[ins.type]}}/></div><div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{ins.text}</div></div>;})}</div></div></div>}
      </div>
    </div>
  );
}

/* ── LC Export Page ──────────────────────────────────────────── */
function LCExportPage({processed,alerts,opps,onBack}){
  function doExport(){
    const wb=XLSX.utils.book_new();
    const h1=["SKU","ASIN","Sessions","CVR (%)","Orders","Total Sales ($)","PPC Sales ($)","Buy Box (%)","ACoS (%)","Listing Quality","Recommended Action","Priority"];
    const r1=processed.map(m=>{const ql=lcQualityLabel(m.listingScore);const rec=lcOptRec(m,null);return{SKU:m.sku,ASIN:m.asin||"",Sessions:Math.round(m.sessions),"CVR (%)":m.cvr.toFixed(1),Orders:Math.round(m.orders),"Total Sales ($)":m.totalSales.toFixed(0),"PPC Sales ($)":m.ppcSales.toFixed(0),"Buy Box (%)":m.buyBox>0?m.buyBox.toFixed(0):"—","ACoS (%)":m.acos>0?m.acos.toFixed(1):"—","Listing Quality":ql.label,"Recommended Action":rec.action,"Priority":rec.priority};});
    const ws1=XLSX.utils.json_to_sheet(r1.sort((a,b)=>a.Priority-b.Priority),{header:h1});ws1["!cols"]=h1.map(()=>({wch:18}));
    XLSX.utils.book_append_sheet(wb,ws1,"Listing Actions");
    if(alerts.length){
      const h2=["SKU","Alert Type","Severity","Comparison","Cause","Action","Impact","Confidence"];
      const r2=alerts.map(a=>({SKU:a.sku,"Alert Type":a.type,Severity:a.severity,Comparison:a.comparison,Cause:a.cause,Action:a.action,Impact:a.impact||"",Confidence:`${a.confidence}%`}));
      const ws2=XLSX.utils.json_to_sheet(r2,{header:h2});ws2["!cols"]=h2.map(()=>({wch:24}));
      XLSX.utils.book_append_sheet(wb,ws2,"Conversion Alerts");
    }
    if(opps.length){
      const h3=["SKU","Opportunity","Type","Why","Action","Impact"];
      const r3=opps.map(o=>({SKU:o.sku,Opportunity:o.title,Type:o.type,Why:o.why,Action:o.action,Impact:o.impact||""}));
      const ws3=XLSX.utils.json_to_sheet(r3,{header:h3});ws3["!cols"]=h3.map(()=>({wch:28}));
      XLSX.utils.book_append_sheet(wb,ws3,"Scaling Opportunities");
    }
    XLSX.writeFile(wb,`Quarred_Listing_Conversion_${new Date().toISOString().slice(0,10)}.xlsx`);
  }
  const criticalCvr=processed.filter(m=>m.cvr<0.5&&m.sessions>100).length;
  const scaleReady=processed.filter(m=>m.cvr>=5).length;
  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:700,margin:"0 auto",padding:"32px 24px"}}>
        <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:16}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace</button>
        <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Optimization Actions</h2>
        <p style={{fontSize:13,color:"#666",margin:"0 0 22px"}}>Export listing conversion analysis and optimization recommendations as a strategist-ready workbook.</p>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Export Summary</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
            {[{label:"Total Listings",val:processed.length,color:"#555"},{label:"Critical CVR",val:criticalCvr,color:"#d42b2b"},{label:"Scale Ready",val:scaleReady,color:"#1a7a3c"},{label:"Alerts",val:alerts.length,color:"#c47a00"}].map(s=>(
              <div key={s.label} style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div><div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{fontSize:12,color:"#555",marginBottom:14,lineHeight:1.6}}>Export includes 3 sheets: Listing Actions (sorted by priority), Conversion Alerts, and Scaling Opportunities.</div>
          <button onClick={doExport} style={{...T.btnR(false),width:"100%",justifyContent:"center",fontWeight:700,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
            <i className="ti ti-download" style={{fontSize:14}}/> Download Listing Conversion Workbook
          </button>
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>Key listing optimization priorities</div>
          {["Fix critical CVR listings first — no PPC optimization can overcome a broken listing","Main image is the single highest-impact listing element — test it before anything else","Buy Box <80% is a conversion blocker — fix pricing/account health before scaling traffic","For listings with CVR >5%, scaling traffic is more valuable than any listing improvement","Recheck CVR weekly — it can change overnight with new reviews or competitor moves"].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:R,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Listing Conversion Module Root ──────────────────────────── */
function ListingConversionModule({globalData,setTab}){
  const[page,setPage]=useState((globalData?.cur?.business||globalData?.cur?.primary)?"workspace":"upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[curData,setCurData]=useState(globalData?.cur?.business||globalData?.cur?.primary||null);const[compData,setCompData]=useState(globalData?.comp?.business||globalData?.comp?.primary||null);const[exportArgs,setExportArgs]=useState(null);
  useEffect(()=>{if((globalData?.cur?.business||globalData?.cur?.primary)&&page==="upload"){setCurData(globalData.cur.business||globalData.cur.primary);setCompData(globalData.comp?.business||globalData.comp?.primary||null);setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);
  if(page==="export"&&exportArgs)return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Listing Conversion — Export</h2></div><LCExportPage {...exportArgs} onBack={()=>setPage("workspace")}/></div>);
  if(page==="workspace"&&curData)return(<LCWorkspace curData={curData} compData={compData} periods={periods} onReupload={()=>{setCurData(null);setPage("upload");}} onExport={(processed,alerts,opps)=>{setExportArgs({processed,alerts,opps});setPage("export");}}/>);
  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Listing Conversion Intelligence</h2></div><LCUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={({cur,comp,periods:p})=>{setCurData(cur);setCompData(comp||null);if(p)setPeriods(p);setPage("workspace");}}/></div>);
}


/* ================================================================
   BRAND DEFENSE MONITOR MODULE
   Paste this entire block into bids-optimizer.jsx

   INTEGRATION STEPS:
   1. Paste this full block anywhere after the ListingConversionModule (line ~10029)
   2. In the NAV array, change the "branddef" entry:
      FROM: {key:"branddef", ..., soon:true, ...}
      TO:   {key:"branddef", icon:"ti-shield", label:"Brand Defense", badge:"Advanced", desc:"Monitor & defend branded terms"}
   3. In the App component tab switcher, add before the final fallback:
      :tab==="branddef"
      ?<BrandDefenseModule key="branddef"/>
   That's it — no other changes needed.
================================================================ */

/* ── Column aliases for brand-related reports ──────────────── */
const BD_ALIASES={
  campaign:    ["Campaign Name","Campaign","campaign name","Campaign Name (Informational only)"],
  adGroup:     ["Ad Group Name","Ad Group","ad group name"],
  matchType:   ["Match Type","match type","Targeting Type"],
  searchTerm:  ["Customer Search Term","Search Term","Query","Search query","Keyword","Keyword Text","Targeting Expression","Product Targeting Expression"],
  impressions: ["Impressions","impressions","Total Impressions"],
  clicks:      ["Clicks","clicks","Total Clicks"],
  spend:       ["Spend","Cost","Ad Spend","Spend ($)"],
  sales:       ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales","Total Sales","Attributed Sales","Revenue"],
  orders:      ["Orders","14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)","Total Orders","Attributed Conversions"],
  acos:        ["ACOS","ACoS","Advertising Cost of Sales","ACOS (%)"],
  roas:        ["ROAS","Return on Ad Spend"],
  cpc:         ["CPC","Cost Per Click","Average CPC","CPC ($)"],
  ctr:         ["Click-through Rate","CTR","Click-Through Rate","CTR (%)"],
  cvr:         ["Conversion Rate","CVR","Order Rate","Unit Session Percentage"],
  state:       ["State","Status","Campaign State (Informational only)","Campaign State"],
  entity:      ["Entity","Record Type","Type"],
  bid:         ["Bid","Ad Group Default Bid","Keyword Bid","Default Bid"],
};

function bdDetectMap(headers){
  const r={};
  for(const[k,cands]of Object.entries(BD_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function bdGetNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function bdCalcMetrics(row,cm){
  const imp=bdGetNum(row,cm.impressions),clk=bdGetNum(row,cm.clicks),
    spd=bdGetNum(row,cm.spend),sal=bdGetNum(row,cm.sales),ord=bdGetNum(row,cm.orders);
  const ctr=cm.ctr&&bdGetNum(row,cm.ctr)>0?bdGetNum(row,cm.ctr):imp>0?(clk/imp)*100:0;
  const acos=cm.acos&&bdGetNum(row,cm.acos)>0?bdGetNum(row,cm.acos):sal>0?(spd/sal)*100:spd>0?0:0;
  const roas=cm.roas&&bdGetNum(row,cm.roas)>0?bdGetNum(row,cm.roas):spd>0?sal/spd:0;
  const cvr=cm.cvr&&bdGetNum(row,cm.cvr)>0?bdGetNum(row,cm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=cm.cpc&&bdGetNum(row,cm.cpc)>0?bdGetNum(row,cm.cpc):clk>0?spd/clk:0;
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,ctr,acos,roas,cvr,cpc};
}

/* Determine if a keyword/search-term is branded */
function isBranded(text,brandTerms){
  if(!text||!brandTerms.length)return false;
  const t=text.toLowerCase();
  return brandTerms.some(b=>b.trim().length>0&&t.includes(b.trim().toLowerCase()));
}

/* Aggregate rows into summary */
function bdSumAgg(rows,cm){
  let imp=0,clk=0,spd=0,sal=0,ord=0;
  rows.forEach(r=>{const m=bdCalcMetrics(r,cm);imp+=m.impressions;clk+=m.clicks;spd+=m.spend;sal+=m.sales;ord+=m.orders;});
  return{
    impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    acos:sal>0?(spd/sal)*100:0,
    ctr:imp>0?(clk/imp)*100:0,
    cvr:clk>0?(ord/clk)*100:0,
    cpc:clk>0?spd/clk:0,
    roas:spd>0?sal/spd:0,
  };
}

/* Defense score for a branded keyword (0–100) */
function bdDefenseScore(m){
  let score=100;
  if(m.acos>40)score-=25;else if(m.acos>25)score-=10;
  if(m.cpc>2)score-=20;else if(m.cpc>1.2)score-=8;
  if(m.impressions<200)score-=20;else if(m.impressions<500)score-=8;
  if(m.cvr<5)score-=15;else if(m.cvr<10)score-=5;
  if(m.ctr<0.3)score-=10;
  return Math.max(0,Math.min(100,Math.round(score)));
}

/* Competitor attack detection */
function bdDetectAttacks(curAgg,compAgg,brandedRows,cm){
  const alerts=[];
  if(!curAgg)return alerts;

  const delta=(k)=>compAgg&&compAgg[k]!=null?(curAgg[k]-compAgg[k]):null;
  const pct=(k)=>{const d=delta(k);if(d===null||!compAgg[k])return null;return(d/Math.abs(compAgg[k]))*100;};

  /* CPC inflation — competitor bidding on your brand */
  const cpcPct=pct("cpc");
  if(cpcPct!==null&&cpcPct>20){
    alerts.push({
      id:"cpc_inflation",severity:"critical",
      issue:"Branded CPC Inflation",
      explanation:`Your branded CPC increased ${cpcPct.toFixed(1)}% vs previous period ($${compAgg.cpc.toFixed(2)} → $${curAgg.cpc.toFixed(2)}). Competitors are actively bidding on your branded terms, driving up your auction costs.`,
      action:"Increase branded keyword bids to defend top-of-search position. Add exact match branded campaigns if not present. Consider increasing branded campaign budgets.",
      impact:`~$${((curAgg.cpc-compAgg.cpc)*curAgg.clicks).toFixed(0)} extra spend from CPC inflation this period`,
    });
  }

  /* Impression decline — losing branded visibility */
  const impPct=pct("impressions");
  if(impPct!==null&&impPct<-15){
    alerts.push({
      id:"visibility_decline",severity:"critical",
      issue:"Branded Visibility Declining",
      explanation:`Branded impressions dropped ${Math.abs(impPct).toFixed(1)}% vs previous period. Competitors may be outbidding you on your own branded terms, pushing your ads down in search results.`,
      action:"Audit branded campaign bids — are you still winning position 1? Increase bids on exact match branded terms. Check if budget caps are limiting impression delivery.",
      impact:`${Math.abs(impPct).toFixed(1)}% fewer branded impressions — ${Math.round(Math.abs((compAgg.impressions-curAgg.impressions)))} missed exposures`,
    });
  }

  /* CVR decline — competitor landing page stealing conversions */
  const cvrPct=pct("cvr");
  if(cvrPct!==null&&cvrPct<-20){
    alerts.push({
      id:"cvr_decline",severity:"warning",
      issue:"Branded Conversion Rate Declining",
      explanation:`Branded CVR dropped ${Math.abs(cvrPct).toFixed(1)}% vs previous period. Customers searching your brand name are clicking but not buying — possible competitor conquest at the listing level or price undercutting.`,
      action:"Check your listing for recent changes (price, images, reviews). Verify Buy Box ownership. Review branded search terms for competitor ASINs appearing in results.",
      impact:`CVR drop of ${Math.abs(cvrPct).toFixed(1)}pp means ${Math.round(curAgg.clicks*(Math.abs(cvrPct)/100))} fewer orders this period`,
    });
  }

  /* Branded traffic leakage — high spend low conversion on branded */
  const bleeders=brandedRows.filter(r=>{const m=bdCalcMetrics(r,cm);return m.spend>10&&m.orders===0;});
  if(bleeders.length>0){
    const waste=bleeders.reduce((s,r)=>s+bdCalcMetrics(r,cm).spend,0);
    alerts.push({
      id:"traffic_leakage",severity:"warning",
      issue:"Branded Traffic Leakage",
      explanation:`${bleeders.length} branded keyword${bleeders.length>1?"s":""} spent $${waste.toFixed(0)} with zero conversions. Branded traffic that doesn't convert is a signal of poor match type control, low listing quality, or competitor product placements showing within your branded search.`,
      action:"Add negative keywords to prevent irrelevant branded traffic. Review the actual search terms triggering these branded keywords. Ensure product listing quality and pricing is competitive.",
      impact:`$${waste.toFixed(0)} wasted on non-converting branded terms`,
    });
  }

  /* Sales declining on brand */
  const salesPct=pct("sales");
  if(salesPct!==null&&salesPct<-15){
    alerts.push({
      id:"sales_decline",severity:"warning",
      issue:"Branded Sales Declining",
      explanation:`Branded sales dropped ${Math.abs(salesPct).toFixed(1)}% vs previous period. This may indicate competitor conquest is successfully diverting brand-loyal customers, a Buy Box issue, or deteriorating listing performance.`,
      action:"Check competitor product placements on your branded search results page. Verify Buy Box ownership and pricing competitiveness. Consider increasing branded ad budget to dominate the SERP.",
      impact:`$${Math.abs(curAgg.sales-compAgg.sales).toFixed(0)} revenue decline from branded terms`,
    });
  }

  return alerts.sort((a,b)=>{const o={critical:0,warning:1};return(o[a.severity]||2)-(o[b.severity]||2);});
}

/* Defense opportunities */
function bdOpportunities(curAgg,compAgg,brandedRows,cm){
  const opps=[];
  if(!curAgg)return opps;

  /* Low visibility profitable brand terms */
  const underExposed=brandedRows.filter(r=>{
    const m=bdCalcMetrics(r,cm);
    return m.impressions<500&&m.orders>=1&&m.acos>0&&m.acos<30;
  });
  if(underExposed.length>0){
    opps.push({
      id:"scale_branded",type:"opportunity",
      title:"Scale Profitable Branded Terms",
      why:`${underExposed.length} branded keyword${underExposed.length>1?"s":""} convert well (ACoS < 30%) but have low impressions. These are under-defended positions where competitors can enter.`,
      movement:compAgg?"Impressions below historical average on converting branded terms":null,
      action:"Increase bids by 15–25% on these branded terms. Raise campaign budgets to prevent impression throttling.",
      impact:"Higher impression share on your own branded terms — harder for competitors to appear above you",
    });
  }

  /* Branded ACoS too high — opportunity to fix efficiency */
  if(curAgg.acos>35&&curAgg.orders>0){
    opps.push({
      id:"branded_acos",type:"efficiency",
      title:"Reduce Branded ACoS",
      why:`Branded ACoS is ${curAgg.acos.toFixed(1)}% — above the 25–30% benchmark for branded defense. Branded terms should be your most efficient traffic because users already know your brand.`,
      movement:compAgg&&compAgg.acos?`Was ${compAgg.acos.toFixed(1)}% last period`:null,
      action:"Audit branded keyword match types — broad match on branded terms drives irrelevant clicks. Move to phrase and exact. Tighten negatives. Add product targeting negatives to prevent cross-ASIN waste.",
      impact:"Branded ACoS reduction of 5–10pp directly improves profitability without sacrificing volume",
    });
  }

  /* No defensive exact match campaigns detected */
  const hasCampaignTypes=brandedRows.map(r=>String(r[cm.campaign]||"").toLowerCase());
  const hasExact=brandedRows.some(r=>String(r[cm.matchType]||"").toLowerCase()==="exact");
  if(!hasExact&&brandedRows.length>0){
    opps.push({
      id:"exact_defense",type:"structure",
      title:"Add Exact Match Branded Defense Campaign",
      why:"No exact match branded keywords detected. Exact match is your strongest defensive weapon — it ensures your ad appears first when someone searches your exact brand name.",
      movement:null,
      action:"Create a dedicated branded exact match campaign with aggressive bids ($1.50–$3.00+ depending on category). This campaign should always have budget available — never let it run out mid-day.",
      impact:"Exact match branded campaigns typically achieve 2–5% ACoS and prevent competitors from dominating your branded SERP",
    });
  }

  /* High branded CPC — overpaying */
  if(curAgg.cpc>2.5&&curAgg.orders>0){
    opps.push({
      id:"cpc_control",type:"efficiency",
      title:"Branded CPC Too High",
      why:`Average branded CPC of $${curAgg.cpc.toFixed(2)} is elevated. High branded CPC usually means you're competing against yourself (keyword duplication) or bidding too aggressively without a structured match type hierarchy.`,
      movement:compAgg&&compAgg.cpc?`Up from $${compAgg.cpc.toFixed(2)} last period`:null,
      action:"Audit for duplicate branded keywords across campaigns. Structure as: Exact (high bid) → Phrase (medium) → Broad (low). Use campaign-level negatives to prevent internal cannibalization.",
      impact:`Reducing branded CPC by 20% saves ~$${(curAgg.spend*0.2).toFixed(0)} with same impression volume`,
    });
  }

  return opps;
}

/* AI brand analysis — Gemini */
async function bdAIAnalysis(curAgg,compAgg,alerts,opps,brandTerms,apiKey){
  const hasComp=!!compAgg;
  const alertSummary=alerts.map(a=>`- ${a.issue}: ${a.explanation}`).join("\n");
  const oppSummary=opps.map(o=>`- ${o.title}: ${o.why}`).join("\n");

  const prompt=`You are an Amazon PPC brand defense strategist. Analyze the following branded keyword performance data and provide a concise, actionable strategic assessment.

BRAND TERMS BEING DEFENDED: ${brandTerms.join(", ")||"(not specified)"}

CURRENT PERIOD METRICS:
- Branded Spend: $${curAgg.spend.toFixed(2)}
- Branded Sales: $${curAgg.sales.toFixed(2)}
- Branded ACoS: ${curAgg.acos.toFixed(1)}%
- Branded CPC: $${curAgg.cpc.toFixed(2)}
- Branded CTR: ${curAgg.ctr.toFixed(2)}%
- Branded CVR: ${curAgg.cvr.toFixed(1)}%
- Branded Impressions: ${Math.round(curAgg.impressions).toLocaleString()}
- Branded ROAS: ${curAgg.roas.toFixed(2)}x

${hasComp?`PREVIOUS PERIOD:
- Spend: $${compAgg.spend.toFixed(2)} | Sales: $${compAgg.sales.toFixed(2)} | ACoS: ${compAgg.acos.toFixed(1)}% | CPC: $${compAgg.cpc.toFixed(2)} | CVR: ${compAgg.cvr.toFixed(1)}%`:"No comparison period available."}

DETECTED THREATS:
${alertSummary||"No critical threats detected."}

DEFENSE OPPORTUNITIES:
${oppSummary||"No opportunities identified."}

Provide your analysis in exactly this structure:
1. OVERALL BRAND HEALTH (2 sentences — is the brand well-defended or under attack?)
2. BIGGEST THREAT (1 sentence — the most urgent issue)
3. WHERE COMPETITORS MAY BE ATTACKING (1–2 sentences — based only on the data above, no hallucinations)
4. TOP PRIORITY ACTION (1 sentence — the single most important thing to do this week)

Be direct. Be specific. Do not invent competitor names or actions not supported by the data.`;

  const res=await geminiFetch(apiKey,
    {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({contents:[{parts:[{text:prompt}]}]}),
    }
  );
  if(!res.ok){const err=await res.json();throw new Error(err?.error?.message||"Gemini API error");}
  const data=await res.json();
  return data.candidates?.[0]?.content?.parts?.[0]?.text||"Analysis unavailable.";
}

/* ── Upload Zone ────────────────────────────────────────────── */
function BDUploadZone({label,file,onFile,onClear}){
  const[drag,setDrag]=useState(false);
  const ref=useRef();
  const handle=async f=>{
    if(!f)return;
    try{const parsed=await parseSheet(f);onFile(f,parsed);}catch(e){alert("Could not read file: "+e.message);}
  };
  return(
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)} onDrop={e=>{e.preventDefault();setDrag(false);handle(e.dataTransfer.files[0]);}}
      style={{border:`2px dashed ${drag?"#4f46e5":"#e0e0e0"}`,borderRadius:10,padding:"22px 20px",background:drag?"rgba(79,70,229,0.04)":"#fafafa",cursor:"pointer",transition:"all 0.15s"}}
      onClick={()=>!file&&ref.current?.click()}>
      <input ref={ref} type="file" accept=".xlsx,.csv" style={{display:"none"}} onChange={e=>handle(e.target.files[0])}/>
      {file?(
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <i className="ti ti-file-spreadsheet" style={{fontSize:20,color:"#4f46e5"}}/>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:600,color:"#111"}}>{file.name}</div>
            <div style={{fontSize:11,color:"#888",marginTop:2}}>{label} — detected</div>
          </div>
          <button onClick={e=>{e.stopPropagation();onClear();}} style={{padding:"3px 8px",borderRadius:5,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555"}}>Remove</button>
        </div>
      ):(
        <div style={{textAlign:"center"}}>
          <i className="ti ti-cloud-upload" style={{fontSize:26,color:"#ccc",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,fontWeight:600,color:"#555",marginBottom:3}}>{label}</div>
          <div style={{fontSize:11,color:"#aaa"}}>Drag & drop or click — .xlsx or .csv</div>
        </div>
      )}
    </div>
  );
}

/* ── Upload Page ────────────────────────────────────────────── */
function BDUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[curFile,setCurFile]=useState(null);const[curParsed,setCurParsed]=useState(null);
  const[compFile,setCompFile]=useState(null);const[compParsed,setCompParsed]=useState(null);
  const[brandInput,setBrandInput]=useState("");
  const[validated,setValidated]=useState(null);
  const[localPeriods,setLocalPeriods]=useState(periods);

  const validate=parsed=>{
    const cm=bdDetectMap(parsed.headers);
    const found=Object.entries(cm).filter(([,v])=>v).map(([k])=>k);
    const score=found.length;
    const hasKey=cm.impressions&&cm.spend&&(cm.searchTerm||cm.campaign);
    return{cm,found,score,hasKey,rows:parsed.rows};
  };

  const handleCur=(f,p)=>{setCurFile(f);setCurParsed(p);const v=validate(p);setValidated(v);};
  const handleComp=(f,p)=>{setCompFile(f);setCompParsed(p);};



  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);

  const SUPPORTED=[
    {icon:"ti-search",label:"Search Term Report",note:"Customer search term data — best for branded traffic detection"},
    {icon:"ti-speakerphone",label:"Campaign Report",note:"Campaign-level performance — for branded campaign monitoring"},
    {icon:"ti-key",label:"Keyword Report / Bulk File",note:"Keyword-level data — for individual branded keyword analysis"},
  ];

  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:660,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:24}}>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Brand Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload your Amazon PPC reports to analyze branded keyword performance and detect competitor threats.</p>
        </div>

        {/* Brand terms input */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:4}}>Your Brand Terms</div>
          <div style={{fontSize:11,color:"#888",marginBottom:10}}>Comma-separated keywords that identify your brand (e.g. "quarred, quarred brand, quarred ppc")</div>
          <input
            value={brandInput}
            onChange={e=>setBrandInput(e.target.value)}
            placeholder="your brand, brand name, brand variation..."
            style={{width:"100%",boxSizing:"border-box",padding:"8px 12px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:13,fontFamily:"inherit",outline:"none"}}
          />
        </div>

        {/* Current period */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:3}}>Current Period Report <span style={{color:"#4f46e5"}}>*</span></div>
          <div style={{fontSize:11,color:"#888",marginBottom:12}}>Search term report, keyword report, or bulk file from the period you want to analyze</div>
          <BDUploadZone label="Current Period" file={curFile} onFile={handleCur} onClear={()=>{setCurFile(null);setCurParsed(null);setValidated(null);}}/>
          {validated&&(
            <div style={{marginTop:10,padding:"10px 12px",borderRadius:7,background:validated.hasKey?"rgba(26,122,60,0.07)":"rgba(196,122,0,0.07)",border:`1px solid ${validated.hasKey?"rgba(26,122,60,0.2)":"rgba(196,122,0,0.2)"}`}}>
              <div style={{fontSize:12,fontWeight:600,color:validated.hasKey?"#1a7a3c":"#c47a00",marginBottom:4}}>
                <i className={`ti ${validated.hasKey?"ti-check":"ti-alert-triangle"}`} style={{marginRight:5}}/>
                {validated.hasKey?"Report validated successfully":"Partial data detected"}
              </div>
              <div style={{fontSize:11,color:"#555"}}>{validated.rows.length.toLocaleString()} rows · {validated.found.length} columns mapped: {validated.found.join(", ")}</div>
            </div>
          )}
        </div>

        {/* Comparison period */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:3}}>Comparison Period Report <span style={{fontSize:11,color:"#aaa",fontWeight:400}}>(optional)</span></div>
          <div style={{fontSize:11,color:"#888",marginBottom:12}}>Same report type from the previous period — enables delta analysis on every metric</div>
          <BDUploadZone label="Previous Period" file={compFile} onFile={handleComp} onClear={()=>{setCompFile(null);setCompParsed(null);}}/>
        </div>

        {/* Supported reports */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:20}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:12}}>Supported Report Types</div>
          {SUPPORTED.map((s,i)=>(
            <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:i<SUPPORTED.length-1?10:0}}>
              <i className={`ti ${s.icon}`} style={{fontSize:14,color:"#4f46e5",flexShrink:0,marginTop:1}}/>
              <div>
                <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{s.label}</div>
                <div style={{fontSize:11,color:"#888"}}>{s.note}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:4}}>
        <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
        {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
      </div>
      <button
          onClick={()=>{const brandTerms=brandInput.split(",").map(s=>s.trim()).filter(Boolean);const cm=bdDetectMap(curParsed.headers);onComplete({curRows:curParsed.rows,compRows:compParsed?.rows||null,cm,compCm:compParsed?bdDetectMap(compParsed.headers):null,brandTerms,periods:localPeriods});}}
          disabled={!curParsed||!brandInput.trim()}
          style={{width:"100%",padding:"12px",borderRadius:9,border:"none",background:curParsed&&brandInput.trim()?"#4f46e5":"#e0e0e0",color:curParsed&&brandInput.trim()?"#fff":"#aaa",fontSize:14,fontWeight:700,cursor:curParsed&&brandInput.trim()?"pointer":"not-allowed",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          <i className="ti ti-shield-check" style={{fontSize:15}}/>
          Open Defense Workspace
        </button>
      </div>
    </div>
  );
}

/* ── KPI Overview Bar ───────────────────────────────────────── */
function BDOverviewBar({cur,comp}){
  const KPIS=[
    {key:"spend",label:"Branded Spend",fmt:v=>`$${v>=1e3?(v/1e3).toFixed(1)+"K":v.toFixed(2)}`,lowerBetter:true},
    {key:"sales",label:"Branded Sales",fmt:v=>`$${v>=1e3?(v/1e3).toFixed(1)+"K":v.toFixed(2)}`,lowerBetter:false},
    {key:"acos",label:"Branded ACoS",fmt:v=>`${v.toFixed(1)}%`,lowerBetter:true,isPp:true},
    {key:"cpc",label:"Branded CPC",fmt:v=>`$${v.toFixed(2)}`,lowerBetter:true},
    {key:"ctr",label:"Branded CTR",fmt:v=>`${v.toFixed(2)}%`,lowerBetter:false,isPp:true},
    {key:"cvr",label:"Branded CVR",fmt:v=>`${v.toFixed(1)}%`,lowerBetter:false,isPp:true},
    {key:"impressions",label:"Impressions",fmt:v=>v>=1e6?(v/1e6).toFixed(2)+"M":v>=1e3?(v/1e3).toFixed(1)+"K":String(Math.round(v)),lowerBetter:false},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:8,marginBottom:18}}>
      {KPIS.map(k=>{
        const cur_v=cur?.[k.key]??0;
        const comp_v=comp?.[k.key]??null;
        const delta=comp_v!=null?(k.isPp?cur_v-comp_v:((cur_v-comp_v)/Math.abs(comp_v||1))*100):null;
        const good=delta!=null?(k.lowerBetter?delta<0:delta>0):null;
        return(
          <div key={k.key} style={{background:"#fff",borderRadius:10,border:"1px solid #eee",padding:"12px 14px"}}>
            <div style={{fontSize:10,color:"#888",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:6}}>{k.label}</div>
            <div style={{fontSize:17,fontWeight:800,color:"#111",marginBottom:3}}>{k.fmt(cur_v)}</div>
            {comp_v!=null&&(
              <div style={{display:"flex",alignItems:"center",gap:3}}>
                <span style={{fontSize:10,color:good?"#1a7a3c":good===false?"#d42b2b":"#888",fontWeight:700}}>
                  {delta>0?"+":""}{k.isPp?delta.toFixed(1)+"pp":delta.toFixed(1)+"%"}
                </span>
                <i className={`ti ${delta>0?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:9,color:good?"#1a7a3c":good===false?"#d42b2b":"#888"}}/>
              </div>
            )}
            {comp_v!=null&&<div style={{fontSize:9,color:"#bbb",marginTop:1}}>prev: {k.fmt(comp_v)}</div>}
          </div>
        );
      })}
    </div>
  );
}

/* ── Alert Card ─────────────────────────────────────────────── */
function BDAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const SC={critical:{color:"#d42b2b",bg:"rgba(212,43,43,0.08)",icon:"ti-alert-octagon"},warning:{color:"#c47a00",bg:"rgba(196,122,0,0.08)",icon:"ti-alert-triangle"}};
  const s=SC[a.severity]||SC.warning;
  return(
    <div style={{background:"#fff",borderRadius:10,border:`1px solid ${s.color}22`,marginBottom:10,overflow:"hidden"}}>
      <div onClick={()=>setOpen(o=>!o)} style={{display:"flex",alignItems:"center",gap:10,padding:"13px 16px",cursor:"pointer",background:s.bg}}>
        <i className={`ti ${s.icon}`} style={{fontSize:16,color:s.color,flexShrink:0}}/>
        <div style={{flex:1}}>
          <div style={{fontSize:13,fontWeight:700,color:s.color}}>{a.issue}</div>
          <div style={{fontSize:11,color:"#666",marginTop:1}}>{a.impact}</div>
        </div>
        <span style={{fontSize:9,padding:"2px 7px",borderRadius:4,background:s.color,color:"#fff",fontWeight:700,textTransform:"uppercase"}}>{a.severity}</span>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#aaa"}}/>
      </div>
      {open&&(
        <div style={{padding:"14px 16px",borderTop:"1px solid #f0f0f0"}}>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:10}}>{a.explanation}</div>
          <div style={{background:"rgba(79,70,229,0.05)",borderRadius:7,padding:"10px 12px",borderLeft:"3px solid #4f46e5"}}>
            <div style={{fontSize:10,fontWeight:700,color:"#4f46e5",marginBottom:3,textTransform:"uppercase",letterSpacing:"0.5px"}}>Suggested Action</div>
            <div style={{fontSize:12,color:"#333",lineHeight:1.5}}>{a.action}</div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Opportunity Card ───────────────────────────────────────── */
function BDOppCard({opp:o}){
  const[open,setOpen]=useState(false);
  const TC={opportunity:{color:"#1a7a3c",bg:"rgba(26,122,60,0.07)",icon:"ti-rocket"},efficiency:{color:"#1a5fa0",bg:"rgba(26,95,160,0.07)",icon:"ti-adjustments"},structure:{color:"#6338c8",bg:"rgba(99,56,200,0.07)",icon:"ti-sitemap"}};
  const s=TC[o.type]||TC.opportunity;
  return(
    <div style={{background:"#fff",borderRadius:10,border:"1px solid #eee",marginBottom:10,overflow:"hidden"}}>
      <div onClick={()=>setOpen(v=>!v)} style={{display:"flex",alignItems:"center",gap:10,padding:"13px 16px",cursor:"pointer"}}>
        <div style={{width:32,height:32,borderRadius:8,background:s.bg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${s.icon}`} style={{fontSize:14,color:s.color}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{o.title}</div>
          {o.movement&&<div style={{fontSize:11,color:"#888",marginTop:1}}>{o.movement}</div>}
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#aaa"}}/>
      </div>
      {open&&(
        <div style={{padding:"0 16px 14px",borderTop:"1px solid #f5f5f5"}}>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8,paddingTop:10}}>{o.why}</div>
          <div style={{background:"rgba(26,122,60,0.05)",borderRadius:7,padding:"10px 12px",borderLeft:"3px solid #1a7a3c",marginBottom:6}}>
            <div style={{fontSize:10,fontWeight:700,color:"#1a7a3c",marginBottom:2,textTransform:"uppercase",letterSpacing:"0.5px"}}>Action</div>
            <div style={{fontSize:12,color:"#333",lineHeight:1.5}}>{o.action}</div>
          </div>
          <div style={{fontSize:11,color:"#888"}}><strong>Expected impact:</strong> {o.impact}</div>
        </div>
      )}
    </div>
  );
}

/* ── Branded Keyword Table ──────────────────────────────────── */
function BDKeywordTable({rows,cm,compMap,brandTerms,filters}){
  const[sort,setSort]=useState({col:"spend",dir:"desc"});
  const[page,setPage]=useState(0);const PER=25;

  const processed=useMemo(()=>{
    return rows
      .filter(r=>{
        const term=String(r[cm.searchTerm]||r[cm.campaign]||"");
        if(!isBranded(term,brandTerms))return false;
        const m=bdCalcMetrics(r,cm);
        if(filters.minAcos&&m.acos<parseFloat(filters.minAcos))return false;
        if(filters.maxAcos&&m.acos>parseFloat(filters.maxAcos))return false;
        if(filters.maxCpc&&m.cpc>parseFloat(filters.maxCpc))return false;
        if(filters.keyword&&!term.toLowerCase().includes(filters.keyword.toLowerCase()))return false;
        if(filters.matchType&&filters.matchType!=="all"){
          const mt=String(r[cm.matchType]||"").toLowerCase();
          if(mt!==filters.matchType.toLowerCase())return false;
        }
        return true;
      })
      .map(r=>{
        const term=String(r[cm.searchTerm]||r[cm.campaign]||"—");
        const m=bdCalcMetrics(r,cm);
        const key=term.toLowerCase().trim();
        const comp=compMap?.[key];
        const score=bdDefenseScore(m);
        const action=m.acos>50?"Reduce bid 20%+":m.spend>10&&m.orders===0?"Pause / add negatives":m.impressions<300&&m.orders>0?"Increase bid 15–25%":m.acos<20&&m.orders>=2?"Scale bid":"Monitor";
        return{term,m,comp,score,action,matchType:String(r[cm.matchType]||"—"),campaign:String(r[cm.campaign]||"—")};
      })
      .sort((a,b)=>{
        const av=a.m[sort.col]??a.score??0,bv=b.m[sort.col]??b.score??0;
        return sort.dir==="asc"?av-bv:bv-av;
      });
  },[rows,cm,compMap,brandTerms,filters,sort]);

  const paged=processed.slice(page*PER,(page+1)*PER);
  const pages=Math.ceil(processed.length/PER);

  const th=(col,label)=>(
    <th onClick={()=>setSort(s=>({col,dir:s.col===col&&s.dir==="desc"?"asc":"desc"}))}
      style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"right",cursor:"pointer",whiteSpace:"nowrap",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px",userSelect:"none"}}>
      {label}{sort.col===col?<i className={`ti ${sort.dir==="asc"?"ti-chevron-up":"ti-chevron-down"}`} style={{marginLeft:3,fontSize:8}}/>:null}
    </th>
  );

  const delta=(cur,prev,lowerBetter=false,isPp=false)=>{
    if(prev==null||prev===0)return null;
    const d=isPp?cur-prev:((cur-prev)/Math.abs(prev))*100;
    const good=lowerBetter?d<0:d>0;
    return<span style={{fontSize:9,color:good?"#1a7a3c":"#d42b2b",fontWeight:600,marginLeft:3}}>{d>0?"+":""}{isPp?d.toFixed(1)+"pp":d.toFixed(1)+"%"}</span>;
  };

  const scoreColor=s=>s>=75?"#1a7a3c":s>=50?"#c47a00":"#d42b2b";

  if(!processed.length)return(
    <div style={{textAlign:"center",padding:"40px 20px",color:"#aaa"}}>
      <i className="ti ti-search-off" style={{fontSize:32,display:"block",marginBottom:8}}/>
      <div style={{fontSize:13}}>No branded keywords matched your filters.</div>
      <div style={{fontSize:11,marginTop:4}}>Check your brand terms or adjust filters.</div>
    </div>
  );

  return(
    <div>
      <div style={{fontSize:12,color:"#888",marginBottom:8}}>{processed.length} branded keyword{processed.length!==1?"s":""} · showing {page*PER+1}–{Math.min((page+1)*PER,processed.length)}</div>
      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #eee"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr>
              <th style={{padding:"8px 12px",fontSize:10,fontWeight:700,color:"#888",textAlign:"left",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Keyword / Term</th>
              <th style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"left",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Match</th>
              {th("spend","Spend")}{th("sales","Sales")}{th("acos","ACoS")}{th("cpc","CPC")}{th("ctr","CTR")}{th("cvr","CVR")}{th("impressions","Impr.")}
              <th style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"center",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Defense</th>
              <th style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"left",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Action</th>
            </tr>
          </thead>
          <tbody>
            {paged.map((row,i)=>{
              const m=row.m,c=row.comp;
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"9px 12px"}}>
                    <div style={{fontWeight:600,color:"#111",fontSize:12,maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.term}</div>
                    <div style={{fontSize:10,color:"#bbb",marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.campaign}</div>
                  </td>
                  <td style={{padding:"9px 10px"}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:"rgba(79,70,229,0.08)",color:"#4f46e5",fontWeight:700}}>{row.matchType}</span></td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}><span style={{fontWeight:600}}>${m.spend>=1e3?(m.spend/1e3).toFixed(1)+"K":m.spend.toFixed(2)}</span>{c&&delta(m.spend,c.spend,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}><span style={{fontWeight:600}}>${m.sales>=1e3?(m.sales/1e3).toFixed(1)+"K":m.sales.toFixed(2)}</span>{c&&delta(m.sales,c.sales)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}><span style={{fontWeight:600,color:m.acos>40?"#d42b2b":m.acos>25?"#c47a00":"#1a7a3c"}}>{m.acos.toFixed(1)}%</span>{c&&delta(m.acos,c.acos,true,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}><span style={{fontWeight:600}}>${m.cpc.toFixed(2)}</span>{c&&delta(m.cpc,c.cpc,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>{m.ctr.toFixed(2)}%{c&&delta(m.ctr,c.ctr,false,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>{m.cvr.toFixed(1)}%{c&&delta(m.cvr,c.cvr,false,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>{m.impressions>=1e3?(m.impressions/1e3).toFixed(1)+"K":Math.round(m.impressions)}{c&&delta(m.impressions,c.impressions)}</td>
                  <td style={{padding:"9px 10px",textAlign:"center"}}>
                    <div style={{width:32,height:32,borderRadius:"50%",background:`${scoreColor(row.score)}18`,border:`2px solid ${scoreColor(row.score)}`,display:"inline-flex",alignItems:"center",justifyContent:"center"}}>
                      <span style={{fontSize:9,fontWeight:800,color:scoreColor(row.score)}}>{row.score}</span>
                    </div>
                  </td>
                  <td style={{padding:"9px 10px",fontSize:11,color:"#555",whiteSpace:"nowrap"}}>{row.action}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {pages>1&&(
        <div style={{display:"flex",gap:6,justifyContent:"center",marginTop:12}}>
          {Array.from({length:pages},(_,i)=>(
            <button key={i} onClick={()=>setPage(i)} style={{padding:"4px 10px",borderRadius:5,border:"1px solid #e0e0e0",background:page===i?"#4f46e5":"#fff",color:page===i?"#fff":"#555",cursor:"pointer",fontSize:11,fontWeight:page===i?700:400}}>{i+1}</button>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── AI Assistant Panel (Gemini) ────────────────────────────── */
function BDAIPanel({curAgg,compAgg,alerts,opps,brandTerms}){
  const[analysis,setAnalysis]=useState(null);
  const[loading,setLoading]=useState(false);
  const[error,setError]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);
  const[keySaved,setKeySaved]=useState(false);

  const run=async()=>{
    if(!apiKey.trim()){setError("Set your Gemini API key in Settings → AI Settings to use this feature.");return;}
    setLoading(true);setError(null);
    try{
      const txt=await bdAIAnalysis(curAgg,compAgg,alerts,opps,brandTerms,apiKey.trim());
      setAnalysis(txt);setKeySaved(true);
    }
    catch(e){setError("Error: "+e.message+". Check your API key and try again.");}
    finally{setLoading(false);}
  };

  return(
    <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:18}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
        <div style={{width:28,height:28,borderRadius:7,background:"rgba(99,56,200,0.1)",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <i className="ti ti-brain" style={{fontSize:14,color:"#6338c8"}}/>
        </div>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"#111"}}>AI Brand Defense Assistant</div>
          <div style={{fontSize:11,color:"#888"}}>Powered by Gemini · analysis based on your uploaded data only</div>
        </div>
      </div>

      {/* API Key input */}
      {!keySaved&&(
        <div style={{background:"#fafafa",borderRadius:8,border:"1px solid #eee",padding:"12px 14px",marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:6,display:"flex",alignItems:"center",gap:5}}>
            <i className="ti ti-key" style={{fontSize:11,color:"#4f46e5"}}/>
            Gemini API Key <span style={{fontWeight:400,color:"#aaa"}}>(stored in memory only — not saved anywhere)</span>
          </div>
          <div style={{display:"flex",gap:6}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <div style={{fontSize:10,color:"#bbb",marginTop:5}}>Get your key at aistudio.google.com → API Keys</div>
        </div>
      )}

      {/* Run button */}
      {!analysis&&(
        <button onClick={run} disabled={loading||!apiKey} style={{width:"100%",padding:"9px",borderRadius:7,border:"none",background:loading||!apiKey?"#e0e0e0":"#6338c8",color:loading||!apiKey?"#aaa":"#fff",fontSize:13,fontWeight:700,cursor:loading||!apiKey?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6,marginBottom:10}}>
          {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analyzing with Gemini...</>:<><i className="ti ti-sparkles" style={{fontSize:13}}/>Run AI Analysis</>}
        </button>
      )}

      {/* Error */}
      {error&&<div style={{fontSize:12,color:"#d42b2b",padding:"8px 12px",background:"rgba(212,43,43,0.06)",borderRadius:7,marginBottom:10}}><i className="ti ti-alert-circle" style={{marginRight:5}}/>{error}</div>}

      {/* Analysis result */}
      {analysis&&(
        <div>
          <div style={{fontSize:13,color:"#333",lineHeight:1.8,whiteSpace:"pre-wrap",background:"rgba(99,56,200,0.04)",borderRadius:8,padding:"14px 16px",borderLeft:"3px solid #6338c8",marginBottom:10}}>
            {analysis}
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>{setAnalysis(null);setKeySaved(false);}} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>
              <i className="ti ti-refresh" style={{marginRight:4}}/>Refresh
            </button>
            <button onClick={()=>{setAnalysis(null);}} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>
              Change Key
            </button>
          </div>
        </div>
      )}

      {!analysis&&!loading&&!error&&(
        <div style={{fontSize:12,color:"#aaa",fontStyle:"italic"}}>Enter your Gemini API key and click Run to get a strategic brand defense assessment.</div>
      )}
    </div>
  );
}

/* ── Workspace ──────────────────────────────────────────────── */
function BDWorkspace({curRows,compRows,cm,compCm,brandTerms,onReupload,onExport}){
  const[filters,setFilters]=useState({keyword:"",matchType:"all",minAcos:"",maxAcos:"",maxCpc:"",severity:"all"});
  const[showFilters,setShowFilters]=useState(false);
  const[activeTab,setActiveTab]=useState("overview");

  /* Compute branded subsets */
  const brandedRows=useMemo(()=>curRows.filter(r=>{
    const term=String(r[cm.searchTerm]||r[cm.campaign]||"");
    return isBranded(term,brandTerms);
  }),[curRows,cm,brandTerms]);

  const brandedCompRows=useMemo(()=>(compRows||[]).filter(r=>{
    const term=String(r[compCm?.searchTerm||cm.searchTerm]||r[compCm?.campaign||cm.campaign]||"");
    return isBranded(term,brandTerms);
  }),[compRows,compCm,cm,brandTerms]);

  const curAgg=useMemo(()=>bdSumAgg(brandedRows,cm),[brandedRows,cm]);
  const compAgg=useMemo(()=>brandedCompRows.length?bdSumAgg(brandedCompRows,compCm||cm):null,[brandedCompRows,compCm,cm]);

  /* Build comp lookup map by term */
  const compMap=useMemo(()=>{
    if(!brandedCompRows.length)return null;
    const m={};
    brandedCompRows.forEach(r=>{
      const term=String(r[(compCm||cm).searchTerm]||r[(compCm||cm).campaign]||"").toLowerCase().trim();
      if(!term)return;
      const metrics=bdCalcMetrics(r,compCm||cm);
      m[term]=metrics;
    });
    return m;
  },[brandedCompRows,compCm,cm]);

  const alerts=useMemo(()=>bdDetectAttacks(curAgg,compAgg,brandedRows,cm),[curAgg,compAgg,brandedRows,cm]);
  const opps=useMemo(()=>bdOpportunities(curAgg,compAgg,brandedRows,cm),[curAgg,compAgg,brandedRows,cm]);

  /* Traffic share */
  const totalAgg=useMemo(()=>bdSumAgg(curRows,cm),[curRows,cm]);
  const trafficShare=totalAgg.impressions>0?((curAgg.impressions/totalAgg.impressions)*100):0;

  const TABS=[
    {key:"overview",label:"Overview",icon:"ti-layout-dashboard"},
    {key:"threats",label:`Threats${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-octagon"},
    {key:"keywords",label:"Keywords",icon:"ti-key"},
    {key:"opportunities",label:`Opportunities${opps.length?` (${opps.length})`:""}`,icon:"ti-rocket"},
    {key:"ai",label:"AI Analysis",icon:"ti-brain"},
  ];

  return(
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f7f7f7"}}>
      {/* Sub-nav */}
      <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",padding:"0 24px",display:"flex",alignItems:"center",gap:0,flexShrink:0}}>
        {TABS.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"12px 16px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:400,color:activeTab===t.key?"#4f46e5":"#888",borderBottom:activeTab===t.key?"2.5px solid #4f46e5":"2.5px solid transparent",display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:12}}/>{t.label}
          </button>
        ))}
        <div style={{flex:1}}/>
        <button onClick={()=>setShowFilters(v=>!v)} style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:showFilters?"#f0f0f0":"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5}}>
          <i className="ti ti-filter" style={{fontSize:11}}/>Filters
        </button>
        <button onClick={onReupload} style={{marginLeft:8,padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5}}>
          <i className="ti ti-upload" style={{fontSize:11}}/>New Upload
        </button>
        <button onClick={()=>onExport(brandedRows,curAgg,compAgg,alerts,opps,cm,brandTerms)} style={{marginLeft:8,padding:"6px 12px",borderRadius:7,border:"none",background:"#4f46e5",cursor:"pointer",fontSize:11,color:"#fff",fontWeight:700,display:"flex",alignItems:"center",gap:5}}>
          <i className="ti ti-download" style={{fontSize:11}}/>Export
        </button>
      </div>

      {/* Filters bar */}
      {showFilters&&(
        <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",padding:"12px 24px",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",flexShrink:0}}>
          <input placeholder="Filter keyword..." value={filters.keyword} onChange={e=>setFilters(f=>({...f,keyword:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:160,fontFamily:"inherit"}}/>
          <select value={filters.matchType} onChange={e=>setFilters(f=>({...f,matchType:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,fontFamily:"inherit"}}>
            <option value="all">All Match Types</option>
            <option value="exact">Exact</option>
            <option value="phrase">Phrase</option>
            <option value="broad">Broad</option>
          </select>
          <input placeholder="Min ACoS %" value={filters.minAcos} onChange={e=>setFilters(f=>({...f,minAcos:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:90,fontFamily:"inherit"}}/>
          <input placeholder="Max ACoS %" value={filters.maxAcos} onChange={e=>setFilters(f=>({...f,maxAcos:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:90,fontFamily:"inherit"}}/>
          <input placeholder="Max CPC $" value={filters.maxCpc} onChange={e=>setFilters(f=>({...f,maxCpc:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:90,fontFamily:"inherit"}}/>
          <button onClick={()=>setFilters({keyword:"",matchType:"all",minAcos:"",maxAcos:"",maxCpc:"",severity:"all"})} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>Clear</button>
        </div>
      )}

      {/* Content */}
      <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>

        {/* Brand terms pill */}
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:16,flexWrap:"wrap"}}>
          <span style={{fontSize:11,color:"#888",fontWeight:600}}>Defending:</span>
          {brandTerms.map((t,i)=>(
            <span key={i} style={{fontSize:11,padding:"2px 9px",borderRadius:10,background:"rgba(79,70,229,0.08)",color:"#4f46e5",fontWeight:600,border:"1px solid rgba(79,70,229,0.15)"}}>{t}</span>
          ))}
          <span style={{fontSize:11,color:"#aaa",marginLeft:4}}>{brandedRows.length} branded rows · {trafficShare.toFixed(1)}% of total impressions</span>
        </div>

        {/* OVERVIEW TAB */}
        {activeTab==="overview"&&(
          <>
            <div style={{padding:"16px 20px 0",background:"#f7f7f7"}}>
              <ModuleOverview
                moduleName="Brand Defense" moduleIcon="ti-shield" periods={null}
                cur={curAgg} comp={compAgg?.spend>0?compAgg:null}
                rows={brandedRows||[]}
                alerts={(alerts||[]).slice(0,3).map(a=>({type:a.severity==="critical"?"critical":"loss",icon:"ti-shield",title:a.title,detail:a.explanation||""}))}
              />
            </div>
            <BDOverviewBar cur={curAgg} comp={compAgg}/>
            {/* Traffic share widget */}
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 20px",marginBottom:18}}>
              <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Branded Traffic Share</div>
              <div style={{display:"flex",alignItems:"center",gap:14}}>
                <div style={{flex:1,height:10,borderRadius:5,background:"#f0f0f0",overflow:"hidden"}}>
                  <div style={{width:`${Math.min(100,trafficShare)}%`,height:"100%",background:"#4f46e5",borderRadius:5,transition:"width 0.3s"}}/>
                </div>
                <span style={{fontSize:15,fontWeight:800,color:"#4f46e5",minWidth:50}}>{trafficShare.toFixed(1)}%</span>
                <span style={{fontSize:11,color:"#aaa"}}>of total impressions</span>
              </div>
              <div style={{fontSize:11,color:"#888",marginTop:8}}>
                {trafficShare<10?"Low branded share — branded campaigns may need budget increase":trafficShare<25?"Moderate branded share — monitor for competitor encroachment":"Strong branded presence — maintain and defend"}
              </div>
            </div>
            {/* Quick summary */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px"}}>
                <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
                  <i className="ti ti-alert-octagon" style={{color:"#d42b2b",fontSize:13}}/>Active Threats
                </div>
                {alerts.length===0?<div style={{fontSize:12,color:"#aaa"}}>No threats detected in current data.</div>:alerts.slice(0,3).map(a=>(
                  <div key={a.id} style={{fontSize:12,color:"#444",padding:"6px 0",borderBottom:"1px solid #f5f5f5",display:"flex",gap:8,alignItems:"flex-start"}}>
                    <span style={{width:6,height:6,borderRadius:"50%",background:a.severity==="critical"?"#d42b2b":"#c47a00",flexShrink:0,marginTop:4}}/>
                    {a.issue}
                  </div>
                ))}
                {alerts.length>3&&<div style={{fontSize:11,color:"#4f46e5",marginTop:6,cursor:"pointer"}} onClick={()=>setActiveTab("threats")}>+{alerts.length-3} more threats →</div>}
              </div>
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px"}}>
                <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
                  <i className="ti ti-rocket" style={{color:"#1a7a3c",fontSize:13}}/>Defense Opportunities
                </div>
                {opps.length===0?<div style={{fontSize:12,color:"#aaa"}}>No opportunities identified yet.</div>:opps.slice(0,3).map(o=>(
                  <div key={o.id} style={{fontSize:12,color:"#444",padding:"6px 0",borderBottom:"1px solid #f5f5f5",display:"flex",gap:8,alignItems:"flex-start"}}>
                    <span style={{width:6,height:6,borderRadius:"50%",background:"#1a7a3c",flexShrink:0,marginTop:4}}/>
                    {o.title}
                  </div>
                ))}
                {opps.length>3&&<div style={{fontSize:11,color:"#1a7a3c",marginTop:6,cursor:"pointer"}} onClick={()=>setActiveTab("opportunities")}>+{opps.length-3} more →</div>}
              </div>
            </div>
          </>
        )}

        {/* THREATS TAB */}
        {activeTab==="threats"&&(
          <>
            <div style={{fontSize:13,color:"#666",marginBottom:14}}>
              {alerts.length===0?"No competitor threats detected in your current branded data.":
              `${alerts.length} threat${alerts.length!==1?"s":""} detected — click each to see the full explanation and suggested action.`}
            </div>
            {alerts.map(a=><BDAlertCard key={a.id} alert={a}/>)}
            {alerts.length===0&&(
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"32px",textAlign:"center"}}>
                <i className="ti ti-shield-check" style={{fontSize:36,color:"#1a7a3c",display:"block",marginBottom:10}}/>
                <div style={{fontSize:14,fontWeight:700,color:"#111",marginBottom:4}}>Brand Well-Defended</div>
                <div style={{fontSize:12,color:"#888"}}>No critical competitor threats detected in the current period. Continue monitoring weekly.</div>
              </div>
            )}
          </>
        )}

        {/* KEYWORDS TAB */}
        {activeTab==="keywords"&&(
          <BDKeywordTable rows={curRows} cm={cm} compMap={compMap} brandTerms={brandTerms} filters={filters}/>
        )}

        {/* OPPORTUNITIES TAB */}
        {activeTab==="opportunities"&&(
          <>
            <div style={{fontSize:13,color:"#666",marginBottom:14}}>
              {opps.length===0?"No defense opportunities detected yet.":
              `${opps.length} defense opportunit${opps.length!==1?"ies":"y"} identified — prioritized by impact.`}
            </div>
            {opps.map(o=><BDOppCard key={o.id} opp={o}/>)}
          </>
        )}

        {/* AI TAB */}
        {activeTab==="ai"&&(
          <BDAIPanel curAgg={curAgg} compAgg={compAgg} alerts={alerts} opps={opps} brandTerms={brandTerms}/>
        )}
      </div>
    </div>
  );
}

/* ── Export Page ────────────────────────────────────────────── */
function BDExportPage({brandedRows,curAgg,compAgg,alerts,opps,cm,brandTerms,onBack}){
  function doExport(){
    const wb=XLSX.utils.book_new();

    /* Sheet 1: Branded keyword actions */
    const h1=["Keyword / Term","Campaign","Match Type","Spend","Sales","ACoS%","CPC","CTR%","CVR%","Impressions","Defense Score","Suggested Action"];
    const r1=brandedRows.map(r=>{
      const term=String(r[cm.searchTerm]||r[cm.campaign]||"");
      const m=bdCalcMetrics(r,cm);
      const score=bdDefenseScore(m);
      const action=m.acos>50?"Reduce bid 20%+":m.spend>10&&m.orders===0?"Pause / add negatives":m.impressions<300&&m.orders>0?"Increase bid 15–25%":m.acos<20&&m.orders>=2?"Scale bid":"Monitor";
      return{"Keyword / Term":term,"Campaign":String(r[cm.campaign]||""),"Match Type":String(r[cm.matchType]||""),"Spend":m.spend.toFixed(2),"Sales":m.sales.toFixed(2),"ACoS%":m.acos.toFixed(1),"CPC":m.cpc.toFixed(2),"CTR%":m.ctr.toFixed(2),"CVR%":m.cvr.toFixed(1),"Impressions":Math.round(m.impressions),"Defense Score":score,"Suggested Action":action};
    });
    const ws1=XLSX.utils.json_to_sheet(r1,{header:h1});ws1["!cols"]=h1.map(()=>({wch:20}));
    XLSX.utils.book_append_sheet(wb,ws1,"Branded Keyword Actions");

    /* Sheet 2: Threat alerts */
    if(alerts.length){
      const h2=["Threat","Severity","Explanation","Suggested Action","Estimated Impact"];
      const r2=alerts.map(a=>({Threat:a.issue,Severity:a.severity,Explanation:a.explanation,"Suggested Action":a.action,"Estimated Impact":a.impact}));
      const ws2=XLSX.utils.json_to_sheet(r2,{header:h2});ws2["!cols"]=h2.map(()=>({wch:30}));
      XLSX.utils.book_append_sheet(wb,ws2,"Competitor Threats");
    }

    /* Sheet 3: Defense opportunities */
    if(opps.length){
      const h3=["Opportunity","Type","Why","Action","Expected Impact"];
      const r3=opps.map(o=>({Opportunity:o.title,Type:o.type,Why:o.why,Action:o.action,"Expected Impact":o.impact}));
      const ws3=XLSX.utils.json_to_sheet(r3,{header:h3});ws3["!cols"]=h3.map(()=>({wch:30}));
      XLSX.utils.book_append_sheet(wb,ws3,"Defense Opportunities");
    }

    /* Sheet 4: Negative targeting sheet template */
    const h4=["Campaign Name","Ad Group Name","Keyword / ASIN","Match Type","Operation","Notes"];
    const r4=brandedRows
      .filter(r=>{const m=bdCalcMetrics(r,cm);return m.spend>5&&m.orders===0;})
      .map(r=>({
        "Campaign Name":String(r[cm.campaign]||""),
        "Ad Group Name":String(r[cm.adGroup]||""),
        "Keyword / ASIN":String(r[cm.searchTerm]||""),
        "Match Type":"NEGATIVE EXACT",
        "Operation":"create",
        "Notes":"Auto-flagged: branded spend, zero conversions",
      }));
    if(r4.length){const ws4=XLSX.utils.json_to_sheet(r4,{header:h4});ws4["!cols"]=h4.map(()=>({wch:26}));XLSX.utils.book_append_sheet(wb,ws4,"Negative Targeting Sheet");}

    XLSX.writeFile(wb,`Quarred_BrandDefense_${new Date().toISOString().slice(0,10)}.xlsx`);
  }

  const criticalCount=alerts.filter(a=>a.severity==="critical").length;
  const negCount=brandedRows.filter(r=>{const m=bdCalcMetrics(r,cm);return m.spend>5&&m.orders===0;}).length;

  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:660,margin:"0 auto",padding:"32px 24px"}}>
        <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:16}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace</button>
        <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Defense Actions</h2>
        <p style={{fontSize:13,color:"#666",margin:"0 0 22px"}}>Amazon-ready workbook with branded keyword actions, threat alerts, and negative targeting recommendations.</p>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Export Summary</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
            {[
              {label:"Branded Keywords",val:brandedRows.length,color:"#555"},
              {label:"Critical Threats",val:criticalCount,color:"#d42b2b"},
              {label:"Opportunities",val:opps.length,color:"#1a7a3c"},
              {label:"Negative Targets",val:negCount,color:"#c47a00"},
            ].map(s=>(
              <div key={s.label} style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div>
                <div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{fontSize:12,color:"#555",marginBottom:14,lineHeight:1.6}}>
            Export includes: Branded Keyword Actions · Competitor Threats · Defense Opportunities{negCount>0?" · Negative Targeting Sheet":""}.
          </div>
          <button onClick={doExport} style={{width:"100%",padding:"12px",borderRadius:9,border:"none",background:"#4f46e5",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
            <i className="ti ti-download" style={{fontSize:14}}/> Download Brand Defense Workbook
          </button>
        </div>
        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>Brand defense best practices</div>
          {[
            "Branded exact match campaigns should always have budget — never let them go dark mid-day",
            "Target branded CPC below $1.50 for most categories — above $2.50 signals competitive pressure",
            "Branded ACoS should be 15–30% — if it's higher, fix match types before scaling spend",
            "Review branded terms weekly — competitor activity can change overnight",
            "Zero-conversion branded spend is almost always a match type or negative keyword problem",
          ].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}>
              <span style={{width:17,height:17,borderRadius:"50%",background:"#4f46e5",color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span>
              <span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Module Root ────────────────────────────────────────────── */
function BrandDefenseModule({globalData,setTab}){
  const[page,setPage]=useState("upload");
  const[periods,setPeriods]=useState(globalData?.periods||null);
  const[data,setData]=useState(null);
  const[exportArgs,setExportArgs]=useState(null);
  useEffect(()=>{if(globalData?.cur?.primary&&!data&&page==="upload"){const cm=globalData.cur.primary.cm;setData({curRows:globalData.cur.primary.rows,compRows:globalData.comp?.primary?.rows||null,cm,compCm:globalData.comp?.primary?.cm||null,brandTerms:[],periods:globalData.periods});setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);

  if(page==="export"&&exportArgs){
    return(
      <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
        <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}>
          <h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Brand Defense Monitor — Export</h2>
        </div>
        <BDExportPage {...exportArgs} onBack={()=>setPage("workspace")}/>
      </div>
    );
  }

  if(page==="workspace"&&data){
    return(
      <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
        <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
          <i className="ti ti-shield" style={{fontSize:15,color:"#4f46e5"}}/>
          <h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Brand Defense Monitor</h2>
          <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(200,120,0,0.12)",color:"#9a5800",fontWeight:700}}>Advanced</span>
        </div>
        <BDWorkspace
          {...data}
          onReupload={()=>{setData(null);setPage("upload");}}
          onExport={(brandedRows,curAgg,compAgg,alerts,opps,cm,brandTerms)=>{
            setExportArgs({brandedRows,curAgg,compAgg,alerts,opps,cm,brandTerms});
            setPage("export");
          }}
        />
      </div>
    );
  }

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-shield" style={{fontSize:15,color:"#4f46e5"}}/>
        <h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Brand Defense Monitor</h2>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(200,120,0,0.12)",color:"#9a5800",fontWeight:700}}>Advanced</span>
      </div>
      <BDUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={d=>{setData(d);setPage("workspace");}}/> 
    </div>
  );
}


/* ================================================================
   COMPETITOR ATTACK RADAR MODULE
   Paste this entire block into bids-optimizer.jsx after BrandDefenseModule

   INTEGRATION STEPS:
   1. Paste this full block at the very end of bids-optimizer.jsx
   2. In the NAV array, change the "competitor" entry:
      FROM: {key:"competitor", ..., soon:true, ...}
      TO:   {key:"competitor", icon:"ti-radar", label:"Competitor Radar", badge:"Advanced", desc:"Competitor attack & movement alerts"}
   3. In the App component tab switcher, add:
      :tab==="competitor"
      ?<CompetitorRadarModule key="competitor"/>
   No other changes needed.
================================================================ */

/* ── Column aliases ─────────────────────────────────────────── */
const CR_ALIASES={
  campaign:        ["Campaign Name","Campaign","campaign name","Campaign Name (Informational only)"],
  adGroup:         ["Ad Group Name","Ad Group","ad group name"],
  matchType:       ["Match Type","match type","Targeting Type"],
  searchTerm:      ["Customer Search Term","Search Term","Query","Search query","Keyword","Keyword Text","Targeting Expression","Product Targeting Expression"],
  impressions:     ["Impressions","impressions","Total Impressions"],
  clicks:          ["Clicks","clicks","Total Clicks"],
  spend:           ["Spend","Cost","Ad Spend","Spend ($)"],
  sales:           ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales","Total Sales","Attributed Sales","Revenue"],
  orders:          ["Orders","14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)","Total Orders","Attributed Conversions"],
  acos:            ["ACOS","ACoS","Advertising Cost of Sales","ACOS (%)"],
  roas:            ["ROAS","Return on Ad Spend"],
  cpc:             ["CPC","Cost Per Click","Average CPC","CPC ($)"],
  ctr:             ["Click-through Rate","CTR","Click-Through Rate","CTR (%)"],
  cvr:             ["Conversion Rate","CVR","Order Rate"],
  clickShare:      ["Click Share","Click share","Clicks Share"],
  convShare:       ["Conversion Share","Conversion share","Conversions Share"],
  impressionShare: ["Impression Share","Impression share","Top of Search (Impression Share)"],
  rank:            ["Rank","Position","Average Position","Organic Rank","Sponsored Rank"],
  state:           ["State","Status","Campaign State (Informational only)"],
  entity:          ["Entity","Record Type","Type"],
  bid:             ["Bid","Ad Group Default Bid","Keyword Bid","Default Bid"],
};

function crDetectMap(headers){
  const r={};
  for(const[k,cands]of Object.entries(CR_ALIASES)){
    for(const c of cands){
      const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());
      if(h){r[k]=h;break;}
    }
    if(!r[k]){
      for(const c of cands){
        const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));
        if(h){r[k]=h;break;}
      }
    }
  }
  return r;
}

function crGetNum(row,col){
  if(!col||row[col]==null||row[col]==="")return 0;
  const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));
  return isNaN(v)?0:v;
}

function crCalcMetrics(row,cm){
  const imp=crGetNum(row,cm.impressions),clk=crGetNum(row,cm.clicks),
    spd=crGetNum(row,cm.spend),sal=crGetNum(row,cm.sales),ord=crGetNum(row,cm.orders);
  const ctr=cm.ctr&&crGetNum(row,cm.ctr)>0?crGetNum(row,cm.ctr):imp>0?(clk/imp)*100:0;
  const acos=cm.acos&&crGetNum(row,cm.acos)>0?crGetNum(row,cm.acos):sal>0?(spd/sal)*100:0;
  const roas=cm.roas&&crGetNum(row,cm.roas)>0?crGetNum(row,cm.roas):spd>0?sal/spd:0;
  const cvr=cm.cvr&&crGetNum(row,cm.cvr)>0?crGetNum(row,cm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=cm.cpc&&crGetNum(row,cm.cpc)>0?crGetNum(row,cm.cpc):clk>0?spd/clk:0;
  const clickShare=cm.clickShare?crGetNum(row,cm.clickShare):0;
  const convShare=cm.convShare?crGetNum(row,cm.convShare):0;
  const impressionShare=cm.impressionShare?crGetNum(row,cm.impressionShare):0;
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,ctr,acos,roas,cvr,cpc,clickShare,convShare,impressionShare};
}

function crSumAgg(rows,cm){
  let imp=0,clk=0,spd=0,sal=0,ord=0,cs=0,cvs=0,iss=0,n=0;
  rows.forEach(r=>{
    const m=crCalcMetrics(r,cm);
    imp+=m.impressions;clk+=m.clicks;spd+=m.spend;sal+=m.sales;ord+=m.orders;
    if(m.clickShare>0){cs+=m.clickShare;n++;}
    if(m.convShare>0)cvs+=m.convShare;
    if(m.impressionShare>0)iss+=m.impressionShare;
  });
  return{
    impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,
    acos:sal>0?(spd/sal)*100:0,
    ctr:imp>0?(clk/imp)*100:0,
    cvr:clk>0?(ord/clk)*100:0,
    cpc:clk>0?spd/clk:0,
    roas:spd>0?sal/spd:0,
    clickShare:n>0?cs/n:0,
    convShare:n>0?cvs/n:0,
    impressionShare:n>0?iss/n:0,
  };
}

/* ── Pressure score (0–100, higher = more competitor pressure) ── */
function crPressureScore(cur,comp){
  let score=0;
  if(cur.cpc>0){
    const cpcP=comp&&comp.cpc>0?((cur.cpc-comp.cpc)/comp.cpc)*100:0;
    score+=Math.min(30,Math.max(0,cpcP*1.5));
  }
  if(cur.impressions>0&&comp&&comp.impressions>0){
    const impDrop=((comp.impressions-cur.impressions)/comp.impressions)*100;
    score+=Math.min(25,Math.max(0,impDrop));
  }
  if(cur.clickShare>0&&comp&&comp.clickShare>0){
    const csDrop=((comp.clickShare-cur.clickShare)/comp.clickShare)*100;
    score+=Math.min(25,Math.max(0,csDrop));
  }
  if(cur.acos>0){
    const acosHigh=Math.max(0,cur.acos-30);
    score+=Math.min(20,acosHigh*0.5);
  }
  return Math.min(100,Math.round(score));
}

/* ── Aggression score per keyword row ──────────────────────────── */
function crAggressionScore(m,comp){
  let s=0;
  if(m.cpc>1.5)s+=20;else if(m.cpc>1)s+=10;
  if(comp){
    if(m.cpc>comp.cpc*1.2)s+=20;
    if(m.impressions<comp.impressions*0.85)s+=20;
    if(m.clickShare>0&&comp.clickShare>0&&m.clickShare<comp.clickShare*0.9)s+=20;
  }
  if(m.acos>40)s+=15;
  return Math.min(100,s);
}

/* ── Auto-detect competitor alerts ─────────────────────────────── */
function crDetectAlerts(curAgg,compAgg,rows,cm){
  const alerts=[];
  if(!curAgg)return alerts;
  const delta=(k)=>compAgg&&compAgg[k]!=null?(curAgg[k]-compAgg[k]):null;
  const pct=(k)=>{const d=delta(k);if(d===null||!compAgg[k])return null;return(d/Math.abs(compAgg[k]))*100;};

  /* CPC warfare */
  const cpcPct=pct("cpc");
  if(cpcPct!==null&&cpcPct>15){
    alerts.push({
      id:"cpc_warfare",type:"CPC Warfare",severity:"critical",
      keyword:"Account-wide",
      current:`$${curAgg.cpc.toFixed(2)}`,previous:`$${compAgg.cpc.toFixed(2)}`,
      delta:`+${cpcPct.toFixed(1)}%`,trend:"up",
      cause:`Average CPC inflated ${cpcPct.toFixed(1)}% vs previous period. Competitors are actively raising bids across your keyword set, forcing you to pay more per click to maintain position.`,
      action:"Identify highest-CPC keywords and evaluate if the conversion rate justifies the cost. Tighten match types on broad terms to reduce auction exposure. Consider lowering bids on non-converting terms to stop feeding competitor auctions.",
      impact:`~$${((curAgg.cpc-compAgg.cpc)*curAgg.clicks).toFixed(0)} in extra spend from CPC inflation`,
      confidence:85,
    });
  }

  /* Click share loss */
  const csPct=pct("clickShare");
  if(csPct!==null&&csPct<-10){
    alerts.push({
      id:"click_share_loss",type:"Click Share Theft",severity:"critical",
      keyword:"Account-wide",
      current:`${curAgg.clickShare.toFixed(1)}%`,previous:`${compAgg.clickShare.toFixed(1)}%`,
      delta:`${csPct.toFixed(1)}%`,trend:"down",
      cause:`Click share dropped ${Math.abs(csPct).toFixed(1)}% vs previous period. Competitors are capturing a larger proportion of available clicks — your ads are being shown but not clicked as frequently relative to competitors.`,
      action:"Review ad relevance and listing quality. Improve main image and title for CTR lift. Increase bids on high-intent keywords where you're losing share. Consider headline optimization for Sponsored Brand campaigns.",
      impact:`${Math.abs(csPct).toFixed(1)}% fewer clicks from available market — compounding revenue loss`,
      confidence:80,
    });
  }

  /* Conversion share loss */
  const cvsPct=pct("convShare");
  if(cvsPct!==null&&cvsPct<-10){
    alerts.push({
      id:"conv_share_loss",type:"Conversion Share Weakness",severity:"high",
      keyword:"Account-wide",
      current:`${curAgg.convShare.toFixed(1)}%`,previous:`${compAgg.convShare.toFixed(1)}%`,
      delta:`${cvsPct.toFixed(1)}%`,trend:"down",
      cause:`Conversion share dropped ${Math.abs(cvsPct).toFixed(1)}% vs previous period. Competitors are converting at a higher rate relative to you — they may have improved listings, pricing, or review counts.`,
      action:"Audit listing conversion rate. Compare price vs top competitors. Check review count and rating vs competitors on key terms. Consider A/B testing main image and price point before scaling spend.",
      impact:`Conversion share gap means competitors are monetizing shared traffic more effectively`,
      confidence:75,
    });
  }

  /* Visibility suppression */
  const impPct=pct("impressions");
  if(impPct!==null&&impPct<-20){
    alerts.push({
      id:"visibility_suppression",type:"Visibility Suppression",severity:"high",
      keyword:"Account-wide",
      current:curAgg.impressions>=1e3?`${(curAgg.impressions/1e3).toFixed(1)}K`:String(Math.round(curAgg.impressions)),
      previous:compAgg.impressions>=1e3?`${(compAgg.impressions/1e3).toFixed(1)}K`:String(Math.round(compAgg.impressions)),
      delta:`${impPct.toFixed(1)}%`,trend:"down",
      cause:`Impressions dropped ${Math.abs(impPct).toFixed(1)}% vs previous period. Competitors outbidding you for top placement, pushing your ads further down the SERP or out of the auction entirely.`,
      action:"Check daily budget utilization — are campaigns hitting caps? Increase bids on top-performing keywords. Audit placement modifiers, especially Top of Search. Review campaign budget allocation.",
      impact:`${Math.abs(impPct).toFixed(1)}% impression loss — direct reduction in market presence`,
      confidence:78,
    });
  }

  /* Aggressive competitor expansion — high spend, declining efficiency */
  if(curAgg.spend>0&&compAgg&&curAgg.spend>compAgg.spend*1.15&&curAgg.acos>compAgg.acos*1.1){
    alerts.push({
      id:"market_aggression",type:"Market Aggression Shift",severity:"high",
      keyword:"Account-wide",
      current:`ACoS ${curAgg.acos.toFixed(1)}%`,previous:`ACoS ${compAgg.acos.toFixed(1)}%`,
      delta:`+${((curAgg.acos-compAgg.acos)).toFixed(1)}pp`,trend:"up",
      cause:`Spend increased ${(((curAgg.spend-compAgg.spend)/compAgg.spend)*100).toFixed(1)}% but ACoS also worsened by ${(curAgg.acos-compAgg.acos).toFixed(1)}pp. Market competition increased — you're paying more per click AND converting less efficiently.`,
      action:"Identify which campaigns drove spend increase vs efficiency loss. Reduce bids on high-ACoS campaigns. Focus budget on campaigns with strong historic CVR. Pause underperforming ad groups temporarily.",
      impact:"Combined effect: higher costs AND lower returns — competitive market is deteriorating",
      confidence:72,
    });
  }

  /* Bleeders under competitive pressure */
  const bleeders=rows.filter(r=>{const m=crCalcMetrics(r,cm);return m.spend>15&&m.orders===0;});
  if(bleeders.length>=3){
    const waste=bleeders.reduce((s,r)=>s+crCalcMetrics(r,cm).spend,0);
    alerts.push({
      id:"competitor_bleed",type:"Competitor-Induced Waste",severity:"medium",
      keyword:`${bleeders.length} keywords`,
      current:`$${waste.toFixed(0)} wasted`,previous:"—",
      delta:"new",trend:"up",
      cause:`${bleeders.length} keywords spending $${waste.toFixed(0)} with zero conversions. Under competitive pressure, irrelevant clicks accumulate faster as broad/auto campaigns get wider exposure.`,
      action:"Immediately audit search terms behind these keywords. Add negative keywords. Reduce bids by 30–50% or pause worst offenders. This waste is likely competitor-triggered traffic arbitrage.",
      impact:`$${waste.toFixed(0)} in recoverable wasted spend`,
      confidence:88,
    });
  }

  return alerts.sort((a,b)=>{
    const o={critical:0,high:1,medium:2,low:3};
    return(o[a.severity]||3)-(o[b.severity]||3);
  });
}

/* ── Counterattack opportunities ───────────────────────────────── */
function crOpportunities(curAgg,compAgg,rows,cm){
  const opps=[];
  if(!curAgg)return opps;

  /* Visibility recovery */
  const impPct=compAgg&&compAgg.impressions>0?((curAgg.impressions-compAgg.impressions)/compAgg.impressions)*100:null;
  if(impPct!==null&&impPct<-10){
    const recoverers=rows.filter(r=>{const m=crCalcMetrics(r,cm);return m.orders>0&&m.acos<35&&m.impressions>0;});
    if(recoverers.length>0){
      opps.push({
        id:"visibility_recovery",type:"recovery",
        title:"Visibility Recovery Opportunity",
        why:`Impressions dropped ${Math.abs(impPct).toFixed(1)}% but ${recoverers.length} keywords still convert efficiently (ACoS < 35%). These are recoverable positions — increase bids to reclaim lost SERP space.`,
        movement:compAgg?`Impressions: ${compAgg.impressions>=1e3?(compAgg.impressions/1e3).toFixed(1)+"K":Math.round(compAgg.impressions)} → ${curAgg.impressions>=1e3?(curAgg.impressions/1e3).toFixed(1)+"K":Math.round(curAgg.impressions)} (${impPct.toFixed(1)}%)`:null,
        action:"Increase bids 15–20% on the top converting keywords with impression loss. Check placement modifiers — add Top of Search boost of 20–30% on proven converters.",
        impact:"Recovering lost impression share on converters directly improves revenue without changing conversion rate",
      });
    }
  }

  /* CPC efficiency window */
  if(curAgg.acos<25&&curAgg.orders>0){
    opps.push({
      id:"scale_window",type:"opportunity",
      title:"Aggressive Scaling Window",
      why:`Account ACoS is ${curAgg.acos.toFixed(1)}% — below target threshold. Despite competitive pressure, you have efficient headroom to scale spend and capture more market share before competitors tighten the gap.`,
      movement:compAgg?`ACoS stable: ${compAgg.acos.toFixed(1)}% → ${curAgg.acos.toFixed(1)}%`:null,
      action:"Increase daily budgets by 20–30% on top-performing campaigns. Raise bids 10–15% on keywords with ACoS < 20% and proven order history. Launch new broad/auto campaigns to harvest new converting terms.",
      impact:"Low ACoS with competitive pressure = golden window. Scale now before competitors recover and CPCs rise further.",
    });
  }

  /* Weak competitor defense on high-CVR terms */
  const highCvr=rows.filter(r=>{const m=crCalcMetrics(r,cm);return m.cvr>=8&&m.impressions<1000&&m.orders>=1;});
  if(highCvr.length>0){
    opps.push({
      id:"weak_competitor_defense",type:"conquest",
      title:"Weak Competitor Defense on High-CVR Terms",
      why:`${highCvr.length} keyword${highCvr.length>1?"s":""} show high CVR (≥ 8%) but low impressions — competitors haven't fully saturated these terms. They're your strongest converters with room to grow.`,
      movement:null,
      action:"Increase bids aggressively on these terms — push for Top of Search position. Add exact match versions if running on broad/phrase. These are your safest terms to scale: proven CVR, low competition density.",
      impact:"Capturing dominant position on high-CVR, low-competition terms builds durable rank advantage competitors can't easily displace",
    });
  }

  /* Competitor CPC overkill — they're spending inefficiently */
  const cpcPct=compAgg&&compAgg.cpc>0?((curAgg.cpc-compAgg.cpc)/compAgg.cpc)*100:null;
  if(cpcPct!==null&&cpcPct>20&&curAgg.cvr>3){
    opps.push({
      id:"competitor_inefficiency",type:"efficiency",
      title:"Competitor Overspend Window",
      why:`CPCs inflated ${cpcPct.toFixed(1)}% but your CVR (${curAgg.cvr.toFixed(1)}%) remains strong. Competitors inflating CPCs are likely doing so with weaker conversion rates — they're burning budget faster than you.`,
      movement:`CPC: $${compAgg.cpc.toFixed(2)} → $${curAgg.cpc.toFixed(2)} (+${cpcPct.toFixed(1)}%)`,
      action:"Hold your position — don't reduce bids reactively. Competitors overbidding with poor CVR will exhaust budgets by mid-day, leaving afternoon auction space for you at lower effective CPCs.",
      impact:"Staying consistent while competitors overspend creates afternoon visibility advantages at lower CPC",
    });
  }

  /* Branded defense gap */
  opps.push({
    id:"branded_gap",type:"defense",
    title:"Verify Branded Defense Is Active",
    why:"Under competitor pressure, branded term protection is the highest-ROI defensive action. If competitors are conquesting, branded exact match campaigns are the first line of defense.",
    movement:null,
    action:"Confirm you have exact match branded campaigns running with sufficient budget. Verify branded keywords aren't being cannibalized by broad match in other campaigns. Use Brand Defense Monitor module for full analysis.",
    impact:"Branded exact match campaigns typically achieve 2–5% ACoS — losing branded traffic to competitors is the most expensive mistake under pressure",
  });

  return opps;
}

/* ── Gemini AI analysis ─────────────────────────────────────── */
async function crAIAnalysis(curAgg,compAgg,alerts,opps,apiKey){
  const alertSummary=alerts.map(a=>`- ${a.type} (${a.severity}): ${a.cause}`).join("\n");
  const oppSummary=opps.map(o=>`- ${o.title}: ${o.why}`).join("\n");

  const prompt=`You are an Amazon PPC competitive intelligence strategist. Analyze the following account performance data to assess competitor pressure and provide strategic counteraction guidance.

CURRENT PERIOD:
- Spend: $${curAgg.spend.toFixed(2)} | Sales: $${curAgg.sales.toFixed(2)} | ACoS: ${curAgg.acos.toFixed(1)}%
- CPC: $${curAgg.cpc.toFixed(2)} | CTR: ${curAgg.ctr.toFixed(2)}% | CVR: ${curAgg.cvr.toFixed(1)}%
- Impressions: ${Math.round(curAgg.impressions).toLocaleString()} | Click Share: ${curAgg.clickShare.toFixed(1)}%
- Conversion Share: ${curAgg.convShare.toFixed(1)}% | Impression Share: ${curAgg.impressionShare.toFixed(1)}%

${compAgg?`PREVIOUS PERIOD:
- Spend: $${compAgg.spend.toFixed(2)} | Sales: $${compAgg.sales.toFixed(2)} | ACoS: ${compAgg.acos.toFixed(1)}%
- CPC: $${compAgg.cpc.toFixed(2)} | CTR: ${compAgg.ctr.toFixed(2)}% | CVR: ${compAgg.cvr.toFixed(1)}%
- Impressions: ${Math.round(compAgg.impressions).toLocaleString()} | Click Share: ${compAgg.clickShare.toFixed(1)}%`:"No comparison period uploaded."}

DETECTED THREATS:
${alertSummary||"No critical threats auto-detected."}

COUNTERATTACK OPPORTUNITIES:
${oppSummary||"No opportunities identified."}

Provide your competitive analysis in exactly this structure:
1. COMPETITIVE PRESSURE LEVEL (1 sentence — Low / Moderate / High / Critical, and why)
2. WHERE COMPETITORS ARE WINNING (1–2 sentences — based only on the data, no invented competitor names)
3. YOUR STRONGEST DEFENSIVE POSITION (1 sentence — where you are holding ground)
4. TOP COUNTERATTACK PRIORITY (1 sentence — the single highest-ROI action this week)
5. STRATEGIC WARNING (1 sentence — biggest risk if no action is taken)

Be direct and operational. Do not invent competitor names or actions not supported by the data provided.`;

  const res=await geminiFetch(apiKey,
    {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({contents:[{parts:[{text:prompt}]}]}),
    }
  );
  if(!res.ok){const err=await res.json();throw new Error(err?.error?.message||"Gemini API error");}
  const data=await res.json();
  return data.candidates?.[0]?.content?.parts?.[0]?.text||"Analysis unavailable.";
}

/* ==============================================================
   COMPONENTS
============================================================== */

/* ── Upload Zone ────────────────────────────────────────────── */
function CRUploadZone({label,file,onFile,onClear}){
  const[drag,setDrag]=useState(false);
  const ref=useRef();
  const handle=async f=>{
    if(!f)return;
    try{const parsed=await parseSheet(f);onFile(f,parsed);}
    catch(e){alert("Could not read file: "+e.message);}
  };
  return(
    <div
      onDragOver={e=>{e.preventDefault();setDrag(true);}}
      onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);handle(e.dataTransfer.files[0]);}}
      style={{border:`2px dashed ${drag?"#4f46e5":"#e0e0e0"}`,borderRadius:10,padding:"22px 20px",background:drag?"rgba(79,70,229,0.04)":"#fafafa",cursor:"pointer",transition:"all 0.15s"}}
      onClick={()=>!file&&ref.current?.click()}>
      <input ref={ref} type="file" accept=".xlsx,.csv" style={{display:"none"}} onChange={e=>handle(e.target.files[0])}/>
      {file?(
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <i className="ti ti-file-spreadsheet" style={{fontSize:20,color:"#4f46e5"}}/>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:600,color:"#111"}}>{file.name}</div>
            <div style={{fontSize:11,color:"#888",marginTop:2}}>{label} · ready</div>
          </div>
          <button onClick={e=>{e.stopPropagation();onClear();}} style={{padding:"3px 8px",borderRadius:5,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555"}}>Remove</button>
        </div>
      ):(
        <div style={{textAlign:"center"}}>
          <i className="ti ti-cloud-upload" style={{fontSize:26,color:"#ccc",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,fontWeight:600,color:"#555",marginBottom:3}}>{label}</div>
          <div style={{fontSize:11,color:"#aaa"}}>Drag & drop or click · .xlsx or .csv</div>
        </div>
      )}
    </div>
  );
}

/* ── Upload Page ────────────────────────────────────────────── */
function CRUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[curFile,setCurFile]=useState(null);const[curParsed,setCurParsed]=useState(null);
  const[compFile,setCompFile]=useState(null);const[compParsed,setCompParsed]=useState(null);
  const[validated,setValidated]=useState(null);
  const[history,setHistory]=useState([]);
  const[localPeriods,setLocalPeriods]=useState(periods);

  const validate=p=>{
    const cm=crDetectMap(p.headers);
    const found=Object.entries(cm).filter(([,v])=>v).map(([k])=>k);
    const hasKey=!!(cm.impressions&&cm.spend&&(cm.searchTerm||cm.campaign||cm.clicks));
    return{cm,found,hasKey,rows:p.rows};
  };

  const handleCur=(f,p)=>{
    setCurFile(f);setCurParsed(p);
    const v=validate(p);setValidated(v);
    setHistory(h=>[{name:f.name,date:new Date().toLocaleTimeString(),rows:p.rows.length,valid:v.hasKey,cols:v.found.length},...h.slice(0,4)]);
  };

  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);

  const SUPPORTED=[
    {icon:"ti-search",label:"Search Term Report",note:"Customer search term data — best for competitive intelligence"},
    {icon:"ti-chart-pie",label:"SQP Report",note:"Search query performance — click share & conversion share data"},
    {icon:"ti-eye",label:"Impression Share Report",note:"Visibility & share of voice data"},
    {icon:"ti-speakerphone",label:"Campaign Report",note:"Campaign-level performance for competitive benchmarking"},
    {icon:"ti-trending-up",label:"Rank Report",note:"Keyword rank movement data"},
    {icon:"ti-file-spreadsheet",label:"Bulk File",note:"Full Amazon bulk export — auto-detects all report types"},
  ];

  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:660,margin:"0 auto",padding:"32px 24px"}}>
        <div style={{marginBottom:24}}>
          <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Competitor Reports</h2>
          <p style={{fontSize:13,color:"#666",margin:0}}>Upload raw Amazon PPC reports. The system auto-detects report type, maps columns, and validates data — no preprocessing needed.</p>
        </div>

        {/* Current period */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:3}}>Current Period Report <span style={{color:"#4f46e5"}}>*</span></div>
          <div style={{fontSize:11,color:"#888",marginBottom:12}}>Any Amazon report from the period you want to analyze</div>
          <CRUploadZone label="Current Period" file={curFile} onFile={handleCur} onClear={()=>{setCurFile(null);setCurParsed(null);setValidated(null);}}/>
          {validated&&(
            <div style={{marginTop:10,padding:"10px 12px",borderRadius:7,background:validated.hasKey?"rgba(26,122,60,0.07)":"rgba(196,122,0,0.07)",border:`1px solid ${validated.hasKey?"rgba(26,122,60,0.2)":"rgba(196,122,0,0.2)"}`}}>
              <div style={{fontSize:12,fontWeight:600,color:validated.hasKey?"#1a7a3c":"#c47a00",marginBottom:4}}>
                <i className={`ti ${validated.hasKey?"ti-check":"ti-alert-triangle"}`} style={{marginRight:5}}/>
                {validated.hasKey?"Report validated":"Partial data — some columns not detected"}
              </div>
              <div style={{fontSize:11,color:"#555"}}>{validated.rows.length.toLocaleString()} rows · {validated.found.length} columns mapped: {validated.found.join(", ")}</div>
            </div>
          )}
        </div>

        {/* Comparison period */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:3}}>Comparison Period Report <span style={{fontSize:11,color:"#aaa",fontWeight:400}}>(recommended)</span></div>
          <div style={{fontSize:11,color:"#888",marginBottom:12}}>Same report type from previous period — required for delta analysis and competitor pressure detection</div>
          <CRUploadZone label="Previous Period" file={compFile} onFile={(f,p)=>{setCompFile(f);setCompParsed(p);}} onClear={()=>{setCompFile(null);setCompParsed(null);}}/>
        </div>

        {/* Supported reports */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:12}}>Supported Report Types</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            {SUPPORTED.map((s,i)=>(
              <div key={i} style={{display:"flex",gap:9,alignItems:"flex-start",padding:"8px",borderRadius:7,background:"#fafafa"}}>
                <i className={`ti ${s.icon}`} style={{fontSize:13,color:"#4f46e5",flexShrink:0,marginTop:1}}/>
                <div>
                  <div style={{fontSize:11,fontWeight:600,color:"#111"}}>{s.label}</div>
                  <div style={{fontSize:10,color:"#aaa",lineHeight:1.4}}>{s.note}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Upload history */}
        {history.length>0&&(
          <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10}}>Upload History</div>
            {history.map((h,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 0",borderBottom:i<history.length-1?"1px solid #f5f5f5":"none"}}>
                <i className={`ti ${h.valid?"ti-check-circle":"ti-alert-circle"}`} style={{fontSize:13,color:h.valid?"#1a7a3c":"#c47a00",flexShrink:0}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{h.name}</div>
                  <div style={{fontSize:10,color:"#aaa"}}>{h.rows.toLocaleString()} rows · {h.cols} cols · {h.date}</div>
                </div>
                <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:h.valid?"rgba(26,122,60,0.1)":"rgba(196,122,0,0.1)",color:h.valid?"#1a7a3c":"#c47a00",fontWeight:700}}>{h.valid?"Valid":"Partial"}</span>
              </div>
            ))}
          </div>
        )}

        <button
          onClick={()=>onComplete({curRows:curParsed.rows,compRows:compParsed?.rows||null,cm:crDetectMap(curParsed.headers),compCm:compParsed?crDetectMap(compParsed.headers):null})}
          disabled={!curParsed}
          style={{width:"100%",padding:"12px",borderRadius:9,border:"none",background:curParsed?"#4f46e5":"#e0e0e0",color:curParsed?"#fff":"#aaa",fontSize:14,fontWeight:700,cursor:curParsed?"pointer":"not-allowed",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          <i className="ti ti-radar" style={{fontSize:15}}/>
          Open Competitor Intelligence Workspace
        </button>
      </div>
    </div>
  );
}

/* ── Pressure Overview Bar ──────────────────────────────────── */
function CRPressureBar({cur,comp,pressureScore}){
  const KPIS=[
    {key:"impressions",label:"Impressions",fmt:v=>v>=1e6?(v/1e6).toFixed(2)+"M":v>=1e3?(v/1e3).toFixed(1)+"K":String(Math.round(v)),lowerBetter:false},
    {key:"clickShare",label:"Click Share",fmt:v=>`${v.toFixed(1)}%`,lowerBetter:false,isPp:true},
    {key:"convShare",label:"Conv. Share",fmt:v=>`${v.toFixed(1)}%`,lowerBetter:false,isPp:true},
    {key:"cpc",label:"CPC",fmt:v=>`$${v.toFixed(2)}`,lowerBetter:true},
    {key:"acos",label:"ACoS",fmt:v=>`${v.toFixed(1)}%`,lowerBetter:true,isPp:true},
    {key:"ctr",label:"CTR",fmt:v=>`${v.toFixed(2)}%`,lowerBetter:false,isPp:true},
    {key:"cvr",label:"CVR",fmt:v=>`${v.toFixed(1)}%`,lowerBetter:false,isPp:true},
  ];

  const pressureColor=pressureScore>=70?"#d42b2b":pressureScore>=40?"#c47a00":"#1a7a3c";
  const pressureLabel=pressureScore>=70?"Critical":pressureScore>=40?"Elevated":"Stable";

  return(
    <div style={{marginBottom:18}}>
      {/* Pressure score hero */}
      <div style={{background:"#fff",borderRadius:12,border:`2px solid ${pressureColor}22`,padding:"16px 20px",marginBottom:10,display:"flex",alignItems:"center",gap:16}}>
        <div style={{width:64,height:64,borderRadius:"50%",background:`${pressureColor}12`,border:`3px solid ${pressureColor}`,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <span style={{fontSize:20,fontWeight:900,color:pressureColor,lineHeight:1}}>{pressureScore}</span>
          <span style={{fontSize:8,color:pressureColor,fontWeight:700,letterSpacing:"0.5px"}}>/100</span>
        </div>
        <div style={{flex:1}}>
          <div style={{fontSize:14,fontWeight:800,color:pressureColor,marginBottom:2}}>Competitor Pressure: {pressureLabel}</div>
          <div style={{fontSize:12,color:"#666",lineHeight:1.5}}>
            {pressureScore>=70?"Critical competitor activity detected. Immediate strategic response required to protect market position.":
             pressureScore>=40?"Elevated competitive pressure across multiple metrics. Monitor closely and prepare defensive responses.":
             "Competition is stable. Focus on scaling opportunities and market share expansion."}
          </div>
        </div>
        <div style={{textAlign:"right",flexShrink:0}}>
          <div style={{fontSize:10,color:"#aaa",marginBottom:3,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px"}}>Aggression Trend</div>
          <i className={`ti ${pressureScore>=40?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:22,color:pressureScore>=40?"#d42b2b":"#1a7a3c"}}/>
        </div>
      </div>

      {/* KPI grid */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:8}}>
        {KPIS.map(k=>{
          const cv=cur?.[k.key]??0;
          const pv=comp?.[k.key]??null;
          const d=pv!=null?(k.isPp?cv-pv:((cv-pv)/Math.abs(pv||1))*100):null;
          const good=d!=null?(k.lowerBetter?d<0:d>0):null;
          return(
            <div key={k.key} style={{background:"#fff",borderRadius:10,border:"1px solid #eee",padding:"11px 13px"}}>
              <div style={{fontSize:9,color:"#888",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:5}}>{k.label}</div>
              <div style={{fontSize:16,fontWeight:800,color:"#111",marginBottom:2}}>{k.fmt(cv)}</div>
              {pv!=null&&(
                <div style={{display:"flex",alignItems:"center",gap:2}}>
                  <span style={{fontSize:9,color:good?"#1a7a3c":good===false?"#d42b2b":"#888",fontWeight:700}}>
                    {d>0?"+":""}{k.isPp?d.toFixed(1)+"pp":d.toFixed(1)+"%"}
                  </span>
                  <i className={`ti ${d>0?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:8,color:good?"#1a7a3c":good===false?"#d42b2b":"#888"}}/>
                </div>
              )}
              {pv!=null&&<div style={{fontSize:9,color:"#ccc",marginTop:1}}>prev {k.fmt(pv)}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ── Alert Card ─────────────────────────────────────────────── */
function CRAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const SC={
    critical:{color:"#d42b2b",bg:"rgba(212,43,43,0.07)",icon:"ti-alert-octagon"},
    high:{color:"#c47a00",bg:"rgba(196,122,0,0.07)",icon:"ti-alert-triangle"},
    medium:{color:"#1a5fa0",bg:"rgba(26,95,160,0.07)",icon:"ti-info-circle"},
    low:{color:"#666",bg:"rgba(0,0,0,0.03)",icon:"ti-point"},
  };
  const s=SC[a.severity]||SC.medium;
  return(
    <div style={{background:"#fff",borderRadius:10,border:`1px solid ${s.color}22`,marginBottom:10,overflow:"hidden"}}>
      <div onClick={()=>setOpen(v=>!v)} style={{display:"flex",alignItems:"center",gap:10,padding:"13px 16px",cursor:"pointer",background:s.bg}}>
        <i className={`ti ${s.icon}`} style={{fontSize:16,color:s.color,flexShrink:0}}/>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2}}>
            <span style={{fontSize:13,fontWeight:700,color:s.color}}>{a.type}</span>
            <span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:s.color,color:"#fff",fontWeight:700,textTransform:"uppercase"}}>{a.severity}</span>
          </div>
          <div style={{fontSize:11,color:"#666"}}>{a.keyword} · {a.current}{a.previous&&a.previous!=="—"?` vs ${a.previous} (${a.delta})`:a.delta&&a.delta!=="new"?` · ${a.delta}`:""}</div>
        </div>
        <div style={{textAlign:"right",flexShrink:0,marginRight:8}}>
          <div style={{fontSize:9,color:"#aaa",marginBottom:1}}>Confidence</div>
          <div style={{fontSize:12,fontWeight:700,color:s.color}}>{a.confidence||"—"}%</div>
        </div>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#aaa",flexShrink:0}}/>
      </div>
      {open&&(
        <div style={{padding:"14px 16px",borderTop:"1px solid #f0f0f0"}}>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:10}}>{a.cause}</div>
          <div style={{background:"rgba(79,70,229,0.04)",borderRadius:7,padding:"10px 12px",borderLeft:"3px solid #4f46e5",marginBottom:8}}>
            <div style={{fontSize:10,fontWeight:700,color:"#4f46e5",marginBottom:3,textTransform:"uppercase",letterSpacing:"0.5px"}}>Counteraction</div>
            <div style={{fontSize:12,color:"#333",lineHeight:1.5}}>{a.action}</div>
          </div>
          <div style={{fontSize:11,color:"#888"}}><strong>Estimated impact:</strong> {a.impact}</div>
        </div>
      )}
    </div>
  );
}

/* ── Opportunity Card ───────────────────────────────────────── */
function CROppCard({opp:o}){
  const[open,setOpen]=useState(false);
  const TC={
    opportunity:{color:"#1a7a3c",bg:"rgba(26,122,60,0.07)",icon:"ti-rocket"},
    recovery:{color:"#1a5fa0",bg:"rgba(26,95,160,0.07)",icon:"ti-restore"},
    conquest:{color:"#6338c8",bg:"rgba(99,56,200,0.07)",icon:"ti-sword"},
    efficiency:{color:"#c47a00",bg:"rgba(196,122,0,0.07)",icon:"ti-adjustments"},
    defense:{color:"#4f46e5",bg:"rgba(79,70,229,0.07)",icon:"ti-shield"},
  };
  const s=TC[o.type]||TC.opportunity;
  return(
    <div style={{background:"#fff",borderRadius:10,border:"1px solid #eee",marginBottom:10,overflow:"hidden"}}>
      <div onClick={()=>setOpen(v=>!v)} style={{display:"flex",alignItems:"center",gap:10,padding:"13px 16px",cursor:"pointer"}}>
        <div style={{width:32,height:32,borderRadius:8,background:s.bg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${s.icon}`} style={{fontSize:14,color:s.color}}/>
        </div>
        <div style={{flex:1}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{o.title}</div>
          {o.movement&&<div style={{fontSize:11,color:"#888",marginTop:1}}>{o.movement}</div>}
        </div>
        <span style={{fontSize:9,padding:"2px 7px",borderRadius:3,background:s.bg,color:s.color,fontWeight:700,textTransform:"uppercase",flexShrink:0}}>{o.type}</span>
        <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#aaa",marginLeft:6,flexShrink:0}}/>
      </div>
      {open&&(
        <div style={{padding:"0 16px 14px",borderTop:"1px solid #f5f5f5"}}>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8,paddingTop:10}}>{o.why}</div>
          <div style={{background:"rgba(26,122,60,0.05)",borderRadius:7,padding:"10px 12px",borderLeft:"3px solid #1a7a3c",marginBottom:6}}>
            <div style={{fontSize:10,fontWeight:700,color:"#1a7a3c",marginBottom:2,textTransform:"uppercase",letterSpacing:"0.5px"}}>Counter-Strategy</div>
            <div style={{fontSize:12,color:"#333",lineHeight:1.5}}>{o.action}</div>
          </div>
          <div style={{fontSize:11,color:"#888"}}><strong>Expected impact:</strong> {o.impact}</div>
        </div>
      )}
    </div>
  );
}

/* ── Competitor Analysis Table ──────────────────────────────── */
function CRTable({rows,cm,compMap,filters}){
  const[sort,setSort]=useState({col:"spend",dir:"desc"});
  const[page,setPage]=useState(0);const PER=25;

  const processed=useMemo(()=>{
    return rows
      .filter(r=>{
        const term=String(r[cm.searchTerm]||r[cm.campaign]||"");
        const m=crCalcMetrics(r,cm);
        if(filters.keyword&&!term.toLowerCase().includes(filters.keyword.toLowerCase()))return false;
        if(filters.minCpc&&m.cpc<parseFloat(filters.minCpc))return false;
        if(filters.minSpend&&m.spend<parseFloat(filters.minSpend))return false;
        if(filters.matchType&&filters.matchType!=="all"){
          const mt=String(r[cm.matchType]||"").toLowerCase();
          if(mt!==filters.matchType.toLowerCase())return false;
        }
        return m.impressions>0||m.spend>0;
      })
      .map(r=>{
        const term=String(r[cm.searchTerm]||r[cm.campaign]||"—");
        const m=crCalcMetrics(r,cm);
        const key=term.toLowerCase().trim();
        const comp=compMap?.[key];
        const pressure=crPressureScore(m,comp);
        const aggression=crAggressionScore(m,comp);
        const risk=pressure>=70?"Critical":pressure>=50?"High":pressure>=30?"Medium":"Low";
        const action=m.spend>10&&m.orders===0?"Pause / reduce bid":
          m.acos>50?"Cut bid 20%+":
          m.impressions<300&&m.orders>0?"Increase bid 15–25%":
          m.acos<20&&m.orders>=2?"Scale":"Monitor";
        return{term,m,comp,pressure,aggression,risk,action,matchType:String(r[cm.matchType]||"—"),campaign:String(r[cm.campaign]||"—")};
      })
      .sort((a,b)=>{
        const av=sort.col==="pressure"?a.pressure:sort.col==="aggression"?a.aggression:(a.m[sort.col]??0);
        const bv=sort.col==="pressure"?b.pressure:sort.col==="aggression"?b.aggression:(b.m[sort.col]??0);
        return sort.dir==="asc"?av-bv:bv-av;
      });
  },[rows,cm,compMap,filters,sort]);

  const paged=processed.slice(page*PER,(page+1)*PER);
  const pages=Math.ceil(processed.length/PER);

  const th=(col,label,right=true)=>(
    <th onClick={()=>setSort(s=>({col,dir:s.col===col&&s.dir==="desc"?"asc":"desc"}))}
      style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:right?"right":"left",cursor:"pointer",whiteSpace:"nowrap",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px",userSelect:"none"}}>
      {label}{sort.col===col?<i className={`ti ${sort.dir==="asc"?"ti-chevron-up":"ti-chevron-down"}`} style={{marginLeft:3,fontSize:8}}/>:null}
    </th>
  );

  const dc=(cv,pv,lb=false,isPp=false)=>{
    if(pv==null||pv===0)return null;
    const d=isPp?cv-pv:((cv-pv)/Math.abs(pv))*100;
    const good=lb?d<0:d>0;
    return<span style={{fontSize:9,color:good?"#1a7a3c":"#d42b2b",fontWeight:600,marginLeft:3}}>{d>0?"+":""}{isPp?d.toFixed(1)+"pp":d.toFixed(1)+"%"}</span>;
  };

  const scoreColor=s=>s>=70?"#d42b2b":s>=40?"#c47a00":"#1a7a3c";
  const riskColor=r=>r==="Critical"?"#d42b2b":r==="High"?"#c47a00":r==="Medium"?"#1a5fa0":"#888";

  if(!processed.length)return(
    <div style={{textAlign:"center",padding:"40px 20px",color:"#aaa"}}>
      <i className="ti ti-radar" style={{fontSize:32,display:"block",marginBottom:8}}/>
      <div style={{fontSize:13}}>No rows matched your filters.</div>
    </div>
  );

  return(
    <div>
      <div style={{fontSize:12,color:"#888",marginBottom:8}}>{processed.length} rows · showing {page*PER+1}–{Math.min((page+1)*PER,processed.length)}</div>
      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #eee"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr>
              {th("term","Keyword / Term",false)}
              <th style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"left",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Match</th>
              {th("spend","Spend")}{th("acos","ACoS")}{th("cpc","CPC")}{th("ctr","CTR")}{th("cvr","CVR")}
              {th("clickShare","Click Share")}{th("convShare","Conv. Share")}
              {th("pressure","Pressure")}{th("aggression","Aggression")}
              <th style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"center",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Risk</th>
              <th style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"left",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Action</th>
            </tr>
          </thead>
          <tbody>
            {paged.map((row,i)=>{
              const m=row.m,c=row.comp;
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"9px 12px"}}>
                    <div style={{fontWeight:600,color:"#111",fontSize:12,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.term}</div>
                    <div style={{fontSize:10,color:"#bbb",marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.campaign}</div>
                  </td>
                  <td style={{padding:"9px 10px"}}><span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:"rgba(79,70,229,0.07)",color:"#4f46e5",fontWeight:700}}>{row.matchType}</span></td>
                  <td style={{padding:"9px 10px",textAlign:"right",fontWeight:600}}>${m.spend>=1e3?(m.spend/1e3).toFixed(1)+"K":m.spend.toFixed(2)}{c&&dc(m.spend,c.spend,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}><span style={{fontWeight:600,color:m.acos>40?"#d42b2b":m.acos>25?"#c47a00":"#1a7a3c"}}>{m.acos.toFixed(1)}%</span>{c&&dc(m.acos,c.acos,true,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right",fontWeight:600}}>${m.cpc.toFixed(2)}{c&&dc(m.cpc,c.cpc,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>{m.ctr.toFixed(2)}%{c&&dc(m.ctr,c.ctr,false,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>{m.cvr.toFixed(1)}%{c&&dc(m.cvr,c.cvr,false,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>{m.clickShare>0?m.clickShare.toFixed(1)+"%":"—"}{c&&c.clickShare>0&&dc(m.clickShare,c.clickShare,false,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>{m.convShare>0?m.convShare.toFixed(1)+"%":"—"}{c&&c.convShare>0&&dc(m.convShare,c.convShare,false,true)}</td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>
                    <div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:30,height:30,borderRadius:"50%",background:`${scoreColor(row.pressure)}15`,border:`2px solid ${scoreColor(row.pressure)}`}}>
                      <span style={{fontSize:9,fontWeight:800,color:scoreColor(row.pressure)}}>{row.pressure}</span>
                    </div>
                  </td>
                  <td style={{padding:"9px 10px",textAlign:"right"}}>
                    <div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:30,height:30,borderRadius:"50%",background:`${scoreColor(row.aggression)}15`,border:`2px solid ${scoreColor(row.aggression)}`}}>
                      <span style={{fontSize:9,fontWeight:800,color:scoreColor(row.aggression)}}>{row.aggression}</span>
                    </div>
                  </td>
                  <td style={{padding:"9px 10px",textAlign:"center"}}>
                    <span style={{fontSize:9,padding:"2px 7px",borderRadius:3,background:`${riskColor(row.risk)}15`,color:riskColor(row.risk),fontWeight:700}}>{row.risk}</span>
                  </td>
                  <td style={{padding:"9px 10px",fontSize:11,color:"#555",whiteSpace:"nowrap"}}>{row.action}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {pages>1&&(
        <div style={{display:"flex",gap:6,justifyContent:"center",marginTop:12}}>
          {Array.from({length:pages},(_,i)=>(
            <button key={i} onClick={()=>setPage(i)} style={{padding:"4px 10px",borderRadius:5,border:"1px solid #e0e0e0",background:page===i?"#4f46e5":"#fff",color:page===i?"#fff":"#555",cursor:"pointer",fontSize:11,fontWeight:page===i?700:400}}>{i+1}</button>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── AI Competitor Assistant ────────────────────────────────── */
function CRAIPanel({curAgg,compAgg,alerts,opps}){
  const[analysis,setAnalysis]=useState(null);
  const[loading,setLoading]=useState(false);
  const[error,setError]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);
  const[keySaved,setKeySaved]=useState(false);

  const run=async()=>{
    if(!apiKey.trim()){setError("Set your Gemini API key in Settings → AI Settings to use this feature.");return;}
    setLoading(true);setError(null);
    try{
      const txt=await crAIAnalysis(curAgg,compAgg,alerts,opps,apiKey.trim());
      setAnalysis(txt);setKeySaved(true);
    }
    catch(e){setError("Error: "+e.message);}
    finally{setLoading(false);}
  };

  return(
    <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:18}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
        <div style={{width:28,height:28,borderRadius:7,background:"rgba(99,56,200,0.1)",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <i className="ti ti-brain" style={{fontSize:14,color:"#6338c8"}}/>
        </div>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"#111"}}>AI Competitor Assistant</div>
          <div style={{fontSize:11,color:"#888"}}>Powered by Gemini · analysis based on uploaded data only — no hallucinations</div>
        </div>
      </div>
      {!keySaved&&(
        <div style={{background:"#fafafa",borderRadius:8,border:"1px solid #eee",padding:"12px 14px",marginBottom:12}}>
          <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:6}}>
            <i className="ti ti-key" style={{fontSize:11,color:"#4f46e5",marginRight:4}}/>
            Gemini API Key <span style={{fontWeight:400,color:"#aaa"}}>(memory only — not saved)</span>
          </div>
          <div style={{display:"flex",gap:6}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
        </div>
      )}
      {!analysis&&(
        <button onClick={run} disabled={loading||!apiKey} style={{width:"100%",padding:"9px",borderRadius:7,border:"none",background:loading||!apiKey?"#e0e0e0":"#6338c8",color:loading||!apiKey?"#aaa":"#fff",fontSize:13,fontWeight:700,cursor:loading||!apiKey?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6,marginBottom:10}}>
          {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analyzing...</>:<><i className="ti ti-sparkles" style={{fontSize:13}}/>Run Competitive Analysis</>}
        </button>
      )}
      {error&&<div style={{fontSize:12,color:"#d42b2b",padding:"8px 12px",background:"rgba(212,43,43,0.06)",borderRadius:7,marginBottom:10}}>{error}</div>}
      {analysis&&(
        <div>
          <div style={{fontSize:13,color:"#333",lineHeight:1.8,whiteSpace:"pre-wrap",background:"rgba(99,56,200,0.04)",borderRadius:8,padding:"14px 16px",borderLeft:"3px solid #6338c8",marginBottom:10}}>{analysis}</div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>{setAnalysis(null);setKeySaved(false);}} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}><i className="ti ti-refresh" style={{marginRight:4}}/>Refresh</button>
            <button onClick={()=>{setAnalysis(null);}} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>Change Key</button>
          </div>
        </div>
      )}
      {!analysis&&!loading&&!error&&<div style={{fontSize:12,color:"#aaa",fontStyle:"italic"}}>Enter your Gemini API key and run analysis to get AI-powered competitive intelligence.</div>}
    </div>
  );
}

/* ── Workspace ──────────────────────────────────────────────── */
function CRWorkspace({curRows,compRows,cm,compCm,onReupload,onExport}){
  const[filters,setFilters]=useState({keyword:"",matchType:"all",minCpc:"",minSpend:""});
  const[showFilters,setShowFilters]=useState(false);
  const[activeTab,setActiveTab]=useState("overview");

  const curAgg=useMemo(()=>crSumAgg(curRows,cm),[curRows,cm]);
  const compAgg=useMemo(()=>compRows&&compRows.length?crSumAgg(compRows,compCm||cm):null,[compRows,compCm,cm]);
  const pressureScore=useMemo(()=>crPressureScore(curAgg,compAgg),[curAgg,compAgg]);

  const compMap=useMemo(()=>{
    if(!compRows||!compRows.length)return null;
    const m={};
    compRows.forEach(r=>{
      const k=String(r[(compCm||cm).searchTerm]||r[(compCm||cm).campaign]||"").toLowerCase().trim();
      if(k)m[k]=crCalcMetrics(r,compCm||cm);
    });
    return m;
  },[compRows,compCm,cm]);

  const alerts=useMemo(()=>crDetectAlerts(curAgg,compAgg,curRows,cm),[curAgg,compAgg,curRows,cm]);
  const opps=useMemo(()=>crOpportunities(curAgg,compAgg,curRows,cm),[curAgg,compAgg,curRows,cm]);

  const TABS=[
    {key:"overview",label:"Overview",icon:"ti-layout-dashboard"},
    {key:"threats",label:`Threats${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-octagon"},
    {key:"table",label:"Intelligence Table",icon:"ti-table"},
    {key:"counterattack",label:`Counterattack${opps.length?` (${opps.length})`:""}`,icon:"ti-rocket"},
    {key:"ai",label:"AI Analysis",icon:"ti-brain"},
  ];

  return(
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f7f7f7"}}>
      {/* Tab nav */}
      <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",padding:"0 24px",display:"flex",alignItems:"center",gap:0,flexShrink:0,overflowX:"auto"}}>
        {TABS.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"12px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:400,color:activeTab===t.key?"#4f46e5":"#888",borderBottom:activeTab===t.key?"2.5px solid #4f46e5":"2.5px solid transparent",display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap",flexShrink:0}}>
            <i className={`ti ${t.icon}`} style={{fontSize:12}}/>{t.label}
          </button>
        ))}
        <div style={{flex:1}}/>
        <button onClick={()=>setShowFilters(v=>!v)} style={{padding:"6px 11px",borderRadius:7,border:"1px solid #e0e0e0",background:showFilters?"#f0f0f0":"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
          <i className="ti ti-filter" style={{fontSize:11}}/>Filters
        </button>
        <button onClick={onReupload} style={{marginLeft:8,padding:"6px 11px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
          <i className="ti ti-upload" style={{fontSize:11}}/>Re-upload
        </button>
        <button onClick={()=>onExport(curRows,curAgg,compAgg,alerts,opps,cm)} style={{marginLeft:8,padding:"6px 11px",borderRadius:7,border:"none",background:"#4f46e5",cursor:"pointer",fontSize:11,color:"#fff",fontWeight:700,display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
          <i className="ti ti-download" style={{fontSize:11}}/>Export
        </button>
      </div>

      {/* Filters bar */}
      {showFilters&&(
        <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",padding:"10px 24px",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",flexShrink:0}}>
          <input placeholder="Filter keyword..." value={filters.keyword} onChange={e=>setFilters(f=>({...f,keyword:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:160,fontFamily:"inherit"}}/>
          <select value={filters.matchType} onChange={e=>setFilters(f=>({...f,matchType:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,fontFamily:"inherit"}}>
            <option value="all">All Match Types</option>
            <option value="exact">Exact</option>
            <option value="phrase">Phrase</option>
            <option value="broad">Broad</option>
          </select>
          <input placeholder="Min CPC $" value={filters.minCpc} onChange={e=>setFilters(f=>({...f,minCpc:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:90,fontFamily:"inherit"}}/>
          <input placeholder="Min Spend $" value={filters.minSpend} onChange={e=>setFilters(f=>({...f,minSpend:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:100,fontFamily:"inherit"}}/>
          <button onClick={()=>setFilters({keyword:"",matchType:"all",minCpc:"",minSpend:""})} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>Clear</button>
        </div>
      )}

      {/* Content */}
      <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>

        {/* OVERVIEW TAB */}
        {activeTab==="overview"&&(
          <>
            <div style={{padding:"16px 20px 0",background:"#f7f7f7"}}>
              <ModuleOverview
                moduleName="Competitor Radar" moduleIcon="ti-radar" periods={null}
                cur={curAgg} comp={compAgg}
                rows={curRows||[]}
                extraKpis={[{label:"Pressure Score",value:pressureScore,fmt:"int",icon:"ti-gauge",color:pressureScore>70?"#d42b2b":pressureScore>40?"#c47a00":"#1a7a3c"}]}
                alerts={[]}
              />
            </div>
            <CRPressureBar cur={curAgg} comp={compAgg} pressureScore={pressureScore}/>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px"}}>
                <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
                  <i className="ti ti-alert-octagon" style={{color:"#d42b2b",fontSize:13}}/>Detected Threats
                </div>
                {alerts.length===0?<div style={{fontSize:12,color:"#aaa"}}>No threats detected. Upload comparison period for full analysis.</div>
                :alerts.slice(0,4).map(a=>(
                  <div key={a.id} style={{fontSize:12,color:"#444",padding:"6px 0",borderBottom:"1px solid #f5f5f5",display:"flex",gap:8,alignItems:"flex-start"}}>
                    <span style={{width:6,height:6,borderRadius:"50%",background:a.severity==="critical"?"#d42b2b":a.severity==="high"?"#c47a00":"#1a5fa0",flexShrink:0,marginTop:4}}/>
                    <span style={{flex:1}}>{a.type}</span>
                    <span style={{fontSize:9,color:"#aaa"}}>{a.severity}</span>
                  </div>
                ))}
                {alerts.length>4&&<div style={{fontSize:11,color:"#4f46e5",marginTop:6,cursor:"pointer"}} onClick={()=>setActiveTab("threats")}>+{alerts.length-4} more →</div>}
              </div>
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px"}}>
                <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
                  <i className="ti ti-rocket" style={{color:"#1a7a3c",fontSize:13}}/>Counterattack Opportunities
                </div>
                {opps.slice(0,4).map(o=>(
                  <div key={o.id} style={{fontSize:12,color:"#444",padding:"6px 0",borderBottom:"1px solid #f5f5f5",display:"flex",gap:8,alignItems:"flex-start"}}>
                    <span style={{width:6,height:6,borderRadius:"50%",background:"#1a7a3c",flexShrink:0,marginTop:4}}/>
                    {o.title}
                  </div>
                ))}
                {opps.length>4&&<div style={{fontSize:11,color:"#1a7a3c",marginTop:6,cursor:"pointer"}} onClick={()=>setActiveTab("counterattack")}>+{opps.length-4} more →</div>}
              </div>
            </div>
          </>
        )}

        {/* THREATS TAB */}
        {activeTab==="threats"&&(
          <>
            <div style={{fontSize:13,color:"#666",marginBottom:14}}>
              {alerts.length===0?"No threats detected. Upload a comparison period report for full competitor pressure analysis.":
              `${alerts.length} competitive threat${alerts.length!==1?"s":""} detected — click each to see full explanation and counteraction.`}
              {!compAgg&&<span style={{color:"#c47a00",marginLeft:8,fontSize:11}}><i className="ti ti-alert-triangle" style={{marginRight:3}}/>Upload comparison period for delta analysis</span>}
            </div>
            {alerts.map(a=><CRAlertCard key={a.id} alert={a}/>)}
            {alerts.length===0&&(
              <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"32px",textAlign:"center"}}>
                <i className="ti ti-shield-check" style={{fontSize:36,color:"#1a7a3c",display:"block",marginBottom:10}}/>
                <div style={{fontSize:14,fontWeight:700,color:"#111",marginBottom:4}}>No Competitive Threats Detected</div>
                <div style={{fontSize:12,color:"#888"}}>Upload a comparison period report to enable full delta-based threat detection.</div>
              </div>
            )}
          </>
        )}

        {/* TABLE TAB */}
        {activeTab==="table"&&(
          <CRTable rows={curRows} cm={cm} compMap={compMap} filters={filters}/>
        )}

        {/* COUNTERATTACK TAB */}
        {activeTab==="counterattack"&&(
          <>
            <div style={{fontSize:13,color:"#666",marginBottom:14}}>
              {opps.length} counterattack opportunit{opps.length!==1?"ies":"y"} identified — prioritized by strategic impact.
            </div>
            {opps.map(o=><CROppCard key={o.id} opp={o}/>)}
          </>
        )}

        {/* AI TAB */}
        {activeTab==="ai"&&(
          <CRAIPanel curAgg={curAgg} compAgg={compAgg} alerts={alerts} opps={opps}/>
        )}
      </div>
    </div>
  );
}

/* ── Export Page ────────────────────────────────────────────── */
function CRExportPage({rows,curAgg,compAgg,alerts,opps,cm,onBack}){
  function doExport(){
    const wb=XLSX.utils.book_new();

    /* Sheet 1 — Keyword intelligence */
    const h1=["Keyword / Term","Campaign","Match Type","Spend","Sales","ACoS%","CPC","CTR%","CVR%","Impressions","Click Share%","Conv Share%","Pressure Score","Aggression Score","Risk Level","Suggested Action"];
    const r1=rows.map(r=>{
      const term=String(r[cm.searchTerm]||r[cm.campaign]||"");
      const m=crCalcMetrics(r,cm);
      const pressure=crPressureScore(m,null);
      const aggression=crAggressionScore(m,null);
      const risk=pressure>=70?"Critical":pressure>=50?"High":pressure>=30?"Medium":"Low";
      const action=m.spend>10&&m.orders===0?"Pause / reduce bid":m.acos>50?"Cut bid 20%+":m.impressions<300&&m.orders>0?"Increase bid 15–25%":m.acos<20&&m.orders>=2?"Scale":"Monitor";
      return{"Keyword / Term":term,"Campaign":String(r[cm.campaign]||""),"Match Type":String(r[cm.matchType]||""),Spend:m.spend.toFixed(2),"Sales":m.sales.toFixed(2),"ACoS%":m.acos.toFixed(1),CPC:m.cpc.toFixed(2),"CTR%":m.ctr.toFixed(2),"CVR%":m.cvr.toFixed(1),Impressions:Math.round(m.impressions),"Click Share%":m.clickShare.toFixed(1),"Conv Share%":m.convShare.toFixed(1),"Pressure Score":pressure,"Aggression Score":aggression,"Risk Level":risk,"Suggested Action":action};
    });
    const ws1=XLSX.utils.json_to_sheet(r1,{header:h1});ws1["!cols"]=h1.map(()=>({wch:20}));
    XLSX.utils.book_append_sheet(wb,ws1,"Competitor Intelligence");

    /* Sheet 2 — Threat alerts */
    if(alerts.length){
      const h2=["Threat Type","Severity","Keyword","Current","Previous","Delta","Root Cause","Counteraction","Estimated Impact","Confidence %"];
      const r2=alerts.map(a=>({
        "Threat Type":a.type,Severity:a.severity,Keyword:a.keyword,
        Current:a.current,Previous:a.previous,Delta:a.delta,
        "Root Cause":a.cause,Counteraction:a.action,"Estimated Impact":a.impact,"Confidence %":a.confidence||""
      }));
      const ws2=XLSX.utils.json_to_sheet(r2,{header:h2});ws2["!cols"]=h2.map(()=>({wch:28}));
      XLSX.utils.book_append_sheet(wb,ws2,"Competitive Threats");
    }

    /* Sheet 3 — Counterattack opportunities */
    if(opps.length){
      const h3=["Opportunity","Type","Why","Counter-Strategy","Expected Impact"];
      const r3=opps.map(o=>({Opportunity:o.title,Type:o.type,Why:o.why,"Counter-Strategy":o.action,"Expected Impact":o.impact}));
      const ws3=XLSX.utils.json_to_sheet(r3,{header:h3});ws3["!cols"]=h3.map(()=>({wch:32}));
      XLSX.utils.book_append_sheet(wb,ws3,"Counterattack Opportunities");
    }

    /* Sheet 4 — Bulk bid action sheet (high-pressure, actionable rows) */
    const actionRows=rows.filter(r=>{const m=crCalcMetrics(r,cm);return(m.spend>5&&m.orders===0)||(m.acos>40&&m.orders>0);});
    if(actionRows.length){
      const h4=["Keyword","Campaign","Match Type","Current Spend","Current ACoS%","Current CPC","Recommended Action","New Bid Direction"];
      const r4=actionRows.map(r=>{
        const m=crCalcMetrics(r,cm);
        const action=m.spend>10&&m.orders===0?"Pause or reduce bid 40%":m.acos>60?"Reduce bid 25%":m.acos>40?"Reduce bid 15%":"Review";
        const dir=m.spend>10&&m.orders===0?"↓ Reduce":"↓ Reduce";
        return{Keyword:String(r[cm.searchTerm]||r[cm.campaign]||""),Campaign:String(r[cm.campaign]||""),"Match Type":String(r[cm.matchType]||""),"Current Spend":m.spend.toFixed(2),"Current ACoS%":m.acos.toFixed(1),"Current CPC":m.cpc.toFixed(2),"Recommended Action":action,"New Bid Direction":dir};
      });
      const ws4=XLSX.utils.json_to_sheet(r4,{header:h4});ws4["!cols"]=h4.map(()=>({wch:24}));
      XLSX.utils.book_append_sheet(wb,ws4,"Defensive Bid Actions");
    }

    XLSX.writeFile(wb,`Quarred_CompetitorRadar_${new Date().toISOString().slice(0,10)}.xlsx`);
  }

  const criticalCount=alerts.filter(a=>a.severity==="critical").length;
  const actionRows=rows.filter(r=>{const m=crCalcMetrics(r,cm);return(m.spend>5&&m.orders===0)||(m.acos>40&&m.orders>0);}).length;

  return(
    <div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:660,margin:"0 auto",padding:"32px 24px"}}>
        <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:16}}>
          <i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace
        </button>
        <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Competitor Actions</h2>
        <p style={{fontSize:13,color:"#666",margin:"0 0 22px"}}>Strategist-ready workbook with competitive intelligence, threat alerts, counterattack plans, and defensive bid actions.</p>

        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Export Summary</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
            {[
              {label:"Total Rows",val:rows.length,color:"#555"},
              {label:"Critical Threats",val:criticalCount,color:"#d42b2b"},
              {label:"Opportunities",val:opps.length,color:"#1a7a3c"},
              {label:"Bid Actions",val:actionRows,color:"#c47a00"},
            ].map(s=>(
              <div key={s.label} style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:4}}>{s.val}</div>
                <div style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{fontSize:12,color:"#555",marginBottom:14,lineHeight:1.6}}>
            Export includes: Competitor Intelligence · Competitive Threats · Counterattack Opportunities{actionRows>0?" · Defensive Bid Actions":""}.
          </div>
          <button onClick={doExport} style={{width:"100%",padding:"12px",borderRadius:9,border:"none",background:"#4f46e5",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}>
            <i className="ti ti-download" style={{fontSize:14}}/> Download Competitor Intelligence Workbook
          </button>
        </div>

        <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>Competitive response best practices</div>
          {[
            "CPC inflation above 20% is a clear signal — competitors are actively bidding up your terms",
            "Click share loss matters more than impression loss — it means your ads are showing but losing the click",
            "Never reduce bids reactively across the board — isolate the specific terms under pressure first",
            "Branded exact match is always the highest-ROI defensive action under competitive pressure",
            "Competitor overspend creates afternoon budget gaps — maintain bids to capitalize on their budget exhaustion",
          ].map((s,i)=>(
            <div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}>
              <span style={{width:17,height:17,borderRadius:"50%",background:"#4f46e5",color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span>
              <span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Module Root ────────────────────────────────────────────── */
function CompetitorRadarModule({globalData,setTab}){
  const[page,setPage]=useState("upload");
  const[periods,setPeriods]=useState(globalData?.periods||null);
  const[data,setData]=useState(null);
  const[exportArgs,setExportArgs]=useState(null);
  useEffect(()=>{if(globalData?.cur?.primary&&!data&&page==="upload"){const cm=globalData.cur.primary.cm;setData({curRows:globalData.cur.primary.rows,compRows:globalData.comp?.primary?.rows||null,cm,compCm:globalData.comp?.primary?.cm||null,periods:globalData.periods});setPeriods(globalData.periods||null);setPage("workspace");}},[globalData]);

  const HEADER=(
    <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
      <i className="ti ti-radar" style={{fontSize:15,color:"#4f46e5"}}/>
      <h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Competitor Attack Radar</h2>
      <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(200,120,0,0.12)",color:"#9a5800",fontWeight:700}}>Advanced</span>
    </div>
  );

  if(page==="export"&&exportArgs){
    return(
      <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
        <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}>
          <h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Competitor Attack Radar — Export</h2>
        </div>
        <CRExportPage {...exportArgs} onBack={()=>setPage("workspace")}/>
      </div>
    );
  }

  if(page==="workspace"&&data){
    return(
      <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
        {HEADER}
        <CRWorkspace
          {...data}
          onReupload={()=>{setData(null);setPage("upload");}}
          onExport={(rows,curAgg,compAgg,alerts,opps,cm)=>{
            setExportArgs({rows,curAgg,compAgg,alerts,opps,cm});
            setPage("export");
          }}
        />
      </div>
    );
  }

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {HEADER}
      <CRUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={d=>{setData(d);setPage("workspace");}}/> 
    </div>
  );
}


/* ================================================================
   PORTFOLIO PERFORMANCE COMMAND CENTER MODULE
================================================================ */

const PP_ALIASES={
  portfolio:   ["Portfolio Name","Portfolio","portfolio name","Portfolio name"],
  campaign:    ["Campaign Name","Campaign","campaign name","Campaign Name (Informational only)"],
  impressions: ["Impressions","impressions","Total Impressions"],
  clicks:      ["Clicks","clicks","Total Clicks"],
  spend:       ["Spend","Cost","Ad Spend","Spend ($)"],
  sales:       ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales","Total Sales","Attributed Sales","Revenue"],
  orders:      ["Orders","14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)","Total Orders","Attributed Conversions"],
  acos:        ["ACOS","ACoS","Advertising Cost of Sales","ACOS (%)"],
  roas:        ["ROAS","Return on Ad Spend"],
  cpc:         ["CPC","Cost Per Click","Average CPC","CPC ($)"],
  ctr:         ["Click-through Rate","CTR","Click-Through Rate","CTR (%)"],
  cvr:         ["Conversion Rate","CVR","Order Rate","Unit Session Percentage"],
  budget:      ["Budget","Daily Budget","Campaign Budget","Portfolio Budget"],
  state:       ["State","Status","Campaign State","Campaign State (Informational only)"],
  entity:      ["Entity","Record Type","Type"],
};

function ppDetect(headers){
  const r={};
  for(const[k,cands]of Object.entries(PP_ALIASES)){
    for(const c of cands){const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());if(h){r[k]=h;break;}}
    if(!r[k]){for(const c of cands){const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));if(h){r[k]=h;break;}}}
  }
  return r;
}
function ppNum(row,col){if(!col||row[col]==null||row[col]==="")return 0;const v=parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,""));return isNaN(v)?0:v;}
function ppCalc(row,cm){
  const imp=ppNum(row,cm.impressions),clk=ppNum(row,cm.clicks),spd=ppNum(row,cm.spend),sal=ppNum(row,cm.sales),ord=ppNum(row,cm.orders);
  const ctr=cm.ctr&&ppNum(row,cm.ctr)>0?ppNum(row,cm.ctr):imp>0?(clk/imp)*100:0;
  const acos=cm.acos&&ppNum(row,cm.acos)>0?ppNum(row,cm.acos):sal>0?(spd/sal)*100:0;
  const cvr=cm.cvr&&ppNum(row,cm.cvr)>0?ppNum(row,cm.cvr):clk>0?(ord/clk)*100:0;
  const cpc=cm.cpc&&ppNum(row,cm.cpc)>0?ppNum(row,cm.cpc):clk>0?spd/clk:0;
  const roas=cm.roas&&ppNum(row,cm.roas)>0?ppNum(row,cm.roas):spd>0?sal/spd:0;
  return{impressions:imp,clicks:clk,spend:spd,sales:sal,orders:ord,ctr,acos,cvr,cpc,roas};
}

/* Group rows by portfolio name */
function ppGroupByPortfolio(rows,cm){
  const map={};
  rows.forEach(r=>{
    const name=String(r[cm.portfolio]||r[cm.campaign]||"(Unassigned)").trim()||"(Unassigned)";
    if(!map[name])map[name]={name,impressions:0,clicks:0,spend:0,sales:0,orders:0};
    const m=ppCalc(r,cm);
    map[name].impressions+=m.impressions;map[name].clicks+=m.clicks;
    map[name].spend+=m.spend;map[name].sales+=m.sales;map[name].orders+=m.orders;
  });
  return Object.values(map).map(p=>{
    const acos=p.sales>0?(p.spend/p.sales)*100:0;
    const ctr=p.impressions>0?(p.clicks/p.impressions)*100:0;
    const cvr=p.clicks>0?(p.orders/p.clicks)*100:0;
    const cpc=p.clicks>0?p.spend/p.clicks:0;
    const roas=p.spend>0?p.sales/p.spend:0;
    const tacos=p.sales>0?(p.spend/p.sales)*100:0; // same as acos at portfolio level without organic sales
    return{...p,acos,ctr,cvr,cpc,roas,tacos};
  });
}

/* Efficiency score 0–100 */
function ppEffScore(p){
  let s=50;
  if(p.acos>0&&p.acos<20)s+=25;else if(p.acos<30)s+=10;else if(p.acos>50)s-=25;else if(p.acos>40)s-=15;
  if(p.cvr>5)s+=15;else if(p.cvr>2)s+=5;else if(p.cvr<1&&p.clicks>50)s-=15;
  if(p.roas>4)s+=10;else if(p.roas>2)s+=5;else if(p.roas<1&&p.spend>50)s-=10;
  return Math.max(0,Math.min(100,Math.round(s)));
}

/* Scaling score 0–100 */
function ppScaleScore(p,comp){
  let s=0;
  if(p.acos<25&&p.orders>0)s+=30;
  if(p.cvr>3)s+=20;
  if(p.roas>3)s+=20;
  if(comp){
    if(p.sales>comp.sales*1.1)s+=15;
    if(p.acos<comp.acos)s+=15;
  }else{
    if(p.orders>=5)s+=15;
    if(p.spend>0&&p.sales>p.spend*2)s+=15;
  }
  return Math.max(0,Math.min(100,Math.round(s)));
}

/* Account-level aggregate */
function ppAccountAgg(portfolios){
  const totSpend=portfolios.reduce((s,p)=>s+p.spend,0);
  const totSales=portfolios.reduce((s,p)=>s+p.sales,0);
  const totOrders=portfolios.reduce((s,p)=>s+p.orders,0);
  const totClicks=portfolios.reduce((s,p)=>s+p.clicks,0);
  const totImp=portfolios.reduce((s,p)=>s+p.impressions,0);
  return{spend:totSpend,sales:totSales,orders:totOrders,clicks:totClicks,impressions:totImp,
    acos:totSales>0?(totSpend/totSales)*100:0,tacos:totSales>0?(totSpend/totSales)*100:0,
    cpc:totClicks>0?totSpend/totClicks:0,cvr:totClicks>0?(totOrders/totClicks)*100:0,
    roas:totSpend>0?totSales/totSpend:0,count:portfolios.length};
}

/* Alert detection */
function ppAlerts(portfolios,compMap){
  const alerts=[];
  portfolios.forEach(p=>{
    const comp=compMap?.[p.name.toLowerCase()];
    const eff=ppEffScore(p);

    /* Budget drain */
    if(p.spend>50&&p.orders===0){
      alerts.push({id:`drain_${p.name}`,type:"Budget Drain Portfolio",severity:"critical",portfolio:p.name,
        current:`$${p.spend.toFixed(0)} spend, 0 orders`,previous:comp?`$${comp.spend.toFixed(0)} spend, ${comp.orders} orders`:"—",
        cause:`Portfolio "${p.name}" spent $${p.spend.toFixed(0)} with zero conversions. Every dollar is wasted — no revenue generated.`,
        action:"Pause all campaigns in this portfolio immediately. Audit keywords and match types. Rebuild with exact match only before reinstating.",
        impact:`$${p.spend.toFixed(0)} fully wasted — recoverable by pausing`,confidence:95});
    }

    /* Efficiency collapse */
    if(comp&&p.acos>0&&comp.acos>0&&p.acos>comp.acos*1.35&&p.spend>30){
      const delta=((p.acos-comp.acos)/comp.acos)*100;
      alerts.push({id:`collapse_${p.name}`,type:"Portfolio Efficiency Collapse",severity:"critical",portfolio:p.name,
        current:`ACoS ${p.acos.toFixed(1)}%`,previous:`ACoS ${comp.acos.toFixed(1)}%`,
        cause:`ACoS worsened ${delta.toFixed(0)}% vs previous period. Portfolio "${p.name}" is deteriorating rapidly — competitors may be pushing up CPCs or listing conversion dropped.`,
        action:"Reduce bids 15–25% across all campaigns in this portfolio. Pause zero-converting keywords. Review listing quality and pricing.",
        impact:`Recovering to previous ACoS would save ~$${((p.acos-comp.acos)/100*p.sales).toFixed(0)}`,confidence:82});
    }

    /* High ACoS waste */
    if(p.acos>60&&p.spend>100&&p.orders>0){
      alerts.push({id:`highacos_${p.name}`,type:"Budget Drain Portfolio",severity:"high",portfolio:p.name,
        current:`ACoS ${p.acos.toFixed(1)}%`,previous:comp?`ACoS ${comp.acos.toFixed(1)}%`:"—",
        cause:`Portfolio "${p.name}" ACoS at ${p.acos.toFixed(1)}% — spending $${(p.acos/100).toFixed(2)} to generate $1 of sales. Deeply unprofitable.`,
        action:"Cut bids 20–30% across portfolio. Pause keywords with ACoS > 100%. Focus budget on top 20% converting keywords only.",
        impact:`Reducing ACoS to 30% on current sales would save $${((p.acos-30)/100*p.sales).toFixed(0)}`,confidence:78});
    }

    /* Scaling opportunity */
    if(p.acos<25&&p.orders>=5&&p.roas>3){
      alerts.push({id:`scale_${p.name}`,type:"Scaling Portfolio Opportunity",severity:"low",portfolio:p.name,
        current:`ACoS ${p.acos.toFixed(1)}%, ROAS ${p.roas.toFixed(1)}x, ${p.orders} orders`,previous:comp?`ACoS ${comp.acos.toFixed(1)}%, ${comp.orders} orders`:"—",
        cause:`Portfolio "${p.name}" is performing strongly with ${p.acos.toFixed(1)}% ACoS and ${p.roas.toFixed(1)}x ROAS. This portfolio has proven efficiency and should receive more budget.`,
        action:"Increase daily budget by 30–50%. Raise bids 10–15% on top-performing keywords. Launch new broad/phrase campaigns to expand reach.",
        impact:`Every additional $100 in budget could generate ~$${(p.roas*100).toFixed(0)} in revenue at current ROAS`,confidence:80});
    }

    /* Conversion weakness */
    if(p.clicks>200&&p.cvr<0.5&&p.spend>50){
      alerts.push({id:`cvr_${p.name}`,type:"Portfolio Conversion Weakness",severity:"high",portfolio:p.name,
        current:`CVR ${p.cvr.toFixed(2)}%, ${p.clicks} clicks`,previous:comp?`CVR ${comp.cvr.toFixed(2)}%`:"—",
        cause:`Portfolio "${p.name}" CVR at ${p.cvr.toFixed(2)}% — far below 2% benchmark. Traffic is arriving but not converting. Listing quality or targeting precision issue.`,
        action:"Audit all product listings in this portfolio. Check pricing vs competitors. Review which search terms are driving traffic — likely too broad.",
        impact:`Improving CVR to 2% on current traffic would generate ~${Math.round(p.clicks*0.015)} additional orders`,confidence:76});
    }
  });

  /* Uneven budget allocation */
  if(portfolios.length>2){
    const totalSpend=portfolios.reduce((s,p)=>s+p.spend,0);
    const topSpend=Math.max(...portfolios.map(p=>p.spend));
    if(totalSpend>0&&topSpend/totalSpend>0.7){
      const topPortfolio=portfolios.find(p=>p.spend===topSpend);
      alerts.push({id:"uneven_budget",type:"Uneven Budget Allocation",severity:"medium",portfolio:"Account-wide",
        current:`${((topSpend/totalSpend)*100).toFixed(0)}% budget in one portfolio`,previous:"—",
        cause:`Portfolio "${topPortfolio?.name}" consumes ${((topSpend/totalSpend)*100).toFixed(0)}% of total ad spend. Over-concentration creates risk if this portfolio underperforms.`,
        action:"Review whether budget concentration matches performance. Reallocate 15–20% to next-best performing portfolio to diversify.",
        impact:"Diversified budget allocation reduces account-wide volatility",confidence:70});
    }
  }

  return alerts.sort((a,b)=>({critical:0,high:1,medium:2,low:3}[a.severity]||3)-({critical:0,high:1,medium:2,low:3}[b.severity]||3));
}

/* Strategy recommendations */
function ppStrategy(portfolios,compMap){
  const recs=[];
  const totalSpend=portfolios.reduce((s,p)=>s+p.spend,0);

  /* Find best performers for expansion */
  const topPerformers=portfolios.filter(p=>p.acos<25&&p.orders>=3&&p.roas>2).sort((a,b)=>b.roas-a.roas);
  if(topPerformers.length>0){
    recs.push({id:"expand_best",type:"expansion",title:"Budget Expansion Opportunity",
      why:`${topPerformers.length} portfolio${topPerformers.length>1?"s":""} (${topPerformers.slice(0,2).map(p=>p.name).join(", ")}) performing efficiently with ACoS < 25% and ROAS > 2x. Under-funded relative to their potential.`,
      movement:compMap?`Top performer improved vs previous period`:null,
      action:"Increase daily budgets by 30–50% on these portfolios. Ensure no campaigns are hitting budget caps mid-day. Consider launching new campaigns within these portfolios.",
      impact:`At current ROAS, additional $${Math.round(totalSpend*0.2)} budget could generate ~$${Math.round(topPerformers[0]?.roas*totalSpend*0.2)} in revenue`});
  }

  /* Find worst performers for reduction */
  const drains=portfolios.filter(p=>p.acos>50&&p.spend>30);
  if(drains.length>0){
    recs.push({id:"reduce_drains",type:"reallocation",title:"Defensive Budget Reallocation",
      why:`${drains.length} portfolio${drains.length>1?"s":""} (${drains.slice(0,2).map(p=>p.name).join(", ")}) running ACoS > 50%. Budget flowing to these is destroying account-level efficiency.`,
      movement:compMap?"ACoS worsening vs previous period on these portfolios":null,
      action:"Reduce budgets 30–50% on drain portfolios. Move released budget to top-performing portfolios. Implement strict bid caps in drain portfolios.",
      impact:`Reallocating $${drains.reduce((s,p)=>s+p.spend*0.4,0).toFixed(0)} from drains to performers could significantly improve account ROAS`});
  }

  /* Fragmentation */
  if(portfolios.length>8){
    const smallPortfolios=portfolios.filter(p=>p.spend<20&&p.orders<2);
    if(smallPortfolios.length>3){
      recs.push({id:"consolidate",type:"consolidation",title:"Portfolio Consolidation Opportunity",
        why:`${smallPortfolios.length} portfolios with minimal spend (<$20) and low orders. Over-fragmentation makes optimization harder and dilutes algorithmic learning.`,
        movement:null,
        action:"Consolidate underperforming small portfolios into 2–3 broader portfolio categories. Amazon's algorithm learns better from consolidated data.",
        impact:"Consolidation improves Amazon's bid optimization and simplifies strategic management"});
    }
  }

  /* Recovery opportunities */
  if(compMap){
    const recovering=portfolios.filter(p=>{const c=compMap[p.name.toLowerCase()];return c&&p.sales<c.sales*0.8&&c.sales>100;});
    if(recovering.length>0){
      recs.push({id:"recovery",type:"recovery",title:"Portfolio Recovery Opportunities",
        why:`${recovering.length} portfolio${recovering.length>1?"s":""} showing significant sales decline vs previous period. These previously strong portfolios may be recoverable.`,
        movement:`Sales declined >20% vs previous period`,
        action:"Audit bid levels — may have been reduced too aggressively. Check for ranking drops on key ASINs. Review competitor activity in these categories.",
        impact:"Recovering lost sales volume without additional spend improves account-level ROAS"});
    }
  }

  return recs;
}

async function ppAIAnalysis(accountAgg,compAgg,portfolios,alerts,recs,apiKey){
  const topP=portfolios.sort((a,b)=>b.spend-a.spend).slice(0,5).map(p=>`${p.name}: Spend $${p.spend.toFixed(0)}, ACoS ${p.acos.toFixed(1)}%, ROAS ${p.roas.toFixed(1)}x, Orders ${p.orders}`).join("\n");
  const prompt=`You are an Amazon PPC portfolio strategist. Analyze this portfolio performance data.

ACCOUNT TOTALS (CURRENT):
Spend: $${accountAgg.spend.toFixed(2)} | Sales: $${accountAgg.sales.toFixed(2)} | ACoS: ${accountAgg.acos.toFixed(1)}% | ROAS: ${accountAgg.roas.toFixed(2)}x | Orders: ${accountAgg.orders} | Portfolios: ${accountAgg.count}
${compAgg?`PREVIOUS: Spend $${compAgg.spend.toFixed(2)} | Sales $${compAgg.sales.toFixed(2)} | ACoS ${compAgg.acos.toFixed(1)}% | ROAS ${compAgg.roas.toFixed(2)}x`:"No comparison period."}

TOP PORTFOLIOS BY SPEND:
${topP}

ALERTS: ${alerts.map(a=>`${a.type} (${a.severity}) — ${a.portfolio}`).join(", ")||"None"}
STRATEGIC RECOMMENDATIONS: ${recs.map(r=>r.title).join(", ")||"None"}

Respond in exactly this structure:
1. OVERALL PORTFOLIO HEALTH (2 sentences — is the account well-structured or misallocated?)
2. BIGGEST INEFFICIENCY (1 sentence — where is budget being most wasted?)
3. HIGHEST PRIORITY PORTFOLIO MOVE (1 sentence — which portfolio needs immediate attention and why?)
4. BUDGET REALLOCATION DIRECTION (1 sentence — where should budget move this week?)
5. STRATEGIC WARNING (1 sentence — what happens if no action is taken?)

Be direct. Only reference data provided. No invented insights.`;
  const res=await geminiFetch(apiKey,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({contents:[{parts:[{text:prompt}]}]})});
  if(!res.ok){const e=await res.json();throw new Error(e?.error?.message||"Gemini error");}
  const data=await res.json();return data.candidates?.[0]?.content?.parts?.[0]?.text||"Analysis unavailable.";
}

/* ── Upload Zone (reusing same pattern) ─────────────────────── */
function PPUploadZone({label,file,onFile,onClear}){
  const[drag,setDrag]=useState(false);const ref=useRef();
  const handle=async f=>{if(!f)return;try{const p=await parseSheet(f);onFile(f,p);}catch(e){alert("Could not read: "+e.message);}};
  return(<div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)} onDrop={e=>{e.preventDefault();setDrag(false);handle(e.dataTransfer.files[0]);}} onClick={()=>!file&&ref.current?.click()} style={{border:`2px dashed ${drag?"#4f46e5":"#e0e0e0"}`,borderRadius:10,padding:"20px",background:drag?"rgba(79,70,229,0.04)":"#fafafa",cursor:"pointer"}}>
    <input ref={ref} type="file" accept=".xlsx,.csv" style={{display:"none"}} onChange={e=>handle(e.target.files[0])}/>
    {file?(<div style={{display:"flex",alignItems:"center",gap:10}}><i className="ti ti-file-spreadsheet" style={{fontSize:18,color:"#4f46e5"}}/><div style={{flex:1}}><div style={{fontSize:13,fontWeight:600,color:"#111"}}>{file.name}</div><div style={{fontSize:11,color:"#888"}}>{label} · detected</div></div><button onClick={e=>{e.stopPropagation();onClear();}} style={{padding:"3px 8px",borderRadius:5,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11}}>Remove</button></div>)
    :(<div style={{textAlign:"center"}}><i className="ti ti-cloud-upload" style={{fontSize:24,color:"#ccc",display:"block",marginBottom:6}}/><div style={{fontSize:13,fontWeight:600,color:"#555"}}>{label}</div><div style={{fontSize:11,color:"#aaa"}}>Drag & drop or click · .xlsx or .csv</div></div>)}
  </div>);
}

/* ── Upload Page — same pattern as NEGUploadPage ────────────── */
function PPUploadPage({periods,onPeriodSet,onComplete}){
  const[subPage,setSubPage]=useState(periods?"files":"dates");
  const[curFile,setCurFile]=useState(null);const[curParsed,setCurParsed]=useState(null);
  const[compFile,setCompFile]=useState(null);const[compParsed,setCompParsed]=useState(null);
  const[validated,setValidated]=useState(null);const[history,setHistory]=useState([]);
  const[err,setErr]=useState(null);const[loading,setLoading]=useState(false);
  const[localPeriods,setLocalPeriods]=useState(periods);

  const handleCur=async(f,p)=>{
    setCurFile(f);setCurParsed(p);
    const cm=ppDetect(p.headers);const found=Object.entries(cm).filter(([,v])=>v).map(([k])=>k);
    const hasKey=!!(cm.spend&&(cm.portfolio||cm.campaign));
    setValidated({found,hasKey,rows:p.rows});
    setHistory(h=>[{name:f.name,date:new Date().toLocaleTimeString(),rows:p.rows.length,valid:hasKey},...h.slice(0,4)]);
  };

  async function go(){
    if(!curParsed)return;setLoading(true);setErr(null);
    try{
      const cm=ppDetect(curParsed.headers);
      const compCm=compParsed?ppDetect(compParsed.headers):null;
      onComplete({curRows:curParsed.rows,compRows:compParsed?.rows||null,cm,compCm,periods:localPeriods});
    }catch(e){setErr("Error: "+e.message);}
    setLoading(false);
  }

  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setLocalPeriods(p);onPeriodSet(p);setSubPage("files");}}/></div>);

  return(<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
    <div style={{maxWidth:680,margin:"0 auto",padding:"32px 24px"}}>
      <div style={{marginBottom:22}}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
          <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
          {localPeriods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(localPeriods.current?.start)} → {fmtDisp(localPeriods.current?.end)}</span></div>}
        </div>
        <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Upload Portfolio Reports</h2>
        <p style={{fontSize:13,color:"#666",margin:0}}>Upload your Amazon campaign or portfolio reports. The system auto-detects portfolio groupings and maps all columns.</p>
      </div>

      <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:R}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Current Period <span style={{color:R}}>*</span></div></div>
        <PPUploadZone label="Current Period" file={curFile} onFile={handleCur} onClear={()=>{setCurFile(null);setCurParsed(null);setValidated(null);}}/>
        {validated&&<div style={{marginTop:8,padding:"9px 12px",borderRadius:7,background:validated.hasKey?"rgba(26,122,60,0.07)":"rgba(196,122,0,0.07)",border:`1px solid ${validated.hasKey?"rgba(26,122,60,0.2)":"rgba(196,122,0,0.2)"}`}}>
          <div style={{fontSize:12,fontWeight:600,color:validated.hasKey?"#1a7a3c":"#c47a00"}}><i className={`ti ${validated.hasKey?"ti-check":"ti-alert-triangle"}`} style={{marginRight:5}}/>{validated.hasKey?"Report validated":"Partial data"} · {validated.rows.length.toLocaleString()} rows · {validated.found.join(", ")}</div>
        </div>}
      </div>

      <div style={{marginBottom:12}}>
        <button onClick={()=>setCompFile(f=>f?"_clear_":null)} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 14px",borderRadius:8,border:`1.5px dashed ${compFile?"_clear_"!==compFile?R:"#e0e0e0":"#e0e0e0"}`,background:"#fff",cursor:"pointer",color:"#555",fontSize:12,fontWeight:600,width:"100%"}}>
          <i className="ti ti-plus" style={{fontSize:12}}/> Add Comparison Period (recommended — enables delta analysis)
        </button>
      </div>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:12}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:7,height:7,borderRadius:"50%",background:"#aaa"}}/><div style={{fontSize:13,fontWeight:700,color:"#111"}}>Comparison Period <span style={{fontSize:11,color:"#aaa",fontWeight:400}}>(optional)</span></div></div>
        <PPUploadZone label="Previous Period" file={compFile} onFile={(f,p)=>{setCompFile(f);setCompParsed(p);}} onClear={()=>{setCompFile(null);setCompParsed(null);}}/>
      </div>

      <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"14px 16px",marginBottom:12}}>
        <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10}}>Supported Report Types</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          {[{icon:"ti-briefcase",label:"Portfolio Report",note:"Direct portfolio-level data — best source"},
            {icon:"ti-speakerphone",label:"Campaign Report",note:"Campaign data — grouped by Portfolio Name column"},
            {icon:"ti-layout",label:"Placement Report",note:"Placement-level data for portfolio efficiency"},
            {icon:"ti-chart-bar",label:"Business Report",note:"ASIN-level data for portfolio conversion analysis"},
            {icon:"ti-file-spreadsheet",label:"Bulk File",note:"Full Amazon bulk export — auto-detects portfolio structure"}
          ].map((s,i)=>(<div key={i} style={{display:"flex",gap:9,alignItems:"flex-start",padding:"8px",borderRadius:7,background:"#fafafa"}}>
            <i className={`ti ${s.icon}`} style={{fontSize:13,color:R,flexShrink:0,marginTop:1}}/>
            <div><div style={{fontSize:11,fontWeight:600,color:"#111"}}>{s.label}</div><div style={{fontSize:10,color:"#aaa",lineHeight:1.4}}>{s.note}</div></div>
          </div>))}
        </div>
      </div>

      {history.length>0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"14px 16px",marginBottom:12}}>
        <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>Upload History</div>
        {history.map((h,i)=>(<div key={i} style={{display:"flex",alignItems:"center",gap:9,padding:"6px 0",borderBottom:i<history.length-1?"1px solid #f5f5f5":"none"}}>
          <i className={`ti ${h.valid?"ti-check-circle":"ti-alert-circle"}`} style={{fontSize:13,color:h.valid?"#1a7a3c":"#c47a00",flexShrink:0}}/>
          <div style={{flex:1}}><div style={{fontSize:12,fontWeight:600,color:"#111"}}>{h.name}</div><div style={{fontSize:10,color:"#aaa"}}>{h.rows.toLocaleString()} rows · {h.date}</div></div>
          <span style={{fontSize:9,padding:"2px 6px",borderRadius:3,background:h.valid?"rgba(26,122,60,0.1)":"rgba(196,122,0,0.1)",color:h.valid?"#1a7a3c":"#c47a00",fontWeight:700}}>{h.valid?"Valid":"Partial"}</span>
        </div>))}
      </div>}

      {err&&<div style={{padding:"10px 14px",background:"#FCEBEB",borderRadius:8,border:"1px solid #F7C1C1",fontSize:12,color:"#A32D2D",marginBottom:12}}><i className="ti ti-alert-triangle" style={{marginRight:5}}/>{err}</div>}
      <div style={{display:"flex",justifyContent:"flex-end"}}>
        <button onClick={go} disabled={!curParsed||loading} style={{...T.btnR(false),opacity:curParsed&&!loading?1:0.4,fontWeight:700,boxShadow:curParsed?"0 2px 10px rgba(79,70,229,0.3)":"none"}}>
          {loading?<><i className="ti ti-loader" style={{fontSize:14}}/> Processing...</>:<><i className="ti ti-command" style={{fontSize:14}}/> Open Portfolio Workspace</>}
        </button>
      </div>
    </div>
  </div>);
}

/* ── KPI Bar — same style as existing modules ───────────────── */
function PPKPIBar({cur,comp}){
  const defs=[
    {k:"spend",   label:"Total Spend",   fmt:v=>`$${v>=1e3?(v/1e3).toFixed(1)+"K":v.toFixed(0)}`,lb:true},
    {k:"sales",   label:"Total Sales",   fmt:v=>`$${v>=1e3?(v/1e3).toFixed(1)+"K":v.toFixed(0)}`,lb:false},
    {k:"acos",    label:"Avg ACoS",      fmt:v=>`${v.toFixed(1)}%`,lb:true,isPp:true},
    {k:"roas",    label:"Avg ROAS",      fmt:v=>`${v.toFixed(2)}x`,lb:false},
    {k:"cpc",     label:"Avg CPC",       fmt:v=>`$${v.toFixed(2)}`,lb:true},
    {k:"cvr",     label:"Avg CVR",       fmt:v=>`${v.toFixed(1)}%`,lb:false,isPp:true},
    {k:"orders",  label:"Total Orders",  fmt:v=>String(Math.round(v)),lb:false},
    {k:"count",   label:"Portfolios",    fmt:v=>String(v),lb:false},
  ];
  return(<div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",flexShrink:0,overflowX:"auto"}}>
    <div style={{display:"flex",minWidth:"max-content"}}>
      {defs.map(d=>{
        const cv=cur?.[d.k]??0,pv=comp?.[d.k]??null;
        const delta=pv!=null?(d.isPp?cv-pv:((cv-pv)/Math.abs(pv||1))*100):null;
        const good=delta!=null?(d.lb?delta<0:delta>0):null;
        return(<div key={d.k} style={{padding:"12px 18px",borderRight:"1px solid #f0f0f0",minWidth:90}}>
          <div style={{fontSize:10,color:"#888",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:4,whiteSpace:"nowrap"}}>{d.label}</div>
          <div style={{fontSize:16,fontWeight:800,color:"#111",marginBottom:2}}>{d.fmt(cv)}</div>
          {delta!=null&&<div style={{display:"flex",alignItems:"center",gap:3}}>
            <span style={{fontSize:10,color:good?"#1a7a3c":good===false?"#d42b2b":"#888",fontWeight:700}}>{delta>0?"+":""}{d.isPp?delta.toFixed(1)+"pp":delta.toFixed(1)+"%"}</span>
            <i className={`ti ${delta>0?"ti-trending-up":"ti-trending-down"}`} style={{fontSize:9,color:good?"#1a7a3c":good===false?"#d42b2b":"#888"}}/>
          </div>}
          {pv!=null&&<div style={{fontSize:9,color:"#ccc"}}>prev {d.fmt(pv)}</div>}
        </div>);
      })}
    </div>
  </div>);
}

/* ── Alert Card ─────────────────────────────────────────────── */
function PPAlertCard({alert:a}){
  const[open,setOpen]=useState(false);
  const SC={critical:{color:"#d42b2b",bg:"rgba(212,43,43,0.07)",icon:"ti-alert-octagon"},high:{color:"#c47a00",bg:"rgba(196,122,0,0.07)",icon:"ti-alert-triangle"},medium:{color:"#1a5fa0",bg:"rgba(26,95,160,0.07)",icon:"ti-info-circle"},low:{color:"#1a7a3c",bg:"rgba(26,122,60,0.07)",icon:"ti-rocket"}};
  const s=SC[a.severity]||SC.medium;
  return(<div style={{background:"#fff",borderRadius:10,border:`1px solid ${s.color}22`,marginBottom:10,overflow:"hidden"}}>
    <div onClick={()=>setOpen(v=>!v)} style={{display:"flex",alignItems:"center",gap:10,padding:"12px 16px",cursor:"pointer",background:s.bg}}>
      <i className={`ti ${s.icon}`} style={{fontSize:15,color:s.color,flexShrink:0}}/>
      <div style={{flex:1}}>
        <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:2}}><span style={{fontSize:13,fontWeight:700,color:s.color}}>{a.type}</span><span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:s.color,color:"#fff",fontWeight:700,textTransform:"uppercase"}}>{a.severity}</span></div>
        <div style={{fontSize:11,color:"#666"}}>{a.portfolio} · {a.current}{a.confidence?` · ${a.confidence}% confidence`:""}</div>
      </div>
      <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#aaa",flexShrink:0}}/>
    </div>
    {open&&<div style={{padding:"13px 16px",borderTop:"1px solid #f0f0f0"}}>
      {a.previous&&a.previous!=="—"&&<div style={{fontSize:11,color:"#888",marginBottom:8}}>Previous: {a.previous}</div>}
      <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:9}}>{a.cause}</div>
      <div style={{background:"rgba(79,70,229,0.04)",borderRadius:7,padding:"9px 12px",borderLeft:"3px solid #4f46e5",marginBottom:6}}>
        <div style={{fontSize:10,fontWeight:700,color:"#4f46e5",marginBottom:2,textTransform:"uppercase",letterSpacing:"0.5px"}}>Suggested Action</div>
        <div style={{fontSize:12,color:"#333",lineHeight:1.5}}>{a.action}</div>
      </div>
      <div style={{fontSize:11,color:"#888"}}><strong>Impact:</strong> {a.impact}</div>
    </div>}
  </div>);
}

/* ── Strategy Card ──────────────────────────────────────────── */
function PPStratCard({rec:r}){
  const[open,setOpen]=useState(false);
  const TC={expansion:{color:"#1a7a3c",bg:"rgba(26,122,60,0.07)",icon:"ti-trending-up"},reallocation:{color:"#4f46e5",bg:"rgba(79,70,229,0.07)",icon:"ti-arrows-exchange"},consolidation:{color:"#6338c8",bg:"rgba(99,56,200,0.07)",icon:"ti-layers-union"},recovery:{color:"#1a5fa0",bg:"rgba(26,95,160,0.07)",icon:"ti-restore"},isolation:{color:"#c47a00",bg:"rgba(196,122,0,0.07)",icon:"ti-cut"}};
  const s=TC[r.type]||TC.expansion;
  return(<div style={{background:"#fff",borderRadius:10,border:"1px solid #eee",marginBottom:10,overflow:"hidden"}}>
    <div onClick={()=>setOpen(v=>!v)} style={{display:"flex",alignItems:"center",gap:10,padding:"12px 16px",cursor:"pointer"}}>
      <div style={{width:30,height:30,borderRadius:7,background:s.bg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><i className={`ti ${s.icon}`} style={{fontSize:13,color:s.color}}/></div>
      <div style={{flex:1}}><div style={{fontSize:13,fontWeight:700,color:"#111"}}>{r.title}</div>{r.movement&&<div style={{fontSize:11,color:"#888",marginTop:1}}>{r.movement}</div>}</div>
      <span style={{fontSize:9,padding:"2px 7px",borderRadius:3,background:s.bg,color:s.color,fontWeight:700,textTransform:"uppercase",flexShrink:0}}>{r.type}</span>
      <i className={`ti ${open?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:11,color:"#aaa",marginLeft:4,flexShrink:0}}/>
    </div>
    {open&&<div style={{padding:"0 16px 13px",borderTop:"1px solid #f5f5f5"}}>
      <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8,paddingTop:9}}>{r.why}</div>
      <div style={{background:"rgba(26,122,60,0.05)",borderRadius:7,padding:"9px 12px",borderLeft:"3px solid #1a7a3c",marginBottom:5}}>
        <div style={{fontSize:10,fontWeight:700,color:"#1a7a3c",marginBottom:2,textTransform:"uppercase",letterSpacing:"0.5px"}}>Strategic Action</div>
        <div style={{fontSize:12,color:"#333",lineHeight:1.5}}>{r.action}</div>
      </div>
      <div style={{fontSize:11,color:"#888"}}><strong>Expected impact:</strong> {r.impact}</div>
    </div>}
  </div>);
}

/* ── Portfolio Table ────────────────────────────────────────── */
function PPTable({portfolios,compMap,filters}){
  const[sort,setSort]=useState({col:"spend",dir:"desc"});const[pg,setPg]=useState(0);const PER=20;
  const processed=useMemo(()=>{
    return portfolios
      .filter(p=>{
        if(filters.portfolio&&!p.name.toLowerCase().includes(filters.portfolio.toLowerCase()))return false;
        if(filters.minSpend&&p.spend<parseFloat(filters.minSpend))return false;
        if(filters.maxAcos&&p.acos>parseFloat(filters.maxAcos))return false;
        return true;
      })
      .map(p=>{
        const comp=compMap?.[p.name.toLowerCase()];
        const eff=ppEffScore(p);
        const scale=ppScaleScore(p,comp);
        const action=p.spend>50&&p.orders===0?"Pause immediately":p.acos>60?"Cut bids 25%+":p.acos<20&&p.orders>=3?"Scale budget":p.acos>40?"Reduce bids":p.acos<30&&p.orders>=1?"Monitor & optimize":"Review";
        return{...p,comp,eff,scale,action};
      })
      .sort((a,b)=>{
        const av=sort.col==="eff"?a.eff:sort.col==="scale"?a.scale:(a[sort.col]??0);
        const bv=sort.col==="eff"?b.eff:sort.col==="scale"?b.scale:(b[sort.col]??0);
        return sort.dir==="asc"?av-bv:bv-av;
      });
  },[portfolios,compMap,filters,sort]);

  const paged=processed.slice(pg*PER,(pg+1)*PER);const pages=Math.ceil(processed.length/PER);
  const th=(col,label,right=true)=>(<th onClick={()=>setSort(s=>({col,dir:s.col===col&&s.dir==="desc"?"asc":"desc"}))} style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:right?"right":"left",cursor:"pointer",whiteSpace:"nowrap",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px",userSelect:"none"}}>{label}{sort.col===col?<i className={`ti ${sort.dir==="asc"?"ti-chevron-up":"ti-chevron-down"}`} style={{marginLeft:3,fontSize:8}}/>:null}</th>);
  const dc=(cv,pv,lb=false,isPp=false)=>{if(pv==null||pv===0)return null;const d=isPp?cv-pv:((cv-pv)/Math.abs(pv))*100;const good=lb?d<0:d>0;return<span style={{fontSize:9,color:good?"#1a7a3c":"#d42b2b",fontWeight:600,marginLeft:3}}>{d>0?"+":""}{isPp?d.toFixed(1)+"pp":d.toFixed(1)+"%"}</span>;};
  const sc=s=>s>=70?"#1a7a3c":s>=40?"#c47a00":"#d42b2b";
  const acosColor=v=>v>50?"#d42b2b":v>30?"#c47a00":"#1a7a3c";

  if(!processed.length)return(<div style={{textAlign:"center",padding:"40px",color:"#aaa"}}><i className="ti ti-briefcase" style={{fontSize:28,display:"block",marginBottom:8}}/><div style={{fontSize:13}}>No portfolios matched filters.</div></div>);
  return(<div>
    <div style={{fontSize:12,color:"#888",marginBottom:8}}>{processed.length} portfolio{processed.length!==1?"s":""}</div>
    <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #eee"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead><tr>
          <th style={{padding:"8px 12px",fontSize:10,fontWeight:700,color:"#888",textAlign:"left",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px",minWidth:140}}>Portfolio</th>
          {th("spend","Spend")}{th("sales","Sales")}{th("acos","ACoS")}{th("roas","ROAS")}{th("cpc","CPC")}{th("cvr","CVR")}{th("orders","Orders")}{th("eff","Efficiency")}{th("scale","Scaling")}
          <th style={{padding:"8px 10px",fontSize:10,fontWeight:700,color:"#888",textAlign:"left",borderBottom:"1px solid #eee",background:"#fafafa",textTransform:"uppercase",letterSpacing:"0.5px"}}>Action</th>
        </tr></thead>
        <tbody>{paged.map((p,i)=>{const c=p.comp;return(<tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
          <td style={{padding:"9px 12px"}}><div style={{fontWeight:700,color:"#111",fontSize:12,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div></td>
          <td style={{padding:"9px 10px",textAlign:"right",fontWeight:600}}>${p.spend>=1e3?(p.spend/1e3).toFixed(1)+"K":p.spend.toFixed(0)}{c&&dc(p.spend,c.spend,true)}</td>
          <td style={{padding:"9px 10px",textAlign:"right",fontWeight:600}}>${p.sales>=1e3?(p.sales/1e3).toFixed(1)+"K":p.sales.toFixed(0)}{c&&dc(p.sales,c.sales)}</td>
          <td style={{padding:"9px 10px",textAlign:"right"}}><span style={{fontWeight:700,color:acosColor(p.acos)}}>{p.acos.toFixed(1)}%</span>{c&&dc(p.acos,c.acos,true,true)}</td>
          <td style={{padding:"9px 10px",textAlign:"right",fontWeight:600}}>{p.roas.toFixed(2)}x{c&&dc(p.roas,c.roas)}</td>
          <td style={{padding:"9px 10px",textAlign:"right"}}>${p.cpc.toFixed(2)}{c&&dc(p.cpc,c.cpc,true)}</td>
          <td style={{padding:"9px 10px",textAlign:"right"}}>{p.cvr.toFixed(1)}%{c&&dc(p.cvr,c.cvr,false,true)}</td>
          <td style={{padding:"9px 10px",textAlign:"right",fontWeight:600}}>{p.orders}{c&&dc(p.orders,c.orders)}</td>
          <td style={{padding:"9px 10px",textAlign:"center"}}><div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:30,height:30,borderRadius:"50%",background:`${sc(p.eff)}15`,border:`2px solid ${sc(p.eff)}`}}><span style={{fontSize:9,fontWeight:800,color:sc(p.eff)}}>{p.eff}</span></div></td>
          <td style={{padding:"9px 10px",textAlign:"center"}}><div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:30,height:30,borderRadius:"50%",background:`${sc(p.scale)}15`,border:`2px solid ${sc(p.scale)}`}}><span style={{fontSize:9,fontWeight:800,color:sc(p.scale)}}>{p.scale}</span></div></td>
          <td style={{padding:"9px 10px",fontSize:11,color:"#555",whiteSpace:"nowrap"}}>{p.action}</td>
        </tr>);})}</tbody>
      </table>
    </div>
    {pages>1&&<div style={{display:"flex",gap:6,justifyContent:"center",marginTop:10}}>{Array.from({length:pages},(_,i)=>(<button key={i} onClick={()=>setPg(i)} style={{padding:"4px 10px",borderRadius:5,border:"1px solid #e0e0e0",background:pg===i?"#4f46e5":"#fff",color:pg===i?"#fff":"#555",cursor:"pointer",fontSize:11,fontWeight:pg===i?700:400}}>{i+1}</button>))}</div>}
  </div>);
}

/* ── AI Panel ───────────────────────────────────────────────── */
function PPAIPanel({accountAgg,compAgg,portfolios,alerts,recs}){
  const[analysis,setAnalysis]=useState(null);const[loading,setLoading]=useState(false);const[error,setError]=useState(null);const apiKey=useGlobalAIKey();const[showKey,setShowKey]=useState(false);const[keySaved,setKeySaved]=useState(false);
  const run=async()=>{if(!apiKey.trim()){setError("Set your Gemini API key in Settings → AI Settings.");return;}setLoading(true);setError(null);try{const t=await ppAIAnalysis(accountAgg,compAgg,portfolios,alerts,recs,apiKey.trim());setAnalysis(t);setKeySaved(true);}catch(e){setError("Error: "+e.message);}finally{setLoading(false);}};
  return(<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"18px 20px",marginBottom:18}}>
    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><div style={{width:28,height:28,borderRadius:7,background:"rgba(99,56,200,0.1)",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-brain" style={{fontSize:14,color:"#6338c8"}}/></div><div><div style={{fontSize:13,fontWeight:700,color:"#111"}}>AI Portfolio Assistant</div><div style={{fontSize:11,color:"#888"}}>Powered by Gemini · portfolio-level strategic analysis</div></div></div>
    {!keySaved&&<div style={{background:"#fafafa",borderRadius:8,border:"1px solid #eee",padding:"11px 13px",marginBottom:11}}><div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:5}}><i className="ti ti-key" style={{fontSize:11,color:"#4f46e5",marginRight:4}}/>Gemini API Key <span style={{fontWeight:400,color:"#aaa"}}>(memory only)</span></div><div style={{display:"flex",gap:6}}>{/* API key input removed - key configured globally in Settings */}</div></div>}
    {!analysis&&<button onClick={run} disabled={loading||!apiKey} style={{width:"100%",padding:"9px",borderRadius:7,border:"none",background:loading||!apiKey?"#e0e0e0":"#6338c8",color:loading||!apiKey?"#aaa":"#fff",fontSize:13,fontWeight:700,cursor:loading||!apiKey?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6,marginBottom:10}}>{loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analyzing portfolios...</>:<><i className="ti ti-sparkles" style={{fontSize:13}}/>Run Portfolio Analysis</>}</button>}
    {error&&<div style={{fontSize:12,color:"#d42b2b",padding:"8px 12px",background:"rgba(212,43,43,0.06)",borderRadius:7,marginBottom:10}}>{error}</div>}
    {analysis&&<div><div style={{fontSize:13,color:"#333",lineHeight:1.8,whiteSpace:"pre-wrap",background:"rgba(99,56,200,0.04)",borderRadius:8,padding:"13px 16px",borderLeft:"3px solid #6338c8",marginBottom:10}}>{analysis}</div><div style={{display:"flex",gap:8}}><button onClick={()=>{setAnalysis(null);setKeySaved(false);}} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}><i className="ti ti-refresh" style={{marginRight:4}}/>Refresh</button><button onClick={()=>setAnalysis(null)} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>Change Key</button></div></div>}
    {!analysis&&!loading&&!error&&<div style={{fontSize:12,color:"#aaa",fontStyle:"italic"}}>Enter Gemini API key and run to get portfolio strategic assessment.</div>}
  </div>);
}

/* ── Workspace ──────────────────────────────────────────────── */
function PPWorkspace({curRows,compRows,cm,compCm,periods,onReupload,onExport}){
  const[filters,setFilters]=useState({portfolio:"",minSpend:"",maxAcos:""});
  const[showFilters,setShowFilters]=useState(false);const[activeTab,setActiveTab]=useState("overview");

  const portfolios=useMemo(()=>ppGroupByPortfolio(curRows,cm),[curRows,cm]);
  const compPortfolios=useMemo(()=>compRows?.length?ppGroupByPortfolio(compRows,compCm||cm):[],[compRows,compCm,cm]);
  const compMap=useMemo(()=>{const m={};compPortfolios.forEach(p=>m[p.name.toLowerCase()]=p);return Object.keys(m).length?m:null;},[compPortfolios]);
  const accountAgg=useMemo(()=>ppAccountAgg(portfolios),[portfolios]);
  const compAgg=useMemo(()=>compPortfolios.length?ppAccountAgg(compPortfolios):null,[compPortfolios]);
  const alerts=useMemo(()=>ppAlerts(portfolios,compMap),[portfolios,compMap]);
  const recs=useMemo(()=>ppStrategy(portfolios,compMap),[portfolios,compMap]);

  const TABS=[
    {key:"overview",label:"Overview",icon:"ti-layout-dashboard"},
    {key:"alerts",label:`Alerts${alerts.length?` (${alerts.length})`:""}`,icon:"ti-alert-octagon"},
    {key:"table",label:"Portfolio Table",icon:"ti-table"},
    {key:"strategy",label:`Strategy${recs.length?` (${recs.length})`:""}`,icon:"ti-rocket"},
    {key:"ai",label:"AI Analysis",icon:"ti-brain"},
  ];

  const totalSpend=portfolios.reduce((s,p)=>s+p.spend,0);

  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
    <PPKPIBar cur={accountAgg} comp={compAgg}/>
    <div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",padding:"0 24px",display:"flex",alignItems:"center",flexShrink:0,overflowX:"auto"}}>
      {TABS.map(t=>(<button key={t.key} onClick={()=>setActiveTab(t.key)} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:400,color:activeTab===t.key?"#4f46e5":"#888",borderBottom:activeTab===t.key?"2.5px solid #4f46e5":"2.5px solid transparent",display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap",flexShrink:0}}><i className={`ti ${t.icon}`} style={{fontSize:12}}/>{t.label}</button>))}
      <div style={{flex:1}}/>
      <button onClick={()=>setShowFilters(v=>!v)} style={{padding:"6px 11px",borderRadius:7,border:"1px solid #e0e0e0",background:showFilters?"#f0f0f0":"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5,flexShrink:0}}><i className="ti ti-filter" style={{fontSize:11}}/>Filters</button>
      <button onClick={onReupload} style={{marginLeft:8,padding:"6px 11px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5,flexShrink:0}}><i className="ti ti-upload" style={{fontSize:11}}/>Re-upload</button>
      <button onClick={()=>onExport(portfolios,accountAgg,compAgg,alerts,recs,compMap)} style={{marginLeft:8,padding:"6px 11px",borderRadius:7,border:"none",background:"#4f46e5",cursor:"pointer",fontSize:11,color:"#fff",fontWeight:700,display:"flex",alignItems:"center",gap:5,flexShrink:0}}><i className="ti ti-download" style={{fontSize:11}}/>Export</button>
    </div>
    {showFilters&&<div style={{background:"#fff",borderBottom:"1px solid #f0f0f0",padding:"10px 24px",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",flexShrink:0}}>
      <input placeholder="Filter portfolio..." value={filters.portfolio} onChange={e=>setFilters(f=>({...f,portfolio:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:160,fontFamily:"inherit"}}/>
      <input placeholder="Min Spend $" value={filters.minSpend} onChange={e=>setFilters(f=>({...f,minSpend:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:95,fontFamily:"inherit"}}/>
      <input placeholder="Max ACoS %" value={filters.maxAcos} onChange={e=>setFilters(f=>({...f,maxAcos:e.target.value}))} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",fontSize:12,width:90,fontFamily:"inherit"}}/>
      <button onClick={()=>setFilters({portfolio:"",minSpend:"",maxAcos:""})} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>Clear</button>
    </div>}

    <div style={{flex:1,overflowY:"auto",padding:"20px 24px",background:"#f7f7f7"}}>
      {periods&&<div style={{fontSize:11,color:"#888",marginBottom:12}}>{fmtDisp(periods.current?.start)} → {fmtDisp(periods.current?.end)}{compAgg?" · comparison active":""}</div>}

      {/* OVERVIEW TAB */}
      {activeTab==="overview"&&(<>
        {/* Budget distribution */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Budget Distribution Across Portfolios</div>
          {portfolios.sort((a,b)=>b.spend-a.spend).slice(0,8).map((p,i)=>{
            const pct=totalSpend>0?(p.spend/totalSpend)*100:0;
            const barColor=p.acos<25?"#1a7a3c":p.acos<40?"#c47a00":"#d42b2b";
            return(<div key={i} style={{marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                <span style={{fontSize:12,color:"#111",fontWeight:600,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</span>
                <span style={{fontSize:11,color:"#888"}}>${p.spend>=1e3?(p.spend/1e3).toFixed(1)+"K":p.spend.toFixed(0)} · {pct.toFixed(1)}% · ACoS {p.acos.toFixed(1)}%</span>
              </div>
              <div style={{height:7,borderRadius:4,background:"#f0f0f0",overflow:"hidden"}}><div style={{width:`${pct}%`,height:"100%",background:barColor,borderRadius:4,transition:"width 0.3s"}}/></div>
            </div>);
          })}
        </div>

        {/* Summary cards */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
          {[
            {label:"Top Performer",val:portfolios.filter(p=>p.acos<25&&p.orders>=1).sort((a,b)=>b.roas-a.roas)[0]?.name||"—",sub:"Lowest ACoS, highest ROAS",color:"#1a7a3c",icon:"ti-rocket"},
            {label:"Biggest Drain",val:portfolios.filter(p=>p.acos>50||p.orders===0&&p.spend>20).sort((a,b)=>b.spend-a.spend)[0]?.name||"—",sub:"Highest inefficient spend",color:"#d42b2b",icon:"ti-alert-octagon"},
            {label:"Alerts Active",val:String(alerts.filter(a=>a.severity==="critical"||a.severity==="high").length),sub:`${alerts.length} total · ${recs.length} strategic moves`,color:"#c47a00",icon:"ti-bell"},
          ].map((c,i)=>(<div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"14px 16px"}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:8}}><div style={{width:26,height:26,borderRadius:6,background:`${c.color}15`,display:"flex",alignItems:"center",justifyContent:"center"}}><i className={`ti ${c.icon}`} style={{fontSize:12,color:c.color}}/></div><div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px"}}>{c.label}</div></div>
            <div style={{fontSize:16,fontWeight:800,color:c.color,marginBottom:3,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.val}</div>
            <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
          </div>))}
        </div>
      </>)}

      {/* ALERTS TAB */}
      {activeTab==="alerts"&&(<>
        <div style={{fontSize:13,color:"#666",marginBottom:12}}>{alerts.length===0?"No portfolio issues detected.":` ${alerts.length} issue${alerts.length!==1?"s":""} detected across ${new Set(alerts.map(a=>a.portfolio)).size} portfolios.`}</div>
        {alerts.map(a=><PPAlertCard key={a.id} alert={a}/>)}
        {alerts.length===0&&<div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"28px",textAlign:"center"}}><i className="ti ti-circle-check" style={{fontSize:30,color:"#1a7a3c",display:"block",marginBottom:8}}/><div style={{fontSize:14,fontWeight:700,color:"#111",marginBottom:4}}>All Portfolios Healthy</div><div style={{fontSize:12,color:"#888"}}>No critical portfolio issues detected. Upload comparison period for full delta analysis.</div></div>}
      </>)}

      {/* TABLE TAB */}
      {activeTab==="table"&&<PPTable portfolios={portfolios} compMap={compMap} filters={filters}/>}

      {/* STRATEGY TAB */}
      {activeTab==="strategy"&&(<>
        <div style={{fontSize:13,color:"#666",marginBottom:12}}>{recs.length} strategic recommendation{recs.length!==1?"s":""} — prioritized by impact.</div>
        {recs.map(r=><PPStratCard key={r.id} rec={r}/>)}
      </>)}

      {/* AI TAB */}
      {activeTab==="ai"&&<PPAIPanel accountAgg={accountAgg} compAgg={compAgg} portfolios={portfolios} alerts={alerts} recs={recs}/>}
    </div>
  </div>);
}

/* ── Export Page ────────────────────────────────────────────── */
function PPExportPage({portfolios,accountAgg,compAgg,alerts,recs,compMap,onBack}){
  function doExport(){
    const wb=XLSX.utils.book_new();

    /* Sheet 1 — Portfolio Actions */
    const h1=["Portfolio","Spend","Sales","ACoS%","ROAS","CPC","CVR%","Orders","Efficiency Score","Scaling Score","Suggested Action"];
    const r1=portfolios.map(p=>{
      const eff=ppEffScore(p);const scale=ppScaleScore(p,compMap?.[p.name.toLowerCase()]);
      const action=p.spend>50&&p.orders===0?"Pause immediately":p.acos>60?"Cut bids 25%+":p.acos<20&&p.orders>=3?"Scale budget":p.acos>40?"Reduce bids":"Monitor";
      return{Portfolio:p.name,Spend:p.spend.toFixed(2),Sales:p.sales.toFixed(2),"ACoS%":p.acos.toFixed(1),ROAS:p.roas.toFixed(2),CPC:p.cpc.toFixed(2),"CVR%":p.cvr.toFixed(1),Orders:p.orders,"Efficiency Score":eff,"Scaling Score":scale,"Suggested Action":action};
    });
    const ws1=XLSX.utils.json_to_sheet(r1,{header:h1});ws1["!cols"]=h1.map(()=>({wch:20}));
    XLSX.utils.book_append_sheet(wb,ws1,"Portfolio Actions");

    /* Sheet 2 — Budget Reallocation */
    if(portfolios.length>1){
      const totalSpend=portfolios.reduce((s,p)=>s+p.spend,0);
      const h2=["Portfolio","Current Spend","% of Budget","ACoS%","ROAS","Recommendation","Suggested Budget Change"];
      const r2=portfolios.sort((a,b)=>b.spend-a.spend).map(p=>{
        const pct=totalSpend>0?(p.spend/totalSpend)*100:0;
        const rec=p.acos<25&&p.roas>2?"Increase budget 30–50%":p.acos>60||p.orders===0?"Reduce budget 40%+":p.acos>40?"Reduce budget 15–20%":"Maintain";
        const change=p.acos<25&&p.roas>2?`+$${(p.spend*0.4).toFixed(0)}`:p.acos>60||p.orders===0?`-$${(p.spend*0.4).toFixed(0)}`:p.acos>40?`-$${(p.spend*0.175).toFixed(0)}`:"$0";
        return{Portfolio:p.name,"Current Spend":p.spend.toFixed(2),"% of Budget":pct.toFixed(1),"ACoS%":p.acos.toFixed(1),ROAS:p.roas.toFixed(2),Recommendation:rec,"Suggested Budget Change":change};
      });
      const ws2=XLSX.utils.json_to_sheet(r2,{header:h2});ws2["!cols"]=h2.map(()=>({wch:24}));
      XLSX.utils.book_append_sheet(wb,ws2,"Budget Reallocation");
    }

    /* Sheet 3 — Alerts */
    if(alerts.length){
      const h3=["Alert Type","Severity","Portfolio","Current","Previous","Cause","Action","Impact","Confidence%"];
      const r3=alerts.map(a=>({
        "Alert Type":a.type,Severity:a.severity,Portfolio:a.portfolio,
        Current:a.current,Previous:a.previous||"—",Cause:a.cause,
        Action:a.action,Impact:a.impact,"Confidence%":a.confidence||""
      }));
      const ws3=XLSX.utils.json_to_sheet(r3,{header:h3});ws3["!cols"]=h3.map(()=>({wch:28}));
      XLSX.utils.book_append_sheet(wb,ws3,"Portfolio Alerts");
    }

    /* Sheet 4 — Strategic Recommendations */
    if(recs.length){
      const h4=["Recommendation","Type","Why","Strategic Action","Expected Impact"];
      const r4=recs.map(r=>({Recommendation:r.title,Type:r.type,Why:r.why,"Strategic Action":r.action,"Expected Impact":r.impact}));
      const ws4=XLSX.utils.json_to_sheet(r4,{header:h4});ws4["!cols"]=h4.map(()=>({wch:32}));
      XLSX.utils.book_append_sheet(wb,ws4,"Strategic Recommendations");
    }

    XLSX.writeFile(wb,`Quarred_PortfolioCommand_${new Date().toISOString().slice(0,10)}.xlsx`);
  }

  const critCount=alerts.filter(a=>a.severity==="critical").length;
  const drainSpend=portfolios.filter(p=>p.acos>50||p.orders===0&&p.spend>20).reduce((s,p)=>s+p.spend,0);

  return(<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
    <div style={{maxWidth:640,margin:"0 auto",padding:"32px 24px"}}>
      <button onClick={onBack} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4,marginBottom:14}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Back to Workspace</button>
      <h2 style={{fontSize:22,fontWeight:800,color:"#111",margin:"0 0 4px",letterSpacing:"-0.3px"}}>Export Portfolio Actions</h2>
      <p style={{fontSize:13,color:"#666",margin:"0 0 20px"}}>Strategist-ready workbook with portfolio actions, budget reallocation plan, alerts, and strategic recommendations.</p>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Export Summary</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:14}}>
          {[{label:"Portfolios",val:portfolios.length,color:"#555"},{label:"Critical Alerts",val:critCount,color:"#d42b2b"},{label:"Strategic Moves",val:recs.length,color:"#1a7a3c"},{label:"Drain Spend",val:`$${drainSpend>=1e3?(drainSpend/1e3).toFixed(1)+"K":drainSpend.toFixed(0)}`,color:"#c47a00"}]
          .map(s=>(<div key={s.label} style={{padding:"11px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0",textAlign:"center"}}><div style={{fontSize:20,fontWeight:800,color:s.color,marginBottom:3}}>{s.val}</div><div style={{fontSize:10,color:"#888",fontWeight:600}}>{s.label}</div></div>))}
        </div>
        <button onClick={doExport} style={{width:"100%",padding:"11px",borderRadius:9,border:"none",background:"#4f46e5",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 2px 10px rgba(79,70,229,0.25)"}}><i className="ti ti-download" style={{fontSize:14}}/> Download Portfolio Command Workbook</button>
      </div>
      <div style={{background:"#fafafa",border:"1px solid #eee",borderRadius:10,padding:"13px 16px"}}>
        <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:8}}>Portfolio management best practices</div>
        {["Keep portfolios structured around product categories or strategies — not arbitrary groupings","Any portfolio with ACoS > 60% needs immediate bid reduction before budget increase","Top-performing portfolios (ACoS < 20%, ROAS > 4x) should always have surplus budget","Review portfolio distribution weekly — over-concentration creates account-level risk","Never pause a portfolio entirely without first understanding why it underperformed"].map((s,i)=>(<div key={i} style={{display:"flex",gap:9,marginBottom:6,alignItems:"flex-start"}}><span style={{width:17,height:17,borderRadius:"50%",background:"#4f46e5",color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{i+1}</span><span style={{fontSize:12,color:"#555",lineHeight:1.5}}>{s}</span></div>))}
      </div>
    </div>
  </div>);
}

/* ── Module Root ────────────────────────────────────────────── */
function PortfolioCommandModule({globalData,setTab}){
  const[page,setPage]=useState("upload");const[periods,setPeriods]=useState(globalData?.periods||null);const[data,setData]=useState(null);const[exportArgs,setExportArgs]=useState(null);
  const HEADER=(<div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}><i className="ti ti-command" style={{fontSize:15,color:"#4f46e5"}}/><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Portfolio Command Center</h2><span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(200,120,0,0.12)",color:"#9a5800",fontWeight:700}}>Advanced</span>{globalData&&<span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,122,60,0.1)",color:"#1a7a3c",fontWeight:600,marginLeft:4}}>Data Hub ✓</span>}</div>);
  useEffect(()=>{
    if(globalData?.cur?.primary&&!data&&page==="upload"){
      const cm=globalData.cur.primary.cm;
      const compCm=globalData.comp?.primary?.cm||null;
      setData({curRows:globalData.cur.primary.rows,compRows:globalData.comp?.primary?.rows||null,cm,compCm,periods:globalData.periods});
      setPeriods(globalData.periods||null);
      setPage("workspace");
    }
  },[globalData]);
  if(page==="export"&&exportArgs)return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}><div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff"}}><h2 style={{margin:0,fontSize:15,fontWeight:700,color:"#111"}}>Portfolio Command — Export</h2></div><PPExportPage {...exportArgs} onBack={()=>setPage("workspace")}/></div>);
  if(page==="workspace"&&data)return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>{HEADER}<PPWorkspace {...data} periods={periods} onReupload={()=>{setData(null);setPage("upload");}} onExport={(portfolios,accountAgg,compAgg,alerts,recs,compMap)=>{setExportArgs({portfolios,accountAgg,compAgg,alerts,recs,compMap});setPage("export");}}/></div>);
  return(<div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>{HEADER}<PPUploadPage periods={periods} onPeriodSet={p=>setPeriods(p)} onComplete={d=>{setData(d);setPage("workspace");}}/></div>);
}


/* ================================================================
   GLOBAL DATA HUB
   Single upload point — all modules read from globalData prop.
   Strategist uploads once, every module syncs automatically.
================================================================ */

/* ── Universal column detection (all report types) ─────────── */
const HUB_ALIASES={
  portfolio:   ["Portfolio Name","Portfolio","Portfolio Name (Informational only)"],
  campaign:    ["Campaign Name","Campaign","campaign name","Campaign Name (Informational only)"],
  adGroup:     ["Ad Group Name","Ad Group","ad group name"],
  matchType:   ["Match Type","match type","Targeting Type"],
  searchTerm:  ["Customer Search Term","Search Term","Query","Search query","Keyword","Keyword Text","Targeting Expression","Product Targeting Expression"],
  impressions: ["Impressions","impressions","Total Impressions"],
  clicks:      ["Clicks","clicks","Total Clicks"],
  spend:       ["Spend","Cost","Ad Spend","Spend ($)"],
  sales:       ["Sales","14 Day Total Sales","14 Day Total Sales ($)","7 Day Total Sales","Total Sales","Attributed Sales","Revenue"],
  orders:      ["Orders","14 Day Total Orders (#)","14 Day Total Orders","7 Day Total Orders (#)","Total Orders","Attributed Conversions"],
  acos:        ["ACOS","ACoS","Advertising Cost of Sales","ACOS (%)"],
  roas:        ["ROAS","Return on Ad Spend"],
  cpc:         ["CPC","Cost Per Click","Average CPC","CPC ($)"],
  ctr:         ["Click-through Rate","CTR","Click-Through Rate","CTR (%)"],
  cvr:         ["Conversion Rate","CVR","Order Rate","Unit Session Percentage"],
  clickShare:  ["Click Share","Click share","Clicks Share"],
  convShare:   ["Conversion Share","Conversion share","Conversions Share"],
  impressionShare:["Impression Share","Impression share","Top of Search (Impression Share)"],
  rank:        ["Rank","Position","Average Position","Organic Rank","Sponsored Rank"],
  state:       ["State","Status","Campaign State","Campaign State (Informational only)"],
  entity:      ["Entity","Record Type","Type"],
  bid:         ["Bid","Ad Group Default Bid","Keyword Bid","Default Bid"],
  budget:      ["Budget","Daily Budget","Campaign Budget","Portfolio Budget"],
  sku:         ["SKU","sku","Advertised SKU"],
  asin:        ["ASIN","asin","Advertised ASIN","ASIN (Informational only)"],
  sessions:    ["Sessions","sessions","Total Sessions","Unit Session Percentage"],
  pageViews:   ["Page Views","page views","Page views","Browser Page Views"],
  buyBox:      ["Buy Box Percentage","Buy Box %","Featured Offer (Buy Box) Percentage"],
  hour:        ["Hour","Hour of Day","Hour (24h)","hour"],
  date:        ["Date","date","Report Date","Day"],
};

function hubDetect(headers){
  const r={};
  for(const[k,cands]of Object.entries(HUB_ALIASES)){
    for(const c of cands){const h=headers.find(h=>h.trim().toLowerCase()===c.toLowerCase());if(h){r[k]=h;break;}}
    if(!r[k]){for(const c of cands){const h=headers.find(h=>h.trim().toLowerCase().includes(c.toLowerCase().split(" ")[0]));if(h){r[k]=h;break;}}}
  }
  return r;
}

/* Detect what kind of report was uploaded */
function hubDetectReportType(cm,headers){
  const h=(headers||[]).map(x=>(x||"").toLowerCase());
  /* Order matters — most specific first */
  if(cm.searchTerm)              return{type:"searchterm", label:"Search Term Report",          icon:"ti-search",          color:"#4f46e5"};
  if(cm.clickShare||cm.convShare||h.some(x=>x.includes("click share")))
                                  return{type:"sqp",        label:"Search Query Performance",    icon:"ti-chart-pie",       color:"#6338c8"};
  if(cm.rank||h.some(x=>x==="rank"||x==="organic rank"||x.includes("position")))
                                  return{type:"rank",       label:"Rank / Position Report",      icon:"ti-trending-up",     color:"#888"};
  if(cm.hour||h.some(x=>x.includes("hour")))
                                  return{type:"dayparting", label:"Hourly Performance Report",   icon:"ti-clock",           color:"#1a5fa0"};
  if(cm.sessions||cm.pageViews||cm.buyBox||h.some(x=>x.includes("session")||x.includes("page view")))
                                  return{type:"business",   label:"Business Report",             icon:"ti-chart-bar",       color:"#c47a00"};
  if(h.some(x=>x.includes("days of supply")||x.includes("inbound")||x.includes("reserved qty")))
                                  return{type:"inventory",  label:"Inventory Report",            icon:"ti-package",         color:"#e07b00"};
  if(cm.entity||cm.bid)           return{type:"bulk",       label:"Bulk File",                   icon:"ti-file-spreadsheet",color:"#555"};
  if(cm.placement||h.some(x=>x.includes("top of search")||x.includes("rest of search")))
                                  return{type:"placement",  label:"Placement Report",            icon:"ti-layout-2",        color:"#1a7a3c"};
  if((cm.keyword||cm.targeting)&&cm.bid)
                                  return{type:"targeting",  label:"Targeting Report",            icon:"ti-target",          color:"#2a6496"};
  if(cm.asin&&cm.spend&&h.some(x=>x.includes("advertised")))
                                  return{type:"asin",       label:"Advertised Product Report",   icon:"ti-box",             color:"#7b3fa0"};
  if(cm.portfolio&&cm.campaign)   return{type:"campaign",   label:"Campaign / Portfolio Report", icon:"ti-speakerphone",    color:"#1a5fa0"};
  if(cm.campaign)                 return{type:"campaign",   label:"Campaign Report",             icon:"ti-speakerphone",    color:"#1a5fa0"};
  return{type:"unknown",label:"Report uploaded — columns not fully recognised",icon:"ti-file",color:"#aaa"};
}

/* Which modules can use this report type */
const HUB_MODULE_MAP={
  searchterm: ["Search Term Intel","Negation Engine","Brand Defense","Competitor Radar","Search Intent AI","Niche Dives","Priority Engine","Action Center"],
  campaign:   ["Campaign Health","Action Center","Impression Share","Portfolio Command","Bleeder Check","Campaign Suggestions","Conflict Detector","Seasonal Engine","Account Audit","Priority Engine","Client Reporting"],
  bulk:       ["Bids Optimizer","Campaign Health","Action Center","Portfolio Command","Conflict Detector","Bleeder Check","Rules Engine","Priority Engine"],
  sqp:        ["SQPR Analyzer","Competitor Radar","Niche Dives"],
  rank:       ["Rank Radar","Niche Dives","Seasonal Engine"],
  dayparting: ["Dayparting Intel"],
  business:   ["Listing Conversion","Action Center","Account Audit"],
  inventory:  ["Inventory & PPC Intel","Action Center","Seasonal Engine"],
  placement:  ["Placement Optimizer","Campaign Health","Account Audit"],
  targeting:  ["Campaign Health","Negation Engine","Action Center","Conflict Detector","Bleeder Check"],
  asin:       ["Campaign Health","Action Center","Listing Conversion","Account Audit"],
  unknown:    ["Check report type — column headers not recognised"],
};

/* ── Hub Upload Zone ────────────────────────────────────────── */
function HubUploadZone({label,file,detected,onFile,onClear,accent=false}){
  const[drag,setDrag]=useState(false);const ref=useRef();
  const handle=async f=>{if(!f)return;try{const p=await parseSheet(f);onFile(f,p);}catch(e){alert("Could not read file: "+e.message);}};
  return(<div
    onDragOver={e=>{e.preventDefault();setDrag(true);}}
    onDragLeave={()=>setDrag(false)}
    onDrop={e=>{e.preventDefault();setDrag(false);handle(e.dataTransfer.files[0]);}}
    onClick={()=>!file&&ref.current?.click()}
    style={{border:`2px dashed ${drag?"#4f46e5":accent?"rgba(79,70,229,0.3)":"#e0e0e0"}`,borderRadius:12,padding:"20px 22px",background:drag?"rgba(79,70,229,0.04)":accent?"rgba(79,70,229,0.02)":"#fafafa",cursor:file?"default":"pointer",transition:"all 0.15s"}}>
    <input ref={ref} type="file" accept=".xlsx,.csv" style={{display:"none"}} onChange={e=>handle(e.target.files[0])}/>
    {file?(
      <div>
        <div style={{display:"flex",alignItems:"flex-start",gap:10,marginBottom:detected?10:0}}>
          <i className={`ti ${detected?.icon||"ti-file-spreadsheet"}`} style={{fontSize:18,color:detected?.color||"#4f46e5",flexShrink:0,marginTop:2}}/>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:2}}>{file.name}</div>
            {detected&&<div style={{fontSize:11,color:detected.color,fontWeight:600}}>{detected.label}</div>}
          </div>
          <button onClick={e=>{e.stopPropagation();onClear();}} style={{padding:"3px 8px",borderRadius:5,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",flexShrink:0}}>Remove</button>
        </div>
        {detected&&detected.type!=="unknown"&&(
          <div style={{marginTop:6,padding:"7px 10px",background:"rgba(26,122,60,0.06)",borderRadius:7,border:"1px solid rgba(26,122,60,0.15)"}}>
            <div style={{fontSize:10,fontWeight:700,color:"#1a7a3c",marginBottom:3,textTransform:"uppercase",letterSpacing:"0.5px"}}>Feeds into modules</div>
            <div style={{fontSize:11,color:"#555"}}>{(HUB_MODULE_MAP[detected.type]||[]).join(" · ")}</div>
          </div>
        )}
      </div>
    ):(
      <div style={{textAlign:"center",padding:"10px 0"}}>
        <i className="ti ti-cloud-upload" style={{fontSize:28,color:accent?"rgba(79,70,229,0.3)":"#ccc",display:"block",marginBottom:8}}/>
        <div style={{fontSize:13,fontWeight:600,color:accent?"#4f46e5":"#555",marginBottom:3}}>{label}</div>
        <div style={{fontSize:11,color:"#aaa"}}>Drag & drop or click · .xlsx or .csv · any Amazon report</div>
      </div>
    )}
  </div>);
}

/* ── Data Hub Main Component ────────────────────────────────── */
function DataHub({globalData,onDataLoaded,onClearData,setTab}){
  const[subPage,setSubPage]=useState(globalData?"status":"dates");
  const[periods,setPeriods]=useState(globalData?.periods||null);
  const[files,setFiles]=useState({});
  const[parsed,setParsed]=useState({});
  const[detected,setDetected]=useState({});
  const[loading,setLoading]=useState(false);
  const[err,setErr]=useState(null);
  const[expandedHow,setExpandedHow]=useState({});
  const toggleHow=id=>setExpandedHow(p=>({...p,[id]:!p[id]}));

  /* Each slot has a real name, where to get it, and which modules it feeds */
  const FILE_SLOTS=[
    /* ── Advertising Console (Seller Central → Reports → Advertising Reports) ── */
    {id:"searchterm", label:"Search Term Report",        icon:"ti-search",           color:"#4f46e5", source:"advertising", required:true,
     badge:"MOST IMPORTANT",
     desc:"Every customer search query — clicks, spend, sales, ACoS, CVR per term",
     feeds:["Search Term Intel","Negation Engine","Brand Defense","Competitor Radar","Search Intent AI","Niche Dives","Priority Engine","Action Center"],
     howTo:["Seller Central → Reports → Advertising Reports → Create Report","Report type: Search Term Impression Share → set date range → Run Report → Download"]},

    {id:"campaign",   label:"Campaign Report",           icon:"ti-speakerphone",     color:"#1a5fa0", source:"advertising", required:false,
     badge:"REQUIRED FOR MOST MODULES",
     desc:"Campaign-level spend, sales, ACoS, impressions, clicks — one row per campaign",
     feeds:["Campaign Health","Action Center","Impression Share","Portfolio Command","Bleeder Check","Campaign Suggestions","Conflict Detector","Seasonal Engine","Account Audit","Priority Engine","Client Reporting"],
     howTo:["Seller Central → Reports → Advertising Reports → Create Report","Report type: Campaign → set date range → Run → Download"]},

    {id:"targeting",  label:"Targeting Report",          icon:"ti-target",           color:"#2a6496", source:"advertising", required:false,
     desc:"Keyword and product targeting performance — bid, impressions, clicks, ACoS per target. Best for Conflict Detector.",
     feeds:["Campaign Health","Negation Engine","Action Center","Conflict Detector","Bleeder Check","Rules Engine"],
     howTo:["Seller Central → Reports → Advertising Reports → Create Report","Report type: Targeting → set date range → Run → Download"]},

    {id:"placement",  label:"Placement Report",          icon:"ti-layout-2",         color:"#1a7a3c", source:"advertising", required:false,
     desc:"Performance by placement — Top of Search, Product Pages, Rest of Search",
     feeds:["Placement Optimizer","Campaign Health","Account Audit"],
     howTo:["Seller Central → Reports → Advertising Reports → Create Report","Report type: Placement → set date range → Download"]},

    {id:"asin",       label:"Advertised Product Report", icon:"ti-box",              color:"#7b3fa0", source:"advertising", required:false,
     desc:"Performance per advertised ASIN — which products generate PPC sales. Use for ASIN-level analysis.",
     feeds:["Campaign Health","Action Center","Listing Conversion","Account Audit"],
     howTo:["Seller Central → Reports → Advertising Reports → Create Report","Report type: Advertised Product → set date range → Run → Download"]},

    /* ── Bulk Operations (Seller Central → Campaign Manager → Bulk Operations) ── */
    {id:"bulk",       label:"Bulk File",                 icon:"ti-file-spreadsheet", color:"#555",    source:"bulk", required:false,
     desc:"Full Amazon bulk export — SP/SB/SD sheets, bids, keywords, targets in one file. Best for Bids Optimizer.",
     feeds:["Bids Optimizer","Campaign Health","Action Center","Portfolio Command","Conflict Detector","Bleeder Check","Rules Engine","Priority Engine"],
     howTo:["Seller Central → Campaign Manager → Bulk Operations (top right)","Set date range → Create spreadsheet for download → Download file"]},

    /* ── Brand Analytics (Seller Central → Brand Analytics) ── */
    {id:"sqp",        label:"Search Query Performance",  icon:"ti-chart-pie",        color:"#6338c8", source:"analytics", required:false,
     desc:"Your click share & conversion share vs all competitors per search query — Amazon Brand Analytics",
     feeds:["SQPR Analyzer","Competitor Radar","Niche Dives"],
     howTo:["Seller Central → Brand Analytics → Search Query Performance","Choose ASIN + date range → Download report (Excel)"]},

    /* ── Business Reports (Seller Central → Reports → Business Reports) ── */
    {id:"business",   label:"Business Report",           icon:"ti-chart-bar",        color:"#c47a00", source:"business", required:false,
     desc:"Sessions, page views, Buy Box %, Unit Session % (CVR) per ASIN — from Seller Central",
     feeds:["Listing Conversion","Action Center","Account Audit"],
     howTo:["Seller Central → Reports → Business Reports","Select: Detail Page Sales and Traffic by Child Item → set date range → Download"]},

    /* ── Fulfillment Reports (Seller Central → Reports → Fulfillment) ── */
    {id:"inventory",  label:"Inventory Report",          icon:"ti-package",          color:"#e07b00", source:"fulfillment", required:false,
     desc:"Stock units, days of supply, FBA availability per ASIN — prevents scaling into stockouts",
     feeds:["Inventory & PPC Intel","Action Center","Seasonal Engine"],
     howTo:["Seller Central → Reports → Fulfillment → Inventory Health","Download the Inventory Health report as CSV or Excel"]},

    /* ── Third-Party Tools (Helium 10, Data Dive, Jungle Scout etc) ── */
    {id:"rank",       label:"Rank / Keyword Position Report", icon:"ti-trending-up", color:"#888",    source:"thirdparty", required:false,
     desc:"Keyword rank positions from Helium 10, Data Dive, Jungle Scout, or Amazon Brand Analytics",
     feeds:["Rank Radar","Niche Dives","Seasonal Engine"],
     howTo:["Helium 10: Keyword Tracker → select keywords → Export CSV","Data Dive / Jungle Scout: Rank Tracker → Export  |  Must contain Keyword + Rank columns"]},
  ];

  const handleFile=async(slotId,f,p)=>{
    const cm=hubDetect(p.headers);
    const det=hubDetectReportType(cm,p.headers);
    setFiles(prev=>({...prev,[slotId]:f}));
    setParsed(prev=>({...prev,[slotId]:{rows:p.rows,headers:p.headers,cm,rowCount:p.rows.length}}));
    setDetected(prev=>({...prev,[slotId]:det}));
  };

  const clearSlot=id=>{
    setFiles(prev=>{const n={...prev};delete n[id];return n;});
    setParsed(prev=>{const n={...prev};delete n[id];return n;});
    setDetected(prev=>{const n={...prev};delete n[id];return n;});
  };

  /* Comparison period */
  const[compFiles,setCompFiles]=useState({});
  const[compParsed,setCompParsed]=useState({});
  const[compDetected,setCompDetected]=useState({});
  const[showComp,setShowComp]=useState(!!globalData?.comp);

  const handleCompFile=async(slotId,f,p)=>{
    const cm=hubDetect(p.headers);
    const det=hubDetectReportType(cm,p.headers);
    setCompFiles(prev=>({...prev,[slotId]:f}));
    setCompParsed(prev=>({...prev,[slotId]:{rows:p.rows,headers:p.headers,cm,rowCount:p.rows.length}}));
    setCompDetected(prev=>({...prev,[slotId]:det}));
  };
  const clearCompSlot=id=>{
    setCompFiles(prev=>{const n={...prev};delete n[id];return n;});
    setCompParsed(prev=>{const n={...prev};delete n[id];return n;});
    setCompDetected(prev=>{const n={...prev};delete n[id];return n;});
  };

  async function processAndLoad(){
    const hasPrimary=parsed.searchterm||parsed.bulk||parsed.campaign||parsed.targeting;
    if(!hasPrimary){setErr("Upload at least one report to continue (Search Term, Bulk File, Campaign, or Targeting Report).");return;}
    setLoading(true);setErr(null);
    try{
      /* Primary fallback chain: search term → bulk → campaign → targeting → first available */
      const best=parsed.searchterm||parsed.bulk||parsed.campaign||parsed.targeting||Object.values(parsed)[0];
      const compBest=compParsed.searchterm||compParsed.bulk||compParsed.campaign||compParsed.targeting||Object.values(compParsed)[0];

      /* Build cur — every slot maps to its specific key, primary is best available */
      const cur={
        ...parsed,
        primary:best,
        /* Explicit aliases so modules find data regardless of which slot was uploaded */
        searchterm: parsed.searchterm||null,
        campaign:   parsed.campaign||null,
        bulk:       parsed.bulk||null,
        sqp:        parsed.sqp||null,
        placement:  parsed.placement||null,
        business:   parsed.business||null,
        inventory:  parsed.inventory||null,
        rank:       parsed.rank||null,
        targeting:  parsed.targeting||null,
        asin:       parsed.asin||null,
        dayparting: parsed.dayparting||null,
      };
      const comp=Object.keys(compParsed).length?{
        ...compParsed,
        primary:compBest,
        searchterm: compParsed.searchterm||null,
        campaign:   compParsed.campaign||null,
        bulk:       compParsed.bulk||null,
        sqp:        compParsed.sqp||null,
        placement:  compParsed.placement||null,
        business:   compParsed.business||null,
        inventory:  compParsed.inventory||null,
        rank:       compParsed.rank||null,
        targeting:  compParsed.targeting||null,
        asin:       compParsed.asin||null,
        dayparting: compParsed.dayparting||null,
      }:null;

      onDataLoaded({cur,comp,periods,loadedAt:new Date().toISOString(),
        fileNames:Object.fromEntries(Object.entries(files).map(([k,v])=>[k,v.name])),
        reportsLoaded:Object.keys(parsed).length
      });
      setSubPage("status");
    }catch(e){setErr("Error loading data: "+e.message);}
    setLoading(false);
  }

  /* STATUS PAGE */
  if(subPage==="status"&&globalData){
    const{cur,comp,periods:p,loadedAt,fileNames}=globalData;
    const totalRows=Object.values(cur).filter(d=>d?.rowCount).reduce((s,d)=>s+(d.rowCount||0),0);
    return(<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
      <div style={{maxWidth:760,margin:"0 auto",padding:"28px 24px"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
          <div style={{width:42,height:42,borderRadius:11,background:"rgba(26,122,60,0.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><i className="ti ti-database-check" style={{fontSize:19,color:"#1a7a3c"}}/></div>
          <div style={{flex:1}}>
            <h2 style={{fontSize:18,fontWeight:800,color:"#111",margin:"0 0 2px",letterSpacing:"-0.3px"}}>Data Loaded — All Modules Ready</h2>
            <div style={{fontSize:12,color:"#888"}}>{totalRows.toLocaleString()} rows across {Object.keys(cur).filter(k=>k!=="primary"&&cur[k]?.rowCount).length} reports · {new Date(loadedAt).toLocaleTimeString()}{p?` · ${fmtDisp(p.current?.start)} → ${fmtDisp(p.current?.end)}`:""}</div>
          </div>
          <button onClick={()=>{setSubPage("dates");setFiles({});setParsed({});setDetected({});setCompFiles({});setCompParsed({});setCompDetected({});}} style={{padding:"7px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,fontWeight:600,color:"#555",display:"flex",alignItems:"center",gap:5}}><i className="ti ti-refresh" style={{fontSize:11}}/>New Upload</button>
          <button onClick={onClearData} style={{padding:"7px 12px",borderRadius:7,border:"1px solid rgba(212,43,43,0.3)",background:"rgba(212,43,43,0.04)",cursor:"pointer",fontSize:11,fontWeight:600,color:"#d42b2b",display:"flex",alignItems:"center",gap:5}}><i className="ti ti-trash" style={{fontSize:11}}/>Clear</button>
        </div>

        {/* Loaded reports */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"14px 16px",marginBottom:12}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10}}>Loaded Reports</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
            {Object.entries(cur).filter(([k])=>k!=="primary"&&cur[k]?.rowCount).map(([slot,data])=>{
              const s=FILE_SLOTS.find(f=>f.id===slot);
              return(<div key={slot} style={{padding:"8px 10px",borderRadius:8,background:"rgba(26,122,60,0.05)",border:"1px solid rgba(26,122,60,0.15)",display:"flex",gap:7,alignItems:"center"}}>
                <i className={`ti ${s?.icon||"ti-file-spreadsheet"}`} style={{fontSize:13,color:s?.color||"#1a7a3c",flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:11,fontWeight:700,color:"#111",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s?.label||slot}</div>
                  <div style={{fontSize:10,color:"#888"}}>{data.rowCount?.toLocaleString()} rows{comp?.[slot]?" · +comp":""}</div>
                </div>
              </div>);
            })}
          </div>
        </div>

        {/* Module readiness */}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"14px 16px",marginBottom:12}}>
          <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:10}}>Module Readiness — click to open</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7}}>
            {[
              {label:"Priority Engine",   ready:!!(cur.primary?.cm?.spend||cur.campaign?.cm?.spend||cur.bulk?.cm?.spend), icon:"ti-list-check",            tab:"priority"},
              {label:"Action Center",     ready:!!(cur.primary?.cm?.spend||cur.campaign?.cm?.spend),                       icon:"ti-layout-dashboard",      tab:"action"},
              {label:"Bids Optimizer",    ready:!!(cur.bulk?.cm?.bid||cur.bulk?.cm?.entity||cur.bulk?.rows?.length>0),     icon:"ti-adjustments-horizontal",tab:"bids"},
              {label:"Search Term Intel", ready:!!(cur.searchterm?.cm?.searchTerm||cur.primary?.cm?.searchTerm),           icon:"ti-eye-search",             tab:"searchterms"},
              {label:"Negation Engine",   ready:!!(cur.searchterm?.cm?.searchTerm||cur.primary?.cm?.searchTerm),           icon:"ti-ban",                    tab:"negations"},
              {label:"Search Intent AI",  ready:!!(cur.searchterm?.cm?.searchTerm||cur.primary?.cm?.searchTerm),           icon:"ti-target",                 tab:"intent"},
              {label:"SQPR Analyzer",     ready:!!(cur.sqp?.rows?.length>0),                                               icon:"ti-chart-pie",              tab:"sqpr"},
              {label:"Campaign Health",   ready:!!(cur.campaign?.cm?.spend||cur.bulk?.cm?.spend||cur.primary?.cm?.spend),  icon:"ti-heart-rate-monitor",     tab:"health"},
              {label:"Bleeder Check",     ready:!!(cur.campaign?.cm?.spend||cur.primary?.cm?.spend),                       icon:"ti-droplet-off",            tab:"bleeder"},
              {label:"Campaign Suggestions",ready:!!(cur.campaign?.cm?.spend||cur.primary?.cm?.spend),                    icon:"ti-speakerphone",           tab:"campaigns"},
              {label:"Conflict Detector", ready:!!(cur.bulk?.rows?.length>0||cur.targeting?.rows?.length>0||cur.primary?.cm?.keyword), icon:"ti-alert-triangle", tab:"conflict"},
              {label:"Impression Share",  ready:!!(cur.campaign?.cm?.impressions||cur.primary?.cm?.impressions),           icon:"ti-eye",                    tab:"impression"},
              {label:"Rank Radar",        ready:!!(cur.rank?.rows?.length>0),                                              icon:"ti-trending-up",            tab:"rank"},
              {label:"Placement Opt.",    ready:!!(cur.placement?.rows?.length>0),                                         icon:"ti-layout-2",               tab:"placement"},
              {label:"Dayparting Intel",  ready:!!(cur.primary?.cm?.hour||cur.campaign?.cm?.hour),                         icon:"ti-clock",                  tab:"dayparting"},
              {label:"Brand Defense",     ready:!!(cur.searchterm?.cm?.searchTerm||cur.primary?.cm?.searchTerm),           icon:"ti-shield",                 tab:"branddef"},
              {label:"Competitor Radar",  ready:!!(cur.sqp?.rows?.length>0||cur.primary?.cm?.spend),                      icon:"ti-radar",                  tab:"competitor"},
              {label:"Portfolio Command", ready:!!(cur.campaign?.cm?.spend||cur.primary?.cm?.spend),                       icon:"ti-command",                tab:"portfolio"},
              {label:"Niche Dives",       ready:!!(cur.searchterm?.cm?.searchTerm||cur.sqp?.rows?.length>0),               icon:"ti-telescope",              tab:"niche"},
              {label:"Listing Conversion",ready:!!(cur.business?.rows?.length>0),                                          icon:"ti-list-details",           tab:"listing"},
              {label:"Inventory & PPC",   ready:!!(cur.inventory?.rows?.length>0),                                         icon:"ti-package",                tab:"inventory"},
              {label:"Seasonal Engine",   ready:!!(cur.campaign?.cm?.spend||cur.primary?.cm?.spend),                       icon:"ti-calendar-event",         tab:"seasonal"},
              {label:"Account Audit",     ready:!!(cur.campaign?.cm?.spend||cur.primary?.cm?.spend),                       icon:"ti-clipboard-check",        tab:"audit"},
              {label:"Rules Engine",      ready:!!(cur.bulk?.rows?.length>0||cur.primary?.cm?.spend),                      icon:"ti-robot",                  tab:"automation"},
              {label:"Client Reporting",  ready:!!(cur.campaign?.cm?.spend||cur.primary?.cm?.spend),                       icon:"ti-file-analytics",         tab:"reporting"},
              {label:"Bulk Builder",      ready:true,                                                                       icon:"ti-sitemap",                tab:"bulk"},
              {label:"AI Strategist",     ready:!!(cur.primary?.cm?.spend),                                                icon:"ti-brain",                  tab:"ai"},
            ].map((m,i)=>(<button key={i} onClick={()=>m.ready&&setTab(m.tab)} title={m.ready?"Open module":"Upload required report first"} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 10px",borderRadius:7,border:`1px solid ${m.ready?"rgba(26,122,60,0.2)":"#f0f0f0"}`,background:m.ready?"rgba(26,122,60,0.04)":"#fafafa",cursor:m.ready?"pointer":"not-allowed",textAlign:"left"}}>
              <i className={`ti ${m.icon}`} style={{fontSize:12,color:m.ready?"#1a7a3c":"#ccc",flexShrink:0}}/>
              <span style={{fontSize:11,fontWeight:600,color:m.ready?"#111":"#aaa",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.label}</span>
              <i className={`ti ${m.ready?"ti-chevron-right":"ti-lock"}`} style={{fontSize:9,color:m.ready?"#1a7a3c":"#ddd",flexShrink:0}}/>
            </button>))}
          </div>
        </div>
      </div>
    </div>);
  }

  /* DATE PICKER */
  if(subPage==="dates")return(<div style={{flex:1,overflowY:"auto"}}><DateRangePicker onConfirm={p=>{setPeriods(p);setSubPage("upload");}}/></div>);

  /* UPLOAD PAGE — compact grid */
  return(<div style={{flex:1,overflowY:"auto",background:"#f7f7f7"}}>
    <div style={{maxWidth:860,margin:"0 auto",padding:"24px 24px"}}>

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
        <button onClick={()=>setSubPage("dates")} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",color:"#555",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-arrow-left" style={{fontSize:11}}/> Change Dates</button>
        {periods&&<div style={{fontSize:12,color:"#888"}}><span style={{fontWeight:600,color:"#111"}}>{fmtDisp(periods.current?.start)} → {fmtDisp(periods.current?.end)}</span></div>}
        <div style={{flex:1}}/>
        <button onClick={()=>setShowComp(v=>!v)} style={{padding:"5px 12px",borderRadius:7,border:`1.5px dashed ${showComp?R:"#d0d0d0"}`,background:showComp?"rgba(79,70,229,0.03)":"#fff",cursor:"pointer",color:showComp?R:"#666",fontSize:11,fontWeight:600,display:"flex",alignItems:"center",gap:5}}>
          <i className={`ti ${showComp?"ti-minus":"ti-plus"}`} style={{fontSize:11}}/>
          {showComp?"Remove Comparison Period":"+ Add Comparison Period"}
        </button>
      </div>

      <h2 style={{fontSize:18,fontWeight:800,color:"#111",margin:"0 0 3px",letterSpacing:"-0.3px"}}>Upload Your Amazon Reports</h2>
      <p style={{fontSize:12,color:"#888",margin:"0 0 16px"}}>Upload once — all modules sync automatically. Upload what you have, everything optional except Search Term or Bulk File.</p>

      {/* ── Grouped report sections ── */}
      {[
        {source:"advertising", label:"Advertising Console",  icon:"ti-speakerphone", color:"#1a5fa0", path:"Seller Central → Reports → Advertising Reports"},
        {source:"bulk",        label:"Bulk Operations",       icon:"ti-file-spreadsheet",color:"#555",path:"Seller Central → Campaign Manager → Bulk Operations"},
        {source:"analytics",   label:"Brand Analytics",       icon:"ti-chart-pie",    color:"#6338c8", path:"Seller Central → Brand Analytics"},
        {source:"business",    label:"Business Reports",      icon:"ti-chart-bar",    color:"#c47a00", path:"Seller Central → Reports → Business Reports"},
        {source:"fulfillment", label:"Fulfillment Reports",   icon:"ti-package",      color:"#e07b00", path:"Seller Central → Reports → Fulfillment"},
        {source:"thirdparty",  label:"Third-Party Tools",     icon:"ti-tool",         color:"#888",    path:"Helium 10 / Data Dive / Jungle Scout"},
      ].map(group=>{
        const groupSlots=FILE_SLOTS.filter(s=>s.source===group.source);
        const loadedCount=groupSlots.filter(s=>!!files[s.id]).length;
        return(
          <div key={group.source} style={{marginBottom:18}}>
            {/* Group header */}
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,paddingBottom:6,borderBottom:`2px solid ${group.color}22`}}>
              <div style={{width:26,height:26,borderRadius:7,background:`${group.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <i className={`ti ${group.icon}`} style={{fontSize:12,color:group.color}}/>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:800,color:"#111"}}>{group.label}</div>
                <div style={{fontSize:10,color:"#aaa",fontFamily:"monospace"}}>{group.path}</div>
              </div>
              {loadedCount>0&&(
                <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,background:"rgba(26,122,60,0.1)",color:"#1a7a3c",fontWeight:700}}>{loadedCount}/{groupSlots.length} uploaded</span>
              )}
            </div>
            {/* Slots grid within group */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:4}}>
        {groupSlots.map(slot=>{
          const loaded=!!files[slot.id];
          const compLoaded=!!compFiles[slot.id];
          const det=detected[slot.id];
          return(
            <div key={slot.id} style={{background:"#fff",borderRadius:10,border:`1.5px solid ${loaded?"rgba(26,122,60,0.35)":slot.required?"rgba(79,70,229,0.2)":"#e8e8e8"}`,overflow:"hidden",transition:"border-color 0.15s"}}>

              {/* Top info row */}
              <div style={{padding:"10px 12px 8px",borderBottom:"1px solid #f5f5f5"}}>
                <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}>
                  <i className={`ti ${loaded?"ti-check-circle":slot.icon}`} style={{fontSize:14,color:loaded?"#1a7a3c":slot.color,flexShrink:0}}/>
                  <span style={{fontSize:12,fontWeight:800,color:loaded?"#1a7a3c":"#111",flex:1}}>{slot.label}</span>
                  {slot.required&&!loaded&&<span style={{fontSize:8,padding:"1px 5px",borderRadius:3,background:"rgba(79,70,229,0.1)",color:"#4f46e5",fontWeight:700,textTransform:"uppercase",flexShrink:0}}>Required</span>}
                  {slot.badge&&!slot.required&&!loaded&&<span style={{fontSize:8,padding:"1px 5px",borderRadius:3,background:`${slot.color}14`,color:slot.color,fontWeight:700,textTransform:"uppercase",flexShrink:0}}>{slot.badge}</span>}
                  {loaded&&<span style={{fontSize:9,color:"#1a7a3c",fontWeight:600,flexShrink:0}}>{parsed[slot.id]?.rowCount?.toLocaleString()} rows</span>}
                </div>
                <div style={{fontSize:10,color:"#888",lineHeight:1.4,marginBottom:5}}>{slot.desc}</div>

                {/* Feeds pills */}
                <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:4}}>
                  {slot.feeds.map((f,fi)=>(<span key={fi} style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"#f0f0f0",color:"#555",fontWeight:600}}>{f}</span>))}
                </div>

                {/* How to download — inline collapsed */}
                <button onClick={()=>toggleHow(slot.id)} style={{border:"none",background:"transparent",cursor:"pointer",fontSize:10,color:"#1a5fa0",fontWeight:600,padding:"2px 0",display:"flex",alignItems:"center",gap:3}}>
                  <i className="ti ti-info-circle" style={{fontSize:10}}/>How to download<i className={`ti ${expandedHow[slot.id]?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:9,marginLeft:2}}/>
                </button>
                {expandedHow[slot.id]&&(
                  <div style={{marginTop:5,padding:"7px 9px",background:"#f8f9ff",borderRadius:6,border:"1px solid #e8ecff"}}>
                    {slot.howTo.map((step,si)=>(
                      <div key={si} style={{display:"flex",gap:6,marginBottom:si<slot.howTo.length-1?4:0,alignItems:"flex-start"}}>
                        <span style={{width:14,height:14,borderRadius:"50%",background:"#1a5fa0",color:"#fff",fontSize:8,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{si+1}</span>
                        <span style={{fontSize:10,color:"#444",lineHeight:1.4}}>{step}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Upload zone — compact */}
              <div style={{padding:"8px 12px"}}>
                {/* Current period */}
                <div style={{marginBottom:showComp?6:0}}>
                  {!loaded?(
                    <label style={{display:"flex",alignItems:"center",gap:7,padding:"7px 10px",borderRadius:7,border:"1.5px dashed #ddd",background:"#fafafa",cursor:"pointer",transition:"all 0.15s"}}>
                      <input type="file" accept=".xlsx,.csv" style={{display:"none"}} onChange={async e=>{if(e.target.files[0]){const f=e.target.files[0];try{const p=await parseSheet(f);handleFile(slot.id,f,p);}catch(ex){alert("Could not read: "+ex.message);}}e.target.value="";}}/>
                      <i className="ti ti-upload" style={{fontSize:13,color:"#aaa",flexShrink:0}}/>
                      <span style={{fontSize:11,color:"#888"}}>Click to upload current period</span>
                    </label>
                  ):(
                    <div style={{display:"flex",alignItems:"center",gap:7,padding:"6px 10px",borderRadius:7,background:"rgba(26,122,60,0.06)",border:"1px solid rgba(26,122,60,0.2)"}}>
                      <i className="ti ti-file-spreadsheet" style={{fontSize:12,color:"#1a7a3c",flexShrink:0}}/>
                      <span style={{fontSize:10,color:"#1a7a3c",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontWeight:600}}>{files[slot.id]?.name}</span>
                      <button onClick={()=>clearSlot(slot.id)} style={{border:"none",background:"transparent",cursor:"pointer",color:"#aaa",fontSize:10,padding:"0 2px",flexShrink:0}}>✕</button>
                    </div>
                  )}
                </div>

                {/* Comparison period */}
                {showComp&&(
                  <div>
                    {!compLoaded?(
                      <label style={{display:"flex",alignItems:"center",gap:7,padding:"6px 10px",borderRadius:7,border:"1.5px dashed #d8d0ff",background:"rgba(99,56,200,0.03)",cursor:"pointer"}}>
                        <input type="file" accept=".xlsx,.csv" style={{display:"none"}} onChange={async e=>{if(e.target.files[0]){const f=e.target.files[0];try{const p=await parseSheet(f);handleCompFile(slot.id,f,p);}catch(ex){alert("Could not read: "+ex.message);}}e.target.value="";}}/>
                        <i className="ti ti-upload" style={{fontSize:11,color:"#9b8bda",flexShrink:0}}/>
                        <span style={{fontSize:10,color:"#9b8bda"}}>Upload comparison period</span>
                      </label>
                    ):(
                      <div style={{display:"flex",alignItems:"center",gap:7,padding:"5px 10px",borderRadius:7,background:"rgba(99,56,200,0.06)",border:"1px solid rgba(99,56,200,0.2)"}}>
                        <i className="ti ti-arrows-exchange" style={{fontSize:11,color:"#6338c8",flexShrink:0}}/>
                        <span style={{fontSize:10,color:"#6338c8",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{compFiles[slot.id]?.name}</span>
                        <button onClick={()=>clearCompSlot(slot.id)} style={{border:"none",background:"transparent",cursor:"pointer",color:"#aaa",fontSize:10,padding:"0 2px",flexShrink:0}}>✕</button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
            </div>
          </div>
        );
      })}

      {/* Summary + Load button */}
      <div style={{background:"#fff",borderRadius:10,border:"1px solid #eee",padding:"12px 16px",display:"flex",alignItems:"center",gap:14}}>
        <div style={{flex:1}}>
          {Object.keys(parsed).length>0?(
            <div>
              <div style={{fontSize:12,fontWeight:700,color:"#1a7a3c",marginBottom:3}}><i className="ti ti-check-circle" style={{marginRight:5}}/>{Object.keys(parsed).length} report{Object.keys(parsed).length!==1?"s":""} ready · {Object.values(parsed).reduce((s,v)=>s+(v.rowCount||0),0).toLocaleString()} rows total</div>
              {Object.keys(compParsed).length>0&&<div style={{fontSize:11,color:"#6338c8"}}><i className="ti ti-arrows-exchange" style={{marginRight:4}}/>Comparison: {Object.keys(compParsed).length} report{Object.keys(compParsed).length!==1?"s":""}</div>}
            </div>
          ):(
            <div style={{fontSize:12,color:"#aaa"}}>Upload at least one report to continue</div>
          )}
          {err&&<div style={{fontSize:11,color:"#d42b2b",marginTop:4}}><i className="ti ti-alert-triangle" style={{marginRight:4}}/>{err}</div>}
        </div>
        <button onClick={processAndLoad} disabled={Object.keys(parsed).length===0||loading}
          style={{padding:"10px 22px",borderRadius:8,border:"none",background:Object.keys(parsed).length>0&&!loading?"#4f46e5":"#e0e0e0",color:Object.keys(parsed).length>0&&!loading?"#fff":"#aaa",fontSize:13,fontWeight:700,cursor:Object.keys(parsed).length>0&&!loading?"pointer":"not-allowed",display:"flex",alignItems:"center",gap:7,flexShrink:0,boxShadow:Object.keys(parsed).length>0?"0 2px 12px rgba(79,70,229,0.3)":"none",whiteSpace:"nowrap"}}>
          {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Processing...</>:<><i className="ti ti-database-import" style={{fontSize:13}}/>Load Data — Sync All Modules</>}
        </button>
      </div>
    </div>
  </div>);
}

/* ================================================================
   RULES ENGINE MODULE
   Strategist-controlled PPC automation system.
   Sections: Overview · Rule Builder · Safety Engine · Monitoring
             Preview · AI Assistant · History · Templates
   No upload — syncs from Global Data Hub.
================================================================ */

/* ── Rules Engine localStorage key ─────────────────────────── */
const RE_LS_KEY = "quarred_rules_engine_v1";
function reLoadRules(){try{const s=localStorage.getItem(RE_LS_KEY);return s?JSON.parse(s):[];}catch{return [];}}
function reSaveRules(rules){try{localStorage.setItem(RE_LS_KEY,JSON.stringify(rules));}catch{}}

const RE_LS_HIST = "quarred_rules_history_v1";
function reLoadHistory(){try{const s=localStorage.getItem(RE_LS_HIST);return s?JSON.parse(s):[];}catch{return [];}}
function reSaveHistory(h){try{localStorage.setItem(RE_LS_HIST,JSON.stringify(h));}catch{}}

/* ── Rule constants ─────────────────────────────────────────── */
const RE_TRIGGERS=[
  {key:"acos_gt",     label:"ACoS >",          unit:"%",  desc:"When ACoS exceeds threshold"},
  {key:"acos_lt",     label:"ACoS <",          unit:"%",  desc:"When ACoS is below threshold"},
  {key:"spend_gt",    label:"Spend >",          unit:"$",  desc:"When spend exceeds amount"},
  {key:"cpc_inc",     label:"CPC increased >",  unit:"%",  desc:"When CPC rises vs previous period"},
  {key:"cvr_dec",     label:"CVR dropped >",    unit:"pp", desc:"When CVR falls vs previous period"},
  {key:"no_sales",    label:"No sales, spend >",unit:"$",  desc:"Spend without any orders"},
  {key:"imp_lt",      label:"Impressions <",    unit:"",   desc:"When impressions fall below"},
  {key:"orders_gt",   label:"Orders ≥",         unit:"",   desc:"When orders meet threshold"},
  {key:"roas_lt",     label:"ROAS <",           unit:"",   desc:"When ROAS falls below target"},
  {key:"budget_pct",  label:"Budget used >",    unit:"%",  desc:"When budget utilisation exceeds"},
];
const RE_ACTIONS=[
  {key:"bid_inc_pct",  label:"Increase bid by %",    unit:"%"},
  {key:"bid_dec_pct",  label:"Decrease bid by %",    unit:"%"},
  {key:"bid_inc_amt",  label:"Increase bid by $",    unit:"$"},
  {key:"bid_dec_amt",  label:"Decrease bid by $",    unit:"$"},
  {key:"bid_set",      label:"Set bid to $",          unit:"$"},
  {key:"pause",        label:"Pause keyword",         unit:""},
  {key:"export_only",  label:"Flag for review only",  unit:""},
];
const RE_SCOPES=[
  {key:"keyword",   label:"Keyword level"},
  {key:"campaign",  label:"Campaign level"},
  {key:"placement", label:"Placement level"},
  {key:"adgroup",   label:"Ad Group level"},
];
const RE_FREQS=[
  {key:"manual",  label:"Manual review only"},
  {key:"daily",   label:"Daily"},
  {key:"weekly",  label:"Weekly"},
];
const RE_TEMPLATES=[
  {id:"waste",    name:"Waste Reduction",     icon:"ti-droplet-off",  color:"#d42b2b",
   risk:"Medium", purpose:"Pause or reduce bids on keywords spending without converting.",
   trigger:{key:"no_sales",value:"15"},action:{key:"bid_dec_pct",value:"30"},scope:"keyword",freq:"weekly",
   notes:"Only fires on keywords with 15+ spend and zero orders in the period. Safe for most accounts."},
  {id:"budget",   name:"Budget Protection",   icon:"ti-shield",       color:"#c47a00",
   risk:"Low",    purpose:"Flag campaigns that are hitting budget cap and potentially losing impressions.",
   trigger:{key:"budget_pct",value:"90"},action:{key:"export_only",value:""},scope:"campaign",freq:"daily",
   notes:"Flags campaigns for review — does not auto-change bids. Safest automation type."},
  {id:"cpc",      name:"CPC Inflation Guard", icon:"ti-trending-up",  color:"#4f46e5",
   risk:"Medium", purpose:"Reduce bids on keywords where CPC has inflated without sales improvement.",
   trigger:{key:"cpc_inc",value:"30"},action:{key:"bid_dec_pct",value:"15"},scope:"keyword",freq:"weekly",
   notes:"Comparison-first: only fires when CPC vs previous period is 30%+ higher. Requires comparison data."},
  {id:"rank",     name:"Ranking Protection",  icon:"ti-trending-up",  color:"#1a5fa0",
   risk:"High",   purpose:"Protect high-impression keywords from bid reductions that could hurt organic rank.",
   trigger:{key:"imp_lt",value:"500"},action:{key:"export_only",value:""},scope:"keyword",freq:"daily",
   notes:"High-risk: impression drops can signal ranking loss. Always review before acting."},
  {id:"negate",   name:"Negation Candidate",  icon:"ti-ban",          color:"#6338c8",
   risk:"High",   purpose:"Flag search terms with spend but zero orders for negation review.",
   trigger:{key:"no_sales",value:"10"},action:{key:"export_only",value:""},scope:"keyword",freq:"weekly",
   notes:"Always flag only — never auto-negate. Manual review required to avoid blocking converters."},
  {id:"scale",    name:"Scaling Opportunity", icon:"ti-rocket",       color:"#1a7a3c",
   risk:"Low",    purpose:"Increase bids on keywords with low ACoS and strong order velocity.",
   trigger:{key:"acos_lt",value:"20"},action:{key:"bid_inc_pct",value:"15"},scope:"keyword",freq:"weekly",
   notes:"Only fires when ACoS <20% AND orders ≥3. Conservative 15% increase — safe for scaling."},
  {id:"placement",name:"Placement Adjust",    icon:"ti-layout-2",     color:"#555",
   risk:"Medium", purpose:"Flag placements where ACoS is consistently high for modifier review.",
   trigger:{key:"acos_gt",value:"60"},action:{key:"export_only",value:""},scope:"placement",freq:"weekly",
   notes:"Flags only — placement modifier changes require manual review in Campaign Manager."},
];

/* ── Rule evaluator (runs against globalData rows) ────────────── */
function reEvalRule(rule, rows, cm, compRows, compCm){
  if(!rows||!cm)return[];
  const results=[];
  rows.forEach(row=>{
    const m=calcRowMetrics(row,cm);
    let triggered=false;
    const v=parseFloat(rule.triggerValue||0);
    if(rule.trigger==="acos_gt"&&m.acos>v&&m.spend>0)triggered=true;
    else if(rule.trigger==="acos_lt"&&m.acos>0&&m.acos<v&&m.orders>0)triggered=true;
    else if(rule.trigger==="spend_gt"&&m.spend>v)triggered=true;
    else if(rule.trigger==="no_sales"&&m.spend>=v&&m.orders===0)triggered=true;
    else if(rule.trigger==="imp_lt"&&m.impressions>0&&m.impressions<v)triggered=true;
    else if(rule.trigger==="orders_gt"&&m.orders>=v)triggered=true;
    else if(rule.trigger==="roas_lt"&&m.spend>0&&m.roas<v)triggered=true;
    else if(rule.trigger==="budget_pct"&&m.spend>0)triggered=true;
    if(rule.trigger==="cpc_inc"&&compRows&&compCm){
      const compRow=compRows.find(r=>r[compCm.keyword]===row[cm.keyword]);
      if(compRow){const cm2=calcRowMetrics(compRow,compCm);if(cm2.cpc>0&&((m.cpc-cm2.cpc)/cm2.cpc)*100>v)triggered=true;}
    }
    if(rule.trigger==="cvr_dec"&&compRows&&compCm){
      const compRow=compRows.find(r=>r[compCm.keyword]===row[cm.keyword]);
      if(compRow){const cm2=calcRowMetrics(compRow,compCm);if(cm2.cvr>0&&cm2.cvr-m.cvr>v)triggered=true;}
    }
    if(triggered){
      const kw=row[cm.keyword]||row[cm.campaign]||"Unknown";
      const camp=row[cm.campaign]||"—";
      let newBid=m.bid;const av=parseFloat(rule.actionValue||0);
      if(rule.action==="bid_inc_pct")newBid=Math.max(0.02,Math.round(m.bid*(1+av/100)*100)/100);
      else if(rule.action==="bid_dec_pct")newBid=Math.max(0.02,Math.round(m.bid*(1-av/100)*100)/100);
      else if(rule.action==="bid_inc_amt")newBid=Math.max(0.02,Math.round((m.bid+av)*100)/100);
      else if(rule.action==="bid_dec_amt")newBid=Math.max(0.02,Math.round((m.bid-av)*100)/100);
      else if(rule.action==="bid_set")newBid=Math.max(0.02,av);
      results.push({keyword:kw,campaign:camp,currentBid:m.bid,newBid,metrics:m,action:rule.action,actionValue:rule.actionValue});
    }
  });
  return results;
}

/* ── Safety checks ──────────────────────────────────────────── */
function reSafetyCheck(rule, previewResults){
  const warnings=[];
  if(rule.action==="bid_dec_pct"&&parseFloat(rule.actionValue||0)>40)
    warnings.push({severity:"High",issue:"Aggressive bid reduction",explain:"Reducing bids by 40%+ risks visibility collapse and ranking damage.",alt:"Reduce by 15–25% maximum. Monitor for 2 weeks before further cuts."});
  if(rule.action==="bid_inc_pct"&&parseFloat(rule.actionValue||0)>50)
    warnings.push({severity:"High",issue:"Aggressive bid increase",explain:"Increasing bids 50%+ without ACoS cap risks runaway spend.",alt:"Increase 10–25%. Set a max bid cap in rule settings."});
  if(rule.action==="pause"&&previewResults.length>20)
    warnings.push({severity:"High",issue:"Mass pause risk",explain:`${previewResults.length} keywords would be paused. This can devastate account visibility.`,alt:"Use 'Flag for review only' first. Review each keyword manually."});
  if(previewResults.length<3&&previewResults.length>0)
    warnings.push({severity:"Medium",issue:"Low data volume",explain:"Rule triggers on very few keywords. Ensure data covers sufficient period.",alt:"Use at least 14-day date range for reliable automation triggers."});
  if(rule.trigger==="no_sales"&&rule.action!=="export_only"&&parseFloat(rule.actionValue||0)<=5)
    warnings.push({severity:"Medium",issue:"Low spend threshold for auto-action",explain:"Acting on <$5 spend is premature. Insufficient data to confirm non-converter.",alt:"Set no-sales threshold to $15+ before automating actions."});
  return warnings;
}

/* ── Components ─────────────────────────────────────────────── */

function REEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(79,70,229,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-robot" style={{fontSize:26,color:R}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Rules Engine needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:360,lineHeight:1.6,marginBottom:20}}>Upload a Bulk File or Campaign Report in the Data Hub first. The Rules Engine uses that data to evaluate conditions and preview automation impact.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}>
        <i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub
      </button>
    </div>
  );
}

/* Overview cards */
function REOverview({rules,history,previewMap}){
  const active=rules.filter(r=>r.enabled);
  const triggered=history.filter(h=>h.type==="triggered").length;
  const failed=history.filter(h=>h.type==="failed").length;
  const highRisk=rules.filter(r=>r.enabled&&r._warnings&&r._warnings.length>0&&r._warnings.some(w=>w.severity==="High"));
  const estImpact=Object.values(previewMap).flat().length;

  const cards=[
    {label:"Active Rules",val:active.length,icon:"ti-check-circle",color:"#1a7a3c",sub:`of ${rules.length} total`},
    {label:"Triggered (session)",val:triggered,icon:"ti-bolt",color:"#4f46e5",sub:"since last run"},
    {label:"High-Risk Rules",val:highRisk.length,icon:"ti-alert-triangle",color:"#c47a00",sub:"require review"},
    {label:"Entities in scope",val:estImpact,icon:"ti-target",color:"#1a5fa0",sub:"from preview"},
    {label:"Failed / Skipped",val:failed,icon:"ti-x",color:"#888",sub:"this session"},
    {label:"Est. Time Saved",val:`${Math.max(0,(active.length*12))}m`,icon:"ti-clock",color:"#6338c8",sub:"manual work replaced"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
      {cards.map(c=>(
        <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
            </div>
            <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
          </div>
          <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:2}}>{c.val}</div>
          <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}

/* Rule Builder */
function REBuilder({onSave,onCancel,editing}){
  const[name,setName]=useState(editing?.name||"");
  const[trigger,setTrigger]=useState(editing?.trigger||"acos_gt");
  const[triggerValue,setTriggerValue]=useState(editing?.triggerValue||"40");
  const[action,setAction]=useState(editing?.action||"bid_dec_pct");
  const[actionValue,setActionValue]=useState(editing?.actionValue||"15");
  const[scope,setScope]=useState(editing?.scope||"keyword");
  const[freq,setFreq]=useState(editing?.freq||"manual");
  const[minBid,setMinBid]=useState(editing?.minBid||"0.02");
  const[maxBid,setMaxBid]=useState(editing?.maxBid||"");
  const[notes,setNotes]=useState(editing?.notes||"");

  const trigDef=RE_TRIGGERS.find(t=>t.key===trigger)||RE_TRIGGERS[0];
  const actDef=RE_ACTIONS.find(a=>a.key===action)||RE_ACTIONS[0];
  const hasActionVal=actDef.unit!=="";

  function handleSave(){
    if(!name.trim()){alert("Please give the rule a name.");return;}
    onSave({id:editing?.id||`rule_${Date.now()}`,name:name.trim(),trigger,triggerValue,action,actionValue,scope,freq,minBid,maxBid,notes,enabled:editing?.enabled??true,createdAt:editing?.createdAt||new Date().toISOString()});
  }

  const inp={padding:"8px 12px",borderRadius:7,border:"1.5px solid #e0e0e0",background:"#fff",fontSize:13,color:"#111",outline:"none",width:"100%",boxSizing:"border-box"};
  const sel={...inp,cursor:"pointer"};

  return(
    <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e0e0e0",padding:"20px 22px",boxShadow:"0 4px 24px rgba(0,0,0,0.08)"}}>
      <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:18}}>{editing?"Edit Rule":"New Automation Rule"}</div>

      {/* Rule name */}
      <div style={{marginBottom:16}}>
        <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>Rule Name</label>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder='e.g. "High ACoS Bid Reduction"' style={inp}/>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
        {/* Scope */}
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>Scope</label>
          <select value={scope} onChange={e=>setScope(e.target.value)} style={sel}>
            {RE_SCOPES.map(s=><option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
        </div>
        {/* Frequency */}
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>Run Frequency</label>
          <select value={freq} onChange={e=>setFreq(e.target.value)} style={sel}>
            {RE_FREQS.map(f=><option key={f.key} value={f.key}>{f.label}</option>)}
          </select>
        </div>
      </div>

      {/* Trigger */}
      <div style={{background:"#fafafa",borderRadius:10,border:"1px solid #f0f0f0",padding:"14px 16px",marginBottom:14}}>
        <div style={{fontSize:11,fontWeight:700,color:"#4f46e5",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>IF condition</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:10,alignItems:"center"}}>
          <select value={trigger} onChange={e=>setTrigger(e.target.value)} style={sel}>
            {RE_TRIGGERS.map(t=><option key={t.key} value={t.key}>{t.label}{t.unit?` (${t.unit})`:""}</option>)}
          </select>
          {trigDef.unit&&<div style={{display:"flex",alignItems:"center",gap:6}}>
            <input type="number" value={triggerValue} onChange={e=>setTriggerValue(e.target.value)} style={{...inp,width:90}} placeholder="value"/>
            <span style={{fontSize:12,color:"#888",whiteSpace:"nowrap"}}>{trigDef.unit}</span>
          </div>}
        </div>
        <div style={{fontSize:11,color:"#888",marginTop:7,fontStyle:"italic"}}>{trigDef.desc}</div>
      </div>

      {/* Action */}
      <div style={{background:"#fafafa",borderRadius:10,border:"1px solid #f0f0f0",padding:"14px 16px",marginBottom:14}}>
        <div style={{fontSize:11,fontWeight:700,color:"#1a5fa0",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>THEN action</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:10,alignItems:"center"}}>
          <select value={action} onChange={e=>setAction(e.target.value)} style={sel}>
            {RE_ACTIONS.map(a=><option key={a.key} value={a.key}>{a.label}</option>)}
          </select>
          {hasActionVal&&<div style={{display:"flex",alignItems:"center",gap:6}}>
            <input type="number" value={actionValue} onChange={e=>setActionValue(e.target.value)} style={{...inp,width:90}} placeholder="value" min="0"/>
            <span style={{fontSize:12,color:"#888",whiteSpace:"nowrap"}}>{actDef.unit}</span>
          </div>}
        </div>
      </div>

      {/* Bid guards */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>Min Bid ($)</label>
          <input type="number" value={minBid} onChange={e=>setMinBid(e.target.value)} step="0.01" min="0.02" style={inp} placeholder="0.02"/>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>Max Bid ($ optional)</label>
          <input type="number" value={maxBid} onChange={e=>setMaxBid(e.target.value)} step="0.01" min="0" style={inp} placeholder="no limit"/>
        </div>
      </div>

      {/* Notes */}
      <div style={{marginBottom:18}}>
        <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>Strategist Notes (optional)</label>
        <textarea value={notes} onChange={e=>setNotes(e.target.value)} rows={2} placeholder="Why this rule exists, any edge cases to watch..." style={{...inp,resize:"vertical",lineHeight:1.5}}/>
      </div>

      <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
        <button onClick={onCancel} style={{padding:"9px 18px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:13,fontWeight:600,color:"#555"}}>Cancel</button>
        <button onClick={handleSave} style={{...T.btnR(false),padding:"9px 20px"}}>
          <i className="ti ti-check" style={{fontSize:13}}/>{editing?"Save Changes":"Create Rule"}
        </button>
      </div>
    </div>
  );
}

/* Safety warning cards */
function RESafetyCards({warnings}){
  if(!warnings||warnings.length===0)return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"12px 16px",background:"rgba(26,122,60,0.06)",borderRadius:9,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-shield-check" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No safety issues detected — this rule looks safe to activate.</span>
    </div>
  );
  const sev={High:{bg:"rgba(212,43,43,0.06)",border:"rgba(212,43,43,0.2)",color:"#d42b2b",icon:"ti-alert-triangle"},Medium:{bg:"rgba(196,122,0,0.06)",border:"rgba(196,122,0,0.2)",color:"#c47a00",icon:"ti-alert-circle"},Low:{bg:"rgba(99,56,200,0.06)",border:"rgba(99,56,200,0.2)",color:"#6338c8",icon:"ti-info-circle"}};
  return(
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {warnings.map((w,i)=>{const s=sev[w.severity]||sev.Low;return(
        <div key={i} style={{background:s.bg,borderRadius:10,border:`1px solid ${s.border}`,padding:"12px 14px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:5}}>
            <i className={`ti ${s.icon}`} style={{fontSize:14,color:s.color}}/>
            <span style={{fontSize:12,fontWeight:700,color:s.color}}>{w.severity} Risk — {w.issue}</span>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.5,marginBottom:6}}>{w.explain}</div>
          <div style={{fontSize:11,color:"#555",background:"rgba(255,255,255,0.6)",borderRadius:6,padding:"6px 9px"}}>
            <i className="ti ti-bulb" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>Safer alternative: {w.alt}
          </div>
        </div>
      );})}
    </div>
  );
}

/* Preview table */
function REPreviewTable({results,rule}){
  if(!results||results.length===0)return(
    <div style={{textAlign:"center",padding:"30px 0",color:"#aaa"}}>
      <i className="ti ti-search-off" style={{fontSize:28,display:"block",marginBottom:8}}/>
      <div style={{fontSize:13}}>No entities match this rule's conditions with current data.</div>
    </div>
  );
  return(
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead>
          <tr style={{background:"#f7f7f7"}}>
            {["Target / Keyword","Campaign","Current Bid","New Bid","Change","ACoS","Spend","Orders"].map(h=>(
              <th key={h} style={{padding:"8px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {results.slice(0,50).map((r,i)=>{
            const up=r.newBid>r.currentBid;const same=r.newBid===r.currentBid;const isFlag=rule?.action==="export_only"||rule?.action==="pause";
            return(
              <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.keyword}</td>
                <td style={{padding:"8px 10px",color:"#555",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.campaign}</td>
                <td style={{padding:"8px 10px",color:"#555"}}>${r.currentBid.toFixed(2)}</td>
                <td style={{padding:"8px 10px",fontWeight:700,color:isFlag?"#6338c8":up?"#1a7a3c":"#d42b2b"}}>{isFlag?"⚑ Flagged":`$${r.newBid.toFixed(2)}`}</td>
                <td style={{padding:"8px 10px"}}>
                  {!isFlag&&!same&&<span style={{fontSize:11,fontWeight:700,color:up?"#1a7a3c":"#d42b2b"}}>{up?"▲":"▼"} ${Math.abs(r.newBid-r.currentBid).toFixed(2)}</span>}
                  {same&&<span style={{color:"#aaa",fontSize:11}}>—</span>}
                </td>
                <td style={{padding:"8px 10px",color:r.metrics.acos>50?"#d42b2b":r.metrics.acos>30?"#c47a00":"#111"}}>{r.metrics.acos>0?`${r.metrics.acos.toFixed(1)}%`:"—"}</td>
                <td style={{padding:"8px 10px",color:"#555"}}>${r.metrics.spend.toFixed(2)}</td>
                <td style={{padding:"8px 10px",color:"#555"}}>{r.metrics.orders}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {results.length>50&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 50 of {results.length} affected entities</div>}
    </div>
  );
}

/* Monitoring table */
function REMonitoringTable({rules,previewMap,onEdit,onToggle,onDelete,onDuplicate}){
  const[filter,setFilter]=useState("all");
  const[sort,setSort]=useState("name");
  const filtered=rules.filter(r=>filter==="all"||(filter==="active"&&r.enabled)||(filter==="paused"&&!r.enabled)||(filter==="risky"&&r._warnings?.some(w=>w.severity==="High")));
  const sorted=[...filtered].sort((a,b)=>sort==="name"?a.name.localeCompare(b.name):sort==="risk"?(b._warnings?.length||0)-(a._warnings?.length||0):sort==="scope"?a.scope.localeCompare(b.scope):0);
  const pills=["all","active","paused","risky"];
  const scopeLabel={keyword:"Keyword",campaign:"Campaign",placement:"Placement",adgroup:"Ad Group"};
  const freqLabel={manual:"Manual",daily:"Daily",weekly:"Weekly"};
  return(
    <div>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,flexWrap:"wrap"}}>
        {pills.map(p=><button key={p} onClick={()=>setFilter(p)} style={{padding:"5px 12px",borderRadius:20,border:`1px solid ${filter===p?"#4f46e5":"#e0e0e0"}`,background:filter===p?"#4f46e5":"#fff",color:filter===p?"#fff":"#555",fontSize:11,fontWeight:600,cursor:"pointer",textTransform:"capitalize"}}>{p}</button>)}
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="name">Sort by Name</option>
          <option value="risk">Sort by Risk</option>
          <option value="scope">Sort by Scope</option>
        </select>
      </div>
      {sorted.length===0?<div style={{textAlign:"center",padding:"40px 0",color:"#aaa",fontSize:13}}>No rules match this filter.</div>:(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {sorted.map(rule=>{
            const preview=previewMap[rule.id]||[];
            const hasWarn=rule._warnings?.some(w=>w.severity==="High");
            return(
              <div key={rule.id} style={{background:"#fff",borderRadius:11,border:`1.5px solid ${hasWarn?"rgba(212,43,43,0.25)":rule.enabled?"rgba(26,122,60,0.15)":"#eee"}`,padding:"13px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
                <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                      <span style={{fontSize:14,fontWeight:700,color:"#111"}}>{rule.name}</span>
                      {hasWarn&&<span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>High Risk</span>}
                      <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:rule.enabled?"rgba(26,122,60,0.1)":"rgba(0,0,0,0.06)",color:rule.enabled?"#1a7a3c":"#888",fontWeight:700}}>{rule.enabled?"Active":"Paused"}</span>
                    </div>
                    <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                      {[
                        {label:"Scope",val:scopeLabel[rule.scope]||rule.scope},
                        {label:"Frequency",val:freqLabel[rule.freq]||rule.freq},
                        {label:"Trigger",val:(RE_TRIGGERS.find(t=>t.key===rule.trigger)||{label:rule.trigger}).label},
                        {label:"Action",val:(RE_ACTIONS.find(a=>a.key===rule.action)||{label:rule.action}).label},
                        {label:"In preview",val:`${preview.length} entities`},
                      ].map(kv=>(
                        <div key={kv.label} style={{fontSize:11,color:"#666"}}><span style={{color:"#aaa"}}>{kv.label}: </span>{kv.val}</div>
                      ))}
                    </div>
                    {rule.notes&&<div style={{fontSize:11,color:"#888",fontStyle:"italic",marginTop:5}}>{rule.notes}</div>}
                  </div>
                  <div style={{display:"flex",gap:6,flexShrink:0}}>
                    <button onClick={()=>onToggle(rule.id)} title={rule.enabled?"Pause":"Enable"} style={{padding:"5px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555"}}><i className={`ti ${rule.enabled?"ti-pause":"ti-play"}`}/></button>
                    <button onClick={()=>onEdit(rule)} title="Edit" style={{padding:"5px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555"}}><i className="ti ti-pencil"/></button>
                    <button onClick={()=>onDuplicate(rule)} title="Duplicate" style={{padding:"5px 8px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555"}}><i className="ti ti-copy"/></button>
                    <button onClick={()=>{if(window.confirm(`Delete "${rule.name}"?`))onDelete(rule.id);}} title="Delete" style={{padding:"5px 8px",borderRadius:6,border:"1px solid rgba(212,43,43,0.2)",background:"rgba(212,43,43,0.04)",cursor:"pointer",fontSize:12,color:"#d42b2b"}}><i className="ti ti-trash"/></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

/* Templates panel */
function RETemplates({onUse}){
  const riskColor={Low:"#1a7a3c",Medium:"#c47a00",High:"#d42b2b"};
  const riskBg={Low:"rgba(26,122,60,0.08)",Medium:"rgba(196,122,0,0.08)",High:"rgba(212,43,43,0.08)"};
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:12}}>
      {RE_TEMPLATES.map(t=>(
        <div key={t.id} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:34,height:34,borderRadius:9,background:`${t.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${t.icon}`} style={{fontSize:16,color:t.color}}/>
            </div>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{t.name}</div>
              <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:riskBg[t.risk],color:riskColor[t.risk],fontWeight:700}}>{t.risk} Risk</span>
            </div>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.5,marginBottom:10}}>{t.purpose}</div>
          <div style={{fontSize:11,color:"#888",background:"#fafafa",borderRadius:7,padding:"8px 10px",marginBottom:12,lineHeight:1.5}}>
            <strong style={{color:"#555"}}>Trigger: </strong>{(RE_TRIGGERS.find(tr=>tr.key===t.trigger.key)||{label:t.trigger.key}).label} {t.trigger.value}{(RE_TRIGGERS.find(tr=>tr.key===t.trigger.key)||{unit:""}).unit}<br/>
            <strong style={{color:"#555"}}>Action: </strong>{(RE_ACTIONS.find(a=>a.key===t.action.key)||{label:t.action.key}).label}{t.action.value?` ${t.action.value}${(RE_ACTIONS.find(a=>a.key===t.action.key)||{unit:""}).unit}`:""}
          </div>
          <div style={{fontSize:11,color:"#888",fontStyle:"italic",marginBottom:12}}>{t.notes}</div>
          <button onClick={()=>onUse(t)} style={{...T.btnR(true),width:"100%",justifyContent:"center",fontSize:12,padding:"8px 0"}}>
            <i className="ti ti-copy" style={{fontSize:12}}/>Use This Template
          </button>
        </div>
      ))}
    </div>
  );
}

/* History panel */
function REHistory({history,onClear}){
  if(history.length===0)return(
    <div style={{textAlign:"center",padding:"40px 0",color:"#aaa"}}>
      <i className="ti ti-history" style={{fontSize:28,display:"block",marginBottom:8}}/>
      <div style={{fontSize:13}}>No automation history yet. Run a preview or activate a rule to start tracking.</div>
    </div>
  );
  const typeStyle={triggered:{color:"#1a7a3c",icon:"ti-check"},failed:{color:"#d42b2b",icon:"ti-x"},paused:{color:"#c47a00",icon:"ti-pause"},override:{color:"#6338c8",icon:"ti-user"}};
  return(
    <div>
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
        <button onClick={onClear} style={{padding:"5px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>Clear History</button>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:6}}>
        {[...history].reverse().map((h,i)=>{const s=typeStyle[h.type]||typeStyle.triggered;return(
          <div key={i} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"10px 14px",background:"#fff",borderRadius:9,border:"1px solid #f5f5f5"}}>
            <i className={`ti ${s.icon}`} style={{fontSize:14,color:s.color,flexShrink:0,marginTop:2}}/>
            <div style={{flex:1}}>
              <div style={{fontSize:12,fontWeight:600,color:"#111",marginBottom:2}}>{h.ruleName}</div>
              <div style={{fontSize:11,color:"#888"}}>{h.detail}</div>
            </div>
            <div style={{fontSize:10,color:"#bbb",flexShrink:0}}>{new Date(h.ts).toLocaleTimeString()}</div>
          </div>
        );})}
      </div>
    </div>
  );
}

/* ── Rules Engine Root ──────────────────────────────────────── */
function RulesEngineModule({globalData,setTab}){
  const[rules,setRulesRaw]=useState(reLoadRules);
  const[history,setHistory]=useState(reLoadHistory);
  const[activeTab,setActiveTab]=useState("overview");
  const[showBuilder,setShowBuilder]=useState(false);
  const[editingRule,setEditingRule]=useState(null);
  const[selectedRule,setSelectedRule]=useState(null);
  const[previewMap,setPreviewMap]=useState({});

  const setRules=updated=>{setRulesRaw(updated);reSaveRules(updated);};
  const addHistory=entry=>{const h=[...history,{...entry,ts:Date.now()}];setHistory(h);reSaveHistory(h);};

  /* Sync from globalData */
  const rows=globalData?.cur?.primary?.rows||globalData?.cur?.bulk?.rows||globalData?.cur?.campaign?.rows||[];
  const cm=globalData?.cur?.primary?.cm||globalData?.cur?.bulk?.cm||globalData?.cur?.campaign?.cm||{};
  const compRows=globalData?.comp?.primary?.rows||globalData?.comp?.bulk?.rows||[];
  const compCm=globalData?.comp?.primary?.cm||globalData?.comp?.bulk?.cm||{};
  const hasData=rows.length>0;

  /* Run previews for all enabled rules on mount/data change */
  useEffect(()=>{
    if(!hasData)return;
    const map={};
    rules.forEach(r=>{
      if(r.enabled){map[r.id]=reEvalRule(r,rows,cm,compRows,compCm);}
    });
    setPreviewMap(map);
    /* Attach safety warnings */
    const updated=rules.map(r=>({...r,_warnings:reSafetyCheck(r,map[r.id]||[])}));
    if(JSON.stringify(updated.map(r=>r._warnings))!==JSON.stringify(rules.map(r=>r._warnings)))setRulesRaw(updated);
  },[hasData,rows.length,rules.length]);

  function handleSaveRule(rule){
    const exists=rules.find(r=>r.id===rule.id);
    const preview=reEvalRule(rule,rows,cm,compRows,compCm);
    const warnings=reSafetyCheck(rule,preview);
    const withMeta={...rule,_warnings:warnings};
    const updated=exists?rules.map(r=>r.id===rule.id?withMeta:r):[...rules,withMeta];
    setRules(updated);
    const newMap={...previewMap,[rule.id]:preview};setPreviewMap(newMap);
    addHistory({type:"triggered",ruleName:rule.name,detail:`Rule ${exists?"updated":"created"}. ${preview.length} entities in preview.`});
    setShowBuilder(false);setEditingRule(null);
    setSelectedRule(withMeta);setActiveTab("preview");
  }

  function handleUseTemplate(t){
    const rule={id:`rule_${Date.now()}`,name:t.name,trigger:t.trigger.key,triggerValue:t.trigger.value,action:t.action.key,actionValue:t.action.value,scope:t.scope||"keyword",freq:t.freq||"manual",minBid:"0.02",maxBid:"",notes:t.notes,enabled:false,createdAt:new Date().toISOString()};
    const preview=reEvalRule(rule,rows,cm,compRows,compCm);
    const warnings=reSafetyCheck(rule,preview);
    const withMeta={...rule,_warnings:warnings};
    setRules([...rules,withMeta]);
    setPreviewMap(p=>({...p,[rule.id]:preview}));
    addHistory({type:"triggered",ruleName:rule.name,detail:`Created from template. Starts paused — review before activating.`});
    setSelectedRule(withMeta);setActiveTab("preview");
  }

  function toggleRule(id){
    const updated=rules.map(r=>r.id===id?{...r,enabled:!r.enabled}:r);
    setRules(updated);
    const r=updated.find(r=>r.id===id);
    addHistory({type:r.enabled?"triggered":"paused",ruleName:r.name,detail:`Rule ${r.enabled?"activated":"paused"} by strategist.`});
  }

  function deleteRule(id){
    const r=rules.find(r=>r.id===id);
    setRules(rules.filter(r=>r.id!==id));
    const nm={...previewMap};delete nm[id];setPreviewMap(nm);
    if(r)addHistory({type:"failed",ruleName:r.name,detail:"Rule deleted by strategist."});
  }

  function duplicateRule(rule){
    const dup={...rule,id:`rule_${Date.now()}`,name:`${rule.name} (copy)`,enabled:false,createdAt:new Date().toISOString()};
    setRules([...rules,dup]);
    addHistory({type:"triggered",ruleName:dup.name,detail:"Rule duplicated. Starts paused."});
  }

  const tabs=[
    {key:"overview",  label:"Overview",  icon:"ti-layout-dashboard"},
    {key:"rules",     label:"My Rules",  icon:"ti-list",badge:rules.length},
    {key:"builder",   label:"Builder",   icon:"ti-plus-circle"},
    {key:"preview",   label:"Preview",   icon:"ti-eye",badge:selectedRule?(previewMap[selectedRule.id]||[]).length:null},
    {key:"templates", label:"Templates", icon:"ti-template"},
    {key:"history",   label:"History",   icon:"ti-history",badge:history.length||null},
  ];

  /* No data fallback */
  if(!hasData&&activeTab!=="builder"&&activeTab!=="templates"&&activeTab!=="history"){
    return(
      <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
        <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
          <i className="ti ti-robot" style={{fontSize:15,color:R}}/>
          <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Rules Engine</span>
          <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(200,120,0,0.1)",color:"#9a5800",fontWeight:700}}>Advanced</span>
        </div>
        <REEmptyState onGoToHub={()=>setTab("hub")}/>
      </div>
    );
  }

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {/* Header */}
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-robot" style={{fontSize:15,color:R}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Rules Engine</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(200,120,0,0.1)",color:"#9a5800",fontWeight:700}}>Advanced</span>
        <div style={{flex:1}}/>
        <button onClick={()=>{setShowBuilder(true);setEditingRule(null);setActiveTab("builder");}} style={{...T.btnR(false),fontSize:12,padding:"7px 16px"}}>
          <i className="ti ti-plus" style={{fontSize:12}}/>New Rule
        </button>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>{setActiveTab(t.key);if(t.key==="builder"){setShowBuilder(true);setEditingRule(null);}}} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?R:"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#4f46e5":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700,minWidth:16,textAlign:"center"}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      {/* Body */}
      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>

        {activeTab==="overview"&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <REOverview rules={rules} history={history} previewMap={previewMap}/>
            {rules.length===0&&(
              <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"32px",textAlign:"center"}}>
                <i className="ti ti-robot" style={{fontSize:32,color:"#ddd",display:"block",marginBottom:12}}/>
                <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:8}}>No rules yet</div>
                <div style={{fontSize:13,color:"#888",marginBottom:18}}>Start with a template or build your first rule from scratch.</div>
                <div style={{display:"flex",gap:10,justifyContent:"center"}}>
                  <button onClick={()=>setActiveTab("templates")} style={{...T.btnR(true),fontSize:12,padding:"9px 18px"}}><i className="ti ti-template" style={{fontSize:13}}/>Browse Templates</button>
                  <button onClick={()=>{setShowBuilder(true);setEditingRule(null);setActiveTab("builder");}} style={{...T.btnR(false),fontSize:12,padding:"9px 18px"}}><i className="ti ti-plus" style={{fontSize:13}}/>Build Custom Rule</button>
                </div>
              </div>
            )}
            {rules.length>0&&(
              <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"18px 20px"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Quick rule status</div>
                <REMonitoringTable rules={rules} previewMap={previewMap} onEdit={r=>{setEditingRule(r);setShowBuilder(true);setActiveTab("builder");}} onToggle={toggleRule} onDelete={deleteRule} onDuplicate={duplicateRule}/>
              </div>
            )}
          </div>
        )}

        {activeTab==="rules"&&(
          <div style={{maxWidth:960,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"18px 20px"}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
              <span style={{fontSize:14,fontWeight:700,color:"#111"}}>All Rules</span>
              <span style={{fontSize:11,color:"#aaa"}}>{rules.length} total</span>
              <div style={{flex:1}}/>
              <button onClick={()=>{setShowBuilder(true);setEditingRule(null);setActiveTab("builder");}} style={{...T.btnR(false),fontSize:11,padding:"6px 14px"}}><i className="ti ti-plus" style={{fontSize:12}}/>New Rule</button>
            </div>
            <REMonitoringTable rules={rules} previewMap={previewMap} onEdit={r=>{setEditingRule(r);setShowBuilder(true);setActiveTab("builder");}} onToggle={toggleRule} onDelete={deleteRule} onDuplicate={duplicateRule}/>
          </div>
        )}

        {activeTab==="builder"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <REBuilder editing={editingRule} onSave={handleSaveRule} onCancel={()=>{setShowBuilder(false);setEditingRule(null);setActiveTab(rules.length>0?"rules":"overview");}}/>
          </div>
        )}

        {activeTab==="preview"&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            {/* Rule selector */}
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 18px",marginBottom:14}}>
              <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>Select a rule to preview</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {rules.map(r=>(
                  <button key={r.id} onClick={()=>setSelectedRule(r)} style={{padding:"6px 12px",borderRadius:8,border:`1.5px solid ${selectedRule?.id===r.id?"#4f46e5":"#e0e0e0"}`,background:selectedRule?.id===r.id?"rgba(79,70,229,0.04)":"#fff",cursor:"pointer",fontSize:12,fontWeight:selectedRule?.id===r.id?700:400,color:selectedRule?.id===r.id?R:"#555"}}>
                    {r.name} <span style={{color:"#aaa",fontSize:11}}>({(previewMap[r.id]||[]).length})</span>
                  </button>
                ))}
              </div>
              {rules.length===0&&<div style={{fontSize:12,color:"#aaa"}}>Create a rule first to preview its impact.</div>}
            </div>

            {selectedRule&&(
              <>
                {/* Safety */}
                <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
                  <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Safety Check — {selectedRule.name}</div>
                  <RESafetyCards warnings={selectedRule._warnings||[]}/>
                </div>
                {/* Preview table */}
                <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px"}}>
                  <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
                    <div style={{fontSize:13,fontWeight:700,color:"#111"}}>Entities affected by "{selectedRule.name}"</div>
                    <div style={{flex:1}}/>
                    <span style={{fontSize:12,color:"#888"}}>{(previewMap[selectedRule.id]||[]).length} entities</span>
                  </div>
                  <REPreviewTable results={previewMap[selectedRule.id]||[]} rule={selectedRule}/>
                </div>
              </>
            )}
          </div>
        )}

        {activeTab==="templates"&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <div style={{fontSize:13,color:"#888",marginBottom:16}}>Start with a proven template. All templates start paused — review the preview before activating.</div>
            <RETemplates onUse={handleUseTemplate}/>
          </div>
        )}

        {activeTab==="history"&&(
          <div style={{maxWidth:860,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"18px 20px"}}>
            <div style={{fontSize:14,fontWeight:700,color:"#111",marginBottom:14}}>Automation History</div>
            <REHistory history={history} onClear={()=>{setHistory([]);reSaveHistory([]);}}/>
          </div>
        )}

      </div>
    </div>
  );
}

/* ================================================================
   SEARCH INTENT AI MODULE
   AI-powered customer intent classification & targeting intelligence.
   Sections: Overview · Intent Table · Opportunities · Behavior
             AI Assistant · Export Actions
   No upload — syncs from Global Data Hub (search term data).
================================================================ */

/* ── Intent classification engine ──────────────────────────── */
const SI_INTENTS=[
  {key:"high_purchase",  label:"High Purchase Intent",  color:"#1a7a3c", bg:"rgba(26,122,60,0.1)",  icon:"ti-shopping-cart",   score:5},
  {key:"branded",        label:"Branded Intent",        color:"#4f46e5", bg:"rgba(79,70,229,0.1)",    icon:"ti-shield",          score:4},
  {key:"competitor",     label:"Competitor Intent",     color:"#1a5fa0", bg:"rgba(26,95,160,0.1)",  icon:"ti-radar",           score:4},
  {key:"ranking",        label:"Ranking Intent",        color:"#6338c8", bg:"rgba(99,56,200,0.1)",  icon:"ti-trending-up",     score:4},
  {key:"research",       label:"Research Intent",       color:"#c47a00", bg:"rgba(196,122,0,0.1)",  icon:"ti-search",          score:3},
  {key:"problem",        label:"Problem/Solution",      color:"#2a6496", bg:"rgba(42,100,150,0.1)", icon:"ti-help-circle",     score:3},
  {key:"weak",           label:"Weak Intent",           color:"#888",    bg:"rgba(0,0,0,0.06)",     icon:"ti-minus-circle",    score:2},
  {key:"waste",          label:"Waste / Dangerous",     color:"#d42b2b", bg:"rgba(212,43,43,0.1)",  icon:"ti-trash",           score:1},
];

/* Classify a single search term using heuristic + performance data */
function siClassify(term, metrics, compMetrics){
  const t = (term||"").toLowerCase().trim();
  const {spend=0,sales=0,orders=0,cvr=0,acos=0,impressions=0,clicks=0,cpc=0} = metrics||{};

  /* Branded signals */
  const brandedPatterns = ["my order","my account","quarred","your brand"];
  if(brandedPatterns.some(p=>t.includes(p))) return "branded";

  /* Competitor signals */
  const competitorSuffixes = ["vs ","alternative","competitor","review","compare","better than","instead of"];
  if(competitorSuffixes.some(p=>t.includes(p))) return "competitor";

  /* Problem/Solution signals */
  const problemWords = ["how to","how do","fix","repair","stop","prevent","help with","solution","problem","issue","treat","remove","get rid"];
  if(problemWords.some(p=>t.includes(p))) return "problem";

  /* Research signals */
  const researchWords = ["best","top","review","which","what is","guide","tips","difference between","pros and cons","types of","list of"];
  if(researchWords.some(p=>t.includes(p))) return "research";

  /* Weak intent signals */
  const weakWords = ["free","cheap","discount","coupon","sale","clearance","used","second hand","diy","homemade","tutorial","learn","how"];
  if(weakWords.some(p=>t.includes(p))){
    if(orders===0 && spend>5) return "waste";
    return "weak";
  }

  /* Performance-based classification */
  if(spend>0 && orders===0 && clicks>=8) return "waste";
  if(orders>0 && acos>0 && acos<30 && impressions<300) return "ranking";
  if(orders>0 && cvr>=3) return "high_purchase";
  if(orders>0 && cvr>=1) return "ranking";
  if(orders===0 && spend>10) return "weak";

  /* Purchase intent words */
  const buyWords = ["buy","order","purchase","shop","deal","price","where to get","for sale","cheap","discount","near me","with free shipping"];
  if(buyWords.some(p=>t.includes(p))) return orders>0?"high_purchase":"weak";

  /* Default: if converting = high purchase, else research */
  return orders>0 ? "high_purchase" : "research";
}

/* Compute intent score (0-100) */
function siIntentScore(term, metrics){
  const {orders=0,cvr=0,acos=0,spend=0,impressions=0} = metrics||{};
  let score = 50;
  if(orders>0) score += 20;
  if(cvr>4) score += 15; else if(cvr>2) score += 8;
  if(acos>0 && acos<20) score += 10; else if(acos>60) score -= 20;
  if(impressions>1000) score += 5;
  if(spend>0 && orders===0 && spend>15) score -= 25;
  const cls = siClassify(term, metrics, null);
  const def = SI_INTENTS.find(i=>i.key===cls);
  if(def) score += (def.score-3)*5;
  return Math.max(0, Math.min(100, Math.round(score)));
}

/* Buyer probability label */
function siBuyerProb(score){
  if(score>=75) return {label:"Very High",color:"#1a7a3c"};
  if(score>=55) return {label:"High",color:"#2a9a50"};
  if(score>=40) return {label:"Medium",color:"#c47a00"};
  if(score>=25) return {label:"Low",color:"#d42b2b"};
  return {label:"Very Low",color:"#888"};
}

/* Build enriched term list from globalData search term rows */
function siProcessTerms(rows, cm, compRows, compCm){
  if(!rows||!cm) return [];
  const compMap={};
  if(compRows&&compCm){
    compRows.forEach(r=>{
      const k=r[compCm.searchTerm||compCm.keyword];
      if(k) compMap[k]=calcRowMetrics(r,compCm);
    });
  }
  return rows.map(row=>{
    const term = row[cm.searchTerm||cm.keyword]||"";
    if(!term) return null;
    const m = calcRowMetrics(row,cm);
    const compM = compMap[term]||null;
    const intent = siClassify(term, m, compM);
    const score = siIntentScore(term, m);
    const prob = siBuyerProb(score);
    return {term, intent, metrics:m, compMetrics:compM, score, prob,
      campaign: row[cm.campaign]||"—",
      matchType: row[cm.matchType]||"—"};
  }).filter(Boolean);
}

/* ── Sub-components ─────────────────────────────────────────── */

function SIEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(99,56,200,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-target" style={{fontSize:26,color:"#6338c8"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Search Intent AI needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:360,lineHeight:1.6,marginBottom:20}}>Upload a Search Term Report in the Data Hub first. This module classifies customer intent from your actual search term performance data.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}>
        <i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub
      </button>
    </div>
  );
}

/* Overview cards */
function SIOverview({terms}){
  if(!terms||terms.length===0) return null;
  const total=terms.length;
  const highPurchase=terms.filter(t=>t.intent==="high_purchase");
  const waste=terms.filter(t=>t.intent==="waste");
  const weak=terms.filter(t=>t.intent==="weak"||t.intent==="waste");
  const branded=terms.filter(t=>t.intent==="branded");
  const ranking=terms.filter(t=>t.intent==="ranking");
  const avgScore=Math.round(terms.reduce((s,t)=>s+t.score,0)/total);
  const highPct=Math.round((highPurchase.length/total)*100);
  const wastePct=Math.round((waste.length/total)*100);
  const brandPct=Math.round((branded.length/total)*100);

  const cards=[
    {label:"High Intent Terms",val:`${highPct}%`,sub:`${highPurchase.length} of ${total}`,icon:"ti-shopping-cart",color:"#1a7a3c"},
    {label:"Waste Traffic",val:`${wastePct}%`,sub:`${waste.length} terms`,icon:"ti-trash",color:"#d42b2b"},
    {label:"Branded Intent",val:`${brandPct}%`,sub:`${branded.length} terms`,icon:"ti-shield",color:"#4f46e5"},
    {label:"Ranking Opps",val:ranking.length,sub:"underexposed converters",icon:"ti-trending-up",color:"#6338c8"},
    {label:"Traffic Quality Score",val:avgScore,sub:"avg intent score",icon:"ti-target",color:"#1a5fa0"},
    {label:"Weak Intent",val:`${Math.round((weak.length/total)*100)}%`,sub:`${weak.length} terms`,icon:"ti-minus-circle",color:"#888"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
      {cards.map(c=>(
        <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
            </div>
            <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
          </div>
          <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:2}}>{c.val}</div>
          <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}

/* Intent distribution bar */
function SIDistBar({terms}){
  if(!terms||!terms.length) return null;
  const total=terms.length;
  const counts={};
  SI_INTENTS.forEach(i=>{counts[i.key]=terms.filter(t=>t.intent===i.key).length;});
  return(
    <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 18px",marginBottom:14}}>
      <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>Intent Distribution</div>
      <div style={{display:"flex",height:10,borderRadius:5,overflow:"hidden",marginBottom:12}}>
        {SI_INTENTS.map(i=>{const pct=(counts[i.key]/total)*100;return pct>0?(
          <div key={i.key} title={`${i.label}: ${counts[i.key]}`} style={{width:`${pct}%`,background:i.color,transition:"width 0.3s"}}/>
        ):null;})}
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
        {SI_INTENTS.filter(i=>counts[i.key]>0).map(i=>(
          <div key={i.key} style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:"#555"}}>
            <span style={{width:8,height:8,borderRadius:2,background:i.color,display:"inline-block"}}/>
            {i.label} <span style={{color:"#aaa"}}>({counts[i.key]})</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* Alert cards for detected intent signals */
function SIAlerts({terms}){
  const alerts=[];

  const wasteTerms=terms.filter(t=>t.intent==="waste"&&t.metrics.spend>10);
  if(wasteTerms.length>0){
    const totalWaste=wasteTerms.reduce((s,t)=>s+t.metrics.spend,0);
    alerts.push({severity:"Critical",type:"Waste Intent Detected",icon:"ti-trash",color:"#d42b2b",bg:"rgba(212,43,43,0.06)",border:"rgba(212,43,43,0.2)",
      explain:`${wasteTerms.length} terms are spending $${totalWaste.toFixed(0)} with zero orders. These search queries show no buying intent and are pure waste.`,
      action:"Add these terms as negative exact matches immediately. Export via the Actions tab.",
      terms:wasteTerms.slice(0,5),confidence:94});
  }

  const highUnscaled=terms.filter(t=>t.intent==="high_purchase"&&t.metrics.impressions<500&&t.metrics.orders>0);
  if(highUnscaled.length>0){
    alerts.push({severity:"High",type:"High-Intent Terms Under-Exposed",icon:"ti-shopping-cart",color:"#1a7a3c",bg:"rgba(26,122,60,0.06)",border:"rgba(26,122,60,0.2)",
      explain:`${highUnscaled.length} high purchase intent terms are getting fewer than 500 impressions despite converting. These buyers are ready to purchase but your ads aren't reaching them.`,
      action:"Increase bids on these exact keywords. Consider adding as exact match to dedicated campaigns.",
      terms:highUnscaled.slice(0,5),confidence:88});
  }

  const rankingOpps=terms.filter(t=>t.intent==="ranking"&&t.metrics.acos<30&&t.metrics.orders>0);
  if(rankingOpps.length>0){
    alerts.push({severity:"High",type:"Ranking Intent Opportunities",icon:"ti-trending-up",color:"#6338c8",bg:"rgba(99,56,200,0.06)",border:"rgba(99,56,200,0.2)",
      explain:`${rankingOpps.length} terms show ranking intent — they convert at low ACoS but have limited visibility. Investing here improves both PPC and organic rank simultaneously.`,
      action:"Scale bids on these terms. Add to exact match ranking campaigns with TOS bid modifiers.",
      terms:rankingOpps.slice(0,5),confidence:82});
  }

  const competitorTerms=terms.filter(t=>t.intent==="competitor"&&t.metrics.cvr>1);
  if(competitorTerms.length>0){
    alerts.push({severity:"Medium",type:"Competitor Conquesting Opportunity",icon:"ti-radar",color:"#1a5fa0",bg:"rgba(26,95,160,0.06)",border:"rgba(26,95,160,0.2)",
      explain:`${competitorTerms.length} competitor-intent terms are converting. Customers searching competitor brands and clicking your ads are high-quality conquesting traffic.`,
      action:"Isolate in dedicated conquesting campaigns. Use Sponsored Brands for brand awareness alongside.",
      terms:competitorTerms.slice(0,5),confidence:75});
  }

  const brandedLow=terms.filter(t=>t.intent==="branded"&&t.metrics.impressions<200);
  if(brandedLow.length>0){
    alerts.push({severity:"Medium",type:"Branded Intent Under-Protected",icon:"ti-shield",color:"#4f46e5",bg:"rgba(79,70,229,0.06)",border:"rgba(79,70,229,0.2)",
      explain:`${brandedLow.length} branded terms have low impression share. Competitors may be conquesting your brand traffic.`,
      action:"Increase bids on branded terms. Ensure brand campaigns have sufficient budget.",
      terms:brandedLow.slice(0,5),confidence:79});
  }

  if(alerts.length===0) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No critical intent issues detected. Your traffic quality looks healthy.</span>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {alerts.map((a,i)=>(
        <div key={i} style={{background:a.bg,borderRadius:12,border:`1px solid ${a.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <i className={`ti ${a.icon}`} style={{fontSize:14,color:a.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:a.color}}>{a.severity} — {a.type}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Confidence: {a.confidence}%</span>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{a.explain}</div>
          <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px",marginBottom:8}}>
            <i className="ti ti-bulb" style={{fontSize:11,marginRight:5,color:"#c47a00"}}/>
            <strong>Action: </strong>{a.action}
          </div>
          {a.terms&&a.terms.length>0&&(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {a.terms.map((t,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(255,255,255,0.7)",border:`1px solid ${a.border}`,color:a.color,fontWeight:600}}>{t.term}</span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/* Main intent table */
function SITable({terms, onExport}){
  const[filter,setFilter]=useState("all");
  const[sort,setSort]=useState("score");
  const[search,setSearch]=useState("");

  const filtered=terms.filter(t=>{
    if(filter!=="all"&&t.intent!==filter)return false;
    if(search&&!t.term.toLowerCase().includes(search.toLowerCase()))return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="score")return b.score-a.score;
    if(sort==="spend")return b.metrics.spend-a.metrics.spend;
    if(sort==="acos"){const aA=a.metrics.acos||999,aB=b.metrics.acos||999;return aA-aB;}
    if(sort==="cvr")return b.metrics.cvr-a.metrics.cvr;
    if(sort==="orders")return b.metrics.orders-a.metrics.orders;
    if(sort==="term")return a.term.localeCompare(b.term);
    return 0;
  });

  const intentDef=(key)=>SI_INTENTS.find(i=>i.key===key)||SI_INTENTS[6];

  function suggestedAction(t){
    if(t.intent==="waste") return "Negate";
    if(t.intent==="high_purchase"&&t.metrics.impressions<500) return "Scale bids";
    if(t.intent==="ranking") return "Increase bids";
    if(t.intent==="branded") return "Protect";
    if(t.intent==="competitor") return "Conquer";
    if(t.intent==="weak") return "Monitor";
    if(t.intent==="research") return "Awareness";
    return "Review";
  }

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search terms..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:200}}/>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {[{key:"all",label:"All"},...SI_INTENTS.map(i=>({key:i.key,label:i.label}))].map(f=>(
            <button key={f.key} onClick={()=>setFilter(f.key)} style={{padding:"4px 10px",borderRadius:14,border:`1px solid ${filter===f.key?"#4f46e5":"#e0e0e0"}`,background:filter===f.key?"#4f46e5":"#fff",color:filter===f.key?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer"}}>{f.label}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="score">Sort: Intent Score</option>
          <option value="spend">Sort: Spend</option>
          <option value="acos">Sort: ACoS</option>
          <option value="cvr">Sort: CVR</option>
          <option value="orders">Sort: Orders</option>
          <option value="term">Sort: Term</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}>
          <i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})
        </button>
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Search Term","Intent","Score","Buyer Prob.","Spend","Sales","ACoS","CPC","CVR","Orders","Action"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,200).map((t,i)=>{
              const def=intentDef(t.intent);
              const m=t.metrics; const cm2=t.compMetrics;
              const acosColor=m.acos>60?"#d42b2b":m.acos>30?"#c47a00":"#111";
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={t.term}>{t.term}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:10,padding:"2px 7px",borderRadius:4,background:def.bg,color:def.color,fontWeight:700,whiteSpace:"nowrap"}}>
                      <i className={`ti ${def.icon}`} style={{fontSize:10}}/>{def.label}
                    </span>
                  </td>
                  <td style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <div style={{width:36,height:6,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
                        <div style={{width:`${t.score}%`,height:"100%",background:t.score>=70?"#1a7a3c":t.score>=40?"#c47a00":"#d42b2b"}}/>
                      </div>
                      <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{t.score}</span>
                    </div>
                  </td>
                  <td style={{padding:"8px 10px"}}><span style={{fontSize:11,fontWeight:700,color:t.prob.color}}>{t.prob.label}</span></td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.spend.toFixed(2)}{cm2&&<div style={{fontSize:10,color:m.spend>cm2.spend?"#d42b2b":"#1a7a3c"}}>{m.spend>cm2.spend?"+":""}{(m.spend-cm2.spend).toFixed(2)}</div>}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.sales.toFixed(2)}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:acosColor}}>{m.spend>0&&m.acos>0?`${m.acos.toFixed(1)}%`:"—"}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.cpc.toFixed(2)}</td>
                  <td style={{padding:"8px 10px",color:m.cvr>3?"#1a7a3c":"#555"}}>{m.cvr.toFixed(1)}%</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:m.orders>0?"#1a7a3c":"#555"}}>{m.orders}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:t.intent==="waste"?"rgba(212,43,43,0.1)":t.intent==="high_purchase"?"rgba(26,122,60,0.1)":t.intent==="ranking"?"rgba(99,56,200,0.1)":"rgba(0,0,0,0.06)",color:t.intent==="waste"?"#d42b2b":t.intent==="high_purchase"?"#1a7a3c":t.intent==="ranking"?"#6338c8":"#555",fontWeight:600}}>
                      {suggestedAction(t)}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>200&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 200 of {sorted.length} terms</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No terms match this filter.</div>}
      </div>
    </div>
  );
}

/* Strategic opportunities */
function SIOpportunities({terms}){
  const opps=[
    {
      title:"Scale High-Intent Traffic",icon:"ti-rocket",color:"#1a7a3c",
      items:terms.filter(t=>t.intent==="high_purchase"&&t.metrics.impressions<800&&t.metrics.orders>0).slice(0,8),
      why:"These terms show strong purchase intent but low impression share. Increasing bids will capture more ready-to-buy customers.",
      action:"Increase bids 20–35%. Add as exact match if not already targeted.",
      impact:"Expected ACoS improvement + sales lift with controlled spend"
    },
    {
      title:"Negate Waste Intent Traffic",icon:"ti-ban",color:"#d42b2b",
      items:terms.filter(t=>t.intent==="waste"&&t.metrics.spend>8).slice(0,8),
      why:"These terms are consuming budget with zero buying signal. Every dollar spent here is a dollar not spent on converters.",
      action:"Add all as negative exact matches. Review phrase-level negation for common patterns.",
      impact:"Immediate spend recovery. Freed budget reallocated to high-intent terms."
    },
    {
      title:"Ranking Intent — Organic Boost",icon:"ti-trending-up",color:"#6338c8",
      items:terms.filter(t=>t.intent==="ranking"&&t.metrics.acos<35).slice(0,8),
      why:"These converting terms have limited visibility. Scaling PPC here improves organic rank simultaneously.",
      action:"Scale bids. Add TOS bid modifier +30–50%. Isolate in dedicated ranking campaigns.",
      impact:"Organic rank improvement + reduced long-term PPC dependency."
    },
    {
      title:"Competitor Conquesting",icon:"ti-radar",color:"#1a5fa0",
      items:terms.filter(t=>t.intent==="competitor"&&t.metrics.cvr>0.5).slice(0,8),
      why:"Customers searching competitor names and converting on your ads show strong switch intent.",
      action:"Isolate in Sponsored Brands conquesting campaigns. Increase bids aggressively.",
      impact:"Market share gain. Premium placement against competitor brand terms."
    },
    {
      title:"Branded Protection",icon:"ti-shield",color:"#4f46e5",
      items:terms.filter(t=>t.intent==="branded"&&t.metrics.impressions<300).slice(0,8),
      why:"Your branded terms have low impression share. Competitors may be stealing branded traffic.",
      action:"Max bids on branded exact match. Ensure branded campaign has uncapped budget.",
      impact:"Protect branded conversion traffic. Prevent competitor conquesting on your brand."
    },
    {
      title:"Research Funnel — Awareness",icon:"ti-search",color:"#c47a00",
      items:terms.filter(t=>t.intent==="research"&&t.metrics.impressions>200&&t.metrics.cvr>0.5).slice(0,8),
      why:"Research terms that convert despite informational intent are high-value awareness traffic worth retaining.",
      action:"Keep in broad/phrase. Lower bid slightly if ACoS is high. Don't negate converting research terms.",
      impact:"Top-of-funnel brand awareness that occasionally converts."
    },
  ];
  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {opps.map((opp,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:`1px solid rgba(0,0,0,0.06)`,padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:32,height:32,borderRadius:9,background:`${opp.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${opp.icon}`} style={{fontSize:15,color:opp.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{opp.title}</div>
            <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{opp.items.length} terms</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{opp.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Recommended action:</strong><br/>{opp.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Expected impact:</strong><br/>{opp.impact}</div>
          </div>
          {opp.items.length>0&&(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {opp.items.map((t,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${opp.color}10`,color:opp.color,fontWeight:600,border:`1px solid ${opp.color}30`}}>{t.term}</span>
              ))}
            </div>
          )}
          {opp.items.length===0&&<div style={{fontSize:11,color:"#bbb",fontStyle:"italic"}}>No terms match this opportunity with current data.</div>}
        </div>
      ))}
    </div>
  );
}

/* AI assistant panel */
function SIAssistant({terms}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  const wasteTerms=terms.filter(t=>t.intent==="waste");
  const highTerms=terms.filter(t=>t.intent==="high_purchase");
  const rankTerms=terms.filter(t=>t.intent==="ranking");
  const avgScore=terms.length?Math.round(terms.reduce((s,t)=>s+t.score,0)/terms.length):0;
  const totalWasteSpend=wasteTerms.reduce((s,t)=>s+t.metrics.spend,0);
  const totalHighSales=highTerms.reduce((s,t)=>s+t.metrics.sales,0);

  async function runAnalysis(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);
    const prompt=`You are a senior Amazon PPC strategist analysing search intent data. Based ONLY on the data below, give 5 strategic insights about traffic quality and intent optimisation. Be specific and data-driven.

DATA:
- Total search terms: ${terms.length}
- High purchase intent terms: ${highTerms.length} (generating $${totalHighSales.toFixed(0)} sales)
- Waste intent terms: ${wasteTerms.length} (wasting $${totalWasteSpend.toFixed(0)} spend)
- Ranking intent terms: ${rankTerms.length}
- Average traffic quality score: ${avgScore}/100
- Competitor intent terms: ${terms.filter(t=>t.intent==="competitor").length}
- Branded intent terms: ${terms.filter(t=>t.intent==="branded").length}
- Research intent terms: ${terms.filter(t=>t.intent==="research").length}
- Top waste terms: ${wasteTerms.slice(0,5).map(t=>t.term).join(", ")}
- Top high-intent terms: ${highTerms.slice(0,5).map(t=>t.term).join(", ")}

Respond in JSON format ONLY (no markdown, no backticks):
{"insights":[{"title":"...","explanation":"...","action":"...","priority":"Critical|High|Medium"}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.3,maxOutputTokens:1200}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const clean=text.replace(/```json|```/g,"").trim();
      const parsed=JSON.parse(clean);
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key and try again."});}
    setLoading(false);
  }

  const prioColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#1a5fa0"};
  return(
    <div style={{maxWidth:800}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>AI Intent Analysis (Gemini)</div>
        <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analysing...</>:<><i className="ti ti-brain" style={{fontSize:13}}/>Analyse Intent</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Key stays in memory only — never saved. Get a free key at aistudio.google.com/app/apikey</div>
      </div>

      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b",marginBottom:12}}>{result.error}</div>}

      {result?.insights&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.insights.map((ins,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:`${prioColor[ins.priority]||"#888"}18`,color:prioColor[ins.priority]||"#888",fontWeight:700}}>{ins.priority}</span>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{ins.title}</span>
              </div>
              <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{ins.explanation}</div>
              <div style={{fontSize:11,background:"#fafafa",borderRadius:7,padding:"7px 10px",color:"#444"}}>
                <i className="ti ti-arrow-right" style={{fontSize:11,marginRight:5,color:"#6338c8"}}/><strong>Action: </strong>{ins.action}
              </div>
            </div>
          ))}
        </div>
      )}

      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"24px",textAlign:"center"}}>
          <i className="ti ti-brain" style={{fontSize:28,color:"#ddd",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,color:"#aaa"}}>Enter your Gemini API key above and click Analyse Intent.<br/>AI will explain buyer behaviour patterns from your actual data.</div>
        </div>
      )}
    </div>
  );
}

/* Export handler */
function siExport(terms, type="all"){
  const filtered=type==="waste"?terms.filter(t=>t.intent==="waste"):
    type==="scale"?terms.filter(t=>t.intent==="high_purchase"||t.intent==="ranking"):
    type==="branded"?terms.filter(t=>t.intent==="branded"):
    type==="competitor"?terms.filter(t=>t.intent==="competitor"):terms;

  const rows=filtered.map(t=>({
    "Search Term":t.term,"Intent Type":(SI_INTENTS.find(i=>i.key===t.intent)||{label:t.intent}).label,
    "Intent Score":t.score,"Buyer Probability":t.prob.label,
    "Campaign":t.campaign,"Match Type":t.matchType,
    "Spend":t.metrics.spend.toFixed(2),"Sales":t.metrics.sales.toFixed(2),
    "ACoS":t.metrics.acos.toFixed(1),"CPC":t.metrics.cpc.toFixed(2),
    "CVR":t.metrics.cvr.toFixed(1),"Orders":t.metrics.orders,
    "Impressions":t.metrics.impressions,"Clicks":t.metrics.clicks,
    "Suggested Action":type==="waste"?"Negate Exact":type==="scale"?"Scale Bids":type==="branded"?"Protect":type==="competitor"?"Conquer":"Review"
  }));
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]||{}).map(()=>({wch:22}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Intent Analysis");
  XLSX.writeFile(wb,`search_intent_${type}_${Date.now()}.xlsx`);
}

/* ── Search Intent AI Module Root ───────────────────────────── */
function SearchIntentModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("overview");

  /* Sync from globalData search term data */
  const rows=globalData?.cur?.searchterm?.rows||globalData?.cur?.primary?.rows||[];
  const cm=globalData?.cur?.searchterm?.cm||globalData?.cur?.primary?.cm||{};
  const compRows=globalData?.comp?.searchterm?.rows||globalData?.comp?.primary?.rows||[];
  const compCm=globalData?.comp?.searchterm?.cm||globalData?.comp?.primary?.cm||{};
  const hasData=rows.length>0&&(cm.searchTerm||cm.keyword);

  const terms=useMemo(()=>hasData?siProcessTerms(rows,cm,compRows,compCm):[],[rows,cm,hasData]);

  const tabs=[
    {key:"overview",     label:"Overview",     icon:"ti-layout-dashboard"},
    {key:"alerts",       label:"Alerts",       icon:"ti-alert-circle",  badge:hasData?terms.filter(t=>t.intent==="waste"&&t.metrics.spend>10).length||null:null},
    {key:"table",        label:"Intent Table", icon:"ti-table",         badge:hasData?terms.length:null},
    {key:"opportunities",label:"Opportunities",icon:"ti-rocket"},
    {key:"ai",           label:"AI Analysis",  icon:"ti-brain"},
    {key:"export",       label:"Export",       icon:"ti-download"},
  ];

  if(!hasData){
    return(
      <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
        <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
          <i className="ti ti-target" style={{fontSize:15,color:"#6338c8"}}/>
          <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Search Intent AI</span>
          <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(99,56,200,0.1)",color:"#6338c8",fontWeight:700}}>AI</span>
        </div>
        <SIEmptyState onGoToHub={()=>setTab("hub")}/>
      </div>
    );
  }

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {/* Header */}
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-target" style={{fontSize:15,color:"#6338c8"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Search Intent AI</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(99,56,200,0.1)",color:"#6338c8",fontWeight:700}}>AI</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{terms.length} terms analysed</span>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#6338c8":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#6338c8":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#6338c8":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      {/* Body */}
      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>

        {activeTab==="overview"&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <SIOverview terms={terms}/>
            <SIDistBar terms={terms}/>
          </div>
        )}

        {activeTab==="alerts"&&(
          <div style={{maxWidth:860,margin:"0 auto"}}>
            <SIAlerts terms={terms}/>
          </div>
        )}

        {activeTab==="table"&&(
          <div style={{maxWidth:1100,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}>
            <SITable terms={terms} onExport={t=>siExport(t,"all")}/>
          </div>
        )}

        {activeTab==="opportunities"&&(
          <div style={{maxWidth:900,margin:"0 auto"}}>
            <SIOpportunities terms={terms}/>
          </div>
        )}

        {activeTab==="ai"&&(
          <div style={{maxWidth:860,margin:"0 auto"}}>
            <SIAssistant terms={terms}/>
          </div>
        )}

        {activeTab==="export"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Export Intent Actions</div>
              <div style={{fontSize:12,color:"#888",marginBottom:20}}>Export strategist-ready sheets for each intent type. Each file includes term, intent classification, metrics, and recommended action.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {type:"all",    label:"Full Intent Report",    icon:"ti-table",         color:"#555",  count:terms.length,            desc:"All terms with intent classification"},
                  {type:"waste",  label:"Negation List",          icon:"ti-ban",           color:"#d42b2b",count:terms.filter(t=>t.intent==="waste").length, desc:"Waste intent — ready to negate"},
                  {type:"scale",  label:"Scaling Opportunities",  icon:"ti-rocket",        color:"#1a7a3c",count:terms.filter(t=>["high_purchase","ranking"].includes(t.intent)).length, desc:"High intent + ranking terms"},
                  {type:"branded",label:"Branded Terms",          icon:"ti-shield",        color:"#4f46e5",count:terms.filter(t=>t.intent==="branded").length, desc:"Branded intent protection list"},
                  {type:"competitor",label:"Competitor Terms",    icon:"ti-radar",         color:"#1a5fa0",count:terms.filter(t=>t.intent==="competitor").length, desc:"Conquesting opportunities"},
                ].map(ex=>(
                  <div key={ex.type} style={{background:"#fafafa",borderRadius:10,border:"1px solid #eee",padding:"14px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
                      <div style={{width:30,height:30,borderRadius:8,background:`${ex.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${ex.icon}`} style={{fontSize:14,color:ex.color}}/>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ex.label}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{ex.count} terms</div>
                      </div>
                    </div>
                    <div style={{fontSize:11,color:"#888",marginBottom:10}}>{ex.desc}</div>
                    <button onClick={()=>siExport(terms,ex.type)} disabled={ex.count===0} style={{...T.btnR(ex.count>0),width:"100%",justifyContent:"center",fontSize:11,padding:"7px 0",opacity:ex.count===0?0.4:1}}>
                      <i className="ti ti-download" style={{fontSize:12}}/>Download ({ex.count})
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

/* ================================================================
   BLEEDER CHECK MODULE
   Emergency waste-detection system for Amazon PPC strategists.
   Sections: Overview · Alerts · Bleeder Table · Recovery Engine
             Trend Analysis · AI Assistant · Export Actions
   No upload — syncs from Global Data Hub.
================================================================ */

/* ── Bleed scoring helpers ──────────────────────────────────── */
function bcWasteScore(m){
  /* 0–100: higher = more wasteful */
  let s=0;
  if(m.spend>0&&m.orders===0){s+=50;if(m.spend>30)s+=20;if(m.clicks>=10)s+=10;}
  if(m.acos>80)s+=20;else if(m.acos>50)s+=10;
  if(m.cvr<0.5&&m.clicks>10)s+=15;
  if(m.cpc>3)s+=5;
  return Math.min(100,Math.round(s));
}

function bcSeverity(score){
  if(score>=70)return{label:"Critical",color:"#d42b2b",bg:"rgba(212,43,43,0.08)",border:"rgba(212,43,43,0.2)",icon:"ti-alert-octagon"};
  if(score>=45)return{label:"High",color:"#c47a00",bg:"rgba(196,122,0,0.08)",border:"rgba(196,122,0,0.2)",icon:"ti-alert-triangle"};
  if(score>=20)return{label:"Medium",color:"#1a5fa0",bg:"rgba(26,95,160,0.08)",border:"rgba(26,95,160,0.2)",icon:"ti-alert-circle"};
  return{label:"Low",color:"#888",bg:"rgba(0,0,0,0.04)",border:"#e0e0e0",icon:"ti-info-circle"};
}

function bcAction(entity){
  if(entity.wasteScore>=70&&entity.metrics.orders===0) return "Pause / Negate";
  if(entity.metrics.acos>80) return "Reduce bid -30%";
  if(entity.metrics.cvr<0.5&&entity.metrics.clicks>15) return "Reduce bid -20%";
  if(entity.metrics.cpc>3&&entity.metrics.orders===0) return "Cut CPC";
  return "Monitor";
}

function bcDelta(cur,comp,key){
  if(!comp||comp[key]==null) return null;
  return cur[key]-comp[key];
}

/* Build enriched bleeder rows from campaign or keyword data */
function bcProcessRows(rows, cm, compRows, compCm, entityType){
  if(!rows||!cm) return [];
  const compMap={};
  if(compRows&&compCm){
    compRows.forEach(r=>{
      const k=r[compCm.campaign]||r[compCm.keyword]||r[compCm.searchTerm];
      if(k) compMap[k]=calcRowMetrics(r,compCm);
    });
  }
  return rows.map(row=>{
    const name=row[cm.campaign]||row[cm.keyword]||row[cm.searchTerm]||"Unknown";
    const m=calcRowMetrics(row,cm);
    if(m.spend<1&&m.impressions<10) return null;
    const compM=compMap[name]||null;
    const wasteScore=bcWasteScore(m);
    const sev=bcSeverity(wasteScore);
    return{name,entityType,metrics:m,compMetrics:compM,wasteScore,severity:sev,campaign:row[cm.campaign]||"—",matchType:row[cm.matchType]||"—"};
  }).filter(Boolean).sort((a,b)=>b.wasteScore-a.wasteScore);
}

/* ── Sub-components ─────────────────────────────────────────── */
function BCEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(212,43,43,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-droplet-off" style={{fontSize:26,color:"#d42b2b"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Bleeder Check needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:360,lineHeight:1.6,marginBottom:20}}>Upload a Campaign Report or Bulk File in the Data Hub. Bleeder Check analyses spend efficiency across all campaigns and keywords.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Overview KPI cards */
function BCOverview({entities,compEntities}){
  const critical=entities.filter(e=>e.severity.label==="Critical");
  const high=entities.filter(e=>e.severity.label==="High");
  const totalWaste=entities.filter(e=>e.metrics.orders===0).reduce((s,e)=>s+e.metrics.spend,0);
  const totalSpend=entities.reduce((s,e)=>s+e.metrics.spend,0);
  const avgAcos=entities.filter(e=>e.metrics.acos>0).length?entities.filter(e=>e.metrics.acos>0).reduce((s,e)=>s+e.metrics.acos,0)/entities.filter(e=>e.metrics.acos>0).length:0;
  const cpcInflated=entities.filter(e=>e.compMetrics&&e.metrics.cpc>e.compMetrics.cpc*1.3).length;
  const cvrDeclined=entities.filter(e=>e.compMetrics&&e.compMetrics.cvr>0&&e.metrics.cvr<e.compMetrics.cvr*0.7).length;
  const riskScore=Math.min(100,Math.round((critical.length*15)+(high.length*7)+(totalWaste/Math.max(totalSpend,1)*50)));

  const cards=[
    {label:"Total Waste Spend",val:`$${totalWaste.toFixed(0)}`,sub:"spend with zero orders",icon:"ti-cash",color:"#d42b2b"},
    {label:"Critical Bleeders",val:critical.length,sub:"require immediate action",icon:"ti-alert-octagon",color:"#d42b2b"},
    {label:"High Risk Entities",val:high.length,sub:"deteriorating fast",icon:"ti-alert-triangle",color:"#c47a00"},
    {label:"CPC Inflated",val:cpcInflated,sub:"vs previous period",icon:"ti-trending-up",color:"#4f46e5"},
    {label:"CVR Declined",val:cvrDeclined,sub:"conversion rate drop",icon:"ti-trending-down",color:"#c47a00"},
    {label:"Emergency Risk Score",val:riskScore,sub:riskScore>=70?"Critical":riskScore>=40?"High":"Stable",icon:"ti-thermometer",color:riskScore>=70?"#d42b2b":riskScore>=40?"#c47a00":"#1a7a3c"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
      {cards.map(c=>(
        <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
            </div>
            <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
          </div>
          <div style={{fontSize:22,fontWeight:800,color:c.color,marginBottom:2}}>{c.val}</div>
          <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}

/* Emergency alert cards */
function BCAlerts({entities}){
  const alerts=[];

  const criticalLeaks=entities.filter(e=>e.metrics.orders===0&&e.metrics.spend>25);
  if(criticalLeaks.length){
    const total=criticalLeaks.reduce((s,e)=>s+e.metrics.spend,0);
    alerts.push({sev:"Critical",type:"Critical Spend Leak",icon:"ti-droplet",color:"#d42b2b",bg:"rgba(212,43,43,0.06)",border:"rgba(212,43,43,0.2)",
      explain:`${criticalLeaks.length} entities are spending $${total.toFixed(0)} total with zero orders. These are confirmed spend leaks with no return on investment.`,
      action:"Pause immediately or negate at keyword level. Review targeting — these may be mismatched audiences.",
      savings:`$${total.toFixed(0)} recoverable`,items:criticalLeaks.slice(0,5),confidence:97});
  }

  const cpcBombs=entities.filter(e=>e.compMetrics&&e.metrics.cpc>e.compMetrics.cpc*1.4&&e.metrics.orders===0);
  if(cpcBombs.length){
    alerts.push({sev:"Critical",type:"CPC Explosion — No Conversion",icon:"ti-trending-up",color:"#4f46e5",bg:"rgba(79,70,229,0.06)",border:"rgba(79,70,229,0.2)",
      explain:`${cpcBombs.length} entities have CPC inflated 40%+ vs previous period and still zero orders. You're paying more for traffic that doesn't convert.`,
      action:"Reduce bids 25–40% immediately. Add spend cap per entity. Investigate search term match quality.",
      savings:"CPC reduction + waste prevention",items:cpcBombs.slice(0,5),confidence:91});
  }

  const cvrCollapse=entities.filter(e=>e.compMetrics&&e.compMetrics.cvr>1&&e.metrics.cvr<e.compMetrics.cvr*0.5&&e.metrics.spend>15);
  if(cvrCollapse.length){
    alerts.push({sev:"High",type:"Conversion Rate Collapse",icon:"ti-trending-down",color:"#c47a00",bg:"rgba(196,122,0,0.06)",border:"rgba(196,122,0,0.2)",
      explain:`${cvrCollapse.length} entities lost 50%+ CVR vs previous period while still spending. Something changed — listing issue, price change, Buy Box loss, or poor match.`,
      action:"Check listing quality, Buy Box status, and pricing. Reduce bids until root cause is found.",
      savings:"Prevent compounding CVR damage",items:cvrCollapse.slice(0,5),confidence:85});
  }

  const highAcos=entities.filter(e=>e.metrics.acos>80&&e.metrics.spend>15);
  if(highAcos.length){
    const totalOverSpend=highAcos.reduce((s,e)=>s+e.metrics.spend*(1-30/e.metrics.acos),0);
    alerts.push({sev:"High",type:"High ACoS Bleed",icon:"ti-percentage",color:"#c47a00",bg:"rgba(196,122,0,0.06)",border:"rgba(196,122,0,0.2)",
      explain:`${highAcos.length} entities running above 80% ACoS. These campaigns are spending significantly more than they earn back.`,
      action:"Reduce bids by 20–35%. Set ACoS target rule. Isolate in separate campaign for tighter control.",
      savings:`~$${Math.max(0,totalOverSpend).toFixed(0)} overspend reduction`,items:highAcos.slice(0,5),confidence:88});
  }

  const slowLeaks=entities.filter(e=>e.metrics.spend>5&&e.metrics.spend<20&&e.metrics.orders===0&&e.metrics.clicks>5);
  if(slowLeaks.length){
    const total=slowLeaks.reduce((s,e)=>s+e.metrics.spend,0);
    alerts.push({sev:"Medium",type:"Hidden Slow Spend Leaks",icon:"ti-eye-off",color:"#1a5fa0",bg:"rgba(26,95,160,0.06)",border:"rgba(26,95,160,0.2)",
      explain:`${slowLeaks.length} entities are draining small amounts ($5–$20 each) with no orders. These are easy to miss but add up to $${total.toFixed(0)} total.`,
      action:"Review and negate at keyword level. Low individual spend makes these invisible in campaign-level views.",
      savings:`$${total.toFixed(0)} recoverable`,items:slowLeaks.slice(0,5),confidence:82});
  }

  if(!alerts.length) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No critical bleeders detected with current data thresholds.</span>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {alerts.map((a,i)=>(
        <div key={i} style={{background:a.bg,borderRadius:12,border:`1px solid ${a.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <i className={`ti ${a.icon}`} style={{fontSize:14,color:a.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:a.color}}>{a.sev} — {a.type}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Confidence: {a.confidence}%</span>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{a.explain}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
            <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"6px 10px"}}>
              <i className="ti ti-bulb" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>
              <strong>Action: </strong>{a.action}
            </div>
            <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"6px 10px"}}>
              <i className="ti ti-coin" style={{fontSize:11,marginRight:4,color:"#1a7a3c"}}/>
              <strong>Est. savings: </strong>{a.savings}
            </div>
          </div>
          {a.items&&a.items.length>0&&(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {a.items.map((e,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(255,255,255,0.7)",border:`1px solid ${a.border}`,color:a.color,fontWeight:600,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/* Bleeder analysis table */
function BCTable({entities,onExport}){
  const[filter,setFilter]=useState("all");
  const[sort,setSort]=useState("waste");
  const[search,setSearch]=useState("");
  const[typeFilter,setTypeFilter]=useState("all");

  const filtered=entities.filter(e=>{
    if(filter!=="all"&&e.severity.label.toLowerCase()!==filter)return false;
    if(typeFilter!=="all"&&e.entityType!==typeFilter)return false;
    if(search&&!e.name.toLowerCase().includes(search.toLowerCase()))return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="waste")return b.wasteScore-a.wasteScore;
    if(sort==="spend")return b.metrics.spend-a.metrics.spend;
    if(sort==="acos"){const aA=a.metrics.acos||999,aB=b.metrics.acos||999;return aA-aB;}
    if(sort==="cpc")return b.metrics.cpc-a.metrics.cpc;
    return 0;
  });

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search entities..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:190}}/>
        <div style={{display:"flex",gap:4}}>
          {["all","critical","high","medium","low"].map(f=>(
            <button key={f} onClick={()=>setFilter(f)} style={{padding:"4px 10px",borderRadius:14,border:`1px solid ${filter===f?"#4f46e5":"#e0e0e0"}`,background:filter===f?"#4f46e5":"#fff",color:filter===f?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer",textTransform:"capitalize"}}>{f}</button>
          ))}
        </div>
        <div style={{display:"flex",gap:4}}>
          {["all","campaign","keyword","searchterm"].map(t=>(
            <button key={t} onClick={()=>setTypeFilter(t)} style={{padding:"4px 10px",borderRadius:14,border:`1px solid ${typeFilter===t?"#1a5fa0":"#e0e0e0"}`,background:typeFilter===t?"#1a5fa0":"#fff",color:typeFilter===t?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer",textTransform:"capitalize"}}>{t}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="waste">Sort: Waste Score</option>
          <option value="spend">Sort: Spend</option>
          <option value="acos">Sort: ACoS</option>
          <option value="cpc">Sort: CPC</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}><i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})</button>
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Entity","Type","Waste Score","Severity","Spend","Sales","ACoS","CPC","CVR","Orders","Action"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,150).map((e,i)=>{
              const m=e.metrics; const c=e.compMetrics;
              const acosCol=m.acos>80?"#d42b2b":m.acos>40?"#c47a00":"#111";
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={e.name}>{e.name}</td>
                  <td style={{padding:"8px 10px"}}><span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:"rgba(0,0,0,0.06)",color:"#555",fontWeight:600,textTransform:"capitalize"}}>{e.entityType}</span></td>
                  <td style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <div style={{width:36,height:6,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
                        <div style={{width:`${e.wasteScore}%`,height:"100%",background:e.wasteScore>=70?"#d42b2b":e.wasteScore>=45?"#c47a00":"#1a7a3c"}}/>
                      </div>
                      <span style={{fontSize:11,fontWeight:700,color:e.severity.color}}>{e.wasteScore}</span>
                    </div>
                  </td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:e.severity.bg,color:e.severity.color,fontWeight:700,border:`1px solid ${e.severity.border}`}}>{e.severity.label}</span>
                  </td>
                  <td style={{padding:"8px 10px",color:"#555"}}>
                    ${m.spend.toFixed(2)}
                    {c&&<div style={{fontSize:10,color:m.spend>c.spend?"#d42b2b":"#1a7a3c"}}>{m.spend>c.spend?"+":""}{(m.spend-c.spend).toFixed(2)}</div>}
                  </td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.sales.toFixed(2)}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:acosCol}}>{m.spend>0&&m.acos>0?`${m.acos.toFixed(1)}%`:"—"}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>
                    ${m.cpc.toFixed(2)}
                    {c&&m.cpc>c.cpc*1.2&&<div style={{fontSize:10,color:"#d42b2b"}}>+{((m.cpc-c.cpc)/c.cpc*100).toFixed(0)}%</div>}
                  </td>
                  <td style={{padding:"8px 10px",color:m.cvr<0.5&&m.clicks>5?"#d42b2b":"#555"}}>{m.cvr.toFixed(1)}%{c&&m.cvr<c.cvr*0.7&&c.cvr>0&&<div style={{fontSize:10,color:"#d42b2b"}}>▼{(c.cvr-m.cvr).toFixed(1)}pp</div>}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:m.orders>0?"#1a7a3c":"#d42b2b"}}>{m.orders}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:e.wasteScore>=70?"rgba(212,43,43,0.1)":e.wasteScore>=45?"rgba(196,122,0,0.1)":"rgba(0,0,0,0.05)",color:e.wasteScore>=70?"#d42b2b":e.wasteScore>=45?"#c47a00":"#555",fontWeight:600,whiteSpace:"nowrap"}}>{bcAction(e)}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>150&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 150 of {sorted.length} entities</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No entities match this filter.</div>}
      </div>
    </div>
  );
}

/* Recovery engine */
function BCRecovery({entities}){
  const opps=[
    {
      title:"Bid Reduction — Immediate",icon:"ti-adjustments",color:"#d42b2b",
      items:entities.filter(e=>e.metrics.acos>60&&e.metrics.spend>10).slice(0,8),
      why:"High ACoS entities are spending more per sale than they earn. Every impression costs more than it should.",
      action:"Reduce bids 20–35%. Set a max bid rule to prevent future over-spending.",
      impact:"Direct ACoS improvement. Spend reclaimed from inefficient traffic."
    },
    {
      title:"Negation Opportunities",icon:"ti-ban",color:"#c47a00",
      items:entities.filter(e=>e.entityType==="searchterm"&&e.metrics.orders===0&&e.metrics.spend>8).slice(0,8),
      why:"These search terms are consuming budget with zero buying intent. Each one is a confirmed waste signal.",
      action:"Add as negative exact match. Review for phrase-level patterns to block similar waste.",
      impact:"Immediate spend recovery. Budget freed for converting terms."
    },
    {
      title:"Placement Waste Reduction",icon:"ti-layout-2",color:"#4f46e5",
      items:entities.filter(e=>e.entityType==="placement"&&e.metrics.acos>70).slice(0,8),
      why:"These placements are burning budget at unsustainable ACoS. Placement modifiers need urgent correction.",
      action:"Reduce placement modifiers or set to 0%. Reallocate to top-of-search where CVR is stronger.",
      impact:"Placement ACoS brought under control. TOS spend improved."
    },
    {
      title:"Emergency Pause Candidates",icon:"ti-player-stop",color:"#d42b2b",
      items:entities.filter(e=>e.wasteScore>=80&&e.metrics.orders===0).slice(0,6),
      why:"These entities have confirmed zero return and extreme waste scores. No data justifies continued spend.",
      action:"Pause immediately. Investigate root cause before reactivating. Check targeting, listing, Buy Box.",
      impact:"Instant spend halt on confirmed losers."
    },
    {
      title:"CPC Inflation — Bid Cut Needed",icon:"ti-trending-up",color:"#1a5fa0",
      items:entities.filter(e=>e.compMetrics&&e.metrics.cpc>e.compMetrics.cpc*1.35&&e.metrics.spend>10).slice(0,8),
      why:"CPC has risen 35%+ vs previous period. Unless CVR improved proportionally, you're paying more for the same or worse results.",
      action:"Reduce bids 15–25%. Check if a competitor entered the auction — may need targeting adjustment.",
      impact:"CPC reduction without visibility loss if done gradually."
    },
  ];

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {opps.map((opp,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid rgba(0,0,0,0.06)",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:32,height:32,borderRadius:9,background:`${opp.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${opp.icon}`} style={{fontSize:15,color:opp.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{opp.title}</div>
            <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{opp.items.length} entities</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{opp.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Action: </strong>{opp.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Impact: </strong>{opp.impact}</div>
          </div>
          {opp.items.length>0?(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {opp.items.map((e,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${opp.color}10`,color:opp.color,fontWeight:600,border:`1px solid ${opp.color}30`,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
              ))}
            </div>
          ):<div style={{fontSize:11,color:"#bbb",fontStyle:"italic"}}>No entities match this recovery type with current data.</div>}
        </div>
      ))}
    </div>
  );
}

/* AI assistant */
function BCAIAssistant({entities}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  const critical=entities.filter(e=>e.severity.label==="Critical");
  const totalWaste=entities.filter(e=>e.metrics.orders===0).reduce((s,e)=>s+e.metrics.spend,0);
  const totalSpend=entities.reduce((s,e)=>s+e.metrics.spend,0);
  const cpcInflated=entities.filter(e=>e.compMetrics&&e.metrics.cpc>e.compMetrics.cpc*1.3);
  const cvrCollapsed=entities.filter(e=>e.compMetrics&&e.compMetrics.cvr>1&&e.metrics.cvr<e.compMetrics.cvr*0.5);

  async function runAnalysis(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);
    const prompt=`You are a senior Amazon PPC strategist analysing wasted spend data. Based ONLY on the metrics below, give 5 emergency recovery recommendations. Be specific and prioritise by impact.

DATA:
- Total entities analysed: ${entities.length}
- Critical bleeders: ${critical.length}
- Total waste spend (zero orders): $${totalWaste.toFixed(0)}
- Total spend: $${totalSpend.toFixed(0)}
- Waste rate: ${totalSpend>0?((totalWaste/totalSpend)*100).toFixed(1):0}%
- CPC inflated 30%+ vs previous: ${cpcInflated.length} entities
- CVR collapsed 50%+ vs previous: ${cvrCollapsed.length} entities
- Top critical entities: ${critical.slice(0,5).map(e=>`${e.name} ($${e.metrics.spend.toFixed(0)} wasted)`).join(", ")}

Respond in JSON ONLY (no markdown, no backticks):
{"recommendations":[{"priority":"Critical|High|Medium","title":"...","cause":"...","action":"...","expectedImpact":"..."}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.25,maxOutputTokens:1200}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key."});}
    setLoading(false);
  }

  const prioColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#1a5fa0"};
  return(
    <div style={{maxWidth:800}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>AI Bleeder Analysis (Gemini)</div>
        <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analysing...</>:<><i className="ti ti-brain" style={{fontSize:13}}/>Analyse Bleeders</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>

      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b",marginBottom:12}}>{result.error}</div>}
      {result?.recommendations&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.recommendations.map((r,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:`${prioColor[r.priority]||"#888"}18`,color:prioColor[r.priority]||"#888",fontWeight:700}}>{r.priority}</span>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{r.title}</span>
              </div>
              <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:6}}><strong>Cause: </strong>{r.cause}</div>
              <div style={{fontSize:12,color:"#444",lineHeight:1.5,marginBottom:6}}><strong>Action: </strong>{r.action}</div>
              <div style={{fontSize:11,background:"rgba(26,122,60,0.06)",borderRadius:7,padding:"6px 10px",color:"#1a7a3c"}}><i className="ti ti-trending-up" style={{fontSize:11,marginRight:4}}/>Expected: {r.expectedImpact}</div>
            </div>
          ))}
        </div>
      )}
      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"24px",textAlign:"center"}}>
          <i className="ti ti-brain" style={{fontSize:28,color:"#ddd",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,color:"#aaa"}}>Enter your Gemini key and click Analyse Bleeders.<br/>AI explains root causes and emergency recovery steps from your actual data.</div>
        </div>
      )}
    </div>
  );
}

/* Export handler */
function bcExport(entities, type){
  const map={
    all:entities,
    critical:entities.filter(e=>e.severity.label==="Critical"),
    negate:entities.filter(e=>e.entityType==="searchterm"&&e.metrics.orders===0&&e.metrics.spend>5),
    bids:entities.filter(e=>e.metrics.acos>50&&e.metrics.spend>10),
    pause:entities.filter(e=>e.wasteScore>=80&&e.metrics.orders===0),
  };
  const filtered=map[type]||entities;
  if(!filtered.length){alert("No data to export for this filter.");return;}

  const wb=XLSX.utils.book_new();

  /* ── Sheet 1: Amazon Bulk Upload (pause or negate actions) ───
     Produces upload-ready rows with correct Entity + Operation.
     - Keywords to pause: Entity="Keyword", Operation="update", State="paused"
     - Search terms to negate: Entity="Campaign Negative Keyword",
       Operation="create", Match Type="negativeExact"
  ─────────────────────────────────────────────────────────────── */
  const toNegate=filtered.filter(e=>e.entityType==="searchterm"&&e.metrics.orders===0&&e.metrics.spend>5);
  const toPause=filtered.filter(e=>e.entityType==="keyword"&&e.wasteScore>=70);

  const bulkRows=[
    ...toNegate.map(e=>amznCampNegRow({campaign:e.campaign,keyword:e.name,matchType:"negativeExact"})),
    ...toPause.map(e=>amznPauseRow({campaign:e.campaign,keyword:e.name,matchType:e.matchType||""})),
  ];

  if(bulkRows.length){
    const ws1=XLSX.utils.json_to_sheet(bulkRows,{header:AMZN_SP_COLS});
    ws1["!cols"]=AMZN_SP_COLS.map(h=>({wch:["Campaign Name","Keyword Text"].includes(h)?30:14}));
    XLSX.utils.book_append_sheet(wb,ws1,"Sponsored Products Campaigns");
  }

  /* ── Sheet 2: Full analysis for review ───────────────────── */
  const reviewRows=filtered.map(e=>({
    "Entity Name":e.name,"Entity Type":e.entityType,"Campaign":e.campaign,
    "Waste Score":e.wasteScore,"Severity":e.severity.label,
    "Spend ($)":e.metrics.spend.toFixed(2),"Sales ($)":e.metrics.sales.toFixed(2),
    "Orders":e.metrics.orders,"ACoS (%)":e.metrics.acos.toFixed(1),
    "CPC ($)":e.metrics.cpc.toFixed(2),"CVR (%)":e.metrics.cvr.toFixed(1),
    "Prev Spend ($)":e.compMetrics?e.compMetrics.spend.toFixed(2):"—",
    "Prev ACoS (%)":e.compMetrics?e.compMetrics.acos.toFixed(1):"—",
    "Amazon Action":e.entityType==="searchterm"?"Add as negativeExact":e.wasteScore>=70?"Pause keyword":"Reduce bid 25%",
    "Suggested Action":bcAction(e)
  }));
  const ws2=XLSX.utils.json_to_sheet(reviewRows);
  ws2["!cols"]=Object.keys(reviewRows[0]).map(()=>({wch:20}));
  XLSX.utils.book_append_sheet(wb,ws2,"Bleeder Review — Do Not Upload");

  XLSX.writeFile(wb,`Amazon_Bleeders_${type}_${new Date().toISOString().slice(0,10)}.xlsx`);
}

/* ── Bleeder Check Module Root ──────────────────────────────── */
function BleederCheckModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("overview");

  /* Merge campaign + search term + placement data */
  const campRows=globalData?.cur?.campaign?.rows||globalData?.cur?.primary?.rows||[];
  const campCm=globalData?.cur?.campaign?.cm||globalData?.cur?.primary?.cm||{};
  const stRows=globalData?.cur?.searchterm?.rows||[];
  const stCm=globalData?.cur?.searchterm?.cm||{};
  const compCampRows=globalData?.comp?.campaign?.rows||globalData?.comp?.primary?.rows||[];
  const compCampCm=globalData?.comp?.campaign?.cm||globalData?.comp?.primary?.cm||{};
  const compStRows=globalData?.comp?.searchterm?.rows||[];
  const compStCm=globalData?.comp?.searchterm?.cm||{};

  const campEntities=useMemo(()=>bcProcessRows(campRows,campCm,compCampRows,compCampCm,"campaign"),[campRows,campCm]);
  const stEntities=useMemo(()=>bcProcessRows(stRows,stCm,compStRows,compStCm,"searchterm"),[stRows,stCm]);
  const allEntities=useMemo(()=>[...campEntities,...stEntities].sort((a,b)=>b.wasteScore-a.wasteScore),[campEntities,stEntities]);
  const hasData=campRows.length>0||stRows.length>0;

  const tabs=[
    {key:"overview",  label:"Overview",   icon:"ti-layout-dashboard"},
    {key:"alerts",    label:"Alerts",     icon:"ti-alert-octagon", badge:allEntities.filter(e=>e.severity.label==="Critical").length||null},
    {key:"table",     label:"All Bleeders",icon:"ti-table",        badge:allEntities.filter(e=>e.wasteScore>=20).length||null},
    {key:"recovery",  label:"Recovery",   icon:"ti-heart-rate-monitor"},
    {key:"ai",        label:"AI Analysis",icon:"ti-brain"},
    {key:"export",    label:"Export",     icon:"ti-download"},
  ];

  if(!hasData) return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-droplet-off" style={{fontSize:15,color:"#d42b2b"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Bleeder Check</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>Core</span>
      </div>
      <BCEmptyState onGoToHub={()=>setTab("hub")}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-droplet-off" style={{fontSize:15,color:"#d42b2b"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Bleeder Check</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(212,43,43,0.1)",color:"#d42b2b",fontWeight:700}}>Core</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{allEntities.length} entities analysed</span>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#d42b2b":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#d42b2b":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#d42b2b":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>

        {activeTab==="overview"&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <BCOverview entities={allEntities}/>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}>
              <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:14}}>Top Bleeders at a Glance</div>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {allEntities.filter(e=>e.wasteScore>=45).slice(0,8).map((e,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 12px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0"}}>
                    <span style={{fontSize:10,padding:"2px 6px",borderRadius:3,background:e.severity.bg,color:e.severity.color,fontWeight:700,flexShrink:0}}>{e.severity.label}</span>
                    <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
                    <span style={{fontSize:11,color:"#888",flexShrink:0}}>Score {e.wasteScore}</span>
                    <span style={{fontSize:11,color:"#d42b2b",fontWeight:600,flexShrink:0}}>${e.metrics.spend.toFixed(2)} spent</span>
                    <span style={{fontSize:11,color:e.metrics.orders>0?"#1a7a3c":"#d42b2b",flexShrink:0}}>{e.metrics.orders} orders</span>
                  </div>
                ))}
                {allEntities.filter(e=>e.wasteScore>=45).length===0&&<div style={{fontSize:12,color:"#aaa",textAlign:"center",padding:"20px 0"}}>No high-waste entities detected. Account looks healthy.</div>}
              </div>
            </div>
          </div>
        )}

        {activeTab==="alerts"&&(
          <div style={{maxWidth:860,margin:"0 auto"}}>
            <BCAlerts entities={allEntities}/>
          </div>
        )}

        {activeTab==="table"&&(
          <div style={{maxWidth:1100,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}>
            <BCTable entities={allEntities} onExport={rows=>bcExport(rows,"all")}/>
          </div>
        )}

        {activeTab==="recovery"&&(
          <div style={{maxWidth:900,margin:"0 auto"}}>
            <BCRecovery entities={allEntities}/>
          </div>
        )}

        {activeTab==="ai"&&(
          <div style={{maxWidth:860,margin:"0 auto"}}>
            <BCAIAssistant entities={allEntities}/>
          </div>
        )}

        {activeTab==="export"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Export Recovery Actions</div>
              <div style={{fontSize:12,color:"#888",marginBottom:20}}>Each export is strategist-ready with waste scores, comparison deltas, and suggested actions.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {type:"all",    label:"Full Bleeder Report", icon:"ti-table",          color:"#555",  count:allEntities.length,                                               desc:"All entities with waste scores"},
                  {type:"critical",label:"Critical Only",      icon:"ti-alert-octagon",  color:"#d42b2b",count:allEntities.filter(e=>e.severity.label==="Critical").length,     desc:"Emergency action required"},
                  {type:"negate", label:"Negation Sheet",      icon:"ti-ban",            color:"#c47a00",count:allEntities.filter(e=>e.entityType==="searchterm"&&e.metrics.orders===0&&e.metrics.spend>5).length, desc:"Search terms to negate"},
                  {type:"bids",   label:"Bid Reduction Sheet", icon:"ti-adjustments",    color:"#4f46e5",count:allEntities.filter(e=>e.metrics.acos>50&&e.metrics.spend>10).length, desc:"High ACoS bid cuts"},
                  {type:"pause",  label:"Pause Candidates",    icon:"ti-player-stop",    color:"#d42b2b",count:allEntities.filter(e=>e.wasteScore>=80&&e.metrics.orders===0).length, desc:"Emergency pause list"},
                ].map(ex=>(
                  <div key={ex.type} style={{background:"#fafafa",borderRadius:10,border:"1px solid #eee",padding:"14px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
                      <div style={{width:30,height:30,borderRadius:8,background:`${ex.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${ex.icon}`} style={{fontSize:14,color:ex.color}}/>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ex.label}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{ex.count} entities</div>
                      </div>
                    </div>
                    <div style={{fontSize:11,color:"#888",marginBottom:10}}>{ex.desc}</div>
                    <button onClick={()=>bcExport(allEntities,ex.type)} disabled={ex.count===0} style={{...T.btnR(ex.count>0),width:"100%",justifyContent:"center",fontSize:11,padding:"7px 0",opacity:ex.count===0?0.4:1}}>
                      <i className="ti ti-download" style={{fontSize:12}}/>Download ({ex.count})
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

/* ================================================================
   CAMPAIGN SUGGESTIONS MODULE
   PPC optimization recommendation engine.
   Sections: Overview · Recommendations · Table · Opportunities
             Movement Analysis · AI Assistant · Export
   No upload — syncs from Global Data Hub.
================================================================ */

/* ── Recommendation types ───────────────────────────────────── */
const CS_TYPES=[
  {key:"scale",     label:"Scale",          color:"#1a7a3c", bg:"rgba(26,122,60,0.1)",  icon:"ti-rocket"},
  {key:"recover",   label:"Recover",        color:"#c47a00", bg:"rgba(196,122,0,0.1)",  icon:"ti-heart-rate-monitor"},
  {key:"budget",    label:"Budget",         color:"#1a5fa0", bg:"rgba(26,95,160,0.1)",  icon:"ti-cash"},
  {key:"placement", label:"Placement",      color:"#6338c8", bg:"rgba(99,56,200,0.1)",  icon:"ti-layout-2"},
  {key:"keyword",   label:"Keyword",        color:"#4f46e5", bg:"rgba(79,70,229,0.1)",    icon:"ti-key"},
  {key:"structure", label:"Structure",      color:"#2a6496", bg:"rgba(42,100,150,0.1)", icon:"ti-sitemap"},
  {key:"visibility",label:"Visibility",     color:"#c47a00", bg:"rgba(196,122,0,0.1)",  icon:"ti-eye"},
  {key:"efficiency",label:"Efficiency",     color:"#d42b2b", bg:"rgba(212,43,43,0.1)",  icon:"ti-adjustments"},
];

/* ── Opportunity score (0–100) ──────────────────────────────── */
function csOppScore(m, compM){
  let s=50;
  if(m.orders>0&&m.acos>0&&m.acos<25){s+=20;}
  if(m.orders>0&&m.cvr>3){s+=10;}
  if(compM){
    if(m.sales>compM.sales)s+=10;
    if(m.acos<compM.acos&&m.acos>0&&compM.acos>0)s+=8;
    if(m.orders>compM.orders)s+=7;
  }
  if(m.impressions<500&&m.orders>0)s+=15; // underexposed winner
  if(m.spend>0&&m.orders===0)s-=30;
  if(m.acos>80)s-=20;
  return Math.max(0,Math.min(100,Math.round(s)));
}

/* ── Classify recommendation type per entity ────────────────── */
function csClassify(m, compM){
  if(m.orders>0&&m.acos>0&&m.acos<25&&m.impressions<600) return "scale";
  if(m.spend>0&&m.orders===0&&m.spend>15) return "efficiency";
  if(compM&&m.sales<compM.sales*0.7&&compM.sales>5) return "recover";
  if(compM&&m.impressions<compM.impressions*0.6&&m.orders>0) return "visibility";
  if(m.acos>70&&m.spend>10) return "efficiency";
  if(m.orders>3&&m.acos<30) return "scale";
  if(m.cvr<0.5&&m.clicks>15) return "keyword";
  return "efficiency";
}

/* ── Suggested action per entity ────────────────────────────── */
function csSuggestedAction(type, m, compM){
  const map={
    scale:"Increase bids 15–30%",
    recover:"Audit targeting, reduce waste",
    budget:"Increase daily budget",
    placement:"Adjust placement modifiers",
    keyword:"Refine keyword match types",
    structure:"Isolate in dedicated campaign",
    visibility:"Raise bids + TOS modifier",
    efficiency:"Reduce bids 20–30%",
  };
  return map[type]||"Review";
}

/* ── Build enriched suggestion rows ────────────────────────── */
function csProcessRows(rows, cm, compRows, compCm){
  if(!rows||!cm) return [];
  const compMap={};
  if(compRows&&compCm){
    compRows.forEach(r=>{
      const k=r[compCm.campaign]||r[compCm.keyword];
      if(k) compMap[k]=calcRowMetrics(r,compCm);
    });
  }
  return rows.map(row=>{
    const name=row[cm.campaign]||row[cm.keyword]||row[cm.searchTerm]||"Unknown";
    const m=calcRowMetrics(row,cm);
    if(m.spend<0.5&&m.impressions<20) return null;
    const compM=compMap[name]||null;
    const type=csClassify(m,compM);
    const score=csOppScore(m,compM);
    const action=csSuggestedAction(type,m,compM);
    const sevScore=type==="scale"?score>=70?0:type==="recover"?1:2:type==="efficiency"&&m.spend>20?1:2;
    const sev=["Critical","High","Medium","Low"][Math.min(3,sevScore+(score>=60?0:1))];
    return{name,type,metrics:m,compMetrics:compM,score,action,sev,campaign:row[cm.campaign]||"—"};
  }).filter(Boolean).sort((a,b)=>b.score-a.score);
}

/* ── Components ─────────────────────────────────────────────── */
function CSEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(26,95,160,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-speakerphone" style={{fontSize:26,color:"#1a5fa0"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Campaign Suggestions needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:360,lineHeight:1.6,marginBottom:20}}>Upload a Campaign Report or Bulk File in the Data Hub. The recommendation engine analyses all campaigns and surfaces optimisation opportunities automatically.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Overview */
function CSOverview({entities}){
  const byType=(key)=>entities.filter(e=>e.type===key).length;
  const critical=entities.filter(e=>e.sev==="Critical"||e.sev==="High").length;
  const scalable=entities.filter(e=>e.type==="scale").length;
  const recover=entities.filter(e=>e.type==="recover").length;
  const efficiency=entities.filter(e=>e.type==="efficiency").length;
  const visibility=entities.filter(e=>e.type==="visibility").length;
  const avgScore=entities.length?Math.round(entities.reduce((s,e)=>s+e.score,0)/entities.length):0;

  const cards=[
    {label:"Total Recommendations",val:entities.length,sub:"auto-detected",icon:"ti-list-check",color:"#1a5fa0"},
    {label:"Urgent (Critical/High)",val:critical,sub:"require immediate action",icon:"ti-alert-triangle",color:"#d42b2b"},
    {label:"Scale Opportunities",val:scalable,sub:"profitable growth",icon:"ti-rocket",color:"#1a7a3c"},
    {label:"Recovery Needed",val:recover,sub:"declining campaigns",icon:"ti-heart-rate-monitor",color:"#c47a00"},
    {label:"Efficiency Fixes",val:efficiency,sub:"waste reduction",icon:"ti-adjustments",color:"#4f46e5"},
    {label:"Avg Opportunity Score",val:avgScore,sub:"account optimisation potential",icon:"ti-target",color:"#6338c8"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
      {cards.map(c=>(
        <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
            </div>
            <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
          </div>
          <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:2}}>{c.val}</div>
          <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}

/* Recommendation cards */
function CSRecommendations({entities}){
  const[expanded,setExpanded]=useState({});
  const toggle=i=>setExpanded(p=>({...p,[i]:!p[i]}));

  // Group into meaningful alert-style cards
  const groups=[
    {
      sev:"Critical",title:"Immediate Scale Opportunities",icon:"ti-rocket",color:"#1a7a3c",border:"rgba(26,122,60,0.2)",bg:"rgba(26,122,60,0.05)",
      items:entities.filter(e=>e.type==="scale"&&e.score>=70).slice(0,6),
      explain:"These campaigns have low ACoS and strong conversion rates but are under-exposed. Every day without scaling is lost revenue.",
      action:"Increase bids 20–30%. Expand daily budgets. Add exact match variants of top converting terms.",
      confidence:91
    },
    {
      sev:"High",title:"Recovery — Declining Performance",icon:"ti-heart-rate-monitor",color:"#c47a00",border:"rgba(196,122,0,0.2)",bg:"rgba(196,122,0,0.05)",
      items:entities.filter(e=>e.type==="recover").slice(0,6),
      explain:"These campaigns showed stronger performance in the previous period. Sales, CVR, or orders have declined without clear budget reason.",
      action:"Audit search terms for new waste. Check placement performance. Review bid rules that may have over-optimised.",
      confidence:84
    },
    {
      sev:"High",title:"Efficiency — Cut Waste Now",icon:"ti-adjustments",color:"#d42b2b",border:"rgba(212,43,43,0.2)",bg:"rgba(212,43,43,0.05)",
      items:entities.filter(e=>e.type==="efficiency"&&e.metrics.spend>10).slice(0,6),
      explain:"These campaigns are running high ACoS or spending without converting. Unchecked, they drain budget from profitable campaigns.",
      action:"Reduce bids 20–30%. Add negative keywords. Tighten match types. Review placement modifiers.",
      confidence:88
    },
    {
      sev:"Medium",title:"Visibility — Underexposed Winners",icon:"ti-eye",color:"#6338c8",border:"rgba(99,56,200,0.2)",bg:"rgba(99,56,200,0.05)",
      items:entities.filter(e=>e.type==="visibility").slice(0,6),
      explain:"These campaigns convert when they get impressions but their impression share is declining. Visibility loss compounds into ranking loss.",
      action:"Increase bids 15–25%. Raise TOS placement modifier. Check budget cap — may be hitting limit.",
      confidence:79
    },
    {
      sev:"Medium",title:"Keyword Structure — Isolation Needed",icon:"ti-key",color:"#4f46e5",border:"rgba(79,70,229,0.2)",bg:"rgba(79,70,229,0.05)",
      items:entities.filter(e=>e.type==="keyword").slice(0,6),
      explain:"These campaigns have low CVR despite sufficient clicks, suggesting keyword-level targeting issues or match type problems.",
      action:"Isolate top converting terms in exact match campaigns. Move broad discovery to separate campaign structure.",
      confidence:74
    },
  ].filter(g=>g.items.length>0);

  if(!groups.length) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No critical optimisation issues detected. Account looks well-optimised.</span>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {groups.map((g,i)=>(
        <div key={i} style={{background:g.bg,borderRadius:12,border:`1px solid ${g.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,cursor:"pointer"}} onClick={()=>toggle(i)}>
            <i className={`ti ${g.icon}`} style={{fontSize:14,color:g.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:g.color}}>{g.sev} — {g.title}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Confidence: {g.confidence}% · {g.items.length} entities</span>
            <i className={`ti ${expanded[i]?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#aaa"}}/>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{g.explain}</div>
          <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px",marginBottom:8}}>
            <i className="ti ti-bulb" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>
            <strong>Action: </strong>{g.action}
          </div>
          {expanded[i]&&g.items.length>0&&(
            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:8}}>
              {g.items.map((e,j)=>{
                const m=e.metrics; const compM=e.compMetrics;
                return(
                  <div key={j} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 12px",background:"rgba(255,255,255,0.7)",borderRadius:7}}>
                    <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
                    <span style={{fontSize:11,color:"#888"}}>Score {e.score}</span>
                    <span style={{fontSize:11,color:"#555"}}>${m.spend.toFixed(0)} spend</span>
                    <span style={{fontSize:11,color:m.acos>50?"#d42b2b":"#555"}}>{m.acos>0?`${m.acos.toFixed(0)}% ACoS`:"—"}</span>
                    <span style={{fontSize:11,color:m.orders>0?"#1a7a3c":"#888"}}>{m.orders} orders</span>
                    {compM&&m.sales!==compM.sales&&<span style={{fontSize:10,color:m.sales>compM.sales?"#1a7a3c":"#d42b2b",fontWeight:600}}>{m.sales>compM.sales?"▲":"▼"}</span>}
                  </div>
                );
              })}
            </div>
          )}
          {!expanded[i]&&(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {g.items.map((e,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(255,255,255,0.7)",color:g.color,fontWeight:600,border:`1px solid ${g.border}`}}>{e.name}</span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/* Suggestions table */
function CSTable({entities,onExport}){
  const[typeFilter,setTypeFilter]=useState("all");
  const[sevFilter,setSevFilter]=useState("all");
  const[sort,setSort]=useState("score");
  const[search,setSearch]=useState("");

  const filtered=entities.filter(e=>{
    if(typeFilter!=="all"&&e.type!==typeFilter) return false;
    if(sevFilter!=="all"&&e.sev.toLowerCase()!==sevFilter) return false;
    if(search&&!e.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="score") return b.score-a.score;
    if(sort==="spend") return b.metrics.spend-a.metrics.spend;
    if(sort==="acos"){return (a.metrics.acos||999)-(b.metrics.acos||999);}
    if(sort==="sales") return b.metrics.sales-a.metrics.sales;
    return 0;
  });

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:180}}/>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {[{key:"all",label:"All"},...CS_TYPES.map(t=>({key:t.key,label:t.label}))].map(f=>(
            <button key={f.key} onClick={()=>setTypeFilter(f.key)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${typeFilter===f.key?"#1a5fa0":"#e0e0e0"}`,background:typeFilter===f.key?"#1a5fa0":"#fff",color:typeFilter===f.key?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer"}}>{f.label}</button>
          ))}
        </div>
        <div style={{display:"flex",gap:4}}>
          {["all","critical","high","medium","low"].map(s=>(
            <button key={s} onClick={()=>setSevFilter(s)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${sevFilter===s?"#4f46e5":"#e0e0e0"}`,background:sevFilter===s?"#4f46e5":"#fff",color:sevFilter===s?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer",textTransform:"capitalize"}}>{s}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="score">Sort: Opportunity Score</option>
          <option value="spend">Sort: Spend</option>
          <option value="acos">Sort: ACoS</option>
          <option value="sales">Sort: Sales</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}><i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})</button>
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Entity","Opp. Score","Type","Severity","Spend","Sales","ACoS","CPC","CVR","Orders","Suggested Action"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,150).map((e,i)=>{
              const m=e.metrics; const compM=e.compMetrics;
              const typeDef=CS_TYPES.find(t=>t.key===e.type)||CS_TYPES[7];
              const acosCol=m.acos>70?"#d42b2b":m.acos>40?"#c47a00":"#111";
              const sevCol={Critical:"#d42b2b",High:"#c47a00",Medium:"#1a5fa0",Low:"#888"}[e.sev]||"#888";
              const sevBg={Critical:"rgba(212,43,43,0.08)",High:"rgba(196,122,0,0.08)",Medium:"rgba(26,95,160,0.08)",Low:"rgba(0,0,0,0.04)"}[e.sev]||"rgba(0,0,0,0.04)";
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={e.name}>{e.name}</td>
                  <td style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <div style={{width:36,height:6,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
                        <div style={{width:`${e.score}%`,height:"100%",background:e.score>=70?"#1a7a3c":e.score>=45?"#c47a00":"#d42b2b"}}/>
                      </div>
                      <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{e.score}</span>
                    </div>
                  </td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:10,padding:"2px 7px",borderRadius:4,background:typeDef.bg,color:typeDef.color,fontWeight:700,whiteSpace:"nowrap"}}>
                      <i className={`ti ${typeDef.icon}`} style={{fontSize:10}}/>{typeDef.label}
                    </span>
                  </td>
                  <td style={{padding:"8px 10px"}}><span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:sevBg,color:sevCol,fontWeight:700}}>{e.sev}</span></td>
                  <td style={{padding:"8px 10px",color:"#555"}}>
                    ${m.spend.toFixed(2)}
                    {compM&&<div style={{fontSize:10,color:m.spend>compM.spend?"#d42b2b":"#1a7a3c"}}>{m.spend>compM.spend?"+":""}{(m.spend-compM.spend).toFixed(2)}</div>}
                  </td>
                  <td style={{padding:"8px 10px",color:"#555"}}>
                    ${m.sales.toFixed(2)}
                    {compM&&<div style={{fontSize:10,color:m.sales>compM.sales?"#1a7a3c":"#d42b2b"}}>{m.sales>compM.sales?"+":""}{(m.sales-compM.sales).toFixed(2)}</div>}
                  </td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:acosCol}}>{m.spend>0&&m.acos>0?`${m.acos.toFixed(1)}%`:"—"}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.cpc.toFixed(2)}</td>
                  <td style={{padding:"8px 10px",color:m.cvr<1&&m.clicks>10?"#d42b2b":"#555"}}>{m.cvr.toFixed(1)}%</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:m.orders>0?"#1a7a3c":"#888"}}>{m.orders}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:typeDef.bg,color:typeDef.color,fontWeight:600,whiteSpace:"nowrap"}}>{e.action}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>150&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 150 of {sorted.length} entities</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No entities match this filter.</div>}
      </div>
    </div>
  );
}

/* Strategic opportunity panels */
function CSOpportunities({entities}){
  const opps=[
    {
      title:"Fast Scaling — Low ACoS Winners",icon:"ti-rocket",color:"#1a7a3c",
      items:entities.filter(e=>e.metrics.acos>0&&e.metrics.acos<22&&e.metrics.orders>=2).slice(0,8),
      why:"These campaigns are profitable and converting. The only thing limiting their growth is bid or budget constraints.",
      action:"Increase bids 25–35%. Raise daily budget 30–50%. Add exact match variants of converting terms.",
      impact:"Revenue growth without ACoS sacrifice. Low-risk scaling with proven converters."
    },
    {
      title:"Ranking Opportunities — Organic Boost",icon:"ti-trending-up",color:"#6338c8",
      items:entities.filter(e=>e.metrics.impressions<600&&e.metrics.orders>0&&e.metrics.acos<35).slice(0,8),
      why:"These entities convert efficiently but have limited impression share. Scaling PPC here directly improves organic rank position.",
      action:"Increase bids. Add +30–50% TOS modifier. Isolate in dedicated ranking campaigns.",
      impact:"Organic rank improvement + reduced long-term PPC dependency."
    },
    {
      title:"Budget Expansion — Capped Campaigns",icon:"ti-cash",color:"#1a5fa0",
      items:entities.filter(e=>e.metrics.orders>2&&e.metrics.acos<30&&e.metrics.impressions>200).slice(0,8),
      why:"These campaigns have strong performance metrics suggesting they may be hitting daily budget limits before the day ends.",
      action:"Increase daily budget 30–50%. Monitor impression share as budget rises.",
      impact:"More selling time per day. Prevents competitor visibility gains during capped hours."
    },
    {
      title:"Structure Cleanup — Isolation Needed",icon:"ti-sitemap",color:"#2a6496",
      items:entities.filter(e=>e.type==="keyword"&&e.metrics.cvr<1&&e.metrics.clicks>20).slice(0,8),
      why:"These campaigns mix high-intent and low-intent targeting. Poor structure dilutes bid strategy and wastes budget on weak traffic.",
      action:"Separate exact, phrase, and broad into distinct campaigns. Isolate top converters in own campaign.",
      impact:"Better bid control. ACoS improvement per match type. Cleaner performance reporting."
    },
    {
      title:"Placement Scaling — TOS Winners",icon:"ti-layout-2",color:"#4f46e5",
      items:entities.filter(e=>e.metrics.cvr>2&&e.metrics.orders>1&&e.metrics.acos<35).slice(0,8),
      why:"High-converting campaigns often benefit from Top of Search dominance. Placement modifiers can amplify this advantage.",
      action:"Set TOS placement modifier +40–70%. Monitor ACoS at TOS vs other placements.",
      impact:"Higher visibility on most valuable placement. CVR typically higher at TOS."
    },
    {
      title:"Recovery — Declining Campaigns",icon:"ti-heart-rate-monitor",color:"#c47a00",
      items:entities.filter(e=>e.type==="recover").slice(0,8),
      why:"These campaigns performed better in the previous period. Performance has declined without clear external cause.",
      action:"Audit search terms for new waste. Check for listing changes, competitor activity, or seasonal shifts.",
      impact:"Restore prior performance levels. Prevent compounding decline."
    },
  ];
  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {opps.map((opp,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid rgba(0,0,0,0.06)",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:32,height:32,borderRadius:9,background:`${opp.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${opp.icon}`} style={{fontSize:15,color:opp.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{opp.title}</div>
            <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{opp.items.length} entities</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{opp.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Action: </strong>{opp.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Impact: </strong>{opp.impact}</div>
          </div>
          {opp.items.length>0?(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {opp.items.map((e,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${opp.color}10`,color:opp.color,fontWeight:600,border:`1px solid ${opp.color}30`,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
              ))}
            </div>
          ):<div style={{fontSize:11,color:"#bbb",fontStyle:"italic"}}>No entities match this opportunity with current data.</div>}
        </div>
      ))}
    </div>
  );
}

/* Performance movement analysis */
function CSMovement({entities}){
  const improving=entities.filter(e=>e.compMetrics&&e.metrics.sales>e.compMetrics.sales*1.1);
  const declining=entities.filter(e=>e.compMetrics&&e.metrics.sales<e.compMetrics.sales*0.8&&e.compMetrics.sales>3);
  const stable=entities.filter(e=>e.compMetrics&&Math.abs(e.metrics.sales-e.compMetrics.sales)<e.compMetrics.sales*0.1);
  const noComp=entities.filter(e=>!e.compMetrics);

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {noComp.length===entities.length&&(
        <div style={{padding:"16px 18px",background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",fontSize:13,color:"#888",textAlign:"center"}}>
          No comparison period data available. Upload comparison period reports in the Data Hub to see movement analysis.
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
        {[
          {label:"Improving",val:improving.length,color:"#1a7a3c",bg:"rgba(26,122,60,0.06)",icon:"ti-trending-up",desc:"Sales up 10%+ vs prev"},
          {label:"Declining",val:declining.length,color:"#d42b2b",bg:"rgba(212,43,43,0.06)",icon:"ti-trending-down",desc:"Sales down 20%+ vs prev"},
          {label:"Stable",val:stable.length,color:"#1a5fa0",bg:"rgba(26,95,160,0.06)",icon:"ti-minus",desc:"Within 10% of prev"},
        ].map(s=>(
          <div key={s.label} style={{background:s.bg,borderRadius:10,border:`1px solid ${s.color}28`,padding:"14px 16px"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
              <i className={`ti ${s.icon}`} style={{fontSize:14,color:s.color}}/>
              <span style={{fontSize:12,fontWeight:700,color:s.color}}>{s.label}</span>
            </div>
            <div style={{fontSize:24,fontWeight:800,color:"#111",marginBottom:3}}>{s.val}</div>
            <div style={{fontSize:11,color:"#888"}}>{s.desc}</div>
          </div>
        ))}
      </div>
      {declining.length>0&&(
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:12}}>
          <div style={{fontSize:13,fontWeight:700,color:"#d42b2b",marginBottom:10}}>Declining Campaigns — Action Needed</div>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {declining.slice(0,10).map((e,i)=>{
              const d=e.metrics.sales-e.compMetrics.sales;
              return(
                <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 12px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0"}}>
                  <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
                  <span style={{fontSize:11,color:"#888"}}>Prev: ${e.compMetrics.sales.toFixed(0)}</span>
                  <span style={{fontSize:11,color:"#111",fontWeight:600}}>Now: ${e.metrics.sales.toFixed(0)}</span>
                  <span style={{fontSize:11,fontWeight:700,color:"#d42b2b"}}>{d.toFixed(0)} ({((d/e.compMetrics.sales)*100).toFixed(0)}%)</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {improving.length>0&&(
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px"}}>
          <div style={{fontSize:13,fontWeight:700,color:"#1a7a3c",marginBottom:10}}>Improving Campaigns — Scale These</div>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {improving.slice(0,10).map((e,i)=>{
              const d=e.metrics.sales-e.compMetrics.sales;
              return(
                <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 12px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0"}}>
                  <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
                  <span style={{fontSize:11,color:"#888"}}>Prev: ${e.compMetrics.sales.toFixed(0)}</span>
                  <span style={{fontSize:11,color:"#111",fontWeight:600}}>Now: ${e.metrics.sales.toFixed(0)}</span>
                  <span style={{fontSize:11,fontWeight:700,color:"#1a7a3c"}}>+${d.toFixed(0)} (+{((d/e.compMetrics.sales)*100).toFixed(0)}%)</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

/* AI assistant */
function CSAIAssistant({entities}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  const scalable=entities.filter(e=>e.type==="scale");
  const recover=entities.filter(e=>e.type==="recover");
  const efficiency=entities.filter(e=>e.type==="efficiency");
  const avgScore=entities.length?Math.round(entities.reduce((s,e)=>s+e.score,0)/entities.length):0;
  const totalSpend=entities.reduce((s,e)=>s+e.metrics.spend,0);
  const totalSales=entities.reduce((s,e)=>s+e.metrics.sales,0);
  const overallAcos=totalSales>0?(totalSpend/totalSales)*100:0;

  async function runAnalysis(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);
    const prompt=`You are a senior Amazon PPC optimisation strategist. Based ONLY on the data below, give 5 prioritised campaign optimisation recommendations. Be specific and focus on highest-impact actions.

DATA:
- Total campaigns/entities analysed: ${entities.length}
- Scaling opportunities: ${scalable.length} (avg score: ${scalable.length?Math.round(scalable.reduce((s,e)=>s+e.score,0)/scalable.length):0})
- Recovery needed: ${recover.length}
- Efficiency issues: ${efficiency.length}
- Average opportunity score: ${avgScore}/100
- Total spend: $${totalSpend.toFixed(0)}
- Total sales: $${totalSales.toFixed(0)}
- Overall ACoS: ${overallAcos.toFixed(1)}%
- Top scaling entities: ${scalable.slice(0,4).map(e=>`${e.name} (ACoS: ${e.metrics.acos.toFixed(0)}%, orders: ${e.metrics.orders})`).join(", ")}
- Top recovery needed: ${recover.slice(0,3).map(e=>e.name).join(", ")}

Respond in JSON ONLY (no markdown, no backticks):
{"recommendations":[{"priority":"Critical|High|Medium","title":"...","rationale":"...","action":"...","expectedImpact":"..."}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.3,maxOutputTokens:1200}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key."});}
    setLoading(false);
  }

  const prioColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#1a5fa0"};
  return(
    <div style={{maxWidth:800}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>AI Optimisation Analysis (Gemini)</div>
        <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analysing...</>:<><i className="ti ti-brain" style={{fontSize:13}}/>Analyse Campaigns</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>
      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b",marginBottom:12}}>{result.error}</div>}
      {result?.recommendations&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.recommendations.map((r,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:`${prioColor[r.priority]||"#888"}18`,color:prioColor[r.priority]||"#888",fontWeight:700}}>{r.priority}</span>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{r.title}</span>
              </div>
              <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:6}}>{r.rationale}</div>
              <div style={{fontSize:12,color:"#444",lineHeight:1.5,marginBottom:6}}><strong>Action: </strong>{r.action}</div>
              <div style={{fontSize:11,background:"rgba(26,122,60,0.06)",borderRadius:7,padding:"6px 10px",color:"#1a7a3c"}}><i className="ti ti-trending-up" style={{fontSize:11,marginRight:4}}/>Expected: {r.expectedImpact}</div>
            </div>
          ))}
        </div>
      )}
      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"24px",textAlign:"center"}}>
          <i className="ti ti-brain" style={{fontSize:28,color:"#ddd",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,color:"#aaa"}}>Enter your Gemini key and click Analyse Campaigns.<br/>AI prioritises the highest-impact optimisations from your actual account data.</div>
        </div>
      )}
    </div>
  );
}

/* Export handler */
function csExport(entities, type){
  const map={
    all:entities,
    scale:entities.filter(e=>e.type==="scale"),
    recover:entities.filter(e=>e.type==="recover"),
    efficiency:entities.filter(e=>e.type==="efficiency"),
    visibility:entities.filter(e=>e.type==="visibility"),
    keyword:entities.filter(e=>e.type==="keyword"),
  };
  const rows=(map[type]||entities).map(e=>({
    "Entity":e.name,"Campaign":e.campaign,
    "Recommendation Type":(CS_TYPES.find(t=>t.key===e.type)||{label:e.type}).label,
    "Opportunity Score":e.score,"Severity":e.sev,
    "Spend":e.metrics.spend.toFixed(2),"Sales":e.metrics.sales.toFixed(2),
    "Orders":e.metrics.orders,"ACoS":e.metrics.acos.toFixed(1),
    "CPC":e.metrics.cpc.toFixed(2),"CVR":e.metrics.cvr.toFixed(1),
    "Prev Spend":e.compMetrics?e.compMetrics.spend.toFixed(2):"—",
    "Prev Sales":e.compMetrics?e.compMetrics.sales.toFixed(2):"—",
    "Suggested Action":e.action
  }));
  if(!rows.length){alert("No data for this export type.");return;}
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:20}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Campaign Suggestions");
  XLSX.writeFile(wb,`campaign_suggestions_${type}_${Date.now()}.xlsx`);
}

/* ── Campaign Suggestions Module Root ───────────────────────── */
function CampaignSuggestionsModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("overview");

  const campRows=globalData?.cur?.campaign?.rows||globalData?.cur?.primary?.rows||[];
  const campCm=globalData?.cur?.campaign?.cm||globalData?.cur?.primary?.cm||{};
  const compCampRows=globalData?.comp?.campaign?.rows||globalData?.comp?.primary?.rows||[];
  const compCampCm=globalData?.comp?.campaign?.cm||globalData?.comp?.primary?.cm||{};
  const hasData=campRows.length>0;

  const entities=useMemo(()=>hasData?csProcessRows(campRows,campCm,compCampRows,compCampCm):[],[campRows,campCm,hasData]);

  const tabs=[
    {key:"overview",     label:"Overview",      icon:"ti-layout-dashboard"},
    {key:"recommendations",label:"Recommendations",icon:"ti-star",badge:entities.filter(e=>e.sev==="Critical"||e.sev==="High").length||null},
    {key:"table",        label:"All Suggestions",icon:"ti-table",badge:entities.length||null},
    {key:"opportunities",label:"Opportunities",  icon:"ti-rocket"},
    {key:"movement",     label:"Movement",       icon:"ti-trending-up"},
    {key:"ai",           label:"AI Analysis",    icon:"ti-brain"},
    {key:"export",       label:"Export",         icon:"ti-download"},
  ];

  if(!hasData) return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-speakerphone" style={{fontSize:15,color:"#1a5fa0"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Campaign Suggestions</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,95,160,0.1)",color:"#1a5fa0",fontWeight:700}}>Core</span>
      </div>
      <CSEmptyState onGoToHub={()=>setTab("hub")}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-speakerphone" style={{fontSize:15,color:"#1a5fa0"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Campaign Suggestions</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,95,160,0.1)",color:"#1a5fa0",fontWeight:700}}>Core</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{entities.length} recommendations</span>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#1a5fa0":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#1a5fa0":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#1a5fa0":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="overview"&&<div style={{maxWidth:960,margin:"0 auto"}}><CSOverview entities={entities}/></div>}
        {activeTab==="recommendations"&&<div style={{maxWidth:900,margin:"0 auto"}}><CSRecommendations entities={entities}/></div>}
        {activeTab==="table"&&<div style={{maxWidth:1100,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}><CSTable entities={entities} onExport={rows=>csExport(rows,"all")}/></div>}
        {activeTab==="opportunities"&&<div style={{maxWidth:900,margin:"0 auto"}}><CSOpportunities entities={entities}/></div>}
        {activeTab==="movement"&&<CSMovement entities={entities}/>}
        {activeTab==="ai"&&<div style={{maxWidth:860,margin:"0 auto"}}><CSAIAssistant entities={entities}/></div>}
        {activeTab==="export"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Export Campaign Actions</div>
              <div style={{fontSize:12,color:"#888",marginBottom:20}}>Each export contains entity name, opportunity score, comparison deltas, and suggested action — strategist-ready.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {type:"all",       label:"All Recommendations",icon:"ti-table",       color:"#555",  count:entities.length},
                  {type:"scale",     label:"Scaling Actions",     icon:"ti-rocket",      color:"#1a7a3c",count:entities.filter(e=>e.type==="scale").length},
                  {type:"recover",   label:"Recovery Actions",    icon:"ti-heart-rate-monitor",color:"#c47a00",count:entities.filter(e=>e.type==="recover").length},
                  {type:"efficiency",label:"Efficiency Actions",  icon:"ti-adjustments", color:"#d42b2b",count:entities.filter(e=>e.type==="efficiency").length},
                  {type:"visibility",label:"Visibility Actions",  icon:"ti-eye",         color:"#6338c8",count:entities.filter(e=>e.type==="visibility").length},
                  {type:"keyword",   label:"Keyword Actions",     icon:"ti-key",         color:"#4f46e5",count:entities.filter(e=>e.type==="keyword").length},
                ].map(ex=>(
                  <div key={ex.type} style={{background:"#fafafa",borderRadius:10,border:"1px solid #eee",padding:"14px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
                      <div style={{width:30,height:30,borderRadius:8,background:`${ex.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${ex.icon}`} style={{fontSize:14,color:ex.color}}/>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ex.label}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{ex.count} entities</div>
                      </div>
                    </div>
                    <button onClick={()=>csExport(entities,ex.type)} disabled={ex.count===0} style={{...T.btnR(ex.count>0),width:"100%",justifyContent:"center",fontSize:11,padding:"7px 0",opacity:ex.count===0?0.4:1}}>
                      <i className="ti ti-download" style={{fontSize:12}}/>Download ({ex.count})
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   CONFLICT DETECTOR MODULE
   Account structure conflict intelligence system.
   Sections: Overview · Alerts · Conflict Table · Resolution
             Structure Analysis · AI Assistant · Export
   No upload — syncs from Global Data Hub.
================================================================ */

/* ── Conflict detection engine ──────────────────────────────── */
const CD_TYPES=[
  {key:"cannibalization", label:"Keyword Cannibalization", color:"#d42b2b", bg:"rgba(212,43,43,0.1)",  icon:"ti-arrows-shuffle"},
  {key:"matchtype",       label:"Match Type Conflict",     color:"#c47a00", bg:"rgba(196,122,0,0.1)",  icon:"ti-filter"},
  {key:"duplicate",       label:"Duplicate Targeting",     color:"#4f46e5", bg:"rgba(79,70,229,0.1)",    icon:"ti-copy"},
  {key:"budget",          label:"Budget Cannibalization",  color:"#1a5fa0", bg:"rgba(26,95,160,0.1)",  icon:"ti-cash"},
  {key:"placement",       label:"Placement Conflict",      color:"#6338c8", bg:"rgba(99,56,200,0.1)",  icon:"ti-layout-2"},
  {key:"ranking",         label:"Ranking Conflict",        color:"#2a6496", bg:"rgba(42,100,150,0.1)", icon:"ti-trending-up"},
  {key:"asin",            label:"ASIN Target Conflict",    color:"#c47a00", bg:"rgba(196,122,0,0.1)",  icon:"ti-package"},
];

/* Build keyword → campaigns map from rows */
function cdBuildKeywordMap(rows, cm){
  const map={};
  if(!rows||!cm) return map;
  rows.forEach(row=>{
    const kw=(row[cm.keyword]||row[cm.searchTerm]||"").toLowerCase().trim();
    const camp=row[cm.campaign]||"Unknown";
    const mt=row[cm.matchType]||"unknown";
    if(!kw||kw.length<3) return;
    if(!map[kw]) map[kw]={keyword:kw,campaigns:[],matchTypes:[],totalSpend:0,totalOrders:0,rows:[]};
    if(!map[kw].campaigns.includes(camp)) map[kw].campaigns.push(camp);
    if(!map[kw].matchTypes.includes(mt)) map[kw].matchTypes.push(mt);
    const m=calcRowMetrics(row,cm);
    map[kw].totalSpend+=m.spend;
    map[kw].totalOrders+=m.orders;
    map[kw].rows.push({campaign:camp,matchType:mt,metrics:m});
  });
  return map;
}

/* Detect conflicts from keyword map */
function cdDetectConflicts(kwMap){
  const conflicts=[];

  Object.values(kwMap).forEach(kw=>{
    // Keyword cannibalization — 2+ campaigns bidding on same term
    if(kw.campaigns.length>=2){
      const highSpend=kw.rows.filter(r=>r.metrics.spend>2);
      if(highSpend.length>=2){
        const overlapSpend=kw.rows.slice(1).reduce((s,r)=>s+r.metrics.spend,0);
        const severity=kw.campaigns.length>=3||overlapSpend>30?"Critical":overlapSpend>10?"High":"Medium";
        conflicts.push({
          type:"cannibalization",
          keyword:kw.keyword,
          campaigns:kw.campaigns,
          overlapSpend,
          totalSpend:kw.totalSpend,
          totalOrders:kw.totalOrders,
          severity,
          matchTypes:kw.matchTypes,
          efficiencyLoss:Math.round((overlapSpend/Math.max(kw.totalSpend,1))*100),
          fix:"Pause keyword in lower-performing campaign. Add as negative in broad/phrase campaigns.",
          rows:kw.rows,
        });
      }
    }

    // Match type conflict — broad + exact on same base term
    if(kw.matchTypes.length>=2){
      const hasExact=kw.matchTypes.some(m=>m.toLowerCase().includes("exact"));
      const hasBroad=kw.matchTypes.some(m=>m.toLowerCase().includes("broad"));
      const hasPhrase=kw.matchTypes.some(m=>m.toLowerCase().includes("phrase"));
      if(hasExact&&(hasBroad||hasPhrase)){
        const broadRows=kw.rows.filter(r=>r.matchType.toLowerCase().includes("broad")||r.matchType.toLowerCase().includes("phrase"));
        const overlapSpend=broadRows.reduce((s,r)=>s+r.metrics.spend,0);
        if(overlapSpend>5){
          conflicts.push({
            type:"matchtype",
            keyword:kw.keyword,
            campaigns:kw.campaigns,
            overlapSpend,
            totalSpend:kw.totalSpend,
            totalOrders:kw.totalOrders,
            severity:overlapSpend>25?"High":"Medium",
            matchTypes:kw.matchTypes,
            efficiencyLoss:Math.round((overlapSpend/Math.max(kw.totalSpend,1))*60),
            fix:"Add exact match keyword as negative in broad/phrase campaigns to prevent internal auction competition.",
            rows:kw.rows,
          });
        }
      }
    }
  });

  // Duplicate targeting — identical keyword text across campaigns
  const seen={};
  Object.values(kwMap).forEach(kw=>{
    const key=kw.keyword;
    if(seen[key]&&kw.campaigns.length>=2&&kw.totalSpend>3){
      conflicts.push({
        type:"duplicate",
        keyword:kw.keyword,
        campaigns:kw.campaigns,
        overlapSpend:kw.totalSpend*0.4,
        totalSpend:kw.totalSpend,
        totalOrders:kw.totalOrders,
        severity:"Medium",
        matchTypes:kw.matchTypes,
        efficiencyLoss:30,
        fix:"Consolidate duplicate targets. Keep only in strongest campaign based on ACoS and CVR.",
        rows:kw.rows,
      });
    }
    seen[key]=true;
  });

  return conflicts.sort((a,b)=>{
    const sev={Critical:0,High:1,Medium:2,Low:3};
    return (sev[a.severity]||3)-(sev[b.severity]||3);
  });
}

/* Conflict score per campaign pair */
function cdOverlapScore(conflicts){
  const score=conflicts.length*5+
    conflicts.filter(c=>c.severity==="Critical").length*20+
    conflicts.filter(c=>c.severity==="High").length*10+
    conflicts.reduce((s,c)=>s+c.overlapSpend,0)*0.1;
  return Math.min(100,Math.round(score));
}

/* ── Sub-components ─────────────────────────────────────────── */
function CDEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(79,70,229,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-alert-triangle" style={{fontSize:26,color:"#4f46e5"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Conflict Detector needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:380,lineHeight:1.6,marginBottom:20}}>Upload a Bulk File or Campaign Report with keyword-level data in the Data Hub. Conflict Detector scans all keywords and targets for internal bidding overlap and cannibalization.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Overview */
function CDOverview({conflicts,overlapScore}){
  const critical=conflicts.filter(c=>c.severity==="Critical");
  const high=conflicts.filter(c=>c.severity==="High");
  const byType=(key)=>conflicts.filter(c=>c.type===key).length;
  const totalOverlapSpend=conflicts.reduce((s,c)=>s+c.overlapSpend,0);
  const uniqueKws=new Set(conflicts.map(c=>c.keyword)).size;

  const cards=[
    {label:"Total Conflicts",      val:conflicts.length,    sub:"auto-detected",           icon:"ti-alert-triangle", color:"#d42b2b"},
    {label:"Critical / High",      val:`${critical.length}/${high.length}`, sub:"require immediate fix", icon:"ti-alert-octagon",  color:"#d42b2b"},
    {label:"Cannibalized Keywords", val:byType("cannibalization"), sub:"internal auction fight", icon:"ti-arrows-shuffle",  color:"#4f46e5"},
    {label:"Overlap Spend",        val:`$${totalOverlapSpend.toFixed(0)}`, sub:"wasted in conflicts",   icon:"ti-cash",           color:"#c47a00"},
    {label:"Affected Keywords",    val:uniqueKws,           sub:"need restructuring",       icon:"ti-key",            color:"#1a5fa0"},
    {label:"Structural Risk Score",val:overlapScore,        sub:overlapScore>=60?"Critical overlap":overlapScore>=35?"Moderate":"Clean structure", icon:"ti-sitemap", color:overlapScore>=60?"#d42b2b":overlapScore>=35?"#c47a00":"#1a7a3c"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
      {cards.map(c=>(
        <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
            </div>
            <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
          </div>
          <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:2}}>{c.val}</div>
          <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}

/* Alert cards */
function CDAlerts({conflicts}){
  const[expanded,setExpanded]=useState({});
  const toggle=i=>setExpanded(p=>({...p,[i]:!p[i]}));

  // Group into alert types
  const groups=[
    {
      sev:"Critical",type:"cannibalization",title:"Keyword Cannibalization Detected",icon:"ti-arrows-shuffle",color:"#d42b2b",border:"rgba(212,43,43,0.25)",bg:"rgba(212,43,43,0.05)",
      items:conflicts.filter(c=>c.type==="cannibalization"&&(c.severity==="Critical"||c.severity==="High")),
      explain:"Multiple campaigns are actively bidding on the same keywords. This creates an internal auction where your own campaigns compete against each other, inflating your own CPCs.",
      fix:"Add the exact keyword as a negative in lower-performing campaigns. Keep the keyword only in the campaign with best ACoS and CVR.",
      confidence:95
    },
    {
      sev:"High",type:"matchtype",title:"Match Type Conflict — Broad Stealing from Exact",icon:"ti-filter",color:"#c47a00",border:"rgba(196,122,0,0.25)",bg:"rgba(196,122,0,0.05)",
      items:conflicts.filter(c=>c.type==="matchtype"),
      explain:"Broad/Phrase match campaigns are capturing traffic that should route to your Exact match campaigns. This dilutes your exact match data and wastes budget on looser targeting.",
      fix:"Add exact match keywords as negative exact in your broad/phrase campaigns. Route intent traffic correctly.",
      confidence:88
    },
    {
      sev:"Medium",type:"duplicate",title:"Duplicate Targeting Detected",icon:"ti-copy",color:"#4f46e5",border:"rgba(79,70,229,0.2)",bg:"rgba(79,70,229,0.04)",
      items:conflicts.filter(c=>c.type==="duplicate"),
      explain:"Identical targeting exists across multiple campaigns without strategic intent. This creates unnecessary complexity and splits performance data.",
      fix:"Consolidate duplicate targets into one campaign. Use campaign-level negatives to control routing.",
      confidence:80
    },
  ].filter(g=>g.items.length>0);

  if(!groups.length) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No significant conflicts detected. Account structure looks clean.</span>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {groups.map((g,i)=>(
        <div key={i} style={{background:g.bg,borderRadius:12,border:`1px solid ${g.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,cursor:"pointer"}} onClick={()=>toggle(i)}>
            <i className={`ti ${g.icon}`} style={{fontSize:14,color:g.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:g.color}}>{g.sev} — {g.title}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Confidence: {g.confidence}% · {g.items.length} conflicts</span>
            <i className={`ti ${expanded[i]?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#aaa"}}/>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{g.explain}</div>
          <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px",marginBottom:8}}>
            <i className="ti ti-bulb" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>
            <strong>Fix: </strong>{g.fix}
          </div>
          {expanded[i]&&(
            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:8}}>
              {g.items.slice(0,10).map((c,j)=>(
                <div key={j} style={{background:"rgba(255,255,255,0.8)",borderRadius:8,padding:"9px 12px",border:`1px solid ${g.border}`}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
                    <span style={{fontSize:12,fontWeight:700,color:"#111",flex:1}}>{c.keyword}</span>
                    <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:g.bg,color:g.color,fontWeight:700}}>{c.severity}</span>
                    <span style={{fontSize:11,color:"#d42b2b",fontWeight:600}}>${c.overlapSpend.toFixed(2)} wasted</span>
                  </div>
                  <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                    <span style={{fontSize:11,color:"#888"}}>{c.campaigns.length} campaigns: {c.campaigns.slice(0,2).join(", ")}{c.campaigns.length>2?` +${c.campaigns.length-2} more`:""}</span>
                    <span style={{fontSize:11,color:"#888"}}>Match types: {c.matchTypes.join(", ")}</span>
                    <span style={{fontSize:11,color:"#888"}}>Est. efficiency loss: {c.efficiencyLoss}%</span>
                  </div>
                </div>
              ))}
              {g.items.length>10&&<div style={{fontSize:11,color:"#aaa",textAlign:"center",padding:"6px"}}>+{g.items.length-10} more conflicts</div>}
            </div>
          )}
          {!expanded[i]&&(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {g.items.slice(0,8).map((c,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(255,255,255,0.7)",color:g.color,fontWeight:600,border:`1px solid ${g.border}`}}>{c.keyword}</span>
              ))}
              {g.items.length>8&&<span style={{fontSize:10,color:"#aaa",padding:"2px 5px"}}>+{g.items.length-8} more</span>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/* Conflict table */
function CDTable({conflicts,onExport}){
  const[typeFilter,setTypeFilter]=useState("all");
  const[sevFilter,setSevFilter]=useState("all");
  const[search,setSearch]=useState("");
  const[sort,setSort]=useState("severity");

  const sevOrder={Critical:0,High:1,Medium:2,Low:3};
  const filtered=conflicts.filter(c=>{
    if(typeFilter!=="all"&&c.type!==typeFilter) return false;
    if(sevFilter!=="all"&&c.severity.toLowerCase()!==sevFilter) return false;
    if(search&&!c.keyword.toLowerCase().includes(search.toLowerCase())&&!c.campaigns.join(" ").toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="severity") return (sevOrder[a.severity]||3)-(sevOrder[b.severity]||3);
    if(sort==="overlap") return b.overlapSpend-a.overlapSpend;
    if(sort==="campaigns") return b.campaigns.length-a.campaigns.length;
    if(sort==="loss") return b.efficiencyLoss-a.efficiencyLoss;
    return 0;
  });

  const sevStyle={
    Critical:{color:"#d42b2b",bg:"rgba(212,43,43,0.08)"},
    High:{color:"#c47a00",bg:"rgba(196,122,0,0.08)"},
    Medium:{color:"#1a5fa0",bg:"rgba(26,95,160,0.08)"},
    Low:{color:"#888",bg:"rgba(0,0,0,0.05)"},
  };

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search keywords or campaigns..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:220}}/>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {[{key:"all",label:"All"},...CD_TYPES.map(t=>({key:t.key,label:t.label}))].map(f=>(
            <button key={f.key} onClick={()=>setTypeFilter(f.key)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${typeFilter===f.key?"#4f46e5":"#e0e0e0"}`,background:typeFilter===f.key?"#4f46e5":"#fff",color:typeFilter===f.key?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer"}}>{f.label}</button>
          ))}
        </div>
        <div style={{display:"flex",gap:4}}>
          {["all","critical","high","medium"].map(s=>(
            <button key={s} onClick={()=>setSevFilter(s)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${sevFilter===s?"#d42b2b":"#e0e0e0"}`,background:sevFilter===s?"#d42b2b":"#fff",color:sevFilter===s?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer",textTransform:"capitalize"}}>{s}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="severity">Sort: Severity</option>
          <option value="overlap">Sort: Overlap Spend</option>
          <option value="campaigns">Sort: Campaigns Involved</option>
          <option value="loss">Sort: Efficiency Loss</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}><i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})</button>
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Keyword / Target","Conflict Type","Severity","Campaigns","Match Types","Overlap Spend","Efficiency Loss","Fix"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,150).map((c,i)=>{
              const typeDef=CD_TYPES.find(t=>t.key===c.type)||CD_TYPES[0];
              const ss=sevStyle[c.severity]||sevStyle.Low;
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:700,color:"#111",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={c.keyword}>{c.keyword}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:10,padding:"2px 7px",borderRadius:4,background:typeDef.bg,color:typeDef.color,fontWeight:700,whiteSpace:"nowrap"}}>
                      <i className={`ti ${typeDef.icon}`} style={{fontSize:10}}/>{typeDef.label}
                    </span>
                  </td>
                  <td style={{padding:"8px 10px"}}><span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:ss.bg,color:ss.color,fontWeight:700}}>{c.severity}</span></td>
                  <td style={{padding:"8px 10px",color:"#555",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={c.campaigns.join(", ")}>
                    <span style={{fontSize:11,fontWeight:600}}>{c.campaigns.length}× </span>
                    {c.campaigns.slice(0,1).join(", ")}
                    {c.campaigns.length>1&&<span style={{color:"#aaa"}}> +{c.campaigns.length-1}</span>}
                  </td>
                  <td style={{padding:"8px 10px",color:"#555"}}>{c.matchTypes.join(", ")||"—"}</td>
                  <td style={{padding:"8px 10px",fontWeight:700,color:"#d42b2b"}}>${c.overlapSpend.toFixed(2)}</td>
                  <td style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <div style={{width:32,height:5,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
                        <div style={{width:`${c.efficiencyLoss}%`,height:"100%",background:c.efficiencyLoss>=60?"#d42b2b":c.efficiencyLoss>=35?"#c47a00":"#1a7a3c"}}/>
                      </div>
                      <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{c.efficiencyLoss}%</span>
                    </div>
                  </td>
                  <td style={{padding:"8px 10px",fontSize:10,color:"#555",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={c.fix}>{c.fix}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>150&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 150 of {sorted.length} conflicts</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No conflicts match this filter.</div>}
      </div>
    </div>
  );
}

/* Resolution engine */
function CDResolution({conflicts}){
  const opps=[
    {
      title:"Isolation — Stop Internal Auction Competition",icon:"ti-arrows-split",color:"#d42b2b",
      items:conflicts.filter(c=>c.type==="cannibalization").slice(0,8),
      why:"When two campaigns bid on the same keyword, you compete against yourself in Amazon's auction. This inflates your own CPC and splits conversion data making neither campaign look as strong.",
      action:"Add the conflicting keyword as a negative exact match in the weaker campaign (higher ACoS). Keep it only in the stronger performer.",
      impact:"CPC reduction on conflicted terms. Cleaner conversion data. Better optimization signal."
    },
    {
      title:"Match Type Routing — Fix Broad vs Exact",icon:"ti-filter",color:"#c47a00",
      items:conflicts.filter(c=>c.type==="matchtype").slice(0,8),
      why:"Broad match captures traffic that should convert through Exact match. This inflates broad match ACoS and dilutes exact match impression data.",
      action:"Add exact match keywords as negative exact in broad/phrase campaigns. Build a proper match type hierarchy: Broad discovery → Phrase → Exact conversion.",
      impact:"Exact match campaigns get proper traffic routing. Broad match focuses on discovery only."
    },
    {
      title:"Consolidation — Remove Duplicate Targeting",icon:"ti-copy",color:"#4f46e5",
      items:conflicts.filter(c=>c.type==="duplicate").slice(0,8),
      why:"Duplicate targets across campaigns split data and create bid management complexity without strategic benefit.",
      action:"Identify which campaign has better performance metrics. Pause the duplicate in the weaker campaign.",
      impact:"Cleaner account structure. Simpler bid management. Consolidated performance data."
    },
    {
      title:"Campaign Structure — Keyword Routing Optimisation",icon:"ti-sitemap",color:"#1a5fa0",
      items:conflicts.filter(c=>c.campaigns.length>=3).slice(0,6),
      why:"Keywords appearing in 3+ campaigns indicate a structural problem — likely auto campaigns bleeding into manual, or poor campaign segmentation.",
      action:"Map intended traffic flow. Assign each keyword to one campaign based on intent and match type. Use negatives to enforce routing.",
      impact:"Spend concentrated in strongest campaigns. Cleaner auction behavior. Better account hygiene."
    },
  ].filter(o=>o.items.length>0);

  if(!opps.length) return(
    <div style={{padding:"20px",background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",textAlign:"center",fontSize:13,color:"#aaa"}}>
      No resolution opportunities detected — account structure looks conflict-free.
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {opps.map((opp,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid rgba(0,0,0,0.06)",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:32,height:32,borderRadius:9,background:`${opp.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${opp.icon}`} style={{fontSize:15,color:opp.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{opp.title}</div>
            <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{opp.items.length} conflicts</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{opp.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Action: </strong>{opp.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Impact: </strong>{opp.impact}</div>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {opp.items.map((c,j)=>(
              <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${opp.color}10`,color:opp.color,fontWeight:600,border:`1px solid ${opp.color}30`}}>{c.keyword}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/* Structure analysis panel */
function CDStructure({conflicts,kwMap}){
  const totalKws=Object.keys(kwMap).length;
  const conflictedKws=new Set(conflicts.map(c=>c.keyword)).size;
  const multiCamp=Object.values(kwMap).filter(k=>k.campaigns.length>=2).length;
  const cleanKws=totalKws-conflictedKws;
  const avgCamps=totalKws>0?Object.values(kwMap).reduce((s,k)=>s+k.campaigns.length,0)/totalKws:0;

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10,marginBottom:16}}>
        {[
          {label:"Total Unique Keywords",val:totalKws,sub:"across all campaigns",color:"#1a5fa0"},
          {label:"Conflicted Keywords",val:conflictedKws,sub:`${totalKws>0?((conflictedKws/totalKws)*100).toFixed(0):0}% of total`,color:"#d42b2b"},
          {label:"Multi-Campaign Keywords",val:multiCamp,sub:"appearing in 2+ campaigns",color:"#c47a00"},
          {label:"Clean Keywords",val:cleanKws,sub:"no conflicts detected",color:"#1a7a3c"},
        ].map(s=>(
          <div key={s.label} style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
            <div style={{fontSize:11,color:"#888",fontWeight:600,marginBottom:6}}>{s.label}</div>
            <div style={{fontSize:24,fontWeight:800,color:s.color,marginBottom:3}}>{s.val}</div>
            <div style={{fontSize:11,color:"#aaa"}}>{s.sub}</div>
          </div>
        ))}
      </div>

      {/* Top conflicted keywords */}
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Most Conflicted Keywords</div>
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {Object.values(kwMap).filter(k=>k.campaigns.length>=2).sort((a,b)=>b.campaigns.length-a.campaigns.length).slice(0,12).map((kw,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 12px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0"}}>
              <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:"rgba(212,43,43,0.08)",color:"#d42b2b",fontWeight:700,flexShrink:0}}>{kw.campaigns.length}× campaigns</span>
              <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{kw.keyword}</span>
              <span style={{fontSize:11,color:"#d42b2b",flexShrink:0}}>${kw.totalSpend.toFixed(2)}</span>
              <span style={{fontSize:11,color:kw.totalOrders>0?"#1a7a3c":"#888",flexShrink:0}}>{kw.totalOrders} orders</span>
              <span style={{fontSize:10,color:"#888",flexShrink:0,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis"}}>{kw.matchTypes.join(" · ")}</span>
            </div>
          ))}
          {Object.values(kwMap).filter(k=>k.campaigns.length>=2).length===0&&<div style={{fontSize:12,color:"#aaa",textAlign:"center",padding:"16px 0"}}>No multi-campaign keywords found.</div>}
        </div>
      </div>
    </div>
  );
}

/* AI assistant */
function CDAIAssistant({conflicts,overlapScore}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  const cannibal=conflicts.filter(c=>c.type==="cannibalization");
  const matchConflicts=conflicts.filter(c=>c.type==="matchtype");
  const totalOverlap=conflicts.reduce((s,c)=>s+c.overlapSpend,0);

  async function runAnalysis(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);
    const prompt=`You are a senior Amazon PPC account structure specialist. Based ONLY on the conflict data below, give 5 specific structural fix recommendations.

DATA:
- Total conflicts: ${conflicts.length}
- Keyword cannibalization conflicts: ${cannibal.length}
- Match type conflicts: ${matchConflicts.length}
- Total overlap spend wasted: $${totalOverlap.toFixed(0)}
- Structural risk score: ${overlapScore}/100
- Top cannibalized keywords: ${cannibal.slice(0,5).map(c=>`"${c.keyword}" (${c.campaigns.length} campaigns, $${c.overlapSpend.toFixed(0)} overlap)`).join(", ")}
- Top match type conflicts: ${matchConflicts.slice(0,3).map(c=>`"${c.keyword}" (${c.matchTypes.join(" vs ")})`).join(", ")}

Respond in JSON ONLY (no markdown, no backticks):
{"fixes":[{"priority":"Critical|High|Medium","title":"...","rootCause":"...","action":"...","expectedResult":"..."}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.25,maxOutputTokens:1200}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key."});}
    setLoading(false);
  }

  const prioColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#1a5fa0"};
  return(
    <div style={{maxWidth:800}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>AI Conflict Analysis (Gemini)</div>
        <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analysing...</>:<><i className="ti ti-brain" style={{fontSize:13}}/>Analyse Conflicts</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>
      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b"}}>{result.error}</div>}
      {result?.fixes&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.fixes.map((f,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:`${prioColor[f.priority]||"#888"}18`,color:prioColor[f.priority]||"#888",fontWeight:700}}>{f.priority}</span>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{f.title}</span>
              </div>
              <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:6}}><strong>Root cause: </strong>{f.rootCause}</div>
              <div style={{fontSize:12,color:"#444",lineHeight:1.5,marginBottom:6}}><strong>Action: </strong>{f.action}</div>
              <div style={{fontSize:11,background:"rgba(26,122,60,0.06)",borderRadius:7,padding:"6px 10px",color:"#1a7a3c"}}><i className="ti ti-check" style={{fontSize:11,marginRight:4}}/>Expected: {f.expectedResult}</div>
            </div>
          ))}
        </div>
      )}
      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"24px",textAlign:"center"}}>
          <i className="ti ti-brain" style={{fontSize:28,color:"#ddd",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,color:"#aaa"}}>Enter your Gemini key and click Analyse Conflicts.<br/>AI explains root causes and structural fixes based on your actual account data.</div>
        </div>
      )}
    </div>
  );
}

/* Export */
function cdExport(conflicts, type){
  const map={
    all:conflicts,
    cannibalization:conflicts.filter(c=>c.type==="cannibalization"),
    matchtype:conflicts.filter(c=>c.type==="matchtype"),
    duplicate:conflicts.filter(c=>c.type==="duplicate"),
    critical:conflicts.filter(c=>c.severity==="Critical"||c.severity==="High"),
  };
  const rows=(map[type]||conflicts).map(c=>({
    "Keyword / Target":c.keyword,
    "Conflict Type":(CD_TYPES.find(t=>t.key===c.type)||{label:c.type}).label,
    "Severity":c.severity,
    "Campaigns Involved":c.campaigns.join(" | "),
    "Number of Campaigns":c.campaigns.length,
    "Match Types":c.matchTypes.join(", "),
    "Overlap Spend ($)":c.overlapSpend.toFixed(2),
    "Total Spend ($)":c.totalSpend.toFixed(2),
    "Total Orders":c.totalOrders,
    "Efficiency Loss (%)":c.efficiencyLoss,
    "Suggested Fix":c.fix
  }));
  if(!rows.length){alert("No data for this export.");return;}
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:22}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Conflict Analysis");
  XLSX.writeFile(wb,`conflict_detector_${type}_${Date.now()}.xlsx`);
}

/* ── Conflict Detector Module Root ──────────────────────────── */
function ConflictDetectorModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("overview");

  // Sync keyword-level data from globalData
  const rows=globalData?.cur?.bulk?.rows||globalData?.cur?.primary?.rows||globalData?.cur?.searchterm?.rows||[];
  const cm=globalData?.cur?.bulk?.cm||globalData?.cur?.primary?.cm||globalData?.cur?.searchterm?.cm||{};
  const hasData=rows.length>0&&(cm.keyword||cm.searchTerm);

  const kwMap=useMemo(()=>hasData?cdBuildKeywordMap(rows,cm):{},[rows,cm,hasData]);
  const conflicts=useMemo(()=>cdDetectConflicts(kwMap),[kwMap]);
  const overlapScore=useMemo(()=>cdOverlapScore(conflicts),[conflicts]);

  const tabs=[
    {key:"overview",  label:"Overview",   icon:"ti-layout-dashboard"},
    {key:"alerts",    label:"Alerts",     icon:"ti-alert-triangle", badge:conflicts.filter(c=>c.severity==="Critical"||c.severity==="High").length||null},
    {key:"table",     label:"Conflicts",  icon:"ti-table",          badge:conflicts.length||null},
    {key:"resolution",label:"Resolution", icon:"ti-tool"},
    {key:"structure", label:"Structure",  icon:"ti-sitemap"},
    {key:"ai",        label:"AI Analysis",icon:"ti-brain"},
    {key:"export",    label:"Export",     icon:"ti-download"},
  ];

  if(!hasData) return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-alert-triangle" style={{fontSize:15,color:"#4f46e5"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Conflict Detector</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.1)",color:"#4f46e5",fontWeight:700}}>Advanced</span>
      </div>
      <CDEmptyState onGoToHub={()=>setTab("hub")}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-alert-triangle" style={{fontSize:15,color:"#4f46e5"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Conflict Detector</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.1)",color:"#4f46e5",fontWeight:700}}>Advanced</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{Object.keys(kwMap).length} keywords scanned · {conflicts.length} conflicts</span>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#4f46e5":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#4f46e5":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#4f46e5":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="overview"&&<div style={{maxWidth:960,margin:"0 auto"}}><CDOverview conflicts={conflicts} overlapScore={overlapScore}/></div>}
        {activeTab==="alerts"&&<div style={{maxWidth:860,margin:"0 auto"}}><CDAlerts conflicts={conflicts}/></div>}
        {activeTab==="table"&&<div style={{maxWidth:1100,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}><CDTable conflicts={conflicts} onExport={rows=>cdExport(rows,"all")}/></div>}
        {activeTab==="resolution"&&<div style={{maxWidth:900,margin:"0 auto"}}><CDResolution conflicts={conflicts}/></div>}
        {activeTab==="structure"&&<CDStructure conflicts={conflicts} kwMap={kwMap}/>}
        {activeTab==="ai"&&<div style={{maxWidth:860,margin:"0 auto"}}><CDAIAssistant conflicts={conflicts} overlapScore={overlapScore}/></div>}
        {activeTab==="export"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Export Conflict Resolution Actions</div>
              <div style={{fontSize:12,color:"#888",marginBottom:20}}>Each export includes conflict type, campaigns involved, overlap spend, efficiency loss and suggested fix — ready to action.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {type:"all",           label:"Full Conflict Report",  icon:"ti-table",          color:"#555",  count:conflicts.length},
                  {type:"critical",      label:"Critical & High Only",  icon:"ti-alert-octagon",  color:"#d42b2b",count:conflicts.filter(c=>c.severity==="Critical"||c.severity==="High").length},
                  {type:"cannibalization",label:"Cannibalization Sheet", icon:"ti-arrows-shuffle", color:"#4f46e5",count:conflicts.filter(c=>c.type==="cannibalization").length},
                  {type:"matchtype",     label:"Match Type Conflicts",  icon:"ti-filter",          color:"#c47a00",count:conflicts.filter(c=>c.type==="matchtype").length},
                  {type:"duplicate",     label:"Duplicate Targeting",   icon:"ti-copy",            color:"#1a5fa0",count:conflicts.filter(c=>c.type==="duplicate").length},
                ].map(ex=>(
                  <div key={ex.type} style={{background:"#fafafa",borderRadius:10,border:"1px solid #eee",padding:"14px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
                      <div style={{width:30,height:30,borderRadius:8,background:`${ex.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${ex.icon}`} style={{fontSize:14,color:ex.color}}/>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ex.label}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{ex.count} conflicts</div>
                      </div>
                    </div>
                    <button onClick={()=>cdExport(conflicts,ex.type)} disabled={ex.count===0} style={{...T.btnR(ex.count>0),width:"100%",justifyContent:"center",fontSize:11,padding:"7px 0",opacity:ex.count===0?0.4:1}}>
                      <i className="ti ti-download" style={{fontSize:12}}/>Download ({ex.count})
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   NICHE DIVES MODULE
   Niche and category market intelligence engine.
   Sections: Overview · Alerts · Niche Table · Opportunities
             Market Trends · AI Assistant · Export
   No upload — syncs from Global Data Hub (SQP + search term data).
================================================================ */

/* ── Niche classification helpers ───────────────────────────── */
function ndGrowthScore(m, compM){
  if(!compM||!m) return 50;
  let s=50;
  if(m.impressions>0&&compM.impressions>0){
    const impDelta=(m.impressions-compM.impressions)/compM.impressions*100;
    if(impDelta>30)s+=25; else if(impDelta>10)s+=12; else if(impDelta<-20)s-=20; else if(impDelta<-10)s-=10;
  }
  if(m.clicks>0&&compM.clicks>0){
    const clkDelta=(m.clicks-compM.clicks)/compM.clicks*100;
    if(clkDelta>20)s+=10; else if(clkDelta<-15)s-=10;
  }
  if(m.orders>0&&compM.orders>0){
    const ordDelta=(m.orders-compM.orders)/compM.orders*100;
    if(ordDelta>20)s+=15; else if(ordDelta<-20)s-=15;
  }
  return Math.max(0,Math.min(100,Math.round(s)));
}

function ndCompScore(m){
  /* Competition intensity 0–100 based on CPC + ACoS */
  let s=50;
  if(m.cpc>3)s+=20; else if(m.cpc>2)s+=10; else if(m.cpc<0.8)s-=15;
  if(m.acos>60)s+=15; else if(m.acos>40)s+=8; else if(m.acos<20)s-=10;
  if(m.impressions>5000)s+=10;
  return Math.max(0,Math.min(100,Math.round(s)));
}

function ndOppScore(growth, comp, m){
  /* Opportunity = high growth + low competition + converting */
  let s=0;
  s += growth>=70?30:growth>=50?15:0;
  s += comp<=40?25:comp<=55?12:0;
  s += m.orders>0?20:0;
  s += m.acos>0&&m.acos<30?15:m.acos>0&&m.acos<50?8:0;
  s += m.impressions<1000&&m.orders>0?10:0; // underexposed
  return Math.min(100,Math.round(s));
}

function ndTrend(cur, prev){
  if(!prev||prev===0) return{label:"New",color:"#6338c8",icon:"ti-sparkles"};
  const pct=(cur-prev)/prev*100;
  if(pct>25)  return{label:"Surging",color:"#1a7a3c",icon:"ti-trending-up"};
  if(pct>8)   return{label:"Growing",color:"#2a9a50",icon:"ti-arrow-up-right"};
  if(pct>-8)  return{label:"Stable", color:"#1a5fa0",icon:"ti-minus"};
  if(pct>-25) return{label:"Declining",color:"#c47a00",icon:"ti-arrow-down-right"};
  return{label:"Collapsing",color:"#d42b2b",icon:"ti-trending-down"};
}

/* Build niche rows from search term or SQP data */
function ndProcessRows(rows, cm, compRows, compCm){
  if(!rows||!cm) return [];
  const compMap={};
  if(compRows&&compCm){
    compRows.forEach(r=>{
      const k=r[compCm.searchTerm||compCm.keyword||compCm.query];
      if(k) compMap[k.toLowerCase()]=calcRowMetrics(r,compCm);
    });
  }
  return rows.map(row=>{
    const kw=(row[cm.searchTerm||cm.keyword]||"").trim();
    if(!kw||kw.length<2) return null;
    const m=calcRowMetrics(row,cm);
    if(m.impressions<10&&m.spend<0.5) return null;
    const compM=compMap[kw.toLowerCase()]||null;
    const growth=ndGrowthScore(m,compM);
    const comp=ndCompScore(m);
    const opp=ndOppScore(growth,comp,m);
    const impTrend=ndTrend(m.impressions,compM?.impressions||null);
    const cpcTrend=ndTrend(m.cpc,compM?.cpc||null);
    return{kw,metrics:m,compMetrics:compM,growth,comp,opp,impTrend,cpcTrend,campaign:row[cm.campaign]||"—"};
  }).filter(Boolean).sort((a,b)=>b.opp-a.opp);
}

/* ── Sub-components ─────────────────────────────────────────── */
function NDEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(99,56,200,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-telescope" style={{fontSize:26,color:"#6338c8"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Niche Dives needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:380,lineHeight:1.6,marginBottom:20}}>Upload a Search Term Report or SQP Report in the Data Hub. Niche Dives analyses keyword-level data to surface market trends, competitive shifts, and growth opportunities.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Overview KPIs */
function NDOverview({niches}){
  if(!niches.length) return null;
  const surging=niches.filter(n=>n.impTrend.label==="Surging").length;
  const collapsing=niches.filter(n=>n.impTrend.label==="Collapsing").length;
  const highOpp=niches.filter(n=>n.opp>=65).length;
  const highComp=niches.filter(n=>n.comp>=70).length;
  const avgGrowth=Math.round(niches.reduce((s,n)=>s+n.growth,0)/niches.length);
  const avgOpp=Math.round(niches.reduce((s,n)=>s+n.opp,0)/niches.length);
  const cpcInflating=niches.filter(n=>n.cpcTrend.label==="Surging"||n.cpcTrend.label==="Growing").length;

  const cards=[
    {label:"Surging Niches",   val:surging,   sub:"demand accelerating",         icon:"ti-trending-up",    color:"#1a7a3c"},
    {label:"Declining Niches", val:collapsing, sub:"demand weakening",            icon:"ti-trending-down",  color:"#d42b2b"},
    {label:"High Opportunity", val:highOpp,   sub:"score ≥65",                   icon:"ti-rocket",         color:"#6338c8"},
    {label:"High Competition", val:highComp,  sub:"competitive pressure",         icon:"ti-users",          color:"#c47a00"},
    {label:"CPC Inflating",    val:cpcInflating,sub:"cost pressure rising",       icon:"ti-currency-dollar",color:"#4f46e5"},
    {label:"Avg Opportunity",  val:avgOpp,    sub:"account niche potential",      icon:"ti-target",         color:"#1a5fa0"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
      {cards.map(c=>(
        <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
            </div>
            <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
          </div>
          <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:2}}>{c.val}</div>
          <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}

/* Alert engine */
function NDAlerts({niches}){
  const alerts=[];

  const surging=niches.filter(n=>n.impTrend.label==="Surging"&&n.opp>=60);
  if(surging.length){
    alerts.push({sev:"Critical",type:"Rapid Market Growth",icon:"ti-trending-up",color:"#1a7a3c",border:"rgba(26,122,60,0.25)",bg:"rgba(26,122,60,0.05)",
      explain:`${surging.length} niches are surging in impression volume vs previous period. These represent fast-growing markets where scaling now captures demand before competition intensifies.`,
      action:"Increase bids on these terms. Add to exact match campaigns. Consider launching new ad groups to capture broader niche traffic.",
      items:surging.slice(0,6),confidence:88});
  }

  const collapsing=niches.filter(n=>n.impTrend.label==="Collapsing"&&n.metrics.spend>10);
  if(collapsing.length){
    const waste=collapsing.reduce((s,n)=>s+n.metrics.spend,0);
    alerts.push({sev:"High",type:"Demand Collapse Detected",icon:"ti-trending-down",color:"#d42b2b",border:"rgba(212,43,43,0.25)",bg:"rgba(212,43,43,0.05)",
      explain:`${collapsing.length} niches are losing demand rapidly. These are spending $${waste.toFixed(0)} total on declining traffic — continuing investment risks poor returns.`,
      action:"Reduce bids on collapsing niches. Reallocate budget to growing markets. Consider pausing lowest-priority terms.",
      items:collapsing.slice(0,6),confidence:85});
  }

  const cpcSurge=niches.filter(n=>n.cpcTrend.label==="Surging"&&n.metrics.orders===0&&n.metrics.spend>8);
  if(cpcSurge.length){
    alerts.push({sev:"High",type:"CPC Inflation — No Conversion Return",icon:"ti-currency-dollar",color:"#c47a00",border:"rgba(196,122,0,0.25)",bg:"rgba(196,122,0,0.05)",
      explain:`${cpcSurge.length} niches have surging CPC with zero orders. You're paying significantly more per click for traffic that doesn't convert — likely competitive bidding wars.`,
      action:"Cap bids on these terms. Add spend limits. Consider exiting the niche temporarily if CPC doesn't stabilize.",
      items:cpcSurge.slice(0,6),confidence:82});
  }

  const highCompLowOpp=niches.filter(n=>n.comp>=75&&n.opp<30&&n.metrics.spend>10);
  if(highCompLowOpp.length){
    alerts.push({sev:"Medium",type:"High Competition — Low Return Niches",icon:"ti-users",color:"#4f46e5",border:"rgba(79,70,229,0.2)",bg:"rgba(79,70,229,0.04)",
      explain:`${highCompLowOpp.length} niches show very high competitive pressure with poor opportunity scores. These are difficult markets where budget may be better deployed elsewhere.`,
      action:"Review ROI carefully. Reduce bids 15–25%. Consider pivoting to adjacent lower-competition niches.",
      items:highCompLowOpp.slice(0,6),confidence:76});
  }

  const emerging=niches.filter(n=>n.growth>=75&&n.comp<=45&&!n.compMetrics);
  if(emerging.length){
    alerts.push({sev:"Medium",type:"Emerging Niche — Act Early",icon:"ti-sparkles",color:"#6338c8",border:"rgba(99,56,200,0.2)",bg:"rgba(99,56,200,0.04)",
      explain:`${emerging.length} new keywords appeared this period with strong performance and no prior history. These may be emerging search trends — early entry before competition builds is highly valuable.`,
      action:"Test bids on emerging terms. Add to broad match for discovery. Monitor closely for conversion signal before scaling.",
      items:emerging.slice(0,6),confidence:70});
  }

  if(!alerts.length) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No critical niche alerts. Markets look stable based on current data.</span>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {alerts.map((a,i)=>(
        <div key={i} style={{background:a.bg,borderRadius:12,border:`1px solid ${a.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <i className={`ti ${a.icon}`} style={{fontSize:14,color:a.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:a.color}}>{a.sev} — {a.type}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Confidence: {a.confidence}%</span>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{a.explain}</div>
          <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px",marginBottom:8}}>
            <i className="ti ti-bulb" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>
            <strong>Action: </strong>{a.action}
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {a.items.map((n,j)=>(
              <span key={j} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(255,255,255,0.7)",color:a.color,fontWeight:600,border:`1px solid ${a.border}`}}>{n.kw}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/* Niche table */
function NDTable({niches,onExport}){
  const[sort,setSort]=useState("opp");
  const[filter,setFilter]=useState("all");
  const[search,setSearch]=useState("");

  const filtered=niches.filter(n=>{
    if(search&&!n.kw.toLowerCase().includes(search.toLowerCase())) return false;
    if(filter==="surging"&&n.impTrend.label!=="Surging") return false;
    if(filter==="growing"&&!["Surging","Growing"].includes(n.impTrend.label)) return false;
    if(filter==="declining"&&!["Declining","Collapsing"].includes(n.impTrend.label)) return false;
    if(filter==="highcomp"&&n.comp<65) return false;
    if(filter==="lowcomp"&&n.comp>45) return false;
    if(filter==="opportunity"&&n.opp<60) return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="opp")    return b.opp-a.opp;
    if(sort==="growth") return b.growth-a.growth;
    if(sort==="comp")   return b.comp-a.comp;
    if(sort==="spend")  return b.metrics.spend-a.metrics.spend;
    if(sort==="imp")    return b.metrics.impressions-a.metrics.impressions;
    if(sort==="cpc")    return b.metrics.cpc-a.metrics.cpc;
    return 0;
  });

  function suggestAction(n){
    if(n.impTrend.label==="Surging"&&n.opp>=60) return "Scale now";
    if(n.impTrend.label==="Collapsing") return "Reduce bids";
    if(n.comp>=75&&n.opp<35) return "Exit / Review";
    if(n.opp>=60&&n.comp<50) return "Dominate";
    if(!n.compMetrics) return "Test & watch";
    return "Monitor";
  }

  const ScoreBar=({val,color})=>(
    <div style={{display:"flex",alignItems:"center",gap:5}}>
      <div style={{width:36,height:5,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
        <div style={{width:`${val}%`,height:"100%",background:color}}/>
      </div>
      <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{val}</span>
    </div>
  );

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search keywords..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:190}}/>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {[
            {key:"all",label:"All"},
            {key:"surging",label:"Surging"},
            {key:"growing",label:"Growing"},
            {key:"declining",label:"Declining"},
            {key:"highcomp",label:"High Comp"},
            {key:"lowcomp",label:"Low Comp"},
            {key:"opportunity",label:"High Opp"},
          ].map(f=>(
            <button key={f.key} onClick={()=>setFilter(f.key)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${filter===f.key?"#6338c8":"#e0e0e0"}`,background:filter===f.key?"#6338c8":"#fff",color:filter===f.key?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer"}}>{f.label}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="opp">Sort: Opportunity</option>
          <option value="growth">Sort: Growth</option>
          <option value="comp">Sort: Competition</option>
          <option value="spend">Sort: Spend</option>
          <option value="imp">Sort: Impressions</option>
          <option value="cpc">Sort: CPC</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}><i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})</button>
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Keyword / Niche","Demand Trend","Growth","Competition","Opp. Score","Impressions","CPC Trend","Spend","Orders","Action"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,200).map((n,i)=>{
              const m=n.metrics; const compM=n.compMetrics;
              const action=suggestAction(n);
              const actionColor=action==="Scale now"?"#1a7a3c":action==="Reduce bids"?"#d42b2b":action==="Dominate"?"#6338c8":action==="Exit / Review"?"#c47a00":"#555";
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={n.kw}>{n.kw}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:10,padding:"2px 7px",borderRadius:4,background:`${n.impTrend.color}14`,color:n.impTrend.color,fontWeight:700,whiteSpace:"nowrap"}}>
                      <i className={`ti ${n.impTrend.icon}`} style={{fontSize:10}}/>{n.impTrend.label}
                    </span>
                    {compM&&<div style={{fontSize:10,color:m.impressions>compM.impressions?"#1a7a3c":"#d42b2b",marginTop:2}}>
                      {m.impressions>compM.impressions?"+":""}{compM.impressions>0?((m.impressions-compM.impressions)/compM.impressions*100).toFixed(0):"+∞"}%
                    </div>}
                  </td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={n.growth} color={n.growth>=70?"#1a7a3c":n.growth>=45?"#c47a00":"#d42b2b"}/></td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={n.comp} color={n.comp>=70?"#d42b2b":n.comp>=45?"#c47a00":"#1a7a3c"}/></td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={n.opp} color={n.opp>=65?"#6338c8":n.opp>=40?"#1a5fa0":"#888"}/></td>
                  <td style={{padding:"8px 10px",color:"#555"}}>
                    {m.impressions>=1000?`${(m.impressions/1000).toFixed(1)}K`:m.impressions}
                    {compM&&<div style={{fontSize:10,color:m.impressions>compM.impressions?"#1a7a3c":"#d42b2b"}}>{m.impressions>compM.impressions?"+":""}{compM.impressions>0?((m.impressions-compM.impressions)/compM.impressions*100).toFixed(0):"+∞"}%</div>}
                  </td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:3,fontSize:10,color:n.cpcTrend.color,fontWeight:600}}>
                      <i className={`ti ${n.cpcTrend.icon}`} style={{fontSize:10}}/>${m.cpc.toFixed(2)}
                    </span>
                    {compM&&<div style={{fontSize:10,color:m.cpc>compM.cpc?"#d42b2b":"#1a7a3c"}}>{m.cpc>compM.cpc?"+":""}{compM.cpc>0?((m.cpc-compM.cpc)/compM.cpc*100).toFixed(0):"+∞"}%</div>}
                  </td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.spend.toFixed(2)}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:m.orders>0?"#1a7a3c":"#888"}}>{m.orders}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:`${actionColor}12`,color:actionColor,fontWeight:700,whiteSpace:"nowrap"}}>{action}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>200&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 200 of {sorted.length} niches</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No niches match this filter.</div>}
      </div>
    </div>
  );
}

/* Opportunity engine */
function NDOpportunities({niches}){
  const opps=[
    {
      title:"Emerging Niches — Enter Before Competition Builds",icon:"ti-sparkles",color:"#6338c8",
      items:niches.filter(n=>n.impTrend.label==="Surging"&&n.comp<=50&&n.opp>=55).slice(0,8),
      why:"These niches are growing fast but competition is still low. This window of low-competition high-demand is the most valuable moment to enter.",
      action:"Launch campaigns immediately. Use broad match to capture full niche traffic. Scale bids aggressively before competitors notice.",
      impact:"Market share gain at low cost. First-mover advantage on growing search trends."
    },
    {
      title:"Niche Domination — Scale Winners",icon:"ti-rocket",color:"#1a7a3c",
      items:niches.filter(n=>n.opp>=70&&n.metrics.orders>0&&n.metrics.acos<30).slice(0,8),
      why:"These niches convert efficiently and have room to grow. Scaling here captures more of an already-proven market.",
      action:"Increase bids 20–35%. Add phrase and broad variants. Expand to adjacent related keywords.",
      impact:"Revenue growth in proven niches. ACoS stays controlled while volume scales."
    },
    {
      title:"Low Competition — Easy Entry Opportunities",icon:"ti-target",color:"#1a5fa0",
      items:niches.filter(n=>n.comp<=35&&n.metrics.impressions>100).slice(0,8),
      why:"These niches have minimal competition pressure. Lower bids are needed to win visibility, making them highly cost-efficient.",
      action:"Enter at conservative bids. Test CVR before scaling. These are 'low hanging fruit' in terms of CPC efficiency.",
      impact:"Low-cost traffic acquisition. High ROI potential from underserved niches."
    },
    {
      title:"Fast Ranking — Organic Growth Potential",icon:"ti-trending-up",color:"#4f46e5",
      items:niches.filter(n=>n.growth>=70&&n.metrics.acos<35&&n.metrics.orders>0).slice(0,8),
      why:"These niches are growing and converting, meaning PPC investment here also builds organic rank. Dual benefit from every dollar spent.",
      action:"Scale bids specifically on these terms. Add TOS modifier. Track organic rank improvement over 30-day windows.",
      impact:"PPC + organic rank improvement. Long-term reduction in PPC dependency."
    },
    {
      title:"Seasonal Expansion — Trend Intelligence",icon:"ti-calendar-event",color:"#c47a00",
      items:niches.filter(n=>n.impTrend.label==="Surging"&&!n.compMetrics).slice(0,8),
      why:"These keywords appeared or surged this period without prior history. May indicate seasonal or trend-driven demand. Early capture is critical.",
      action:"Test immediately. Add to discovery campaigns. Monitor for 2 weeks before committing to exact match.",
      impact:"Capture seasonal demand peaks before competitors react."
    },
  ].filter(o=>o.items.length>0);

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {opps.map((opp,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid rgba(0,0,0,0.06)",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:32,height:32,borderRadius:9,background:`${opp.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${opp.icon}`} style={{fontSize:15,color:opp.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{opp.title}</div>
            <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{opp.items.length} niches</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{opp.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Action: </strong>{opp.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Impact: </strong>{opp.impact}</div>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {opp.items.map((n,j)=>(
              <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${opp.color}10`,color:opp.color,fontWeight:600,border:`1px solid ${opp.color}30`}}>{n.kw}</span>
            ))}
          </div>
        </div>
      ))}
      {opps.length===0&&<div style={{padding:"24px",background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",textAlign:"center",fontSize:13,color:"#aaa"}}>No major opportunities detected with current data. Upload comparison period data for deeper intelligence.</div>}
    </div>
  );
}

/* Market trend analysis */
function NDTrends({niches}){
  const surging=niches.filter(n=>n.impTrend.label==="Surging");
  const growing=niches.filter(n=>n.impTrend.label==="Growing");
  const declining=niches.filter(n=>n.impTrend.label==="Declining");
  const collapsing=niches.filter(n=>n.impTrend.label==="Collapsing");
  const stable=niches.filter(n=>n.impTrend.label==="Stable");

  const trendGroups=[
    {label:"Surging",items:surging,color:"#1a7a3c",bg:"rgba(26,122,60,0.05)",border:"rgba(26,122,60,0.2)",icon:"ti-trending-up",desc:"Impression growth >25% vs previous period"},
    {label:"Growing",items:growing,color:"#2a9a50",bg:"rgba(42,154,80,0.05)",border:"rgba(42,154,80,0.15)",icon:"ti-arrow-up-right",desc:"Impression growth 8–25% vs previous period"},
    {label:"Stable", items:stable, color:"#1a5fa0",bg:"rgba(26,95,160,0.05)",border:"rgba(26,95,160,0.15)",icon:"ti-minus",desc:"Within ±8% of previous period"},
    {label:"Declining",items:declining,color:"#c47a00",bg:"rgba(196,122,0,0.05)",border:"rgba(196,122,0,0.2)",icon:"ti-arrow-down-right",desc:"Impression loss 8–25% vs previous period"},
    {label:"Collapsing",items:collapsing,color:"#d42b2b",bg:"rgba(212,43,43,0.05)",border:"rgba(212,43,43,0.2)",icon:"ti-trending-down",desc:"Impression loss >25% vs previous period"},
  ];

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {/* Distribution summary */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:8,marginBottom:16}}>
        {trendGroups.map(g=>(
          <div key={g.label} style={{background:g.bg,borderRadius:10,border:`1px solid ${g.border}`,padding:"12px 14px",textAlign:"center"}}>
            <i className={`ti ${g.icon}`} style={{fontSize:16,color:g.color,display:"block",marginBottom:6}}/>
            <div style={{fontSize:20,fontWeight:800,color:g.color,marginBottom:3}}>{g.items.length}</div>
            <div style={{fontSize:11,fontWeight:600,color:g.color}}>{g.label}</div>
          </div>
        ))}
      </div>

      {/* Trend detail panels */}
      {trendGroups.filter(g=>g.items.length>0).map((g,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:`1px solid ${g.border}`,padding:"14px 18px",marginBottom:10}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
            <i className={`ti ${g.icon}`} style={{fontSize:14,color:g.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:g.color}}>{g.label} ({g.items.length})</span>
            <span style={{fontSize:11,color:"#aaa",marginLeft:6}}>{g.desc}</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            {g.items.slice(0,8).map((n,j)=>(
              <div key={j} style={{display:"flex",alignItems:"center",gap:12,padding:"7px 10px",background:"#fafafa",borderRadius:7,border:"1px solid #f0f0f0"}}>
                <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{n.kw}</span>
                <span style={{fontSize:11,color:"#888"}}>Opp: <strong style={{color:"#111"}}>{n.opp}</strong></span>
                <span style={{fontSize:11,color:"#888"}}>Comp: <strong style={{color:n.comp>=70?"#d42b2b":n.comp>=45?"#c47a00":"#1a7a3c"}}>{n.comp}</strong></span>
                <span style={{fontSize:11,color:"#555"}}>${n.metrics.cpc.toFixed(2)} CPC</span>
                <span style={{fontSize:11,color:n.metrics.orders>0?"#1a7a3c":"#888"}}>{n.metrics.orders} orders</span>
              </div>
            ))}
            {g.items.length>8&&<div style={{fontSize:11,color:"#aaa",textAlign:"center",padding:"5px"}}>+{g.items.length-8} more {g.label.toLowerCase()} niches</div>}
          </div>
        </div>
      ))}
    </div>
  );
}

/* AI assistant */
function NDAIAssistant({niches}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  const surging=niches.filter(n=>n.impTrend.label==="Surging");
  const collapsing=niches.filter(n=>n.impTrend.label==="Collapsing");
  const highOpp=niches.filter(n=>n.opp>=65);
  const avgCpc=niches.length?niches.reduce((s,n)=>s+n.metrics.cpc,0)/niches.length:0;
  const cpcRising=niches.filter(n=>n.cpcTrend.label==="Surging"||n.cpcTrend.label==="Growing");

  async function runAnalysis(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);
    const prompt=`You are a senior Amazon PPC market intelligence strategist. Based ONLY on the niche data below, give 5 strategic market insights. Be specific about which niches to act on.

DATA:
- Total niches analysed: ${niches.length}
- Surging niches (demand up 25%+): ${surging.length}
- Collapsing niches (demand down 25%+): ${collapsing.length}
- High opportunity niches (score ≥65): ${highOpp.length}
- Average CPC: $${avgCpc.toFixed(2)}
- CPC inflating niches: ${cpcRising.length}
- Top surging niches: ${surging.slice(0,5).map(n=>`"${n.kw}" (opp:${n.opp}, comp:${n.comp})`).join(", ")}
- Top collapsing niches: ${collapsing.slice(0,4).map(n=>`"${n.kw}" ($${n.metrics.spend.toFixed(0)} spend)`).join(", ")}
- Top opportunities: ${highOpp.slice(0,4).map(n=>`"${n.kw}" (score:${n.opp})`).join(", ")}

Respond in JSON ONLY (no markdown, no backticks):
{"insights":[{"priority":"Critical|High|Medium","title":"...","analysis":"...","action":"...","expectedImpact":"..."}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.3,maxOutputTokens:1200}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key."});}
    setLoading(false);
  }

  const prioColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#6338c8"};
  return(
    <div style={{maxWidth:800}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>AI Niche Intelligence (Gemini)</div>
        <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analysing...</>:<><i className="ti ti-brain" style={{fontSize:13}}/>Analyse Niches</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>
      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b"}}>{result.error}</div>}
      {result?.insights&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.insights.map((ins,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:`${prioColor[ins.priority]||"#888"}18`,color:prioColor[ins.priority]||"#888",fontWeight:700}}>{ins.priority}</span>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{ins.title}</span>
              </div>
              <div style={{fontSize:12,color:"#555",lineHeight:1.5,marginBottom:6}}>{ins.analysis}</div>
              <div style={{fontSize:12,color:"#444",marginBottom:6}}><strong>Action: </strong>{ins.action}</div>
              <div style={{fontSize:11,background:"rgba(99,56,200,0.06)",borderRadius:7,padding:"6px 10px",color:"#6338c8"}}><i className="ti ti-trending-up" style={{fontSize:11,marginRight:4}}/>Expected: {ins.expectedImpact}</div>
            </div>
          ))}
        </div>
      )}
      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"24px",textAlign:"center"}}>
          <i className="ti ti-telescope" style={{fontSize:28,color:"#ddd",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,color:"#aaa"}}>Enter your Gemini key and click Analyse Niches.<br/>AI explains market trends and strategic opportunities from your actual search data.</div>
        </div>
      )}
    </div>
  );
}

/* Export */
function ndExport(niches, type){
  const map={
    all:niches,
    opportunities:niches.filter(n=>n.opp>=60),
    surging:niches.filter(n=>n.impTrend.label==="Surging"||n.impTrend.label==="Growing"),
    declining:niches.filter(n=>n.impTrend.label==="Declining"||n.impTrend.label==="Collapsing"),
    lowcomp:niches.filter(n=>n.comp<=40),
    scaling:niches.filter(n=>n.opp>=65&&n.metrics.orders>0),
  };
  const rows=(map[type]||niches).map(n=>({
    "Keyword / Niche":n.kw,"Campaign":n.campaign,
    "Demand Trend":n.impTrend.label,"Growth Score":n.growth,
    "Competition Score":n.comp,"Opportunity Score":n.opp,
    "CPC Trend":n.cpcTrend.label,"CPC ($)":n.metrics.cpc.toFixed(2),
    "Impressions":n.metrics.impressions,"Clicks":n.metrics.clicks,
    "Spend ($)":n.metrics.spend.toFixed(2),"Sales ($)":n.metrics.sales.toFixed(2),
    "Orders":n.metrics.orders,"ACoS (%)":n.metrics.acos.toFixed(1),
    "Prev Impressions":n.compMetrics?n.compMetrics.impressions:"—",
    "Prev CPC":n.compMetrics?n.compMetrics.cpc.toFixed(2):"—",
    "Suggested Action":n.impTrend.label==="Surging"&&n.opp>=60?"Scale Now":n.impTrend.label==="Collapsing"?"Reduce Bids":n.comp<=40?"Enter Niche":n.opp>=65?"Dominate":"Monitor"
  }));
  if(!rows.length){alert("No data for this export.");return;}
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:18}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Niche Dives");
  XLSX.writeFile(wb,`niche_dives_${type}_${Date.now()}.xlsx`);
}

/* ── Niche Dives Module Root ────────────────────────────────── */
function NicheDivesModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("overview");

  const rows=globalData?.cur?.searchterm?.rows||globalData?.cur?.primary?.rows||globalData?.cur?.sqp?.rows||[];
  const cm=globalData?.cur?.searchterm?.cm||globalData?.cur?.primary?.cm||globalData?.cur?.sqp?.cm||{};
  const compRows=globalData?.comp?.searchterm?.rows||globalData?.comp?.primary?.rows||[];
  const compCm=globalData?.comp?.searchterm?.cm||globalData?.comp?.primary?.cm||{};
  const hasData=rows.length>0&&(cm.searchTerm||cm.keyword||cm.query);

  const niches=useMemo(()=>hasData?ndProcessRows(rows,cm,compRows,compCm):[],[rows,cm,hasData]);

  const tabs=[
    {key:"overview",     label:"Overview",       icon:"ti-layout-dashboard"},
    {key:"alerts",       label:"Alerts",         icon:"ti-alert-circle",  badge:niches.filter(n=>n.impTrend.label==="Surging"||n.impTrend.label==="Collapsing").length||null},
    {key:"table",        label:"Niche Table",    icon:"ti-table",         badge:niches.length||null},
    {key:"opportunities",label:"Opportunities",  icon:"ti-rocket"},
    {key:"trends",       label:"Market Trends",  icon:"ti-trending-up"},
    {key:"ai",           label:"AI Analysis",    icon:"ti-brain"},
    {key:"export",       label:"Export",         icon:"ti-download"},
  ];

  if(!hasData) return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-telescope" style={{fontSize:15,color:"#6338c8"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Niche Dives</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(99,56,200,0.1)",color:"#6338c8",fontWeight:700}}>Advanced</span>
      </div>
      <NDEmptyState onGoToHub={()=>setTab("hub")}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-telescope" style={{fontSize:15,color:"#6338c8"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Niche Dives</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(99,56,200,0.1)",color:"#6338c8",fontWeight:700}}>Advanced</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{niches.length} niches analysed</span>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#6338c8":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#6338c8":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#6338c8":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="overview"&&<div style={{maxWidth:960,margin:"0 auto"}}><NDOverview niches={niches}/></div>}
        {activeTab==="alerts"&&<div style={{maxWidth:860,margin:"0 auto"}}><NDAlerts niches={niches}/></div>}
        {activeTab==="table"&&<div style={{maxWidth:1100,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}><NDTable niches={niches} onExport={rows=>ndExport(rows,"all")}/></div>}
        {activeTab==="opportunities"&&<div style={{maxWidth:900,margin:"0 auto"}}><NDOpportunities niches={niches}/></div>}
        {activeTab==="trends"&&<NDTrends niches={niches}/>}
        {activeTab==="ai"&&<div style={{maxWidth:860,margin:"0 auto"}}><NDAIAssistant niches={niches}/></div>}
        {activeTab==="export"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Export Niche Intelligence</div>
              <div style={{fontSize:12,color:"#888",marginBottom:20}}>Each export includes niche keyword, demand trend, growth/competition/opportunity scores, comparison deltas, and suggested action.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {type:"all",          label:"Full Niche Report",     icon:"ti-table",          color:"#555",  count:niches.length},
                  {type:"opportunities",label:"High Opportunity",      icon:"ti-rocket",          color:"#6338c8",count:niches.filter(n=>n.opp>=60).length},
                  {type:"surging",      label:"Growing Niches",        icon:"ti-trending-up",    color:"#1a7a3c",count:niches.filter(n=>["Surging","Growing"].includes(n.impTrend.label)).length},
                  {type:"declining",    label:"Declining Niches",      icon:"ti-trending-down",  color:"#d42b2b",count:niches.filter(n=>["Declining","Collapsing"].includes(n.impTrend.label)).length},
                  {type:"lowcomp",      label:"Low Competition",       icon:"ti-target",          color:"#1a5fa0",count:niches.filter(n=>n.comp<=40).length},
                  {type:"scaling",      label:"Scale Candidates",      icon:"ti-arrow-up-right", color:"#4f46e5",count:niches.filter(n=>n.opp>=65&&n.metrics.orders>0).length},
                ].map(ex=>(
                  <div key={ex.type} style={{background:"#fafafa",borderRadius:10,border:"1px solid #eee",padding:"14px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
                      <div style={{width:30,height:30,borderRadius:8,background:`${ex.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${ex.icon}`} style={{fontSize:14,color:ex.color}}/>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ex.label}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{ex.count} niches</div>
                      </div>
                    </div>
                    <button onClick={()=>ndExport(niches,ex.type)} disabled={ex.count===0} style={{...T.btnR(ex.count>0),width:"100%",justifyContent:"center",fontSize:11,padding:"7px 0",opacity:ex.count===0?0.4:1}}>
                      <i className="ti ti-download" style={{fontSize:12}}/>Download ({ex.count})
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   SEASONAL ENGINE MODULE
   Seasonal PPC intelligence and demand shift system.
   Sections: Overview · Alerts · Analysis Table · Opportunities
             Trend Analysis · AI Assistant · Export
   No upload — syncs from Global Data Hub.
================================================================ */

/* ── Seasonal scoring helpers ───────────────────────────────── */
const SE_MONTHS=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

/* Detect seasonal phase based on impression momentum + period */
function sePhase(m, compM){
  if(!compM||!m) return{label:"Entering",color:"#6338c8",icon:"ti-sunrise"};
  const impDelta=compM.impressions>0?(m.impressions-compM.impressions)/compM.impressions*100:0;
  const salesDelta=compM.sales>0?(m.sales-compM.sales)/compM.sales*100:0;
  if(impDelta>30&&salesDelta>20) return{label:"Peak",color:"#1a7a3c",icon:"ti-trending-up"};
  if(impDelta>10)                return{label:"Rising",color:"#2a9a50",icon:"ti-arrow-up-right"};
  if(impDelta>-10&&impDelta<=10) return{label:"Stable",color:"#1a5fa0",icon:"ti-minus"};
  if(impDelta>-30)               return{label:"Declining",color:"#c47a00",icon:"ti-arrow-down-right"};
  return{label:"Off-Season",color:"#888",icon:"ti-moon"};
}

/* Growth score factoring impressions + sales + orders vs comp */
function seGrowthScore(m, compM){
  if(!compM) return 55;
  let s=50;
  if(compM.impressions>0){const d=(m.impressions-compM.impressions)/compM.impressions*100;s+=d>30?25:d>10?12:d<-20?-20:d<-10?-10:0;}
  if(compM.sales>0){const d=(m.sales-compM.sales)/compM.sales*100;s+=d>30?20:d>10?10:d<-20?-15:d<-10?-8:0;}
  if(compM.orders>0){const d=(m.orders-compM.orders)/compM.orders*100;s+=d>20?10:d<-20?-10:0;}
  return Math.max(0,Math.min(100,Math.round(s)));
}

/* Seasonal risk score — things that can go wrong */
function seRiskScore(m, compM){
  let s=20;
  if(compM&&m.acos>0&&compM.acos>0&&m.acos>compM.acos*1.3)s+=25;
  if(compM&&m.cpc>0&&compM.cpc>0&&m.cpc>compM.cpc*1.25)s+=20;
  if(compM&&m.cvr>0&&compM.cvr>0&&m.cvr<compM.cvr*0.75)s+=20;
  if(m.spend>0&&m.orders===0)s+=15;
  return Math.max(0,Math.min(100,Math.round(s)));
}

/* Opportunity score for seasonal scaling */
function seOppScore(growth, risk, m){
  let s=growth*0.5;
  s+=risk<30?15:risk<50?8:0;
  s+=m.orders>0?15:0;
  s+=m.acos>0&&m.acos<30?10:0;
  s+=m.impressions>0&&m.impressions<800&&m.orders>0?10:0;
  return Math.min(100,Math.round(s));
}

/* Build seasonal enriched rows */
function seProcessRows(rows, cm, compRows, compCm){
  if(!rows||!cm) return [];
  const compMap={};
  if(compRows&&compCm){
    compRows.forEach(r=>{
      const k=(r[compCm.campaign]||r[compCm.keyword]||r[compCm.searchTerm]||"").toLowerCase();
      if(k) compMap[k]=calcRowMetrics(r,compCm);
    });
  }
  const month=new Date().getMonth();
  return rows.map(row=>{
    const name=row[cm.campaign]||row[cm.keyword]||row[cm.searchTerm]||"Unknown";
    const m=calcRowMetrics(row,cm);
    if(m.spend<0.5&&m.impressions<20) return null;
    const compM=compMap[name.toLowerCase()]||null;
    const phase=sePhase(m,compM);
    const growth=seGrowthScore(m,compM);
    const risk=seRiskScore(m,compM);
    const opp=seOppScore(growth,risk,m);
    const cpcDelta=compM&&compM.cpc>0?((m.cpc-compM.cpc)/compM.cpc*100):0;
    const cvrDelta=compM&&compM.cvr>0?((m.cvr-compM.cvr)/compM.cvr*100):0;
    const impDelta=compM&&compM.impressions>0?((m.impressions-compM.impressions)/compM.impressions*100):0;
    return{name,metrics:m,compMetrics:compM,phase,growth,risk,opp,cpcDelta,cvrDelta,impDelta,currentMonth:month};
  }).filter(Boolean).sort((a,b)=>b.opp-a.opp);
}

/* ── Sub-components ─────────────────────────────────────────── */
function SEEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(196,122,0,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-calendar-event" style={{fontSize:26,color:"#c47a00"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Seasonal Engine needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:380,lineHeight:1.6,marginBottom:20}}>Upload a Campaign Report or Search Term Report with comparison period data in the Data Hub. Seasonal Engine detects demand shifts by comparing current vs previous period performance.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Overview */
function SEOverview({entities}){
  if(!entities.length) return null;
  const peak=entities.filter(e=>e.phase.label==="Peak").length;
  const rising=entities.filter(e=>e.phase.label==="Rising").length;
  const declining=entities.filter(e=>e.phase.label==="Declining"||e.phase.label==="Off-Season").length;
  const highOpp=entities.filter(e=>e.opp>=65).length;
  const highRisk=entities.filter(e=>e.risk>=55).length;
  const avgGrowth=Math.round(entities.reduce((s,e)=>s+e.growth,0)/entities.length);
  const month=SE_MONTHS[new Date().getMonth()];

  const cards=[
    {label:"Peak Season Entities", val:peak,     sub:"at maximum demand",        icon:"ti-trending-up",     color:"#1a7a3c"},
    {label:"Rising (Pre-Peak)",    val:rising,   sub:"entering growth phase",    icon:"ti-arrow-up-right",  color:"#2a9a50"},
    {label:"Declining / Off-Season",val:declining,sub:"demand weakening",         icon:"ti-trending-down",   color:"#888"},
    {label:"High Opportunity",     val:highOpp,  sub:"seasonal scale window",    icon:"ti-rocket",          color:"#6338c8"},
    {label:"High Seasonal Risk",   val:highRisk, sub:"efficiency under pressure",icon:"ti-alert-triangle",  color:"#d42b2b"},
    {label:"Avg Growth Score",     val:avgGrowth, sub:`current momentum (${month})`,icon:"ti-chart-bar",   color:"#c47a00"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
      {cards.map(c=>(
        <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
            </div>
            <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
          </div>
          <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:2}}>{c.val}</div>
          <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}

/* Seasonal phase distribution bar */
function SEPhaseDist({entities}){
  if(!entities.length) return null;
  const total=entities.length;
  const phases=[
    {label:"Peak",color:"#1a7a3c"},
    {label:"Rising",color:"#2a9a50"},
    {label:"Stable",color:"#1a5fa0"},
    {label:"Declining",color:"#c47a00"},
    {label:"Off-Season",color:"#888"},
    {label:"Entering",color:"#6338c8"},
  ];
  const counts={};
  phases.forEach(p=>{counts[p.label]=entities.filter(e=>e.phase.label===p.label).length;});
  return(
    <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 18px",marginBottom:14}}>
      <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>Seasonal Phase Distribution — {SE_MONTHS[new Date().getMonth()]} {new Date().getFullYear()}</div>
      <div style={{display:"flex",height:8,borderRadius:4,overflow:"hidden",marginBottom:10}}>
        {phases.map(p=>counts[p.label]>0?(
          <div key={p.label} title={`${p.label}: ${counts[p.label]}`} style={{width:`${(counts[p.label]/total)*100}%`,background:p.color,transition:"width 0.3s"}}/>
        ):null)}
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
        {phases.filter(p=>counts[p.label]>0).map(p=>(
          <div key={p.label} style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:"#555"}}>
            <span style={{width:8,height:8,borderRadius:2,background:p.color,display:"inline-block"}}/>
            {p.label} <span style={{color:"#aaa"}}>({counts[p.label]})</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* Alert engine */
function SEAlerts({entities}){
  const alerts=[];
  const month=SE_MONTHS[new Date().getMonth()];

  const surging=entities.filter(e=>e.phase.label==="Peak"&&e.opp>=60);
  if(surging.length){
    alerts.push({sev:"Critical",type:"Peak Demand — Scale Now",icon:"ti-trending-up",color:"#1a7a3c",border:"rgba(26,122,60,0.25)",bg:"rgba(26,122,60,0.05)",
      explain:`${surging.length} entities are in peak seasonal demand right now (${month}). This is the highest-revenue window — every day of under-investment is permanent lost opportunity.`,
      action:"Increase bids 25–40% immediately. Raise daily budgets. Ensure TOS placement is maximised. Don't let budgets cap during peak hours.",
      items:surging.slice(0,6),confidence:91});
  }

  const rising=entities.filter(e=>e.phase.label==="Rising"&&e.opp>=55);
  if(rising.length){
    alerts.push({sev:"High",type:"Pre-Season Rising — Enter Before Competitors",icon:"ti-arrow-up-right",color:"#2a9a50",border:"rgba(42,154,80,0.2)",bg:"rgba(42,154,80,0.05)",
      explain:`${rising.length} entities are entering a growth phase. Scaling now — before peak — builds organic rank, data density, and lower CPCs before competitors drive bids up.`,
      action:"Increase bids 15–25%. Launch broad discovery campaigns. Start building exact match data now so you're ready for peak.",
      items:rising.slice(0,6),confidence:85});
  }

  const cpcSpike=entities.filter(e=>e.cpcDelta>30&&e.metrics.spend>8);
  if(cpcSpike.length){
    alerts.push({sev:"High",type:"Seasonal CPC Inflation Detected",icon:"ti-currency-dollar",color:"#c47a00",border:"rgba(196,122,0,0.25)",bg:"rgba(196,122,0,0.05)",
      explain:`${cpcSpike.length} entities have CPC rising 30%+ vs previous period. Seasonal competition is driving auction prices up — protect profitability before it escalates further.`,
      action:"Set CPC caps via bid rules. Prioritise exact match to reduce waste at inflated CPCs. Shift budget to lower-competition adjacent terms.",
      items:cpcSpike.slice(0,6),confidence:83});
  }

  const declining=entities.filter(e=>(e.phase.label==="Declining"||e.phase.label==="Off-Season")&&e.metrics.spend>10);
  if(declining.length){
    const waste=declining.reduce((s,e)=>s+e.metrics.spend,0);
    alerts.push({sev:"Medium",type:"Seasonal Decline — Reduce Spend",icon:"ti-trending-down",color:"#888",border:"rgba(0,0,0,0.15)",bg:"rgba(0,0,0,0.03)",
      explain:`${declining.length} entities are entering or are in off-season, yet spending $${waste.toFixed(0)} total. Continuing full bids post-peak wastes budget better deployed on rising products.`,
      action:"Reduce bids 20–35% on off-season entities. Reallocate freed budget to peak/rising campaigns.",
      items:declining.slice(0,6),confidence:78});
  }

  const cvrDrop=entities.filter(e=>e.cvrDelta<-25&&e.metrics.clicks>15);
  if(cvrDrop.length){
    alerts.push({sev:"Medium",type:"Seasonal Conversion Shift — Buyer Behaviour Changing",icon:"ti-percentage",color:"#4f46e5",border:"rgba(79,70,229,0.2)",bg:"rgba(79,70,229,0.04)",
      explain:`${cvrDrop.length} entities show CVR declining 25%+ vs previous period. Seasonal buyer intent may be shifting — earlier in the season customers research more and buy less.`,
      action:"Review listing CVR. Check pricing vs seasonal competitors. Adjust creative and headline for seasonal messaging.",
      items:cvrDrop.slice(0,6),confidence:74});
  }

  if(!alerts.length) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No critical seasonal alerts with current data.</span>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {alerts.map((a,i)=>(
        <div key={i} style={{background:a.bg,borderRadius:12,border:`1px solid ${a.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <i className={`ti ${a.icon}`} style={{fontSize:14,color:a.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:a.color}}>{a.sev} — {a.type}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Confidence: {a.confidence}%</span>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{a.explain}</div>
          <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px",marginBottom:8}}>
            <i className="ti ti-bulb" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>
            <strong>Action: </strong>{a.action}
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {a.items.map((e,j)=>(
              <span key={j} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(255,255,255,0.7)",color:a.color,fontWeight:600,border:`1px solid ${a.border}`,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/* Seasonal analysis table */
function SETable({entities,onExport}){
  const[sort,setSort]=useState("opp");
  const[phaseFilter,setPhaseFilter]=useState("all");
  const[search,setSearch]=useState("");

  const filtered=entities.filter(e=>{
    if(search&&!e.name.toLowerCase().includes(search.toLowerCase())) return false;
    if(phaseFilter!=="all"&&e.phase.label.toLowerCase()!==phaseFilter) return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="opp")    return b.opp-a.opp;
    if(sort==="growth") return b.growth-a.growth;
    if(sort==="risk")   return b.risk-a.risk;
    if(sort==="spend")  return b.metrics.spend-a.metrics.spend;
    if(sort==="imp")    return b.impDelta-a.impDelta;
    return 0;
  });

  function suggestAction(e){
    if(e.phase.label==="Peak"&&e.opp>=60)        return "Max bids now";
    if(e.phase.label==="Rising")                  return "Scale pre-peak";
    if(e.phase.label==="Off-Season"&&e.metrics.spend>5) return "Reduce 30%";
    if(e.phase.label==="Declining")               return "Reduce 20%";
    if(e.risk>=60)                                return "Review risk";
    return "Monitor";
  }

  const ScoreBar=({val,color})=>(
    <div style={{display:"flex",alignItems:"center",gap:5}}>
      <div style={{width:34,height:5,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
        <div style={{width:`${val}%`,height:"100%",background:color}}/>
      </div>
      <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{val}</span>
    </div>
  );

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:180}}/>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {["all","peak","rising","stable","declining","off-season"].map(f=>(
            <button key={f} onClick={()=>setPhaseFilter(f)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${phaseFilter===f?"#c47a00":"#e0e0e0"}`,background:phaseFilter===f?"#c47a00":"#fff",color:phaseFilter===f?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer",textTransform:"capitalize"}}>{f}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="opp">Sort: Opportunity</option>
          <option value="growth">Sort: Growth</option>
          <option value="risk">Sort: Risk</option>
          <option value="spend">Sort: Spend</option>
          <option value="imp">Sort: Impression Δ</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}><i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})</button>
      </div>

      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Entity","Phase","Growth","Risk","Opp.","Imp. Δ","CPC Δ","CVR Δ","Spend","Orders","Action"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,150).map((e,i)=>{
              const action=suggestAction(e);
              const acColor=action==="Max bids now"?"#1a7a3c":action==="Scale pre-peak"?"#2a9a50":action.startsWith("Reduce")?"#c47a00":action==="Review risk"?"#d42b2b":"#555";
              const fmtDelta=(v,inv=false)=>{
                const color=v>5?(inv?"#d42b2b":"#1a7a3c"):v<-5?(inv?"#1a7a3c":"#d42b2b"):"#888";
                return<span style={{fontSize:11,color,fontWeight:600}}>{v>0?"+":""}{v.toFixed(0)}%</span>;
              };
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={e.name}>{e.name}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:10,padding:"2px 7px",borderRadius:4,background:`${e.phase.color}14`,color:e.phase.color,fontWeight:700,whiteSpace:"nowrap"}}>
                      <i className={`ti ${e.phase.icon}`} style={{fontSize:10}}/>{e.phase.label}
                    </span>
                  </td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={e.growth} color={e.growth>=70?"#1a7a3c":e.growth>=45?"#c47a00":"#d42b2b"}/></td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={e.risk} color={e.risk>=60?"#d42b2b":e.risk>=35?"#c47a00":"#1a7a3c"}/></td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={e.opp} color={e.opp>=65?"#6338c8":e.opp>=40?"#1a5fa0":"#888"}/></td>
                  <td style={{padding:"8px 10px"}}>{fmtDelta(e.impDelta)}</td>
                  <td style={{padding:"8px 10px"}}>{fmtDelta(e.cpcDelta,true)}</td>
                  <td style={{padding:"8px 10px"}}>{fmtDelta(e.cvrDelta)}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${e.metrics.spend.toFixed(2)}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:e.metrics.orders>0?"#1a7a3c":"#888"}}>{e.metrics.orders}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:`${acColor}12`,color:acColor,fontWeight:700,whiteSpace:"nowrap"}}>{action}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>150&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 150 of {sorted.length}</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No entities match this filter.</div>}
      </div>
    </div>
  );
}

/* Opportunity engine */
function SEOpportunities({entities}){
  const opps=[
    {
      title:"Pre-Season Scaling — Act Before Competitors",icon:"ti-arrow-up-right",color:"#2a9a50",
      items:entities.filter(e=>e.phase.label==="Rising"&&e.opp>=55).slice(0,8),
      why:"These entities are entering their growth phase. Scaling before peak builds organic rank and data density while CPCs are still reasonable.",
      action:"Increase bids 15–25% now. Launch exact match variants. Build campaign structure before peak traffic arrives.",
      impact:"Lower entry CPCs. Stronger rank position at peak. More data for bid optimisation."
    },
    {
      title:"Peak Demand — Maximise Right Now",icon:"ti-trending-up",color:"#1a7a3c",
      items:entities.filter(e=>e.phase.label==="Peak"&&e.opp>=50).slice(0,8),
      why:"These are in peak season. Every impression, click, and order at peak is worth more than off-season. Maximum investment now generates maximum annual ROI.",
      action:"Set maximum bids. Remove budget caps. Ensure 24h coverage. Prioritise TOS placement.",
      impact:"Maximum revenue in the highest-value window of the year."
    },
    {
      title:"Seasonal Budget Expansion Required",icon:"ti-cash",color:"#c47a00",
      items:entities.filter(e=>(e.phase.label==="Rising"||e.phase.label==="Peak")&&e.metrics.orders>0&&e.metrics.acos<35).slice(0,8),
      why:"These profitable seasonal entities likely hit budget caps during peak hours. Increasing budget ensures they run all day during high-demand periods.",
      action:"Increase daily budget 40–60%. Monitor impression share. Set portfolio budget rules if using portfolio campaigns.",
      impact:"Eliminate budget-constrained visibility loss during peak demand hours."
    },
    {
      title:"Ranking Opportunity — Build Before Peak",icon:"ti-rocket",color:"#6338c8",
      items:entities.filter(e=>e.phase.label==="Entering"&&e.metrics.orders>0).slice(0,8),
      why:"These keywords are entering their seasonal demand curve. PPC investment now builds organic rank so you capture free traffic at peak without entirely relying on paid.",
      action:"Scale bids aggressively on these terms. Add TOS modifier +40–60%. Target Page 1 rank within 3–4 weeks.",
      impact:"Organic rank improvement means lower ACoS at peak and sustainable long-term traffic."
    },
    {
      title:"Post-Season Efficiency — Reduce Safely",icon:"ti-trending-down",color:"#888",
      items:entities.filter(e=>(e.phase.label==="Declining"||e.phase.label==="Off-Season")&&e.metrics.spend>8).slice(0,8),
      why:"These entities are leaving their peak. Continuing aggressive bids post-season burns budget on declining traffic and inflated CPCs without proportional return.",
      action:"Reduce bids 20–35%. Lower daily budgets. Reallocate freed budget to rising entities.",
      impact:"Budget efficiency improvement. Preserved capital for next seasonal cycle."
    },
    {
      title:"Seasonal Visibility Defence — Protect Your Market",icon:"ti-shield",color:"#4f46e5",
      items:entities.filter(e=>e.phase.label==="Peak"&&e.impDelta<0).slice(0,6),
      why:"These are at seasonal peak but losing impression share. Competitors are scaling aggressively. Losing visibility during peak costs disproportionately more than any other time.",
      action:"Emergency bid increase. Check budget cap. Add TOS modifier. Ensure branded terms are fully covered.",
      impact:"Recaptured seasonal market share. Prevent competitors from dominating your peak window."
    },
  ].filter(o=>o.items.length>0);

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {opps.map((opp,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid rgba(0,0,0,0.06)",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:32,height:32,borderRadius:9,background:`${opp.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${opp.icon}`} style={{fontSize:15,color:opp.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{opp.title}</div>
            <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{opp.items.length} entities</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{opp.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Action: </strong>{opp.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Impact: </strong>{opp.impact}</div>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {opp.items.map((e,j)=>(
              <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${opp.color}10`,color:opp.color,fontWeight:600,border:`1px solid ${opp.color}30`,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
            ))}
          </div>
          {opp.items.length===0&&<div style={{fontSize:11,color:"#bbb",fontStyle:"italic"}}>No entities match this opportunity with current data.</div>}
        </div>
      ))}
      {opps.length===0&&<div style={{padding:"24px",background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",textAlign:"center",fontSize:13,color:"#aaa"}}>Upload comparison period data in the Data Hub for full seasonal opportunity detection.</div>}
    </div>
  );
}

/* Trend analysis */
function SETrends({entities}){
  const phases=["Peak","Rising","Entering","Stable","Declining","Off-Season"];
  const phaseColors={"Peak":"#1a7a3c","Rising":"#2a9a50","Entering":"#6338c8","Stable":"#1a5fa0","Declining":"#c47a00","Off-Season":"#888"};
  const grouped={};
  phases.forEach(p=>{grouped[p]=entities.filter(e=>e.phase.label===p);});

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {/* Phase counts */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:16}}>
        {phases.map(p=>{
          const count=grouped[p].length;
          const color=phaseColors[p];
          const avgOpp=count?Math.round(grouped[p].reduce((s,e)=>s+e.opp,0)/count):0;
          return(
            <div key={p} style={{background:"#fff",borderRadius:10,border:`1.5px solid ${color}28`,padding:"12px 16px"}}>
              <div style={{fontSize:11,fontWeight:600,color,marginBottom:4}}>{p}</div>
              <div style={{fontSize:24,fontWeight:800,color:"#111",marginBottom:3}}>{count}</div>
              <div style={{fontSize:11,color:"#aaa"}}>Avg opp: {avgOpp}</div>
            </div>
          );
        })}
      </div>

      {/* Month context */}
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 18px",marginBottom:12}}>
        <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>
          Current Month Context — {SE_MONTHS[new Date().getMonth()]} {new Date().getFullYear()}
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {SE_MONTHS.map((m,i)=>{
            const isCurrent=i===new Date().getMonth();
            return(
              <div key={m} style={{padding:"5px 10px",borderRadius:6,background:isCurrent?"#4f46e5":"#fafafa",border:`1px solid ${isCurrent?"#4f46e5":"#eee"}`,fontSize:11,fontWeight:isCurrent?700:400,color:isCurrent?"#fff":"#555"}}>
                {m}
              </div>
            );
          })}
        </div>
        <div style={{fontSize:11,color:"#888",marginTop:8}}>Seasonal intelligence is most accurate when comparison period data covers the same calendar period from a previous year or season.</div>
      </div>

      {/* Phase detail lists */}
      {phases.filter(p=>grouped[p].length>0).map(p=>(
        <div key={p} style={{background:"#fff",borderRadius:12,border:`1px solid ${phaseColors[p]}28`,padding:"14px 18px",marginBottom:10}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
            <span style={{fontSize:13,fontWeight:700,color:phaseColors[p]}}>{p} ({grouped[p].length})</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            {grouped[p].slice(0,8).map((e,j)=>(
              <div key={j} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 10px",background:"#fafafa",borderRadius:7,border:"1px solid #f0f0f0"}}>
                <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
                <span style={{fontSize:11,color:"#888"}}>Opp: <strong style={{color:"#111"}}>{e.opp}</strong></span>
                <span style={{fontSize:11,color:"#888"}}>Risk: <strong style={{color:e.risk>=60?"#d42b2b":e.risk>=35?"#c47a00":"#1a7a3c"}}>{e.risk}</strong></span>
                <span style={{fontSize:11,color:e.impDelta>0?"#1a7a3c":"#d42b2b",fontWeight:600}}>{e.impDelta>0?"+":""}{e.impDelta.toFixed(0)}% imp</span>
                <span style={{fontSize:11,color:"#555"}}>${e.metrics.spend.toFixed(0)}</span>
              </div>
            ))}
            {grouped[p].length>8&&<div style={{fontSize:11,color:"#aaa",textAlign:"center",padding:"5px"}}>+{grouped[p].length-8} more</div>}
          </div>
        </div>
      ))}
    </div>
  );
}

/* AI assistant */
function SEAIAssistant({entities}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  const peak=entities.filter(e=>e.phase.label==="Peak");
  const rising=entities.filter(e=>e.phase.label==="Rising");
  const declining=entities.filter(e=>e.phase.label==="Declining"||e.phase.label==="Off-Season");
  const highRisk=entities.filter(e=>e.risk>=60);
  const month=SE_MONTHS[new Date().getMonth()];

  async function runAnalysis(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);
    const prompt=`You are a senior Amazon PPC seasonal strategy expert. Based ONLY on the seasonal data below, give 5 strategic seasonal recommendations for right now (${month}). Be specific about timing and urgency.

CURRENT SEASONAL DATA:
- Month: ${month} ${new Date().getFullYear()}
- Total entities: ${entities.length}
- Peak season entities: ${peak.length}
- Rising / pre-peak: ${rising.length}
- Declining / off-season: ${declining.length}
- High seasonal risk: ${highRisk.length}
- Top peak entities: ${peak.slice(0,4).map(e=>`"${e.name}" (opp:${e.opp}, spend:$${e.metrics.spend.toFixed(0)})`).join(", ")}
- Top rising entities: ${rising.slice(0,4).map(e=>`"${e.name}" (growth:${e.growth})`).join(", ")}
- Top at-risk entities: ${highRisk.slice(0,3).map(e=>`"${e.name}" (risk:${e.risk})`).join(", ")}
- Avg impression delta: ${entities.length?Math.round(entities.reduce((s,e)=>s+e.impDelta,0)/entities.length):0}%
- Avg CPC delta: ${entities.length?Math.round(entities.reduce((s,e)=>s+e.cpcDelta,0)/entities.length):0}%

Respond in JSON ONLY (no markdown, no backticks):
{"insights":[{"priority":"Critical|High|Medium","title":"...","rationale":"...","action":"...","timing":"..."}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.3,maxOutputTokens:1200}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key."});}
    setLoading(false);
  }

  const prioColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#6338c8"};
  return(
    <div style={{maxWidth:800}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:4}}>AI Seasonal Intelligence (Gemini)</div>
        <div style={{fontSize:11,color:"#888",marginBottom:12}}>Analysis tuned for <strong>{SE_MONTHS[new Date().getMonth()]} {new Date().getFullYear()}</strong> — all insights calibrated to current month context.</div>
        <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Analysing...</>:<><i className="ti ti-brain" style={{fontSize:13}}/>Analyse Season</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>
      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b"}}>{result.error}</div>}
      {result?.insights&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.insights.map((ins,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:`${prioColor[ins.priority]||"#888"}18`,color:prioColor[ins.priority]||"#888",fontWeight:700}}>{ins.priority}</span>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{ins.title}</span>
              </div>
              <div style={{fontSize:12,color:"#555",lineHeight:1.5,marginBottom:6}}>{ins.rationale}</div>
              <div style={{fontSize:12,color:"#444",marginBottom:6}}><strong>Action: </strong>{ins.action}</div>
              <div style={{fontSize:11,background:"rgba(196,122,0,0.06)",borderRadius:7,padding:"6px 10px",color:"#c47a00"}}><i className="ti ti-clock" style={{fontSize:11,marginRight:4}}/>Timing: {ins.timing}</div>
            </div>
          ))}
        </div>
      )}
      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"24px",textAlign:"center"}}>
          <i className="ti ti-calendar-event" style={{fontSize:28,color:"#ddd",display:"block",marginBottom:8}}/>
          <div style={{fontSize:13,color:"#aaa"}}>Enter your Gemini key and click Analyse Season.<br/>AI gives month-specific seasonal strategy based on your actual performance data.</div>
        </div>
      )}
    </div>
  );
}

/* Export */
function seExport(entities, type){
  const map={
    all:entities,
    peak:entities.filter(e=>e.phase.label==="Peak"),
    scaling:entities.filter(e=>e.phase.label==="Rising"||e.phase.label==="Entering"),
    reduce:entities.filter(e=>e.phase.label==="Declining"||e.phase.label==="Off-Season"),
    risk:entities.filter(e=>e.risk>=55),
    opportunities:entities.filter(e=>e.opp>=60),
  };
  const rows=(map[type]||entities).map(e=>({
    "Entity":e.name,"Seasonal Phase":e.phase.label,
    "Growth Score":e.growth,"Risk Score":e.risk,"Opportunity Score":e.opp,
    "Impression Δ (%)":e.impDelta.toFixed(1),"CPC Δ (%)":e.cpcDelta.toFixed(1),"CVR Δ (%)":e.cvrDelta.toFixed(1),
    "Spend ($)":e.metrics.spend.toFixed(2),"Sales ($)":e.metrics.sales.toFixed(2),
    "Orders":e.metrics.orders,"ACoS (%)":e.metrics.acos.toFixed(1),"CPC ($)":e.metrics.cpc.toFixed(2),
    "Prev Spend":e.compMetrics?e.compMetrics.spend.toFixed(2):"—",
    "Prev Impressions":e.compMetrics?e.compMetrics.impressions:"—",
    "Suggested Action":e.phase.label==="Peak"&&e.opp>=60?"Max Bids Now":e.phase.label==="Rising"?"Scale Pre-Peak":e.phase.label==="Off-Season"?"Reduce 30%":e.phase.label==="Declining"?"Reduce 20%":"Monitor"
  }));
  if(!rows.length){alert("No data for this export.");return;}
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:18}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Seasonal Engine");
  XLSX.writeFile(wb,`seasonal_engine_${type}_${Date.now()}.xlsx`);
}

/* ── Seasonal Engine Module Root ────────────────────────────── */
function SeasonalEngineModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("overview");

  const rows=globalData?.cur?.campaign?.rows||globalData?.cur?.primary?.rows||globalData?.cur?.searchterm?.rows||[];
  const cm=globalData?.cur?.campaign?.cm||globalData?.cur?.primary?.cm||globalData?.cur?.searchterm?.cm||{};
  const compRows=globalData?.comp?.campaign?.rows||globalData?.comp?.primary?.rows||globalData?.comp?.searchterm?.rows||[];
  const compCm=globalData?.comp?.campaign?.cm||globalData?.comp?.primary?.cm||globalData?.comp?.searchterm?.cm||{};
  const hasData=rows.length>0;

  const entities=useMemo(()=>hasData?seProcessRows(rows,cm,compRows,compCm):[],[rows,cm,hasData]);

  const tabs=[
    {key:"overview",     label:"Overview",      icon:"ti-layout-dashboard"},
    {key:"alerts",       label:"Alerts",        icon:"ti-alert-circle",  badge:entities.filter(e=>e.phase.label==="Peak"&&e.opp>=60).length||null},
    {key:"table",        label:"Analysis",      icon:"ti-table",         badge:entities.length||null},
    {key:"opportunities",label:"Opportunities", icon:"ti-rocket"},
    {key:"trends",       label:"Trends",        icon:"ti-trending-up"},
    {key:"ai",           label:"AI Analysis",   icon:"ti-brain"},
    {key:"export",       label:"Export",        icon:"ti-download"},
  ];

  if(!hasData) return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-calendar-event" style={{fontSize:15,color:"#c47a00"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Seasonal Engine</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(196,122,0,0.1)",color:"#c47a00",fontWeight:700}}>Advanced</span>
      </div>
      <SEEmptyState onGoToHub={()=>setTab("hub")}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-calendar-event" style={{fontSize:15,color:"#c47a00"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Seasonal Engine</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(196,122,0,0.1)",color:"#c47a00",fontWeight:700}}>Advanced</span>
        <span style={{fontSize:11,color:"#aaa",marginLeft:4}}>{SE_MONTHS[new Date().getMonth()]} {new Date().getFullYear()}</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{entities.length} entities analysed</span>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#c47a00":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#c47a00":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#c47a00":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="overview"&&<div style={{maxWidth:960,margin:"0 auto"}}><SEOverview entities={entities}/><SEPhaseDist entities={entities}/></div>}
        {activeTab==="alerts"&&<div style={{maxWidth:860,margin:"0 auto"}}><SEAlerts entities={entities}/></div>}
        {activeTab==="table"&&<div style={{maxWidth:1100,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}><SETable entities={entities} onExport={rows=>seExport(rows,"all")}/></div>}
        {activeTab==="opportunities"&&<div style={{maxWidth:900,margin:"0 auto"}}><SEOpportunities entities={entities}/></div>}
        {activeTab==="trends"&&<SETrends entities={entities}/>}
        {activeTab==="ai"&&<div style={{maxWidth:860,margin:"0 auto"}}><SEAIAssistant entities={entities}/></div>}
        {activeTab==="export"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Export Seasonal Action Plans</div>
              <div style={{fontSize:12,color:"#888",marginBottom:20}}>Each export includes seasonal phase, growth/risk/opportunity scores, all metric deltas vs previous period, and suggested action.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {type:"all",          label:"Full Seasonal Report",  icon:"ti-table",          color:"#555",  count:entities.length},
                  {type:"peak",         label:"Peak — Max Bids Now",   icon:"ti-trending-up",    color:"#1a7a3c",count:entities.filter(e=>e.phase.label==="Peak").length},
                  {type:"scaling",      label:"Pre-Season Scaling",    icon:"ti-arrow-up-right", color:"#2a9a50",count:entities.filter(e=>["Rising","Entering"].includes(e.phase.label)).length},
                  {type:"reduce",       label:"Post-Season Reductions",icon:"ti-trending-down",  color:"#888",  count:entities.filter(e=>["Declining","Off-Season"].includes(e.phase.label)).length},
                  {type:"risk",         label:"High Risk Entities",    icon:"ti-alert-triangle", color:"#d42b2b",count:entities.filter(e=>e.risk>=55).length},
                  {type:"opportunities",label:"High Opportunity",      icon:"ti-rocket",          color:"#c47a00",count:entities.filter(e=>e.opp>=60).length},
                ].map(ex=>(
                  <div key={ex.type} style={{background:"#fafafa",borderRadius:10,border:"1px solid #eee",padding:"14px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
                      <div style={{width:30,height:30,borderRadius:8,background:`${ex.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${ex.icon}`} style={{fontSize:14,color:ex.color}}/>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ex.label}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{ex.count} entities</div>
                      </div>
                    </div>
                    <button onClick={()=>seExport(entities,ex.type)} disabled={ex.count===0} style={{...T.btnR(ex.count>0),width:"100%",justifyContent:"center",fontSize:11,padding:"7px 0",opacity:ex.count===0?0.4:1}}>
                      <i className="ti ti-download" style={{fontSize:12}}/>Download ({ex.count})
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   ACCOUNT AUDIT MODULE
   Complete PPC account auditing system.
   Sections: Scores · Alerts · Audit Table · Strategic Opps
             Maturity Analysis · AI Consultant · Export
   No upload — syncs from Global Data Hub.
================================================================ */

/* ── Audit scoring engine ───────────────────────────────────── */
function aaComputeScores(rows, cm, compRows, compCm){
  if(!rows||!cm||!rows.length) return null;

  const allM = rows.map(r=>calcRowMetrics(r,cm)).filter(m=>m.spend>0||m.impressions>10);
  if(!allM.length) return null;

  const totalSpend  = allM.reduce((s,m)=>s+m.spend,0);
  const totalSales  = allM.reduce((s,m)=>s+m.sales,0);
  const totalOrders = allM.reduce((s,m)=>s+m.orders,0);
  const totalImp    = allM.reduce((s,m)=>s+m.impressions,0);
  const overallAcos = totalSales>0?(totalSpend/totalSales)*100:0;
  const overallCvr  = allM.filter(m=>m.clicks>0).length?allM.reduce((s,m)=>s+m.cvr,0)/allM.filter(m=>m.clicks>0).length:0;
  const wasteItems  = allM.filter(m=>m.spend>5&&m.orders===0);
  const wasteSpend  = wasteItems.reduce((s,m)=>s+m.spend,0);
  const scalable    = allM.filter(m=>m.acos>0&&m.acos<25&&m.orders>=2);
  const highAcos    = allM.filter(m=>m.acos>70&&m.spend>10);

  // Compute comp aggregates
  let compData=null;
  if(compRows&&compCm&&compRows.length){
    const compM=compRows.map(r=>calcRowMetrics(r,compCm)).filter(m=>m.spend>0||m.impressions>10);
    if(compM.length){
      compData={
        spend:compM.reduce((s,m)=>s+m.spend,0),
        sales:compM.reduce((s,m)=>s+m.sales,0),
        orders:compM.reduce((s,m)=>s+m.orders,0),
        impressions:compM.reduce((s,m)=>s+m.impressions,0),
      };
    }
  }

  /* Efficiency score: reward low ACoS, penalise waste */
  let efficiency=70;
  if(overallAcos>0&&overallAcos<20) efficiency=90;
  else if(overallAcos<35) efficiency=75;
  else if(overallAcos<55) efficiency=55;
  else if(overallAcos>55) efficiency=35;
  efficiency-=Math.min(25,Math.round((wasteSpend/Math.max(totalSpend,1))*40));
  efficiency=Math.max(0,Math.min(100,efficiency));

  /* Waste score: lower is better (shown inverted as "waste level") */
  const wasteScore=Math.min(100,Math.round((wasteSpend/Math.max(totalSpend,1))*100));

  /* Scaling score: reward scalable entities */
  const scalingScore=Math.min(100,Math.round((scalable.length/Math.max(allM.length,1))*100)+
    (overallAcos>0&&overallAcos<30?20:0)+
    (totalOrders>50?15:totalOrders>20?8:0));

  /* Visibility score: reward impression volume */
  const visScore=Math.min(100,Math.round(totalImp>50000?85:totalImp>20000?70:totalImp>5000?55:totalImp>1000?40:25)+
    (scalable.length>3?10:0));

  /* Conversion score */
  const cvrScore=Math.min(100,Math.round(overallCvr>5?90:overallCvr>3?75:overallCvr>1.5?58:overallCvr>0.5?40:20));

  /* Structure score: penalise waste + high ACoS campaigns */
  const structScore=Math.min(100,Math.round(100-
    Math.min(40,(wasteItems.length/Math.max(allM.length,1))*60)-
    Math.min(30,(highAcos.length/Math.max(allM.length,1))*50)));

  /* Overall health */
  const health=Math.round((efficiency*0.25)+(scalingScore*0.2)+(cvrScore*0.2)+(structScore*0.15)+(visScore*0.1)+((100-wasteScore)*0.1));

  /* Maturity: based on campaign count, keyword diversity, scalable % */
  const maturity=Math.min(100,Math.round(
    (allM.length>50?25:allM.length>20?15:allM.length>10?8:3)+
    (scalable.length>5?25:scalable.length>2?15:5)+
    (overallAcos>0&&overallAcos<40?20:10)+
    (totalOrders>100?20:totalOrders>30?12:5)+
    (wasteSpend/Math.max(totalSpend,1)<0.2?10:0)
  ));

  return{
    health:Math.max(0,Math.min(100,health)),
    efficiency,wasteScore,scalingScore,visScore,cvrScore,structScore,maturity,
    totals:{spend:totalSpend,sales:totalSales,orders:totalOrders,impressions:totalImp,acos:overallAcos,cvr:overallCvr},
    counts:{total:allM.length,waste:wasteItems.length,scalable:scalable.length,highAcos:highAcos.length},
    wasteSpend,compData
  };
}

/* Score colour helper */
function aaScoreColor(v,inverted=false){
  const score=inverted?100-v:v;
  if(score>=75) return"#1a7a3c";
  if(score>=55) return"#2a9a50";
  if(score>=38) return"#c47a00";
  return"#d42b2b";
}

/* Build enriched audit rows */
function aaProcessRows(rows, cm, compRows, compCm){
  if(!rows||!cm) return [];
  const compMap={};
  if(compRows&&compCm){
    compRows.forEach(r=>{
      const k=(r[compCm.campaign]||r[compCm.keyword]||"").toLowerCase();
      if(k) compMap[k]=calcRowMetrics(r,compCm);
    });
  }
  return rows.map(row=>{
    const name=row[cm.campaign]||row[cm.keyword]||row[cm.searchTerm]||"Unknown";
    const m=calcRowMetrics(row,cm);
    if(m.spend<0.5&&m.impressions<20) return null;
    const compM=compMap[name.toLowerCase()]||null;

    // Classify audit area
    let area="Efficiency";
    if(m.spend>5&&m.orders===0) area="Waste";
    else if(m.acos>0&&m.acos<25&&m.orders>=2&&m.impressions<600) area="Scale Opportunity";
    else if(compM&&m.sales<compM.sales*0.75) area="Recovery";
    else if(m.acos>70) area="High ACoS";
    else if(m.impressions<200&&m.orders>0) area="Visibility Gap";
    else if(m.cvr<0.5&&m.clicks>15) area="Conversion Issue";

    const effScore=m.acos>0?Math.max(0,Math.min(100,Math.round(100-(m.acos*1.2)))):m.orders>0?65:30;
    const riskScore=m.spend>5&&m.orders===0?90:m.acos>80?75:m.acos>50?50:compM&&m.sales<compM.sales*0.7?55:20;
    const visScore=Math.min(100,Math.round(m.impressions>5000?80:m.impressions>1000?60:m.impressions>200?40:20)+(m.orders>0?15:0));

    return{name,area,metrics:m,compMetrics:compM,effScore,riskScore,visScore};
  }).filter(Boolean).sort((a,b)=>b.riskScore-a.riskScore);
}

/* ── Sub-components ─────────────────────────────────────────── */
function AAEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(26,95,160,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-clipboard-check" style={{fontSize:26,color:"#1a5fa0"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Account Audit needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:380,lineHeight:1.6,marginBottom:20}}>Upload a Campaign Report or Bulk File in the Data Hub. Account Audit runs a full diagnostic across all campaigns and surfaces structural weaknesses, scaling opportunities, and priority fixes.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Score card */
function AAScoreCard({label,value,icon,inverted=false,sub}){
  const color=aaScoreColor(value,inverted);
  const grade=inverted?(value<=20?"A":value<=40?"B":value<=60?"C":value<=75?"D":"F"):(value>=80?"A":value>=65?"B":value>=50?"C":value>=35?"D":"F");
  return(
    <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
        <div style={{width:28,height:28,borderRadius:7,background:`${color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
          <i className={`ti ${icon}`} style={{fontSize:13,color}}/>
        </div>
        <span style={{fontSize:11,color:"#888",fontWeight:600}}>{label}</span>
        <span style={{marginLeft:"auto",fontSize:14,fontWeight:800,color,padding:"1px 7px",borderRadius:5,background:`${color}14`}}>{grade}</span>
      </div>
      <div style={{display:"flex",alignItems:"flex-end",gap:8,marginBottom:6}}>
        <span style={{fontSize:28,fontWeight:800,color:"#111"}}>{value}</span>
        <span style={{fontSize:12,color:"#aaa",marginBottom:4}}>/100</span>
      </div>
      <div style={{height:5,borderRadius:3,background:"#f0f0f0",overflow:"hidden",marginBottom:6}}>
        <div style={{width:`${inverted?100-value:value}%`,height:"100%",background:color,borderRadius:3,transition:"width 0.4s"}}/>
      </div>
      <div style={{fontSize:11,color:"#aaa"}}>{sub}</div>
    </div>
  );
}

/* Audit alerts */
function AAAlerts({scores,auditRows}){
  if(!scores) return null;
  const alerts=[];
  const {counts,wasteSpend,totals}=scores;

  if(scores.wasteScore>=40){
    alerts.push({sev:"Critical",cat:"Budget Waste Risk",icon:"ti-cash",color:"#d42b2b",border:"rgba(212,43,43,0.25)",bg:"rgba(212,43,43,0.05)",
      explain:`${counts.waste} entities spending $${wasteSpend.toFixed(0)} with zero orders. Waste rate is ${scores.wasteScore}% of total spend — well above the 15% safe threshold for a healthy account.`,
      fix:"Pause or negate all zero-order entities spending >$5. Review search terms feeding these campaigns. Run Negation Engine immediately.",
      impact:`Recover ~$${wasteSpend.toFixed(0)} in wasted spend per period`,confidence:95});
  }

  if(scores.efficiency<50){
    alerts.push({sev:"Critical",cat:"Structural Efficiency Collapse",icon:"ti-adjustments",color:"#4f46e5",border:"rgba(79,70,229,0.25)",bg:"rgba(79,70,229,0.05)",
      explain:`Overall account efficiency score is ${scores.efficiency}/100. ACoS of ${totals.acos.toFixed(1)}% indicates systematic over-spending relative to revenue generated.`,
      fix:"Run Bids Optimizer. Apply bid reduction rules to all >50% ACoS campaigns. Review match types — broad likely bleeding into exact territory.",
      impact:"ACoS normalisation. Immediate profitability improvement.",confidence:90});
  }

  if(scores.scalingScore>=65&&scores.efficiency>=55){
    alerts.push({sev:"High",cat:"Scaling Opportunity — Under-Investing in Winners",icon:"ti-rocket",color:"#1a7a3c",border:"rgba(26,122,60,0.2)",bg:"rgba(26,122,60,0.05)",
      explain:`${counts.scalable} campaigns have sub-25% ACoS and 2+ orders but low impression share. These are proven winners being held back by conservative bids or budget caps.`,
      fix:"Increase bids 20–30% on these campaigns. Remove budget caps. Add exact match variants. Scale before competitors notice.",
      impact:`Estimated revenue uplift from scaling ${counts.scalable} under-exposed winners`,confidence:88});
  }

  if(scores.visScore<45){
    alerts.push({sev:"High",cat:"Visibility Weakness — Low Impression Share",icon:"ti-eye",color:"#6338c8",border:"rgba(99,56,200,0.2)",bg:"rgba(99,56,200,0.05)",
      explain:`Account visibility score is ${scores.visScore}/100. Low impression volume suggests budget constraints, conservative bids, or poor placement targeting limiting market reach.`,
      fix:"Check budget caps on top campaigns. Increase bids on converting keywords. Add TOS placement modifiers +30–50%.",
      impact:"Improved market presence. More impressions = more data = better optimisation signal.",confidence:82});
  }

  if(scores.cvrScore<45){
    alerts.push({sev:"High",cat:"Conversion Rate Weakness",icon:"ti-percentage",color:"#c47a00",border:"rgba(196,122,0,0.2)",bg:"rgba(196,122,0,0.05)",
      explain:`Account-level CVR is ${totals.cvr.toFixed(1)}% with a conversion score of ${scores.cvrScore}/100. Significant traffic is not monetising — likely a listing quality, pricing, or Buy Box issue.`,
      fix:"Run Listing Conversion module. Check Buy Box %. Review product pricing vs competitors. Improve hero image and title relevance.",
      impact:"Every 1pp CVR improvement multiplies revenue without extra ad spend.",confidence:80});
  }

  if(scores.structScore<50){
    alerts.push({sev:"Medium",cat:"Campaign Structure Weakness",icon:"ti-sitemap",color:"#1a5fa0",border:"rgba(26,95,160,0.2)",bg:"rgba(26,95,160,0.05)",
      explain:`Structural score ${scores.structScore}/100. High number of high-ACoS and zero-conversion campaigns relative to account size suggests poor campaign segmentation or match type management.`,
      fix:"Run Conflict Detector for overlap. Consolidate duplicate structures. Implement proper Exact > Phrase > Broad hierarchy.",
      impact:"Cleaner account structure = better bid control, better data, better automation.",confidence:75});
  }

  if(!alerts.length) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>Account scores look healthy. No critical audit issues detected.</span>
    </div>
  );
  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {alerts.map((a,i)=>(
        <div key={i} style={{background:a.bg,borderRadius:12,border:`1px solid ${a.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <i className={`ti ${a.icon}`} style={{fontSize:14,color:a.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:a.color}}>{a.sev} — {a.cat}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Confidence: {a.confidence}%</span>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{a.explain}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px"}}>
              <i className="ti ti-tool" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>
              <strong>Fix: </strong>{a.fix}
            </div>
            <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px"}}>
              <i className="ti ti-trending-up" style={{fontSize:11,marginRight:4,color:"#1a7a3c"}}/>
              <strong>Impact: </strong>{a.impact}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

/* Audit table */
function AATable({auditRows,onExport}){
  const[areaFilter,setAreaFilter]=useState("all");
  const[sort,setSort]=useState("risk");
  const[search,setSearch]=useState("");
  const areas=["all","Waste","High ACoS","Scale Opportunity","Visibility Gap","Conversion Issue","Recovery","Efficiency"];

  const filtered=auditRows.filter(r=>{
    if(areaFilter!=="all"&&r.area!==areaFilter) return false;
    if(search&&!r.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="risk")  return b.riskScore-a.riskScore;
    if(sort==="eff")   return b.effScore-a.effScore;
    if(sort==="vis")   return b.visScore-a.visScore;
    if(sort==="spend") return b.metrics.spend-a.metrics.spend;
    if(sort==="acos")  return (a.metrics.acos||999)-(b.metrics.acos||999);
    return 0;
  });

  const areaColor={
    "Waste":"#d42b2b","High ACoS":"#c47a00","Scale Opportunity":"#1a7a3c",
    "Visibility Gap":"#6338c8","Conversion Issue":"#4f46e5","Recovery":"#1a5fa0","Efficiency":"#555"
  };
  const ScoreBar=({val,inv=false})=>{
    const c=aaScoreColor(val,inv);
    return<div style={{display:"flex",alignItems:"center",gap:4}}>
      <div style={{width:30,height:5,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
        <div style={{width:`${inv?100-val:val}%`,height:"100%",background:c}}/>
      </div>
      <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{val}</span>
    </div>;
  };

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:180}}/>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {areas.map(a=>(
            <button key={a} onClick={()=>setAreaFilter(a)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${areaFilter===a?"#1a5fa0":"#e0e0e0"}`,background:areaFilter===a?"#1a5fa0":"#fff",color:areaFilter===a?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer"}}>{a}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="risk">Sort: Risk Score</option>
          <option value="eff">Sort: Efficiency</option>
          <option value="vis">Sort: Visibility</option>
          <option value="spend">Sort: Spend</option>
          <option value="acos">Sort: ACoS</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}><i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})</button>
      </div>
      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["Entity","Audit Area","Efficiency","Risk","Visibility","Spend","Sales","ACoS","CVR","Orders","vs Prev"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,150).map((r,i)=>{
              const m=r.metrics; const c=r.compMetrics;
              const ac=m.acos>70?"#d42b2b":m.acos>40?"#c47a00":"#111";
              const aColor=areaColor[r.area]||"#555";
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.name}>{r.name}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:`${aColor}12`,color:aColor,fontWeight:700,whiteSpace:"nowrap"}}>{r.area}</span>
                  </td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={r.effScore}/></td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={r.riskScore} inv={true}/></td>
                  <td style={{padding:"8px 10px"}}><ScoreBar val={r.visScore}/></td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.spend.toFixed(2)}{c&&<div style={{fontSize:10,color:m.spend>c.spend?"#d42b2b":"#1a7a3c"}}>{m.spend>c.spend?"+":""}{(m.spend-c.spend).toFixed(2)}</div>}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.sales.toFixed(2)}{c&&<div style={{fontSize:10,color:m.sales>c.sales?"#1a7a3c":"#d42b2b"}}>{m.sales>c.sales?"+":""}{(m.sales-c.sales).toFixed(2)}</div>}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:ac}}>{m.spend>0&&m.acos>0?`${m.acos.toFixed(1)}%`:"—"}</td>
                  <td style={{padding:"8px 10px",color:m.cvr<1&&m.clicks>10?"#d42b2b":"#555"}}>{m.cvr.toFixed(1)}%</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:m.orders>0?"#1a7a3c":"#888"}}>{m.orders}</td>
                  <td style={{padding:"8px 10px",fontSize:11,color:c?m.sales>c.sales?"#1a7a3c":"#d42b2b":"#aaa"}}>
                    {c?`${m.sales>c.sales?"+":""}{((m.sales-c.sales)/Math.max(c.sales,1)*100).toFixed(0)}%`:"—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>150&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 150 of {sorted.length}</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No entities match this filter.</div>}
      </div>
    </div>
  );
}

/* Strategic opportunities */
function AAStrategicOpps({scores,auditRows}){
  if(!scores) return null;
  const opps=[
    {
      title:"Scaling Readiness — Scale These Now",icon:"ti-rocket",color:"#1a7a3c",
      items:auditRows.filter(r=>r.area==="Scale Opportunity").slice(0,8),
      why:"These entities have proven profitability but limited exposure. They are the account's highest-ROI investment right now.",
      action:"Increase bids 20–30%. Remove budget caps. Add exact match variants. Scale immediately.",
      impact:"Revenue growth without proportional ACoS increase."
    },
    {
      title:"Keyword Expansion — Harvest Profitable Terms",icon:"ti-key",color:"#4f46e5",
      items:auditRows.filter(r=>r.area==="Conversion Issue"&&r.metrics.clicks>20).slice(0,8),
      why:"High click volume with low conversion suggests terms are not being isolated into dedicated exact match campaigns.",
      action:"Run Search Term Intel. Harvest converting search terms into exact match. Build new exact match campaigns for top performers.",
      impact:"Better match type alignment. Improved CVR from more targeted ad groups."
    },
    {
      title:"Budget Reallocation — Move Spend to Winners",icon:"ti-cash",color:"#1a5fa0",
      items:auditRows.filter(r=>r.area==="Waste"&&r.metrics.spend>8).slice(0,8),
      why:"These entities waste budget that should flow to scaling campaigns. Every dollar here is a dollar not invested in proven performers.",
      action:"Pause or reduce these entities. Reallocate freed budget to Scale Opportunity campaigns.",
      impact:`~$${auditRows.filter(r=>r.area==="Waste").reduce((s,r)=>s+r.metrics.spend,0).toFixed(0)} recoverable for redeployment.`
    },
    {
      title:"Placement Optimisation Gap",icon:"ti-layout-2",color:"#6338c8",
      items:auditRows.filter(r=>r.effScore>=60&&r.metrics.orders>1).slice(0,6),
      why:"Converting campaigns without TOS optimisation miss the highest-CVR placement. A simple modifier change can unlock significant performance improvement.",
      action:"Add +40–60% TOS modifier to these campaigns via Placement Optimizer. Monitor ACoS at TOS vs other placements.",
      impact:"Higher CVR at TOS. Rank improvement as a byproduct."
    },
    {
      title:"Recovery — Restore Declining Performance",icon:"ti-heart-rate-monitor",color:"#c47a00",
      items:auditRows.filter(r=>r.area==="Recovery").slice(0,8),
      why:"These entities performed better last period. Something changed — listing, competitor, bid, or targeting.",
      action:"Audit search terms for new waste. Check placement efficiency. Review bid rules for over-optimisation.",
      impact:"Restoring to previous performance level."
    },
  ].filter(o=>o.items.length>0);

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {opps.map((opp,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid rgba(0,0,0,0.06)",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:32,height:32,borderRadius:9,background:`${opp.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${opp.icon}`} style={{fontSize:15,color:opp.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{opp.title}</div>
            <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{opp.items.length} entities</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{opp.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Action: </strong>{opp.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Impact: </strong>{opp.impact}</div>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {opp.items.map((r,j)=>(
              <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${opp.color}10`,color:opp.color,fontWeight:600,border:`1px solid ${opp.color}30`,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name}</span>
            ))}
          </div>
        </div>
      ))}
      {opps.length===0&&<div style={{padding:"24px",background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",textAlign:"center",fontSize:13,color:"#aaa"}}>No strategic opportunities detected with current data.</div>}
    </div>
  );
}

/* Account maturity panel */
function AAMaturity({scores}){
  if(!scores) return null;
  const{health,efficiency,wasteScore,scalingScore,visScore,cvrScore,structScore,maturity,totals,counts}=scores;
  const matLabel=maturity>=80?"Advanced":maturity>=60?"Intermediate":maturity>=40?"Developing":"Early Stage";
  const matColor=maturity>=80?"#1a7a3c":maturity>=60?"#2a9a50":maturity>=40?"#c47a00":"#d42b2b";

  const dimensions=[
    {label:"Waste Control",    score:100-wasteScore, icon:"ti-droplet-off",  desc:"How well waste spend is controlled (lower waste = higher score)"},
    {label:"Efficiency",       score:efficiency,      icon:"ti-adjustments",  desc:"Overall ACoS efficiency across the account"},
    {label:"Scaling Readiness",score:scalingScore,    icon:"ti-rocket",       desc:"Proportion of scalable profitable campaigns"},
    {label:"Visibility",       score:visScore,        icon:"ti-eye",          desc:"Impression share and market presence"},
    {label:"Conversion",       score:cvrScore,        icon:"ti-percentage",   desc:"Account-level CVR quality"},
    {label:"Structure",        score:structScore,     icon:"ti-sitemap",      desc:"Campaign organisation and segmentation quality"},
  ];

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {/* Maturity header */}
      <div style={{background:"#fff",borderRadius:14,border:`2px solid ${matColor}28`,padding:"20px 24px",marginBottom:16,display:"flex",alignItems:"center",gap:20}}>
        <div style={{textAlign:"center",flexShrink:0}}>
          <div style={{fontSize:48,fontWeight:900,color:matColor,lineHeight:1}}>{maturity}</div>
          <div style={{fontSize:11,color:"#aaa",marginTop:3}}>Maturity Score</div>
        </div>
        <div style={{width:1,height:60,background:"#f0f0f0",flexShrink:0}}/>
        <div>
          <div style={{fontSize:20,fontWeight:800,color:"#111",marginBottom:4}}>{matLabel} Account</div>
          <div style={{fontSize:12,color:"#666",lineHeight:1.6,maxWidth:520}}>
            {matLabel==="Advanced"&&"Well-structured account with strong performance data, controlled waste, and clear scaling opportunities. Ready for aggressive optimisation."}
            {matLabel==="Intermediate"&&"Solid foundation with some structural gaps. Waste is partially controlled. Focus on harvesting keywords and scaling proven winners."}
            {matLabel==="Developing"&&"Account has potential but needs structural work. Waste reduction and keyword harvesting are the highest-impact priorities."}
            {matLabel==="Early Stage"&&"Limited data and high waste. Prioritise pausing zero-order spend, building exact match structure, and generating conversion signal."}
          </div>
        </div>
        <div style={{marginLeft:"auto",textAlign:"right",flexShrink:0}}>
          <div style={{fontSize:11,color:"#aaa",marginBottom:4}}>Overall Health</div>
          <div style={{fontSize:32,fontWeight:800,color:aaScoreColor(health)}}>{health}</div>
        </div>
      </div>

      {/* Dimension scores */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
        {dimensions.map(d=>(
          <div key={d.label} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.03)"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
              <i className={`ti ${d.icon}`} style={{fontSize:13,color:aaScoreColor(d.score)}}/>
              <span style={{fontSize:12,fontWeight:600,color:"#555"}}>{d.label}</span>
              <span style={{marginLeft:"auto",fontSize:16,fontWeight:800,color:aaScoreColor(d.score)}}>{d.score}</span>
            </div>
            <div style={{height:5,borderRadius:3,background:"#f0f0f0",overflow:"hidden",marginBottom:6}}>
              <div style={{width:`${d.score}%`,height:"100%",background:aaScoreColor(d.score),borderRadius:3}}/>
            </div>
            <div style={{fontSize:10,color:"#aaa",lineHeight:1.4}}>{d.desc}</div>
          </div>
        ))}
      </div>

      {/* Account stats */}
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 20px"}}>
        <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:12}}>Account Overview</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
          {[
            {label:"Total Spend",val:`$${totals.spend>=1000?(totals.spend/1000).toFixed(1)+"K":totals.spend.toFixed(0)}`},
            {label:"Total Sales",val:`$${totals.sales>=1000?(totals.sales/1000).toFixed(1)+"K":totals.sales.toFixed(0)}`},
            {label:"Total Orders",val:totals.orders},
            {label:"Overall ACoS",val:totals.acos>0?`${totals.acos.toFixed(1)}%`:"—"},
            {label:"Entities Analysed",val:counts.total},
            {label:"Scalable (ACoS<25)",val:counts.scalable},
            {label:"Waste Entities",val:counts.waste},
            {label:"High ACoS (>70%)",val:counts.highAcos},
          ].map(s=>(
            <div key={s.label} style={{textAlign:"center"}}>
              <div style={{fontSize:18,fontWeight:800,color:"#111",marginBottom:3}}>{s.val}</div>
              <div style={{fontSize:10,color:"#aaa"}}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* AI consultant */
function AAAIConsultant({scores,auditRows}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  async function runAnalysis(){
    if(!scores){alert("No data loaded.");return;}
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);

    const wasteRows=auditRows.filter(r=>r.area==="Waste").slice(0,5);
    const scaleRows=auditRows.filter(r=>r.area==="Scale Opportunity").slice(0,5);

    const prompt=`You are a senior Amazon PPC consultant conducting a full account audit. Based ONLY on the data below, provide 6 specific audit findings with actionable recommendations. Respond like a consultant delivering a paid audit report.

ACCOUNT DATA:
- Health Score: ${scores.health}/100
- Maturity Score: ${scores.maturity}/100
- Efficiency Score: ${scores.efficiency}/100
- Waste Rate: ${scores.wasteScore}% of total spend
- Scaling Score: ${scores.scalingScore}/100
- Conversion Score: ${scores.cvrScore}/100
- Visibility Score: ${scores.visScore}/100
- Structure Score: ${scores.structScore}/100
- Total Spend: $${scores.totals.spend.toFixed(0)}
- Total Sales: $${scores.totals.sales.toFixed(0)}
- Overall ACoS: ${scores.totals.acos.toFixed(1)}%
- Scalable campaigns: ${scores.counts.scalable} of ${scores.counts.total}
- Waste entities: ${scores.counts.waste}
- Top waste entities: ${wasteRows.map(r=>`${r.name} ($${r.metrics.spend.toFixed(0)} wasted)`).join(", ")}
- Top scale opportunities: ${scaleRows.map(r=>`${r.name} (ACoS:${r.metrics.acos.toFixed(0)}%, orders:${r.metrics.orders})`).join(", ")}

Respond in JSON ONLY (no markdown, no backticks):
{"findings":[{"priority":"Critical|High|Medium","category":"...","finding":"...","rootCause":"...","recommendation":"...","expectedImpact":"..."}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.25,maxOutputTokens:1400}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key."});}
    setLoading(false);
  }

  const prioColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#1a5fa0"};
  return(
    <div style={{maxWidth:860}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:4}}>AI Account Audit Consultant (Gemini)</div>
        <div style={{fontSize:11,color:"#888",marginBottom:12}}>AI analyses your actual account data and responds like a senior PPC consultant delivering a paid audit report.</div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Auditing...</>:<><i className="ti ti-clipboard-check" style={{fontSize:13}}/>Run Full Audit</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa",marginTop:8}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>
      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b"}}>{result.error}</div>}
      {result?.findings&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.findings.map((f,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:`1px solid ${prioColor[f.priority]||"#e0e0e0"}28`,padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:`${prioColor[f.priority]||"#888"}18`,color:prioColor[f.priority]||"#888",fontWeight:700}}>{f.priority}</span>
                <span style={{fontSize:11,color:"#aaa",padding:"1px 6px",borderRadius:3,background:"rgba(0,0,0,0.05)"}}>{f.category}</span>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{f.finding}</span>
              </div>
              <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:6}}><strong>Root cause: </strong>{f.rootCause}</div>
              <div style={{fontSize:12,color:"#444",lineHeight:1.5,marginBottom:6}}><strong>Recommendation: </strong>{f.recommendation}</div>
              <div style={{fontSize:11,background:"rgba(26,122,60,0.06)",borderRadius:7,padding:"6px 10px",color:"#1a7a3c"}}><i className="ti ti-trending-up" style={{fontSize:11,marginRight:4}}/>Expected impact: {f.expectedImpact}</div>
            </div>
          ))}
        </div>
      )}
      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"28px",textAlign:"center"}}>
          <i className="ti ti-clipboard-check" style={{fontSize:32,color:"#ddd",display:"block",marginBottom:10}}/>
          <div style={{fontSize:13,fontWeight:600,color:"#888",marginBottom:6}}>Ready to run a full AI account audit</div>
          <div style={{fontSize:12,color:"#aaa"}}>Enter your Gemini key and click Run Full Audit.<br/>AI delivers a consultant-level analysis with 6 specific findings, root causes, and recommendations.</div>
        </div>
      )}
    </div>
  );
}

/* Export */
function aaExport(auditRows, scores, type){
  if(type==="scores"&&scores){
    const rows=[{
      "Health Score":scores.health,"Maturity Score":scores.maturity,
      "Efficiency Score":scores.efficiency,"Waste Rate (%)":scores.wasteScore,
      "Scaling Score":scores.scalingScore,"Visibility Score":scores.visScore,
      "Conversion Score":scores.cvrScore,"Structure Score":scores.structScore,
      "Total Spend ($)":scores.totals.spend.toFixed(2),"Total Sales ($)":scores.totals.sales.toFixed(2),
      "Overall ACoS (%)":scores.totals.acos.toFixed(1),"Total Orders":scores.totals.orders,
      "Entities Analysed":scores.counts.total,"Scalable Entities":scores.counts.scalable,
      "Waste Entities":scores.counts.waste,"High ACoS Entities":scores.counts.highAcos
    }];
    const ws=XLSX.utils.json_to_sheet(rows);
    ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:22}));
    const wb=XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb,ws,"Audit Scores");
    XLSX.writeFile(wb,`account_audit_scores_${Date.now()}.xlsx`);
    return;
  }
  const map={
    all:auditRows,
    waste:auditRows.filter(r=>r.area==="Waste"),
    scale:auditRows.filter(r=>r.area==="Scale Opportunity"),
    highacos:auditRows.filter(r=>r.area==="High ACoS"),
    visibility:auditRows.filter(r=>r.area==="Visibility Gap"),
    recovery:auditRows.filter(r=>r.area==="Recovery"),
  };
  const rows=(map[type]||auditRows).map(r=>({
    "Entity":r.name,"Audit Area":r.area,
    "Efficiency Score":r.effScore,"Risk Score":r.riskScore,"Visibility Score":r.visScore,
    "Spend ($)":r.metrics.spend.toFixed(2),"Sales ($)":r.metrics.sales.toFixed(2),
    "Orders":r.metrics.orders,"ACoS (%)":r.metrics.acos.toFixed(1),
    "CVR (%)":r.metrics.cvr.toFixed(1),"CPC ($)":r.metrics.cpc.toFixed(2),
    "Prev Spend":r.compMetrics?r.compMetrics.spend.toFixed(2):"—",
    "Prev Sales":r.compMetrics?r.compMetrics.sales.toFixed(2):"—",
  }));
  if(!rows.length){alert("No data for this export.");return;}
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:18}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Account Audit");
  XLSX.writeFile(wb,`account_audit_${type}_${Date.now()}.xlsx`);
}

/* ── Account Audit Module Root ──────────────────────────────── */
function AccountAuditModule({globalData,setTab}){
  /* ── Data from Data Hub ── */
  const campData   = globalData?.cur?.primary    || globalData?.cur?.campaign;
  const compCamp   = globalData?.comp?.primary   || globalData?.comp?.campaign;
  const strData    = globalData?.cur?.searchterm;
  const compSTR    = globalData?.comp?.searchterm;
  const placData   = globalData?.cur?.placement;
  const compPlac   = globalData?.comp?.placement;
  const targetData = globalData?.cur?.targeting;
  const compTarget = globalData?.comp?.targeting;
  const asinData   = globalData?.cur?.asin;
  const compAsin   = globalData?.comp?.asin;
  const bizData    = globalData?.cur?.business;
  const compBiz    = globalData?.comp?.business;
  const periods    = globalData?.periods;

  const[section,setSection]=useState('overview');
  const[clientName,setClientName]=useState('');
  const[targetAcos,setTargetAcos]=useState(30);
  const[targetCpa,setTargetCpa]=useState(5);
  const[editingClient,setEditingClient]=useState(false);

  /* ── Column detectors ── */
  function cm(data){ return data?.cm||{}; }
  function n(row,col){ if(!col||row[col]==null||row[col]==='')return 0; return parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,''))||0; }

  /* ── Aggregate campaign rows ── */
  function aggCamp(data){
    if(!data?.rows?.length) return null;
    const sm=cm(data);
    let spend=0,sales=0,impressions=0,clicks=0,orders=0;
    data.rows.forEach(r=>{
      spend+=n(r,sm.spend||'Spend')||n(r,'Spend')||n(r,'spend');
      sales+=n(r,sm.sales||'Sales')||n(r,'Sales')||n(r,'14 Day Total Sales')||n(r,'7 Day Total Sales');
      impressions+=n(r,sm.impressions||'Impressions')||n(r,'Impressions');
      clicks+=n(r,sm.clicks||'Clicks')||n(r,'Clicks');
      orders+=n(r,sm.orders||'Orders')||n(r,'Orders')||n(r,'14 Day Total Orders');
    });
    const acos=sales>0?(spend/sales)*100:0;
    const ctr=impressions>0?(clicks/impressions)*100:0;
    const cvr=clicks>0?(orders/clicks)*100:0;
    const cpc=clicks>0?spend/clicks:0;
    const roas=spend>0?sales/spend:0;
    return{spend,sales,impressions,clicks,orders,acos,ctr,cvr,cpc,roas};
  }

  /* ── Aggregate business rows ── */
  function aggBiz(data){
    if(!data?.rows?.length) return null;
    let totalSales=0,sessions=0,units=0,pageViews=0;
    data.rows.forEach(r=>{
      totalSales+=n(r,'Ordered Product Sales')||n(r,'Total Sales')||n(r,'ordered product sales');
      sessions+=n(r,'Sessions - Total')||n(r,'Sessions')||n(r,'sessions');
      units+=n(r,'Units Ordered')||n(r,'units ordered')||n(r,'Units');
      pageViews+=n(r,'Page Views - Total')||n(r,'Page Views')||n(r,'page views');
    });
    return{totalSales,sessions,units,pageViews};
  }

  /* ── Delta helper ── */
  function delta(cur,prev,invert=false){
    if(prev==null||prev===0||cur==null) return null;
    const pct=((cur-prev)/Math.abs(prev))*100;
    const good=invert?pct<0:pct>0;
    return{pct,good,abs:cur-prev};
  }

  /* ── Format helpers ── */
  const fmtD=(v)=>v==null?'—':`$${Math.abs(v)>=1000?(Math.abs(v)/1000).toFixed(1)+'K':Math.abs(v).toFixed(0)}`;
  const fmtP=(v)=>v==null?'—':`${v.toFixed(1)}%`;
  const fmtN=(v)=>v==null?'—':v>=1000?(v/1000).toFixed(1)+'K':Math.round(v).toString();
  const fmtX=(v)=>v==null?'—':`${v.toFixed(2)}x`;

  /* ── KPI Card component ── */
  function KpiCard({label,value,prev,fmt='dollar',invert=false}){
    const d=delta(value,prev,invert);
    const color=d?(d.good?'#1a9e5f':'#e05656'):'#888';
    const fmtV=fmt==='dollar'?fmtD:fmt==='pct'?fmtP:fmt==='int'?fmtN:fmt==='x'?fmtX:String;
    return(
      <div style={{padding:'12px 14px',background:'#fff',border:'1px solid #eef0f4',borderRadius:8}}>
        <div style={{fontSize:10,color:'#8893a7',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:4}}>{label}</div>
        <div style={{fontSize:18,fontWeight:700,color:'#111',marginBottom:d?2:0}}>{fmtV(value)}</div>
        {d&&<div style={{display:'flex',alignItems:'center',gap:4}}>
          <span style={{fontSize:10,color:'#888'}}>{fmtV(prev)}</span>
          <span style={{fontSize:10,fontWeight:700,color}}>{d.pct>=0?'+':''}{d.pct.toFixed(1)}%</span>
        </div>}
      </div>
    );
  }

  /* ── Section purpose box ── */
  function PurposeBox({purpose,what}){
    return(
      <div style={{marginBottom:18,padding:'14px 18px',background:'#f8f9fc',border:'1px solid #e8ebf2',borderRadius:10}}>
        <div style={{fontWeight:700,fontSize:13,color:'#111',marginBottom:6}}>🔹 Purpose:</div>
        {purpose.map((p,i)=><div key={i} style={{fontSize:12,color:'#444',marginBottom:3}}>- {p}</div>)}
        {what&&<><div style={{fontWeight:700,fontSize:13,color:'#c47a00',marginTop:10,marginBottom:6}}>💡 What to Look For:</div>
        {what.map((w,i)=><div key={i} style={{fontSize:12,color:'#555',marginBottom:3}}>- {w}</div>)}</>}
      </div>
    );
  }

  /* ── Comparison table row ── */
  function CmpRow({label,cur,prev,fmt='dollar',invert=false,bold=false}){
    const d=delta(cur,prev,invert);
    const color=d?(d.good?'#1a9e5f':'#e05656'):'transparent';
    const fmtV=fmt==='dollar'?fmtD:fmt==='pct'?fmtP:fmt==='int'?fmtN:fmt==='x'?fmtX:v=>String(v??'—');
    return(
      <tr style={{borderBottom:'1px solid #f0f2f7'}}>
        <td style={{padding:'8px 12px',fontSize:12,fontWeight:bold?700:500,color:'#111'}}>{label}</td>
        <td style={{padding:'8px 12px',fontSize:12,fontWeight:700,color:'#111',textAlign:'right'}}>{fmtV(cur)}</td>
        {prev!=null&&<td style={{padding:'8px 12px',fontSize:11,textAlign:'right'}}>
          <div style={{color:'#888',fontSize:10}}>{fmtV(prev)}</div>
          {d&&<div style={{color,fontWeight:700,fontSize:10}}>{d.pct>=0?'+':''}{d.pct.toFixed(1)}%</div>}
        </td>}
      </tr>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 1: OVERVIEW
  ═══════════════════════════════════════ */
  function OverviewSection(){
    const cur=aggCamp(campData); const prev=aggCamp(compCamp);
    const biz=aggBiz(bizData);   const bizP=aggBiz(compBiz);
    const tacos=biz?.totalSales>0&&cur?.spend!=null?(cur.spend/biz.totalSales)*100:null;
    const tacosP=bizP?.totalSales>0&&prev?.spend!=null?(prev.spend/bizP.totalSales)*100:null;
    const orgSales=biz&&cur?biz.totalSales-cur.sales:null;
    const orgSalesP=bizP&&prev?bizP.totalSales-prev.sales:null;
    const adSalesPct=biz?.totalSales>0&&cur?.sales!=null?(cur.sales/biz.totalSales)*100:null;

    /* Weekly performance from campaign data */
    const weeks=useMemo(()=>{
      if(!campData?.rows?.length)return[];
      const sm=cm(campData);
      const byWeek={};
      campData.rows.forEach(r=>{
        const dateStr=String(r[sm.startDate||'Start Date']||r['date']||r['Date']||'');
        if(!dateStr)return;
        const d=new Date(dateStr);
        if(isNaN(d.getTime()))return;
        const weekStart=new Date(d);
        weekStart.setDate(d.getDate()-d.getDay()+1);
        const wk=weekStart.toISOString().slice(0,10);
        if(!byWeek[wk])byWeek[wk]={spend:0,sales:0,acos:0,orders:0};
        byWeek[wk].spend+=n(r,sm.spend||'Spend')||n(r,'Spend');
        byWeek[wk].sales+=n(r,sm.sales||'Sales')||n(r,'Sales')||n(r,'14 Day Total Sales');
        byWeek[wk].orders+=n(r,sm.orders||'Orders')||n(r,'Orders')||n(r,'14 Day Total Orders');
      });
      return Object.entries(byWeek).sort((a,b)=>b[0].localeCompare(a[0])).slice(0,5).map(([wk,v])=>({
        week:wk,spend:v.spend,sales:v.sales,
        acos:v.sales>0?(v.spend/v.sales)*100:0,
        tacos:biz?.totalSales>0?(v.spend/(biz.totalSales/Object.keys(byWeek).length))*100:0,
      }));
    },[campData,bizData]);

    return(
      <div style={{padding:'24px',maxWidth:1200}}>
        <PurposeBox
          purpose={['Gives a performance snapshot of the last 30–60 days','Provides a high-level overview of the current state of the account']}
          what={null}
        />
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px',marginBottom:20}}>
          <h2 style={{fontSize:18,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>

          {/* Two column KPI layout */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:20}}>
            {/* Total Performance */}
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',marginBottom:12,padding:'8px',background:'#f8f9fc',borderRadius:7}}>Total Performance Overview</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:8}}>
                <KpiCard label="Total Sales" value={biz?.totalSales} prev={bizP?.totalSales} fmt="dollar"/>
                <KpiCard label="Total Sessions" value={biz?.sessions} prev={bizP?.sessions} fmt="int"/>
                <KpiCard label="Total Units" value={biz?.units} prev={bizP?.units} fmt="int"/>
                <KpiCard label="TACOS" value={tacos} prev={tacosP} fmt="pct" invert/>
                <KpiCard label="Total CVR" value={biz&&cur?cur.cvr:null} prev={prev?.cvr} fmt="pct"/>
                <KpiCard label="Organic Sales" value={orgSales} prev={orgSalesP} fmt="dollar"/>
                <KpiCard label="Ad Sales % of Total" value={adSalesPct} prev={bizP&&prev?((prev.sales/bizP.totalSales)*100):null} fmt="pct"/>
                <KpiCard label="Total AOV" value={biz&&biz.units>0?biz.totalSales/biz.units:null} prev={bizP&&bizP.units>0?bizP.totalSales/bizP.units:null} fmt="dollar"/>
              </div>
            </div>
            {/* Ad Performance */}
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',marginBottom:12,padding:'8px',background:'#f8f9fc',borderRadius:7}}>Ad Performance Overview</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:8}}>
                <KpiCard label="Ad Spend" value={cur?.spend} prev={prev?.spend} fmt="dollar" invert/>
                <KpiCard label="Ad Sales" value={cur?.sales} prev={prev?.sales} fmt="dollar"/>
                <KpiCard label="Ad ACOS" value={cur?.acos} prev={prev?.acos} fmt="pct" invert/>
                <KpiCard label="Ad CVR" value={cur?.cvr} prev={prev?.cvr} fmt="pct"/>
                <KpiCard label="Ad CPC" value={cur?.cpc} prev={prev?.cpc} fmt="dollar" invert/>
                <KpiCard label="Ad CTR" value={cur?.ctr} prev={prev?.ctr} fmt="pct"/>
                <KpiCard label="Ad ROAS" value={cur?.roas} prev={prev?.roas} fmt="x"/>
                <KpiCard label="Total CPA" value={cur&&cur.orders>0?cur.spend/cur.orders:null} prev={prev&&prev.orders>0?prev.spend/prev.orders:null} fmt="dollar" invert/>
              </div>
            </div>
          </div>

          {/* Weekly Performance Table */}
          {weeks.length>0&&(
            <div style={{marginTop:20}}>
              <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',marginBottom:12,padding:'8px',background:'#f8f9fc',borderRadius:7}}>Weekly Performance</div>
              <div style={{overflowX:'auto'}}>
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                  <thead>
                    <tr style={{background:'#f8f9fc'}}>
                      <th style={{padding:'8px 12px',textAlign:'left',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>Metric</th>
                      <th style={{padding:'8px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>Total</th>
                      {weeks.map((w,i)=><th key={i} style={{padding:'8px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',minWidth:90}}>
                        {new Date(w.week+'T00:00:00').toLocaleDateString('en-US',{month:'short',day:'numeric'})}
                      </th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {label:'Total Sales',vals:weeks.map(w=>w.sales),total:biz?.totalSales,fmt:fmtD},
                      {label:'Ad Spend',vals:weeks.map(w=>w.spend),total:cur?.spend,fmt:fmtD},
                      {label:'TACOS',vals:weeks.map(w=>w.tacos),total:tacos,fmt:fmtP},
                      {label:'Ad ACOS',vals:weeks.map(w=>w.acos),total:cur?.acos,fmt:fmtP},
                      {label:'Ad Sales',vals:weeks.map(w=>w.sales),total:cur?.sales,fmt:fmtD},
                    ].map((row,ri)=>{
                      const max=Math.max(...row.vals.filter(Boolean));
                      const min=Math.min(...row.vals.filter(v=>v>0));
                      return(
                        <tr key={ri} style={{borderBottom:'1px solid #f0f2f7'}}>
                          <td style={{padding:'8px 12px',fontWeight:600,color:'#111'}}>{row.label}</td>
                          <td style={{padding:'8px 12px',textAlign:'right',fontWeight:700,color:'#111'}}>{row.fmt(row.total)}</td>
                          {row.vals.map((v,vi)=>{
                            const isHigh=v===max&&max!==min;
                            const isLow=v===min&&max!==min;
                            const bg=isHigh?'rgba(26,158,95,0.12)':isLow?'rgba(224,86,86,0.1)':'transparent';
                            return<td key={vi} style={{padding:'8px 12px',textAlign:'right',background:bg,fontWeight:isHigh||isLow?700:400,color:'#333'}}>{row.fmt(v)}</td>;
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 2: TOTAL PRODUCT PERFORMANCE
  ═══════════════════════════════════════ */
  function ProductPerformanceSection(){
    const rows=asinData?.rows||[];
    const compRows=compAsin?.rows||[];
    const bizRows=bizData?.rows||[];

    /* Aggregate by parent ASIN */
    const byParent=useMemo(()=>{
      const map={};
      rows.forEach(r=>{
        const parent=String(r['Advertised ASIN']||r['Parent ASIN']||r['advertised asin']||'Unknown').trim().toUpperCase();
        const name=String(r['Advertised product name']||r['Product Name']||r['name']||parent).trim();
        if(!map[parent])map[parent]={parent,name,spend:0,sales:0,impressions:0,clicks:0,orders:0};
        map[parent].spend+=n(r,'Spend')||n(r,'spend');
        map[parent].sales+=n(r,'Sales')||n(r,'14 Day Total Sales')||n(r,'7 Day Total Sales');
        map[parent].orders+=n(r,'Orders')||n(r,'14 Day Total Orders');
        map[parent].clicks+=n(r,'Clicks');
        map[parent].impressions+=n(r,'Impressions');
      });
      // Add biz data
      bizRows.forEach(r=>{
        const asin=String(r['Parent ASIN']||r['(Parent) ASIN']||'').trim().toUpperCase();
        const totalSales=n(r,'Ordered Product Sales')||n(r,'Total Sales');
        if(map[asin])map[asin].totalSales=(map[asin].totalSales||0)+totalSales;
      });
      const totalSales=Object.values(map).reduce((s,v)=>s+(v.totalSales||v.sales),0);
      const totalSpend=Object.values(map).reduce((s,v)=>s+v.spend,0);
      return Object.values(map).map(p=>({
        ...p,
        acos:p.sales>0?(p.spend/p.sales)*100:0,
        tacos:(p.totalSales||p.sales)>0?(p.spend/(p.totalSales||p.sales))*100:0,
        pctSales:totalSales>0?((p.totalSales||p.sales)/totalSales)*100:0,
        pctSpend:totalSpend>0?(p.spend/totalSpend)*100:0,
      })).sort((a,b)=>b.sales-a.sales);
    },[rows,bizRows]);

    const totalAll=byParent.reduce((s,p)=>s+p.sales,0);
    const totalSpendAll=byParent.reduce((s,p)=>s+p.spend,0);

    function ProductTable({data,title}){
      return(
        <div style={{marginBottom:24}}>
          <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',padding:'8px',background:'#f8f9fc',borderRadius:7,marginBottom:12}}>{title}</div>
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead>
                <tr style={{background:'#f8f9fc'}}>
                  <th style={{padding:'8px 12px',textAlign:'left',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',minWidth:200}}>Name</th>
                  <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>% of Total Sales<br/><span style={{fontWeight:400,color:'#888'}}>{totalAll>0?((data.reduce((s,p)=>s+(p.totalSales||p.sales),0)/totalAll)*100).toFixed(1)+'%':'—'}</span></th>
                  <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>Total Sales<br/><span style={{fontWeight:400,color:'#888'}}>{fmtD(totalAll)}</span></th>
                  <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>Ad Spend<br/><span style={{fontWeight:400,color:'#888'}}>{fmtD(totalSpendAll)}</span></th>
                  <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>TACOS</th>
                  <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>Ad ACOS</th>
                  <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>Ad Sales</th>
                  <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>% of Ad Spend</th>
                </tr>
              </thead>
              <tbody>
                {data.map((p,i)=>(
                  <tr key={i} style={{borderBottom:'1px solid #f0f2f7',background:i%2===0?'#fff':'#fafbfc'}}>
                    <td style={{padding:'9px 12px',fontWeight:600,color:'#111',maxWidth:220,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={p.name}>{p.name}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{p.pctSales.toFixed(1)}%</td>
                    <td style={{padding:'9px 10px',textAlign:'right',fontWeight:600,color:'#111'}}>{fmtD(p.totalSales||p.sales)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{fmtD(p.spend)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:p.tacos>targetAcos?'#e05656':p.tacos>targetAcos*0.7?'#c47a00':'#1a9e5f',fontWeight:600}}>{fmtP(p.tacos)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:p.acos>targetAcos?'#e05656':p.acos>targetAcos*0.7?'#c47a00':'#1a9e5f',fontWeight:600}}>{fmtP(p.acos)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#111'}}>{fmtD(p.sales)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{p.pctSpend.toFixed(1)}%</td>
                  </tr>
                ))}
                {data.length===0&&<tr><td colSpan={8} style={{textAlign:'center',padding:'30px',color:'#aaa'}}>No product data — upload Advertised Product Report in Data Hub</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    return(
      <div style={{padding:'24px',maxWidth:1200}}>
        <PurposeBox
          purpose={['Shows Product Level Efficiency/Investment Levels','Combines ad spend data with total sales data']}
          what={['Budget distribution across catalog — see if big portion of budget goes to a small subset','Identify high ACOS/TACOS ASINs','Products unrepresented in ads']}
        />
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px'}}>
          <h2 style={{fontSize:16,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>
          <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',marginBottom:16,padding:'6px',background:'#f8f9fc',borderRadius:7}}>Parent ASIN</div>
          <ProductTable data={byParent} title="Total Product Performance (Parent ASIN)"/>
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 3: PLACEMENT PERFORMANCE
  ═══════════════════════════════════════ */
  function PlacementSection(){
    /* Parse placement report */
    const placRows=placData?.rows||[];
    const compPlacRows=compPlac?.rows||[];

    function aggPlacement(rows,adType){
      const map={};
      const typeMap={'top of search (impression share)':'Top of Search','product pages':'Product Pages','rest of search':'Rest Of Search','home':'Home','off-amazon':'Off-Amazon','amazon business':'Amazon Business'};
      rows.forEach(r=>{
        const camp=String(r['Campaign Name']||r['campaign name']||'');
        const placement=String(r['Placement']||r['placement']||'').toLowerCase().trim();
        const entity=String(r['Entity']||r['entity']||'').toLowerCase();
        if(!placement||entity!=='bidding adjustment'&&!entity.includes('placement'))return;
        // Detect ad type from campaign name
        const isAdType=adType==='SP'?(!camp.toLowerCase().includes(' sb ')&&!camp.toLowerCase().includes(' sd ')):
                        adType==='SB'?camp.toLowerCase().includes(' sb ')||camp.toLowerCase().includes('sponsored brand'):
                        camp.toLowerCase().includes(' sd ')||camp.toLowerCase().includes('sponsored display');
        if(!isAdType&&adType!=='all')return;
        const label=Object.entries(typeMap).find(([k])=>placement.includes(k))?.[1]||placement;
        if(!map[label])map[label]={name:label,spend:0,sales:0,clicks:0,orders:0,impressions:0};
        map[label].spend+=n(r,'Spend')||n(r,'spend');
        map[label].sales+=n(r,'Sales')||n(r,'14 Day Total Sales');
        map[label].clicks+=n(r,'Clicks');
        map[label].orders+=n(r,'Orders')||n(r,'14 Day Total Orders');
        map[label].impressions+=n(r,'Impressions');
      });
      const total={spend:0,sales:0};
      Object.values(map).forEach(v=>{total.spend+=v.spend;total.sales+=v.sales;});
      return Object.values(map).map(p=>({
        ...p,
        acos:p.sales>0?(p.spend/p.sales)*100:0,
        cvr:p.clicks>0?(p.orders/p.clicks)*100:0,
        cpc:p.clicks>0?p.spend/p.clicks:0,
        rpc:p.clicks>0?p.sales/p.clicks:0,
        pctSpend:total.spend>0?(p.spend/total.spend)*100:0,
        pctSales:total.sales>0?(p.sales/total.sales)*100:0,
      })).sort((a,b)=>b.spend-a.spend);
    }

    function PlacTable({data,title,compData}){
      const totals={spend:data.reduce((s,r)=>s+r.spend,0),sales:data.reduce((s,r)=>s+r.sales,0)};
      const compTotals=compData?{spend:compData.reduce((s,r)=>s+r.spend,0),sales:compData.reduce((s,r)=>s+r.sales,0)}:null;
      return(
        <div style={{marginBottom:24}}>
          <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',padding:'8px',background:'#f8f9fc',borderRadius:7,marginBottom:12}}>{title}</div>
          {data.length===0?<div style={{textAlign:'center',padding:'20px',color:'#aaa',fontSize:12}}>No placement data available</div>:(
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead><tr style={{background:'#f8f9fc'}}>
              {['Name','% of Spend','Spend','ACOS','CVR','RPC','Sales','CPC','% of Sales'].map(h=>(
                <th key={h} style={{padding:'7px 10px',textAlign:h==='Name'?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',whiteSpace:'nowrap'}}>
                  {h}
                  {h==='% of Spend'&&<div style={{fontWeight:400,color:'#888'}}>{totals.spend>0?'100%':'—'}</div>}
                  {h==='Spend'&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totals.spend)}</div>}
                  {h==='Sales'&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totals.sales)}</div>}
                  {h==='ACOS'&&<div style={{fontWeight:400,color:'#888'}}>{totals.sales>0?fmtP((totals.spend/totals.sales)*100):'—'}</div>}
                </th>
              ))}
            </tr></thead>
            <tbody>
              {data.map((row,i)=>(
                <tr key={i} style={{borderBottom:'1px solid #f0f2f7'}}>
                  <td style={{padding:'8px 10px',fontWeight:600,color:'#111'}}>{row.name}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{row.pctSpend.toFixed(1)}%</td>
                  <td style={{padding:'8px 10px',textAlign:'right',fontWeight:600}}>{fmtD(row.spend)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:row.acos>targetAcos?'#e05656':'#1a9e5f',fontWeight:600}}>{fmtP(row.acos)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtP(row.cvr)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtD(row.rpc)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',fontWeight:600}}>{fmtD(row.sales)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtD(row.cpc)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{row.pctSales.toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </table>)}
        </div>
      );
    }

    /* Try to extract SP/SB from campaign data if no placement report */
    const campRows=campData?.rows||[];
    function aggCampByPlacement(rows){
      const map={};
      rows.forEach(r=>{
        const placement=String(r['Placement']||r['placement']||'—');
        if(!map[placement])map[placement]={name:placement,spend:0,sales:0,clicks:0,orders:0};
        map[placement].spend+=n(r,'Spend')||n(r,'spend');
        map[placement].sales+=n(r,'Sales')||n(r,'14 Day Total Sales');
        map[placement].clicks+=n(r,'Clicks');
        map[placement].orders+=n(r,'Orders')||n(r,'14 Day Total Orders');
      });
      const total=Object.values(map).reduce((s,v)=>({spend:s.spend+v.spend,sales:s.sales+v.sales}),{spend:0,sales:0});
      return Object.values(map).map(p=>({
        ...p,acos:p.sales>0?(p.spend/p.sales)*100:0,cvr:p.clicks>0?(p.orders/p.clicks)*100:0,
        cpc:p.clicks>0?p.spend/p.clicks:0,rpc:p.clicks>0?p.sales/p.clicks:0,
        pctSpend:total.spend>0?(p.spend/total.spend)*100:0,pctSales:total.sales>0?(p.sales/total.sales)*100:0,
      })).sort((a,b)=>b.spend-a.spend);
    }

    const spData=placRows.length>0?aggPlacement(placRows,'SP'):aggCampByPlacement(campRows.filter(r=>!String(r['Campaign Name']||'').toLowerCase().includes(' sb ')&&!String(r['Campaign Name']||'').toLowerCase().includes(' sd ')));
    const sbData=aggPlacement(placRows,'SB');
    const sdData=aggPlacement(placRows,'SD');

    return(
      <div style={{padding:'24px',maxWidth:1100}}>
        <PurposeBox
          purpose={['Identify inefficiencies in ad spend across placements']}
          what={['Is spend being allocated to placements with highest CVR or RPC?','Is there a lot of spend happening off-Amazon that does not convert?','Do business placements outperform other placements?']}
        />
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px'}}>
          <h2 style={{fontSize:16,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>
          <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',padding:'6px',background:'rgba(26,95,160,0.08)',borderRadius:7,marginBottom:16,color:'#1a5fa0'}}>Sponsored Products</div>
          <PlacTable data={spData} title="Placement Performance (Sponsored Products)"/>
          {sbData.length>0&&<><div style={{fontSize:13,fontWeight:700,color:'#1a5fa0',textAlign:'center',padding:'6px',background:'rgba(26,95,160,0.06)',borderRadius:7,marginBottom:12,marginTop:8}}>Sponsored Brands</div><PlacTable data={sbData} title="Placement Performance (Sponsored Brands)"/></>}
          {sdData.length>0&&<><div style={{fontSize:13,fontWeight:700,color:'#1a7a3c',textAlign:'center',padding:'6px',background:'rgba(26,122,60,0.06)',borderRadius:7,marginBottom:12,marginTop:8}}>Sponsored Display</div><PlacTable data={sdData} title="Placement Performance (Sponsored Display)"/></>}
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 4: BID MANAGEMENT
  ═══════════════════════════════════════ */
  function BidManagementSection(){
    const rows=targetData?.rows||strData?.rows||campData?.rows||[];
    const sm=cm(targetData||strData||campData||{});

    const getMetrics=r=>({
      name:String(r[sm.keyword||'Keyword']||r['Keyword Text']||r['Customer Search Term']||r['Campaign Name']||'').trim(),
      spend:n(r,sm.spend||'Spend')||n(r,'Spend'),
      sales:n(r,sm.sales||'Sales')||n(r,'14 Day Total Sales')||n(r,'Sales'),
      orders:n(r,sm.orders||'Orders')||n(r,'14 Day Total Orders')||n(r,'Orders'),
      clicks:n(r,sm.clicks||'Clicks')||n(r,'Clicks'),
    });

    const processed=useMemo(()=>rows.map(r=>{
      const m=getMetrics(r);
      return{...m,acos:m.sales>0?(m.spend/m.sales)*100:0,cvr:m.clicks>0?(m.orders/m.clicks)*100:0,cpc:m.clicks>0?m.spend/m.clicks:0};
    }).filter(r=>r.spend>0),[rows]);

    const highAcos=processed.filter(r=>r.acos>targetAcos&&r.sales>0).sort((a,b)=>b.spend-a.spend).slice(0,20);
    const highSpendNoSales=processed.filter(r=>r.sales===0&&r.spend>targetCpa).sort((a,b)=>b.spend-a.spend).slice(0,20);

    function BidTable({data,title}){
      const totals={spend:data.reduce((s,r)=>s+r.spend,0),sales:data.reduce((s,r)=>s+r.sales,0)};
      return(
        <div style={{marginBottom:24}}>
          <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',padding:'8px',background:'#f8f9fc',borderRadius:7,marginBottom:12}}>{title}</div>
          {data.length===0?<div style={{textAlign:'center',padding:'20px',color:'#aaa',fontSize:12,background:'rgba(26,122,60,0.04)',borderRadius:8}}>✓ No issues found</div>:(
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead><tr style={{background:'#f8f9fc'}}>
              {['Name','Spend','Sales','ACOS','CVR','CPC'].map((h,hi)=>(
                <th key={h} style={{padding:'7px 10px',textAlign:hi===0?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>
                  {h}{hi===1&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totals.spend)}</div>}
                  {hi===2&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totals.sales)}</div>}
                  {hi===3&&<div style={{fontWeight:400,color:'#888'}}>{totals.sales>0?fmtP((totals.spend/totals.sales)*100):'—'}</div>}
                </th>
              ))}
            </tr></thead>
            <tbody>
              {data.map((r,i)=>(
                <tr key={i} style={{borderBottom:'1px solid #f0f2f7',background:i%2===0?'#fff':'#fafbfc'}}>
                  <td style={{padding:'8px 10px',maxWidth:300,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',fontWeight:500,color:'#111'}} title={r.name}>{r.name||'—'}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',fontWeight:600,color:'#d42b2b'}}>{fmtD(r.spend)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtD(r.sales)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#e05656',fontWeight:700}}>{r.sales>0?fmtP(r.acos):'—'}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtP(r.cvr)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtD(r.cpc)}</td>
                </tr>
              ))}
            </tbody>
          </table>)}
        </div>
      );
    }

    return(
      <div style={{padding:'24px',maxWidth:1000}}>
        <PurposeBox
          purpose={['Identify targets overshooting Target ACOS','Identify targets exceeding target CPA without generating sales']}
          what={['% of ad spend on High ACOS targets','% of ad spend on High Spend/No Sales targets, exceeding Target CPA']}
        />
        <div style={{display:'flex',gap:12,marginBottom:20,padding:'12px 16px',background:'#fff',borderRadius:10,border:'1px solid #e8ebf2'}}>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:12,color:'#555',fontWeight:600}}>Target ACOS:</span>
            <input type="number" value={targetAcos} onChange={e=>setTargetAcos(parseFloat(e.target.value)||30)} style={{width:60,padding:'4px 8px',borderRadius:6,border:'1px solid #e0e0e0',fontSize:12,outline:'none',textAlign:'center'}}/>
            <span style={{fontSize:11,color:'#888'}}>%</span>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:12,color:'#555',fontWeight:600}}>Target CPA threshold:</span>
            <span style={{fontSize:11,color:'#888'}}>$</span>
            <input type="number" value={targetCpa} onChange={e=>setTargetCpa(parseFloat(e.target.value)||5)} style={{width:60,padding:'4px 8px',borderRadius:6,border:'1px solid #e0e0e0',fontSize:12,outline:'none',textAlign:'center'}}/>
          </div>
        </div>
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px'}}>
          <h2 style={{fontSize:16,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>
          <BidTable data={highAcos} title={`High ACOS Targets (> ${targetAcos}% ACOS)`}/>
          <BidTable data={highSpendNoSales} title={`High Spend Targets (> $${targetCpa} Spend & No Sales)`}/>
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 5: SEARCH TERM ANALYSIS
  ═══════════════════════════════════════ */
  function SearchTermSection(){
    const rows=strData?.rows||[];
    const sm=cm(strData||{});

    const processed=useMemo(()=>rows.map(r=>({
      name:String(r[sm.searchTerm||'Customer Search Term']||r['Search Term']||r['Query']||'').trim(),
      spend:n(r,sm.spend||'Spend')||n(r,'Spend'),
      sales:n(r,sm.sales||'Sales')||n(r,'14 Day Total Sales'),
      orders:n(r,sm.orders||'Orders')||n(r,'14 Day Total Orders'),
      clicks:n(r,sm.clicks||'Clicks')||n(r,'Clicks'),
    })).filter(r=>r.name&&r.spend>0).map(r=>({
      ...r,acos:r.sales>0?(r.spend/r.sales)*100:0,cvr:r.clicks>0?(r.orders/r.clicks)*100:0,
    })),[rows]);

    const totalSpend=processed.reduce((s,r)=>s+r.spend,0);
    const withPct=processed.map(r=>({...r,pctSpend:totalSpend>0?(r.spend/totalSpend)*100:0}));
    const topTerms=withPct.sort((a,b)=>b.spend-a.spend).slice(0,20);
    const nonConverting=withPct.filter(r=>r.orders===0&&r.spend>0).sort((a,b)=>b.spend-a.spend).slice(0,20);
    const ncSpend=nonConverting.reduce((s,r)=>s+r.spend,0);

    function STTable({data,title}){
      const totals={spend:data.reduce((s,r)=>s+r.spend,0),sales:data.reduce((s,r)=>s+r.sales,0)};
      return(
        <div style={{marginBottom:24}}>
          <div style={{fontSize:13,fontWeight:700,color:'#111',textAlign:'center',padding:'8px',background:'#f8f9fc',borderRadius:7,marginBottom:12}}>{title}</div>
          {data.length===0?<div style={{textAlign:'center',padding:'20px',color:'#aaa',fontSize:12}}>No data — upload Search Term Report in Data Hub</div>:(
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead><tr style={{background:'#f8f9fc'}}>
              {['Name','% of Spend','Spend','Sales','ACOS','CVR'].map((h,hi)=>(
                <th key={h} style={{padding:'7px 10px',textAlign:hi===0?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>
                  {h}
                  {hi===1&&<div style={{fontWeight:400,color:'#888'}}>{totals.spend>0?'100%':'—'}</div>}
                  {hi===2&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totals.spend)}</div>}
                  {hi===3&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totals.sales)}</div>}
                  {hi===4&&<div style={{fontWeight:400,color:'#888'}}>{totals.sales>0?fmtP((totals.spend/totals.sales)*100):'—'}</div>}
                </th>
              ))}
            </tr></thead>
            <tbody>
              {data.map((r,i)=>(
                <tr key={i} style={{borderBottom:'1px solid #f0f2f7',background:i%2===0?'#fff':'#fafbfc'}}>
                  <td style={{padding:'8px 10px',maxWidth:300,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',fontWeight:500,color:'#111'}} title={r.name}>{r.name}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{r.pctSpend.toFixed(1)}%</td>
                  <td style={{padding:'8px 10px',textAlign:'right',fontWeight:600}}>{fmtD(r.spend)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:r.sales>0?'#1a9e5f':'#e05656',fontWeight:600}}>{fmtD(r.sales)}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:r.sales===0?'#888':r.acos>targetAcos?'#e05656':'#1a9e5f',fontWeight:600}}>{r.sales>0?fmtP(r.acos):'0.00%'}</td>
                  <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtP(r.cvr)}</td>
                </tr>
              ))}
            </tbody>
          </table>)}
        </div>
      );
    }

    return(
      <div style={{padding:'24px',maxWidth:1000}}>
        <PurposeBox
          purpose={['Provide a search term level view of performance']}
          what={['Non-converting spend % of total spend','Irrelevant search terms — opportunities to negate','Identify top search terms']}
        />
        {nonConverting.length>0&&(
          <div style={{padding:'10px 14px',background:'rgba(212,43,43,0.06)',border:'1px solid rgba(212,43,43,0.2)',borderRadius:8,marginBottom:16,fontSize:12,color:'#d42b2b'}}>
            ⚠ <strong>{fmtD(ncSpend)}</strong> ({totalSpend>0?((ncSpend/totalSpend)*100).toFixed(1):'0'}% of spend) is going to non-converting search terms — immediate negation opportunity
          </div>
        )}
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px'}}>
          <h2 style={{fontSize:16,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>
          <STTable data={topTerms} title="Top Search Terms (by Spend)"/>
          <STTable data={nonConverting} title="Non-Converting Search Terms"/>
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 6: TACTIC ALLOCATION
  ═══════════════════════════════════════ */
  function TacticAllocationSection(){
    const rows=campData?.rows||[];
    const sm=cm(campData||{});

    const byPortfolio=useMemo(()=>{
      const map={};
      rows.forEach(r=>{
        const port=String(r['Portfolio Name']||r['Portfolio name']||r[sm.portfolio||'']||'(No Portfolio)').trim()||'(No Portfolio)';
        if(!map[port])map[port]={name:port,spend:0,sales:0,orders:0,clicks:0};
        map[port].spend+=n(r,sm.spend||'Spend')||n(r,'Spend');
        map[port].sales+=n(r,sm.sales||'Sales')||n(r,'14 Day Total Sales');
        map[port].orders+=n(r,sm.orders||'Orders')||n(r,'14 Day Total Orders');
        map[port].clicks+=n(r,sm.clicks||'Clicks');
      });
      const total={spend:Object.values(map).reduce((s,v)=>s+v.spend,0),sales:Object.values(map).reduce((s,v)=>s+v.sales,0)};
      return Object.values(map).map(p=>({
        ...p,
        acos:p.sales>0?(p.spend/p.sales)*100:0,
        pctSpend:total.spend>0?(p.spend/total.spend)*100:0,
        pctSales:total.sales>0?(p.sales/total.sales)*100:0,
      })).sort((a,b)=>b.spend-a.spend);
    },[rows]);

    const totalSpend=byPortfolio.reduce((s,p)=>s+p.spend,0);
    const totalSales=byPortfolio.reduce((s,p)=>s+p.sales,0);

    return(
      <div style={{padding:'24px',maxWidth:1000}}>
        <PurposeBox
          purpose={['Analyze % of spend being allocated to brand vs non-brand targeting']}
          what={['Over-allocating spend to brand defense','Brand defense spend coming through non-brand campaigns']}
        />
        <div style={{padding:'12px 16px',background:'rgba(196,122,0,0.07)',border:'1px solid rgba(196,122,0,0.2)',borderRadius:8,marginBottom:16,fontSize:12,color:'#7a4e00'}}>
          💡 <strong>Setup Tip:</strong> Tag your campaigns by tactic (Brand, Non-Brand, Competitor) in Amazon to see Brand vs Non-Brand spend split. This view groups by Portfolio as a proxy.
        </div>
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px'}}>
          <h2 style={{fontSize:16,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead><tr style={{background:'#f8f9fc'}}>
                {['Portfolio / Tactic','% of Spend','Spend','Sales','% of Sales','ACOS'].map((h,i)=>(
                  <th key={h} style={{padding:'8px 12px',textAlign:i===0?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>
                    {h}
                    {i===1&&<div style={{fontWeight:400,color:'#888'}}>100%</div>}
                    {i===2&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totalSpend)}</div>}
                    {i===3&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totalSales)}</div>}
                  </th>
                ))}
              </tr></thead>
              <tbody>
                {byPortfolio.map((r,i)=>(
                  <tr key={i} style={{borderBottom:'1px solid #f0f2f7',background:i%2===0?'#fff':'#fafbfc'}}>
                    <td style={{padding:'9px 12px',fontWeight:600,color:'#111',maxWidth:300,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={r.name}>{r.name}</td>
                    <td style={{padding:'9px 12px',textAlign:'right',color:'#555'}}>{r.pctSpend.toFixed(1)}%</td>
                    <td style={{padding:'9px 12px',textAlign:'right',fontWeight:600}}>{fmtD(r.spend)}</td>
                    <td style={{padding:'9px 12px',textAlign:'right',fontWeight:600,color:'#1a9e5f'}}>{fmtD(r.sales)}</td>
                    <td style={{padding:'9px 12px',textAlign:'right',color:'#555'}}>{r.pctSales.toFixed(1)}%</td>
                    <td style={{padding:'9px 12px',textAlign:'right',color:r.acos>targetAcos?'#e05656':'#1a9e5f',fontWeight:700}}>{fmtP(r.acos)}</td>
                  </tr>
                ))}
                {byPortfolio.length===0&&<tr><td colSpan={6} style={{textAlign:'center',padding:'30px',color:'#aaa'}}>No campaign data — upload Campaign Report in Data Hub</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 7: MATCH TYPE PERFORMANCE
  ═══════════════════════════════════════ */
  function MatchTypeSection(){
    const rows=targetData?.rows||campData?.rows||[];
    const sm=cm(targetData||campData||{});

    const byMatchType=useMemo(()=>{
      const map={};
      rows.forEach(r=>{
        const entity=String(r['Entity']||r['entity']||'').toLowerCase();
        let mt=String(r[sm.matchType||'Match Type']||r['Match Type']||'').trim().toLowerCase();
        if(!mt||mt==='negativephrase'||mt==='negativeexact')return;
        if(mt==='exact')mt='Exact';
        else if(mt==='phrase')mt='Phrase';
        else if(mt==='broad')mt='Broad';
        else if(mt==='auto'||entity.includes('auto'))mt='Auto';
        else if(entity.includes('product targeting')||entity.includes('targeting'))mt='Indiv. PT';
        else mt=mt.charAt(0).toUpperCase()+mt.slice(1);
        if(!map[mt])map[mt]={name:mt,spend:0,sales:0,clicks:0,orders:0,impressions:0};
        map[mt].spend+=n(r,sm.spend||'Spend')||n(r,'Spend');
        map[mt].sales+=n(r,sm.sales||'Sales')||n(r,'14 Day Total Sales');
        map[mt].clicks+=n(r,sm.clicks||'Clicks')||n(r,'Clicks');
        map[mt].orders+=n(r,sm.orders||'Orders')||n(r,'14 Day Total Orders');
        map[mt].impressions+=n(r,sm.impressions||'Impressions')||n(r,'Impressions');
      });
      const total={spend:Object.values(map).reduce((s,v)=>s+v.spend,0)};
      return Object.values(map).map(m=>({
        ...m,acos:m.sales>0?(m.spend/m.sales)*100:0,cvr:m.clicks>0?(m.orders/m.clicks)*100:0,
        cpc:m.clicks>0?m.spend/m.clicks:0,pctSpend:total.spend>0?(m.spend/total.spend)*100:0,
      })).sort((a,b)=>b.spend-a.spend);
    },[rows]);

    const totalSpend=byMatchType.reduce((s,m)=>s+m.spend,0);
    const COLORS=['#1a5fa0','#1a9e5f','#4f46e5','#6338c8','#c47a00','#e05656'];

    return(
      <div style={{padding:'24px',maxWidth:1000}}>
        <PurposeBox
          purpose={['Analyze match type utilization and spend efficiency']}
          what={['Over-indexing on Auto campaigns and expanded match types','Missing use of product targeting','Exact match under-invested relative to its CVR']}
        />
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px'}}>
          <h2 style={{fontSize:16,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>
          <div style={{display:'grid',gridTemplateColumns:'auto 1fr',gap:20,alignItems:'start',marginBottom:20}}>
            {/* Donut chart (CSS-based) */}
            <div style={{display:'flex',flexDirection:'column',gap:8,minWidth:180}}>
              <div style={{fontSize:12,fontWeight:700,color:'#555',marginBottom:4,textAlign:'center'}}>Match Type Spend Allocation</div>
              {byMatchType.map((m,i)=>(
                <div key={i} style={{display:'flex',alignItems:'center',gap:8}}>
                  <div style={{width:10,height:10,borderRadius:'50%',background:COLORS[i%COLORS.length],flexShrink:0}}/>
                  <span style={{fontSize:11,color:'#333',flex:1}}>{m.name}</span>
                  <span style={{fontSize:11,fontWeight:700,color:COLORS[i%COLORS.length]}}>{fmtD(m.spend)} ({m.pctSpend.toFixed(1)}%)</span>
                </div>
              ))}
              {byMatchType.length===0&&<div style={{color:'#aaa',fontSize:11,textAlign:'center'}}>No data</div>}
            </div>
            {/* Table */}
            <div>
              <div style={{fontSize:12,fontWeight:700,color:'#555',marginBottom:8,textAlign:'center'}}>Match Type Utilization</div>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                <thead><tr style={{background:'#f8f9fc'}}>
                  {['Name','CVR','CPC','Spend','Sales','ACOS'].map((h,i)=>(
                    <th key={h} style={{padding:'7px 10px',textAlign:i===0?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2'}}>{h}
                      {i===3&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(totalSpend)}</div>}
                      {i===4&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(byMatchType.reduce((s,m)=>s+m.sales,0))}</div>}
                    </th>
                  ))}
                </tr></thead>
                <tbody>
                  {byMatchType.map((m,i)=>(
                    <tr key={i} style={{borderBottom:'1px solid #f0f2f7'}}>
                      <td style={{padding:'8px 10px',fontWeight:700,color:COLORS[i%COLORS.length]}}>{m.name}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtP(m.cvr)}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:'#555'}}>{fmtD(m.cpc)}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',fontWeight:600}}>{fmtD(m.spend)}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',fontWeight:600,color:'#1a9e5f'}}>{fmtD(m.sales)}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:m.acos>targetAcos?'#e05656':'#1a9e5f',fontWeight:700}}>{m.sales>0?fmtP(m.acos):'—'}</td>
                    </tr>
                  ))}
                  {byMatchType.length===0&&<tr><td colSpan={6} style={{textAlign:'center',padding:'20px',color:'#aaa'}}>Upload Targeting Report or Campaign Report</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════════════
     SECTION 8: AD TYPE UTILIZATION
  ═══════════════════════════════════════ */
  function AdTypeSection(){
    const rows=campData?.rows||[];
    const sm=cm(campData||{});

    const byAdType=useMemo(()=>{
      const map={SP:{name:'SP',spend:0,sales:0,clicks:0,orders:0,impressions:0},SB:{name:'SB',spend:0,sales:0,clicks:0,orders:0,impressions:0},SD:{name:'SD',spend:0,sales:0,clicks:0,orders:0,impressions:0}};
      rows.forEach(r=>{
        const entity=String(r['Entity']||r['entity']||'').toLowerCase();
        const camp=String(r['Campaign Name']||r['campaign name']||'').toLowerCase();
        let type='SP';
        if(entity.includes('sponsored brand')||camp.includes(' sb ')||camp.includes('| sb |')||camp.includes('- sb -'))type='SB';
        else if(entity.includes('sponsored display')||camp.includes(' sd ')||camp.includes('| sd |')||camp.includes('- sd -'))type='SD';
        map[type].spend+=n(r,sm.spend||'Spend')||n(r,'Spend');
        map[type].sales+=n(r,sm.sales||'Sales')||n(r,'14 Day Total Sales');
        map[type].clicks+=n(r,sm.clicks||'Clicks')||n(r,'Clicks');
        map[type].orders+=n(r,sm.orders||'Orders')||n(r,'14 Day Total Orders');
        map[type].impressions+=n(r,sm.impressions||'Impressions')||n(r,'Impressions');
      });
      const total={spend:Object.values(map).reduce((s,v)=>s+v.spend,0),sales:Object.values(map).reduce((s,v)=>s+v.sales,0),impressions:Object.values(map).reduce((s,v)=>s+v.impressions,0),clicks:Object.values(map).reduce((s,v)=>s+v.clicks,0)};
      return{
        types:Object.values(map).map(m=>({
          ...m,acos:m.sales>0?(m.spend/m.sales)*100:0,cvr:m.clicks>0?(m.orders/m.clicks)*100:0,
          cpc:m.clicks>0?m.spend/m.clicks:0,ctr:m.impressions>0?(m.clicks/m.impressions)*100:0,
          pctSpend:total.spend>0?(m.spend/total.spend)*100:0,pctSales:total.sales>0?(m.sales/total.sales)*100:0,
          pctImpressions:total.impressions>0?(m.impressions/total.impressions)*100:0,
        })),total
      };
    },[rows]);

    const COLORS={SP:'#1a5fa0',SB:'#c47a00',SD:'#1a9e5f'};

    return(
      <div style={{padding:'24px',maxWidth:1000}}>
        <PurposeBox
          purpose={['Measure performance and spend allocation across different ad types (SP, SB, SD)']}
          what={['Opportunities for leveraging different ad types','Over-allocating spend to SB or SD without proper SP support','Which ad type drives the best ROAS']}
        />
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'20px'}}>
          <h2 style={{fontSize:16,fontWeight:800,color:'#111',textAlign:'center',marginBottom:20}}>{clientName||'[CLIENT NAME]'} Amazon Account Audit</h2>

          {/* Three mini cards */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:16,marginBottom:20}}>
            {['Spend by Ad Type','Sales by Ad Type','ACOS by Ad Type'].map((title,ti)=>(
              <div key={title} style={{border:'1px solid #e8ebf2',borderRadius:8,padding:'12px'}}>
                <div style={{fontSize:11,fontWeight:700,color:'#555',textAlign:'center',marginBottom:10}}>{title}</div>
                {byAdType.types.filter(t=>(ti===0?t.spend:ti===1?t.sales:t.acos)>0).map((t,i)=>(
                  <div key={i} style={{display:'flex',alignItems:'center',gap:6,marginBottom:6}}>
                    <div style={{width:8,height:8,borderRadius:'50%',background:COLORS[t.name]||'#888',flexShrink:0}}/>
                    <span style={{fontSize:10,color:'#333',fontWeight:600}}>{t.name}</span>
                    <span style={{fontSize:10,color:COLORS[t.name]||'#888',marginLeft:'auto',fontWeight:700}}>
                      {ti===0?`${fmtD(t.spend)} (${t.pctSpend.toFixed(1)}%)`:ti===1?`${fmtD(t.sales)} (${t.pctSales.toFixed(1)}%)`:fmtP(t.acos)}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* Table */}
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead><tr style={{background:'#f8f9fc'}}>
                {['Name','% of Spend','Impressions','Clicks','CTR','Spend','Sales','ACOS','CVR','CPC'].map((h,i)=>(
                  <th key={h} style={{padding:'7px 10px',textAlign:i===0?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',whiteSpace:'nowrap'}}>
                    {h}
                    {i===5&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(byAdType.total.spend)}</div>}
                    {i===6&&<div style={{fontWeight:400,color:'#888'}}>{fmtD(byAdType.total.sales)}</div>}
                    {i===7&&<div style={{fontWeight:400,color:'#888'}}>{byAdType.total.sales>0?fmtP((byAdType.total.spend/byAdType.total.sales)*100):'—'}</div>}
                  </th>
                ))}
              </tr></thead>
              <tbody>
                {byAdType.types.map((t,i)=>(
                  <tr key={i} style={{borderBottom:'1px solid #f0f2f7',background:i%2===0?'#fff':'#fafbfc'}}>
                    <td style={{padding:'9px 12px',fontWeight:800,color:COLORS[t.name]||'#555',fontSize:13}}>{t.name}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{t.pctSpend.toFixed(1)}%</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{fmtN(t.impressions)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{fmtN(t.clicks)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{fmtP(t.ctr)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',fontWeight:700}}>{fmtD(t.spend)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',fontWeight:700,color:'#1a9e5f'}}>{fmtD(t.sales)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:t.acos>targetAcos?'#e05656':'#1a9e5f',fontWeight:700}}>{t.sales>0?fmtP(t.acos):'—'}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{fmtP(t.cvr)}</td>
                    <td style={{padding:'9px 10px',textAlign:'right',color:'#555'}}>{fmtD(t.cpc)}</td>
                  </tr>
                ))}
                {byAdType.types.every(t=>t.spend===0)&&<tr><td colSpan={10} style={{textAlign:'center',padding:'20px',color:'#aaa'}}>Upload Campaign Report in Data Hub</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  /* ── SECTIONS CONFIG ── */
  const SECTIONS=[
    {key:'overview',     label:'Overview',               icon:'ti-layout-dashboard'},
    {key:'products',     label:'Total Product Performance',icon:'ti-package'},
    {key:'placement',    label:'Placement Performance',   icon:'ti-layout-2'},
    {key:'bids',         label:'Bid Management',          icon:'ti-coin'},
    {key:'searchterms',  label:'Search Term Analysis',    icon:'ti-search'},
    {key:'tactic',       label:'Tactic Allocation',       icon:'ti-chart-pie'},
    {key:'matchtype',    label:'Match Type Performance',  icon:'ti-list-check'},
    {key:'adtype',       label:'Ad Type Utilization',     icon:'ti-speakerphone'},
  ];

  const RENDER={overview:<OverviewSection/>,products:<ProductPerformanceSection/>,placement:<PlacementSection/>,bids:<BidManagementSection/>,searchterms:<SearchTermSection/>,tactic:<TacticAllocationSection/>,matchtype:<MatchTypeSection/>,adtype:<AdTypeSection/>};

  return(
    <div style={{display:'flex',height:'100%',overflow:'hidden'}}>
      {/* Sub-sidebar */}
      <div style={{width:210,background:'#f8f9fc',borderRight:'1px solid #e8ebf2',display:'flex',flexDirection:'column',flexShrink:0,overflowY:'auto'}}>
        <div style={{padding:'12px 14px',borderBottom:'1px solid #e8ebf2'}}>
          <div style={{fontSize:11,fontWeight:700,color:'#8893a7',textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:6}}>Sections</div>
          {editingClient?(
            <input autoFocus value={clientName} onChange={e=>setClientName(e.target.value)} onBlur={()=>setEditingClient(false)} onKeyDown={e=>e.key==='Enter'&&setEditingClient(false)} style={{width:'100%',padding:'4px 8px',borderRadius:5,border:'1px solid #1a5fa0',fontSize:11,outline:'none',boxSizing:'border-box'}}/>
          ):(
            <div onClick={()=>setEditingClient(true)} style={{fontSize:11,fontWeight:700,color:'#1a5fa0',cursor:'pointer',padding:'3px 6px',borderRadius:5,background:'rgba(26,95,160,0.08)'}} title="Click to set client name">
              {clientName||'[CLIENT NAME]'} Amazon Audit ✏
            </div>
          )}
        </div>
        <div style={{flex:1,padding:'8px 0'}}>
          {SECTIONS.map(s=>(
            <button key={s.key} onClick={()=>setSection(s.key)} style={{width:'100%',padding:'8px 14px',border:'none',background:section===s.key?'rgba(26,95,160,0.12)':'transparent',cursor:'pointer',display:'flex',alignItems:'center',gap:8,textAlign:'left',color:section===s.key?'#1a5fa0':'#444',fontSize:12,fontWeight:section===s.key?700:400,borderLeft:`3px solid ${section===s.key?'#1a5fa0':'transparent'}`}}>
              <i className={`ti ${s.icon}`} style={{fontSize:12,flexShrink:0}}/>
              <span style={{lineHeight:1.3}}>{s.label}</span>
            </button>
          ))}
        </div>
        <div style={{padding:'10px 14px',borderTop:'1px solid #e8ebf2',fontSize:10,color:'#aaa',textAlign:'center'}}>
          Upload reports in Data Hub to populate all sections
        </div>
      </div>

      {/* Content area */}
      <div style={{flex:1,overflowY:'auto',background:'#f4f6fb'}}>
        {RENDER[section]||<OverviewSection/>}
      </div>
    </div>
  );
}


/* ================================================================
   PRIORITY ENGINE MODULE
   Strategist command decision center — account-wide priority intelligence.
   Sections: Overview · Alerts · Priority Table · Action Ranking
             Movement Analysis · AI Strategist Lead · Export
   No upload — syncs everything from Global Data Hub.
================================================================ */

/* ── Priority scoring constants ─────────────────────────────── */
const PE_TYPES=[
  {key:"waste",      label:"Critical Waste",       color:"#d42b2b", bg:"rgba(212,43,43,0.1)",  icon:"ti-droplet-off",  source:"Bleeder Check"},
  {key:"scale",      label:"Scale Opportunity",    color:"#1a7a3c", bg:"rgba(26,122,60,0.1)",  icon:"ti-rocket",       source:"Campaign Suggestions"},
  {key:"visibility", label:"Visibility Decline",   color:"#6338c8", bg:"rgba(99,56,200,0.1)",  icon:"ti-eye-off",      source:"Impression Share"},
  {key:"budget",     label:"Budget Constraint",    color:"#1a5fa0", bg:"rgba(26,95,160,0.1)",  icon:"ti-cash",         source:"Action Center"},
  {key:"conversion", label:"Conversion Weakness",  color:"#c47a00", bg:"rgba(196,122,0,0.1)",  icon:"ti-percentage",   source:"Listing Conversion"},
  {key:"structure",  label:"Structural Conflict",  color:"#4f46e5", bg:"rgba(79,70,229,0.1)",    icon:"ti-sitemap",      source:"Conflict Detector"},
  {key:"cpc",        label:"CPC Inflation",        color:"#c47a00", bg:"rgba(196,122,0,0.1)",  icon:"ti-trending-up",  source:"Campaign Health"},
  {key:"ranking",    label:"Ranking Momentum",     color:"#2a6496", bg:"rgba(42,100,150,0.1)", icon:"ti-chart-bar",    source:"Rank Radar"},
];

/* Compute priority score per row */
function pePriorityScore(m, compM, type){
  let score=40;
  // Spend impact
  if(m.spend>50)score+=20; else if(m.spend>20)score+=12; else if(m.spend>8)score+=6;
  // Type-specific boosts
  if(type==="waste"&&m.orders===0)score+=25;
  if(type==="scale"&&m.acos>0&&m.acos<25&&m.orders>=2)score+=20;
  if(type==="visibility"&&compM&&m.impressions<compM.impressions*0.6)score+=20;
  if(type==="cpc"&&compM&&compM.cpc>0&&m.cpc>compM.cpc*1.3)score+=18;
  if(type==="conversion"&&m.cvr<1&&m.clicks>15)score+=15;
  // Comparison delta urgency
  if(compM){
    if(m.acos>0&&compM.acos>0&&m.acos>compM.acos*1.3)score+=10;
    if(m.sales<compM.sales*0.75&&compM.sales>5)score+=12;
  }
  return Math.min(100,Math.round(score));
}

function peClassifyRow(m, compM){
  if(m.spend>5&&m.orders===0) return "waste";
  if(m.acos>0&&m.acos<25&&m.orders>=2&&m.impressions<600) return "scale";
  if(compM&&m.impressions<compM.impressions*0.55&&m.orders>0) return "visibility";
  if(compM&&compM.cpc>0&&m.cpc>compM.cpc*1.3&&m.orders===0&&m.spend>8) return "cpc";
  if(m.cvr<0.8&&m.clicks>20) return "conversion";
  if(compM&&m.sales<compM.sales*0.7&&compM.sales>5) return "scale"; // recovery opportunity
  if(m.acos>70&&m.spend>10) return "waste";
  return "scale";
}

/* Build priority items from globalData */
function peBuildItems(rows, cm, compRows, compCm){
  if(!rows||!cm) return [];
  const compMap={};
  if(compRows&&compCm){
    compRows.forEach(r=>{
      const k=(r[compCm.campaign]||r[compCm.keyword]||"").toLowerCase();
      if(k) compMap[k]=calcRowMetrics(r,compCm);
    });
  }
  return rows.map(row=>{
    const name=row[cm.campaign]||row[cm.keyword]||row[cm.searchTerm]||"Unknown";
    const m=calcRowMetrics(row,cm);
    if(m.spend<0.5&&m.impressions<20) return null;
    const compM=compMap[name.toLowerCase()]||null;
    const type=peClassifyRow(m,compM);
    const priorityScore=pePriorityScore(m,compM,type);
    const urgency=priorityScore>=75?"Critical":priorityScore>=55?"High":priorityScore>=35?"Medium":"Low";
    const typeDef=PE_TYPES.find(t=>t.key===type)||PE_TYPES[0];
    const spendImpact=type==="waste"?m.spend:type==="scale"?m.sales*0.3:m.spend*0.2;
    const salesImpact=type==="scale"?m.sales:compM?Math.abs(m.sales-compM.sales):0;
    return{name,type,typeDef,priorityScore,urgency,metrics:m,compMetrics:compM,spendImpact,salesImpact};
  }).filter(Boolean).sort((a,b)=>b.priorityScore-a.priorityScore);
}

/* Account movement analysis */
function peMovement(rows, cm, compRows, compCm){
  if(!rows||!cm) return null;
  const cur={spend:0,sales:0,orders:0,impressions:0,clicks:0,cpc_sum:0,cvr_sum:0,n:0};
  rows.forEach(r=>{const m=calcRowMetrics(r,cm);cur.spend+=m.spend;cur.sales+=m.sales;cur.orders+=m.orders;cur.impressions+=m.impressions;cur.clicks+=m.clicks;if(m.cpc>0){cur.cpc_sum+=m.cpc;cur.n++;}if(m.cvr>0)cur.cvr_sum+=m.cvr;});
  cur.acos=cur.sales>0?(cur.spend/cur.sales)*100:0;
  cur.avgCpc=cur.n>0?cur.cpc_sum/cur.n:0;
  cur.avgCvr=rows.length>0?cur.cvr_sum/rows.length:0;

  let prev=null;
  if(compRows&&compCm&&compRows.length){
    prev={spend:0,sales:0,orders:0,impressions:0,clicks:0,cpc_sum:0,cvr_sum:0,n:0};
    compRows.forEach(r=>{const m=calcRowMetrics(r,compCm);prev.spend+=m.spend;prev.sales+=m.sales;prev.orders+=m.orders;prev.impressions+=m.impressions;prev.clicks+=m.clicks;if(m.cpc>0){prev.cpc_sum+=m.cpc;prev.n++;}if(m.cvr>0)prev.cvr_sum+=m.cvr;});
    prev.acos=prev.sales>0?(prev.spend/prev.sales)*100:0;
    prev.avgCpc=prev.n>0?prev.cpc_sum/prev.n:0;
    prev.avgCvr=compRows.length>0?prev.cvr_sum/compRows.length:0;
  }
  return{cur,prev};
}

/* ── Sub-components ─────────────────────────────────────────── */
function PEEmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(79,70,229,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-list-check" style={{fontSize:26,color:R}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Priority Engine needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:380,lineHeight:1.6,marginBottom:20}}>Upload a Campaign Report or Bulk File in the Data Hub. The Priority Engine scans all campaigns and surfaces the highest-impact actions first — so you always know what to do next.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Overview cards */
function PEOverview({items,movement}){
  const critical=items.filter(i=>i.urgency==="Critical").length;
  const high=items.filter(i=>i.urgency==="High").length;
  const wasteItems=items.filter(i=>i.type==="waste");
  const wasteSpend=wasteItems.reduce((s,i)=>s+i.metrics.spend,0);
  const scaleItems=items.filter(i=>i.type==="scale");
  const visItems=items.filter(i=>i.type==="visibility");
  const top=items[0];
  const overallScore=items.length?Math.round(items.slice(0,10).reduce((s,i)=>s+i.priorityScore,0)/Math.min(items.length,10)):0;

  const cards=[
    {label:"Critical Issues",    val:critical,                sub:"require immediate action",icon:"ti-alert-octagon",  color:"#d42b2b"},
    {label:"High Priority",      val:high,                    sub:"act within 24–48h",       icon:"ti-alert-triangle", color:"#c47a00"},
    {label:"Waste Spend",        val:`$${wasteSpend.toFixed(0)}`, sub:`${wasteItems.length} entities bleeding`,icon:"ti-droplet-off",color:"#d42b2b"},
    {label:"Scale Opportunities",val:scaleItems.length,       sub:"ready to grow",           icon:"ti-rocket",         color:"#1a7a3c"},
    {label:"Visibility Risks",   val:visItems.length,         sub:"impression decline",      icon:"ti-eye-off",        color:"#6338c8"},
    {label:"Priority Score",     val:overallScore,            sub:"account urgency level",   icon:"ti-target",         color:R},
  ];
  return(
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
        {cards.map(c=>(
          <div key={c.label} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
              <div style={{width:30,height:30,borderRadius:8,background:`${c.color}18`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
              </div>
              <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
            </div>
            <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:2}}>{c.val}</div>
            <div style={{fontSize:11,color:"#aaa"}}>{c.sub}</div>
          </div>
        ))}
      </div>
      {/* Top priority strip */}
      {top&&(
        <div style={{background:"#fff",borderRadius:12,border:`2px solid ${top.typeDef.color}30`,padding:"14px 18px",marginBottom:0}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
            <span style={{fontSize:10,fontWeight:700,color:"#d42b2b",background:"rgba(212,43,43,0.1)",padding:"2px 8px",borderRadius:3}}>TOP PRIORITY RIGHT NOW</span>
            <span style={{fontSize:10,color:"#aaa"}}>Priority score: {top.priorityScore}/100</span>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <div style={{width:36,height:36,borderRadius:10,background:`${top.typeDef.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${top.typeDef.icon}`} style={{fontSize:17,color:top.typeDef.color}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:700,color:"#111",marginBottom:2}}>{top.name}</div>
              <div style={{fontSize:12,color:"#555"}}>
                <span style={{color:top.typeDef.color,fontWeight:600}}>{top.typeDef.label}</span>
                <span style={{color:"#aaa",margin:"0 8px"}}>·</span>
                ${top.metrics.spend.toFixed(2)} spend
                <span style={{color:"#aaa",margin:"0 8px"}}>·</span>
                {top.metrics.orders} orders
                <span style={{color:"#aaa",margin:"0 8px"}}>·</span>
                {top.metrics.acos>0?`${top.metrics.acos.toFixed(1)}% ACoS`:"No sales"}
              </div>
            </div>
            <span style={{fontSize:11,padding:"4px 12px",borderRadius:6,background:`${top.typeDef.color}14`,color:top.typeDef.color,fontWeight:700,flexShrink:0}}>{top.urgency}</span>
          </div>
        </div>
      )}
    </div>
  );
}

/* Alert engine */
function PEAlerts({items}){
  const[expanded,setExpanded]=useState({});
  const toggle=i=>setExpanded(p=>({...p,[i]:!p[i]}));

  const groups=[
    {
      key:"waste",sev:"Critical",title:"Emergency Waste — Immediate Action Required",
      items:items.filter(i=>i.type==="waste"&&i.urgency==="Critical").slice(0,8),
      color:"#d42b2b",border:"rgba(212,43,43,0.25)",bg:"rgba(212,43,43,0.05)",
      explain:"These entities are consuming significant budget with zero orders. Every hour they run is recoverable money lost.",
      action:"Pause or negate immediately. Run Negation Engine to identify search term root causes.",
      source:"Bleeder Check",confidence:96
    },
    {
      key:"scale",sev:"High",title:"High-Impact Scaling — Scale These Now",
      items:items.filter(i=>i.type==="scale"&&i.priorityScore>=60).slice(0,8),
      color:"#1a7a3c",border:"rgba(26,122,60,0.2)",bg:"rgba(26,122,60,0.05)",
      explain:"Proven profitable campaigns being held back. These are the highest ROI investments in your account right now.",
      action:"Increase bids 20–30%. Remove budget caps. Add exact match variants.",
      source:"Campaign Suggestions",confidence:90
    },
    {
      key:"visibility",sev:"High",title:"Visibility Collapse — Impression Share Declining",
      items:items.filter(i=>i.type==="visibility").slice(0,8),
      color:"#6338c8",border:"rgba(99,56,200,0.2)",bg:"rgba(99,56,200,0.05)",
      explain:"Converting campaigns are losing impression share vs previous period. Visibility loss compounds into ranking loss.",
      action:"Increase bids. Check budget caps. Add TOS modifier +30–50%.",
      source:"Impression Share",confidence:85
    },
    {
      key:"cpc",sev:"Medium",title:"CPC Inflation — Cost Pressure Rising",
      items:items.filter(i=>i.type==="cpc").slice(0,6),
      color:"#c47a00",border:"rgba(196,122,0,0.2)",bg:"rgba(196,122,0,0.05)",
      explain:"CPC has risen 30%+ vs previous period on non-converting entities. Over-paying for traffic that doesn't convert.",
      action:"Cap bids. Reduce 15–25%. Investigate match type quality on these terms.",
      source:"Campaign Health",confidence:82
    },
    {
      key:"conversion",sev:"Medium",title:"Conversion Weakness — Traffic Not Monetising",
      items:items.filter(i=>i.type==="conversion").slice(0,6),
      color:"#4f46e5",border:"rgba(79,70,229,0.2)",bg:"rgba(79,70,229,0.04)",
      explain:"High click volume with very low CVR. PPC is driving traffic that listing can't convert. Fix the listing before scaling spend.",
      action:"Run Listing Conversion module. Check Buy Box, pricing, hero image. Reduce bids until CVR improves.",
      source:"Listing Conversion",confidence:78
    },
  ].filter(g=>g.items.length>0);

  if(!groups.length) return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:10,border:"1px solid rgba(26,122,60,0.2)"}}>
      <i className="ti ti-check-circle" style={{fontSize:16,color:"#1a7a3c"}}/>
      <span style={{fontSize:13,color:"#1a7a3c",fontWeight:600}}>No critical priorities detected. Account looks in good shape.</span>
    </div>
  );
  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {groups.map((g,i)=>(
        <div key={i} style={{background:g.bg,borderRadius:12,border:`1px solid ${g.border}`,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,cursor:"pointer"}} onClick={()=>toggle(i)}>
            <i className={`ti ${PE_TYPES.find(t=>t.key===g.key)?.icon||"ti-alert"}`} style={{fontSize:14,color:g.color}}/>
            <span style={{fontSize:13,fontWeight:700,color:g.color}}>{g.sev} — {g.title}</span>
            <span style={{marginLeft:"auto",fontSize:10,color:"#aaa"}}>Source: {g.source} · {g.items.length} entities · {g.confidence}%</span>
            <i className={`ti ${expanded[i]?"ti-chevron-up":"ti-chevron-down"}`} style={{fontSize:12,color:"#aaa"}}/>
          </div>
          <div style={{fontSize:12,color:"#444",lineHeight:1.6,marginBottom:8}}>{g.explain}</div>
          <div style={{fontSize:11,background:"rgba(255,255,255,0.6)",borderRadius:7,padding:"7px 10px",marginBottom:8}}>
            <i className="ti ti-bulb" style={{fontSize:11,marginRight:4,color:"#c47a00"}}/>
            <strong>Action: </strong>{g.action}
          </div>
          {expanded[i]&&(
            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:8}}>
              {g.items.map((item,j)=>(
                <div key={j} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 12px",background:"rgba(255,255,255,0.8)",borderRadius:8}}>
                  <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.name}</span>
                  <span style={{fontSize:11,fontWeight:700,color:g.color}}>Score {item.priorityScore}</span>
                  <span style={{fontSize:11,color:"#555"}}>${item.metrics.spend.toFixed(0)} spend</span>
                  <span style={{fontSize:11,color:item.metrics.orders>0?"#1a7a3c":"#d42b2b"}}>{item.metrics.orders} orders</span>
                  {item.compMetrics&&<span style={{fontSize:10,color:item.metrics.sales>item.compMetrics.sales?"#1a7a3c":"#d42b2b",fontWeight:600}}>{item.metrics.sales>item.compMetrics.sales?"▲":"▼"}</span>}
                </div>
              ))}
            </div>
          )}
          {!expanded[i]&&(
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {g.items.map((item,j)=>(
                <span key={j} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(255,255,255,0.7)",color:g.color,fontWeight:600,border:`1px solid ${g.border}`,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.name}</span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/* Priority table */
function PETable({items,onExport}){
  const[sevFilter,setSevFilter]=useState("all");
  const[typeFilter,setTypeFilter]=useState("all");
  const[sort,setSort]=useState("priority");
  const[search,setSearch]=useState("");

  const filtered=items.filter(item=>{
    if(sevFilter!=="all"&&item.urgency.toLowerCase()!==sevFilter) return false;
    if(typeFilter!=="all"&&item.type!==typeFilter) return false;
    if(search&&!item.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  const sorted=[...filtered].sort((a,b)=>{
    if(sort==="priority") return b.priorityScore-a.priorityScore;
    if(sort==="spend")    return b.metrics.spend-a.metrics.spend;
    if(sort==="impact")   return b.spendImpact-a.spendImpact;
    if(sort==="sales")    return b.metrics.sales-a.metrics.sales;
    return 0;
  });

  const urgColor={Critical:"#d42b2b",High:"#c47a00",Medium:"#1a5fa0",Low:"#888"};
  const urgBg={Critical:"rgba(212,43,43,0.08)",High:"rgba(196,122,0,0.08)",Medium:"rgba(26,95,160,0.08)",Low:"rgba(0,0,0,0.05)"};

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..." style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:180}}/>
        <div style={{display:"flex",gap:4}}>
          {["all","critical","high","medium","low"].map(s=>(
            <button key={s} onClick={()=>setSevFilter(s)} style={{padding:"4px 9px",borderRadius:14,border:`1px solid ${sevFilter===s?"#4f46e5":"#e0e0e0"}`,background:sevFilter===s?"#4f46e5":"#fff",color:sevFilter===s?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer",textTransform:"capitalize"}}>{s}</button>
          ))}
        </div>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {[{key:"all",label:"All"},...PE_TYPES.map(t=>({key:t.key,label:t.label}))].map(f=>(
            <button key={f.key} onClick={()=>setTypeFilter(f.key)} style={{padding:"4px 8px",borderRadius:14,border:`1px solid ${typeFilter===f.key?"#1a5fa0":"#e0e0e0"}`,background:typeFilter===f.key?"#1a5fa0":"#fff",color:typeFilter===f.key?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer"}}>{f.label}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"5px 10px",borderRadius:7,border:"1px solid #e0e0e0",fontSize:12,color:"#555",cursor:"pointer"}}>
          <option value="priority">Sort: Priority Score</option>
          <option value="spend">Sort: Spend</option>
          <option value="impact">Sort: Spend Impact</option>
          <option value="sales">Sort: Sales</option>
        </select>
        <button onClick={()=>onExport(sorted)} style={{...T.btnR(true),fontSize:11,padding:"6px 12px"}}><i className="ti ti-download" style={{fontSize:12}}/>Export ({sorted.length})</button>
      </div>
      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #f0f0f0",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f7f7f7"}}>
              {["#","Entity","Type","Priority","Urgency","Spend Impact","Spend","Sales","ACoS","Orders","Source","vs Prev"].map(h=>(
                <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0,150).map((item,i)=>{
              const m=item.metrics; const c=item.compMetrics;
              const ac=m.acos>70?"#d42b2b":m.acos>40?"#c47a00":"#111";
              return(
                <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 10px",fontWeight:800,color:"#aaa",fontSize:11}}>{i+1}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:"#111",maxWidth:170,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={item.name}>{item.name}</td>
                  <td style={{padding:"8px 10px"}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:10,padding:"2px 7px",borderRadius:4,background:item.typeDef.bg,color:item.typeDef.color,fontWeight:700,whiteSpace:"nowrap"}}>
                      <i className={`ti ${item.typeDef.icon}`} style={{fontSize:10}}/>{item.typeDef.label}
                    </span>
                  </td>
                  <td style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:5}}>
                      <div style={{width:30,height:5,borderRadius:3,background:"#f0f0f0",overflow:"hidden"}}>
                        <div style={{width:`${item.priorityScore}%`,height:"100%",background:item.priorityScore>=75?"#d42b2b":item.priorityScore>=55?"#c47a00":"#1a5fa0"}}/>
                      </div>
                      <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{item.priorityScore}</span>
                    </div>
                  </td>
                  <td style={{padding:"8px 10px"}}><span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:urgBg[item.urgency]||"rgba(0,0,0,0.05)",color:urgColor[item.urgency]||"#888",fontWeight:700}}>{item.urgency}</span></td>
                  <td style={{padding:"8px 10px",color:"#d42b2b",fontWeight:600}}>${item.spendImpact.toFixed(0)}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.spend.toFixed(2)}</td>
                  <td style={{padding:"8px 10px",color:"#555"}}>${m.sales.toFixed(2)}{c&&<div style={{fontSize:10,color:m.sales>c.sales?"#1a7a3c":"#d42b2b"}}>{m.sales>c.sales?"+":""}{(m.sales-c.sales).toFixed(2)}</div>}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:ac}}>{m.acos>0?`${m.acos.toFixed(1)}%`:"—"}</td>
                  <td style={{padding:"8px 10px",fontWeight:600,color:m.orders>0?"#1a7a3c":"#888"}}>{m.orders}</td>
                  <td style={{padding:"8px 10px",fontSize:10,color:"#888"}}>{item.typeDef.source}</td>
                  <td style={{padding:"8px 10px",fontSize:11,color:c?m.sales>c.sales?"#1a7a3c":"#d42b2b":"#aaa",fontWeight:600}}>
                    {c?`${m.sales>c.sales?"+":""}{c.sales>0?((m.sales-c.sales)/c.sales*100).toFixed(0):"+∞"}%`:"—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sorted.length>150&&<div style={{textAlign:"center",padding:"10px",fontSize:11,color:"#aaa"}}>Showing 150 of {sorted.length}</div>}
        {sorted.length===0&&<div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No items match this filter.</div>}
      </div>
    </div>
  );
}

/* Action ranking panels */
function PEActionRanking({items}){
  const ranked=[
    {
      rank:1,title:"Stop the Bleeding — Eliminate Waste First",icon:"ti-droplet-off",color:"#d42b2b",urgency:"Immediate",
      items:items.filter(i=>i.type==="waste").slice(0,8),
      why:"Waste reduction has zero risk and immediate dollar return. Every paused zero-order entity is instant money back.",
      action:"Pause all entities with 10+ clicks and zero orders. Run Negation Engine. Block waste search terms.",
      impact:`$${items.filter(i=>i.type==="waste").reduce((s,i)=>s+i.metrics.spend,0).toFixed(0)} potentially recoverable`
    },
    {
      rank:2,title:"Scale Winners — Maximum ROI Right Now",icon:"ti-rocket",color:"#1a7a3c",urgency:"This Week",
      items:items.filter(i=>i.type==="scale"&&i.priorityScore>=60).slice(0,8),
      why:"Scaling proven converters is the highest-impact positive action. These deliver revenue growth without ACoS risk.",
      action:"Increase bids 20–30% on <25% ACoS campaigns. Remove budget caps. Expand keyword coverage.",
      impact:`${items.filter(i=>i.type==="scale").length} scalable campaigns identified`
    },
    {
      rank:3,title:"Recover Visibility — Stop Impression Loss",icon:"ti-eye",color:"#6338c8",urgency:"This Week",
      items:items.filter(i=>i.type==="visibility").slice(0,8),
      why:"Visibility loss on converting campaigns costs compound — lost impressions = lost data = worse optimisation signal.",
      action:"Increase bids on declining impression campaigns. Check budget cap. Add TOS modifier.",
      impact:"Restore impression share before it triggers ranking decline"
    },
    {
      rank:4,title:"Fix CPC Inflation — Protect Margins",icon:"ti-trending-up",color:"#c47a00",urgency:"This Week",
      items:items.filter(i=>i.type==="cpc").slice(0,6),
      why:"CPC rising without sales improvement directly compresses margins. Unchecked, it spreads to adjacent keywords.",
      action:"Apply bid reduction rules. Set CPC caps. Audit match types for broad/phrase overlap.",
      impact:"Margin protection + spend efficiency improvement"
    },
    {
      rank:5,title:"Repair Conversion — Fix the Funnel",icon:"ti-percentage",color:"#4f46e5",urgency:"Next 2 Weeks",
      items:items.filter(i=>i.type==="conversion").slice(0,6),
      why:"No amount of bid optimisation fixes a broken listing. CVR issues make all PPC investment less efficient.",
      action:"Run Listing Conversion module. Fix CVR before scaling any of these keywords.",
      impact:"Every 1pp CVR lift multiplies all existing traffic value"
    },
  ].filter(r=>r.items.length>0);

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {ranked.map((r,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid rgba(0,0,0,0.06)",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
            <div style={{width:28,height:28,borderRadius:7,background:`${r.color}20`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontWeight:900,fontSize:13,color:r.color}}>#{r.rank}</div>
            <div style={{width:28,height:28,borderRadius:7,background:`${r.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${r.icon}`} style={{fontSize:13,color:r.color}}/>
            </div>
            <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{r.title}</div>
            <span style={{marginLeft:"auto",fontSize:10,padding:"2px 7px",borderRadius:4,background:`${r.color}12`,color:r.color,fontWeight:700,flexShrink:0}}>{r.urgency}</span>
          </div>
          <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{r.why}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Action: </strong>{r.action}</div>
            <div style={{background:"#fafafa",borderRadius:7,padding:"8px 10px",fontSize:11,color:"#555"}}><strong style={{color:"#333"}}>Impact: </strong>{r.impact}</div>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {r.items.map((item,j)=>(
              <span key={j} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${r.color}10`,color:r.color,fontWeight:600,border:`1px solid ${r.color}30`,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.name}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/* Movement analysis */
function PEMovementPanel({movement}){
  if(!movement) return null;
  const{cur,prev}=movement;

  const metrics=[
    {label:"Total Spend",    cur:cur.spend,        prev:prev?.spend,        fmt:v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`, lowerBetter:true},
    {label:"Total Sales",    cur:cur.sales,        prev:prev?.sales,        fmt:v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`, lowerBetter:false},
    {label:"Total Orders",   cur:cur.orders,       prev:prev?.orders,       fmt:v=>String(Math.round(v)),lowerBetter:false},
    {label:"Overall ACoS",   cur:cur.acos,         prev:prev?.acos,         fmt:v=>`${v.toFixed(1)}%`,lowerBetter:true},
    {label:"Avg CPC",        cur:cur.avgCpc,       prev:prev?.avgCpc,       fmt:v=>`$${v.toFixed(2)}`,lowerBetter:true},
    {label:"Avg CVR",        cur:cur.avgCvr,       prev:prev?.avgCvr,       fmt:v=>`${v.toFixed(1)}%`,lowerBetter:false},
    {label:"Impressions",    cur:cur.impressions,  prev:prev?.impressions,  fmt:v=>v>=1000?(v/1000).toFixed(1)+"K":String(Math.round(v)),lowerBetter:false},
    {label:"Clicks",         cur:cur.clicks,       prev:prev?.clicks,       fmt:v=>String(Math.round(v)),lowerBetter:false},
  ];

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {!prev&&<div style={{padding:"10px 14px",background:"rgba(196,122,0,0.07)",borderRadius:8,border:"1px solid rgba(196,122,0,0.2)",fontSize:12,color:"#c47a00",marginBottom:14}}>Upload comparison period data in the Data Hub to see movement trends.</div>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10}}>
        {metrics.map(m=>{
          const hasPrev=prev&&m.prev!=null&&m.prev>0;
          const delta=hasPrev?((m.cur-m.prev)/m.prev)*100:null;
          const improving=delta!==null?(m.lowerBetter?delta<0:delta>0):null;
          return(
            <div key={m.label} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.03)"}}>
              <div style={{fontSize:11,color:"#888",fontWeight:600,marginBottom:8}}>{m.label}</div>
              <div style={{fontSize:20,fontWeight:800,color:"#111",marginBottom:4}}>{m.fmt(m.cur)}</div>
              {hasPrev?(
                <div style={{display:"flex",alignItems:"center",gap:6}}>
                  <span style={{fontSize:11,fontWeight:700,color:improving?"#1a7a3c":"#d42b2b"}}>
                    {delta>0?"+":""}{delta.toFixed(0)}%
                  </span>
                  <span style={{fontSize:10,color:"#aaa"}}>vs {m.fmt(m.prev)}</span>
                </div>
              ):<div style={{fontSize:10,color:"#ccc"}}>No comparison data</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* AI strategist lead */
function PEAIStrategist({items,movement}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);

  const critical=items.filter(i=>i.urgency==="Critical");
  const wasteSpend=items.filter(i=>i.type==="waste").reduce((s,i)=>s+i.metrics.spend,0);
  const scaleCount=items.filter(i=>i.type==="scale").length;
  const mv=movement?.cur;

  async function runAnalysis(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    setLoading(true);setResult(null);

    const prompt=`You are a senior Amazon PPC strategist. Based ONLY on the priority data below, tell me what to do first, second, and third. Be direct and specific. Think like a senior consultant giving a 30-minute strategy session.

PRIORITY DATA:
- Total items prioritised: ${items.length}
- Critical urgency: ${critical.length}
- Waste spend (zero orders): $${wasteSpend.toFixed(0)}
- Scale opportunities: ${scaleCount}
- Visibility declining: ${items.filter(i=>i.type==="visibility").length}
- CPC inflation: ${items.filter(i=>i.type==="cpc").length}
- Conversion issues: ${items.filter(i=>i.type==="conversion").length}
- Top priority entity: ${items[0]?.name||"none"} (score:${items[0]?.priorityScore}, type:${items[0]?.type})
${mv?`- Account ACoS: ${mv.acos.toFixed(1)}%
- Total spend: $${mv.spend.toFixed(0)}
- Total sales: $${mv.sales.toFixed(0)}`:""}
- Priority breakdown: ${PE_TYPES.map(t=>({t:t.label,c:items.filter(i=>i.type===t.key).length})).filter(x=>x.c>0).map(x=>`${x.t}:${x.c}`).join(", ")}

Respond in JSON ONLY (no markdown, no backticks):
{"priorities":[{"rank":1,"action":"...","reasoning":"...","expectedResult":"...","timeframe":"..."},{"rank":2,"action":"...","reasoning":"...","expectedResult":"...","timeframe":"..."},{"rank":3,"action":"...","reasoning":"...","expectedResult":"...","timeframe":"..."}]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.25,maxOutputTokens:1000}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Analysis failed. Check your API key."});}
    setLoading(false);
  }

  return(
    <div style={{maxWidth:800}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:4}}>AI Strategist Lead (Gemini)</div>
        <div style={{fontSize:11,color:"#888",marginBottom:12}}>AI gives you your top 3 priorities in order — what to do first, second, and third. Based on your actual account data only.</div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={runAnalysis} disabled={loading} style={{...T.btnR(false),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Thinking...</>:<><i className="ti ti-brain" style={{fontSize:13}}/>Get My Priorities</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa",marginTop:8}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>
      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b"}}>{result.error}</div>}
      {result?.priorities&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {result.priorities.map((p,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:11,border:`2px solid ${p.rank===1?"#4f46e5":p.rank===2?"#c47a00":"#e0e0e0"}`,padding:"16px 18px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                <div style={{width:32,height:32,borderRadius:8,background:p.rank===1?"#4f46e5":p.rank===2?"#c47a00":"#e8e8e8",display:"flex",alignItems:"center",justifyContent:"center",color:p.rank<=2?"#fff":"#555",fontWeight:900,fontSize:14,flexShrink:0}}>#{p.rank}</div>
                <span style={{fontSize:15,fontWeight:800,color:"#111"}}>{p.action}</span>
                <span style={{marginLeft:"auto",fontSize:10,color:"#aaa",flexShrink:0}}>{p.timeframe}</span>
              </div>
              <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:8}}>{p.reasoning}</div>
              <div style={{fontSize:11,background:p.rank===1?"rgba(79,70,229,0.06)":"rgba(26,122,60,0.06)",borderRadius:7,padding:"7px 10px",color:p.rank===1?"#4f46e5":"#1a7a3c"}}>
                <i className="ti ti-trending-up" style={{fontSize:11,marginRight:4}}/>Expected: {p.expectedResult}
              </div>
            </div>
          ))}
        </div>
      )}
      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"28px",textAlign:"center"}}>
          <i className="ti ti-list-check" style={{fontSize:32,color:"#ddd",display:"block",marginBottom:10}}/>
          <div style={{fontSize:13,fontWeight:600,color:"#888",marginBottom:6}}>Ready to tell you your top 3 priorities</div>
          <div style={{fontSize:12,color:"#aaa"}}>Enter your Gemini key and click Get My Priorities.<br/>AI analyses all {items.length} ranked items and tells you exactly what to do first.</div>
        </div>
      )}
    </div>
  );
}

/* Export */
function peExport(items, type){
  const map={
    all:items,
    critical:items.filter(i=>i.urgency==="Critical"),
    waste:items.filter(i=>i.type==="waste"),
    scale:items.filter(i=>i.type==="scale"),
    visibility:items.filter(i=>i.type==="visibility"),
    top20:items.slice(0,20),
  };
  const rows=(map[type]||items).map((item,idx)=>({
    "Rank":idx+1,"Entity":item.name,
    "Issue Type":item.typeDef.label,"Priority Score":item.priorityScore,
    "Urgency":item.urgency,"Source Module":item.typeDef.source,
    "Spend Impact ($)":item.spendImpact.toFixed(2),
    "Spend ($)":item.metrics.spend.toFixed(2),"Sales ($)":item.metrics.sales.toFixed(2),
    "Orders":item.metrics.orders,"ACoS (%)":item.metrics.acos.toFixed(1),
    "CPC ($)":item.metrics.cpc.toFixed(2),"CVR (%)":item.metrics.cvr.toFixed(1),
    "Prev Sales ($)":item.compMetrics?item.compMetrics.sales.toFixed(2):"—",
  }));
  if(!rows.length){alert("No data for this export.");return;}
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:18}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Priority Engine");
  XLSX.writeFile(wb,`priority_engine_${type}_${Date.now()}.xlsx`);
}

/* ── Priority Engine Module Root ────────────────────────────── */
function PriorityEngineModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("overview");

  const rows=globalData?.cur?.campaign?.rows||globalData?.cur?.primary?.rows||globalData?.cur?.bulk?.rows||[];
  const cm=globalData?.cur?.campaign?.cm||globalData?.cur?.primary?.cm||globalData?.cur?.bulk?.cm||{};
  const compRows=globalData?.comp?.campaign?.rows||globalData?.comp?.primary?.rows||[];
  const compCm=globalData?.comp?.campaign?.cm||globalData?.comp?.primary?.cm||{};
  const hasData=rows.length>0;

  const items=useMemo(()=>hasData?peBuildItems(rows,cm,compRows,compCm):[],[rows,cm,hasData]);
  const movement=useMemo(()=>hasData?peMovement(rows,cm,compRows,compCm):null,[rows,cm,hasData]);

  const tabs=[
    {key:"overview",  label:"Command",     icon:"ti-list-check"},
    {key:"alerts",    label:"Alerts",      icon:"ti-alert-octagon",badge:items.filter(i=>i.urgency==="Critical").length||null},
    {key:"table",     label:"Priority Queue",icon:"ti-table",     badge:items.length||null},
    {key:"actions",   label:"Action Plan", icon:"ti-rocket"},
    {key:"movement",  label:"Movement",    icon:"ti-trending-up"},
    {key:"ai",        label:"AI Strategist",icon:"ti-brain"},
    {key:"export",    label:"Export",      icon:"ti-download"},
  ];

  if(!hasData) return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-list-check" style={{fontSize:15,color:R}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Priority Engine</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.1)",color:R,fontWeight:700}}>Core</span>
      </div>
      <PEEmptyState onGoToHub={()=>setTab("hub")}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-list-check" style={{fontSize:15,color:R}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Priority Engine</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.1)",color:R,fontWeight:700}}>Core</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{items.length} items ranked · {items.filter(i=>i.urgency==="Critical").length} critical</span>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?R:"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?R:"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="overview"&&<div style={{maxWidth:960,margin:"0 auto"}}><PEOverview items={items} movement={movement}/></div>}
        {activeTab==="alerts"&&<div style={{maxWidth:860,margin:"0 auto"}}><PEAlerts items={items}/></div>}
        {activeTab==="table"&&<div style={{maxWidth:1100,margin:"0 auto",background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 18px"}}><PETable items={items} onExport={rows=>peExport(rows,"all")}/></div>}
        {activeTab==="actions"&&<div style={{maxWidth:900,margin:"0 auto"}}><PEActionRanking items={items}/></div>}
        {activeTab==="movement"&&<PEMovementPanel movement={movement}/>}
        {activeTab==="ai"&&<div style={{maxWidth:800,margin:"0 auto"}}><PEAIStrategist items={items} movement={movement}/></div>}
        {activeTab==="export"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#111",marginBottom:6}}>Export Priority Actions</div>
              <div style={{fontSize:12,color:"#888",marginBottom:20}}>Each export is ranked by priority score and includes source module, urgency level, spend impact, and comparison deltas.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {type:"all",       label:"Full Priority Queue",   icon:"ti-list-check",  color:"#555",  count:items.length},
                  {type:"top20",     label:"Top 20 Actions",        icon:"ti-trophy",      color:R,        count:Math.min(20,items.length)},
                  {type:"critical",  label:"Critical Only",         icon:"ti-alert-octagon",color:"#d42b2b",count:items.filter(i=>i.urgency==="Critical").length},
                  {type:"waste",     label:"Waste Elimination",     icon:"ti-droplet-off", color:"#d42b2b",count:items.filter(i=>i.type==="waste").length},
                  {type:"scale",     label:"Scaling Opportunities", icon:"ti-rocket",      color:"#1a7a3c",count:items.filter(i=>i.type==="scale").length},
                  {type:"visibility",label:"Visibility Recovery",   icon:"ti-eye",         color:"#6338c8",count:items.filter(i=>i.type==="visibility").length},
                ].map(ex=>(
                  <div key={ex.type} style={{background:"#fafafa",borderRadius:10,border:"1px solid #eee",padding:"14px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
                      <div style={{width:30,height:30,borderRadius:8,background:`${ex.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <i className={`ti ${ex.icon}`} style={{fontSize:14,color:ex.color}}/>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{ex.label}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{ex.count} items</div>
                      </div>
                    </div>
                    <button onClick={()=>peExport(items,ex.type)} disabled={ex.count===0} style={{...T.btnR(ex.count>0),width:"100%",justifyContent:"center",fontSize:11,padding:"7px 0",opacity:ex.count===0?0.4:1}}>
                      <i className="ti ti-download" style={{fontSize:12}}/>Download ({ex.count})
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   PPC LEARNING HUB MODULE
   Amazon PPC strategist academy.
   Sections: Dashboard · Learning Paths · Framework Library
             Playbooks · Toolkits · AI Mentor · Case Studies
   No data upload — purely educational content.
================================================================ */

/* ── Learning Hub data ──────────────────────────────────────── */
const LH_LS="quarred_learning_v1";
function lhLoad(){try{const s=localStorage.getItem(LH_LS);return s?JSON.parse(s):{completed:[],bookmarks:[],recentlyViewed:[]};}catch{return{completed:[],bookmarks:[],recentlyViewed:[]};}}
function lhSave(d){try{localStorage.setItem(LH_LS,JSON.stringify(d));}catch{}}

const LH_PATHS=[
  {id:"beginner",   label:"Beginner PPC Strategist",   icon:"ti-seedling",  color:"#1a7a3c",  time:"4 hrs",
   desc:"Learn the fundamentals of Amazon PPC from campaign types to your first bid strategy.",
   modules:["PPC Foundations","Campaign Types","Keyword Targeting","Match Type Mastery","First Bid Strategy","Reading Your Reports"]},
  {id:"intermediate",label:"Intermediate Strategist",  icon:"ti-trending-up",color:"#1a5fa0", time:"6 hrs",
   desc:"Level up with search term harvesting, negation systems, and ACoS optimisation.",
   modules:["Search Term Harvesting","Negation Logic","ACoS Optimisation","Placement Strategy","Scaling Basics","Campaign Structure"]},
  {id:"advanced",   label:"Advanced PPC Strategist",   icon:"ti-rocket",    color:"#4f46e5",  time:"8 hrs",
   desc:"Master ranking campaigns, TACOS frameworks, impression share dominance, and automation.",
   modules:["Ranking Strategy","TACOS Optimisation","Impression Share Dominance","Bid Psychology","Advanced Automation","PPC Audit Systems"]},
  {id:"ranking",    label:"Ranking Specialist",         icon:"ti-chart-bar", color:"#6338c8",  time:"5 hrs",
   desc:"Become an expert in using PPC to drive organic rank improvement.",
   modules:["Ranking vs ACoS Mindset","Keyword Velocity","TOS Dominance","Organic Rank Flywheel","Ranking Structures","Post-Rank Strategy"]},
  {id:"str",        label:"Search Term Specialist",     icon:"ti-search",    color:"#c47a00",  time:"4 hrs",
   desc:"Deep expertise in search term analysis, intent classification, and traffic quality.",
   modules:["Search Intent Psychology","Bleeders vs Converters","Harvest Timing","Negation Safety","Term Isolation","STR Analysis Systems"]},
  {id:"automation", label:"PPC Automation Specialist",  icon:"ti-robot",     color:"#2a6496",  time:"3 hrs",
   desc:"Build safe, effective automation systems using rules engines and AI-assisted workflows.",
   modules:["Automation Philosophy","Safe Rule Design","Bid Rules Deep Dive","Risk Management","AI-Assisted PPC","Automation Audit"]},
];

const LH_FRAMEWORKS=[
  {id:"harvest",   title:"Keyword Harvesting Framework",  icon:"ti-plant",    level:"Intermediate", color:"#1a7a3c",
   summary:"A systematic process for extracting converting search terms from broad/auto campaigns and isolating them in exact match campaigns.",
   useCase:"Use when your broad or auto campaigns have been running 2–4 weeks and you see search terms with 2+ orders.",
   workflow:["Run Search Term Report for last 30 days","Filter: Orders ≥ 2 OR (Spend >$15 AND CVR >1.5%)","Add converting terms to Exact Match campaigns","Add high-spend zero-order terms as Negative Exact in source campaigns","Repeat weekly"],
   mistakes:["Harvesting too early — wait for statistical significance","Not adding negatives to source campaign — creates cannibalization","Harvesting branded terms into ASIN campaigns"],
   kpis:["New exact match CVR vs broad source CVR","Reduction in wasted STR spend","Increase in total converting keywords"]},
  {id:"ranking",   title:"Ranking Framework",             icon:"ti-chart-bar",level:"Advanced",     color:"#4f46e5",
   summary:"A structured approach to using PPC spend to systematically build organic keyword rank.",
   useCase:"When a product has CVR ≥ 3% and you want to reduce long-term PPC dependency by building organic presence.",
   workflow:["Identify 5–10 keywords with strong CVR and current rank between Page 2–4","Launch dedicated ranking campaigns (Exact match, TOS only, +80% TOS modifier)","Set bids aggressively — rank investment, not profitability","Track organic rank weekly — expect movement in 3–6 weeks","Once Page 1 achieved, reduce spend gradually while monitoring rank stability"],
   mistakes:["Using broad match for ranking — dilutes click velocity signal","Ranking keywords with <2% CVR — wastes spend without rank signal","Pausing ranking campaigns during rank momentum — causes rank loss"],
   kpis:["Organic rank position (Page 1 target)","Ranking campaign CTR (proxy for relevance)","TACOS trend (should decrease as organic improves)"]},
  {id:"bleeder",   title:"Bleeder Recovery Framework",    icon:"ti-droplet-off",level:"Beginner",   color:"#d42b2b",
   summary:"Systematic identification and elimination of PPC spend that generates zero sales return.",
   useCase:"Use immediately when waste rate exceeds 20% of total ad spend, or when ACoS spikes above 60%.",
   workflow:["Pull Search Term Report + Campaign Report for last 14–30 days","Identify all entities with Spend >$10 AND Orders = 0","For keywords: add as Negative Exact — do not just reduce bid","For campaigns: audit search term reports for waste-generating terms","Set minimum spend threshold rules — pause if spend >$15, orders = 0 over 14 days","Re-evaluate weekly"],
   mistakes:["Reducing bid instead of negating — waste continues at lower rate","Negating converting root words — blocks profitable related terms","Not checking bleeders every week — waste compounds quickly"],
   kpis:["Waste rate (% of spend with zero orders)","Total waste spend $","ACoS trend after cleanup"]},
  {id:"tacos",     title:"TACOS Optimisation Framework",  icon:"ti-percentage",level:"Advanced",    color:"#c47a00",
   summary:"A framework for optimising Total ACoS (TACOS = Total Ad Spend / Total Revenue) to balance PPC investment with organic growth.",
   useCase:"Use after reaching Page 1 rank on target keywords. Goal is reducing TACOS while protecting rank.",
   workflow:["Calculate current TACOS: Total PPC Spend / (PPC Sales + Organic Sales)","Identify which campaigns are supporting organic rank (ranking campaigns)","Identify which campaigns are pure profit campaigns (harvest/exact)","Gradually reduce bids on profitable campaigns by 5–10% every 2 weeks","Monitor organic rank — if rank drops, restore bids","Target TACOS should be 30–50% lower than initial TACOS post-ranking"],
   mistakes:["Cutting PPC spend too fast — destroys rank before organic momentum builds","Not tracking organic rank — flying blind","Applying TACOS logic before reaching Page 1"],
   kpis:["TACOS % trend (decreasing = success)","Organic rank stability","Revenue trend (organic revenue should increase)"]},
  {id:"placement", title:"Placement Optimisation Framework",icon:"ti-layout-2",level:"Intermediate",color:"#6338c8",
   summary:"A structured approach to maximising the right Amazon ad placements for each campaign type.",
   useCase:"After 4+ weeks of campaign data when you have enough placement-level performance to make decisions.",
   workflow:["Pull Placement Report — look at TOS vs PP vs RoS performance","Calculate ACoS per placement for each campaign","Ranking campaigns: set TOS modifier +40–80%, PP 0%, RoS 0%","Profit campaigns: find the highest CVR placement and raise modifier +20–40%","Waste at PP or RoS: reduce modifier -30–50% or set to 0%","Review placement performance monthly"],
   mistakes:["Using same modifiers across all campaign types","Applying high TOS modifier to a campaign with poor listing CVR","Never checking placement performance — leaving money on the table"],
   kpis:["ACoS per placement (TOS vs PP vs RoS)","CVR per placement","Impression share at TOS (for ranking campaigns)"]},
  {id:"scaling",   title:"Safe Scaling Framework",        icon:"ti-rocket",   level:"Intermediate", color:"#2a9a50",
   summary:"A controlled approach to scaling PPC investment without losing profitability or inventory safety.",
   useCase:"When account ACoS is stable <30% for 2+ weeks and you want to grow revenue.",
   workflow:["Identify scale candidates: ACoS <25%, Orders ≥ 3, Impressions <600","Increase bids by 15–20% only — avoid bid shocks","Scale one campaign at a time — measure impact before next scale","Monitor ACoS for 7 days — if ACoS stays <30%, scale again","Check inventory levels — never scale when <30 days of stock remaining","Build budget in parallel — scale campaigns need room to run"],
   mistakes:["Scaling by doubling bids — causes ACoS spikes and poor data","Scaling all campaigns simultaneously — can't isolate what caused performance change","Scaling without inventory check — drives traffic to out-of-stock listings"],
   kpis:["ACoS post-scale (should stay within 5% of pre-scale)","Revenue growth %","Impression share increase"]},
];

const LH_PLAYBOOKS=[
  {id:"launch",   title:"Product Launch Playbook",   icon:"ti-rocket",      color:"#1a7a3c",
   objective:"Achieve Page 1 rank and positive sales velocity within 30–60 days of launch.",
   when:"Use immediately upon listing a new product.",
   phases:[
     {phase:"Week 1–2: Discovery",steps:["Launch Auto campaign at $20–30/day budget","Set bid at estimated CPC × 1.3","Let it run — collect search term data","No negative keywords yet — discovery mode"]},
     {phase:"Week 2–4: Harvesting",steps:["Pull STR — harvest converting terms (≥1 order)","Add converting terms to Exact Match campaigns","Add obvious irrelevant terms as Negative Exact","Run Exact + Phrase campaigns alongside Auto"]},
     {phase:"Week 4–8: Ranking Push",steps:["Launch ranking campaigns for 5–10 target keywords","High TOS modifier (+80%), adequate budget","Accept high ACoS — this is rank investment, not profit","Track organic rank weekly"]},
   ],
   kpis:["Organic rank position by week 8","CVR (target ≥3% to support ranking)","STR coverage (how many converting terms harvested)"],
   mistakes:["Bidding too low at launch — need velocity to rank","Too many negative keywords too early — blocks discovery","Comparing launch ACoS to mature account ACoS"]},
  {id:"recovery", title:"Recovery Playbook",         icon:"ti-heart-rate-monitor",color:"#c47a00",
   objective:"Restore declining account performance back to previous levels within 3–6 weeks.",
   when:"Use when sales drop 20%+ vs previous period without obvious external cause.",
   phases:[
     {phase:"Day 1–3: Diagnose",steps:["Run Account Audit — identify score changes","Pull Bleeder Check — find new waste","Check Conflict Detector — new cannibalization?","Review search terms — new waste terms triggering?"]},
     {phase:"Week 1: Stabilise",steps:["Eliminate new waste immediately (pause/negate)","Restore budgets on good campaigns if they were cut","Remove any aggressive rules that over-optimised","Return bids on declining impression campaigns"]},
     {phase:"Week 2–4: Rebuild",steps:["Run new harvest cycle on surviving campaigns","Relaunch any paused strong performers","Scale winners with new exact match terms","Monitor daily — recovery should show in week 3"]},
   ],
   kpis:["Total sales vs previous period","ACoS trend (should stabilise, then improve)","Waste rate (should drop within week 1)"],
   mistakes:["Cutting all bids — destroys data signal","Changing too many things simultaneously — can't diagnose","Expecting overnight recovery — allow 2–3 weeks"]},
  {id:"lowAcos",  title:"Low ACoS Playbook",         icon:"ti-percentage",   color:"#4f46e5",
   objective:"Drive ACoS below 25% account-wide without sacrificing ranking or visibility.",
   when:"When account ACoS is >40% and you need profitability without a full restructure.",
   phases:[
     {phase:"Step 1: Stop the Bleed",steps:["Pause all entities with spend >$10, zero orders","Negate top wasted search terms","Reduce bids on >70% ACoS campaigns by 25%"]},
     {phase:"Step 2: Isolate Winners",steps:["Identify all <25% ACoS campaigns","Move converting search terms to dedicated exact campaigns","Increase budgets on profitable campaigns — let them run"]},
     {phase:"Step 3: Rebuild Efficiency",steps:["Apply match type hierarchy — exact > phrase > broad","Add placement modifiers: reduce PP/RoS, increase TOS if CVR supports","Review weekly and reduce bids further on remaining high-ACoS terms"]},
   ],
   kpis:["Overall ACoS % trend","Waste rate % trend","Revenue vs previous period (should not drop >10%)"],
   mistakes:["Cutting bids on ranking campaigns — destroys rank","Targeting 0% ACoS — kills visibility and rank momentum","Applying same ACoS target to all campaign types"]},
  {id:"seasonal", title:"Seasonal Scaling Playbook", icon:"ti-calendar-event",color:"#6338c8",
   objective:"Capture maximum seasonal revenue while protecting ACoS during demand peaks.",
   when:"6–8 weeks before expected seasonal peak (Q4, Prime Day, seasonal product cycle).",
   phases:[
     {phase:"8 Weeks Before: Prepare",steps:["Identify top 10 seasonal keywords","Start ranking campaigns early — build rank before peak","Increase inventory — never scale into low stock","Create seasonal ad copy variants"]},
     {phase:"4 Weeks Before: Scale",steps:["Increase bids 20–30% on all seasonal keywords","Raise daily budgets — budget caps kill peak visibility","Launch broad match discovery for new seasonal terms","Harvest converting terms aggressively"]},
     {phase:"Peak: Maximise",steps:["Remove all budget caps on profitable campaigns","Set bids to maximum allowable ACoS target","Monitor hourly — adjust if ACoS spikes","Do not pause campaigns during peak — visibility loss is permanent"]},
   ],
   kpis:["Revenue vs same season previous year","ACoS vs target (allow +5–10% during peak)","Impression share during peak days"],
   mistakes:["Waiting until peak to start scaling — competitors already dominating","Running out of stock during peak — catastrophic rank damage","Cutting bids mid-peak to save ACoS — false economy"]},
  {id:"defense",  title:"Brand Defense Playbook",    icon:"ti-shield",       color:"#d42b2b",
   objective:"Protect branded search traffic from competitor conquesting.",
   when:"When branded search terms have <80% impression share or competitors are running ads on your brand terms.",
   phases:[
     {phase:"Step 1: Audit",steps:["Check branded search term impression share in STR","Identify competitor ads on brand searches via SQP","Calculate branded revenue at risk"]},
     {phase:"Step 2: Fortify",steps:["Launch dedicated Sponsored Brands campaign on all branded terms","Ensure SP exact match campaigns for all branded keywords have max bids","Set branded campaign budget — never cap branded traffic"]},
     {phase:"Step 3: Monitor",steps:["Check branded impression share weekly","Alert if branded CVR drops unexpectedly — competitor may be gaining","Use Brand Defense module in this portal for ongoing monitoring"]},
   ],
   kpis:["Branded impression share % (target >90%)","Branded CVR (protect, not optimise)","Branded ACoS (secondary — defend regardless)"],
   mistakes:["Reducing bids on branded terms to save ACoS — competitors will take the space","Not bidding on branded terms at all — leaving space for competitors","Applying negatives to branded terms in other campaigns without dedicated branded coverage"]},
];

const LH_CHECKLISTS=[
  {id:"daily",  title:"Daily Optimization Checklist",  icon:"ti-calendar",   color:"#1a5fa0",
   items:["Check for new bleeders (spend >$10, zero orders) — pause immediately","Review yesterday's ACoS vs previous 7-day average — flag if >10% rise","Check if any profitable campaigns hit budget cap — increase budget","Review top 5 keywords by spend — are they converting?","Check for CPC inflation on top terms","Look for any sudden impression drops on key campaigns"]},
  {id:"weekly", title:"Weekly Optimization Checklist", icon:"ti-calendar-week",color:"#1a7a3c",
   items:["Pull Search Term Report — harvest any new converters (≥2 orders)","Add confirmed waste terms as Negative Exact","Check placement performance — TOS vs PP vs RoS ACoS","Review bid rules — did any fire correctly?","Check organic rank on target keywords","Calculate account-level ACoS and TACOS — trending correctly?","Review campaign structure — any new conflicts?","Run weekly comparison report — what improved, what declined?"]},
  {id:"launch", title:"New Product Launch Checklist",  icon:"ti-rocket",      color:"#4f46e5",
   items:["Listing verified: title, bullets, images, A+ content complete","Buy Box confirmed at target price","Inventory stocked: minimum 60 days supply","Auto campaign launched: $20–30/day, bids at 1.3× estimated CPC","Broad match campaign launched with top 10 seed keywords","Ranking campaigns ready to launch after week 2 harvest","Goals documented: rank target, ACoS target, timeline","Weekly tracking schedule set up"]},
  {id:"audit",  title:"Monthly Account Audit Checklist",icon:"ti-clipboard-check",color:"#6338c8",
   items:["Run Account Audit module — review all 8 scores","Check waste rate — should be <15% of total spend","Verify harvesting is happening — any new exact match campaigns added?","Check Conflict Detector — any new cannibalization?","Review placement efficiency account-wide","Verify ranking campaigns are producing organic improvement","Check TACOS trend — should be declining over time","Review budget allocation — are dollars flowing to best performers?","Check seasonal readiness — any upcoming demand periods?","Update bid rules — are they still appropriate for current account stage?"]},
];

const LH_CASE_STUDIES=[
  {id:"launch_cs",  title:"Launch to Page 1 in 45 Days", tag:"Launch", color:"#1a7a3c",
   problem:"New private label product in competitive kitchen category. No sales history, no rank, $30/day starting budget.",
   analysis:"Category had moderate competition (avg CPC $0.85). Listing CVR was 3.2% after first week. Top keywords had organic rank on Page 4–5.",
   actions:["Week 1: Auto campaign at $30/day — collected 847 search terms","Week 2: Harvested 12 converting terms (≥1 order each) into Exact match","Week 2–4: Launched ranking campaign on 3 primary keywords (TOS only, $60/day each)","Week 4: Organic rank moved from Page 4 to Page 2 on main keyword","Week 6: Organic rank hit Page 1 position 3 — reduced ranking campaign spend 30%"],
   outcome:"Page 1 position 3 at day 45. ACoS stabilised at 28%. TACOS dropped from 45% to 31% by week 8 as organic sales increased.",
   lessons:["CVR >3% is required for ranking campaigns to work efficiently","Ranking budget should be proportional — underfunding ranking campaigns delays rank","Reducing ranking spend too early kills momentum — wait for stability first"]},
  {id:"recovery_cs",title:"ACoS Recovery from 78% to 31%",tag:"Recovery",color:"#d42b2b",
   problem:"Mature account with ACoS rising from 28% to 78% over 6 weeks. Revenue declining. No obvious external cause.",
   analysis:"Search Term Report revealed 23 new waste terms generating $340 in spend with zero orders. Auto campaign had expanded into unrelated categories after a broad keyword was accidentally added.",
   actions:["Identified and negated 23 waste search terms immediately — saved $340/period","Removed the misplaced broad keyword","Reduced bids 20% across all campaigns >50% ACoS","Relaunched harvest cycle — found 8 new exact match opportunities missed during the waste period"],
   outcome:"ACoS dropped from 78% to 31% within 3 weeks. Revenue recovered to previous levels by week 5.",
   lessons:["Regular STR review is the single most important weekly task in PPC","One misplaced keyword can cascade into account-wide ACoS damage","Recovery is almost always faster than the problem developed — if you act decisively"]},
  {id:"scale_cs",   title:"Scaling from $5K to $18K Monthly Sales",tag:"Scaling",color:"#6338c8",
   problem:"Account stuck at $5K monthly revenue despite healthy 22% ACoS. Strategist not sure what was preventing growth.",
   analysis:"Account had 3 exact match campaigns converting well but extremely low impression share. Daily budgets were capping at 2pm every day. 12 high-potential keywords were only getting 200–400 impressions/day.",
   actions:["Increased daily budgets from $15/day to $45/day on all 3 converting campaigns","Added 15 new exact match keywords from recent STR harvest","Launched Sponsored Brands campaign on top 5 keywords for additional visibility","Added TOS modifier +40% on 2 campaigns with strong TOS CVR"],
   outcome:"Monthly revenue grew from $5K to $18K over 90 days. ACoS stayed at 24% throughout — proving headroom existed.",
   lessons:["Budget caps are silent revenue killers — always check if campaigns hit cap before 5pm","Impression share is the easiest scaling lever — more budget at good ACoS = more revenue","Multiple ad types (SP + SB) compound visibility — not just additively"]},
];

/* ── Sub-components ─────────────────────────────────────────── */
function LHDashboard({progress,onNavigate}){
  const completedPaths=LH_PATHS.filter(p=>p.modules.every(m=>progress.completed.includes(p.id+"_"+m))).length;
  const totalLessons=LH_PATHS.reduce((s,p)=>s+p.modules.length,0);
  const completedLessons=progress.completed.length;
  const pct=Math.round((completedLessons/totalLessons)*100);
  const recentlyViewed=progress.recentlyViewed.slice(0,4);

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {/* Progress header */}
      <div style={{background:"linear-gradient(135deg,#4f46e5,#5a0000)",borderRadius:16,padding:"24px 28px",marginBottom:16,color:"#fff"}}>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <div style={{flex:1}}>
            <div style={{fontSize:12,opacity:.7,marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px"}}>Your Learning Progress</div>
            <div style={{fontSize:26,fontWeight:900,marginBottom:8}}>{pct}% Complete</div>
            <div style={{height:6,background:"rgba(255,255,255,0.2)",borderRadius:3,overflow:"hidden"}}>
              <div style={{width:`${pct}%`,height:"100%",background:"rgba(255,255,255,0.85)",borderRadius:3,transition:"width 0.5s"}}/>
            </div>
            <div style={{fontSize:11,opacity:.6,marginTop:6}}>{completedLessons} of {totalLessons} lessons · {completedPaths} of {LH_PATHS.length} paths completed</div>
          </div>
          <div style={{textAlign:"center",flexShrink:0}}>
            <div style={{fontSize:42,fontWeight:900,opacity:.9}}>{progress.bookmarks.length}</div>
            <div style={{fontSize:11,opacity:.6}}>Bookmarked</div>
          </div>
        </div>
      </div>

      {/* Quick nav cards */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
        {[
          {label:"Learning Paths",     sub:`${LH_PATHS.length} paths available`,     icon:"ti-route",     tab:"paths",    color:"#1a5fa0"},
          {label:"Framework Library",  sub:`${LH_FRAMEWORKS.length} frameworks`,     icon:"ti-book",      tab:"frameworks",color:"#1a7a3c"},
          {label:"Playbooks",          sub:`${LH_PLAYBOOKS.length} playbooks`,       icon:"ti-clipboard", tab:"playbooks", color:"#4f46e5"},
          {label:"Toolkits",           sub:`${LH_CHECKLISTS.length} checklists`,     icon:"ti-checklist", tab:"toolkits",  color:"#6338c8"},
          {label:"Case Studies",       sub:`${LH_CASE_STUDIES.length} studies`,      icon:"ti-file-text", tab:"cases",     color:"#c47a00"},
          {label:"AI Mentor",          sub:"Ask any PPC question",                    icon:"ti-brain",     tab:"ai",        color:"#2a6496"},
        ].map(c=>(
          <button key={c.tab} onClick={()=>onNavigate(c.tab)} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",cursor:"pointer",textAlign:"left",boxShadow:"0 1px 4px rgba(0,0,0,0.04)",transition:"border-color 0.15s"}}>
            <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:7}}>
              <div style={{width:30,height:30,borderRadius:8,background:`${c.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
              </div>
              <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{c.label}</span>
            </div>
            <div style={{fontSize:11,color:"#888"}}>{c.sub}</div>
          </button>
        ))}
      </div>

      {/* Recommended */}
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Recommended for You</div>
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {LH_PATHS.filter(p=>!p.modules.every(m=>progress.completed.includes(p.id+"_"+m))).slice(0,3).map((p,i)=>{
            const done=p.modules.filter(m=>progress.completed.includes(p.id+"_"+m)).length;
            const pct2=Math.round((done/p.modules.length)*100);
            return(
              <button key={p.id} onClick={()=>onNavigate("paths")} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0",cursor:"pointer",textAlign:"left"}}>
                <div style={{width:32,height:32,borderRadius:8,background:`${p.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${p.icon}`} style={{fontSize:14,color:p.color}}/>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:600,color:"#111",marginBottom:3}}>{p.label}</div>
                  <div style={{height:4,background:"#eee",borderRadius:2,overflow:"hidden"}}>
                    <div style={{width:`${pct2}%`,height:"100%",background:p.color,borderRadius:2}}/>
                  </div>
                </div>
                <span style={{fontSize:11,color:"#aaa",flexShrink:0}}>{pct2}% · {p.time}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

/* Learning paths */
function LHPaths({progress,onUpdate}){
  const[selected,setSelected]=useState(null);
  const path=selected?LH_PATHS.find(p=>p.id===selected):null;

  function toggleLesson(pathId,mod){
    const key=pathId+"_"+mod;
    const completed=progress.completed.includes(key)?progress.completed.filter(c=>c!==key):[...progress.completed,key];
    onUpdate({...progress,completed});
  }

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {!selected?(
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10}}>
          {LH_PATHS.map(p=>{
            const done=p.modules.filter(m=>progress.completed.includes(p.id+"_"+m)).length;
            const pct=Math.round((done/p.modules.length)*100);
            return(
              <div key={p.id} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"18px 20px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                  <div style={{width:36,height:36,borderRadius:10,background:`${p.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <i className={`ti ${p.icon}`} style={{fontSize:16,color:p.color}}/>
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{p.label}</div>
                    <div style={{fontSize:11,color:"#aaa"}}>{p.time} · {p.modules.length} modules</div>
                  </div>
                  {pct===100&&<i className="ti ti-circle-check-filled" style={{fontSize:18,color:"#1a7a3c"}}/>}
                </div>
                <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:10}}>{p.desc}</div>
                <div style={{height:5,background:"#f0f0f0",borderRadius:3,overflow:"hidden",marginBottom:10}}>
                  <div style={{width:`${pct}%`,height:"100%",background:p.color,borderRadius:3}}/>
                </div>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <span style={{fontSize:11,color:"#888"}}>{done}/{p.modules.length} complete</span>
                  <button onClick={()=>setSelected(p.id)} style={{...T.btnR(true),fontSize:11,padding:"6px 14px"}}>
                    {pct===0?"Start Path":pct===100?"Review":"Continue"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      ):(
        <div>
          <button onClick={()=>setSelected(null)} style={{display:"flex",alignItems:"center",gap:6,padding:"7px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555",marginBottom:14}}>
            <i className="ti ti-arrow-left" style={{fontSize:12}}/> All Paths
          </button>
          <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"20px 22px"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{width:40,height:40,borderRadius:11,background:`${path.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className={`ti ${path.icon}`} style={{fontSize:18,color:path.color}}/>
              </div>
              <div>
                <div style={{fontSize:16,fontWeight:800,color:"#111"}}>{path.label}</div>
                <div style={{fontSize:12,color:"#888"}}>{path.time} · {path.modules.length} modules</div>
              </div>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {path.modules.map((mod,i)=>{
                const done=progress.completed.includes(path.id+"_"+mod);
                return(
                  <div key={mod} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:done?"rgba(26,122,60,0.04)":"#fafafa",borderRadius:9,border:`1px solid ${done?"rgba(26,122,60,0.2)":"#f0f0f0"}`}}>
                    <span style={{fontSize:12,fontWeight:600,color:"#aaa",width:20,flexShrink:0}}>{i+1}</span>
                    <span style={{fontSize:13,fontWeight:500,color:"#111",flex:1}}>{mod}</span>
                    <button onClick={()=>toggleLesson(path.id,mod)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${done?"rgba(26,122,60,0.3)":"#e0e0e0"}`,background:done?"rgba(26,122,60,0.08)":"#fff",cursor:"pointer",fontSize:11,fontWeight:600,color:done?"#1a7a3c":"#555",display:"flex",alignItems:"center",gap:5}}>
                      <i className={`ti ${done?"ti-check":"ti-circle"}`} style={{fontSize:11}}/>{done?"Done":"Mark Done"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* Framework library */
function LHFrameworks({progress,onUpdate}){
  const[selected,setSelected]=useState(null);
  const[search,setSearch]=useState("");
  const fw=selected?LH_FRAMEWORKS.find(f=>f.id===selected):null;

  const filtered=LH_FRAMEWORKS.filter(f=>!search||f.title.toLowerCase().includes(search.toLowerCase())||f.summary.toLowerCase().includes(search.toLowerCase()));

  function toggleBookmark(id){
    const bm=progress.bookmarks.includes(id)?progress.bookmarks.filter(b=>b!==id):[...progress.bookmarks,id];
    onUpdate({...progress,bookmarks:bm});
  }

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {!selected?(
        <>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search frameworks..." style={{padding:"8px 14px",borderRadius:8,border:"1px solid #e0e0e0",fontSize:13,outline:"none",width:"100%",marginBottom:14,boxSizing:"border-box"}}/>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10}}>
            {filtered.map(f=>(
              <div key={f.id} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                  <div style={{width:32,height:32,borderRadius:8,background:`${f.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <i className={`ti ${f.icon}`} style={{fontSize:14,color:f.color}}/>
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{f.title}</div>
                    <span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:f.level==="Advanced"?"rgba(79,70,229,0.08)":f.level==="Intermediate"?"rgba(196,122,0,0.08)":"rgba(26,122,60,0.08)",color:f.level==="Advanced"?"#4f46e5":f.level==="Intermediate"?"#c47a00":"#1a7a3c",fontWeight:700}}>{f.level}</span>
                  </div>
                  <button onClick={()=>toggleBookmark(f.id)} style={{border:"none",background:"transparent",cursor:"pointer",fontSize:16,color:progress.bookmarks.includes(f.id)?"#c47a00":"#ddd"}}>
                    <i className={`ti ${progress.bookmarks.includes(f.id)?"ti-bookmark-filled":"ti-bookmark"}`}/>
                  </button>
                </div>
                <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:10}}>{f.summary}</div>
                <button onClick={()=>setSelected(f.id)} style={{...T.btnR(true),fontSize:11,padding:"6px 14px"}}>Read Framework</button>
              </div>
            ))}
          </div>
        </>
      ):(
        <div>
          <button onClick={()=>setSelected(null)} style={{display:"flex",alignItems:"center",gap:6,padding:"7px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555",marginBottom:14}}>
            <i className="ti ti-arrow-left" style={{fontSize:12}}/> All Frameworks
          </button>
          <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
              <div style={{width:38,height:38,borderRadius:10,background:`${fw.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className={`ti ${fw.icon}`} style={{fontSize:16,color:fw.color}}/>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:16,fontWeight:800,color:"#111"}}>{fw.title}</div>
                <span style={{fontSize:10,padding:"2px 7px",borderRadius:3,background:fw.level==="Advanced"?"rgba(79,70,229,0.08)":"rgba(196,122,0,0.08)",color:fw.level==="Advanced"?"#4f46e5":"#c47a00",fontWeight:700}}>{fw.level}</span>
              </div>
              <button onClick={()=>toggleBookmark(fw.id)} style={{border:"none",background:"transparent",cursor:"pointer",fontSize:18,color:progress.bookmarks.includes(fw.id)?"#c47a00":"#ddd"}}>
                <i className={`ti ${progress.bookmarks.includes(fw.id)?"ti-bookmark-filled":"ti-bookmark"}`}/>
              </button>
            </div>
            {[
              {title:"Summary",      content:<p style={{fontSize:13,color:"#444",lineHeight:1.7,margin:0}}>{fw.summary}</p>},
              {title:"When to Use",  content:<p style={{fontSize:13,color:"#444",lineHeight:1.7,margin:0}}>{fw.useCase}</p>},
              {title:"Workflow",     content:<ol style={{margin:0,paddingLeft:18}}>{fw.workflow.map((s,i)=><li key={i} style={{fontSize:12,color:"#444",lineHeight:1.7,marginBottom:4}}>{s}</li>)}</ol>},
              {title:"Common Mistakes",content:<ul style={{margin:0,paddingLeft:18}}>{fw.mistakes.map((s,i)=><li key={i} style={{fontSize:12,color:"#d42b2b",lineHeight:1.7,marginBottom:4}}>{s}</li>)}</ul>},
              {title:"KPIs to Monitor",content:<ul style={{margin:0,paddingLeft:18}}>{fw.kpis.map((s,i)=><li key={i} style={{fontSize:12,color:"#1a7a3c",lineHeight:1.7,marginBottom:4}}>{s}</li>)}</ul>},
            ].map((sec,i)=>(
              <div key={i} style={{marginBottom:16}}>
                <div style={{fontSize:11,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:8}}>{sec.title}</div>
                {sec.content}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

/* Playbooks */
function LHPlaybooks({progress,onUpdate}){
  const[selected,setSelected]=useState(null);
  const pb=selected?LH_PLAYBOOKS.find(p=>p.id===selected):null;

  function toggleBookmark(id){
    const bm=progress.bookmarks.includes("pb_"+id)?progress.bookmarks.filter(b=>b!=="pb_"+id):[...progress.bookmarks,"pb_"+id];
    onUpdate({...progress,bookmarks:bm});
  }

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {!selected?(
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10}}>
          {LH_PLAYBOOKS.map(p=>(
            <div key={p.id} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                <div style={{width:32,height:32,borderRadius:8,background:`${p.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${p.icon}`} style={{fontSize:14,color:p.color}}/>
                </div>
                <span style={{fontSize:13,fontWeight:700,color:"#111",flex:1}}>{p.title}</span>
                <button onClick={()=>toggleBookmark(p.id)} style={{border:"none",background:"transparent",cursor:"pointer",fontSize:16,color:progress.bookmarks.includes("pb_"+p.id)?"#c47a00":"#ddd"}}>
                  <i className={`ti ${progress.bookmarks.includes("pb_"+p.id)?"ti-bookmark-filled":"ti-bookmark"}`}/>
                </button>
              </div>
              <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:4}}><strong>Objective: </strong>{p.objective}</div>
              <div style={{fontSize:11,color:"#888",marginBottom:10}}><strong>When: </strong>{p.when}</div>
              <button onClick={()=>setSelected(p.id)} style={{...T.btnR(true),fontSize:11,padding:"6px 14px"}}>Open Playbook</button>
            </div>
          ))}
        </div>
      ):(
        <div>
          <button onClick={()=>setSelected(null)} style={{display:"flex",alignItems:"center",gap:6,padding:"7px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555",marginBottom:14}}>
            <i className="ti ti-arrow-left" style={{fontSize:12}}/> All Playbooks
          </button>
          <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{width:38,height:38,borderRadius:10,background:`${pb.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className={`ti ${pb.icon}`} style={{fontSize:16,color:pb.color}}/>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:16,fontWeight:800,color:"#111"}}>{pb.title}</div>
                <div style={{fontSize:12,color:"#888",marginTop:2}}>{pb.objective}</div>
              </div>
            </div>
            <div style={{padding:"10px 14px",background:"rgba(26,95,160,0.06)",borderRadius:8,border:"1px solid rgba(26,95,160,0.15)",fontSize:12,color:"#1a5fa0",marginBottom:16}}>
              <strong>When to use: </strong>{pb.when}
            </div>
            {pb.phases.map((phase,i)=>(
              <div key={i} style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                  <span style={{width:20,height:20,borderRadius:"50%",background:`${pb.color}14`,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:pb.color,flexShrink:0}}>{i+1}</span>
                  {phase.phase}
                </div>
                <div style={{paddingLeft:28,display:"flex",flexDirection:"column",gap:5}}>
                  {phase.steps.map((s,j)=>(
                    <div key={j} style={{display:"flex",gap:8,fontSize:12,color:"#444",lineHeight:1.6}}>
                      <span style={{color:"#ccc",flexShrink:0,marginTop:1}}>→</span>{s}
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginTop:8}}>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:8}}>KPIs to Monitor</div>
                {pb.kpis.map((k,i)=><div key={i} style={{fontSize:12,color:"#1a7a3c",marginBottom:4,display:"flex",gap:6}}><span>✓</span>{k}</div>)}
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:8}}>Common Mistakes</div>
                {pb.mistakes.map((m,i)=><div key={i} style={{fontSize:12,color:"#d42b2b",marginBottom:4,display:"flex",gap:6}}><span>✗</span>{m}</div>)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* Toolkits / Checklists */
function LHToolkits(){
  const[selected,setSelected]=useState(null);
  const cl=selected?LH_CHECKLISTS.find(c=>c.id===selected):null;
  const[checked,setChecked]=useState({});

  function exportChecklist(c){
    const rows=c.items.map((item,i)=>({"#":i+1,"Task":item,"Completed":"[ ]"}));
    const ws=XLSX.utils.json_to_sheet(rows);
    ws["!cols"]=[{wch:4},{wch:80},{wch:12}];
    const wb=XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb,ws,c.title);
    XLSX.writeFile(wb,`${c.title.toLowerCase().replace(/\s+/g,"_")}.xlsx`);
  }

  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {!selected?(
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10}}>
          {LH_CHECKLISTS.map(c=>(
            <div key={c.id} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                <div style={{width:32,height:32,borderRadius:8,background:`${c.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${c.icon}`} style={{fontSize:14,color:c.color}}/>
                </div>
                <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{c.title}</span>
              </div>
              <div style={{fontSize:12,color:"#888",marginBottom:10}}>{c.items.length} items</div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>setSelected(c.id)} style={{...T.btnR(true),fontSize:11,padding:"6px 14px"}}>View Checklist</button>
                <button onClick={()=>exportChecklist(c)} style={{padding:"6px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5}}><i className="ti ti-download" style={{fontSize:11}}/>Export</button>
              </div>
            </div>
          ))}
        </div>
      ):(
        <div>
          <button onClick={()=>setSelected(null)} style={{display:"flex",alignItems:"center",gap:6,padding:"7px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555",marginBottom:14}}>
            <i className="ti ti-arrow-left" style={{fontSize:12}}/> All Toolkits
          </button>
          <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <i className={`ti ${cl.icon}`} style={{fontSize:18,color:cl.color}}/>
              <span style={{fontSize:16,fontWeight:800,color:"#111"}}>{cl.title}</span>
              <button onClick={()=>exportChecklist(cl)} style={{marginLeft:"auto",padding:"7px 14px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:5}}><i className="ti ti-download" style={{fontSize:11}}/>Export</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {cl.items.map((item,i)=>{
                const key=cl.id+"_"+i;
                const done=!!checked[key];
                return(
                  <div key={i} onClick={()=>setChecked(p=>({...p,[key]:!p[key]}))} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"10px 14px",background:done?"rgba(26,122,60,0.04)":"#fafafa",borderRadius:9,border:`1px solid ${done?"rgba(26,122,60,0.2)":"#f0f0f0"}`,cursor:"pointer"}}>
                    <div style={{width:18,height:18,borderRadius:4,border:`2px solid ${done?"#1a7a3c":"#ddd"}`,background:done?"#1a7a3c":"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                      {done&&<i className="ti ti-check" style={{fontSize:10,color:"#fff"}}/>}
                    </div>
                    <span style={{fontSize:13,color:done?"#888":"#333",textDecoration:done?"line-through":"none",lineHeight:1.5}}>{item}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* Case studies */
function LHCaseStudies(){
  const[selected,setSelected]=useState(null);
  const cs=selected?LH_CASE_STUDIES.find(c=>c.id===selected):null;
  return(
    <div style={{maxWidth:860,margin:"0 auto"}}>
      {!selected?(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {LH_CASE_STUDIES.map(c=>(
            <div key={c.id} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 20px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                <span style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${c.color}12`,color:c.color,fontWeight:700}}>{c.tag}</span>
                <span style={{fontSize:14,fontWeight:700,color:"#111"}}>{c.title}</span>
              </div>
              <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:10}}>{c.problem}</div>
              <button onClick={()=>setSelected(c.id)} style={{...T.btnR(true),fontSize:11,padding:"6px 14px"}}>Read Case Study</button>
            </div>
          ))}
        </div>
      ):(
        <div>
          <button onClick={()=>setSelected(null)} style={{display:"flex",alignItems:"center",gap:6,padding:"7px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555",marginBottom:14}}>
            <i className="ti ti-arrow-left" style={{fontSize:12}}/> All Case Studies
          </button>
          <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"22px 24px"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:16}}>
              <span style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${cs.color}12`,color:cs.color,fontWeight:700}}>{cs.tag}</span>
              <span style={{fontSize:18,fontWeight:800,color:"#111"}}>{cs.title}</span>
            </div>
            {[
              {title:"The Problem",  content:cs.problem,  color:"#d42b2b"},
              {title:"Analysis",     content:cs.analysis, color:"#1a5fa0"},
              {title:"Lessons Learned",content:null,      color:"#1a7a3c",isList:true,list:cs.lessons},
            ].map((sec,i)=>(
              <div key={i} style={{marginBottom:16,padding:"14px 16px",background:`${sec.color}05`,borderRadius:9,border:`1px solid ${sec.color}18`}}>
                <div style={{fontSize:11,fontWeight:700,color:sec.color,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:8}}>{sec.title}</div>
                {sec.isList?<ul style={{margin:0,paddingLeft:16}}>{sec.list.map((l,j)=><li key={j} style={{fontSize:12,color:"#333",lineHeight:1.7,marginBottom:4}}>{l}</li>)}</ul>:<p style={{fontSize:13,color:"#333",lineHeight:1.7,margin:0}}>{sec.content}</p>}
              </div>
            ))}
            <div style={{marginBottom:16}}>
              <div style={{fontSize:11,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Actions Taken</div>
              {cs.actions.map((a,i)=>(
                <div key={i} style={{display:"flex",gap:10,marginBottom:8,fontSize:12,color:"#333",lineHeight:1.6}}>
                  <span style={{fontWeight:700,color:"#1a5fa0",flexShrink:0}}>{i+1}.</span>{a}
                </div>
              ))}
            </div>
            <div style={{padding:"14px 16px",background:"rgba(26,122,60,0.06)",borderRadius:9,border:"1px solid rgba(26,122,60,0.2)"}}>
              <div style={{fontSize:11,fontWeight:700,color:"#1a7a3c",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:6}}>Outcome</div>
              <p style={{fontSize:13,color:"#333",lineHeight:1.7,margin:0}}>{cs.outcome}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* AI Mentor */
function LHAIMentor(){
  const[messages,setMessages]=useState([{role:"assistant",text:"Hi! I'm your Amazon PPC mentor. Ask me anything about PPC strategy, optimization, ranking, search terms, bid management, or anything in this portal. What would you like to learn?"}]);
  const[input,setInput]=useState("");
  const[loading,setLoading]=useState(false);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);
  const bottomRef=useRef(null);
  useEffect(()=>{bottomRef.current?.scrollIntoView({behavior:"smooth"});},[messages]);

  async function sendMessage(){
    const msg=input.trim();
    if(!msg||!apiKey.trim()) return;
    const newMessages=[...messages,{role:"user",text:msg}];
    setMessages(newMessages);setInput("");setLoading(true);
    try{
      const history=newMessages.map(m=>({role:m.role==="user"?"user":"model",parts:[{text:m.text}]}));
      const res=await geminiFetch(apiKey.trim(),{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          system_instruction:{parts:[{text:"You are a senior Amazon PPC mentor and strategist. Answer questions clearly and practically. Only explain based on proven Amazon PPC principles — never invent or guess Amazon policy. Keep responses focused, practical, and strategist-level. If a question is outside Amazon PPC, politely redirect."}]},
          contents:history,
          generationConfig:{temperature:0.3,maxOutputTokens:800}
        })
      });
      const data=await res.json();
      const reply=data.candidates?.[0]?.content?.parts?.[0]?.text||"I couldn't generate a response. Please try again.";
      setMessages(p=>[...p,{role:"assistant",text:reply}]);
    }catch{setMessages(p=>[...p,{role:"assistant",text:"Connection error. Check your API key and try again."}]);}
    setLoading(false);
  }

  const suggestions=["What is keyword harvesting?","How do I reduce ACoS?","When should I start ranking campaigns?","What is TACOS and why does it matter?","How do I build a match type structure?","What causes impression share loss?"];

  return(
    <div style={{maxWidth:780,margin:"0 auto",display:"flex",flexDirection:"column",height:"calc(100vh - 200px)",minHeight:400}}>
      {/* API Key bar */}
      <div style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"10px 14px",marginBottom:10,display:"flex",gap:8,alignItems:"center"}}>
        <div style={{position:"relative",flex:1}}>
          {/* API key input removed - key configured globally in Settings */}
        </div>
        <span style={{fontSize:11,color:"#aaa",flexShrink:0}}>aistudio.google.com</span>
      </div>

      {/* Suggestions */}
      {messages.length<=1&&(
        <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
          {suggestions.map((s,i)=>(
            <button key={i} onClick={()=>{setInput(s);}} style={{padding:"5px 12px",borderRadius:16,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",fontWeight:500}}>{s}</button>
          ))}
        </div>
      )}

      {/* Chat */}
      <div style={{flex:1,overflowY:"auto",background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px",marginBottom:10,display:"flex",flexDirection:"column",gap:10}}>
        {messages.map((m,i)=>(
          <div key={i} style={{display:"flex",gap:10,justifyContent:m.role==="user"?"flex-end":"flex-start"}}>
            {m.role==="assistant"&&<div style={{width:28,height:28,borderRadius:7,background:"rgba(79,70,229,0.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:2}}><i className="ti ti-brain" style={{fontSize:13,color:R}}/></div>}
            <div style={{maxWidth:"80%",padding:"10px 14px",borderRadius:m.role==="user"?"12px 12px 3px 12px":"12px 12px 12px 3px",background:m.role==="user"?"#4f46e5":"#f7f7f7",color:m.role==="user"?"#fff":"#333",fontSize:13,lineHeight:1.65,whiteSpace:"pre-wrap"}}>{m.text}</div>
            {m.role==="user"&&<div style={{width:28,height:28,borderRadius:7,background:"rgba(0,0,0,0.06)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:2}}><i className="ti ti-user" style={{fontSize:13,color:"#555"}}/></div>}
          </div>
        ))}
        {loading&&<div style={{display:"flex",gap:10}}><div style={{width:28,height:28,borderRadius:7,background:"rgba(79,70,229,0.1)",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-brain ti-spin" style={{fontSize:13,color:R}}/></div><div style={{padding:"10px 14px",background:"#f7f7f7",borderRadius:"12px 12px 12px 3px",fontSize:13,color:"#888"}}>Thinking...</div></div>}
        <div ref={bottomRef}/>
      </div>

      {/* Input */}
      <div style={{display:"flex",gap:8}}>
        <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&!e.shiftKey&&sendMessage()} placeholder="Ask your PPC mentor anything..." style={{flex:1,padding:"10px 14px",borderRadius:9,border:"1.5px solid #e0e0e0",fontSize:13,outline:"none"}}/>
        <button onClick={sendMessage} disabled={loading||!input.trim()||!apiKey.trim()} style={{...T.btnR(!!input.trim()&&!!apiKey.trim()),padding:"10px 18px",opacity:!input.trim()||!apiKey.trim()?0.4:1}}>
          <i className="ti ti-send" style={{fontSize:13}}/>Send
        </button>
      </div>
    </div>
  );
}

/* ── PPC Learning Hub Module Root ───────────────────────────── */
function PPCLearningHubModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("dashboard");
  const[progress,setProgressRaw]=useState(lhLoad);

  function setProgress(p){setProgressRaw(p);lhSave(p);}

  const tabs=[
    {key:"dashboard",   label:"Dashboard",        icon:"ti-layout-dashboard"},
    {key:"paths",       label:"Learning Paths",   icon:"ti-route",          badge:LH_PATHS.filter(p=>p.modules.every(m=>progress.completed.includes(p.id+"_"+m))).length||null},
    {key:"frameworks",  label:"Frameworks",       icon:"ti-book",           badge:LH_FRAMEWORKS.length},
    {key:"playbooks",   label:"Playbooks",        icon:"ti-clipboard",      badge:LH_PLAYBOOKS.length},
    {key:"toolkits",    label:"Toolkits",         icon:"ti-checklist"},
    {key:"cases",       label:"Case Studies",     icon:"ti-file-text",      badge:LH_CASE_STUDIES.length},
    {key:"ai",          label:"AI Mentor",        icon:"ti-brain"},
  ];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-school" style={{fontSize:15,color:"#4f46e5"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>PPC Learning Hub</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(79,70,229,0.1)",color:"#4f46e5",fontWeight:700}}>Academy</span>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#aaa"}}>{progress.completed.length} lessons completed</span>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?R:"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?R:"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?R:"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="dashboard"&&<LHDashboard progress={progress} onNavigate={setActiveTab}/>}
        {activeTab==="paths"&&<LHPaths progress={progress} onUpdate={setProgress}/>}
        {activeTab==="frameworks"&&<LHFrameworks progress={progress} onUpdate={setProgress}/>}
        {activeTab==="playbooks"&&<LHPlaybooks progress={progress} onUpdate={setProgress}/>}
        {activeTab==="toolkits"&&<LHToolkits/>}
        {activeTab==="cases"&&<LHCaseStudies/>}
        {activeTab==="ai"&&<LHAIMentor/>}
      </div>
    </div>
  );
}

/* ================================================================
   SETTINGS MODULE
   Centralized strategist configuration system.
   Sections: Overview · General · Automation · Export · Notifications
             AI Settings · Integrations · Team · History
================================================================ */

const ST_LS="quarred_settings_v1";
const ST_DEFAULTS={
  general:{timezone:"UTC",currency:"USD",dateFormat:"MM/DD/YYYY",compactSidebar:false,defaultTab:"hub",theme:"light"},
  automation:{maxBidIncreasePct:30,maxBidDecreasePct:40,minBidUsd:0.02,maxBidUsd:10,requireApproval:true,safeMode:true,weeklyRunLimit:3,pauseWarningThreshold:20},
  export:{format:"xlsx",namingConvention:"module_date",includeComparison:true,includeScores:true,sheetPrefix:"Quarred"},
  notifications:{criticalAlerts:true,highAlerts:true,mediumAlerts:false,emailSummary:false,weeklyDigest:true,wasteThreshold:25,acosThreshold:60},
  ai:{aggressiveness:"balanced",explanationDepth:"detailed",opportunitySensitivity:"medium",riskSensitivity:"medium",strategistMode:"intermediate",geminiKey:""},
  team:[{id:"owner",name:"Account Owner",email:"",role:"Admin",added:"2024-01-01"}],
};

function stLoad(){try{const s=localStorage.getItem(ST_LS);return s?{...ST_DEFAULTS,...JSON.parse(s)}:JSON.parse(JSON.stringify(ST_DEFAULTS));}catch{return JSON.parse(JSON.stringify(ST_DEFAULTS));}}
function stSave(s){try{localStorage.setItem(ST_LS,JSON.stringify(s));}catch{}}

const ST_HISTORY_LS="quarred_settings_hist_v1";
function stLoadHistory(){try{const s=localStorage.getItem(ST_HISTORY_LS);return s?JSON.parse(s):[];}catch{return[];}}
function stSaveHistory(h){try{localStorage.setItem(ST_HISTORY_LS,JSON.stringify(h.slice(0,20)));}catch{}}

/* ── Global AI Key helpers (reads from Settings storage) ── */
function getGlobalAIKey(){
  try{
    const s=localStorage.getItem("quarred_settings_v1");
    if(!s)return "";
    const parsed=JSON.parse(s);
    return (parsed?.ai?.geminiKey||"").trim();
  }catch{return "";}
}
function useGlobalAIKey(){
  const[key,setKey]=React.useState(getGlobalAIKey);
  // Refresh when settings change (user saves in Settings tab)
  React.useEffect(()=>{
    const handler=()=>setKey(getGlobalAIKey());
    window.addEventListener("storage",handler);
    window.addEventListener("rq_settings_saved",handler);
    return()=>{window.removeEventListener("storage",handler);window.removeEventListener("rq_settings_saved",handler);};
  },[]);
  return key;
}
/* AI key banner shown inside any module when key is not set */
function AIKeyBanner({onGoToSettings}){
  return(
    <div style={{padding:"12px 16px",background:"rgba(99,56,200,0.06)",border:"1px solid rgba(99,56,200,0.2)",borderRadius:10,marginBottom:14,display:"flex",alignItems:"center",gap:10}}>
      <i className="ti ti-key" style={{fontSize:14,color:"#6338c8",flexShrink:0}}/>
      <div style={{flex:1}}>
        <div style={{fontSize:12,fontWeight:700,color:"#6338c8"}}>AI API Key not configured</div>
        <div style={{fontSize:11,color:"#888",marginTop:2}}>Go to Settings → AI Settings and paste your Gemini API key. It will work across all AI modules automatically.</div>
      </div>
      {onGoToSettings&&<button onClick={onGoToSettings} style={{padding:"6px 14px",borderRadius:7,border:"none",background:"#6338c8",color:"#fff",fontSize:11,fontWeight:700,cursor:"pointer",flexShrink:0,whiteSpace:"nowrap"}}>
        Open Settings →
      </button>}
    </div>
  );
}

/* ── Helper components ──────────────────────────────────────── */
function STToggle({value,onChange,label,sub}){
  return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 0",borderBottom:"1px solid #f5f5f5"}}>
      <div>
        <div style={{fontSize:13,fontWeight:500,color:"#111"}}>{label}</div>
        {sub&&<div style={{fontSize:11,color:"#aaa",marginTop:2}}>{sub}</div>}
      </div>
      <button onClick={()=>onChange(!value)} style={{width:40,height:22,borderRadius:11,background:value?"#4f46e5":"#e0e0e0",border:"none",cursor:"pointer",position:"relative",transition:"background 0.2s",flexShrink:0}}>
        <div style={{width:16,height:16,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:value?21:3,transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
      </button>
    </div>
  );
}

function STSelect({value,onChange,label,options,sub}){
  return(
    <div style={{marginBottom:14}}>
      <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>{label}</label>
      {sub&&<div style={{fontSize:11,color:"#aaa",marginBottom:5}}>{sub}</div>}
      <select value={value} onChange={e=>onChange(e.target.value)} style={{padding:"8px 12px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:13,color:"#111",width:"100%",cursor:"pointer",outline:"none",background:"#fff"}}>
        {options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}

function STInput({value,onChange,label,type="text",placeholder,sub,min,max,step}){
  return(
    <div style={{marginBottom:14}}>
      <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>{label}</label>
      {sub&&<div style={{fontSize:11,color:"#aaa",marginBottom:5}}>{sub}</div>}
      <input type={type} value={value} onChange={e=>onChange(type==="number"?parseFloat(e.target.value)||0:e.target.value)} placeholder={placeholder} min={min} max={max} step={step} style={{padding:"8px 12px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:13,color:"#111",width:"100%",boxSizing:"border-box",outline:"none"}}/>
    </div>
  );
}

function STSaveBar({dirty,onSave,onReset}){
  if(!dirty) return null;
  return(
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:"rgba(79,70,229,0.05)",borderRadius:8,border:"1px solid rgba(79,70,229,0.15)",marginBottom:14}}>
      <i className="ti ti-edit" style={{fontSize:13,color:"#4f46e5"}}/>
      <span style={{fontSize:12,color:"#4f46e5",fontWeight:600,flex:1}}>Unsaved changes</span>
      <button onClick={onReset} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555"}}>Reset</button>
      <button onClick={onSave} style={{...T.btnR(true),fontSize:12,padding:"5px 14px"}}><i className="ti ti-device-floppy" style={{fontSize:12}}/>Save</button>
    </div>
  );
}

function STPanel({title,icon,color="#555",children}){
  return(
    <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"18px 20px",boxShadow:"0 1px 4px rgba(0,0,0,0.03)",marginBottom:14}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:16,paddingBottom:12,borderBottom:"1px solid #f5f5f5"}}>
        <i className={`ti ${icon}`} style={{fontSize:14,color}}/>
        <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{title}</span>
      </div>
      {children}
    </div>
  );
}

/* ── Settings sections ──────────────────────────────────────── */

function STOverview({settings,history}){
  const statuses=[
    {label:"Gemini AI",       val:settings.ai.geminiKey?"Connected":"Not configured",   ok:!!settings.ai.geminiKey,    icon:"ti-brain"},
    {label:"Safe Mode",       val:settings.automation.safeMode?"Enabled":"Disabled",     ok:settings.automation.safeMode,icon:"ti-shield"},
    {label:"Approval Required",val:settings.automation.requireApproval?"Yes":"No",      ok:settings.automation.requireApproval,icon:"ti-checkbox"},
    {label:"Critical Alerts", val:settings.notifications.criticalAlerts?"Active":"Off", ok:settings.notifications.criticalAlerts,icon:"ti-bell"},
    {label:"Export Format",   val:settings.export.format.toUpperCase(),                  ok:true,                       icon:"ti-download"},
    {label:"Team Members",    val:`${settings.team.length} member${settings.team.length!==1?"s":""}`,ok:true,           icon:"ti-users"},
    {label:"Strategist Mode", val:settings.ai.strategistMode.charAt(0).toUpperCase()+settings.ai.strategistMode.slice(1),ok:true,icon:"ti-user-star"},
    {label:"Settings History",val:`${history.length} saved`,                             ok:true,                       icon:"ti-history"},
  ];
  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
        {statuses.map(s=>(
          <div key={s.label} style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"12px 14px",boxShadow:"0 1px 3px rgba(0,0,0,0.03)"}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:8}}>
              <i className={`ti ${s.icon}`} style={{fontSize:13,color:s.ok?"#1a7a3c":"#c47a00"}}/>
              <span style={{fontSize:11,color:"#888",fontWeight:600}}>{s.label}</span>
            </div>
            <div style={{fontSize:13,fontWeight:700,color:s.ok?"#111":"#c47a00"}}>{s.val}</div>
          </div>
        ))}
      </div>
      {!settings.ai.geminiKey&&(
        <div style={{padding:"12px 16px",background:"rgba(196,122,0,0.06)",borderRadius:9,border:"1px solid rgba(196,122,0,0.2)",fontSize:12,color:"#c47a00",marginBottom:12}}>
          <i className="ti ti-alert-triangle" style={{fontSize:12,marginRight:6}}/>
          <strong>Gemini API key not set.</strong> AI features across all modules require a key. Add it in AI Settings → Gemini API Key.
        </div>
      )}
    </div>
  );
}

function STGeneralSettings({settings,onSave}){
  const[s,setS]=useState(settings.general);
  const dirty=JSON.stringify(s)!==JSON.stringify(settings.general);
  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <STSaveBar dirty={dirty} onSave={()=>onSave("general",s)} onReset={()=>setS(settings.general)}/>
      <STPanel title="Workspace Preferences" icon="ti-layout-dashboard" color="#1a5fa0">
        <STSelect value={s.defaultTab} onChange={v=>setS(p=>({...p,defaultTab:v}))} label="Default Tab on Launch"
          options={[{value:"hub",label:"Data Hub"},{value:"bids",label:"Bids Optimizer"},{value:"priority",label:"Priority Engine"},{value:"action",label:"Action Center"}]}/>
        <STToggle value={s.compactSidebar} onChange={v=>setS(p=>({...p,compactSidebar:v}))} label="Compact Sidebar" sub="Show only icons in sidebar for more workspace room"/>
      </STPanel>
      <STPanel title="Locale & Formatting" icon="ti-world" color="#6338c8">
        <STSelect value={s.currency} onChange={v=>setS(p=>({...p,currency:v}))} label="Currency"
          options={[{value:"USD",label:"USD ($)"},{value:"GBP",label:"GBP (£)"},{value:"EUR",label:"EUR (€)"},{value:"CAD",label:"CAD (C$)"},{value:"AUD",label:"AUD (A$)"}]}/>
        <STSelect value={s.timezone} onChange={v=>setS(p=>({...p,timezone:v}))} label="Timezone"
          options={["UTC","US/Eastern","US/Pacific","US/Central","Europe/London","Europe/Berlin","Asia/Kolkata","Asia/Dubai","Australia/Sydney"].map(z=>({value:z,label:z}))}/>
        <STSelect value={s.dateFormat} onChange={v=>setS(p=>({...p,dateFormat:v}))} label="Date Format"
          options={[{value:"MM/DD/YYYY",label:"MM/DD/YYYY"},{value:"DD/MM/YYYY",label:"DD/MM/YYYY"},{value:"YYYY-MM-DD",label:"YYYY-MM-DD"}]}/>
      </STPanel>
    </div>
  );
}

function STAutomationSettings({settings,onSave}){
  const[s,setS]=useState(settings.automation);
  const dirty=JSON.stringify(s)!==JSON.stringify(settings.automation);
  const warnings=[];
  if(s.maxBidIncreasePct>50) warnings.push("Bid increases above 50% are aggressive and risk rapid ACoS spikes.");
  if(s.maxBidDecreasePct>60) warnings.push("Bid decreases above 60% risk complete visibility collapse.");
  if(!s.safeMode&&!s.requireApproval) warnings.push("Disabling both Safe Mode and Approval Required allows fully automatic bid changes without review. High risk.");
  if(s.maxBidUsd>20) warnings.push(`Max bid of $${s.maxBidUsd} is very high — consider $5–$10 for most categories.`);
  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <STSaveBar dirty={dirty} onSave={()=>onSave("automation",s)} onReset={()=>setS(settings.automation)}/>
      {warnings.length>0&&(
        <div style={{marginBottom:14}}>
          {warnings.map((w,i)=>(
            <div key={i} style={{display:"flex",gap:8,padding:"8px 12px",background:"rgba(196,122,0,0.06)",borderRadius:7,border:"1px solid rgba(196,122,0,0.2)",marginBottom:6,fontSize:12,color:"#c47a00"}}>
              <i className="ti ti-alert-triangle" style={{fontSize:12,flexShrink:0,marginTop:1}}/>{w}
            </div>
          ))}
        </div>
      )}
      <STPanel title="Safety Guardrails" icon="ti-shield" color="#1a7a3c">
        <STToggle value={s.safeMode} onChange={v=>setS(p=>({...p,safeMode:v}))} label="Safe Mode" sub="Prevents automation from making changes above safety thresholds without manual confirmation"/>
        <STToggle value={s.requireApproval} onChange={v=>setS(p=>({...p,requireApproval:v}))} label="Require Approval Before Executing" sub="All rule-triggered changes must be manually reviewed before applying"/>
      </STPanel>
      <STPanel title="Bid Safety Thresholds" icon="ti-adjustments" color="#4f46e5">
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <STInput value={s.maxBidIncreasePct} onChange={v=>setS(p=>({...p,maxBidIncreasePct:v}))} label="Max Bid Increase (%)" type="number" min={1} max={100} step={1} sub="Rules cannot increase bids more than this %"/>
          <STInput value={s.maxBidDecreasePct} onChange={v=>setS(p=>({...p,maxBidDecreasePct:v}))} label="Max Bid Decrease (%)" type="number" min={1} max={100} step={1} sub="Rules cannot decrease bids more than this %"/>
          <STInput value={s.minBidUsd} onChange={v=>setS(p=>({...p,minBidUsd:v}))} label="Minimum Bid ($)" type="number" min={0.02} step={0.01} sub="Floor bid — bids never go below this"/>
          <STInput value={s.maxBidUsd} onChange={v=>setS(p=>({...p,maxBidUsd:v}))} label="Maximum Bid ($)" type="number" min={0.1} step={0.1} sub="Ceiling bid — bids never go above this"/>
        </div>
        <STInput value={s.weeklyRunLimit} onChange={v=>setS(p=>({...p,weeklyRunLimit:v}))} label="Max Rule Runs Per Week" type="number" min={1} max={30} step={1} sub="Prevents over-optimisation from running rules too frequently"/>
        <STInput value={s.pauseWarningThreshold} onChange={v=>setS(p=>({...p,pauseWarningThreshold:v}))} label="Mass Pause Warning Threshold" type="number" min={1} step={1} sub="Show warning when a rule would pause more than this many keywords at once"/>
      </STPanel>
    </div>
  );
}

function STExportSettings({settings,onSave}){
  const[s,setS]=useState(settings.export);
  const dirty=JSON.stringify(s)!==JSON.stringify(settings.export);
  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <STSaveBar dirty={dirty} onSave={()=>onSave("export",s)} onReset={()=>setS(settings.export)}/>
      <STPanel title="Export Configuration" icon="ti-download" color="#1a5fa0">
        <STSelect value={s.format} onChange={v=>setS(p=>({...p,format:v}))} label="Default Export Format"
          options={[{value:"xlsx",label:"Excel (.xlsx)"},{value:"csv",label:"CSV (.csv)"}]}/>
        <STSelect value={s.namingConvention} onChange={v=>setS(p=>({...p,namingConvention:v}))} label="File Naming Convention"
          options={[{value:"module_date",label:"ModuleName_Date"},{value:"date_module",label:"Date_ModuleName"},{value:"custom",label:"Custom prefix only"}]}/>
        <STInput value={s.sheetPrefix} onChange={v=>setS(p=>({...p,sheetPrefix:v}))} label="File Prefix" placeholder="Quarred" sub="Added to the beginning of every exported file name"/>
        <STToggle value={s.includeComparison} onChange={v=>setS(p=>({...p,includeComparison:v}))} label="Include Comparison Period Data" sub="Add previous period columns to all exports when comparison data is available"/>
        <STToggle value={s.includeScores} onChange={v=>setS(p=>({...p,includeScores:v}))} label="Include Calculated Scores" sub="Include module-specific scores (waste score, opportunity score, etc.) in exports"/>
      </STPanel>
    </div>
  );
}

function STNotificationSettings({settings,onSave}){
  const[s,setS]=useState(settings.notifications);
  const dirty=JSON.stringify(s)!==JSON.stringify(settings.notifications);
  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <STSaveBar dirty={dirty} onSave={()=>onSave("notifications",s)} onReset={()=>setS(settings.notifications)}/>
      <STPanel title="Alert Visibility" icon="ti-bell" color="#c47a00">
        <STToggle value={s.criticalAlerts} onChange={v=>setS(p=>({...p,criticalAlerts:v}))} label="Critical Alerts" sub="Show Critical severity alerts across all modules"/>
        <STToggle value={s.highAlerts} onChange={v=>setS(p=>({...p,highAlerts:v}))} label="High Priority Alerts" sub="Show High severity alerts across all modules"/>
        <STToggle value={s.mediumAlerts} onChange={v=>setS(p=>({...p,mediumAlerts:v}))} label="Medium Alerts" sub="Show Medium severity alerts (can create noise in large accounts)"/>
      </STPanel>
      <STPanel title="Alert Thresholds" icon="ti-adjustments" color="#4f46e5">
        <STInput value={s.wasteThreshold} onChange={v=>setS(p=>({...p,wasteThreshold:v}))} label="Waste Alert Threshold ($)" type="number" min={1} step={1} sub="Only alert on entities with waste spend above this amount"/>
        <STInput value={s.acosThreshold} onChange={v=>setS(p=>({...p,acosThreshold:v}))} label="High ACoS Alert Threshold (%)" type="number" min={10} max={200} step={5} sub="Only alert on campaigns with ACoS above this %"/>
      </STPanel>
      <STPanel title="Summary Reports" icon="ti-file-analytics" color="#1a5fa0">
        <STToggle value={s.weeklyDigest} onChange={v=>setS(p=>({...p,weeklyDigest:v}))} label="Weekly Performance Digest" sub="Show a weekly summary when opening the portal on Mondays"/>
        <STToggle value={s.emailSummary} onChange={v=>setS(p=>({...p,emailSummary:v}))} label="Email Summary (Coming Soon)" sub="Email weekly summaries — requires email integration setup"/>
      </STPanel>
    </div>
  );
}

function STAISettings({settings,onSave}){
  const[s,setS]=useState(settings.ai);
  const[showKey,setShowKey]=useState(false);
  const dirty=JSON.stringify(s)!==JSON.stringify(settings.ai);
  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <STSaveBar dirty={dirty} onSave={()=>onSave("ai",s)} onReset={()=>setS(settings.ai)}/>
      <STPanel title="Gemini API Key" icon="ti-key" color="#6338c8">
        <div style={{fontSize:12,color:"#555",lineHeight:1.6,marginBottom:12}}>Required for all AI features across the portal — AI Strategist, Brand Defense AI, Competitor Radar AI, Account Audit, Niche Dives, and the AI Mentor in the Learning Hub.</div>
        <div style={{marginBottom:8}}>
          <label style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:5}}>API Key</label>
          <div style={{position:"relative"}}>
            <input type={showKey?"text":"password"} value={s.geminiKey} onChange={e=>setS(p=>({...p,geminiKey:e.target.value}))} placeholder="Paste Gemini API key here (starts with AIza...)" style={{padding:"8px 40px 8px 12px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:13,color:"#111",width:"100%",boxSizing:"border-box",outline:"none"}}/>
            <button onClick={()=>setShowKey(v=>!v)} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",border:"none",background:"transparent",cursor:"pointer",color:"#aaa",fontSize:14}}><i className={`ti ${showKey?"ti-eye-off":"ti-eye"}`}/></button>
          </div>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Get a free key at <strong>aistudio.google.com/app/apikey</strong> — free tier supports 15 requests/minute and 1M tokens/day. Key is stored locally in your browser only.</div>
      </STPanel>
      <STPanel title="AI Behaviour" icon="ti-brain" color="#4f46e5">
        <STSelect value={s.strategistMode} onChange={v=>setS(p=>({...p,strategistMode:v}))} label="Strategist Mode"
          options={[{value:"beginner",label:"Beginner — simplified explanations, more guidance"},{value:"intermediate",label:"Intermediate — balanced detail and strategy"},{value:"advanced",label:"Advanced — concise, technical, expert-level"}]}
          sub="Affects how AI explains recommendations and analysis across all modules"/>
        <STSelect value={s.aggressiveness} onChange={v=>setS(p=>({...p,aggressiveness:v}))} label="Recommendation Aggressiveness"
          options={[{value:"conservative",label:"Conservative — only high-confidence, low-risk suggestions"},{value:"balanced",label:"Balanced — mix of safe and growth-oriented"},{value:"aggressive",label:"Aggressive — all opportunities, including higher-risk"}]}/>
        <STSelect value={s.explanationDepth} onChange={v=>setS(p=>({...p,explanationDepth:v}))} label="Explanation Depth"
          options={[{value:"brief",label:"Brief — short, action-focused"},{value:"detailed",label:"Detailed — full reasoning and context"},{value:"comprehensive",label:"Comprehensive — deep analysis with background"}]}/>
        <STSelect value={s.opportunitySensitivity} onChange={v=>setS(p=>({...p,opportunitySensitivity:v}))} label="Opportunity Detection Sensitivity"
          options={[{value:"low",label:"Low — only show clear, obvious opportunities"},{value:"medium",label:"Medium — balanced detection"},{value:"high",label:"High — surface marginal opportunities too"}]}/>
      </STPanel>
    </div>
  );
}

function STIntegrations({settings}){
  const integrations=[
    {name:"Amazon Advertising Console",status:"Manual Upload",icon:"ti-cloud-upload",color:"#c47a00",desc:"Reports are uploaded manually via the Data Hub. No direct API connection.",action:"Data Hub"},
    {name:"Helium 10",status:"Not Connected",icon:"ti-plug",color:"#888",desc:"Rank and keyword data can be imported via CSV/Excel upload in the Data Hub.",action:"Connect"},
    {name:"Jungle Scout",status:"Not Connected",icon:"ti-plug",color:"#888",desc:"Keyword and rank data import supported via file upload.",action:"Connect"},
    {name:"Google Sheets",status:"Coming Soon",icon:"ti-brand-google",color:"#aaa",desc:"Direct export to Google Sheets — planned feature.",action:"Soon"},
    {name:"Slack Notifications",status:"Coming Soon",icon:"ti-brand-slack",color:"#aaa",desc:"Push weekly summaries and critical alerts to Slack channels.",action:"Soon"},
  ];
  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <div style={{padding:"10px 14px",background:"rgba(26,95,160,0.06)",borderRadius:8,border:"1px solid rgba(26,95,160,0.15)",fontSize:12,color:"#1a5fa0",marginBottom:14}}>
        <i className="ti ti-info-circle" style={{fontSize:12,marginRight:6}}/>
        This tool works fully offline — reports are uploaded manually via the Data Hub. Direct Amazon API integration requires Amazon SP-API credentials which are not currently configured.
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {integrations.map((int,i)=>(
          <div key={i} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 18px",display:"flex",alignItems:"center",gap:14}}>
            <div style={{width:36,height:36,borderRadius:9,background:`${int.color}14`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${int.icon}`} style={{fontSize:16,color:int.color}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600,color:"#111",marginBottom:2}}>{int.name}</div>
              <div style={{fontSize:11,color:"#888"}}>{int.desc}</div>
            </div>
            <div style={{textAlign:"right",flexShrink:0}}>
              <div style={{fontSize:11,fontWeight:700,color:int.status==="Manual Upload"?"#1a7a3c":int.status==="Not Connected"?"#c47a00":"#aaa",marginBottom:5}}>{int.status}</div>
              <button disabled={int.action==="Soon"} style={{padding:"4px 12px",borderRadius:6,border:`1px solid ${int.action==="Soon"?"#e0e0e0":int.action==="Data Hub"?"rgba(26,122,60,0.3)":"rgba(79,70,229,0.3)"}`,background:"#fff",cursor:int.action==="Soon"?"default":"pointer",fontSize:11,color:int.action==="Soon"?"#aaa":int.action==="Data Hub"?"#1a7a3c":"#4f46e5",fontWeight:600,opacity:int.action==="Soon"?0.5:1}}>
                {int.action}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function STTeam({settings,onSave}){
  const[team,setTeam]=useState(settings.team);
  const[addName,setAddName]=useState("");
  const[addEmail,setAddEmail]=useState("");
  const[addRole,setAddRole]=useState("Strategist");
  const roles=["Admin","Strategist","Analyst","Viewer"];
  const roleColors={Admin:"#d42b2b",Strategist:"#1a5fa0",Analyst:"#6338c8",Viewer:"#888"};

  function addMember(){
    if(!addName.trim()) return;
    const newTeam=[...team,{id:`m_${Date.now()}`,name:addName.trim(),email:addEmail.trim(),role:addRole,added:new Date().toISOString().split("T")[0]}];
    setTeam(newTeam);onSave("team",newTeam);
    setAddName("");setAddEmail("");setAddRole("Strategist");
  }
  function removeMember(id){
    if(team.find(m=>m.id===id)?.role==="Admin"&&team.filter(m=>m.role==="Admin").length<=1){alert("Cannot remove the last Admin.");return;}
    const updated=team.filter(m=>m.id!==id);setTeam(updated);onSave("team",updated);
  }

  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <STPanel title="Team Members" icon="ti-users" color="#1a5fa0">
        <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:16}}>
          {team.map(m=>(
            <div key={m.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0"}}>
              <div style={{width:32,height:32,borderRadius:"50%",background:"rgba(79,70,229,0.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontWeight:700,fontSize:12,color:"#4f46e5"}}>{m.name.charAt(0).toUpperCase()}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600,color:"#111"}}>{m.name}</div>
                {m.email&&<div style={{fontSize:11,color:"#aaa"}}>{m.email}</div>}
              </div>
              <span style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:`${roleColors[m.role]||"#888"}12`,color:roleColors[m.role]||"#888",fontWeight:700}}>{m.role}</span>
              <div style={{fontSize:11,color:"#ccc"}}>{m.added}</div>
              {m.id!=="owner"&&<button onClick={()=>removeMember(m.id)} style={{border:"none",background:"transparent",cursor:"pointer",color:"#d42b2b",fontSize:13,padding:"2px"}}><i className="ti ti-trash"/></button>}
            </div>
          ))}
        </div>
        <div style={{padding:"14px 16px",background:"#fafafa",borderRadius:10,border:"1px solid #f0f0f0"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>Add Team Member</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
            <input value={addName} onChange={e=>setAddName(e.target.value)} placeholder="Full name" style={{padding:"7px 10px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:12,outline:"none"}}/>
            <input value={addEmail} onChange={e=>setAddEmail(e.target.value)} placeholder="Email (optional)" style={{padding:"7px 10px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:12,outline:"none"}}/>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <select value={addRole} onChange={e=>setAddRole(e.target.value)} style={{flex:1,padding:"7px 10px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:12,cursor:"pointer"}}>
              {roles.map(r=><option key={r} value={r}>{r}</option>)}
            </select>
            <button onClick={addMember} disabled={!addName.trim()} style={{...T.btnR(!!addName.trim()),padding:"7px 16px",fontSize:12,opacity:!addName.trim()?0.4:1}}>
              <i className="ti ti-plus" style={{fontSize:12}}/>Add
            </button>
          </div>
        </div>
      </STPanel>
      <STPanel title="Role Permissions" icon="ti-lock" color="#6338c8">
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {[
            {role:"Admin",desc:"Full access — all modules, settings, team management, all exports"},
            {role:"Strategist",desc:"All PPC modules + exports. No team management or settings changes."},
            {role:"Analyst",desc:"Read-only access to all modules. Can view but not apply changes."},
            {role:"Viewer",desc:"Dashboard and report view only. No module access."},
          ].map(r=>(
            <div key={r.role} style={{display:"flex",gap:10,padding:"8px 12px",background:"#fafafa",borderRadius:7}}>
              <span style={{fontSize:11,fontWeight:700,padding:"1px 7px",borderRadius:4,background:`${roleColors[r.role]||"#888"}12`,color:roleColors[r.role]||"#888",flexShrink:0}}>{r.role}</span>
              <span style={{fontSize:12,color:"#555"}}>{r.desc}</span>
            </div>
          ))}
        </div>
      </STPanel>
    </div>
  );
}

function STHistory({history,onRestore,onClear}){
  if(!history.length) return(
    <div style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>
      <i className="ti ti-history" style={{fontSize:28,display:"block",marginBottom:8,color:"#ddd"}}/>
      No settings changes recorded yet. Changes are tracked after your first save.
    </div>
  );
  return(
    <div style={{maxWidth:700,margin:"0 auto"}}>
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}>
        <button onClick={onClear} style={{padding:"5px 12px",borderRadius:7,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#888"}}>Clear History</button>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {[...history].reverse().map((h,i)=>(
          <div key={i} style={{background:"#fff",borderRadius:10,border:"1px solid #f0f0f0",padding:"12px 16px",display:"flex",alignItems:"center",gap:12}}>
            <i className="ti ti-history" style={{fontSize:14,color:"#aaa",flexShrink:0}}/>
            <div style={{flex:1}}>
              <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{h.section.charAt(0).toUpperCase()+h.section.slice(1)} settings updated</div>
              <div style={{fontSize:11,color:"#aaa"}}>{new Date(h.ts).toLocaleString()}</div>
            </div>
            <button onClick={()=>onRestore(h)} style={{padding:"4px 10px",borderRadius:6,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555"}}>Restore</button>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Settings Module Root ────────────────────────────────────── */
function SettingsModule(){
  const[activeTab,setActiveTab]=useState("overview");
  const[settings,setSettingsRaw]=useState(stLoad);
  const[history,setHistory]=useState(stLoadHistory);
  const[saved,setSaved]=useState(false);

  function saveSection(section,value){
    const updated={...settings,[section]:value};
    setSettingsRaw(updated);stSave(updated);
    const hist=[...history,{section,ts:Date.now(),prev:settings[section],next:value}];
    setHistory(hist);stSaveHistory(hist);
    setSaved(true);setTimeout(()=>setSaved(false),2000);
    // Notify all AI modules that key may have changed
    window.dispatchEvent(new Event("rq_settings_saved"));
  }

  function restoreSnapshot(h){
    if(!window.confirm(`Restore ${h.section} settings to state from ${new Date(h.ts).toLocaleString()}?`)) return;
    saveSection(h.section,h.prev);
  }

  function resetAll(){
    if(!window.confirm("Reset ALL settings to defaults? This cannot be undone.")) return;
    const def=JSON.parse(JSON.stringify(ST_DEFAULTS));
    setSettingsRaw(def);stSave(def);
  }

  const tabs=[
    {key:"overview",       label:"Overview",       icon:"ti-layout-dashboard"},
    {key:"general",        label:"General",        icon:"ti-settings"},
    {key:"automation",     label:"Automation",     icon:"ti-robot"},
    {key:"export",         label:"Export",         icon:"ti-download"},
    {key:"notifications",  label:"Notifications",  icon:"ti-bell"},
    {key:"ai",             label:"AI Settings",    icon:"ti-brain"},
    {key:"integrations",   label:"Integrations",   icon:"ti-plug"},
    {key:"team",           label:"Team",           icon:"ti-users",badge:settings.team.length},
    {key:"history",        label:"History",        icon:"ti-history",badge:history.length||null},
  ];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-settings" style={{fontSize:15,color:"#555"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Settings</span>
        {saved&&<span style={{fontSize:11,color:"#1a7a3c",fontWeight:600,display:"flex",alignItems:"center",gap:4}}><i className="ti ti-check" style={{fontSize:11}}/>Saved</span>}
        <div style={{flex:1}}/>
        <button onClick={resetAll} style={{padding:"5px 12px",borderRadius:7,border:"1px solid rgba(212,43,43,0.3)",background:"rgba(212,43,43,0.04)",cursor:"pointer",fontSize:11,color:"#d42b2b",fontWeight:600}}>
          <i className="ti ti-refresh" style={{fontSize:11,marginRight:4}}/>Reset All Defaults
        </button>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#555":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#333":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#555":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="overview"&&<STOverview settings={settings} history={history}/>}
        {activeTab==="general"&&<STGeneralSettings settings={settings} onSave={saveSection}/>}
        {activeTab==="automation"&&<STAutomationSettings settings={settings} onSave={saveSection}/>}
        {activeTab==="export"&&<STExportSettings settings={settings} onSave={saveSection}/>}
        {activeTab==="notifications"&&<STNotificationSettings settings={settings} onSave={saveSection}/>}
        {activeTab==="ai"&&<STAISettings settings={settings} onSave={saveSection}/>}
        {activeTab==="integrations"&&<STIntegrations settings={settings}/>}
        {activeTab==="team"&&<STTeam settings={settings} onSave={saveSection}/>}
        {activeTab==="history"&&<STHistory history={history} onRestore={restoreSnapshot} onClear={()=>{setHistory([]);stSaveHistory([]);}}/>}
      </div>
    </div>
  );
}

/* ================================================================
   CLIENT REPORTING MODULE
   Professional Amazon PPC client reporting system.
   Sections: Dashboard · Report Builder · KPI Engine
             AI Assistant · Templates · Schedule · Export
   No upload — syncs from Global Data Hub.
================================================================ */

/* ── Report storage ─────────────────────────────────────────── */
const CR_LS="quarred_reports_v1";
function crLoadReports(){try{const s=localStorage.getItem(CR_LS);return s?JSON.parse(s):[];}catch{return[];}}
function crSaveReports(r){try{localStorage.setItem(CR_LS,JSON.stringify(r));}catch{}}

/* ── Report templates ───────────────────────────────────────── */
const CR_TEMPLATES=[
  {id:"weekly",   name:"Weekly Client Report",     icon:"ti-calendar-week",  color:"#1a5fa0",
   sections:["executive_summary","kpi_overview","spend_sales","acos_tacos","actions_completed","next_steps"],
   desc:"Concise weekly summary for regular client check-ins. Covers key KPIs, notable changes, and next-week priorities."},
  {id:"monthly",  name:"Monthly Performance Report",icon:"ti-calendar",      color:"#4f46e5",
   sections:["executive_summary","kpi_overview","spend_sales","acos_tacos","search_terms","ranking","visibility","actions_completed","opportunities","next_steps"],
   desc:"Comprehensive monthly report with full performance breakdown, trend analysis, and strategic recommendations."},
  {id:"executive",name:"Executive Summary",         icon:"ti-presentation",  color:"#6338c8",
   sections:["executive_summary","kpi_overview","opportunities","ai_insights"],
   desc:"High-level overview for senior stakeholders. Minimal detail, maximum clarity on business impact."},
  {id:"launch",   name:"Product Launch Report",     icon:"ti-rocket",        color:"#1a7a3c",
   sections:["executive_summary","kpi_overview","spend_sales","ranking","search_terms","actions_completed","next_steps"],
   desc:"Tracks launch progress — rank movement, CVR performance, keyword harvesting, and scaling readiness."},
  {id:"scaling",  name:"Scaling Opportunity Report",icon:"ti-trending-up",   color:"#2a9a50",
   sections:["executive_summary","opportunities","kpi_overview","visibility","ai_insights","next_steps"],
   desc:"Focused entirely on growth — where to scale, what's ready, and what the projected impact is."},
  {id:"recovery", name:"Recovery Report",           icon:"ti-heart-rate-monitor",color:"#c47a00",
   sections:["executive_summary","kpi_overview","acos_tacos","actions_completed","ai_insights","next_steps"],
   desc:"Post-recovery reporting showing ACoS improvement, waste elimination, and performance restoration."},
  {id:"audit",    name:"Account Audit Report",      icon:"ti-clipboard-check",color:"#2a6496",
   sections:["executive_summary","kpi_overview","acos_tacos","search_terms","visibility","opportunities","ai_insights"],
   desc:"Full account health diagnostic with structural findings, efficiency scores, and strategic priorities."},
  {id:"custom",   name:"Custom Report",             icon:"ti-adjustments",    color:"#555",
   sections:["executive_summary","kpi_overview"],
   desc:"Build your own report from scratch. Add, remove, and reorder any sections you need."},
];

const CR_SECTIONS=[
  {key:"executive_summary", label:"Executive Summary",           icon:"ti-star"},
  {key:"kpi_overview",      label:"KPI Overview",                icon:"ti-chart-bar"},
  {key:"spend_sales",       label:"Spend & Sales Analysis",      icon:"ti-cash"},
  {key:"acos_tacos",        label:"ACoS / TACOS Analysis",       icon:"ti-percentage"},
  {key:"search_terms",      label:"Search Term Intelligence",    icon:"ti-search"},
  {key:"ranking",           label:"Ranking Movement",            icon:"ti-trending-up"},
  {key:"visibility",        label:"Visibility Analysis",         icon:"ti-eye"},
  {key:"actions_completed", label:"Optimisations Completed",     icon:"ti-check"},
  {key:"opportunities",     label:"Growth Opportunities",        icon:"ti-rocket"},
  {key:"next_steps",        label:"Next-Step Recommendations",   icon:"ti-arrow-right"},
  {key:"ai_insights",       label:"AI Strategic Insights",       icon:"ti-brain"},
];

/* ── KPI computation ────────────────────────────────────────── */
function crComputeKPIs(rows, cm, compRows, compCm){
  if(!rows||!cm||!rows.length) return null;
  const sum=(arr,key)=>arr.reduce((s,m)=>s+m[key],0);
  const metrics=rows.map(r=>calcRowMetrics(r,cm)).filter(m=>m.spend>0||m.impressions>10);
  if(!metrics.length) return null;

  const spend=sum(metrics,"spend");
  const sales=sum(metrics,"sales");
  const orders=sum(metrics,"orders");
  const impressions=sum(metrics,"impressions");
  const clicks=sum(metrics,"clicks");
  const acos=sales>0?(spend/sales)*100:0;
  const ctr=impressions>0?(clicks/impressions)*100:0;
  const cvr=clicks>0?(orders/clicks)*100:0;
  const cpc=clicks>0?spend/clicks:0;
  const roas=spend>0?sales/spend:0;
  const wasteItems=metrics.filter(m=>m.spend>5&&m.orders===0);
  const wasteSpend=wasteItems.reduce((s,m)=>s+m.spend,0);

  let prev=null;
  if(compRows&&compCm&&compRows.length){
    const cm2=metrics.map(r=>calcRowMetrics(r,compCm)).filter(m=>m.spend>0||m.impressions>10);
    if(cm2.length){
      const ps=sum(cm2,"spend"),psa=sum(cm2,"sales"),po=sum(cm2,"orders"),pi=sum(cm2,"impressions"),pc=sum(cm2,"clicks");
      prev={spend:ps,sales:psa,orders:po,impressions:pi,clicks:pc,
        acos:psa>0?(ps/psa)*100:0,ctr:pi>0?(pc/pi)*100:0,cvr:pc>0?(po/pc)*100:0,
        cpc:pc>0?ps/pc:0,roas:ps>0?psa/ps:0};
    }
  }
  return{spend,sales,orders,impressions,clicks,acos,ctr,cvr,cpc,roas,wasteSpend,wasteCount:wasteItems.length,prev,totalEntities:metrics.length};
}

function crDelta(cur,prev,key,lowerBetter=false){
  if(!prev||!prev[key]) return null;
  const d=((cur[key]-prev[key])/prev[key])*100;
  const improving=lowerBetter?d<0:d>0;
  return{pct:d,improving};
}

/* ── Sub-components ─────────────────────────────────────────── */
function CREmptyState({onGoToHub}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:16,background:"rgba(26,95,160,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-file-analytics" style={{fontSize:26,color:"#1a5fa0"}}/>
      </div>
      <div style={{fontSize:17,fontWeight:700,color:"#111",marginBottom:8}}>Client Reporting needs data</div>
      <div style={{fontSize:13,color:"#666",maxWidth:380,lineHeight:1.6,marginBottom:20}}>Upload a Campaign Report in the Data Hub first. Client Reporting uses your campaign data to auto-populate KPIs, generate comparisons, and build professional reports.</div>
      <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 24px"}}><i className="ti ti-database-import" style={{fontSize:14}}/>Go to Data Hub</button>
    </div>
  );
}

/* Dashboard */
function CRDashboard({reports,onNewReport,kpis}){
  const recent=reports.slice(-5).reverse();
  return(
    <div style={{maxWidth:960,margin:"0 auto"}}>
      {/* Summary cards */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
        {[
          {label:"Reports Created",  val:reports.length,       icon:"ti-file-analytics",color:"#1a5fa0"},
          {label:"This Week",        val:reports.filter(r=>Date.now()-r.createdAt<7*24*3600*1000).length,icon:"ti-calendar-week",color:"#1a7a3c"},
          {label:"Exports",          val:reports.filter(r=>r.exported).length,icon:"ti-download",color:"#4f46e5"},
          {label:"Templates Used",   val:[...new Set(reports.map(r=>r.templateId))].length,icon:"ti-template",color:"#6338c8"},
        ].map(c=>(
          <div key={c.label} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"13px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.03)"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
              <i className={`ti ${c.icon}`} style={{fontSize:13,color:c.color}}/>
              <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
            </div>
            <div style={{fontSize:22,fontWeight:800,color:"#111"}}>{c.val}</div>
          </div>
        ))}
      </div>

      {/* Quick start */}
      <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"20px 22px",marginBottom:14}}>
        <div style={{fontSize:14,fontWeight:700,color:"#111",marginBottom:14}}>Start a Report</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
          {CR_TEMPLATES.slice(0,8).map(t=>(
            <button key={t.id} onClick={()=>onNewReport(t.id)} style={{background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0",padding:"12px 14px",cursor:"pointer",textAlign:"left",transition:"border-color 0.15s"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                <i className={`ti ${t.icon}`} style={{fontSize:14,color:t.color}}/>
                <span style={{fontSize:11,fontWeight:700,color:"#111"}}>{t.name}</span>
              </div>
              <div style={{fontSize:10,color:"#888",lineHeight:1.4}}>{t.desc.split(".")[0]}.</div>
            </button>
          ))}
        </div>
      </div>

      {/* Recent reports */}
      {recent.length>0&&(
        <div style={{background:"#fff",borderRadius:14,border:"1px solid #f0f0f0",padding:"16px 20px"}}>
          <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Recent Reports</div>
          <div style={{display:"flex",flexDirection:"column",gap:7}}>
            {recent.map(r=>{
              const t=CR_TEMPLATES.find(t=>t.id===r.templateId)||CR_TEMPLATES[0];
              return(
                <div key={r.id} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 12px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0"}}>
                  <i className={`ti ${t.icon}`} style={{fontSize:14,color:t.color,flexShrink:0}}/>
                  <span style={{fontSize:12,fontWeight:600,color:"#111",flex:1}}>{r.name||t.name}</span>
                  <span style={{fontSize:11,color:"#aaa"}}>{new Date(r.createdAt).toLocaleDateString()}</span>
                  {r.exported&&<span style={{fontSize:10,padding:"1px 6px",borderRadius:3,background:"rgba(26,122,60,0.1)",color:"#1a7a3c",fontWeight:700}}>Exported</span>}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

/* KPI card with delta */
function CRKPICard({label,value,prev,fmt,lowerBetter=false,icon,color="#555"}){
  const d=prev!=null&&prev>0?((value-prev)/prev)*100:null;
  const improving=d===null?null:(lowerBetter?d<0:d>0);
  return(
    <div style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.03)"}}>
      <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:8}}>
        <i className={`ti ${icon}`} style={{fontSize:12,color}}/>
        <span style={{fontSize:11,color:"#888",fontWeight:600}}>{label}</span>
      </div>
      <div style={{fontSize:22,fontWeight:800,color:"#111",marginBottom:4}}>{fmt(value)}</div>
      {d!==null&&(
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <span style={{fontSize:12,fontWeight:700,color:improving?"#1a7a3c":"#d42b2b"}}>{d>0?"+":""}{d.toFixed(1)}%</span>
          <span style={{fontSize:10,color:"#aaa"}}>vs {fmt(prev)}</span>
        </div>
      )}
      {d===null&&<div style={{fontSize:10,color:"#ccc"}}>No comparison</div>}
    </div>
  );
}

/* Report builder */
function CRBuilder({templateId,kpis,globalData,onSave,onCancel}){
  const template=CR_TEMPLATES.find(t=>t.id===templateId)||CR_TEMPLATES[0];
  const[name,setName]=useState(`${template.name} — ${new Date().toLocaleDateString()}`);
  const[sections,setSections]=useState(template.sections);
  const[clientName,setClientName]=useState("");
  const[notes,setNotes]=useState("");
  const[period,setPeriod]=useState(globalData?.periods?.current?`${globalData.periods.current.start} → ${globalData.periods.current.end}`:"");
  const[activeSection,setActiveSection]=useState(sections[0]||"kpi_overview");

  const availableSections=CR_SECTIONS.filter(s=>!sections.includes(s.key));

  function buildReport(){
    const report={
      id:`rep_${Date.now()}`,
      templateId,name,clientName,notes,period,sections,
      kpiSnapshot:kpis,
      createdAt:Date.now(),exported:false
    };
    onSave(report);
  }

  return(
    <div style={{display:"grid",gridTemplateColumns:"260px 1fr",gap:14,maxWidth:1100,margin:"0 auto",height:"calc(100vh - 220px)",minHeight:500}}>
      {/* Left: config */}
      <div style={{display:"flex",flexDirection:"column",gap:10,overflow:"auto"}}>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>Report Details</div>
          <div style={{marginBottom:10}}>
            <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:4}}>Report Name</label>
            <input value={name} onChange={e=>setName(e.target.value)} style={{padding:"7px 10px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
          </div>
          <div style={{marginBottom:10}}>
            <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:4}}>Client / Account Name</label>
            <input value={clientName} onChange={e=>setClientName(e.target.value)} placeholder="e.g. Acme Brand" style={{padding:"7px 10px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
          </div>
          <div style={{marginBottom:10}}>
            <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:4}}>Reporting Period</label>
            <input value={period} onChange={e=>setPeriod(e.target.value)} placeholder="e.g. Jun 1–30, 2025" style={{padding:"7px 10px",borderRadius:6,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
          </div>
        </div>

        <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 16px",flex:1,overflow:"auto"}}>
          <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>Report Sections</div>
          <div style={{display:"flex",flexDirection:"column",gap:5,marginBottom:12}}>
            {sections.map((key,i)=>{
              const sec=CR_SECTIONS.find(s=>s.key===key);
              if(!sec) return null;
              return(
                <div key={key} onClick={()=>setActiveSection(key)} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",borderRadius:7,border:`1.5px solid ${activeSection===key?"#4f46e5":"#f0f0f0"}`,background:activeSection===key?"rgba(79,70,229,0.04)":"#fafafa",cursor:"pointer"}}>
                  <i className={`ti ${sec.icon}`} style={{fontSize:12,color:activeSection===key?"#4f46e5":"#aaa"}}/>
                  <span style={{fontSize:11,fontWeight:500,color:activeSection===key?"#4f46e5":"#555",flex:1}}>{sec.label}</span>
                  <button onClick={e=>{e.stopPropagation();setSections(s=>s.filter((_,j)=>j!==i));}} style={{border:"none",background:"transparent",cursor:"pointer",color:"#ccc",fontSize:12,padding:"1px"}}><i className="ti ti-x"/></button>
                </div>
              );
            })}
          </div>
          {availableSections.length>0&&(
            <>
              <div style={{fontSize:10,fontWeight:700,color:"#ccc",textTransform:"uppercase",letterSpacing:"0.4px",marginBottom:6}}>Add Section</div>
              <div style={{display:"flex",flexDirection:"column",gap:4}}>
                {availableSections.map(sec=>(
                  <button key={sec.key} onClick={()=>setSections(s=>[...s,sec.key])} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",borderRadius:6,border:"1px dashed #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555",textAlign:"left"}}>
                    <i className={`ti ${sec.icon}`} style={{fontSize:11,color:"#ccc"}}/>{sec.label}<i className="ti ti-plus" style={{marginLeft:"auto",fontSize:10,color:"#ccc"}}/>
                  </button>
                ))}
              </div>
            </>
          )}
        </div>

        <div style={{display:"flex",gap:8}}>
          <button onClick={onCancel} style={{flex:1,padding:"9px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:12,color:"#555",fontWeight:600}}>Cancel</button>
          <button onClick={buildReport} style={{...T.btnR(true),flex:1,justifyContent:"center",fontSize:12,padding:"9px"}}><i className="ti ti-file-plus" style={{fontSize:12}}/>Build</button>
        </div>
      </div>

      {/* Right: preview */}
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"20px 22px",overflow:"auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:16,paddingBottom:12,borderBottom:"1px solid #f5f5f5"}}>
          <i className={`ti ${template.icon}`} style={{fontSize:15,color:template.color}}/>
          <div>
            <div style={{fontSize:14,fontWeight:800,color:"#111"}}>{name}</div>
            {clientName&&<div style={{fontSize:11,color:"#888"}}>For: {clientName} {period&&`· ${period}`}</div>}
          </div>
        </div>

        {activeSection==="kpi_overview"&&kpis&&(
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>KPI Overview</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:12}}>
              <CRKPICard label="Total Spend"  value={kpis.spend}   prev={kpis.prev?.spend}   fmt={v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`} lowerBetter icon="ti-cash"      color="#4f46e5"/>
              <CRKPICard label="Total Sales"  value={kpis.sales}   prev={kpis.prev?.sales}   fmt={v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`} icon="ti-coin"     color="#1a7a3c"/>
              <CRKPICard label="Total Orders" value={kpis.orders}  prev={kpis.prev?.orders}  fmt={v=>String(Math.round(v))}  icon="ti-shopping-cart" color="#1a5fa0"/>
              <CRKPICard label="ACoS"         value={kpis.acos}    prev={kpis.prev?.acos}    fmt={v=>`${v.toFixed(1)}%`} lowerBetter icon="ti-percentage" color="#c47a00"/>
              <CRKPICard label="CPC"          value={kpis.cpc}     prev={kpis.prev?.cpc}     fmt={v=>`$${v.toFixed(2)}`} lowerBetter icon="ti-click"     color="#555"/>
              <CRKPICard label="CVR"          value={kpis.cvr}     prev={kpis.prev?.cvr}     fmt={v=>`${v.toFixed(1)}%`} icon="ti-percentage"  color="#6338c8"/>
              <CRKPICard label="CTR"          value={kpis.ctr}     prev={kpis.prev?.ctr}     fmt={v=>`${v.toFixed(2)}%`} icon="ti-eye"         color="#2a6496"/>
              <CRKPICard label="ROAS"         value={kpis.roas}    prev={kpis.prev?.roas}    fmt={v=>v.toFixed(2)+"x"} icon="ti-trending-up" color="#1a7a3c"/>
            </div>
            {kpis.wasteCount>0&&(
              <div style={{padding:"10px 14px",background:"rgba(212,43,43,0.06)",borderRadius:8,border:"1px solid rgba(212,43,43,0.15)",fontSize:12,color:"#d42b2b"}}>
                <i className="ti ti-droplet-off" style={{fontSize:12,marginRight:6}}/><strong>{kpis.wasteCount} entities</strong> with $${kpis.wasteSpend.toFixed(0)} waste spend (zero orders) identified for optimisation.
              </div>
            )}
          </div>
        )}

        {activeSection==="executive_summary"&&(
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>Executive Summary</div>
            {kpis?(
              <div style={{fontSize:13,color:"#333",lineHeight:1.8,padding:"16px 18px",background:"#fafafa",borderRadius:10,border:"1px solid #f0f0f0"}}>
                {`During ${period||"the reporting period"}, the account generated `}
                <strong>${kpis.sales>=1000?(kpis.sales/1000).toFixed(1)+"K":kpis.sales.toFixed(0)} in total sales</strong>
                {` on $${kpis.spend>=1000?(kpis.spend/1000).toFixed(1)+"K":kpis.spend.toFixed(0)} ad spend`}
                {kpis.prev&&kpis.prev.sales>0?`, representing a ${((kpis.sales-kpis.prev.sales)/kpis.prev.sales*100).toFixed(0)}% ${kpis.sales>=kpis.prev.sales?"increase":"change"} in sales vs the previous period`:""}
                {`. Overall ACoS was ${kpis.acos.toFixed(1)}%`}
                {kpis.prev&&kpis.prev.acos>0?` (${kpis.acos<kpis.prev.acos?"improved":"increased"} from ${kpis.prev.acos.toFixed(1)}%)`:""}.
                {` ${kpis.orders} total orders were generated`}
                {kpis.prev&&kpis.prev.orders>0?` vs ${Math.round(kpis.prev.orders)} previously`:""}
                {`. CVR was ${kpis.cvr.toFixed(1)}% and average CPC was $${kpis.cpc.toFixed(2)}.`}
                {kpis.wasteCount>0?` ${kpis.wasteCount} waste entities consuming $${kpis.wasteSpend.toFixed(0)} were identified for immediate action.`:""}
              </div>
            ):<div style={{fontSize:13,color:"#aaa",fontStyle:"italic"}}>Load data in the Data Hub to generate an executive summary.</div>}
          </div>
        )}

        {activeSection==="spend_sales"&&kpis&&(
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>Spend & Sales Analysis</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
              {[
                {label:"Total Spend",cur:kpis.spend,prev:kpis.prev?.spend,fmt:v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`,lb:true},
                {label:"Total Sales",cur:kpis.sales,prev:kpis.prev?.sales,fmt:v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`,lb:false},
                {label:"ROAS",cur:kpis.roas,prev:kpis.prev?.roas,fmt:v=>`${v.toFixed(2)}x`,lb:false},
                {label:"Orders",cur:kpis.orders,prev:kpis.prev?.orders,fmt:v=>String(Math.round(v)),lb:false},
                {label:"Impressions",cur:kpis.impressions,prev:kpis.prev?.impressions,fmt:v=>v>=1000?(v/1000).toFixed(0)+"K":String(Math.round(v)),lb:false},
                {label:"Clicks",cur:kpis.clicks,prev:kpis.prev?.clicks,fmt:v=>String(Math.round(v)),lb:false},
              ].map(m=>{
                const d=m.prev&&m.prev>0?((m.cur-m.prev)/m.prev*100):null;
                const ok=d===null?null:(m.lb?d<0:d>0);
                return(
                  <div key={m.label} style={{padding:"12px 14px",background:"#fafafa",borderRadius:9,border:"1px solid #f0f0f0"}}>
                    <div style={{fontSize:11,color:"#888",marginBottom:6}}>{m.label}</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#111",marginBottom:3}}>{m.fmt(m.cur)}</div>
                    {d!==null&&<span style={{fontSize:11,fontWeight:700,color:ok?"#1a7a3c":"#d42b2b"}}>{d>0?"+":""}{d.toFixed(1)}% vs prev</span>}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {activeSection==="acos_tacos"&&kpis&&(
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>ACoS / TACOS Analysis</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
              <div style={{padding:"16px 18px",background:kpis.acos<30?"rgba(26,122,60,0.05)":kpis.acos<50?"rgba(196,122,0,0.05)":"rgba(212,43,43,0.05)",borderRadius:11,border:`1px solid ${kpis.acos<30?"rgba(26,122,60,0.2)":kpis.acos<50?"rgba(196,122,0,0.2)":"rgba(212,43,43,0.2)"}`}}>
                <div style={{fontSize:11,color:"#888",marginBottom:6}}>ACoS (Advertising Cost of Sale)</div>
                <div style={{fontSize:32,fontWeight:900,color:kpis.acos<30?"#1a7a3c":kpis.acos<50?"#c47a00":"#d42b2b",marginBottom:4}}>{kpis.acos.toFixed(1)}%</div>
                {kpis.prev?.acos>0&&<div style={{fontSize:12,color:"#555"}}>Previous: {kpis.prev.acos.toFixed(1)}% <span style={{color:kpis.acos<kpis.prev.acos?"#1a7a3c":"#d42b2b",fontWeight:700}}>{kpis.acos<kpis.prev.acos?"▼":"+▲"} {Math.abs(kpis.acos-kpis.prev.acos).toFixed(1)}pp</span></div>}
                <div style={{fontSize:11,color:"#888",marginTop:6}}>{kpis.acos<25?"Excellent — well below target":"Kpi.acos"<40?"On target":"Above target — optimisation needed"}</div>
              </div>
              <div style={{padding:"16px 18px",background:"rgba(26,95,160,0.05)",borderRadius:11,border:"1px solid rgba(26,95,160,0.15)"}}>
                <div style={{fontSize:11,color:"#888",marginBottom:6}}>CVR (Conversion Rate)</div>
                <div style={{fontSize:32,fontWeight:900,color:kpis.cvr>=3?"#1a7a3c":kpis.cvr>=1.5?"#c47a00":"#d42b2b",marginBottom:4}}>{kpis.cvr.toFixed(1)}%</div>
                {kpis.prev?.cvr>0&&<div style={{fontSize:12,color:"#555"}}>Previous: {kpis.prev.cvr.toFixed(1)}% <span style={{color:kpis.cvr>kpis.prev.cvr?"#1a7a3c":"#d42b2b",fontWeight:700}}>{kpis.cvr>kpis.prev.cvr?"▲":"▼"} {Math.abs(kpis.cvr-kpis.prev.cvr).toFixed(1)}pp</span></div>}
              </div>
            </div>
          </div>
        )}

        {(activeSection==="actions_completed"||activeSection==="next_steps"||activeSection==="opportunities"||activeSection==="search_terms"||activeSection==="ranking"||activeSection==="visibility")&&(
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>{CR_SECTIONS.find(s=>s.key===activeSection)?.label}</div>
            <div style={{padding:"16px 18px",background:"#fafafa",borderRadius:10,border:"1px dashed #e0e0e0"}}>
              <div style={{fontSize:13,color:"#aaa",fontStyle:"italic",textAlign:"center",padding:"20px 0"}}>
                <i className="ti ti-edit" style={{fontSize:20,display:"block",marginBottom:8,color:"#ddd"}}/>
                Add your notes for this section in the Notes field, or use AI to generate content for this section.
              </div>
            </div>
          </div>
        )}

        {activeSection==="ai_insights"&&(
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>AI Strategic Insights</div>
            <div style={{fontSize:12,color:"#888",fontStyle:"italic"}}>AI insights will be generated in the AI Assistant tab after building the report.</div>
          </div>
        )}
      </div>
    </div>
  );
}

/* AI Reporting assistant */
function CRAIAssistant({kpis,selectedReport}){
  const[loading,setLoading]=useState(false);
  const[result,setResult]=useState(null);
  const apiKey=useGlobalAIKey();
  const[showKey,setShowKey]=useState(false);
  const[reportType,setReportType]=useState("weekly");

  async function generate(){
    const key=apiKey.trim();
    if(!key){alert("Please enter your Gemini API key.");return;}
    if(!kpis){alert("No KPI data available. Upload data in the Data Hub first.");return;}
    setLoading(true);setResult(null);

    const prompt=`You are a senior Amazon PPC account manager writing a professional ${reportType} client report. Based ONLY on the performance data below, generate a complete client-facing report. Write clearly, professionally, and without jargon. Focus on business impact.

PERFORMANCE DATA:
- Reporting Period: ${selectedReport?.period||"Current period"}
- Client / Account: ${selectedReport?.clientName||"Account"}
- Total Spend: $${kpis.spend.toFixed(0)}
- Total Sales: $${kpis.sales.toFixed(0)}
- Total Orders: ${Math.round(kpis.orders)}
- Overall ACoS: ${kpis.acos.toFixed(1)}%
- CVR: ${kpis.cvr.toFixed(1)}%
- CPC: $${kpis.cpc.toFixed(2)}
- ROAS: ${kpis.roas.toFixed(2)}x
${kpis.prev?`- Previous Spend: $${kpis.prev.spend.toFixed(0)}
- Previous Sales: $${kpis.prev.sales.toFixed(0)}
- Previous ACoS: ${kpis.prev.acos.toFixed(1)}%
- Sales change: ${((kpis.sales-kpis.prev.sales)/kpis.prev.sales*100).toFixed(0)}%
- ACoS change: ${(kpis.acos-kpis.prev.acos).toFixed(1)}pp`:"- No comparison period available"}
- Waste entities: ${kpis.wasteCount} ($${kpis.wasteSpend.toFixed(0)} waste spend)

Generate a professional client report with these sections. Respond in JSON ONLY (no markdown, no backticks):
{"executiveSummary":"...","performanceHighlights":[{"metric":"...","result":"...","context":"..."}],"keyActions":"...","opportunities":[{"opportunity":"...","impact":"..."}],"nextSteps":["...","...","..."]}`;

    try{
      const res=await geminiFetch(key,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({contents:[{parts:[{text:prompt}]}],generationConfig:{temperature:0.3,maxOutputTokens:1400}})
      });
      const data=await res.json();
      const text=data.candidates?.[0]?.content?.parts?.[0]?.text||"";
      const parsed=JSON.parse(text.replace(/```json|```/g,"").trim());
      setResult(parsed);
    }catch(e){setResult({error:"Generation failed. Check your API key."});}
    setLoading(false);
  }

  function exportToText(){
    if(!result) return;
    const lines=[
      `AMAZON PPC CLIENT REPORT`,
      `Generated: ${new Date().toLocaleString()}`,
      `Period: ${selectedReport?.period||"—"}`,
      `Client: ${selectedReport?.clientName||"—"}`,
      "",
      "EXECUTIVE SUMMARY",
      "─".repeat(60),
      result.executiveSummary,"",
      "PERFORMANCE HIGHLIGHTS",
      "─".repeat(60),
      ...(result.performanceHighlights||[]).map(h=>`• ${h.metric}: ${h.result}\n  ${h.context}`),
      "","KEY ACTIONS TAKEN",
      "─".repeat(60),
      result.keyActions,"",
      "OPPORTUNITIES IDENTIFIED",
      "─".repeat(60),
      ...(result.opportunities||[]).map(o=>`• ${o.opportunity}\n  Impact: ${o.impact}`),
      "","NEXT STEPS",
      "─".repeat(60),
      ...(result.nextSteps||[]).map((s,i)=>`${i+1}. ${s}`),
    ];
    const blob=new Blob([lines.join("\n")],{type:"text/plain"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");a.href=url;a.download=`report_${Date.now()}.txt`;a.click();
    URL.revokeObjectURL(url);
  }

  function exportToExcel(){
    if(!result||!kpis) return;
    const wb=XLSX.utils.book_new();
    const kpiRows=[
      {Metric:"Total Spend",Current:`$${kpis.spend.toFixed(0)}`,Previous:kpis.prev?`$${kpis.prev.spend.toFixed(0)}`:"—",Change:kpis.prev?`${((kpis.sales-kpis.prev.sales)/kpis.prev.sales*100).toFixed(0)}%`:"—"},
      {Metric:"Total Sales",Current:`$${kpis.sales.toFixed(0)}`,Previous:kpis.prev?`$${kpis.prev.sales.toFixed(0)}`:"—",Change:kpis.prev?`${((kpis.sales-kpis.prev.sales)/kpis.prev.sales*100).toFixed(0)}%`:"—"},
      {Metric:"Total Orders",Current:Math.round(kpis.orders),Previous:kpis.prev?Math.round(kpis.prev.orders):"—",Change:""},
      {Metric:"ACoS",Current:`${kpis.acos.toFixed(1)}%`,Previous:kpis.prev?`${kpis.prev.acos.toFixed(1)}%`:"—",Change:kpis.prev?`${(kpis.acos-kpis.prev.acos).toFixed(1)}pp`:"—"},
      {Metric:"CVR",Current:`${kpis.cvr.toFixed(1)}%`,Previous:kpis.prev?`${kpis.prev.cvr.toFixed(1)}%`:"—",Change:""},
      {Metric:"CPC",Current:`$${kpis.cpc.toFixed(2)}`,Previous:kpis.prev?`$${kpis.prev.cpc.toFixed(2)}`:"—",Change:""},
      {Metric:"ROAS",Current:`${kpis.roas.toFixed(2)}x`,Previous:kpis.prev?`${kpis.prev.roas.toFixed(2)}x`:"—",Change:""},
    ];
    const ws1=XLSX.utils.json_to_sheet(kpiRows);ws1["!cols"]=[{wch:20},{wch:15},{wch:15},{wch:12}];
    XLSX.utils.book_append_sheet(wb,ws1,"KPI Summary");

    const summaryRows=[{Section:"Executive Summary",Content:result.executiveSummary||""},{Section:"Key Actions",Content:result.keyActions||""},{Section:"Next Steps",Content:(result.nextSteps||[]).join("\n")}];
    const ws2=XLSX.utils.json_to_sheet(summaryRows);ws2["!cols"]=[{wch:20},{wch:80}];
    XLSX.utils.book_append_sheet(wb,ws2,"Report Content");

    if(result.opportunities?.length){
      const oppRows=(result.opportunities||[]).map(o=>({Opportunity:o.opportunity,Impact:o.impact}));
      const ws3=XLSX.utils.json_to_sheet(oppRows);ws3["!cols"]=[{wch:50},{wch:50}];
      XLSX.utils.book_append_sheet(wb,ws3,"Opportunities");
    }
    XLSX.writeFile(wb,`client_report_${selectedReport?.clientName?.replace(/\s+/g,"_")||"account"}_${Date.now()}.xlsx`);
  }

  return(
    <div style={{maxWidth:900,margin:"0 auto"}}>
      <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:4}}>AI Report Generator (Gemini)</div>
        <div style={{fontSize:11,color:"#888",marginBottom:12}}>AI writes professional client-facing report content from your actual performance data. Output is ready to send or copy.</div>
        <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
          <select value={reportType} onChange={e=>setReportType(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,cursor:"pointer",flexShrink:0}}>
            <option value="weekly">Weekly Report</option>
            <option value="monthly">Monthly Report</option>
            <option value="executive">Executive Summary</option>
            <option value="launch">Launch Report</option>
            <option value="recovery">Recovery Report</option>
          </select>
          <div style={{position:"relative",flex:1}}>
            {/* API key input removed - key configured globally in Settings */}
          </div>
          <button onClick={generate} disabled={loading} style={{...T.btnR(true),padding:"9px 18px",opacity:loading?0.6:1,flexShrink:0}}>
            {loading?<><i className="ti ti-loader ti-spin" style={{fontSize:13}}/>Generating...</>:<><i className="ti ti-pencil" style={{fontSize:13}}/>Generate Report</>}
          </button>
        </div>
        <div style={{fontSize:11,color:"#aaa"}}>Key stays in memory only. Get free key at aistudio.google.com/app/apikey</div>
      </div>

      {result?.error&&<div style={{padding:"12px 16px",background:"rgba(212,43,43,0.06)",borderRadius:9,border:"1px solid rgba(212,43,43,0.2)",fontSize:12,color:"#d42b2b",marginBottom:12}}>{result.error}</div>}

      {result&&!result.error&&(
        <div>
          <div style={{display:"flex",gap:8,marginBottom:14,justifyContent:"flex-end"}}>
            <button onClick={exportToText} style={{...T.btnR(true),fontSize:11,padding:"7px 14px"}}><i className="ti ti-file-text" style={{fontSize:12}}/>Export Text</button>
            <button onClick={exportToExcel} style={{...T.btnR(false),fontSize:11,padding:"7px 14px"}}><i className="ti ti-table" style={{fontSize:12}}/>Export Excel</button>
          </div>

          {/* Executive Summary */}
          <div style={{background:"#fff",borderRadius:12,border:"2px solid #4f46e5",padding:"20px 22px",marginBottom:12}}>
            <div style={{fontSize:11,fontWeight:700,color:"#4f46e5",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Executive Summary</div>
            <div style={{fontSize:14,color:"#222",lineHeight:1.8}}>{result.executiveSummary}</div>
          </div>

          {/* Performance highlights */}
          {result.performanceHighlights?.length>0&&(
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:12}}>
              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>Performance Highlights</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                {result.performanceHighlights.map((h,i)=>(
                  <div key={i} style={{background:"#fafafa",borderRadius:9,padding:"12px 14px",border:"1px solid #f0f0f0"}}>
                    <div style={{fontSize:11,color:"#888",marginBottom:4}}>{h.metric}</div>
                    <div style={{fontSize:15,fontWeight:800,color:"#111",marginBottom:4}}>{h.result}</div>
                    <div style={{fontSize:11,color:"#666",lineHeight:1.4}}>{h.context}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Key actions */}
          {result.keyActions&&(
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:12}}>
              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Key Actions Completed</div>
              <div style={{fontSize:13,color:"#333",lineHeight:1.7}}>{result.keyActions}</div>
            </div>
          )}

          {/* Opportunities */}
          {result.opportunities?.length>0&&(
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:12}}>
              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Opportunities Identified</div>
              <div style={{display:"flex",flexDirection:"column",gap:7}}>
                {result.opportunities.map((o,i)=>(
                  <div key={i} style={{display:"flex",gap:10,padding:"9px 12px",background:"rgba(26,122,60,0.04)",borderRadius:8,border:"1px solid rgba(26,122,60,0.15)"}}>
                    <i className="ti ti-rocket" style={{fontSize:12,color:"#1a7a3c",flexShrink:0,marginTop:2}}/>
                    <div><strong style={{fontSize:12,color:"#111"}}>{o.opportunity}</strong><div style={{fontSize:11,color:"#666",marginTop:2}}>Impact: {o.impact}</div></div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Next steps */}
          {result.nextSteps?.length>0&&(
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px"}}>
              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Next Steps</div>
              <div style={{display:"flex",flexDirection:"column",gap:7}}>
                {result.nextSteps.map((s,i)=>(
                  <div key={i} style={{display:"flex",gap:10,fontSize:13,color:"#333",lineHeight:1.6}}>
                    <span style={{fontWeight:700,color:"#4f46e5",flexShrink:0}}>{i+1}.</span>{s}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {!result&&!loading&&(
        <div style={{background:"#fafafa",borderRadius:12,border:"1px dashed #e0e0e0",padding:"28px",textAlign:"center"}}>
          <i className="ti ti-file-analytics" style={{fontSize:32,color:"#ddd",display:"block",marginBottom:10}}/>
          <div style={{fontSize:13,fontWeight:600,color:"#888",marginBottom:6}}>Ready to generate a professional client report</div>
          <div style={{fontSize:12,color:"#aaa"}}>Select report type, enter your Gemini key, and click Generate.<br/>AI writes the full report from your actual performance data.</div>
        </div>
      )}
    </div>
  );
}

/* ── Client Reporting Module Root ───────────────────────────── */

/* ── Client Reporting: Schedule & Deliver Panel ── */
const CR_SCHEDULE_KEY = 'rq_cr_schedules_v1';
function loadCRSchedules(){ try{ return JSON.parse(localStorage.getItem(CR_SCHEDULE_KEY)||'[]'); }catch{ return []; } }
function saveCRSchedules(s){ try{ localStorage.setItem(CR_SCHEDULE_KEY, JSON.stringify(s)); }catch{} }

function CRSchedulePanel({reports,globalData}){
  const[schedules,setSchedules] = useState(loadCRSchedules);
  const[form,setForm] = useState({clientName:'',email:'',frequency:'weekly',day:'Monday',reportId:'',branding:'Quarred',subject:'Your Weekly PPC Report',active:true});
  const[saved,setSaved] = useState(false);

  function addSchedule(){
    if(!form.email||!form.clientName){ alert('Enter client name and email'); return; }
    const s=[...schedules,{...form,id:Date.now(),createdAt:new Date().toISOString(),lastSent:null}];
    setSchedules(s); saveCRSchedules(s); setSaved(true); setTimeout(()=>setSaved(false),2000);
    setForm(p=>({...p,clientName:'',email:''}));
  }
  function toggleSchedule(id){ const s=schedules.map(x=>x.id===id?{...x,active:!x.active}:x); setSchedules(s); saveCRSchedules(s); }
  function deleteSchedule(id){ const s=schedules.filter(x=>x.id!==id); setSchedules(s); saveCRSchedules(s); }

  const inp = (field,type='text',placeholder='') => (
    <input type={type} value={form[field]} onChange={e=>setForm(p=>({...p,[field]:e.target.value}))} placeholder={placeholder}
      style={{width:'100%',padding:'8px 10px',borderRadius:7,border:'1.5px solid #e0e0e0',fontSize:13,outline:'none',boxSizing:'border-box'}}/>
  );

  return(
    <div style={{padding:'24px',maxWidth:900}}>
      {/* Info banner */}
      <div style={{background:'rgba(26,95,160,0.06)',border:'1px solid rgba(26,95,160,0.15)',borderRadius:10,padding:'12px 16px',marginBottom:20,display:'flex',gap:10}}>
        <i className="ti ti-info-circle" style={{fontSize:14,color:'#1a5fa0',flexShrink:0,marginTop:1}}/>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:'#1a5fa0'}}>Automated Report Delivery</div>
          <div style={{fontSize:11,color:'#888',lineHeight:1.5}}>Configure scheduled reports for your clients. Reports are queued and sent via your backend email service (requires server deployment with email configured in .env). White-label with your own branding.</div>
        </div>
      </div>

      {/* New schedule form */}
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px',marginBottom:20}}>
        <div style={{fontSize:13,fontWeight:800,color:'#111',marginBottom:14,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-plus" style={{color:'#1a5fa0'}}/> Add New Schedule
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Client Name *</label>{inp('clientName','text','e.g. Terra Elements')}</div>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Client Email *</label>{inp('email','email','client@company.com')}</div>
          <div>
            <label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Frequency</label>
            <select value={form.frequency} onChange={e=>setForm(p=>({...p,frequency:e.target.value}))} style={{width:'100%',padding:'8px 10px',borderRadius:7,border:'1.5px solid #e0e0e0',fontSize:13,outline:'none'}}>
              <option value="weekly">Weekly</option>
              <option value="biweekly">Bi-Weekly</option>
              <option value="monthly">Monthly</option>
            </select>
          </div>
          <div>
            <label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Send Day</label>
            <select value={form.day} onChange={e=>setForm(p=>({...p,day:e.target.value}))} style={{width:'100%',padding:'8px 10px',borderRadius:7,border:'1.5px solid #e0e0e0',fontSize:13,outline:'none'}}>
              {['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'].map(d=><option key={d}>{d}</option>)}
            </select>
          </div>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Report Branding</label>{inp('branding','text','Your Agency Name')}</div>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Email Subject</label>{inp('subject','text','Your Weekly PPC Report')}</div>
        </div>
        <button onClick={addSchedule} style={{padding:'9px 22px',borderRadius:8,border:'none',background:'#1a5fa0',color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:7}}>
          <i className="ti ti-calendar-plus" style={{fontSize:12}}/> Add Schedule
          {saved&&<span style={{fontSize:11,background:'rgba(255,255,255,0.2)',padding:'1px 6px',borderRadius:4}}>✓ Saved!</span>}
        </button>
      </div>

      {/* Existing schedules */}
      {schedules.length>0&&(
        <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',overflow:'hidden'}}>
          <div style={{padding:'14px 18px',borderBottom:'1px solid #f0f0f0',fontSize:13,fontWeight:800,color:'#111'}}>
            Active Schedules ({schedules.length})
          </div>
          {schedules.map((s,i)=>(
            <div key={s.id} style={{padding:'14px 18px',borderBottom:i<schedules.length-1?'1px solid #f5f5f5':'none',display:'flex',alignItems:'center',gap:12,background:s.active?'#fff':'#fafafa',opacity:s.active?1:0.6}}>
              <div style={{width:36,height:36,borderRadius:9,background:'rgba(26,95,160,0.08)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <i className="ti ti-mail" style={{fontSize:15,color:'#1a5fa0'}}/>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:700,color:'#111'}}>{s.clientName}</div>
                <div style={{fontSize:11,color:'#888'}}>{s.email} · {s.frequency} on {s.day}s · Brand: {s.branding}</div>
                {s.lastSent&&<div style={{fontSize:10,color:'#1a9e5f',marginTop:2}}>Last sent: {new Date(s.lastSent).toLocaleDateString()}</div>}
                {!s.lastSent&&<div style={{fontSize:10,color:'#aaa',marginTop:2}}>Never sent — requires backend deployment</div>}
              </div>
              <div style={{display:'flex',alignItems:'center',gap:6,flexShrink:0}}>
                <span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:s.active?'rgba(26,158,95,0.1)':'rgba(0,0,0,0.05)',color:s.active?'#1a9e5f':'#888',fontWeight:700}}>{s.active?'Active':'Paused'}</span>
                <button onClick={()=>toggleSchedule(s.id)} style={{padding:'5px 10px',borderRadius:7,border:'1px solid #e0e0e0',background:'#fff',cursor:'pointer',fontSize:11,color:'#555',fontWeight:600}}>{s.active?'Pause':'Resume'}</button>
                <button onClick={()=>deleteSchedule(s.id)} style={{padding:'5px 10px',borderRadius:7,border:'1px solid rgba(212,43,43,0.2)',background:'rgba(212,43,43,0.05)',cursor:'pointer',fontSize:11,color:'#d42b2b',fontWeight:600}}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {schedules.length===0&&(
        <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'30px',textAlign:'center',color:'#aaa'}}>
          <i className="ti ti-send" style={{fontSize:36,display:'block',marginBottom:8,color:'#ddd'}}/>
          <div style={{fontSize:13,fontWeight:600,color:'#555'}}>No schedules yet — add your first client above</div>
        </div>
      )}
    </div>
  );
}

function ClientReportingModule({globalData,setTab}){
  const[activeTab,setActiveTab]=useState("dashboard");
  const[reports,setReportsRaw]=useState(crLoadReports);
  const[buildingTemplate,setBuildingTemplate]=useState(null);
  const[selectedReport,setSelectedReport]=useState(null);

  const rows=globalData?.cur?.campaign?.rows||globalData?.cur?.primary?.rows||[];
  const cm=globalData?.cur?.campaign?.cm||globalData?.cur?.primary?.cm||{};
  const compRows=globalData?.comp?.campaign?.rows||globalData?.comp?.primary?.rows||[];
  const compCm=globalData?.comp?.campaign?.cm||globalData?.comp?.primary?.cm||{};
  const hasData=rows.length>0;

  const kpis=useMemo(()=>hasData?crComputeKPIs(rows,cm,compRows,compCm):null,[rows,cm,hasData]);

  function setReports(r){setReportsRaw(r);crSaveReports(r);}

  function saveReport(report){
    const updated=[...reports,report];
    setReports(updated);setSelectedReport(report);
    setBuildingTemplate(null);setActiveTab("ai");
  }

  function startNew(templateId){
    setBuildingTemplate(templateId);setActiveTab("builder");
  }

  const tabs=[
    {key:"dashboard",label:"Dashboard",    icon:"ti-layout-dashboard"},
    {key:"builder",  label:"Report Builder",icon:"ti-pencil"},
    {key:"kpis",     label:"KPI Engine",   icon:"ti-chart-bar",badge:hasData?null:null},
    {key:"ai",       label:"AI Generator", icon:"ti-brain"},
    {key:"templates",label:"Templates",    icon:"ti-template",badge:CR_TEMPLATES.length},
    {key:"schedule", label:"Schedule & Deliver", icon:"ti-send",badge:"NEW"},
  ];

  if(!hasData) return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-file-analytics" style={{fontSize:15,color:"#1a5fa0"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Client Reporting</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,95,160,0.1)",color:"#1a5fa0",fontWeight:700}}>Core</span>
      </div>
      <CREmptyState onGoToHub={()=>setTab("hub")}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-file-analytics" style={{fontSize:15,color:"#1a5fa0"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Client Reporting</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,95,160,0.1)",color:"#1a5fa0",fontWeight:700}}>Core</span>
        <div style={{flex:1}}/>
        <button onClick={()=>{setBuildingTemplate("custom");setActiveTab("builder");}} style={{...T.btnR(false),fontSize:12,padding:"7px 16px"}}>
          <i className="ti ti-plus" style={{fontSize:12}}/>New Report
        </button>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0,overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#1a5fa0":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#1a5fa0":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>
            {t.label}
            {t.badge!=null&&t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#1a5fa0":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"20px",background:"#f7f7f7"}}>
        {activeTab==="dashboard"&&<CRDashboard reports={reports} onNewReport={startNew} kpis={kpis}/>}
        {activeTab==="builder"&&buildingTemplate&&(
          <CRBuilder templateId={buildingTemplate} kpis={kpis} globalData={globalData} onSave={saveReport} onCancel={()=>{setBuildingTemplate(null);setActiveTab("dashboard");}}/>
        )}
        {activeTab==="builder"&&!buildingTemplate&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <div style={{fontSize:13,color:"#888",marginBottom:14}}>Select a template to start building a report, or create a custom one.</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10}}>
              {CR_TEMPLATES.map(t=>(
                <button key={t.id} onClick={()=>setBuildingTemplate(t.id)} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"16px",cursor:"pointer",textAlign:"left",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
                  <i className={`ti ${t.icon}`} style={{fontSize:20,color:t.color,display:"block",marginBottom:10}}/>
                  <div style={{fontSize:12,fontWeight:700,color:"#111",marginBottom:4}}>{t.name}</div>
                  <div style={{fontSize:10,color:"#888",lineHeight:1.4}}>{t.desc.split(".")[0]}.</div>
                </button>
              ))}
            </div>
          </div>
        )}
        {activeTab==="kpis"&&kpis&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:14}}>
              <CRKPICard label="Total Spend"   value={kpis.spend}   prev={kpis.prev?.spend}   fmt={v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`} lowerBetter icon="ti-cash"          color="#4f46e5"/>
              <CRKPICard label="Total Sales"   value={kpis.sales}   prev={kpis.prev?.sales}   fmt={v=>`$${v>=1000?(v/1000).toFixed(1)+"K":v.toFixed(0)}`} icon="ti-coin"          color="#1a7a3c"/>
              <CRKPICard label="Total Orders"  value={kpis.orders}  prev={kpis.prev?.orders}  fmt={v=>String(Math.round(v))} icon="ti-shopping-cart"  color="#1a5fa0"/>
              <CRKPICard label="ACoS"          value={kpis.acos}    prev={kpis.prev?.acos}    fmt={v=>`${v.toFixed(1)}%`} lowerBetter icon="ti-percentage"    color="#c47a00"/>
              <CRKPICard label="ROAS"          value={kpis.roas}    prev={kpis.prev?.roas}    fmt={v=>`${v.toFixed(2)}x`} icon="ti-trending-up"    color="#1a7a3c"/>
              <CRKPICard label="CVR"           value={kpis.cvr}     prev={kpis.prev?.cvr}     fmt={v=>`${v.toFixed(1)}%`} icon="ti-percentage"     color="#6338c8"/>
              <CRKPICard label="CPC"           value={kpis.cpc}     prev={kpis.prev?.cpc}     fmt={v=>`$${v.toFixed(2)}`} lowerBetter icon="ti-click"         color="#555"/>
              <CRKPICard label="CTR"           value={kpis.ctr}     prev={kpis.prev?.ctr}     fmt={v=>`${v.toFixed(2)}%`} icon="ti-eye"            color="#2a6496"/>
              <CRKPICard label="Impressions"   value={kpis.impressions} prev={kpis.prev?.impressions} fmt={v=>v>=1000?(v/1000).toFixed(0)+"K":String(Math.round(v))} icon="ti-eye" color="#888"/>
              <CRKPICard label="Clicks"        value={kpis.clicks}  prev={kpis.prev?.clicks}  fmt={v=>String(Math.round(v))} icon="ti-mouse"         color="#888"/>
              <CRKPICard label="Waste Spend"   value={kpis.wasteSpend} prev={null} fmt={v=>`$${v.toFixed(0)}`} lowerBetter icon="ti-droplet-off"   color="#d42b2b"/>
              <CRKPICard label="Waste Entities" value={kpis.wasteCount} prev={null} fmt={v=>String(v)} lowerBetter icon="ti-alert-triangle" color="#d42b2b"/>
            </div>
          </div>
        )}
        {activeTab==="ai"&&<CRAIAssistant kpis={kpis} selectedReport={selectedReport}/>}
        {activeTab==="schedule"&&<CRSchedulePanel reports={reports} globalData={globalData}/>}
        {activeTab==="templates"&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10}}>
              {CR_TEMPLATES.map(t=>(
                <div key={t.id} style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                    <div style={{width:32,height:32,borderRadius:8,background:`${t.color}14`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <i className={`ti ${t.icon}`} style={{fontSize:14,color:t.color}}/>
                    </div>
                    <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{t.name}</span>
                  </div>
                  <div style={{fontSize:12,color:"#666",lineHeight:1.5,marginBottom:8}}>{t.desc}</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:10}}>
                    {t.sections.map(s=>{const sec=CR_SECTIONS.find(sc=>sc.key===s);return sec?(
                      <span key={s} style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:"rgba(0,0,0,0.05)",color:"#555"}}>{sec.label}</span>
                    ):null;})}
                  </div>
                  <button onClick={()=>startNew(t.id)} style={{...T.btnR(true),fontSize:11,padding:"6px 14px"}}>
                    <i className="ti ti-pencil" style={{fontSize:11}}/>Use Template
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   BRAND TABLE MODULE
   Product catalog — ASINs, COGs, fees, breakeven calculations.
   Data pulled from Data Hub (ASIN/Business reports).
   Strategist adds: Portfolio ID/Name, Product Code, COGs, notes.
   Brand Table feeds directly into Bulk Builder.
================================================================ */

const BT_LS = "quarred_brand_table_v1";
function btLoad(){try{const s=localStorage.getItem(BT_LS);return s?JSON.parse(s):{products:[],portfolios:[]};}catch{return{products:[],portfolios:[]};}}
function btSave(d){try{localStorage.setItem(BT_LS,JSON.stringify(d));}catch{}}

/* Generate product code suggestion from product name */
function btSuggestCode(brandName, productName){
  if(!productName) return "";
  // Take first letters of significant words
  const stopWords=new Set(["of","the","and","for","with","in","a","an","oz","pack","set","case","count","size"]);
  const brandCode=(brandName||"").split(/\s+/).map(w=>w[0]||"").join("").toUpperCase().slice(0,2);
  const words=productName.split(/[\s\-–,\/]+/).filter(w=>w.length>1&&!stopWords.has(w.toLowerCase()));
  let code="";
  // Try to build meaningful abbreviation
  if(words.length>=2){
    code=words.slice(0,3).map(w=>w.slice(0,2).toUpperCase()).join("");
  } else {
    code=words[0]?.slice(0,4).toUpperCase()||"PROD";
  }
  // Extract size/variant hints
  const sizeMatch=productName.match(/(\d+\.?\d*)\s*(oz|lb|fl|g|ml|pack|pk|ct)/i);
  const sizeCode=sizeMatch?sizeMatch[1]+(sizeMatch[2].slice(0,2).toUpperCase()):"";
  return `${brandCode}-${code}${sizeCode?"-"+sizeCode:""}`;
}

/* Breakeven calculations */
function btCalcBreakeven(p){
  const price=parseFloat(p.price)||0;
  const cogs=parseFloat(p.cogs)||0;
  const fbaFee=parseFloat(p.fbaFee)||0;
  const refFee=parseFloat(p.refFeeFixed)||0||(price*(parseFloat(p.refFeePct)||15)/100);
  const totalCost=cogs+fbaFee+refFee;
  const margin=price-totalCost;
  const breakevenAcos=price>0?(margin/price)*100:0;
  const targetAcos=Math.max(0,breakevenAcos-5); // 5pp buffer
  const maxCpa=margin>0?margin:0; // max cost per acquisition
  const maxSpendPerUnit=margin;
  // Breakeven TACOS (includes organic — assume 50/50 split as default)
  const breakevenTacos=price>0?(margin/price)*100*0.6:0; // more conservative
  // CVR needed at various CPCs to break even
  const cpc=parseFloat(p.avgCpc)||0.5;
  const breakevenCvr=cpc>0&&margin>0?(cpc/margin)*100:0;

  return{
    price, cogs, fbaFee, refFee,
    totalCost: parseFloat(totalCost.toFixed(2)),
    margin: parseFloat(margin.toFixed(2)),
    marginPct: price>0?parseFloat(((margin/price)*100).toFixed(1)):0,
    breakevenAcos: parseFloat(breakevenAcos.toFixed(1)),
    targetAcos: parseFloat(targetAcos.toFixed(1)),
    breakevenTacos: parseFloat(breakevenTacos.toFixed(1)),
    maxCpa: parseFloat(maxCpa.toFixed(2)),
    breakevenCvr: parseFloat(breakevenCvr.toFixed(2)),
    maxSpendPerUnit: parseFloat(maxSpendPerUnit.toFixed(2)),
  };
}

/* ── Sub-components ─────────────────────────────────────────── */
function BTEmptyState({onGoToHub, onAddManual}){
  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:40,textAlign:"center"}}>
      <div style={{width:60,height:60,borderRadius:16,background:"rgba(26,122,60,0.08)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <i className="ti ti-table-heart" style={{fontSize:28,color:"#1a7a3c"}}/>
      </div>
      <div style={{fontSize:18,fontWeight:800,color:"#111",marginBottom:8}}>Brand Table</div>
      <div style={{fontSize:13,color:"#666",maxWidth:420,lineHeight:1.7,marginBottom:24}}>
        Your product catalog with ASIN data, COG calculations, and breakeven analytics. Build this first — Bulk Builder reads directly from Brand Table for Portfolio IDs and product codes.
      </div>
      <div style={{display:"flex",gap:10}}>
        <button onClick={onGoToHub} style={{...T.btnR(false),padding:"10px 22px"}}><i className="ti ti-database-import" style={{fontSize:13}}/>Import from Data Hub</button>
        <button onClick={onAddManual} style={{padding:"10px 22px",borderRadius:9,border:"1.5px solid #1a7a3c",background:"rgba(26,122,60,0.06)",color:"#1a7a3c",cursor:"pointer",fontWeight:700,fontSize:13,display:"flex",alignItems:"center",gap:6}}><i className="ti ti-plus" style={{fontSize:13}}/>Add Product Manually</button>
      </div>
    </div>
  );
}

/* Portfolio manager panel */
function BTPortfolioPanel({portfolios, onChange}){
  const[name,setName]=useState("");
  const[pid,setPid]=useState("");

  function add(){
    if(!name.trim()||!pid.trim()){alert("Enter both Portfolio Name and Portfolio ID.");return;}
    onChange([...portfolios,{id:Date.now(),name:name.trim(),portfolioId:pid.trim()}]);
    setName("");setPid("");
  }

  return(
    <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px",marginBottom:14}}>
      <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Portfolio Management</div>
      <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"flex-end"}}>
        <div style={{flex:1}}>
          <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:4}}>Portfolio Name</label>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. El Yucateco Hot Sauces" style={{padding:"7px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
        </div>
        <div style={{flex:1}}>
          <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:4}}>Portfolio ID (from Amazon)</label>
          <input value={pid} onChange={e=>setPid(e.target.value)} placeholder="e.g. 157001817011792" style={{padding:"7px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
        </div>
        <button onClick={add} style={{...T.btnR(true),padding:"7px 16px",fontSize:12,flexShrink:0}}><i className="ti ti-plus" style={{fontSize:12}}/>Add</button>
      </div>
      {portfolios.length>0&&(
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {portfolios.map((p,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:6,padding:"4px 10px",borderRadius:6,background:"rgba(26,95,160,0.07)",border:"1px solid rgba(26,95,160,0.2)"}}>
              <i className="ti ti-folder" style={{fontSize:11,color:"#1a5fa0"}}/>
              <span style={{fontSize:11,fontWeight:600,color:"#1a5fa0"}}>{p.name}</span>
              <span style={{fontSize:10,color:"#888"}}>({p.portfolioId})</span>
              <button onClick={()=>onChange(portfolios.filter((_,j)=>j!==i))} style={{border:"none",background:"transparent",cursor:"pointer",color:"#ccc",fontSize:11,padding:"0 2px",lineHeight:1}}><i className="ti ti-x"/></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* Product Code suggestion UI */
function BTCodeSuggest({brandName, productName, value, onChange}){
  const suggestion = btSuggestCode(brandName, productName);
  const [showSug, setShowSug] = useState(false);
  return(
    <div style={{position:"relative"}}>
      <div style={{display:"flex",gap:4}}>
        <input value={value} onChange={e=>onChange(e.target.value)} placeholder={suggestion||"e.g. RHHS-HG"} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,flex:1,outline:"none",minWidth:0}}/>
        {suggestion&&suggestion!==value&&(
          <button onClick={()=>onChange(suggestion)} title={`Use suggestion: ${suggestion}`} style={{padding:"5px 9px",borderRadius:6,border:"1px solid rgba(26,95,160,0.3)",background:"rgba(26,95,160,0.07)",cursor:"pointer",fontSize:10,color:"#1a5fa0",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>
            💡 {suggestion}
          </button>
        )}
      </div>
    </div>
  );
}

/* Breakeven display card */
function BTBreakevenCard({calc}){
  if(!calc||!calc.price) return(
    <div style={{padding:"12px",background:"#fafafa",borderRadius:9,border:"1px dashed #e0e0e0",textAlign:"center",fontSize:11,color:"#bbb"}}>Enter Price + COGs to see breakeven</div>
  );
  const items=[
    {label:"Margin / Unit",   val:`$${calc.margin.toFixed(2)}`,   color:calc.margin>0?"#1a7a3c":"#d42b2b",  icon:"ti-coin"},
    {label:"Margin %",        val:`${calc.marginPct}%`,           color:calc.margin>0?"#1a7a3c":"#d42b2b",  icon:"ti-percentage"},
    {label:"Breakeven ACoS",  val:`${calc.breakevenAcos}%`,       color:"#4f46e5",                           icon:"ti-target"},
    {label:"Target ACoS",     val:`${calc.targetAcos}%`,          color:"#1a5fa0",                           icon:"ti-crosshair"},
    {label:"Breakeven TACOS", val:`${calc.breakevenTacos}%`,      color:"#6338c8",                           icon:"ti-chart-line"},
    {label:"Max CPA",         val:`$${calc.maxCpa.toFixed(2)}`,   color:"#c47a00",                           icon:"ti-user-dollar"},
    {label:"Breakeven CVR",   val:`${calc.breakevenCvr.toFixed(2)}%`,color:"#555",                          icon:"ti-percentage"},
    {label:"Total Cost/Unit", val:`$${calc.totalCost.toFixed(2)}`,color:"#888",                              icon:"ti-calculator"},
  ];
  return(
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5}}>
      {items.map(item=>(
        <div key={item.label} style={{padding:"7px 10px",background:"#fafafa",borderRadius:7,border:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:7}}>
          <i className={`ti ${item.icon}`} style={{fontSize:11,color:item.color,flexShrink:0}}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:9,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.3px",marginBottom:1}}>{item.label}</div>
            <div style={{fontSize:13,fontWeight:800,color:item.color,whiteSpace:"nowrap"}}>{item.val}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

/* Add / Edit product modal */
function BTProductModal({product, portfolios, onSave, onClose}){
  const isEdit = !!product?.id;
  const[form,setForm]=useState(product||{
    brandName:"",productName:"",parentAsin:"",childAsin:"",
    productCode:"",sku:"",sku2:"",sku3:"",sku4:"",
    price:"",cogs:"",fbaFee:"",refFeePct:"15",refFeeFixed:"",
    avgCpc:"0.50",
    portfolioId:"",portfolioName:"",
    notes:"",status:"Active",
  });
  const upd=(k,v)=>setForm(p=>({...p,[k]:v}));
  const calc=btCalcBreakeven(form);

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:900,maxHeight:"90vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
        <div style={{padding:"16px 20px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
          <i className="ti ti-table-heart" style={{fontSize:15,color:"#1a7a3c"}}/>
          <span style={{fontSize:15,fontWeight:800,color:"#111"}}>{isEdit?"Edit Product":"Add Product"}</span>
          <button onClick={onClose} style={{marginLeft:"auto",border:"none",background:"transparent",cursor:"pointer",fontSize:18,color:"#aaa"}}><i className="ti ti-x"/></button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"18px 20px"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
            {/* Left column */}
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10,paddingBottom:5,borderBottom:"1px solid #f5f5f5"}}>Product Info</div>
              {[
                {k:"brandName",    label:"Brand Name",     ph:"El Yucateco"},
                {k:"productName",  label:"Product Name",   ph:"Red Habanero Hot Sauce - Half Gallon"},
                {k:"parentAsin",   label:"Parent ASIN",    ph:"B00ABC123"},
                {k:"childAsin",    label:"Child ASIN",     ph:"B00XYZ456"},
                {k:"sku",          label:"SKU (Primary)",  ph:"75"},
                {k:"sku2",         label:"SKU 2",          ph:""},
                {k:"sku3",         label:"SKU 3",          ph:""},
                {k:"sku4",         label:"SKU 4",          ph:""},
              ].map(f=>(
                <div key={f.k} style={{marginBottom:9}}>
                  <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:3}}>{f.label}</label>
                  <input value={form[f.k]||""} onChange={e=>upd(f.k,e.target.value)} placeholder={f.ph} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
                </div>
              ))}

              <div style={{marginBottom:9}}>
                <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:3}}>Product Code</label>
                <BTCodeSuggest brandName={form.brandName} productName={form.productName} value={form.productCode||""} onChange={v=>upd("productCode",v)}/>
                <div style={{fontSize:10,color:"#aaa",marginTop:3}}>Used in campaign naming. Click 💡 to use AI suggestion.</div>
              </div>

              <div style={{marginBottom:9}}>
                <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:3}}>Status</label>
                <select value={form.status||"Active"} onChange={e=>upd("status",e.target.value)} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",cursor:"pointer"}}>
                  {["Active","Paused","Out of Stock","Discontinued","Pending Launch"].map(s=><option key={s}>{s}</option>)}
                </select>
              </div>

              <div style={{marginBottom:9}}>
                <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:3}}>Notes</label>
                <textarea value={form.notes||""} onChange={e=>upd("notes",e.target.value)} placeholder="Any product notes..." rows={2} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none",resize:"vertical"}}/>
              </div>
            </div>

            {/* Right column */}
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10,paddingBottom:5,borderBottom:"1px solid #f5f5f5"}}>Portfolio Assignment</div>
              <div style={{marginBottom:9}}>
                <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:3}}>Assign to Portfolio</label>
                <select value={form.portfolioId||""} onChange={e=>{
                  const p=portfolios.find(p=>p.portfolioId===e.target.value);
                  upd("portfolioId",e.target.value);
                  if(p)upd("portfolioName",p.name);
                }} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",cursor:"pointer"}}>
                  <option value="">— No Portfolio —</option>
                  {portfolios.map(p=><option key={p.portfolioId} value={p.portfolioId}>{p.name} ({p.portfolioId})</option>)}
                </select>
                {form.portfolioId&&<div style={{fontSize:10,color:"#1a5fa0",marginTop:3}}>ID: {form.portfolioId}</div>}
              </div>

              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10,marginTop:16,paddingBottom:5,borderBottom:"1px solid #f5f5f5"}}>Financials</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:9}}>
                {[
                  {k:"price",      label:"Selling Price ($)",   ph:"24.99"},
                  {k:"cogs",       label:"Landed COGs ($)",     ph:"8.00"},
                  {k:"fbaFee",     label:"FBA Fee ($)",         ph:"4.50"},
                  {k:"refFeePct",  label:"Referral Fee (%)",    ph:"15"},
                  {k:"avgCpc",     label:"Avg CPC ($)",         ph:"0.50"},
                ].map(f=>(
                  <div key={f.k}>
                    <label style={{fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.4px",display:"block",marginBottom:3}}>{f.label}</label>
                    <input type="number" step="0.01" value={form[f.k]||""} onChange={e=>upd(f.k,e.target.value)} placeholder={f.ph} style={{padding:"6px 10px",borderRadius:7,border:"1.5px solid #e0e0e0",fontSize:12,width:"100%",boxSizing:"border-box",outline:"none"}}/>
                  </div>
                ))}
              </div>

              <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10,marginTop:16,paddingBottom:5,borderBottom:"1px solid #f5f5f5"}}>Breakeven Summary</div>
              <BTBreakevenCard calc={calc}/>
            </div>
          </div>
        </div>
        <div style={{padding:"12px 20px",borderTop:"1px solid #f0f0f0",display:"flex",gap:8,justifyContent:"flex-end",flexShrink:0}}>
          <button onClick={onClose} style={{padding:"8px 18px",borderRadius:8,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:13,color:"#555",fontWeight:600}}>Cancel</button>
          <button onClick={()=>onSave({...form,id:form.id||Date.now(),calc})} style={{...T.btnR(true),padding:"8px 22px",fontSize:13}}>
            <i className="ti ti-check" style={{fontSize:13}}/>{isEdit?"Save Changes":"Add Product"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* Product row in table */
function BTProductRow({product, portfolios, onEdit, onDelete}){
  const c=product.calc||btCalcBreakeven(product);
  const statusColor={"Active":"#1a7a3c","Paused":"#c47a00","Out of Stock":"#d42b2b","Discontinued":"#888","Pending Launch":"#6338c8"}[product.status]||"#555";
  return(
    <tr style={{borderBottom:"1px solid #f5f5f5"}}>
      <td style={{padding:"9px 10px",maxWidth:40,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
        <span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:`${statusColor}12`,color:statusColor,fontWeight:700}}>{product.status||"Active"}</span>
      </td>
      <td style={{padding:"9px 10px",fontWeight:700,color:R,fontSize:12,whiteSpace:"nowrap"}}>{product.productCode||"—"}</td>
      <td style={{padding:"9px 10px",fontSize:11,color:"#888"}}>{product.brandName||"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,color:"#111",maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={product.productName}>{product.productName||"—"}</td>
      <td style={{padding:"9px 10px",fontSize:11,color:"#555",fontFamily:"monospace"}}>{product.parentAsin||"—"}</td>
      <td style={{padding:"9px 10px",fontSize:11,color:"#555",fontFamily:"monospace"}}>{product.childAsin||"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,fontWeight:600,color:"#111"}}>{product.price?`$${parseFloat(product.price).toFixed(2)}`:"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,color:"#555"}}>{product.cogs?`$${parseFloat(product.cogs).toFixed(2)}`:"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,fontWeight:700,color:c.margin>0?"#1a7a3c":"#d42b2b"}}>{c.price?`$${c.margin.toFixed(2)}`:"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,fontWeight:700,color:"#4f46e5"}}>{c.price?`${c.breakevenAcos}%`:"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,fontWeight:700,color:"#1a5fa0"}}>{c.price?`${c.targetAcos}%`:"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,color:"#6338c8",fontWeight:700}}>{c.price?`${c.breakevenTacos}%`:"—"}</td>
      <td style={{padding:"9px 10px",fontSize:12,color:"#c47a00"}}>{c.price?`$${c.maxCpa.toFixed(2)}`:"—"}</td>
      <td style={{padding:"9px 10px",fontSize:11,color:"#888"}}>{product.portfolioName||"—"}</td>
      <td style={{padding:"9px 10px"}}>
        <div style={{display:"flex",gap:4}}>
          <button onClick={()=>onEdit(product)} style={{padding:"3px 8px",borderRadius:5,border:"1px solid #e0e0e0",background:"#fff",cursor:"pointer",fontSize:11,color:"#555"}}><i className="ti ti-edit" style={{fontSize:10}}/></button>
          <button onClick={()=>onDelete(product.id)} style={{padding:"3px 8px",borderRadius:5,border:"1px solid rgba(212,43,43,0.2)",background:"rgba(212,43,43,0.04)",cursor:"pointer",fontSize:11,color:"#d42b2b"}}><i className="ti ti-trash" style={{fontSize:10}}/></button>
        </div>
      </td>
    </tr>
  );
}

/* Export brand table */
function btExport(products){
  if(!products.length){alert("No products to export.");return;}
  const rows=products.map(p=>{
    const c=btCalcBreakeven(p);
    return{
      "Product Code":p.productCode||"","Brand":p.brandName||"","Product Name":p.productName||"",
      "Status":p.status||"Active","Parent ASIN":p.parentAsin||"","Child ASIN":p.childAsin||"",
      "SKU":p.sku||"","SKU2":p.sku2||"","SKU3":p.sku3||"","SKU4":p.sku4||"",
      "Price ($)":p.price||"","COGs ($)":p.cogs||"","FBA Fee ($)":p.fbaFee||"",
      "Referral Fee (%)":p.refFeePct||"15","Total Cost/Unit ($)":c.totalCost||"",
      "Margin/Unit ($)":c.margin||"","Margin %":c.marginPct||"",
      "Breakeven ACoS (%)":c.breakevenAcos||"","Target ACoS (%)":c.targetAcos||"",
      "Breakeven TACOS (%)":c.breakevenTacos||"","Max CPA ($)":c.maxCpa||"",
      "Breakeven CVR (%)":c.breakevenCvr||"","Portfolio ID":p.portfolioId||"",
      "Portfolio Name":p.portfolioName||"","Notes":p.notes||""
    };
  });
  const ws=XLSX.utils.json_to_sheet(rows);
  ws["!cols"]=Object.keys(rows[0]).map(()=>({wch:18}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,"Brand Table");
  XLSX.writeFile(wb,`Brand_Table_${new Date().toISOString().slice(0,10)}.xlsx`);
}

/* ── Brand Table Module Root ────────────────────────────────── */
function BrandTableModule({globalData, setTab}){
  const[data,setDataRaw]=useState(btLoad);
  const[showModal,setShowModal]=useState(false);
  const[editProduct,setEditProduct]=useState(null);
  const[activeTab,setActiveTab]=useState("table");
  const[search,setSearch]=useState("");
  const[filterStatus,setFilterStatus]=useState("All");

  function setData(d){setDataRaw(d);btSave(d);}

  function saveProduct(p){
    const existing=data.products.find(x=>x.id===p.id);
    const products=existing?data.products.map(x=>x.id===p.id?p:x):[...data.products,p];
    setData({...data,products});
    setShowModal(false);setEditProduct(null);
  }
  function deleteProduct(id){
    if(!window.confirm("Delete this product?"))return;
    setData({...data,products:data.products.filter(p=>p.id!==id)});
  }
  function openEdit(p){setEditProduct(p);setShowModal(true);}

  /* Import from Data Hub ASIN report */
  function importFromHub(){
    const rows=globalData?.cur?.asin?.rows||globalData?.cur?.business?.rows||[];
    const cm=globalData?.cur?.asin?.cm||globalData?.cur?.business?.cm||{};
    if(!rows.length){alert("No ASIN or Business Report found in Data Hub. Upload an Advertised Product Report or Business Report first.");return;}
    let added=0;
    const newProds=[...data.products];
    rows.forEach(row=>{
      const asin=row[cm.asin]||row["ASIN"]||row["Child ASIN"]||"";
      const name=row[cm.productName]||row["Advertised product name"]||row["Title"]||row["Product Name"]||"";
      const price=row["Price"]||row[cm.price]||"";
      if(!asin) return;
      // Don't duplicate
      if(newProds.find(p=>p.childAsin===asin||p.parentAsin===asin)) return;
      const suggested=btSuggestCode(row["Brand"]||"",name);
      newProds.push({id:Date.now()+added,brandName:row["Brand"]||"",productName:name,parentAsin:"",childAsin:asin,productCode:suggested,sku:"",price:price,cogs:"",fbaFee:"",refFeePct:"15",portfolioId:"",portfolioName:"",status:"Active",notes:""});
      added++;
    });
    if(!added){alert("No new ASINs found — all already in Brand Table.");return;}
    setData({...data,products:newProds});
    alert(`Imported ${added} products from Data Hub.`);
  }

  const filtered=data.products.filter(p=>{
    if(filterStatus!=="All"&&p.status!==filterStatus) return false;
    if(search&&!`${p.productName}${p.productCode}${p.brandName}${p.parentAsin}${p.childAsin}`.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const tabs=[
    {key:"table",      label:"Product Table",     icon:"ti-table"},
    {key:"portfolios", label:"Portfolios",         icon:"ti-folder",badge:data.portfolios.length||null},
    {key:"analytics",  label:"Analytics",          icon:"ti-chart-bar"},
  ];

  if(!data.products.length&&activeTab==="table") return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-table-heart" style={{fontSize:15,color:"#1a7a3c"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Brand Table</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,122,60,0.1)",color:"#1a7a3c",fontWeight:700}}>Core</span>
      </div>
      <BTEmptyState onGoToHub={()=>setTab("hub")} onAddManual={()=>{setEditProduct(null);setShowModal(true);}}/>
      {showModal&&<BTProductModal product={null} portfolios={data.portfolios} onSave={saveProduct} onClose={()=>setShowModal(false)}/>}
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {showModal&&<BTProductModal product={editProduct} portfolios={data.portfolios} onSave={saveProduct} onClose={()=>{setShowModal(false);setEditProduct(null);}}/>}

      <div style={{padding:"12px 20px",borderBottom:"1px solid #f0f0f0",flexShrink:0,background:"#fff",display:"flex",alignItems:"center",gap:12}}>
        <i className="ti ti-table-heart" style={{fontSize:15,color:"#1a7a3c"}}/>
        <span style={{fontSize:15,fontWeight:700,color:"#111"}}>Brand Table</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"rgba(26,122,60,0.1)",color:"#1a7a3c",fontWeight:700}}>Core</span>
        <span style={{fontSize:11,color:"#aaa"}}>{data.products.length} products</span>
        <div style={{flex:1}}/>
        <button onClick={importFromHub} style={{padding:"7px 14px",borderRadius:8,border:"1px solid rgba(26,95,160,0.3)",background:"rgba(26,95,160,0.06)",cursor:"pointer",fontSize:11,color:"#1a5fa0",fontWeight:600,display:"flex",alignItems:"center",gap:5}}>
          <i className="ti ti-database-import" style={{fontSize:11}}/>Import from Hub
        </button>
        <button onClick={()=>btExport(data.products)} style={{padding:"7px 14px",borderRadius:8,border:"1px solid rgba(26,122,60,0.3)",background:"rgba(26,122,60,0.06)",cursor:"pointer",fontSize:11,color:"#1a7a3c",fontWeight:600,display:"flex",alignItems:"center",gap:5}}>
          <i className="ti ti-download" style={{fontSize:11}}/>Export
        </button>
        <button onClick={()=>{setEditProduct(null);setShowModal(true);}} style={{...T.btnR(true),fontSize:12,padding:"7px 16px"}}>
          <i className="ti ti-plus" style={{fontSize:12}}/>Add Product
        </button>
      </div>

      <div style={{display:"flex",gap:2,padding:"0 20px",borderBottom:"1px solid #f0f0f0",background:"#fff",flexShrink:0}}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setActiveTab(t.key)} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 14px",border:"none",borderBottom:`2px solid ${activeTab===t.key?"#1a7a3c":"transparent"}`,background:"transparent",cursor:"pointer",fontSize:12,fontWeight:activeTab===t.key?700:500,color:activeTab===t.key?"#1a7a3c":"#666",whiteSpace:"nowrap"}}>
            <i className={`ti ${t.icon}`} style={{fontSize:13}}/>{t.label}
            {t.badge>0&&<span style={{fontSize:10,padding:"1px 5px",borderRadius:10,background:activeTab===t.key?"#1a7a3c":"#e8e8e8",color:activeTab===t.key?"#fff":"#666",fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"16px 20px",background:"#f7f7f7"}}>
        {activeTab==="table"&&(
          <div style={{maxWidth:1300,margin:"0 auto"}}>
            <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center",flexWrap:"wrap"}}>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search products, codes, ASINs..." style={{padding:"7px 12px",borderRadius:8,border:"1px solid #e0e0e0",fontSize:12,outline:"none",width:260}}/>
              <div style={{display:"flex",gap:4}}>
                {["All","Active","Paused","Out of Stock","Pending Launch"].map(s=>(
                  <button key={s} onClick={()=>setFilterStatus(s)} style={{padding:"4px 10px",borderRadius:14,border:`1px solid ${filterStatus===s?"#1a7a3c":"#e0e0e0"}`,background:filterStatus===s?"#1a7a3c":"#fff",color:filterStatus===s?"#fff":"#555",fontSize:10,fontWeight:600,cursor:"pointer"}}>{s}</button>
                ))}
              </div>
              <span style={{fontSize:11,color:"#aaa",marginLeft:"auto"}}>{filtered.length} of {data.products.length} products</span>
            </div>

            <div style={{overflowX:"auto",borderRadius:12,border:"1px solid #f0f0f0",background:"#fff",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                <thead>
                  <tr style={{background:"#f7f7f7"}}>
                    {["Status","Product Code","Brand","Product Name","Parent ASIN","Child ASIN","Price","COGs","Margin","B/E ACoS","Target ACoS","B/E TACOS","Max CPA","Portfolio","Actions"].map(h=>(
                      <th key={h} style={{padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((p,i)=>(
                    <BTProductRow key={p.id||i} product={p} portfolios={data.portfolios} onEdit={openEdit} onDelete={deleteProduct}/>
                  ))}
                  {filtered.length===0&&<tr><td colSpan={15} style={{textAlign:"center",padding:"40px",color:"#aaa",fontSize:13}}>No products match this filter.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab==="portfolios"&&(
          <div style={{maxWidth:700,margin:"0 auto"}}>
            <BTPortfolioPanel portfolios={data.portfolios} onChange={p=>setData({...data,portfolios:p})}/>
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"14px 18px"}}>
              <div style={{fontSize:12,fontWeight:700,color:"#555",marginBottom:10}}>Products per Portfolio</div>
              {data.portfolios.length===0&&<div style={{fontSize:12,color:"#aaa",fontStyle:"italic"}}>No portfolios added yet.</div>}
              {data.portfolios.map(p=>{
                const count=data.products.filter(pr=>pr.portfolioId===p.portfolioId).length;
                return(
                  <div key={p.portfolioId} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 12px",background:"#fafafa",borderRadius:8,border:"1px solid #f0f0f0",marginBottom:6}}>
                    <i className="ti ti-folder" style={{fontSize:14,color:"#1a5fa0"}}/>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:600,color:"#111"}}>{p.name}</div>
                      <div style={{fontSize:11,color:"#aaa"}}>ID: {p.portfolioId}</div>
                    </div>
                    <span style={{fontSize:12,fontWeight:700,color:"#1a5fa0"}}>{count} products</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {activeTab==="analytics"&&(
          <div style={{maxWidth:960,margin:"0 auto"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:14}}>
              {[
                {label:"Total Products",       val:data.products.length,                                          icon:"ti-package",     color:"#1a5fa0"},
                {label:"Active",               val:data.products.filter(p=>p.status==="Active").length,           icon:"ti-circle-check",color:"#1a7a3c"},
                {label:"With Breakeven Data",  val:data.products.filter(p=>p.price&&p.cogs).length,              icon:"ti-calculator",  color:"#4f46e5"},
                {label:"Avg Breakeven ACoS",   val:`${(data.products.filter(p=>p.price&&p.cogs).reduce((s,p)=>s+(btCalcBreakeven(p).breakevenAcos||0),0)/Math.max(1,data.products.filter(p=>p.price&&p.cogs).length)).toFixed(1)}%`,icon:"ti-target",color:"#c47a00"},
                {label:"Avg Margin/Unit",      val:`$${(data.products.filter(p=>p.price&&p.cogs).reduce((s,p)=>s+(btCalcBreakeven(p).margin||0),0)/Math.max(1,data.products.filter(p=>p.price&&p.cogs).length)).toFixed(2)}`,icon:"ti-coin",color:"#1a7a3c"},
                {label:"Portfolios",           val:data.portfolios.length,                                        icon:"ti-folder",      color:"#6338c8"},
              ].map(c=>(
                <div key={c.label} style={{background:"#fff",borderRadius:11,border:"1px solid #f0f0f0",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.03)"}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                    <i className={`ti ${c.icon}`} style={{fontSize:13,color:c.color}}/>
                    <span style={{fontSize:11,color:"#888",fontWeight:600}}>{c.label}</span>
                  </div>
                  <div style={{fontSize:22,fontWeight:800,color:"#111"}}>{c.val}</div>
                </div>
              ))}
            </div>

            {/* Breakeven table */}
            <div style={{background:"#fff",borderRadius:12,border:"1px solid #f0f0f0",padding:"16px 18px"}}>
              <div style={{fontSize:13,fontWeight:700,color:"#111",marginBottom:12}}>Product Breakeven Summary</div>
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                  <thead>
                    <tr style={{background:"#f7f7f7"}}>
                      {["Product Code","Product","Price","Margin","Margin %","B/E ACoS","Target ACoS","B/E TACOS","Max CPA","B/E CVR"].map(h=>(
                        <th key={h} style={{padding:"8px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:"#888",textTransform:"uppercase",borderBottom:"1px solid #eee",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.products.filter(p=>p.price).map((p,i)=>{
                      const c=btCalcBreakeven(p);
                      return(
                        <tr key={i} style={{borderBottom:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa"}}>
                          <td style={{padding:"8px 10px",fontWeight:700,color:R}}>{p.productCode||"—"}</td>
                          <td style={{padding:"8px 10px",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"#111"}}>{p.productName||"—"}</td>
                          <td style={{padding:"8px 10px",fontWeight:600,color:"#111"}}>${parseFloat(p.price).toFixed(2)}</td>
                          <td style={{padding:"8px 10px",fontWeight:700,color:c.margin>0?"#1a7a3c":"#d42b2b"}}>${c.margin.toFixed(2)}</td>
                          <td style={{padding:"8px 10px",color:c.marginPct>30?"#1a7a3c":c.marginPct>15?"#c47a00":"#d42b2b",fontWeight:600}}>{c.marginPct}%</td>
                          <td style={{padding:"8px 10px",fontWeight:700,color:"#4f46e5"}}>{c.breakevenAcos}%</td>
                          <td style={{padding:"8px 10px",fontWeight:700,color:"#1a5fa0"}}>{c.targetAcos}%</td>
                          <td style={{padding:"8px 10px",color:"#6338c8",fontWeight:700}}>{c.breakevenTacos}%</td>
                          <td style={{padding:"8px 10px",color:"#c47a00"}}>${c.maxCpa.toFixed(2)}</td>
                          <td style={{padding:"8px 10px",color:"#555"}}>{c.breakevenCvr.toFixed(2)}%</td>
                        </tr>
                      );
                    })}
                    {!data.products.filter(p=>p.price).length&&<tr><td colSpan={10} style={{textAlign:"center",padding:"30px",color:"#aaa",fontSize:12}}>Add price and COGs data to products to see breakeven calculations.</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   STR HARVEST ENGINE MODULE
   Workflow:
   1. Upload STR Report + Bulk File
   2. Set criteria (ACoS range, min orders, min clicks)
   3. Filter by portfolio (include/exclude)
   4. Shows each qualifying search term → which match types it's
      already in (from Bulk) vs UNIQUE (harvest opportunities)
   5. Export unique terms per match type for Bulk Builder
================================================================ */

/* ── Column detection ── */
function shDetectSTR(headers){
  const alias=(cands)=>headers.find(h=>cands.some(c=>h.trim().toLowerCase().includes(c.toLowerCase())))||null;
  return{
    searchTerm: alias(['customer search term','search term','query','keyword text']),
    campaign:   alias(['campaign name','campaign']),
    adGroup:    alias(['ad group name','ad group']),
    portfolio:  alias(['portfolio name','portfolio']),
    impressions:alias(['impressions']),
    clicks:     alias(['clicks']),
    spend:      alias(['spend','cost','ad spend']),
    sales:      alias(['sales','14 day total sales','7 day total sales','attributed sales']),
    orders:     alias(['orders','14 day total orders','7 day total orders']),
    acos:       alias(['acos','advertising cost']),
  };
}

function shDetectBulk(headers){
  const alias=(cands)=>headers.find(h=>cands.some(c=>h.trim().toLowerCase()===c.toLowerCase()))||
    headers.find(h=>cands.some(c=>h.trim().toLowerCase().includes(c.toLowerCase())))||null;
  return{
    entity:     alias(['entity']),
    campaign:   alias(['campaign name']),
    adGroup:    alias(['ad group name']),
    portfolio:  alias(['portfolio name','portfolio id']),
    keyword:    alias(['keyword text']),
    matchType:  alias(['match type']),
    targeting:  alias(['product targeting expression','product targeting']),
    state:      alias(['state','keyword state']),
  };
}

function shNum(row,col){
  if(!col||row[col]==null||row[col]==='')return 0;
  return parseFloat(String(row[col]).replace(/[%$,\s£€₹]/g,''))||0;
}

/* ── Parse STR rows into term metrics ── */
function shParseSTR(rows, sm, criteria, portfolioFilter){
  const termMap={};
  rows.forEach(r=>{
    const term=String(r[sm.searchTerm]||'').trim().toLowerCase();
    if(!term)return;
    const portfolio=String(r[sm.portfolio]||'').trim();
    // Portfolio filter
    if(portfolioFilter.size>0 && !portfolioFilter.has(portfolio.toLowerCase()))return;

    const spend=shNum(r,sm.spend), sales=shNum(r,sm.sales), orders=shNum(r,sm.orders), clicks=shNum(r,sm.clicks);
    const acos=sales>0?(spend/sales)*100:0;
    const cvr=clicks>0?(orders/clicks)*100:0;

    if(!termMap[term])termMap[term]={term,spend:0,sales:0,orders:0,clicks:0,impressions:0,portfolios:new Set()};
    termMap[term].spend+=spend;
    termMap[term].sales+=sales;
    termMap[term].orders+=orders;
    termMap[term].clicks+=clicks;
    termMap[term].impressions+=shNum(r,sm.impressions);
    termMap[term].portfolios.add(portfolio);
  });

  // Apply criteria
  return Object.values(termMap).filter(t=>{
    const acos=t.sales>0?(t.spend/t.sales)*100:0;
    t.acos=acos; t.cvr=t.clicks>0?(t.orders/t.clicks)*100:0;
    t.cpc=t.clicks>0?t.spend/t.clicks:0;
    t.roas=t.spend>0?t.sales/t.spend:0;
    return (!criteria.minAcos||acos>=criteria.minAcos)
      && (!criteria.maxAcos||acos<=criteria.maxAcos)
      && (!criteria.minOrders||t.orders>=criteria.minOrders)
      && (!criteria.minClicks||t.clicks>=criteria.minClicks)
      && (!criteria.minCvr||t.cvr>=criteria.minCvr);
  }).sort((a,b)=>b.orders-a.orders);
}

/* ── Parse Bulk file → build targeted keyword set per match type ── */
function shParseBulk(rows, bm){
  const targeted={exact:new Set(),phrase:new Set(),broad:new Set(),asin:new Set(),asinExpanded:new Set()};
  rows.forEach(r=>{
    const entity=String(r[bm.entity]||'').toLowerCase();
    const kw=String(r[bm.keyword]||'').trim().toLowerCase();
    const mt=String(r[bm.matchType]||'').trim().toLowerCase();
    const pt=String(r[bm.targeting]||'').trim().toLowerCase();
    const state=String(r[bm.state]||'').toLowerCase();
    if(state==='archived')return;

    if(entity.includes('keyword')&&kw){
      if(mt==='exact'||mt==='negativeexact')targeted.exact.add(kw);
      else if(mt==='phrase'||mt==='negativephrase')targeted.phrase.add(kw);
      else if(mt==='broad')targeted.broad.add(kw);
    }
    if(entity.includes('targeting')||entity.includes('product targeting')){
      const asinMatch=pt.match(/asin="([^"]+)"/i);
      if(asinMatch)targeted.asin.add(asinMatch[1].toLowerCase());
      if(pt.includes('asin='))targeted.asinExpanded.add(pt);
    }
  });
  return targeted;
}

/* ── Harvest results component ── */
function SHResultsTable({qualifying,targeted,onExport}){
  const[filter,setFilter]=useState('');
  const[showOnly,setShowOnly]=useState('all');

  const results=useMemo(()=>qualifying.map(t=>{
    const kw=t.term;
    return{
      ...t,
      inExact:  targeted.exact.has(kw),
      inPhrase: targeted.phrase.has(kw),
      inBroad:  targeted.broad.has(kw),
      uniqueExact:  !targeted.exact.has(kw),
      uniquePhrase: !targeted.phrase.has(kw),
      uniqueBroad:  !targeted.broad.has(kw),
      uniqueCount: [!targeted.exact.has(kw),!targeted.phrase.has(kw),!targeted.broad.has(kw)].filter(Boolean).length,
    };
  }),[qualifying,targeted]);

  const filtered=useMemo(()=>results.filter(r=>{
    if(filter&&!r.term.includes(filter.toLowerCase()))return false;
    if(showOnly==='unique')return r.uniqueCount>0;
    if(showOnly==='not_exact')return r.uniqueExact;
    if(showOnly==='not_phrase')return r.uniquePhrase;
    return true;
  }),[results,filter,showOnly]);

  const uniqueExact=results.filter(r=>r.uniqueExact).map(r=>r.term);
  const uniquePhrase=results.filter(r=>r.uniquePhrase).map(r=>r.term);
  const uniqueBroad=results.filter(r=>r.uniqueBroad).map(r=>r.term);

  const Dot=({on})=><div style={{width:10,height:10,borderRadius:'50%',background:on?'#1a7a3c':'#e0e0e0',flexShrink:0}}/>;

  return(
    <div style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden'}}>
      {/* Stats bar */}
      <div style={{padding:'10px 20px',borderBottom:'1px solid #f0f0f0',background:'#fff',display:'flex',gap:14,alignItems:'center',flexWrap:'wrap',flexShrink:0}}>
        {[
          {label:'Qualifying Terms',val:results.length,color:'#111'},
          {label:'Unique Exact',val:uniqueExact.length,color:'#4f46e5'},
          {label:'Unique Phrase',val:uniquePhrase.length,color:'#1a5fa0'},
          {label:'Unique Broad',val:uniqueBroad.length,color:'#1a7a3c'},
        ].map(s=>(
          <div key={s.label} style={{padding:'6px 12px',background:'#f8f8f8',borderRadius:8,textAlign:'center'}}>
            <div style={{fontSize:16,fontWeight:800,color:s.color}}>{s.val}</div>
            <div style={{fontSize:9,color:'#888',textTransform:'uppercase',letterSpacing:'0.4px'}}>{s.label}</div>
          </div>
        ))}
        <div style={{flex:1}}/>
        <button onClick={()=>onExport(uniqueExact,uniquePhrase,uniqueBroad,results)} style={{...T.btnR(true),padding:'7px 16px',fontSize:12}}>
          <i className="ti ti-download" style={{fontSize:12}}/>Export Harvest
        </button>
      </div>

      {/* Filters */}
      <div style={{padding:'8px 20px',background:'#fafafa',borderBottom:'1px solid #f0f0f0',display:'flex',gap:8,alignItems:'center',flexShrink:0}}>
        <input value={filter} onChange={e=>setFilter(e.target.value)} placeholder="Filter search terms..." style={{padding:'5px 10px',borderRadius:7,border:'1px solid #e0e0e0',fontSize:12,outline:'none',width:220}}/>
        <div style={{display:'flex',gap:4}}>
          {[{k:'all',l:'All'},{'k':'unique',l:'Has Gaps'},{'k':'not_exact',l:'No Exact'},{'k':'not_phrase',l:'No Phrase'}].map(f=>(
            <button key={f.k} onClick={()=>setShowOnly(f.k)} style={{padding:'4px 10px',borderRadius:14,border:`1px solid ${showOnly===f.k?R:'#e0e0e0'}`,background:showOnly===f.k?R:'#fff',color:showOnly===f.k?'#fff':'#555',fontSize:10,fontWeight:showOnly===f.k?700:400,cursor:'pointer'}}>{f.l}</button>
          ))}
        </div>
        <span style={{fontSize:10,color:'#aaa',marginLeft:'auto'}}>{filtered.length} terms shown</span>
      </div>

      {/* Table */}
      <div style={{flex:1,overflowY:'auto'}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
          <thead style={{position:'sticky',top:0,zIndex:2}}>
            <tr style={{background:'#f7f7f7'}}>
              <th style={{padding:'8px 12px',textAlign:'left',fontSize:10,fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'1px solid #eee',minWidth:200}}>Search Term</th>
              <th style={{padding:'8px 10px',textAlign:'right',fontSize:10,fontWeight:700,color:'#888',textTransform:'uppercase',borderBottom:'1px solid #eee'}}>Orders</th>
              <th style={{padding:'8px 10px',textAlign:'right',fontSize:10,fontWeight:700,color:'#888',textTransform:'uppercase',borderBottom:'1px solid #eee'}}>ACoS</th>
              <th style={{padding:'8px 10px',textAlign:'right',fontSize:10,fontWeight:700,color:'#888',textTransform:'uppercase',borderBottom:'1px solid #eee'}}>Spend</th>
              <th style={{padding:'8px 10px',textAlign:'center',fontSize:10,fontWeight:700,color:'#4f46e5',textTransform:'uppercase',borderBottom:'1px solid #eee'}}>Exact</th>
              <th style={{padding:'8px 10px',textAlign:'center',fontSize:10,fontWeight:700,color:'#1a5fa0',textTransform:'uppercase',borderBottom:'1px solid #eee'}}>Phrase</th>
              <th style={{padding:'8px 10px',textAlign:'center',fontSize:10,fontWeight:700,color:'#1a7a3c',textTransform:'uppercase',borderBottom:'1px solid #eee'}}>Broad</th>
              <th style={{padding:'8px 10px',textAlign:'center',fontSize:10,fontWeight:700,color:'#555',textTransform:'uppercase',borderBottom:'1px solid #eee'}}>Gaps</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r,i)=>(
              <tr key={i} style={{borderBottom:'1px solid #f5f5f5',background:i%2===0?'#fff':'#fafafa'}}>
                <td style={{padding:'7px 12px',fontWeight:500,color:'#111'}}>{r.term}</td>
                <td style={{padding:'7px 10px',textAlign:'right',fontWeight:700,color:'#1a7a3c'}}>{Math.round(r.orders)}</td>
                <td style={{padding:'7px 10px',textAlign:'right',color:r.acos<15?'#1a7a3c':r.acos<25?'#c47a00':'#d42b2b',fontWeight:600}}>{r.acos.toFixed(1)}%</td>
                <td style={{padding:'7px 10px',textAlign:'right',color:'#555'}}>${r.spend.toFixed(2)}</td>
                <td style={{padding:'7px 10px',textAlign:'center'}}>
                  {r.inExact ? <Dot on={true}/> : <span style={{fontSize:9,padding:'1px 5px',borderRadius:6,background:'rgba(79,70,229,0.1)',color:'#4f46e5',fontWeight:700}}>ADD</span>}
                </td>
                <td style={{padding:'7px 10px',textAlign:'center'}}>
                  {r.inPhrase ? <Dot on={true}/> : <span style={{fontSize:9,padding:'1px 5px',borderRadius:6,background:'rgba(26,95,160,0.1)',color:'#1a5fa0',fontWeight:700}}>ADD</span>}
                </td>
                <td style={{padding:'7px 10px',textAlign:'center'}}>
                  {r.inBroad ? <Dot on={true}/> : <span style={{fontSize:9,padding:'1px 5px',borderRadius:6,background:'rgba(26,122,60,0.1)',color:'#1a7a3c',fontWeight:700}}>ADD</span>}
                </td>
                <td style={{padding:'7px 10px',textAlign:'center',fontWeight:700,color:r.uniqueCount>0?R:'#aaa'}}>{r.uniqueCount>0?r.uniqueCount:'✓'}</td>
              </tr>
            ))}
            {filtered.length===0&&<tr><td colSpan={8} style={{textAlign:'center',padding:'40px',color:'#aaa'}}>No terms match this filter</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── Export function ── */
function shExport(uniqueExact,uniquePhrase,uniqueBroad,allResults){
  const wb=XLSX.utils.book_new();

  // Sheet 1: Full results with coverage matrix
  const fullRows=allResults.map(r=>({
    'Search Term':r.term,'Orders':Math.round(r.orders),'Spend ($)':r.spend.toFixed(2),
    'Sales ($)':r.sales.toFixed(2),'ACoS (%)':r.acos.toFixed(1),'CVR (%)':r.cvr.toFixed(2),
    'CPC ($)':r.cpc.toFixed(2),'Clicks':r.clicks,
    'In Exact':r.inExact?'Yes':'','In Phrase':r.inPhrase?'Yes':'','In Broad':r.inBroad?'Yes':'',
    'Unique Exact':r.uniqueExact?r.term:'','Unique Phrase':r.uniquePhrase?r.term:'','Unique Broad':r.uniqueBroad?r.term:'',
    'Harvest Gaps':r.uniqueCount,
  }));
  const ws1=XLSX.utils.json_to_sheet(fullRows);
  ws1['!cols']=Object.keys(fullRows[0]||{}).map(()=>({wch:18}));
  XLSX.utils.book_append_sheet(wb,ws1,'Harvest Analysis');

  // Sheet 2: Unique Exact only (ready to paste into Bulk Builder)
  const maxLen=Math.max(uniqueExact.length,uniquePhrase.length,uniqueBroad.length,1);
  const colRows=Array.from({length:maxLen},(_,i)=>({
    'Unique Exact':uniqueExact[i]||'',
    'Unique Phrase':uniquePhrase[i]||'',
    'Unique Broad':uniqueBroad[i]||'',
  }));
  const ws2=XLSX.utils.json_to_sheet(colRows);
  ws2['!cols']=[{wch:40},{wch:40},{wch:40}];
  XLSX.utils.book_append_sheet(wb,ws2,'Bulk Builder Ready');

  XLSX.writeFile(wb,`STR_Harvest_${new Date().toISOString().slice(0,10)}.xlsx`);
}

/* ── STR Harvest Module Root ── */

/* ================================================================
   STIN — Search Term Insight Navigator
   Pulls from Data Hub: Campaign + STR + Placement reports
   Local uploads: SP Impression Share + SB Impression Share
   All sections have comparison period built in
================================================================ */
function STINModule({globalData,setTab}){
  /* ── Data Hub sources ── */
  const campCur  = globalData?.cur?.primary || globalData?.cur?.campaign;
  const campComp = globalData?.comp?.primary || globalData?.comp?.campaign;
  const strCur   = globalData?.cur?.searchterm;
  const strComp  = globalData?.comp?.searchterm;
  const placCur  = globalData?.cur?.placement;
  const placComp = globalData?.comp?.placement;

  /* ── Local IS uploads ── */
  const[spIS,setSpIS]   = useState(null);
  const[sbIS,setSbIS]   = useState(null);
  const[spISComp,setSpISComp] = useState(null);
  const[sbISComp,setSbISComp] = useState(null);

  /* ── Navigation ── */
  const[sec,setSec] = useState('overview');

  /* ── Helpers ── */
  const n = (row,col) => {
    if(!col||row[col]==null||row[col]==='')return 0;
    return parseFloat(String(row[col]).replace(/[%$,\s]/g,''))||0;
  };
  const fmtD = v => v==null?'—':`$${Math.abs(v)>=1000?(Math.abs(v)/1000).toFixed(1)+'K':Math.abs(v).toFixed(0)}`;
  const fmtP = v => v==null?'—':`${Number(v).toFixed(1)}%`;
  const fmtN = v => v==null?'—':v>=1000?(v/1000).toFixed(1)+'K':Math.round(v).toLocaleString();
  const fmtX = v => v==null?'—':`${Number(v).toFixed(2)}x`;

  const pct=(a,b)=>b&&b!==0?((a-b)/Math.abs(b))*100:null;
  const Delta=({cur,prev,invert=false,fmt='pct'})=>{
    if(prev==null||prev===0||cur==null)return null;
    const d=((cur-prev)/Math.abs(prev))*100;
    const good=invert?d<0:d>0;
    const color=good?'#1a9e5f':'#e05656';
    return<span style={{fontSize:10,fontWeight:700,color,marginLeft:4}}>{d>=0?'+':''}{d.toFixed(1)}%</span>;
  };

  /* ── Parse rows from a report ── */
  function parseRows(data){
    if(!data?.rows?.length)return[];
    return data.rows;
  }

  /* ── Column finder ── */
  function col(rows,candidates){
    if(!rows?.length)return null;
    const keys=Object.keys(rows[0]);
    for(const c of candidates){
      const found=keys.find(k=>k.trim().toLowerCase()===c.toLowerCase());
      if(found)return found;
    }
    for(const c of candidates){
      const found=keys.find(k=>k.toLowerCase().includes(c.toLowerCase()));
      if(found)return found;
    }
    return null;
  }

  /* ── Aggregate campaign rows → total metrics ── */
  function aggCamp(data){
    const rows=parseRows(data);
    if(!rows.length)return null;
    const sp=col(rows,['Spend','spend','Cost']);
    const sa=col(rows,['Sales','14 Day Total Sales','7 Day Total Sales','Revenue']);
    const cl=col(rows,['Clicks','clicks']);
    const or=col(rows,['Orders','14 Day Total Orders','Purchases']);
    const im=col(rows,['Impressions','impressions']);
    let spend=0,sales=0,clicks=0,orders=0,impressions=0;
    rows.forEach(r=>{spend+=n(r,sp);sales+=n(r,sa);clicks+=n(r,cl);orders+=n(r,or);impressions+=n(r,im);});
    return{spend,sales,clicks,orders,impressions,
      acos:sales>0?(spend/sales)*100:0,
      ctr:impressions>0?(clicks/impressions)*100:0,
      cvr:clicks>0?(orders/clicks)*100:0,
      cpc:clicks>0?spend/clicks:0,
      roas:spend>0?sales/spend:0};
  }

  /* ── Count unique values in a column ── */
  function countUnique(data,colCandidates){
    const rows=parseRows(data);
    if(!rows.length)return 0;
    const c=col(rows,colCandidates);
    if(!c)return 0;
    return new Set(rows.map(r=>String(r[c]||'').trim()).filter(Boolean)).size;
  }

  /* ── Group by a column and aggregate ── */
  function groupBy(data,groupColCandidates){
    const rows=parseRows(data);
    if(!rows.length)return[];
    const gc=col(rows,groupColCandidates);
    const sp=col(rows,['Spend','spend','Cost']);
    const sa=col(rows,['Sales','14 Day Total Sales','7 Day Total Sales']);
    const cl=col(rows,['Clicks','clicks']);
    const or=col(rows,['Orders','14 Day Total Orders']);
    const im=col(rows,['Impressions','impressions']);
    const map={};
    rows.forEach(r=>{
      const key=String(r[gc]||'(None)').trim()||'(None)';
      if(!map[key])map[key]={name:key,spend:0,sales:0,clicks:0,orders:0,impressions:0};
      map[key].spend+=n(r,sp);
      map[key].sales+=n(r,sa);
      map[key].clicks+=n(r,cl);
      map[key].orders+=n(r,or);
      map[key].impressions+=n(r,im);
    });
    const totSpend=Object.values(map).reduce((s,v)=>s+v.spend,0);
    const totSales=Object.values(map).reduce((s,v)=>s+v.sales,0);
    return Object.values(map).map(m=>({...m,
      acos:m.sales>0?(m.spend/m.sales)*100:0,
      ctr:m.impressions>0?(m.clicks/m.impressions)*100:0,
      cvr:m.clicks>0?(m.orders/m.clicks)*100:0,
      cpc:m.clicks>0?m.spend/m.clicks:0,
      pctSpend:totSpend>0?(m.spend/totSpend)*100:0,
      pctSales:totSales>0?(m.sales/totSales)*100:0,
    })).sort((a,b)=>b.sales-a.sales);
  }

  /* ── Group by Match Type (STR) ── */
  function groupByMatchType(data){
    const rows=parseRows(data);
    if(!rows.length)return[];
    const mtCol=col(rows,['Match Type','match type','matchType']);
    const kwCol=col(rows,['Customer Search Term','Search Term','Query','Keyword']);
    const tgCol=col(rows,['Targeting','Target','keyword']);
    const sp=col(rows,['Spend','spend']);
    const sa=col(rows,['Sales','14 Day Total Sales','7 Day Total Sales']);
    const cl=col(rows,['Clicks','clicks']);
    const or=col(rows,['Orders','14 Day Total Orders']);
    const im=col(rows,['Impressions','impressions']);
    const map={};
    rows.forEach(r=>{
      let mt=String(r[mtCol]||'').trim().toUpperCase()||'AUTO';
      if(mt==='TARGETING'||mt.includes('PRODUCT')||mt.includes('PT'))mt='Product Targeting';
      else if(mt==='PHRASE')mt='Phrase';
      else if(mt==='EXACT')mt='Exact';
      else if(mt==='BROAD')mt='Broad';
      else mt='Auto';
      if(!map[mt])map[mt]={name:mt,spend:0,sales:0,clicks:0,orders:0,impressions:0,terms:new Set(),targets:new Set()};
      map[mt].spend+=n(r,sp);
      map[mt].sales+=n(r,sa);
      map[mt].clicks+=n(r,cl);
      map[mt].orders+=n(r,or);
      map[mt].impressions+=n(r,im);
      if(kwCol&&r[kwCol])map[mt].terms.add(String(r[kwCol]).trim().toLowerCase());
      if(tgCol&&r[tgCol])map[mt].targets.add(String(r[tgCol]).trim().toLowerCase());
    });
    const totSpend=Object.values(map).reduce((s,v)=>s+v.spend,0);
    const totSales=Object.values(map).reduce((s,v)=>s+v.sales,0);
    const ORDER=['Auto','Phrase','Exact','Broad','Product Targeting'];
    return ORDER.filter(k=>map[k]).map(k=>{
      const m=map[k];
      return{...m,
        uniqueTerms:m.terms.size,
        uniqueTargets:m.targets.size,
        acos:m.sales>0?(m.spend/m.sales)*100:0,
        ctr:m.impressions>0?(m.clicks/m.impressions)*100:0,
        cvr:m.clicks>0?(m.orders/m.clicks)*100:0,
        cpc:m.clicks>0?m.spend/m.clicks:0,
        roas:m.spend>0?m.sales/m.spend:0,
        pctSpend:totSpend>0?(m.spend/totSpend)*100:0,
        pctSales:totSales>0?(m.sales/totSales)*100:0,
      };
    });
  }

  /* ── Parse IS file ── */
  function handleISUpload(file,setCur,setComp,isPeriod){
    const reader=new FileReader();
    reader.onload=e=>{
      const wb=XLSX.read(e.target.result,{type:'binary'});
      const sheet=wb.Sheets[wb.SheetNames[0]];
      const rows=XLSX.utils.sheet_to_json(sheet,{defval:''});
      if(isPeriod)setComp({rows,headers:Object.keys(rows[0]||{})});
      else setCur({rows,headers:Object.keys(rows[0]||{})});
    };
    reader.readAsBinaryString(file);
  }

  /* ── Computed values ── */
  const curAgg  = useMemo(()=>aggCamp(campCur),[campCur]);
  const compAgg = useMemo(()=>aggCamp(campComp),[campComp]);
  const mtCur   = useMemo(()=>groupByMatchType(strCur||campCur),[strCur,campCur]);
  const mtComp  = useMemo(()=>groupByMatchType(strComp||campComp),[strComp,campComp]);
  const portCur = useMemo(()=>groupBy(campCur,['Portfolio Name','Portfolio name','portfolio']),[campCur]);
  const portComp= useMemo(()=>groupBy(campComp,['Portfolio Name','Portfolio name','portfolio']),[campComp]);

  const uniquePortfolios = useMemo(()=>countUnique(campCur,['Portfolio Name','Portfolio name']),[campCur]);
  const uniqueCampaigns  = useMemo(()=>countUnique(campCur,['Campaign Name','Campaign name','campaign']),[campCur]);
  const uniqueTerms      = useMemo(()=>countUnique(strCur||campCur,['Customer Search Term','Search Term','Query','Keyword']),[strCur,campCur]);
  const uniqueTargets    = useMemo(()=>countUnique(campCur,['Targeting','Target']),[campCur]);

  const hasData = campCur?.rows?.length>0;

  /* ── Colors ── */
  const R='#4f46e5';
  const MT_COLORS={Auto:'#1a5fa0',Phrase:'#6338c8',Exact:'#1a9e5f',Broad:'#c47a00','Product Targeting':'#555'};

  /* ── Shared table styles ── */
  const TH = {padding:'8px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11,whiteSpace:'nowrap',background:'#f8f9fc'};
  const THL= {...TH,textAlign:'left'};
  const TD = {padding:'8px 12px',textAlign:'right',fontSize:12,borderBottom:'1px solid #f0f2f7',color:'#333'};
  const TDL= {...TD,textAlign:'left'};

  /* ── Comparison row for a metric ── */
  function CmpCell({cur,comp,fmt='dollar',invert=false}){
    const fmtV=fmt==='dollar'?fmtD:fmt==='pct'?fmtP:fmt==='int'?fmtN:fmtX;
    if(comp==null)return<td style={TD}>{fmtV(cur)}</td>;
    const d=pct(cur,comp);
    const good=invert?d<0:d>0;
    return<td style={TD}>
      <div style={{fontWeight:600}}>{fmtV(cur)}</div>
      <div style={{fontSize:10,color:good?'#1a9e5f':'#e05656',fontWeight:600}}>
        {d!=null&&(d>=0?'+':'')+d.toFixed(1)+'%'}
      </div>
      <div style={{fontSize:9,color:'#bbb'}}>{fmtV(comp)}</div>
    </td>;
  }

  /* ══════════════════════════════════════════════════
     SECTION: OVERVIEW
  ══════════════════════════════════════════════════ */
  function OverviewSection(){
    if(!hasData)return<EmptyState/>;
    const KPI=({label,cur,prev,fmt='dollar',invert=false,icon,color})=>{
      const fmtV=fmt==='dollar'?fmtD:fmt==='pct'?fmtP:fmt==='int'?fmtN:fmtX;
      const d=prev&&prev!==0?((cur-prev)/Math.abs(prev))*100:null;
      const good=invert?d<0:d>0;
      return<div style={{background:'#fff',borderRadius:10,border:'1px solid #eef0f4',padding:'14px 16px'}}>
        <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:6}}>
          <div style={{width:28,height:28,borderRadius:8,background:color+'18',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
            <i className={`ti ${icon}`} style={{fontSize:13,color}}/>
          </div>
          <span style={{fontSize:10,color:'#8893a7',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.5px'}}>{label}</span>
        </div>
        <div style={{fontSize:20,fontWeight:800,color:'#111',letterSpacing:'-0.3px'}}>{fmtV(cur)}</div>
        {d!=null&&<div style={{fontSize:10,fontWeight:700,color:good?'#1a9e5f':'#e05656',marginTop:2}}>
          {d>=0?'+':''}{d.toFixed(1)}% vs prev
          <span style={{fontWeight:400,color:'#aaa',marginLeft:4}}>{fmtV(prev)}</span>
        </div>}
      </div>;
    };

    return<div style={{padding:'24px',maxWidth:1200}}>
      {/* Account Structure */}
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px',marginBottom:18}}>
        <div style={{fontSize:13,fontWeight:800,color:'#111',marginBottom:14,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-layout-grid" style={{color:R,fontSize:14}}/>Account Structure
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12}}>
          {[
            {label:'Portfolios',val:uniquePortfolios,icon:'ti-briefcase',color:'#1a5fa0'},
            {label:'Campaigns',val:uniqueCampaigns,icon:'ti-speakerphone',color:'#6338c8'},
            {label:'Unique Search Terms',val:uniqueTerms,icon:'ti-search',color:'#1a9e5f'},
            {label:'Unique Targets',val:uniqueTargets,icon:'ti-target',color:'#c47a00'},
          ].map((k,i)=><div key={i} style={{background:'#f8f9fc',borderRadius:9,padding:'12px 14px',textAlign:'center'}}>
            <div style={{width:32,height:32,borderRadius:8,background:k.color+'15',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 8px'}}>
              <i className={`ti ${k.icon}`} style={{fontSize:14,color:k.color}}/>
            </div>
            <div style={{fontSize:22,fontWeight:900,color:'#111'}}>{fmtN(k.val)}</div>
            <div style={{fontSize:10,color:'#888',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.4px'}}>{k.label}</div>
          </div>)}
        </div>
      </div>

      {/* Performance KPIs */}
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px',marginBottom:18}}>
        <div style={{fontSize:13,fontWeight:800,color:'#111',marginBottom:14,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-chart-bar" style={{color:R,fontSize:14}}/>Performance Overview
          {compAgg&&<span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:'rgba(26,95,160,0.1)',color:'#1a5fa0',marginLeft:6,fontWeight:700}}>vs Previous Period</span>}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12}}>
          <KPI label="Ad Spend"       cur={curAgg?.spend}       prev={compAgg?.spend}       fmt="dollar" invert icon="ti-coin"           color="#4f46e5"/>
          <KPI label="Ad Sales"       cur={curAgg?.sales}       prev={compAgg?.sales}       fmt="dollar"        icon="ti-currency-dollar"  color="#1a9e5f"/>
          <KPI label="ACOS"           cur={curAgg?.acos}        prev={compAgg?.acos}        fmt="pct"    invert icon="ti-percentage"       color="#e05656"/>
          <KPI label="ROAS"           cur={curAgg?.roas}        prev={compAgg?.roas}        fmt="x"             icon="ti-trending-up"      color="#6338c8"/>
          <KPI label="Impressions"    cur={curAgg?.impressions} prev={compAgg?.impressions} fmt="int"           icon="ti-eye"              color="#1a5fa0"/>
          <KPI label="Clicks"         cur={curAgg?.clicks}      prev={compAgg?.clicks}      fmt="int"           icon="ti-cursor-text"      color="#555"/>
          <KPI label="CTR"            cur={curAgg?.ctr}         prev={compAgg?.ctr}         fmt="pct"           icon="ti-hand-click"       color="#c47a00"/>
          <KPI label="CPC"            cur={curAgg?.cpc}         prev={compAgg?.cpc}         fmt="dollar" invert icon="ti-cash"             color="#888"/>
        </div>
      </div>

      {/* Mini match type summary */}
      {mtCur.length>0&&<div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px'}}>
        <div style={{fontSize:13,fontWeight:800,color:'#111',marginBottom:14,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-list-check" style={{color:R,fontSize:14}}/>Match Type Distribution
        </div>
        <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          {mtCur.map((mt,i)=><div key={i} style={{flex:1,minWidth:140,background:'#f8f9fc',borderRadius:9,padding:'12px',borderLeft:`4px solid ${MT_COLORS[mt.name]||'#aaa'}`}}>
            <div style={{fontSize:11,fontWeight:700,color:MT_COLORS[mt.name]||'#555',marginBottom:6}}>{mt.name}</div>
            <div style={{fontSize:13,fontWeight:800,color:'#111'}}>{fmtD(mt.spend)} <span style={{fontSize:10,color:'#888'}}>spent</span></div>
            <div style={{fontSize:11,color:'#555'}}>{fmtP(mt.pctSpend)} of budget</div>
            <div style={{fontSize:11,color:mt.acos>30?'#e05656':'#1a9e5f',fontWeight:600,marginTop:4}}>{fmtP(mt.acos)} ACOS</div>
          </div>)}
        </div>
      </div>}
    </div>;
  }

  /* ══════════════════════════════════════════════════
     SECTION: MATCH TYPE INTEL
  ══════════════════════════════════════════════════ */
  function MatchTypeSection(){
    if(!hasData)return<EmptyState/>;
    const totCur=mtCur.reduce((a,m)=>({spend:a.spend+m.spend,sales:a.sales+m.sales,clicks:a.clicks+m.clicks,orders:a.orders+m.orders,impressions:a.impressions+m.impressions}),{spend:0,sales:0,clicks:0,orders:0,impressions:0});
    const mtCompMap=Object.fromEntries(mtComp.map(m=>[m.name,m]));

    return<div style={{padding:'24px',maxWidth:1100}}>
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px'}}>
        <div style={{fontSize:14,fontWeight:800,color:'#111',marginBottom:16,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-list-check" style={{color:R}}/>Match Type Performance
          {mtComp.length>0&&<span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:'rgba(26,95,160,0.1)',color:'#1a5fa0',fontWeight:700}}>With Comparison</span>}
        </div>
        <div style={{overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead><tr>
              <th style={THL}>Match Type</th>
              <th style={TH}>Search Terms</th>
              <th style={TH}>Impressions</th>
              <th style={TH}>Clicks</th>
              <th style={TH}>Orders</th>
              <th style={TH}>Spend</th>
              <th style={TH}>Sales</th>
              <th style={TH}>CTR</th>
              <th style={TH}>CVR</th>
              <th style={TH}>CPC</th>
              <th style={TH}>ACOS</th>
              <th style={TH}>% Spend</th>
              <th style={TH}>% Sales</th>
            </tr></thead>
            <tbody>
              {mtCur.map((mt,i)=>{
                const prev=mtCompMap[mt.name];
                return<tr key={i} style={{background:i%2===0?'#fff':'#fafbfd'}}>
                  <td style={{...TDL,fontWeight:700,color:MT_COLORS[mt.name]||'#555'}}>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <div style={{width:8,height:8,borderRadius:'50%',background:MT_COLORS[mt.name]||'#aaa',flexShrink:0}}/>
                      {mt.name}
                    </div>
                  </td>
                  <CmpCell cur={mt.uniqueTerms} comp={prev?.uniqueTerms} fmt="int"/>
                  <CmpCell cur={mt.impressions} comp={prev?.impressions} fmt="int"/>
                  <CmpCell cur={mt.clicks}      comp={prev?.clicks}      fmt="int"/>
                  <CmpCell cur={mt.orders}      comp={prev?.orders}      fmt="int"/>
                  <CmpCell cur={mt.spend}       comp={prev?.spend}       fmt="dollar"/>
                  <CmpCell cur={mt.sales}       comp={prev?.sales}       fmt="dollar"/>
                  <CmpCell cur={mt.ctr}         comp={prev?.ctr}         fmt="pct"/>
                  <CmpCell cur={mt.cvr}         comp={prev?.cvr}         fmt="pct"/>
                  <CmpCell cur={mt.cpc}         comp={prev?.cpc}         fmt="dollar" invert/>
                  <CmpCell cur={mt.acos}        comp={prev?.acos}        fmt="pct" invert/>
                  <td style={TD}><strong>{fmtP(mt.pctSpend)}</strong></td>
                  <td style={TD}><strong>{fmtP(mt.pctSales)}</strong></td>
                </tr>;
              })}
              {/* Grand Total */}
              <tr style={{background:'#f0f4f8',fontWeight:700}}>
                <td style={{...TDL,fontWeight:800,color:'#111'}}>Grand Total</td>
                <td style={TD}></td>
                <CmpCell cur={totCur.impressions} comp={compAgg?.impressions} fmt="int"/>
                <CmpCell cur={totCur.clicks}      comp={compAgg?.clicks}      fmt="int"/>
                <CmpCell cur={totCur.orders}      comp={compAgg?.orders}      fmt="int"/>
                <CmpCell cur={totCur.spend}       comp={compAgg?.spend}       fmt="dollar"/>
                <CmpCell cur={totCur.sales}       comp={compAgg?.sales}       fmt="dollar"/>
                <CmpCell cur={curAgg?.ctr}        comp={compAgg?.ctr}         fmt="pct"/>
                <CmpCell cur={curAgg?.cvr}        comp={compAgg?.cvr}         fmt="pct"/>
                <CmpCell cur={curAgg?.cpc}        comp={compAgg?.cpc}         fmt="dollar" invert/>
                <CmpCell cur={curAgg?.acos}       comp={compAgg?.acos}        fmt="pct" invert/>
                <td style={{...TD,fontWeight:800}}>100%</td>
                <td style={{...TD,fontWeight:800}}>100%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
  }

  /* ══════════════════════════════════════════════════
     SECTION: PORTFOLIO INTEL
  ══════════════════════════════════════════════════ */
  function PortfolioSection(){
    if(!hasData)return<EmptyState/>;
    const portCompMap=Object.fromEntries(portComp.map(p=>[p.name,p]));
    const COLORS=['#1a5fa0','#4f46e5','#1a9e5f','#6338c8','#c47a00','#555','#e05656','#1a7a6a','#7a3a00','#003a7a'];

    return<div style={{padding:'24px',maxWidth:1200}}>
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px'}}>
        <div style={{fontSize:14,fontWeight:800,color:'#111',marginBottom:16,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-briefcase" style={{color:R}}/>Portfolio Performance
          {portComp.length>0&&<span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:'rgba(26,95,160,0.1)',color:'#1a5fa0',fontWeight:700}}>With Comparison</span>}
          <span style={{fontSize:11,color:'#aaa',marginLeft:'auto'}}>Sorted by Sales ↓</span>
        </div>
        <div style={{overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead><tr>
              <th style={THL}>Portfolio</th>
              <th style={TH}>Impressions</th>
              <th style={TH}>Clicks</th>
              <th style={TH}>Orders</th>
              <th style={TH}>Spend</th>
              <th style={TH}>Sales</th>
              <th style={TH}>CTR</th>
              <th style={TH}>CVR</th>
              <th style={TH}>CPC</th>
              <th style={TH}>ACOS</th>
              <th style={TH}>% Spend</th>
              <th style={TH}>% Sales</th>
            </tr></thead>
            <tbody>
              {portCur.map((p,i)=>{
                const prev=portCompMap[p.name];
                return<tr key={i} style={{background:i%2===0?'#fff':'#fafbfd'}}>
                  <td style={{...TDL,maxWidth:280}}>
                    <div style={{display:'flex',alignItems:'center',gap:7}}>
                      <div style={{width:8,height:8,borderRadius:'50%',background:COLORS[i%COLORS.length],flexShrink:0}}/>
                      <span style={{fontWeight:600,color:'#111',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={p.name}>{p.name}</span>
                    </div>
                  </td>
                  <CmpCell cur={p.impressions} comp={prev?.impressions} fmt="int"/>
                  <CmpCell cur={p.clicks}      comp={prev?.clicks}      fmt="int"/>
                  <CmpCell cur={p.orders}      comp={prev?.orders}      fmt="int"/>
                  <CmpCell cur={p.spend}       comp={prev?.spend}       fmt="dollar"/>
                  <CmpCell cur={p.sales}       comp={prev?.sales}       fmt="dollar"/>
                  <CmpCell cur={p.ctr}         comp={prev?.ctr}         fmt="pct"/>
                  <CmpCell cur={p.cvr}         comp={prev?.cvr}         fmt="pct"/>
                  <CmpCell cur={p.cpc}         comp={prev?.cpc}         fmt="dollar" invert/>
                  <CmpCell cur={p.acos}        comp={prev?.acos}        fmt="pct" invert/>
                  <td style={TD}>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <div style={{width:Math.max(3,p.pctSpend*2),height:6,borderRadius:3,background:COLORS[i%COLORS.length],opacity:0.7}}/>
                      {fmtP(p.pctSpend)}
                    </div>
                  </td>
                  <td style={TD}>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <div style={{width:Math.max(3,p.pctSales*2),height:6,borderRadius:3,background:'#1a9e5f',opacity:0.7}}/>
                      {fmtP(p.pctSales)}
                    </div>
                  </td>
                </tr>;
              })}
              {/* Grand Total */}
              <tr style={{background:'#f0f4f8'}}>
                <td style={{...TDL,fontWeight:800,color:'#111'}}>Grand Total</td>
                <CmpCell cur={curAgg?.impressions} comp={compAgg?.impressions} fmt="int"/>
                <CmpCell cur={curAgg?.clicks}      comp={compAgg?.clicks}      fmt="int"/>
                <CmpCell cur={curAgg?.orders}      comp={compAgg?.orders}      fmt="int"/>
                <CmpCell cur={curAgg?.spend}       comp={compAgg?.spend}       fmt="dollar"/>
                <CmpCell cur={curAgg?.sales}       comp={compAgg?.sales}       fmt="dollar"/>
                <CmpCell cur={curAgg?.ctr}         comp={compAgg?.ctr}         fmt="pct"/>
                <CmpCell cur={curAgg?.cvr}         comp={compAgg?.cvr}         fmt="pct"/>
                <CmpCell cur={curAgg?.cpc}         comp={compAgg?.cpc}         fmt="dollar" invert/>
                <CmpCell cur={curAgg?.acos}        comp={compAgg?.acos}        fmt="pct" invert/>
                <td style={{...TD,fontWeight:800}}>100%</td>
                <td style={{...TD,fontWeight:800}}>100%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
  }

  /* ══════════════════════════════════════════════════
     SECTION: IMPRESSION SHARE (SP or SB)
  ══════════════════════════════════════════════════ */
  function ISSection({type}){
    const isData  = type==='SP'?spIS:sbIS;
    const isComp  = type==='SP'?spISComp:sbISComp;
    const setData = type==='SP'?setSpIS:setSbIS;
    const setComp = type==='SP'?setSpISComp:setSbISComp;
    const color   = type==='SP'?'#1a5fa0':'#c47a00';

    /* Parse IS rows */
    const rows = isData?.rows||[];
    const compRows = isComp?.rows||[];

    /* Detect columns */
    const kwCol      = col(rows,['Keyword','Search Term','Query','Target','Targeting','keyword']);
    const campCol    = col(rows,['Campaign Name','Campaign','campaign']);
    const imCol      = col(rows,['Impressions','impressions']);
    const isCol      = col(rows,['Impression Share','Impression Share %','IS %','impression share']);
    const isRankCol  = col(rows,['Impression Rank','IS Rank','impression rank']);
    const clicksCol  = col(rows,['Clicks','clicks']);
    const spendCol   = col(rows,['Spend','spend','Cost']);
    const salesCol   = col(rows,['Sales','14 Day Total Sales','sales']);

    const compMap=Object.fromEntries(compRows.map(r=>[String(r[kwCol]||'').trim().toLowerCase(),r]));

    return<div style={{padding:'24px',maxWidth:1100}}>
      {/* Upload section */}
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px',marginBottom:18}}>
        <div style={{fontSize:13,fontWeight:800,color:'#111',marginBottom:12,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-upload" style={{color}}/>Upload {type} Impression Share Report
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          <label style={{display:'flex',alignItems:'center',gap:8,padding:'10px 14px',border:`1.5px dashed ${isData?color:'#e0e0e0'}`,borderRadius:9,cursor:'pointer',background:isData?color+'08':'#fafafa'}}>
            <i className={`ti ${isData?'ti-check':'ti-file-upload'}`} style={{color:isData?color:'#aaa',fontSize:14}}/>
            <div>
              <div style={{fontSize:12,fontWeight:700,color:isData?color:'#555'}}>{isData?`✓ ${isData.rows.length} rows loaded`:`Current Period — ${type} IS Report`}</div>
              <div style={{fontSize:10,color:'#aaa'}}>CSV or Excel from Amazon Advertising Console</div>
            </div>
            <input type="file" accept=".csv,.xlsx,.xls" style={{display:'none'}} onChange={e=>e.target.files[0]&&handleISUpload(e.target.files[0],setData,setComp,false)}/>
          </label>
          <label style={{display:'flex',alignItems:'center',gap:8,padding:'10px 14px',border:`1.5px dashed ${isComp?'#6338c8':'#e0e0e0'}`,borderRadius:9,cursor:'pointer',background:isComp?'rgba(99,56,200,0.05)':'#fafafa'}}>
            <i className={`ti ${isComp?'ti-check':'ti-file-upload'}`} style={{color:isComp?'#6338c8':'#aaa',fontSize:14}}/>
            <div>
              <div style={{fontSize:12,fontWeight:700,color:isComp?'#6338c8':'#555'}}>{isComp?`✓ ${isComp.rows.length} rows loaded`:`Comparison Period — ${type} IS Report`}</div>
              <div style={{fontSize:10,color:'#aaa'}}>Upload previous period for comparison</div>
            </div>
            <input type="file" accept=".csv,.xlsx,.xls" style={{display:'none'}} onChange={e=>e.target.files[0]&&handleISUpload(e.target.files[0],setData,setComp,true)}/>
          </label>
        </div>
      </div>

      {!rows.length&&<div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'40px',textAlign:'center'}}>
        <i className="ti ti-chart-radar" style={{fontSize:40,color:'#ddd',display:'block',marginBottom:12}}/>
        <div style={{fontSize:14,fontWeight:700,color:'#555',marginBottom:6}}>{type} Impression Share data not loaded</div>
        <div style={{fontSize:12,color:'#aaa'}}>Download the {type} Impression Share report from Amazon Advertising → Reports → Campaign → Impression Share, then upload above</div>
      </div>}

      {rows.length>0&&<div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px'}}>
        <div style={{fontSize:14,fontWeight:800,color:'#111',marginBottom:16,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-eye" style={{color}}/>
          {type} Impression Share by Keyword / Target
          {isComp&&<span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:'rgba(26,95,160,0.1)',color:'#1a5fa0',fontWeight:700}}>vs Previous Period</span>}
          <span style={{fontSize:11,color:'#aaa',marginLeft:'auto'}}>{rows.length} keywords</span>
        </div>
        <div style={{overflowX:'auto',maxHeight:600,overflowY:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead style={{position:'sticky',top:0,zIndex:1}}>
              <tr>
                <th style={THL}>Keyword / Target</th>
                {campCol&&<th style={THL}>Campaign</th>}
                {imCol&&<th style={TH}>Impressions</th>}
                {isCol&&<th style={TH}>Imp. Share</th>}
                {isRankCol&&<th style={TH}>IS Rank</th>}
                {clicksCol&&<th style={TH}>Clicks</th>}
                {spendCol&&<th style={TH}>Spend</th>}
                {salesCol&&<th style={TH}>Sales</th>}
              </tr>
            </thead>
            <tbody>
              {rows.slice(0,200).map((r,i)=>{
                const kw=String(r[kwCol]||'').trim();
                const prev=compMap[kw.toLowerCase()];
                const isVal=n(r,isCol);
                const isColor=isVal===0?'#e05656':isVal<10?'#c47a00':isVal<30?'#1a5fa0':'#1a9e5f';
                return<tr key={i} style={{background:i%2===0?'#fff':'#fafbfd'}}>
                  <td style={{...TDL,maxWidth:280,fontWeight:500}}>{kw||'—'}</td>
                  {campCol&&<td style={{...TDL,fontSize:11,color:'#888',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{String(r[campCol]||'')}</td>}
                  {imCol&&<CmpCell cur={n(r,imCol)} comp={prev&&n(prev,imCol)} fmt="int"/>}
                  {isCol&&<td style={{...TD}}>
                    <div style={{fontWeight:700,color:isColor}}>{fmtP(isVal)}</div>
                    {prev&&<div style={{fontSize:10,color:'#aaa'}}>{fmtP(n(prev,isCol))} prev</div>}
                    <div style={{height:4,background:'#f0f0f0',borderRadius:2,marginTop:3,width:60}}>
                      <div style={{height:4,borderRadius:2,background:isColor,width:`${Math.min(100,isVal)}%`}}/>
                    </div>
                  </td>}
                  {isRankCol&&<td style={TD}><span style={{fontWeight:600,color:n(r,isRankCol)<=10?'#1a9e5f':n(r,isRankCol)<=50?'#c47a00':'#e05656'}}>#{n(r,isRankCol)}</span></td>}
                  {clicksCol&&<CmpCell cur={n(r,clicksCol)} comp={prev&&n(prev,clicksCol)} fmt="int"/>}
                  {spendCol&&<CmpCell cur={n(r,spendCol)} comp={prev&&n(prev,spendCol)} fmt="dollar"/>}
                  {salesCol&&<CmpCell cur={n(r,salesCol)} comp={prev&&n(prev,salesCol)} fmt="dollar"/>}
                </tr>;
              })}
            </tbody>
          </table>
        </div>
        {rows.length>200&&<div style={{padding:'10px',textAlign:'center',fontSize:11,color:'#aaa'}}>Showing 200 of {rows.length} rows</div>}
      </div>}
    </div>;
  }

  /* ── Empty state ── */
  function EmptyState(){
    return<div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:12,background:'#f7f7f7'}}>
      <i className="ti ti-chart-radar" style={{fontSize:44,color:'#ddd'}}/>
      <div style={{fontSize:14,fontWeight:700,color:'#555'}}>No data loaded</div>
      <div style={{fontSize:12,color:'#aaa',textAlign:'center'}}>Upload Campaign + Search Term reports in Data Hub first</div>
      <button onClick={()=>setTab('hub')} style={{padding:'8px 18px',borderRadius:8,border:'none',background:R,color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer',marginTop:4}}>
        Go to Data Hub →
      </button>
    </div>;
  }

  /* ── Section tabs ── */
  /* ══════════════════════════════════════════════════
     SECTION: SEARCH TERM DRILL-DOWN
     Select any ASIN or Keyword → see ALL search terms
     with their impression share, clicks, spend, orders
  ══════════════════════════════════════════════════ */
  const[drillType,setDrillType]=useState('asin'); // 'asin' | 'keyword'
  const[drillSearch,setDrillSearch]=useState('');
  const[drillSelected,setDrillSelected]=useState(null);

  const drillOptions=useMemo(()=>{
    const rows=parseRows(strCur||campCur);
    if(!rows.length)return[];
    if(drillType==='asin'){
      const asinCol=col(rows,['ASIN','Advertised ASIN','asin','advertised asin']);
      if(!asinCol)return[];
      return[...new Set(rows.map(r=>String(r[asinCol]||'').trim()).filter(Boolean))].sort();
    } else {
      const kwCol=col(rows,['Keyword','Target','Targeting','targeting','keyword']);
      if(!kwCol)return[];
      return[...new Set(rows.map(r=>String(r[kwCol]||'').trim()).filter(Boolean))].sort().slice(0,500);
    }
  },[strCur,campCur,drillType]);

  const drillFiltered=useMemo(()=>{
    if(!drillSearch&&!drillSelected)return[];
    const rows=parseRows(strCur||campCur);
    if(!rows.length)return[];
    const search=(drillSelected||drillSearch).toLowerCase();
    if(drillType==='asin'){
      const asinCol=col(rows,['ASIN','Advertised ASIN','asin']);
      const kwCol=col(rows,['Customer Search Term','Search Term','Query','keyword']);
      if(!asinCol)return[];
      return rows.filter(r=>String(r[asinCol]||'').toLowerCase()===search);
    } else {
      const kwCol=col(rows,['Keyword','Target','Targeting','targeting','keyword']);
      if(!kwCol)return[];
      return rows.filter(r=>String(r[kwCol]||'').toLowerCase()===search);
    }
  },[strCur,campCur,drillType,drillSearch,drillSelected]);

  function DrillDownSection(){
    if(!hasData)return<EmptyState/>;
    const spendCol2 = col(drillFiltered,['Spend','spend']);
    const salesCol2 = col(drillFiltered,['Sales','14 Day Total Sales']);
    const clicksCol2= col(drillFiltered,['Clicks','clicks']);
    const ordersCol2= col(drillFiltered,['Orders','14 Day Total Orders']);
    const imCol2    = col(drillFiltered,['Impressions','impressions']);
    const isCol2    = col(drillFiltered,['Impression Share','IS %']);
    const isRkCol2  = col(drillFiltered,['Impression Rank','IS Rank']);
    const kwCol2    = col(drillFiltered,['Customer Search Term','Search Term','Query','Keyword','keyword']);
    const mtCol2    = col(drillFiltered,['Match Type','match type']);
    const campCol2  = col(drillFiltered,['Campaign Name','Campaign','campaign']);

    const totals=drillFiltered.reduce((a,r)=>({
      spend:a.spend+n(r,spendCol2),
      sales:a.sales+n(r,salesCol2),
      clicks:a.clicks+n(r,clicksCol2),
      orders:a.orders+n(r,ordersCol2),
      impressions:a.impressions+n(r,imCol2),
    }),{spend:0,sales:0,clicks:0,orders:0,impressions:0});

    const filtSearch=drillSearch.toLowerCase();
    const suggestions=drillOptions.filter(o=>o.toLowerCase().includes(filtSearch)).slice(0,15);

    return<div style={{padding:'24px',maxWidth:1200}}>
      {/* Selector panel */}
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px',marginBottom:18}}>
        <div style={{fontSize:13,fontWeight:800,color:'#111',marginBottom:14,display:'flex',alignItems:'center',gap:8}}>
          <i className="ti ti-search" style={{color:R}}/>Search Term Drill-Down
          <span style={{fontSize:11,color:'#aaa',fontWeight:400}}>— Select an ASIN or Keyword to see all its search terms with full metrics</span>
        </div>
        <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'center'}}>
          {/* Type selector */}
          <div style={{display:'flex',borderRadius:8,overflow:'hidden',border:'1px solid #e0e0e0',flexShrink:0}}>
            {[{k:'asin',l:'By ASIN'},{k:'keyword',l:'By Keyword / Target'}].map(t=>(
              <button key={t.k} onClick={()=>{setDrillType(t.k);setDrillSearch('');setDrillSelected(null);}} style={{padding:'7px 16px',border:'none',background:drillType===t.k?R:'#fff',color:drillType===t.k?'#fff':'#555',fontSize:12,fontWeight:drillType===t.k?700:500,cursor:'pointer'}}>
                {t.l}
              </button>
            ))}
          </div>

          {/* Search input with autocomplete */}
          <div style={{position:'relative',flex:1,minWidth:240}}>
            <input value={drillSearch} onChange={e=>{setDrillSearch(e.target.value);setDrillSelected(null);}}
              placeholder={drillType==='asin'?'Type ASIN (e.g. B08XYZ...)':'Type keyword or target...'}
              style={{width:'100%',padding:'8px 36px 8px 12px',borderRadius:8,border:'1.5px solid #e0e0e0',fontSize:13,outline:'none',boxSizing:'border-box'}}/>
            {drillSearch&&<button onClick={()=>{setDrillSearch('');setDrillSelected(null);}} style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',border:'none',background:'transparent',cursor:'pointer',color:'#aaa',fontSize:14}}>×</button>}
            {/* Dropdown suggestions */}
            {drillSearch&&!drillSelected&&suggestions.length>0&&(
              <div style={{position:'absolute',top:'calc(100% + 4px)',left:0,right:0,background:'#fff',border:'1px solid #e8ebf2',borderRadius:8,boxShadow:'0 4px 16px rgba(0,0,0,0.1)',zIndex:99,maxHeight:200,overflowY:'auto'}}>
                {suggestions.map((s,i)=>(
                  <button key={i} onClick={()=>{setDrillSelected(s);setDrillSearch(s);}} style={{width:'100%',padding:'8px 12px',border:'none',background:i%2===0?'#fff':'#fafbfd',textAlign:'left',cursor:'pointer',fontSize:12,color:'#333',display:'block'}}>
                    {s}
                  </button>
                ))}
                {drillOptions.filter(o=>o.toLowerCase().includes(drillSearch.toLowerCase())).length>15&&(
                  <div style={{padding:'6px 12px',fontSize:11,color:'#aaa'}}>Type more to narrow results...</div>
                )}
              </div>
            )}
          </div>

          {drillFiltered.length>0&&<span style={{fontSize:12,color:'#1a9e5f',fontWeight:700,flexShrink:0}}>
            {drillFiltered.length} search terms found
          </span>}
        </div>
      </div>

      {/* Results */}
      {drillFiltered.length===0&&(drillSearch||drillSelected)&&(
        <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'30px',textAlign:'center',color:'#aaa'}}>
          <i className="ti ti-search" style={{fontSize:32,display:'block',marginBottom:8,color:'#ddd'}}/>
          No search terms found for "{drillSelected||drillSearch}"
        </div>
      )}

      {drillFiltered.length===0&&!drillSearch&&!drillSelected&&(
        <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'40px',textAlign:'center'}}>
          <i className="ti ti-zoom-scan" style={{fontSize:40,color:'#ddd',display:'block',marginBottom:12}}/>
          <div style={{fontSize:14,fontWeight:700,color:'#555',marginBottom:6}}>Select an ASIN or Keyword above</div>
          <div style={{fontSize:12,color:'#aaa'}}>The drill-down will show every search term that triggered that ASIN or keyword, with spend, sales, clicks, impression share and more</div>
        </div>
      )}

      {drillFiltered.length>0&&(
        <>
          {/* Totals summary */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:10,marginBottom:14}}>
            {[
              {l:'Total Spend',v:fmtD(totals.spend),c:'#4f46e5'},
              {l:'Total Sales',v:fmtD(totals.sales),c:'#1a9e5f'},
              {l:'Total Clicks',v:fmtN(totals.clicks),c:'#1a5fa0'},
              {l:'Total Orders',v:fmtN(totals.orders),c:'#6338c8'},
              {l:'ACOS',v:totals.sales>0?fmtP((totals.spend/totals.sales)*100):'—',c:totals.sales>0&&(totals.spend/totals.sales)*100>30?'#e05656':'#1a9e5f'},
            ].map((k,i)=>(
              <div key={i} style={{background:'#fff',borderRadius:9,border:'1px solid #e8ebf2',padding:'10px 14px',textAlign:'center'}}>
                <div style={{fontSize:16,fontWeight:800,color:k.c}}>{k.v}</div>
                <div style={{fontSize:10,color:'#888',fontWeight:600,textTransform:'uppercase',marginTop:2}}>{k.l}</div>
              </div>
            ))}
          </div>

          {/* Table */}
          <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #f0f0f0',fontSize:13,fontWeight:700,color:'#111',display:'flex',alignItems:'center',gap:8}}>
              <i className="ti ti-list" style={{color:R}}/>
              Search Terms for: <span style={{color:R}}>{drillSelected||drillSearch}</span>
              <span style={{marginLeft:'auto',fontSize:11,color:'#aaa'}}>{drillFiltered.length} rows</span>
            </div>
            <div style={{overflowX:'auto',maxHeight:500,overflowY:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                <thead style={{position:'sticky',top:0,zIndex:1}}>
                  <tr>
                    <th style={THL}>Search Term</th>
                    {mtCol2&&<th style={TH}>Match Type</th>}
                    {campCol2&&<th style={THL}>Campaign</th>}
                    {imCol2&&<th style={TH}>Impressions</th>}
                    {isCol2&&<th style={TH}>IS%</th>}
                    {isRkCol2&&<th style={TH}>IS Rank</th>}
                    {clicksCol2&&<th style={TH}>Clicks</th>}
                    {ordersCol2&&<th style={TH}>Orders</th>}
                    <th style={TH}>CVR</th>
                    {spendCol2&&<th style={TH}>Spend</th>}
                    {salesCol2&&<th style={TH}>Sales</th>}
                    <th style={TH}>ACOS</th>
                  </tr>
                </thead>
                <tbody>
                  {drillFiltered.map((r,i)=>{
                    const sp=n(r,spendCol2),sa=n(r,salesCol2),cl=n(r,clicksCol2),or=n(r,ordersCol2);
                    const acos=sa>0?(sp/sa)*100:0;
                    const cvr=cl>0?(or/cl)*100:0;
                    const isVal=n(r,isCol2);
                    const isColor=isVal===0?'#e05656':isVal<10?'#c47a00':isVal<30?'#1a5fa0':'#1a9e5f';
                    const mt=String(r[mtCol2]||'').trim().toUpperCase();
                    const mtColor=MT_COLORS[mt==='AUTO'?'Auto':mt==='PHRASE'?'Phrase':mt==='EXACT'?'Exact':mt.includes('PRODUCT')||mt.includes('PT')?'Product Targeting':'Broad']||'#888';
                    return<tr key={i} style={{background:i%2===0?'#fff':'#fafbfd'}}>
                      <td style={{...TDL,fontWeight:500,maxWidth:250,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}
                        title={String(r[kwCol2]||'')}>{String(r[kwCol2]||'—')}</td>
                      {mtCol2&&<td style={TD}><span style={{padding:'1px 6px',borderRadius:4,background:mtColor+'18',color:mtColor,fontSize:10,fontWeight:700}}>{mt}</span></td>}
                      {campCol2&&<td style={{...TDL,fontSize:11,color:'#888',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{String(r[campCol2]||'')}</td>}
                      {imCol2&&<td style={TD}>{fmtN(n(r,imCol2))}</td>}
                      {isCol2&&<td style={TD}>
                        <span style={{fontWeight:700,color:isColor}}>{isVal>0?fmtP(isVal):'—'}</span>
                        {isVal>0&&<div style={{height:3,background:'#f0f0f0',borderRadius:2,marginTop:2,width:50}}>
                          <div style={{height:3,borderRadius:2,background:isColor,width:`${Math.min(100,isVal)}%`}}/>
                        </div>}
                      </td>}
                      {isRkCol2&&<td style={TD}>{n(r,isRkCol2)>0?<span style={{fontWeight:600,color:n(r,isRkCol2)<=10?'#1a9e5f':n(r,isRkCol2)<=50?'#c47a00':'#e05656'}}>#{n(r,isRkCol2)}</span>:'—'}</td>}
                      {clicksCol2&&<td style={TD}>{fmtN(cl)}</td>}
                      {ordersCol2&&<td style={TD}><strong>{or}</strong></td>}
                      <td style={TD}><span style={{color:cvr>10?'#1a9e5f':cvr>0?'#555':'#aaa'}}>{cl>0?fmtP(cvr):'—'}</span></td>
                      {spendCol2&&<td style={TD}>{fmtD(sp)}</td>}
                      {salesCol2&&<td style={TD}><strong style={{color:'#1a9e5f'}}>{fmtD(sa)}</strong></td>}
                      <td style={TD}><span style={{fontWeight:700,color:sa>0&&acos>30?'#e05656':sa>0?'#1a9e5f':'#aaa'}}>{sa>0?fmtP(acos):'—'}</span></td>
                    </tr>;
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>;
  }

  const SECTIONS=[
    {k:'overview',  label:'Overview',            icon:'ti-layout-dashboard', color:'#4f46e5'},
    {k:'matchtype', label:'Match Type Intel',     icon:'ti-list-check',       color:'#1a5fa0'},
    {k:'portfolio', label:'Portfolio Intel',      icon:'ti-briefcase',        color:'#6338c8'},
    {k:'drilldown', label:'Search Term Drill-Down',icon:'ti-zoom-scan',       color:'#c47a00'},
    {k:'spis',      label:'SP Impression Share',  icon:'ti-eye',              color:'#1a9e5f'},
    {k:'sbis',      label:'SB Impression Share',  icon:'ti-eye-check',        color:'#c47a00'},
  ];

  const RENDER={
    overview:  <OverviewSection/>,
    matchtype: <MatchTypeSection/>,
    portfolio: <PortfolioSection/>,
    drilldown: <DrillDownSection/>,
    spis:      <ISSection type="SP"/>,
    sbis:      <ISSection type="SB"/>,
  };

  return<div style={{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'}}>
    {/* Header */}
    <div style={{padding:'12px 20px',borderBottom:'1px solid #f0f0f0',flexShrink:0,background:'#fff',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
      <i className="ti ti-chart-radar" style={{fontSize:15,color:R}}/>
      <span style={{fontSize:15,fontWeight:800,color:'#111'}}>STIN</span>
      <span style={{fontSize:11,color:'#888',fontWeight:400}}>Search Term Insight Navigator</span>
      <span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:'rgba(26,122,60,0.1)',color:'#1a7a3c',fontWeight:700}}>Core</span>
      {!hasData&&<span style={{fontSize:11,color:'#c47a00',fontWeight:600}}>⚠ Upload Campaign report in Data Hub</span>}
      {hasData&&<span style={{fontSize:11,color:'#1a9e5f',fontWeight:600}}>✓ {(campCur?.rows?.length||0).toLocaleString()} campaign rows loaded</span>}
      {compAgg&&<span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:'rgba(99,56,200,0.08)',color:'#6338c8',fontWeight:700}}>📊 Comparison period active</span>}
    </div>

    {/* Section tabs */}
    <div style={{display:'flex',borderBottom:'1px solid #f0f0f0',background:'#fff',flexShrink:0,overflowX:'auto'}}>
      {SECTIONS.map(s=>(
        <button key={s.k} onClick={()=>setSec(s.k)} style={{display:'flex',alignItems:'center',gap:6,padding:'10px 18px',border:'none',borderBottom:`2px solid ${sec===s.k?s.color:'transparent'}`,background:'transparent',cursor:'pointer',fontSize:12,fontWeight:sec===s.k?700:500,color:sec===s.k?s.color:'#666',whiteSpace:'nowrap',flexShrink:0}}>
          <i className={`ti ${s.icon}`} style={{fontSize:12}}/>{s.label}
        </button>
      ))}
    </div>

    {/* Content */}
    <div style={{flex:1,overflow:'auto',background:'#f4f6fb'}}>
      {RENDER[sec]||<OverviewSection/>}
    </div>
  </div>;
}



/* ================================================================
   MODULE 1: PROFIT INTELLIGENCE
   True profit per ASIN after COGS + FBA fees + PPC spend
   Break-even ACOS calculator, margin-aware campaign analysis
================================================================ */
const PROFIT_KEY = 'rq_profit_products_v1';
function loadProfitProducts(){ try{ return JSON.parse(localStorage.getItem(PROFIT_KEY)||'[]'); }catch{ return []; } }
function saveProfitProducts(p){ try{ localStorage.setItem(PROFIT_KEY, JSON.stringify(p)); }catch{} }

function ProfitIntelModule({globalData,setTab}){
  const campData = globalData?.cur?.primary || globalData?.cur?.campaign;
  const asinData = globalData?.cur?.asin;
  const compCamp = globalData?.comp?.primary || globalData?.comp?.campaign;

  const[products,setProducts] = useState(loadProfitProducts);
  const[editRow,setEditRow]   = useState(null);
  const[sec,setSec]           = useState('dashboard');
  const[newRow,setNewRow]     = useState({asin:'',name:'',price:0,cogs:0,fbaFee:0,referralPct:15});

  const FBA_TIERS = [
    {label:'Small Standard (<1lb)',fee:3.22},{label:'Large Standard (1-2lb)',fee:4.11},
    {label:'Large Standard (2-3lb)',fee:5.40},{label:'Large Standard (3-20lb)',fee:7.17},
    {label:'Small Oversize',fee:9.61},{label:'Medium Oversize',fee:19.35},
  ];

  function saveProduct(p){
    const updated = products.find(x=>x.asin===p.asin)
      ? products.map(x=>x.asin===p.asin?p:x)
      : [...products, {...p, id:Date.now()}];
    setProducts(updated); saveProfitProducts(updated); setEditRow(null);
  }
  function deleteProduct(asin){ const u=products.filter(x=>x.asin!==asin); setProducts(u); saveProfitProducts(u); }

  /* Calc profit metrics per product */
  function calcMetrics(p){
    const referralFee = (p.price * (p.referralPct||15)) / 100;
    const totalCosts  = p.cogs + p.fbaFee + referralFee;
    const grossProfit = p.price - totalCosts;
    const breakEvenAcos = p.price > 0 ? (grossProfit / p.price) * 100 : 0;
    return { referralFee, totalCosts, grossProfit, breakEvenAcos,
      netMargin: p.price > 0 ? (grossProfit / p.price) * 100 : 0 };
  }

  /* Aggregate ad spend/sales per ASIN from campaign data */
  const adByAsin = useMemo(()=>{
    const rows = asinData?.rows || campData?.rows || [];
    if(!rows.length) return {};
    const map = {};
    rows.forEach(r=>{
      const asin = String(r['Advertised ASIN']||r['ASIN']||'').trim().toUpperCase();
      if(!asin) return;
      if(!map[asin]) map[asin]={spend:0,sales:0,orders:0,clicks:0};
      const sp = parseFloat(String(r['Spend']||r['spend']||0).replace(/[$,]/g,''))||0;
      const sa = parseFloat(String(r['Sales']||r['14 Day Total Sales']||0).replace(/[$,]/g,''))||0;
      const or = parseFloat(String(r['Orders']||r['14 Day Total Orders']||0))||0;
      const cl = parseFloat(String(r['Clicks']||0))||0;
      map[asin].spend+=sp; map[asin].sales+=sa; map[asin].orders+=or; map[asin].clicks+=cl;
    });
    return map;
  },[asinData,campData]);

  /* Enriched products with ad + profit data */
  const enriched = useMemo(()=>products.map(p=>{
    const m = calcMetrics(p);
    const ad = adByAsin[p.asin.toUpperCase()]||{spend:0,sales:0,orders:0};
    const ppcCostPerUnit = ad.orders>0 ? ad.spend/ad.orders : 0;
    const profitAfterPPC = m.grossProfit - ppcCostPerUnit;
    const actualAcos = ad.sales>0 ? (ad.spend/ad.sales)*100 : null;
    const isLoss = actualAcos!=null && actualAcos > m.breakEvenAcos;
    const roi = m.totalCosts>0 ? (m.grossProfit/m.totalCosts)*100 : 0;
    return{...p,...m,ad,ppcCostPerUnit,profitAfterPPC,actualAcos,isLoss,roi};
  }),[products,adByAsin]);

  const fmtD=v=>`$${Math.abs(v||0).toFixed(2)}`;
  const fmtP=v=>`${(v||0).toFixed(1)}%`;
  const R='#4f46e5';

  const SECS=[
    {k:'dashboard',label:'Dashboard',    icon:'ti-layout-dashboard'},
    {k:'products', label:'Product Setup', icon:'ti-package'},
    {k:'campaigns',label:'Campaign P&L',  icon:'ti-chart-bar'},
  ];

  /* ── Product Setup form ── */
  function ProductForm({p,onSave,onCancel}){
    const[d,setD]=useState(p||{asin:'',name:'',price:0,cogs:0,fbaFee:0,referralPct:15});
    const m=calcMetrics(d);
    const inp=(field,type='number')=>(
      <input type={type} value={d[field]} onChange={e=>setD(v=>({...v,[field]:type==='number'?parseFloat(e.target.value)||0:e.target.value}))}
        style={{width:'100%',padding:'7px 10px',borderRadius:7,border:'1.5px solid #e0e0e0',fontSize:13,outline:'none',boxSizing:'border-box'}}/>
    );
    return(
      <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px',marginBottom:16}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:12}}>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>ASIN *</label>{inp('asin','text')}</div>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Product Name</label>{inp('name','text')}</div>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Selling Price ($)</label>{inp('price')}</div>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>COGS / Unit ($)</label>{inp('cogs')}</div>
          <div>
            <label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>FBA Fulfillment Fee ($)</label>
            <div style={{display:'flex',gap:6}}>
              {inp('fbaFee')}
              <select onChange={e=>setD(v=>({...v,fbaFee:parseFloat(e.target.value)}))} style={{padding:'7px 8px',borderRadius:7,border:'1.5px solid #e0e0e0',fontSize:11,background:'#fff',cursor:'pointer'}}>
                <option value="">Quick select</option>
                {FBA_TIERS.map(t=><option key={t.label} value={t.fee}>{t.label} — ${t.fee}</option>)}
              </select>
            </div>
          </div>
          <div><label style={{fontSize:11,fontWeight:700,color:'#555',display:'block',marginBottom:4}}>Amazon Referral Fee (%)</label>{inp('referralPct')}</div>
        </div>
        {/* Live preview */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,padding:'12px',background:'#f8f9fc',borderRadius:9,marginBottom:12}}>
          {[
            {l:'Referral Fee',v:fmtD(m.referralFee),c:'#555'},
            {l:'Total Costs/Unit',v:fmtD(m.totalCosts),c:'#e05656'},
            {l:'Gross Profit/Unit',v:fmtD(m.grossProfit),c:m.grossProfit>0?'#1a9e5f':'#e05656'},
            {l:'Break-Even ACOS',v:fmtP(m.breakEvenAcos),c:m.breakEvenAcos>0?'#1a5fa0':'#e05656'},
          ].map((k,i)=><div key={i} style={{textAlign:'center'}}>
            <div style={{fontSize:15,fontWeight:800,color:k.c}}>{k.v}</div>
            <div style={{fontSize:10,color:'#888',fontWeight:600,textTransform:'uppercase'}}>{k.l}</div>
          </div>)}
        </div>
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>onSave(d)} style={{padding:'8px 20px',borderRadius:8,border:'none',background:R,color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer'}}>Save Product</button>
          {onCancel&&<button onClick={onCancel} style={{padding:'8px 16px',borderRadius:8,border:'1px solid #e0e0e0',background:'#fff',color:'#555',fontSize:12,cursor:'pointer'}}>Cancel</button>}
        </div>
      </div>
    );
  }

  return(
    <div style={{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'}}>
      <div style={{padding:'12px 20px',borderBottom:'1px solid #f0f0f0',flexShrink:0,background:'#fff',display:'flex',alignItems:'center',gap:10}}>
        <i className="ti ti-coin" style={{fontSize:15,color:'#1a9e5f'}}/>
        <span style={{fontSize:15,fontWeight:800,color:'#111'}}>Profit Intelligence</span>
        <span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:'rgba(26,158,95,0.1)',color:'#1a9e5f',fontWeight:700}}>Core</span>
        {products.length>0&&<span style={{fontSize:11,color:'#888'}}>{products.length} products configured</span>}
        {!campData?.rows?.length&&<span style={{fontSize:11,color:'#c47a00',fontWeight:600}}>⚠ Upload Campaign report in Data Hub for ad metrics</span>}
      </div>

      <div style={{display:'flex',borderBottom:'1px solid #f0f0f0',background:'#fff',flexShrink:0}}>
        {SECS.map(s=><button key={s.k} onClick={()=>setSec(s.k)} style={{display:'flex',alignItems:'center',gap:6,padding:'10px 18px',border:'none',borderBottom:`2px solid ${sec===s.k?'#1a9e5f':'transparent'}`,background:'transparent',cursor:'pointer',fontSize:12,fontWeight:sec===s.k?700:500,color:sec===s.k?'#1a9e5f':'#666'}}>
          <i className={`ti ${s.icon}`} style={{fontSize:12}}/>{s.label}
        </button>)}
      </div>

      <div style={{flex:1,overflow:'auto',background:'#f4f6fb',padding:'24px'}}>

        {sec==='dashboard'&&(
          <>
            {enriched.length===0?(
              <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'40px',textAlign:'center'}}>
                <i className="ti ti-coin" style={{fontSize:40,color:'#ddd',display:'block',marginBottom:12}}/>
                <div style={{fontSize:14,fontWeight:700,color:'#555',marginBottom:6}}>No products configured yet</div>
                <div style={{fontSize:12,color:'#aaa',marginBottom:16}}>Go to Product Setup tab and add your ASINs with COGS, FBA fees, and selling price</div>
                <button onClick={()=>setSec('products')} style={{padding:'8px 20px',borderRadius:8,border:'none',background:'#1a9e5f',color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer'}}>Set Up Products →</button>
              </div>
            ):(
              <>
                {/* Alert bar */}
                {enriched.filter(p=>p.isLoss).length>0&&(
                  <div style={{background:'rgba(212,43,43,0.08)',border:'1px solid rgba(212,43,43,0.25)',borderRadius:10,padding:'12px 16px',marginBottom:16,display:'flex',alignItems:'center',gap:10}}>
                    <i className="ti ti-alert-triangle" style={{fontSize:16,color:'#d42b2b',flexShrink:0}}/>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:'#d42b2b'}}>{enriched.filter(p=>p.isLoss).length} ASINs advertising at a LOSS</div>
                      <div style={{fontSize:11,color:'#888'}}>These ASINs have actual ACOS above their break-even ACOS — every ad click loses money</div>
                    </div>
                  </div>
                )}

                {/* Summary KPIs */}
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:16}}>
                  {[
                    {l:'Avg Break-Even ACOS',v:fmtP(enriched.reduce((s,p)=>s+p.breakEvenAcos,0)/enriched.length),c:'#1a5fa0',icon:'ti-percentage'},
                    {l:'Avg Gross Margin',v:fmtP(enriched.reduce((s,p)=>s+p.netMargin,0)/enriched.length),c:'#1a9e5f',icon:'ti-trending-up'},
                    {l:'Profitable ASINs',v:`${enriched.filter(p=>!p.isLoss||!p.actualAcos).length}/${enriched.length}`,c:'#1a9e5f',icon:'ti-check'},
                    {l:'Loss-Making ASINs',v:enriched.filter(p=>p.isLoss).length,c:'#d42b2b',icon:'ti-alert-triangle'},
                  ].map((k,i)=>(
                    <div key={i} style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'14px 16px'}}>
                      <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:6}}>
                        <i className={`ti ${k.icon}`} style={{fontSize:13,color:k.c}}/>
                        <span style={{fontSize:10,color:'#888',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.4px'}}>{k.l}</span>
                      </div>
                      <div style={{fontSize:22,fontWeight:800,color:k.c}}>{k.v}</div>
                    </div>
                  ))}
                </div>

                {/* Product table */}
                <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',overflow:'hidden'}}>
                  <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                    <thead><tr style={{background:'#f8f9fc'}}>
                      {['ASIN / Product','Price','COGS','FBA Fee','Gross Profit/Unit','Break-Even ACOS','Actual ACOS','Profit After PPC','Status'].map(h=>(
                        <th key={h} style={{padding:'10px 12px',textAlign:h.includes('ASIN')?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11,whiteSpace:'nowrap'}}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {enriched.map((p,i)=>(
                        <tr key={i} style={{background:p.isLoss?'rgba(212,43,43,0.03)':i%2===0?'#fff':'#fafbfd',borderBottom:'1px solid #f0f2f7'}}>
                          <td style={{padding:'10px 12px',fontWeight:600,color:'#111'}}>
                            <div style={{fontWeight:700}}>{p.asin}</div>
                            {p.name&&<div style={{fontSize:11,color:'#888',fontWeight:400}}>{p.name}</div>}
                          </td>
                          <td style={{padding:'10px 12px',textAlign:'right'}}>{fmtD(p.price)}</td>
                          <td style={{padding:'10px 12px',textAlign:'right',color:'#e05656'}}>{fmtD(p.cogs)}</td>
                          <td style={{padding:'10px 12px',textAlign:'right',color:'#e05656'}}>{fmtD(p.fbaFee)}</td>
                          <td style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:p.grossProfit>0?'#1a9e5f':'#d42b2b'}}>{fmtD(p.grossProfit)}</td>
                          <td style={{padding:'10px 12px',textAlign:'right'}}>
                            <span style={{fontWeight:700,color:'#1a5fa0',background:'rgba(26,95,160,0.08)',padding:'2px 8px',borderRadius:6}}>{fmtP(p.breakEvenAcos)}</span>
                          </td>
                          <td style={{padding:'10px 12px',textAlign:'right'}}>
                            {p.actualAcos!=null?(
                              <span style={{fontWeight:700,color:p.isLoss?'#d42b2b':'#1a9e5f',background:p.isLoss?'rgba(212,43,43,0.08)':'rgba(26,158,95,0.08)',padding:'2px 8px',borderRadius:6}}>
                                {fmtP(p.actualAcos)}
                              </span>
                            ):<span style={{color:'#aaa'}}>No ad data</span>}
                          </td>
                          <td style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:p.profitAfterPPC>0?'#1a9e5f':'#d42b2b'}}>
                            {p.ad?.orders>0?fmtD(p.profitAfterPPC):<span style={{color:'#aaa'}}>—</span>}
                          </td>
                          <td style={{padding:'10px 12px',textAlign:'right'}}>
                            {p.actualAcos==null?<span style={{fontSize:10,color:'#aaa'}}>No ads</span>
                            :p.isLoss?<span style={{fontSize:10,fontWeight:700,color:'#d42b2b',background:'rgba(212,43,43,0.08)',padding:'2px 7px',borderRadius:6}}>🔴 LOSS</span>
                            :<span style={{fontSize:10,fontWeight:700,color:'#1a9e5f',background:'rgba(26,158,95,0.08)',padding:'2px 7px',borderRadius:6}}>✓ PROFIT</span>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </>
        )}

        {sec==='products'&&(
          <>
            <div style={{marginBottom:16}}>
              <div style={{fontSize:14,fontWeight:800,color:'#111',marginBottom:4}}>Add / Edit Products</div>
              <div style={{fontSize:12,color:'#888'}}>Enter COGS, FBA fee, and selling price to calculate your true break-even ACOS and profit per unit</div>
            </div>
            <ProductForm p={null} onSave={saveProduct}/>
            {products.map((p,i)=>(
              <div key={i} style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'12px 16px',marginBottom:8,display:'flex',alignItems:'center',gap:12}}>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,color:'#111'}}>{p.asin}</div>
                  <div style={{fontSize:11,color:'#888'}}>{p.name||'—'} · Price: {fmtD(p.price)} · COGS: {fmtD(p.cogs)} · FBA: {fmtD(p.fbaFee)} · Break-Even: <strong style={{color:'#1a5fa0'}}>{fmtP(calcMetrics(p).breakEvenAcos)}</strong></div>
                </div>
                <button onClick={()=>setEditRow(editRow===p.asin?null:p.asin)} style={{padding:'5px 12px',borderRadius:7,border:'1px solid #e0e0e0',background:'#fff',cursor:'pointer',fontSize:11,color:'#555',fontWeight:600}}>Edit</button>
                <button onClick={()=>deleteProduct(p.asin)} style={{padding:'5px 10px',borderRadius:7,border:'1px solid rgba(212,43,43,0.2)',background:'rgba(212,43,43,0.05)',cursor:'pointer',fontSize:11,color:'#d42b2b',fontWeight:600}}>Delete</button>
              </div>
            ))}
          </>
        )}

        {sec==='campaigns'&&(
          <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'20px'}}>
            <div style={{fontSize:14,fontWeight:800,color:'#111',marginBottom:16}}>Campaign P&L — Spend vs Profit Contribution</div>
            {!campData?.rows?.length?(
              <div style={{textAlign:'center',padding:40,color:'#aaa'}}>
                <i className="ti ti-chart-bar" style={{fontSize:36,display:'block',marginBottom:10,color:'#ddd'}}/>
                Upload Campaign report in Data Hub to see campaign-level profitability
                <div style={{marginTop:12}}><button onClick={()=>setTab('hub')} style={{padding:'7px 18px',borderRadius:8,border:'none',background:R,color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer'}}>Go to Data Hub →</button></div>
              </div>
            ):(
              <div style={{fontSize:12,color:'#888'}}>Campaign-level P&L requires products to be configured with COGS data. {products.length===0?'Add products in the Product Setup tab first.':'Showing profit analysis below.'}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   MODULE 4: BUDGET PACING & FORECASTING
   Daily spend pace, month-end projection, over/under alerts
================================================================ */
const BUDGET_KEY = 'rq_budgets_v1';
function loadBudgets(){ try{ return JSON.parse(localStorage.getItem(BUDGET_KEY)||'{}'); }catch{ return {}; } }
function saveBudgets(b){ try{ localStorage.setItem(BUDGET_KEY, JSON.stringify(b)); }catch{} }

function BudgetPacingModule({globalData,setTab}){
  const campData = globalData?.cur?.primary || globalData?.cur?.campaign;
  const[budgets,setBudgets] = useState(loadBudgets);
  const[editingBudget,setEditingBudget] = useState(null);
  const[newBudgetVal,setNewBudgetVal] = useState('');

  const today = new Date();
  const daysInMonth = new Date(today.getFullYear(), today.getMonth()+1, 0).getDate();
  const dayOfMonth  = today.getDate();
  const daysLeft    = daysInMonth - dayOfMonth;
  const pctMonthElapsed = (dayOfMonth / daysInMonth) * 100;

  /* Group spend by portfolio */
  const spendByPort = useMemo(()=>{
    const rows = campData?.rows||[];
    if(!rows.length) return {};
    const map={};
    rows.forEach(r=>{
      const port = String(r['Portfolio Name']||r['Portfolio name']||'(No Portfolio)').trim()||'(No Portfolio)';
      const sp = parseFloat(String(r['Spend']||r['spend']||0).replace(/[$,]/g,''))||0;
      map[port] = (map[port]||0) + sp;
    });
    return map;
  },[campData]);

  const totalSpend = Object.values(spendByPort).reduce((a,b)=>a+b,0);
  const totalBudget = Object.values(budgets).reduce((a,b)=>a+(parseFloat(b)||0),0);

  /* Pacing calculations */
  function getPacing(portName){
    const spent = spendByPort[portName]||0;
    const budget = parseFloat(budgets[portName])||0;
    if(!budget) return null;
    const projectedSpend = dayOfMonth > 0 ? (spent / dayOfMonth) * daysInMonth : 0;
    const dailyBudget = budget / daysInMonth;
    const dailyActual = dayOfMonth > 0 ? spent / dayOfMonth : 0;
    const remaining = budget - spent;
    const pctUsed = (spent / budget) * 100;
    const pacing = pctUsed - pctMonthElapsed; // positive = overpacing, negative = underpacing
    const status = Math.abs(pacing) < 5 ? 'on_track' : pacing > 5 ? 'over' : 'under';
    return{spent,budget,projectedSpend,dailyBudget,dailyActual,remaining,pctUsed,pacing,status};
  }

  const fmtD = v => `$${(v||0).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0})}`;
  const fmtP = v => `${(v||0).toFixed(1)}%`;
  const R = '#4f46e5';
  const STATUS_COLOR = {on_track:'#1a9e5f',over:'#d42b2b',under:'#c47a00'};
  const STATUS_LABEL = {on_track:'On Track',over:'Overpacing',under:'Underpacing'};
  const STATUS_BG = {on_track:'rgba(26,158,95,0.08)',over:'rgba(212,43,43,0.08)',under:'rgba(196,122,0,0.08)'};

  const allPorts = [...new Set([...Object.keys(spendByPort),...Object.keys(budgets)])].sort();

  return(
    <div style={{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'}}>
      <div style={{padding:'12px 20px',borderBottom:'1px solid #f0f0f0',flexShrink:0,background:'#fff',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        <i className="ti ti-chart-arcs" style={{fontSize:15,color:'#6338c8'}}/>
        <span style={{fontSize:15,fontWeight:800,color:'#111'}}>Budget Pacing</span>
        <span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:'rgba(99,56,200,0.1)',color:'#6338c8',fontWeight:700}}>Core</span>
        <span style={{fontSize:11,color:'#888'}}>Day {dayOfMonth} of {daysInMonth} · {fmtP(pctMonthElapsed)} of month elapsed</span>
        {!campData?.rows?.length&&<span style={{fontSize:11,color:'#c47a00',fontWeight:600}}>⚠ Upload Campaign report for spend data</span>}
      </div>

      <div style={{flex:1,overflow:'auto',background:'#f4f6fb',padding:'24px',maxWidth:1100}}>

        {/* Account-level summary */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
          {[
            {l:'Total Spent (MTD)',      v:fmtD(totalSpend),c:'#4f46e5',icon:'ti-coin'},
            {l:'Total Monthly Budget',   v:fmtD(totalBudget),c:'#1a5fa0',icon:'ti-target'},
            {l:'Remaining Budget',       v:fmtD(totalBudget-totalSpend),c:totalBudget>0&&totalSpend>totalBudget?'#d42b2b':'#1a9e5f',icon:'ti-wallet'},
            {l:'Projected Month-End',    v:totalBudget>0?fmtD(dayOfMonth>0?(totalSpend/dayOfMonth)*daysInMonth:0):'Set budgets',c:'#6338c8',icon:'ti-chart-line'},
          ].map((k,i)=>(
            <div key={i} style={{background:'#fff',borderRadius:10,border:'1px solid #e8ebf2',padding:'14px 16px'}}>
              <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:6}}>
                <i className={`ti ${k.icon}`} style={{fontSize:13,color:k.c}}/>
                <span style={{fontSize:10,color:'#888',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.4px'}}>{k.l}</span>
              </div>
              <div style={{fontSize:20,fontWeight:800,color:k.c}}>{k.v}</div>
            </div>
          ))}
        </div>

        {/* Portfolio pacing table */}
        <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',overflow:'hidden',marginBottom:20}}>
          <div style={{padding:'14px 18px',borderBottom:'1px solid #f0f0f0',display:'flex',alignItems:'center',gap:10}}>
            <span style={{fontSize:13,fontWeight:800,color:'#111'}}>Portfolio Budget Pacing</span>
            <span style={{marginLeft:'auto',fontSize:11,color:'#aaa'}}>Set monthly budgets to track pacing</span>
          </div>
          {allPorts.length===0?(
            <div style={{padding:'30px',textAlign:'center',color:'#aaa',fontSize:12}}>
              No portfolio data — upload Campaign report in Data Hub first
            </div>
          ):(
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead><tr style={{background:'#f8f9fc'}}>
                {['Portfolio','MTD Spend','Monthly Budget','% Used','Projected End','Remaining','Daily Rate','Status',''].map(h=>(
                  <th key={h} style={{padding:'9px 12px',textAlign:h===''||h==='Portfolio'?'left':'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',whiteSpace:'nowrap',fontSize:11}}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {allPorts.map((port,i)=>{
                  const p = getPacing(port);
                  const spent = spendByPort[port]||0;
                  return(
                    <tr key={i} style={{background:i%2===0?'#fff':'#fafbfd',borderBottom:'1px solid #f0f2f7'}}>
                      <td style={{padding:'10px 12px',fontWeight:600,color:'#111',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{port}</td>
                      <td style={{padding:'10px 12px',textAlign:'right',fontWeight:700}}>{fmtD(spent)}</td>
                      <td style={{padding:'10px 12px',textAlign:'right'}}>
                        {editingBudget===port?(
                          <div style={{display:'flex',gap:4,justifyContent:'flex-end'}}>
                            <input autoFocus type="number" value={newBudgetVal} onChange={e=>setNewBudgetVal(e.target.value)}
                              onKeyDown={e=>{if(e.key==='Enter'){const u={...budgets,[port]:parseFloat(newBudgetVal)||0};setBudgets(u);saveBudgets(u);setEditingBudget(null);}if(e.key==='Escape')setEditingBudget(null);}}
                              style={{width:90,padding:'4px 7px',borderRadius:6,border:'1.5px solid #6338c8',fontSize:12,outline:'none',textAlign:'right'}}/>
                            <button onClick={()=>{const u={...budgets,[port]:parseFloat(newBudgetVal)||0};setBudgets(u);saveBudgets(u);setEditingBudget(null);}} style={{padding:'4px 8px',borderRadius:6,border:'none',background:'#6338c8',color:'#fff',fontSize:11,cursor:'pointer',fontWeight:700}}>✓</button>
                          </div>
                        ):(
                          <span onClick={()=>{setEditingBudget(port);setNewBudgetVal(budgets[port]||'');}} style={{cursor:'pointer',color:budgets[port]?'#111':'#aaa',fontWeight:budgets[port]?600:400}}>
                            {budgets[port]?fmtD(parseFloat(budgets[port])):'Click to set →'}
                          </span>
                        )}
                      </td>
                      {p?(
                        <>
                          <td style={{padding:'10px 12px',textAlign:'right'}}>
                            <div style={{display:'flex',flex:1,alignItems:'center',gap:6,justifyContent:'flex-end'}}>
                              <div style={{width:60,height:6,background:'#f0f0f0',borderRadius:3,overflow:'hidden'}}>
                                <div style={{height:'100%',width:`${Math.min(100,p.pctUsed)}%`,background:p.status==='over'?'#d42b2b':p.status==='under'?'#c47a00':'#1a9e5f',borderRadius:3}}/>
                              </div>
                              <span style={{fontWeight:700,color:STATUS_COLOR[p.status]}}>{fmtP(p.pctUsed)}</span>
                            </div>
                          </td>
                          <td style={{padding:'10px 12px',textAlign:'right',fontWeight:600}}>{fmtD(p.projectedSpend)}</td>
                          <td style={{padding:'10px 12px',textAlign:'right',color:p.remaining<0?'#d42b2b':'#1a9e5f',fontWeight:600}}>{fmtD(p.remaining)}</td>
                          <td style={{padding:'10px 12px',textAlign:'right',color:'#555'}}>{fmtD(p.dailyActual)}<span style={{fontSize:10,color:'#aaa'}}>/day</span></td>
                          <td style={{padding:'10px 12px',textAlign:'right'}}>
                            <span style={{fontSize:11,fontWeight:700,color:STATUS_COLOR[p.status],background:STATUS_BG[p.status],padding:'3px 9px',borderRadius:8}}>
                              {STATUS_LABEL[p.status]} {p.status!=='on_track'&&`(${p.pacing>=0?'+':''}${p.pacing.toFixed(1)}pp)`}
                            </span>
                          </td>
                        </>
                      ):(
                        <td colSpan={6} style={{padding:'10px 12px',textAlign:'center',color:'#aaa',fontSize:11}}>Set a monthly budget to track pacing</td>
                      )}
                      <td style={{padding:'10px 12px'}}>
                        <button onClick={()=>{setEditingBudget(port);setNewBudgetVal(budgets[port]||'');}} style={{padding:'3px 10px',borderRadius:6,border:'1px solid #e0e0e0',background:'#fff',fontSize:11,cursor:'pointer',color:'#555'}}>
                          {budgets[port]?'Edit':'Set'}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {/* Forecasting insight */}
        {totalBudget>0&&totalSpend>0&&(
          <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',padding:'18px 20px'}}>
            <div style={{fontSize:13,fontWeight:800,color:'#111',marginBottom:14,display:'flex',alignItems:'center',gap:8}}>
              <i className="ti ti-chart-line" style={{color:'#6338c8'}}/>Month-End Forecast
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
              {[
                {l:'At Current Pace',v:fmtD((totalSpend/dayOfMonth)*daysInMonth),desc:'Projected total spend if daily rate holds',c:'#6338c8'},
                {l:'Budget Remaining',v:fmtD(totalBudget-totalSpend),desc:`${daysLeft} days left in month`,c:totalBudget-totalSpend<0?'#d42b2b':'#1a9e5f'},
                {l:'Required Daily Spend',v:daysLeft>0?fmtD((totalBudget-totalSpend)/daysLeft):'—',desc:'To hit monthly budget exactly',c:'#1a5fa0'},
              ].map((k,i)=>(
                <div key={i} style={{background:'#f8f9fc',borderRadius:9,padding:'14px',borderLeft:`4px solid ${k.c}`}}>
                  <div style={{fontSize:11,color:'#888',fontWeight:600,textTransform:'uppercase',marginBottom:6}}>{k.l}</div>
                  <div style={{fontSize:20,fontWeight:800,color:k.c,marginBottom:4}}>{k.v}</div>
                  <div style={{fontSize:11,color:'#aaa'}}>{k.desc}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   MODULE 5: ACOS STRATEGY MANAGER
   Launch / Scale / Defend / Custom per portfolio or campaign
================================================================ */
const STRATEGY_KEY = 'rq_strategies_v1';
function loadStrategies(){ try{ return JSON.parse(localStorage.getItem(STRATEGY_KEY)||'{}'); }catch{ return {}; } }
function saveStrategies(s){ try{ localStorage.setItem(STRATEGY_KEY, JSON.stringify(s)); }catch{} }

const STRATEGY_DEFS = {
  launch:  { label:'Launch',  color:'#6338c8', icon:'ti-rocket',       acos:60, desc:'Max visibility — aggressive spend, high ACOS acceptable to build rank and reviews' },
  scale:   { label:'Scale',   color:'#1a5fa0', icon:'ti-trending-up',  acos:35, desc:'Balanced growth — profitable ACOS targeting, scaling spend on winning keywords' },
  defend:  { label:'Defend',  color:'#1a9e5f', icon:'ti-shield',       acos:20, desc:'Efficiency mode — protect rank, minimize ACOS, extract maximum margin' },
  pause:   { label:'Pause',   color:'#e05656', icon:'ti-player-pause', acos:0,  desc:'Pausing or sunsetting — check if still adding value before cutting' },
  custom:  { label:'Custom',  color:'#c47a00', icon:'ti-settings',     acos:null,desc:'Custom ACOS target — enter your own target' },
};

function ACOSStrategyModule({globalData,setTab}){
  const campData = globalData?.cur?.primary || globalData?.cur?.campaign;
  const compCamp = globalData?.comp?.primary || globalData?.comp?.campaign;
  const[strategies,setStrategies] = useState(loadStrategies);
  const[view,setView] = useState('portfolio'); // portfolio | campaign
  const[sortBy,setSortBy] = useState('spend');
  const R = '#4f46e5';

  function setStrategy(name, strat, customAcos=null){
    const u = {...strategies, [name]:{ strategy:strat, customAcos }};
    setStrategies(u); saveStrategies(u);
  }

  /* Group by portfolio or campaign */
  const groups = useMemo(()=>{
    const rows = campData?.rows||[];
    const compRows = compCamp?.rows||[];
    if(!rows.length) return [];
    const colKey = view==='portfolio' ? ['Portfolio Name','Portfolio name','portfolio'] : ['Campaign Name','Campaign name','campaign'];
    const getKey = r => {
      for(const k of colKey){ if(r[k]) return String(r[k]).trim(); }
      return '(No Portfolio)';
    };
    const map={};
    rows.forEach(r=>{
      const k=getKey(r)||'(No Portfolio)';
      if(!map[k])map[k]={name:k,spend:0,sales:0,clicks:0,orders:0,impressions:0};
      map[k].spend+=parseFloat(String(r['Spend']||0).replace(/[$,]/g,''))||0;
      map[k].sales+=parseFloat(String(r['Sales']||r['14 Day Total Sales']||0).replace(/[$,]/g,''))||0;
      map[k].clicks+=parseFloat(r['Clicks']||0)||0;
      map[k].orders+=parseFloat(r['Orders']||r['14 Day Total Orders']||0)||0;
      map[k].impressions+=parseFloat(r['Impressions']||0)||0;
    });
    // Add comp data
    const compMap={};
    compRows.forEach(r=>{
      const k=getKey(r)||'(No Portfolio)';
      if(!compMap[k])compMap[k]={spend:0,sales:0};
      compMap[k].spend+=parseFloat(String(r['Spend']||0).replace(/[$,]/g,''))||0;
      compMap[k].sales+=parseFloat(String(r['Sales']||r['14 Day Total Sales']||0).replace(/[$,]/g,''))||0;
    });
    return Object.values(map).map(g=>{
      const acos = g.sales>0?(g.spend/g.sales)*100:0;
      const strat = strategies[g.name];
      const def = STRATEGY_DEFS[strat?.strategy||'scale'];
      const targetAcos = strat?.strategy==='custom'?(strat.customAcos||0):def.acos;
      const delta = targetAcos>0 ? acos - targetAcos : null;
      const comp = compMap[g.name];
      const compAcos = comp?.sales>0?(comp.spend/comp.sales)*100:null;
      return{...g,acos,strat:strat?.strategy||null,targetAcos,delta,comp,compAcos};
    }).sort((a,b)=>b[sortBy]-a[sortBy]);
  },[campData,compCamp,strategies,view,sortBy]);

  const fmtD=v=>`$${(v||0).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0})}`;
  const fmtP=v=>`${(v||0).toFixed(1)}%`;

  /* Strategy selector cell */
  function StrategyPicker({name,current}){
    const[open,setOpen]=useState(false);
    const[customVal,setCustomVal]=useState('');
    const def=STRATEGY_DEFS[current||''];
    return(
      <div style={{position:'relative'}}>
        <button onClick={()=>setOpen(!open)} style={{padding:'4px 10px',borderRadius:7,border:`1px solid ${def?.color||'#e0e0e0'}`,background:def?def.color+'12':'#f8f8f8',color:def?.color||'#888',fontSize:11,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:5,whiteSpace:'nowrap'}}>
          {def?<><i className={`ti ${def.icon}`} style={{fontSize:10}}/>{def.label}</>:<span style={{color:'#aaa'}}>Set Strategy ▾</span>}
        </button>
        {open&&(
          <div style={{position:'absolute',top:'calc(100% + 4px)',left:0,background:'#fff',border:'1px solid #e8ebf2',borderRadius:10,boxShadow:'0 4px 16px rgba(0,0,0,0.1)',zIndex:99,minWidth:220,overflow:'hidden'}}>
            {Object.entries(STRATEGY_DEFS).map(([k,s])=>(
              <button key={k} onClick={()=>{if(k!=='custom'){setStrategy(name,k);setOpen(false);}}} style={{width:'100%',padding:'9px 12px',border:'none',background:'transparent',cursor:'pointer',textAlign:'left',display:'flex',alignItems:'center',gap:8}}>
                <i className={`ti ${s.icon}`} style={{fontSize:12,color:s.color,flexShrink:0}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:700,color:s.color}}>{s.label}{s.acos?` — Target ${s.acos}% ACOS`:''}</div>
                  <div style={{fontSize:10,color:'#888',lineHeight:1.3}}>{s.desc}</div>
                </div>
              </button>
            ))}
            {/* Custom ACOS input */}
            <div style={{padding:'8px 12px',borderTop:'1px solid #f0f0f0'}}>
              <div style={{fontSize:11,fontWeight:700,color:'#c47a00',marginBottom:4}}>Custom ACOS Target</div>
              <div style={{display:'flex',gap:6}}>
                <input type="number" value={customVal} onChange={e=>setCustomVal(e.target.value)} placeholder="e.g. 28" style={{flex:1,padding:'5px 8px',borderRadius:6,border:'1px solid #e0e0e0',fontSize:12,outline:'none'}}/>
                <span style={{padding:'5px 0',fontSize:12,color:'#888'}}>%</span>
                <button onClick={()=>{setStrategy(name,'custom',parseFloat(customVal));setOpen(false);}} style={{padding:'5px 10px',borderRadius:6,border:'none',background:'#c47a00',color:'#fff',fontSize:11,fontWeight:700,cursor:'pointer'}}>Set</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return(
    <div style={{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'}}>
      <div style={{padding:'12px 20px',borderBottom:'1px solid #f0f0f0',flexShrink:0,background:'#fff',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        <i className="ti ti-target-arrow" style={{fontSize:15,color:'#c47a00'}}/>
        <span style={{fontSize:15,fontWeight:800,color:'#111'}}>ACOS Strategy Manager</span>
        <span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:'rgba(196,122,0,0.1)',color:'#c47a00',fontWeight:700}}>Core</span>
        <div style={{display:'flex',gap:4,marginLeft:8}}>
          {['portfolio','campaign'].map(v=>(
            <button key={v} onClick={()=>setView(v)} style={{padding:'4px 12px',borderRadius:6,border:'none',background:view===v?'#c47a00':'#f0f0f0',color:view===v?'#fff':'#555',fontSize:11,fontWeight:600,cursor:'pointer',textTransform:'capitalize'}}>{v}</button>
          ))}
        </div>
        {!campData?.rows?.length&&<span style={{fontSize:11,color:'#c47a00',fontWeight:600}}>⚠ Upload Campaign report in Data Hub</span>}
        {compCamp?.rows?.length>0&&<span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:'rgba(26,95,160,0.1)',color:'#1a5fa0',fontWeight:700}}>📊 Comparison period active</span>}
      </div>

      {/* Strategy legend */}
      <div style={{display:'flex',gap:8,padding:'10px 20px',borderBottom:'1px solid #f0f0f0',background:'#fff',flexWrap:'wrap',flexShrink:0}}>
        {Object.entries(STRATEGY_DEFS).filter(([k])=>k!=='custom').map(([k,s])=>(
          <div key={k} style={{display:'flex',alignItems:'center',gap:5,padding:'4px 10px',borderRadius:7,background:s.color+'10',border:`1px solid ${s.color}30`}}>
            <i className={`ti ${s.icon}`} style={{fontSize:11,color:s.color}}/>
            <span style={{fontSize:11,fontWeight:700,color:s.color}}>{s.label}</span>
            {s.acos>0&&<span style={{fontSize:10,color:s.color}}>≤{s.acos}%</span>}
          </div>
        ))}
        <span style={{fontSize:11,color:'#aaa',marginLeft:'auto'}}>Click any row to assign strategy</span>
      </div>

      <div style={{flex:1,overflow:'auto',background:'#f4f6fb'}}>
        {groups.length===0?(
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:12,height:'100%'}}>
            <i className="ti ti-target-arrow" style={{fontSize:44,color:'#ddd'}}/>
            <div style={{fontSize:14,fontWeight:700,color:'#555'}}>No campaign data</div>
            <button onClick={()=>setTab('hub')} style={{padding:'8px 18px',borderRadius:8,border:'none',background:R,color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer'}}>Go to Data Hub →</button>
          </div>
        ):(
          <div style={{padding:'24px',maxWidth:1200}}>
            {/* Status summary */}
            <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
              {Object.entries(STRATEGY_DEFS).filter(([k])=>k!=='custom').map(([k,s])=>{
                const count=groups.filter(g=>g.strat===k).length;
                const overTarget=groups.filter(g=>g.strat===k&&g.delta>5).length;
                return<div key={k} style={{background:'#fff',borderRadius:10,border:`1px solid ${s.color}30`,padding:'12px 14px'}}>
                  <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:6}}>
                    <i className={`ti ${s.icon}`} style={{fontSize:13,color:s.color}}/>
                    <span style={{fontSize:11,color:'#888',fontWeight:600,textTransform:'uppercase'}}>{s.label}</span>
                  </div>
                  <div style={{fontSize:20,fontWeight:800,color:s.color}}>{count}</div>
                  <div style={{fontSize:10,color:'#888',marginTop:2}}>{view}s assigned{overTarget>0&&<span style={{color:'#d42b2b',fontWeight:600}}> · {overTarget} over target</span>}</div>
                </div>;
              })}
            </div>

            <div style={{background:'#fff',borderRadius:12,border:'1px solid #e8ebf2',overflow:'hidden'}}>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                <thead><tr style={{background:'#f8f9fc'}}>
                  <th style={{padding:'10px 12px',textAlign:'left',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>{view==='portfolio'?'Portfolio':'Campaign'}</th>
                  <th style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>Spend</th>
                  <th style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>Sales</th>
                  <th style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>Actual ACOS</th>
                  <th style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>vs Prev</th>
                  <th style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>Target ACOS</th>
                  <th style={{padding:'10px 12px',textAlign:'right',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>Delta</th>
                  <th style={{padding:'10px 12px',textAlign:'left',fontWeight:700,color:'#555',borderBottom:'2px solid #e8ebf2',fontSize:11}}>Strategy</th>
                </tr></thead>
                <tbody>
                  {groups.map((g,i)=>{
                    const def=STRATEGY_DEFS[g.strat||''];
                    const deltaOk=g.delta!=null&&g.delta<=0;
                    const compD=g.compAcos!=null?g.acos-g.compAcos:null;
                    return(
                      <tr key={i} style={{background:i%2===0?'#fff':'#fafbfd',borderBottom:'1px solid #f0f2f7'}}>
                        <td style={{padding:'10px 12px',fontWeight:600,color:'#111',maxWidth:240,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={g.name}>{g.name}</td>
                        <td style={{padding:'10px 12px',textAlign:'right',fontWeight:600}}>{fmtD(g.spend)}</td>
                        <td style={{padding:'10px 12px',textAlign:'right',color:'#1a9e5f',fontWeight:600}}>{fmtD(g.sales)}</td>
                        <td style={{padding:'10px 12px',textAlign:'right'}}>
                          <span style={{fontWeight:800,color:g.sales>0?(g.acos>50?'#d42b2b':g.acos>30?'#c47a00':'#1a9e5f'):'#aaa',fontSize:13}}>
                            {g.sales>0?fmtP(g.acos):'—'}
                          </span>
                        </td>
                        <td style={{padding:'10px 12px',textAlign:'right'}}>
                          {compD!=null&&<span style={{fontSize:11,fontWeight:700,color:compD<0?'#1a9e5f':'#d42b2b'}}>{compD>=0?'+':''}{compD.toFixed(1)}pp</span>}
                        </td>
                        <td style={{padding:'10px 12px',textAlign:'right'}}>
                          {g.targetAcos>0?<span style={{fontWeight:600,color:def?.color||'#888'}}>{fmtP(g.targetAcos)}</span>:<span style={{color:'#aaa'}}>—</span>}
                        </td>
                        <td style={{padding:'10px 12px',textAlign:'right'}}>
                          {g.delta!=null&&g.targetAcos>0?(
                            <span style={{fontWeight:700,padding:'2px 8px',borderRadius:6,fontSize:11,background:deltaOk?'rgba(26,158,95,0.08)':'rgba(212,43,43,0.08)',color:deltaOk?'#1a9e5f':'#d42b2b'}}>
                              {g.delta>=0?'+':''}{g.delta.toFixed(1)}pp {deltaOk?'✓':'⚠'}
                            </span>
                          ):<span style={{color:'#aaa'}}>—</span>}
                        </td>
                        <td style={{padding:'10px 12px'}}><StrategyPicker name={g.name} current={g.strat}/></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


function STRHarvestModule({globalData,setTab}){
  const[page,setPage]=useState('upload');
  const[strFile,setStrFile]=useState(null);
  const[bulkFile,setBulkFile]=useState(null);
  const[strData,setStrData]=useState(null);
  const[bulkData,setBulkData]=useState(null);
  const[criteria,setCriteria]=useState({minAcos:1,maxAcos:20,minOrders:4,minClicks:0,minCvr:0});
  const[portfolios,setPortfolios]=useState([]);      // [{name,include}]
  const[results,setResults]=useState(null);
  const[targeted,setTargeted]=useState(null);
  const[activeTab,setActiveTab]=useState('upload');

  // Auto-load from Data Hub
  useEffect(()=>{
    if(globalData?.cur?.primary&&!strData){
      setStrData(globalData.cur.primary);
    }
    if(globalData?.cur?.bulk&&!bulkData){
      setBulkData(globalData.cur.bulk);
    }
  },[globalData]);

  // Extract portfolios from STR data
  useEffect(()=>{
    if(!strData)return;
    const sm=shDetectSTR(strData.headers);
    const ps=new Set();
    strData.rows.forEach(r=>{const p=String(r[sm.portfolio]||'').trim();if(p)ps.add(p);});
    setPortfolios(Array.from(ps).sort().map(name=>({name,include:true})));
  },[strData]);

  function handleSTRFile(file){
    const reader=new FileReader();
    reader.onload=e=>{
      const wb=XLSX.read(e.target.result,{type:'binary'});
      const ws=wb.Sheets[wb.SheetNames[0]];
      const rows=XLSX.utils.sheet_to_json(ws,{defval:''});
      if(rows.length){setStrData({headers:Object.keys(rows[0]),rows});setStrFile(file.name);}
    };
    reader.readAsBinaryString(file);
  }

  function handleBulkFile(file){
    const reader=new FileReader();
    reader.onload=e=>{
      const wb=XLSX.read(e.target.result,{type:'binary'});
      const ws=wb.Sheets[wb.SheetNames[0]]||wb.Sheets[wb.SheetNames.find(n=>n.toLowerCase().includes('sponsored'))||wb.SheetNames[0]];
      const rows=XLSX.utils.sheet_to_json(ws,{defval:''});
      if(rows.length){setBulkData({headers:Object.keys(rows[0]),rows});setBulkFile(file.name);}
    };
    reader.readAsBinaryString(file);
  }

  function runHarvest(){
    if(!strData||!bulkData){alert('Upload both STR and Bulk files first.');return;}
    const sm=shDetectSTR(strData.headers);
    const bm=shDetectBulk(bulkData.headers);
    const portfolioFilter=new Set(portfolios.filter(p=>p.include).map(p=>p.name.toLowerCase()));
    const qualifying=shParseSTR(strData.rows,sm,criteria,portfolioFilter);
    const tgt=shParseBulk(bulkData.rows,bm);
    setResults(qualifying);
    setTargeted(tgt);
    setActiveTab('results');
  }

  const upd=(k,v)=>setCriteria(p=>({...p,[k]:v}));

  const TABS=[
    {k:'upload',  label:'Upload Files',    icon:'ti-upload'},
    {k:'criteria',label:'Criteria',         icon:'ti-filter'},
    {k:'portfolios',label:'Portfolios',     icon:'ti-folder',badge:portfolios.filter(p=>p.include).length||null},
    {k:'results', label:'Harvest Results',  icon:'ti-plant-2',badge:results?.length||null},
  ];

  return(
    <div style={{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'}}>
      {/* Header */}
      <div style={{padding:'12px 20px',borderBottom:'1px solid #f0f0f0',flexShrink:0,background:'#fff',display:'flex',alignItems:'center',gap:12}}>
        <i className="ti ti-plant-2" style={{fontSize:15,color:'#1a7a3c'}}/>
        <span style={{fontSize:15,fontWeight:700,color:'#111'}}>STR Harvest Engine</span>
        <span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:'rgba(26,122,60,0.1)',color:'#1a7a3c',fontWeight:700}}>Core</span>
        <span style={{fontSize:11,color:'#aaa'}}>Search Term → Campaign pipeline</span>
        <div style={{flex:1}}/>
        <button onClick={runHarvest} style={{...T.btnR(true),padding:'7px 18px',fontSize:12,background:'#1a7a3c',boxShadow:'0 2px 8px rgba(26,122,60,0.3)'}} disabled={!strData||!bulkData}>
          <i className="ti ti-plant-2" style={{fontSize:12}}/>Generate Harvest
        </button>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',padding:'0 20px',borderBottom:'1px solid #f0f0f0',background:'#fff',flexShrink:0}}>
        {TABS.map(t=>(
          <button key={t.k} onClick={()=>setActiveTab(t.k)} style={{display:'flex',alignItems:'center',gap:6,padding:'9px 14px',border:'none',borderBottom:`2px solid ${activeTab===t.k?'#1a7a3c':'transparent'}`,background:'transparent',cursor:'pointer',fontSize:12,fontWeight:activeTab===t.k?700:500,color:activeTab===t.k?'#1a7a3c':'#666',whiteSpace:'nowrap'}}>
            <i className={`ti ${t.icon}`} style={{fontSize:12}}/>{t.label}
            {t.badge>0&&<span style={{fontSize:9,padding:'1px 5px',borderRadius:8,background:activeTab===t.k?'#1a7a3c':'rgba(26,122,60,0.1)',color:activeTab===t.k?'#fff':'#1a7a3c',fontWeight:700}}>{t.badge}</span>}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div style={{flex:1,overflow:'hidden',display:'flex',flexDirection:'column'}}>

        {/* UPLOAD */}
        {activeTab==='upload'&&(
          <div style={{flex:1,overflowY:'auto',padding:'20px',background:'#f7f7f7'}}>
            <div style={{maxWidth:700,margin:'0 auto'}}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
                {/* STR Upload */}
                <div style={{background:'#fff',borderRadius:12,border:'1px solid #f0f0f0',padding:'20px'}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:12}}>
                    <i className="ti ti-search" style={{fontSize:14,color:'#4f46e5'}}/>
                    <span style={{fontSize:13,fontWeight:700,color:'#111'}}>Search Term Report</span>
                    {strFile&&<span style={{fontSize:9,padding:'1px 6px',borderRadius:8,background:'rgba(26,122,60,0.1)',color:'#1a7a3c',fontWeight:700}}>✓ Loaded</span>}
                  </div>
                  <div style={{fontSize:11,color:'#888',marginBottom:12,lineHeight:1.6}}>Upload your STR report (CSV/Excel). Must contain: Search Term, Campaign, Orders, Spend, ACoS columns.</div>
                  {strData&&<div style={{fontSize:11,color:'#1a7a3c',marginBottom:8,fontWeight:600}}>✓ {strData.rows.length.toLocaleString()} rows loaded — {strFile}</div>}
                  <label style={{display:'flex',alignItems:'center',gap:7,padding:'9px 14px',background:'rgba(79,70,229,0.06)',borderRadius:8,border:'1.5px dashed rgba(79,70,229,0.3)',cursor:'pointer',fontSize:12,color:'#4f46e5',fontWeight:600}}>
                    <i className="ti ti-file-upload" style={{fontSize:13}}/>
                    {strData?'Re-upload STR':'Select STR File'}
                    <input type="file" accept=".csv,.xlsx,.xls" style={{display:'none'}} onChange={e=>e.target.files[0]&&handleSTRFile(e.target.files[0])}/>
                  </label>
                  {globalData?.cur?.primary&&!strData&&<div style={{marginTop:8,fontSize:10,color:'#1a5fa0'}}>💡 Data Hub has STR data — click Generate Harvest to use it automatically</div>}
                </div>

                {/* Bulk Upload */}
                <div style={{background:'#fff',borderRadius:12,border:'1px solid #f0f0f0',padding:'20px'}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:12}}>
                    <i className="ti ti-file-spreadsheet" style={{fontSize:14,color:'#555'}}/>
                    <span style={{fontSize:13,fontWeight:700,color:'#111'}}>Bulk Operations File</span>
                    {bulkFile&&<span style={{fontSize:9,padding:'1px 6px',borderRadius:8,background:'rgba(26,122,60,0.1)',color:'#1a7a3c',fontWeight:700}}>✓ Loaded</span>}
                  </div>
                  <div style={{fontSize:11,color:'#888',marginBottom:12,lineHeight:1.6}}>Upload your Amazon Bulk file. Used to check which terms are already targeted in each match type.</div>
                  {bulkData&&<div style={{fontSize:11,color:'#1a7a3c',marginBottom:8,fontWeight:600}}>✓ {bulkData.rows.length.toLocaleString()} rows loaded — {bulkFile}</div>}
                  <label style={{display:'flex',alignItems:'center',gap:7,padding:'9px 14px',background:'rgba(85,85,85,0.06)',borderRadius:8,border:'1.5px dashed rgba(85,85,85,0.3)',cursor:'pointer',fontSize:12,color:'#555',fontWeight:600}}>
                    <i className="ti ti-file-upload" style={{fontSize:13}}/>
                    {bulkData?'Re-upload Bulk':'Select Bulk File'}
                    <input type="file" accept=".csv,.xlsx,.xls" style={{display:'none'}} onChange={e=>e.target.files[0]&&handleBulkFile(e.target.files[0])}/>
                  </label>
                  {globalData?.cur?.bulk&&!bulkData&&<div style={{marginTop:8,fontSize:10,color:'#1a5fa0'}}>💡 Data Hub has Bulk data — will auto-use</div>}
                </div>
              </div>

              <div style={{marginTop:16,padding:'12px 16px',background:'rgba(26,122,60,0.05)',borderRadius:10,border:'1px solid rgba(26,122,60,0.15)',fontSize:11,color:'#333',lineHeight:1.7}}>
                <strong style={{color:'#1a7a3c'}}>How it works:</strong> Upload your STR report and Bulk file → set ACoS/orders criteria → filter by portfolio → the engine finds all search terms meeting your criteria and shows which match types they're <strong>already in</strong> (green dot) vs which are <strong>gaps</strong> (ADD badge) → export the unique columns directly into Bulk Builder.
              </div>
            </div>
          </div>
        )}

        {/* CRITERIA */}
        {activeTab==='criteria'&&(
          <div style={{flex:1,overflowY:'auto',padding:'20px',background:'#f7f7f7'}}>
            <div style={{maxWidth:600,margin:'0 auto',background:'#fff',borderRadius:12,border:'1px solid #f0f0f0',padding:'24px'}}>
              <div style={{fontSize:14,fontWeight:700,color:'#111',marginBottom:4}}>STR Criteria</div>
              <div style={{fontSize:11,color:'#888',marginBottom:20}}>Only search terms matching ALL enabled criteria will appear in harvest results.</div>

              {[
                {k:'maxAcos',label:'ACoS ≤ (%)',desc:'Maximum ACoS — exclude high-waste terms',default:20,step:1},
                {k:'minAcos',label:'ACoS ≥ (%)',desc:'Minimum ACoS — exclude branded (very low ACoS)',default:1,step:0.5},
                {k:'minOrders',label:'Orders ≥',desc:'Minimum orders — only proven converters',default:4,step:1},
                {k:'minClicks',label:'Clicks ≥',desc:'Minimum clicks — optional data threshold',default:0,step:5},
                {k:'minCvr',label:'CVR ≥ (%)',desc:'Minimum conversion rate',default:0,step:0.5},
              ].map(field=>(
                <div key={field.k} style={{display:'flex',alignItems:'center',gap:12,marginBottom:14,padding:'10px 14px',background:'#fafafa',borderRadius:8,border:'1px solid #f0f0f0'}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:12,fontWeight:700,color:'#111'}}>{field.label}</div>
                    <div style={{fontSize:10,color:'#aaa'}}>{field.desc}</div>
                  </div>
                  <input type="number" min={0} step={field.step} value={criteria[field.k]||0}
                    onChange={e=>upd(field.k,parseFloat(e.target.value)||0)}
                    style={{width:80,padding:'6px 10px',borderRadius:7,border:'1.5px solid #e0e0e0',fontSize:13,fontWeight:700,outline:'none',textAlign:'center'}}/>
                </div>
              ))}

              <div style={{marginTop:16,padding:'10px 14px',background:'rgba(26,122,60,0.05)',borderRadius:8,fontSize:11,color:'#555'}}>
                <strong style={{color:'#1a7a3c'}}>Current criteria:</strong> ACoS {criteria.minAcos}%–{criteria.maxAcos}%, Orders ≥{criteria.minOrders}{criteria.minClicks>0?`, Clicks ≥${criteria.minClicks}`:''}{criteria.minCvr>0?`, CVR ≥${criteria.minCvr}%`:''}
              </div>
            </div>
          </div>
        )}

        {/* PORTFOLIOS */}
        {activeTab==='portfolios'&&(
          <div style={{flex:1,overflowY:'auto',padding:'20px',background:'#f7f7f7'}}>
            <div style={{maxWidth:500,margin:'0 auto',background:'#fff',borderRadius:12,border:'1px solid #f0f0f0',padding:'20px'}}>
              <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:14}}>
                <div style={{fontSize:13,fontWeight:700,color:'#111',flex:1}}>Portfolio Filter</div>
                <button onClick={()=>setPortfolios(p=>p.map(x=>({...x,include:true})))} style={{fontSize:10,padding:'3px 8px',borderRadius:6,border:'1px solid #e0e0e0',background:'#fff',cursor:'pointer',color:'#555'}}>All</button>
                <button onClick={()=>setPortfolios(p=>p.map(x=>({...x,include:false})))} style={{fontSize:10,padding:'3px 8px',borderRadius:6,border:'1px solid #e0e0e0',background:'#fff',cursor:'pointer',color:'#555'}}>None</button>
              </div>
              {portfolios.length===0&&<div style={{color:'#aaa',fontSize:12,textAlign:'center',padding:'20px'}}>Upload STR file first to detect portfolios</div>}
              {portfolios.map((p,i)=>(
                <div key={i} onClick={()=>setPortfolios(pp=>pp.map((x,j)=>j===i?{...x,include:!x.include}:x))}
                  style={{display:'flex',alignItems:'center',gap:10,padding:'9px 12px',borderRadius:8,cursor:'pointer',background:p.include?'rgba(26,122,60,0.05)':'#fafafa',border:`1px solid ${p.include?'rgba(26,122,60,0.2)':'#f0f0f0'}`,marginBottom:6}}>
                  <div style={{width:18,height:18,borderRadius:4,border:`2px solid ${p.include?'#1a7a3c':'#ccc'}`,background:p.include?'#1a7a3c':'#fff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    {p.include&&<i className="ti ti-check" style={{fontSize:10,color:'#fff'}}/>}
                  </div>
                  <span style={{fontSize:12,fontWeight:p.include?600:400,color:p.include?'#111':'#888',flex:1}}>{p.name}</span>
                  <span style={{fontSize:10,color:p.include?'#1a7a3c':'#ccc',fontWeight:700}}>{p.include?'INCLUDE':'SKIP'}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* RESULTS */}
        {activeTab==='results'&&results&&targeted&&(
          <SHResultsTable
            qualifying={results}
            targeted={targeted}
            onExport={shExport}
          />
        )}
        {activeTab==='results'&&!results&&(
          <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:12,color:'#aaa',background:'#f7f7f7'}}>
            <i className="ti ti-plant-2" style={{fontSize:40,color:'#ddd'}}/>
            <div style={{fontSize:14,fontWeight:600,color:'#555'}}>No results yet</div>
            <div style={{fontSize:12}}>Upload files → set criteria → click Generate Harvest</div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================================================================
   PORTFOLIO DEDUPLICATION MODULE
   Scans Bulk file for:
   - Same keyword in multiple campaigns (same match type = conflict)
   - Same keyword in Exact + Phrase in same campaign (ok but visible)
   - High-spend duplicates (prioritized)
   Export: bulk-ready pause rows for duplicates
================================================================ */

function shDeduplicateBulk(rows, bm){
  const kwMap={};
  rows.forEach((r,idx)=>{
    const entity=String(r[bm.entity]||'').toLowerCase();
    if(!entity.includes('keyword'))return;
    const kw=String(r[bm.keyword]||'').trim().toLowerCase();
    const mt=String(r[bm.matchType]||'').trim().toLowerCase();
    if(!kw||!mt||mt.includes('negative'))return;
    const campaign=String(r[bm.campaign]||'').trim();
    const portfolio=String(r[bm.portfolio]||'').trim();
    const state=String(r[bm.state]||'').trim().toLowerCase();
    const bid=parseFloat(String(r['Bid']||r['bid']||0).replace(/[^0-9.]/g,''))||0;

    const key=`${kw}__${mt}`;
    if(!kwMap[key])kwMap[key]={kw,mt,entries:[]};
    kwMap[key].entries.push({campaign,portfolio,state,bid,rowIdx:idx,raw:r});
  });

  // Find duplicates (same kw + same match type in multiple campaigns)
  const duplicates=[];
  Object.values(kwMap).forEach(({kw,mt,entries})=>{
    if(entries.length<2)return;
    // Group by campaign
    const byCampaign={};
    entries.forEach(e=>{
      if(!byCampaign[e.campaign])byCampaign[e.campaign]=[];
      byCampaign[e.campaign].push(e);
    });
    const campaigns=Object.keys(byCampaign);
    if(campaigns.length<2)return;
    // This keyword+matchtype appears in multiple campaigns = duplicate
    duplicates.push({
      kw,mt,campaigns,entries,
      severity: mt==='exact'?'critical':mt==='phrase'?'warning':'info',
      enabledCount: entries.filter(e=>e.state==='enabled').length,
      pausedCount: entries.filter(e=>e.state!=='enabled').length,
    });
  });

  return duplicates.sort((a,b)=>{
    const sev={critical:0,warning:1,info:2};
    return (sev[a.severity]||2)-(sev[b.severity]||2)||b.entries.length-a.entries.length;
  });
}

function ddExport(duplicates){
  if(!duplicates.length){alert('No duplicates to export.');return;}
  const rows=[];
  duplicates.forEach(d=>{
    // Keep first campaign, suggest pausing rest
    d.entries.slice(1).forEach(e=>{
      rows.push({
        'Keyword':d.kw,'Match Type':d.mt,
        'Campaign to Pause':e.campaign,'Portfolio':e.portfolio,
        'Current State':e.state,'Bid':e.bid,
        'Conflict Type':d.severity,
        'Reason':`Duplicate — also in: ${d.entries[0].campaign}`,
        'Action':'Pause or negative-exact in this campaign',
      });
    });
  });
  const ws=XLSX.utils.json_to_sheet(rows);
  ws['!cols']=Object.keys(rows[0]||{}).map(()=>({wch:24}));
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb,ws,'Deduplication Actions');
  XLSX.writeFile(wb,`Portfolio_Dedup_${new Date().toISOString().slice(0,10)}.xlsx`);
}

function PortfolioDeduplicationModule({globalData,setTab}){
  /* ── Shared bulk state ── */
  const[bulkData,setBulkData]=useState(globalData?.cur?.bulk||null);
  const[bulkFile,setBulkFile]=useState(null);
  /* ── Module tab ── */
  const[modTab,setModTab]=useState('sp');  // sp | sb | sd | checker
  /* ── Per ad-type dedup state ── */
  const[spDups,setSpDups]=useState(null);
  const[sbDups,setSbDups]=useState(null);
  const[sdDups,setSdDups]=useState(null);
  /* ── Target checker state ── */
  const[kwInput,setKwInput]=useState('');
  const[asinInput,setAsinInput]=useState('');
  const[checkerResults,setCheckerResults]=useState(null);
  /* ── Filters ── */
  const[activeView,setActiveView]=useState('all');
  const[searchQ,setSearchQ]=useState('');

  useEffect(()=>{if(globalData?.cur?.bulk&&!bulkData)setBulkData(globalData.cur.bulk);},[globalData]);

  function handleFile(file){
    const reader=new FileReader();
    reader.onload=e=>{
      const wb=XLSX.read(e.target.result,{type:'binary'});
      // Try to find the right sheet
      const spSheet=wb.SheetNames.find(n=>/sponsored products/i.test(n))||wb.SheetNames[0];
      const rows=XLSX.utils.sheet_to_json(wb.Sheets[spSheet],{defval:''});
      if(rows.length){setBulkData({headers:Object.keys(rows[0]),rows,wb});setBulkFile(file.name);}
    };
    reader.readAsBinaryString(file);
  }

  /* ── Filter rows by ad type prefix in entity or campaign name ── */
  function filterByAdType(rows,bm,type){
    return rows.filter(r=>{
      const entity=String(r[bm.entity]||'').toLowerCase();
      const camp=String(r[bm.campaign]||'').toLowerCase();
      if(type==='sp') return entity.includes('sponsored product')||(!entity.includes('sponsored brand')&&!entity.includes('sponsored display'));
      if(type==='sb') return entity.includes('sponsored brand')||camp.includes(' sb ')||camp.includes('| sb |')||camp.includes('- sb -');
      if(type==='sd') return entity.includes('sponsored display')||camp.includes(' sd ')||camp.includes('| sd |')||camp.includes('- sd -');
      return true;
    });
  }

  function runDedup(type){
    if(!bulkData){alert('Upload a Bulk file first.');return;}
    const bm=shDetectBulk(bulkData.headers);
    const filtered=filterByAdType(bulkData.rows,bm,type);
    const dups=shDeduplicateBulk(filtered,bm);
    if(type==='sp')setSpDups(dups);
    if(type==='sb')setSbDups(dups);
    if(type==='sd')setSdDups(dups);
  }

  function runAllDedup(){
    if(!bulkData){alert('Upload a Bulk file first.');return;}
    const bm=shDetectBulk(bulkData.headers);
    setSpDups(shDeduplicateBulk(filterByAdType(bulkData.rows,bm,'sp'),bm));
    setSbDups(shDeduplicateBulk(filterByAdType(bulkData.rows,bm,'sb'),bm));
    setSdDups(shDeduplicateBulk(filterByAdType(bulkData.rows,bm,'sd'),bm));
  }

  /* ── Target Checker ── */
  function runChecker(){
    if(!bulkData){alert('Upload a Bulk file first.');return;}
    const bm=shDetectBulk(bulkData.headers);
    const targeted=shParseBulk(bulkData.rows,bm);

    // Build a map of all targeted keywords/ASINs with their match types
    const kwTargetMap={};
    bulkData.rows.forEach(r=>{
      const entity=String(r[bm.entity]||'').toLowerCase();
      const kw=String(r[bm.keyword]||'').trim().toLowerCase();
      const mt=String(r[bm.matchType]||'').trim().toLowerCase();
      const pt=String(r[bm.targeting]||'').trim().toLowerCase();
      const camp=String(r[bm.campaign]||'').trim();
      const state=String(r[bm.state]||'').toLowerCase();
      if(state==='archived')return;
      if(entity.includes('keyword')&&kw&&mt&&!mt.includes('negative')){
        if(!kwTargetMap[kw])kwTargetMap[kw]=[];
        kwTargetMap[kw].push({mt,camp,state});
      }
      if((entity.includes('targeting')||entity.includes('product targeting'))&&pt){
        const asinMatch=pt.match(/asin="([^"]+)"/i);
        if(asinMatch){
          const asin=asinMatch[1].toLowerCase();
          if(!kwTargetMap[asin])kwTargetMap[asin]=[];
          kwTargetMap[asin].push({mt:'product targeting',camp,state});
        }
      }
    });

    const kwList=kwInput.split(/[\n,]+/).map(k=>k.trim().toLowerCase()).filter(Boolean);
    const asinList=asinInput.split(/[\n,]+/).map(a=>a.trim().toLowerCase()).filter(Boolean);

    const results=[
      ...kwList.map(kw=>{
        const found=kwTargetMap[kw]||[];
        return{term:kw,type:'keyword',found,isTargeted:found.length>0,
          matchTypes:[...new Set(found.map(f=>f.mt))],
          campaigns:[...new Set(found.map(f=>f.camp))].slice(0,3)};
      }),
      ...asinList.map(asin=>{
        const found=kwTargetMap[asin]||[];
        return{term:asin,type:'asin',found,isTargeted:found.length>0,
          matchTypes:[...new Set(found.map(f=>f.mt))],
          campaigns:[...new Set(found.map(f=>f.camp))].slice(0,3)};
      }),
    ];
    setCheckerResults(results);
  }

  function exportCheckerResults(results){
    if(!results?.length){alert('Run the checker first.');return;}
    const rows=results.map(r=>({
      'Keyword / ASIN':r.term,'Type':r.type,
      'Already Targeted':r.isTargeted?'YES':'NO',
      'Match Types':r.matchTypes.join(', ')||'—',
      'Campaigns':r.campaigns.join(' | ')||'—',
      'Action':r.isTargeted?'Already covered — do NOT re-target':'FREE — safe to target',
    }));
    const ws=XLSX.utils.json_to_sheet(rows);
    ws['!cols']=Object.keys(rows[0]).map(()=>({wch:28}));
    const wb=XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb,ws,'Target Checker Results');
    XLSX.writeFile(wb,`Target_Check_${new Date().toISOString().slice(0,10)}.xlsx`);
  }

  /* ── Shared dedup view ── */
  function DedupView({dups,adType,adColor}){
    const sevColor={critical:'#d42b2b',warning:'#c47a00',info:'#1a5fa0'};
    const sevBg={critical:'rgba(212,43,43,0.06)',warning:'rgba(196,122,0,0.06)',info:'rgba(26,95,160,0.06)'};
    const critCount=dups?.filter(d=>d.severity==='critical').length||0;
    const warnCount=dups?.filter(d=>d.severity==='warning').length||0;

    const filtered=useMemo(()=>{
      if(!dups)return[];
      return dups.filter(d=>{
        if(activeView!=='all'&&d.severity!==activeView)return false;
        if(searchQ&&!d.kw.includes(searchQ.toLowerCase()))return false;
        return true;
      });
    },[dups,activeView,searchQ]);

    if(!bulkData) return(
      <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',padding:'40px',background:'#f7f7f7'}}>
        <div style={{textAlign:'center'}}>
          <i className="ti ti-file-upload" style={{fontSize:40,color:'#ddd',display:'block',marginBottom:12}}/>
          <div style={{fontSize:13,fontWeight:600,color:'#555',marginBottom:8}}>Upload Bulk File First</div>
          <div style={{fontSize:11,color:'#aaa'}}>Use the upload button in the header</div>
        </div>
      </div>
    );

    if(!dups) return(
      <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:12,background:'#f7f7f7'}}>
        <i className="ti ti-scan" style={{fontSize:44,color:adColor}}/>
        <div style={{fontSize:14,fontWeight:600,color:'#111'}}>{adType} — Ready to scan</div>
        <div style={{fontSize:12,color:'#888'}}>{bulkData.rows.length.toLocaleString()} rows loaded</div>
        <button onClick={()=>runDedup(adType.toLowerCase())} style={{padding:'9px 22px',borderRadius:9,background:adColor,color:'#fff',border:'none',fontSize:13,fontWeight:700,cursor:'pointer'}}>
          <i className="ti ti-scan" style={{marginRight:6}}/>Scan {adType} Duplicates
        </button>
      </div>
    );

    return(
      <>
        {/* Stats */}
        <div style={{padding:'10px 20px',background:'#fff',borderBottom:'1px solid #f0f0f0',display:'flex',gap:12,alignItems:'center',flexWrap:'wrap',flexShrink:0}}>
          {[{label:'Total Duplicates',val:dups.length,color:'#111'},{label:'Critical (Exact)',val:critCount,color:'#d42b2b'},{label:'Warning (Phrase)',val:warnCount,color:'#c47a00'},{label:'Info (Broad)',val:dups.filter(d=>d.severity==='info').length,color:'#1a5fa0'}].map(s=>(
            <div key={s.label} style={{padding:'5px 12px',background:'#f8f8f8',borderRadius:8,textAlign:'center'}}>
              <div style={{fontSize:16,fontWeight:800,color:s.color}}>{s.val}</div>
              <div style={{fontSize:9,color:'#888',textTransform:'uppercase',letterSpacing:'0.4px'}}>{s.label}</div>
            </div>
          ))}
          <div style={{flex:1}}/>
          <button onClick={()=>ddExport(dups)} style={{padding:'6px 12px',borderRadius:7,border:`1px solid ${adColor}44`,background:`${adColor}0a`,cursor:'pointer',fontSize:11,color:adColor,fontWeight:600,display:'flex',alignItems:'center',gap:5}}>
            <i className="ti ti-download" style={{fontSize:11}}/>Export
          </button>
          <button onClick={()=>runDedup(adType.toLowerCase())} style={{padding:'6px 12px',borderRadius:7,background:adColor,color:'#fff',border:'none',cursor:'pointer',fontSize:11,fontWeight:600}}>
            Re-scan
          </button>
        </div>
        {/* Filter */}
        <div style={{padding:'8px 20px',background:'#fafafa',borderBottom:'1px solid #f0f0f0',display:'flex',gap:8,alignItems:'center',flexShrink:0}}>
          <input value={searchQ} onChange={e=>setSearchQ(e.target.value)} placeholder="Filter keywords..." style={{padding:'5px 10px',borderRadius:7,border:'1px solid #e0e0e0',fontSize:12,outline:'none',width:200}}/>
          <div style={{display:'flex',gap:4}}>
            {['all','critical','warning','info'].map(v=>(
              <button key={v} onClick={()=>setActiveView(v)} style={{padding:'4px 10px',borderRadius:14,border:`1px solid ${activeView===v?sevColor[v]||adColor:'#e0e0e0'}`,background:activeView===v?(sevColor[v]||adColor):'#fff',color:activeView===v?'#fff':'#555',fontSize:10,fontWeight:activeView===v?700:400,cursor:'pointer',textTransform:'capitalize'}}>{v}</button>
            ))}
          </div>
          <span style={{fontSize:10,color:'#aaa',marginLeft:'auto'}}>{filtered.length} duplicates shown</span>
        </div>
        {/* List */}
        <div style={{flex:1,overflowY:'auto',padding:'14px 20px',background:'#f7f7f7'}}>
          {filtered.length===0&&<div style={{textAlign:'center',padding:'40px',color:'#aaa',background:'#fff',borderRadius:12}}>{dups.length===0?'✓ No duplicates found — clean account!':'No duplicates match this filter'}</div>}
          {filtered.map((d,i)=>(
            <div key={i} style={{background:'#fff',borderRadius:10,border:`1px solid ${sevColor[d.severity]}33`,marginBottom:8,overflow:'hidden'}}>
              <div style={{padding:'10px 14px',background:sevBg[d.severity],display:'flex',alignItems:'center',gap:10}}>
                <div style={{width:7,height:7,borderRadius:'50%',background:sevColor[d.severity],flexShrink:0}}/>
                <span style={{fontSize:13,fontWeight:700,color:'#111',flex:1}}>{d.kw}</span>
                <span style={{fontSize:11,padding:'2px 8px',borderRadius:6,background:sevColor[d.severity]+'22',color:sevColor[d.severity],fontWeight:700}}>{d.mt.toUpperCase()}</span>
                <span style={{fontSize:10,color:'#888'}}>{d.entries.length} campaigns</span>
                {d.enabledCount>1&&<span style={{fontSize:9,padding:'1px 6px',borderRadius:8,background:'rgba(212,43,43,0.1)',color:'#d42b2b',fontWeight:700}}>{d.enabledCount} ACTIVE</span>}
              </div>
              <div style={{padding:'8px 14px'}}>
                {d.entries.map((e,j)=>(
                  <div key={j} style={{display:'flex',alignItems:'center',gap:8,padding:'4px 0',borderBottom:j<d.entries.length-1?'1px solid #f5f5f5':'none'}}>
                    <span style={{fontSize:10,padding:'1px 5px',borderRadius:4,background:e.state==='enabled'?'rgba(26,122,60,0.1)':'rgba(0,0,0,0.05)',color:e.state==='enabled'?'#1a7a3c':'#888',fontWeight:600}}>{e.state}</span>
                    <span style={{fontSize:11,color:'#333',flex:1}}>{e.campaign}</span>
                    {e.portfolio&&<span style={{fontSize:10,color:'#aaa'}}>{e.portfolio}</span>}
                    {j>0&&<span style={{fontSize:10,color:'#d42b2b',fontWeight:600}}>← pause this</span>}
                    {j===0&&<span style={{fontSize:10,color:'#1a7a3c',fontWeight:600}}>← keep</span>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }

  /* ── Target Checker View ── */
  function CheckerView(){
    const notTargeted=checkerResults?.filter(r=>!r.isTargeted)||[];
    const alreadyTargeted=checkerResults?.filter(r=>r.isTargeted)||[];
    return(
      <div style={{flex:1,overflowY:'auto',padding:'16px 20px',background:'#f7f7f7'}}>
        <div style={{maxWidth:1000,margin:'0 auto'}}>
          {/* Input area */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
            <div style={{background:'#fff',borderRadius:11,border:'1px solid #f0f0f0',padding:'16px'}}>
              <div style={{fontSize:12,fontWeight:700,color:'#111',marginBottom:4,display:'flex',alignItems:'center',gap:6}}>
                <i className="ti ti-keyboard" style={{fontSize:12,color:'#4f46e5'}}/>New Keywords to Check
              </div>
              <div style={{fontSize:10,color:'#aaa',marginBottom:8}}>Paste one keyword per line — we'll check if they're already targeted in your bulk file</div>
              <textarea value={kwInput} onChange={e=>setKwInput(e.target.value)}
                placeholder={"silicone body scrubber\nantibacterial loofah\nshower brush for body"}
                style={{width:'100%',height:160,resize:'vertical',padding:'8px 10px',borderRadius:8,border:'1.5px solid #e0e0e0',fontSize:12,fontFamily:'monospace',outline:'none',boxSizing:'border-box',lineHeight:1.6}}/>
              <div style={{fontSize:10,color:'#888',marginTop:4}}>{kwInput.split('\n').filter(k=>k.trim()).length} keywords</div>
            </div>
            <div style={{background:'#fff',borderRadius:11,border:'1px solid #f0f0f0',padding:'16px'}}>
              <div style={{fontSize:12,fontWeight:700,color:'#111',marginBottom:4,display:'flex',alignItems:'center',gap:6}}>
                <i className="ti ti-box" style={{fontSize:12,color:'#6338c8'}}/>New ASINs to Check
              </div>
              <div style={{fontSize:10,color:'#aaa',marginBottom:8}}>Paste competitor/category ASINs — we'll check if they're already in Product Targeting</div>
              <textarea value={asinInput} onChange={e=>setAsinInput(e.target.value)}
                placeholder={"B0COMPETITOR1\nB0COMPETITOR2\nB0CATEGORY123"}
                style={{width:'100%',height:160,resize:'vertical',padding:'8px 10px',borderRadius:8,border:'1.5px solid #e0e0e0',fontSize:12,fontFamily:'monospace',outline:'none',boxSizing:'border-box',lineHeight:1.6}}/>
              <div style={{fontSize:10,color:'#888',marginTop:4}}>{asinInput.split('\n').filter(a=>a.trim()).length} ASINs</div>
            </div>
          </div>

          <div style={{display:'flex',gap:10,marginBottom:16,alignItems:'center'}}>
            <button onClick={runChecker} disabled={!bulkData||(kwInput.trim()===''&&asinInput.trim()==='')}
              style={{padding:'9px 22px',borderRadius:9,background:'#6338c8',color:'#fff',border:'none',fontSize:13,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:7,opacity:(!bulkData||(kwInput.trim()===''&&asinInput.trim()===''))?0.45:1}}>
              <i className="ti ti-search" style={{fontSize:13}}/>Check Against Bulk File
            </button>
            {checkerResults&&<button onClick={()=>exportCheckerResults(checkerResults)} style={{padding:'9px 18px',borderRadius:9,border:'1px solid rgba(99,56,200,0.3)',background:'rgba(99,56,200,0.07)',color:'#6338c8',fontSize:12,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
              <i className="ti ti-download" style={{fontSize:12}}/>Export Results
            </button>}
            {!bulkData&&<span style={{fontSize:11,color:'#c47a00'}}>⚠ Upload a Bulk file first</span>}
          </div>

          {checkerResults&&(
            <>
              {/* Summary */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
                <div style={{background:'rgba(26,122,60,0.05)',borderRadius:10,border:'1px solid rgba(26,122,60,0.2)',padding:'14px 16px'}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#1a7a3c',marginBottom:8,display:'flex',alignItems:'center',gap:6}}>
                    <i className="ti ti-circle-plus" style={{fontSize:13}}/>✅ NOT TARGETED — Safe to Add ({notTargeted.length})
                  </div>
                  <div style={{fontSize:10,color:'#555',marginBottom:8,lineHeight:1.5}}>These are <strong>free</strong> — not in any existing campaign. Safe to target.</div>
                  {notTargeted.slice(0,10).map((r,i)=>(
                    <div key={i} style={{display:'flex',alignItems:'center',gap:7,padding:'4px 0',borderBottom:i<Math.min(9,notTargeted.length-1)?'1px solid rgba(26,122,60,0.1)':'none'}}>
                      <span style={{fontSize:10,padding:'1px 5px',borderRadius:4,background:'rgba(26,122,60,0.1)',color:'#1a7a3c',fontWeight:700,flexShrink:0}}>{r.type==='asin'?'ASIN':'KW'}</span>
                      <span style={{fontSize:12,color:'#111',fontWeight:500,flex:1}}>{r.term}</span>
                      <span style={{fontSize:10,color:'#1a7a3c',fontWeight:700}}>ADD →</span>
                    </div>
                  ))}
                  {notTargeted.length>10&&<div style={{fontSize:10,color:'#888',marginTop:6}}>+{notTargeted.length-10} more — export to see all</div>}
                  {notTargeted.length===0&&<div style={{fontSize:11,color:'#aaa',fontStyle:'italic'}}>All terms already targeted</div>}
                </div>

                <div style={{background:'rgba(212,43,43,0.04)',borderRadius:10,border:'1px solid rgba(212,43,43,0.15)',padding:'14px 16px'}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#d42b2b',marginBottom:8,display:'flex',alignItems:'center',gap:6}}>
                    <i className="ti ti-circle-check" style={{fontSize:13}}/>🔴 ALREADY TARGETED ({alreadyTargeted.length})
                  </div>
                  <div style={{fontSize:10,color:'#555',marginBottom:8,lineHeight:1.5}}>These are <strong>already in campaigns</strong> — adding again = duplicate spend.</div>
                  {alreadyTargeted.slice(0,10).map((r,i)=>(
                    <div key={i} style={{borderBottom:i<Math.min(9,alreadyTargeted.length-1)?'1px solid rgba(212,43,43,0.08)':'none',paddingBottom:6,marginBottom:6}}>
                      <div style={{display:'flex',alignItems:'center',gap:7}}>
                        <span style={{fontSize:10,padding:'1px 5px',borderRadius:4,background:'rgba(212,43,43,0.1)',color:'#d42b2b',fontWeight:700,flexShrink:0}}>{r.type==='asin'?'ASIN':'KW'}</span>
                        <span style={{fontSize:12,color:'#111',fontWeight:500,flex:1}}>{r.term}</span>
                        <span style={{fontSize:10,color:'#d42b2b',fontWeight:700}}>SKIP</span>
                      </div>
                      <div style={{fontSize:10,color:'#888',marginTop:2,marginLeft:42}}>
                        In: {r.matchTypes.join(', ')} · {r.campaigns[0]}{r.campaigns.length>1?` +${r.campaigns.length-1} more`:''}
                      </div>
                    </div>
                  ))}
                  {alreadyTargeted.length>10&&<div style={{fontSize:10,color:'#888',marginTop:6}}>+{alreadyTargeted.length-10} more — export to see all</div>}
                  {alreadyTargeted.length===0&&<div style={{fontSize:11,color:'#aaa',fontStyle:'italic'}}>None of your terms are targeted yet</div>}
                </div>
              </div>
            </>
          )}

          {!checkerResults&&(
            <div style={{background:'#fff',borderRadius:10,border:'1px solid #f0f0f0',padding:'24px',textAlign:'center',color:'#aaa'}}>
              <i className="ti ti-search" style={{fontSize:36,display:'block',marginBottom:10,color:'#ddd'}}/>
              <div style={{fontSize:13,fontWeight:600,color:'#555',marginBottom:4}}>Paste keywords or ASINs above and click Check</div>
              <div style={{fontSize:11}}>The engine cross-references your list against all active targets in the Bulk file</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  const MODULE_TABS=[
    {k:'sp',   label:'SP Deduplication',    icon:'ti-copy-off',  color:'#6338c8', dups:spDups},
    {k:'sb',   label:'SB Deduplication',    icon:'ti-copy-off',  color:'#1a5fa0', dups:sbDups},
    {k:'sd',   label:'SD Deduplication',    icon:'ti-copy-off',  color:'#1a7a3c', dups:sdDups},
    {k:'checker',label:'Target Checker',    icon:'ti-search',    color:'#4f46e5', dups:null},
  ];

  const activeMod=MODULE_TABS.find(t=>t.k===modTab);
  const totalCrit=(spDups?.filter(d=>d.severity==='critical').length||0)+(sbDups?.filter(d=>d.severity==='critical').length||0)+(sdDups?.filter(d=>d.severity==='critical').length||0);

  return(
    <div style={{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'}}>
      {/* Header */}
      <div style={{padding:'12px 20px',borderBottom:'1px solid #f0f0f0',flexShrink:0,background:'#fff',display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
        <i className="ti ti-copy-off" style={{fontSize:15,color:'#6338c8'}}/>
        <span style={{fontSize:15,fontWeight:700,color:'#111'}}>Portfolio Deduplication</span>
        <span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:'rgba(99,56,200,0.1)',color:'#6338c8',fontWeight:700}}>Core</span>
        {totalCrit>0&&<span style={{fontSize:10,padding:'2px 8px',borderRadius:12,background:'rgba(212,43,43,0.1)',color:'#d42b2b',fontWeight:700}}>{totalCrit} Critical</span>}
        <div style={{flex:1}}/>
        {/* Upload button */}
        <label style={{display:'inline-flex',alignItems:'center',gap:6,padding:'6px 12px',background:'rgba(99,56,200,0.07)',borderRadius:8,border:'1px solid rgba(99,56,200,0.2)',cursor:'pointer',fontSize:11,color:'#6338c8',fontWeight:600}}>
          <i className="ti ti-file-upload" style={{fontSize:11}}/>{bulkData?`✓ ${bulkFile||'Bulk loaded'}  ·  Re-upload`:'Upload Bulk File'}
          <input type="file" accept=".csv,.xlsx,.xls" style={{display:'none'}} onChange={e=>e.target.files[0]&&handleFile(e.target.files[0])}/>
        </label>
        <button onClick={runAllDedup} disabled={!bulkData} style={{...T.btnR(true),padding:'7px 18px',fontSize:12,background:'#6338c8',opacity:!bulkData?0.45:1}}>
          <i className="ti ti-scan" style={{fontSize:12}}/>Scan All (SP+SB+SD)
        </button>
      </div>

      {/* Module tabs */}
      <div style={{display:'flex',padding:'0 20px',borderBottom:'1px solid #f0f0f0',background:'#fff',flexShrink:0}}>
        {MODULE_TABS.map(t=>{
          const badge=t.k!=='checker'?t.dups?.filter(d=>d.severity==='critical').length:checkerResults?.filter(r=>!r.isTargeted).length;
          return(
            <button key={t.k} onClick={()=>{setModTab(t.k);setActiveView('all');setSearchQ('');}}
              style={{display:'flex',alignItems:'center',gap:6,padding:'9px 16px',border:'none',borderBottom:`2px solid ${modTab===t.k?t.color:'transparent'}`,background:'transparent',cursor:'pointer',fontSize:12,fontWeight:modTab===t.k?700:500,color:modTab===t.k?t.color:'#666',whiteSpace:'nowrap'}}>
              <i className={`ti ${t.icon}`} style={{fontSize:12}}/>{t.label}
              {badge>0&&<span style={{fontSize:9,padding:'1px 5px',borderRadius:8,background:modTab===t.k?t.color:'rgba(212,43,43,0.1)',color:modTab===t.k?'#fff':'#d42b2b',fontWeight:700}}>{badge}</span>}
            </button>
          );
        })}
      </div>

      {/* Content */}
      <div style={{flex:1,overflow:'hidden',display:'flex',flexDirection:'column'}}>
        {modTab==='checker'?<CheckerView/>:<DedupView dups={activeMod?.dups} adType={modTab.toUpperCase()} adColor={activeMod?.color||'#6338c8'}/>}
      </div>
    </div>
  );
}
